import * as i0 from '@angular/core';
import { Injectable, Component, PLATFORM_ID, Inject, Input, Pipe, EventEmitter, Output, ChangeDetectionStrategy, Directive, HostBinding, HostListener, ViewChild, NgModule, CUSTOM_ELEMENTS_SCHEMA, ElementRef } from '@angular/core';
import { Subject, BehaviorSubject, ReplaySubject, lastValueFrom, from, forkJoin, map, takeUntil, take, catchError, of, timeout, startWith, delay, first, Observable } from 'rxjs';
import { __awaiter } from 'tslib';
import proj4 from 'proj4';
import { Cluster, Vector, OSM, ImageWMS, ImageArcGISRest, WMTS, TileWMS, TileArcGISRest, XYZ, ImageStatic } from 'ol/source';
import { Control, defaults, ScaleLine } from 'ol/control';
import { DoubleClickZoom, KeyboardPan, KeyboardZoom, MouseWheelZoom, PinchRotate, PinchZoom, DragPan, DragZoom, DragRotate, Select, Modify, Draw, Snap, DragBox } from 'ol/interaction';
import { Map, Kinetic, View, Feature as Feature$1, Collection, Overlay } from 'ol';
import { Group, Tile, Vector as Vector$1, Image as Image$1, Layer } from 'ol/layer';
import { transform, transformExtent, METERS_PER_UNIT, get, toLonLat } from 'ol/proj';
import { platformModifierKeyOnly, click } from 'ol/events/condition';
import { register } from 'ol/proj/proj4';
import * as i3 from '@angular/common';
import { isPlatformBrowser, CommonModule, LocationStrategy, PathLocationStrategy, APP_BASE_HREF } from '@angular/common';
import { getDistance, getArea } from 'ol/sphere';
import * as i1 from '@angular/common/http';
import { HttpHeaders, HttpClient, HttpClientModule } from '@angular/common/http';
import * as merge from 'deepmerge';
import * as i1$1 from '@ngx-translate/core';
import { TranslateService, TranslateFakeCompiler, TranslateDefaultParser, FakeMissingTranslationHandler, TranslatePipe, TranslateModule, TranslateStore, TranslateLoader } from '@ngx-translate/core';
import { RegularShape, Icon, Circle, Style, Fill, Stroke, Text } from 'ol/style';
import { GeoJSON, TopoJSON, KML, GPX, WFS, WMSCapabilities, WKT, WMTSCapabilities as WMTSCapabilities$1 } from 'ol/format';
import IDW from 'ol-ext/source/IDW';
import TileLayer from 'ol/layer/Tile';
import * as extent from 'ol/extent';
import { isEmpty, equals as equals$1, containsExtent, getCenter } from 'ol/extent';
import dayjs from 'dayjs';
import * as i1$2 from 'ngx-cookie-service';
import { CookieService } from 'ngx-cookie-service';
import ImageLayer from 'ol/layer/Image';
import * as xml2Json from 'xml-js';
import VectorLayer from 'ol/layer/Vector';
import * as loadingStrategy from 'ol/loadingstrategy';
import { bbox } from 'ol/loadingstrategy';
import WMTSCapabilities from 'ol/format/WMTSCapabilities';
import WMTS$1, { optionsFromCapabilities } from 'ol/source/WMTS';
import * as i7 from '@ng-bootstrap/ng-bootstrap';
import { NgbToastModule, NgbDropdownModule, NgbProgressbarModule, NgbAccordionModule, NgbDatepickerModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import * as i3$1 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { PROJECTIONS } from 'ol/proj/epsg4326';
import VectorSource from 'ol/source/Vector';
import Feature from 'ol/Feature';
import { Point, Circle as Circle$1, Polygon as Polygon$1, LineString } from 'ol/geom';
import OpenLayersParser, { OlStyleParser } from 'geostyler-openlayers-parser';
import QGISStyleParser from 'geostyler-qgis-parser';
import SLDParser from 'geostyler-sld-parser';
import colormap from 'colormap';
import { createDefaultStyle } from 'ol/style/Style';
import { toStringHDMS, createStringXY } from 'ol/coordinate';
import * as i1$3 from '@angular/platform-browser';
import JSZip from 'jszip';
import Resumable from 'resumablejs';
import { unByKey } from 'ol/Observable';
import Polygon, { fromExtent, fromCircle } from 'ol/geom/Polygon';
import queue from 'queue';
import { takeUntil as takeUntil$1, timeout as timeout$1, map as map$1, catchError as catchError$1 } from 'rxjs/operators';
import 'share-api-polyfill';
import * as polygonClipping from 'polygon-clipping';
import polygonSplitter from 'polygon-splitter';
import Geolocation from 'ol/Geolocation';
import Rotate from 'ol/control/Rotate';
import * as i4 from '@angular/cdk/drag-drop';
import { moveItemInArray, transferArrayItem, DragDropModule } from '@angular/cdk/drag-drop';
import LegendRenderer from 'geostyler-legend/dist/LegendRenderer/LegendRenderer';
import colorScales from 'colormap/colorScale';
import * as i3$2 from 'ngx-color/sketch';
import { ColorSketchModule } from 'ngx-color/sketch';
import Popup from 'ol-popup';
import Collection$1 from 'ol/Collection';

class HslayersService {
    constructor() { }
}
HslayersService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HslayersService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
HslayersService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HslayersService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HslayersService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return []; } });

class HsConfigObject {
    constructor() {
        this.mapSwipeOptions = {};
        this.pathExclusivity = false;
        this.panelsEnabled = {
            legend: true,
            info: true,
            composition_browser: true,
            toolbar: true,
            measure: true,
            mobile_settings: false,
            draw: true,
            layermanager: true,
            print: true,
            saveMap: true,
            language: true,
            permalink: true,
            compositionLoadingProgress: false,
            sensors: true,
            filter: false,
            search: false,
            tripPlanner: false,
            addData: true,
            mapSwipe: false,
        };
        this.componentsEnabled = {
            guiOverlay: true,
            sidebar: true,
            toolbar: true,
            drawToolbar: true,
            searchToolbar: true,
            measureToolbar: true,
            geolocationButton: true,
            defaultViewButton: true,
            mapControls: true,
            basemapGallery: false,
            mapSwipe: false,
        };
        this.queryPopupWidgets = ['layer-name', 'feature-info', 'clear-layer'];
        this.panelWidths = {
            default: 425,
            ows: 700,
            composition_browser: 550,
            addData: 700,
            mapSwipe: 550,
        };
    }
}
class HsConfig {
    constructor() {
        this.apps = {
            default: new HsConfigObject(),
        };
        this.configChanges = new Subject();
        this.defaultSymbolizerIcons = [
            { name: 'favourite', url: 'img/icons/favourite28.svg' },
            { name: 'gps', url: 'img/icons/gps43.svg' },
            { name: 'information', url: 'img/icons/information78.svg' },
            { name: 'wifi', url: 'img/icons/wifi8.svg' },
        ];
    }
    checkDeprecatedCesiumConfig(newConfig) {
        for (const prop of [
            'cesiumDebugShowFramesPerSecond',
            'cesiumShadows',
            'cesiumBase',
            'createWorldTerrainOptions',
            'terrain_provider',
            'cesiumTimeline',
            'cesiumAnimation',
            'creditContainer',
            'cesiumInfoBox',
            'imageryProvider',
            'terrainExaggeration',
            'cesiumBingKey',
            'newTerrainProviderOptions',
            'terrain_providers',
            'cesiumAccessToken',
            'cesiumTime',
        ]) {
            if (newConfig[prop] != undefined) {
                console.error(`HsConfig.get(app).${prop} has been moved to HsCesiumConfig service or hslayersCesiumConfig.${prop} when using hslayers-cesium-app`);
            }
        }
    }
    update(newConfig, app) {
        var _a;
        if (app == undefined) {
            app = 'default';
        }
        this.checkDeprecatedCesiumConfig(newConfig);
        let appConfig = this.apps[app];
        if (appConfig == undefined) {
            this.apps[app] = new HsConfigObject();
            appConfig = this.apps[app];
        }
        appConfig.symbolizerIcons = this.defaultSymbolizerIcons.map((val) => {
            var _a;
            val.url = ((_a = appConfig.assetsPath) !== null && _a !== void 0 ? _a : '') + val.url;
            return val;
        });
        Object.assign(appConfig.componentsEnabled, newConfig.componentsEnabled);
        //Delete since we assign the whole object later and don't want it replaced, but merged
        delete newConfig.componentsEnabled;
        Object.assign(appConfig.panelWidths, newConfig.panelWidths);
        //See componentsEnabled ^
        Object.assign(appConfig.panelsEnabled, newConfig.panelsEnabled);
        delete newConfig.panelsEnabled;
        appConfig.symbolizerIcons = [
            ...this.updateSymbolizers(newConfig),
            ...((_a = newConfig.symbolizerIcons) !== null && _a !== void 0 ? _a : []),
        ];
        delete newConfig.symbolizerIcons;
        Object.assign(appConfig, newConfig);
        if (appConfig.assetsPath == undefined) {
            appConfig.assetsPath = '';
        }
        appConfig.assetsPath += appConfig.assetsPath.endsWith('/') ? '' : '/';
        appConfig._ajaxLoaderPath = appConfig.assetsPath + 'img/ajax-loader.gif';
        this.configChanges.next({ app, config: appConfig });
    }
    /**
     * This kind of duplicates getAssetsPath() in HsUtilsService, which can't be used here due to circular dependency
     */
    updateSymbolizers(config) {
        var _a;
        /* Removing 'private' since it makes this method non-optional */
        let assetsPath = (_a = config.assetsPath) !== null && _a !== void 0 ? _a : '';
        assetsPath += assetsPath.endsWith('/') ? '' : '/';
        return this.defaultSymbolizerIcons.map((val) => {
            val.url = assetsPath + val.url;
            return val;
        });
    }
    get(app = 'default') {
        if (this.apps[app] == undefined) {
            return this.apps['default'];
        }
        return this.apps[app];
    }
}
HsConfig.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsConfig, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
HsConfig.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsConfig });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsConfig, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return []; } });

/**
 * HsEventBusService provides observable events which you can subscribe to or fire them
 *
 * @example
 * HsEventBusService.sizeChanges.subscribe((size) =\> \{
 *              doSomethingWith(size);
 * \})
 * @example
 * HsEventBusService.layerLoads.next();
 */
class HsEventBusService {
    constructor() {
        this.sizeChanges = new Subject();
        /**
         * Fires when map completely reset
         * @event mapResets
         */
        this.mapResets = new Subject();
        this.layerManagerUpdates = new Subject();
        this.compositionLoadStarts = new Subject();
        this.compositionDeletes = new Subject();
        /**
         * Fires when composition is loaded or not loaded with Error message
         * @event compositionLoads
         */
        this.compositionLoads = new Subject();
        this.layerRemovals = new Subject();
        this.compositionEdits = new Subject();
        this.layerAdditions = new Subject();
        this.LayerManagerBaseLayerVisibilityChanges = new Subject();
        this.LayerManagerLayerVisibilityChanges = new Subject();
        this.layerLoads = new Subject();
        this.layerLoadings = new Subject();
        /**
         * Fires when user enables layer time synchronization in the UI
         * Used to synchronize time in PARAMS across WM(T)S-t layers
         */
        this.layerTimeSynchronizations = new Subject();
        /**
         * DEPRECATED. Moved into the HsDimensionTimeService for mostly internal usage.
         * @deprecated Replaced by layerDimensionDefinitionChanges
         */
        this.layerTimeChanges = new Subject();
        /**
         * Used to listen for changes either in "time" property in HsLayerDescrtiptor
         * or in "dimensions" property in OL Layer object
         */
        this.layerDimensionDefinitionChanges = new Subject();
        /**
         * Used to listen for changes of dimension settings in layermanager-dimensions component
         */
        this.layermanagerDimensionChanges = new Subject();
        this.vectorQueryFeatureSelection = new Subject();
        this.vectorQueryFeatureDeselection = new Subject();
        /**
         * Fires when current mainpanel change - toggle, change of opened panel.
         * replaces 'core.mainpanel_changed'
         * @event mainPanelChanges
         */
        this.mainPanelChanges = new Subject();
        /**
         * replaces 'measure.drawStart'
         */
        this.measurementStarts = new Subject();
        /**
         * replaces 'measure.drawEnd'
         */
        this.measurementEnds = new Subject();
        this.cesiumLoads = new Subject();
        this.cesiumResizes = new Subject();
        this.zoomTo = new Subject();
        /**
         * Fires when map extent change (move, zoom, resize).
         * Returns structure containing OL map, event which triggered the extent change, newly
         * calculated {@link http://openlayers.org/en/latest/apidoc/ol.html#.Extent extent}
         * and app name ('default' in most cases)
         */
        this.mapExtentChanges = new Subject();
        this.mapCenterSynchronizations = new Subject();
        this.mapLibraryChanges = new Subject();
        /**
         * replaces 'cesium.time_layers_changed'
         */
        this.cesiumTimeLayerChanges = new Subject();
        this.layoutResizes = new Subject();
        this.layoutLoads = new Subject();
        /**
         * replaces 'map.loaded'
         */
        this.olMapLoads = new Subject();
        /**
         * Fires when composition is downloaded from server and parsing begins
         * replaces 'compositions.composition_loading'
         * @event compositionLoading
         */
        this.compositionLoading = new Subject();
        this.currentComposition = new BehaviorSubject(null);
        /**
         * replaces 'search.resultsReceived'
         */
        this.searchResultsReceived = new Subject();
        this.searchZoomTo = new Subject();
        this.clearSearchResults = new Subject();
        /**
         * replaces 'query.dataUpdated'
         */
        this.queryDataUpdated = new Subject();
        /**
         * replaces 'mapClicked'
         */
        this.mapClicked = new Subject();
        /**
         * Fires when layerSelected parameter is found in the URL
         * @event layerSelectedFromUrl
         */
        this.layerSelectedFromUrl = new BehaviorSubject(null);
    }
}
HsEventBusService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsEventBusService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
HsEventBusService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsEventBusService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsEventBusService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return []; } });

/* eslint-disable no-console */
class HsLogService {
    warn(...attrs) {
        console.warn(attrs);
    }
    log(...attrs) {
        console.log(attrs);
    }
    error(...attrs) {
        console.error(attrs);
    }
    info(...attrs) {
        console.info(attrs);
    }
}
HsLogService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLogService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
HsLogService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLogService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLogService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class HsPanelContainerParams {
    constructor() {
        this.panels = [];
        this.panelObserver = new ReplaySubject();
        this.panelDestroyObserver = new Subject();
    }
}

class HsPanelItem {
    constructor(component, data) {
        this.component = component;
        this.data = data;
    }
}

class HsPanelContainerService {
    constructor() {
        this.apps = {
            default: new HsPanelContainerParams(),
        };
    }
    get(app) {
        if (this.apps[app !== null && app !== void 0 ? app : 'default'] == undefined) {
            this.apps[app !== null && app !== void 0 ? app : 'default'] = new HsPanelContainerParams();
        }
        return this.apps[app !== null && app !== void 0 ? app : 'default'];
    }
    /**
     * Create new dynamic panels. They are replayed in the PanelContainerComponent
     * in case of race conditions existing where panels are created before the
     * container component is even added to the DOM.
     * @param component - PanelComponent class
     * @param data-  Extra data to give the new panel
     * @param app - App id
     * @param panelObserver - ReplaySubject to which you need to add the panel components. This is used when panels in this service are used only sometimes (for particular layers)
     */
    create(component, data, app = 'default', panelObserver) {
        if (data && data.app === undefined) {
            data.app = app;
        }
        else if (data === undefined) {
            data = { app };
        }
        (panelObserver !== null && panelObserver !== void 0 ? panelObserver : this.get(app).panelObserver).next(new HsPanelItem(component, data));
    }
    destroy(component, app) {
        if (component.cleanup) {
            component.cleanup();
        }
        const panelCollection = this.get(app).panels;
        const panelIx = panelCollection.findIndex((d) => d == component);
        if (panelIx > -1) {
            panelCollection.splice(panelIx, 1);
        }
        this.get(app).panelDestroyObserver.next(component);
    }
    /**
     * An admittedly hacky solution to set panel width
     * from dictionary containing names (as in name property in PanelComponent)
     * and numbers stored in HsConfig.get(app).panelWidths in most cases.
     * It's also possible to set the css class hs-panel-width-(400-850) on the panel
     * templates root element skipping the HsConfig.get(app).panelWidths.
     * @param panelWidths - key-value pairs of panel names and their widths
     * @param componentRefInstance - Panel component instance which can be read from HsPanelContainerService.panels array
     */
    setPanelWidth(panelWidths, componentRefInstance) {
        if (componentRefInstance == undefined) {
            return;
        }
        const pnlWidth = panelWidths[componentRefInstance.name] || panelWidths.default;
        const guessedClass = `hs-panel-width-${Math.round(pnlWidth / 25) * 25}`;
        setTimeout(() => {
            const rootView = componentRefInstance.viewRef; //Any is used because the actual class RootViewRef is not exported from angular
            //Without timeout componentRefInstance.viewRef.rootNodes could contain only placeholder <!--container--> until the real content is loaded
            for (const rootNode of rootView.rootNodes) {
                for (const child of rootNode.children) {
                    if (!child.classList.contains(guessedClass)) {
                        child.classList.add(guessedClass);
                    }
                }
            }
        }, 0);
    }
}
HsPanelContainerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsPanelContainerService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
HsPanelContainerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsPanelContainerService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsPanelContainerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return []; } });

class HsOverlayPanelContainerService extends HsPanelContainerService {
    constructor() {
        super();
    }
}
HsOverlayPanelContainerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsOverlayPanelContainerService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
HsOverlayPanelContainerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsOverlayPanelContainerService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsOverlayPanelContainerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return []; } });

const defaultLayoutParams = {
    defaultPanel: '',
    panel_statuses: {},
    panel_enabled: {},
    mainpanel: '',
    sidebarRight: true,
    sidebarLabels: true,
    sidebarToggleable: true,
    sidebarButtons: true,
    smallWidth: false,
    sidebarExpanded: false,
    initializedOnce: false,
    minisidebar: false,
    sidebarVisible: true,
    sidebarPosition: 'left',
};
class HsLayoutService {
    constructor(HsConfig, HsEventBusService, $log, componentFactoryResolver, hsPanelContainerService, hsOverlayPanelContainerService) {
        this.HsConfig = HsConfig;
        this.HsEventBusService = HsEventBusService;
        this.$log = $log;
        this.componentFactoryResolver = componentFactoryResolver;
        this.hsPanelContainerService = hsPanelContainerService;
        this.hsOverlayPanelContainerService = hsOverlayPanelContainerService;
        this.apps = {};
        this.mapSpaceRef = new BehaviorSubject(undefined);
        this.panelSpaceWidth = new BehaviorSubject({
            app: 'default',
            width: 425,
        });
        this.sidebarPosition = new BehaviorSubject({
            app: 'default',
            position: 'left',
        });
        this.sidebarVisible = new BehaviorSubject({
            app: 'default',
            visible: true,
        });
        Object.defineProperty(this, 'panelListElement', {
            get: function () {
                return this.contentWrapper.querySelector('.hs-panelplace');
            },
        });
        Object.defineProperty(this, 'dialogAreaElement', {
            get: function () {
                return this.contentWrapper.querySelector('.hs-dialog-area');
            },
        });
        Object.defineProperty(this, 'sidebarListElement', {
            get: function () {
                return this.contentWrapper.querySelector('.hs-sidebar-list');
            },
        });
    }
    init(_app) {
        this.parseConfig(_app);
        this.HsConfig.configChanges.subscribe(({ app, config }) => {
            if (app == _app) {
                this.parseConfig(_app);
            }
        });
        this.HsEventBusService.mainPanelChanges.subscribe(({ which, app }) => {
            this.updPanelSpaceWidth(app);
        });
        this.updPanelSpaceWidth(_app);
        this.updSidebarPosition(_app);
        this.updSidebarVisible(_app, true);
        this.sidebarVisible.subscribe(({ app, visible }) => {
            this.apps[app].sidebarVisible = visible;
        });
        this.sidebarPosition.subscribe(({ app, position }) => {
            this.apps[app].sidebarPosition = position;
        });
    }
    updPanelSpaceWidth(app) {
        //Timeout to repaint first to get width from element clientWidth
        setTimeout(() => {
            this.panelSpaceWidth.next({ app, width: this.getPanelSpaceWidth(app) });
        }, 0);
    }
    updSidebarPosition(app) {
        return __awaiter(this, void 0, void 0, function* () {
            const lastPosition = this.get(app).sidebarPosition;
            if (window.innerWidth <= 767) {
                if (lastPosition != 'bottom') {
                    this.sidebarPosition.next({
                        app,
                        position: 'bottom',
                    });
                }
            }
            else {
                if (this.HsConfig.apps[app].sidebarPosition != lastPosition) {
                    this.sidebarPosition.next({
                        app,
                        position: this.HsConfig.apps[app].sidebarPosition,
                    });
                }
            }
        });
    }
    parseConfig(app) {
        var _a;
        const appRef = this.get(app);
        appRef.panel_enabled = {};
        const configRef = this.HsConfig.get(app);
        if (configRef) {
            for (const key of Object.keys(configRef.panelsEnabled)) {
                this.panelEnabled(key, app, this.getPanelEnableState(key, app));
            }
            appRef.sidebarToggleable = configRef.hasOwnProperty('sidebarToggleable')
                ? configRef.sidebarToggleable
                : true;
        }
        this.sidebarPosition.next({
            app,
            position: (_a = configRef === null || configRef === void 0 ? void 0 : configRef.sidebarPosition) !== null && _a !== void 0 ? _a : 'left',
        });
    }
    getPanelEnableState(panel, app) {
        var _a, _b;
        if (((_a = this.HsConfig) === null || _a === void 0 ? void 0 : _a.get(app).panelsEnabled) == undefined ||
            ((_b = this.HsConfig) === null || _b === void 0 ? void 0 : _b.get(app).panelsEnabled[panel]) == undefined) {
            /*
            Function called from sidebar and panel is
            probably custom panel added to buttons array from outside
            */
            return true;
        }
        return this.HsConfig.get(app).panelsEnabled[panel];
    }
    /**
     * Find if selected panel is currently opened (in sidebar or as unpinned window)
     * @param which - Which Name of panel to test
     * @param app - App name
     * @param panelComponent - Instance of panel component. Used for toggling multiple panels at the same time
     * @returns Panel opened/closed status
     */
    panelVisible(which, app = 'default', panelComponent) {
        const appRef = this.get(app);
        if (panelComponent) {
            if (panelComponent.name == undefined) {
                panelComponent.name = which;
            }
        }
        if (appRef.panel_statuses[which] !== undefined) {
            return appRef.panel_statuses[which] && this.panelEnabled(which, app);
        }
        if (appRef.mainpanel == which) {
            return true;
        }
        else if (panelComponent) {
            return panelComponent.unpinned;
        }
        else {
            return false;
        }
    }
    /**
     * Close opened panel programmatically.
     * If sidebar toolbar is used in app, sidebar stay expanded with sidebar labels.
     * Cannot resolve unpinned panels.
     * @public
     */
    hidePanels(app) {
        const appRef = this.get(app);
        appRef.mainpanel = '';
        appRef.sidebarLabels = true;
        this.HsEventBusService.mainPanelChanges.next({ app });
    }
    get(app = 'default') {
        if (this.apps[app] == undefined) {
            this.apps[app] = Object.assign({}, defaultLayoutParams);
        }
        return this.apps[app];
    }
    /**
     * @public
     * @param {object} which Panel to close (panel scope)
     * @description Close selected panel (either unpinned panels or actual mainpanel). If default panel is defined, it is opened instead.
     */
    closePanel(which, app) {
        const appRef = this.get(app);
        if (which.unpinned) {
            appRef.contentWrapper
                .querySelector(which.original_container)
                .appendChild(which.drag_panel);
            which.drag_panel.css({
                top: 'auto',
                left: 'auto',
                position: 'relative',
            });
        }
        which.unpinned = false;
        if (which.panelName == appRef.mainpanel) {
            if (appRef.defaultPanel != '') {
                if (which.panelName == appRef.defaultPanel) {
                    appRef.sidebarExpanded = false;
                }
                else {
                    this.setMainPanel(appRef.defaultPanel, app);
                }
            }
            else {
                appRef.mainpanel = '';
                appRef.sidebarLabels = true;
            }
            appRef.sidebarExpanded = false;
        }
        this.HsEventBusService.mainPanelChanges.next({ which, app });
    }
    /**
     * Get or set panel visibility in sidebar.
     * When panel is disabled it means that it's not displayed in sidebar (it can be opened programmatically) but its functionality is running.
     * Use with status parameter as setter.
     * @public
     * @param which - Selected panel (panel name)
     * @param status - Visibility status of panel to set
     * @returns Panel enabled/disabled status for getter function
     */
    panelEnabled(which, app, status) {
        const appRef = this.get(app);
        if (status === undefined) {
            if (appRef.panel_enabled[which] != undefined) {
                return appRef.panel_enabled[which];
            }
            else {
                return true;
            }
        }
        else {
            appRef.panel_enabled[which] = status;
        }
    }
    /**
     * Wrapper for accessing HsConfig.get(app).componentsEnabled settings.
     * @param which - Name of the GUI component to check
     * @returns true if set to true (default), false otherwise
     */
    componentEnabled(which, app) {
        return (this.HsConfig.get(app).componentsEnabled == undefined ||
            this.HsConfig.get(app).componentsEnabled[which] == undefined ||
            this.HsConfig.get(app).componentsEnabled[which]);
    }
    /**
     * Sets new main panel (Panel displayed in expanded sidebar).
     * Change GUI and queryable status of map (when queryable and with hs.query component in app, map does info query on map click).
     * @public
     * @param which - New panel to activate (panel name)
     * @param app - Application's ID
     * @param by_gui - Whether function call came as result of GUI action
     */
    //TODO: introduce a new breaking change = change fction pattern to (which, {app, byGui}) => Promise<void>
    setMainPanel(which, app = 'default', by_gui) {
        const appRef = this.get(app);
        if (!this.panelEnabled(which, app)) {
            return;
        }
        if (which == appRef.mainpanel && by_gui) {
            which = '';
            if (appRef.sidebarExpanded == true) {
                if (appRef.sidebarPosition == 'bottom') {
                    appRef.sidebarExpanded = false;
                }
                else {
                    appRef.sidebarLabels = true;
                }
            }
        }
        else {
            appRef.sidebarExpanded = true;
            appRef.sidebarLabels = false;
        }
        appRef.mainpanel = which;
        const componentRefInstance = this.hsPanelContainerService
            .get(app)
            .panels.find((p) => p.name == which);
        this.hsPanelContainerService.setPanelWidth(this.HsConfig.get(app).panelWidths, componentRefInstance);
        for (const p of this.hsPanelContainerService.apps[app].panels) {
            const visible = p.isVisible();
            if (p.isVisible$ && p.isVisible$.value != visible) {
                p.isVisible$.next(visible);
            }
        }
        this.HsEventBusService.mainPanelChanges.next({ which, app });
    }
    /**
     * Sets new default panel (Panel which is opened first and which displayed if previous active panel is closed)
     * @public
     * @param which - New panel to be default (specify panel name)
     */
    setDefaultPanel(which, app = 'default') {
        this.get(app).defaultPanel = which;
        this.setMainPanel(which, app);
    }
    getPanelSpaceWidth(app) {
        const appRef = this.get(app);
        const panelSpaceWidth = appRef.layoutElement.getElementsByClassName('hs-panelspace-wrapper')[0].clientWidth;
        return panelSpaceWidth;
    }
    updSidebarVisible(app, visible) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.HsConfig.get(app).sidebarPosition == 'invisible' ||
                this.HsConfig.get(app).pureMap ||
                this.HsConfig.get(app).componentsEnabled.guiOverlay === false ||
                this.HsConfig.get(app).componentsEnabled.sidebar === false) {
                return this.sidebarVisible.next({ app, visible: false });
            }
            if (visible == undefined) {
                this.sidebarVisible.next({ app, visible: true });
            }
            else {
                this.sidebarVisible.next({ app, visible });
            }
        });
    }
    panelSpaceHeight(app) {
        const appRef = this.get(app);
        if (appRef.contentWrapper.querySelector('.hs-panelspace-wrapper')) {
            return appRef.contentWrapper.querySelector('.hs-panelspace-wrapper')
                .clientHeight;
            // return tmp
        }
    }
    mdToolbarHeight(app) {
        const ELEM = this.get(app).contentWrapper.querySelector('.md-app-toolbar');
        return ELEM ? ELEM.clientHeight : 0;
    }
    addMapVisualizer(visualizerComponent, _app) {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(visualizerComponent);
        this.mapSpaceRef.subscribe((params) => {
            if ((params === null || params === void 0 ? void 0 : params.viewContainerRef) && (params === null || params === void 0 ? void 0 : params.app) == _app) {
                const componentRef = params.viewContainerRef.createComponent(componentFactory);
                componentRef.instance.app = params === null || params === void 0 ? void 0 : params.app;
            }
        });
    }
    createPanel(panelComponent, app = 'default', data) {
        this.hsPanelContainerService.create(panelComponent, data || {}, app);
    }
    createOverlay(panelComponent, app, data) {
        this.hsOverlayPanelContainerService.create(panelComponent, data || {}, app);
    }
}
HsLayoutService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayoutService, deps: [{ token: HsConfig }, { token: HsEventBusService }, { token: HsLogService }, { token: i0.ComponentFactoryResolver }, { token: HsPanelContainerService }, { token: HsOverlayPanelContainerService }], target: i0.ɵɵFactoryTarget.Injectable });
HsLayoutService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayoutService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayoutService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsConfig }, { type: HsEventBusService }, { type: HsLogService }, { type: i0.ComponentFactoryResolver }, { type: HsPanelContainerService }, { type: HsOverlayPanelContainerService }]; } });

class HsPanelBaseComponent {
    constructor(hsLayoutService) {
        this.hsLayoutService = hsLayoutService;
        this.isVisible$ = new BehaviorSubject(false);
    }
    isVisible() {
        return this.hsLayoutService.panelVisible(this.name, this.data.app);
    }
}
HsPanelBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsPanelBaseComponent, deps: [{ token: HsLayoutService }], target: i0.ɵɵFactoryTarget.Component });
HsPanelBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsPanelBaseComponent, selector: "ng-component", ngImport: i0, template: '<div></div>', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsPanelBaseComponent, decorators: [{
            type: Component,
            args: [{
                    template: '<div></div>',
                }]
        }], ctorParameters: function () { return [{ type: HsLayoutService }]; } });

const servicesSupportedByUrl = [
    'wms',
    'wfs',
    'wmts',
    'kml',
    'gpx',
    'geojson',
    'arcgis',
];

const ABSTRACT = 'abstract';
const ACCESS_RIGHTS = 'access_rights';
const ACTIVE = 'active';
const ATTRIBUTION = 'attribution';
const AUTO_LEGEND = 'autoLegend';
const BASE = 'base';
const CAPABILITIES = 'capabilities';
const CLUSTER = 'cluster';
const CUSTOM_INFO_TEMPLATE = 'customInfoTemplate';
const DEFINITION = 'definition';
const DIMENSIONS = 'dimensions';
const EDITOR = 'editor';
const ENABLEPROXY = 'enableProxy';
const EVENTS_SUSPENDED = 'eventsSuspended';
const EXCLUSIVE = 'exclusive';
const FEATURE_INFO_LANG = 'featureInfoLang';
const FROM_COMPOSITION = 'fromComposition';
const GET_FEATURE_INFO_TARGET = 'getFeatureInfoTarget';
const HS_LAYMAN_SYNCHRONIZING = 'hsLaymanSynchronizing';
const HS_QML = 'qml';
const HS_SLD = 'sld';
const INFO_FORMAT = 'infoFormat';
const INLINE_LEGEND = 'inlineLegend';
const LAYMAN_LAYER_DESCRIPTOR = 'laymanLayerDescriptor';
const LEGENDS = 'legends';
const MAX_RESOLUTION_DENOMINATOR = 'maxResolutionDenominator';
const METADATA = 'metadata';
const MINIMUM_TERRAIN_LEVEL = 'minimumTerrainLevel';
const NAME$1 = 'name';
const ON_FEATURE_SELECTED = 'onFeatureSelected';
const ORIG_LAYERS = 'origLayers';
const PATH = 'path';
const POPUP = 'popUp';
const POPUP_CLASS = 'popupClass';
const QUERY_CAPABILITIES = 'queryCapabilities';
const QUERY_FILTER = 'queryFilter';
const QUERYABLE = 'queryable';
const REMOVABLE = 'removable';
const SHOW_IN_LAYER_MANAGER = 'showInLayerManager';
const SUB_LAYERS = ['subLayers', 'sublayers'];
const SWIPE_SIDE = 'swipeSide';
const THUMBNAIL = 'thumbnail';
const TITLE$1 = 'title';
const VIRTUAL_ATTRIBUTES = 'virtualAttributes';
const WFS_URL = 'wfsUrl';
const WORKSPACE = 'workspace';
const DOM_FEATURE_LINKS = 'domFeatureLinks';
function getAccessRights(layer) {
    return layer.get(ACCESS_RIGHTS);
}
function setAccessRights(layer, access_rights) {
    layer.set(ACCESS_RIGHTS, access_rights);
}
function setTitle(layer, title) {
    layer.set(TITLE$1, title);
}
function getTitle(layer) {
    return layer.get(TITLE$1);
}
function setName(layer, name) {
    layer.set(NAME$1, name);
}
function getName(layer) {
    return layer.get(NAME$1);
}
function setAbstract(layer, abstract) {
    layer.set(ABSTRACT, abstract);
}
function getAbstract(layer) {
    return layer.get(ABSTRACT);
}
function setActive(group, active) {
    group.set(ACTIVE, active);
}
function getActive(group) {
    return group.get(ACTIVE);
}
function setAttribution(layer, attribution) {
    layer.set(ATTRIBUTION, attribution);
}
function getAttribution(layer) {
    return layer.get(ATTRIBUTION);
}
function setAutoLegend(layer, value) {
    layer.set(AUTO_LEGEND, value);
}
function getAutoLegend(layer) {
    return layer.get(AUTO_LEGEND);
}
function getCachedCapabilities(layer) {
    return layer.get(CAPABILITIES);
}
function setCacheCapabilities(layer, capabilities) {
    layer.set(CAPABILITIES, capabilities);
}
function setBase(layer, base) {
    layer.set(BASE, base);
}
function getBase(layer) {
    return layer.get(BASE);
}
function setCluster(layer, clusterActive) {
    layer.set(CLUSTER, clusterActive);
}
function getCluster(layer) {
    return layer.get(CLUSTER);
}
function setCustomInfoTemplate(layer, customInfoTemplate) {
    layer.set(CUSTOM_INFO_TEMPLATE, customInfoTemplate);
}
function getCustomInfoTemplate(layer) {
    return layer.get(CUSTOM_INFO_TEMPLATE);
}
function setDefinition(layer, definition) {
    layer.set(DEFINITION, definition);
}
function getDefinition(layer) {
    return layer.get(DEFINITION);
}
/**
 * Set the dimensions definition. TODO: Extend description
 * @param layer - OL layer
 * @param dimensions
 * @example
 *  dimensions: \{
      time: \{ label: 'Local time', default: '2020-02-25T01:00' \},
      level: \{
        label: 'Level hPa',
        value: 'surface',
        values: ['surface', '950mb - 500m', '900mb - 1km'],
        availability: function(layer) \{
          return layer.get('title') != 'Temperature observations'
        \}
      \}
    \}
 */
function setDimensions(layer, dimensions) {
    layer.set(DIMENSIONS, dimensions);
}
function getDimensions(layer) {
    return layer.get(DIMENSIONS);
}
/**
 * If no dimensions are defined then creates a new dimension object,
 * if dimensions exist but the type is not present yet, it appends that dimension,
 * if dimensions exist and the type is present already, it replaces that dimension
 * @param layer - OL layer object
 * @param dimension - a dimension definition object
 * @param type - dimension type, e.g. 'time', 'height', etc.
 */
function setDimension(layer, dimension, type) {
    if (layer.get(DIMENSIONS)) {
        const dims = layer.get(DIMENSIONS);
        dims[type] = dimension;
        layer.set(DIMENSIONS, dims);
    }
    else {
        layer.set(DIMENSIONS, { [type]: dimension });
    }
}
/**
 * @param layer - OL layer object
 * @param type - dimension type, e.g. 'time', 'height', etc.
 * @returns Single dimension object definition
 */
function getDimension(layer, type) {
    return layer.get(DIMENSIONS) ? layer.get(DIMENSIONS)[type] : undefined;
}
function setDomFeatureLinks(layer, domFeatureLinks) {
    layer.set(DOM_FEATURE_LINKS, domFeatureLinks);
}
function getDomFeatureLinks(layer) {
    return layer.get(DOM_FEATURE_LINKS);
}
function setEditor(layer, editor) {
    layer.set(EDITOR, editor);
}
function getEditor(layer) {
    return layer.get(EDITOR);
}
function setEnableProxy(layer, enableProxy) {
    layer.set(ENABLEPROXY, enableProxy);
}
function getEnableProxy(layer) {
    return layer.get(ENABLEPROXY);
}
function setEventsSuspended(layer, eventsSuspended) {
    layer.set(EVENTS_SUSPENDED, eventsSuspended);
}
function getEventsSuspended(layer) {
    return layer.get(EVENTS_SUSPENDED);
}
function setExclusive(layer, exclusive) {
    layer.set(EXCLUSIVE, exclusive);
}
function getExclusive(layer) {
    return layer.get(EXCLUSIVE);
}
function setFeatureInfoLang(layer, featureInfoLang) {
    layer.set(FEATURE_INFO_LANG, featureInfoLang);
}
function getFeatureInfoLang(layer) {
    return layer.get(FEATURE_INFO_LANG);
}
function setFromComposition(layer, fromComposition) {
    layer.set(FROM_COMPOSITION, fromComposition);
}
function getFromComposition(layer) {
    return layer.get(FROM_COMPOSITION);
}
function setFeatureInfoTarget(layer, featureInfoTarget) {
    layer.set(GET_FEATURE_INFO_TARGET, featureInfoTarget);
}
function getFeatureInfoTarget(layer) {
    return layer.get(GET_FEATURE_INFO_TARGET);
}
function getSld(layer) {
    return layer.get(HS_SLD);
}
function getQml(layer) {
    return layer.get(HS_QML);
}
function setSld(layer, sld) {
    layer.set(HS_SLD, sld);
}
function setHsLaymanSynchronizing(layer, hsLaymanSynchronizing) {
    layer.set(HS_LAYMAN_SYNCHRONIZING, hsLaymanSynchronizing);
}
function getHsLaymanSynchronizing(layer) {
    return layer.get(HS_LAYMAN_SYNCHRONIZING);
}
function setInfoFormat(layer, infoFormat) {
    layer.set(INFO_FORMAT, infoFormat);
}
function getInfoFormat(layer) {
    return layer.get(INFO_FORMAT);
}
function setInlineLegend(layer, inlineLegend) {
    layer.set(INLINE_LEGEND, inlineLegend);
}
function getInlineLegend(layer) {
    return layer.get(INLINE_LEGEND);
}
function setLaymanLayerDescriptor(layer, hsLaymanLayerDescriptor) {
    layer.set(LAYMAN_LAYER_DESCRIPTOR, hsLaymanLayerDescriptor);
}
function getLaymanLayerDescriptor(layer) {
    return layer.get(LAYMAN_LAYER_DESCRIPTOR);
}
function setLegends(layer, path) {
    layer.set(LEGENDS, path);
}
function getLegends(layer) {
    if (layer.get(LEGENDS) == undefined &&
        layer.get('legendImage') !== undefined) {
        console.warn('"legendImage" layer property is deprecated in favor of "legends"');
        return layer.get('legendImage');
    }
    return layer.get(LEGENDS);
}
function setMaxResolutionDenominator(layer, maxResolutionDenominator) {
    layer.set(MAX_RESOLUTION_DENOMINATOR, maxResolutionDenominator);
}
function getMaxResolutionDenominator(layer) {
    return layer.get(MAX_RESOLUTION_DENOMINATOR);
}
/**
 * Store metadata which were parsed from layer definition in composition json.
 * @param layer -
 * @param metadata -
 */
function setMetadata(layer, metadata) {
    layer.set(METADATA, metadata);
}
function getMetadata(layer) {
    return layer.get(METADATA);
}
function setMinimumTerrainLevel(layer, minimumTerrainLevel) {
    layer.set(MINIMUM_TERRAIN_LEVEL, minimumTerrainLevel);
}
function getMinimumTerrainLevel(layer) {
    return layer.get(MINIMUM_TERRAIN_LEVEL);
}
function setOnFeatureSelected(layer, onFeatureSelected) {
    layer.set(ON_FEATURE_SELECTED, onFeatureSelected);
}
function getOnFeatureSelected(layer) {
    return layer.get(ON_FEATURE_SELECTED);
}
/**
 * Used internaly by hslayers. Store the original LAYERS param
 * when overriding LAYERS by subLayers property. This is needed for metadata
 * parsing after page has refreshed and LAYERS are read from cookie or map compositions.
 * @param layer - OL layer
 * @param origLayers - Comma separated list of layer names OR 1 container layer name
 */
function setOrigLayers(layer, origLayers) {
    layer.set(ORIG_LAYERS, origLayers);
}
function getOrigLayers(layer) {
    return layer.get(ORIG_LAYERS);
}
function setPath(layer, path) {
    layer.set(PATH, path);
}
function getPath(layer) {
    return layer.get(PATH);
}
function setPopUp(layer, popUp) {
    layer.set(POPUP, popUp);
}
function getPopUp(layer) {
    return layer.get(POPUP);
}
function setPopupClass(layer, popupClass) {
    layer.set(POPUP_CLASS, popupClass);
}
function getPopupClass(layer) {
    return layer.get(POPUP_CLASS);
}
function setQueryable(layer, queryable) {
    layer.set(QUERYABLE, queryable);
}
function getQueryable(layer) {
    return layer.get(QUERYABLE);
}
function setQueryCapabilities(layer, queryCapabilities) {
    layer.set(QUERY_CAPABILITIES, queryCapabilities);
}
function getQueryCapabilities(layer) {
    return layer.get(QUERY_CAPABILITIES);
}
function setQueryFilter(layer, queryFilter) {
    layer.set(QUERY_FILTER, queryFilter);
}
function getQueryFilter(layer) {
    return layer.get(QUERY_FILTER);
}
function setRemovable(layer, removable) {
    layer.set(REMOVABLE, removable);
}
function getRemovable(layer) {
    return layer.get(REMOVABLE);
}
function setShowInLayerManager(layer, showInLayerManager) {
    layer.set(SHOW_IN_LAYER_MANAGER, showInLayerManager);
}
function getShowInLayerManager(layer) {
    return layer.get(SHOW_IN_LAYER_MANAGER);
}
/**
 * Set list of all possible sub-layers for WMS.
 * This is used to limit the displayed sub-layers on the map.
 * If sublayers property is set, the sub-layer tree in layer manager is
 * hidden, otherwise all sub-layers are shown.
 * @param layer -
 * @param subLayers - String of all possible WMS layers sub-layer names separated by comma
 */
function setSubLayers(layer, subLayers) {
    layer.set(SUB_LAYERS[0], subLayers);
}
/**
 * Get list of all possible sub-layers for WMS.
 * This is used to limit the displayed sub-layers on the map.
 * If sub-layers property is set, the sub-layer tree in layer manager is
 * hidden, otherwise all sub-layers are shown.
 * @param layer -
 */
function getSubLayers(layer) {
    var _a;
    return (_a = layer.get(SUB_LAYERS[0])) !== null && _a !== void 0 ? _a : layer.get(SUB_LAYERS[1]);
}
function setThumbnail(layer, thumbnail) {
    layer.set(THUMBNAIL, thumbnail);
}
function getThumbnail(layer) {
    return layer.get(THUMBNAIL);
}
function setVirtualAttributes(layer, virtualAttributes) {
    layer.set(VIRTUAL_ATTRIBUTES, virtualAttributes);
}
function getVirtualAttributes(layer) {
    return layer.get(VIRTUAL_ATTRIBUTES);
}
function getWorkspace(layer) {
    return layer.get(WORKSPACE);
}
function setWorkspace(layer, workspace) {
    layer.set(WORKSPACE, workspace);
}
function getWfsUrl(layer) {
    return layer.get(WFS_URL);
}
function setWfsUrl(layer, url) {
    layer.set(WFS_URL, url);
}
function getSwipeSide(layer) {
    return layer.get(SWIPE_SIDE);
}
function setSwipeSide(layer, side) {
    layer.set(SWIPE_SIDE, side);
}
const HsLayerExt = {
    getAccessRights,
    setAccessRights,
    setTitle,
    getTitle,
    setName,
    getName,
    setAbstract,
    getAbstract,
    setActive,
    getActive,
    setAttribution,
    getAttribution,
    setCacheCapabilities,
    getCachedCapabilities,
    setBase,
    getBase,
    setCluster,
    getCluster,
    setCustomInfoTemplate,
    getCustomInfoTemplate,
    setDefinition,
    getDefinition,
    setDimensions,
    getDimensions,
    getDomFeatureLinks,
    setDomFeatureLinks,
    setEditor,
    getEditor,
    setEnableProxy,
    getEnableProxy,
    setEventsSuspended,
    getEventsSuspended,
    setExclusive,
    getExclusive,
    setFeatureInfoLang,
    getFeatureInfoLang,
    setFromComposition,
    getFromComposition,
    setFeatureInfoTarget,
    getFeatureInfoTarget,
    setHsLaymanSynchronizing,
    getHsLaymanSynchronizing,
    setInfoFormat,
    getInfoFormat,
    setInlineLegend,
    getInlineLegend,
    setLaymanLayerDescriptor,
    getLaymanLayerDescriptor,
    setMaxResolutionDenominator,
    getMaxResolutionDenominator,
    setMetadata,
    getMetadata,
    setMinimumTerrainLevel,
    getMinimumTerrainLevel,
    setOnFeatureSelected,
    getOnFeatureSelected,
    setPath,
    getPath,
    setPopUp,
    getPopUp,
    setPopupClass,
    getPopupClass,
    setQueryable,
    getQueryable,
    setQueryCapabilities,
    getQueryCapabilities,
    setQueryFilter,
    getQueryFilter,
    setRemovable,
    getRemovable,
    setShowInLayerManager,
    getShowInLayerManager,
    setThumbnail,
    getThumbnail,
    setVirtualAttributes,
    getVirtualAttributes,
    setWorkspace,
    getWorkspace,
    getWfsUrl,
    setWfsUrl,
    getSwipeSide,
    setSwipeSide,
};

class HsUtilsService {
    constructor(HsConfig, http, LogService, platformId) {
        this.HsConfig = HsConfig;
        this.http = http;
        this.LogService = LogService;
        this.platformId = platformId;
    }
    /**
     * Add path to proxy cgi script (hsproxy.cgi) into URL and encode rest of URL if valid HTTP URL is send and proxy use is allowed.
     * @public
     * @param url - URL to proxify
     * @param toEncoding - Optional parameter if UTF-8 encoding shouldn't be used for non-image URLs.
     * @returns Encoded Url with path to hsproxy.cgi script
     */
    proxify(url, app = 'default', toEncoding) {
        var _a;
        const laymanEp = (_a = this.HsConfig.get(app).datasources) === null || _a === void 0 ? void 0 : _a.find((ep) => ep.type == 'layman');
        if (url.startsWith(this.HsConfig.get(app).proxyPrefix) ||
            (laymanEp && url.startsWith(laymanEp.url))) {
            return url;
        }
        if (url.startsWith('data:application')) {
            return url;
        }
        toEncoding = toEncoding === undefined ? true : toEncoding;
        let outUrl = url;
        //Not using location because don't know if port 80 was specified explicitly or not
        const windowUrlPosition = url.indexOf(window.location.origin);
        if (windowUrlPosition == -1 ||
            windowUrlPosition > 7 ||
            this.getPortFromUrl(url) != this.getPortFromUrl(window.location.origin)) {
            if (this.HsConfig.get(app).useProxy === undefined ||
                this.HsConfig.get(app).useProxy === true) {
                outUrl = this.HsConfig.get(app).proxyPrefix || '/proxy/';
                if (outUrl.indexOf('hsproxy.cgi') > -1) {
                    if (toEncoding &&
                        (url.indexOf('GetMap') == -1 || url.indexOf('GetFeatureInfo') > -1)) {
                        outUrl += 'toEncoding=utf-8&';
                    }
                    outUrl = outUrl + 'url=' + encodeURIComponent(url);
                }
                else {
                    outUrl += url;
                }
            }
        }
        return outUrl;
    }
    /**
     * @public
     * @param url - URL to shorten
     * @returns Shortened URL
     * Promise which shortens URL by using some URL shortener.
     * By default tinyurl is used, but user provided function in config.shortenUrl can be used. Example: function(url) {
              return new Promise(function(resolve, reject){
                  $http.get("http://tinyurl.com/api-create.php?url=" + url, {
                      longUrl: url
                  }).then(function(response) {
                      resolve(response.data);
                  }).catch(function(err) {
                      reject()
                  })
              })
          }
     */
    shortUrl(url, app) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.HsConfig.get(app).shortenUrl != undefined) {
                return this.HsConfig.get(app).shortenUrl(url);
            }
            return yield lastValueFrom(this.http.get(this.proxify('http://tinyurl.com/api-create.php?url=' + url, app), {
                responseType: 'text',
            }));
            // return new Promise((resolve, reject) => {
            //   this.http
            //     .get(
            //       this.proxify('http://tinyurl.com/api-create.php?url=' + url, true),
            //       {
            //         longUrl: url,
            //       }
            //     )
            //     .then((response) => {
            //       resolve(response.data);
            //     })
            //     .catch((err) => {
            //       reject();
            //     });
            // });
        });
    }
    /**
     * @param url - URL for which to determine port number
     * @returns Port number
     */
    getPortFromUrl(url) {
        if (this.runningInBrowser()) {
            const link = document.createElement('a');
            link.setAttribute('href', url);
            if (link.port == '') {
                if (url.indexOf('https://') === 0) {
                    return '443';
                }
                if (url.indexOf('http://') === 0) {
                    return '80';
                }
            }
            return link.port;
        }
    }
    runningInBrowser() {
        return isPlatformBrowser(this.platformId);
    }
    /**
     * Parse parameters and their values from URL string
     * @public
     * @param str - URL to parse parameters from
     * @returns Object with parsed parameters as properties
     */
    getParamsFromUrl(str) {
        if (typeof str !== 'string') {
            return {};
        }
        if (str.includes('?')) {
            str = str.substring(str.indexOf('?') + 1);
        }
        else {
            return {};
        }
        return str
            .trim()
            .split('&')
            .reduce((ret, param) => {
            if (!param) {
                return ret;
            }
            const parts = param.replace(/\+/g, ' ').split('=');
            let key = parts[0];
            let val = parts[1];
            key = decodeURIComponent(key);
            // missing `=` should be `null`:
            // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
            val = val === undefined ? null : decodeURIComponent(val);
            if (!ret.hasOwnProperty(key)) {
                ret[key] = val;
            }
            else if (Array.isArray(ret[key])) {
                ret[key].push(val);
            }
            else {
                ret[key] = [ret[key], val];
            }
            return ret;
        }, {});
    }
    /**
     * Create encoded Url string from object with parameters
     * @public
     * @param {object} array - Parameter object with parameter key-value pairs
     * @returns Joined encoded URL query string
     */
    paramsToURL(array) {
        const pairs = [];
        for (const key in array) {
            if (array.hasOwnProperty(key) && array[key] !== undefined) {
                pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(array[key]));
            }
        }
        return pairs.join('&');
    }
    /**
     * Insert every element in the set of matched elements after the target.
     * @public
     * @param {element} newNode - Element to insert
     * @param {element} referenceNode - Element after which to insert
     */
    insertAfter(newNode, referenceNode) {
        if (newNode.length !== undefined && newNode.length > 0) {
            newNode = newNode[0];
        }
        referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
    }
    /**
     * Create URL string from object with parameters without encoding
     * @public
     * @param {object} array - Parameter object with parameter key-value pairs
     * @returns Joined URL query string
     */
    paramsToURLWoEncode(array) {
        const pairs = [];
        for (const key in array) {
            if (array.hasOwnProperty(key)) {
                pairs.push(key + '=' + array[key]);
            }
        }
        return pairs.join('&');
    }
    /**
     * Returns a function, that, as long as it continues to be
     * invoked, will not be triggered.
     * (https://davidwalsh.name/javascript-debounce-function)
     * @public
     * @param {Function} func - Function to execute with throttling
     * @param wait - The function will be called after it stops
     * being called for N milliseconds.
     * @param immediate - If `immediate` is passed, trigger the
     * function on the leading edge, instead of the trailing.
     * @param {object} context - Context element which stores the timeout handle
     * @returns {Function} Returns function which is debounced
     */
    debounce(func, wait, immediate, context) {
        if (context === undefined) {
            context = this;
        }
        return function (...args) {
            const later = function () {
                if (!immediate) {
                    func.apply(context, args);
                }
                context.timeout = null;
            };
            const callNow = immediate && !context.timeout;
            clearTimeout(context.timeout);
            context.timeout = setTimeout(later, wait);
            if (callNow) {
                func.apply(context, args);
            }
        };
    }
    /**
     * Generate randomized UUID
     * @public
     * @returns Random uuid
     */
    generateUuid() {
        return generateUuid();
    }
    /**
     * Generates CSS color string (rgba(0, 0, 0, 1)) from given range and value for which to have color
     * @public
     * @param numOfSteps - Maximum value which is the last color in rainbow
     * @param step - Current value to get color for
     * @param opacity - Opacity from 0 to 1
     * @returns CSS color
     */
    rainbow(numOfSteps, step, opacity) {
        // based on http://stackoverflow.com/a/7419630
        // This function generates vibrant, "evenly spaced" colours (i.e. no clustering). This is ideal for creating easily distinguishable vibrant markers in Google Maps and other apps.
        // Adam Cole, 2011-Sept-14
        // HSV to RBG adapted from: http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript
        let r, g, b;
        const h = step / (numOfSteps * 1.00000001);
        const i = ~~(h * 4);
        const f = h * 4 - i;
        const q = 1 - f;
        switch (i % 4) {
            case 2:
                (r = f), (g = 1), (b = 0);
                break;
            case 0:
                (r = 0), (g = f), (b = 1);
                break;
            case 3:
                (r = 1), (g = q), (b = 0);
                break;
            case 1:
                (r = 0), (g = 1), (b = q);
                break;
            default:
        }
        const c = 'rgba(' +
            ~~(r * 235) +
            ',' +
            ~~(g * 235) +
            ',' +
            ~~(b * 235) +
            ', ' +
            opacity +
            ')';
        return c;
    }
    /**
     * Creates a deep copy of the input object
     * @param {object} from object to deep copy
     * @param {object?} to optional target for copy
     * @returns a deep copy of input object
     */
    structuredClone(from, to) {
        if (from === null || typeof from !== 'object') {
            return from;
        }
        if (from.constructor != Object && from.constructor != Array) {
            return from;
        }
        if (from.constructor == Date ||
            from.constructor == RegExp ||
            from.constructor == Function ||
            from.constructor == String ||
            from.constructor == Number ||
            from.constructor == Boolean) {
            return new from.constructor(from);
        }
        to = to || new from.constructor();
        for (const key in from) {
            to[key] =
                typeof to[key] == 'undefined'
                    ? this.structuredClone(from[key])
                    : to[key];
        }
        return to;
    }
    /**
     * Check if object is a function
     * @param functionToCheck
     * @returns true when input is a function, false otherwise
     */
    isFunction(functionToCheck) {
        return isFunction(functionToCheck);
    }
    /**
     * Check if object is plain object (not function, not array, not class)
     * @param objectToCheck
     * @returns true when input is plain old JavaScript object, false otherwise
     */
    isPOJO(objectToCheck) {
        return (objectToCheck && {}.toString.call(objectToCheck) === '[object Object]');
    }
    /**
     * Remove duplicate items from an array
     * @param {Array<object>} dirtyArray Array with possible duplicate objects
     * @param property - Property of objects which must be unique in the new array.
     * Use dot symbol (".") to denote a property chain in nested object.
     * Function will return an empty array if it won't find the property in the object.
     * @returns {Array<object>} Array without duplicate objects
     */
    removeDuplicates(dirtyArray, property) {
        const propertyChain = property.split('.');
        const flatArray = [...dirtyArray];
        for (const prop of propertyChain) {
            for (const idx in flatArray) {
                if (flatArray[idx] === undefined) {
                    this.LogService.error(`Property "${prop}" not found in object.`);
                    return [];
                }
                flatArray[idx] =
                    flatArray[idx].get !== undefined
                        ? flatArray[idx].get(prop) /* get() is only defined for OL objects */
                        : flatArray[idx][prop]; /* POJO access */
            }
        }
        return dirtyArray.filter((item, position) => {
            let propertyValue = item;
            for (const prop of propertyChain) {
                propertyValue =
                    propertyValue.get !== undefined
                        ? propertyValue.get(prop) /* get() is only defined for OL objects */
                        : propertyValue[prop]; /* POJO access */
            }
            return flatArray.indexOf(propertyValue) === position;
        });
    }
    hashCode(s) {
        let hash = 0;
        if (s.length == 0) {
            return hash;
        }
        for (let i = 0; i < s.length; i++) {
            const char = s.charCodeAt(i);
            hash = (hash << 5) - hash + char;
            hash = hash & hash; // Convert to 32bit integer
        }
        return hash;
    }
    /**
     * Replaces input string text with replacement text
     * @public
     * @param target - Target string
     * @param search - String to look for
     * @param replacement - Replacement value
     * @returns Returns modified string
     */
    replaceAll(target, search, replacement) {
        return target.replace(new RegExp(search, 'g'), replacement);
    }
    resolveEsModule(module) {
        if (module.default) {
            return module.default;
        }
        else {
            return module;
        }
    }
    /**
     * Replaces first string letter to UpperCase
     * @public
     * @param target - Target string
     * @returns modified string
     */
    capitalizeFirstLetter(target) {
        return target.charAt(0).toUpperCase() + target.slice(1);
    }
    undefineEmptyString(str) {
        if (str === undefined) {
            return undefined;
        }
        return str.trim() != '' ? str : undefined;
    }
    isOverflown(element) {
        return (element.scrollHeight > element.clientHeight ||
            element.scrollWidth > element.clientWidth);
    }
    /**
     * @private
     * @param {LineString} line
     * @returns {Measurement} numeric length of line with used units
     * @description Compute and format line length with correct units (m/km)
     */
    formatLength(line, sourceProj) {
        let length = 0;
        const coordinates = line.getCoordinates();
        for (let i = 0; i < coordinates.length - 1; ++i) {
            const c1 = transform(coordinates[i], sourceProj, 'EPSG:4326');
            const c2 = transform(coordinates[i + 1], sourceProj, 'EPSG:4326');
            length += getDistance(c1, c2);
        }
        const output = {
            size: length,
            type: 'Length',
            unit: 'm',
        };
        if (length > 100) {
            output.size = Math.round((length / 1000) * 100) / 100;
            output.unit = 'km';
        }
        else {
            output.size = Math.round(length * 100) / 100;
            output.unit = 'm';
        }
        return output;
    }
    instOf(obj, type) {
        return instOf(obj, type);
    }
    /**
     * @private
     * @param {Polygon} polygon
     * @returns {object} area of polygon with used units
     * @description Compute and format polygon area with correct units (m2/km2)
     */
    formatArea(polygon, sourceProj) {
        const area = Math.abs(getArea(polygon));
        const output = {
            size: area,
            type: 'Area',
            unit: 'm',
        };
        if (area > 10000) {
            output.size = Math.round((area / 1000000) * 100) / 100;
            output.unit = 'km';
        }
        else {
            output.size = Math.round(area * 100) / 100;
            output.unit = 'm';
        }
        return output;
    }
}
HsUtilsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUtilsService, deps: [{ token: HsConfig }, { token: i1.HttpClient }, { token: HsLogService }, { token: PLATFORM_ID }], target: i0.ɵɵFactoryTarget.Injectable });
HsUtilsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUtilsService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUtilsService, decorators: [{
            type: Injectable
        }], ctorParameters: function () {
        return [{ type: HsConfig }, { type: i1.HttpClient }, { type: HsLogService }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [PLATFORM_ID]
                    }] }];
    } });
function generateUuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0, v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
/**
 * Check if object is an instance of a specific class
 * @param obj - any object to check
 * @param type - class type itself
 * @returns true when obj is an instance of the provided type, false otherwise
 */
function instOf(obj, type) {
    return _instanceOf(obj, type);
}
function _instanceOf(obj, klass) {
    if (obj === undefined || obj === null) {
        return false;
    }
    if (klass.default) {
        klass = klass.default;
    }
    if (isFunction(klass)) {
        return obj instanceof klass;
    }
    obj = Object.getPrototypeOf(obj);
    while (obj !== null) {
        if (obj.constructor.name === klass) {
            return true;
        }
        obj = Object.getPrototypeOf(obj);
    }
    return false;
}
/**
 * Check if object is a function
 * @param functionToCheck - object to check, presumably a function
 * @returns true when input is a function, false otherwise
 */
function isFunction(functionToCheck) {
    return (functionToCheck && {}.toString.call(functionToCheck) === '[object Function]');
}

var ADDDATA = {
    catalogue: "Data Catalogue",
    CATALOGUE: {
        addAs: "Add as",
        DESC: {
            WFS: "Web Feature Service: it adds the layer as a set of vector features. It is more power-consuming, especially with large layers, but it allows to edit features or to display individual feature info.",
            WMS: "Web Map Service: it adds the layer as a raster image. The transferred data is usually smaller so it generally loads faster. Yet it does not give you the access to the underlaying layer features."
        },
        filterType: "Search within",
        loading: "Loading data",
        queryDataTypes: {
            all: "All",
            dataset: "Datasets",
            service: "Services"
        },
        resourceType: "Resource type",
        searchFilterTypes: {
            Abstract: "Abstract",
            AnyText: "All",
            Title: "Title"
        },
        searchType: "Search filter type",
        selectFilterType: "Change search filter type",
        showAll: "All",
        showingSubset: "Currently showing {{limitShown}} of {{total}} services. Show",
        showNext100: "Next 100",
        sortbyTypes: {
            bbox: "Extent",
            date: "Date",
            title: "Title"
        },
        theNumberOfRecords: "The number of records will be calculated as close as possible to the selected number"
    },
    file: "File",
    FILE: {
        onlyOneZipFileCan: "Only one zip file can be uploaded at once",
        someOfTheUploadedFiles: "Uploaded file exceeded maximum allowed size of 20MB",
        zipFileCannotBeUploaded: "Archive file cannot be uploaded together with regular files"
    },
    requestServiceLayers: "Request service layers",
    saveToDatabase: "Save to database",
    URL: {
        selectAll: "Select all Layers",
        submitLayerName: "Fill in layer name",
        submitLayerTitle: "Fill in layer title"
    },
    dialogOverWrite: {
        overwriteExistingLayer: "Layer already exists!",
        doYouWishToOverwrite: "Do You wish to overwrite layer:",
        noteForRepetiveDialog: "*Note: Renaming and uploading layer failed, because such layer name already exists!"
    }
};
var ADDLAYERS = {
    addSelected: "Add selected layers to the map",
    Basemap: "Add as basemap",
    capabilitiesParsingProblem: "Capabilities parsing problem",
    chooseFormat: "Choose format",
    chooseType: "Choose type",
    considerUsingTiles: "Consider using tiles. Some servers has restricted max size of picture.",
    couldNotUploadSelectedFile: "There was a problem uploading the selected file!",
    ERROR: {
        errorWhileRequestingLayers: "Error while requesting layers",
        someErrorHappened: "Some error happened or input missing",
        srsNotSupported: "Selected Coordinate reference systems (CRS/SRS) is not supported. Please provide file in EPSG:3857 or EPSG:4326 to proceed.",
        thereWasErrorWhile: "There was error while parsing Capabilities response from given URL",
        urlInvalid: "Missing or invalid endpoint URL of requested layer!",
        unsupportedDatasourceType: "Unsupported datasource type"
    },
    externalDataSource: "External data source (URL)",
    featureCount: "Feature count",
    filesSelected: "Files selected",
    folderName: "Folder name",
    GPServerServicesAreNotSupported: "GPServer services are not supported!",
    imageFormat: "Image format",
    layerNameAlreadyExists: "Layer name already exists",
    loadingFeaturePleaseWait: "Loading features, please wait",
    mapAndLayerProjection: "Map and layer projection do not match! Resampling will be used. This may lead to unexpectable results.",
    mapProjectionAndLayerProjection: "Map projection and layer projection do not match. Add the layer to map and use server-side resampling program?",
    missingImageorWorldFile: "Missing an image or world file, please check the files and try again!",
    nameAndSRSRequired: "'Name' and 'SRS' field required to proceed!",
    nameRequired: "'Name' field required to proceed!",
    none: "None (at top)",
    OlDoesNotRecognizeProjection: "Ol does not recognize requested layers projection",
    queryFormat: "Query format",
    "Raster image": "Raster image",
    rasterImageryWith: "Raster imagery with georeferencing is currently only supported on EPSG:4326 and EPSG:3857 coordinate systems. Please make sure your data meets these requirements before uploading.",
    registerMetadata: "Register metadata",
    resampleLayer: "Resample layer",
    serviceTypeNotMatching: "URL service type does not match selected category",
    SHP: {
        loginRequired: "User login is required before layer can be loaded",
        maximumNumberOf: "Maximum number of {{allowed}} files allowed, but {{length}} selected",
        missingOneOrMore: "Missing one or more Shape files. Load files with extensions *.shp, *.shx, *.dbf or zip containing these files.",
        shapeFile: "Shape file (shp+dbf+shx)",
        SLDStyleFile: "Style file",
        neededFiles: "Load files with extensions *.shp, *.shx, *.dbf or zip file containing these files.",
        considerUsingZip: "Consider using '.zip' format for shapefiles bigger than 10MB of size, that way upload will be much quicker.",
        exceedingSize: "Shapefile being loaded exceeds recommended size"
    },
    srs: "SRS",
    SRSRequired: "'SRS' field required to proceed!",
    thisIsRequired: "This is required!",
    tileSize: "Tile size",
    TYPES: {
        ArcGIS: "ArcGIS Map Server",
        shapeFile: "Shapefile",
        vectorFile: "Vector file (GeoJSON, KML)",
        WFS: "Web feature service (WFS)",
        WMS: "Web map service (WMS)"
    },
    unauthorizedAccess: "Unauthorized access. You are not authorized to query data from this service",
    under: "Add under layer",
    unknownDimesion: "This layer defines some dimension, which cannot be currently parsed",
    useProxy: "Use proxy",
    useTiles: "Use tiles",
    Vector: {
        addingFiles: "Adding {{featuresCount}} features into:",
        addSld: "Add SLD file",
        chooseFiles: "Choose files...",
        chooseLayer: "Please, choose a layer from list...",
        dragAndDropFiles: "Drag and drop files",
        note: "*Note: if you link a file with coordinates other than World Geodetic System (lon/lat), please set the SRS",
        uploadVectorFiles: "Upload vector files"
    },
    VECTOR: {
        extractStyles: "Extract styles"
    },
    WFS: {
        addToMap: "Add to map",
        loadingToManyAtOnce: "features. Loading too many at once (while zoomed out) may affect app performance",
        selectedLayerContains: "Selected layer contains"
    },
    WMTS: {
        tileMatrix: "Tile matrix"
    }
};
var COMMON = {
    abstract: "Abstract",
    access: "Access",
    add: "Add",
    addAs: "Add as",
    advancedOptions: "Advanced options",
    all: "All",
    application: "Application",
    apply: "Apply",
    area: "Area",
    attribute: "Attribute",
    attributes: "Attributes",
    "Authentication failed. Login to the catalogue.": "Authentication failed. Login to the catalogue.",
    author: "Author",
    boundingBox: "Bounding box",
    cancel: "Cancel",
    category: "Category",
    circle: "Circle",
    clear: "Clear",
    close: "Close",
    closeDialog: "Close dialog",
    color: "Color",
    confirm: "Confirm",
    confirmDelete: "Confirm delete",
    connect: "Connect",
    contactInformation: "Contact Information",
    context: "Context",
    "continue": "Continue",
    copyLayer: "Copy layer",
    data: "Data",
    dataset: "Dataset",
    date: "Date",
    "delete": "Delete",
    description: "Description",
    distance: "Distance",
    download: "Download",
    downloadAsPng: "Download as PNG",
    drawNewFeatures: "Draw new features",
    east: "East",
    edit: "Edit",
    enabled: "Enabled",
    extent: "Extent",
    fill: "Fill",
    fillInDescriptive: "Fill in descriptive text about map",
    fillInName: "Fill in name",
    filter: "Filter:",
    folder: "Folder",
    from: "From",
    fullText: "Full text",
    hide: "Hide",
    icon: "Icon",
    ignoreAndContinue: "Ignore and continue",
    info: "Additional information",
    into: " into",
    keywords: "Keywords",
    layer: "Layer",
    layers: "Layers",
    legend: "Legend",
    less: "Less",
    line: "Line",
    lineColor: "Line color",
    lineWidth: "Line width",
    loading: "Loading",
    Login: "Log in",
    Logout: "Log out",
    mapExtentFilterMissing: "Please enable Filter by map extent checkbox to be able to sort data by Bounding box",
    menu: "Menu",
    metadata: "Metadata",
    more: "More",
    name: "Name",
    "new": "New",
    newDrawingLayer: "New drawing layer",
    next: "Next",
    no: "No",
    noDataReceived: "No data received!",
    north: "North",
    ok: "Ok",
    open: "Open",
    or: "or",
    orderBy: "Order by",
    photo: "Photo",
    point: "Point",
    polygon: "Polygon",
    preview: "Preview",
    print: "Print",
    projection: "Projection",
    radius: "Radius",
    reload: "Reload",
    removeLayer: "Remove layer",
    renameLayer: "Rename layer",
    reset: "Reset",
    resetToDefault: "Reset to default values",
    results: "Results",
    rotation: "Rotation",
    save: "Save",
    saveAs: "Save as..",
    saveTo: "Save to",
    scale: "Scale",
    search: "Search:",
    selectAndConfirmToDeleteMultiple: "Select and confirm to delete multiple layers",
    selectRecordCountPerPage: "Select record count per page",
    service: "Service",
    settings: "Settings",
    share: "Share",
    showMore: "Show more",
    Sort: "Sort",
    sortBy: "Sort by",
    south: "South",
    steps: "Steps",
    stop: "Stop",
    stroke: "Stroke",
    strokeWidth: "Stroke width",
    style: "Style",
    theme: "Theme",
    thumbnail: "Thumbnail",
    title: "Title",
    to: "to",
    type: "Type",
    unknown: "Unknown",
    unknownError: "Unknown error. Please try again.",
    until: "Until",
    uploading: "Uploading data",
    url: "URL",
    value: "Value",
    warning: "Warning",
    west: "West",
    width: "Width",
    wrongCombinationOfParams: "Wrong combination of parameters",
    yes: "Yes",
    zoomTo: "zoom to",
    height: "Height",
    required: "Required",
    addLayers: "Add layers",
    toggle: "Toggle",
    reversed: "Reversed",
    setPermissions: "Set permissions",
    selectAndSavePermissions: "Select and confirm permissions for",
    setPermissionsError: "Set permissions error",
    somethingWentWrong: "Something went wrong, please try again!",
    reading: "Reading data"
};
var COMPOSITIONS = {
    addByAddress: "Add composition by address",
    Address: "Address",
    clearFilters: "Clear all filters",
    compostionsNameAttributeIsNotDefined: "Compositions name attribute is not defined!",
    dialogDelete: {
        doYouWantToDeleteMap: "Do you want to delete map?"
    },
    dialogInfo: {
        details: "details",
        metadata: {
            comparison_url: "Comparison URL",
            csw_url: "CSW URL",
            identifier: "Identifier",
            record_url: "Record URL"
        },
        metadataAboutMetadata: "Metadata about metadata"
    },
    dialogoverwriteConfirm: {
        mergeCompositions: "Merge compositions",
        overwriteExistingMap: "Overwrite existing map?",
        saveChangesFirst: "Save changes first",
        thereAreCurrentlyUnsavedChanges: "There are currently unsaved changes.",
        whatDoYouWant: "What do you want to do before opening the selected map composition?",
        youAreOpeningMap: "You are opening map"
    },
    dialogShare: {
        shareMap: "Share map"
    },
    dialogWarning: {
        outOfBounds: "Compostion extent is out of EPSG:4326 boundaries.",
        toContinue: "Map will not fit the given composition geometry or extent based on the given map size and borders."
    },
    endpointUrlIsNotDefined: "Endpoint url is not defined!",
    endpointUserIsNotDefined: "Endpoint user is not defined!",
    errorWhileCreatingLayerFromComposition: "Error while creating layer from composition",
    errorWhileLoadingCompositionMetadata: "Error while loading composition metadata",
    errorWhileRequestingCompositions: "Error while requesting compositions",
    errorWhileSharingOnSocialNetwork: "Error while sharing composition on social network",
    filterByMap: "Filter by map extent",
    "import": "Import composition from a file on device",
    inspireTheme: "INSPIRE theme",
    loginToCatalogue: "Login to catalogue",
    metadataNotAvailable: "Metadata are not available!",
    notAbleToParseLayerFromComposition: "It was not possible to parse a layer from composition:",
    notAllowedToEditLayer: "You are not allowed to edit this composition",
    onlyMine: "Only mine",
    selectKeywords: "Select keywords",
    selectThemes: "Select themes",
    sharingUrlIsNotAvailable: "Sharing URL is not available!",
    compositionNotFound: "Composition not found",
    sorryButComposition: "Sorry, but composition was deleted or incorrectly saved",
    compositionNotLoaded: "Composition not loaded",
    weAreSorryBut: "We are sorry, but composition was not loaded due to some error",
    cswDialog: {
        servicesLoading: "Service is loading, please wait!",
        infoText: "Choose which layers you want to add to map from services available below! ",
        otherLayers: "Other layers that are part of the composition",
        loadComposition: "Load composition"
    }
};
var COMPOSITONINSPIRETHEMES = {
    Addresses: "Addresses",
    "Administrative units": "Administrative units",
    "Agricultural and aquaculture facilities": "Agricultural and aquaculture facilities",
    "Area management/restriction/regulation zones and reporting units": "Area management/restriction/regulation zones and reporting units",
    "Atmospheric conditions": "Atmospheric conditions",
    "Atmospheric Conditions and meteorological geographical features": "Atmospheric Conditions and meteorological geographical features",
    "Bio-geographical regions": "Bio-geographical regions",
    Buildings: "Buildings",
    "Cadastral parcels": "Cadastral parcels",
    "Coordinate reference systems": "Coordinate reference systems",
    Elevation: "Elevation",
    "Energy resources": "Energy resources",
    "Environmental monitoring facilities": "Environmental monitoring facilities",
    "Geographical grid systems": "Geographical grid systems",
    "Geographical names": "Geographical names",
    Geology: "Geology",
    "Habitants and biotopes": "Habitats and biotopes",
    "Human health and safety": "Human health and safety",
    Hydrography: "Hydrography",
    "Land cover": "Land cover",
    "Land use": "Land use",
    "Meteorological geographical features": "Meteorological geographical features",
    "Mineral resources": "Mineral resources",
    "Natural risk zones": "Natural risk zones",
    None: "None",
    "Oceanographic geographical features": "Oceanographic geographical features",
    Orthoimagery: "Orthoimagery",
    "Population distribution - demography": "Population distribution - demography",
    "Production and industrial facilities": "Production and industrial facilities",
    "Protected sites": "Protected sites",
    "Sea regions": "Sea regions",
    Soil: "Soil",
    "Species distribution": "Species distribution",
    "Statistical units": "Statistical units",
    "Transport networks": "Transport networks",
    "Utility and governmental services": "Utility and governmental services"
};
var COMPOSITONKEYWORDS = {
    Basemap: "Basemap",
    Borders: "Borders",
    Cadastre: "Cadastre",
    "Complex information": "Complex information",
    Culture: "Culture",
    Demographics: "Demographics",
    Economics: "Economics",
    Environment: "Environment",
    Hazards: "Hazards",
    Infrastructure: "Infrastructure",
    "Land use": "Land use",
    "Physical geography": "Physical geography",
    Planning: "Planning",
    "Real estate": "Real estate",
    "Socio political conditions": "Socio political conditions",
    Transport: "Transport",
    Water: "Water"
};
var COMPOSITONSORTVALUES = {
    Bbox: "Bounding box",
    "Date": "Date",
    None: "None",
    Title: "Title"
};
var COMPOSITONTYPES = {
    Application: "Application",
    Datasource: "Data",
    "Feature catalogue": "Feature catalogue",
    None: "None",
    Service: "Service"
};
var DATASOURCE_SELECTOR = {
    addToMapAs: "Add to map as",
    advancedMicka: {
        applicationType: "Application type",
        dateStamp: "Date stamp",
        extendedSearchParameters: "Extended search parameters for Micka",
        extentSimilarity: "Extent similarity",
        featureCatalogue: "Feature catalogue",
        organizationName: "Organization name",
        serviceType: "Service type",
        topicCategory: "Topic category"
    },
    datasourceListItem: {
        abortAdd: "Abort add",
        addToMap: "Add to map",
        notAllowedToEditLayer: "You are not allowed to edit this layer",
        whatDoesItMean: "What does it mean?"
    },
    externalData: "External data",
    layerRDF: "Layer RDF",
    metadataFor: "Metadata for",
    noResults: "No results",
    suggestions: "Suggestions"
};
var DRAW = {
    activateDrawing: "Activate drawing by choosing a feature type",
    activeLayers: "Active layers",
    allowSnapping: "Allow snapping",
    boxSelection: "Box selection",
    boxSelectionActivated: "Box selection activated",
    definedStyle: "Defined style",
    deleteNote: "*Layer will be deleted completely. In case you want to delete layer from the current compositon only (preserving it in database) do so in 'Layermanager' panel.",
    deleteNotePlural: "* All selected layers will be deleted completely. In case you want to delete all selected layers from the current compositon only (preserving it in database) do so in 'LayerManager' panel.",
    deselectAllFeatures: "Deselect all features",
    disableDrawing: "Disable drawing",
    drawInfo: "While drawing polygon or line you can hold SHIFT to free-hand draw; You can delete last point with Backspace key",
    drawingTo: "Drawing to:",
    drawLayer: "Draw layer",
    drawLayerMetadata: {
        defaultAttributes: "Default attributes",
        defaultValue: "Default value",
        layerTitle: "Layer title",
        layerWillBeAdded: "*Layer will be added to the map and can be further managed in \"Layermanager\" panel",
        loadServerLayers: "Load layer from server",
        nameOfFolder: "Name of folder in layer-manager hierararchy"
    },
    drawToolbar: {
        addDrawLayer: "Add new draw layer",
        addLayer: "Add layer",
        finishFeature: "Finish feature",
        removeLastPoint: "Remove last point",
        selectType: "Geometry type"
    },
    featureEditor: {
        drawNewFeature: "Draw new feature",
        editOptions: {
            difference: "Difference",
            intersection: "Intersection",
            split: "Split",
            union: "Union"
        },
        featureCanBeEditedbyOptions: "can be edited by one of the avaliable options",
        featureEditor: "Feature editor",
        noIntersection: "No common intersection found for selected features",
        onlyOneFeatureToEdit: "Only one feature can be edited (split) at the time!",
        onlyOneSplitLine: "Only one splitting line allowed",
        orSelectOne: "or select one (shift + click)",
        selectedFeature: "Selected feature",
        selectFeatureToEdit: "Select a polygon feature you want to edit!"
    },
    fillOpacity: "Fill opacity:",
    loadingLayer: "Loading layer ",
    longerLoading: "Seems like loading takes longer than usual. Wait a moment please!\n",
    newGPS: "New GPS",
    noSuitableLayer: "No suitable layer available",
    notAuthorized: "User not authorized, drawings won´t be preserved",
    notAVectorLayer: "Not a vector layer",
    pleaseCheckTheLayers: "Please check the layers you want to delete",
    reallyDeleteThisLayer: "Really delete this layer?",
    removeMultipleLayers: "Remove multiple layers",
    saveDrawingToLayer: "Save drawing to layer",
    "Select layer": "Select layer",
    selectAllFeatures: "Select all features",
    serverLayers: "Server layers",
    snapTo: "Snap to features of layer",
    stylingMissing: "Proper styling missing",
    stylingMissingWarning: "{{type}} geometry can NOT be visualized. Create {{symbolizer}} symbolizer first. You can do so in {{panel}} panel.",
    thisLayerDoesNotSupportDrawing: "This layer does not support drawing, would You like to add it anyway?",
    unsavedDrawing: "Unsaved drawing",
    useModifierToSelectWithBox: "Use {{platformModifierKey}} and drag to select features with box"
};
var ERRORMESSAGES = {
    "0": "Http failure response for {{url}}: 0 Unknown Error",
    "400": "Http failure response for {{url}}: 400 Bad Request",
    "403": "Http failure response for {{url}}: 403 Forbidden",
    "404": "Http failure response for {{url}}: 404 Not Found",
    "502": "Http failure response for {{url}}: 502 Bad Gateway",
    "Invalid Params": "Please check if all the required text fields are filled in before sharing the map!",
    "Timeout has occurred": "Http failure response for {{url}}: Timeout Out"
};
var FEATURE_TABLE = {
    "delete": "delete",
    showFeatureStats: "Expand",
    sortFeaturesByValue: "Sort features by value",
    "zoom to": "zoom to"
};
var GEOLOCATION = {
    altitude: "Altitude",
    follow: "Follow",
    locateMe: "Locate me",
    precision: "Precision",
    speed: "Speed"
};
var HISTORY = {
    toggleDropdown: "Toggle dropdown"
};
var INFOCOMPONENT = {
    newMap: "New map",
    unsavedMap: "Unsaved map",
    viewComposeAndAnalyse: "View, Compose and analyse spatial data",
    youHaveUnsavedChanges: "You have unsaved changes!"
};
var LAYERMANAGER = {
    baselayers: "Baselayers",
    baseMapGallery: {
        grayscale: "Grayscale",
        noBaseMap: "No basemap"
    },
    dialogRemoveAll: {
        dialogMessage: "Do you really want to remove all your layers?",
        reloadComposition: "Reload composition",
        removeAllAdded: "Remove all added layers"
    },
    dialogRemoveLayer: {
        dialogMessage: "Do You really want to remove the selected layer?"
    },
    dimensions: "Dimensions",
    editorButtons: "Editor buttons",
    enablePhysicalLayerList: "Enable/Disable layer reordering",
    layerEditor: {
        cluster: "Cluster",
        copyLayer: "Copy selected layer",
        copyright: "Copyright",
        layerFrom: "layer from",
        memory: "memory",
        metadataOfLayer: "Metadata of layer in",
        metadataOfService: "Metadata of service",
        opacity: "Opacity",
        savegeojson: "Download layer content as GeoJSON",
        styleLayer: "Style layer",
        vector: "Vector",
        "vector (GeoJSON)": "Vector (GeoJSON)",
        "vector (KML)": "Vector (KML)",
        "vector (TopoJSON)": "Vector (TopoJSON)",
        zoomToLayer: "Zoom to layer",
        interpolatedAttribute: "Interpolated attribute",
        colorMap: "Color map",
        min: "Min",
        max: "Max"
    },
    layerList: {
        layerIsQueryable: "This layer is queryable",
        layerNotAvailable: "This layer is not available",
        moveLayerDown: "Move layer down the list",
        moveLayerUp: "Move layer up the list",
        noAvailableInScale: "This layer is not available in this scale",
        sendingToLayman: "Sending to layman"
    },
    layermanagerMd: {
        aboutLayer: "About layer",
        changeLayerOpacity: "Change layer opacity",
        changeLineWidht: "Change line width",
        filterFeatures: "Filter features",
        imageLayer: "Image layer",
        innerRadius: "Inner radius",
        layerName: "Layer name",
        layerOpacity: "Layer Opacity",
        layerOptions: "Layer options",
        layerStyle: "Layer Style",
        layerVisibility: "Layer visibility",
        lineFeatures: "Line features",
        moveLayerDown: "Move layer down",
        moveLayerDownward: "Move layer downward, SHIFT-click to bottom",
        moveLayerUp: "Move layer up",
        moveLayerUpward: "Move layer upward, SHIFT-click to top",
        outerRadius: "Outer radius",
        pointFeatures: "Point features",
        polygonFeatures: "Polygon features",
        sidesNumber: "Sides number",
        star: "Star"
    },
    mapContent: "Map content",
    other: "Other",
    removeAllLayers: "Remove all layers",
    resetMap: "Reset map",
    terrains: "Terrains",
    time: {
        outOfRange: "Selected time is out of range",
        outOfRangeDescription: "This layer can show different data based on a selected time. The time can get \"out of range\" when it is synchronized with another layer but this layer has no data for that point in time. Click to pick a valid date and time. You can also disable the layer time synchronization.",
        syncTimes: "Synchronize times",
        syncTimesTooltip: "Synchronize time for all layers",
        loading: "Fetching available times ..."
    },
    toggleAllLayerVisibility: "Toggle visibility of all layers",
    "User generated": "User generated"
};
var LAYERS = {
    existingLayer: "Existing layer",
    newLayer: "New layer"
};
var LAYMAN = {
    allLayersSuccessfullyRemoved: "All layers successfully removed",
    deleteLayersRequest: "Delete layers request",
    deletionInProgress: "Deletion in progress, please wait!",
    ERROR: {
        "2": "Unable to open raster file",
        "18": "Missing one or more Shape files",
        "50": "Error when normalizing raster file"
    },
    layerSuccessfullyRemoved: "Layer successfully removed"
};
var LEGEND = {
    noLegendExists: "No layer with legend exists!"
};
var MAP = {
    zoomKeyModifier: "Use {{platformModifierKey}} + mouse-wheel to zoom the map",
    zoomToInitialWindow: "Zoom to initial window"
};
var MAP_SWIPE = {
    bottom: "Bottom",
    disableSwipe: "Disable swipe",
    dndLayers: "Use drag&drop to move layers between the map sides!",
    enableSwipe: "Enable swipe",
    entireMap: "Entire map",
    horizontalSwipe: "Horizontal swipe",
    leftSide: "Left side",
    noLayers: "No layers (drag any layer here)",
    resetSlider: "Reset slider",
    rightSide: "Right side",
    top: "Top",
    verticalSwipe: "Vertical swipe"
};
var MEASURE = {
    measureMd: {
        deleteAllMeasurements: "Delete all measurements",
        measureType: "Measure type",
        saveMeasurementToLayer: "Save measurement to layer"
    },
    multipleShapes: "Multiple shapes"
};
var PANEL_HEADER = {
    ADDLAYERS: "Add external data",
    APPLICATIONSETTINGS: "Application settings",
    COMPOSITIONS: "Compositions",
    DATASOURCE_SELECTOR: "Datasources",
    DRAW: "Draw",
    FEATURE_TABLE: "Feature table",
    FILTERFEATURES: "Filter features",
    INFO: "Info",
    LANGUAGE: "Change language",
    LEGEND: "Legend",
    LM: "Layermanager",
    MAP_SWIPE: "Map swipe",
    MAPCOMPOSITIONS: "Map compositions",
    MEASURE: "Measurement",
    PERMALINK: "Share map",
    PRINT: "Print",
    ROUTING: "Routing",
    SAVECOMPOSITION: "Save current map",
    SEARCH: "Search",
    SENSORS: "Sensors",
    TRIP_PLANNER: "Trip planner"
};
var PERMALINK = {
    directiveMd: {
        copyToClipboard: "Copy to clipboard"
    },
    embed: "embed",
    embedCode: "Embed code",
    linkFor: "Link for",
    newShare: "New share",
    permalink: "Permalink",
    pureMap: "Pure map",
    shareOnSocialNetwork: "Share on social network",
    sharePureMap: "Share pure map",
    sharesMapWith: "*Shares map with (all )portal functionality",
    sharesOnlyMap: "*Shares only map as picture",
    socialShare: "Social share"
};
var PRINT = {
    bottom: "Bottom",
    center: "Center",
    degrees: "Degrees",
    "imperial inch": "Imperial inch",
    imprintStylingOptions: "Imprint styling options",
    italic: "Italic",
    left: "Left",
    legendStylingOptions: "Legend styling options",
    metric: "Metric",
    middle: "Middle",
    "nautical mile": "Nautical mile",
    normal: "Normal",
    bold: "Bold",
    right: "Right",
    scalebar: "Scale bar",
    scaleBarText: "Scale bar text",
    scaleline: "Scale line",
    scaleSteps: "Scale steps",
    scaleStylingOptions: "Scale styling options",
    scaleType: "Scale type",
    scaleUnits: "Scale units",
    textDraw: "Text draw type",
    textPosition: "Text position",
    titleStylingOptions: "Title styling options",
    top: "Top",
    "us inch": "Us inch",
    imprint: "Imprint",
    backgroundColor: "Background color",
    textColor: "Text color"
};
var QUERY = {
    clusterContaining: "Cluster containing {{count}} features",
    confirmClear: "Confirm clear",
    confirmDelete: "Confirm delete",
    coordinates: "Coordinates",
    deleteAllSelected: "Delete all selected features",
    downloadAs: "Download as",
    feature: {
        attributeName: "Attribute name",
        attributeValue: "Attribute value",
        copyFeature: "Copy feature",
        copyFeatures: "Copy features",
        featurecopySucc: "Feature was successfully copied into layer: ",
        featureEdited: "Feature change successfull",
        featuremoveSucc: "Feature was successfully moved to layer: ",
        moveFeature: "Move feature",
        moveFeatures: "Move features",
        inLayer: "in layer"
    },
    featureInfo: "Feature info",
    featurePopup: {
        clearLayer: "Clear layer",
        closePopup: "Close popup",
        removeClusterPart: "Remove cluster part",
        removeFeature: "Remove feature"
    },
    featuresSelected: "Features selected: ",
    infoPanel: {
        clickOnMap: "Click on map for query results"
    },
    reallyDelete: "Really delete this feature?",
    reallyDeleteAllFeaturesFrom: "Really delete all features from layer {0}?",
    reallyDeleteAllSelectedLayers: "Really delete all selected features?",
    untitledFeature: "Untitled feature"
};
var SAVECOMPOSITION = {
    dialogResult: {
        compositionFailedToSave: "Composition failed to save",
        compositionSavedSuccessfully: "Composition saved successfully",
        requestWasProcessed: "Request was processed, but map was not saved due to authorization missing",
        savingCompositionStatus: "Saving composition status",
        serverDidNotRespond: "Server didn't respond or other error occurred"
    },
    dialogSave: {
        areYouAttempting: "You are attempting to save map changes to",
        noSaveAs: "No, save as",
        saveComposition: "Save composition",
        selectNewNameForMap: "Select new name for map",
        useDifferentName: "Use a different name to save the map",
        wantToOverwrite: "Do you really want to overwrite?",
        yesSave: "Yes, save",
        youDoNotHave: "You don't have sufficient rights to do so. Maybe the session has ended?"
    },
    form: {
        address: "Address",
        changeName: "Change name",
        city: "City",
        country: "Country",
        email: "Email",
        organization: "Organization",
        overwrite: "Overwrite",
        person: "Person",
        phone: "Phone",
        position: "Position",
        postalCode: "Postal code",
        read: "Read",
        state: "State",
        toggleAll: "Toggle all",
        userCurrentMapExtent: "Use current map extent",
        write: "Write"
    },
    panelMd: {
        fillKeywords: "Fill keywords",
        makePublic: "Make public",
        saveMap: "Save map",
        showThumbnail: "Show thumbnail",
        thumbnailSwitch: "Thumbnail switch",
        useMapExtent: "Use map extent",
        youAreNotAuthorized: "You are not authorized to store composition. Please sign in or contact administrator for your credentials."
    },
    "private": "Private",
    "public": "Public",
    readAccessRights: "Read access rights",
    removeLayerError: "Layer {{layer}} was not deleted from the database. {{error}}",
    saveOrOverwrite: "This compositon was created by another user",
    syncErrorDialog: {
        errorWhenSyncing: "Error when syncing"
    },
    writeAccessRights: "Write access rights",
    perUser: "Per user",
    everyone: "Everyone"
};
var SENSORS = {
    "1D": "1D",
    "1H": "1H",
    "1M": "1M",
    "1W": "1W",
    "6M": "6M",
    at: "at",
    avg: "Avg.",
    max: "Max",
    measure: "Measure",
    min: "Min",
    oneHour: "1 hour",
    phenomena: "Phenomena",
    sensors: "Sensors",
    sensorUnit: "Sensor unit"
};
var SIDEBAR = {
    additionalPanels: "Additional panels",
    descriptions: {
        ADDLAYERS: "Select data or services for your map composition",
        APPLICATIONSETTINGS: "Specify application user settings",
        DRAW: "Draw new features",
        FEATURE_TABLE: "Display layer features in html table",
        FILTERFEATURES: "Crossfilter",
        INFO: "Display map-query result information",
        LANGUAGE: "Change language",
        LEGEND: "Legend",
        LM: "Manage and style your layers in composition",
        MAP_SWIPE: "Map swipe cotrol layer manager",
        MAPCOMPOSITIONS: "List available map compositions",
        MEASURE: "Measure distance or area at map",
        PERMALINK: "Share map",
        PRINT: "Print map",
        SAVECOMPOSITION: "Save content of map to composition",
        SEARCH: "Search for location",
        TRIP_PLANNER: "Create new trip routes"
    }
};
var STYLER = {
    addFilter: "Add filter",
    addRule: "Add rule",
    addSymbolizer: "Add symbolizer",
    anchor: "Anchor",
    anchorX: "Offset X",
    anchorY: "Offset Y",
    andFilter: "AND",
    blur: "Blur",
    cap: "Cap",
    clear: "Reset to default style",
    clusterRule: "Rule for clusters",
    color: "Color",
    comparisonFilter: "COMPARE",
    dashPattern: "Dash pattern",
    downloadSld: "Download style as SLD file",
    features: "Features",
    fillColor: "Fill color",
    fillOpacity: "Fill opacity",
    fillSymbolizer: "Fill symbolizer",
    filtersAndScales: "Filters & scales",
    font: "Font",
    fontStyle: "Font style",
    fontWeight: "Font weight",
    gapWidth: "Gap width",
    graphicFill: "Graphic fill",
    graphicStroke: "Graphic stroke",
    haloColor: "Halo color",
    haloWidth: "Halo width",
    iconSymbolizer: "Icon symbolizer",
    join: "Join",
    justify: "Justify",
    kind: "Kind",
    layer: "Layer",
    level: "Level",
    lineSymbolizer: "Line symbolizer",
    manageStyle: "Manage style",
    markSymbolizer: "Mark symbolizer",
    maxScale: "Max. scale",
    minScale: "Min. scale",
    miterLimit: "Miter limit",
    name: "Name",
    notFilter: "NOT",
    offsetX: "Offset X",
    offsetY: "Offset Y",
    opacity: "Opacity",
    orFilter: "OR",
    outlineColor: "Outline color",
    outlineOpacity: "Outline opacity",
    outlineWidth: "Outline width",
    perpendicularOffset: "Perpendicular offset",
    pleaseEnterAttrib: "Please enter the name of attribute by which to categorize",
    pleaseEnterMin: "Please enter the min value",
    pleaseEnterMax: "Please enter the max value",
    radius: "Radius",
    removeFilter: "Remove filter",
    removeRule: "Remove rule",
    removeSymbolizer: "Remove symbolizer",
    rotation: "Rotation",
    roundLimit: "Round limit",
    rules: "Rules",
    selectIcon: "Select icon",
    selection: "Selection",
    simpleRule: "Simple rule",
    size: "Size",
    source: "URL",
    spacing: "Spacing",
    strokeColor: "Stroke color",
    strokeOpacity: "Stroke opacity",
    strokeWidth: "Stroke width",
    symbol: "Symbol",
    symbolizers: "Symbolizers",
    template: "Template",
    textColor: "Text color",
    textSize: "Text size",
    textSymbolizer: "Text symbolizer",
    toggleFilters: "Toggle filters",
    toggleScaleDenominators: "Toggle scale denominators",
    transform: "Transform",
    unknownSymbolizer: "Unknown symbolizer",
    uploadSld: "Upload style as SLD file",
    warningAttribNotStoredNotVisualized: "Attribute currently not visualized correctly and not stored in SLD",
    warningAttribNotStoredVisualized: "Attribute visualized, but not stored in SLD",
    warningAttribStoredNotVisualized: "Attribute stored in SLD, but currently is not visualized correctly",
    width: "Width",
    colorMap: "Color map"
};
var TOOLBAR = {
    measureLinesAndPolygon: "Measure lines and polygon"
};
var TRIP_PLANNER = {
    clearWaypoints: "Clear waypoints",
    missingAuth: "Routing service not authorized",
    removeWaypoint: "Remove waypoint",
    routerLayer: "Route layer",
    serviceDown: "Navigation service seems to be down. We are sorry!",
    totalDistance: "Total distance",
    travelRoute: "Travel route",
    waypointDrawingHint: "Please click on map to add waypoints",
    waypointLayer: "Waypoint layer",
    waypoints: "Waypoints"
};
var en = {
    ADDDATA: ADDDATA,
    ADDLAYERS: ADDLAYERS,
    COMMON: COMMON,
    COMPOSITIONS: COMPOSITIONS,
    COMPOSITONINSPIRETHEMES: COMPOSITONINSPIRETHEMES,
    COMPOSITONKEYWORDS: COMPOSITONKEYWORDS,
    COMPOSITONSORTVALUES: COMPOSITONSORTVALUES,
    COMPOSITONTYPES: COMPOSITONTYPES,
    DATASOURCE_SELECTOR: DATASOURCE_SELECTOR,
    DRAW: DRAW,
    ERRORMESSAGES: ERRORMESSAGES,
    FEATURE_TABLE: FEATURE_TABLE,
    GEOLOCATION: GEOLOCATION,
    HISTORY: HISTORY,
    INFOCOMPONENT: INFOCOMPONENT,
    LAYERMANAGER: LAYERMANAGER,
    LAYERS: LAYERS,
    LAYMAN: LAYMAN,
    LEGEND: LEGEND,
    MAP: MAP,
    MAP_SWIPE: MAP_SWIPE,
    MEASURE: MEASURE,
    PANEL_HEADER: PANEL_HEADER,
    PERMALINK: PERMALINK,
    PRINT: PRINT,
    QUERY: QUERY,
    SAVECOMPOSITION: SAVECOMPOSITION,
    SENSORS: SENSORS,
    SIDEBAR: SIDEBAR,
    STYLER: STYLER,
    TOOLBAR: TOOLBAR,
    TRIP_PLANNER: TRIP_PLANNER
};

class WebpackTranslateLoader {
    constructor(HsConfig, HttpClient) {
        this.HsConfig = HsConfig;
        this.HttpClient = HttpClient;
    }
    /**
     *
     * @param lang - language code for each app in format `app|language` such as `app-1|en`
     * @returns
     */
    getTranslation(lang) {
        const hsConfig = this.HsConfig;
        const app = lang.split('|')[0];
        lang = lang.split('|')[1];
        //Idea taken from https://github.com/denniske/ngx-translate-multi-http-loader/blob/master/projects/ngx-translate/multi-http-loader/src/lib/multi-http-loader.ts
        const requests = [
            //these translations are loaded as promises in order, where next one overwrites previous loaders values
            from(new Promise((resolve) => resolve(en))),
            from(new Promise((resolve) => __awaiter(this, void 0, void 0, function* () {
                (() => __awaiter(this, void 0, void 0, function* () {
                    if (hsConfig.get(app).assetsPath == undefined) {
                        console.warn('HsConfig.apps[?].assetsPath not set. Waiting...'); //HsConfig won't be updated yet if HsCore is included in AppComponent
                        let counter = 0;
                        const MAX_CONFIG_POLLS = 10;
                        while (!hsConfig.get(app).assetsPath &&
                            counter++ < MAX_CONFIG_POLLS) {
                            yield new Promise((resolve2) => setTimeout(resolve2, 100));
                        }
                        if (counter >= MAX_CONFIG_POLLS) {
                            resolve(en); //This is needed to display English if assetsPath will never be set.
                            if (lang != 'en') {
                                console.error('Please set HsConfig.apps[default].assetsPath so translations can be loaded');
                            }
                            return;
                        }
                        console.log('assetsPath OK');
                    }
                    const res = yield lastValueFrom(this.HttpClient.get(`${hsConfig.get(app).assetsPath}/locales/${lang}.json`));
                    resolve(res);
                }))();
            }))),
            from(new Promise((resolve) => {
                //Wait a bit for the HsConfig to be set from container app
                setTimeout((_) => {
                    if (hsConfig.get(app).translationOverrides &&
                        hsConfig.get(app).translationOverrides[lang]) {
                        resolve(hsConfig.get(app).translationOverrides[lang]);
                    }
                    else {
                        resolve({});
                    }
                }, 200);
            })),
        ];
        const tmp = forkJoin(requests).pipe(map((response) => {
            return merge.all(response);
        }));
        return tmp;
    }
}
class CustomTranslationService extends TranslateService {
    constructor(HsConfig, HttpClient) {
        super(null, new WebpackTranslateLoader(HsConfig, HttpClient), new TranslateFakeCompiler(), new TranslateDefaultParser(), new FakeMissingTranslationHandler(), false, true, false, null);
    }
}
CustomTranslationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: CustomTranslationService, deps: [{ token: HsConfig }, { token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
CustomTranslationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: CustomTranslationService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: CustomTranslationService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: HsConfig }, { type: i1.HttpClient }]; } });

const DEFAULT_LANG = 'en';
class HsLanguageObject {
}
class HsLanguageService {
    constructor(translateServiceFactory, HttpClient, hsConfig) {
        this.HttpClient = HttpClient;
        this.hsConfig = hsConfig;
        this.apps = {};
        this.translateServiceFactory = translateServiceFactory;
        this.hsConfig.configChanges.subscribe(({ app, config }) => {
            if (config.translationOverrides != undefined) {
                const translator = this.getTranslator(app);
                if (translator === null || translator === void 0 ? void 0 : translator.currentLang) {
                    translator.reloadLang(translator.currentLang);
                }
            }
        });
    }
    /**
     * @public
     * @param lang - Language code without app prefix
     * Set language
     */
    setLanguage(lang, app = 'default') {
        if (!lang.includes('|')) {
            lang = `${app}|${lang}`;
        }
        this.getTranslator(app).use(lang);
        this.apps[app].language = lang;
    }
    getTranslator(app) {
        if (this.apps[app] == undefined) {
            this.apps[app] = {
                language: app + '|' + DEFAULT_LANG,
                translationService: this.translateServiceFactory(this.hsConfig, this.HttpClient),
            };
        }
        return this.apps[app].translationService;
    }
    /**
     * @public
     * @returns Returns language code
     * Get code of current language
     */
    getCurrentLanguageCode(app = 'default') {
        if (typeof this.apps[app].language == 'undefined' ||
            this.apps[app].language == '') {
            return DEFAULT_LANG;
        }
        return this.apps[app].language.split('|').pop().substr(0, 2).toLowerCase();
    }
    /**
     * @public
     * @returns Returns available languages
     * Get array of available languages based
     */
    listAvailableLanguages(app = 'default') {
        const languageCodeNameMap = {
            'en': 'English',
            'cs': 'Česky',
            'fr': 'Français',
            'lv': 'Latviski',
            'nl': 'Nederlands',
            'sk': 'Slovensky',
        };
        const langs = [{ key: 'en', name: 'English' }];
        for (const lang of this.getTranslator(app)
            .getLangs()
            .map((l) => l.split('|')[1])) {
            if (languageCodeNameMap.hasOwnProperty(lang) &&
                langs.filter((l) => l.key == lang).length == 0) {
                langs.push({ key: lang, name: languageCodeNameMap[lang] });
            }
        }
        return langs;
    }
    /**
     * @param  str - Identifier of the string to be translated
     * @param params -
     * @returns Translation
     */
    getTranslation(str, params, app = 'default') {
        return this.getTranslator(app).instant(str, params);
    }
    /**
     * Async variant of getTranslation function for translations which might
     * be needed immediately after application init before locales are even loaded
     */
    awaitTranslation(str, params, app = 'default') {
        return __awaiter(this, void 0, void 0, function* () {
            return yield lastValueFrom(this.getTranslator(app).get(str, params));
        });
    }
    /**
     * @param module - Module to look for inside the locales json
     * @param text - Text that represents the translation
     * @param params - Dynamic params included in the translation, for example,
     * "translation": "This is my {{nr}} translation" - params: {nr: 'first'}
     * @returns Translation
     */
    getTranslationIgnoreNonExisting(module, text, params, app = 'default') {
        const tmp = this.getTranslation(module + '.' + text, params || undefined, app);
        if (tmp.includes(module + '.')) {
            return text;
        }
        return tmp;
    }
}
HsLanguageService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLanguageService, deps: [{ token: CustomTranslationService }, { token: i1.HttpClient }, { token: HsConfig }], target: i0.ɵɵFactoryTarget.Injectable });
HsLanguageService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLanguageService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLanguageService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: [CustomTranslationService]
                    }] }, { type: i1.HttpClient }, { type: HsConfig }];
    } });

var DuplicateHandling;
(function (DuplicateHandling) {
    DuplicateHandling[DuplicateHandling["AddDuplicate"] = 0] = "AddDuplicate";
    DuplicateHandling[DuplicateHandling["IgnoreNew"] = 1] = "IgnoreNew";
    DuplicateHandling[DuplicateHandling["RemoveOriginal"] = 2] = "RemoveOriginal";
})(DuplicateHandling || (DuplicateHandling = {}));
const DEFAULT = 'default';
class AppData {
    constructor() {
        this.featureLayerMapping = {};
    }
}
class HsMapService {
    constructor(hsConfig, hsLayoutService, hsUtilsService, hsEventBusService, hsLanguageService, rendererFactory) {
        this.hsConfig = hsConfig;
        this.hsLayoutService = hsLayoutService;
        this.hsUtilsService = hsUtilsService;
        this.hsEventBusService = hsEventBusService;
        this.hsLanguageService = hsLanguageService;
        this.rendererFactory = rendererFactory;
        this.apps = {
            default: new AppData(),
        };
        //timer variable for extent change event
        this.timer = null;
        /**
         * @public
         * @default 400
         * Duration of added interactions animation. (400 ms used, default in OpenLayers is 250 ms)
         */
        this.duration = 400;
        /**
         * @public
         * Set map to default view
         * @param e - Mouse click event
         * @param app - App identifier
         */
        this.setDefaultView = function (e, app) {
            var _a, _b;
            const appRef = this.hsConfig.get(app);
            if (!appRef.default_view) {
                return;
            }
            const mapRef = this.getMap(app);
            const center = (_a = appRef.default_view) === null || _a === void 0 ? void 0 : _a.getCenter();
            mapRef.getView().setCenter(center);
            const zoom = (_b = appRef.default_view) === null || _b === void 0 ? void 0 : _b.getZoom();
            mapRef.getView().setZoom(zoom);
        };
    }
    /**
     * Returns the associated layer for feature.
     * This is used in query-vector.service to get the layer of clicked
     * feature when features are listed in info panel.
     * @param feature - Feature selected
     * @returns VectorLayer
     */
    getLayerForFeature(feature, app) {
        if (typeof feature.getId() == 'undefined') {
            feature.setId(this.hsUtilsService.generateUuid());
        }
        const fid = feature.getId();
        if (this.apps[app].featureLayerMapping[fid]) {
            return this.refineLayerSearch(this.apps[app].featureLayerMapping[fid], feature);
        }
        const layersFound = [];
        const layersToLookFor = [];
        this.getVectorLayers(layersToLookFor, app);
        for (const obj of layersToLookFor) {
            let found = false;
            if (obj.source.getFeatureById) {
                //For ordinary vector layers we can search by Id
                found = obj.source.getFeatureById(fid);
            }
            else {
                //For cluster layers we need to loop through features
                found = this.findFeatureByInst(obj, feature) !== undefined;
            }
            if (found) {
                layersFound.push(obj);
                //break; Tempting to use break, but if multiple layers contain features with same id we won't find them all.
            }
        }
        if (layersFound && !this.apps[app].featureLayerMapping[fid]) {
            //TODO: Will have to delete the mapping at some point when layer is cleared or feature removed
            this.apps[app].featureLayerMapping[fid] = layersFound;
        }
        return this.refineLayerSearch(layersFound, feature);
    }
    /**
     * When multiple layers contain feature with the same ID do a full search by feature instance instead.
     * @param array - Cached array of layers for a given feature ID
     * @param feature - Instance of feature
     * @returns Layer
     */
    refineLayerSearch(array, feature) {
        var _a;
        array = array.filter((entry) => entry.layer.getVisible());
        if (array.length > 1) {
            return (_a = array.find((entry) => this.findFeatureByInst(entry, feature) !== undefined)) === null || _a === void 0 ? void 0 : _a.layer;
        }
        else if (array.length == 1) {
            return array[0].layer;
        }
    }
    /**
     * Search for feature in layer by looping through feature list. getFeatureById is more efficient, but is not always available
     * @param obj - dictionary entry for layer and its vector source (ordinary vector source, source of each Group layers child or underlying source for cluster layer)
     * @param feature - Feature instance
     * @returns Feature
     */
    findFeatureByInst(obj, feature) {
        return obj.source.getFeatures().find((layer_feature) => {
            return layer_feature === feature;
        });
    }
    /**
     * @public
     * Get vector layers from the map, mentioned in the layersToLookFor array
     * @param layersToLookFor - Layers requested
     * @param app - App identifier
     */
    getVectorLayers(layersToLookFor, app) {
        const check = (layer) => {
            const source = layer.getSource();
            if (this.hsUtilsService.instOf(source, Cluster)) {
                layersToLookFor.push({
                    layer,
                    source,
                });
                layersToLookFor.push({
                    layer,
                    source: source.getSource(),
                });
            }
            else if (this.hsUtilsService.instOf(source, Vector)) {
                layersToLookFor.push({
                    layer,
                    source,
                });
            }
        };
        this.getMap(app !== null && app !== void 0 ? app : DEFAULT)
            .getLayers()
            .forEach((layer) => {
            if (this.hsUtilsService.instOf(layer, Group)) {
                layer.getLayers().forEach(check);
            }
            else {
                check(layer);
            }
        });
    }
    /**
     * @public
     * Get geometry feature by its ID
     * @param fid - Feature ID
     * @param app - App identifier
     * @returns Feature
     */
    getFeatureById(fid, app) {
        if (this.apps[app].featureLayerMapping[fid]) {
            if (this.apps[app].featureLayerMapping[fid].length > 1) {
                console.warn(`Multiple layers exist for feature id ${fid}`);
            }
            else {
                return this.apps[app].featureLayerMapping[fid][0].source.getFeatureById(fid);
            }
        }
        else {
            const layersToLookFor = [];
            this.getVectorLayers(layersToLookFor, app);
            const obj = layersToLookFor.find((obj) => obj.source.getFeatureById(fid));
            if (obj) {
                return obj.source.getFeatureById(fid);
            }
        }
    }
    /**
     * @public
     * Create default view button inside the map html element
     * @param app - App identifier
     * @param defaultDesktopControls - Default controls
     */
    createDefaultViewButton(app, defaultDesktopControls) {
        const rendered = this.apps[app].renderer;
        const button = rendered.createElement('button');
        button.addEventListener('click', (e) => {
            this.setDefaultView(e, app);
        }, false);
        const icon = rendered.createElement('i');
        rendered.addClass(icon, 'glyphicon');
        rendered.addClass(icon, 'icon-globe');
        this.element = rendered.createElement('div');
        rendered.addClass(this.element, 'hs-defaultView');
        rendered.addClass(this.element, 'ol-unselectable');
        rendered.addClass(this.element, 'ol-control');
        rendered.setAttribute(this.element, 'title', this.hsLanguageService.getTranslation('MAP.zoomToInitialWindow', undefined, app));
        rendered.appendChild(button, icon);
        rendered.appendChild(this.element, button);
        const defaultViewControl = new Control({
            element: this.element,
        });
        defaultDesktopControls.push(defaultViewControl);
    }
    /**
     * @param e - Map or view change
     * @param app - App identifier
     */
    extentChanged(e, app) {
        if (this.timer !== null) {
            clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
            const map = this.getMap(app);
            this.hsEventBusService.mapExtentChanges.next({
                map: e.target,
                event: e.type,
                extent: map.getView().calculateExtent(map.getSize()),
                app,
            });
        }, 500);
    }
    /**
     * Initialization function for HSLayers map object.
     * Initialize map with basic interaction, scale line and watcher for map view changes.
     * When default controller is used, it's called automatically, otherwise it must be called before other modules dependent on map object are loaded.
     * @public
     * @param mapElement - Map html element
     * @param app - App identifier
     */
    init(mapElement, app) {
        var _a, _b;
        let map;
        if (this.getMap(app)) {
            map = this.getMap(app);
            map.setTarget(mapElement);
        }
        else {
            const defaultMobileControls = defaults({
                zoom: false,
            });
            const defaultDesktopControls = defaults({
                attributionOptions: {
                    collapsible: true,
                    collapsed: true,
                },
            });
            defaultDesktopControls.removeAt(1);
            defaultDesktopControls.push(new ScaleLine());
            const controls = defaultDesktopControls;
            const placeholderOsm = new Tile({
                source: new OSM(),
                visible: true,
                properties: {
                    title: 'OpenStreetMap',
                    base: true,
                    removable: true,
                },
            });
            map = new Map({
                controls,
                layers: [placeholderOsm],
                target: mapElement,
                interactions: [],
                view: (_a = this.hsConfig.get(app).default_view) !== null && _a !== void 0 ? _a : this.createPlaceholderView(),
            });
            this.apps[app] = {
                mapElement,
                placeholderOsm,
                map,
                renderer: this.rendererFactory.createRenderer(null, null),
                featureLayerMapping: {},
            };
            const view = map.getView();
            this.originalView = {
                center: view.getCenter(),
                zoom: view.getZoom(),
                rotation: view.getRotation(),
            };
            view.on('change:center', (e) => {
                this.extentChanged(e, app);
            });
            view.on('change:resolution', (e) => {
                this.extentChanged(e, app);
            });
            map.on('moveend', (e) => {
                this.extentChanged(e, app);
            });
            setTimeout(() => {
                var _a, _b;
                //make sure translations are loaded
                if (((_a = this.hsConfig.get(app).componentsEnabled) === null || _a === void 0 ? void 0 : _a.defaultViewButton) &&
                    ((_b = this.hsConfig.get(app).componentsEnabled) === null || _b === void 0 ? void 0 : _b.guiOverlay) != false) {
                    this.createDefaultViewButton(app, defaultDesktopControls);
                }
            }, 500);
        }
        const interactions = {
            'DoubleClickZoom': new DoubleClickZoom({
                duration: this.duration,
            }),
            'KeyboardPan': new KeyboardPan({
                pixelDelta: 256,
            }),
            'KeyboardZoom': new KeyboardZoom({
                duration: this.duration,
            }),
            'MouseWheelZoom': new MouseWheelZoom({
                condition: (browserEvent) => {
                    var _a;
                    if (((_a = this.hsConfig.get(app).componentsEnabled) === null || _a === void 0 ? void 0 : _a.mapControls) == false) {
                        return false;
                    }
                    return this.hsConfig.get(app).zoomWithModifierKeyOnly
                        ? platformModifierKeyOnly(browserEvent)
                        : true;
                },
                duration: this.duration,
            }),
            'PinchRotate': new PinchRotate(),
            'PinchZoom': new PinchZoom({
                duration: this.duration,
            }),
            'DragPan': new DragPan({
                kinetic: new Kinetic(-0.01, 0.1, 200),
            }),
            'DragZoom': new DragZoom(),
            'DragRotate': new DragRotate(),
        };
        if (this.hsConfig.get(app).mapInteractionsEnabled != false) {
            for (const value of Object.values(interactions).filter((value) => !map.getInteractions().getArray().includes(value))) {
                map.addInteraction(value);
            }
        }
        //this.map.addControl(new ol.control.ZoomSlider());
        // this.map.addControl(new ol.control.ScaleLine());
        // If the MouseWheelInteraction is set to behave only with CTRL pressed,
        // then also notify the user when he tries to zoom,
        // but the CTRL is not pressed
        if (this.hsConfig.get(app).zoomWithModifierKeyOnly &&
            this.hsConfig.get(app).mapInteractionsEnabled != false) {
            map.on('wheel', (e) => {
                const renderer = this.apps[app].renderer;
                //ctrlKey works for Win and Linux, metaKey for Mac
                if (!(e.originalEvent.ctrlKey || e.originalEvent.metaKey) &&
                    !this.hsLayoutService
                        .get(app)
                        .contentWrapper.querySelector('.hs-zoom-info-dialog')) {
                    //TODO: change the name of platform modifier key dynamically based on OS
                    const platformModifierKey = 'CTRL/META';
                    //Following styles would be better written as ng-styles...
                    const html = renderer.createElement('div');
                    renderer.setAttribute(html, 'class', 'alert alert-info mt-1 hs-zoom-info-dialog');
                    renderer.setAttribute(html, 'style', `position: absolute; right:15px; top:0.6em;z-index:101`);
                    const text = renderer.createText(`${this.hsLanguageService.getTranslation('MAP.zoomKeyModifier', {
                        platformModifierKey: platformModifierKey,
                    }, app)}`);
                    renderer.appendChild(html, text);
                    renderer.appendChild(this.hsLayoutService
                        .get(app)
                        .contentWrapper.querySelector('.hs-map-space'), html);
                    setTimeout(() => {
                        this.hsLayoutService
                            .get(app)
                            .contentWrapper.querySelector('.hs-zoom-info-dialog')
                            .remove();
                    }, 4000);
                }
            });
        }
        this.repopulateLayers(this.visibleLayersInUrl, app);
        proj4.defs('EPSG:5514', '+proj=krovak +lat_0=49.5 +lon_0=24.83333333333333 +alpha=30.28813972222222 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=542.5,89.2,456.9,5.517,2.275,5.516,6.96 +units=m +no_defs');
        proj4.defs('http://www.opengis.net/gml/srs/epsg.xml#5514', proj4.defs('EPSG:5514'));
        proj4.defs('EPSG:4258', '+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs');
        proj4.defs('http://www.opengis.net/gml/srs/epsg.xml#4258', proj4.defs('EPSG:4258'));
        proj4.defs('EPSG:4326', '+proj=longlat +datum=WGS84 +no_defs');
        proj4.defs('EPSG:3995', '+proj=stere +lat_0=90 +lat_ts=71 +lon_0=0 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs');
        proj4.defs('http://www.opengis.net/gml/srs/epsg.xml#3995', proj4.defs('EPSG:3995'));
        proj4.defs('EPSG:3031', '+proj=stere +lat_0=-90 +lat_ts=-71 +lon_0=0 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs');
        proj4.defs('http://www.opengis.net/gml/srs/epsg.xml#3031', proj4.defs('EPSG:3031'));
        register(proj4);
        if (((_b = this.hsConfig.get(app).componentsEnabled) === null || _b === void 0 ? void 0 : _b.mapControls) == false) {
            this.removeAllControls(app);
        }
        this.hsEventBusService.olMapLoads.next({ map, app });
    }
    /**
     * @public
     * Wait until the OL map is fully loaded
     * @param app - App identifier
     * @returns OL map object
     */
    loaded(app) {
        return new Promise((resolve, reject) => {
            if (this.getMap(app !== null && app !== void 0 ? app : DEFAULT)) {
                resolve(this.getMap(app !== null && app !== void 0 ? app : DEFAULT));
                return;
            }
            else {
                this.hsEventBusService.olMapLoads.subscribe(({ map, app }) => {
                    if (map) {
                        resolve(map);
                    }
                });
            }
        });
    }
    /**
     * Find layer object by title of layer
     * @public
     * @param title - Title of the layer (from layer creation)
     * @param app - App identifier
     * @returns OL.layer object
     */
    findLayerByTitle(title, app) {
        const layers = this.getLayersArray(app);
        let tmp = null;
        for (const layer of layers) {
            if (getTitle(layer) == title) {
                tmp = layer;
            }
        }
        return tmp;
    }
    /**
     * @param existingLayer - Layer 1. Usually the one which is already added to map
     * @param newLayer - Layer 2. Usually the one which will be added to map
     * @returns True or false
     */
    layersEqual(existingLayer, newLayer) {
        if (newLayer === 'undefined') {
            console.warn('Checking duplicity for undefined layer. Why are we doing this?');
            return true;
        }
        if (existingLayer.getSource === 'undefined') {
            return false;
        }
        if (newLayer.getSource === 'undefined') {
            return false;
        }
        const existingSource = existingLayer.getSource();
        const newSource = newLayer.getSource();
        const existingTitle = getTitle(existingLayer);
        const newTitle = getTitle(newLayer);
        const existingSourceType = typeof existingSource;
        const newSourceType = typeof newSource;
        const existingLAYERS = existingSource.getParams == null ? '' : existingSource.getParams().LAYERS;
        const newLAYERS = newSource.getParams == null ? '' : newSource.getParams().LAYERS;
        const existingUrl = existingSource.getUrl == null ? '' : existingSource.getUrl();
        const newUrl = newSource.getUrl == null ? '' : newSource.getUrl();
        const existingUrls = existingSource.getUrls == null ? '' : existingSource.getUrls();
        let newUrls = newSource.getUrls == null ? [''] : newSource.getUrls();
        newUrls = newUrls ? newUrls : [''];
        const urlsEqual = existingUrls == newUrls ||
            (newUrls.length > 0 && existingUrls.indexOf(newUrls[0]) > -1);
        return (existingTitle == newTitle &&
            existingSourceType == newSourceType &&
            existingLAYERS == newLAYERS &&
            existingUrl == newUrl &&
            urlsEqual);
    }
    /**
     * Checks if a layer with the same title already exists in the map
     * @param lyr - A layer to check
     * @param app - App identifier
     * @returns True if layer is already present in the map, false otherwise
     */
    layerAlreadyExists(lyr, app) {
        const duplicateLayers = this.getLayersArray(app !== null && app !== void 0 ? app : DEFAULT).filter((existing) => {
            const equal = this.layersEqual(existing, lyr);
            return equal;
        });
        return duplicateLayers.length > 0;
    }
    /**
     * Remove any duplicate layer inside map layers array
     * @param lyr - A layer to check
     * @param app - App identifier
     */
    removeDuplicate(lyr, app) {
        this.getLayersArray(app !== null && app !== void 0 ? app : DEFAULT)
            .filter((existing) => {
            const equal = this.layersEqual(existing, lyr);
            return equal;
        })
            .forEach((to_remove) => {
            this.getMap(app !== null && app !== void 0 ? app : DEFAULT)
                .getLayers()
                .remove(to_remove);
        });
    }
    /**
     * Get layers array from the OL map object
     * @param app - App identifier
     * @returns Layer array
     */
    getLayersArray(app) {
        return this.getMap(app !== null && app !== void 0 ? app : DEFAULT)
            .getLayers()
            .getArray();
    }
    /**
     * Proxify layer based on its source object type and if it's tiled or not.
     * Each underlying OL source class has its own way to override imagery loading.
     * @param lyr - Layer which to proxify if needed
     * @param app - App identifier
     */
    proxifyLayer(lyr, app) {
        const source = lyr.getSource();
        if ([ImageWMS, ImageArcGISRest].some((typ) => this.hsUtilsService.instOf(source, typ))) {
            this.proxifyLayerLoader(lyr, false, app);
        }
        if (this.hsUtilsService.instOf(source, WMTS)) {
            source.setTileLoadFunction((i, s) => this.simpleImageryProxy(i, s, app));
        }
        if ([TileWMS, TileArcGISRest].some((typ) => this.hsUtilsService.instOf(source, typ))) {
            this.proxifyLayerLoader(lyr, true, app);
        }
        if (this.hsUtilsService.instOf(source, XYZ) &&
            !this.hsUtilsService.instOf(source, OSM) &&
            source
                .getUrls()
                .filter((url) => url.indexOf('openstreetmap') > -1).length == 0) {
            this.proxifyLayerLoader(lyr, true, app);
        }
        if (this.hsUtilsService.instOf(source, ImageStatic)) {
            //NOTE: Using url_ is not nice, but don't see other way, because no setUrl or set('url'.. exists yet
            source.url_ = this.hsUtilsService.proxify(source.getUrl(), app);
        }
    }
    /**
     * Function to add layer to map which also checks if
     * the layer is not already present and also proxifies the layer if needed.
     * Generally for non vector layers it would be better to use this function than to add to OL map directly
     * and rely on layer manager service to do the proxification and also it's shorter than to use HsMapService.getMap(app).addLayer.
     *
     * @param lyr - Layer to add
     * @param duplicateHandling - How to handle duplicate layers (same class and title)
     * @param visibleOverride - Override the visibility using an array layer titles, which
     */
    addLayer(lyr, app, duplicateHandling, visibleOverride) {
        if (this.layerAlreadyExists(lyr, app !== null && app !== void 0 ? app : DEFAULT)) {
            if (getTitle(lyr) === getTitle(this.apps[app].placeholderOsm)) {
                duplicateHandling = DuplicateHandling.RemoveOriginal;
            }
            switch (duplicateHandling) {
                case DuplicateHandling.RemoveOriginal:
                    /* if (getBase(lyr) == true) { //Removed so we could add OSM over the placeholderOsm
                      return;
                    } */
                    this.removeDuplicate(lyr, app);
                    break;
                case DuplicateHandling.IgnoreNew:
                    return;
                case DuplicateHandling.AddDuplicate:
                default:
            }
        }
        if (visibleOverride) {
            lyr.setVisible(this.layerTitleInArray(lyr, visibleOverride));
        }
        const source = lyr.getSource();
        if (this.hsUtilsService.instOf(source, Vector)) {
            this.getVectorType(lyr);
        }
        this.proxifyLayer(lyr, app);
        lyr.on('change:source', (e) => {
            this.proxifyLayer(e.target, app);
        });
        this.getMap(app !== null && app !== void 0 ? app : DEFAULT).addLayer(lyr);
    }
    /**
     * Add all layers from app config (box_layers and default_layers) to the map.
     * Only layers specified in visibilityOverrides parameter will get instantly visible.
     * @public
     * @param visibilityOverrides - Override the visibility using an array layer titles, which
     * should be visible. Useful when the layer visibility is stored in a URL parameter
     * @param app - App identifier
     */
    repopulateLayers(visibilityOverrides, app) {
        const appConfig = this.hsConfig.get(app);
        if (appConfig.box_layers) {
            appConfig.box_layers.forEach((box) => {
                for (const lyr of box.getLayers().getArray()) {
                    this.addLayer(lyr, app, DuplicateHandling.IgnoreNew, visibilityOverrides);
                }
            });
        }
        if (appConfig.default_layers) {
            const layers = appConfig.default_layers.filter((lyr) => lyr);
            if (layers.length > 0) {
                this.getMap(app).removeLayer(this.apps[app].placeholderOsm);
            }
            layers.forEach((lyr) => {
                this.addLayer(lyr, app, DuplicateHandling.IgnoreNew, visibilityOverrides);
            });
        }
    }
    /**
     * Get map projection currently used in the map view
     * @public
     * @param app - App identifier
     * Get current map projection
     * @returns Projection
     */
    getCurrentProj(app) {
        return this.getMap(app !== null && app !== void 0 ? app : DEFAULT)
            .getView()
            .getProjection();
    }
    /**
     * For a vector layer with a vector source, determines if it includes points, lines and/or polygons and stores the information in hasPoint, hasLine, hasPoly properties of the source.
     * @public
     * @param layer - Vector layer selected
     * Get vector type from the layer selected
     */
    getVectorType(layer) {
        let src;
        if (layer.getSource().getSource) {
            src = layer.getSource().getSource();
        }
        else {
            src = layer.getSource();
        }
        src.hasLine = false;
        src.hasPoly = false;
        src.hasPoint = false;
        if (src.getFeatures().length > 0) {
            this.vectorSourceTypeComputer(src);
        }
        else {
            src.on('change', (evt) => {
                const source = evt.target;
                if (source.getState() === 'ready') {
                    this.vectorSourceTypeComputer(source);
                }
            });
        }
    }
    /**
     * Check vector geometry types as found from vector source provided
     * @param src - Vector source
     */
    vectorSourceTypeComputer(src) {
        src.getFeatures().forEach((f) => {
            if (f.getGeometry()) {
                switch (f.getGeometry().getType()) {
                    case 'LineString':
                    case 'MultiLineString':
                        src.hasLine = true;
                        break;
                    case 'Polygon':
                    case 'MultiPolygon':
                        src.hasPoly = true;
                        break;
                    case 'Point':
                    case 'MultiPoint':
                        src.hasPoint = true;
                        break;
                    default:
                }
            }
        });
        if (src.hasLine || src.hasPoly || src.hasPoint) {
            src.styleAble = true;
        }
    }
    /**
     * Reset map to state configured in app config (reload all layers and set default view)
     * @public
     * @param app - App identifier
     */
    reset(app) {
        this.removeAllLayers(app);
        this.repopulateLayers(null, app);
        this.resetView(app);
    }
    /**
     * Reset map view to view configured in app config
     * @public
     * @param app - App identifier
     */
    resetView(app) {
        const view = this.getMap(app !== null && app !== void 0 ? app : DEFAULT).getView();
        view.setCenter(this.originalView.center);
        view.setZoom(this.originalView.zoom);
        view.setRotation(this.originalView.rotation);
    }
    /**
     * Create a placeholder view
     * @returns Map view
     */
    createPlaceholderView() {
        return new View({
            center: transform([17.474129, 52.574], 'EPSG:4326', 'EPSG:3857'),
            zoom: 4,
        });
    }
    /**
     * Checks if layer title is present in an array of layer titles.
     * Used to set visibility by URL parameter which contains visible layer titles
     * @public
     * @param lyr - Layer for which to determine visibility
     * @param array - Layer title to check in.
     * @returns Detected visibility of layer
     */
    layerTitleInArray(lyr, array) {
        if (array && getTitle(lyr) != undefined) {
            return array.filter((title) => title == getTitle(lyr)).length > 0;
        }
        return lyr.getVisible();
    }
    /**
     * Get ol-layer canvas element from DOM
     * @public
     * @param app - App identifier
     * @returns DOM NodeListOf<HTMLCanvasElement>
     */
    getCanvases(app) {
        return this.apps[app !== null && app !== void 0 ? app : DEFAULT].mapElement.querySelectorAll('.ol-layer canvas');
    }
    /**
     * Get ol-layer canvas element from DOM
     * @public
     * @param type - Scale type (scaleline or scalebar)
     * @param app - App identifier
     * @returns DOM element
     */
    getScaleLineElement(type, app) {
        var _a, _b;
        switch (type) {
            case 'scalebar':
                return (_a = this.apps[app].mapElement.querySelectorAll('.ol-scale-bar.ol-unselectable')) === null || _a === void 0 ? void 0 : _a[0];
            case 'scaleline':
            default:
                return (_b = this.apps[app].mapElement.querySelectorAll('.ol-scale-line.ol-unselectable')) === null || _b === void 0 ? void 0 : _b[0];
        }
    }
    /**
     * Proxify layer loader to work with layers from other sources than app
     * @public
     * @param lyr - Layer to proxify
     * @param tiled - Info if layer is tiled
     * @param app - App identifier
     * @returns proxified URL
     */
    proxifyLayerLoader(lyr, tiled, app) {
        const src = lyr.getSource();
        if (getEnableProxy(lyr) !== undefined && getEnableProxy(lyr) == false) {
            return;
        }
        if (tiled) {
            //TODO: refactor: tileUrlFunction() seems redundant
            const tile_url_function = src.getTileUrlFunction() ||
                src.tileUrlFunction();
            src.setTileUrlFunction((b, c, d) => {
                let url = tile_url_function.call(src, b, c, d);
                if (getDimensions(lyr)) {
                    const dimensions = getDimensions(lyr);
                    Object.keys(dimensions).forEach((dimension) => {
                        url = url.replace(`{${dimension}}`, dimensions[dimension].value);
                    });
                }
                if (url.indexOf(this.hsConfig.get(app).proxyPrefix) == 0) {
                    return url;
                }
                else {
                    return this.hsUtilsService.proxify(url, app);
                }
            });
            src.setTileLoadFunction((tile, src) => {
                var _a;
                const laymanEp = (_a = this.hsConfig
                    .get(app)
                    .datasources) === null || _a === void 0 ? void 0 : _a.find((ep) => ep.type == 'layman');
                if (laymanEp && src.startsWith(laymanEp.url)) {
                    this.laymanWmsLoadingFunction(tile, src);
                }
                else {
                    tile.getImage().src = src;
                }
            });
        }
        else {
            src.setImageLoadFunction((i, s) => this.simpleImageryProxy(i, s, app));
        }
    }
    /**
     * Proxify loader for any imagery layer, either tiled or not
     * @public
     * @param image - Image or ImageTile as required by setImageLoadFunction() in ImageWMS, ImageArcGISRest and WMTS sources
     * @param src - Original (unproxified) source URL
     * @param app - App identifier
     */
    simpleImageryProxy(image, src, app) {
        var _a;
        if (src.indexOf(this.hsConfig.get(app).proxyPrefix) == 0) {
            image.getImage().src = src;
            return;
        }
        const laymanEp = (_a = this.hsConfig
            .get(app)
            .datasources) === null || _a === void 0 ? void 0 : _a.find((ep) => ep.type == 'layman');
        if (laymanEp && src.startsWith(laymanEp.url)) {
            this.laymanWmsLoadingFunction(image, src);
            return;
        }
        image.getImage().src = this.hsUtilsService.proxify(src, app); //Previously urlDecodeComponent was called on src, but it breaks in firefox.
    }
    /**
     * Create a loader function for Layman WMS layers specifically
     * @public
     * @param image - ol/Image, the image requested via WMS source
     * @param src - Original (unproxified) source URL
     */
    laymanWmsLoadingFunction(image, src) {
        const xhr = new XMLHttpRequest();
        xhr.withCredentials = true;
        xhr.responseType = 'arraybuffer';
        xhr.open('GET', src);
        xhr.addEventListener('loadend', function (evt) {
            const arrayBufferView = new Uint8Array(this.response);
            const blob = new Blob([arrayBufferView], { type: 'image/png' });
            const urlCreator = window.URL || window.webkitURL;
            const imageUrl = urlCreator.createObjectURL(blob);
            image.getImage().src = imageUrl;
        });
        xhr.send();
    }
    /**
     * Move map and zoom to specified coordinate/zoom level
     * @public
     * @param x - X coordinate of new center
     * @param y - Y coordinate of new center
     * @param zoom - New zoom level
     * @param app - App identifier
     */
    moveToAndZoom(x, y, zoom, app) {
        const view = this.getMap(app !== null && app !== void 0 ? app : DEFAULT).getView();
        view.setCenter([x, y]);
        view.setZoom(zoom);
    }
    /**
     * Get current map extent
     * @public
     * @param app - App identifier
     * @returns Extent
     */
    getMapExtent(app) {
        const mapSize = this.getMap(app !== null && app !== void 0 ? app : DEFAULT).getSize();
        const mapExtent = mapSize
            ? this.getMap(app !== null && app !== void 0 ? app : DEFAULT)
                .getView()
                .calculateExtent(mapSize)
            : [0, 0, 100, 100];
        return mapExtent;
    }
    /**
     * Get current map extent in WGS84 (EPSG:4326) projection
     * @public
     * @param app - App identifier
     * @returns Extent
     */
    getMapExtentInEpsg4326(app) {
        const bbox = transformExtent(this.getMapExtent(app), this.getCurrentProj(app), 'EPSG:4326');
        return bbox;
    }
    /**
     * Fit extent into map view
     * @public
     * @param extent - Extent provided
     * @param app - App identifier
     */
    fitExtent(extent, app) {
        return __awaiter(this, void 0, void 0, function* () {
            const mapSize = this.getMap(app !== null && app !== void 0 ? app : DEFAULT).getSize();
            if (!mapSize.every((p) => p > 0)) {
                console.warn('Tried to fit extent but one of map dimensions were 0. Will wait a bit and try again!');
                yield new Promise((resolve) => setTimeout(resolve, 250));
            }
            this.getMap(app !== null && app !== void 0 ? app : DEFAULT)
                .getView()
                .fit(extent, { size: mapSize });
        });
    }
    /**
     * Get ol.Map object from service
     * @public
     * @param app - App identifier
     * @returns ol.Map
     */
    getMap(app) {
        var _a;
        return (_a = this.apps[app !== null && app !== void 0 ? app : DEFAULT]) === null || _a === void 0 ? void 0 : _a.map;
    }
    /**
     * Remove all map layers
     * @public
     * @param app - App identifier
     */
    removeAllLayers(app) {
        const to_be_removed = [];
        this.getLayersArray(app)
            .filter((layer) => getRemovable(layer) !== false)
            .forEach((lyr) => {
            to_be_removed.push(lyr);
        });
        while (to_be_removed.length > 0) {
            this.getMap(app !== null && app !== void 0 ? app : DEFAULT).removeLayer(to_be_removed.shift());
        }
    }
    /**
     * Remove all layers gained from composition from map
     * @param app - App identifier
     */
    removeCompositionLayers(app) {
        const to_be_removed = [];
        this.getLayersArray(app).forEach((lyr) => {
            if (getFromComposition(lyr) ||
                getRemovable(lyr) === undefined ||
                getRemovable(lyr) == true) {
                to_be_removed.push(lyr);
            }
        });
        while (to_be_removed.length > 0) {
            this.getMap(app).removeLayer(to_be_removed.shift());
        }
    }
    /**
     * Remove all map controls
     * @public
     * @param app - App identifier
     */
    removeAllControls(app) {
        [
            ...this.getMap(app !== null && app !== void 0 ? app : DEFAULT)
                .getControls()
                .getArray(),
        ].forEach((control) => {
            this.getMap(app !== null && app !== void 0 ? app : DEFAULT).removeControl(control);
        });
        this.hsConfig.get(app).componentsEnabled.mapControls = false;
    }
    /**
     * Remove all map interactions
     * @public
     * @param app - App identifier
     */
    removeAllInteractions(app) {
        this.getMap(app !== null && app !== void 0 ? app : DEFAULT)
            .getInteractions()
            .forEach((interaction) => {
            this.getMap(app !== null && app !== void 0 ? app : DEFAULT).removeInteraction(interaction);
        });
        this.hsConfig.get(app).mapInteractionsEnabled = false;
    }
    /**
     * Get current extent of map, transform it into EPSG:4326 and round coordinates to 2 decimals.
     * This is used mainly in compositions and sharing of map and the coordinates are not very precise.
     * @param app - App identifier
     * @returns Extent coordinates. Example: {east: "0.00", south: "0.00", west: "1.00", north: "1.00"}
     */
    describeExtent(app) {
        const b = this.getMap(app)
            .getView()
            .calculateExtent(this.getMap(app).getSize());
        let pair1 = [b[0], b[1]];
        let pair2 = [b[2], b[3]];
        const cur_proj = this.getCurrentProj(app).getCode();
        pair1 = transform(pair1, cur_proj, 'EPSG:4326');
        pair2 = transform(pair2, cur_proj, 'EPSG:4326');
        return {
            east: pair1[0].toFixed(2),
            south: pair1[1].toFixed(2),
            west: pair2[0].toFixed(2),
            north: pair2[1].toFixed(2),
        };
    }
}
HsMapService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsMapService, deps: [{ token: HsConfig }, { token: HsLayoutService }, { token: HsUtilsService }, { token: HsEventBusService }, { token: HsLanguageService }, { token: i0.RendererFactory2 }], target: i0.ɵɵFactoryTarget.Injectable });
HsMapService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsMapService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsMapService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsConfig }, { type: HsLayoutService }, { type: HsUtilsService }, { type: HsEventBusService }, { type: HsLanguageService }, { type: i0.RendererFactory2 }]; } });

var EndpointErrorHandling;
(function (EndpointErrorHandling) {
    EndpointErrorHandling["ignore"] = "ignore";
    EndpointErrorHandling["toast"] = "toast";
})(EndpointErrorHandling || (EndpointErrorHandling = {}));
function isErrorHandlerFunction(object) {
    if (typeof object == 'string' || object === undefined) {
        return false;
    }
    return 'handle' in object;
}

class HsToastService {
    constructor(HsLanguageService, HsLayoutService) {
        this.HsLanguageService = HsLanguageService;
        this.HsLayoutService = HsLayoutService;
        this.apps = {
            default: {
                toasts: [],
            },
        };
    }
    get(app) {
        if (this.apps[app !== null && app !== void 0 ? app : 'default'] == undefined) {
            this.apps[app !== null && app !== void 0 ? app : 'default'] = {
                toasts: [],
            };
        }
        return this.apps[app !== null && app !== void 0 ? app : 'default'];
    }
    /**
     * @param toast - Toast pop up
     * Callback method to remove Toast DOM element from view
     */
    remove(toast, app) {
        const appRef = this.get(app);
        appRef.toasts = appRef.toasts.filter((t) => t !== toast);
    }
    removeByText(text, app) {
        const found = this.get(app).toasts.filter((t) => t.textOrTpl === text);
        if ((found === null || found === void 0 ? void 0 : found.length) > 0) {
            for (const f of found) {
                this.remove(f, app);
            }
        }
    }
    /**
     * @param textOrTpl - Text or a template message to display
     * @param options - Toast window options
     * Pushes new Toasts to array with content and options
     */
    show(textOrTpl, app = 'default', options = {}) {
        const appRef = this.get(app);
        if (appRef.toasts.length >= 5) {
            appRef.toasts = appRef.toasts.slice(-4);
        }
        if (!appRef.toasts.some((toast) => toast.textOrTpl === textOrTpl &&
            (toast === null || toast === void 0 ? void 0 : toast.serviceCalledFrom) === options.serviceCalledFrom)) {
            appRef.toasts.push(Object.assign({ textOrTpl }, options));
        }
    }
    /**
     * Creates new toast message with custom text and custom styling
     * @param header - Header text to display
     * @param text - Toast body text to display
     * @param options - Custom options for the toast message (disableLocalization: boolean, toastStyleClasses: string, customDelay: number, serviceCalledFrom: string)
     * @param app - Application id
     */
    createToastPopupMessage(header, text, options = {}, app = 'default') {
        this.show(options.disableLocalization
            ? text
            : this.HsLanguageService.getTranslation(text, undefined, app), app, {
            header: options.disableLocalization
                ? header
                : this.HsLanguageService.getTranslation(header, undefined, app),
            delay: options.customDelay || 7000,
            autohide: true,
            classname: options.toastStyleClasses || `bg-danger text-light`,
            serviceCalledFrom: options.serviceCalledFrom,
            details: options.details || [],
        });
    }
    shown(app) {
        //** Following hack is needed until ngBootstrap supports bootstrap5 fully */
        for (const toastElement of this.HsLayoutService.get(app).contentWrapper.querySelectorAll('.toast-header .close')) {
            const classList = toastElement.classList;
            classList.add('btn-close');
            classList.remove('close');
        }
    }
}
HsToastService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsToastService, deps: [{ token: HsLanguageService }, { token: HsLayoutService }], target: i0.ɵɵFactoryTarget.Injectable });
HsToastService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsToastService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsToastService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsLanguageService }, { type: HsLayoutService }]; } });

class HsCommonLaymanService {
    constructor($http, hsToastService, hsLanguageService) {
        this.$http = $http;
        this.hsToastService = hsToastService;
        this.hsLanguageService = hsLanguageService;
        this.authChange = new Subject();
    }
    /**
     *  Monitor if authorization state has changed and
     * return true and broadcast authChange event if so .
     * @param endpoint - Endpoint definition - usually Layman
     * @param app - App identifier
     * @returns Promise<boolean> true if authorization state changed (user logged in or out)
     */
    detectAuthChange(endpoint, app) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${endpoint.url}/rest/current-user`;
            try {
                const res = yield lastValueFrom(this.$http.get(url, { withCredentials: true }));
                let somethingChanged = false;
                if (res.code === 32) {
                    endpoint.authenticated = false;
                    endpoint.user = endpoint.originalConfiguredUser;
                }
                if (res.username) {
                    if (endpoint.user != res.username) {
                        endpoint.user = res.username;
                        endpoint.authenticated = res.authenticated;
                        somethingChanged = true;
                        this.authChange.next({ endpoint, app });
                    }
                }
                else {
                    if (endpoint.user != endpoint.originalConfiguredUser) {
                        somethingChanged = true;
                    }
                    endpoint.user = endpoint.originalConfiguredUser;
                }
                return somethingChanged;
            }
            catch (e) {
                console.warn(e);
                return e;
            }
        });
    }
    getCurrentUserIfNeeded(endpoint, app) {
        return __awaiter(this, void 0, void 0, function* () {
            if (endpoint.user === undefined ||
                ['anonymous', 'browser'].includes(endpoint.user)) {
                yield this.detectAuthChange(endpoint, app);
            }
        });
    }
    logout(endpoint, app) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${endpoint.url}/logout`;
            try {
                yield lastValueFrom(this.$http.get(url, { withCredentials: true }));
            }
            catch (ex) {
                console.warn(ex);
            }
            finally {
                endpoint.user = 'anonymous';
                endpoint.authenticated = false;
                this.authChange.next({ endpoint, app });
            }
        });
    }
    displayLaymanError(endpoint, errorMsg, responseBody, app) {
        let simplifiedResponse = '';
        if (responseBody.code === undefined) {
            simplifiedResponse = 'COMMON.unknownError';
        }
        switch (responseBody.code) {
            case 48:
                simplifiedResponse = 'mapExtentFilterMissing';
                break;
            case 32:
                simplifiedResponse = 'Authentication failed. Login to the catalogue.';
                this.detectAuthChange(endpoint, app);
                break;
            default:
                simplifiedResponse = responseBody.message;
                if (responseBody.detail) {
                    simplifiedResponse = simplifiedResponse + ' ' + responseBody.detail;
                }
        }
        //If response is object, it is an error response
        this.hsToastService.createToastPopupMessage(this.hsLanguageService.getTranslation(errorMsg, undefined, app), endpoint.title +
            ': ' +
            this.hsLanguageService.getTranslationIgnoreNonExisting('COMMON', simplifiedResponse, undefined, app), { disableLocalization: true, serviceCalledFrom: 'HsCommonLaymanService' }, app);
    }
}
HsCommonLaymanService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCommonLaymanService, deps: [{ token: i1.HttpClient }, { token: HsToastService }, { token: HsLanguageService }], target: i0.ɵɵFactoryTarget.Injectable });
HsCommonLaymanService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCommonLaymanService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCommonLaymanService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: HsToastService }, { type: HsLanguageService }]; } });

class HsCommonEndpointsService {
    constructor(hsConfig, hsCommonLaymanService, hsUtilsService) {
        this.hsConfig = hsConfig;
        this.hsCommonLaymanService = hsCommonLaymanService;
        this.hsUtilsService = hsUtilsService;
        this.endpointsFilled = new BehaviorSubject(null);
    }
    init(_app) {
        this.fillEndpoints(_app);
        this.hsConfig.configChanges.subscribe(({ app, config }) => {
            if (app == _app) {
                this.fillEndpoints(app);
            }
        });
    }
    fillEndpoints(app) {
        this.endpoints = [
            ...(this.hsConfig.get(app).status_manager_url
                ? [
                    {
                        type: 'statusmanager',
                        title: 'Status manager',
                        url: this.hsConfig.get(app).status_manager_url,
                        onError: { compositionLoad: EndpointErrorHandling.ignore },
                    },
                ]
                : []),
            ...(this.hsConfig.get(app).datasources || []).map((ds) => {
                const tmp = {
                    url: ds.url,
                    id: this.hsUtilsService.generateUuid(),
                    type: ds.type,
                    title: ds.title,
                    onError: ds.onError,
                    datasourcePaging: {
                        start: 0,
                        limit: this.getItemsPerPageConfig(ds),
                        loaded: false,
                    },
                    compositionsPaging: {
                        start: 0,
                        limit: this.getItemsPerPageConfig(ds),
                        loaded: false,
                    },
                    paging: {
                        itemsPerPage: this.getItemsPerPageConfig(ds),
                    },
                    user: ds.user,
                    originalConfiguredUser: ds.user,
                    getCurrentUserIfNeeded: () => __awaiter(this, void 0, void 0, function* () { return yield this.hsCommonLaymanService.getCurrentUserIfNeeded(tmp, app); }),
                };
                return tmp;
            }),
        ]
            /**
             * Sort endpoints in order to give layman's
             * layers priority in duplicate filtering.
             */
            .sort((a, b) => a.type.localeCompare(b.type));
        if (this.endpoints) {
            this.endpointsFilled.next({ endpoints: this.endpoints, app });
        }
    }
    getItemsPerPageConfig(endpoint) {
        return endpoint.paging !== undefined &&
            endpoint.paging.itemsPerPage !== undefined
            ? endpoint.paging.itemsPerPage
            : 10;
    }
}
HsCommonEndpointsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCommonEndpointsService, deps: [{ token: HsConfig }, { token: HsCommonLaymanService }, { token: HsUtilsService }], target: i0.ɵɵFactoryTarget.Injectable });
HsCommonEndpointsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCommonEndpointsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCommonEndpointsService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: HsConfig }, { type: HsCommonLaymanService }, { type: HsUtilsService }]; } });

class HsAddDataParams {
    constructor() {
        this.sidebarLoad = new Subject();
        this.dsSelected = undefined;
    }
}
class HsAddDataService {
    constructor(hsMapService, hsUtilsService, hsConfig, hsCommonEndpointsService, hsCommonLaymanService) {
        this.hsMapService = hsMapService;
        this.hsUtilsService = hsUtilsService;
        this.hsConfig = hsConfig;
        this.hsCommonEndpointsService = hsCommonEndpointsService;
        this.hsCommonLaymanService = hsCommonLaymanService;
        this.apps = { default: new HsAddDataParams() };
        this.datasetSelected = new Subject();
        /**
         * Cancels any external url data request from datasources panel
         */
        this.cancelUrlRequest = new Subject();
    }
    get(app) {
        if (this.apps[app !== null && app !== void 0 ? app : 'default'] == undefined) {
            this.apps[app !== null && app !== void 0 ? app : 'default'] = new HsAddDataParams();
        }
        return this.apps[app !== null && app !== void 0 ? app : 'default'];
    }
    addLayer(layer, app, underLayer) {
        if (underLayer) {
            const layers = this.hsMapService.getLayersArray(app);
            const underZ = underLayer.getZIndex();
            layer.setZIndex(underZ);
            for (const iLayer of layers.filter((l) => !getBase(l))) {
                if (iLayer.getZIndex() >= underZ) {
                    iLayer.setZIndex(iLayer.getZIndex() + 1);
                }
            }
            const ix = layers.indexOf(underLayer);
            this.hsMapService.getMap(app).getLayers().insertAt(ix, layer);
        }
        else {
            this.hsMapService.getMap(app).addLayer(layer);
        }
    }
    selectType(type, app) {
        this.apps[app].dsSelected = type;
        this.datasetSelected.next({ type, app });
    }
}
HsAddDataService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataService, deps: [{ token: HsMapService }, { token: HsUtilsService }, { token: HsConfig }, { token: HsCommonEndpointsService }, { token: HsCommonLaymanService }], target: i0.ɵɵFactoryTarget.Injectable });
HsAddDataService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsMapService }, { type: HsUtilsService }, { type: HsConfig }, { type: HsCommonEndpointsService }, { type: HsCommonLaymanService }]; } });

/**
 * List of GET parameters set and red by Hslayers
 */
const HS_PRMS = {
    x: 'hs-x',
    y: 'hs-y',
    zoom: 'hs-z',
    visibleLayers: 'hs-visible-layers',
    panel: 'hs-panel',
    lang: 'hs-lang',
    pureMap: 'hs-puremap',
    view: 'hs-view',
    permalink: 'hs-permalink',
    composition: 'hs-composition',
    search: 'hs-search',
    layerSelected: 'hs-layer-selected',
    hsWmsToConnect: 'hs-wms-to-connect',
    hsWfsToConnect: 'hs-wfs-to-connect',
    hsWmtsToConnect: 'hs-wmts-to-connect',
    hsKmlToConnect: 'hs-kml-to-connect',
    hsGeojsonToConnect: 'hs-geojson-to-connect',
    hsArcgisToConnect: 'hs-arcgis-to-connect',
    hsWmsLayers: 'hs-wms-layers',
    hsWfsLayers: 'hs-wfs-layers',
    hsWmtsLayers: 'hs-wmts-layers',
    hsKmlLayers: 'hs-kml-layers',
    hsGeojsonLayers: 'hs-geojson-layers',
    hsArcgisLayers: 'hs-arcgis-layers',
};
/**
 * If we cant find GET param from HS_PRMS, search in old parameters list before renaming.
 * NOTE: It's important that values in HS_PRMS_BACKWARDS don't exist in
 * HS_PRMS values otherwise recursion will occur.
 */
const HS_PRMS_BACKWARDS = {
    permalink: 'permalink',
    view: 'view',
    panel: 'hs_panel',
    lang: 'lang',
    x: 'hs_x',
    y: 'hs_y',
    zoom: 'hs_z',
    pureMap: 'puremap',
    visibleLayers: 'visible_layers',
    composition: 'composition',
    search: 'search',
    layerSelected: 'layerSelected',
    hsWmsToConnect: 'wms_to_connect',
    hsWfsToConnect: 'wfs_to_connect',
    hsWmtsToConnect: 'wmts_to_connect',
    hsWmsLayers: 'wms_layers',
    hsWfsLayers: 'wfs_layers',
    hsWmtsLayers: 'wmts_layers',
};
/**
 * Some params are set on map interaction or UI and we don't
 * want to reset their values with the original ones when generating the browser URL.
 * GET params not in HS_PRMS_REGENERATED will be remembered and set in the URL.
 */
const HS_PRMS_REGENERATED = [
    HS_PRMS.x,
    HS_PRMS.y,
    HS_PRMS.zoom,
    HS_PRMS.lang,
    HS_PRMS.panel,
    HS_PRMS.visibleLayers,
    HS_PRMS_BACKWARDS.x,
    HS_PRMS_BACKWARDS.y,
    HS_PRMS_BACKWARDS.zoom,
    HS_PRMS_BACKWARDS.lang,
    HS_PRMS_BACKWARDS.panel,
    HS_PRMS_BACKWARDS.visibleLayers,
];

class HsCoreService {
    constructor(HsMapService, HsConfig, HsLayoutService, HsUtilsService, log, HsEventBusService, hsLanguageService) {
        this.HsMapService = HsMapService;
        this.HsConfig = HsConfig;
        this.HsLayoutService = HsLayoutService;
        this.HsUtilsService = HsUtilsService;
        this.log = log;
        this.HsEventBusService = HsEventBusService;
        this.hsLanguageService = hsLanguageService;
        /**
         * @public
         */
        this.embeddedEnabled = true;
        this.language = 'en';
        this._puremapApp = false;
        this.HsEventBusService.layoutLoads.subscribe(({ element, innerElement, app }) => {
            if (!this.initCalled) {
                this.init(app);
            }
        });
    }
    /**
     * Initialization function for HSLayers elements and their sizes.
     * Stores element and container references and sets event listeners for map resizing.
     * @public
     */
    init(app) {
        if (window.innerWidth < 767 || this.HsConfig.get(app).sidebarClosed) {
            this.HsLayoutService.get(app).sidebarExpanded = false;
            this.HsLayoutService.get(app).sidebarLabels = false;
        }
        else {
            this.HsLayoutService.get(app).sidebarExpanded = true;
        }
        const languages = this.HsConfig.get(app).enabledLanguages
            ? this.HsConfig.get(app)
                .enabledLanguages.split(',')
                .map((lang) => lang.trim())
            : ['cs', 'lv'];
        const translateService = this.hsLanguageService.getTranslator(app);
        translateService.addLangs(languages.map((l) => `${app}|${l}`));
        translateService.setDefaultLang(`${app}|en`);
        if (this.HsConfig.get(app).language) {
            translateService.use(`${app}|${this.HsConfig.get(app).language}`);
        }
        else {
            translateService.use(translateService.getDefaultLang());
        }
        if (this.initCalled) {
            return;
        }
        this.HsMapService.loaded(app).then(() => {
            this.initSizeListeners(app);
            setTimeout(() => {
                this.updateVH();
                this.updateMapSize(app);
            }, 750);
            this.initCalled = true;
        });
    }
    /**
     * Define and change size of CSS custom variable --vh used as reference for hs.app-height
     * @private
     */
    updateVH() {
        if (this.HsUtilsService.runningInBrowser()) {
            const vh = window.innerHeight * 0.01;
            document.body.style.setProperty('--vh', `${vh}px`);
            if (window.matchMedia('(orientation: portrait)').matches) {
                document.getElementsByTagName('html')[0].style.height = '100vh';
                setTimeout(() => {
                    document.getElementsByTagName('html')[0].style.height = '100%';
                }, 500);
            }
        }
    }
    /**
     * Add event listeners for updating HS element and map size after browser resizing or complete load of application.
     * @public
     */
    initSizeListeners(app) {
        window.addEventListener('resize', () => {
            this.HsUtilsService.debounce(function () {
                this.updateVH();
                this.updateMapSize(app);
                this.HsEventBusService.layoutResizes.next();
            }, 300, false, this)();
        });
    }
    /**
     * Update map size.
     * @public
     */
    updateMapSize(app) {
        const map = this.HsMapService.apps[app].mapElement;
        if (map === null) {
            return;
        }
        if (this.HsMapService.getMap(app)) {
            this.HsMapService.getMap(app).updateSize();
            if (window.innerWidth < 767 ||
                this.HsLayoutService.get(app).mainpanel != '') {
                this.HsLayoutService.get(app).smallWidth = true; //deprecated
                this.HsLayoutService.get(app).sidebarLabels = false;
            }
            else {
                this.HsLayoutService.get(app).smallWidth = false; //deprecated
                this.HsLayoutService.get(app).sidebarLabels = true;
            }
        }
        else {
            console.log('Map not yet initialized!');
        }
        const neededSize = {
            width: map.offsetWidth,
            height: map.offsetHeight,
        };
        this.HsEventBusService.sizeChanges.next(neededSize);
    }
    /**
     * Do authorization check of User, currently authorization is possible only in connection with Liferay app
     * @public
     * @returns Check result - true for authorized user
     */
    isAuthorized() {
        if (window['getLRUser'] === undefined && !this.missingLRFunctionsWarned) {
            this.log.warn('window.getLRUser function needs to be defined, which usually comes from Liferay.');
            this.missingLRFunctionsWarned = true;
        }
        if (window['getLRUser'] && window['getLRUser']() != 'guest') {
            return true;
        }
        return false;
    }
    /**
     * Do complete reset of map (view, layers) according to app config
     * @public
     */
    resetMap(app) {
        this.HsMapService.reset(app);
        this.HsEventBusService.mapResets.next({ app });
    }
    /**
     * Tests if screen of used device is mobile type (current breakdown is screen width 800px)
     * @public
     * @returns "mobile" or ""
     */
    isMobile() {
        if (window['cordova']) {
            return 'mobile';
        }
        else {
            return '';
        }
    }
    /**
     * Whether app is running in puremapApp mode
     * @public
     */
    get puremapApp() {
        return this._puremapApp;
    }
    setPuremapApp(value, app) {
        this._puremapApp = value;
        if (value) {
            this.HsConfig.get(app).componentsEnabled.guiOverlay = false;
            this.HsMapService.removeAllInteractions(app);
            this.HsMapService.removeAllControls(app);
            this.HsLayoutService.updSidebarVisible(app, false);
        }
    }
}
HsCoreService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCoreService, deps: [{ token: HsMapService }, { token: HsConfig }, { token: HsLayoutService }, { token: HsUtilsService }, { token: HsLogService }, { token: HsEventBusService }, { token: HsLanguageService }], target: i0.ɵɵFactoryTarget.Injectable });
HsCoreService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCoreService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCoreService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsMapService }, { type: HsConfig }, { type: HsLayoutService }, { type: HsUtilsService }, { type: HsLogService }, { type: HsEventBusService }, { type: HsLanguageService }]; } });

class HsLayerUtilsService {
    constructor(HsUtilsService, HsLanguageService, hsMapService, zone) {
        this.HsUtilsService = HsUtilsService;
        this.HsLanguageService = HsLanguageService;
        this.hsMapService = hsMapService;
        this.zone = zone;
    }
    /**
     * Determines if layer has properties needed for 'Zoom to layer' function.
     * @param layer - Selected layer
     * @returns True for layer with BoundingBox property, for
     * WMS layer or for layer, which has source with extent
     */
    layerIsZoomable(layer) {
        if (typeof layer == 'undefined') {
            return false;
        }
        if (layer.getExtent()) {
            return true;
        }
        if (this.isLayerWMS(layer)) {
            return true;
        }
        const src = layer.getSource();
        if (src.getExtent && src.getExtent() && !isEmpty(src.getExtent())) {
            return true;
        }
        return false;
    }
    /**
     * Determines if layer has underlying layers.
     * @param layer - Selected layer
     * @returns True for layer with sub layers, for layer type
     * WMS layer
     */
    hasNestedLayers(layer) {
        if (layer === undefined) {
            return false;
        }
        return layer.Layer !== undefined;
    }
    /**
     * Determines if layer is a Vector layer and therefore styleable
     * @param layer - Selected layer
     * @returns True for ol.layer.Vector
     */
    layerIsStyleable(layer) {
        if (typeof layer == 'undefined') {
            return false;
        }
        if (this.HsUtilsService.instOf(layer, Vector$1) /*&& layer.getSource().styleAble*/) {
            return true;
        }
        return false;
    }
    /**
     * Test if layer is queryable (WMS layer with Info format)
     * @param layer - Selected layer
     * @returns True for ol.layer.Tile and ol.layer.Image with
     * INFO_FORMAT in params
     */
    isLayerQueryable(layer) {
        return this.isLayerWMS(layer) && !!this.getLayerParams(layer).INFO_FORMAT;
    }
    /**
     * Get title of selected layer
     * @param layer - to get layer title
     * @returns Layer title or "Void"
     */
    getLayerTitle(layer) {
        if (getTitle(layer) !== undefined && getTitle(layer) != '') {
            return getTitle(layer).replace(/&#47;/g, '/');
        }
        else {
            return 'Void';
        }
    }
    // todo
    getURL(layer) {
        const src = layer.getSource();
        if (this.HsUtilsService.instOf(src, ImageWMS)) {
            return src.getUrl();
        }
        if (this.HsUtilsService.instOf(src, TileArcGISRest)) {
            return src.getUrls()[0];
        }
        if (this.HsUtilsService.instOf(src, TileWMS)) {
            return src.getUrls()[0];
        }
        if (this.HsUtilsService.instOf(src, WMTS)) {
            return src.getUrls()[0];
        }
        if (this.HsUtilsService.instOf(src, XYZ)) {
            return src.getUrls()[0];
        }
        if (src.getUrl) {
            const tmpUrl = src.getUrl();
            if (typeof tmpUrl == 'string') {
                return tmpUrl;
            }
            else if (this.HsUtilsService.isFunction(tmpUrl)) {
                return tmpUrl();
            }
        }
        if (src.getUrls) {
            return src.getUrls()[0];
        }
    }
    /**
     * Test if layer is WMS layer
     * @param layer - Selected layer
     * @returns True for ol.layer.Tile and ol.layer.Image
     */
    isLayerWMS(layer) {
        if (this.HsUtilsService.instOf(layer, TileLayer) &&
            this.HsUtilsService.instOf(layer.getSource(), TileWMS)) {
            return true;
        }
        if (this.HsUtilsService.instOf(layer, Image$1) &&
            this.HsUtilsService.instOf(layer.getSource(), ImageWMS)) {
            return true;
        }
        return false;
    }
    // todo
    isLayerWMTS(layer) {
        if (this.HsUtilsService.instOf(layer, TileLayer) &&
            this.HsUtilsService.instOf(layer.getSource(), WMTS)) {
            return true;
        }
        return false;
    }
    isLayerXYZ(layer) {
        if (this.HsUtilsService.instOf(layer, TileLayer) &&
            this.HsUtilsService.instOf(layer.getSource(), XYZ)) {
            return true;
        }
        return false;
    }
    isLayerArcgis(layer) {
        if (this.HsUtilsService.instOf(layer, TileLayer) &&
            this.HsUtilsService.instOf(layer.getSource(), TileArcGISRest)) {
            return true;
        }
        return false;
    }
    isLayerIDW(layer) {
        if (this.HsUtilsService.instOf(layer, Image$1) &&
            this.HsUtilsService.instOf(layer.getSource(), IDW)) {
            return true;
        }
        return false;
    }
    getLayerSourceFormat(layer) {
        var _a;
        if (!this.isLayerVectorLayer(layer)) {
            return;
        }
        return (_a = layer
            .getSource()) === null || _a === void 0 ? void 0 : _a.getFormat();
    }
    /**
     * Test if layer is Vector layer
     * @param layer - Selected layer
     * @returns True for Vector layer
     */
    isLayerVectorLayer(layer) {
        if (this.HsUtilsService.instOf(layer, Vector$1) &&
            (this.HsUtilsService.instOf(layer.getSource(), Cluster) ||
                this.HsUtilsService.instOf(layer.getSource(), Vector))) {
            return true;
        }
        return false;
    }
    /**
     * Test if the features in the vector layer come from a GeoJSON source
     * @param layer - an OL vector layer
     * @returns true only if the GeoJSON format is explicitly specified in the source. False otherwise.
     */
    isLayerGeoJSONSource(layer) {
        if (this.HsUtilsService.instOf(this.getLayerSourceFormat(layer), GeoJSON)) {
            return true;
        }
        return false;
    }
    /**
     * Test if the features in the vector layer come from a TopoJSON source
     * @param layer - an OL vector layer
     * @returns true only if the TopoJSON format is explicitly specified in the source. False otherwise.
     */
    isLayerTopoJSONSource(layer) {
        if (this.HsUtilsService.instOf(this.getLayerSourceFormat(layer), TopoJSON)) {
            return true;
        }
        return false;
    }
    /**
     * Test if the features in the vector layer come from a KML source
     * @param layer - an OL vector layer
     * @returns true only if the KML format is explicitly specified in the source. False otherwise.
     */
    isLayerKMLSource(layer) {
        if (this.HsUtilsService.instOf(this.getLayerSourceFormat(layer), KML)) {
            return true;
        }
        return false;
    }
    /**
     * Test if the features in the vector layer come from a GPX source
     * @param layer - an OL vector layer
     * @returns true only if the GPX format is explicitly specified in the source. False otherwise.
     */
    isLayerGPXSource(layer) {
        if (this.HsUtilsService.instOf(this.getLayerSourceFormat(layer), GPX)) {
            return true;
        }
        return false;
    }
    /**
     * Test if layer is shown in layer switcher
     * (if not some internal hslayers layer like selected feature layer)
     * @param layer - Layer to check
     * @returns True if showInLayerManager attribute is set to true
     */
    isLayerInManager(layer) {
        return (getShowInLayerManager(layer) === undefined ||
            getShowInLayerManager(layer) == true);
    }
    getSourceParams(source) {
        return source.getParams();
    }
    getLayerParams(layer) {
        const src = layer.getSource();
        if (this.HsUtilsService.instOf(src, ImageWMS)) {
            return this.getSourceParams(src);
        }
        if (this.HsUtilsService.instOf(src, TileWMS)) {
            return this.getSourceParams(src);
        }
        if (this.HsUtilsService.instOf(src, TileArcGISRest)) {
            return this.getSourceParams(src);
        }
    }
    updateLayerParams(layer, params) {
        const src = layer.getSource();
        if (this.HsUtilsService.instOf(src, ImageWMS)) {
            src.updateParams(params);
        }
        if (this.HsUtilsService.instOf(src, TileWMS)) {
            src.updateParams(params);
        }
        if (this.HsUtilsService.instOf(src, TileArcGISRest)) {
            src.updateParams(params);
        }
    }
    /**
     * Test if layer is has a title
     * @param layer - Layer to check
     * @returns True if layer is has a title
     */
    hasLayerTitle(layer) {
        return getTitle(layer) !== undefined && getTitle(layer) !== '';
    }
    /**
     * Test if layers features are editable
     * @param layer - Layer to check
     * @returns True if layer has attribute 'editor' and in it
     * 'editable' property is set to true or missing
     */
    isLayerEditable(layer) {
        if (getEditor(layer) === undefined) {
            return true;
        }
        const editorConfig = getEditor(layer);
        if (editorConfig.editable === undefined) {
            return true;
        }
        return editorConfig.editable;
    }
    /**
     * Get user friendly name of layer based primary on title
     * and secondary on name attributes.
     * Is used in query service and hover popup.
     * @param layer - Layer to get the name for
     */
    getLayerName(layer) {
        if (layer === undefined ||
            (getShowInLayerManager(layer) !== undefined &&
                getShowInLayerManager(layer) === false)) {
            return '';
        }
        else {
            const layerName = getTitle(layer) || getName(layer);
            return layerName;
        }
    }
    /**
     * Highlight feature corresponding records inside a list
     * @param featuresUnder - Features under the cursor
     * @param layer - Layer to get features from
     */
    highlightFeatures(featuresUnder, layer, list) {
        const highlightedFeatures = list
            .filter((record) => record.highlighted)
            .map((record) => layer.getSource().getFeatureById(record.featureId));
        const dontHighlight = highlightedFeatures
            .filter((feature) => feature && !featuresUnder.includes(feature))
            .map((f) => f.getId());
        const highlight = featuresUnder
            .filter((feature) => feature && !highlightedFeatures.includes(feature))
            .map((f) => f.getId());
        if (dontHighlight.length > 0 || highlight.length > 0) {
            this.zone.run(() => {
                for (const record of list) {
                    if (highlight.includes(record.featureId)) {
                        record.highlighted = true;
                    }
                    if (dontHighlight.includes(record.featureId)) {
                        record.highlighted = false;
                    }
                }
            });
        }
    }
    /**
     * Checks if layer has a VectorSource object, if layer is
     * not internal for hslayers, if it has title and is shown in layer
     * switcher
     * @param layer - Layer to check
     * @returns True if layer is drawable vector layer
     */
    isLayerDrawable(layer) {
        return (this.HsUtilsService.instOf(layer, Vector$1) &&
            layer.getVisible() &&
            this.isLayerInManager(layer) &&
            this.hasLayerTitle(layer) &&
            this.isLayerEditable(layer));
    }
    /**
     * Checks if layer's source has its own source
     * @param layer - Layer to check
     * @returns True if layer is clustered, false otherwise
     */
    isLayerClustered(layer) {
        return this.isLayerVectorLayer(layer) &&
            getCluster(layer) &&
            this.HsUtilsService.instOf(layer.getSource(), Cluster)
            ? true
            : false;
    }
    translateTitle(title, app) {
        return this.HsLanguageService.getTranslationIgnoreNonExisting('LAYERS', title, undefined, app);
    }
    /**
     * Test if layers source is loaded
     * @param layer - Selected layer descriptor
     * @returns True loaded / False not (fully) loaded
     */
    layerLoaded(layer) {
        var _a;
        return (_a = layer.loadProgress) === null || _a === void 0 ? void 0 : _a.loaded;
    }
    /**
     * Test if layers source is validly loaded (!true for invalid)
     * @param layer - Selected layer descriptor
     * @returns True invalid, false valid source
     */
    layerInvalid(layer) {
        var _a;
        return (_a = layer.loadProgress) === null || _a === void 0 ? void 0 : _a.error;
    }
    calculateResolutionFromScale(denominator, app) {
        if (!denominator) {
            return denominator;
        }
        const view = this.hsMapService.getMap(app).getView();
        const units = view.getProjection().getUnits();
        const dpi = 25.4 / 0.28;
        const mpu = METERS_PER_UNIT[units];
        return denominator / (mpu * 39.37 * dpi);
    }
}
HsLayerUtilsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerUtilsService, deps: [{ token: HsUtilsService }, { token: HsLanguageService }, { token: HsMapService }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Injectable });
HsLayerUtilsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerUtilsService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerUtilsService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: HsUtilsService }, { type: HsLanguageService }, { type: HsMapService }, { type: i0.NgZone }]; } });

class HsShareThumbnailService {
    constructor(HsMapService, HsLogService, rendererFactory, hsConfig) {
        this.HsMapService = HsMapService;
        this.HsLogService = HsLogService;
        this.hsConfig = hsConfig;
        this.renderer = rendererFactory.createRenderer(null, null);
    }
    /**
     * @param canvas
     * @param width
     * @param height
     */
    setCanvasSize(canvas, width, height) {
        canvas.width = width;
        canvas.height = height;
        canvas.style.width = width + 'px';
        canvas.style.height = height + 'px';
    }
    /**
     * @param ctx
     */
    setupContext(ctx) {
        ctx.mozImageSmoothingEnabled = false;
        ctx.webkitImageSmoothingEnabled = false;
        ctx.msImageSmoothingEnabled = false;
        ctx.imageSmoothingEnabled = false;
    }
    rendered($element, app, newRender) {
        var _a, _b;
        if (!$element) {
            return;
        }
        let thumbnail;
        const collectorCanvas = this.renderer.createElement('canvas');
        const targetCanvas = this.renderer.createElement('canvas');
        const width = 256, height = 256;
        const firstCanvas = this.HsMapService.apps[app].mapElement.querySelector('.ol-layer canvas');
        this.setCanvasSize(targetCanvas, width, height);
        this.setCanvasSize(collectorCanvas, (_a = firstCanvas === null || firstCanvas === void 0 ? void 0 : firstCanvas.width) !== null && _a !== void 0 ? _a : width, (_b = firstCanvas === null || firstCanvas === void 0 ? void 0 : firstCanvas.height) !== null && _b !== void 0 ? _b : height);
        const ctxCollector = collectorCanvas.getContext('2d');
        const ctxTarget = targetCanvas.getContext('2d');
        this.setupContext(ctxTarget);
        this.setupContext(ctxCollector);
        const configRef = this.hsConfig.get(app);
        Array.prototype.forEach.call(this.HsMapService.apps[app].mapElement.querySelectorAll('.ol-layer canvas'), (canvas) => {
            if (canvas.width > 0) {
                //console.log('canvas loop', this.isCanvasTainted(canvas), canvas);
                /* canvases retrieved from mapElement might be already tainted because they can contain
                 * images (i.e. maps) retrieved from another sources without CORS
                 */
                const opacity = canvas.parentNode.style.opacity;
                ctxCollector.globalAlpha = opacity === '' ? 1 : Number(opacity);
                const transform = canvas.style.transform;
                // Get the transform parameters from the style's transform matrix
                const matrix = transform
                    .match(/^matrix\(([^\(]*)\)$/)[1]
                    .split(',')
                    .map(Number);
                // Apply the transform to the export map context
                CanvasRenderingContext2D.prototype.setTransform.apply(ctxCollector, matrix);
                ctxCollector.drawImage(canvas, 0, 0);
            }
        });
        /* Final render pass */
        ctxTarget.drawImage(collectorCanvas, Math.floor(collectorCanvas.width / 2 - width / 2), Math.floor(collectorCanvas.height / 2 - height / 2), width, height, 0, 0, width, height);
        //console.log('image drawn', this.isCanvasTainted(targetCanvas));
        /**
         * from now on, the targetCanvas is also tainted because another tainted canvas was used
         * to draw inside it
         */
        try {
            /**
             * targetCanvas.toDataURL() fires a SecurityError here
             * see https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image#security_and_tainted_canvases
             */
            $element.setAttribute('src', targetCanvas.toDataURL('image/png'));
            //this.data.thumbnail
            thumbnail = targetCanvas.toDataURL('image/jpeg', 0.85);
        }
        catch (e) {
            console.log('catched, is tainted?', this.isCanvasTainted(targetCanvas));
            //console.log(targetCanvas);
            this.HsLogService.warn(e);
            $element.setAttribute('src', configRef.assetsPath + 'img/notAvailable.png');
        }
        $element.style.width = width + 'px';
        $element.style.height = height + 'px';
        return thumbnail;
    }
    isCanvasTainted(canvas) {
        try {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const pixel = canvas.getContext('2d').getImageData(0, 0, 1, 1);
            return false;
        }
        catch (err) {
            return err.code === 18;
        }
    }
}
HsShareThumbnailService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsShareThumbnailService, deps: [{ token: HsMapService }, { token: HsLogService }, { token: i0.RendererFactory2 }, { token: HsConfig }], target: i0.ɵɵFactoryTarget.Injectable });
HsShareThumbnailService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsShareThumbnailService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsShareThumbnailService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsMapService }, { type: HsLogService }, { type: i0.RendererFactory2 }, { type: HsConfig }]; } });

const LCLSTORAGE_EXPIRE = 5000;
class HsSaveMapService {
    constructor(hsMapService, hsUtilsService, hsLogService, hsLayerUtilsService, hsShareThumbnailService) {
        this.hsMapService = hsMapService;
        this.hsUtilsService = hsUtilsService;
        this.hsLogService = hsLogService;
        this.hsLayerUtilsService = hsLayerUtilsService;
        this.hsShareThumbnailService = hsShareThumbnailService;
        this.internalLayers = [];
    }
    /**
     * Create Json object, which stores information about composition, user, map state and map layers (including layer data)
     * @param map - Selected OL map object
     * @param compoData - Composition general metadata
     * @param userData - Metadata about user
     * @param statusData - Metadata about permissions
     * @param app - App identifier
     * @returns - JSON object with all required map composition's metadata
     */
    map2json(map, compoData, userData, statusData, app) {
        const groups = {};
        for (const g of statusData.groups || []) {
            if (g.r || g.w) {
                groups[g.roleName] = (g.r ? 'r' : '') + (g.w ? 'w' : '');
            }
        }
        if (groups.guest == undefined) {
            groups.guest = 'r';
        }
        const bbox = this.getBboxFromObject(compoData.bbox);
        const json = {
            abstract: compoData.abstract,
            title: compoData.name,
            keywords: compoData.keywords,
            nativeExtent: transformExtent(bbox, 'EPSG:4326', this.hsMapService.getCurrentProj(app)),
            extent: bbox,
            user: {
                address: userData.address,
                city: userData.city,
                country: userData.country,
                email: userData.email || 'none@none',
                name: userData.name,
                organization: userData.organization,
                phone: userData.phone,
                position: userData.position,
                postalcode: userData.postalCode,
                state: userData.state,
            },
            describedBy: 'https://raw.githubusercontent.com/hslayers/map-compositions/2.0.0/schema.json',
            schema_version: '2.0.0',
            groups: groups,
        };
        // Map properties
        const currentProj = this.hsMapService.getCurrentProj(app);
        json.scale = currentProj.getMetersPerUnit();
        json.projection = currentProj.getCode().toLowerCase();
        const center = map.getView().getCenter();
        if (center) {
            json.center = [center[0], center[1]];
        }
        json.units = currentProj.getUnits();
        //*NOTE Does not exist on OL map anymore
        // if (map.maxExtent) {
        //   json.maxExtent = {};
        //   json.maxExtent.left = map.maxExtent.left;
        //   json.maxExtent.bottom = map.maxExtent.bottom;
        //   json.maxExtent.right = map.maxExtent.right;
        //   json.maxExtent.top = map.maxExtent.top;
        // }
        //json.minResolution = map.minResolution;
        //json.maxResolution = map.maxResolution;
        //json.numZoomLevels = map.numZoomLevels;
        //json.resolutions = map.resolutions;
        //json.scales = map.scales;
        //json.sphericalMercator = map.sphericalMercator;
        // Layers properties
        const olLayers = compoData.layers.map((l) => l.layer);
        json.layers = this.layers2json(olLayers, app);
        json.current_base_layer = this.getCurrentBaseLayer(app);
        return json;
    }
    /**
     * Get currently selected base layer from the OL map
     * @param app - App identifier
     * @returns Object with currently selected base layer's title as attribute
     */
    getCurrentBaseLayer(app) {
        let current_base_layer = null;
        for (const lyr of this.hsMapService.getLayersArray(app)) {
            if ((getShowInLayerManager(lyr) == undefined ||
                getShowInLayerManager(lyr) == true) &&
                getBase(lyr) == true &&
                lyr.getVisible()) {
                current_base_layer = {
                    title: getTitle(lyr),
                };
            }
        }
        return current_base_layer;
    }
    /**
     * Get bounding box from object {east: value, south: value, west: value, north: value}
     * @param bbox - Bounding box
     * @returns Returns bounding box as number array
     */
    getBboxFromObject(bbox) {
        if (bbox && !Array.isArray(bbox)) {
            return [
                parseFloat(bbox.east),
                parseFloat(bbox.south),
                parseFloat(bbox.west),
                parseFloat(bbox.north),
            ];
        }
        else {
            return bbox;
        }
    }
    /**
     * Convert map layers into a JSON object
     * Uses layer2json().
     * @param layers - All map layers
     * @param app - App identifier
     * @returns JSON object representing the layers
     */
    layers2json(layers, app) {
        const json = [];
        layers.forEach((layer) => {
            const l = this.layer2json(layer, app);
            if (l) {
                json.unshift(l);
            }
        });
        return json;
    }
    /**
     * Converts map layer from Layer object to text in JSON notation.
     *
     * Syntactic sugar for layer2json() UNUSED?
     *
     * @param layer - Layer to be converted
     * @param pretty - Whether to use pretty notation
     * @param app - App identifier
     * @returns Text in JSON notation representing the layer
     */
    layer2string(layer, pretty, app) {
        const json = this.layer2json(layer, app);
        const text = JSON.stringify(json, pretty);
        return text;
    }
    /**
     * Convert layer's style object into JSON object, partial function of layer2style
     * (saves Fill color, Stroke color/width, Image fill, stroke, radius, src and type)
     *
     * @param style - Style to convert
     * @param app - App identifier
     * @returns Converted JSON object replacing OL style
     */
    serializeStyle(style, app) {
        const s = Array.isArray(style) ? style[0] : style;
        const o = {};
        const ima = {};
        if (s.getFill() && s.getFill() !== null) {
            o.fill = s.getFill().getColor();
        }
        if (s.getStroke() && s.getStroke() !== null) {
            o.stroke = {
                color: s.getStroke().getColor(),
                width: s.getStroke().getWidth(),
            };
        }
        if (s.getImage() && s.getImage() !== null) {
            const style_img = s.getImage();
            if (this.hsUtilsService.instOf(style_img, RegularShape)) {
                const regShape = style_img;
                if (regShape.getFill()) {
                    ima.fill = regShape.getFill().getColor();
                }
                if (regShape.getStroke()) {
                    ima.stroke = {
                        color: regShape.getStroke().getColor(),
                        width: regShape.getStroke().getWidth(),
                    };
                }
                ima.radius = regShape.getRadius();
            }
            if (this.hsUtilsService.instOf(style_img, Icon) &&
                typeof style_img.getSrc() === 'string' &&
                !style_img.getSrc().startsWith('data:image')) {
                ima.src = this.hsUtilsService.proxify(style_img.getSrc(), app);
            }
            if (this.hsUtilsService.instOf(style_img, Circle)) {
                ima.type = 'circle';
            }
            if (this.hsUtilsService.instOf(style_img, Icon)) {
                ima.type = 'icon';
            }
            o.image = ima;
        }
        return o;
    }
    /**
     * Convert map layer into a JSON object (only for ol.layer.Layer)
     * Layer properties covered:  (CLASS_NAME), name, url, params,
     *                            group, displayInLayerSwitcher, *visibility, *opacity
     *                            attribution, transitionEffect,
     *                             isBaseLayer, minResolution,
     *                            maxResolution, metadata,
     *                            abstract, opacity, singleTile, removable,
     *                            queryable, legend, projections,
     *                            wmsMinScale, wmsMaxScale
     *
     * The layer index is not covered, as we assume
     * that it is corresponding to the layers order.
     *
     * @param layer - Map layer that should be converted
     * @param app - App identifier
     * @returns JSON object representing the layer
     */
    layer2json(layer, app) {
        var _a;
        const json = {
            metadata: getMetadata(layer) || {},
        };
        /*
              Commented out because we cant reliably use instanceof.
              utils.instOf is also not possible, because Layer is a base type
    
              if (!layer instanceof Layer) {
                  return;
              }
              */
        // Common stuff
        // type
        //json.className = layer.CLASS_NAME;
        //json.origClassName = layer.CLASS_NAME; // the original type
        // options
        json.visibility = layer.getVisible();
        json.swipeSide = getSwipeSide(layer);
        json.opacity = layer.getOpacity();
        json.base = (_a = getBase(layer)) !== null && _a !== void 0 ? _a : false;
        json.title = getTitle(layer);
        if (getTitle(layer) == undefined) {
            this.hsLogService.warn('Layer title undefined', layer);
        }
        //json.index = layer.map.getLayerIndex(layer);
        json.path = getPath(layer);
        if (layer.getExtent()) {
            const ex = layer.getExtent();
            json.maxExtent = {
                left: ex[0],
                bottom: ex[3],
                right: ex[2],
                top: ex[1],
            };
        }
        // HTTPRequest
        if (this.hsUtilsService.instOf(layer, Tile) ||
            this.hsUtilsService.instOf(layer, Image$1)) {
            const src = layer.getSource();
            if (layer.getMaxResolution() !== null) {
                json.maxResolution = layer.getMaxResolution();
            }
            if (layer.getMinResolution() !== null) {
                json.minResolution = layer.getMinResolution();
            }
            json.displayInLayerSwitcher = getShowInLayerManager(layer);
            if (getDimensions(layer)) {
                json.dimensions = getDimensions(layer);
            }
            if (this.hsUtilsService.instOf(src, XYZ)) {
                json.className = 'XYZ';
            }
            if (this.hsUtilsService.instOf(src, ImageArcGISRest) ||
                this.hsUtilsService.instOf(src, TileArcGISRest)) {
                json.className = 'ArcGISRest';
                json.singleTile = this.hsUtilsService.instOf(src, ImageArcGISRest);
            }
            if (this.hsUtilsService.instOf(src, ImageStatic)) {
                json.className = 'StaticImage';
                json.extent = src.getImageExtent();
            }
            if (this.hsLayerUtilsService.isLayerWMS(layer)) {
                json.className = 'HSLayers.Layer.WMS';
                json.singleTile = this.hsUtilsService.instOf(src, ImageWMS);
                if (getLegends(layer)) {
                    json.legends = [];
                    const legends = getLegends(layer);
                    if (Array.isArray(legends)) {
                        json.legends = legends.map((l) => encodeURIComponent(l));
                    }
                    if (typeof legends == 'string') {
                        json.legends = [legends];
                    }
                }
                if (src.getProjection()) {
                    json.projection = src.getProjection().getCode().toLowerCase();
                }
                json.params = this.hsLayerUtilsService.getLayerParams(layer);
                if (getOrigLayers(layer)) {
                    json.params.LAYERS = getOrigLayers(layer);
                }
                json.subLayers = getSubLayers(layer);
                json.metadata.styles = src.get('styles');
            }
            json.url = encodeURIComponent(this.hsLayerUtilsService.getURL(layer));
            if (getAttribution(layer)) {
                json.attributions = getAttribution(layer);
            }
            if (this.hsUtilsService.instOf(src, WMTS)) {
                const wmts = src;
                json.className = 'HSLayers.Layer.WMTS';
                json.matrixSet = wmts.getMatrixSet();
                json.layer = wmts.getLayer();
                json.format = wmts.getFormat();
                json.info_format = layer.get('info_format');
                json.url = wmts.getUrls()[0];
            }
        }
        // Vector
        if (this.hsUtilsService.instOf(layer, Vector$1)) {
            let src = layer.getSource();
            if (this.hsLayerUtilsService.isLayerClustered(layer)) {
                src = src.getSource();
            }
            json.name = getName(layer);
            json.className = 'Vector';
            const definition = getDefinition(layer);
            if (definition && definition.url) {
                json.protocol = {
                    url: encodeURIComponent(definition.url),
                    format: definition.format,
                };
                json.workspace = getWorkspace(layer);
                delete json.features;
            }
            else {
                if (getWfsUrl(layer)) {
                    json.protocol = {
                        url: getWfsUrl(layer),
                        format: 'hs.format.externalWFS',
                    };
                }
                else {
                    try {
                        json.features = this.getFeaturesJson(src.getFeatures(), app);
                    }
                    catch (ex) {
                        //Do nothing
                    }
                }
            }
            json.maxResolution = layer.getMaxResolution();
            json.minResolution = layer.getMinResolution();
            json.projection = 'epsg:4326';
            if (getSld(layer) != undefined) {
                json.style = getSld(layer);
            }
            else if (this.hsUtilsService.instOf(layer.getStyle(), Style)) {
                json.style = this.serializeStyle(layer.getStyle(), app);
            }
        }
        return json;
    }
    /**
     * Convert feature array to GeoJSON string
     *
     * @param features - Array of features
     * @param app - App identifier
     * @returns GeoJSON
     */
    getFeaturesJson(features, app) {
        const f = new GeoJSON();
        const featureProjection = this.hsMapService.getCurrentProj(app).getCode();
        return f.writeFeaturesObject(features, {
            dataProjection: 'EPSG:4326',
            featureProjection,
        });
    }
    /**
     * Create thumbnail of the map view and save it into selected element
     * @param $element - Selected element
     * @param app - App identifier
     * @param newRender - Force new render
     */
    generateThumbnail($element, app, newRender) {
        if ($element === null) {
            return;
        }
        $element.setAttribute('crossOrigin', 'Anonymous');
        const map = this.hsMapService.getMap(app);
        map.once('postcompose', () => this.hsShareThumbnailService.rendered($element, app, newRender));
        if (newRender) {
            map.renderSync();
        }
        else {
            this.hsShareThumbnailService.rendered($element, app, newRender);
        }
    }
    /**
     * Save map layers to browsers' local storage
     * @param app - App identifier
     */
    save2storage(app) {
        const data = {
            expires: new Date().getTime() + LCLSTORAGE_EXPIRE,
            layers: this.hsMapService
                .getLayersArray(app)
                .filter((lyr) => !this.internalLayers.includes(lyr) &&
                (getShowInLayerManager(lyr) == undefined ||
                    getShowInLayerManager(lyr) == true))
                .map((lyr) => this.layer2json(lyr, app)),
        };
        //TODO: Set the item sooner, so it can be reloaded after accidental browser crash
        // but remove it if leaving the site for good
        localStorage.setItem('hs_layers', JSON.stringify(data));
    }
}
HsSaveMapService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSaveMapService, deps: [{ token: HsMapService }, { token: HsUtilsService }, { token: HsLogService }, { token: HsLayerUtilsService }, { token: HsShareThumbnailService }], target: i0.ɵɵFactoryTarget.Injectable });
HsSaveMapService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSaveMapService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSaveMapService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsMapService }, { type: HsUtilsService }, { type: HsLogService }, { type: HsLayerUtilsService }, { type: HsShareThumbnailService }]; } });

class HsShareUrlService {
    constructor(HsMapService, HsCore, HsUtilsService, HsSaveMapService, HsConfig, HsLanguageService, HsLayoutService, HsEventBusService, Location, zone, PlatformLocation) {
        this.HsMapService = HsMapService;
        this.HsCore = HsCore;
        this.HsUtilsService = HsUtilsService;
        this.HsSaveMapService = HsSaveMapService;
        this.HsConfig = HsConfig;
        this.HsLanguageService = HsLanguageService;
        this.HsLayoutService = HsLayoutService;
        this.HsEventBusService = HsEventBusService;
        this.Location = Location;
        this.zone = zone;
        this.PlatformLocation = PlatformLocation;
        this.url_generation = true;
        //some of the code is taken from http://stackoverflow.com/questions/22258793/set-url-parameters-without-causing-page-refresh
        this.paramTimer = null;
        this.shareId = null;
        this.current_url = '';
        this.permalinkRequestUrl = '';
        this.params = {};
        this.customParams = {};
        this.updateDebouncer = {};
        this.ngUnsubscribe = new Subject();
        this.statusSaving = false;
        this.browserUrlUpdated = new Subject();
        this.keepTrackOfGetParams();
    }
    keepTrackOfGetParams() {
        const params = this.parse(location.search);
        /* We keep track of most hsl params separately so don't process
        them here. Only third party params are interesting */
        for (const key of Object.keys(HS_PRMS_REGENERATED)) {
            delete params[HS_PRMS_REGENERATED[key]];
        }
        Object.assign(this.customParams, params);
    }
    /**
     * Get actual map state information (visible layers, added layers*, active panel, map center and zoom level), create full Url link and push it in Url bar. (*Added layers are ommited from permalink url).
     */
    update(app) {
        if (Object.entries(this.HsConfig.apps).length > 1) {
            if (!this.ngUnsubscribe.closed) {
                this.current_url = location.origin + location.pathname + '?';
                this.id = this.HsUtilsService.generateUuid();
                this.ngUnsubscribe.next();
                this.ngUnsubscribe.complete();
            }
            this.browserUrlUpdated.next();
            /**
             * FIXME: ?
             * Some third party params ( mentioned in keepTrackOfGetParams ) might need to be handled separately?
             */
            return;
        }
        const view = this.HsMapService.getMap(app).getView();
        this.id = this.HsUtilsService.generateUuid();
        const externalLayers = this.HsMapService.getLayersArray(app).filter((lyr) => !(getShowInLayerManager(lyr) === false));
        const visibleLayers = externalLayers
            .filter((lyr) => lyr.getVisible())
            .map((lyr) => getTitle(lyr));
        const addedLayers = externalLayers.filter((lyr) => { var _a; return !((_a = this.HsConfig.get(app).default_layers) === null || _a === void 0 ? void 0 : _a.includes(lyr)); });
        //This might become useful, but url size is limited, so we are not using it
        const addedLayersJson = this.HsSaveMapService.layers2json(addedLayers, app);
        const pnlMain = this.HsLayoutService.get(app).mainpanel;
        this.push(HS_PRMS.panel, pnlMain == 'permalink' ? 'layermanager' : pnlMain);
        this.push(HS_PRMS.x, view.getCenter()[0]);
        this.push(HS_PRMS.y, view.getCenter()[1]);
        this.push(HS_PRMS.zoom, view.getZoom());
        if (this.HsLanguageService.apps[app].language) {
            this.push(HS_PRMS.lang, this.HsLanguageService.apps[app].language);
        }
        this.push(HS_PRMS.visibleLayers, visibleLayers.join(';'));
        if (this.HsCore.puremapApp) {
            this.push(HS_PRMS.pureMap, 'true');
        }
        for (const cP in this.customParams) {
            this.push(cP, this.customParams[cP]);
        }
        if (this.statusSaving) {
            return;
        }
        this.HsUtilsService.debounce(() => {
            let locationPath = this.pathName();
            const paramsSerialized = Object.keys(this.params)
                .map((key) => {
                return { key, value: this.params[key] };
            })
                .map((dic) => `${dic.key}=${encodeURIComponent(dic.value)}`)
                .join('&');
            const baseHref = this.PlatformLocation.getBaseHrefFromDOM();
            if (locationPath.indexOf(baseHref) == 0 &&
                this.HsConfig.get(app).ngRouter) {
                locationPath = locationPath.replace(baseHref, '');
            }
            this.Location.replaceState(locationPath, paramsSerialized);
            this.browserUrlUpdated.next();
        }, 300, false, this.updateDebouncer)();
    }
    /**
     * @returns Permalink url
     * Create permalink Url to map
     */
    getPermalinkUrl(app) {
        if (this.HsCore.isMobile() && this.HsConfig.get(app).permalinkLocation) {
            //Deprecated? - isMobile??
            return (this.HsConfig.get(app).permalinkLocation.origin +
                this.current_url.replace(this.pathName(), this.HsConfig.get(app).permalinkLocation.pathname) +
                `&${HS_PRMS.permalink}=${encodeURIComponent(this.permalinkRequestUrl)}`).replace(this.pathName(), this.HsConfig.get(app).permalinkLocation.pathname);
        }
        else {
            return `${this.current_url}&${HS_PRMS.permalink}=${encodeURIComponent(this.permalinkRequestUrl)}`;
        }
    }
    pathName() {
        let tmp = window.location.pathname.split('?')[0];
        if (!tmp.endsWith('/') && !tmp.split('/').pop().includes('.')) {
            tmp = tmp + '/';
        }
        return tmp;
    }
    /**
     * @returns Embedded url
     * Create Url for PureMap version of map
     */
    getPureMapUrl(app) {
        const params = { puremap: 'true' };
        return (this.getPermalinkUrl(app) +
            '&' +
            this.HsUtilsService.paramsToURLWoEncode(params));
    }
    /**
     * @param str Parameter string to parse
     * @returns Parsed parameter object
     * Parse parameter string from Url into key-value(s) pairs
     */
    parse(str) {
        if (typeof str != 'string') {
            return {};
        }
        str = str.trim().replace(/^\?/, '');
        if (!str) {
            return {};
        }
        return str
            .trim()
            .split('&')
            .reduce((paramDict, param) => {
            const parts = param.replace(/\+/g, ' ').split('=');
            let key = parts[0];
            let val = parts[1];
            key = decodeURIComponent(key);
            // missing `=` should be `null`:
            // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
            val = val == undefined ? null : decodeURIComponent(val);
            if (!paramDict.hasOwnProperty(key)) {
                paramDict[key] = val;
            }
            else if (Array.isArray(paramDict[key])) {
                paramDict[key].push(val);
            }
            else {
                paramDict[key] = [paramDict[key], val];
            }
            return paramDict;
        }, {});
    }
    /**
     * @param obj Parameter object to stringify
     * @returns Encoded parameter string or "" if no parameter object is given
     * Create encoded parameter string from parameter object
     */
    stringify(obj) {
        if (!obj) {
            return '';
        }
        return Object.keys(obj)
            .map((key) => {
            const val = obj[key];
            if (Array.isArray(val)) {
                return val
                    .map((val2) => {
                    return encodeURIComponent(key) + '=' + encodeURIComponent(val2);
                })
                    .join('&');
            }
            return encodeURIComponent(key) + '=' + encodeURIComponent(val);
        })
            .join('&');
    }
    /**
     * @param key Key name for pushed parameter
     * @param new_value Value for pushed parameter
     * Push new key-value pair into paramater object and update Url string with new params
     */
    push(key, new_value) {
        if (new_value === undefined) {
            delete this.params[key];
        }
        else {
            this.params[key] = new_value;
        }
        const new_params_string = this.stringify(this.params);
        this.param_string = new_params_string;
        this.urlUntilParams = location.origin + location.pathname;
        this.current_url = this.urlUntilParams + '?' + new_params_string;
    }
    /**
     * @param param - Param to get current value and remove
     * Returns param value and removes custom param when it is called
     */
    getParamValAndRemove(param) {
        const value = this.getParamValue(param);
        if (this.customParams[param]) {
            delete this.customParams[param];
        }
        return value;
    }
    /**
     * @param param Param to get current value
     * @returns Current value for requested param or null if param doesn't exist
     * Find current param value from Url
     */
    getParamValue(param) {
        const tmp = this.parse(location.search);
        const key = Object.keys(HS_PRMS).find((k) => HS_PRMS[k] == param);
        if (tmp[param]) {
            return tmp[param];
        }
        else {
            if (tmp[param] == undefined && HS_PRMS_BACKWARDS[key] != undefined) {
                return this.getParamValue(HS_PRMS_BACKWARDS[key]);
            }
            else {
                return;
            }
        }
    }
    getParamValues(keys) {
        const tmp = {};
        for (const key of keys) {
            tmp[key] = this.getParamValue(key);
        }
        return tmp;
    }
    /**
     * @param params A dictionary of custom parameters which get added to the generated url
     * Update values for custom parameters which get added to the url and usually are application specific
     */
    updateCustomParams(params, app) {
        for (const param in params) {
            this.customParams[param] = params[param];
        }
        if (this.paramTimer !== null) {
            clearTimeout(this.paramTimer);
        }
        this.paramTimer = setTimeout(() => {
            this.update(app);
        }, 1000);
    }
    /**
     * @param map Openlayers map
     */
    init(app) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.HsMapService.loaded(app);
            const map = this.HsMapService.getMap(app);
            if (this.url_generation) {
                let timer = null;
                this.HsEventBusService.mapExtentChanges
                    .pipe(takeUntil(this.ngUnsubscribe))
                    .subscribe(this.HsUtilsService.debounce(({ map, event, extent, app }) => {
                    this.zone.run(() => {
                        this.update(app);
                    });
                }, 200, false, this));
                map.getLayers().on('add', (e) => {
                    const layer = e.element;
                    const external = getShowInLayerManager(layer);
                    if (external !== null && external == false) {
                        return;
                    }
                    layer.on('change:visible', (e) => {
                        if (timer !== null) {
                            clearTimeout(timer);
                        }
                        timer = setTimeout(() => {
                            if (!this.ngUnsubscribe.closed) {
                                this.update(app);
                            }
                        }, 1000);
                    });
                });
                const lang = this.getParamValue(HS_PRMS.lang);
                if (lang) {
                    this.HsLanguageService.setLanguage(lang, app);
                }
                const view = this.getParamValue(HS_PRMS.view);
                // this.HsMapService.visible = !(view == '3d');
            }
        });
    }
}
HsShareUrlService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsShareUrlService, deps: [{ token: HsMapService }, { token: HsCoreService }, { token: HsUtilsService }, { token: HsSaveMapService }, { token: HsConfig }, { token: HsLanguageService }, { token: HsLayoutService }, { token: HsEventBusService }, { token: i3.Location }, { token: i0.NgZone }, { token: i3.PlatformLocation }], target: i0.ɵɵFactoryTarget.Injectable });
HsShareUrlService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsShareUrlService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsShareUrlService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: HsMapService }, { type: HsCoreService }, { type: HsUtilsService }, { type: HsSaveMapService }, { type: HsConfig }, { type: HsLanguageService }, { type: HsLayoutService }, { type: HsEventBusService }, { type: i3.Location }, { type: i0.NgZone }, { type: i3.PlatformLocation }]; } });

class HsAddDataUrlParams {
    constructor() {
        this.connectFromParams = true;
        this.addDataCapsParsingError = new Subject();
    }
}
class HsAddDataUrlService {
    constructor(hsLog, hsLanguageService, hsLayoutService) {
        this.hsLog = hsLog;
        this.hsLanguageService = hsLanguageService;
        this.hsLayoutService = hsLayoutService;
        this.apps = { default: new HsAddDataUrlParams() };
    }
    get(app) {
        if (this.apps[app !== null && app !== void 0 ? app : 'default'] == undefined) {
            this.apps[app !== null && app !== void 0 ? app : 'default'] = new HsAddDataUrlParams();
        }
        return this.apps[app !== null && app !== void 0 ? app : 'default'];
    }
    /**
     * Selects a service layer to be added (WMS | WMTS | ArcGIS Map Server)
     * @param services - Layer group of a service to select a layer from
     * @param layerToSelect - Layer to be selected (checked = true)
     * @param selector - Layer selector. Can be either 'Name' or 'Title'. Differs in between different services
     */
    selectLayerByName(layerToSelect, services, selector) {
        if (!layerToSelect) {
            return;
        }
        let selectedLayer;
        if (Array.isArray(services)) {
            for (const serviceLayer of services) {
                selectedLayer = this.selectSubLayerByName(layerToSelect, serviceLayer, selector);
                if (selectedLayer && serviceLayer[selector] == layerToSelect) {
                    return selectedLayer;
                }
            }
        }
        else {
            return this.selectSubLayerByName(layerToSelect, services, selector);
        }
    }
    /**
     * Helper function for selectLayerByName()
     */
    selectSubLayerByName(layerToSelect, serviceLayer, selector) {
        let selectedLayer;
        if (serviceLayer.Layer && serviceLayer[selector] != layerToSelect) {
            selectedLayer = this.selectLayerByName(layerToSelect, serviceLayer.Layer, selector);
        }
        if (serviceLayer[selector] == layerToSelect) {
            selectedLayer = this.setLayerCheckedTrue(layerToSelect, serviceLayer, selector);
        }
        return selectedLayer;
    }
    /**
     * Helper function for selectLayerByName()
     * Does the actual selection (checked = true)
     */
    setLayerCheckedTrue(layerToSelect, serviceLayer, selector) {
        if (serviceLayer[selector] == layerToSelect) {
            serviceLayer.checked = true;
        }
        return serviceLayer;
    }
    searchForChecked(records, app) {
        var _a;
        this.get(app).addingAllowed =
            (_a = records === null || records === void 0 ? void 0 : records.some((l) => l.checked)) !== null && _a !== void 0 ? _a : this.get(app).typeSelected == 'arcgis';
    }
}
HsAddDataUrlService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataUrlService, deps: [{ token: HsLogService }, { token: HsLanguageService }, { token: HsLayoutService }], target: i0.ɵɵFactoryTarget.Injectable });
HsAddDataUrlService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataUrlService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataUrlService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsLogService }, { type: HsLanguageService }, { type: HsLayoutService }]; } });

class HsSidebarParams {
    constructor() {
        this.extraButtons = [];
        this.buttonsSubject = new BehaviorSubject([]);
        /**
         * If buttons with importancy property exist.
         * If not, don't display expansion +/- icon
         */
        this.unimportantExist = false;
        /**
         * List of visible buttons taking into account viewport size
         */
        this.visibleButtons = [];
        this.buttons = this.buttonsSubject.asObservable();
    }
}
class HsSidebarService {
    constructor(HsLayoutService, HsConfig, HsLanguageService, HsCoreService, HsEventBusService, HsUtilsService) {
        this.HsLayoutService = HsLayoutService;
        this.HsConfig = HsConfig;
        this.HsLanguageService = HsLanguageService;
        this.HsCoreService = HsCoreService;
        this.HsEventBusService = HsEventBusService;
        this.HsUtilsService = HsUtilsService;
        this.apps = { default: new HsSidebarParams() };
        this.sidebarLoad = new Subject();
        this.HsEventBusService.mainPanelChanges.subscribe(({ which, app }) => {
            /* NOTE: WE used to update map size only 'if (!HsLayoutService.sidebarExpanded) {'
            but that leads to blank margin between map and window border
            (see https://github.com/hslayers/hslayers-ng/issues/1107). Using timer to take
            into account sidebar width changing animation.
            */
            setTimeout(() => {
                this.HsCoreService.updateMapSize(app);
            }, 550);
        });
    }
    get(app = 'default') {
        if (this.apps[app] == undefined) {
            this.apps[app] = new HsSidebarParams();
        }
        return this.apps[app];
    }
    prepareForTemplate(buttons) {
        const tmp = buttons.map((button) => {
            if (typeof button.title == 'function') {
                button.title = button.title();
            }
            if (typeof button.description == 'function') {
                button.description = button.description();
            }
            return button;
        });
        tmp.sort((a, b) => a.order - b.order);
        return tmp;
    }
    setButtonVisibility(buttons, app) {
        const appRef = this.get(app);
        if (this.HsLayoutService.get(app).layoutElement == undefined) {
            setTimeout(() => this.setButtonVisibility(buttons, app), 100);
            return;
        }
        appRef.importantButtons = buttons.filter((button) => {
            return (button.important != false &&
                appRef.visibleButtons.includes(button.panel));
        });
        appRef.numberOfUnimportant =
            buttons.length - appRef.importantButtons.length;
        for (const button of appRef.importantButtons) {
            button.fits = this.fitsSidebar(button, app);
        }
        if (!appRef.unimportantExist) {
            this.HsLayoutService.get(app).minisidebar = this.get(app).importantButtons.some((b) => b.fits == false);
        }
    }
    addButton(button, app) {
        this.get(app !== null && app !== void 0 ? app : 'default')
            .buttons.pipe(take(1))
            .subscribe((cur) => {
            this.get(app !== null && app !== void 0 ? app : 'default').buttonsSubject.next([...cur, button]);
        });
    }
    /**
     * Function to set if a button is important and always visible
     * or only when the sidebar buttons are expanded
     *
     * @param panelName
     * @param state
     */
    setButtonImportancy(buttons, panelName, state, app = 'default') {
        const appRef = this.get(app);
        const backCompat = { datasource_selector: 'addData' };
        panelName = backCompat[panelName] ? backCompat[panelName] : panelName;
        const button = buttons.find((b) => b.panel == panelName);
        if (button) {
            //Unimportant buttons are automatically placed inside minisidebar
            button.fits = state;
            button.important = state;
        }
        appRef.unimportantExist = buttons.some((b) => b.important == false);
        this.HsLayoutService.get(app).minisidebar = appRef.unimportantExist;
    }
    buttonClicked(button, app) {
        if (button.click) {
            button.click();
        }
        else {
            this.HsLayoutService.setMainPanel(button.panel, app, true);
        }
    }
    setPanelState(buttons, app) {
        const appRef = this.get(app);
        if (buttons.length == 0) {
            return;
        }
        for (const button of buttons) {
            if (this.HsLayoutService.getPanelEnableState(button.panel, app) &&
                this.checkConfigurableButtons(button, app)) {
                if (!appRef.visibleButtons.includes(button.panel)) {
                    appRef.visibleButtons.push(button.panel);
                    button.visible = true;
                }
            }
            else {
                button.visible = false;
            }
        }
    }
    /**
     * Checks whether the panels, which could be placed both in map or
     * in sidebar, have state defined in config.panelsEnabled. If yes it
     * should be placed in sidebar rather then in map.
     * It´s necessary for buttons like 'measure' because simple
     * 'config.panelsEnabled = false' would prevent their functionality.
     * @param {object} button buttons Buttons object
     */
    checkConfigurableButtons(button, app) {
        if (typeof button.condition == 'undefined') {
            return true;
        }
        else if (!this.HsConfig.get(app).panelsEnabled) {
            return false;
        }
        else {
            return this.HsConfig.get(app).panelsEnabled[button.panel];
        }
    }
    /**
     * @public
     * @param {string} which Sidear button to be checked (specify panel name)
     * @description Check if sidebar button should be visible in classic sidebar or hidden inside minisidebar panel
     * @description Toggles minisidebar button
     */
    fitsSidebar(button, app) {
        const dimensionToCheck = window.innerWidth > 767 ? 'clientHeight' : 'clientWidth';
        this.HsLayoutService.get(app).sidebarToggleable = window.innerWidth > 767;
        let maxNumberOfButtons = Math.floor(this.HsLayoutService.get(app).layoutElement[dimensionToCheck] / 65);
        maxNumberOfButtons =
            dimensionToCheck == 'clientHeight'
                ? maxNumberOfButtons - 1
                : maxNumberOfButtons;
        return (this.get(app).importantButtons.findIndex((btn) => btn.panel === button.panel) +
            2 <=
            maxNumberOfButtons);
    }
}
HsSidebarService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSidebarService, deps: [{ token: HsLayoutService }, { token: HsConfig }, { token: HsLanguageService }, { token: HsCoreService }, { token: HsEventBusService }, { token: HsUtilsService }], target: i0.ɵɵFactoryTarget.Injectable });
HsSidebarService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSidebarService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSidebarService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsLayoutService }, { type: HsConfig }, { type: HsLanguageService }, { type: HsCoreService }, { type: HsEventBusService }, { type: HsUtilsService }]; } });

class HsPanelHeaderComponent {
    /*transclude: {
      'extraButtons': '?extraButtons',
      'extraTitle': '?extraTitle',
    },*/
    constructor(HsLayoutService) {
        this.HsLayoutService = HsLayoutService;
        this.app = 'default';
    }
    closePanel() {
        this.HsLayoutService.closePanel(this.name, this.app);
    }
}
HsPanelHeaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsPanelHeaderComponent, deps: [{ token: HsLayoutService }], target: i0.ɵɵFactoryTarget.Component });
HsPanelHeaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsPanelHeaderComponent, selector: "hs-panel-header", inputs: { name: "name", app: "app", title: "title" }, ngImport: i0, template: "<div class=\"card-header d-flex p-1\"><span class=\"flex-grow-1 p-1\">{{title}}<ng-content select=\"extra-title\"></ng-content></span>\n    <ng-content select=\"extra-buttons\"></ng-content>\n</div>" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsPanelHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-panel-header', template: "<div class=\"card-header d-flex p-1\"><span class=\"flex-grow-1 p-1\">{{title}}<ng-content select=\"extra-title\"></ng-content></span>\n    <ng-content select=\"extra-buttons\"></ng-content>\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsLayoutService }]; }, propDecorators: { name: [{
                type: Input
            }], app: [{
                type: Input
            }], title: [{
                type: Input
            }] } });

const AddDataUrlValues = [
    {
        id: 'wms',
        text: 'WMS',
    },
    {
        id: 'wmts',
        text: 'WMTS',
    },
    {
        id: 'wfs',
        text: 'WFS',
    },
    {
        id: 'kml',
        text: 'KML',
    },
    {
        id: 'gpx',
        text: 'GPX',
    },
    {
        id: 'geojson',
        text: 'GeoJSON',
    },
    {
        id: 'arcgis',
        text: 'ArcGIS Map Server',
    },
];

class HsDialogItem {
    constructor(component, data, app) {
        this.component = component;
        this.data = data;
        this.app = app;
    }
    waitResult() {
        const promise = new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });
        return promise;
    }
}

class HsDialogContainerParams {
    constructor() {
        this.dialogs = [];
        this.dialogObserver = new ReplaySubject();
        this.dialogDestroyObserver = new Subject();
    }
}
class HsDialogContainerService {
    constructor() {
        this.apps = { default: new HsDialogContainerParams() };
    }
    get(app = 'default') {
        if (this.apps[app] === undefined) {
            this.apps[app] = new HsDialogContainerParams();
        }
        return this.apps[app];
    }
    create(component, data, app = 'default') {
        data.app = app;
        const item = new HsDialogItem(component, data, app);
        this.get(app).dialogObserver.next(item);
        return item;
    }
    destroy(component, app = 'default') {
        if (component.cleanup) {
            component.cleanup();
        }
        const dialogCollection = this.get(app).dialogs;
        const dialogIx = dialogCollection.findIndex((d) => d == component);
        if (dialogIx > -1) {
            dialogCollection.splice(dialogIx, 1);
        }
        this.get(app).dialogDestroyObserver.next(component);
    }
}
HsDialogContainerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsDialogContainerService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
HsDialogContainerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsDialogContainerService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsDialogContainerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return []; } });

class TranslateCustomPipe extends TranslatePipe {
    constructor(translate2, _theRef, hsLanguageService) {
        super(translate2, _theRef);
        this.translate2 = translate2;
        this._theRef = _theRef;
        this.hsLanguageService = hsLanguageService;
    }
    transform(query, ...args) {
        if (query == undefined || query == '') {
            return query;
        }
        if (equals(query, this.lastKey) && equals(args, this.lastParams)) {
            return this.value;
        }
        let interpolateParams = undefined;
        if (args[0] && args.length) {
            if (typeof args[0] === 'string' && args[0].length) {
                // we accept objects written in the template such as {n:1}, {'n':1}, {n:'v'}
                // which is why we might need to change it to real JSON objects such as {"n":1} or {"n":"v"}
                const validArgs = args[0]
                    .replace(/(\')?([a-zA-Z0-9_]+)(\')?(\s)?:/g, '"$2":')
                    .replace(/:(\s)?(\')(.*?)(\')/g, ':"$3"');
                try {
                    interpolateParams = JSON.parse(validArgs);
                }
                catch (e) {
                    throw new SyntaxError(`Wrong parameter in TranslatePipe. Expected a valid Object, received: ${args[0]}`);
                }
            }
            else if (typeof args[0] === 'object' && !Array.isArray(args[0])) {
                interpolateParams = args[0];
            }
        }
        if (interpolateParams.app == undefined) {
            console.warn('You must specify app parameter for translateHs pipe i.e. `translateHs : {app: "default"}`. Translating: ' +
                query);
        }
        let module;
        if (interpolateParams.module != undefined) {
            module = interpolateParams.module;
        }
        const translator = this.hsLanguageService.getTranslator(interpolateParams.app);
        if (!this.onTranslationChange) {
            this.onTranslationChange = translator.onTranslationChange.subscribe((event) => {
                if (this.lastKey && event.lang === translator.currentLang) {
                    this.lastKey = null;
                    this.updateTranslation(query, translator, module);
                }
            });
        }
        // subscribe to onLangChange event, in case the language changes
        if (!this.onLangChange) {
            this.onLangChange = translator.onLangChange.subscribe((event) => {
                if (this.lastKey) {
                    this.lastKey = null; // we want to make sure it doesn't return the same value until it's been updated
                    this.updateTranslation(query, translator, module);
                }
            });
        }
        this.lastKey = query;
        // store the params, in case they change
        this.lastParams = args;
        this.updateTranslation(query, translator, module);
        return this.value;
    }
    updateTranslation(query, translator, module) {
        const onTranslation = (res) => {
            this.value = res !== undefined ? res : query;
            if (module != undefined && res == module + '.' + query) {
                this.value = query;
            }
            this.lastKey = query;
        };
        if (translator.currentLang == undefined) {
            translator.currentLang = translator.defaultLang;
        }
        translator
            .get((module ? module + '.' : '') + query)
            .subscribe(onTranslation);
    }
}
TranslateCustomPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TranslateCustomPipe, deps: [{ token: i1$1.TranslateService }, { token: i0.ChangeDetectorRef }, { token: HsLanguageService }], target: i0.ɵɵFactoryTarget.Pipe });
TranslateCustomPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TranslateCustomPipe, name: "translateHs", pure: false });
TranslateCustomPipe.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TranslateCustomPipe });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TranslateCustomPipe, decorators: [{
            type: Injectable
        }, {
            type: Pipe,
            args: [{
                    name: 'translateHs',
                    pure: false, // required to update the value when the promise is resolved
                }]
        }], ctorParameters: function () { return [{ type: i1$1.TranslateService }, { type: i0.ChangeDetectorRef }, { type: HsLanguageService }]; } });
function equals(o1, o2) {
    if (o1 === o2) {
        return true;
    }
    if (o1 === null || o2 === null) {
        return false;
    }
    if (o1 !== o1 && o2 !== o2) {
        return true;
    } // NaN === NaN
    let t1 = typeof o1, t2 = typeof o2, length, key, keySet;
    if (t1 == t2 && t1 == 'object') {
        if (Array.isArray(o1)) {
            if (!Array.isArray(o2)) {
                return false;
            }
            if ((length = o1.length) == o2.length) {
                for (key = 0; key < length; key++) {
                    if (!equals(o1[key], o2[key])) {
                        return false;
                    }
                }
                return true;
            }
        }
        else {
            if (Array.isArray(o2)) {
                return false;
            }
            keySet = Object.create(null);
            for (key in o1) {
                if (!equals(o1[key], o2[key])) {
                    return false;
                }
                keySet[key] = true;
            }
            for (key in o2) {
                if (!(key in keySet) && typeof o2[key] !== 'undefined') {
                    return false;
                }
            }
            return true;
        }
    }
    return false;
}

class HsGetCapabilitiesErrorComponent {
    constructor(hsDialogContainerService) {
        this.hsDialogContainerService = hsDialogContainerService;
    }
    ngOnInit() {
        this.capabilitiesErrorModalVisible = true;
    }
    close() {
        this.hsDialogContainerService.destroy(this, this.data.app);
    }
}
HsGetCapabilitiesErrorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsGetCapabilitiesErrorComponent, deps: [{ token: HsDialogContainerService }], target: i0.ɵɵFactoryTarget.Component });
HsGetCapabilitiesErrorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsGetCapabilitiesErrorComponent, selector: "hs-get-capabilities-error", inputs: { data: "data" }, ngImport: i0, template: "<div class=\"modal in hs-ows-wms-capabilities-error\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header bg-danger text-white\" style=\"opacity: 0.9;\">\n                <h4 class=\"modal-title text-uppercase\">\n                    {{'ADDLAYERS.capabilitiesParsingProblem' | translateHs : {app: data.app} }}\n                </h4>\n                <button type=\"button\" (click)=\"close()\" class=\"btn-close\" data-dismiss=\"modal\"\n                    attr.aria-label=\"{{'COMMON.close' | translateHs : {app: data.app} }}\"></button>\n            </div>\n            <div class=\"modal-body\" style=\"max-height:600px; overflow-y:auto\">\n                <p>{{'ADDLAYERS.ERROR.thereWasErrorWhile' | translateHs : {app: data.app} }}</p>\n                <p>{{data.error}}</p>\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-secondary\" (click)=\"close()\" data-dismiss=\"modal\">{{'COMMON.close'\n                    | translateHs : {app: data.app} }}</button>\n            </div>\n        </div>\n    </div>\n</div>\n", pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsGetCapabilitiesErrorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-get-capabilities-error', template: "<div class=\"modal in hs-ows-wms-capabilities-error\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header bg-danger text-white\" style=\"opacity: 0.9;\">\n                <h4 class=\"modal-title text-uppercase\">\n                    {{'ADDLAYERS.capabilitiesParsingProblem' | translateHs : {app: data.app} }}\n                </h4>\n                <button type=\"button\" (click)=\"close()\" class=\"btn-close\" data-dismiss=\"modal\"\n                    attr.aria-label=\"{{'COMMON.close' | translateHs : {app: data.app} }}\"></button>\n            </div>\n            <div class=\"modal-body\" style=\"max-height:600px; overflow-y:auto\">\n                <p>{{'ADDLAYERS.ERROR.thereWasErrorWhile' | translateHs : {app: data.app} }}</p>\n                <p>{{data.error}}</p>\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-secondary\" (click)=\"close()\" data-dismiss=\"modal\">{{'COMMON.close'\n                    | translateHs : {app: data.app} }}</button>\n            </div>\n        </div>\n    </div>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: HsDialogContainerService }]; }, propDecorators: { data: [{
                type: Input
            }] } });

//Move to common/dimensions
class HsDimensionDescriptor {
    //Original dimension object can be shared between multiple layers.
    constructor(name, originalDimension) {
        var _a, _b, _c;
        this.name = name;
        this.originalDimension = originalDimension;
        this.type = this.originalDimension.type;
        this.value = (_a = this.originalDimension.value) !== null && _a !== void 0 ? _a : this.originalDimension.default;
        this.modelValue =
            (_b = this.originalDimension.value) !== null && _b !== void 0 ? _b : this.originalDimension.default;
        // Duck-type check if the passed value is an instance of Date.
        if (typeof ((_c = this.value) === null || _c === void 0 ? void 0 : _c.getMonth) == 'function') {
            if (this.type == 'datetime') {
                this.modelValue = {
                    year: this.value.getFullYear(),
                    month: this.value.getMonth() + 1,
                    day: this.value.getDate(),
                };
                this.modelTimeValue = {
                    hour: this.value.getHours(),
                    minute: this.value.getMinutes(),
                };
            }
            if (this.type == 'date') {
                this.modelValue = {
                    year: this.value.getFullYear(),
                    month: this.value.getMonth() + 1,
                    day: this.value.getDate(),
                };
            }
        }
        this.label = this.originalDimension.label;
        this.values = this.originalDimension.values;
        this.format = this.originalDimension.format;
    }
    /* This is needed because ng-bootstrap datepicker sets value to
      object {year:.., month: .., day: ..} but we need vanillaJs Date
      in dimension.value attribute instead. Use the complex value only
      for picker through modelValue */
    postProcessDimensionValue() {
        var _a, _b;
        if (this.modelValue.year && this.modelValue.month) {
            this.originalDimension.value = new Date(this.modelValue.year, this.modelValue.month - 1, this.modelValue.day, (_a = this.modelTimeValue) === null || _a === void 0 ? void 0 : _a.hour, (_b = this.modelTimeValue) === null || _b === void 0 ? void 0 : _b.minute);
        }
        else {
            this.originalDimension.value = this.modelValue;
        }
        if (['datetime', 'date'].includes(this.type) && this.format) {
            this.originalDimension.value = dayjs(this.originalDimension.value).format(this.format);
        }
        this.value = this.originalDimension.value;
    }
}

class HsDimensionTimeService {
    constructor(hsLog, HsUtilsService) {
        this.hsLog = hsLog;
        this.HsUtilsService = HsUtilsService;
        /**
         * To communicate changes between this service and HsDimensionService
         */
        this.layerTimeChanges = new Subject();
    }
    /**
     * Parse interval string to get interval as a number
     * @param interval - Interval time string
     * @returns - Number of milliseconds representing the interval
     */
    parseInterval(interval) {
        let dateComponent;
        let timeComponent;
        let year;
        let month;
        let day;
        let hour;
        let minute;
        let second;
        // eslint-disable-next-line no-multi-assign
        year = month = day = hour = minute = second = 0;
        const indexOfT = interval.search('T');
        if (indexOfT > -1) {
            dateComponent = interval.substring(1, indexOfT);
            timeComponent = interval.substring(indexOfT + 1);
        }
        else {
            dateComponent = interval.substring(1);
        }
        // parse date
        if (dateComponent) {
            const indexOfY = dateComponent.search('Y') > -1 ? dateComponent.search('Y') : undefined;
            const indexOfM = dateComponent.search('M') > -1 ? dateComponent.search('M') : undefined;
            const indexOfD = dateComponent.search('D') > -1 ? dateComponent.search('D') : undefined;
            if (indexOfY !== undefined) {
                year = parseFloat(dateComponent.substring(0, indexOfY));
            }
            if (indexOfM !== undefined) {
                month = parseFloat(dateComponent.substring((indexOfY || -1) + 1, indexOfM));
            }
            if (indexOfD !== undefined) {
                day = parseFloat(dateComponent.substring((indexOfM || indexOfY || -1) + 1, indexOfD));
            }
        }
        // parse time
        if (timeComponent) {
            const indexOfH = timeComponent.search('H') > -1 ? timeComponent.search('H') : undefined;
            const indexOfm = timeComponent.search('M') > -1 ? timeComponent.search('M') : undefined;
            const indexOfS = timeComponent.search('S') > -1 ? timeComponent.search('S') : undefined;
            if (indexOfH !== undefined) {
                hour = parseFloat(timeComponent.substring(0, indexOfH));
            }
            if (indexOfm !== undefined) {
                minute = parseFloat(timeComponent.substring((indexOfH || -1) + 1, indexOfm));
            }
            if (indexOfS !== undefined) {
                second = parseFloat(timeComponent.substring((indexOfm || indexOfH || -1) + 1, indexOfS));
            }
        }
        // year, month, day, hours, minutes, seconds, milliseconds)
        const zero = new Date(0, 0, 0, 0, 0, 0, 0).getTime();
        const step = new Date(year, month, day, hour, minute, second, 0).getTime();
        return step - zero;
    }
    /**
     * Test if WMS layer has time support (WMS-T). WMS layer has to have dimension property
     * @param layer - Container object of layer (layerContainer.layer expected)
     * @returns True for WMS layer with time support
     */
    layerIsWmsT(layer) {
        var _a, _b;
        const olLayer = (_a = layer.layer) !== null && _a !== void 0 ? _a : layer;
        if (!olLayer) {
            return false;
        }
        if (layer.time) {
            return true;
        }
        /*
         * 'dimensions_time' is deprecated
         * backwards compatibility with HSL < 3.0
         */
        if (olLayer.get('dimensions_time') &&
            Array.isArray(olLayer.get('dimensions_time').timeInterval)) {
            this.hsLog.warn('"dimensions_time" is deprecated, use "dimensions" param with "time" object instead');
            const currentDimensions = getDimensions(olLayer);
            const newTimeDimension = {
                label: 'time',
                default: olLayer.get('dimensions_time').value,
            };
            if (!currentDimensions) {
                setDimensions(olLayer, { 'time': newTimeDimension });
            }
            else {
                setDimensions(olLayer, Object.assign(currentDimensions, { 'time': newTimeDimension }));
            }
        }
        if ((_b = getDimensions(olLayer)) === null || _b === void 0 ? void 0 : _b.time) {
            return true;
        }
        return false;
    }
    /**
     * Make initial setup for WM(T)S-t layers
     * @param currentLayer - Layer for which the time is being set up
     * @param serviceLayer - Description of that layer's capabilities in a service
     */
    setupTimeLayer(currentLayer, app, serviceLayer) {
        var _a, _b;
        const olLayer = currentLayer.layer;
        //parse config set at a Layer level
        const hsLayerTimeConfig = (_a = getDimensions(olLayer)) === null || _a === void 0 ? void 0 : _a.time;
        //parse parametres available at the WM(T)S level
        let serviceLayerTimeConfig;
        if (serviceLayer) {
            if (!Array.isArray(serviceLayer.Dimension)) {
                serviceLayerTimeConfig = serviceLayer.Dimension;
            }
            else {
                serviceLayerTimeConfig = (_b = serviceLayer.Dimension) === null || _b === void 0 ? void 0 : _b.find((dim) => dim.name == 'time'); // Let's assume there will be only one time dimension..
            }
        }
        else if (hsLayerTimeConfig) {
            serviceLayerTimeConfig = hsLayerTimeConfig;
        }
        const timePoints = Array.isArray(serviceLayerTimeConfig.values)
            ? serviceLayerTimeConfig.values
            : this.parseTimePoints(serviceLayerTimeConfig.values);
        // Gracefully fallback through time settings to find the best default value
        let today = new Date().toISOString();
        today = today.slice(0, today.indexOf('T'));
        let defaultTime;
        let layerParams = {};
        const isTileWms = this.HsUtilsService.instOf(olLayer.getSource(), TileWMS);
        if (isTileWms) {
            const src = olLayer.getSource();
            layerParams = src.getParams();
            src.on('change', (_) => {
                this.syncQueryParamToDimension(src, olLayer, currentLayer, app);
            });
        }
        const isImgWms = this.HsUtilsService.instOf(olLayer.getSource(), ImageWMS);
        if (isImgWms) {
            const src = olLayer.getSource();
            layerParams = src.getParams();
            src.on('change', (_) => {
                this.syncQueryParamToDimension(src, olLayer, currentLayer, app);
            });
        }
        if (layerParams['TIME'] && timePoints.includes(layerParams['TIME'])) {
            defaultTime = layerParams['TIME'];
        }
        else if (timePoints.includes(hsLayerTimeConfig === null || hsLayerTimeConfig === void 0 ? void 0 : hsLayerTimeConfig.default)) {
            defaultTime = hsLayerTimeConfig.default;
        }
        else if (timePoints.includes(serviceLayerTimeConfig === null || serviceLayerTimeConfig === void 0 ? void 0 : serviceLayerTimeConfig.default)) {
            defaultTime = serviceLayerTimeConfig.default;
        }
        else if (timePoints.some((point) => point.startsWith(today))) {
            defaultTime = timePoints.find((point) => point.startsWith(today));
        }
        else {
            defaultTime = timePoints[0];
        }
        currentLayer.time = {
            default: defaultTime,
            timePoints,
        };
        this.polyfillLayerDimensionsValues(currentLayer);
        this.setLayerTime(currentLayer, defaultTime, app);
    }
    /**
     * When PARAMS object on layer source is set directly from outside
     * we want to monitor it and set time dimension separately to
     * update the time selector. The actual dimension value will be
     * set in postProcessDimensionValue function of
     * get-capabilities/dimension class.
     */
    syncQueryParamToDimension(src, olLayer, currentLayer, app) {
        var _a;
        const timeFromParams = src.getParams()['TIME'];
        if (timeFromParams &&
            timeFromParams != ((_a = getDimensions(olLayer)) === null || _a === void 0 ? void 0 : _a.time.value)) {
            this.setLayerTime(currentLayer, timeFromParams, app);
        }
    }
    /**
     * Update layer TIME parameter
     * @param currentLayer - Selected layer
     * @param newTime - ISO8601 string of a date and time to set
     */
    setLayerTime(currentLayer, newTime, app) {
        if (currentLayer === undefined || currentLayer.layer === undefined) {
            return;
        }
        this.layerTimeChanges.next({
            layer: currentLayer,
            time: newTime,
            app,
        });
    }
    /**
     * Reads a time dimension definition and transforms it into a canonical form of an array of time points
     * @param values - Stringified time definition. Either defined by a list of values or by an ISO 8601 duration pattern
     * @returns Array of time points in ISO 8601 format
     */
    parseTimePoints(values) {
        values = values.trim();
        if (values.includes('/')) {
            const timeValues = values.split('/');
            if (timeValues.length == 3 && timeValues[2].trim().startsWith('P')) {
                // Duration, pattern: "1999-01-22T19:00:00/2018-01-22T13:00:00/PT8766H"
                return this.timePointsFromInterval(timeValues[0], timeValues[1], this.parseInterval(timeValues[2]));
            }
            else if (timeValues.length == 2) {
                // Duration, pattern: "1999-01-22T19:00:00/2018-01-22T13:00:00"
                // Daily interval is a pure guessing here and might be overkill for common cases
                // TODO: => try better guessing
                return this.timePointsFromInterval(timeValues[0], timeValues[1], 24 * 60 * 60 * 1000);
            }
            else {
                throw new Error(`Invalid ISO8601 time definition provided: ${values}`);
            }
        }
        return values.split(',');
    }
    /**
     * Because of the way the HsDimension interface is set up,
     * we need to fill all parsed and currently undefined values
     * into the "dimensions" property of OL Layer as well.
     * Nevertheless we are duplicating some information.
     */
    polyfillLayerDimensionsValues(layerDescriptor) {
        var _a, _b, _c, _d, _e;
        if (!((_a = getDimensions(layerDescriptor.layer)) === null || _a === void 0 ? void 0 : _a.time)) {
            setDimension(layerDescriptor.layer, { label: 'time' }, 'time');
        }
        const dimensionTimeProp = getDimensions(layerDescriptor.layer).time;
        dimensionTimeProp.label = (_b = dimensionTimeProp.label) !== null && _b !== void 0 ? _b : 'time';
        dimensionTimeProp.default =
            (_c = dimensionTimeProp.default) !== null && _c !== void 0 ? _c : layerDescriptor.time.default;
        dimensionTimeProp.value =
            (_d = dimensionTimeProp.value) !== null && _d !== void 0 ? _d : layerDescriptor.time.default;
        dimensionTimeProp.values =
            (_e = dimensionTimeProp.values) !== null && _e !== void 0 ? _e : layerDescriptor.time.timePoints;
    }
    timePointsFromInterval(start, end, step) {
        const timePoints = [];
        const endMillis = new Date(end).getTime();
        let tempMillis = new Date(start).getTime();
        while (tempMillis <= endMillis) {
            timePoints.push(new Date(tempMillis).toISOString());
            tempMillis += step;
        }
        return timePoints;
    }
}
HsDimensionTimeService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsDimensionTimeService, deps: [{ token: HsLogService }, { token: HsUtilsService }], target: i0.ɵɵFactoryTarget.Injectable });
HsDimensionTimeService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsDimensionTimeService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsDimensionTimeService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsLogService }, { type: HsUtilsService }]; } });

class HsDimensionService {
    constructor($log, hsDimensionTimeService, hsEventBusService, hsLayerUtilsService, hsMapService, hsUtilsService) {
        this.$log = $log;
        this.hsDimensionTimeService = hsDimensionTimeService;
        this.hsEventBusService = hsEventBusService;
        this.hsLayerUtilsService = hsLayerUtilsService;
        this.hsMapService = hsMapService;
        this.hsUtilsService = hsUtilsService;
        this.hsDimensionTimeService.layerTimeChanges.subscribe(({ layer: layerDescriptor, time: newTime, app }) => {
            var _a;
            const dimensions = getDimensions(layerDescriptor.layer);
            if (dimensions && (dimensions['time'] || dimensions['TIME'])) {
                const dimensionDesc = new HsDimensionDescriptor('time', (_a = dimensions['time']) !== null && _a !== void 0 ? _a : dimensions['TIME']);
                dimensionDesc.modelValue = newTime;
                this.dimensionChanged(dimensionDesc, app);
            }
        });
    }
    getDimensionValues(dimension) {
        try {
            if (typeof dimension.values === 'string') {
                return this.hsDimensionTimeService.parseTimePoints(dimension.values);
            }
            else {
                return dimension.values;
            }
        }
        catch (ex) {
            this.$log.error(ex);
        }
    }
    paramsFromDimensions(layer) {
        if (!layer.Dimension) {
            return;
        }
        const tmp = {};
        for (const dimension of layer.Dimension) {
            if (dimension.value) {
                tmp[dimension.name] = dimension.value;
            }
        }
        return tmp;
    }
    /**
     * A recursive function with goes through layers
     * children and sets the possible dimension values used in dropdown.
     *
     * @param layer - Layer to fill the dimension values
     */
    fillDimensionValues(layer) {
        if (!Array.isArray(layer.Layer)) {
            return;
        }
        if (this.hsLayerUtilsService.hasNestedLayers(layer) &&
            Array.isArray(layer.Layer)) {
            for (const sublayer of layer.Layer) {
                this.fillDimensionValues(sublayer);
            }
        }
        if (layer.Dimension && Array.isArray(layer.Dimension)) {
            for (const dimension of layer.Dimension) {
                /* Since we augment the 'values' property here in the WmsLayer definition
                 * it shall not be needed again in the HsDimensionTimeService.setupTimeLayer()
                 */
                dimension.values = this.getDimensionValues(dimension);
            }
        }
    }
    dimensionChanged(dimension, app) {
        dimension.postProcessDimensionValue();
        //Dimension can be linked to multiple layers
        for (const layer of this.hsMapService.getLayersArray(app)) {
            const iteratedDimensions = getDimensions(layer);
            if (iteratedDimensions &&
                Object.keys(iteratedDimensions).filter((dimensionIterator) => iteratedDimensions[dimensionIterator] == dimension.originalDimension).length > 0 //Dimension also linked to this layer?
            ) {
                const src = layer.getSource();
                if (this.hsLayerUtilsService.isLayerWMS(layer)) {
                    const params = this.hsLayerUtilsService.getLayerParams(layer);
                    params[dimension.name == 'time' ? 'TIME' : dimension.name] =
                        dimension.value;
                    this.hsLayerUtilsService.updateLayerParams(layer, params);
                }
                else if (this.hsUtilsService.instOf(src, XYZ)) {
                    src.refresh();
                }
                else if (this.hsUtilsService.instOf(src, Vector)) {
                    src.refresh();
                }
                this.hsEventBusService.layermanagerDimensionChanges.next({
                    layer,
                    dimension: dimension.originalDimension,
                });
            }
        }
    }
    /**
     * Test if layer has dimensions
     * @param layer - OL Layer
     * @returns true if layer has any dimensions
     */
    isLayerWithDimensions(layer) {
        if (!layer) {
            return false;
        }
        const dimensions = getDimensions(layer);
        if (dimensions === undefined) {
            return false;
        }
        return (Object.keys(dimensions).filter((k) => {
            return k == 'time' ? dimensions[k].onlyInEditor : true;
        }).length > 0);
    }
}
HsDimensionService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsDimensionService, deps: [{ token: HsLogService }, { token: HsDimensionTimeService }, { token: HsEventBusService }, { token: HsLayerUtilsService }, { token: HsMapService }, { token: HsUtilsService }], target: i0.ɵɵFactoryTarget.Injectable });
HsDimensionService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsDimensionService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsDimensionService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsLogService }, { type: HsDimensionTimeService }, { type: HsEventBusService }, { type: HsLayerUtilsService }, { type: HsMapService }, { type: HsUtilsService }]; } });

class HsAddDataCommonParams {
    constructor() {
        this.loadingInfo = false;
        this.showDetails = false;
    }
}
class HsAddDataCommonService {
    constructor(hsMapService, hsAddDataUrlService, hsToastService, hsAddDataService, hsDimensionService, hsEventBusService) {
        this.hsMapService = hsMapService;
        this.hsAddDataUrlService = hsAddDataUrlService;
        this.hsToastService = hsToastService;
        this.hsAddDataService = hsAddDataService;
        this.hsDimensionService = hsDimensionService;
        this.hsEventBusService = hsEventBusService;
        this.apps = { default: new HsAddDataCommonParams() };
        //TODO: all dimension related things need to be refactored into separate module
        this.getDimensionValues = this.hsDimensionService.getDimensionValues;
        this.serviceLayersCalled = new Subject();
        this.hsAddDataService.cancelUrlRequest.subscribe((app) => {
            this.clearParams(app);
        });
    }
    get(app) {
        if (this.apps[app !== null && app !== void 0 ? app : 'default'] == undefined) {
            this.apps[app !== null && app !== void 0 ? app : 'default'] = new HsAddDataCommonParams();
        }
        return this.apps[app !== null && app !== void 0 ? app : 'default'];
    }
    clearParams(app) {
        const appRef = this.get(app);
        appRef.layerToSelect = '';
        appRef.loadingInfo = false;
        appRef.showDetails = false;
        appRef.url = '';
        this.hsAddDataUrlService.get(app).typeSelected = null;
    }
    setPanelToCatalogue(app) {
        this.hsAddDataService.apps[app].dsSelected = 'catalogue';
    }
    /**
     * For the sake of possible future implementation changes
     * @param url - URL to be set
     */
    updateUrl(url, app) {
        this.get(app).url = url;
    }
    checkTheSelectedLayer(services, serviceType, app) {
        var _a, _b, _c, _d;
        if (!services) {
            return;
        }
        const nameOrTitle = serviceType !== 'wmts';
        for (const layer of services) {
            //TODO: If Layman allows layers with different casing,
            // then remove the case lowering
            const layerName = nameOrTitle
                ? (_b = (_a = layer.Name) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : (_c = layer.Title) === null || _c === void 0 ? void 0 : _c.toLowerCase()
                : (_d = layer.Identifier) === null || _d === void 0 ? void 0 : _d.toLowerCase();
            if (layerName === this.get(app).layerToSelect.toLowerCase()) {
                layer.checked = true;
            }
        }
    }
    displayParsingError(e, app) {
        if ((e === null || e === void 0 ? void 0 : e.status) === 401) {
            this.hsToastService.createToastPopupMessage('ADDLAYERS.capabilitiesParsingProblem', 'ADDLAYERS.unauthorizedAccess', { serviceCalledFrom: 'HsAddDataCommonUrlService' }, app);
        }
        else {
            this.hsAddDataUrlService.apps[app].addDataCapsParsingError.next(e);
        }
    }
    throwParsingError(e, app) {
        this.clearParams(app);
        this.displayParsingError(e, app);
    }
    //NOTE* - Is this method even needed?
    srsChanged(srs, app) {
        setTimeout(() => {
            return !this.currentProjectionSupported([srs], app);
        }, 0);
    }
    /**
     * Test if current map projection is in supported projection list
     *
     * @param srss - List of supported projections
     * @returns True if map projection is in list, false otherwise
     */
    currentProjectionSupported(srss, app) {
        if (!srss || srss.length === 0) {
            return false;
        }
        let found = false;
        for (const val of srss) {
            if (!val) {
                found = false;
            }
            else {
                if (this.hsMapService
                    .getMap(app)
                    .getView()
                    .getProjection()
                    .getCode()
                    .toUpperCase() == val.toUpperCase()) {
                    found = true;
                }
            }
        }
        return found;
    }
    /**
     * Constructs body of LAYER parameter for getMap request
     * @param layerOrLayers - layer object or layers received from capabilities. If no layer is provided
     * merge all checked layer ids into one string
     * @param property - layer property
     * @returns
     */
    createBasemapName(layerOrLayers, property) {
        let baseName = '';
        if (Array.isArray(layerOrLayers)) {
            for (const layer of layerOrLayers) {
                if (layer.checked) {
                    baseName = layer[property];
                    break;
                }
                else {
                    if (layer.Layer) {
                        baseName = baseName.concat(this.createBasemapName(layer.Layer, property));
                    }
                }
            }
        }
        else {
            baseName = layerOrLayers[property];
        }
        return baseName;
    }
    /**
     * @param service -
     */
    getSublayerNames(service) {
        if (service.Layer) {
            return service.Layer.map((l) => {
                let tmp = [];
                if (l.Name) {
                    tmp.push(l.Name);
                }
                if (l.Layer) {
                    const children = this.getSublayerNames(l);
                    tmp = tmp.concat(children);
                }
                return tmp.join(',');
            });
        }
        else {
            return '';
        }
    }
}
HsAddDataCommonService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataCommonService, deps: [{ token: HsMapService }, { token: HsAddDataUrlService }, { token: HsToastService }, { token: HsAddDataService }, { token: HsDimensionService }, { token: HsEventBusService }], target: i0.ɵɵFactoryTarget.Injectable });
HsAddDataCommonService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataCommonService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataCommonService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: HsMapService }, { type: HsAddDataUrlService }, { type: HsToastService }, { type: HsAddDataService }, { type: HsDimensionService }, { type: HsEventBusService }]; } });

class HsHistoryListService {
    constructor(CookieService) {
        this.CookieService = CookieService;
        this.items = {};
    }
    readSourceHistory(forWhat) {
        if (forWhat !== undefined) {
            let sourceString = this.CookieService.get(`last${forWhat}Sources`);
            if (sourceString !== undefined) {
                this.items[forWhat] = {
                    history: [],
                };
                if (sourceString !== '') {
                    sourceString = sourceString.replace(/[\[\]\"]/gi, '');
                    const historyArray = sourceString.split(',');
                    for (const item of historyArray) {
                        this.items[forWhat].history.push(item);
                    }
                }
            }
            else {
                this.items[forWhat].history = [];
            }
            return this.items[forWhat].history;
        }
    }
    uniq(a) {
        return a.sort().filter((item, pos, ary) => {
            return !pos || item != ary[pos - 1];
        });
    }
    addSourceHistory(forWhat, url) {
        var _a, _b, _c;
        if (url === null || url === undefined) {
            return;
        }
        if (((_a = this.items[forWhat]) === null || _a === void 0 ? void 0 : _a.history) === undefined) {
            this.items[forWhat] = {
                history: [],
            };
        }
        if (!((_c = (_b = this.items[forWhat]) === null || _b === void 0 ? void 0 : _b.history) === null || _c === void 0 ? void 0 : _c.includes(url))) {
            this.items[forWhat].history.push(url);
            this.CookieService.set(`last${forWhat}Sources`, JSON.stringify(this.items[forWhat].history));
        }
    }
}
HsHistoryListService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsHistoryListService, deps: [{ token: i1$2.CookieService }], target: i0.ɵɵFactoryTarget.Injectable });
HsHistoryListService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsHistoryListService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsHistoryListService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$2.CookieService }]; } });

/**
 * Loop through list of formats returned by getcapabilities and select first available from the list of available formats
 *
 * @param formats - List of formats available for service
 * @param preferredFormats - List of preferred formats for output
 * @returns Either one of preferred formats or first available format
 */
function getPreferredFormat(formats, preferredFormats) {
    for (let i = 0; i < preferredFormats.length; i++) {
        if (formats.indexOf(preferredFormats[i]) > -1) {
            return preferredFormats[i];
        }
    }
    return formats[0];
}

class HsCapabilityCacheService {
    constructor() {
        this.cache = {};
    }
    set(url, wrap) {
        this.cache[url] = wrap;
    }
    get(url) {
        return this.cache[url];
    }
}
HsCapabilityCacheService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCapabilityCacheService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
HsCapabilityCacheService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCapabilityCacheService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCapabilityCacheService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return []; } });

class HsArcgisGetCapabilitiesService {
    constructor(httpClient, hsEventBusService, hsMapService, hsUtilsService, hsLogService, hsAddDataService, hsCapabilityCacheService) {
        this.httpClient = httpClient;
        this.hsEventBusService = hsEventBusService;
        this.hsMapService = hsMapService;
        this.hsUtilsService = hsUtilsService;
        this.hsLogService = hsLogService;
        this.hsAddDataService = hsAddDataService;
        this.hsCapabilityCacheService = hsCapabilityCacheService;
    }
    /**
     * Get WMS service location without parameters from url string
     *
     * @param str - Url string to parse
     * @returns WMS service Url
     */
    getPathFromUrl(str) {
        if (str.indexOf('?') > -1) {
            return str.substring(0, str.indexOf('?'));
        }
        else {
            return str;
        }
    }
    /**
     * Create WMS parameter string from parameter object
     * TODO: Probably the same as utils.paramsToURL
     *
     * @param obj - Object with stored WMS service parameters
     * @returns Parameter string or empty string if no object given
     */
    params2String(obj) {
        return obj
            ? Object.keys(obj)
                .map((key) => {
                const val = obj[key];
                if (Array.isArray(val)) {
                    return val
                        .map((val2) => {
                        return (encodeURIComponent(key) + '=' + encodeURIComponent(val2));
                    })
                        .join('&');
                }
                return encodeURIComponent(key) + '=' + encodeURIComponent(val);
            })
                .join('&')
            : '';
    }
    /**
     * Parse added service url and sends GetCapabilities request to WMS service
     *
     * @param service_url - Raw Url localization of service
     * @param owrCache - Overwrites cache for the requested url
     * @returns Promise object - Response to GetCapabilities request
     */
    request(service_url, app, owrCache) {
        return __awaiter(this, void 0, void 0, function* () {
            service_url = service_url.replace(/&amp;/g, '&');
            const params = this.hsUtilsService.getParamsFromUrl(service_url);
            const path = this.getPathFromUrl(service_url);
            params.f = 'json';
            let url = [path, this.params2String(params)].join('?');
            url = this.hsUtilsService.proxify(url, app);
            if (this.hsCapabilityCacheService.get(url) && !owrCache) {
                return this.hsCapabilityCacheService.get(url);
            }
            try {
                const r = yield lastValueFrom(this.httpClient
                    .get(url, {
                    responseType: 'json',
                })
                    .pipe(takeUntil(this.hsAddDataService.cancelUrlRequest)));
                const wrap = { response: r };
                this.hsCapabilityCacheService.set(url, wrap);
                return wrap;
            }
            catch (e) {
                return { response: e, error: true };
            }
        });
    }
    /**
     * Load all layers of selected service to the map
     *
     * @param caps - XML response of GetCapabilities of selected service
     * @returns List of layers from service
     */
    service2layers(caps, app) {
        const service = caps.layers;
        //onst srss = caps.spatialReference.wkid;
        const image_formats = caps.supportedImageFormatTypes.split(',');
        const query_formats = caps.supportedQueryFormats
            ? caps.supportedQueryFormats.split(',')
            : [];
        const image_format = getPreferredFormat(image_formats, [
            'image/png; mode=8bit',
            'image/png',
            'image/gif',
            'image/jpeg',
        ]);
        const query_format = getPreferredFormat(query_formats, [
            'application/vnd.esri.wms_featureinfo_xml',
            'application/vnd.ogc.gml',
            'application/vnd.ogc.wms_xml',
            'text/plain',
            'text/html',
        ]);
        const tmp = [];
        for (const subservice of service) {
            this.hsLogService.log('Load service', subservice);
            for (const layer of subservice.Layer) {
                this.hsLogService.log('Load service', this);
                let attributions = [];
                if (layer.Attribution) {
                    attributions = [
                        `<a href="${layer.Attribution.OnlineResource}">${layer.Attribution.Title}</a>`,
                    ];
                }
                const new_layer = new Tile({
                    properties: {
                        title: layer.Title.replace(/\//g, '&#47;'),
                        abstract: layer.Abstract,
                    },
                    source: new TileWMS({
                        url: caps.Capability.Request.GetMap.DCPType[0].HTTP.Get
                            .OnlineResource,
                        attributions: attributions,
                        params: {
                            LAYERS: layer.Name,
                            INFO_FORMAT: layer.queryable ? query_format : undefined,
                            FORMAT: image_format,
                            styles: layer.Style && layer.Style.length > 0
                                ? layer.Style[0].Name
                                : undefined,
                        },
                        crossOrigin: 'anonymous',
                    }),
                    useInterimTilesOnError: false,
                    extent: layer.BoundingBox,
                });
                this.hsMapService.proxifyLayerLoader(new_layer, true, app);
                tmp.push(new_layer);
            }
        }
        return tmp;
    }
}
HsArcgisGetCapabilitiesService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsArcgisGetCapabilitiesService, deps: [{ token: i1.HttpClient }, { token: HsEventBusService }, { token: HsMapService }, { token: HsUtilsService }, { token: HsLogService }, { token: HsAddDataService }, { token: HsCapabilityCacheService }], target: i0.ɵɵFactoryTarget.Injectable });
HsArcgisGetCapabilitiesService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsArcgisGetCapabilitiesService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsArcgisGetCapabilitiesService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: HsEventBusService }, { type: HsMapService }, { type: HsUtilsService }, { type: HsLogService }, { type: HsAddDataService }, { type: HsCapabilityCacheService }]; } });

/**
 * Replace Urls in text by anchor html tag with url, useful for attribution to be clickable
 *
 * @param url - String to look for Urls
 * @returns Text with added anchors
 */
function addAnchors(url) {
    if (!url) {
        return null;
    }
    const exp = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
    return url.replace(exp, "<a href='$1'>$1</a>");
}

class HsUrlArcGisParams {
    constructor() {
        this.data = {
            map_projection: '',
            register_metadata: true,
            tile_size: 512,
            use_resampling: false,
            use_tiles: true,
            table: {
                trackBy: 'id',
                nameProperty: 'name',
            },
        };
    }
}
class HsUrlArcGisService {
    constructor(hsArcgisGetCapabilitiesService, hsLayoutService, hsMapService, hsUtilsService, hsAddDataUrlService, hsAddDataCommonService, hsLayerUtilsService, hsToastService) {
        this.hsArcgisGetCapabilitiesService = hsArcgisGetCapabilitiesService;
        this.hsLayoutService = hsLayoutService;
        this.hsMapService = hsMapService;
        this.hsUtilsService = hsUtilsService;
        this.hsAddDataUrlService = hsAddDataUrlService;
        this.hsAddDataCommonService = hsAddDataCommonService;
        this.hsLayerUtilsService = hsLayerUtilsService;
        this.hsToastService = hsToastService;
        this.apps = { default: new HsUrlArcGisParams() };
    }
    get(app) {
        if (this.apps[app !== null && app !== void 0 ? app : 'default'] == undefined) {
            this.apps[app !== null && app !== void 0 ? app : 'default'] = new HsUrlArcGisParams();
        }
        return this.apps[app !== null && app !== void 0 ? app : 'default'];
    }
    /**
     * List and return layers from Arcgis getCapabilities response
     * @param wrapper - Capabilities response wrapper
     */
    listLayerFromCapabilities(wrapper, app) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!wrapper.response && !wrapper.error) {
                return;
            }
            if (wrapper.error) {
                this.hsAddDataCommonService.throwParsingError(wrapper.response.message, app);
                return;
            }
            try {
                yield this.createLayer(wrapper.response, app);
                if (this.hsAddDataCommonService.get(app).layerToSelect) {
                    this.hsAddDataCommonService.checkTheSelectedLayer(this.get(app).data.layers, 'arcgis', app);
                    return this.getLayers(app);
                }
            }
            catch (e) {
                this.hsAddDataCommonService.throwParsingError(e, app);
            }
        });
    }
    /**
     * Parse information received in Arcgis getCapabilities response
     * @param response - getCapabilities response
     */
    createLayer(response, app) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const appRef = this.get(app);
                const caps = response;
                appRef.data.map_projection = this.hsMapService
                    .getMap(app)
                    .getView()
                    .getProjection()
                    .getCode()
                    .toUpperCase();
                appRef.data.title =
                    ((_a = caps.documentInfo) === null || _a === void 0 ? void 0 : _a.Title) || caps.mapName || caps.name || 'Arcgis layer';
                appRef.data.description = addAnchors(caps.description);
                appRef.data.version = caps.currentVersion;
                appRef.data.image_formats = caps.supportedImageFormatTypes
                    ? caps.supportedImageFormatTypes.split(',')
                    : [];
                appRef.data.query_formats = caps.supportedQueryFormats
                    ? caps.supportedQueryFormats.split(',')
                    : [];
                appRef.data.srss = ((_b = caps.spatialReference) === null || _b === void 0 ? void 0 : _b.latestWkid)
                    ? [caps.spatialReference.latestWkid.toString()]
                    : [];
                appRef.data.services = (_c = caps.services) === null || _c === void 0 ? void 0 : _c.filter((s) => !this.isGpService(s.type));
                appRef.data.layers = caps.layers;
                this.hsAddDataUrlService.searchForChecked((_d = appRef.data.layers) !== null && _d !== void 0 ? _d : appRef.data.services, app);
                appRef.data.srs = (() => {
                    for (const srs of appRef.data.srss) {
                        if (srs.includes('3857')) {
                            return srs;
                        }
                    }
                    return appRef.data.srss[0];
                })();
                appRef.data.extent = caps.fullExtent;
                appRef.data.resample_warning = this.hsAddDataCommonService.srsChanged(appRef.data.srs, app);
                appRef.data.image_format = getPreferredFormat(appRef.data.image_formats, [
                    'PNG32',
                    'PNG',
                    'GIF',
                    'JPG',
                ]);
                appRef.data.query_format = getPreferredFormat(appRef.data.query_formats, [
                    'geoJSON',
                    'JSON',
                ]);
                this.hsAddDataCommonService.get(app).loadingInfo = false;
            }
            catch (e) {
                throw new Error(e);
            }
        });
    }
    /**
     * Loop through the list of layers and call getLayer
     */
    getLayers(app) {
        var _a;
        const appRef = this.get(app);
        if (appRef.data.layers === undefined &&
            appRef.data.services === undefined &&
            !this.isImageService(app)) {
            return;
        }
        const checkedLayers = (_a = appRef.data.layers) === null || _a === void 0 ? void 0 : _a.filter((l) => l.checked);
        const collection = [
            this.getLayer(checkedLayers, {
                layerTitle: appRef.data.title.replace(/\//g, '&#47;'),
                path: this.hsUtilsService.undefineEmptyString(appRef.data.folder_name),
                imageFormat: appRef.data.image_format,
                queryFormat: appRef.data.query_format,
                tileSize: appRef.data.tile_size,
                crs: appRef.data.srs,
                base: appRef.data.base,
            }, app),
        ];
        appRef.data.base = false;
        this.hsAddDataCommonService.clearParams(app);
        this.apps[app] = new HsUrlArcGisParams();
        this.hsAddDataCommonService.setPanelToCatalogue(app);
        if (collection.length > 0) {
            this.hsLayoutService.setMainPanel('layermanager', app);
        }
        return collection;
    }
    /**
     * Get selected layer
     * @param layer - capabilities layer object
     * @param layerTitle - layer name in the map
     * @param path - Path name
     * @param imageFormat - Format in which to serve image. Usually: image/png
     * @param queryFormat - See info_format in https://docs.geoserver.org/stable/en/user/services/wms/reference.html
     * @param tileSize - Tile size in pixels
     * @param crs - of the layer
     * @param subLayers - Static sub-layers of the layer
     */
    getLayer(layers, options, app) {
        const appRef = this.get(app);
        const attributions = [];
        const dimensions = {};
        //Not being used right now
        // const legends = [];
        const sourceParams = {
            url: appRef.data.get_map_url,
            attributions,
            //projection: me.data.srs,
            params: Object.assign({
                FORMAT: options.imageFormat,
            }, {}),
            crossOrigin: 'anonymous',
        };
        if (!this.isImageService(app)) {
            const LAYERS = layers.length > 0
                ? `show:${layers.map((l) => l.id).join(',')}`
                : undefined;
            Object.assign(sourceParams.params, { LAYERS });
        }
        const source = appRef.data.use_tiles
            ? new TileArcGISRest(sourceParams)
            : new ImageArcGISRest(sourceParams);
        let mapExtent;
        try {
            mapExtent = transformExtent([
                appRef.data.extent.xmin,
                appRef.data.extent.ymin,
                appRef.data.extent.xmax,
                appRef.data.extent.ymax,
            ], 'EPSG:' + appRef.data.srs, appRef.data.map_projection);
        }
        catch (error) {
            this.hsToastService.createToastPopupMessage('ADDLAYERS.capabilitiesParsingProblem', 'ADDLAYERS.OlDoesNotRecognizeProjection', {
                serviceCalledFrom: 'HsUrlArcGisService',
                details: [`${options.layerTitle}`, `EPSG: ${appRef.data.srs}`],
            }, app);
        }
        const layerParams = {
            properties: {
                title: options.layerTitle,
                name: options.layerTitle,
                removable: true,
                path: options.path,
                base: appRef.data.base,
                extent: mapExtent,
                dimensions,
            },
            source,
        };
        if (!this.isImageService(app)) {
            Object.assign(layerParams.properties, {
                subLayers: layers === null || layers === void 0 ? void 0 : layers.map((l) => l.id).join(','),
            });
        }
        const new_layer = appRef.data.use_tiles
            ? new Tile(layerParams)
            : new ImageLayer(layerParams);
        //OlMap.proxifyLayerLoader(new_layer, me.data.use_tiles);
        return new_layer;
    }
    /**
     * Loop through the list of layers and add them to the map
     * @param layers - Layers selected
     */
    addLayers(layers, app) {
        for (const l of layers) {
            this.hsMapService.getMap(app).addLayer(l);
        }
    }
    /**
     * Request services layers
     * @param service - Service URL
     */
    expandService(service, app) {
        return __awaiter(this, void 0, void 0, function* () {
            const appRef = this.get(app);
            let urlRest = this.hsAddDataCommonService.get(app).url.toLowerCase();
            //There are cases when loaded services are loaded from folders, problem is that folder name is also included inside the service.name
            //to avoid any uncertainties, lets remove everything starting from 'services' inside the url and rebuild it
            if (urlRest.includes('services')) {
                urlRest = urlRest.slice(0, urlRest.indexOf('services'));
            }
            appRef.data.get_map_url =
                (urlRest.endsWith('/') ? urlRest : urlRest.concat('/')) +
                    ['services', service.name, service.type].join('/');
            const wrapper = yield this.hsArcgisGetCapabilitiesService.request(appRef.data.get_map_url, app);
            yield this.listLayerFromCapabilities(wrapper, app);
        });
    }
    /**
     * Add services layers
     * @param services - Services selected
     */
    addServices(services, app) {
        return __awaiter(this, void 0, void 0, function* () {
            const originalRestUrl = this.hsAddDataCommonService.get(app).url;
            for (const service of services.filter((s) => s.checked)) {
                this.hsAddDataCommonService.get(app).url = originalRestUrl; //Because getLayers clears all params
                yield this.expandService(service, app);
                const layers = this.getLayers(app);
                this.addLayers(layers, app);
            }
        });
    }
    /**
     * Check if getCapabilities response is Image service layer
     */
    isImageService(app) {
        var _a;
        return (_a = this.get(app)
            .data.get_map_url) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes('imageserver');
    }
    /**
     * Check if getCapabilities response is Gp service layer
     */
    isGpService(str) {
        return str.toLowerCase().includes('gpserver');
    }
}
HsUrlArcGisService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUrlArcGisService, deps: [{ token: HsArcgisGetCapabilitiesService }, { token: HsLayoutService }, { token: HsMapService }, { token: HsUtilsService }, { token: HsAddDataUrlService }, { token: HsAddDataCommonService }, { token: HsLayerUtilsService }, { token: HsToastService }], target: i0.ɵɵFactoryTarget.Injectable });
HsUrlArcGisService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUrlArcGisService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUrlArcGisService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: HsArcgisGetCapabilitiesService }, { type: HsLayoutService }, { type: HsMapService }, { type: HsUtilsService }, { type: HsAddDataUrlService }, { type: HsAddDataCommonService }, { type: HsLayerUtilsService }, { type: HsToastService }]; } });

/**
 * Provides a source of features from WFS endpoint
 */
class WfsSource extends Vector {
    constructor(hsUtilsService, http, { data_version, output_format, crs, provided_url, layer_name, map_projection, }, app) {
        super({
            loader: function (extent, resolution, projection) {
                return __awaiter(this, void 0, void 0, function* () {
                    if (typeof data_version == 'undefined') {
                        data_version = '1.0.0';
                    }
                    if (typeof output_format == 'undefined') {
                        output_format = data_version == '1.0.0' ? 'GML2' : 'GML3';
                    }
                    const srs = crs.toUpperCase();
                    extent = transformExtent(extent, projection.getCode(), srs);
                    if (srs.includes('4326') || srs.includes('4258')) {
                        extent = [extent[1], extent[0], extent[3], extent[2]];
                    }
                    const params = {
                        service: 'wfs',
                        version: data_version,
                        request: 'GetFeature',
                        srsName: srs,
                        output_format: output_format,
                        // count: layer.limitFeatureCount ? 1000 : '',
                        BBOX: extent.join(',') + ',' + srs,
                    };
                    params[data_version.startsWith('1') ? 'typeName' : 'typeNames'] =
                        layer_name;
                    let url = [
                        provided_url,
                        hsUtilsService.paramsToURLWoEncode(params),
                    ].join('?');
                    url = hsUtilsService.proxify(url, app);
                    const response = yield lastValueFrom(http.get(url, { responseType: 'text' }));
                    if (response) {
                        const features = readFeatures(response, map_projection, data_version, srs);
                        this.addFeatures(features);
                    }
                });
            },
            strategy: bbox,
        });
    }
}
function readFeatures(doc, map_projection, data_version, srs) {
    const wfs = new WFS({ version: data_version });
    const features = wfs.readFeatures(doc, {
        dataProjection: srs,
        featureProjection: map_projection.getCode() == srs ? '' : map_projection,
    });
    return features;
}

class HsWfsGetCapabilitiesService {
    constructor(httpClient, hsEventBusService, hsMapService, hsUtilsService, hsAddDataService, hsCapabilityCacheService) {
        this.httpClient = httpClient;
        this.hsEventBusService = hsEventBusService;
        this.hsMapService = hsMapService;
        this.hsUtilsService = hsUtilsService;
        this.hsAddDataService = hsAddDataService;
        this.hsCapabilityCacheService = hsCapabilityCacheService;
    }
    /**
     * Get WFS service location without parameters from url string
     *
     * @param str - Url string to parse
     * @returns WFS service Url without params
     */
    getPathFromUrl(str) {
        if (str.indexOf('?') > -1) {
            return str.substring(0, str.indexOf('?'));
        }
        else {
            return str;
        }
    }
    /**
     * Create WFS parameter string from parameter object
     * TODO: Probably the same as utils.paramsToURL
     *
     * @param obj - Object with stored WFS service parameters
     * @returns Parameter string or empty string if no object given
     */
    params2String(obj) {
        return obj
            ? Object.keys(obj)
                .map((key) => {
                const val = obj[key];
                if (Array.isArray(val)) {
                    return val
                        .map((val2) => {
                        return (encodeURIComponent(key) + '=' + encodeURIComponent(val2));
                    })
                        .join('&');
                }
                return encodeURIComponent(key) + '=' + encodeURIComponent(val);
            })
                .join('&')
            : '';
    }
    /**
     * Parse added service url and sends request GetCapabilities to WFS service
     *
     * @param service_url - Raw Url localization of service
     * @param owrCache - Overwrites cache for the requested url
     * @returns Promise object - Response to GetCapabilities request
     */
    request(service_url, app, owrCache) {
        return __awaiter(this, void 0, void 0, function* () {
            service_url = service_url.replace(/&amp;/g, '&');
            this.service_url = service_url;
            const params = this.hsUtilsService.getParamsFromUrl(service_url);
            const path = this.getPathFromUrl(service_url);
            if (params.request == undefined && params.REQUEST == undefined) {
                params.request = 'GetCapabilities';
            }
            else if (params.request !== undefined) {
                params.request = 'GetCapabilities';
            }
            else if (params.REQUEST !== undefined) {
                params.REQUEST = 'GetCapabilities';
            }
            if (params.service == undefined && params.SERVICE == undefined) {
                params.service = 'WFS';
            }
            if (params.version == undefined && params.VERSION == undefined) {
                params.version = '1.1.0';
            }
            let url = [path, this.params2String(params)].join('?');
            url = this.hsUtilsService.proxify(url, app);
            if (this.hsCapabilityCacheService.get(url) && !owrCache) {
                return this.hsCapabilityCacheService.get(url);
            }
            try {
                const r = yield lastValueFrom(this.httpClient
                    .get(url, {
                    responseType: 'text',
                })
                    .pipe(takeUntil(this.hsAddDataService.cancelUrlRequest)));
                const wrap = { response: r };
                this.hsCapabilityCacheService.set(url, wrap);
                return wrap;
            }
            catch (e) {
                return { response: e, error: true };
            }
        });
    }
}
HsWfsGetCapabilitiesService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsWfsGetCapabilitiesService, deps: [{ token: i1.HttpClient }, { token: HsEventBusService }, { token: HsMapService }, { token: HsUtilsService }, { token: HsAddDataService }, { token: HsCapabilityCacheService }], target: i0.ɵɵFactoryTarget.Injectable });
HsWfsGetCapabilitiesService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsWfsGetCapabilitiesService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsWfsGetCapabilitiesService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: HsEventBusService }, { type: HsMapService }, { type: HsUtilsService }, { type: HsAddDataService }, { type: HsCapabilityCacheService }]; } });

class HsUrlWfsParams {
    constructor() {
        this.data = {
            add_all: null,
            bbox: null,
            folder_name: 'WFS',
            layers: [],
            map_projection: undefined,
            output_format: '',
            output_formats: null,
            services: [],
            srs: null,
            srss: [],
            title: '',
            version: '',
            table: {
                trackBy: 'Name',
                nameProperty: 'Title',
            },
        };
        this.definedProjections = [
            'EPSG:3857',
            'EPSG:5514',
            'EPSG:4258',
            'EPSG:4326',
        ];
    }
}
class HsUrlWfsService {
    constructor(http, hsUtilsService, hsWfsGetCapabilitiesService, hsMapService, hsEventBusService, hsLayoutService, hsAddDataCommonService) {
        this.http = http;
        this.hsUtilsService = hsUtilsService;
        this.hsWfsGetCapabilitiesService = hsWfsGetCapabilitiesService;
        this.hsMapService = hsMapService;
        this.hsEventBusService = hsEventBusService;
        this.hsLayoutService = hsLayoutService;
        this.hsAddDataCommonService = hsAddDataCommonService;
        this.apps = { default: new HsUrlWfsParams() };
        this.hsEventBusService.olMapLoads.subscribe(({ map, app }) => {
            this.get(app).data.map_projection = this.hsMapService
                .getMap(app)
                .getView()
                .getProjection()
                .getCode()
                .toUpperCase();
        });
    }
    get(app) {
        if (this.apps[app !== null && app !== void 0 ? app : 'default'] == undefined) {
            this.apps[app !== null && app !== void 0 ? app : 'default'] = new HsUrlWfsParams();
        }
        return this.apps[app !== null && app !== void 0 ? app : 'default'];
    }
    /**
     * List and return layers from WFS getCapabilities response
     * @param wrapper - Capabilities response wrapper
     */
    listLayerFromCapabilities(wrapper, app, style) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!wrapper.response && !wrapper.error) {
                return;
            }
            if (wrapper.error) {
                this.hsAddDataCommonService.throwParsingError(wrapper.response.message, app);
                return;
            }
            try {
                const bbox = yield this.parseCapabilities(wrapper.response, app);
                if (this.hsAddDataCommonService.get(app).layerToSelect) {
                    this.hsAddDataCommonService.checkTheSelectedLayer(this.get(app).data.layers, 'wfs', app);
                    const collection = this.getLayers(app, true, false, style);
                    this.zoomToBBox(bbox, app);
                    return collection;
                }
            }
            catch (e) {
                this.hsAddDataCommonService.throwParsingError(e, app);
            }
        });
    }
    /**
     * Parse information received in WFS getCapabilities response
     * @param response - A stringified XML response to getCapabilities request
     */
    parseCapabilities(response, app) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const appRef = this.get(app);
                appRef.loadingFeatures = false;
                let caps = xml2Json.xml2js(response, { compact: true });
                if (caps['wfs:WFS_Capabilities']) {
                    caps = caps['wfs:WFS_Capabilities'];
                }
                else {
                    caps = caps['WFS_Capabilities'];
                }
                this.parseWFSJson(caps);
                appRef.data.title = caps.ServiceIdentification.Title || 'Wfs layer';
                // this.description = addAnchors(caps.ServiceIdentification.Abstract);
                appRef.data.version = caps.ServiceIdentification.ServiceTypeVersion;
                const layer = Array.isArray(caps.FeatureTypeList.FeatureType)
                    ? caps.FeatureTypeList.FeatureType.find((layer) => layer.Name == this.hsAddDataCommonService.get(app).layerToSelect)
                    : caps.FeatureTypeList.FeatureType;
                appRef.data.layers = Array.isArray(caps.FeatureTypeList.FeatureType)
                    ? caps.FeatureTypeList.FeatureType
                    : [caps.FeatureTypeList.FeatureType];
                if (layer) {
                    appRef.data.bbox =
                        layer.WGS84BoundingBox || layer.OutputFormats.WGS84BoundingBox;
                    const srsType = layer && layer.DefaultSRS ? 'SRS' : 'CRS';
                    if (layer['Default' + srsType] !== undefined) {
                        appRef.data.srss = [layer['Default' + srsType]];
                    }
                    else {
                        appRef.data.srss = [];
                        appRef.data.srss.push('EPSG:4326');
                    }
                    const otherSRS = layer['Other' + srsType];
                    if (otherSRS) {
                        if (typeof otherSRS == 'string') {
                            appRef.data.srss.push(otherSRS);
                        }
                        else {
                            for (const srs of layer['Other' + srsType]) {
                                appRef.data.srss.push(srs);
                            }
                        }
                    }
                    if (appRef.data.srss[0] === undefined) {
                        appRef.data.srss = [
                            caps.FeatureTypeList.FeatureType[0]['Default' + srsType],
                        ];
                        for (const srs of caps.FeatureTypeList.FeatureType[0]['Other' + srsType]) {
                            appRef.data.srss.push(srs);
                        }
                    }
                }
                appRef.data.output_format = this.getPreferredFormat(appRef.data.version);
                appRef.data.srss = this.parseEPSG(appRef.data.srss, app);
                if (appRef.data.srss.length == 0) {
                    appRef.data.srss = ['EPSG:3857'];
                }
                appRef.data.srs = (() => {
                    for (const srs of appRef.data.srss) {
                        if (srs.includes('3857')) {
                            return srs;
                        }
                    }
                    return appRef.data.srss[0];
                })();
                if (!this.hsAddDataCommonService.get(app).layerToSelect) {
                    setTimeout(() => {
                        try {
                            this.parseFeatureCount(app);
                        }
                        catch (e) {
                            throw new Error(e);
                        }
                    });
                }
                this.hsAddDataCommonService.get(app).loadingInfo = false;
                return appRef.data.bbox;
            }
            catch (e) {
                throw new Error(e);
            }
        });
    }
    /**
     * Get preferred GML version format
     * @param version - GML version
     */
    getPreferredFormat(version) {
        switch (version) {
            case '1.0.0':
                return 'GML2';
            case '1.1.0':
                return 'GML3';
            case '2.0.0':
                return 'GML32';
            default:
                return 'GML3';
        }
    }
    /**
     * Parse layer feature count and set feature limits
     */
    parseFeatureCount(app) {
        const appRef = this.get(app);
        for (const layer of appRef.data.layers) {
            const params = {
                service: 'wfs',
                version: appRef.data.version,
                request: 'GetFeature',
                resultType: 'hits',
            };
            params[appRef.data.version.startsWith('1') ? 'typeName' : 'typeNames'] = layer.Name;
            const url = [
                this.hsWfsGetCapabilitiesService.service_url.split('?')[0],
                this.hsUtilsService.paramsToURLWoEncode(params),
            ].join('?');
            this.http
                .get(this.hsUtilsService.proxify(url, app), { responseType: 'text' })
                .subscribe((response) => {
                const oParser = new DOMParser();
                const oDOM = oParser.parseFromString(response, 'application/xml');
                const doc = oDOM.documentElement;
                layer.featureCount = doc.getAttribute('numberOfFeatures');
                //WFS 2.0.0
                if (layer.featureCount == 0 || !layer.featureCount) {
                    layer.featureCount = doc.getAttribute('numberMatched');
                }
                layer.featureCount > 1000
                    ? (layer.limitFeatureCount = true)
                    : (layer.limitFeatureCount = false);
            }, (e) => {
                this.hsAddDataCommonService.throwParsingError(e, app);
            });
        }
    }
    /**
     * Parse WFS json file
     * @param json - JSON file
     */
    parseWFSJson(json) {
        try {
            for (const key of Object.keys(json)) {
                if (key.includes(':')) {
                    json[key.substring(4)] = json[key];
                    if (typeof json[key.substring(4)] == 'object') {
                        this.parseWFSJson(json[key]);
                    }
                    if (json[key.substring(4)] && json[key.substring(4)]['_text']) {
                        json[key.substring(4)] = json[key.substring(4)]['_text'];
                    }
                    delete json[key];
                }
                if (typeof json[key] == 'object') {
                    this.parseWFSJson(json[key]);
                    if (json[key] && json[key]['_text']) {
                        json[key] = json[key]['_text'];
                    }
                }
            }
        }
        catch (e) {
            throw new Error(e);
        }
    }
    /**
     * Parse EPSG in usable formats
     * @param srss -
     */
    parseEPSG(srss, app) {
        srss.forEach((srs, index) => {
            const epsgCode = srs.slice(-4);
            srss[index] = 'EPSG:' + epsgCode;
            if (!get(srss[index])) {
                srss.splice(srss.indexOf(index), 1);
            }
        });
        return [...Array.from(new Set(srss))].filter((srs) => this.get(app).definedProjections.includes(srs));
    }
    /**
     * Loop through the list of layers and call getLayer
     * @param checkedOnly - Add all available layers or only checked ones. Checked=false=all
     * @param shallow - Wether to go through full depth of layer tree or to stop on first queriable
     */
    getLayers(app, checkedOnly, shallow = false, style) {
        const appRef = this.get(app);
        appRef.data.add_all = checkedOnly;
        const collection = [];
        for (const layer of appRef.data.layers) {
            this.getLayersRecursively(layer, { style }, collection, app);
        }
        this.hsAddDataCommonService.clearParams(app);
        this.apps[app] = new HsUrlWfsParams();
        this.hsAddDataCommonService.setPanelToCatalogue(app);
        return collection;
    }
    /**
     * Loop through the list of layers and call getLayer recursively
     * @param layer - Layer selected
     * @param options - Add layers recursively options
     * (checkedOnly?: boolean; style?: string;)
     * @param collection - Layers created and retreived collection
     */
    getLayersRecursively(layer, options, collection, app) {
        var _a, _b;
        const appRef = this.get(app);
        if (!appRef.data.add_all || layer.checked) {
            const newLayer = this.getLayer(layer, {
                layerName: layer.Name,
                folder: this.hsUtilsService.undefineEmptyString(appRef.data.folder_name),
                crs: appRef.data.srs,
                sld: ((_a = options.style) === null || _a === void 0 ? void 0 : _a.includes('StyledLayerDescriptor'))
                    ? options.style
                    : undefined,
                qml: ((_b = options.style) === null || _b === void 0 ? void 0 : _b.includes('qgis')) ? options.style : undefined,
            }, app);
            collection.push(newLayer);
        }
        if (layer.Layer) {
            for (const sublayer of layer.Layer) {
                this.getLayersRecursively(sublayer, { style: options.style }, collection, app);
            }
        }
    }
    /**
     * Get selected layer
     * @param layer - capabilities layer object
     * @param layerName - layer name in the map
     * @param folder - name
     * @param srs - of the layer
     */
    getLayer(layer, options, app) {
        const appRef = this.get(app);
        const new_layer = new VectorLayer({
            properties: {
                name: options.layerName,
                title: layer.Title.replace(/\//g, '&#47;'),
                path: options.folder,
                removable: true,
                sld: options.sld,
                qml: options.qml,
                wfsUrl: this.hsWfsGetCapabilitiesService.service_url.split('?')[0],
            },
            source: new WfsSource(this.hsUtilsService, this.http, {
                data_version: appRef.data.version,
                output_format: appRef.data.output_format,
                crs: options.crs,
                provided_url: this.hsWfsGetCapabilitiesService.service_url.split('?')[0],
                layer_name: options.layerName,
                map_projection: this.hsMapService
                    .getMap(app)
                    .getView()
                    .getProjection(),
            }, app),
            renderOrder: null,
            //Used to determine whether its URL WFS service when saving to compositions
        });
        return new_layer;
    }
    /**
     * Loop through the list of layers and add them to the map
     */
    addLayers(layers, app) {
        for (const l of layers) {
            this.hsMapService.getMap(app).addLayer(l);
        }
        this.hsLayoutService.setMainPanel('layermanager', app);
    }
    zoomToBBox(bbox, app) {
        const appRef = this.get(app);
        if (!bbox) {
            return;
        }
        if (bbox.LowerCorner) {
            bbox = [
                bbox.LowerCorner.split(' ')[0],
                bbox.LowerCorner.split(' ')[1],
                bbox.UpperCorner.split(' ')[0],
                bbox.UpperCorner.split(' ')[1],
            ];
        }
        if (!appRef.data.map_projection) {
            appRef.data.map_projection = this.hsMapService
                .getMap(app)
                .getView()
                .getProjection()
                .getCode()
                .toUpperCase();
        }
        const extent = transformExtent(bbox, 'EPSG:4326', appRef.data.map_projection);
        if (extent) {
            this.hsMapService.fitExtent(extent, app);
        }
    }
}
HsUrlWfsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUrlWfsService, deps: [{ token: i1.HttpClient }, { token: HsUtilsService }, { token: HsWfsGetCapabilitiesService }, { token: HsMapService }, { token: HsEventBusService }, { token: HsLayoutService }, { token: HsAddDataCommonService }], target: i0.ɵɵFactoryTarget.Injectable });
HsUrlWfsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUrlWfsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUrlWfsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: HsUtilsService }, { type: HsWfsGetCapabilitiesService }, { type: HsMapService }, { type: HsEventBusService }, { type: HsLayoutService }, { type: HsAddDataCommonService }]; } });

class HsWmsGetCapabilitiesService {
    constructor(httpClient, hsEventBusService, hsMapService, hsUtilsService, hsCommonEndpointsService, hsAddDataService, hsCapabilityCacheService) {
        this.httpClient = httpClient;
        this.hsEventBusService = hsEventBusService;
        this.hsMapService = hsMapService;
        this.hsUtilsService = hsUtilsService;
        this.hsCommonEndpointsService = hsCommonEndpointsService;
        this.hsAddDataService = hsAddDataService;
        this.hsCapabilityCacheService = hsCapabilityCacheService;
    }
    /**
     * Get WMS service location without parameters from url string
     *
     * @param str Url string to parse
     * @returns WMS service Url
     */
    getPathFromUrl(str) {
        if (str.indexOf('?') > -1) {
            return str.substring(0, str.indexOf('?'));
        }
        else {
            return str;
        }
    }
    /**
     * Create WMS parameter string from parameter object
     * TODO: Probably the same as utils.paramsToURL
     *
     * @param obj Object with stored WMS service parameters
     * @returns Parameter string or empty string if no object given
     */
    params2String(obj) {
        return obj
            ? Object.keys(obj)
                .map((key) => {
                const val = obj[key];
                if (Array.isArray(val)) {
                    return val
                        .map((val2) => {
                        return (encodeURIComponent(key) + '=' + encodeURIComponent(val2));
                    })
                        .join('&');
                }
                return encodeURIComponent(key) + '=' + encodeURIComponent(val);
            })
                .join('&')
            : '';
    }
    /**
     * Parse added service url and sends GetCapabilities request to WMS service
     *
     * @param service_url - Raw Url localization of service
     * @param owrCache - Overwrites cache for the requested url
     * @returns Promise object - Response to GetCapabilities request
     */
    request(service_url, app, owrCache) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            service_url = service_url.replace(/&amp;/g, '&');
            const params = this.hsUtilsService.getParamsFromUrl(service_url);
            const path = this.getPathFromUrl(service_url);
            if (params.request === undefined && params.REQUEST === undefined) {
                params.request = 'GetCapabilities';
            }
            else if (params.request !== undefined) {
                params.request = 'GetCapabilities';
            }
            else if (params.REQUEST !== undefined) {
                params.REQUEST = 'GetCapabilities';
            }
            if (params.service === undefined && params.SERVICE === undefined) {
                params.service = 'WMS';
            }
            if (params.version === undefined && params.VERSION === undefined) {
                params.version = '1.3.0';
            }
            let url = [path, this.params2String(params)].join('?');
            url = this.hsUtilsService.proxify(url, app);
            if (this.hsCapabilityCacheService.get(url) && !owrCache) {
                return this.hsCapabilityCacheService.get(url);
            }
            try {
                const r = yield lastValueFrom(this.httpClient
                    .get(url, {
                    responseType: 'text',
                    withCredentials: url.includes((_b = (_a = this.hsCommonEndpointsService) === null || _a === void 0 ? void 0 : _a.endpoints.filter((ep) => ep.type == 'layman')[0]) === null || _b === void 0 ? void 0 : _b.url),
                })
                    .pipe(takeUntil(this.hsAddDataService.cancelUrlRequest)));
                const wrap = { response: r };
                this.hsCapabilityCacheService.set(url, wrap);
                return wrap;
            }
            catch (e) {
                return {
                    response: e,
                    error: true,
                };
            }
        });
    }
    /**
     * Load all layers of selected service to the map
     *
     * @param capabilitiesXml - XML response of GetCapabilities of selected service
     * @returns List of layers from service
     */
    service2layers(capabilitiesXml, app, path) {
        const parser = new WMSCapabilities();
        const caps = parser.read(capabilitiesXml);
        let service = caps.Capability.Layer;
        if (service.length === undefined && service.Layer != undefined) {
            service = [service];
        }
        //const srss = caps.Capability.Layer.CRS;
        const imageFormats = caps.Capability.Request.GetMap.Format;
        const queryFormats = caps.Capability.Request.GetFeatureInfo
            ? caps.Capability.Request.GetFeatureInfo.Format
            : [];
        const image_format = getPreferredFormat(imageFormats, [
            'image/png; mode=8bit',
            'image/png',
            'image/gif',
            'image/jpeg',
        ]);
        const query_format = getPreferredFormat(queryFormats, [
            'application/vnd.esri.wms_featureinfo_xml',
            'application/vnd.ogc.gml',
            'application/vnd.ogc.wms_xml',
            'text/plain',
            'text/html',
        ]);
        const tmp = [];
        service.forEach((service) => {
            service.Layer.forEach((layer) => {
                let attributions = [];
                if (layer.Attribution) {
                    attributions = [
                        `<a href="${layer.Attribution.OnlineResource}">${layer.Attribution.Title}</a>`,
                    ];
                }
                const metadata = this.getMetadataObjectWithUrls(layer);
                const new_layer = new Tile({
                    properties: {
                        title: layer.Title.replace(/\//g, '&#47;'),
                        name: layer.Name.replace(/\//g, '&#47;'),
                        path,
                        abstract: layer.Abstract,
                        metadata,
                    },
                    source: new TileWMS({
                        url: caps.Capability.Request.GetMap.DCPType[0].HTTP.Get
                            .OnlineResource,
                        attributions: attributions,
                        params: {
                            LAYERS: layer.Name,
                            INFO_FORMAT: layer.queryable ? query_format : undefined,
                            FORMAT: image_format,
                            styles: layer.Style && layer.Style.length > 0
                                ? layer.Style[0].Name
                                : undefined,
                        },
                        crossOrigin: 'anonymous',
                    }),
                    useInterimTilesOnError: false,
                    extent: layer.BoundingBox,
                });
                this.hsMapService.proxifyLayerLoader(new_layer, true, app);
                tmp.push(new_layer);
            });
        });
        return tmp;
    }
    getMetadataObjectWithUrls(layer) {
        if (layer.MetadataURL) {
            const metadata = {
                urls: layer.MetadataURL.map((url) => {
                    return {
                        type: url.type,
                        format: url.Format,
                        onlineResource: url.OnlineResource,
                    };
                }),
            };
            return metadata;
        }
    }
}
HsWmsGetCapabilitiesService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsWmsGetCapabilitiesService, deps: [{ token: i1.HttpClient }, { token: HsEventBusService }, { token: HsMapService }, { token: HsUtilsService }, { token: HsCommonEndpointsService }, { token: HsAddDataService }, { token: HsCapabilityCacheService }], target: i0.ɵɵFactoryTarget.Injectable });
HsWmsGetCapabilitiesService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsWmsGetCapabilitiesService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsWmsGetCapabilitiesService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: HsEventBusService }, { type: HsMapService }, { type: HsUtilsService }, { type: HsCommonEndpointsService }, { type: HsAddDataService }, { type: HsCapabilityCacheService }]; } });

class HsUrlWmsParams {
    constructor() {
        this.data = {
            add_under: null,
            map_projection: '',
            register_metadata: true,
            tile_size: 512,
            use_resampling: false,
            use_tiles: true,
            visible: true,
            table: {
                trackBy: 'Name',
                nameProperty: 'Title',
            },
        };
    }
}
class HsUrlWmsService {
    constructor(hsMapService, hsWmsGetCapabilitiesService, hsDimensionService, hsLayoutService, hsUtilsService, hsConfig, hsAddDataService, hsEventBusService, hsAddDataUrlService, hsAddDataCommonService, HsLayerUtilsService) {
        this.hsMapService = hsMapService;
        this.hsWmsGetCapabilitiesService = hsWmsGetCapabilitiesService;
        this.hsDimensionService = hsDimensionService;
        this.hsLayoutService = hsLayoutService;
        this.hsUtilsService = hsUtilsService;
        this.hsConfig = hsConfig;
        this.hsAddDataService = hsAddDataService;
        this.hsEventBusService = hsEventBusService;
        this.hsAddDataUrlService = hsAddDataUrlService;
        this.hsAddDataCommonService = hsAddDataCommonService;
        this.HsLayerUtilsService = HsLayerUtilsService;
        this.apps = { default: new HsUrlWmsParams() };
        this.hsEventBusService.olMapLoads.subscribe(({ map, app }) => {
            this.get(app).data.map_projection = this.hsMapService
                .getMap(app)
                .getView()
                .getProjection()
                .getCode()
                .toUpperCase();
        });
    }
    get(app) {
        if (this.apps[app !== null && app !== void 0 ? app : 'default'] === undefined) {
            this.apps[app !== null && app !== void 0 ? app : 'default'] = new HsUrlWmsParams();
        }
        return this.apps[app !== null && app !== void 0 ? app : 'default'];
    }
    /**
     * List and return layers from WMS getCapabilities response
     * @param wrapper - Capabilities response wrapper
     */
    listLayerFromCapabilities(wrapper, app) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!wrapper.response && !wrapper.error) {
                return;
            }
            if (wrapper.error) {
                this.hsAddDataCommonService.throwParsingError(wrapper.response.message, app);
                return;
            }
            try {
                yield this.capabilitiesReceived(wrapper.response, this.hsAddDataCommonService.get(app).layerToSelect, app);
                if (this.hsAddDataCommonService.get(app).layerToSelect) {
                    this.hsAddDataCommonService.checkTheSelectedLayer(this.get(app).data.layers, 'wms', app);
                    return this.getLayers(app, true);
                }
            }
            catch (e) {
                this.hsAddDataCommonService.throwParsingError(e, app);
            }
        });
    }
    /**
     * Expands all sibling cells belonging to the same row after overflown cell is clicked
     */
    expandTableRow(e) {
        const action = e.target.className.includes('hs-wms-expandedRow')
            ? 'remove'
            : 'add';
        if (this.hsUtilsService.isOverflown(e.target) || action == 'remove') {
            const selectedRow = e.target.parentElement;
            for (const el of selectedRow.children) {
                el.classList[action]('hs-wms-expandedRow');
            }
        }
    }
    /**
     * Fills list of available projections
     */
    fillProjections(caps, response, app) {
        const appRef = this.get(app);
        if (caps.Capability.Layer.CRS !== undefined) {
            appRef.data.srss = caps.Capability.Layer.CRS;
        }
        else if (caps.Capability.Layer.Layer &&
            caps.Capability.Layer.Layer.length > 0 &&
            caps.Capability.Layer.Layer[0].CRS) {
            appRef.data.srss = caps.Capability.Layer.Layer[0].CRS;
        }
        else {
            const oParser = new DOMParser();
            const oDOM = oParser.parseFromString(response, 'application/xml');
            const doc = oDOM.documentElement;
            doc.querySelectorAll('Capability>Layer CRS').forEach((srs) => {
                appRef.data.srss.push(srs.innerHTML);
            });
            /**
             * SRS is a malformed input and an error but let's be generous...
             */
            if (appRef.data.srss.length == 0) {
                doc.querySelectorAll('Capability>Layer SRS').forEach((srs) => {
                    appRef.data.srss.push(srs.innerHTML);
                });
            }
            //filter out duplicate records
            appRef.data.srss = [...new Set(appRef.data.srss)];
        }
        if (appRef.data.srss.length == 0) {
            appRef.data.srss = ['EPSG:4326'];
            this.hsAddDataCommonService.throwParsingError("No CRS found in the service's Capabilities. This is an error on the provider's site. Guessing WGS84 will be supported. This may or may not be correct.", app);
        }
    }
    /**
     * Parse information received in WMS getCapabilities response
     */
    capabilitiesReceived(response, layerToSelect, app) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const appRef = this.get(app);
                const parser = new WMSCapabilities();
                const caps = parser.read(response);
                appRef.data.map_projection = this.hsMapService
                    .getMap(app)
                    .getView()
                    .getProjection()
                    .getCode()
                    .toUpperCase();
                appRef.data.title = caps.Service.Title || 'Wms layer';
                appRef.data.description = addAnchors(caps.Service.Abstract);
                appRef.data.version = caps.Version || caps.version;
                appRef.data.image_formats = caps.Capability.Request.GetMap.Format
                    ? caps.Capability.Request.GetMap.Format
                    : [];
                appRef.data.query_formats = caps.Capability.Request.GetFeatureInfo
                    ? caps.Capability.Request.GetFeatureInfo.Format
                    : [];
                appRef.data.exceptions = caps.Capability.Exception;
                appRef.data.srss = [];
                this.fillProjections(caps, response, app);
                // //TODO: WHY?
                // if (this.data.srss.includes('CRS:84')) {
                //   this.data.srss.splice(this.data.srss.indexOf('CRS:84'), 1);
                // }
                if (this.hsAddDataCommonService.currentProjectionSupported(appRef.data.srss, app)) {
                    appRef.data.srs = appRef.data.srss.includes(this.hsMapService.getMap(app).getView().getProjection().getCode())
                        ? this.hsMapService.getMap(app).getView().getProjection().getCode()
                        : this.hsMapService
                            .getMap(app)
                            .getView()
                            .getProjection()
                            .getCode()
                            .toLowerCase();
                }
                else if (appRef.data.srss.includes('EPSG:4326')) {
                    appRef.data.srs = 'EPSG:4326';
                }
                else {
                    appRef.data.srs = appRef.data.srss[0];
                }
                appRef.data.resample_warning = this.hsAddDataCommonService.srsChanged(appRef.data.srs, app);
                appRef.data.layers = this.filterCapabilitiesLayers(caps.Capability.Layer);
                //Make sure every service has a title to be displayed in table
                for (const layer of appRef.data.layers) {
                    if (layer.Title.length == 0) {
                        layer.Title = layer.Name;
                    }
                }
                const serviceLayer = this.hsAddDataUrlService.selectLayerByName(layerToSelect, appRef.data.layers, 'Name');
                this.hsAddDataUrlService.searchForChecked(appRef.data.layers, app);
                //TODO: shalln't we move this logic after the layer is added to map?
                if (layerToSelect) {
                    appRef.data.extent = this.getLayerBBox(serviceLayer, appRef.data.srs, app);
                }
                else {
                    appRef.data.extent = this.calcAllLayersExtent(appRef.data.layers, app);
                }
                this.hsDimensionService.fillDimensionValues(caps.Capability.Layer);
                appRef.data.get_map_url = this.removePortIfProxified(caps.Capability.Request.GetMap.DCPType[0].HTTP.Get.OnlineResource, app);
                appRef.data.image_format = getPreferredFormat(appRef.data.image_formats, [
                    'image/png; mode=8bit',
                    'image/png',
                    'image/gif',
                    'image/jpeg',
                ]);
                appRef.data.query_format = getPreferredFormat(appRef.data.query_formats, [
                    'application/vnd.esri.wms_featureinfo_xml',
                    'application/vnd.ogc.gml',
                    'application/vnd.ogc.wms_xml',
                    'text/plain',
                    'text/html',
                ]);
                this.hsAddDataCommonService.get(app).loadingInfo = false;
            }
            catch (e) {
                throw new Error(e);
            }
        });
    }
    /**
     * For given array of layers (service layer definitions) it calculates a cumulative bounding box which encloses all the layers
     */
    calcAllLayersExtent(serviceLayers, app) {
        const appRef = this.get(app);
        if (!Array.isArray(serviceLayers)) {
            return this.getLayerBBox(serviceLayers, appRef.data.srs, app);
        }
        return serviceLayers
            .map((lyr) => this.getLayerBBox(lyr, appRef.data.srs, app))
            .reduce((acc, curr) => {
            //some services define layer bboxes beyond the canonical 180/90 degrees intervals, the checks are necessary then
            const [west, south, east, north] = curr;
            //minimum easting
            if (-180 <= west < acc[0]) {
                acc[0] = west;
            }
            //minimum northing
            if (-90 <= south < acc[1]) {
                acc[1] = south;
            }
            //maximum easting
            if (180 >= east > acc[2]) {
                acc[2] = east;
            }
            //maximum northing
            if (90 >= north > acc[3]) {
                acc[3] = north;
            }
            return acc;
        });
    }
    getLayerBBox(serviceLayer, crs, app) {
        //Can be called without valid serviceLayer as part of micka dataset loading pipeline
        if (!serviceLayer) {
            return;
        }
        const appRef = this.get(app);
        let boundingbox = serviceLayer.BoundingBox;
        let preferred;
        if (Array.isArray(serviceLayer.BoundingBox)) {
            preferred = boundingbox.filter((bboxInCrs) => {
                return bboxInCrs.crs == appRef.data.map_projection;
            })[0];
        }
        if (preferred) {
            boundingbox = preferred.extent;
        }
        else if (crs !== undefined) {
            if (serviceLayer.EX_GeographicBoundingBox !== undefined) {
                boundingbox = transformExtent(serviceLayer.EX_GeographicBoundingBox, 'EPSG:4326', this.hsMapService.getMap(app).getView().getProjection());
            }
        }
        else {
            if (appRef.data.map_projection != serviceLayer.crs) {
                boundingbox = serviceLayer.LatLonBoundingBox;
            }
        }
        return boundingbox; // TODO: ?? serviceLayer.BoundingBox; (is more complex, contains SRS definition etc.)
    }
    /**
     * Filters out layers without 'Name' parameter
     */
    filterCapabilitiesLayers(layers) {
        if (Array.isArray(layers)) {
            return layers;
        }
        let tmp = [];
        if (typeof layers == 'object') {
            if (layers.Layer && Array.isArray(layers.Layer)) {
                const layersWithNameParam = layers.Layer.filter((layer) => layer.Name);
                if (layersWithNameParam.length > 0) {
                    return layersWithNameParam;
                }
                for (const layer of layers.Layer) {
                    tmp.push(...this.filterCapabilitiesLayers(layer));
                }
            }
            else {
                tmp = [layers];
            }
        }
        return tmp;
    }
    /**
     * Removes extra port which is added to the getMap request when
     * GetCapabilities is queried through proxy. <GetMap><DCPType><HTTP><Get>
     * \<OnlineResource xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="http://gis.lesprojekt.cz/cgi-bin/mapserv?map=/home/maps"/\>
     * then becomes <GetMap><DCPType><HTTP><Get>
     * \<OnlineResource xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="http://gis.lesprojekt.cz:8085/cgi-bin/mapserv?map=/home/maps"/\>
     * which is wrong.
     * @param url - URL for which to remove port but only when proxified
     * with port in proxy path.
     * @returns URL without proxy services port added to it.
     */
    removePortIfProxified(url, app) {
        if (this.hsConfig.get(app).proxyPrefix === undefined) {
            return url;
        }
        const proxyPort = parseInt(this.hsUtilsService.getPortFromUrl(this.hsConfig.get(app).proxyPrefix));
        if (proxyPort > 0) {
            return url.replace(':' + proxyPort.toString(), '');
        }
        return url;
    }
    /**
     * Loop through the list of layers and call getLayer.
     * @param checkedOnly - Add all available layers or only checked ones. checkedOnly=false=all
     */
    getLayers(app, checkedOnly, shallow = false) {
        const appRef = this.get(app);
        if (appRef.data.layers === undefined) {
            return;
        }
        const collection = [];
        //Limit visible layers to 10 to not freeze accidentally
        appRef.data.visible = checkedOnly
            ? appRef.data.layers.filter((l) => l.checked === true).length <= 10
            : false;
        if (appRef.data.base) {
            const newLayer = this.getLayer({}, {
                layerName: appRef.data.title.replace(/\//g, '&#47;'),
                path: this.hsUtilsService.undefineEmptyString(appRef.data.folder_name),
                imageFormat: appRef.data.image_format,
                queryFormat: appRef.data.query_format,
                tileSize: appRef.data.tile_size,
                crs: appRef.data.srs,
                subLayers: '',
            }, app);
            collection.push(newLayer);
        }
        else {
            for (const layer of appRef.data.layers) {
                this.getLayersRecursively(layer, { checkedOnly: checkedOnly, shallow: shallow }, collection, app);
            }
            this.zoomToLayers(app);
        }
        appRef.data.base = false;
        this.hsAddDataCommonService.clearParams(app);
        this.apps[app] = new HsUrlWmsParams();
        this.hsAddDataCommonService.setPanelToCatalogue(app);
        if (collection.length > 0) {
            this.hsLayoutService.setMainPanel('layermanager', app);
        }
        return collection;
    }
    /**
     * Get selected layer
     * @param layer - capabilities layer object
     * @param layerName - layer name in the map
     * @param path - Path (folder) name
     * @param imageFormat - Format in which to serve image. Usually: image/png
     * @param queryFormat - See info_format in https://docs.geoserver.org/stable/en/user/services/wms/reference.html
     * @param tileSize - Tile size in pixels
     * @param crs - of the layer
     * @param subLayers - Static sub-layers of the layer
     */
    getLayer(layer, options, app) {
        const appRef = this.get(app);
        let attributions = [];
        if (layer.Attribution) {
            attributions = [
                `<a href="${layer.Attribution.OnlineResource}">${layer.Attribution.Title}</a>`,
            ];
        }
        const dimensions = {};
        if (layer.Dimension) {
            for (const val of layer.Dimension) {
                dimensions[val.name] = val;
            }
        }
        const { styles, legends } = this.getLayerStyles(layer);
        const sourceOptions = {
            url: appRef.data.get_map_url,
            attributions,
            projection: appRef.data.srs,
            params: Object.assign({ LAYERS: appRef.data.base
                    ? this.hsAddDataCommonService.createBasemapName(appRef.data.layers, 'Name')
                    : layer.Name, INFO_FORMAT: layer.queryable ? options.queryFormat : undefined, FORMAT: options.imageFormat, VERSION: appRef.data.version, STYLES: styles }, this.hsDimensionService.paramsFromDimensions(layer)),
            crossOrigin: 'anonymous',
        };
        const source = !appRef.data.use_tiles
            ? new ImageWMS(sourceOptions)
            : new TileWMS(sourceOptions);
        const metadata = this.hsWmsGetCapabilitiesService.getMetadataObjectWithUrls(layer);
        const layerOptions = {
            title: options.layerName,
            name: options.layerName,
            source,
            minResolution: this.HsLayerUtilsService.calculateResolutionFromScale(layer.MinScaleDenominator, app),
            maxResolution: this.HsLayerUtilsService.calculateResolutionFromScale(layer.MaxScaleDenominator, app),
            removable: true,
            abstract: layer.Abstract,
            metadata,
            extent: this.getLayerBBox(layer, options.crs, app),
            path: options.path,
            dimensions: dimensions,
            legends: legends,
            subLayers: options.subLayers,
            base: appRef.data.base,
            visible: appRef.data.visible,
        };
        const new_layer = !appRef.data.use_tiles
            ? new Image$1(layerOptions)
            : new Tile(layerOptions);
        this.hsMapService.proxifyLayerLoader(new_layer, appRef.data.use_tiles, app);
        return new_layer;
    }
    /**
     * Loop through the list of layers and add them to the map
     */
    addLayers(layers, app) {
        for (const l of layers) {
            this.hsAddDataService.addLayer(l, app, this.get(app).data.add_under);
        }
    }
    /**
     * Get selected layer styles and legends
     * @param layer - Selected layer
     */
    getLayerStyles(layer) {
        var _a;
        const legends = [];
        let styles = undefined;
        if (layer.styleSelected) {
            styles = layer.styleSelected.Name;
            if (((_a = layer.styleSelected.LegendURL) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                legends.push(layer.styleSelected.LegendURL[0].OnlineResource);
            }
        }
        else if (layer.Style && layer.Style.length > 0) {
            const firstStyle = layer.Style[0];
            styles = firstStyle.Name;
            if (firstStyle.LegendURL) {
                legends.push(firstStyle.LegendURL[0].OnlineResource);
            }
        }
        else {
            styles = '';
        }
        return { styles, legends };
    }
    /**
     * Loop through the list of layers and call getLayer recursively
     * @param layer - Layer selected. A descriptor similar to WmsLayer, but has additional properties, also specific to WFS and ArcGIS layers
     * @param options - Add layers recursively options
     * (checkedOnly?: boolean; shallow?: boolean; style?: string;)
     * @param collection - Layers created and retrieved collection
     */
    getLayersRecursively(layer, //TODO: better typing. It is a wrapper similar to WmsLayer, but has additional properties, also specific to WFS and ArcGIS layers
    options = { checkedOnly: true }, collection, app) {
        const appRef = this.get(app);
        if (!options.checkedOnly || layer.checked) {
            collection.push(this.getLayer(layer, {
                layerName: layer.Title.replace(/\//g, '&#47;'),
                path: this.hsUtilsService.undefineEmptyString(appRef.data.folder_name),
                imageFormat: appRef.data.image_format,
                queryFormat: appRef.data.query_format,
                tileSize: appRef.data.tile_size,
                crs: appRef.data.srs,
            }, app));
        }
        // When not shallow go full depth otherwise layer.Name has got to be missing (first queriable layer)
        const nextDepthAllowed = options.shallow ? !layer.Name : true;
        if (layer.Layer && nextDepthAllowed) {
            for (const sublayer of layer.Layer) {
                this.getLayersRecursively(sublayer, { checkedOnly: options.checkedOnly }, collection, app);
            }
        }
    }
    /**
     * Zoom map to one layers or combined layer list extent
     */
    zoomToLayers(app) {
        if (this.get(app).data.extent) {
            this.hsMapService.fitExtent(this.get(app).data.extent, app);
        }
    }
}
HsUrlWmsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUrlWmsService, deps: [{ token: HsMapService }, { token: HsWmsGetCapabilitiesService }, { token: HsDimensionService }, { token: HsLayoutService }, { token: HsUtilsService }, { token: HsConfig }, { token: HsAddDataService }, { token: HsEventBusService }, { token: HsAddDataUrlService }, { token: HsAddDataCommonService }, { token: HsLayerUtilsService }], target: i0.ɵɵFactoryTarget.Injectable });
HsUrlWmsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUrlWmsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUrlWmsService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: HsMapService }, { type: HsWmsGetCapabilitiesService }, { type: HsDimensionService }, { type: HsLayoutService }, { type: HsUtilsService }, { type: HsConfig }, { type: HsAddDataService }, { type: HsEventBusService }, { type: HsAddDataUrlService }, { type: HsAddDataCommonService }, { type: HsLayerUtilsService }]; } });

class HsWmtsGetCapabilitiesService {
    constructor(httpClient, hsEventBusService, hsMapService, hsUtilsService, hsWmsGetCapabilitiesService, hsAddDataService, hsCapabilityCacheService) {
        this.httpClient = httpClient;
        this.hsEventBusService = hsEventBusService;
        this.hsMapService = hsMapService;
        this.hsUtilsService = hsUtilsService;
        this.hsWmsGetCapabilitiesService = hsWmsGetCapabilitiesService;
        this.hsAddDataService = hsAddDataService;
        this.hsCapabilityCacheService = hsCapabilityCacheService;
    }
    /**
     * Get WMTS service location without parameters from url string
     *
     * @param str - Url string to parse
     * @returns WMTS service Url
     */
    getPathFromUrl(str) {
        if (str.indexOf('?') > -1) {
            return str.substring(0, str.indexOf('?'));
        }
        else {
            return str;
        }
    }
    /**
     * Create WMTS parameter string from parameter object
     * TODO: Probably the same as utils.paramsToURL
     *
     * @param obj - Object with stored WMS service parameters
     * @returns Parameter string or empty string if no object given
     */
    params2String(obj) {
        return obj
            ? Object.keys(obj)
                .map((key) => {
                const val = obj[key];
                if (Array.isArray(val)) {
                    return val
                        .map((val2) => {
                        return (encodeURIComponent(key) + '=' + encodeURIComponent(val2));
                    })
                        .join('&');
                }
                return encodeURIComponent(key) + '=' + encodeURIComponent(val);
            })
                .join('&')
            : '';
    }
    /**
     * Parse added service url and sends GetCapabilities request to WMTS service
     *
     * @param service_url - Raw Url localization of service
     * @param owrCache - Overwrites cache for the requested url
     * @returns Promise object -  Response to GetCapabilities request
     */
    request(service_url, app, owrCache) {
        return __awaiter(this, void 0, void 0, function* () {
            service_url = service_url.replace(/&amp;/g, '&');
            const params = this.hsUtilsService.getParamsFromUrl(service_url);
            const path = this.getPathFromUrl(service_url);
            if (params.request == undefined && params.REQUEST == undefined) {
                params.request = 'GetCapabilities';
            }
            else if (params.request != undefined) {
                params.request = 'GetCapabilities';
            }
            else if (params.REQUEST != undefined) {
                params.REQUEST = 'GetCapabilities';
            }
            if (params.service == undefined && params.SERVICE == undefined) {
                params.service = 'wmts';
            }
            if (params.version == undefined && params.VERSION == undefined) {
                params.version = '1.3.0';
            }
            let url = [path, this.params2String(params)].join('?');
            if (this.hsCapabilityCacheService.get(url) && !owrCache) {
                return this.hsCapabilityCacheService.get(url);
            }
            try {
                url = this.hsUtilsService.proxify(url, app);
                const r = yield lastValueFrom(this.httpClient
                    .get(url, {
                    responseType: 'text',
                })
                    .pipe(takeUntil(this.hsAddDataService.cancelUrlRequest)));
                const wrap = { response: r };
                this.hsCapabilityCacheService.set(url, wrap);
                return wrap;
            }
            catch (error) {
                return {
                    response: error,
                    error: true,
                };
            }
        });
    }
    /**
     * Load all layers of selected service to the map
     *
     * @param capabilities_xml - XML response of GetCapabilities of selected service
     * @returns List of layers from service
     */
    service2layers(capabilities_xml, app) {
        const parser = new WMTSCapabilities();
        const caps = parser.read(capabilities_xml);
        const service = caps.Capability.Layer;
        //const srss = caps.Capability.Layer.CRS;
        const image_formats = caps.Capability.Request.GetMap.Format;
        const query_formats = caps.Capability.Request.GetFeatureInfo
            ? caps.Capability.Request.GetFeatureInfo.Format
            : [];
        const image_format = getPreferredFormat(image_formats, [
            'image/png; mode=8bit',
            'image/png',
            'image/gif',
            'image/jpeg',
        ]);
        const query_format = getPreferredFormat(query_formats, [
            'application/vnd.esri.wmts_featureinfo_xml',
            'application/vnd.ogc.gml',
            'application/vnd.ogc.wmts_xml',
            'text/plain',
            'text/html',
        ]);
        const tmp = [];
        for (const subservice of service) {
            for (const layer of subservice.Layer) {
                let attributions = [];
                if (layer.Attribution) {
                    attributions = [
                        `<a href="${layer.Attribution.OnlineResource}">${layer.Attribution.Title}</a>`,
                    ];
                }
                const metadata = this.hsWmsGetCapabilitiesService.getMetadataObjectWithUrls(layer);
                const new_layer = new Tile({
                    properties: {
                        title: layer.Title.replace(/\//g, '&#47;'),
                        abstract: layer.Abstract,
                        metadata,
                    },
                    source: new WMTS({
                        url: caps.Capability.Request.GetMap.DCPType[0].HTTP.Get
                            .OnlineResource,
                        attributions: attributions,
                        style: layer.Style && layer.Style.length > 0
                            ? layer.Style[0].Name
                            : undefined,
                        crossOrigin: 'anonymous',
                    }),
                    useInterimTilesOnError: false,
                    extent: layer.BoundingBox,
                });
                tmp.push(new_layer);
            }
        }
        return tmp;
    }
}
HsWmtsGetCapabilitiesService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsWmtsGetCapabilitiesService, deps: [{ token: i1.HttpClient }, { token: HsEventBusService }, { token: HsMapService }, { token: HsUtilsService }, { token: HsWmsGetCapabilitiesService }, { token: HsAddDataService }, { token: HsCapabilityCacheService }], target: i0.ɵɵFactoryTarget.Injectable });
HsWmtsGetCapabilitiesService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsWmtsGetCapabilitiesService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsWmtsGetCapabilitiesService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: HsEventBusService }, { type: HsMapService }, { type: HsUtilsService }, { type: HsWmsGetCapabilitiesService }, { type: HsAddDataService }, { type: HsCapabilityCacheService }]; } });

class HsUrlWmtsParams {
    constructor() {
        this.data = {
            add_all: null,
            caps: null,
            description: '',
            image_format: '',
            services: [],
            layers: [],
            title: '',
            version: '',
            table: {
                trackBy: 'Identifier',
                nameProperty: 'Title',
            },
        };
    }
}
class HsUrlWmtsService {
    constructor(hsMapService, hsLayoutService, hsAddDataUrlService, hsAddDataCommonService) {
        this.hsMapService = hsMapService;
        this.hsLayoutService = hsLayoutService;
        this.hsAddDataUrlService = hsAddDataUrlService;
        this.hsAddDataCommonService = hsAddDataCommonService;
        this.apps = { default: new HsUrlWmtsParams() };
    }
    get(app) {
        if (this.apps[app !== null && app !== void 0 ? app : 'default'] == undefined) {
            this.apps[app !== null && app !== void 0 ? app : 'default'] = new HsUrlWmtsParams();
        }
        return this.apps[app !== null && app !== void 0 ? app : 'default'];
    }
    /**
     * List and return layers from WMTS getCapabilities response
     * @param wrapper - Capabilities response wrapper
     */
    listLayerFromCapabilities(wrapper, app) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = wrapper.response;
            const error = wrapper.error;
            if (!response && !error) {
                return;
            }
            if (error) {
                this.hsAddDataCommonService.throwParsingError(response.message, app);
                return;
            }
            try {
                //TODO AWAIT and add-layer if layerToSelect
                yield this.capabilitiesReceived(response, app);
                if (this.hsAddDataCommonService.get(app).layerToSelect) {
                    this.hsAddDataCommonService.checkTheSelectedLayer(this.get(app).data.layers, 'wmts', app);
                    return this.getLayers(app, true);
                }
            }
            catch (e) {
                this.hsAddDataCommonService.throwParsingError(e, app);
            }
        });
    }
    /**
     * Parse information received in WMTS getCapabilities response
     * @param response - Url of requested service
     */
    capabilitiesReceived(response, app) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const appRef = this.get(app);
                const parser = new WMTSCapabilities();
                const caps = parser.read(response);
                appRef.data.caps = caps;
                appRef.data.title = caps.ServiceIdentification.Title || 'Wmts layer';
                appRef.data.description = addAnchors(caps.ServiceIdentification.Abstract);
                appRef.data.version = caps.Version || caps.version;
                appRef.data.layers = caps.Contents.Layer;
                this.hsAddDataCommonService.get(app).loadingInfo = false;
                return appRef.data.title;
            }
            catch (e) {
                throw new Error(e);
            }
        });
    }
    /**
     * Loop through the list of layers and call getLayer recursively
     * @param layer - Layer selected
     * @param collection - Layers created and retreived collection
     */
    getLayersRecursively(layer, options, collection, app) {
        if (!this.get(app).data.add_all || layer.checked) {
            collection.push(this.getLayer(layer, undefined, app));
        }
        if (layer.Layer) {
            for (const sublayer of layer.Layer) {
                this.getLayersRecursively(sublayer, options, collection, app);
            }
        }
    }
    /**
     * Loop through the list of layers and add them to the map
     */
    addLayers(layers, app) {
        for (const l of layers) {
            this.hsMapService.addLayer(l, app);
        }
    }
    /**
     * Loop through the list of layers and call getLayer.
     * @param checkedOnly - Add all available layers or only checked ones. checkedOnly=false=all
     */
    getLayers(app, checkedOnly) {
        const appRef = this.get(app);
        appRef.data.add_all = checkedOnly;
        const collection = [];
        for (const layer of appRef.data.layers) {
            this.getLayersRecursively(layer, undefined, collection, app);
        }
        this.hsAddDataCommonService.clearParams(app);
        this.apps[app] = new HsUrlWmtsParams(); //Replaces setDataToDefault
        this.hsAddDataCommonService.setPanelToCatalogue(app);
        if (collection.length > 0) {
            this.hsLayoutService.setMainPanel('layermanager', app);
        }
        return collection;
        //FIX ME: to implement
        // this.zoomToLayers();
    }
    /**
     * Return preferred tile format
     * @param formats - Set of available formats for layer being added
     */
    getPreferredFormat(formats) {
        const preferred = formats.find((format) => format.includes('png'));
        return preferred ? preferred : formats[0];
    }
    /**
     * Return preferred tile tileMatrixSet
     * Looks for the occurrence of supported CRS's, if possible picks CRS of current view
     * otherwise returns 3857 as trial(some services support 3857 matrix set even though its not clear from capabilities )
     * @param sets - Set of available matrixSets
     */
    getPreferredMatrixSet(sets, app) {
        const supportedFormats = ['3857', '4326', '5514'];
        const preferred = sets.filter((set) => supportedFormats.some((v) => set.TileMatrixSet.includes(v)));
        if (preferred.length != 0) {
            const preferCurrent = preferred.find((set) => set.TileMatrixSet.includes(this.hsMapService.getMap(app).getView().getProjection().getCode()));
            return preferCurrent
                ? preferCurrent.TileMatrixSet
                : preferred[0].TileMatrixSet;
        }
        return 'EPSG:3857';
    }
    /**
     * Return preferred info format
     * Looks for the occurrence of supported formats (query.wms)
     * if possible picks HTML, otherwise first from the list of supported is selected
     * @param response - Set of available info formats for layer being added
     */
    getPreferredInfoFormat(formats) {
        if (formats) {
            const supportedFormats = ['html', 'xml', 'gml'];
            const infos = formats.filter((format) => format.resourceType == 'FeatureInfo' &&
                supportedFormats.some((v) => format.format.includes(v)));
            if (infos.length != 0) {
                const preferHTML = infos.find((format) => format.format.includes('html'));
                return preferHTML ? preferHTML.format : infos[0].format;
            }
        }
    }
    /***
     * Get WMTS layer bounding box
     */
    getWMTSExtent(identifier, app) {
        const caps = this.get(app).data.caps;
        const layer = caps.Contents.Layer.find((l) => l.Identifier == identifier);
        return (layer === null || layer === void 0 ? void 0 : layer.WGS84BoundingBox)
            ? transformExtent(layer.WGS84BoundingBox, 'EPSG:4326', this.hsMapService.getCurrentProj(app))
            : undefined;
    }
    /**
     * Get WMTS layer
     * Uses previously received capabilities response as a reference for the source
     * @param response - Set of available info formats for layer
     */
    getLayer(layer, options, app) {
        try {
            const wmts = new Tile({
                extent: this.getWMTSExtent(layer.Identifier, app),
                properties: {
                    title: layer.Title,
                    name: layer.Title,
                    info_format: this.getPreferredInfoFormat(layer.ResourceURL),
                    queryCapabilities: false,
                    removable: true,
                    base: layer.base,
                },
                source: new WMTS$1({}),
            });
            // Get WMTS Capabilities and create WMTS source base on it
            const options = optionsFromCapabilities(this.get(app).data.caps, {
                layer: layer.Identifier,
                matrixSet: this.getPreferredMatrixSet(layer.TileMatrixSetLink, app),
                format: this.getPreferredFormat(layer.Format),
            });
            // WMTS source for raster tiles layer
            const wmtsSource = new WMTS$1(options);
            // set the data source for raster and vector tile layers
            wmts.setSource(wmtsSource);
            layer.base = false;
            return wmts;
        }
        catch (e) {
            throw new Error(e);
        }
    }
}
HsUrlWmtsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUrlWmtsService, deps: [{ token: HsMapService }, { token: HsLayoutService }, { token: HsAddDataUrlService }, { token: HsAddDataCommonService }], target: i0.ɵɵFactoryTarget.Injectable });
HsUrlWmtsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUrlWmtsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUrlWmtsService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: HsMapService }, { type: HsLayoutService }, { type: HsAddDataUrlService }, { type: HsAddDataCommonService }]; } });

class HsAddDataOwsParams {
}
class HsAddDataOwsService {
    constructor(hsAddDataService, hsAddDataCommonService, hsAddDataUrlService, hsHistoryListService, hsArcgisGetCapabilitiesService, hsUrlArcGisService, hsUrlWfsService, hsWfsGetCapabilitiesService, hsUrlWmsService, hsWmsGetCapabilitiesService, hsWmtsGetCapabilitiesService, hsUrlWmtsService) {
        this.hsAddDataService = hsAddDataService;
        this.hsAddDataCommonService = hsAddDataCommonService;
        this.hsAddDataUrlService = hsAddDataUrlService;
        this.hsHistoryListService = hsHistoryListService;
        this.hsArcgisGetCapabilitiesService = hsArcgisGetCapabilitiesService;
        this.hsUrlArcGisService = hsUrlArcGisService;
        this.hsUrlWfsService = hsUrlWfsService;
        this.hsWfsGetCapabilitiesService = hsWfsGetCapabilitiesService;
        this.hsUrlWmsService = hsUrlWmsService;
        this.hsWmsGetCapabilitiesService = hsWmsGetCapabilitiesService;
        this.hsWmtsGetCapabilitiesService = hsWmtsGetCapabilitiesService;
        this.hsUrlWmtsService = hsUrlWmtsService;
        this.apps = { default: new HsAddDataOwsParams() };
        this.hsAddDataCommonService.serviceLayersCalled.subscribe(({ url, app }) => {
            this.setUrlAndConnect({ uri: url }, app);
        });
    }
    get(app) {
        if (this.apps[app !== null && app !== void 0 ? app : 'default'] == undefined) {
            this.apps[app !== null && app !== void 0 ? app : 'default'] = new HsAddDataOwsParams();
        }
        return this.apps[app !== null && app !== void 0 ? app : 'default'];
    }
    connect(app, opt) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const typeBeingSelected = this.hsAddDataUrlService.get(app).typeSelected;
            yield this.setTypeServices(app);
            const appRef = this.get(app);
            const url = this.hsAddDataCommonService.get(app).url;
            if (!url || url === '') {
                return;
            }
            this.hsAddDataUrlService.apps[app].addingAllowed = false;
            if (this.hsAddDataUrlService.apps[app].typeSelected === 'arcgis') {
                if (this.hsUrlArcGisService.isGpService(url)) {
                    this.hsAddDataCommonService.throwParsingError('GPServerServicesAreNotSupported', app);
                    return;
                }
                appRef.typeService.get(app).data.get_map_url = url;
                this.hsAddDataUrlService.apps[app].addingAllowed = true;
            }
            this.hsHistoryListService.addSourceHistory(this.hsAddDataUrlService.apps[app].typeSelected, url);
            Object.assign(this.hsAddDataCommonService.get(app), {
                loadingInfo: true,
                showDetails: true,
            });
            const wrapper = yield appRef.typeCapabilitiesService.request(url, app, opt === null || opt === void 0 ? void 0 : opt.owrCache);
            if (typeof wrapper.response === 'string' &&
                ((_a = wrapper.response) === null || _a === void 0 ? void 0 : _a.includes('Unsuccessful OAuth2'))) {
                this.hsAddDataCommonService.throwParsingError(wrapper.response, app);
                return [];
            }
            else {
                const response = yield this.get(app).typeService.listLayerFromCapabilities(wrapper, app, opt === null || opt === void 0 ? void 0 : opt.style);
                if (!(opt === null || opt === void 0 ? void 0 : opt.getOnly)) {
                    if ((response === null || response === void 0 ? void 0 : response.length) > 0) {
                        appRef.typeService.addLayers(response, app);
                    }
                    //Note:
                    //!response condition would result in inifinite connectToOWS calls
                    //response?.length by design also checks for hsAddDataCommonService.layerToSelect
                    if ((response === null || response === void 0 ? void 0 : response.length) == 0) {
                        console.log('Empty response when layer selected');
                        this.hsAddDataService.selectType('url', app);
                        yield this.connectToOWS({
                            type: typeBeingSelected,
                            uri: url,
                            layer: undefined,
                        }, app);
                    }
                    if (this.hsUrlArcGisService.isImageService(app)) {
                        const layers = this.hsUrlArcGisService.getLayers(app);
                        this.hsUrlArcGisService.addLayers(layers, app);
                    }
                }
                return response;
            }
        });
    }
    /**
     * Connect to service of specified Url
     * @param params - Connection params
     * @param app - App identifier
     */
    setUrlAndConnect(params, app) {
        return __awaiter(this, void 0, void 0, function* () {
            this.hsAddDataCommonService.get(app).layerToSelect = params.layer;
            this.hsAddDataCommonService.updateUrl(params.uri, app);
            return yield this.connect(app, {
                style: params.style,
                owrCache: params.owrCache,
                getOnly: params.getOnly,
            });
        });
    }
    changed(data, app) {
        this.hsAddDataUrlService.searchForChecked(data.layers, app);
    }
    /**
     * replaces `ows.${type}_connecting`
     */
    connectToOWS(params, app) {
        return __awaiter(this, void 0, void 0, function* () {
            this.hsAddDataUrlService.get(app).typeSelected =
                params.type;
            return yield this.setUrlAndConnect(params, app);
        });
    }
    setTypeServices(app) {
        return __awaiter(this, void 0, void 0, function* () {
            const appRef = this.get(app);
            switch (this.hsAddDataUrlService.get(app).typeSelected) {
                case 'wmts':
                    appRef.typeService = this.hsUrlWmtsService;
                    appRef.typeCapabilitiesService = this.hsWmtsGetCapabilitiesService;
                    return;
                case 'wms':
                    appRef.typeService = this.hsUrlWmsService;
                    appRef.typeCapabilitiesService = this.hsWmsGetCapabilitiesService;
                    return;
                case 'wfs':
                    appRef.typeService = this.hsUrlWfsService;
                    appRef.typeCapabilitiesService = this.hsWfsGetCapabilitiesService;
                    return;
                case 'arcgis':
                    appRef.typeService = this.hsUrlArcGisService;
                    appRef.typeCapabilitiesService = this.hsArcgisGetCapabilitiesService;
                    return;
                default:
                    return;
            }
        });
    }
}
HsAddDataOwsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataOwsService, deps: [{ token: HsAddDataService }, { token: HsAddDataCommonService }, { token: HsAddDataUrlService }, { token: HsHistoryListService }, { token: HsArcgisGetCapabilitiesService }, { token: HsUrlArcGisService }, { token: HsUrlWfsService }, { token: HsWfsGetCapabilitiesService }, { token: HsUrlWmsService }, { token: HsWmsGetCapabilitiesService }, { token: HsWmtsGetCapabilitiesService }, { token: HsUrlWmtsService }], target: i0.ɵɵFactoryTarget.Injectable });
HsAddDataOwsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataOwsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataOwsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsAddDataService }, { type: HsAddDataCommonService }, { type: HsAddDataUrlService }, { type: HsHistoryListService }, { type: HsArcgisGetCapabilitiesService }, { type: HsUrlArcGisService }, { type: HsUrlWfsService }, { type: HsWfsGetCapabilitiesService }, { type: HsUrlWmsService }, { type: HsWmsGetCapabilitiesService }, { type: HsWmtsGetCapabilitiesService }, { type: HsUrlWmtsService }]; } });

class HsHistoryListComponent {
    constructor(HsHistoryListService) {
        this.HsHistoryListService = HsHistoryListService;
        this.app = 'default';
        this.historyUrlSelected = new EventEmitter(); //output
    }
    ngOnChanges(changes) {
        this.items = this.HsHistoryListService.readSourceHistory(changes.what.currentValue);
    }
    historyUrlClicked(value) {
        this.historyUrlSelected.emit(value);
    }
}
HsHistoryListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsHistoryListComponent, deps: [{ token: HsHistoryListService }], target: i0.ɵɵFactoryTarget.Component });
HsHistoryListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsHistoryListComponent, selector: "hs-history-list", inputs: { what: "what", app: "app" }, outputs: { historyUrlSelected: "historyUrlSelected" }, usesOnChanges: true, ngImport: i0, template: "<div ngbDropdown display=\"dynamic\" placement=\"bottom-right\" class=\"h-100\">\n    <button ngbDropdownToggle type=\"button\"\n        class=\"btn btn-outline-secondary dropdown-toggle dropdown-toggle-split rounded-0 h-100\"\n        [title]=\"'HISTORY.toggleDropdown' | translateHs : {'app': app}\" aria-haspopup=\"true\" aria-expanded=\"false\">\n    </button>\n    <div ngbDropdownMenu class=\"dropdown-menu\" style=\"width:325px; overflow: hidden\">\n        <a class=\"dropdown-item\" *ngFor=\"let item of items | keyvalue\"\n            (click)=\"historyUrlClicked(item.value)\">{{item.value}}</a>\n    </div>\n</div>\n", directives: [{ type: i7.NgbDropdown, selector: "[ngbDropdown]", inputs: ["autoClose", "dropdownClass", "open", "placement", "container", "display"], outputs: ["openChange"], exportAs: ["ngbDropdown"] }, { type: i7.NgbDropdownToggle, selector: "[ngbDropdownToggle]" }, { type: i7.NgbDropdownMenu, selector: "[ngbDropdownMenu]" }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "translateHs": TranslateCustomPipe, "keyvalue": i3.KeyValuePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsHistoryListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-history-list', template: "<div ngbDropdown display=\"dynamic\" placement=\"bottom-right\" class=\"h-100\">\n    <button ngbDropdownToggle type=\"button\"\n        class=\"btn btn-outline-secondary dropdown-toggle dropdown-toggle-split rounded-0 h-100\"\n        [title]=\"'HISTORY.toggleDropdown' | translateHs : {'app': app}\" aria-haspopup=\"true\" aria-expanded=\"false\">\n    </button>\n    <div ngbDropdownMenu class=\"dropdown-menu\" style=\"width:325px; overflow: hidden\">\n        <a class=\"dropdown-item\" *ngFor=\"let item of items | keyvalue\"\n            (click)=\"historyUrlClicked(item.value)\">{{item.value}}</a>\n    </div>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: HsHistoryListService }]; }, propDecorators: { what: [{
                type: Input
            }], app: [{
                type: Input
            }], historyUrlSelected: [{
                type: Output
            }] } });

class HsCommonUrlComponent {
    constructor(historyListService) {
        this.historyListService = historyListService;
        this.app = 'default';
        this.urlChange = new EventEmitter();
        this.connect = new EventEmitter();
        this.items = this.historyListService.readSourceHistory(this.what);
    }
    emitConnect() {
        this.connect.emit();
    }
    change() {
        this.urlChange.emit(this.url.trim());
    }
    historySelected(url) {
        this.url = url;
        this.change();
    }
}
HsCommonUrlComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCommonUrlComponent, deps: [{ token: HsHistoryListService }], target: i0.ɵɵFactoryTarget.Component });
HsCommonUrlComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsCommonUrlComponent, selector: "hs-common-url", inputs: { type: "type", url: "url", app: "app" }, outputs: { urlChange: "urlChange", connect: "connect" }, ngImport: i0, template: "<div class=\"form-group\">\n    <div class=\"input-group\">\n        <input type=\"url\" class=\"form-control\" name=\"url\" [(ngModel)]=\"url\" (change)=\"change()\"\n            [placeholder]=\"'ADDLAYERS.externalDataSource' | translateHs: {app} \" required #uri=\"ngModel\"\n            style=\"height: auto;\" />\n\n        <button type=\"button\" class=\"btn btn-secondary\" *ngIf=\"uri.valid\" (click)=\"emitConnect()\"><i\n                class=\"icon-link\"></i></button>\n\n        <!-- TODO: Folllowing should be validating URL and warning user if URL is invalid -->\n\n        <!-- <button type=\"button\" class=\"btn btn-danger\" *ngIf=\"uri && !uri.valid\"><i\n                    class=\"icon-alertalt\"></i></button> -->\n        <hs-history-list type=\"button\" (historyUrlSelected)=\"historySelected($event)\" [app]=\"app\" [(what)]=\"type\">\n        </hs-history-list>\n    </div>\n</div>", components: [{ type: HsHistoryListComponent, selector: "hs-history-list", inputs: ["what", "app"], outputs: ["historyUrlSelected"] }], directives: [{ type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3$1.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCommonUrlComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-common-url', template: "<div class=\"form-group\">\n    <div class=\"input-group\">\n        <input type=\"url\" class=\"form-control\" name=\"url\" [(ngModel)]=\"url\" (change)=\"change()\"\n            [placeholder]=\"'ADDLAYERS.externalDataSource' | translateHs: {app} \" required #uri=\"ngModel\"\n            style=\"height: auto;\" />\n\n        <button type=\"button\" class=\"btn btn-secondary\" *ngIf=\"uri.valid\" (click)=\"emitConnect()\"><i\n                class=\"icon-link\"></i></button>\n\n        <!-- TODO: Folllowing should be validating URL and warning user if URL is invalid -->\n\n        <!-- <button type=\"button\" class=\"btn btn-danger\" *ngIf=\"uri && !uri.valid\"><i\n                    class=\"icon-alertalt\"></i></button> -->\n        <hs-history-list type=\"button\" (historyUrlSelected)=\"historySelected($event)\" [app]=\"app\" [(what)]=\"type\">\n        </hs-history-list>\n    </div>\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsHistoryListService }]; }, propDecorators: { type: [{
                type: Input
            }], url: [{
                type: Input
            }], app: [{
                type: Input
            }], urlChange: [{
                type: Output
            }], connect: [{
                type: Output
            }] } });

class HsUrlProgressComponent {
    constructor(hsAddDataService, hsUtilsService, hsConfig) {
        this.hsAddDataService = hsAddDataService;
        this.hsUtilsService = hsUtilsService;
        this.hsConfig = hsConfig;
        this.app = 'default';
    }
    ngOnInit() {
        this.configRef = this.hsConfig.get(this.app);
    }
}
HsUrlProgressComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUrlProgressComponent, deps: [{ token: HsAddDataService }, { token: HsUtilsService }, { token: HsConfig }], target: i0.ɵɵFactoryTarget.Component });
HsUrlProgressComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsUrlProgressComponent, selector: "hs-url-progress", inputs: { app: "app" }, ngImport: i0, template: "<div class=\"d-flex justify-content-center btn-group w-75 m-auto\">\n  <button class=\"btn btn-primary w-75\">{{'ADDDATA.CATALOGUE.loading' | translateHs: {app} }}<img class=\"ms-2\"\n      [src]=\"configRef._ajaxLoaderPath\" /></button>\n  <button class=\"btn btn-secondary\" (click)=\"hsAddDataService.cancelUrlRequest.next(app)\">&#10006;\n  </button>\n</div>", pipes: { "translateHs": TranslateCustomPipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUrlProgressComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-url-progress', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"d-flex justify-content-center btn-group w-75 m-auto\">\n  <button class=\"btn btn-primary w-75\">{{'ADDDATA.CATALOGUE.loading' | translateHs: {app} }}<img class=\"ms-2\"\n      [src]=\"configRef._ajaxLoaderPath\" /></button>\n  <button class=\"btn btn-secondary\" (click)=\"hsAddDataService.cancelUrlRequest.next(app)\">&#10006;\n  </button>\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsAddDataService }, { type: HsUtilsService }, { type: HsConfig }]; }, propDecorators: { app: [{
                type: Input
            }] } });

class WmsLayerHighlightDirective {
    constructor(hsUtilsService, elRef) {
        this.hsUtilsService = hsUtilsService;
        this.elRef = elRef;
        this.highlighted = false;
        setTimeout(() => {
            this.highlighted = this.hsUtilsService.isOverflown(this.elRef.nativeElement);
        }, 500);
    }
}
WmsLayerHighlightDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: WmsLayerHighlightDirective, deps: [{ token: HsUtilsService }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
WmsLayerHighlightDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.11", type: WmsLayerHighlightDirective, selector: "[hsWmsLayerHighlight]", host: { properties: { "class.hs-wms-highlighted": "this.highlighted" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: WmsLayerHighlightDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[hsWmsLayerHighlight]',
                }]
        }], ctorParameters: function () { return [{ type: HsUtilsService }, { type: i0.ElementRef }]; }, propDecorators: { highlighted: [{
                type: HostBinding,
                args: ['class.hs-wms-highlighted']
            }] } });

//@ https://www.bennadel.com/blog/3579-using-pure-pipes-to-generate-ngfor-trackby-identity-functions-in-angular-7-2-7.html
const cache = {};
class TrackByPropertyPipe {
    transform(propertyName) {
        if (!cache[propertyName]) {
            cache[propertyName] = function trackByProperty(index, item) {
                return item[propertyName];
            };
        }
        return cache[propertyName];
    }
}
TrackByPropertyPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TrackByPropertyPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
TrackByPropertyPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TrackByPropertyPipe, name: "trackByProperty" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TrackByPropertyPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'trackByProperty',
                    pure: true,
                }]
        }] });

class HsNestedLayersTableComponent {
    constructor(hsUrlWmsService) {
        this.hsUrlWmsService = hsUrlWmsService;
        this.app = 'default';
        this.layerChecked = new EventEmitter(); //output
    }
    checked(layer) {
        this.layerChecked.emit(layer);
    }
    isArray(maybeArray) {
        return Array.isArray(maybeArray);
    }
}
HsNestedLayersTableComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsNestedLayersTableComponent, deps: [{ token: HsUrlWmsService }], target: i0.ɵɵFactoryTarget.Component });
HsNestedLayersTableComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsNestedLayersTableComponent, selector: "hs-nested-layers-table", inputs: { layers: "layers", app: "app" }, outputs: { layerChecked: "layerChecked" }, ngImport: i0, template: "<table class=\"table table-sm table-striped table-bordered hs-url-table\" style=\"width: 100%\">\n    <tbody *ngFor=\"let sub_layer of layers; trackBy:( 'Name' | trackByProperty )\">\n        <tr>\n            <td style=\"width: 1em\"><input type=\"checkbox\" [(ngModel)]=\"sub_layer.checked\" (change)=\"checked(sub_layer)\"\n                    [ngModelOptions]=\"{standalone: true}\" style=\"cursor: pointer;\" /></td>\n            <td hsWmsLayerHighlight class=\"text-truncate\" style=\"max-width: 12em;\"\n                [title]=\"'Title: ' + sub_layer.Title  + '\\nName: ' + sub_layer.Name\"\n                (click)=\"hsUrlWmsService.expandTableRow($event)\">{{sub_layer.Title}}\n            </td>\n            <!-- <td class=\"text-truncate\" style=\"width: 30%; padding-left: 1em\">{{sub_layer.Name}}</td> -->\n            <td hsWmsLayerHighlight class=\"text-truncate\" style=\"max-width: 10.875em;width: 30%;\"\n                [title]=\"sub_layer.Abstract\" (click)=\"hsUrlWmsService.expandTableRow($event)\">{{sub_layer.Abstract}}\n            </td>\n        </tr>\n        <tr *ngIf=\"sub_layer.Style?.length > 1 && sub_layer.checked\">\n            <td colspan=\"3\">\n                <div class=\"d-flex align-items-baseline px-2 w-100\">\n                    <div class=\"d-flex align-items-baseline\" style=\"flex-grow: 1;\">\n                        <label class=\"control-label\">{{'COMMON.style' | translateHs: {app} }}:</label>\n                        <select class=\"form-control form-select-sm form-select\" [(ngModel)]=\"sub_layer.styleSelected\"\n                            [ngModelOptions]=\"{standalone: true}\">\n                            <option *ngFor=\"let style of sub_layer.Style\">{{style.Name}}</option>\n                        </select>\n                    </div>\n                </div>\n            </td>\n        </tr>\n        <tr *ngIf=\"!!sub_layer.Dimension\">\n            <td colspan=\"3\">\n                <form class=\"form\">\n                    <div class=\"form-group\" *ngFor=\"let dimension of sub_layer.Dimension\">\n                        <ng-container *ngIf=\"isArray(dimension.values); else unsupported_dim_format\"><!-- TODO: Remove function call from template -->\n                            <label class=\"control-label\">{{dimension.name}}:</label>\n                            <div>\n                                <select class=\"form-control form-select\" [(ngModel)]=\"dimension.value\"\n                                    [ngModelOptions]=\"{standalone: true}\">\n                                    <option [value]=\"dimension_value\" *ngFor=\"let dimension_value of dimension.values\">\n                                        {{dimension_value}}</option>\n                                </select>\n                            </div>\n                        </ng-container>\n                        <ng-template #unsupported_dim_format><span class=\"text-muted\">{{'ADDLAYERS.unknownDimesion'|\n                                translateHs: {app} }}: {{dimension.name}}</span></ng-template>\n                    </div>\n                </form>\n            </td>\n        </tr>\n\n        <tr *ngIf=\"!!sub_layer.Layer\">\n            <td colspan=\"3\" style=\"padding-left: 1em\">\n                <hs-nested-layers-table style=\"display: block;\" [app]=\"app\" (layerChecked)=\"checked($event)\"\n                    [layers]=\"sub_layer.Layer\"></hs-nested-layers-table>\n            </td>\n        </tr>\n    </tbody>\n</table>", components: [{ type: HsNestedLayersTableComponent, selector: "hs-nested-layers-table", inputs: ["layers", "app"], outputs: ["layerChecked"] }], directives: [{ type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3$1.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: WmsLayerHighlightDirective, selector: "[hsWmsLayerHighlight]" }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3$1.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i3$1.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i3$1.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i3$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i3$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i3$1.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }], pipes: { "trackByProperty": TrackByPropertyPipe, "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsNestedLayersTableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-nested-layers-table', template: "<table class=\"table table-sm table-striped table-bordered hs-url-table\" style=\"width: 100%\">\n    <tbody *ngFor=\"let sub_layer of layers; trackBy:( 'Name' | trackByProperty )\">\n        <tr>\n            <td style=\"width: 1em\"><input type=\"checkbox\" [(ngModel)]=\"sub_layer.checked\" (change)=\"checked(sub_layer)\"\n                    [ngModelOptions]=\"{standalone: true}\" style=\"cursor: pointer;\" /></td>\n            <td hsWmsLayerHighlight class=\"text-truncate\" style=\"max-width: 12em;\"\n                [title]=\"'Title: ' + sub_layer.Title  + '\\nName: ' + sub_layer.Name\"\n                (click)=\"hsUrlWmsService.expandTableRow($event)\">{{sub_layer.Title}}\n            </td>\n            <!-- <td class=\"text-truncate\" style=\"width: 30%; padding-left: 1em\">{{sub_layer.Name}}</td> -->\n            <td hsWmsLayerHighlight class=\"text-truncate\" style=\"max-width: 10.875em;width: 30%;\"\n                [title]=\"sub_layer.Abstract\" (click)=\"hsUrlWmsService.expandTableRow($event)\">{{sub_layer.Abstract}}\n            </td>\n        </tr>\n        <tr *ngIf=\"sub_layer.Style?.length > 1 && sub_layer.checked\">\n            <td colspan=\"3\">\n                <div class=\"d-flex align-items-baseline px-2 w-100\">\n                    <div class=\"d-flex align-items-baseline\" style=\"flex-grow: 1;\">\n                        <label class=\"control-label\">{{'COMMON.style' | translateHs: {app} }}:</label>\n                        <select class=\"form-control form-select-sm form-select\" [(ngModel)]=\"sub_layer.styleSelected\"\n                            [ngModelOptions]=\"{standalone: true}\">\n                            <option *ngFor=\"let style of sub_layer.Style\">{{style.Name}}</option>\n                        </select>\n                    </div>\n                </div>\n            </td>\n        </tr>\n        <tr *ngIf=\"!!sub_layer.Dimension\">\n            <td colspan=\"3\">\n                <form class=\"form\">\n                    <div class=\"form-group\" *ngFor=\"let dimension of sub_layer.Dimension\">\n                        <ng-container *ngIf=\"isArray(dimension.values); else unsupported_dim_format\"><!-- TODO: Remove function call from template -->\n                            <label class=\"control-label\">{{dimension.name}}:</label>\n                            <div>\n                                <select class=\"form-control form-select\" [(ngModel)]=\"dimension.value\"\n                                    [ngModelOptions]=\"{standalone: true}\">\n                                    <option [value]=\"dimension_value\" *ngFor=\"let dimension_value of dimension.values\">\n                                        {{dimension_value}}</option>\n                                </select>\n                            </div>\n                        </ng-container>\n                        <ng-template #unsupported_dim_format><span class=\"text-muted\">{{'ADDLAYERS.unknownDimesion'|\n                                translateHs: {app} }}: {{dimension.name}}</span></ng-template>\n                    </div>\n                </form>\n            </td>\n        </tr>\n\n        <tr *ngIf=\"!!sub_layer.Layer\">\n            <td colspan=\"3\" style=\"padding-left: 1em\">\n                <hs-nested-layers-table style=\"display: block;\" [app]=\"app\" (layerChecked)=\"checked($event)\"\n                    [layers]=\"sub_layer.Layer\"></hs-nested-layers-table>\n            </td>\n        </tr>\n    </tbody>\n</table>" }]
        }], ctorParameters: function () { return [{ type: HsUrlWmsService }]; }, propDecorators: { layers: [{
                type: Input
            }], app: [{
                type: Input
            }], layerChecked: [{
                type: Output
            }] } });

class HsLayerTableComponent {
    constructor(hsAddDataUrlService, hsUtilsService, hsLayerUtilsService, hsAddDataService, hsLanguageService, hsUrlWmsService, hsAddDataCommonService) {
        this.hsAddDataUrlService = hsAddDataUrlService;
        this.hsUtilsService = hsUtilsService;
        this.hsLayerUtilsService = hsLayerUtilsService;
        this.hsAddDataService = hsAddDataService;
        this.hsLanguageService = hsLanguageService;
        this.hsUrlWmsService = hsUrlWmsService;
        this.hsAddDataCommonService = hsAddDataCommonService;
        this.app = 'default';
        this.checkedSubLayers = {};
        this.limitShown = 100;
    }
    ngAfterContentInit() {
        this.data = this.injectedService.get(this.app).data;
        this.getDimensionValues = this.hsAddDataCommonService.getDimensionValues;
    }
    reachedLimit() {
        var _a, _b;
        if (((_a = this.data.layers) === null || _a === void 0 ? void 0 : _a.length) > this.limitShown ||
            ((_b = this.data.services) === null || _b === void 0 ? void 0 : _b.length) > this.limitShown) {
            return true;
        }
        else {
            return false;
        }
    }
    changed(whichArray) {
        if (whichArray == 'layers') {
            this.hsAddDataUrlService.searchForChecked(this.data.layers, this.app);
        }
        if (whichArray == 'services') {
            this.hsAddDataUrlService.searchForChecked(this.data.services, this.app);
        }
    }
    expandService(service) {
        if (this.injectedService.expandService) {
            this.injectedService.expandService(service, this.app);
            if (this.injectedService.isImageService &&
                this.injectedService.isImageService(this.app)) {
                const layers = this.injectedService.getLayers(this.app);
                this.injectedService.addLayers(layers, this.app);
            }
        }
    }
    searchForChecked(layer) {
        this.checkedSubLayers[layer.Name] = layer.checked;
        this.hsAddDataUrlService.apps[this.app].addingAllowed = Object.values(this.checkedSubLayers).some((value) => value === true);
    }
    getLimitTextTranslation() {
        return this.hsLanguageService.getTranslation('ADDDATA.CATALOGUE.showingSubset', { limitShown: this.limitShown, total: this.data.layers.length }, this.app);
    }
}
HsLayerTableComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerTableComponent, deps: [{ token: HsAddDataUrlService }, { token: HsUtilsService }, { token: HsLayerUtilsService }, { token: HsAddDataService }, { token: HsLanguageService }, { token: HsUrlWmsService }, { token: HsAddDataCommonService }], target: i0.ɵɵFactoryTarget.Component });
HsLayerTableComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsLayerTableComponent, selector: "hs-layer-table", inputs: { injectedService: "injectedService", type: "type", app: "app" }, ngImport: i0, template: "<div>\n    <ng-container *ngIf=\"type === 'wms'; else simpleTable\">\n        <table class=\"table table-sm table-striped table-bordered hs-url-table\">\n            <thead class=\"bg-secondary text-light\">\n                <th style=\"width:1.5em\">&nbsp;</th>\n                <th>{{'COMMON.title' | translateHs: {app} }}</th>\n                <!-- <th style=\"width:30%\">{{'COMMON.name' | translateHs: {app} }}</th> -->\n                <th>{{'COMMON.abstract' | translateHs: {app} }}</th>\n            </thead>\n            <tbody *ngFor=\"let layer of data.layers | slice:0:limitShown; trackBy:( 'Name' | trackByProperty )\">\n                <tr>\n                    <td [attr.rowspan]=\"layer.Style?.length ? 3 : 2\" [ngClass]=\"{'align-middle': !layer.Layer}\">\n                        <input type=\"checkbox\" class=\"checkbox-lg\" [(ngModel)]=\"layer.checked\" name=\"layer\"\n                            style=\"cursor: pointer;\" (change)=\"searchForChecked(layer)\" />\n                    </td>\n                    <td hsWmsLayerHighlight style=\"max-width: 25.375em\" class=\"text-truncate\"\n                        [title]=\"'Title: ' + layer.Title  + '\\nName: ' + layer.Name\"\n                        (click)=\"hsUrlWmsService.expandTableRow($event)\">{{layer.Title}}</td>\n                    <!-- <td style=\"max-width: 13.75em\" class=\"text-truncate\" [title]=\"layer.Name\">{{layer.Name}}</td> -->\n                    <td hsWmsLayerHighlight style=\"max-width: 10.875em; width:30%\" class=\"text-truncate\"\n                        [title]=\"layer.Abstract\" (click)=\"hsUrlWmsService.expandTableRow($event)\">\n                        {{layer.Abstract}}</td>\n                </tr>\n                <tr *ngIf=\"layer.Style?.length > 1 && layer.checked\">\n                    <td colspan=\"3\">\n                        <div class=\"d-flex align-items-baseline px-2 w-100\">\n                            <div class=\"d-flex align-items-baseline\" style=\"flex-grow: 1;\">\n                                <label class=\"control-label\">{{'COMMON.style' | translateHs: {app} }}:</label>\n                                <select class=\"form-control form-select-sm form-select\"\n                                    [(ngModel)]=\"layer.styleSelected\" [ngModelOptions]=\"{standalone: true}\">\n                                    <option *ngFor=\"let style of layer.Style\" [ngValue]=\"style\">{{style.Name}}\n                                    </option>\n                                </select>\n                            </div>\n                        </div>\n                    </td>\n                </tr>\n                <tr [hidden]=\"!layer.Layer\">\n                    <td colspan=\"3\" style=\"padding-left: 1em\">\n                        <hs-nested-layers-table style=\"display: block;\" [app]=\"app\" [layers]=\"layer.Layer\"\n                            (layerChecked)=\"searchForChecked($event)\">\n                        </hs-nested-layers-table>\n                    </td>\n                </tr>\n            </tbody>\n        </table>\n    </ng-container>\n    <ng-template #simpleTable>\n        <table class=\"table table-sm table-striped table-bordered\">\n            <thead>\n                <th style=\"width:1em\">&nbsp;</th>\n                <th>{{'COMMON.name' | translateHs: {app} }}</th>\n            </thead>\n            <tbody *ngFor=\"let service of data.services; trackBy:( 'id' | trackByProperty )\">\n                <tr>\n                    <td>\n                        <input class=\"checkbox-lg\" type=\"checkbox\" name=\"service\" (change)=\"changed('services')\"\n                            style=\"cursor: pointer;\" [(ngModel)]=\"service.checked\" />\n                    </td>\n                    <td (click)=\"expandService(service)\" data-toggle=\"tooltip\"\n                        [title]=\"'ADDDATA.requestServiceLayers' | translateHs: {app} \" style=\"cursor: pointer;\">\n                        {{service.name}}\n                        <span style=\"font-size: x-small;\"><i class=\"icon-chevron-right\"></i></span>\n                    </td>\n                </tr>\n            </tbody>\n            <tbody *ngFor=\"let layer of data.layers; trackBy:( data.table.trackBy | trackByProperty )\">\n                <tr>\n                    <td><input class=\"checkbox-lg\" type=\"checkbox\" name=\"layer\" style=\"cursor: pointer;\"\n                            (change)=\"changed('layers')\" [(ngModel)]=\"layer.checked\" /></td>\n                    <td hsWmsLayerHighlight (click)=\"hsUrlWmsService.expandTableRow($event)\" class=\"text-truncate\"\n                        style=\"max-width: 45ch;\">{{layer[data.table.nameProperty]}}\n                        <div *ngIf=\"layer.checked && type === 'wmts'\"\n                            class=\"d-flex flex-row justify-content-end align-items-baseline mt-1\">\n                            {{'ADDDATA.CATALOGUE.addAs' | translateHs: {app} }}\n                            <div class=\"btn-group ms-2\">\n                                <button type=\"button\" class=\"btn btn-sm btn-light  btn-outline-secondary\"\n                                    (click)=\"layer.base = true\" [ngClass]=\"{'active':layer.base}\">\n                                    {{'COMPOSITONKEYWORDS.Basemap' | translateHs: {app} }}\n                                </button>\n                                <button type=\"button\" class=\"btn btn-sm btn-light  btn-outline-secondary\"\n                                    (click)=\"layer.base = false\" [ngClass]=\"{'active': !layer.base}\">\n                                    {{'COMMON.layer' | translateHs: {app} }}\n                                </button>\n                            </div>\n                        </div>\n                        <div class=\"alert alert-primary d-flex m-1\" role=\"alert\"\n                            *ngIf=\"layer.featureCount > 1000 && layer.checked && type === 'wfs'\">\n                            <div class=\"w-100\">\n                                <p class=\"mb-0\" style=\"white-space: normal\" [hidden]=\"!layer.limitFeatureCount\">\n                                    {{'ADDLAYERS.WFS.selectedLayerContains' |\n                                    translateHs: {app} }}\n                                    {{layer.featureCount}} {{'ADDLAYERS.WFS.loadingToManyAtOnce' | translateHs: {app} }}\n                                </p>\n                            </div>\n                        </div>\n                    </td>\n                </tr>\n            </tbody>\n        </table>\n    </ng-template>\n    <ng-container *ngIf=\"type === 'wms'\">\n        <div *ngIf=\"reachedLimit()\" class=\"d-flex justify-content-around align-items-center m-3\"><span>\n                {{getLimitTextTranslation()}}</span>\n            <div class=\"btn-group ms-2\">\n                <button type=\"button\" class=\"btn btn-sm btn-light  btn-outline-secondary\"\n                    (click)=\"limitShown = limitShown + 100\">\n                    {{'ADDDATA.CATALOGUE.showNext100' | translateHs: {app} }}\n                </button>\n                <button type=\"button\" class=\"btn btn-sm btn-light  btn-outline-secondary\"\n                    (click)=\"limitShown = data.layers.length\">\n                    {{'ADDDATA.CATALOGUE.showAll' | translateHs: {app} }}\n                </button>\n            </div>\n        </div>\n    </ng-container>\n</div>\n", components: [{ type: HsNestedLayersTableComponent, selector: "hs-nested-layers-table", inputs: ["layers", "app"], outputs: ["layerChecked"] }], directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3$1.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: WmsLayerHighlightDirective, selector: "[hsWmsLayerHighlight]" }, { type: i3$1.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i3$1.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i3$1.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }], pipes: { "translateHs": TranslateCustomPipe, "slice": i3.SlicePipe, "trackByProperty": TrackByPropertyPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerTableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-layer-table', template: "<div>\n    <ng-container *ngIf=\"type === 'wms'; else simpleTable\">\n        <table class=\"table table-sm table-striped table-bordered hs-url-table\">\n            <thead class=\"bg-secondary text-light\">\n                <th style=\"width:1.5em\">&nbsp;</th>\n                <th>{{'COMMON.title' | translateHs: {app} }}</th>\n                <!-- <th style=\"width:30%\">{{'COMMON.name' | translateHs: {app} }}</th> -->\n                <th>{{'COMMON.abstract' | translateHs: {app} }}</th>\n            </thead>\n            <tbody *ngFor=\"let layer of data.layers | slice:0:limitShown; trackBy:( 'Name' | trackByProperty )\">\n                <tr>\n                    <td [attr.rowspan]=\"layer.Style?.length ? 3 : 2\" [ngClass]=\"{'align-middle': !layer.Layer}\">\n                        <input type=\"checkbox\" class=\"checkbox-lg\" [(ngModel)]=\"layer.checked\" name=\"layer\"\n                            style=\"cursor: pointer;\" (change)=\"searchForChecked(layer)\" />\n                    </td>\n                    <td hsWmsLayerHighlight style=\"max-width: 25.375em\" class=\"text-truncate\"\n                        [title]=\"'Title: ' + layer.Title  + '\\nName: ' + layer.Name\"\n                        (click)=\"hsUrlWmsService.expandTableRow($event)\">{{layer.Title}}</td>\n                    <!-- <td style=\"max-width: 13.75em\" class=\"text-truncate\" [title]=\"layer.Name\">{{layer.Name}}</td> -->\n                    <td hsWmsLayerHighlight style=\"max-width: 10.875em; width:30%\" class=\"text-truncate\"\n                        [title]=\"layer.Abstract\" (click)=\"hsUrlWmsService.expandTableRow($event)\">\n                        {{layer.Abstract}}</td>\n                </tr>\n                <tr *ngIf=\"layer.Style?.length > 1 && layer.checked\">\n                    <td colspan=\"3\">\n                        <div class=\"d-flex align-items-baseline px-2 w-100\">\n                            <div class=\"d-flex align-items-baseline\" style=\"flex-grow: 1;\">\n                                <label class=\"control-label\">{{'COMMON.style' | translateHs: {app} }}:</label>\n                                <select class=\"form-control form-select-sm form-select\"\n                                    [(ngModel)]=\"layer.styleSelected\" [ngModelOptions]=\"{standalone: true}\">\n                                    <option *ngFor=\"let style of layer.Style\" [ngValue]=\"style\">{{style.Name}}\n                                    </option>\n                                </select>\n                            </div>\n                        </div>\n                    </td>\n                </tr>\n                <tr [hidden]=\"!layer.Layer\">\n                    <td colspan=\"3\" style=\"padding-left: 1em\">\n                        <hs-nested-layers-table style=\"display: block;\" [app]=\"app\" [layers]=\"layer.Layer\"\n                            (layerChecked)=\"searchForChecked($event)\">\n                        </hs-nested-layers-table>\n                    </td>\n                </tr>\n            </tbody>\n        </table>\n    </ng-container>\n    <ng-template #simpleTable>\n        <table class=\"table table-sm table-striped table-bordered\">\n            <thead>\n                <th style=\"width:1em\">&nbsp;</th>\n                <th>{{'COMMON.name' | translateHs: {app} }}</th>\n            </thead>\n            <tbody *ngFor=\"let service of data.services; trackBy:( 'id' | trackByProperty )\">\n                <tr>\n                    <td>\n                        <input class=\"checkbox-lg\" type=\"checkbox\" name=\"service\" (change)=\"changed('services')\"\n                            style=\"cursor: pointer;\" [(ngModel)]=\"service.checked\" />\n                    </td>\n                    <td (click)=\"expandService(service)\" data-toggle=\"tooltip\"\n                        [title]=\"'ADDDATA.requestServiceLayers' | translateHs: {app} \" style=\"cursor: pointer;\">\n                        {{service.name}}\n                        <span style=\"font-size: x-small;\"><i class=\"icon-chevron-right\"></i></span>\n                    </td>\n                </tr>\n            </tbody>\n            <tbody *ngFor=\"let layer of data.layers; trackBy:( data.table.trackBy | trackByProperty )\">\n                <tr>\n                    <td><input class=\"checkbox-lg\" type=\"checkbox\" name=\"layer\" style=\"cursor: pointer;\"\n                            (change)=\"changed('layers')\" [(ngModel)]=\"layer.checked\" /></td>\n                    <td hsWmsLayerHighlight (click)=\"hsUrlWmsService.expandTableRow($event)\" class=\"text-truncate\"\n                        style=\"max-width: 45ch;\">{{layer[data.table.nameProperty]}}\n                        <div *ngIf=\"layer.checked && type === 'wmts'\"\n                            class=\"d-flex flex-row justify-content-end align-items-baseline mt-1\">\n                            {{'ADDDATA.CATALOGUE.addAs' | translateHs: {app} }}\n                            <div class=\"btn-group ms-2\">\n                                <button type=\"button\" class=\"btn btn-sm btn-light  btn-outline-secondary\"\n                                    (click)=\"layer.base = true\" [ngClass]=\"{'active':layer.base}\">\n                                    {{'COMPOSITONKEYWORDS.Basemap' | translateHs: {app} }}\n                                </button>\n                                <button type=\"button\" class=\"btn btn-sm btn-light  btn-outline-secondary\"\n                                    (click)=\"layer.base = false\" [ngClass]=\"{'active': !layer.base}\">\n                                    {{'COMMON.layer' | translateHs: {app} }}\n                                </button>\n                            </div>\n                        </div>\n                        <div class=\"alert alert-primary d-flex m-1\" role=\"alert\"\n                            *ngIf=\"layer.featureCount > 1000 && layer.checked && type === 'wfs'\">\n                            <div class=\"w-100\">\n                                <p class=\"mb-0\" style=\"white-space: normal\" [hidden]=\"!layer.limitFeatureCount\">\n                                    {{'ADDLAYERS.WFS.selectedLayerContains' |\n                                    translateHs: {app} }}\n                                    {{layer.featureCount}} {{'ADDLAYERS.WFS.loadingToManyAtOnce' | translateHs: {app} }}\n                                </p>\n                            </div>\n                        </div>\n                    </td>\n                </tr>\n            </tbody>\n        </table>\n    </ng-template>\n    <ng-container *ngIf=\"type === 'wms'\">\n        <div *ngIf=\"reachedLimit()\" class=\"d-flex justify-content-around align-items-center m-3\"><span>\n                {{getLimitTextTranslation()}}</span>\n            <div class=\"btn-group ms-2\">\n                <button type=\"button\" class=\"btn btn-sm btn-light  btn-outline-secondary\"\n                    (click)=\"limitShown = limitShown + 100\">\n                    {{'ADDDATA.CATALOGUE.showNext100' | translateHs: {app} }}\n                </button>\n                <button type=\"button\" class=\"btn btn-sm btn-light  btn-outline-secondary\"\n                    (click)=\"limitShown = data.layers.length\">\n                    {{'ADDDATA.CATALOGUE.showAll' | translateHs: {app} }}\n                </button>\n            </div>\n        </div>\n    </ng-container>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: HsAddDataUrlService }, { type: HsUtilsService }, { type: HsLayerUtilsService }, { type: HsAddDataService }, { type: HsLanguageService }, { type: HsUrlWmsService }, { type: HsAddDataCommonService }]; }, propDecorators: { injectedService: [{
                type: Input
            }], type: [{
                type: Input
            }], app: [{
                type: Input
            }] } });

class HsUrlAddComponent {
    constructor(hsAddDataUrlService) {
        this.hsAddDataUrlService = hsAddDataUrlService;
        this.app = 'default';
        this._selectAll = true;
    }
    /**
     * Select all records from service.
     */
    selectAll() {
        var _a;
        this._selectAll = !this._selectAll;
        this.checkAllRecords(((_a = this.services) === null || _a === void 0 ? void 0 : _a.length) > 0 ? this.services : this.layers);
    }
    checkAllRecords(records) {
        if (!records) {
            return;
        }
        for (const r of records) {
            r.checked = !this._selectAll;
            if (r.Layer) {
                this.checkAllRecords(r.Layer);
            }
        }
        this.changed();
    }
    add() {
        if (this.layers) {
            const layers = this.injectedService.getLayers(this.app, true);
            this.injectedService.addLayers(layers, this.app);
        }
        if (this.injectedService.addServices && this.services) {
            this.injectedService.addServices(this.services, this.app);
        }
        //FIXME: to implement
        // this.injectedService.zoomToLayers();
    }
    changed() {
        var _a, _b;
        this.hsAddDataUrlService.searchForChecked([...((_a = this.layers) !== null && _a !== void 0 ? _a : []), ...((_b = this.services) !== null && _b !== void 0 ? _b : [])], this.app);
    }
}
HsUrlAddComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUrlAddComponent, deps: [{ token: HsAddDataUrlService }], target: i0.ɵɵFactoryTarget.Component });
HsUrlAddComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsUrlAddComponent, selector: "hs-url-add", inputs: { services: "services", app: "app", layers: "layers", injectedService: "injectedService" }, ngImport: i0, template: "<div class=\"w-100 d-flex justify-content-between pb-2 bg-white\" style=\"position: sticky;\n                bottom: 0\">\n  <button class=\"btn btn-primary\" (click)=\"selectAll()\">{{'ADDDATA.URL.selectAll' |\n    translateHs: {app} }}</button>\n  <button class=\"btn btn-primary\" [disabled]=\"!hsAddDataUrlService.apps[app].addingAllowed\"\n    [title]=\"'ADDLAYERS.addSelected' | translateHs: {app} \" (click)=\"add()\">{{'ADDLAYERS.WFS.addToMap' |\n    translateHs: {app} }}</button>\n</div>", pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUrlAddComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-url-add', template: "<div class=\"w-100 d-flex justify-content-between pb-2 bg-white\" style=\"position: sticky;\n                bottom: 0\">\n  <button class=\"btn btn-primary\" (click)=\"selectAll()\">{{'ADDDATA.URL.selectAll' |\n    translateHs: {app} }}</button>\n  <button class=\"btn btn-primary\" [disabled]=\"!hsAddDataUrlService.apps[app].addingAllowed\"\n    [title]=\"'ADDLAYERS.addSelected' | translateHs: {app} \" (click)=\"add()\">{{'ADDLAYERS.WFS.addToMap' |\n    translateHs: {app} }}</button>\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsAddDataUrlService }]; }, propDecorators: { services: [{
                type: Input
            }], app: [{
                type: Input
            }], layers: [{
                type: Input
            }], injectedService: [{
                type: Input
            }] } });

class HsUrlDetailsComponent {
    constructor(hsAddDataCommonService) {
        this.hsAddDataCommonService = hsAddDataCommonService;
        this.app = 'default';
    }
    ngAfterContentInit() {
        this.data = this.injectedService.get(this.app).data;
        this.getDimensionValues = this.hsAddDataCommonService.getDimensionValues;
    }
    srsChanged() {
        this.data.resample_warning = this.hsAddDataCommonService.srsChanged(this.data.srs, this.app);
    }
}
HsUrlDetailsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUrlDetailsComponent, deps: [{ token: HsAddDataCommonService }], target: i0.ɵɵFactoryTarget.Component });
HsUrlDetailsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsUrlDetailsComponent, selector: "hs-url-details", inputs: { injectedService: "injectedService", type: "type", app: "app" }, ngImport: i0, template: "<div [hidden]=\"!hsAddDataCommonService.get(app).showDetails || hsAddDataCommonService.get(app).loadingInfo\"><!-- TODO: Remove function call from template -->\n  <ng-container>\n    <div class=\"form-group\">\n      <div class=\"input-group\">\n        <span class=\"input-group-text control-label\">{{'ADDLAYERS.imageFormat' | translateHs: {app} }}</span>\n        <select class=\"form-control form-select\" name=\"imageFormat\" [(ngModel)]=\"data.image_format\">\n          <option *ngFor=\"let format of data.image_formats\">{{format}}</option>\n        </select>\n      </div>\n    </div>\n\n    <div class=\"form-group\">\n      <div class=\"input-group\">\n        <span class=\"input-group-text control-label\">{{'ADDLAYERS.queryFormat' | translateHs: {app} }}</span>\n        <select class=\"form-control form-select\" name=\"queryFormat\" [(ngModel)]=\"data.query_format\">\n          <option *ngFor=\"let format of data.query_formats\">{{format}}</option>\n        </select>\n      </div>\n    </div>\n\n    <div class=\"form-group\" [hidden]=\"!data.srs || data.srs.toUpperCase() === data.map_projection\">\n      <div class=\"input-group\">\n        <span class=\"input-group-text control-label\">{{'ADDLAYERS.srs' | translateHs: {app} }}</span>\n        <select class=\"form-control form-select form-select\" name=\"srs\" [(ngModel)]=\"data.srs\" (change)=\"srsChanged()\">\n          <option *ngFor=\"let i of data.srss | slice:0:50\">{{i}}</option>\n        </select>\n      </div>\n    </div>\n  </ng-container>\n\n  <div class=\"form-group\" [hidden]=\"data.base === true\">\n    <div class=\"input-group\">\n      <span class=\"input-group-text control-label\">{{'ADDLAYERS.folderName' | translateHs: {app} }}</span>\n      <input class=\"form-control\" name=\"folderName\" [(ngModel)]=\"data.folder_name\" />\n    </div>\n  </div>\n  <ng-container *ngIf=\"type === 'wms' || type === 'arcgis'\">\n    <p class=\"col-sm-12 alert alert-danger\" [hidden]=\"!data.use_resampling\">\n      {{'ADDLAYERS.mapAndLayerProjection' | translateHs: {app} }}\n    </p>\n  </ng-container>\n  <div class=\"form-group\">\n    <div class=\"capabilities_input d-flex flex-column\">\n      <ng-container *ngIf=\"type === 'wms' || type === 'arcgis'\">\n        <label class=\"capabilities_label control-label\"> <input type=\"checkbox\" class=\"me-1 checkbox-lg\" name=\"useTiles\"\n            [(ngModel)]=\"data.use_tiles\" />\n          {{'ADDLAYERS.useTiles' | translateHs: {app} }}\n        </label>\n      </ng-container>\n\n      <label class=\"capabilities_label control-label\"> <input type=\"checkbox\" class=\"me-2 checkbox-lg\"\n          [(ngModel)]=\"data.register_metadata\" name=\"registerMetadata\" />{{'ADDLAYERS.registerMetadata' |\n        translateHs: {app} }}</label>\n    </div>\n  </div>\n  <ng-container *ngIf=\"type === 'wms' || type === 'arcgis'\">\n    <p class=\"col-sm-12 alert alert-warning\" [hidden]=\"data.use_tiles\">\n      {{'ADDLAYERS.considerUsingTiles' | translateHs: {app} }}\n    </p>\n  </ng-container>\n  <ng-container *ngIf=\"type === 'wms'\">\n    <div class=\"form-group\">\n      <div class=\"input-group\">\n        <span class=\"input-group-text control-label\">{{'ADDLAYERS.tileSize' | translateHs: {app} }}</span>\n        <input class=\"form-control\" name=\"tileSize\" [(ngModel)]=\"data.tile_size\" />\n      </div>\n    </div>\n  </ng-container>\n  <div class=\"d-flex flex-column my-3\">\n    <div class=\"d-flex flex-row justify-content-start align-items-baseline mb-1\">\n      {{'ADDDATA.CATALOGUE.addAs' | translateHs: {app} }}\n      <div class=\"btn-group ms-2\">\n        <button type=\"button\" class=\"btn btn-sm btn-light  btn-outline-secondary\" (click)=\"data.base = true\"\n          [ngClass]=\"{'active':data.base}\">\n          {{'COMPOSITONKEYWORDS.Basemap' | translateHs: {app} }}\n        </button>\n        <button type=\"button\" class=\"btn btn-sm btn-light  btn-outline-secondary\" (click)=\"data.base = false\"\n          [ngClass]=\"{'active': !data.base}\">\n          {{'COMMON.layer' | translateHs: {app} }}\n        </button>\n      </div>\n    </div>\n    <div class=\"input-group\">\n      <span class=\"input-group-text control-label\">{{'COMMON.title' | translateHs: {app} }}</span>\n      <input class=\"form-control\" name=\"baseTitle\" [(ngModel)]=\"data.title\" />\n    </div>\n  </div>\n  <ng-container *ngIf=\"type === 'wms'\">\n    <hs-target-position [(addUnder)]=\"data.add_under\" [app]=\"app\"></hs-target-position>\n  </ng-container>\n  <hr />\n  <hs-layer-table [app]=\"app\" [type]=\"type\" [injectedService]=\"injectedService\"> </hs-layer-table>\n  <hs-url-add class=\"w-100\" [injectedService]=\"injectedService\" [services]=\"data.services\" [layers]=\"data.layers\"\n    [app]=\"app\">\n  </hs-url-add>\n</div>\n", components: [{ type: HsLayerTableComponent, selector: "hs-layer-table", inputs: ["injectedService", "type", "app"] }, { type: HsUrlAddComponent, selector: "hs-url-add", inputs: ["services", "app", "layers", "injectedService"] }], directives: [{ type: i3$1.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3$1.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i3$1.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3$1.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], pipes: { "translateHs": TranslateCustomPipe, "slice": i3.SlicePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUrlDetailsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-url-details', template: "<div [hidden]=\"!hsAddDataCommonService.get(app).showDetails || hsAddDataCommonService.get(app).loadingInfo\"><!-- TODO: Remove function call from template -->\n  <ng-container>\n    <div class=\"form-group\">\n      <div class=\"input-group\">\n        <span class=\"input-group-text control-label\">{{'ADDLAYERS.imageFormat' | translateHs: {app} }}</span>\n        <select class=\"form-control form-select\" name=\"imageFormat\" [(ngModel)]=\"data.image_format\">\n          <option *ngFor=\"let format of data.image_formats\">{{format}}</option>\n        </select>\n      </div>\n    </div>\n\n    <div class=\"form-group\">\n      <div class=\"input-group\">\n        <span class=\"input-group-text control-label\">{{'ADDLAYERS.queryFormat' | translateHs: {app} }}</span>\n        <select class=\"form-control form-select\" name=\"queryFormat\" [(ngModel)]=\"data.query_format\">\n          <option *ngFor=\"let format of data.query_formats\">{{format}}</option>\n        </select>\n      </div>\n    </div>\n\n    <div class=\"form-group\" [hidden]=\"!data.srs || data.srs.toUpperCase() === data.map_projection\">\n      <div class=\"input-group\">\n        <span class=\"input-group-text control-label\">{{'ADDLAYERS.srs' | translateHs: {app} }}</span>\n        <select class=\"form-control form-select form-select\" name=\"srs\" [(ngModel)]=\"data.srs\" (change)=\"srsChanged()\">\n          <option *ngFor=\"let i of data.srss | slice:0:50\">{{i}}</option>\n        </select>\n      </div>\n    </div>\n  </ng-container>\n\n  <div class=\"form-group\" [hidden]=\"data.base === true\">\n    <div class=\"input-group\">\n      <span class=\"input-group-text control-label\">{{'ADDLAYERS.folderName' | translateHs: {app} }}</span>\n      <input class=\"form-control\" name=\"folderName\" [(ngModel)]=\"data.folder_name\" />\n    </div>\n  </div>\n  <ng-container *ngIf=\"type === 'wms' || type === 'arcgis'\">\n    <p class=\"col-sm-12 alert alert-danger\" [hidden]=\"!data.use_resampling\">\n      {{'ADDLAYERS.mapAndLayerProjection' | translateHs: {app} }}\n    </p>\n  </ng-container>\n  <div class=\"form-group\">\n    <div class=\"capabilities_input d-flex flex-column\">\n      <ng-container *ngIf=\"type === 'wms' || type === 'arcgis'\">\n        <label class=\"capabilities_label control-label\"> <input type=\"checkbox\" class=\"me-1 checkbox-lg\" name=\"useTiles\"\n            [(ngModel)]=\"data.use_tiles\" />\n          {{'ADDLAYERS.useTiles' | translateHs: {app} }}\n        </label>\n      </ng-container>\n\n      <label class=\"capabilities_label control-label\"> <input type=\"checkbox\" class=\"me-2 checkbox-lg\"\n          [(ngModel)]=\"data.register_metadata\" name=\"registerMetadata\" />{{'ADDLAYERS.registerMetadata' |\n        translateHs: {app} }}</label>\n    </div>\n  </div>\n  <ng-container *ngIf=\"type === 'wms' || type === 'arcgis'\">\n    <p class=\"col-sm-12 alert alert-warning\" [hidden]=\"data.use_tiles\">\n      {{'ADDLAYERS.considerUsingTiles' | translateHs: {app} }}\n    </p>\n  </ng-container>\n  <ng-container *ngIf=\"type === 'wms'\">\n    <div class=\"form-group\">\n      <div class=\"input-group\">\n        <span class=\"input-group-text control-label\">{{'ADDLAYERS.tileSize' | translateHs: {app} }}</span>\n        <input class=\"form-control\" name=\"tileSize\" [(ngModel)]=\"data.tile_size\" />\n      </div>\n    </div>\n  </ng-container>\n  <div class=\"d-flex flex-column my-3\">\n    <div class=\"d-flex flex-row justify-content-start align-items-baseline mb-1\">\n      {{'ADDDATA.CATALOGUE.addAs' | translateHs: {app} }}\n      <div class=\"btn-group ms-2\">\n        <button type=\"button\" class=\"btn btn-sm btn-light  btn-outline-secondary\" (click)=\"data.base = true\"\n          [ngClass]=\"{'active':data.base}\">\n          {{'COMPOSITONKEYWORDS.Basemap' | translateHs: {app} }}\n        </button>\n        <button type=\"button\" class=\"btn btn-sm btn-light  btn-outline-secondary\" (click)=\"data.base = false\"\n          [ngClass]=\"{'active': !data.base}\">\n          {{'COMMON.layer' | translateHs: {app} }}\n        </button>\n      </div>\n    </div>\n    <div class=\"input-group\">\n      <span class=\"input-group-text control-label\">{{'COMMON.title' | translateHs: {app} }}</span>\n      <input class=\"form-control\" name=\"baseTitle\" [(ngModel)]=\"data.title\" />\n    </div>\n  </div>\n  <ng-container *ngIf=\"type === 'wms'\">\n    <hs-target-position [(addUnder)]=\"data.add_under\" [app]=\"app\"></hs-target-position>\n  </ng-container>\n  <hr />\n  <hs-layer-table [app]=\"app\" [type]=\"type\" [injectedService]=\"injectedService\"> </hs-layer-table>\n  <hs-url-add class=\"w-100\" [injectedService]=\"injectedService\" [services]=\"data.services\" [layers]=\"data.layers\"\n    [app]=\"app\">\n  </hs-url-add>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: HsAddDataCommonService }]; }, propDecorators: { injectedService: [{
                type: Input
            }], type: [{
                type: Input
            }], app: [{
                type: Input
            }] } });

class HsUrlArcGisComponent {
    constructor(hsAddDataCommonService, hsUrlArcGisService, hsAddDataOwsService) {
        this.hsAddDataCommonService = hsAddDataCommonService;
        this.hsUrlArcGisService = hsUrlArcGisService;
        this.hsAddDataOwsService = hsAddDataOwsService;
        this.app = 'default';
    }
}
HsUrlArcGisComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUrlArcGisComponent, deps: [{ token: HsAddDataCommonService }, { token: HsUrlArcGisService }, { token: HsAddDataOwsService }], target: i0.ɵɵFactoryTarget.Component });
HsUrlArcGisComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsUrlArcGisComponent, selector: "hs-url-arcgis", inputs: { app: "app" }, ngImport: i0, template: "<form class=\"form-horizontal\" name=\"frmConnectArcgis\" role=\"form\">\n    <hs-common-url type=\"arcgis\" [app]=\"app\" [(url)]=\"hsAddDataCommonService.get(app).url\"\n        (connect)=\"hsAddDataOwsService.connect(app)\">\n    </hs-common-url>\n    <hs-url-progress *ngIf=\"hsAddDataCommonService.get(app).loadingInfo\" [app]=\"app\"></hs-url-progress>\n    <hs-url-details [injectedService]=\"hsUrlArcGisService\" [app]=\"app\" type=\"arcgis\"></hs-url-details>\n</form>", components: [{ type: HsCommonUrlComponent, selector: "hs-common-url", inputs: ["type", "url", "app"], outputs: ["urlChange", "connect"] }, { type: HsUrlProgressComponent, selector: "hs-url-progress", inputs: ["app"] }, { type: HsUrlDetailsComponent, selector: "hs-url-details", inputs: ["injectedService", "type", "app"] }], directives: [{ type: i3$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i3$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i3$1.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUrlArcGisComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-url-arcgis', template: "<form class=\"form-horizontal\" name=\"frmConnectArcgis\" role=\"form\">\n    <hs-common-url type=\"arcgis\" [app]=\"app\" [(url)]=\"hsAddDataCommonService.get(app).url\"\n        (connect)=\"hsAddDataOwsService.connect(app)\">\n    </hs-common-url>\n    <hs-url-progress *ngIf=\"hsAddDataCommonService.get(app).loadingInfo\" [app]=\"app\"></hs-url-progress>\n    <hs-url-details [injectedService]=\"hsUrlArcGisService\" [app]=\"app\" type=\"arcgis\"></hs-url-details>\n</form>" }]
        }], ctorParameters: function () { return [{ type: HsAddDataCommonService }, { type: HsUrlArcGisService }, { type: HsAddDataOwsService }]; }, propDecorators: { app: [{
                type: Input
            }] } });

class HsUrlWfsComponent {
    constructor(hsUrlWfsService, hsAddDataOwsService, hsAddDataCommonService, hsUtilsService, hsConfig) {
        this.hsUrlWfsService = hsUrlWfsService;
        this.hsAddDataOwsService = hsAddDataOwsService;
        this.hsAddDataCommonService = hsAddDataCommonService;
        this.hsUtilsService = hsUtilsService;
        this.hsConfig = hsConfig;
        this.title = ''; //FIXME: unused
        this.app = 'default';
    }
    ngOnInit() {
        this.appRef = this.hsUrlWfsService.get(this.app);
        this.configRef = this.hsConfig.get(this.app);
    }
}
HsUrlWfsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUrlWfsComponent, deps: [{ token: HsUrlWfsService }, { token: HsAddDataOwsService }, { token: HsAddDataCommonService }, { token: HsUtilsService }, { token: HsConfig }], target: i0.ɵɵFactoryTarget.Component });
HsUrlWfsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsUrlWfsComponent, selector: "hs-url-wfs", inputs: { app: "app" }, ngImport: i0, template: "<form class=\"form-horizontal\" name=\"frmConnectWfs\" role=\"form\">\n    <hs-common-url type=\"wfs\" [app]=\"app\" [(url)]=\"hsAddDataCommonService.get(app).url\"\n        (connect)=\"hsAddDataOwsService.connect(app)\">\n    </hs-common-url>\n\n    <hs-url-progress *ngIf=\"hsAddDataCommonService.get(app).loadingInfo\" [app]=\"app\"></hs-url-progress>\n\n    <div *ngIf=\"hsAddDataCommonService.get(app).showDetails && !hsAddDataCommonService.get(app).loadingInfo\"\n        class=\"card p-2\"><!-- TODO: Remove function call from template -->\n\n        <!-- FIXME: unused -->\n        <div class=\"card-title text-center fw-bold\">{{title}}</div>\n        <div class=\"form-floating mb-2\">\n            <input class=\"form-control\" [(ngModel)]=\"appRef.data.folder_name\" name=\"hs-addData-wfs-folder\"\n                placeholder=\"'ADDLAYERS.folderName' | translateHs: {app} \" />\n            <label for=\"hs-addData-wfs-folder\">{{'ADDLAYERS.folderName' | translateHs: {app} }}</label>\n        </div>\n        <ul class=\"list-group\">\n            <hs-layer-table [app]=\"app\" [type]=\"'wfs'\" [injectedService]=\"hsUrlWfsService\"> </hs-layer-table>\n            <li class=\"list-group-item hs-ows-layerlistheading clearfix bg-white\">\n                <div class=\"d-flex justify-content-center\">\n                    <hs-url-add class=\"w-100\" [injectedService]=\"hsUrlWfsService\" [layers]=\"appRef.data.layers\"\n                        [app]=\"app\">\n                    </hs-url-add>\n                    <button *ngIf=\"appRef.loadingFeatures\"\n                        class=\"btn btn-primary w-75\">{{'ADDLAYERS.loadingFeaturePleaseWait' | translateHs: {app} }}<img\n                            class=\"ms-2\" [src]=\"configRef._ajaxLoaderPath\" /></button>\n                </div>\n            </li>\n\n        </ul>\n    </div>\n</form>\n", components: [{ type: HsCommonUrlComponent, selector: "hs-common-url", inputs: ["type", "url", "app"], outputs: ["urlChange", "connect"] }, { type: HsUrlProgressComponent, selector: "hs-url-progress", inputs: ["app"] }, { type: HsLayerTableComponent, selector: "hs-layer-table", inputs: ["injectedService", "type", "app"] }, { type: HsUrlAddComponent, selector: "hs-url-add", inputs: ["services", "app", "layers", "injectedService"] }], directives: [{ type: i3$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i3$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i3$1.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUrlWfsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-url-wfs', template: "<form class=\"form-horizontal\" name=\"frmConnectWfs\" role=\"form\">\n    <hs-common-url type=\"wfs\" [app]=\"app\" [(url)]=\"hsAddDataCommonService.get(app).url\"\n        (connect)=\"hsAddDataOwsService.connect(app)\">\n    </hs-common-url>\n\n    <hs-url-progress *ngIf=\"hsAddDataCommonService.get(app).loadingInfo\" [app]=\"app\"></hs-url-progress>\n\n    <div *ngIf=\"hsAddDataCommonService.get(app).showDetails && !hsAddDataCommonService.get(app).loadingInfo\"\n        class=\"card p-2\"><!-- TODO: Remove function call from template -->\n\n        <!-- FIXME: unused -->\n        <div class=\"card-title text-center fw-bold\">{{title}}</div>\n        <div class=\"form-floating mb-2\">\n            <input class=\"form-control\" [(ngModel)]=\"appRef.data.folder_name\" name=\"hs-addData-wfs-folder\"\n                placeholder=\"'ADDLAYERS.folderName' | translateHs: {app} \" />\n            <label for=\"hs-addData-wfs-folder\">{{'ADDLAYERS.folderName' | translateHs: {app} }}</label>\n        </div>\n        <ul class=\"list-group\">\n            <hs-layer-table [app]=\"app\" [type]=\"'wfs'\" [injectedService]=\"hsUrlWfsService\"> </hs-layer-table>\n            <li class=\"list-group-item hs-ows-layerlistheading clearfix bg-white\">\n                <div class=\"d-flex justify-content-center\">\n                    <hs-url-add class=\"w-100\" [injectedService]=\"hsUrlWfsService\" [layers]=\"appRef.data.layers\"\n                        [app]=\"app\">\n                    </hs-url-add>\n                    <button *ngIf=\"appRef.loadingFeatures\"\n                        class=\"btn btn-primary w-75\">{{'ADDLAYERS.loadingFeaturePleaseWait' | translateHs: {app} }}<img\n                            class=\"ms-2\" [src]=\"configRef._ajaxLoaderPath\" /></button>\n                </div>\n            </li>\n\n        </ul>\n    </div>\n</form>\n" }]
        }], ctorParameters: function () { return [{ type: HsUrlWfsService }, { type: HsAddDataOwsService }, { type: HsAddDataCommonService }, { type: HsUtilsService }, { type: HsConfig }]; }, propDecorators: { app: [{
                type: Input
            }] } });

class HsUrlWmsComponent {
    constructor(hsAddDataCommonService, hsAddDataOwsService, hsUrlWmsService) {
        this.hsAddDataCommonService = hsAddDataCommonService;
        this.hsAddDataOwsService = hsAddDataOwsService;
        this.hsUrlWmsService = hsUrlWmsService;
        this.app = 'default';
    }
}
HsUrlWmsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUrlWmsComponent, deps: [{ token: HsAddDataCommonService }, { token: HsAddDataOwsService }, { token: HsUrlWmsService }], target: i0.ɵɵFactoryTarget.Component });
HsUrlWmsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsUrlWmsComponent, selector: "hs-url-wms", inputs: { app: "app" }, ngImport: i0, template: "<form class=\"form-horizontal\" name=\"frmConnectWms\" role=\"form\">\n    <hs-common-url type=\"wms\" [app]=\"app\" [(url)]=\"hsAddDataCommonService.get(app).url\"\n        (connect)=\"hsAddDataOwsService.connect(app)\">\n    </hs-common-url>\n    <hs-url-progress *ngIf=\"hsAddDataCommonService.get(app).loadingInfo\" [app]=\"app\"></hs-url-progress><!-- TODO: Remove function call from template -->\n    <hs-url-details [injectedService]=\"hsUrlWmsService\" [app]=\"app\" type=\"wms\"></hs-url-details>\n</form>", components: [{ type: HsCommonUrlComponent, selector: "hs-common-url", inputs: ["type", "url", "app"], outputs: ["urlChange", "connect"] }, { type: HsUrlProgressComponent, selector: "hs-url-progress", inputs: ["app"] }, { type: HsUrlDetailsComponent, selector: "hs-url-details", inputs: ["injectedService", "type", "app"] }], directives: [{ type: i3$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i3$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i3$1.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUrlWmsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-url-wms', template: "<form class=\"form-horizontal\" name=\"frmConnectWms\" role=\"form\">\n    <hs-common-url type=\"wms\" [app]=\"app\" [(url)]=\"hsAddDataCommonService.get(app).url\"\n        (connect)=\"hsAddDataOwsService.connect(app)\">\n    </hs-common-url>\n    <hs-url-progress *ngIf=\"hsAddDataCommonService.get(app).loadingInfo\" [app]=\"app\"></hs-url-progress><!-- TODO: Remove function call from template -->\n    <hs-url-details [injectedService]=\"hsUrlWmsService\" [app]=\"app\" type=\"wms\"></hs-url-details>\n</form>" }]
        }], ctorParameters: function () { return [{ type: HsAddDataCommonService }, { type: HsAddDataOwsService }, { type: HsUrlWmsService }]; }, propDecorators: { app: [{
                type: Input
            }] } });

class HsUrlWmtsComponent {
    constructor(hsAddDataOwsService, hsUrlWmtsService, hsAddDataCommonService) {
        this.hsAddDataOwsService = hsAddDataOwsService;
        this.hsUrlWmtsService = hsUrlWmtsService;
        this.hsAddDataCommonService = hsAddDataCommonService;
        this.app = 'default';
    }
    ngOnInit() {
        this.appRef = this.hsUrlWmtsService.get(this.app);
    }
}
HsUrlWmtsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUrlWmtsComponent, deps: [{ token: HsAddDataOwsService }, { token: HsUrlWmtsService }, { token: HsAddDataCommonService }], target: i0.ɵɵFactoryTarget.Component });
HsUrlWmtsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsUrlWmtsComponent, selector: "hs-url-wmts", inputs: { app: "app" }, ngImport: i0, template: "<form class=\"form-horizontal\" name=\"frmConnectWmts\" role=\"form\">\n    <hs-common-url type=\"wmts\" [app]=\"app\" [(url)]=\"hsAddDataCommonService.get(app).url\"\n        (connect)=\"hsAddDataOwsService.connect(app)\">\n    </hs-common-url>\n\n    <hs-url-progress *ngIf=\"hsAddDataCommonService.get(app).loadingInfo\" [app]=\"app\"></hs-url-progress>\n    <div *ngIf=\"hsAddDataCommonService.get(app).showDetails && !hsAddDataCommonService.get(app).loadingInfo\"\n        class=\"card\"><!-- TODO: Remove function call from template -->\n        <ul class=\"list-group\">\n            <li class=\"list-group-item hs-ows-layerlistheading clearfix bg-white\">\n                <div>{{appRef.data.title}}</div>\n            </li>\n            <hs-layer-table [app]=\"app\" [type]=\"'wmts'\" [injectedService]=\"hsUrlWmtsService\"> </hs-layer-table>\n        </ul>\n        <li class=\"list-group-item hs-ows-layerlistheading clearfix bg-white\" style=\"position: sticky;\n        bottom: 0; z-index:10\">\n            <div class=\"d-flex justify-content-center\">\n                <hs-url-add class=\"w-100\" [injectedService]=\"hsUrlWmtsService\" [layers]=\"appRef.data.layers\"\n                    [app]=\"app\">\n                </hs-url-add>\n            </div>\n        </li>\n    </div>\n\n</form>\n", components: [{ type: HsCommonUrlComponent, selector: "hs-common-url", inputs: ["type", "url", "app"], outputs: ["urlChange", "connect"] }, { type: HsUrlProgressComponent, selector: "hs-url-progress", inputs: ["app"] }, { type: HsLayerTableComponent, selector: "hs-layer-table", inputs: ["injectedService", "type", "app"] }, { type: HsUrlAddComponent, selector: "hs-url-add", inputs: ["services", "app", "layers", "injectedService"] }], directives: [{ type: i3$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i3$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i3$1.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUrlWmtsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-url-wmts', template: "<form class=\"form-horizontal\" name=\"frmConnectWmts\" role=\"form\">\n    <hs-common-url type=\"wmts\" [app]=\"app\" [(url)]=\"hsAddDataCommonService.get(app).url\"\n        (connect)=\"hsAddDataOwsService.connect(app)\">\n    </hs-common-url>\n\n    <hs-url-progress *ngIf=\"hsAddDataCommonService.get(app).loadingInfo\" [app]=\"app\"></hs-url-progress>\n    <div *ngIf=\"hsAddDataCommonService.get(app).showDetails && !hsAddDataCommonService.get(app).loadingInfo\"\n        class=\"card\"><!-- TODO: Remove function call from template -->\n        <ul class=\"list-group\">\n            <li class=\"list-group-item hs-ows-layerlistheading clearfix bg-white\">\n                <div>{{appRef.data.title}}</div>\n            </li>\n            <hs-layer-table [app]=\"app\" [type]=\"'wmts'\" [injectedService]=\"hsUrlWmtsService\"> </hs-layer-table>\n        </ul>\n        <li class=\"list-group-item hs-ows-layerlistheading clearfix bg-white\" style=\"position: sticky;\n        bottom: 0; z-index:10\">\n            <div class=\"d-flex justify-content-center\">\n                <hs-url-add class=\"w-100\" [injectedService]=\"hsUrlWmtsService\" [layers]=\"appRef.data.layers\"\n                    [app]=\"app\">\n                </hs-url-add>\n            </div>\n        </li>\n    </div>\n\n</form>\n" }]
        }], ctorParameters: function () { return [{ type: HsAddDataOwsService }, { type: HsUrlWmtsService }, { type: HsAddDataCommonService }]; }, propDecorators: { app: [{
                type: Input
            }] } });

var OverwriteResponse;
(function (OverwriteResponse) {
    OverwriteResponse["cancel"] = "cancel";
    OverwriteResponse["add"] = "add";
    OverwriteResponse["overwrite"] = "overwrite";
})(OverwriteResponse || (OverwriteResponse = {}));

class VectorLayerDescriptor {
    constructor(type, name, title, abstract, url, options, mapProjection) {
        /**
         * Artificial object which is used when layer is saved to composition.
         * It describes format (ol.format.KML, )
         */
        const definition = {};
        this.mapProjection = mapProjection;
        this.layerParams = {
            abstract,
            definition,
            name,
            title,
            opacity: options.opacity || 1,
            fromComposition: options.fromComposition || false,
            style: options.style,
            removable: true,
            path: options.path,
            sld: options.sld,
            visible: options.visible,
            workspace: options.workspace,
            access_rights: options.access_rights,
            queryCapabilities: options.queryCapabilities,
        };
        switch (type ? type.toLowerCase() : '') {
            case 'kml':
                definition.format = 'ol.format.KML';
                definition.url = url;
                break;
            case 'geojson':
                definition.format = 'ol.format.GeoJSON';
                definition.url = url;
                break;
            case 'gpx':
                definition.format = 'ol.format.GPX';
                definition.url = url;
                break;
            case 'sparql':
                definition.format = 'hs.format.Sparql';
                break;
            case 'wfs':
                Object.assign(this.layerParams, {
                    editor: {
                        editable: true,
                        defaultAttributes: {
                            name: title,
                        },
                    },
                });
                break;
            default:
        }
    }
}

/**
 * This function generates vibrant, "evenly spaced" colours (i.e. no clustering). This is ideal for creating easily distinguishable vibrant markers in Google Maps and other apps.
 * Adam Cole, 2011-Sept-14
 * HSV to RBG adapted from: http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript
 * based on http://stackoverflow.com/a/7419630
 * @param numOfSteps
 * @param step
 * @param opacity
 */
function rainbow(numOfSteps, step, opacity) {
    let r, g, b;
    const h = step / (numOfSteps * 1.00000001);
    const i = ~~(h * 4);
    const f = h * 4 - i;
    const q = 1 - f;
    switch (i % 4) {
        case 2:
            (r = f), (g = 1), (b = 0);
            break;
        case 0:
            (r = 0), (g = f), (b = 1);
            break;
        case 3:
            (r = 1), (g = q), (b = 0);
            break;
        case 1:
            (r = 0), (g = 1), (b = q);
            break;
        default:
            (r = 0), (g = 0), (b = 0);
    }
    const c = 'rgba(' +
        ~~(r * 235) +
        ',' +
        ~~(g * 235) +
        ',' +
        ~~(b * 235) +
        ', ' +
        opacity +
        ')';
    return c;
}
/**
 * @param feature_object
 * @param optionsCategoryField
 * @param feature
 * @param category_map
 * @param category_id
 */
function registerCategoryForStatistics(feature_object, optionsCategoryField, feature, category_map, category_id) {
    if (feature_object[optionsCategoryField]) {
        if (typeof category_map[feature_object[optionsCategoryField]] === 'undefined') {
            category_map[feature_object[optionsCategoryField]] = {
                id: category_id,
                name: feature_object[optionsCategoryField],
            };
            category_id++;
        }
        feature.category_id = category_map[feature_object[optionsCategoryField]].id;
    }
}
/**
 * @param objects
 * @param src
 * @param options
 * @param occupied_xy
 * @param category_map
 * @param category_id
 */
function loadFeatures(objects, src, optionsCategoryField, occupied_xy, category_map, category_id, proj) {
    const features = [];
    const format = new WKT();
    for (const key in objects) {
        if (objects[key]['http://www.w3.org/2003/01/geo/wgs84_pos#lat'] &&
            objects[key]['http://www.w3.org/2003/01/geo/wgs84_pos#long'] &&
            objects[key]['http://www.w3.org/2003/01/geo/wgs84_pos#lat'] != '' &&
            objects[key]['http://www.w3.org/2003/01/geo/wgs84_pos#long'] != '') {
            const x = parseFloat(objects[key]['http://www.w3.org/2003/01/geo/wgs84_pos#long']);
            const y = parseFloat(objects[key]['http://www.w3.org/2003/01/geo/wgs84_pos#lat']);
            if (!isNaN(x) && !isNaN(y)) {
                const coord = transform([x, y], 'EPSG:4326', 'EPSG:3857');
                if (typeof occupied_xy[coord.toString()] !== 'undefined') {
                    continue;
                }
                objects[key].geometry = new Point(coord);
                const feature = new Feature(objects[key]);
                registerCategoryForStatistics(objects[key], optionsCategoryField, feature, category_map, category_id);
                occupied_xy[coord.toString()] = true;
                features.push(feature);
            }
        }
        if (objects[key]['http://www.opengis.net/ont/geosparql#asWKT']) {
            const g_feature = format.readFeature(objects[key]['http://www.opengis.net/ont/geosparql#asWKT'].toUpperCase());
            objects[key].geometry = g_feature.getGeometry();
            objects[key].geometry.transform('EPSG:4326', proj);
            delete objects[key]['http://www.opengis.net/ont/geosparql#asWKT'];
            const coord = objects[key].geometry.getCoordinates();
            if (typeof occupied_xy[coord.toString()] !== 'undefined') {
                continue;
            }
            const feature = new Feature(objects[key]);
            registerCategoryForStatistics(objects[key], optionsCategoryField, feature, category_map, category_id);
            occupied_xy[coord] = true;
            features.push(feature);
        }
    }
    for (const categ in category_map) {
        category_map[categ].color = rainbow(category_id, category_map[categ].id, 0.7);
    }
    src.legend_categories = category_map;
    for (let i = 0; i < features.length; i++) {
        if (features[i].category_id) {
            features[i].color = rainbow(category_id, features[i].category_id, 0.7);
        }
    }
    //console.log(features);
    return features;
}
/**
 * @param extend_with_attribs
 * @param objects
 */
function extendAttributes(extend_with_attribs, objects) {
    if (typeof extend_with_attribs != 'undefined') {
        for (const attr_i in extend_with_attribs) {
            for (const i in objects) {
                if (typeof objects[i][extend_with_attribs[attr_i]] == 'undefined') {
                    objects[i][extend_with_attribs[attr_i]] = '';
                }
            }
        }
    }
}
/**
 * Provides a source of features from SPARQL endpoint
 */
class SparqlJson extends Vector {
    /**
     * Only 'projection' and either 'url' or 'endpointUrl' + 'query' are mandatory
     */
    constructor({ category, category_field, clear_on_move, endpointUrl, endpointOptions, extend_with_attribs, geom_attribute, hsproxy = false, optimizeForVirtuoso = false, projection, query, strategy, url, updates_url, }) {
        super({
            format: new GeoJSON(),
            loader: (extent, resolution, projection) => __awaiter(this, void 0, void 0, function* () {
                this.set('loaded', false);
                if (!url && !endpointUrl) {
                    return;
                }
                if (endpointUrl && query) {
                    const queryParts = query.split('<extent>');
                    url =
                        endpointUrl +
                            '?query=' +
                            encodeURIComponent(queryParts[0]) +
                            '<extent>' +
                            encodeURIComponent(queryParts[1]) +
                            '&format=application%2Fsparql-results%2Bjson';
                    console.log(url);
                }
                if (typeof clear_on_move !== 'undefined' && clear_on_move) {
                    this.clear();
                }
                if (typeof geom_attribute === 'undefined') {
                    geom_attribute = 'bif:st_point(xsd:decimal(?lon), xsd:decimal(?lat))';
                }
                let first_pair = [extent[0], extent[1]];
                let second_pair = [extent[2], extent[3]];
                first_pair = transform(first_pair, 'EPSG:3857', 'EPSG:4326');
                second_pair = transform(second_pair, 'EPSG:3857', 'EPSG:4326');
                extent = [...first_pair, ...second_pair];
                const geof = optimizeForVirtuoso
                    ? 'bif:st_may_intersect'
                    : 'geof:sfIntersects';
                /* Do NOT break lines in the POLYGON() section! */
                const s_extent = encodeURIComponent(`FILTER(${geof}(
            "POLYGON((${extent[0]} ${extent[1]}, ${extent[0]} ${extent[3]}, ${extent[2]} ${extent[3]}, ${extent[2]} ${extent[1]}, ${extent[0]} ${extent[1]}))"^^geo:wktLiteral,
          ${geom_attribute}
          )).`);
                const tmp = url.split('query=');
                url =
                    tmp[0] +
                        'query=' +
                        encodeURIComponent('PREFIX geo: <http://www.opengis.net/ont/geosparql#>\n' +
                            'PREFIX geof: <http://www.opengis.net/def/function/geosparql/>\n') +
                        tmp[1];
                url = url.replace(/<extent>/g, s_extent);
                if (hsproxy) {
                    url =
                        '/cgi-bin/hsproxy.cgi?toEncoding=utf-8&url=' +
                            encodeURIComponent(url);
                }
                if (console && typeof this.get('geoname') !== 'undefined') {
                    console.log('Get ', this.get('geoname'));
                }
                this.loadCounter += 1;
                this.loadTotal += 1;
                console.log(url);
                const response = yield fetch(url, {
                    method: 'GET',
                });
                const data = yield response.json();
                /*if (console) {
                  console.log(
                    'Finish ',
                    this.get('geoname'),
                    data.results.bindings.length
                  );
                }*/
                this.loadCounter -= 1;
                if (updates_url) {
                    let updates_query = updates_url;
                    const tmp = updates_query.split('&query=');
                    updates_query =
                        tmp[0] +
                            '&query=' +
                            encodeURIComponent('PREFIX geo: <http://www.opengis.net/ont/geosparql#>\n' +
                                'PREFIX geof: <http://www.opengis.net/def/function/geosparql/>\n') +
                            tmp[1];
                    updates_query = updates_query.replace(/<extent>/g, s_extent);
                    this.loadCounter += 1;
                    this.loadTotal += 1;
                    const response = yield fetch(updates_query, {
                        method: 'GET',
                    });
                    const updates_data = yield response.json();
                    if (console && typeof this.get('geoname') !== 'undefined') {
                        console.log('Finish updates ', this.get('geoname'), data.results.bindings.length, updates_data.results.bindings.length);
                    }
                    const objects = {};
                    for (const item of data.results.bindings) {
                        if (typeof objects[item.o.value] === 'undefined') {
                            objects[item.o.value] = {
                                'poi_id': item.o.value,
                            };
                        }
                        objects[item.o.value][item.p.value] = item.s.value;
                    }
                    for (const item of updates_data.results.bindings) {
                        let attribute_name = item.attr.value;
                        //Because photos can be more than one
                        if (typeof objects[item.o.value][attribute_name] !== 'undefined' &&
                            attribute_name == 'http://xmlns.com/foaf/0.1/depiction') {
                            for (let try_i = 1; try_i < 20; try_i++) {
                                if (typeof objects[item.o.value][attribute_name + try_i] ==
                                    'undefined') {
                                    attribute_name = attribute_name + try_i;
                                    break;
                                }
                            }
                        }
                        objects[item.o.value][attribute_name] = item.value.value;
                    }
                    if (typeof category != 'undefined') {
                        for (const i in objects) {
                            objects[i]['http://www.sdi4apps.eu/poi/#mainCategory'] = category;
                        }
                    }
                    extendAttributes(extend_with_attribs, objects);
                    if (console) {
                        console.log('Add features', objects);
                    }
                    this.addFeatures(loadFeatures(objects, this, category_field, this.occupied_xy, this.category_map, this.category_id, projection));
                    this.loadCounter -= 1;
                    this.set('last_feature_count', Object.keys(objects).length);
                    if (this.loadCounter == 0) {
                        this.set('loaded', true);
                        this.dispatchEvent('imageloadend');
                    }
                }
                else {
                    const objects = {};
                    for (const b of data.results.bindings) {
                        if (objects[b.o.value] === undefined) {
                            objects[b.o.value] = {
                                'poi_id': b.o.value,
                            };
                        }
                        objects[b.o.value][b.p.value] = b.s.value;
                    }
                    if (typeof category !== 'undefined') {
                        for (const i in objects) {
                            objects[i]['http://www.sdi4apps.eu/poi/#mainCategory'] = category;
                        }
                    }
                    extendAttributes(extend_with_attribs, objects);
                    this.addFeatures(loadFeatures(objects, this, category_field, this.occupied_xy, this.category_map, this.category_id, projection));
                    this.styleAble = true;
                    this.hasPoint = true;
                    this.loadCounter -= 1;
                    this.set('last_feature_count', Object.keys(objects).length);
                    if (this.loadCounter == 0) {
                        this.set('loaded', true);
                        this.dispatchEvent('imageloadend');
                    }
                }
            }),
            strategy: strategy !== null && strategy !== void 0 ? strategy : function (extent, resolution) {
                const tmp = [extent[0], extent[1], extent[2], extent[3]];
                if (extent[2] - extent[0] > 65735) {
                    tmp[0] = (extent[2] + extent[0]) / 2.0 - 65735 / 2.0;
                    tmp[2] = (extent[2] + extent[0]) / 2.0 + 65735 / 2.0;
                    tmp[1] = (extent[3] + extent[1]) / 2.0 - 35000 / 2.0;
                    tmp[3] = (extent[3] + extent[1]) / 2.0 + 35000 / 2.0;
                }
                return [tmp];
            },
        });
        this.category_map = {};
        this.category_id = 0;
        this.occupied_xy = {};
        this.loadCounter = 0;
        this.loadTotal = 0;
        this.legend_categories = this.category_map;
    }
}

class VectorSourceFromUrl extends VectorSource {
    constructor(descriptor) {
        super({
            format: descriptor.sourceParams.format,
            url: descriptor.sourceParams.url,
            strategy: loadingStrategy.all,
        });
        this.featureProjection = get(descriptor.sourceParams.srs);
        this.mapProjection = descriptor.mapProjection;
        super.set('extractStyles', descriptor.sourceParams.extractStyles);
        super.setLoader(this.loaderFunction);
    }
    loaderFunction(extent, resolution, projection) {
        const _super = Object.create(null, {
            set: { get: () => super.set },
            getUrl: { get: () => super.getUrl },
            addFeatures: { get: () => super.addFeatures },
            getFormat: { get: () => super.getFormat }
        });
        return __awaiter(this, void 0, void 0, function* () {
            try {
                _super.set.call(this, 'loaded', false);
                const response = yield fetch(_super.getUrl.call(this));
                let data = yield response.text();
                if (data.type == 'GeometryCollection') {
                    const temp = {
                        type: 'Feature',
                        geometry: data,
                    };
                    data = temp;
                }
                _super.addFeatures.call(this, _super.getFormat.call(this).readFeatures(data, {
                    dataProjection: this.featureProjection,
                    featureProjection: this.mapProjection,
                }));
                _super.set.call(this, 'loaded', true);
            }
            catch (err) {
                this.error = true;
                this.errorMessage = err.status;
                _super.set.call(this, 'loaded', true);
            }
        });
    }
}

class VectorSourceDescriptor {
    constructor(type, url, srs, options, mapProjection) {
        this.mapProjection = mapProjection;
        this.sourceParams = {
            fromComposition: options.fromComposition || false,
            srs,
        };
        switch (type ? type.toLowerCase() : '') {
            case 'kml':
                this.sourceParams.url = url;
                this.sourceParams.format = new KML({
                    extractStyles: options.extractStyles,
                });
                this.sourceClass = VectorSourceFromUrl;
                break;
            case 'geojson':
                this.sourceParams.url = url;
                this.sourceParams.format = new GeoJSON();
                this.sourceClass = VectorSourceFromUrl;
                break;
            case 'gpx':
                this.sourceParams.url = url;
                this.sourceParams.format = new GPX();
                this.sourceClass = VectorSourceFromUrl;
                break;
            case 'sparql':
                this.sourceParams = {
                    geom_attribute: '?geom',
                    url: url,
                    category_field: 'http://www.openvoc.eu/poi#categoryWaze',
                    projection: 'EPSG:3857',
                    minResolution: 1,
                    maxResolution: 38,
                    //#####feature_loaded: function(feature){feature.set('hstemplate', 'hs.geosparql_directive')}
                };
                this.sourceClass = SparqlJson;
                break;
            case 'wfs':
                this.sourceClass = VectorSource;
                break;
            default:
                this.sourceClass = VectorSource;
                const format = new GeoJSON();
                let features = options.features || [];
                if (typeof features === 'string') {
                    features = format.readFeatures(options.features, {
                        dataProjection: srs,
                        featureProjection: this.mapProjection,
                    });
                }
                this.sourceParams = {
                    srs,
                    options,
                    features,
                };
        }
    }
}

const PREFER_RESUMABLE_SIZE_LIMIT = 2 * 1024 * 1024; // 2 MB
const SUPPORTED_SRS_LIST = [
    'EPSG:3857',
    'EPSG:4326',
    'EPSG:5514',
    'EPSG:32633',
    'EPSG:32634',
    'EPSG:3034',
    'EPSG:3035',
    'EPSG:3059',
];
/**
 * Get Layman friendly name for layer based on its title by
 * replacing spaces with underscores, converting to lowercase, etc.
 * see https://github.com/jirik/layman/blob/c79edab5d9be51dee0e2bfc5b2f6a380d2657cbd/src/layman/util.py#L30
 * @param title - Title to get Layman-friendly name for
 * @returns New layer name
 */
function getLaymanFriendlyLayerName(title) {
    //TODO: Unidecode on server side or just drop the unsupported letters.
    title = title
        .toLowerCase()
        .replace(/[^\w\s\-\.]/gm, '') //Remove spaces
        .trim()
        .replace(/[\s\-\._]+/gm, '_') //Remove dashes
        .replace(/[^\x00-\x7F]/g, ''); //Remove non-ascii letters https://stackoverflow.com/questions/20856197/remove-non-ascii-character-in-string
    return title;
}
/**
 * Get layman friendly name of layer based primary on name
 * and secondary on title attributes.
 *
 * @param layer - Layer to get the name for
 */
function getLayerName(layer) {
    const layerName = getName(layer) || getTitle(layer);
    if (layerName == undefined) {
        this.$log.warn('Layer title/name not set for', layer);
    }
    return getLaymanFriendlyLayerName(layerName);
}
function wfsNotAvailable(descr) {
    var _a;
    return ((_a = descr.wfs) === null || _a === void 0 ? void 0 : _a.status) == 'NOT_AVAILABLE';
}
function wfsPendingOrStarting(descr) {
    var _a, _b;
    return ((_a = descr.wfs) === null || _a === void 0 ? void 0 : _a.status) == 'PENDING' || ((_b = descr.wfs) === null || _b === void 0 ? void 0 : _b.status) == 'STARTED';
}
function wfsFailed(descr) {
    var _a;
    return ((_a = descr.wfs) === null || _a === void 0 ? void 0 : _a.status) == 'FAILURE';
}
function getSupportedSrsList(ep) {
    if (isAtLeastVersions(ep, '1.16.0')) {
        return SUPPORTED_SRS_LIST;
    }
    return SUPPORTED_SRS_LIST.slice(0, 2);
}
/**
 * @param ep - Layman endpoint
 * @param version - Version which the endpoint version will be compared with
 */
function isAtLeastVersions(ep, version) {
    let epVer = ep.version.split('.').map((part) => parseInt(part));
    const compareVer = version.split('.').map((part) => parseInt(part));
    if (epVer.length != compareVer.length) {
        epVer = epVer.slice(0, (epVer.length - compareVer.length) * -1);
    }
    for (let i = 0; i < epVer.length; i++) {
        if (epVer[i] < compareVer[i]) {
            return false;
        }
    }
    return true;
}

const defaultStyle = `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<StyledLayerDescriptor version="1.0.0" xsi:schemaLocation="http://www.opengis.net/sld StyledLayerDescriptor.xsd" xmlns="http://www.opengis.net/sld" xmlns:ogc="http://www.opengis.net/ogc" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance">
  <NamedLayer>
    <Name/>
    <UserStyle>
      <Name/>
      <Title/>
      <FeatureTypeStyle>
        <Rule>
          <Name/>
          <PointSymbolizer>
            <Graphic>
              <Mark>
                <WellKnownName>circle</WellKnownName>
                <Fill>
                  <CssParameter name="fill">#FFFFFF</CssParameter>
                  <CssParameter name="fill-opacity">0.41</CssParameter>
                </Fill>
                <Stroke>
                  <CssParameter name="stroke">#0099ff</CssParameter>
                  <CssParameter name="stroke-width">1.25</CssParameter>
                </Stroke>
              </Mark>
              <Size>10</Size>
            </Graphic>
          </PointSymbolizer>
          <PolygonSymbolizer>
            <Fill>
              <CssParameter name="fill-opacity">0.45</CssParameter>
            </Fill>
            <Stroke>
              <CssParameter name="stroke">#0099ff</CssParameter>
              <CssParameter name="stroke-width">1.25</CssParameter>
              <CssParameter name="stroke-opacity">0.3</CssParameter>
            </Stroke>
          </PolygonSymbolizer>
          <LineSymbolizer>
            <Stroke>
              <CssParameter name="stroke">#0099ff</CssParameter>
              <CssParameter name="stroke-width">1.25</CssParameter>
            </Stroke>
          </LineSymbolizer>
        </Rule>
      </FeatureTypeStyle>
    </UserStyle>
  </NamedLayer>
</StyledLayerDescriptor>`;
const simple_style = new Style({
    fill: new Fill({
        color: 'rgba(255, 255, 255, 1)',
    }),
    stroke: new Stroke({
        color: '#ffcc33',
        width: 1,
    }),
    image: new Circle({
        radius: 7,
        fill: new Fill({
            color: '#ffcc33',
        }),
    }),
});

const TITLE = 'title';
const HIGHLIGHTED = 'highlighted';
const LABEL = 'label';
const NAME = 'name';
const FEATURES = 'features';
const UNITID = 'unitId';
function setFeatureTitle(feature, title) {
    feature.set(TITLE, title);
}
function getFeatureTitle(feature) {
    return feature.get(TITLE);
}
function setHighlighted(feature, highlighted) {
    feature.set(HIGHLIGHTED, highlighted);
}
function getHighlighted(feature) {
    return feature.get(HIGHLIGHTED);
}
function setFeatureLabel(feature, label) {
    feature.set(LABEL, label);
}
function getFeatureLabel(feature) {
    return feature.get(LABEL);
}
function setFeatureName(feature, name) {
    feature.set(NAME, name);
}
function getFeatureName(feature) {
    return feature.get(NAME);
}
function setFeatures(feature, features) {
    feature.set(FEATURES, features);
}
function getFeatures(feature) {
    return feature.get(FEATURES);
}
function setUnitId(feature, unitId) {
    feature.set(UNITID, unitId);
}
function getUnitId(feature) {
    return feature.get(UNITID);
}
const HsFeatureExt = {
    setFeatureTitle,
    getFeatureTitle,
    setHighlighted,
    getHighlighted,
    setFeatureLabel,
    getFeatureLabel,
    setFeatureName,
    getFeatureName,
    setFeatures,
    getFeatures,
    setUnitId,
    getUnitId,
};

function parseStyle(j) {
    return __awaiter(this, void 0, void 0, function* () {
        const style_json = {};
        if (j.fill) {
            style_json.fill = new Fill({
                color: j.fill,
            });
        }
        if (j.stroke) {
            style_json.stroke = new Stroke({
                color: j.stroke.color,
                width: j.stroke.width,
            });
        }
        if (j.image) {
            if (j.image.type == 'circle') {
                const circle_json = {};
                if (j.image.radius) {
                    circle_json.radius = j.image.radius;
                }
                if (j.image.fill) {
                    circle_json.fill = new Fill({
                        color: j.image.fill,
                    });
                }
                if (j.image.stroke) {
                    circle_json.stroke = new Stroke({
                        color: j.image.stroke.color,
                        width: j.image.stroke.width,
                    });
                }
                style_json.image = new Circle(circle_json);
            }
            if (j.image.type == 'icon') {
                const img = new Image();
                img.src = j.image.src;
                if (img.width == 0) {
                    img.width = 43;
                }
                if (img.height == 0) {
                    img.height = 41;
                }
                const icon_json = {
                    img: img,
                    imgSize: [img.width, img.height],
                    crossOrigin: 'anonymous',
                };
                style_json.image = new Icon(icon_json);
            }
        }
        const sld = yield convertHsStyleToSld(j);
        return { style: new Style(style_json), sld };
    });
}
/**
 * We get serialized layer definition including style definition in custom JSON format.
 * This we need to convert to SLD xml text
 * @param json - Serialized layer which we get from hslayers-ng
 * @param layer - Vector layer to get title from
 */
function convertHsStyleToSld(json) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
        const symbolizers = [];
        if (((_a = json.image) === null || _a === void 0 ? void 0 : _a.type) == 'circle') {
            symbolizers.push(createCircleSymbol(json));
        }
        if (((_b = json.image) === null || _b === void 0 ? void 0 : _b.type) == 'icon') {
            symbolizers.push(createIconSymbol(json));
        }
        if (json.fill) {
            symbolizers.push(createPolygonSymbol(json));
        }
        else if (json.stroke) {
            symbolizers.push(createLineSymbol(json));
        }
        if (symbolizers.length > 0) {
            const name = '';
            const sldModel = {
                name,
                rules: [{ name, symbolizers }],
            };
            const parser = SLDParser.default
                ? new SLDParser.default()
                : new SLDParser();
            return (yield parser.writeStyle(sldModel)).output;
        }
    });
}
/**
 * Create polygon symbolizer configuration from which the
 * geostyler-sld-parser library will generate SLD xml
 * @param json -
 * @returns
 */
function createPolygonSymbol(json) {
    const tmp = {
        kind: 'Fill',
        color: json.fill.color,
    };
    if (json.stroke) {
        Object.assign(tmp, {
            outlineColor: json.stroke.color,
            outlineWidth: json.stroke.width,
        });
    }
    return tmp;
}
/**
 * Create line symbolizer configuration from which the
 * geostyler-sld-parser library will generate SLD xml
 * @param json -
 * @returns
 */
function createLineSymbol(json) {
    const tmp = {
        kind: 'Line',
        color: json.stroke.color,
        width: json.stroke.width,
    };
    return tmp;
}
/**
 * Create circle symbolizer configuration from which the
 * geostyler-sld-parser library will generate SLD xml
 * @param json -
 * @returns
 */
function createCircleSymbol(json) {
    const tmp = {
        kind: 'Mark',
        wellKnownName: 'circle',
        color: json.image.fill.color || json.fill,
        radius: json.image.radius,
    };
    if (json.image.stroke) {
        tmp.strokeColor = json.image.stroke.color;
    }
    else {
        tmp.strokeColor = json.stroke.color;
    }
    if (json.stroke) {
        tmp.strokeWidth = json.stroke.width;
    }
    return tmp;
}
/**
 * Create icon symbolizer configuration from which the
 * geostyler-sld-parser library will generate SLD xml.
 * It must include embedded base64 encoded svg image
 * @param json -
 * @returns
 */
function createIconSymbol(json) {
    return {
        kind: 'Icon',
        offset: [0, 0],
        image: json.image.src.replace('data:image/svg+xml;base64,', 'base64:') +
            `?fill=${encodeURIComponent(json.fill)}&fill-opacity=1&outline=${encodeURIComponent(json.stroke.color)}&outline-opacity=1&outline-width=${json.stroke.width}`,
    };
}

class HsQueryData {
    constructor(queryLayerStyle, hsEventBusService, invisiblePopup) {
        this.attributes = [];
        this.features = [];
        this.featureInfoHtmls = [];
        this.customFeatures = [];
        this.coordinates = [];
        this.featureLayersUnderMouse = [];
        this.dataCleared = true;
        this.queryPoint = new Point([0, 0]);
        this.selector = null;
        this.queryActive = false;
        this.currentQuery = null;
        this.queryLayer = new VectorLayer({
            properties: {
                title: 'Point clicked',
                queryable: false,
                showInLayerManager: false,
                removable: false,
            },
            source: new Vector({
                features: [
                    new Feature$1({
                        geometry: this.queryPoint,
                    }),
                ],
            }),
            style: queryLayerStyle,
        });
        this.hsEventBusService = hsEventBusService;
        this.invisiblePopup = invisiblePopup;
    }
    set(data, type, overwrite) {
        if (type) {
            if (overwrite) {
                this[type].length = 0;
            }
            if (Array.isArray(data)) {
                this[type] = this[type].concat(data);
            }
            else {
                this[type].push(data);
            }
            this.hsEventBusService.queryDataUpdated.next(this);
        }
        else if (console) {
            console.log('Query.BaseService.setData type not passed');
        }
    }
    clear(type) {
        if (type) {
            this[type].length = 0;
        }
        else {
            this.attributes.length = 0;
            this.features.length = 0;
            this.coordinates.length = 0;
            this.featureInfoHtmls = [];
            this.customFeatures = [];
        }
        if (this.invisiblePopup) {
            this.invisiblePopup.contentDocument.body.innerHTML = '';
            this.invisiblePopup.style.height = '0px';
            this.invisiblePopup.style.width = '0px';
        }
        this.dataCleared = true;
    }
}
class HsQueryBaseService {
    constructor(hsMapService, hsConfig, hsLayoutService, hsLanguageService, hsUtilsService, hsEventBusService, hsSaveMapService, domSanitizer, zone) {
        this.hsMapService = hsMapService;
        this.hsConfig = hsConfig;
        this.hsLayoutService = hsLayoutService;
        this.hsLanguageService = hsLanguageService;
        this.hsUtilsService = hsUtilsService;
        this.hsEventBusService = hsEventBusService;
        this.hsSaveMapService = hsSaveMapService;
        this.domSanitizer = domSanitizer;
        this.zone = zone;
        this.popupClassname = '';
        this.nonQueryablePanels = [
            'measure',
            'composition_browser',
            'analysis',
            'sensors',
            // 'draw',
            'tripPlanner',
        ];
        this.getFeatureInfoStarted = new Subject();
        this.getFeatureInfoCollected = new Subject();
        this.queryStatusChanges = new Subject();
        this.vectorSelectorCreated = new Subject();
        this.apps = {};
        this.vectorSelectorCreated.subscribe((data) => {
            this.get(data.app).selector = data.selector;
        });
    }
    /**
     * Get the params saved by the query base service for the current app
     * @param app - App identifier
     * @returns Query base service data for the app
     */
    get(app) {
        if (this.apps[app !== null && app !== void 0 ? app : 'default'] == undefined) {
            this.apps[app !== null && app !== void 0 ? app : 'default'] = new HsQueryData(() => this.pointClickedStyle(app), this.hsEventBusService, this.getInvisiblePopup());
        }
        return this.apps[app !== null && app !== void 0 ? app : 'default'];
    }
    /**
     * Initialize the query base service data and subscribers
     * @param app - App identifier
     */
    init(app) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.hsMapService.loaded(app);
            const appRef = this.get(app);
            this.activateQueries(app);
            this.hsMapService.getMap(app).on('singleclick', (evt) => {
                this.zone.run(() => {
                    this.hsEventBusService.mapClicked.next(Object.assign(evt, {
                        coordinates: this.getCoordinate(evt.coordinate, app),
                        app,
                    }));
                    if (!appRef.queryActive) {
                        return;
                    }
                    this.popupClassname = '';
                    if (!appRef) {
                        appRef.clear();
                    }
                    appRef.dataCleared = false;
                    appRef.currentQuery = (Math.random() + 1).toString(36).substring(7);
                    appRef.set(this.getCoordinate(evt.coordinate, app), 'coordinates', true);
                    appRef.last_coordinate_clicked = evt.coordinate; //It is used in some examples and apps
                    appRef.selectedProj = appRef.coordinates[0].projections[0];
                    this.getFeatureInfoStarted.next({ evt, app });
                });
            });
        });
    }
    /**
     * Get features under the mouse pointer on the map
     * @param map - Current map object
     * @param pixel - Target pixel
     * @param app - App identifier
     * @returns Array with features
     */
    getFeaturesUnderMouse(map, pixel, app) {
        return map
            .getFeaturesAtPixel(pixel)
            .filter((feature) => {
            const layer = this.hsMapService.getLayerForFeature(feature, app);
            return layer && layer != this.get(app).queryLayer;
        });
    }
    /**
     * Get invisible popup element
     * @returns HTML frame element, if the app is running in a browser
     */
    getInvisiblePopup() {
        if (this.hsUtilsService.runningInBrowser()) {
            return document.getElementById('invisible_popup');
        }
    }
    /**
     * Push a new feature info html content to other htmls array
     * @param html - Feature info html content
     * @param app - App identifier
     */
    pushFeatureInfoHtml(html, app) {
        const appRef = this.get(app);
        appRef.featureInfoHtmls.push(this.domSanitizer.bypassSecurityTrustHtml(html));
        appRef.dataCleared = false;
    }
    /**
     * Fill popup iframe and resize it to fit the content
     * @param response - Response of GetFeatureInfoRequest
     * @param append - If true, the response will be appended to iframe's inner HTML, otherwise its content will be replaced
     * @param app - App identifier
     */
    fillIframeAndResize(response, append, app) {
        const iframe = this.getInvisiblePopup();
        if (append) {
            iframe.contentDocument.body.innerHTML += response;
        }
        else {
            iframe.contentDocument.body.innerHTML = response;
        }
        let tmp_width = iframe.contentWindow.innerWidth;
        if (tmp_width >
            this.hsLayoutService.get(app).contentWrapper.querySelector('.hs-ol-map')
                .clientWidth -
                60) {
            tmp_width =
                this.hsLayoutService.get(app).contentWrapper.querySelector('.hs-ol-map')
                    .clientWidth - 60;
        }
        iframe.style.width = tmp_width + 'px';
        let tmp_height = iframe.contentWindow.innerHeight;
        if (tmp_height > 700) {
            tmp_height = 700;
        }
        iframe.style.height = tmp_height + 'px';
    }
    /**
     * Get coordinates in multiple projections
     * @param coordinate - Coordinates from map single click interaction
     * @param app - App identifier
     * @returns Object with coordinates in multiple projections
     */
    getCoordinate(coordinate, app) {
        this.get(app).queryPoint.setCoordinates(coordinate, 'XY');
        const epsg4326Coordinate = transform(coordinate, this.hsMapService.getCurrentProj(app), 'EPSG:4326');
        const coords = {
            name: this.hsLanguageService.getTranslation('QUERY.coordinates', undefined, app),
            mapProjCoordinate: coordinate,
            epsg4326Coordinate,
            projections: [
                {
                    name: 'EPSG:4326',
                    value: toStringHDMS(epsg4326Coordinate),
                },
                {
                    name: 'EPSG:4326',
                    value: createStringXY(7)(epsg4326Coordinate),
                },
                {
                    name: this.hsMapService.getCurrentProj(app).getCode(),
                    value: createStringXY(7)(coordinate),
                },
            ],
        };
        return coords;
    }
    /**
     * Activate queries for the current OL map
     * @param app - App identifier
     */
    activateQueries(app) {
        const appRef = this.get(app);
        if (appRef.queryActive) {
            return;
        }
        appRef.queryActive = true;
        this.hsMapService.getMap(app).addLayer(appRef.queryLayer);
        this.hsSaveMapService.internalLayers.push(appRef.queryLayer);
        this.queryStatusChanges.next({ status: true, app });
    }
    /**
     * Deactivate queries for the current OL map
     * @param app - App identifier
     */
    deactivateQueries(app) {
        const appRef = this.get(app);
        if (!appRef.queryActive) {
            return;
        }
        appRef.queryActive = false;
        this.hsMapService.getMap(app).removeLayer(appRef.queryLayer);
        this.queryStatusChanges.next({ status: false, app });
    }
    /**
     * Check if current app panel is queryable
     * @param app - App identifier
     * @returns - True or false
     */
    currentPanelQueryable(app) {
        return (!this.nonQueryablePanels.includes(this.hsLayoutService.get(app).mainpanel) && !this.nonQueryablePanels.includes('*'));
    }
    /**
     * Get style for point clicked on the map
     * @param app - App identifier
     * @returns - OL style
     */
    pointClickedStyle(app) {
        const defaultStyle = new Style({
            image: new Circle({
                fill: new Fill({
                    color: 'rgba(255, 156, 156, 0.4)',
                }),
                stroke: new Stroke({
                    color: '#cc3333',
                    width: 1,
                }),
                radius: 5,
            }),
        });
        if (this.hsConfig.get(app).queryPoint) {
            const circle = defaultStyle.getImage();
            if (this.hsConfig.get(app).queryPoint == 'hidden') {
                circle.setRadius(0);
            }
            else if (this.hsConfig.get(app).queryPoint == 'notWithin') {
                if (this.get(app).selector.getFeatures().getLength() > 0) {
                    circle.setRadius(0);
                }
            }
        }
        return defaultStyle;
    }
}
HsQueryBaseService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsQueryBaseService, deps: [{ token: HsMapService }, { token: HsConfig }, { token: HsLayoutService }, { token: HsLanguageService }, { token: HsUtilsService }, { token: HsEventBusService }, { token: HsSaveMapService }, { token: i1$3.DomSanitizer }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Injectable });
HsQueryBaseService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsQueryBaseService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsQueryBaseService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsMapService }, { type: HsConfig }, { type: HsLayoutService }, { type: HsLanguageService }, { type: HsUtilsService }, { type: HsEventBusService }, { type: HsSaveMapService }, { type: i1$3.DomSanitizer }, { type: i0.NgZone }]; } });

class HsQueryVectorService {
    constructor(hsQueryBaseService, hsMapService, hsConfig, hsLayerUtilsService, hsUtilsService, hsEventBusService, domSanitizer) {
        this.hsQueryBaseService = hsQueryBaseService;
        this.hsMapService = hsMapService;
        this.hsConfig = hsConfig;
        this.hsLayerUtilsService = hsLayerUtilsService;
        this.hsUtilsService = hsUtilsService;
        this.hsEventBusService = hsEventBusService;
        this.domSanitizer = domSanitizer;
        this.featureRemovals = new Subject();
        this.apps = {};
    }
    /**
     * Get the params saved by the query vector service for the current app
     * @param app - App identifier
     * @returns Query vector service data for the app
     */
    get(app = 'default') {
        if (this.apps[app] == undefined) {
            this.apps[app] = { selector: null };
        }
        return this.apps[app];
    }
    /**
     * Initialize the query vector service data and subscribers
     * @param _app - App identifier
     */
    init(_app) {
        const queryBaseAppRef = this.hsQueryBaseService.get(_app);
        this.hsQueryBaseService.getFeatureInfoStarted.subscribe(({ evt, app }) => {
            if (_app == app) {
                queryBaseAppRef.clear('features');
                if (!queryBaseAppRef.queryActive) {
                    return;
                }
                this.createFeatureAttributeList(app);
            }
        });
        if (this.apps[_app]) {
            return;
        }
        else {
            this.setNewSelector(_app);
            this.hsEventBusService.vectorQueryFeatureSelection.subscribe((e) => {
                if ((e === null || e === void 0 ? void 0 : e.feature) && e.app == _app) {
                    const layer = this.hsMapService.getLayerForFeature(e.feature, _app);
                    if (layer && getOnFeatureSelected(layer)) {
                        const originalFeature = this.getSelectedFeature(e.feature);
                        if (originalFeature) {
                            getOnFeatureSelected(layer)(originalFeature);
                        }
                    }
                }
            });
        }
    }
    /**
     * Set new selector for the app
     * @param _app - App identifier
     */
    setNewSelector(_app) {
        var _a;
        const selector = new Select({
            condition: click,
            multi: ((_a = this.hsConfig.get(_app).query) === null || _a === void 0 ? void 0 : _a.multi)
                ? this.hsConfig.get(_app).query.multi
                : false,
            filter: function (feature, layer) {
                if (layer === null) {
                    return;
                }
                if (getQueryable(layer) === false) {
                    return false;
                }
                else {
                    return true;
                }
            },
        });
        this.get(_app).selector = selector;
        this.hsQueryBaseService.vectorSelectorCreated.next({ selector, app: _app });
        this.hsEventBusService.olMapLoads.subscribe(({ map, app }) => {
            if (_app == app) {
                map.addInteraction(selector);
            }
        });
        selector.getFeatures().on('add', (e) => {
            this.hsEventBusService.vectorQueryFeatureSelection.next({
                feature: e.element,
                selector,
                app: _app,
            });
        });
        selector.getFeatures().on('remove', (e) => {
            this.hsEventBusService.vectorQueryFeatureDeselection.next({
                feature: e.element,
                selector,
            });
        });
    }
    /**
     * Get features under the mouse pointer on the map
     * @param map - Current map object
     * @param pixel - Target pixel
     * @param app - App identifier
     * @returns Array with features
     */
    getFeaturesUnderMouse(map, pixel, app) {
        return map
            .getFeaturesAtPixel(pixel)
            .filter((feature) => {
            const layer = this.hsMapService.getLayerForFeature(feature, app);
            return layer && layer != this.hsQueryBaseService.get(app).queryLayer;
        });
    }
    /**
     * Get selected features original data
     * @param feature - Feature selected
     * @returns Feature
     */
    getSelectedFeature(feature) {
        let original = feature;
        if (getFeatures(original) && getFeatures(original).length == 1) {
            original = getFeatures(original)[0];
        }
        return original;
    }
    /**
     * Create attribute list for all of the features selected with the selector
     * @param app - App identifier
     */
    createFeatureAttributeList(app) {
        const queryBaseAppRef = this.hsQueryBaseService.get(app);
        queryBaseAppRef.attributes.length = 0;
        const features = this.get(app).selector.getFeatures().getArray();
        let featureDescriptions = [];
        for (const feature of features) {
            featureDescriptions = featureDescriptions.concat(this.getFeatureAttributes(feature, app));
        }
        queryBaseAppRef.set(featureDescriptions, 'features');
        this.hsQueryBaseService.getFeatureInfoCollected.next();
    }
    /**
     * Export feature/s in specified format
     * @param clickedFormat - Export format
     * @param feature - Feature or features to export
     * @param app - App identifier
     * @returns Formatted features
     */
    exportData(clickedFormat, feature, app) {
        let fmt;
        const featureArray = Array.isArray(feature) ? feature : [feature];
        switch (clickedFormat) {
            case 'WKT':
                fmt = new WKT();
                return fmt.writeFeatures(featureArray);
            case 'GeoJSON':
            default:
                fmt = new GeoJSON();
                return fmt.writeFeatures(featureArray, {
                    dataProjection: 'EPSG:4326',
                    featureProjection: this.hsMapService.getCurrentProj(app),
                });
        }
    }
    /**
     * Get layer name from the feature selected
     * @param feature - Feature selected
     * @param app - App identifier
     * @returns Layer name
     */
    getFeatureLayerName(feature, app) {
        const layer = this.hsMapService.getLayerForFeature(feature, app);
        return this.hsLayerUtilsService.getLayerName(layer);
    }
    /**
     * Get center coordinates of the selected feature
     * @param feature - Selected feature from the map
     * @returns Center coordinates
     */
    getCentroid(feature) {
        if (feature == undefined) {
            return;
        }
        const center = extent.getCenter(feature.getGeometry().getExtent());
        return center;
    }
    /**
     * Adding a default stats to query based on feature geometry type
     * @param f - Selected feature from the map
     * @param app - App identifier
     * @returns Default feature stats
     */
    addDefaultStats(f, app) {
        const geom = f.getGeometry();
        const type = geom.getType();
        if (type == 'Polygon') {
            const area = this.hsUtilsService.formatArea(geom, this.hsMapService.getCurrentProj(app));
            return [
                { name: `${area.type} in ${area.unit}`, value: area.size },
                { name: 'center', value: toLonLat(this.getCentroid(f)) },
            ];
        }
        if (type == 'LineString') {
            const length = this.hsUtilsService.formatLength(geom, this.hsMapService.getCurrentProj(app));
            return [
                { name: `${length.type} in ${length.unit}`, value: length.size },
                { name: 'center', value: toLonLat(this.getCentroid(f)) },
            ];
        }
        if (type == 'Point') {
            return [{ name: 'center', value: toLonLat(this.getCentroid(f)) }];
        }
    }
    /**
     * Find layer source from the feature selected
     * @param feature - Selected feature from the map
     * @param app - App identifier
     * @returns Vector layer's source
     */
    olSource(feature, app) {
        const layer = this.hsMapService.getLayerForFeature(feature, app);
        if (layer == undefined) {
            return;
        }
        else if (this.hsUtilsService.instOf(layer.getSource(), Cluster)) {
            return layer.getSource().getSource();
        }
        else {
            return layer.getSource();
        }
    }
    /**
     * Check if feature is removable
     * @param feature - Selected feature from the map
     * @param app - App identifier
     * @returns True if feature is removable, false otherwise
     */
    isFeatureRemovable(feature, app) {
        const source = this.olSource(feature, app);
        if (source == undefined) {
            return false;
        }
        const layer = this.hsMapService.getLayerForFeature(feature, app);
        return (this.hsUtilsService.instOf(source, Vector) &&
            this.hsLayerUtilsService.isLayerEditable(layer));
    }
    /**
     * Remove selected feature
     * @param feature - Selected feature from map
     * @param app - App identifier
     */
    removeFeature(feature, app) {
        const source = this.olSource(feature, app);
        if (this.hsUtilsService.instOf(source, Vector)) {
            source.removeFeature(feature);
        }
        this.get(app).selector.getFeatures().remove(feature);
        this.featureRemovals.next(feature);
    }
    /**
     * Handler for querying vector layers of map. Get information about selected feature.
     * @param feature - Selected feature from map
     * @param app - App identifier
     * @returns Feature attributes
     */
    getFeatureAttributes(feature, app) {
        const attributes = [];
        let tmp = [];
        const hstemplate = feature.get('hstemplate')
            ? feature.get('hstemplate')
            : null;
        let customInfoTemplate = null;
        feature.getKeys().forEach((key) => {
            if (['gid', 'geometry', 'wkb_geometry'].indexOf(key) > -1) {
                return;
            }
            if (key == 'features') {
                for (const subFeature of getFeatures(feature)) {
                    tmp = tmp.concat(this.getFeatureAttributes(subFeature, app));
                }
            }
            else {
                const obj = {
                    name: key,
                    value: feature.get(key),
                };
                obj.sanitizedValue = this.sanitizeAttributeValue(feature.get(key));
                attributes.push(obj);
            }
        });
        const layer = this.hsMapService.getLayerForFeature(feature, app);
        if (layer && getCustomInfoTemplate(layer)) {
            customInfoTemplate = getCustomInfoTemplate(layer);
        }
        if (layer && getVirtualAttributes(layer)) {
            const virtualAttributes = getVirtualAttributes(layer);
            for (const key of Object.keys(virtualAttributes)) {
                const value = virtualAttributes[key](feature);
                const obj = {
                    name: key,
                    value,
                };
                obj.sanitizedValue = this.sanitizeAttributeValue(value);
                attributes.push(obj);
            }
        }
        if (!getFeatures(feature)) {
            const featureDescription = {
                layer: this.getFeatureLayerName(feature, app),
                name: 'Feature',
                attributes: attributes,
                stats: this.addDefaultStats(feature, app),
                hstemplate,
                feature,
                customInfoTemplate: this.domSanitizer.bypassSecurityTrustHtml(customInfoTemplate),
            };
            tmp.push(featureDescription);
        }
        return tmp;
    }
    /**
     * Sanitize attribute value to be safe HTML if it is a string
     * @param value - Attribute value
     * @returns Sanitized attribute value
     */
    sanitizeAttributeValue(value) {
        if ((typeof value).toLowerCase() == 'string') {
            return this.domSanitizer.bypassSecurityTrustHtml(value);
        }
        else {
            return;
        }
    }
}
HsQueryVectorService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsQueryVectorService, deps: [{ token: HsQueryBaseService }, { token: HsMapService }, { token: HsConfig }, { token: HsLayerUtilsService }, { token: HsUtilsService }, { token: HsEventBusService }, { token: i1$3.DomSanitizer }], target: i0.ɵɵFactoryTarget.Injectable });
HsQueryVectorService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsQueryVectorService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsQueryVectorService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsQueryBaseService }, { type: HsMapService }, { type: HsConfig }, { type: HsLayerUtilsService }, { type: HsUtilsService }, { type: HsEventBusService }, { type: i1$3.DomSanitizer }]; } });

class HsStylerParams {
    constructor() {
        this.layer = null;
        this.onSet = new Subject();
        this.sldParser = SLDParser.default
            ? new SLDParser.default()
            : new SLDParser();
        this.qmlParser = QGISStyleParser.default
            ? new QGISStyleParser.default()
            : new QGISStyleParser();
        this.colorMapDialogVisible = false;
    }
}
class HsStylerService {
    constructor(hsQueryVectorService, hsUtilsService, hsLayerUtilsService, hsEventBusService, hsLogService, sanitizer, hsMapService, hsSaveMapService, srvLanguage, hsConfig) {
        this.hsQueryVectorService = hsQueryVectorService;
        this.hsUtilsService = hsUtilsService;
        this.hsLayerUtilsService = hsLayerUtilsService;
        this.hsEventBusService = hsEventBusService;
        this.hsLogService = hsLogService;
        this.sanitizer = sanitizer;
        this.hsMapService = hsMapService;
        this.hsSaveMapService = hsSaveMapService;
        this.srvLanguage = srvLanguage;
        this.hsConfig = hsConfig;
        this.apps = { default: new HsStylerParams() };
    }
    get(app) {
        if (this.apps[app !== null && app !== void 0 ? app : ''] == undefined) {
            this.apps[app !== null && app !== void 0 ? app : 'default'] = new HsStylerParams();
        }
        return this.apps[app !== null && app !== void 0 ? app : 'default'];
    }
    init(app) {
        return __awaiter(this, void 0, void 0, function* () {
            const appRef = this.get(app);
            const configRef = this.hsConfig.get(app);
            yield this.hsMapService.loaded(app);
            appRef.pin_white_blue = new Style({
                image: new Icon({
                    src: configRef.assetsPath + 'img/pin_white_blue32.png',
                    crossOrigin: 'anonymous',
                    anchor: [0.5, 1],
                }),
            });
            appRef.pin_white_blue_highlight = (feature, resolution) => {
                return [
                    new Style({
                        image: new Icon({
                            src: configRef.assetsPath + getHighlighted(feature)
                                ? 'img/pin_white_red32.png'
                                : 'img/pin_white_blue32.png',
                            crossOrigin: 'anonymous',
                            anchor: [0.5, 1],
                        }),
                    }),
                ];
            };
            for (const layer of this.hsMapService
                .getLayersArray(app)
                .filter((layer) => this.hsLayerUtilsService.isLayerVectorLayer(layer))) {
                this.initLayerStyle(layer, app);
            }
            this.hsEventBusService.layerAdditions.subscribe((layerDescriptor) => {
                if (this.hsLayerUtilsService.isLayerVectorLayer(layerDescriptor.layer)) {
                    this.initLayerStyle(layerDescriptor.layer, app);
                }
            });
        });
    }
    isVectorLayer(layer) {
        if (this.hsUtilsService.instOf(layer, VectorLayer)) {
            return true;
        }
        else {
            return false;
        }
    }
    /**
     * Get a Source for any vector layer. Both clustered and un-clustered.
     * @param layer - Any vector layer
     * @param isClustered -
     * @returns Source of the input layer or source of its cluster's source
     */
    getLayerSource(layer, isClustered) {
        if (!layer) {
            return;
        }
        let src;
        if (isClustered) {
            src = layer.getSource().getSource();
        }
        else {
            src = layer.getSource();
        }
        return src;
    }
    /**
     * Style clustered layer features using cluster style or individual feature style.
     * @param layer - Any vector layer
     */
    styleClusteredLayer(layer, app) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const appRef = this.get(app);
            yield this.fill(layer, app);
            //Check if layer already has SLD style for clusters
            if (!appRef.styleObject.rules.find((r) => {
                try {
                    /*
                    For clusters SLD styles created by Hslayers have 'AND' rule where the
                    first condition checks if 'features' attribute of a feature is set.
                    See addRule function
                    */
                    return r.filter[1][1] == 'features';
                }
                catch (ex) {
                    return false;
                }
            })) {
                // Remember to clone singleFeatureFilter on usage so the filters
                // don't share the same reference
                const singleFeatureFilter = [
                    '||',
                    ['==', 'features', 'undefined'],
                    ['==', 'features', '[object Object]'],
                ];
                for (const rule of appRef.styleObject.rules) {
                    // Set filter so the original style is applied to features which are not clusters
                    rule.filter =
                        ((_a = rule.filter) === null || _a === void 0 ? void 0 : _a.length) > 0
                            ? ['&&', [...singleFeatureFilter], rule.filter]
                            : [...singleFeatureFilter];
                }
                yield this.addRule('Cluster', app);
            }
            let style = layer.getStyle();
            if (this.hsUtilsService.instOf(appRef.layer.getSource(), Cluster) &&
                this.hsUtilsService.isFunction(style)) {
                style = this.wrapStyleForClusters(style);
                layer.setStyle(style);
            }
        });
    }
    /**
     * Parse style from 'sld' attribute defined in SLD format and convert to OL
     * style which is set on the layer. Also do the opposite if no SLD is defined,
     * because SLD is used in the styler panel.
     *
     * @param layer - OL layer to fill the missing style info
     */
    initLayerStyle(layer, app) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.isVectorLayer(layer)) {
                return;
            }
            let sld = getSld(layer);
            const qml = getQml(layer);
            let style = layer.getStyle();
            if ((!style || style == createDefaultStyle) && !sld && !qml) {
                sld = defaultStyle;
                setSld(layer, defaultStyle);
            }
            if ((sld || qml) && (!style || style == createDefaultStyle)) {
                style = (yield this.parseStyle(sld !== null && sld !== void 0 ? sld : qml, app)).style;
                if (style) {
                    layer.setStyle(style);
                }
                if (getCluster(layer)) {
                    yield this.styleClusteredLayer(layer, app);
                }
            }
            else if (style &&
                !sld &&
                !qml &&
                !this.hsUtilsService.isFunction(style) &&
                !Array.isArray(style)) {
                const customJson = this.hsSaveMapService.serializeStyle(style, app);
                const sld = (yield this.parseStyle(customJson, app)).sld;
                if (sld) {
                    setSld(layer, sld);
                }
            }
            this.get(app).sld = sld;
        });
    }
    /**
     * Parse style encoded as custom JSON or SLD and return OL style object.
     * This function is used to support backwards compatibility with custom format.
     * @param style -
     * @returns OL style object
     */
    parseStyle(style, app) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!style) {
                return {
                    sld: defaultStyle,
                    style: yield this.sldToOlStyle(defaultStyle, app),
                };
            }
            if (typeof style == 'string' &&
                style.includes('StyledLayerDescriptor')) {
                return { sld: style, style: yield this.sldToOlStyle(style, app) };
            }
            if (typeof style == 'string' && style.includes('<qgis')) {
                return { qml: style, style: yield this.qmlToOlStyle(style, app) };
            }
            else if (typeof style == 'object' &&
                !this.hsUtilsService.instOf(style, Style)) {
                //Backwards compatibility with style encoded in custom JSON object
                return parseStyle(style);
            }
            else {
                return { style };
            }
        });
    }
    /**
     * Prepare current layers style for editing by converting
     * SLD attribute string to JSON and reading layers title
     *
     * @param layer - OL layer
     */
    fill(layer, app) {
        return __awaiter(this, void 0, void 0, function* () {
            const appRef = this.get(app);
            const blankStyleObj = { name: 'untitled style', rules: [] };
            try {
                if (!layer) {
                    return;
                }
                appRef.layer = layer;
                appRef.layerTitle = getTitle(layer);
                const sld = getSld(layer);
                const qml = getQml(layer);
                if (sld != undefined) {
                    appRef.styleObject = yield this.sldToJson(sld, app);
                }
                else if (qml != undefined) {
                    appRef.styleObject = yield this.qmlToJson(qml, app);
                }
                else {
                    appRef.styleObject = blankStyleObj;
                }
                this.geostylerWorkaround(app);
            }
            catch (ex) {
                appRef.styleObject = blankStyleObj;
                this.hsLogService.error(ex.message);
            }
        });
    }
    /**
     * Tweak geostyler object attributes to mitigate
     * some discrepancies between opacity and fillOpacity usage
     */
    geostylerWorkaround(app) {
        const appRef = this.get(app);
        if (appRef.styleObject.rules) {
            for (const rule of appRef.styleObject.rules) {
                if (rule.symbolizers) {
                    for (const symbol of rule.symbolizers.filter((symb) => symb.kind == 'Fill')) {
                        symbol.opacity = symbol.fillOpacity;
                    }
                }
            }
        }
    }
    /**
     * Convert SLD to OL style object
     */
    sldToOlStyle(sld, app) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const sldObject = yield this.sldToJson(sld, app);
                return yield this.geoStylerStyleToOlStyle(sldObject);
            }
            catch (ex) {
                this.hsLogService.error(ex);
            }
        });
    }
    /**
     * Convert QML to OL style object
     */
    qmlToOlStyle(qml, app) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const styleObject = yield this.qmlToJson(qml, app);
                return yield this.geoStylerStyleToOlStyle(styleObject);
            }
            catch (ex) {
                this.hsLogService.error(ex);
            }
        });
    }
    geoStylerStyleToOlStyle(sldObject) {
        return __awaiter(this, void 0, void 0, function* () {
            const olConverter = OpenLayersParser.default
                ? new OpenLayersParser.default()
                : new OpenLayersParser();
            const { output: style } = yield olConverter.writeStyle(sldObject);
            return style;
        });
    }
    /**
     * Convert SLD text to JSON which is easier to edit in Angular.
     * @param sld -
     * @returns
     */
    sldToJson(sld, app) {
        return __awaiter(this, void 0, void 0, function* () {
            const { output: sldObject } = yield this.get(app).sldParser.readStyle(sld);
            return sldObject;
        });
    }
    /**
     * Convert QML text to JSON which is easier to edit in Angular.
     * @param qml -
     * @returns
     */
    qmlToJson(qml, app) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.get(app).qmlParser.readStyle(qml);
            if (result.output) {
                return result.output;
            }
            else {
                this.hsLogService.error(result.errors);
            }
        });
    }
    jsonToSld(styleObject, app) {
        return __awaiter(this, void 0, void 0, function* () {
            const { output: sld } = yield this.get(app).sldParser.writeStyle(styleObject);
            return sld;
        });
    }
    addRule(kind, app, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const appRef = this.get(app);
            switch (kind) {
                case 'ColorMap':
                    const colors = colormap({
                        colormap: options.colorMapName,
                        nshades: 11,
                        format: 'hex',
                        alpha: 1,
                    });
                    const step = (options.max - options.min) / 10.0;
                    appRef.styleObject.rules = colors.map((color) => {
                        const ix = colors.indexOf(color);
                        const from = options.min + ix * step;
                        const till = options.min + (ix + 1) * step;
                        return {
                            name: `${from.toFixed(2)} - ${till.toFixed(2)} ${options.attribute}`,
                            filter: [
                                '&&',
                                ['>=', options.attribute, from],
                                ['<', options.attribute, till],
                            ],
                            symbolizers: [
                                {
                                    kind: 'Mark',
                                    color: color,
                                    strokeOpacity: 0.41,
                                    strokeColor: 'white',
                                    strokeWidth: 0.3,
                                    wellKnownName: 'circle',
                                    radius: 5,
                                },
                                {
                                    kind: 'Fill',
                                    color: color,
                                    strokeOpacity: 0.2,
                                },
                            ],
                        };
                    });
                    break;
                case 'Cluster':
                    appRef.styleObject.rules.push({
                        name: 'Cluster rule',
                        filter: [
                            '&&',
                            ['!=', 'features', 'undefined'],
                            ['!=', 'features', '[object Object]'],
                        ],
                        symbolizers: [
                            {
                                kind: 'Mark',
                                color: '#FFFFFF',
                                strokeOpacity: 0.41,
                                strokeColor: '#0099ff',
                                strokeWidth: 2,
                                wellKnownName: 'circle',
                                radius: 10,
                            },
                            {
                                kind: 'Text',
                                label: '{{features}}',
                                size: 12,
                                haloColor: '#fff',
                                color: '#000',
                                offset: [0, 0],
                            },
                        ],
                    });
                    break;
                case 'Simple':
                default:
                    appRef.styleObject.rules.push({
                        name: 'Untitled rule',
                        symbolizers: [],
                    });
            }
            yield this.save(app);
        });
    }
    removeRule(rule, app) {
        return __awaiter(this, void 0, void 0, function* () {
            const appRef = this.get(app);
            appRef.styleObject.rules.splice(appRef.styleObject.rules.indexOf(rule), 1);
            yield this.save(app);
        });
    }
    encodeTob64(str) {
        return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (match, p1) => {
            return String.fromCharCode(parseInt(p1, 16));
        }));
    }
    decodeToUnicode(str) {
        return decodeURIComponent(Array.prototype.map
            .call(atob(str), (c) => {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
            .join(''));
    }
    save(app) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const appRef = this.get(app);
                let style = yield this.geoStylerStyleToOlStyle(appRef.styleObject);
                if (appRef.styleObject.rules.length == 0) {
                    this.hsLogService.warn('Missing style rules for layer', appRef.layer);
                    style = createDefaultStyle;
                }
                /* style is a function when text symbolizer is used. We need some hacking
                for cluster layer in that case to have the correct number of features in
                cluster display over the label */
                if (this.hsUtilsService.instOf(appRef.layer.getSource(), Cluster) &&
                    this.hsUtilsService.isFunction(style)) {
                    style = this.wrapStyleForClusters(style);
                }
                appRef.layer.setStyle(style);
                const sld = yield this.jsonToSld(appRef.styleObject, app);
                setSld(appRef.layer, sld);
                appRef.sld = sld;
                appRef.onSet.next(appRef.layer);
            }
            catch (ex) {
                this.hsLogService.error(ex);
            }
        });
    }
    /**
     * HACK is needed to style cluster layers. It wraps existing OL style function
     * in a function which searches for for Text styles and in them for serialized
     * feature arrays and instead sets the length of this array as the label.
     * If the geostyler text symbolizer had {{features}} as the text label template
     * (which returns the "features" attribute of the parent/cluster feature) and returned
     * '[object Object], [object Object]' the result would become "2".
     * See https://github.com/geostyler/geostyler-openlayers-parser/issues/227
     * @param style -
     * @returns
     */
    wrapStyleForClusters(style) {
        return (feature, resolution) => {
            var _a, _b;
            const tmp = style(feature, resolution);
            if (!tmp) {
                return;
            }
            if (Array.isArray(tmp)) {
                for (const evaluatedStyle of tmp) {
                    if (evaluatedStyle.getText &&
                        ((_b = (_a = evaluatedStyle.getText()) === null || _a === void 0 ? void 0 : _a.getText()) === null || _b === void 0 ? void 0 : _b.includes('[object Object]'))) {
                        const featureListSerialized = evaluatedStyle.getText().getText();
                        const fCount = featureListSerialized
                            .split(',')
                            .length.toString();
                        evaluatedStyle.getText().setText(fCount);
                    }
                }
            }
            return tmp;
        };
    }
    reset(app) {
        return __awaiter(this, void 0, void 0, function* () {
            const appRef = this.get(app);
            setSld(appRef.layer, undefined);
            appRef.layer.setStyle(createDefaultStyle);
            yield this.initLayerStyle(appRef.layer, app);
            yield this.fill(appRef.layer, app);
            yield this.save(app);
        });
    }
    loadSld(sld, app) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const appRef = this.get(app);
                yield appRef.sldParser.readStyle(sld);
                setSld(appRef.layer, sld);
                yield this.fill(appRef.layer, app);
                yield this.save(app);
            }
            catch (err) {
                console.warn('SLD could not be parsed');
            }
        });
    }
}
HsStylerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsStylerService, deps: [{ token: HsQueryVectorService }, { token: HsUtilsService }, { token: HsLayerUtilsService }, { token: HsEventBusService }, { token: HsLogService }, { token: i1$3.DomSanitizer }, { token: HsMapService }, { token: HsSaveMapService }, { token: HsLanguageService }, { token: HsConfig }], target: i0.ɵɵFactoryTarget.Injectable });
HsStylerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsStylerService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsStylerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsQueryVectorService }, { type: HsUtilsService }, { type: HsLayerUtilsService }, { type: HsEventBusService }, { type: HsLogService }, { type: i1$3.DomSanitizer }, { type: HsMapService }, { type: HsSaveMapService }, { type: HsLanguageService }, { type: HsConfig }]; } });

class HsRenameLayerDialogComponent {
    constructor(hsDialogContainerService) {
        this.hsDialogContainerService = hsDialogContainerService;
    }
    ngOnInit() {
        this.newLayerName = this.data.currentName;
    }
    /**
     * @public
     * Close the dialog
     */
    close() {
        this.hsDialogContainerService.destroy(this, this.data.app);
        this.dialogItem.resolve(false);
    }
    /**
     * @public
     * Continue with the new layer name from user's input
     */
    continue() {
        this.hsDialogContainerService.destroy(this, this.data.app);
        this.dialogItem.resolve(this.newLayerName);
    }
    handleKeyUp(e) {
        if (e.key == 'Enter') {
            this.continue();
        }
        else if (e.key == 'Escape') {
            this.close();
        }
    }
}
HsRenameLayerDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsRenameLayerDialogComponent, deps: [{ token: HsDialogContainerService }], target: i0.ɵɵFactoryTarget.Component });
HsRenameLayerDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsRenameLayerDialogComponent, selector: "hs-rename-layer-dialog", ngImport: i0, template: "<div class=\"modal in hs-layer-overwrite-dialog\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n  <div class=\"modal-dialog\">\n    <div class=\"modal-content\">\n      <div class=\"modal-header\">\n        <h4 class=\"modal-title\">{{'COMMON.renameLayer' | translateHs: {app:\n          data.app}\n          }}</h4>\n        <button type=\"button\" (click)=\"close()\" class=\"btn-close\" data-dismiss=\"modal\"\n          attr.aria-label=\"{{'COMMON.close' | translateHs: {app: data.app} }}\">\n        </button>\n      </div>\n      <div class=\"modal-body\" style=\"overflow-y:auto\">\n        <div class=\"form-floating m-2\">\n          <input class=\"form-control\" name=\"name\" [(ngModel)]=\"newLayerName\"\n            placeholder=\"'COMMON.name' | translateHs : data\" (keyup)=\"handleKeyUp($event)\" />\n          <label for=\"name\" class=\"capabilities_label control-label\">{{'COMMON.name' | translateHs : {app:\n            data.app}\n            }}</label>\n        </div>\n      </div>\n      <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-primary compositions-btn-overwrite\" (click)=\"continue()\"\n          data-dismiss=\"modal\" [disabled]=\"!newLayerName\">{{'COMMON.continue' |\n          translateHs: {app: data.app} }}</button>\n\n        <button type=\"button\" class=\"btn btn-secondary compositions-btn-cancel\" (click)=\"close()\"\n          data-dismiss=\"modal\">{{'COMMON.cancel' | translateHs: {app: data.app} }}</button>\n      </div>\n    </div>\n  </div>\n</div>", directives: [{ type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsRenameLayerDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-rename-layer-dialog', template: "<div class=\"modal in hs-layer-overwrite-dialog\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n  <div class=\"modal-dialog\">\n    <div class=\"modal-content\">\n      <div class=\"modal-header\">\n        <h4 class=\"modal-title\">{{'COMMON.renameLayer' | translateHs: {app:\n          data.app}\n          }}</h4>\n        <button type=\"button\" (click)=\"close()\" class=\"btn-close\" data-dismiss=\"modal\"\n          attr.aria-label=\"{{'COMMON.close' | translateHs: {app: data.app} }}\">\n        </button>\n      </div>\n      <div class=\"modal-body\" style=\"overflow-y:auto\">\n        <div class=\"form-floating m-2\">\n          <input class=\"form-control\" name=\"name\" [(ngModel)]=\"newLayerName\"\n            placeholder=\"'COMMON.name' | translateHs : data\" (keyup)=\"handleKeyUp($event)\" />\n          <label for=\"name\" class=\"capabilities_label control-label\">{{'COMMON.name' | translateHs : {app:\n            data.app}\n            }}</label>\n        </div>\n      </div>\n      <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-primary compositions-btn-overwrite\" (click)=\"continue()\"\n          data-dismiss=\"modal\" [disabled]=\"!newLayerName\">{{'COMMON.continue' |\n          translateHs: {app: data.app} }}</button>\n\n        <button type=\"button\" class=\"btn btn-secondary compositions-btn-cancel\" (click)=\"close()\"\n          data-dismiss=\"modal\">{{'COMMON.cancel' | translateHs: {app: data.app} }}</button>\n      </div>\n    </div>\n  </div>\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsDialogContainerService }]; } });

class HsLayerOverwriteDialogComponent {
    constructor(hsDialogContainerService) {
        this.hsDialogContainerService = hsDialogContainerService;
    }
    /**
     * @public
     * Close the dialog
     */
    close() {
        this.hsDialogContainerService.destroy(this, this.data.app);
        this.dialogItem.resolve('cancel');
    }
    /**
     * @public
     * Overwrite the exsiting layer with current layer data
     */
    overwrite() {
        this.hsDialogContainerService.destroy(this, this.data.app);
        this.dialogItem.resolve('overwrite');
    }
    renameAndAdd() {
        return __awaiter(this, void 0, void 0, function* () {
            const renameDialogRef = this.hsDialogContainerService.create(HsRenameLayerDialogComponent, {
                currentName: this.data.dataObj.name,
                app: this.data.app,
            }, this.data.app);
            const result = yield renameDialogRef.waitResult();
            if (!result) {
                //Do nothing
            }
            else {
                this.data.dataObj.name = result;
                this.data.dataObj.title = result;
                this.hsDialogContainerService.destroy(this, this.data.app);
                this.dialogItem.resolve('add');
            }
        });
    }
}
HsLayerOverwriteDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerOverwriteDialogComponent, deps: [{ token: HsDialogContainerService }], target: i0.ɵɵFactoryTarget.Component });
HsLayerOverwriteDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsLayerOverwriteDialogComponent, selector: "hs-layer-overwrite-dialog", ngImport: i0, template: "<div class=\"modal in hs-layer-overwrite-dialog\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h4 class=\"modal-title\">{{'ADDDATA.dialogOverWrite.overwriteExistingLayer' | translateHs: {app:\n                    data.app} }}</h4>\n                <button type=\"button\" (click)=\"close()\" class=\"btn-close\" data-dismiss=\"modal\"\n                    attr.aria-label=\"{{'COMMON.close' | translateHs: {app: data.app} }}\">\n                </button>\n            </div>\n            <div class=\"modal-body\" style=\"overflow-y:auto\">\n                <p class=\"fw-bold h6\">{{'ADDDATA.dialogOverWrite.doYouWishToOverwrite' | translateHs: {app:\n                    data.app } }} {{data.dataObj.name}}?</p>\n                <p *ngIf=\"data.repetive\" class=\"h6 small\">{{'ADDDATA.dialogOverWrite.noteForRepetiveDialog' |\n                    translateHs: {app:\n                    data.app } }}</p>\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-primary compositions-btn-overwrite\" (click)=\"overwrite()\"\n                    data-dismiss=\"modal\">{{'SAVECOMPOSITION.form.overwrite' | translateHs: {app: data.app} }}</button>\n                <button type=\"button\" class=\"btn btn-secondary compositions-btn-cancel\" (click)=\"renameAndAdd()\"\n                    data-dismiss=\"modal\">{{'COMMON.renameLayer' | translateHs:\n                    {app: data.app} }}</button>\n                <button type=\"button\" class=\"btn btn-secondary compositions-btn-cancel\" (click)=\"close()\"\n                    data-dismiss=\"modal\">{{'COMMON.cancel' | translateHs: {app: data.app} }}</button>\n            </div>\n        </div>\n    </div>\n</div>", directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerOverwriteDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-layer-overwrite-dialog', template: "<div class=\"modal in hs-layer-overwrite-dialog\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h4 class=\"modal-title\">{{'ADDDATA.dialogOverWrite.overwriteExistingLayer' | translateHs: {app:\n                    data.app} }}</h4>\n                <button type=\"button\" (click)=\"close()\" class=\"btn-close\" data-dismiss=\"modal\"\n                    attr.aria-label=\"{{'COMMON.close' | translateHs: {app: data.app} }}\">\n                </button>\n            </div>\n            <div class=\"modal-body\" style=\"overflow-y:auto\">\n                <p class=\"fw-bold h6\">{{'ADDDATA.dialogOverWrite.doYouWishToOverwrite' | translateHs: {app:\n                    data.app } }} {{data.dataObj.name}}?</p>\n                <p *ngIf=\"data.repetive\" class=\"h6 small\">{{'ADDDATA.dialogOverWrite.noteForRepetiveDialog' |\n                    translateHs: {app:\n                    data.app } }}</p>\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-primary compositions-btn-overwrite\" (click)=\"overwrite()\"\n                    data-dismiss=\"modal\">{{'SAVECOMPOSITION.form.overwrite' | translateHs: {app: data.app} }}</button>\n                <button type=\"button\" class=\"btn btn-secondary compositions-btn-cancel\" (click)=\"renameAndAdd()\"\n                    data-dismiss=\"modal\">{{'COMMON.renameLayer' | translateHs:\n                    {app: data.app} }}</button>\n                <button type=\"button\" class=\"btn btn-secondary compositions-btn-cancel\" (click)=\"close()\"\n                    data-dismiss=\"modal\">{{'COMMON.cancel' | translateHs: {app: data.app} }}</button>\n            </div>\n        </div>\n    </div>\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsDialogContainerService }]; } });

class HsLaymanService {
    constructor(hsUtilsService, http, hsMapService, hsLogService, hsCommonEndpointsService, hsToastService, hsLanguageService, hsCommonLaymanService) {
        this.hsUtilsService = hsUtilsService;
        this.http = http;
        this.hsMapService = hsMapService;
        this.hsLogService = hsLogService;
        this.hsCommonEndpointsService = hsCommonEndpointsService;
        this.hsToastService = hsToastService;
        this.hsLanguageService = hsLanguageService;
        this.hsCommonLaymanService = hsCommonLaymanService;
        this.pendingLayers = [];
        this.laymanLayerPending = new Subject();
        this.totalProgress = 0;
        this.supportedCRRList = SUPPORTED_SRS_LIST.slice(0, 2);
        this.hsCommonEndpointsService.endpointsFilled.subscribe((data) => __awaiter(this, void 0, void 0, function* () {
            if (data) {
                const laymanEP = data.endpoints.find((ep) => ep.type == 'layman');
                if (laymanEP) {
                    const laymanVersion = yield lastValueFrom(this.http
                        .get(laymanEP.url + '/rest/about/version')
                        .pipe(map((res) => {
                        return {
                            about: {
                                applications: {
                                    layman: {
                                        version: res.about.applications.layman.version,
                                        releaseTimestamp: res.about.applications.layman['release-timestamp'],
                                    },
                                    laymanTestClient: {
                                        version: res.about.applications['layman-test-client']
                                            .version,
                                    },
                                },
                                data: {
                                    layman: {
                                        lastSchemaMigration: res.about.applications['last-schema-migration'],
                                        lastDataMigration: res.about.applications['last-data-migration'],
                                    },
                                },
                            },
                        };
                    })));
                    laymanEP.version = laymanVersion.about.applications.layman.version;
                    this.supportedCRRList = getSupportedSrsList(laymanEP);
                }
            }
        }));
    }
    /**
     * Update composition's access rights
     * @param compName - Composition's name
     * @param endpoint - Endpoint's description
     * @param access_rights - Composition's new access rights
     * @param app - App identifier
     * @returns Promise result of composition's PATCH request
     */
    updateCompositionAccessRights(compName, endpoint, access_rights, app) {
        return __awaiter(this, void 0, void 0, function* () {
            const rights = this.parseAccessRightsForLayman(endpoint, access_rights);
            const formdata = new FormData();
            formdata.append('name', compName);
            formdata.append('access_rights.read', rights.read);
            formdata.append('access_rights.write', rights.write);
            return yield this.makeMapPostPatchRequest(endpoint, endpoint.user, compName, formdata, false, app);
        });
    }
    /**
     * Save composition to Layman's database
     * @param compositionJson - Json with composition's definition
     * @param endpoint - Endpoint's description
     * @param compoData - Additional data for composition
     * @param saveAsNew - Save as new composition
     * @param app - App identifier
     * @returns Promise result of POST
     */
    save(compositionJson, endpoint, compoData, saveAsNew, app) {
        return __awaiter(this, void 0, void 0, function* () {
            const rights = this.parseAccessRightsForLayman(endpoint, compoData.access_rights);
            const formdata = new FormData();
            formdata.append('file', new Blob([JSON.stringify(compositionJson)], {
                type: 'application/json',
            }), 'blob.json');
            formdata.append('name', compoData.name);
            formdata.append('abstract', compoData.abstract);
            formdata.append('access_rights.read', rights.read);
            formdata.append('access_rights.write', rights.write);
            const workspace = compoData.workspace
                ? saveAsNew
                    ? endpoint.user
                    : compoData.workspace
                : endpoint.user;
            return yield this.makeMapPostPatchRequest(endpoint, workspace, compoData.name, formdata, saveAsNew, app, compositionJson);
        });
    }
    /**
     * Save composition to Layman's database
     * @param endpoint - Endpoint's description
     * @param access_rights - Provided access rights
     * @returns Access rights object as two strings, one for read access and the other for write access
     */
    parseAccessRightsForLayman(endpoint, access_rights) {
        const write = access_rights['access_rights.write'] == 'private'
            ? endpoint.user
            : access_rights['access_rights.write'];
        const read = access_rights['access_rights.read'] == 'private'
            ? endpoint.user
            : access_rights['access_rights.read'];
        return { write, read };
    }
    /**
     * Save composition to Layman's database
     * @param endpoint - Endpoint's description
     * @param workspace - Current Layman's workspace
     * @param mapName - Map composition's name
     * @param formdata - FormData object used for sending data over HTTP request
     * @param saveAsNew - Save as new composition
     * @param app - App identifier
     * @param compositionJson - Json with composition's definition
     * @returns Promise result of POST/PATCH request
     */
    makeMapPostPatchRequest(endpoint, workspace, mapName, formdata, saveAsNew, app, compositionJson) {
        return __awaiter(this, void 0, void 0, function* () {
            const headers = new HttpHeaders();
            headers.append('Content-Type', null);
            headers.append('Accept', 'application/json');
            try {
                let response;
                let success = false;
                //Need safety against infinite loop when fixing errors and retrying
                let amendmentsApplied = false;
                //If at First You Don't Succeed, Try, Try Again
                while (!success) {
                    const options = {
                        headers: headers,
                        withCredentials: true,
                    };
                    response = yield lastValueFrom(this.http[saveAsNew ? 'post' : 'patch'](`${endpoint.url}/rest/workspaces/${workspace}/maps${saveAsNew ? `?${Math.random()}` : `/${mapName}`}`, formdata, options)).catch((err) => {
                        this.hsToastService.createToastPopupMessage(this.hsLanguageService.getTranslation('COMMON.setPermissionsError', undefined, app), this.hsLanguageService.getTranslationIgnoreNonExisting('COMMON', 'somethingWentWrong', app), { serviceCalledFrom: 'HsLaymanService' }, app);
                        return err;
                    });
                    //Unsuccessfull request response contains code,detail and message properties
                    if (!response.code) {
                        success = true;
                    }
                    else {
                        if (amendmentsApplied) {
                            break;
                        }
                        if (compositionJson) {
                            featuresTypeFallback(response, compositionJson);
                        }
                        amendmentsApplied = true;
                    }
                }
                return response;
            }
            catch (err) {
                throw err;
            }
        });
    }
    /**
     * Send layer's definition and features to Layman
     * @param endpoint - Endpoint's description
     * @param geojson - Geojson's object with features to send to server
     * @param description - Object containing {name, title, crs, workspace, access_rights} of
     * layer to retrieve
     * @param app - App identifier
     * @returns Promise result of POST/PATCH
     */
    makeUpsertLayerRequest(endpoint, geojson, description, app) {
        return __awaiter(this, void 0, void 0, function* () {
            const formData = new FormData();
            let asyncUpload;
            if (geojson) {
                formData.append('file', new Blob([JSON.stringify(geojson)], { type: 'application/geo+json' }), 'blob.geojson');
                asyncUpload = this.prepareAsyncUpload(formData);
            }
            //Empty blob causes Layman to return “Internal Server Error”
            if (description.sld) {
                formData.append('sld', new Blob([description.sld], { type: 'application/octet-stream' }), 'file.sld');
            }
            formData.append('name', description.name);
            formData.append('title', description.title);
            if (description.crs) {
                formData.append('crs', description.crs);
            }
            if (description.access_rights) {
                const rights = this.parseAccessRightsForLayman(endpoint, description.access_rights);
                formData.append('access_rights.write', rights.write);
                formData.append('access_rights.read', rights.read);
            }
            const headers = new HttpHeaders();
            headers.append('Content-Type', null);
            headers.append('Accept', 'application/json');
            const options = {
                headers: headers,
                withCredentials: true,
            };
            try {
                let layerDesc;
                try {
                    layerDesc = yield this.describeLayer(endpoint, description.name, description.workspace);
                }
                catch (ex) {
                    this.hsLogService.log(`Creating layer ${description.name}`);
                }
                const exists = (layerDesc === null || layerDesc === void 0 ? void 0 : layerDesc.name) ? true : false;
                const res = yield this.tryLoadLayer(endpoint, formData, asyncUpload, (layerDesc === null || layerDesc === void 0 ? void 0 : layerDesc.name) ? description.name : '', app, exists);
                return res;
            }
            catch (err) {
                throw err;
            }
        });
    }
    /**
     * Try to load layer to Layman's server
     * @param endpoint - Endpoint's description
     * @param formData - A set of key/value pairs representing layer fields and values, for HTTP request
     * @param asyncUpload - Async upload data: Async upload state and files to upload
     * @param layerName - Existing layer's name
     * @param app - App identifier
     * @param overwrite - (Optional) Should overwrite existing layer
     * @returns Promise result of POST/PATCH
     */
    tryLoadLayer(endpoint, formData, asyncUpload, layerName, app, overwrite) {
        return __awaiter(this, void 0, void 0, function* () {
            layerName = getLaymanFriendlyLayerName(layerName);
            try {
                let data = yield lastValueFrom(this.http[overwrite ? 'patch' : 'post'](`${endpoint.url}/rest/workspaces/${endpoint.user}/layers${overwrite ? `/${layerName}` : `?${Math.random()}`}`, formData, { withCredentials: true })).catch((err) => {
                    this.hsToastService.createToastPopupMessage(this.hsLanguageService.getTranslation('COMMON.setPermissionsError', undefined, app), this.hsLanguageService.getTranslationIgnoreNonExisting('COMMON', 'somethingWentWrong', app), { serviceCalledFrom: 'HsLaymanService' }, app);
                    return err;
                });
                data = Array.isArray(data) ? data[0] : data;
                //CHECK IF OK not auth etc.
                if (data && !data.code) {
                    if (asyncUpload === null || asyncUpload === void 0 ? void 0 : asyncUpload.async) {
                        const promise = yield this.asyncUpload(asyncUpload.filesToAsyncUpload, data, endpoint);
                        return promise;
                    }
                    else {
                        return data;
                    }
                }
                else {
                    return data;
                }
            }
            catch (error) {
                this.hsLogService.error(error);
            }
        });
    }
    /**
     * Prepare files for async upload if needed
     * @param formData - FormData object for HTTP request
     * @returns File array for async upload
     */
    prepareAsyncUpload(formData) {
        const asyncUpload = { filesToAsyncUpload: [] };
        const sumFileSize = formData
            .getAll('file')
            .filter((f) => f.name)
            .reduce((prev, f) => prev + f.size, 0);
        const async_upload = sumFileSize >= PREFER_RESUMABLE_SIZE_LIMIT;
        if (async_upload) {
            asyncUpload.async = async_upload;
            this.switchFormDataToFileNames(formData, asyncUpload.filesToAsyncUpload);
        }
        return asyncUpload;
    }
    /**
     * Saves files for later upload and switches from files to file names in form data
     * @param formdata - File that will be uploaded
     * @param files_to_async_upload - File array that will get uploaded asynchronously
     */
    switchFormDataToFileNames(formdata, files_to_async_upload) {
        const files = formdata.getAll('file').filter((f) => f.name);
        files_to_async_upload.push(...files);
        const file_names = files.map((f) => f.name);
        formdata.delete('file');
        file_names.forEach((fn) => formdata.append('file', fn));
    }
    /**
     * Use resumable to chunk upload data larger than PREFER_RESUMABLE_SIZE_LIMIT(2MB)
     * @param files_to_async_upload - File array that will get uploaded asynchronously
     * @param data - Layman's response after posting layer
     * @param endpoint - Layman's service endpoint
     */
    asyncUpload(files_to_async_upload, data, endpoint) {
        return new Promise((resolve, reject) => {
            files_to_async_upload = files_to_async_upload.filter((file_to_upload) => !!data['files_to_upload'].find((expected_file) => file_to_upload.name === expected_file.file));
            const layername = data['name'];
            const resumable = new Resumable({
                target: `${endpoint.url}/rest/workspaces/${endpoint.user}/layers/${layername}/chunk`,
                query: {
                    'layman_original_parameter': 'file',
                },
                testChunks: false,
                maxFiles: 3,
                withCredentials: true,
            });
            const chunksProgress = [];
            resumable.on('complete', () => {
                this.hsLogService.log(`Async upload finished successfully!`);
                resolve(data);
            });
            resumable.on('fileError', (file, message) => {
                this.hsLogService.log('fileError', message);
                reject(message);
            });
            resumable.on('fileSuccess', (file, message) => {
                this.hsLogService.log(message);
            });
            resumable.on('fileProgress', (file) => {
                chunksProgress[file.uniqueIdentifier] = file.progress(false);
                const sum = Object.values(chunksProgress).reduce((a, b) => a + b);
                this.totalProgress = sum / files_to_async_upload.length;
            });
            resumable.on('filesAdded', (files) => {
                this.hsLogService.log(`${files.length} files added to Resumable.js, starting async upload.`);
                resumable.upload();
            });
            // add files to Resumable.js, it will fire 'filesAdded' event
            resumable.addFiles(files_to_async_upload);
        });
    }
    /**
     * Create Layman layer if needed and send all features
     * @param endpoint - Layman's endpoint description
     * @param layer - Layer to get Layman friendly name for
     * in order to get features
     * @param withFeatures - Layer state, whether or not it has features
     * @param app - App identifier
     */
    upsertLayer(endpoint, layer, withFeatures, app) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (layer.getSource().loading) {
                return;
            }
            const layerName = getLayerName(layer);
            let layerTitle = getTitle(layer);
            const crsSupported = this.supportedCRRList.includes(this.crs);
            if (((_a = endpoint === null || endpoint === void 0 ? void 0 : endpoint.version) === null || _a === void 0 ? void 0 : _a.split('.').join()) < 171) {
                layerTitle = getLaymanFriendlyLayerName(layerTitle);
            }
            setHsLaymanSynchronizing(layer, true);
            const data = {
                title: layerTitle,
                name: layerName,
                crs: crsSupported ? this.crs : 'EPSG:3857',
                workspace: getWorkspace(layer),
                access_rights: getAccessRights(layer),
                sld: getSld(layer),
            };
            yield this.makeUpsertLayerRequest(endpoint, this.getFeatureGeoJSON(layer.getSource().getFeatures(), crsSupported, withFeatures), data, app);
            setTimeout(() => __awaiter(this, void 0, void 0, function* () {
                yield this.makeGetLayerRequest(endpoint, layer, app);
                setHsLaymanSynchronizing(layer, false);
            }), 2000);
        });
    }
    getFeatureGeoJSON(features, crsSupported, withFeatures) {
        const f = new GeoJSON();
        let geojson;
        if (withFeatures) {
            if (!crsSupported) {
                geojson = f.writeFeaturesObject(features.map((f) => {
                    const f2 = f.clone();
                    f2.getGeometry().transform(this.crs, 'EPSG:3857');
                    return f2;
                }));
            }
            else {
                geojson = f.writeFeaturesObject(features);
            }
            return geojson;
        }
        else {
            return;
        }
    }
    /**
     * Sync WFS features using transaction. Publish layer first if needed
     * @param param0 - Object describing endpoint, layer and arrays
     * for each of the methods: update, del, insert containing the features to be processed
     * @param ep - Layman's endpoint description
     * @param add - Features being added
     * @param upd - Features being uploaded
     * @param del - Features being deleted
     * @param layer - Layer interacted with
     * @param app - App identifier
     * @returns Promise result of POST
     */
    sync({ ep, add, upd, del, layer }, app) {
        return __awaiter(this, void 0, void 0, function* () {
            /* Clone because endpoint.user can change while the request is processed
            and then description might get cached even if anonymous user was set before.
            Should not cache anonymous layers, because layer can be authorized anytime */
            const endpoint = Object.assign({}, ep);
            try {
                let desc = getLaymanLayerDescriptor(layer);
                const name = getLayerName(layer);
                try {
                    if (!desc) {
                        desc = yield this.describeLayer(endpoint, name, getWorkspace(layer));
                        this.cacheLaymanDescriptor(layer, desc, endpoint);
                    }
                    if (desc.name == undefined || desc.wfs.url == undefined) {
                        throw `Layer or its name/url didn't exist`;
                    }
                }
                catch (ex) {
                    this.hsLogService.warn(`Layer ${name} didn't exist. Creating..`);
                    this.upsertLayer(ep, layer, true, app);
                    return;
                }
                desc.wfs.url = desc.wfs.url;
                return this.makeWfsRequest({ ep: endpoint, add, upd, del, layer }, desc.wfs.url, app);
            }
            catch (ex) {
                throw ex;
            }
        });
    }
    /**
     * Make WFS transaction request
     * @param param0 - Object describing endpoint, layer and arrays
     * for each of the methods: update, del, insert containing the features to be processed
     * @param ep - Layman's endpoint description
     * @param add - Features being added
     * @param upd - Features being uploaded
     * @param del - Features being deleted
     * @param layer - Layer interacted with
     * @param app - App identifier
     * @returns Promise result of POST
     */
    makeWfsRequest({ ep, add, upd, del, layer }, url, app) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const srsName = this.hsMapService.getCurrentProj(app).getCode();
                const featureType = getLayerName(layer);
                const wfsFormat = new WFS();
                const options = {
                    featureNS: 'http://' + ep.user,
                    featurePrefix: ep.user,
                    featureType,
                    srsName,
                    nativeElements: null,
                };
                const featureNode = wfsFormat.writeTransaction(add, upd, del, options);
                const headers = new HttpHeaders();
                headers.append('Content-Type', 'application/xml');
                headers.append('Accept', 'application/xml');
                const httpOptions = {
                    headers,
                    responseType: 'text',
                    withCredentials: true,
                };
                const body = featureNode.outerHTML
                    .replace(/<geometry>/gm, '<wkb_geometry>')
                    .replace(/<\/geometry>/gm, '</wkb_geometry>');
                const r = yield lastValueFrom(this.http.post(url, body, httpOptions));
                return r;
            }
            catch (ex) {
                this.hsLogService.error(ex);
            }
        });
    }
    /**
     * Cache Layman's layer descriptor so it can be used layer on
     * @param layer - Layer interacted with
     * @param layer - Layman's layer descriptor
     * @param endpoint - Layman's endpoint description
     */
    cacheLaymanDescriptor(layer, desc, endpoint) {
        if (endpoint.user != 'browser') {
            setLaymanLayerDescriptor(layer, desc);
        }
    }
    /**
     * Retrieve layer's features from server
     * @param ep - Layman's endpoint description
     * @param layer - Layer interacted with
     * @returns Promise with WFS xml (GML3.1) response
     * with features for a specified layer
     */
    makeGetLayerRequest(ep, layer, app) {
        return __awaiter(this, void 0, void 0, function* () {
            /* Clone because endpoint.user can change while the request is processed
            and then description might get cached even if anonymous user was set before.
            Should not cache anonymous layers, because layer can be authorized anytime */
            const endpoint = Object.assign({}, ep);
            let descr;
            const layerName = getLayerName(layer);
            try {
                descr = yield this.describeLayer(endpoint, layerName, getWorkspace(layer));
                if (descr === null || //In case of response?.code == 15 || 32
                    (descr.wfs.status == descr.wms.status && wfsNotAvailable(descr))) {
                    return null;
                }
                else if ((descr === null || descr === void 0 ? void 0 : descr.name) && !wfsNotAvailable(descr)) {
                    this.cacheLaymanDescriptor(layer, descr, endpoint);
                }
            }
            catch (ex) {
                //If Layman returned 404
                return null;
            }
            try {
                /* When OL will support GML3.2, then we can use WFS
                  version 2.0.0. Currently only 3.1.1 is possible */
                const response = yield lastValueFrom(this.http.get(descr.wfs.url +
                    '?' +
                    this.hsUtilsService.paramsToURL({
                        service: 'wfs',
                        version: '1.1.0',
                        request: 'GetFeature',
                        typeNames: `${getWorkspace(layer)}:${descr.name}`,
                        r: Math.random(),
                        srsName: this.hsMapService.getCurrentProj(app).getCode(),
                    }), { responseType: 'text', withCredentials: true }));
                return response;
            }
            catch (ex) {
                return null;
            }
        });
    }
    /**
     * Try getting layer's description from Layman.
     * @param endpoint - Layman's endpoint description
     * @param layerName - Interacted layer's name
     * @param workspace - Current Layman's workspace
     * @returns Promise which returns layers
     * description containing name, file, WMS, WFS urls etc.
     */
    describeLayer(endpoint, layerName, workspace, ignoreStatus) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                layerName = getLaymanFriendlyLayerName(layerName); //Better safe than sorry
                const response = yield lastValueFrom(this.http.get(`${endpoint.url}/rest/workspaces/${workspace}/layers/${layerName}?${Math.random()}`, {
                    withCredentials: true,
                }));
                switch (true) {
                    case (response === null || response === void 0 ? void 0 : response.code) == 15 ||
                        (response === null || response === void 0 ? void 0 : response.code) == 15 ||
                        wfsFailed(response):
                        return null;
                    case response.name && ignoreStatus:
                        return response;
                    case response.wfs &&
                        (wfsPendingOrStarting(response) || ((_a = response.wfs) === null || _a === void 0 ? void 0 : _a.url) == undefined):
                        if (!this.pendingLayers.includes(layerName)) {
                            this.pendingLayers.push(layerName);
                            this.laymanLayerPending.next(this.pendingLayers);
                        }
                        yield new Promise((resolve) => setTimeout(resolve, 3500));
                        return this.describeLayer(endpoint, layerName, workspace);
                    default:
                        if (response.name) {
                            this.managePendingLayers(layerName);
                            return response;
                        }
                }
            }
            catch (ex) {
                this.managePendingLayers(layerName);
                this.hsLogService.error(ex);
                throw ex;
            }
        });
    }
    /**
     * Keep track of pending layers that are still being loaded
     * @param layerName - Interacted layer's name
     */
    managePendingLayers(layerName) {
        if (this.pendingLayers.includes(layerName)) {
            this.pendingLayers = this.pendingLayers.filter((layer) => layer != layerName);
            this.laymanLayerPending.next(this.pendingLayers);
        }
    }
    /**
     * Removes selected layer from Layman's database
     * @param app - App identifier
     * @param layer - (Optional) Layer to be removed
     */
    removeLayer(app, layer) {
        return __awaiter(this, void 0, void 0, function* () {
            let success;
            return new Promise((resolve, reject) => {
                if (this.deleteQuery) {
                    this.deleteQuery.unsubscribe();
                    delete this.deleteQuery;
                }
                const observables = [];
                (this.hsCommonEndpointsService.endpoints || [])
                    .filter((ds) => ds.type == 'layman')
                    .forEach((ds) => {
                    let url;
                    if (layer) {
                        const layerName = typeof layer == 'string' ? layer : getLayerName(layer);
                        url = `${ds.url}/rest/workspaces/${ds.user}/layers/${layerName}`;
                    }
                    else {
                        url = `${ds.url}/rest/workspaces/${ds.user}/layers`;
                    }
                    const response = this.http
                        .delete(url, {
                        withCredentials: true,
                    })
                        .pipe(map((res) => {
                        this.hsToastService.removeByText(this.hsLanguageService.getTranslation('LAYMAN.deletionInProgress', undefined, app), app);
                        const response = Array.isArray(res) ? res[0] : res;
                        if (response === null || response === void 0 ? void 0 : response.code) {
                            this.hsCommonLaymanService.displayLaymanError(ds, 'LAYMAN.deleteLayersRequest', response, app);
                            success = false;
                        }
                        else {
                            let message = 'LAYMAN.layerSuccessfullyRemoved';
                            if (!layer) {
                                message = 'LAYMAN.allLayersSuccessfullyRemoved';
                            }
                            const details = Array.isArray(res)
                                ? res.map((item) => item.name)
                                : [res.name];
                            this.hsToastService.createToastPopupMessage('LAYMAN.deleteLayersRequest', message, {
                                toastStyleClasses: 'bg-success text-light',
                                details,
                            }, app);
                            success = true;
                        }
                    }), catchError((e) => {
                        var _a;
                        this.hsToastService.createToastPopupMessage(this.hsLanguageService.getTranslation('LAYMAN.deleteLayersRequest', undefined, app), this.hsLanguageService.getTranslationIgnoreNonExisting('SAVECOMPOSITION', 'removeLayerError', {
                            error: (_a = e.error.message) !== null && _a !== void 0 ? _a : e.message,
                            layer: layer instanceof Layer
                                ? layer.get('title')
                                : layer,
                        }, app), { serviceCalledFrom: 'HsLaymanService' }, app);
                        success = false;
                        return of(e);
                    }));
                    observables.push(response);
                });
                this.deleteQuery = forkJoin(observables).subscribe(() => {
                    resolve(success);
                });
            });
        });
    }
    /**
     * Get Layman's endpoint description
     * @returns Layman's endpoint description
     */
    getLaymanEndpoint() {
        var _a;
        return (_a = this.hsCommonEndpointsService.endpoints) === null || _a === void 0 ? void 0 : _a.find(
        //FIXME..."?" was not there before multiple apps. Added to bypass while refactoring other
        (e) => e.type == 'layman');
    }
    /**
     * Check if the current Layman's user is anonymous (Not logged in)
     * @returns True if user is not logged in, false otherwise
     */
    isLaymanGuest() {
        const endpoint = this.getLaymanEndpoint();
        return endpoint.user == 'anonymous' || endpoint.user == 'browser';
    }
}
HsLaymanService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLaymanService, deps: [{ token: HsUtilsService }, { token: i1.HttpClient }, { token: HsMapService }, { token: HsLogService }, { token: HsCommonEndpointsService }, { token: HsToastService }, { token: HsLanguageService }, { token: HsCommonLaymanService }], target: i0.ɵɵFactoryTarget.Injectable });
HsLaymanService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLaymanService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLaymanService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsUtilsService }, { type: i1.HttpClient }, { type: HsMapService }, { type: HsLogService }, { type: HsCommonEndpointsService }, { type: HsToastService }, { type: HsLanguageService }, { type: HsCommonLaymanService }]; } });
/**
 * Mend error when features are not encoded as string.
 * They would not need to be encoded in the future, but for now Layman
 * and composition schema requires them to be.
 * @param response - Response containing error about features
 * @param compositionJson  - Composition json being sent on first try
 */
function featuresTypeFallback(response, compositionJson) {
    if (response.code == 2 &&
        response.detail &&
        response.detail['validation-errors'] &&
        response.detail['validation-errors'].some((er) => er.message.startsWith("{'type': 'FeatureCollection'"))) {
        for (const layer of compositionJson.layers.filter((l) => l.features && typeof l.features !== 'string')) {
            layer.features = JSON.stringify(layer.features);
        }
    }
}

const FILE_UPLOAD_SIZE_LIMIT = 10 * 1024 * 1024; //10MB
class HsAddDataCommonFileServiceParams {
    constructor() {
        this.readingData = false;
        this.loadingToLayman = false;
        this.asyncLoading = false;
        this.endpoint = null;
        this.layerAddedAsWms = new Subject();
        this.dataObjectChanged = new Subject();
        this.fileUploadErrorHeader = 'ADDLAYERS.couldNotUploadSelectedFile';
    }
}
class HsAddDataCommonFileService {
    constructor(hsLog, hsToastService, hsAddDataService, hsLanguageService, hsCommonEndpointsService, hsLaymanService, hsAddDataOwsService, hsDialogContainerService, hsUtilsService, hsAddDataUrlService) {
        this.hsLog = hsLog;
        this.hsToastService = hsToastService;
        this.hsAddDataService = hsAddDataService;
        this.hsLanguageService = hsLanguageService;
        this.hsCommonEndpointsService = hsCommonEndpointsService;
        this.hsLaymanService = hsLaymanService;
        this.hsAddDataOwsService = hsAddDataOwsService;
        this.hsDialogContainerService = hsDialogContainerService;
        this.hsUtilsService = hsUtilsService;
        this.hsAddDataUrlService = hsAddDataUrlService;
        this.apps = { default: new HsAddDataCommonFileServiceParams() };
    }
    /**
     * Get the params saved by the add data common file service for the current app
     * @param app - App identifier
     */
    get(app) {
        if (this.apps[app !== null && app !== void 0 ? app : 'default'] == undefined) {
            this.apps[app !== null && app !== void 0 ? app : 'default'] = new HsAddDataCommonFileServiceParams();
        }
        return this.apps[app !== null && app !== void 0 ? app : 'default'];
    }
    /**
     * Clear service param values to default values
     * @param app - App identifier
     */
    clearParams(app) {
        const appRef = this.get(app);
        appRef.asyncLoading = false;
        appRef.endpoint = null;
        appRef.loadingToLayman = false;
        this.hsLaymanService.totalProgress = 0;
    }
    /**
     * Check if provided url exists and is obtainable
     * @param url - Provided url
     * @param app - App identifier
     */
    isUrlObtainable(url, app) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!url || url === '') {
                return;
            }
            url = this.hsUtilsService.proxify(url, app);
            try {
                const response = yield fetch(url, {
                    method: 'GET',
                });
                if (response.status === 200) {
                    return true;
                }
                else {
                    this.hsAddDataUrlService.apps[app].addDataCapsParsingError.next(response.statusText);
                    return;
                }
            }
            catch (e) {
                this.hsAddDataUrlService.apps[app].addDataCapsParsingError.next(e.message);
                return;
            }
        });
    }
    /**
     * From available endpoints picks one
     * - either Layman endpoint if available or any other if not
     * @param app - App identifier
     */
    pickEndpoint(app) {
        const appRef = this.get(app);
        const endpoints = this.hsCommonEndpointsService.endpoints;
        if (endpoints && endpoints.length > 0) {
            const laymans = endpoints.filter((ep) => ep.type == 'layman');
            if (laymans.length > 0) {
                appRef.endpoint = laymans[0];
            }
            else {
                appRef.endpoint = endpoints[0];
            }
            if (appRef.endpoint && appRef.endpoint.type == 'layman') {
                appRef.endpoint.getCurrentUserIfNeeded(appRef.endpoint, app);
            }
        }
    }
    /**
     * Get tooltip translated text
     * @param data - File data object provided
     * @param app - App identifier
     * @returns Translated string
     */
    getToolTipText(data, app) {
        if (!data.srs) {
            return this.hsLanguageService.getTranslationIgnoreNonExisting('ADDLAYERS', 'SRSRequired', undefined, app);
        }
        else {
            return this.hsLanguageService.getTranslationIgnoreNonExisting('DRAW.drawToolbar', 'addLayer', undefined, app);
        }
    }
    /**
     * Validate files before upload
     * @param files - Files provided for upload
     * @param app - App identifier
     * @returns True, if files are valid for upload, false otherwise
     */
    filesValid(files, app) {
        let isValid = true;
        if (files.find((f) => f.name.endsWith('shp') && f.size > FILE_UPLOAD_SIZE_LIMIT)) {
            this.hsToastService.createToastPopupMessage('ADDLAYERS.SHP.exceedingSize', 'ADDLAYERS.SHP.considerUsingZip', {
                serviceCalledFrom: 'HsAddDataCommonFileService',
                toastStyleClasses: 'bg-warning text-white',
            }, app);
        }
        const zipFilesCount = files.filter((file) => this.isZip(file.type)).length;
        if (zipFilesCount === 1 && files.length > 1) {
            this.displayErrorMessage({
                message: 'ADDDATA.FILE.zipFileCannotBeUploaded',
            }, app);
            isValid = false;
        }
        if (zipFilesCount > 1) {
            isValid = false;
            this.displayErrorMessage({ message: 'ADDDATA.FILE.onlyOneZipFileCan' }, app);
        }
        return isValid;
    }
    /**
     * Check if file is a zip archive
     * @param type - Uploaded file type
     * @returns True, if upload file is a zip file, false otherwise
     */
    isZip(type) {
        return [
            'application/zip',
            'application/x-zip',
            'application/x-zip-compressed',
        ].includes(type);
    }
    /**
     * Check if file is a geotiff image
     * @param type - Uploaded file type
     * @returns True, if upload file is a geotiff image, false otherwise
     */
    isGeotiff(type) {
        return ['image/tiff', 'image/tif', 'image/gtiff'].includes(type);
    }
    /**
     * Check if file is a jp2 image
     * @param type - Uploaded file type
     * @returns True, if upload file is a jp2 image, false otherwise
     */
    isJp2(type) {
        return ['image/jp2'].includes(type);
    }
    /**
     * Load non-wms OWS data and create layer
     * @param endpoint - Layman endpoint description (url, name, user)
     * @param files - Array of files
     * @param name - Name of new layer
     * @param title - Title of new layer
     * @param abstract - Abstract of new layer
     * @param srs - EPSG code of selected projection (eg. "EPSG:4326")
     * @param sld - Array of sld files
     * @param access_rights - User access rights for the new layer,
     * @param app - App identifier
     * @param overwrite - (Optional) Overwrite existing layman layer
     * @returns
     */
    loadNonWmsLayer(endpoint, files, name, title, abstract, srs, sld, access_rights, app, overwrite) {
        return __awaiter(this, void 0, void 0, function* () {
            const appRef = this.get(app);
            try {
                const formData = yield this.constructFormData(endpoint, files, name, title, abstract, srs, sld, access_rights, app);
                const asyncUpload = this.hsLaymanService.prepareAsyncUpload(formData);
                appRef.asyncLoading = asyncUpload.async;
                const res = yield this.hsLaymanService.tryLoadLayer(endpoint, formData, asyncUpload, name, app, overwrite);
                return res;
            }
            catch (err) {
                this.get(app).readingData = false;
                throw err;
            }
        });
    }
    /**
     * Try to find layer in Layman's database using Layman friendly layer name
     * @param name - Layman friendly layer name to search by
     * @param app - App identifier
     */
    lookupLaymanLayer(name, app) {
        return __awaiter(this, void 0, void 0, function* () {
            const fiendlyName = getLaymanFriendlyLayerName(name);
            const commonFileRef = this.get(app);
            let descriptor;
            if (this.isAuthorized()) {
                this.pickEndpoint(app);
                try {
                    descriptor = yield this.hsLaymanService.describeLayer(commonFileRef.endpoint, name, commonFileRef.endpoint.user, true);
                }
                catch (error) {
                    console.error(error);
                    throw error;
                }
            }
            if (!descriptor || (descriptor === null || descriptor === void 0 ? void 0 : descriptor.name) != fiendlyName) {
                return false;
            }
            else {
                return true;
            }
        });
    }
    /**
     * Convert value from one range to another
     * @param value - value to convert
     * @param oldRange - min, max of values range
     * @param newRange - min, max of values range. Default to 0 - 1
     */
    convertRange(value, oldRange, newRange = { min: 0, max: 1 }) {
        return (((value - oldRange.min) * (newRange.max - newRange.min)) /
            (oldRange.max - oldRange.min) +
            newRange.min);
    }
    /**
     * Calculates progress of individual file being zipped by transforimg value into 0 - 1 scale
     */
    calculateFileProgress(value, nrOfFiles) {
        const unit = 100 / nrOfFiles;
        const breakpoints = new Array(nrOfFiles).fill(unit);
        //Get breakpoints eg. [33,66,99] for nrOfFiles = 3
        for (const [index, item] of breakpoints.entries()) {
            if (breakpoints[index - 1]) {
                breakpoints[index] = item + breakpoints[index - 1];
            }
        }
        const rangeMaxIdx = breakpoints.findIndex((b) => value < b);
        const newRangeMax = breakpoints[rangeMaxIdx];
        const newRangeMin = breakpoints[rangeMaxIdx - 1]
            ? breakpoints[rangeMaxIdx - 1]
            : 0;
        return this.convertRange(value, { min: newRangeMin, max: newRangeMax });
    }
    /**
     * Construct a set of key/value pairs from, that can be easily sent using HTTP
     * @param endpoint - Layman endpoint description (url, name, user)
     * @param files - Array of files
     * @param name - Name of new layer
     * @param title - Title of new layer
     * @param abstract - Abstract of new layer
     * @param srs - EPSG code of selected projection (eg. "EPSG:4326")
     * @param sld - Array of sld files
     * @param access_rights - User access rights for the new layer,
     * @returns Formdata object for HTTP request
     */
    constructFormData(endpoint, files, name, title, abstract, srs, sld, access_rights, app) {
        return __awaiter(this, void 0, void 0, function* () {
            this.get(app).readingData = true;
            const formdata = new FormData();
            let zipFile;
            const zip = new JSZip();
            if (this.isZip(files[0].type)) {
                zipFile = new Blob([files[0].content], { type: files[0].type });
            }
            else {
                files.forEach((file) => {
                    zip.file(file.name, file.content);
                });
                zipFile = yield zip.generateAsync({ type: 'blob', streamFiles: true }, (metadata) => {
                    setTimeout(() => {
                        this.hsLaymanService.totalProgress = this.calculateFileProgress(metadata.percent, files.length);
                    }, 0);
                });
            }
            formdata.append('file', zipFile, files[0].name.split('.')[0] + '.zip');
            if (sld) {
                formdata.append('sld', new Blob([sld.content], { type: sld.type }), sld.name);
            }
            formdata.append('name', name);
            title = title == '' ? name : title;
            formdata.append('title', title);
            formdata.append('abstract', abstract);
            formdata.append('crs', srs);
            const rights = this.hsLaymanService.parseAccessRightsForLayman(endpoint, access_rights);
            formdata.append('access_rights.write', rights.write);
            formdata.append('access_rights.read', rights.read);
            this.get(app).readingData = false;
            return formdata;
        });
    }
    /**
     * Handler for button click to send file to layman and wait for
     * answer with wms service url to add to map
     * @param data - Current data object for upload
     * @param app - App identifier
     * @param options - (Optional) overwrite: Overwrite existing layman layer, repetive: Called for more the one time
     */
    addAsWms(data, app, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let exists;
            try {
                const appRef = this.get(app);
                appRef.loadingToLayman = true;
                if (!appRef.endpoint) {
                    this.pickEndpoint(app);
                }
                if (!this.isSRSSupported(data)) {
                    throw new Error(this.hsLanguageService.getTranslationIgnoreNonExisting('ADDLAYERS.ERROR', 'srsNotSupported', undefined, app));
                }
                if (!(options === null || options === void 0 ? void 0 : options.overwrite)) {
                    exists = yield this.lookupLaymanLayer(data.name, app);
                }
                if (exists) {
                    this.callOverwriteDialog(data, app, options === null || options === void 0 ? void 0 : options.repetive);
                }
                else {
                    const response = yield this.loadNonWmsLayer(appRef.endpoint, data.files, data.name, data.title, data.abstract, data.srs, data.sld, data.access_rights, app, options === null || options === void 0 ? void 0 : options.overwrite);
                    if (response === null || response === void 0 ? void 0 : response.code) {
                        yield this.postLoadNonWmsError(response, data, app, options === null || options === void 0 ? void 0 : options.repetive);
                    }
                    else {
                        yield this.postLoadNonWmsSuccess(response, data, app);
                    }
                }
            }
            catch (err) {
                this.displayErrorMessage({ message: err.message, details: null }, app);
            }
        });
    }
    /**
     * Load overwrite layer dialog
     * @param data - Current data object for upload
     * @param app - App identifier
     */
    loadOverwriteLayerDialog(data, app, repetive) {
        return __awaiter(this, void 0, void 0, function* () {
            const dialogRef = this.hsDialogContainerService.create(HsLayerOverwriteDialogComponent, {
                dataObj: data,
                repetive,
                app,
            }, app);
            return yield dialogRef.waitResult();
        });
    }
    /**
     * Call for overwrite dialog
     * @param data - Current data object to load
     * @param app - App identifier
     * @param repetive - Called for more the one time
     */
    callOverwriteDialog(data, app, repetive) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.loadOverwriteLayerDialog(data, app, repetive);
            switch (result) {
                case OverwriteResponse.add:
                    this.addAsWms(data, app, { repetive: true });
                    break;
                case OverwriteResponse.overwrite:
                    this.addAsWms(data, app, { overwrite: true });
                    break;
                case OverwriteResponse.cancel:
                default:
                    this.get(app).loadingToLayman = false;
                    return;
            }
        });
    }
    /**
     * Process error server response after trying to load non-wms layer
     * @param response - Http post/past response after loading layer to Layman
     * @param data - Current data object to load
     * @param app - App identifier
     */
    postLoadNonWmsError(response, data, app, repetive) {
        return __awaiter(this, void 0, void 0, function* () {
            if (response.code == 17) {
                this.callOverwriteDialog(data, app, repetive);
            }
            else {
                this.handleLaymanError(response, app);
            }
        });
    }
    /**
     * Process success server response after trying to load non-wms layer
     * @param response - Http post/past response after loading layer to Layman
     * @param app - App identifier
     */
    handleLaymanError(response, app) {
        var _a, _b, _c, _d;
        const errorMessage = ((_b = (_a = response === null || response === void 0 ? void 0 : response.error) === null || _a === void 0 ? void 0 : _a.message) !== null && _b !== void 0 ? _b : (response === null || response === void 0 ? void 0 : response.message) == 'Wrong parameter value')
            ? `${response === null || response === void 0 ? void 0 : response.message} : ${response === null || response === void 0 ? void 0 : response.detail.parameter}`
            : response === null || response === void 0 ? void 0 : response.message;
        const errorDetails = ((_c = response === null || response === void 0 ? void 0 : response.detail) === null || _c === void 0 ? void 0 : _c.missing_extensions)
            ? Object.values((_d = response.detail) === null || _d === void 0 ? void 0 : _d.missing_extensions)
            : [];
        this.displayErrorMessage({ message: errorMessage, details: errorDetails }, app);
    }
    /**
     * Process success server response after trying to load non-wms layer
     * @param response - Http post/past response after loading layer to Layman
     * @param data - Current data object to load
     * @param app - App identifier
     */
    postLoadNonWmsSuccess(response, data, app) {
        return __awaiter(this, void 0, void 0, function* () {
            const appRef = this.get(app);
            data.name = response.name; //Name translated to Layman-safe name
            const descriptor = yield this.describeNewLayer(appRef.endpoint, response.name);
            if (descriptor === null || descriptor === void 0 ? void 0 : descriptor.file.error) {
                this.hsToastService.createToastPopupMessage(this.hsLanguageService.getTranslation('ADDLAYERS.ERROR.someErrorHappened', undefined, app), this.hsLanguageService.getTranslationIgnoreNonExisting('LAYMAN.ERROR', descriptor.file.error.code.toString(), undefined, app), {
                    serviceCalledFrom: 'HsAddDataCommonFileService',
                    disableLocalization: true,
                }, app);
                appRef.layerAddedAsWms.next(false);
                return;
            }
            this.hsLaymanService.totalProgress = 0;
            this.hsAddDataService.selectType('url', app);
            appRef.layerAddedAsWms.next(true);
            yield this.hsAddDataOwsService.connectToOWS({
                type: 'wms',
                uri: descriptor.wms.url,
                layer: data.name,
                owrCache: true,
            }, app);
        });
    }
    /**
     * @param endpoint - Selected endpoint (should be Layman)
     * @param layerName - Name of the layer to describe
     * @returns Description of Layman layer
     */
    describeNewLayer(endpoint, layerName) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const descriptor = yield this.hsLaymanService.describeLayer(endpoint, layerName, endpoint.user);
                if (['STARTED', 'PENDING'].includes(descriptor === null || descriptor === void 0 ? void 0 : descriptor.wms.status)) {
                    return new Promise((resolve) => {
                        setTimeout(() => {
                            resolve(this.describeNewLayer(endpoint, layerName));
                        }, 2000);
                    });
                }
                else {
                    return descriptor;
                }
            }
            catch (ex) {
                this.hsLog.error(ex);
                throw ex;
            }
        });
    }
    /**
     * Display error message toast, when called and broadcast event about a failed attempt to load wms layer
     * @param _options - Error message options: message, header or details
     * @param app - App identifier
     */
    displayErrorMessage(_options = {}, app) {
        var _a;
        this.hsToastService.createToastPopupMessage((_a = _options === null || _options === void 0 ? void 0 : _options.header) !== null && _a !== void 0 ? _a : this.get(app).fileUploadErrorHeader, _options.message, {
            serviceCalledFrom: 'HsAddDataCommonFileService',
            details: _options === null || _options === void 0 ? void 0 : _options.details,
        }, app);
        this.get(app).layerAddedAsWms.next(false);
    }
    /**
     * Check if srs from data is supported by Layman
     * @param data - Current data object to load
     * @returns True, if srs is supported, false otherwise
     */
    isSRSSupported(data) {
        return this.hsLaymanService.supportedCRRList.some((epsg) => data.srs.endsWith(epsg));
    }
    /**
     * Check if user is authorized as Layman user
     * @returns True, if user is authorized, false otherwise
     */
    isAuthorized() {
        var _a, _b;
        return (_b = (_a = this.hsLaymanService.getLaymanEndpoint()) === null || _a === void 0 ? void 0 : _a.authenticated) !== null && _b !== void 0 ? _b : false;
    }
    /**
     * Set data object name based on uploaded files
     * @param data - Current data object to load
     * @param app - App identifier
     */
    setDataName(data, app) {
        data.name = data.files[0].name.slice(0, -4);
        data.title = data.name;
        this.get(app).dataObjectChanged.next(data);
    }
}
HsAddDataCommonFileService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataCommonFileService, deps: [{ token: HsLogService }, { token: HsToastService }, { token: HsAddDataService }, { token: HsLanguageService }, { token: HsCommonEndpointsService }, { token: HsLaymanService }, { token: HsAddDataOwsService }, { token: HsDialogContainerService }, { token: HsUtilsService }, { token: HsAddDataUrlService }], target: i0.ɵɵFactoryTarget.Injectable });
HsAddDataCommonFileService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataCommonFileService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataCommonFileService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: HsLogService }, { type: HsToastService }, { type: HsAddDataService }, { type: HsLanguageService }, { type: HsCommonEndpointsService }, { type: HsLaymanService }, { type: HsAddDataOwsService }, { type: HsDialogContainerService }, { type: HsUtilsService }, { type: HsAddDataUrlService }]; } });

class HsAddDataVectorService {
    constructor(hsMapService, hsUtilsService, hsStylerService, hsAddDataService, hsAddDataCommonFileService, hsLaymanService) {
        this.hsMapService = hsMapService;
        this.hsUtilsService = hsUtilsService;
        this.hsStylerService = hsStylerService;
        this.hsAddDataService = hsAddDataService;
        this.hsAddDataCommonFileService = hsAddDataCommonFileService;
        this.hsLaymanService = hsLaymanService;
        this.readUploadedFileAsText = (inputFile) => {
            const temporaryFileReader = new FileReader();
            return new Promise((resolve, reject) => {
                temporaryFileReader.onerror = () => {
                    temporaryFileReader.abort();
                    reject(new DOMException('Problem parsing input file.'));
                };
                temporaryFileReader.onload = () => {
                    resolve(temporaryFileReader.result);
                };
                temporaryFileReader.readAsText(inputFile);
            });
        };
        this.readUploadedFileAsURL = (inputFile) => {
            const temporaryFileReader = new FileReader();
            return new Promise((resolve, reject) => {
                temporaryFileReader.onerror = () => {
                    temporaryFileReader.abort();
                    reject(new DOMException('Problem parsing input file.'));
                };
                temporaryFileReader.onload = () => {
                    resolve(temporaryFileReader.result);
                };
                temporaryFileReader.readAsDataURL(inputFile);
            });
        };
    }
    /**
     * Load non-wms OWS data and create layer
     * @param type - Type of data to load (supports Kml, Geojson, Wfs and Sparql)
     * @param url - Url of data/service localization
     * @param name -
     * @param title - Title of new layer
     * @param abstract - Abstract of new layer
     * @param addUnder -
     * @param srs - EPSG code of selected projection (eg. "EPSG:4326")
     * @param options - Other options
     * @returns Promise which return OpenLayers vector layer
     */
    addVectorLayer(type, url, name, title, abstract, srs, options, app, addUnder) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const lyr = yield this.createVectorLayer(type, url, name, title, abstract, srs, options, app);
                /*
                TODO: Should have set definition property with protocol inside
                so layer synchronizer would know if to sync
                */
                if (options.saveToLayman) {
                    if (this.hsUtilsService.undefineEmptyString(url) !== undefined) {
                        setDefinition(lyr, {
                            format: 'hs.format.WFS',
                            url: url,
                        });
                    }
                    else {
                        setDefinition(lyr, {
                            format: 'hs.format.WFS',
                        });
                    }
                }
                if (this.hsMapService.getMap(app)) {
                    this.hsAddDataService.addLayer(lyr, app, addUnder);
                }
                resolve(lyr);
            }
            catch (ex) {
                reject(ex);
            }
        }));
    }
    /**
     * Load non-wms OWS data and create layer
     * @param type - Type of data to load (supports Kml, Geojson, Wfs and Sparql)
     * @param url - Url of data/service localization
     * @param name -
     * @param title - Title of new layer
     * @param abstract - Abstract of new layer
     * @param srs - EPSG code of selected projection (eg. "EPSG:4326")
     * @param options - Other options
     * @returns Promise which return OpenLayer's vector layer
     */
    createVectorLayer(type, url, name, title, abstract, srs, options = {}, app) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if ((type === null || type === void 0 ? void 0 : type.toLowerCase()) != 'sparql' &&
                (type === null || type === void 0 ? void 0 : type.toLowerCase()) != 'wfs' &&
                url !== undefined) {
                url = this.hsUtilsService.proxify(url, app);
            }
            if (this.hsUtilsService.undefineEmptyString(type) === undefined) {
                type = this.tryGuessTypeFromNameOrUrl(url);
            }
            let mapProjection;
            if (this.hsMapService.getMap(app)) {
                mapProjection = this.hsMapService
                    .getMap(app)
                    .getView()
                    .getProjection()
                    .getCode();
            }
            const descriptor = new VectorLayerDescriptor(type, name, title, abstract, url, options, mapProjection);
            const sourceDescriptor = new VectorSourceDescriptor(type, url, srs, options, mapProjection);
            const src = sourceDescriptor.sourceClass == Vector
                ? new sourceDescriptor.sourceClass(sourceDescriptor.sourceParams)
                : new sourceDescriptor.sourceClass(sourceDescriptor);
            descriptor.layerParams.source = src;
            Object.assign(descriptor.layerParams, yield this.hsStylerService.parseStyle((_a = descriptor.layerParams.style) !== null && _a !== void 0 ? _a : descriptor.layerParams.sld, app));
            const lyr = new Vector$1(descriptor.layerParams);
            return lyr;
        });
    }
    /**
     * Fit map view to layer's extent
     * @param lyr - Provided layer
     * @param app - App identifier
     */
    fitExtent(lyr, app) {
        const src = lyr.getSource();
        if (src.getFeatures().length > 0) {
            this.tryFit(src.getExtent(), src, app);
        }
        else {
            src.on('change', this.changeListener(src, app));
        }
    }
    /**
     * Set catalogue as active HSLayers panel
     * @param app - App identifier
     */
    setPanelToCatalogue(app) {
        this.hsAddDataService.apps[app].dsSelected = 'catalogue';
    }
    /**
     * Listen to any source changes made
     * @param src - Layer source provided
     * @param app - App identifier
     */
    changeListener(src, app) {
        if (src.getState() == 'ready') {
            setTimeout(() => {
                if (src.getFeatures().length == 0) {
                    return;
                }
                const extent = src.getExtent();
                this.tryFit(extent, src, app);
            }, 1000);
        }
    }
    /**
     * Wait until layer synchonization is complete
     * @param layer - Layer provided
     */
    awaitLayerSync(layer) {
        return __awaiter(this, void 0, void 0, function* () {
            while (getHsLaymanSynchronizing(layer)) {
                yield new Promise((r) => setTimeout(r, 200));
            }
            return true;
        });
    }
    /**
     * Add new layer to map and Layman (if possible)
     * @param data - Layer data object provided
     * @param app - App identifier
     * @returns Created layer and layer adding state (true, if complete, false otherwise)
     */
    addNewLayer(data, app) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            const commonFileRef = this.hsAddDataCommonFileService.get(app);
            if (!commonFileRef.endpoint) {
                this.hsAddDataCommonFileService.pickEndpoint(app);
            }
            const addLayerRes = { layer: null, complete: true };
            if (data.saveToLayman && data.saveAvailable) {
                const checkResult = yield this.checkForLayerInLayman(data, app);
                if (!checkResult || checkResult == OverwriteResponse.cancel) {
                    addLayerRes.complete = false;
                    return addLayerRes;
                }
                //Create layer on layman: OverwriteResponse.add
                yield this.upsertLayer(data, app);
            }
            const layer = yield this.addVectorLayer(data.features.length != 0 ? '' : data.type, data.url || data.base64url, data.name, data.title, data.abstract, data.srs, {
                extractStyles: data.extract_styles,
                features: data.saveToLayman ? null : data.features,
                path: this.hsUtilsService.undefineEmptyString(data.folder_name),
                access_rights: data.access_rights,
                workspace: (_a = commonFileRef.endpoint) === null || _a === void 0 ? void 0 : _a.user,
                queryCapabilities: data.type != 'kml' &&
                    data.type != 'gpx' &&
                    !((_b = data.url) === null || _b === void 0 ? void 0 : _b.endsWith('json')),
                saveToLayman: data.saveToLayman,
                sld: typeof data.sld == 'string' ? data.sld : (_c = data.sld) === null || _c === void 0 ? void 0 : _c.content,
            }, app, data.addUnder);
            this.fitExtent(layer, app);
            addLayerRes.layer = layer;
            if (data.saveToLayman) {
                this.awaitLayerSync(layer).then(() => {
                    layer.getSource().dispatchEvent('addfeature');
                });
            }
            return addLayerRes;
        });
    }
    /**
     * Prepare layer for upsertion to Layman
     * @param data - Vector data object
     * @param app - App identifier
     */
    upsertLayer(data, app) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const commonFileRef = this.hsAddDataCommonFileService.get(app);
            const crsSupported = this.hsLaymanService.supportedCRRList.includes(data.nativeSRS);
            const layerDesc = {
                title: data.title,
                name: getLaymanFriendlyLayerName(data.name),
                crs: this.getFeaturesProjection(get(data.nativeSRS)).getCode(),
                workspace: commonFileRef.endpoint.user,
                access_rights: data.access_rights,
                sld: typeof data.sld == 'string' ? data.sld : (_a = data.sld) === null || _a === void 0 ? void 0 : _a.content,
            };
            return this.hsLaymanService.makeUpsertLayerRequest(commonFileRef.endpoint, this.hsLaymanService.getFeatureGeoJSON(data.nativeFeatures, crsSupported, true), layerDesc, app);
        });
    }
    /**
     * Check if layer with the same name exists in Layman database and provide the user to choose
     * what action he wishes to take
     * @param data - Layer data object provided
     * @param app - App identifier
     * @returns Action the user took, inside promted dialog
     */
    checkForLayerInLayman(data, app, repetive) {
        return __awaiter(this, void 0, void 0, function* () {
            let upsertReq;
            const commonFileRef = this.hsAddDataCommonFileService.get(app);
            commonFileRef.loadingToLayman = true;
            const exists = yield this.hsAddDataCommonFileService.lookupLaymanLayer(data.name, app);
            if (!exists) {
                return OverwriteResponse.add;
            }
            else {
                const result = yield this.hsAddDataCommonFileService.loadOverwriteLayerDialog(data, app, repetive);
                switch (result) {
                    case OverwriteResponse.overwrite:
                        upsertReq = yield this.upsertLayer(data, app);
                        if (!upsertReq) {
                            return OverwriteResponse.cancel;
                        }
                        else if (upsertReq === null || upsertReq === void 0 ? void 0 : upsertReq.code) {
                            switch (upsertReq.code) {
                                case 17:
                                    return yield this.checkForLayerInLayman(data, app);
                                default:
                                    this.hsAddDataCommonFileService.handleLaymanError(upsertReq, app);
                                    return OverwriteResponse.cancel;
                            }
                        }
                        else {
                            yield this.hsLaymanService.describeLayer(commonFileRef.endpoint, upsertReq.name, commonFileRef.endpoint.user);
                            return OverwriteResponse.overwrite;
                        }
                    case OverwriteResponse.add:
                        return yield this.checkForLayerInLayman(data, app, true);
                    case OverwriteResponse.cancel:
                        commonFileRef.loadingToLayman = false;
                        return OverwriteResponse.cancel;
                    default:
                }
            }
        });
    }
    /**
     * Check if uploaded data are KML
     * @param fileType - Uploaded data type
     * @param url -  Upload source url
     * @returns True, if data are in KML format, false otherwise
     */
    isKml(fileType, url) {
        if (fileType == 'kml' || (url === null || url === void 0 ? void 0 : url.endsWith('kml'))) {
            return true;
        }
        else {
            return false;
        }
    }
    /**
     * Try to fit layer extent as map view
     * @param extent - Extent provided
     * @param src - Layer source provided
     * @param app - App identifier
     */
    tryFit(extent, src, app) {
        if (!isNaN(extent[0]) &&
            !isNaN(extent[1]) &&
            !isNaN(extent[2]) &&
            !isNaN(extent[3]) &&
            this.hsMapService.getMap(app)) {
            this.hsMapService.fitExtent(extent, app);
            src.un('change', this.changeListener);
        }
    }
    /**
     * Tries to guess file type based on the file extension
     * @param extension - Parsed file extension from uploaded file
     */
    tryGuessTypeFromNameOrUrl(extension) {
        if (extension !== undefined) {
            if (extension.toLowerCase().endsWith('kml')) {
                return 'kml';
            }
            if (extension.toLowerCase().endsWith('gpx')) {
                return 'gpx';
            }
            if (extension.toLowerCase().endsWith('geojson') ||
                extension.toLowerCase().endsWith('json')) {
                return 'geojson';
            }
        }
    }
    /**
     * Create a object containing data from XML dataset
     * @param file - File uploaded by the user
     * @param type - Data type
     */
    createVectorObjectFromXml(file, type) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const uploadedContent = yield this.readUploadedFileAsURL(file);
                const dataUrl = uploadedContent.toString();
                const object = {
                    url: dataUrl,
                    name: file.name,
                    title: file.name,
                    type: type,
                };
                return object;
            }
            catch (e) {
                console.log('Uploaded file is not supported!');
                return { error: 'couldNotUploadSelectedFile' };
            }
        });
    }
    /**
     * Read uploaded file and extract the data as JSON object
     * @param file - File uploaded by the user
     * @param app - App identifier
     * @returns JSON object with parsed data
     */
    readUploadedFile(file, app) {
        return __awaiter(this, void 0, void 0, function* () {
            let uploadedData = {};
            const fileType = this.tryGuessTypeFromNameOrUrl(file.name.toLowerCase());
            switch (fileType) {
                case 'kml':
                    uploadedData = yield this.createVectorObjectFromXml(file, fileType);
                    break;
                case 'gpx':
                    uploadedData = yield this.convertUploadedData(file, app);
                    break;
                default:
                    try {
                        const fileContents = yield this.readUploadedFileAsText(file);
                        const fileToJSON = JSON.parse(fileContents);
                        if (fileToJSON !== undefined) {
                            fileToJSON.name = file.name.split('.')[0];
                            uploadedData = this.createVectorObjectFromJson(fileToJSON, app);
                            return uploadedData;
                        }
                    }
                    catch (e) {
                        console.log('Uploaded file is not supported!', e);
                        return { error: 'couldNotUploadSelectedFile' };
                    }
            }
            return uploadedData;
        });
    }
    /**
     * Returns layman supported projection
     */
    getFeaturesProjection(projection) {
        return PROJECTIONS
            .map((proj) => proj.getCode())
            .some((code) => code === projection.getCode())
            ? get('EPSG:4326')
            : this.hsLaymanService.supportedCRRList.indexOf(projection.getCode()) > -1
                ? projection
                : get('EPSG:4326');
        //Features in map CRS
    }
    /**
     * Read features from uploaded file as objects
     * @param json - Uploaded file parsed as json object
     * @param app - App identifier
     * @returns JSON object with file name and read features
     */
    createVectorObjectFromJson(json, app) {
        var _a;
        let features = [];
        const format = new GeoJSON();
        const projection = format.readProjection(json);
        if (!projection) {
            return {
                error: 'ERROR.srsNotSupported',
            };
        }
        if (((_a = json.features) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            features = format.readFeatures(json);
            this.transformFeaturesIfNeeded(features, projection, app);
        }
        const object = {
            name: json.name,
            title: json.name,
            srs: this.getFeaturesProjection(projection),
            features: features,
            nativeFeatures: format.readFeatures(json),
            nativeSRS: projection,
        };
        return object;
    }
    /**
     * Transform features to other projection if needed
     * @param features - Extracted features from uploaded file
     * @param projection - Projection to which transform the features
     * @param app - App identifier
     */
    transformFeaturesIfNeeded(features, projection, app) {
        const mapProjection = this.hsMapService
            .getMap(app)
            .getView()
            .getProjection();
        if (projection != mapProjection) {
            projection = PROJECTIONS
                .map((proj) => proj.getCode())
                .some((code) => code === projection.getCode())
                ? get('EPSG:4326')
                : projection;
            features.forEach((f) => 
            //TODO: Make it parallel using workers or some library
            f.getGeometry().transform(projection, mapProjection));
        }
    }
    /**
     * Convert uploaded kml or gpx files into GeoJSON format / parse loaded GeoJSON
     * @param file - Uploaded  kml, gpx or GeoJSON files
     * @param app - App identifier
     */
    convertUploadedData(file, app) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            let parser;
            const uploadedData = {};
            try {
                const uploadedContent = yield this.readUploadedFileAsText(file);
                let fileType = this.tryGuessTypeFromNameOrUrl(file.name.toLowerCase());
                switch (fileType) {
                    case 'kml':
                        parser = new KML();
                        uploadedData.features = parser.readFeatures(uploadedContent);
                        break;
                    case 'gpx':
                        parser = new GPX();
                        uploadedData.features = parser.readFeatures(uploadedContent);
                        fileType = 'json';
                        break;
                    default:
                }
                if (((_a = uploadedData === null || uploadedData === void 0 ? void 0 : uploadedData.features) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    this.transformFeaturesIfNeeded(uploadedData.features, parser.readProjection(uploadedContent), app);
                }
                uploadedData.nativeFeatures = parser.readFeatures(uploadedContent);
                uploadedData.nativeSRS = parser.readProjection(uploadedContent);
                uploadedData.title = file.name.split('.')[0].trim();
                uploadedData.name = uploadedData.title;
                uploadedData.type = fileType;
                return uploadedData;
            }
            catch (e) {
                console.error('Uploaded file is not supported' + e);
                return { error: 'couldNotUploadSelectedFile' };
            }
        });
    }
}
HsAddDataVectorService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataVectorService, deps: [{ token: HsMapService }, { token: HsUtilsService }, { token: HsStylerService }, { token: HsAddDataService }, { token: HsAddDataCommonFileService }, { token: HsLaymanService }], target: i0.ɵɵFactoryTarget.Injectable });
HsAddDataVectorService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataVectorService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataVectorService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsMapService }, { type: HsUtilsService }, { type: HsStylerService }, { type: HsAddDataService }, { type: HsAddDataCommonFileService }, { type: HsLaymanService }]; } });

class HsFileService {
    constructor(hsLanguageService, hsAddDataCommonFileService) {
        this.hsLanguageService = hsLanguageService;
        this.hsAddDataCommonFileService = hsAddDataCommonFileService;
        this.fileUploadErrorHeader = 'ADDLAYERS.couldNotUploadSelectedFile';
    }
    read(evt, app, readAsText = false) {
        return __awaiter(this, void 0, void 0, function* () {
            const filesRead = [];
            const files = Array.from(evt.fileList);
            const promises = [];
            const data = {};
            try {
                if (!this.hsAddDataCommonFileService.filesValid(files, app)) {
                    return;
                }
                for (const file of files) {
                    const filePromise = new Promise((resolve) => {
                        const reader = new FileReader();
                        reader.onload = (loadEvent) => {
                            filesRead.push({
                                name: file.name,
                                type: file.type,
                                content: loadEvent.target.result,
                            });
                            resolve(reader.result);
                        };
                        const readerMethod = readAsText ? 'readAsText' : 'readAsArrayBuffer';
                        reader[readerMethod](file);
                    });
                    promises.push(filePromise);
                }
                yield Promise.all(promises);
                if (evt.uploader.includes('shpdbfshx')) {
                    data.files = filesRead;
                    this.checkShpFiles(data, app);
                }
                else if (evt.uploader.includes('sld')) {
                    data.sld = filesRead[0];
                    this.hsAddDataCommonFileService.get(app).dataObjectChanged.next(data);
                }
                else if (evt.uploader.includes('hs-file-raster')) {
                    data.files = filesRead;
                    this.checkRasterFiles(data, app);
                }
            }
            catch (e) {
                this.hsAddDataCommonFileService.displayErrorMessage({
                    message: e.message,
                    header: this.fileUploadErrorHeader,
                }, app);
            }
        });
    }
    checkShpFiles(data, app) {
        if (data.files.length == 3 ||
            this.hsAddDataCommonFileService.isZip(data.files[0].type)) {
            this.hsAddDataCommonFileService.setDataName(data, app);
        }
        else if (data.files.length > 3) {
            this.tooManyFiles(3, data.files.length, app);
        }
        else {
            this.hsAddDataCommonFileService.displayErrorMessage({
                message: 'ADDLAYERS.SHP.missingOneOrMore',
                header: this.fileUploadErrorHeader,
            }, app);
        }
    }
    checkRasterFiles(data, app) {
        if (data.files.length == 2 ||
            this.hsAddDataCommonFileService.isZip(data.files[0].type) ||
            this.hsAddDataCommonFileService.isGeotiff(data.files[0].type) ||
            this.hsAddDataCommonFileService.isJp2(data.files[0].type)) {
            this.hsAddDataCommonFileService.setDataName(data, app);
        }
        else if (data.files.length > 2) {
            this.tooManyFiles(2, data.files.length, app);
        }
        else {
            this.hsAddDataCommonFileService.displayErrorMessage({
                message: 'ADDLAYERS.missingImageorWorldFile',
                header: this.fileUploadErrorHeader,
            }, app);
        }
    }
    tooManyFiles(allowed, length, app) {
        this.hsAddDataCommonFileService.displayErrorMessage({
            message: this.hsLanguageService.getTranslationIgnoreNonExisting('ADDLAYERS.SHP', 'maximumNumberOf', { allowed, length }, app),
            header: this.fileUploadErrorHeader,
        }, app);
    }
}
HsFileService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsFileService, deps: [{ token: HsLanguageService }, { token: HsAddDataCommonFileService }], target: i0.ɵɵFactoryTarget.Injectable });
HsFileService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsFileService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsFileService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: HsLanguageService }, { type: HsAddDataCommonFileService }]; } });

class FilterPipe {
    transform(items, filterCallback) {
        return items.filter((item) => filterCallback(item));
    }
}
FilterPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: FilterPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
FilterPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: FilterPipe, name: "filter" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: FilterPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'filter',
                }]
        }] });

var GrantingOptions;
(function (GrantingOptions) {
    GrantingOptions["PERUSER"] = "per_user";
    GrantingOptions["EVERYONE"] = "everyone";
})(GrantingOptions || (GrantingOptions = {}));
class HsCommonLaymanAccessRightsComponent {
    constructor(hsLanguageService, hsLaymanService, $http, hsLog) {
        this.hsLanguageService = hsLanguageService;
        this.hsLaymanService = hsLaymanService;
        this.$http = $http;
        this.hsLog = hsLog;
        this.app = 'default';
        this.grantingOptions = GrantingOptions;
        this.currentOption = GrantingOptions.EVERYONE;
        this.allUsers = [];
        /**
         * Filter users by name
         * This function is passed as filter pipe function
         */
        this.userFilter = (item) => {
            const r = new RegExp(this.userSearch, 'i');
            return (r.test(item.givenName) ||
                r.test(item.familyName) ||
                r.test(item.screenName));
        };
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.endpoint = this.hsLaymanService.getLaymanEndpoint();
            const readAccess = this.access_rights['access_rights.read'].split(',');
            const writeAccess = this.access_rights['access_rights.write'].split(',');
            if (readAccess.length > 1 || writeAccess.length > 1) {
                this.currentOption = GrantingOptions.PERUSER;
                yield this.getAllUsers();
                this.tickFoundUsers(readAccess, 'read');
                this.tickFoundUsers(writeAccess, 'write');
            }
        });
    }
    /**
     * Tick found user checkboxes in UI that have access rights
     * @param users - Username list that have access rights
     * @param type - Access right type (read or write)
     */
    tickFoundUsers(users, type) {
        users.forEach((user) => {
            const found = this.allUsers.find((u) => u.username == user);
            if (found) {
                found[type] = true;
            }
        });
    }
    /**
     * Change access rights for everyone
     * @param type - Access rights type (access_rights.read or access_rights.write)
     * @param value - Access rights value (private or EVERYONE)
     * @param event - Checkbox change event
     */
    accessRightsChanged(type, value, event) {
        if (this.currentOption == this.grantingOptions.PERUSER) {
            this.rightsChangedPerUser(type, value, event);
        }
        else {
            this.access_rights[type] = value;
            if (this.access_rights['access_rights.read'] == 'private' &&
                this.access_rights['access_rights.write'] != 'private') {
                this.access_rights['access_rights.write'] = 'private';
            }
        }
    }
    /**
     * Change each user access rights individually
     * @param type - Access rights type (access_rights.read or access_rights.write)
     * @param value - Access rights value (username for user)
     * @param event - Checkbox change event
     */
    rightsChangedPerUser(type, value, event) {
        if (event.target.checked && type == 'access_rights.write') {
            this.access_rights['access_rights.read'] = this.access_rights['access_rights.read'].concat(',' + value);
            this.findLaymanUser(value).read = event.target.checked;
        }
        else if (!event.target.checked && type == 'access_rights.read') {
            this.removeUserRights('access_rights.write', value);
            this.findLaymanUser(value).write = event.target.checked;
        }
        event.target.checked
            ? (this.access_rights[type] = this.access_rights[type].concat(',' + value))
            : this.removeUserRights(type, value);
    }
    /**
     * Find user by username from all Layman users
     * @param username - User username provided
     */
    findLaymanUser(username) {
        return this.allUsers.find((u) => u.username == username);
    }
    /**
     * Remove user rights by filtering username from access_rights
     * @param type - Access rights type (access_rights.read or access_rights.write)
     * @param username - User username provided
     */
    removeUserRights(type, username) {
        this.access_rights[type] = this.access_rights[type]
            .split(',')
            .filter((u) => u != username)
            .join(',');
    }
    /**
     * Get a translation based on the value of the right
     * @param right - Value of the access right
     */
    getRightTranslation(right) {
        if (right == 'read') {
            return this.hsLanguageService.getTranslation('SAVECOMPOSITION.readAccessRights', undefined, this.app);
        }
        else if (right == 'write') {
            return this.hsLanguageService.getTranslation('SAVECOMPOSITION.writeAccessRights', undefined, this.app);
        }
    }
    /**
     * Change access granting options (everyone or per_user)
     * @param option - Access granting option
     */
    changeGrantingOptions(option) {
        return __awaiter(this, void 0, void 0, function* () {
            if (option == this.grantingOptions.PERUSER) {
                yield this.getAllUsers();
                this.access_rights['access_rights.read'] = this.endpoint.user;
                this.access_rights['access_rights.write'] = this.endpoint.user;
            }
            else {
                this.allUsers = [];
                this.access_rights['access_rights.read'] = 'EVERYONE';
                this.access_rights['access_rights.write'] = 'private';
            }
            this.currentOption = option;
        });
    }
    /**
     * Get all registered users from Layman's endpoint service
     */
    getAllUsers() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if ((_a = this.endpoint) === null || _a === void 0 ? void 0 : _a.authenticated) {
                const url = `${this.endpoint.url}/rest/users`;
                try {
                    this.allUsers = yield lastValueFrom(this.$http.get(url, { withCredentials: true }).pipe(map((res) => {
                        return res
                            .filter((user) => user.username != this.endpoint.user)
                            .map((user) => {
                            const laymanUser = {
                                username: user.username,
                                screenName: user.screen_name,
                                givenName: user.given_name,
                                familyName: user.family_name,
                                middleName: user.middle_name,
                                name: user.name,
                            };
                            laymanUser.hslDisplayName = this.getUserName(laymanUser);
                            return laymanUser;
                        });
                    })));
                }
                catch (e) {
                    this.hsLog.error(e);
                }
            }
        });
    }
    /**
     * Refresh user list, when searching for specific user
     */
    refreshList() {
        this.allUsers = Array.from(this.allUsers);
    }
    /**
     * Refresh user list, when searching for specific user
     * @param user - Provided Layman's service user
     */
    getUserName(user) {
        if (user.givenName && user.familyName) {
            return user.givenName + ' ' + user.familyName;
        }
        else if (user.screenName) {
            return user.screenName;
        }
        else {
            return user.username;
        }
    }
}
HsCommonLaymanAccessRightsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCommonLaymanAccessRightsComponent, deps: [{ token: HsLanguageService }, { token: HsLaymanService }, { token: i1.HttpClient }, { token: HsLogService }], target: i0.ɵɵFactoryTarget.Component });
HsCommonLaymanAccessRightsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsCommonLaymanAccessRightsComponent, selector: "hs-layman-access-rights", inputs: { access_rights: "access_rights", app: "app" }, ngImport: i0, template: "<!-- Access rights template -->\n<ng-template #accessRightsTpl let-accessRights=\"access_rights\" let-right=\"right\" let-grantedTo=\"grantedTo\">\n    <div class=\"form-group d-flex justify-content-between\">\n        <label class=\"pt-2\" style=\"margin-bottom: 0;\">\n            {{getRightTranslation(right)}}\n        </label>\n        <div class=\"btn-group\">\n            <button type=\"button\" class=\"btn btn-light hs-toolbar-button  btn-outline-secondary\"\n                [disabled]=\"right !== 'read' && access_rights['access_rights.read'] === 'private'\"\n                (click)=\"accessRightsChanged('access_rights.' + right,grantedTo)\"\n                [ngClass]=\"{'active':access_rights['access_rights.'+ right] === grantedTo}\">\n                {{'SAVECOMPOSITION.public' | translateHs : {app} }}\n            </button>\n            <button type=\"button\" class=\"btn btn-light hs-toolbar-button  btn-outline-secondary\"\n                (click)=\"accessRightsChanged('access_rights.' + right,'private')\"\n                [ngClass]=\"{'active':access_rights['access_rights.' + right] === 'private'}\">\n                {{'SAVECOMPOSITION.private' | translateHs : {app} }}\n            </button>\n        </div>\n    </div>\n</ng-template>\n<ul class=\"nav nav-tabs justify-content-end my-2 py-1\">\n    <li class=\"nav-item\" (click)=\"changeGrantingOptions(grantingOptions.EVERYONE)\">\n        <a [ngClass]=\"{'active': currentOption === grantingOptions.EVERYONE}\" class=\"nav-link \"\n            aria-current=\"page\">{{'SAVECOMPOSITION.everyone' | translateHs : {app} }}</a>\n    </li>\n    <li class=\"nav-item\" (click)=\"changeGrantingOptions(grantingOptions.PERUSER)\">\n        <a [ngClass]=\"{'active': currentOption === grantingOptions.PERUSER}\" class=\"nav-link \"\n            aria-current=\"page\">{{'SAVECOMPOSITION.perUser' | translateHs : {app} }}</a>\n    </li>\n</ul>\n<ng-container *ngIf=\"currentOption === grantingOptions.EVERYONE; else perUserTpl\">\n    <ng-container\n        *ngTemplateOutlet=\"accessRightsTpl;context:{accessRights: access_rights, right: 'read', grantedTo: 'EVERYONE'}\">\n    </ng-container>\n    <ng-container\n        *ngTemplateOutlet=\"accessRightsTpl;context:{accessRights: access_rights, right: 'write', grantedTo: 'EVERYONE'}\">\n    </ng-container>\n</ng-container>\n\n<ng-template #perUserTpl>\n    <div><input type=\"search\" class=\"form-control hs-save-map-filter\"\n            [placeholder]=\"'COMMON.filter' | translateHs : {app}\" [(ngModel)]=\"userSearch\"\n            [ngModelOptions]=\"{standalone: true}\" (input)=\"refreshList()\">\n    </div>\n    <div class=\"hs-save-map-users-list p-1 my-1\">\n        <div class=\"d-flex flex-row justify-content-between align-items-start p-1\"\n            *ngFor=\"let user of allUsers | filter: userFilter\">\n            <span class=\"w-50\">{{user.hslDisplayName}}</span>\n            <label style=\"cursor: pointer;\"><input class=\"me-2\" type=\"checkbox\" name=\"rightToRead\"\n                    [(ngModel)]=\"user.read\"\n                    (change)=\"accessRightsChanged('access_rights.read', user.username, $event)\">{{'SAVECOMPOSITION.form.read'\n                | translateHs : {app} }}</label>\n            <label style=\"cursor: pointer;\"><input class=\"me-2\" type=\"checkbox\" name=\"rightToWrite\"\n                    [(ngModel)]=\"user.write\"\n                    (change)=\"accessRightsChanged('access_rights.write', user.username, $event)\">{{'SAVECOMPOSITION.form.write'\n                | translateHs : {app} }}</label>\n        </div>\n    </div>\n</ng-template>", directives: [{ type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3$1.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }], pipes: { "translateHs": TranslateCustomPipe, "filter": FilterPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCommonLaymanAccessRightsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-layman-access-rights', template: "<!-- Access rights template -->\n<ng-template #accessRightsTpl let-accessRights=\"access_rights\" let-right=\"right\" let-grantedTo=\"grantedTo\">\n    <div class=\"form-group d-flex justify-content-between\">\n        <label class=\"pt-2\" style=\"margin-bottom: 0;\">\n            {{getRightTranslation(right)}}\n        </label>\n        <div class=\"btn-group\">\n            <button type=\"button\" class=\"btn btn-light hs-toolbar-button  btn-outline-secondary\"\n                [disabled]=\"right !== 'read' && access_rights['access_rights.read'] === 'private'\"\n                (click)=\"accessRightsChanged('access_rights.' + right,grantedTo)\"\n                [ngClass]=\"{'active':access_rights['access_rights.'+ right] === grantedTo}\">\n                {{'SAVECOMPOSITION.public' | translateHs : {app} }}\n            </button>\n            <button type=\"button\" class=\"btn btn-light hs-toolbar-button  btn-outline-secondary\"\n                (click)=\"accessRightsChanged('access_rights.' + right,'private')\"\n                [ngClass]=\"{'active':access_rights['access_rights.' + right] === 'private'}\">\n                {{'SAVECOMPOSITION.private' | translateHs : {app} }}\n            </button>\n        </div>\n    </div>\n</ng-template>\n<ul class=\"nav nav-tabs justify-content-end my-2 py-1\">\n    <li class=\"nav-item\" (click)=\"changeGrantingOptions(grantingOptions.EVERYONE)\">\n        <a [ngClass]=\"{'active': currentOption === grantingOptions.EVERYONE}\" class=\"nav-link \"\n            aria-current=\"page\">{{'SAVECOMPOSITION.everyone' | translateHs : {app} }}</a>\n    </li>\n    <li class=\"nav-item\" (click)=\"changeGrantingOptions(grantingOptions.PERUSER)\">\n        <a [ngClass]=\"{'active': currentOption === grantingOptions.PERUSER}\" class=\"nav-link \"\n            aria-current=\"page\">{{'SAVECOMPOSITION.perUser' | translateHs : {app} }}</a>\n    </li>\n</ul>\n<ng-container *ngIf=\"currentOption === grantingOptions.EVERYONE; else perUserTpl\">\n    <ng-container\n        *ngTemplateOutlet=\"accessRightsTpl;context:{accessRights: access_rights, right: 'read', grantedTo: 'EVERYONE'}\">\n    </ng-container>\n    <ng-container\n        *ngTemplateOutlet=\"accessRightsTpl;context:{accessRights: access_rights, right: 'write', grantedTo: 'EVERYONE'}\">\n    </ng-container>\n</ng-container>\n\n<ng-template #perUserTpl>\n    <div><input type=\"search\" class=\"form-control hs-save-map-filter\"\n            [placeholder]=\"'COMMON.filter' | translateHs : {app}\" [(ngModel)]=\"userSearch\"\n            [ngModelOptions]=\"{standalone: true}\" (input)=\"refreshList()\">\n    </div>\n    <div class=\"hs-save-map-users-list p-1 my-1\">\n        <div class=\"d-flex flex-row justify-content-between align-items-start p-1\"\n            *ngFor=\"let user of allUsers | filter: userFilter\">\n            <span class=\"w-50\">{{user.hslDisplayName}}</span>\n            <label style=\"cursor: pointer;\"><input class=\"me-2\" type=\"checkbox\" name=\"rightToRead\"\n                    [(ngModel)]=\"user.read\"\n                    (change)=\"accessRightsChanged('access_rights.read', user.username, $event)\">{{'SAVECOMPOSITION.form.read'\n                | translateHs : {app} }}</label>\n            <label style=\"cursor: pointer;\"><input class=\"me-2\" type=\"checkbox\" name=\"rightToWrite\"\n                    [(ngModel)]=\"user.write\"\n                    (change)=\"accessRightsChanged('access_rights.write', user.username, $event)\">{{'SAVECOMPOSITION.form.write'\n                | translateHs : {app} }}</label>\n        </div>\n    </div>\n</ng-template>" }]
        }], ctorParameters: function () { return [{ type: HsLanguageService }, { type: HsLaymanService }, { type: i1.HttpClient }, { type: HsLogService }]; }, propDecorators: { access_rights: [{
                type: Input
            }], app: [{
                type: Input
            }] } });

class HsSaveToLaymanComponent {
    constructor() {
        this.app = 'default';
    }
}
HsSaveToLaymanComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSaveToLaymanComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
HsSaveToLaymanComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsSaveToLaymanComponent, selector: "hs-save-to-layman", inputs: { data: "data", app: "app" }, ngImport: i0, template: "<ng-container *ngIf=\"data.type !== 'shp' && data.type !== 'raster'\">\n  <div class=\"d-flex flex-row justify-content-between align-items-baseline mb-1 ps-4\">\n    {{'ADDDATA.saveToDatabase' | translateHs : {app} }}\n    <div class=\"btn-group ms-2\">\n      <button type=\"button\" class=\"btn btn-light  btn-outline-secondary\" (click)=\"data.saveToLayman = true\"\n        [ngClass]=\"{'active':data.saveToLayman}\">\n        {{'COMMON.yes' | translateHs : {app} }}\n      </button>\n      <button type=\"button\" class=\"btn btn-light  btn-outline-secondary\" (click)=\"data.saveToLayman = false\"\n        [ngClass]=\"{'active': !data.saveToLayman}\">\n        {{'COMMON.no' | translateHs : {app} }}\n      </button>\n    </div>\n  </div>\n</ng-container>\n<div class=\"ps-4 mt-3\">\n  <hs-layman-access-rights *ngIf=\"data.saveToLayman\" [app]=\"app\" [(access_rights)]=\"data.access_rights\">\n  </hs-layman-access-rights>\n</div>\n", components: [{ type: HsCommonLaymanAccessRightsComponent, selector: "hs-layman-access-rights", inputs: ["access_rights", "app"] }], directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSaveToLaymanComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-save-to-layman', template: "<ng-container *ngIf=\"data.type !== 'shp' && data.type !== 'raster'\">\n  <div class=\"d-flex flex-row justify-content-between align-items-baseline mb-1 ps-4\">\n    {{'ADDDATA.saveToDatabase' | translateHs : {app} }}\n    <div class=\"btn-group ms-2\">\n      <button type=\"button\" class=\"btn btn-light  btn-outline-secondary\" (click)=\"data.saveToLayman = true\"\n        [ngClass]=\"{'active':data.saveToLayman}\">\n        {{'COMMON.yes' | translateHs : {app} }}\n      </button>\n      <button type=\"button\" class=\"btn btn-light  btn-outline-secondary\" (click)=\"data.saveToLayman = false\"\n        [ngClass]=\"{'active': !data.saveToLayman}\">\n        {{'COMMON.no' | translateHs : {app} }}\n      </button>\n    </div>\n  </div>\n</ng-container>\n<div class=\"ps-4 mt-3\">\n  <hs-layman-access-rights *ngIf=\"data.saveToLayman\" [app]=\"app\" [(access_rights)]=\"data.access_rights\">\n  </hs-layman-access-rights>\n</div>\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { data: [{
                type: Input
            }], app: [{
                type: Input
            }] } });

class HsConfirmDialogComponent {
    constructor(HsDialogContainerService) {
        this.HsDialogContainerService = HsDialogContainerService;
    }
    yes() {
        this.HsDialogContainerService.destroy(this, this.data.app);
        this.dialogItem.resolve('yes');
    }
    no() {
        this.HsDialogContainerService.destroy(this, this.data.app);
        this.dialogItem.resolve('no');
    }
}
HsConfirmDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsConfirmDialogComponent, deps: [{ token: HsDialogContainerService }], target: i0.ɵɵFactoryTarget.Component });
HsConfirmDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsConfirmDialogComponent, selector: "hs-confirm-dialog", ngImport: i0, template: "<div class=\"modal in\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h4 class=\"modal-title\">\n                    {{data.title}}\n                </h4>\n                <button type=\"button\" (click)=\"no()\" class=\"btn-close\" data-dismiss=\"modal\" attr.aria-label=\"{{'COMMON.close' | translateHs : {app: data.app} }}\"></button>\n            </div>\n            <div class=\"modal-body\" style=\"overflow-y:auto\">\n                <p class=\"fw-bold h6\">{{data.message}}</p>\n                <p class=\"h6 small\">{{data.note}}</p>\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-primary\" (click)=\"yes()\" [title]=\"'COMMON.yes' | translateHs : data\" data-dismiss=\"modal\">{{'COMMON.yes' | translateHs : {app: data.app} }}</button>\n                <button type=\"button\" class=\"btn btn-secondary compositions-btn-cancel\" [title]=\"'COMMON.no' | translateHs : data\" (click)=\"no()\" data-dismiss=\"modal\">{{'COMMON.no' | translateHs : {app: data.app} }}</button>\n            </div>\n        </div>\n    </div>\n</div>\n", pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsConfirmDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-confirm-dialog', template: "<div class=\"modal in\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h4 class=\"modal-title\">\n                    {{data.title}}\n                </h4>\n                <button type=\"button\" (click)=\"no()\" class=\"btn-close\" data-dismiss=\"modal\" attr.aria-label=\"{{'COMMON.close' | translateHs : {app: data.app} }}\"></button>\n            </div>\n            <div class=\"modal-body\" style=\"overflow-y:auto\">\n                <p class=\"fw-bold h6\">{{data.message}}</p>\n                <p class=\"h6 small\">{{data.note}}</p>\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-primary\" (click)=\"yes()\" [title]=\"'COMMON.yes' | translateHs : data\" data-dismiss=\"modal\">{{'COMMON.yes' | translateHs : {app: data.app} }}</button>\n                <button type=\"button\" class=\"btn btn-secondary compositions-btn-cancel\" [title]=\"'COMMON.no' | translateHs : data\" (click)=\"no()\" data-dismiss=\"modal\">{{'COMMON.no' | translateHs : {app: data.app} }}</button>\n            </div>\n        </div>\n    </div>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: HsDialogContainerService }]; } });

class HsDrawServiceParams {
    constructor() {
        this.drawableLayers = [];
        this.drawableLaymanLayers = [];
        this.hasSomeDrawables = false;
        this.moreThenOneDrawable = false;
        this.boxSelectionActive = false;
        this.snapActive = false;
        this.drawActive = false;
        this.selectedFeatures = new Collection();
        this.toggleSelectionString = 'selectAllFeatures';
        this.highlightDrawButton = false; // Toggles toolbar button 'Draw' class
        this.onlyMine = true;
        this.addedLayersRemoved = false;
        this.drawingLayerChanges = new Subject();
        this.layerMetadataDialog = new Subject();
        //Layer being loaded from layman (endpoint url pending)
        this.pendingLayers = [];
        this.requiredSymbolizer = {
            Point: ['Point'],
            Polygon: ['Fill', 'Line'],
            LineString: ['Line'],
            Circle: ['Fill', 'Line'],
        };
    }
}

class HsRmMultipleDialogComponent {
    constructor(HsDialogContainerService, hsLanguageService) {
        this.HsDialogContainerService = HsDialogContainerService;
        this.hsLanguageService = hsLanguageService;
        this._selectAll = false;
    }
    ngOnInit() {
        for (const item of this.data.items) {
            item.displayTitle = this.getTitle(item);
        }
    }
    yes() {
        this.HsDialogContainerService.destroy(this, this.data.app);
        this.dialogItem.resolve('yes');
    }
    no() {
        this.HsDialogContainerService.destroy(this, this.data.app);
        this.dialogItem.resolve('no');
    }
    checkToRemove(item) {
        if (item.toRemove !== undefined) {
            item.toRemove = !item.toRemove;
        }
        else {
            item.toRemove = true;
        }
    }
    selectDeselectAll() {
        this._selectAll = !this._selectAll;
        for (const item of this.data.items) {
            item.toRemove = this._selectAll;
        }
    }
    getTitle(item) {
        let title = item instanceof Layer ? getTitle(item) : item.name;
        if (!title) {
            title = this.hsLanguageService.getTranslation('COMMON.unknown', undefined, this.data.app);
        }
        return title;
    }
}
HsRmMultipleDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsRmMultipleDialogComponent, deps: [{ token: HsDialogContainerService }, { token: HsLanguageService }], target: i0.ɵɵFactoryTarget.Component });
HsRmMultipleDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsRmMultipleDialogComponent, selector: "hs-rm-multiple-dialog", ngImport: i0, template: "<div class=\"modal in\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h4 class=\"modal-title\">\n                    {{data.title}}\n                </h4>\n                <button type=\"button\" (click)=\"no()\" class=\"btn-close\" data-dismiss=\"modal\"\n                    attr.aria-label=\"{{'COMMON.close' | translateHs : {app: data.app} }}\"></button>\n            </div>\n            <div class=\"modal-body\" style=\"overflow-y:auto\">\n                <p class=\"fw-bold h6\">{{data.message}}</p>\n                <p class=\"h6 small\">{{data.note}}</p>\n                <div *ngIf=\"data.items?.length > 0\">\n                    <div class=\"d-flex w-100 justify-content-center\">\n                        <button type=\"button\" class=\"mt-1 btn btn-primary\"\n                            (click)=\"selectDeselectAll()\">{{'SAVECOMPOSITION.form.toggleAll' |\n                            translateHs : {app: data.app} }}</button>\n                    </div>\n                    <div class=\"d-flex align-items-center\" style=\"word-break:break-all\" *ngFor=\"let item of data.items\">\n                        <button type=\"button\" class=\"btn btn-sm m-0 p-0\"\n                            (click)=\"checkToRemove(item);$event.stopPropagation()\"\n                            [ngClass]=\"item.toRemove ? 'hs-checkmark' : 'hs-uncheckmark'\"></button>\n                        <p class=\"m-0 ps-1\">{{item.displayTitle}}</p>\n                    </div>\n                </div>\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-primary\" (click)=\"yes()\" [title]=\"'COMMON.yes' | translateHs : data\"\n                    data-dismiss=\"modal\">{{'COMMON.yes' | translateHs : {app: data.app} }}</button>\n                <button type=\"button\" class=\"btn btn-secondary compositions-btn-cancel\"\n                    [title]=\"'COMMON.no' | translateHs : data\" (click)=\"no()\" data-dismiss=\"modal\">{{'COMMON.no' |\n                    translateHs : {app: data.app} }}</button>\n            </div>\n        </div>\n    </div>\n</div>", directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsRmMultipleDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-rm-multiple-dialog', template: "<div class=\"modal in\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h4 class=\"modal-title\">\n                    {{data.title}}\n                </h4>\n                <button type=\"button\" (click)=\"no()\" class=\"btn-close\" data-dismiss=\"modal\"\n                    attr.aria-label=\"{{'COMMON.close' | translateHs : {app: data.app} }}\"></button>\n            </div>\n            <div class=\"modal-body\" style=\"overflow-y:auto\">\n                <p class=\"fw-bold h6\">{{data.message}}</p>\n                <p class=\"h6 small\">{{data.note}}</p>\n                <div *ngIf=\"data.items?.length > 0\">\n                    <div class=\"d-flex w-100 justify-content-center\">\n                        <button type=\"button\" class=\"mt-1 btn btn-primary\"\n                            (click)=\"selectDeselectAll()\">{{'SAVECOMPOSITION.form.toggleAll' |\n                            translateHs : {app: data.app} }}</button>\n                    </div>\n                    <div class=\"d-flex align-items-center\" style=\"word-break:break-all\" *ngFor=\"let item of data.items\">\n                        <button type=\"button\" class=\"btn btn-sm m-0 p-0\"\n                            (click)=\"checkToRemove(item);$event.stopPropagation()\"\n                            [ngClass]=\"item.toRemove ? 'hs-checkmark' : 'hs-uncheckmark'\"></button>\n                        <p class=\"m-0 ps-1\">{{item.displayTitle}}</p>\n                    </div>\n                </div>\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-primary\" (click)=\"yes()\" [title]=\"'COMMON.yes' | translateHs : data\"\n                    data-dismiss=\"modal\">{{'COMMON.yes' | translateHs : {app: data.app} }}</button>\n                <button type=\"button\" class=\"btn btn-secondary compositions-btn-cancel\"\n                    [title]=\"'COMMON.no' | translateHs : data\" (click)=\"no()\" data-dismiss=\"modal\">{{'COMMON.no' |\n                    translateHs : {app: data.app} }}</button>\n            </div>\n        </div>\n    </div>\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsDialogContainerService }, { type: HsLanguageService }]; } });

/**
 * @param record - Record of one dataset from Get Records response
 * @returns
 * Create extent features for displaying extent of loaded dataset records in map
 */
function addExtentFeature(record, mapProjection) {
    const attributes = {
        hs_notqueryable: true,
        highlighted: false,
        title: record.title || record.name,
        geometry: null,
        id: generateUuid(),
    };
    let mapExtent = mapProjection.getExtent();
    if (mapExtent === null) {
        console.warn('Map projection extent not found - fallback value used. To prevent unexpected results of app functionalities define it by yourself. Eg. mapExtent.setExtent([extent])');
        mapProjection.setExtent(transformExtentValue(parseExtent([-180, -90, 180, 90]), mapProjection, true));
        mapExtent = mapProjection.getExtent();
    }
    const recordBBox = record.bbox || record.bounding_box;
    const b = parseExtent(recordBBox || ['180', '180', '180', '180']);
    //Check if height or Width covers the whole screen
    const extent = record.bounding_box //if from layman
        ? transformExtentValue(b, mapProjection, true)
        : transformExtentValue(b, mapProjection);
    if (b &&
        ((extent[0] < mapExtent[0] && extent[2] > mapExtent[2]) ||
            (extent[1] < mapExtent[1] && extent[3] > mapExtent[3]))) {
        return;
    }
    attributes.geometry = fromExtent(extent);
    const extentFeature = new Feature(attributes);
    extentFeature.setId(extentFeature.get('id'));
    return extentFeature;
}
function transformExtentValue(pairs, mapProjection, disableTransform) {
    if (!pairs) {
        return;
    }
    let first_pair;
    let second_pair;
    if (disableTransform) {
        (first_pair = pairs[0]), (second_pair = pairs[1]);
    }
    else {
        first_pair = transform(pairs[0], 'EPSG:4326', mapProjection);
        second_pair = transform(pairs[1], 'EPSG:4326', mapProjection);
    }
    const mapProjectionExtent = mapProjection.getExtent();
    if (!isFinite(first_pair[0])) {
        first_pair[0] = mapProjectionExtent[0];
    }
    if (!isFinite(first_pair[1])) {
        first_pair[1] = mapProjectionExtent[1];
    }
    if (!isFinite(second_pair[0])) {
        second_pair[0] = mapProjectionExtent[2];
    }
    if (!isFinite(second_pair[1])) {
        second_pair[1] = mapProjectionExtent[3];
    }
    if (isNaN(first_pair[0]) ||
        isNaN(first_pair[1]) ||
        isNaN(second_pair[0]) ||
        isNaN(second_pair[1])) {
        return;
    }
    return [first_pair[0], first_pair[1], second_pair[0], second_pair[1]];
}
function parseExtent(bbox) {
    if (!bbox) {
        return;
    }
    let b;
    const pairs = [];
    if (typeof bbox === 'string') {
        b = bbox.split(' ');
    }
    else if (Array.isArray(bbox)) {
        b = bbox;
    }
    pairs.push([parseFloat(b[0]), parseFloat(b[1])]);
    pairs.push([parseFloat(b[2]), parseFloat(b[3])]);
    return pairs;
}

class HsLaymanBrowserService {
    constructor(http, log, hsCommonLaymanService, hsUtilsService, hsToastService, hsLanguageService, hsMapService) {
        this.http = http;
        this.log = log;
        this.hsCommonLaymanService = hsCommonLaymanService;
        this.hsUtilsService = hsUtilsService;
        this.hsToastService = hsToastService;
        this.hsLanguageService = hsLanguageService;
        this.hsMapService = hsMapService;
    }
    /**
     * Loads datasets metadata from Layman
     * @param endpoint - Configuration of selected datasource (from app config)
     * extent feature is created. Has one parameter: feature
     * @param data -
     */
    queryCatalog(endpoint, app, data, extentFeatureCreated) {
        var _a, _b;
        endpoint.getCurrentUserIfNeeded(endpoint, app);
        const withPermissionOrMine = (data === null || data === void 0 ? void 0 : data.onlyMine)
            ? endpoint.user !== 'anonymous' && endpoint.user !== 'browser'
                ? `workspaces/${endpoint.user}/`
                : ''
            : '';
        const url = `${endpoint.url}/rest/${withPermissionOrMine}layers`;
        endpoint.datasourcePaging.loaded = false;
        let query, bbox, sortBy, params;
        if (data) {
            query = data.query;
            sortBy = query.sortby == 'date' ? 'last_change' : query.sortby;
            const b = transformExtent(this.hsMapService
                .getMap(app)
                .getView()
                .calculateExtent(this.hsMapService.getMap(app).getSize()), this.hsMapService.getMap(app).getView().getProjection(), 'EPSG:3857');
            bbox = data.filterByExtent ? b.join(',') : '';
            params = {
                //Draw layer limit independent on datasourcePaging
                'limit': `${(_a = data.limit) !== null && _a !== void 0 ? _a : endpoint.datasourcePaging.limit}`,
                'offset': `${endpoint.datasourcePaging.start}`,
                'full_text_filter': `${(_b = query === null || query === void 0 ? void 0 : query.textFilter) !== null && _b !== void 0 ? _b : ''}`,
                'order_by': `${sortBy !== null && sortBy !== void 0 ? sortBy : 'last_change'}`,
            };
            //Use bbox_filter only if its defined to prevent
            //Wrong parameter value error
            if (bbox) {
                params['bbox_filter'] = bbox;
            }
        }
        endpoint.httpCall = this.http
            .get(url, {
            observe: 'response',
            withCredentials: true,
            responseType: 'json',
            params,
        })
            .pipe(timeout(5000), map((x) => {
            if (Array.isArray(x.body)) {
                x.body.dataset = endpoint;
                x.body.extentFeatureCreated = extentFeatureCreated;
                x.body.matched = x.headers.get('x-total-count')
                    ? x.headers.get('x-total-count')
                    : x.body.length;
                this.datasetsReceived(x.body, app);
            }
            else {
                this.hsCommonLaymanService.displayLaymanError(endpoint, 'ADDLAYERS.ERROR.errorWhileRequestingLayers', x.body, app);
            }
            return x.body;
        }), catchError((e) => __awaiter(this, void 0, void 0, function* () {
            var _c, _d, _e;
            if (isErrorHandlerFunction((_c = endpoint.onError) === null || _c === void 0 ? void 0 : _c.compositionLoad)) {
                (_d = endpoint.onError) === null || _d === void 0 ? void 0 : _d.compositionLoad.handle(endpoint, e);
                return of(e);
            }
            switch ((_e = endpoint.onError) === null || _e === void 0 ? void 0 : _e.compositionLoad) {
                case EndpointErrorHandling.ignore:
                    break;
                case EndpointErrorHandling.toast:
                default:
                    this.hsToastService.createToastPopupMessage(yield this.hsLanguageService.awaitTranslation('ADDLAYERS.ERROR.errorWhileRequestingLayers', undefined, app), endpoint.title +
                        ': ' +
                        this.hsLanguageService.getTranslationIgnoreNonExisting('ERRORMESSAGES', e.status ? e.status.toString() : e.message, { url }, app), {
                        disableLocalization: true,
                        serviceCalledFrom: 'HsLaymanBrowserService',
                    }, app);
            }
            endpoint.datasourcePaging.loaded = true;
            return of(e);
        })));
        return endpoint.httpCall;
    }
    /**
     * (PRIVATE) Callback for catalogue http query
     * @param data - HTTP response containing all the layers
     */
    datasetsReceived(data, app) {
        if (!data.dataset) {
            this.hsToastService.createToastPopupMessage(this.hsLanguageService.getTranslation('COMMON.warning', undefined, app), data.dataset.title +
                ': ' +
                this.hsLanguageService.getTranslation('COMMON.noDataReceived', undefined, app), {
                disableLocalization: true,
                toastStyleClasses: 'bg-warning text-light',
                serviceCalledFrom: 'HsLaymanBrowserService',
            }, app);
            return;
        }
        const dataset = data.dataset;
        dataset.loading = false;
        dataset.layers = [];
        dataset.datasourcePaging.loaded = true;
        if (!data.length) {
            dataset.datasourcePaging.matched = 0;
        }
        else {
            dataset.datasourcePaging.matched = parseInt(data.matched);
            dataset.layers = data.map((layer) => {
                const tmp = {
                    title: layer.title,
                    name: layer.name,
                    id: layer.uuid,
                    featureId: layer.featureId,
                    highlighted: false,
                    workspace: layer.workspace,
                    access_rights: layer.access_rights,
                    editable: layer.access_rights.write.some((user) => {
                        return [dataset.user, 'EVERYONE'].includes(user);
                    }),
                };
                if (data.extentFeatureCreated) {
                    const extentFeature = addExtentFeature(layer, this.hsMapService.getCurrentProj(app));
                    if (extentFeature) {
                        tmp.featureId = extentFeature.getId();
                        data.extentFeatureCreated(extentFeature);
                    }
                }
                return tmp;
            });
        }
    }
    /**
     * Fills metadata about layer, because Layman layer list API provides just name and UUID
     * @param endpoint - Configuration of selected datasource (from app config)
     * @param layer - Layman layer for which to get metadata
     * @returns Promise which is resolved when layer metadata is filled
     */
    fillLayerMetadata(endpoint, layer) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${endpoint.url}/rest/workspaces/${layer.workspace}/layers/${layer.name}`;
            try {
                const data = yield lastValueFrom(this.http.get(url, {
                    //timeout: endpoint.canceler.promise,
                    //endpoint,
                    responseType: 'json',
                    withCredentials: true,
                }));
                layer.type =
                    ((_a = data === null || data === void 0 ? void 0 : data.file) === null || _a === void 0 ? void 0 : _a.file_type) === 'raster' ? ['WMS'] : ['WMS', 'WFS'];
                layer = Object.assign(Object.assign({}, layer), data);
                if (layer.thumbnail) {
                    layer.thumbnail = endpoint.url + layer.thumbnail.url;
                }
                return layer;
            }
            catch (e) {
                this.log.error(e);
                return e;
            }
        });
    }
    /**
     * Gets layer metadata and returns promise which describes layer
     * @param ds - Configuration of selected datasource (from app config)
     * @param layer - Layman layer for which to get metadata
     * @returns Promise which describes layer in a common format for use in add-layers component
     */
    describeWhatToAdd(ds, layer, app) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            const lyr = yield this.fillLayerMetadata(ds, layer);
            let style = undefined;
            if ((_a = lyr.style) === null || _a === void 0 ? void 0 : _a.url) {
                style = yield this.getStyleFromUrl((_b = lyr.style) === null || _b === void 0 ? void 0 : _b.url);
            }
            if (((_c = lyr.style) === null || _c === void 0 ? void 0 : _c.type) == 'sld') {
                if (!(style === null || style === void 0 ? void 0 : style.includes('StyledLayerDescriptor'))) {
                    style = undefined;
                }
            }
            if (((_d = lyr.style) === null || _d === void 0 ? void 0 : _d.type) == 'qml') {
                if (!(style === null || style === void 0 ? void 0 : style.includes('<qgis'))) {
                    style = undefined;
                }
            }
            if (lyr.wms.url) {
                return {
                    type: lyr.type,
                    link: lyr.wms.url,
                    style,
                    layer: lyr.name,
                    name: lyr.name,
                    title: lyr.title,
                    dsType: ds.type,
                    editable: lyr.editable,
                    workspace: lyr.workspace,
                };
            }
            else {
                this.hsToastService.createToastPopupMessage(this.hsLanguageService.getTranslation('ADDLAYERS.ERROR.errorWhileRequestingLayers', undefined, app), this.hsLanguageService.getTranslation('ADDLAYERS.ERROR.urlInvalid', undefined, app), {
                    disableLocalization: true,
                    serviceCalledFrom: 'HsLaymanBrowserService',
                }, app);
                return false;
            }
        });
    }
    getStyleFromUrl(styleUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield lastValueFrom(this.http.get(styleUrl, {
                    headers: new HttpHeaders().set('Content-Type', 'text'),
                    responseType: 'text',
                    withCredentials: true,
                }));
            }
            catch (ex) {
                console.error(ex);
            }
        });
    }
}
HsLaymanBrowserService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLaymanBrowserService, deps: [{ token: i1.HttpClient }, { token: HsLogService }, { token: HsCommonLaymanService }, { token: HsUtilsService }, { token: HsToastService }, { token: HsLanguageService }, { token: HsMapService }], target: i0.ɵɵFactoryTarget.Injectable });
HsLaymanBrowserService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLaymanBrowserService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLaymanBrowserService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: HsLogService }, { type: HsCommonLaymanService }, { type: HsUtilsService }, { type: HsToastService }, { type: HsLanguageService }, { type: HsMapService }]; } });

const TMP_LAYER_TITLE = 'tmpDrawLayer';
class HsDrawService {
    constructor(hsMapService, hsLayerUtilsService, hsEventBusService, hsLayoutService, hsDialogContainerService, hsLogService, hsConfig, hsQueryBaseService, hsQueryVectorService, hsLaymanService, hsLanguageService, hsLaymanBrowserService, hsAddDataVectorService, hsUtilsService, hsCommonLaymanService, hsToastService, hsAddDataOwsService, zone) {
        this.hsMapService = hsMapService;
        this.hsLayerUtilsService = hsLayerUtilsService;
        this.hsEventBusService = hsEventBusService;
        this.hsLayoutService = hsLayoutService;
        this.hsDialogContainerService = hsDialogContainerService;
        this.hsLogService = hsLogService;
        this.hsConfig = hsConfig;
        this.hsQueryBaseService = hsQueryBaseService;
        this.hsQueryVectorService = hsQueryVectorService;
        this.hsLaymanService = hsLaymanService;
        this.hsLanguageService = hsLanguageService;
        this.hsLaymanBrowserService = hsLaymanBrowserService;
        this.hsAddDataVectorService = hsAddDataVectorService;
        this.hsUtilsService = hsUtilsService;
        this.hsCommonLaymanService = hsCommonLaymanService;
        this.hsToastService = hsToastService;
        this.hsAddDataOwsService = hsAddDataOwsService;
        this.zone = zone;
        this.apps = { default: new HsDrawServiceParams() };
        this.keyUp = this.keyUp.bind(this);
    }
    get(app) {
        if (this.apps[app !== null && app !== void 0 ? app : 'default'] == undefined) {
            this.apps[app !== null && app !== void 0 ? app : 'default'] = new HsDrawServiceParams();
        }
        return this.apps[app !== null && app !== void 0 ? app : 'default'];
    }
    /**
     * initial function if the draw panel is loaded as first panel
     */
    init(_app) {
        return __awaiter(this, void 0, void 0, function* () {
            const appRef = this.get(_app);
            yield this.hsMapService.loaded(_app);
            const map = this.hsMapService.getMap(_app);
            this.fillDrawableLayers(_app);
            this.hsMapService.getLayersArray(_app).forEach((l) => l.on('change:visible', (e) => {
                if (appRef.draw && l == appRef.selectedLayer) {
                    this.setType(appRef.type, _app);
                }
                this.fillDrawableLayers(_app);
            }));
            appRef.modify = new Modify({
                features: appRef.selectedFeatures,
            });
            map.addInteraction(appRef.modify);
            appRef.selectedFeatures.on('add', (e) => {
                if (appRef.onSelected) {
                    appRef.onSelected(e);
                }
                appRef.modify.setActive(true);
            });
            appRef.selectedFeatures.on('remove', (e) => {
                if (appRef.selectedFeatures.length == 0) {
                    appRef.modify.setActive(false);
                }
            });
            this.hsEventBusService.vectorQueryFeatureSelection.subscribe((event) => {
                if (this.get(event.app) == appRef) {
                    appRef.selectedFeatures.push(event.feature);
                }
            });
            this.hsEventBusService.vectorQueryFeatureDeselection.subscribe(({ feature, selector }) => {
                appRef.selectedFeatures.remove(feature);
            });
            this.hsLaymanService.laymanLayerPending.subscribe((pendingLayers) => {
                appRef.pendingLayers = pendingLayers;
            });
            this.hsEventBusService.mapResets.subscribe(({ app }) => {
                if (app == _app) {
                    appRef.addedLayersRemoved = true;
                    this.fillDrawableLayers(app);
                }
            });
            this.hsEventBusService.mainPanelChanges.subscribe(({ which, app }) => {
                if (which === 'draw' && this.hsMapService.getMap(app)) {
                    this.fillDrawableLayers(app);
                }
            });
            this.hsCommonLaymanService.authChange.subscribe(({ endpoint }) => {
                var _a;
                this.fillDrawableLayers(_app);
                appRef.isAuthorized = endpoint === null || endpoint === void 0 ? void 0 : endpoint.authenticated;
                //When metadata dialog window opened. Layer is being added
                if (appRef.selectedLayer && appRef.tmpDrawLayer) {
                    setWorkspace(appRef.selectedLayer, endpoint === null || endpoint === void 0 ? void 0 : endpoint.user);
                    const definition = {
                        format: appRef.isAuthorized ? 'hs.format.WFS' : null,
                        url: appRef.isAuthorized
                            ? ((_a = this.hsLaymanService.getLaymanEndpoint()) === null || _a === void 0 ? void 0 : _a.url) + '/wfs'
                            : null,
                    };
                    setDefinition(appRef.selectedLayer, definition);
                }
            });
        });
    }
    /**
     * selectedLayerString
     * @returns Possibly translated name of layer selected for drawing
     */
    selectedLayerString(app) {
        const appRef = this.get(app);
        if (appRef.selectedLayer) {
            const title = getTitle(appRef.selectedLayer);
            return title == TMP_LAYER_TITLE
                ? this.hsLanguageService.getTranslation('DRAW.unsavedDrawing', undefined, app)
                : this.hsLayerUtilsService.translateTitle(title, app) ||
                    getName(appRef.selectedLayer);
        }
        else {
            return this.hsLanguageService.getTranslation('DRAW.Select layer', undefined, app);
        }
    }
    /**
     * snapLayerString
     * @returns Possibly translated name of layer selected for snapping
     */
    snapLayerString(app) {
        const appRef = this.get(app);
        if (appRef.snapLayer) {
            const title = getTitle(appRef.snapLayer);
            return (this.hsLayerUtilsService.translateTitle(title, app) ||
                getName(appRef.snapLayer));
        }
    }
    saveDrawingLayer(app) {
        const appRef = this.get(app);
        if (appRef.selectedLayer) {
            appRef.previouslySelected = appRef.selectedLayer;
        }
        let tmpTitle = this.hsLanguageService.getTranslation('DRAW.drawLayer', undefined, app);
        const tmpLayer = this.hsMapService.findLayerByTitle(TMP_LAYER_TITLE, app);
        const tmpSource = tmpLayer ? tmpLayer.getSource() : new VectorSource();
        let i = 1;
        while (this.hsMapService.findLayerByTitle(tmpTitle, app)) {
            tmpTitle = `${this.hsLanguageService.getTranslation('DRAW.drawLayer')} ${i++}`;
        }
        const layman = this.hsLaymanService.getLaymanEndpoint();
        const drawLayer = new VectorLayer({
            //TODO: Also name should be set, but take care in case a layer with that name already exists in layman
            source: tmpSource,
            visible: true,
        });
        setTitle(drawLayer, tmpTitle);
        setShowInLayerManager(drawLayer, true);
        setRemovable(drawLayer, true);
        setSld(drawLayer, defaultStyle);
        setEditor(drawLayer, { editable: true });
        setPath(drawLayer, this.hsConfig.get(app).defaultDrawLayerPath || 'User generated'); //TODO: Translate this
        setDefinition(drawLayer, {
            format: appRef.isAuthorized ? 'hs.format.WFS' : null,
            url: appRef.isAuthorized ? layman.url + '/wfs' : null,
        });
        setWorkspace(drawLayer, layman === null || layman === void 0 ? void 0 : layman.user);
        appRef.tmpDrawLayer = true;
        appRef.selectedLayer = drawLayer;
        appRef.layerMetadataDialog.next();
    }
    setType(what, app) {
        const appRef = this.get(app);
        if (appRef.type == what) {
            appRef.type = null;
            this.deactivateDrawing(app);
            const tmpLayer = this.hsMapService.findLayerByTitle(TMP_LAYER_TITLE, app) || null;
            if (tmpLayer) {
                this.hsMapService.getMap(app).removeLayer(tmpLayer);
                appRef.tmpDrawLayer = false;
            }
            this.hsQueryBaseService.activateQueries(app);
            return false;
        }
        //console.log(this.drawableLayers);
        //console.log(this.selectedLayer);
        if (appRef.drawableLayers.length == 0 && !appRef.tmpDrawLayer) {
            const drawLayer = new VectorLayer({
                source: new VectorSource(),
                visible: true,
            });
            setSld(drawLayer, defaultStyle);
            setTitle(drawLayer, TMP_LAYER_TITLE);
            setShowInLayerManager(drawLayer, false);
            setRemovable(drawLayer, true);
            setEditor(drawLayer, { editable: true });
            setPath(drawLayer, this.hsConfig.get(app).defaultDrawLayerPath || 'User generated');
            appRef.tmpDrawLayer = true;
            appRef.selectedLayer = drawLayer;
            this.addDrawLayer(drawLayer, app);
        }
        appRef.type = what;
        if (appRef.selectedLayer) {
            appRef.source = this.hsLayerUtilsService.isLayerClustered(appRef.selectedLayer)
                ? appRef.selectedLayer.getSource().getSource() //Is it clustered vector layer?
                : appRef.selectedLayer.getSource();
        }
        return true;
    }
    /**
     * Handles drawing layer selection/change by activating drawing for selected layer.
     * In case of Layman layer not yet existing in app it pulls the layer first.
     * @param layer -
     */
    selectLayer(layer, app = 'default') {
        var _a, _b, _c, _d, _e;
        return __awaiter(this, void 0, void 0, function* () {
            let metadata;
            let style;
            const appRef = this.get(app);
            if (!(layer instanceof Layer)) {
                metadata = yield this.hsLaymanBrowserService.fillLayerMetadata(appRef.laymanEndpoint, layer);
            }
            if (metadata) {
                if (!((_a = metadata === null || metadata === void 0 ? void 0 : metadata.type) === null || _a === void 0 ? void 0 : _a.includes('WFS'))) {
                    const dialog = this.hsDialogContainerService.create(HsConfirmDialogComponent, {
                        message: this.hsLanguageService.getTranslation('DRAW.thisLayerDoesNotSupportDrawing', undefined, app),
                        title: this.hsLanguageService.getTranslation('DRAW.notAVectorLayer', undefined, app),
                    }, app);
                    const confirmed = yield dialog.waitResult();
                    if (confirmed == 'yes') {
                        yield this.hsAddDataOwsService.connectToOWS({
                            type: 'wms',
                            uri: decodeURIComponent(metadata.wms.url),
                            layer: layer.name,
                        }, app);
                        appRef.selectedLayer = null;
                        this.fillDrawableLayers(app);
                    }
                    return;
                }
                if ((_b = metadata.style) === null || _b === void 0 ? void 0 : _b.url) {
                    style = yield this.hsLaymanBrowserService.getStyleFromUrl((_c = metadata.style) === null || _c === void 0 ? void 0 : _c.url);
                }
                if (((_d = metadata.style) === null || _d === void 0 ? void 0 : _d.type) == 'sld') {
                    if (!(style === null || style === void 0 ? void 0 : style.includes('StyledLayerDescriptor'))) {
                        style = undefined;
                    }
                }
                if (((_e = metadata.style) === null || _e === void 0 ? void 0 : _e.type) == 'qml') {
                    if (!(style === null || style === void 0 ? void 0 : style.includes('<qgis'))) {
                        style = undefined;
                    }
                }
            }
            let lyr = layer;
            if (layer.workspace) {
                lyr = yield this.hsAddDataVectorService.addVectorLayer('wfs', appRef.laymanEndpoint.url, layer.name, layer.title, undefined, 'EPSG:4326', { workspace: layer.workspace, saveToLayman: true, style: style }, app);
                lyr = this.hsMapService.findLayerByTitle(layer.title, app);
            }
            if (lyr != appRef.selectedLayer) {
                if (appRef.selectedLayer &&
                    getTitle(appRef.selectedLayer) == TMP_LAYER_TITLE) {
                    appRef.tmpDrawLayer = false;
                    this.hsMapService.getMap(app).removeLayer(appRef.selectedLayer);
                }
                appRef.selectedLayer = lyr;
                this.changeDrawSource(app);
            }
            this.fillDrawableLayers(app);
        });
    }
    /**
     * Add draw layer to the map and repopulate list of drawables.
     * @param layer -
     */
    addDrawLayer(layer, app) {
        this.hsMapService.getMap(app).addLayer(layer);
        this.fillDrawableLayers(app);
    }
    /**
     * @param changeStyle - controller callback function
     * Update draw style without neccessity to reactivate drawing interaction
     */
    updateStyle(changeStyle, app) {
        const appRef = this.get(app);
        if (appRef.draw) {
            appRef.currentStyle = changeStyle();
            appRef.draw.getOverlay().setStyle(appRef.currentStyle);
        }
    }
    onDrawEnd(e, app) {
        const appRef = this.get(app);
        if (!getEditor(appRef.selectedLayer)) {
            return;
        }
        const editorConfig = getEditor(appRef.selectedLayer);
        if (editorConfig.defaultAttributes) {
            for (const key in editorConfig.defaultAttributes) {
                const value = editorConfig.defaultAttributes[key];
                e.feature.set(key, value);
            }
        }
        /*Timeout is necessary because features are not immediately
         * added to the layer and layer can't be retrieved from the
         * feature, so they don't appear in Info panel */
        if (this.hsLayoutService.get(app).mainpanel != 'draw' &&
            this.hsConfig.get(app).openQueryPanelOnDrawEnd) {
            this.hsLayoutService.setMainPanel('info', app);
        }
        setTimeout(() => {
            this.addFeatureToSelector(e.feature, app);
        });
    }
    /**
     * Adds drawn feature to selection
     */
    addFeatureToSelector(feature, app) {
        //Zone is used to ensure change detection updates the view
        this.zone.run(() => {
            this.hsQueryBaseService.get(app).clear('features');
            this.hsQueryVectorService.init(app);
            this.hsQueryVectorService.apps[app].selector.getFeatures().push(feature);
            this.hsQueryVectorService.createFeatureAttributeList(app);
        });
    }
    /**
     * Re-enables getFeatureInfo info and cleans up after drawing
     */
    afterDrawEnd(app) {
        const appRef = this.get(app);
        if (appRef.draw) {
            appRef.draw.setActive(false);
        }
        appRef.drawActive = false;
    }
    removeLastPoint(app) {
        this.get(app).draw.removeLastPoint();
    }
    /**
     * Sets layer source where new drawing should be pushed to... after 'selectedLayer' change
     */
    changeDrawSource(app) {
        const appRef = this.get(app);
        if (appRef.selectedLayer.getSource === undefined) {
            return;
        }
        appRef.source = this.hsLayerUtilsService.isLayerClustered(appRef.selectedLayer)
            ? appRef.selectedLayer.getSource().getSource()
            : appRef.selectedLayer.getSource();
        appRef.drawingLayerChanges.next({
            layer: appRef.selectedLayer,
            source: appRef.source,
        });
        if (appRef.draw) {
            //Reactivate drawing with updated source
            this.activateDrawing({
                drawState: true,
            }, app);
            //Set snapLayer and snap interaction source
            appRef.snapLayer = appRef.selectedLayer;
            this.toggleSnapping(app, appRef.source);
        }
    }
    /**
     * Deactivate all hs.draw interaction in map (Draw, Modify, Select)
     * @returns {Promise}
     */
    deactivateDrawing(app) {
        const appRef = this.get(app);
        return new Promise((resolve, reject) => {
            this.hsMapService.loaded(app).then((map) => {
                this.afterDrawEnd(app);
                if (appRef.draw) {
                    map.removeInteraction(appRef.draw);
                    appRef.draw = null;
                }
                resolve(null);
            });
        });
    }
    stopDrawing(app) {
        const appRef = this.get(app);
        if (!appRef.draw || appRef.draw === null) {
            return;
        }
        try {
            if (appRef.draw.getActive()) {
                appRef.draw.finishDrawing();
            }
        }
        catch (ex) {
            this.hsLogService.warn(ex);
        }
        appRef.draw.setActive(false);
        appRef.modify.setActive(false);
        this.hsQueryBaseService.activateQueries(app);
        appRef.type = null;
        appRef.drawActive = false;
    }
    startDrawing(app) {
        const draw = this.get(app).draw;
        try {
            if (draw.getActive()) {
                draw.finishDrawing();
            }
        }
        catch (ex) {
            this.hsLogService.warn(ex);
        }
        draw.setActive(true);
    }
    /**
     * Repopulates drawable layers. In case layman connection exists it also creates
     * a list of available server possibilities.
     */
    fillDrawableLayers(app) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const appRef = this.get(app);
            let drawables = [];
            yield this.hsMapService.loaded(app);
            drawables = this.hsMapService
                .getMap(app)
                .getLayers()
                .getArray()
                .filter((layer) => this.hsLayerUtilsService.isLayerDrawable(layer));
            if (drawables.length == 0 && !appRef.tmpDrawLayer) {
                appRef.type = null;
                this.deactivateDrawing(app);
                appRef.selectedLayer = null;
                appRef.snapSource = null;
            }
            else if (drawables.length > 0) {
                if (this.selectedLayerNotAvailable(drawables, app)) {
                    appRef.selectedLayer = drawables[0];
                    this.changeDrawSource(app);
                }
            }
            appRef.addedLayersRemoved = false;
            appRef.drawableLayers = drawables;
            appRef.laymanEndpoint = this.hsLaymanService.getLaymanEndpoint();
            if (appRef.laymanEndpoint) {
                yield lastValueFrom(this.hsLaymanBrowserService.queryCatalog(appRef.laymanEndpoint, app, {
                    onlyMine: appRef.onlyMine,
                    limit: '',
                    query: {},
                }));
                if (appRef.laymanEndpoint.layers) {
                    appRef.drawableLaymanLayers = appRef.laymanEndpoint.layers.filter((layer) => {
                        return (!this.hsMapService.findLayerByTitle(layer.title, app) &&
                            layer.editable);
                    });
                }
            }
            appRef.hasSomeDrawables =
                appRef.drawableLayers.length > 0 ||
                    appRef.drawableLaymanLayers.length > 0;
            appRef.moreThenOneDrawable =
                ((_a = appRef.drawableLayers) === null || _a === void 0 ? void 0 : _a.length) + ((_b = appRef.drawableLaymanLayers) === null || _b === void 0 ? void 0 : _b.length) > 1;
        });
    }
    selectedLayerNotAvailable(drawables, app) {
        const appRef = this.get(app);
        if (appRef.addedLayersRemoved) {
            return true;
        }
        else {
            return (
            //Don't want to change after authChange when layer is being added
            (!appRef.tmpDrawLayer &&
                !drawables.some((layer) => appRef.selectedLayer &&
                    getTitle(layer) == getTitle(appRef.selectedLayer))) ||
                !appRef.selectedLayer);
        }
    }
    /**
     * Removes selected drawing layer from both Layermanager and Layman
     */
    removeLayer(app) {
        return __awaiter(this, void 0, void 0, function* () {
            const appRef = this.get(app);
            const dialog = this.hsDialogContainerService.create(HsConfirmDialogComponent, {
                message: this.hsLanguageService.getTranslation('DRAW.reallyDeleteThisLayer', undefined, app),
                note: this.getDeleteNote(app),
                title: this.hsLanguageService.getTranslation('COMMON.confirmDelete', undefined, app),
            }, app);
            const confirmed = yield dialog.waitResult();
            if (confirmed == 'yes') {
                yield this.completeLayerRemoval(appRef.selectedLayer, app);
                appRef.selectedLayer = null;
                this.fillDrawableLayers(app);
            }
        });
    }
    /**
     * Removes multiple selected layers from both Layermanager and Layman
     */
    removeMultipleLayers(app) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            const appRef = this.get(app);
            const dialog = this.hsDialogContainerService.create(HsRmMultipleDialogComponent, {
                message: this.hsLanguageService.getTranslation('DRAW.pleaseCheckTheLayers', undefined, app),
                note: this.getDeleteNote(app, true),
                title: this.hsLanguageService.getTranslation('COMMON.selectAndConfirmToDeleteMultiple', undefined, app),
                items: [
                    ...((_a = appRef.drawableLayers) !== null && _a !== void 0 ? _a : []),
                    ...((_b = appRef.drawableLaymanLayers) !== null && _b !== void 0 ? _b : []),
                ],
                app,
            }, app);
            const confirmed = yield dialog.waitResult();
            if (confirmed == 'yes') {
                this.hsToastService.createToastPopupMessage(this.hsLanguageService.getTranslation('LAYMAN.deleteLayersRequest', undefined, app), this.hsLanguageService.getTranslation('LAYMAN.deletionInProgress', undefined, app), {
                    toastStyleClasses: 'bg-info text-white',
                    serviceCalledFrom: 'HsDrawService',
                    disableLocalization: true,
                    customDelay: 600000,
                }, app);
                const drawableLaymanRm = appRef.drawableLaymanLayers.filter((l) => l.toRemove);
                const drawableRm = appRef.drawableLayers.filter((l) => l.toRemove);
                if ((drawableLaymanRm === null || drawableLaymanRm === void 0 ? void 0 : drawableLaymanRm.length) == ((_c = appRef.drawableLaymanLayers) === null || _c === void 0 ? void 0 : _c.length) &&
                    ((_d = appRef.drawableLaymanLayers) === null || _d === void 0 ? void 0 : _d.length) != 0) {
                    yield this.hsLaymanService.removeLayer(app);
                    for (const l of drawableRm) {
                        yield this.completeLayerRemoval(l, app);
                    }
                }
                else {
                    const toRemove = [...drawableRm, ...drawableLaymanRm];
                    for (const l of toRemove) {
                        yield this.completeLayerRemoval(l, app);
                    }
                }
                appRef.selectedLayer = null;
                this.fillDrawableLayers(app);
            }
        });
    }
    completeLayerRemoval(layerToRemove, app) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            let definition;
            const isLayer = layerToRemove instanceof Layer;
            if (isLayer) {
                this.hsMapService.getMap(app).removeLayer(layerToRemove);
                definition = getDefinition(layerToRemove);
                if (getTitle(layerToRemove) == TMP_LAYER_TITLE) {
                    this.get(app).tmpDrawLayer = false;
                }
            }
            if ((((_a = definition === null || definition === void 0 ? void 0 : definition.format) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes('wfs')) && (definition === null || definition === void 0 ? void 0 : definition.url)) ||
                !isLayer) {
                yield this.hsLaymanService.removeLayer(app, layerToRemove);
            }
        });
    }
    getDeleteNote(app, plural) {
        return this.get(app).isAuthorized
            ? this.hsLanguageService.getTranslation(plural ? 'DRAW.deleteNotePlural' : 'DRAW.deleteNote', undefined, app)
            : '';
    }
    /**
     * @param event -
     */
    keyUp(event, app) {
        if (event.key == 'Backspace') {
            this.removeLastPoint(app);
        }
    }
    /**
     * Determines whether rightclick should finish the drawing or not
     * @param typeNum - Number used in calculation of minimal number of vertexes. Depends on geom type (polygon/line)
     * @param vertexCount - Number of vertexes the sketch has
     * @returns return boolean value if right mouse button was clicked
     */
    rightClickCondition(typeNum, vertexCount, app) {
        const minPoints = this.hsConfig.get(app).preserveLastSketchPoint ? 1 : 0;
        const minVertexCount = typeNum - minPoints;
        if (vertexCount >= minVertexCount) {
            setTimeout(() => {
                if (minPoints == 0) {
                    this.removeLastPoint(app);
                }
                this.get(app).draw.finishDrawing();
            }, 250);
            return true;
        }
        return false;
    }
    /**
     * @param options - Options object
     * @param onDrawStart - Callback function called when drawing is started
     * @param onDrawEnd - Callback function called when drawing is finished
     * @param onSelected - Callback function called when feature is selected for modification
     * @param onDeselected - Callback function called when feature is deselected
     * @param changeStyle - controller callback function which set style
     * dynamically according to selected parameters
     * @param drawState - Should drawing be set active when
     * creating the interactions
     * Add drawing interaction to map. Partial interactions are Draw, Modify and Select. Add Event listeners for drawstart, drawend and (de)selection of feature.
     */
    activateDrawing({ onDrawStart, onDrawEnd = (e, app) => this.onDrawEnd(e, app), onSelected, onDeselected, drawState = true, }, app = 'default') {
        const appRef = this.get(app);
        appRef.onDeselected = onDeselected;
        appRef.onSelected = onSelected;
        this.deactivateDrawing(app).then(() => {
            this.hsQueryBaseService.deactivateQueries(app);
            appRef.draw = new Draw({
                source: appRef.source,
                type: /** GeometryType */ appRef.type,
                condition: (e) => {
                    var _a, _b;
                    if (e.originalEvent.buttons === 1) {
                        //left click
                        return true;
                    }
                    else if (e.originalEvent.buttons === 2) {
                        //right click
                        if (appRef.type == 'Polygon') {
                            const vertexCount = (_a = appRef.draw.sketchLineCoords_) === null || _a === void 0 ? void 0 : _a.length;
                            return this.rightClickCondition(4, vertexCount, app);
                        }
                        else if (appRef.type == 'LineString') {
                            const vertexCount = (_b = appRef.draw.sketchCoords_) === null || _b === void 0 ? void 0 : _b.length;
                            return this.rightClickCondition(2, vertexCount - 1, app);
                        }
                    }
                },
            });
            appRef.draw.setActive(drawState);
            this.hsMapService.loaded(app).then((map) => {
                map.addInteraction(appRef.draw);
            });
            appRef.draw.on('drawstart', (e) => {
                if (!this.hasRequiredSymbolizer(app)) {
                    this.hsToastService.createToastPopupMessage(this.hsLanguageService.getTranslation('DRAW.stylingMissing', undefined, app), `${this.hsLanguageService.getTranslation('DRAW.stylingMissingWarning', {
                        type: appRef.type,
                        symbolizer: appRef.requiredSymbolizer[appRef.type].join(' or '),
                        panel: this.hsLanguageService.getTranslation('PANEL_HEADER.LM'),
                    }, app)}`, {
                        serviceCalledFrom: 'HsDrawService',
                    }, app);
                }
                appRef.drawActive = true;
                appRef.modify.setActive(false);
                if (onDrawStart) {
                    onDrawStart(e);
                }
                if (this.hsUtilsService.runningInBrowser()) {
                    document.addEventListener('keyup', this.keyUp.bind(this, e, app));
                }
            });
            appRef.draw.on('drawend', (e) => {
                if (appRef.type == 'Circle') {
                    e.feature.setGeometry(fromCircle(e.feature.getGeometry()));
                }
                if (onDrawEnd) {
                    onDrawEnd(e, app);
                }
                if (this.hsUtilsService.runningInBrowser()) {
                    document.removeEventListener('keyup', this.keyUp.bind(this, e, app));
                }
            });
            //Add snap interaction -  must be added after the Modify and Draw interactions
            const snapSourceToBeUsed = appRef.snapSource
                ? appRef.snapSource
                : appRef.source;
            this.toggleSnapping(app, snapSourceToBeUsed);
        });
    }
    /**
     * Checks whether selected geometry can be properly visualized on selected layer
     */
    hasRequiredSymbolizer(app) {
        const appRef = this.get(app);
        const sld = getSld(appRef.selectedLayer);
        return appRef.requiredSymbolizer[appRef.type].some((symbolizer) => {
            return sld.includes(`${symbolizer}Symbolizer`);
        });
    }
    /**
     * Handle snap interaction changes
     * Remove snap interaction if it already exists, recreate it if source is provided.
     */
    toggleSnapping(app, source) {
        const appRef = this.get(app);
        this.hsMapService.loaded(app).then((map) => {
            appRef.snapSource = source ? source : appRef.snapSource;
            if (appRef.snap) {
                map.removeInteraction(appRef.snap);
                // appRef.snapLayer = null;
            }
            if (appRef.snapActive && appRef.snapSource) {
                appRef.snap = new Snap({
                    source: appRef.snapSource,
                });
                map.addInteraction(appRef.snap);
            }
        });
    }
    /**
     * Changes layer source of snap interaction
     */
    changeSnapSource(layer, app) {
        //isLayerClustered
        const snapSourceToBeUsed = this.hsLayerUtilsService.isLayerClustered(layer)
            ? layer.getSource().getSource()
            : layer.getSource();
        this.get(app).snapLayer = layer;
        this.toggleSnapping(app, snapSourceToBeUsed);
    }
    /**
     * Selects or deselects all features in this.selectedLayer
     */
    selectAllFeatures(app) {
        const appRef = this.get(app);
        const selectFeatures = appRef.selectedFeatures.getLength() !=
            appRef.selectedLayer.getSource().getFeatures().length;
        appRef.toggleSelectionString = selectFeatures
            ? 'deselectAllFeatures'
            : 'selectAllFeatures';
        this.hsQueryBaseService.apps[app].clear('features');
        this.hsQueryBaseService.get(app).selector.getFeatures().clear();
        if (selectFeatures) {
            this.hsQueryBaseService
                .get(app)
                .selector.getFeatures()
                .extend(appRef.selectedLayer.getSource().getFeatures());
        }
        this.hsQueryVectorService.createFeatureAttributeList(app);
    }
    toggleBoxSelection(app) {
        const appRef = this.get(app);
        this.hsMapService.loaded(app).then((map) => {
            if (appRef.boxSelection) {
                map.removeInteraction(appRef.boxSelection);
            }
            if (appRef.boxSelectionActive) {
                appRef.boxSelection = new DragBox({
                    condition: platformModifierKeyOnly,
                });
                map.addInteraction(appRef.boxSelection);
                appRef.boxSelection.on('boxend', () => {
                    if (!appRef.selectedLayer) {
                        return;
                    }
                    this.hsQueryBaseService.apps[app].clear('features');
                    const extent = appRef.boxSelection.getGeometry().getExtent();
                    appRef.selectedLayer
                        .getSource()
                        .forEachFeatureIntersectingExtent(extent, (feature) => {
                        this.hsQueryBaseService
                            .get(app)
                            .selector.getFeatures()
                            .push(feature);
                    });
                    this.hsQueryVectorService.createFeatureAttributeList(app);
                });
                appRef.boxSelection.on('boxstart', () => {
                    this.hsQueryBaseService.get(app).selector.getFeatures().clear();
                });
                this.hsToastService.createToastPopupMessage(this.hsLanguageService.getTranslation('DRAW.boxSelectionActivated', undefined, app), `${this.hsLanguageService.getTranslation('DRAW.useModifierToSelectWithBox', {
                    platformModifierKey: 'CTRL/META',
                })}`, {
                    toastStyleClasses: 'bg-info text-white',
                    serviceCalledFrom: 'HsDrawService',
                }, app);
            }
        });
    }
}
HsDrawService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsDrawService, deps: [{ token: HsMapService }, { token: HsLayerUtilsService }, { token: HsEventBusService }, { token: HsLayoutService }, { token: HsDialogContainerService }, { token: HsLogService }, { token: HsConfig }, { token: HsQueryBaseService }, { token: HsQueryVectorService }, { token: HsLaymanService }, { token: HsLanguageService }, { token: HsLaymanBrowserService }, { token: HsAddDataVectorService }, { token: HsUtilsService }, { token: HsCommonLaymanService }, { token: HsToastService }, { token: HsAddDataOwsService }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Injectable });
HsDrawService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsDrawService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsDrawService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsMapService }, { type: HsLayerUtilsService }, { type: HsEventBusService }, { type: HsLayoutService }, { type: HsDialogContainerService }, { type: HsLogService }, { type: HsConfig }, { type: HsQueryBaseService }, { type: HsQueryVectorService }, { type: HsLaymanService }, { type: HsLanguageService }, { type: HsLaymanBrowserService }, { type: HsAddDataVectorService }, { type: HsUtilsService }, { type: HsCommonLaymanService }, { type: HsToastService }, { type: HsAddDataOwsService }, { type: i0.NgZone }]; } });

class HsLayerEditorVectorLayerService {
    constructor(HsMapService, HsUtilsService, HsStylerService, HsConfig) {
        this.HsMapService = HsMapService;
        this.HsUtilsService = HsUtilsService;
        this.HsStylerService = HsStylerService;
        this.HsConfig = HsConfig;
        this.layersClusteredFromStart = [];
    }
    /**
     * Convert layer to clustered state where it's source gets nested in another
     * VectorSource and first level sources features contain 'features' attribute
     * with the original features in it as an array
     * @param newValue - Cluster or not to cluster
     * @param distance - Minimum distance in pixels between clusters
     */
    cluster(newValue, layer, distance, generateStyle, app) {
        return __awaiter(this, void 0, void 0, function* () {
            if (newValue == true) {
                if (!this.HsUtilsService.instOf(layer.getSource(), Cluster)) {
                    layer.setSource(this.createClusteredSource(layer, distance));
                    if (generateStyle) {
                        yield this.HsStylerService.styleClusteredLayer(layer, app);
                    }
                    this.updateFeatureTableLayers(layer, app);
                }
            }
            else if (this.HsUtilsService.instOf(layer.getSource(), Cluster)) {
                layer.setSource(layer.getSource().getSource());
            }
        });
    }
    createClusteredSource(layer, distance) {
        return new Cluster({
            distance,
            source: layer.getSource(),
            geometryFunction: function (feature) {
                if (!feature) {
                    return null;
                }
                switch (feature.getGeometry().getType()) {
                    case 'Point':
                        return feature.getGeometry();
                    case 'Circle':
                        return new Point(feature.getGeometry().getCenter());
                    case 'Polygon':
                        return feature.getGeometry().getInteriorPoint();
                    case 'LineString':
                        return new Point(feature.getGeometry().getFirstCoordinate());
                    default:
                        return null;
                }
            },
        });
    }
    updateFeatureTableLayers(layer, app) {
        var _a;
        const currentLayerIndex = (_a = this.HsConfig.get(app).layersInFeatureTable) === null || _a === void 0 ? void 0 : _a.findIndex((l) => l == layer);
        if (layer && currentLayerIndex > -1) {
            this.HsConfig.get(app).layersInFeatureTable[currentLayerIndex] = layer;
        }
    }
}
HsLayerEditorVectorLayerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerEditorVectorLayerService, deps: [{ token: HsMapService }, { token: HsUtilsService }, { token: HsStylerService }, { token: HsConfig }], target: i0.ɵɵFactoryTarget.Injectable });
HsLayerEditorVectorLayerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerEditorVectorLayerService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerEditorVectorLayerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsMapService }, { type: HsUtilsService }, { type: HsStylerService }, { type: HsConfig }]; } });

class HsLayerManagerMetadataService {
    constructor(HsWmtsGetCapabilitiesService, HsWfsGetCapabilitiesService, HsWmsGetCapabilitiesService, HsArcgisGetCapabilitiesService, HsDimensionTimeService, HsLayerUtilsService, hsLog, hsUrlWmsService) {
        this.HsWmtsGetCapabilitiesService = HsWmtsGetCapabilitiesService;
        this.HsWfsGetCapabilitiesService = HsWfsGetCapabilitiesService;
        this.HsWmsGetCapabilitiesService = HsWmsGetCapabilitiesService;
        this.HsArcgisGetCapabilitiesService = HsArcgisGetCapabilitiesService;
        this.HsDimensionTimeService = HsDimensionTimeService;
        this.HsLayerUtilsService = HsLayerUtilsService;
        this.hsLog = hsLog;
        this.hsUrlWmsService = hsUrlWmsService;
    }
    /**
     * Recursive callback which identifies object representing added layer in WMS getCapabilities structure.
     * It is used as reference for sublayer structure, metadata
     * @param layerName
     * @param currentLayer
     * @returns Wms layer definition
     */
    identifyLayerObject(layerName, currentLayer, serviceLayer = false) {
        // FIXME: Temporary bypass for layer names like 'UTM:evi'
        /*if (layerName.includes(':')) { //This is wrong because then we are not able to find layer by name
          layerName = layerName.slice(layerName.indexOf(':'));
        }*/
        // NOTE: We are parsing also a top-most layer of the WMS Service, as it is implementationally simpler
        if (layerName == currentLayer.Name || serviceLayer) {
            return serviceLayer ? this.getParsedLayers(currentLayer) : currentLayer;
        }
        else if (Array.isArray(currentLayer.Layer)) {
            for (const subLayer of currentLayer.Layer) {
                const found = this.identifyLayerObject(layerName, subLayer);
                if (found) {
                    return found;
                }
            }
        }
        else if (currentLayer.Layer) {
            return this.identifyLayerObject(layerName, currentLayer.Layer);
        }
        return null;
    }
    getParsedLayers(layerObject) {
        const isUsable = layerObject.Layer.every((l) => l.Name); //Sublayers are all queriable
        if (!isUsable) {
            layerObject.Layer =
                this.hsUrlWmsService.filterCapabilitiesLayers(layerObject);
        }
        return layerObject;
    }
    /**
     * Adds hasSublayers parameter if layer has sub-layers
     * @param layerDescriptor - Selected layer
     */
    fillMetadata(layerDescriptor, app) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const layer = layerDescriptor.layer;
            try {
                yield this.queryMetadata(layerDescriptor, app);
            }
            catch (error) {
                this.hsLog.warn(`Error while querying metadata ${error}`);
            }
            const subLayers = (_a = getCachedCapabilities(layer)) === null || _a === void 0 ? void 0 : _a.Layer;
            if (subLayers != undefined && subLayers.length > 0) {
                if (!layerDescriptor.hasSublayers) {
                    layerDescriptor.hasSublayers = true;
                    //ADD config values
                }
            }
        });
    }
    metadataArray(layer) {
        var _a;
        return (_a = getMetadata(layer.layer)) === null || _a === void 0 ? void 0 : _a.urls;
    }
    /**
     * Determines if layer has metadata information available *
     * @param layer Current layer
     */
    hasMetadata(layer) {
        var _a;
        if (!layer) {
            return false;
        }
        else {
            return layer && ((_a = getMetadata(layer.layer)) === null || _a === void 0 ? void 0 : _a.urls) ? true : false;
        }
    }
    /**
     * @param properties
     * @returns {any}
     * @description Looks for maxScaleDenominator in property object
     */
    searchForScaleDenominator(properties, app) {
        let maxResolution = properties.MaxScaleDenominator
            ? this.HsLayerUtilsService.calculateResolutionFromScale(properties.MaxScaleDenominator, app)
            : null;
        //TODO: Currently we are not using minResolution, but should. That would require rewriting this function to return structure of {minRes, maxRes}
        const minResolution = properties.MinScaleDenominator
            ? this.HsLayerUtilsService.calculateResolutionFromScale(properties.MinScaleDenominator, app)
            : 0;
        const layers = properties.Layer;
        if (layers) {
            for (const sublayer of layers) {
                if (sublayer.Layer) {
                    const subResolution = this.searchForScaleDenominator(sublayer, app);
                    maxResolution =
                        subResolution > maxResolution ? subResolution : maxResolution;
                }
                else {
                    // Set sublayer.maxResolution which is used
                    // to display sublayers grayed out or black in layer-editor sublayer tree
                    if (sublayer.MaxScaleDenominator) {
                        sublayer.maxResolution =
                            this.HsLayerUtilsService.calculateResolutionFromScale(sublayer.MaxScaleDenominator, app);
                        if (maxResolution < sublayer.maxResolution &&
                            maxResolution !== null) {
                            maxResolution =
                                this.HsLayerUtilsService.calculateResolutionFromScale(sublayer.MaxScaleDenominator, app);
                        }
                    }
                    else if (!sublayer.maxResolution) {
                        sublayer.maxResolution = maxResolution !== null && maxResolution !== void 0 ? maxResolution : Number.MAX_VALUE;
                    }
                }
            }
        }
        if (maxResolution) {
            properties.maxResolution = maxResolution;
        }
        if (minResolution) {
            properties.minResolution = minResolution;
        }
        return maxResolution;
    }
    /**
     * Sets or updates values in layer object
     * @param layer
     * @param key
     * @param values
     */
    //TODO: TYPES
    setOrUpdate(layer, key, values) {
        const previousValue = layer.get(key);
        if (previousValue) {
            for (const value of values) {
                layer.set(key, previousValue.push(value));
            }
        }
        else {
            layer.set(key, values);
        }
    }
    parseWmsCaps(layerDescriptor, layerName, caps, app) {
        var _a, _b, _c;
        const olLayer = layerDescriptor.layer;
        const legends = [];
        const layerCaps = caps.Capability.Layer;
        let layerObj; //Main object representing layer created from capabilities which will be cached
        if (layerName.includes(',')) {
            const layerObjs = []; //array of layer objects representing added layer
            for (const subLayer of layerName.split(',')) {
                const layerSubObject = this.identifyLayerObject(subLayer, layerCaps);
                layerObjs.push(layerSubObject);
                this.collectLegend(layerSubObject, legends);
                if (layerSubObject &&
                    layerSubObject.Layer !== undefined &&
                    getSubLayers(olLayer)) {
                    delete layerSubObject.Layer;
                }
            }
            if (getCachedCapabilities(olLayer) === undefined) {
                layerObj = Object.assign(JSON.parse(JSON.stringify(layerObjs[0])), {
                    maxResolution: Math.max(...layerObjs.map((layer) => this.searchForScaleDenominator(layer, app))),
                    Layer: layerObjs,
                });
            }
            this.fillMetadataUrlsIfNotExist(olLayer, caps);
        }
        else {
            layerObj = this.identifyLayerObject(layerName, layerCaps, olLayer.get('serviceLayer'));
            if (layerObj == undefined) {
                return;
            }
            //TODO: This should be removed probably to not pollute layer object. Use cachedCapabilities instead
            olLayer.setProperties(layerObj);
            if (((_a = layerObj.Dimension) === null || _a === void 0 ? void 0 : _a.name) === 'time' ||
                ((_b = layerObj.Dimension) === null || _b === void 0 ? void 0 : _b.filter((dim) => dim.name === 'time').length) > 0) {
                this.HsDimensionTimeService.setupTimeLayer(layerDescriptor, app, layerObj);
            }
            if (layerObj.Layer && getSubLayers(olLayer)) {
                layerObj.maxResolution = this.searchForScaleDenominator(layerObj, app);
                /* layerObj.Layer contains sublayers and gets stored to cachedCapabilities. */
                const subLayerArray = getSubLayers(olLayer).split(',');
                layerObj.Layer = layerObj.Layer.filter((l) => subLayerArray.includes(l.Name));
            }
            if (layerObj.queryable &&
                ((_c = this.HsLayerUtilsService.getLayerParams(olLayer)) === null || _c === void 0 ? void 0 : _c.INFO_FORMAT) ==
                    undefined) {
                this.HsLayerUtilsService.updateLayerParams(olLayer, {
                    //TODO: Hslayers needs to support other formats too
                    INFO_FORMAT: 'application/vnd.ogc.gml', //Assumption that this will be supported by the server.
                });
            }
            this.collectLegend(layerObj, legends);
        }
        if (getCachedCapabilities(olLayer) === undefined) {
            setCacheCapabilities(olLayer, layerObj);
        }
        this.parseAttribution(olLayer, getCachedCapabilities(olLayer));
        const existingLegends = getLegends(olLayer);
        if (legends.length > 0 && existingLegends == undefined) {
            setLegends(olLayer, legends);
        }
    }
    collectLegend(layerObject, legends) {
        var _a;
        const styleWithLegend = (_a = layerObject === null || layerObject === void 0 ? void 0 : layerObject.Style) === null || _a === void 0 ? void 0 : _a.find((style) => style.LegendURL !== undefined);
        if (styleWithLegend) {
            legends.push(styleWithLegend.LegendURL[0].OnlineResource);
        }
    }
    parseAttribution(layer, caps) {
        var _a;
        const attr = caps.Attribution;
        if (((_a = getAttribution(layer)) === null || _a === void 0 ? void 0 : _a.locked) || attr == undefined) {
            return;
        }
        const parsedAttribution = {
            title: attr.Title,
            onlineResource: attr.OnlineResource,
            logoUrl: attr.LogoURL
                ? {
                    format: attr.LogoURL.Format,
                    onlineResource: attr.LogoURL.OnlineResource,
                }
                : undefined,
        };
        setAttribution(layer, parsedAttribution);
    }
    /**
     * Callback function, adds getCapabilities response metadata to layer object
     * @param layerDescriptor - Selected layer
     * @returns Promise
     */
    queryMetadata(layerDescriptor, app) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const layer = layerDescriptor.layer;
            const url = this.HsLayerUtilsService.getURL(layer);
            if (!url) {
                return;
            }
            //ArcGIS
            if (this.HsLayerUtilsService.isLayerArcgis(layer)) {
                const wrapper = yield this.HsArcgisGetCapabilitiesService.request(url, app);
                if (wrapper.error) {
                    return wrapper.response;
                }
                else {
                    this.parseArcGisCaps(layerDescriptor, wrapper.response);
                }
            }
            //WMS
            else if (this.HsLayerUtilsService.isLayerWMS(layer)) {
                const wrapper = yield this.HsWmsGetCapabilitiesService.request(url, app);
                if (wrapper.error) {
                    this.hsLog.warn('GetCapabilities call invalid', wrapper.response);
                    return wrapper.response;
                }
                const parser = new WMSCapabilities();
                const caps = parser.read(wrapper.response);
                const params = this.HsLayerUtilsService.getLayerParams(layer);
                const layerNameInParams = params.LAYERS;
                this.parseWmsCaps(layerDescriptor, layerNameInParams, caps, app);
                const sublayers = getSubLayers(layer);
                if (sublayers) {
                    if (!(Array.isArray(sublayers) && sublayers.length == 0)) {
                        /* When capabilities have been queried, it's safe to override LAYERS
                          param now to not render the container layer, but sublayers.*/
                        this.HsLayerUtilsService.updateLayerParams(layer, {
                            LAYERS: getSubLayers(layer),
                        });
                    }
                }
                this.fillMetadataUrlsIfNotExist(layer, caps);
                //Identify max resolution of layer. If layer has sublayers the highest value is selected
                setTimeout(() => {
                    if (getMaxResolutionDenominator(layer)) {
                        layer.setMaxResolution(getMaxResolutionDenominator(layer));
                        return;
                    }
                    const maxResolution = this.searchForScaleDenominator(layer.getProperties(), app);
                    if (maxResolution) {
                        layer.setMaxResolution(maxResolution);
                    }
                });
                return true;
            }
            //WMTS
            else if (this.HsLayerUtilsService.isLayerWMTS(layer)) {
                const wrapper = yield this.HsWmtsGetCapabilitiesService.request(url, app);
                if (wrapper.error) {
                    return wrapper.response;
                }
                else {
                    const parser = new WMTSCapabilities$1();
                    const caps = parser.read(wrapper.response);
                    layer.setProperties(caps);
                    if (!((_a = getAttribution(layer)) === null || _a === void 0 ? void 0 : _a.locked)) {
                        setAttribution(layer, {
                            onlineResource: caps.ServiceProvider.ProviderSite,
                        });
                    }
                    return true;
                }
            }
            //WFS and vector
            else if (this.HsLayerUtilsService.isLayerVectorLayer(layer)) {
                if (url) {
                    const wrapper = yield this.HsWfsGetCapabilitiesService.request(url, app);
                    if (wrapper.error) {
                        return wrapper.response;
                    }
                    else {
                        const parser = new DOMParser();
                        const caps = parser.parseFromString(wrapper.response.data, 'application/xml');
                        const el = caps.getElementsByTagNameNS('*', 'ProviderSite');
                        if (!((_b = getAttribution(layer)) === null || _b === void 0 ? void 0 : _b.locked)) {
                            setAttribution(layer, {
                                onlineResource: el[0].getAttribute('xlink:href'),
                            });
                        }
                        return true;
                    }
                }
            }
        });
    }
    parseArcGisCaps(layerDescriptor, resp) {
        const olLayer = layerDescriptor.layer;
        const params = this.HsLayerUtilsService.getLayerParams(olLayer);
        const layerName = params.LAYERS;
        const legends = [];
        let layerObj; //Main object representing layer created from capabilities which will be cached
        if (layerName !== undefined &&
            (layerName.includes(',') || layerName.includes('show'))) {
            const layerObjs = []; //array of layer objects representing added layer
            for (const subLayer of layerName.replace('show:', '').split(',')) {
                /** This is the found sublayer by ID from the layers array */
                const subObj = this.identifyArcgisLayerObj(parseInt(subLayer), resp);
                layerObjs.push(subObj);
                this.collectLegend(subObj, legends);
                if (subObj && subObj.Layer !== undefined && getSubLayers(olLayer)) {
                    delete subObj.Layer;
                }
            }
            if (getCachedCapabilities(olLayer) === undefined) {
                layerObj = Object.assign(JSON.parse(JSON.stringify(layerObjs[0])), {
                    /* TODO maxResolution: Math.max(
                      ...layerObjs.map((layer) => this.searchForScaleDenominator(layer))
                    ), */
                    Layer: layerObjs,
                });
            }
            //TODO this.fillMetadataUrlsIfNotExist(olLayer, resp);
        }
        else {
            layerObj = this.identifyArcgisLayerObj(parseInt(layerName), resp);
            if (layerObj == undefined) {
                return;
            }
            /* TODO
            if (
              layerObj.Dimension?.name === 'time' ||
              layerObj.Dimension?.filter((dim) => dim.name === 'time').length > 0
            ) {
              this.HsDimensionTimeService.setupTimeLayer(layerDescriptor, layerObj);
            } */
            if (layerObj.Layer && getSubLayers(olLayer)) {
                //TODO layerObj.maxResolution = this.searchForScaleDenominator(layerObj);
                /* layerObj.Layer contains sublayers and gets stored to cachedCapabilities.
                We delete to not crash interface if the service has thousands of layers. There is an assumption that if we specify sublayers
                in layer definition, user will not be allowed to display other sublayers
                thus it is fine if the sublayer list gets hidden in layer editor. */
                delete layerObj.Layer;
            }
            this.collectLegend(layerObj, legends);
        }
        if (getCachedCapabilities(olLayer) == undefined) {
            setCacheCapabilities(olLayer, layerObj);
        }
        this.parseAttribution(olLayer, getCachedCapabilities(olLayer));
        const existingLegends = getLegends(olLayer);
        if (legends.length > 0 && existingLegends == undefined) {
            setLegends(olLayer, legends);
        }
    }
    identifyArcgisLayerObj(layerId, caps) {
        var _a;
        if (layerId == undefined || isNaN(layerId)) {
            //parseInt(undefined) returns NaN
            return {
                Title: caps.mapName,
                Name: 0,
                Layer: (_a = caps === null || caps === void 0 ? void 0 : caps.layers) === null || _a === void 0 ? void 0 : _a.map((l) => {
                    return { Title: l.name, Name: l.id };
                }),
            };
        }
        else {
            const found = caps.layers.find((l) => l.id == layerId);
            if (found) {
                const tmp = {
                    Title: found.name,
                    Name: found.id,
                    Layer: caps.layers
                        .filter((l) => l.parentLayerId == layerId)
                        .map((l) => {
                        return { Title: l.name, Name: l.id };
                    }),
                };
                if (tmp.Layer.length == 0) {
                    delete tmp.Layer;
                }
                return tmp;
            }
        }
        return null;
    }
    fillMetadataUrlsIfNotExist(layer, caps) {
        if (getMetadata(layer) == undefined) {
            setMetadata(layer, {
                urls: [{ onlineResource: caps.Service.OnlineResource }],
            });
        }
    }
}
HsLayerManagerMetadataService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerManagerMetadataService, deps: [{ token: HsWmtsGetCapabilitiesService }, { token: HsWfsGetCapabilitiesService }, { token: HsWmsGetCapabilitiesService }, { token: HsArcgisGetCapabilitiesService }, { token: HsDimensionTimeService }, { token: HsLayerUtilsService }, { token: HsLogService }, { token: HsUrlWmsService }], target: i0.ɵɵFactoryTarget.Injectable });
HsLayerManagerMetadataService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerManagerMetadataService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerManagerMetadataService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsWmtsGetCapabilitiesService }, { type: HsWfsGetCapabilitiesService }, { type: HsWmsGetCapabilitiesService }, { type: HsArcgisGetCapabilitiesService }, { type: HsDimensionTimeService }, { type: HsLayerUtilsService }, { type: HsLogService }, { type: HsUrlWmsService }]; } });

class HsLayerSelectorParams {
}
class HsLayerSelectorService {
    constructor() {
        this.apps = { default: new HsLayerSelectorParams() };
        this.layerSelected = new Subject();
    }
    /**
     * Multicasts new HsLayerManagerService.currentLayer to observers listening to the layerSelected subject.
     * @param hsLayer - Selected layer (HsLayerManagerService.currentLayer)
     */
    select(hsLayer, app) {
        this.get(app).currentLayer = hsLayer;
        this.layerSelected.next({ layer: hsLayer, app });
    }
    get(app) {
        if (this.apps[app !== null && app !== void 0 ? app : 'default'] == undefined) {
            this.apps[app !== null && app !== void 0 ? app : 'default'] = new HsLayerSelectorParams();
        }
        return this.apps[app !== null && app !== void 0 ? app : 'default'];
    }
}
HsLayerSelectorService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerSelectorService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
HsLayerSelectorService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerSelectorService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerSelectorService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return []; } });

class HsQueuesService {
    constructor() {
        this.apps = {
            default: { queues: {} },
        };
    }
    /**
     * Get the params saved by the queues service for the current app
     * @param app - App identifier
     */
    get(app) {
        if (this.apps[app !== null && app !== void 0 ? app : 'default'] == undefined) {
            this.apps[app !== null && app !== void 0 ? app : 'default'] = {
                queues: {},
            };
        }
        return this.apps[app !== null && app !== void 0 ? app : 'default'];
    }
    /**
     * Get the params saved by the queues service for the current app
     * @param useCase - Queue for
     * @param app - App identifier
     * @param customConcurrency - (Optional) custom concurrency
     * @param timeout - (Optional) Timeout of one queue item
     */
    ensureQueue(useCase, app, customConcurrency, timeout) {
        const appRef = this.get(app);
        if (appRef.queues[useCase]) {
            return appRef.queues[useCase].q;
        }
        const newQueue = {
            q: queue({
                results: [],
                concurrency: customConcurrency || 5,
                autostart: true,
                timeout,
            }),
        };
        appRef.queues[useCase] = newQueue;
        newQueue.q.on('end', () => {
            delete appRef.queues[useCase];
        });
        return newQueue.q;
    }
}
HsQueuesService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsQueuesService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
HsQueuesService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsQueuesService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsQueuesService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class HsLayermanagerDataObject {
    constructor() {
        /**
         * Folders object for structure of layers. Each level contain 5 properties:
         * hsl_path \{String\}: Worded path to folder position in folders hierarchy.
         * coded_path \{String\}: Path encoded in numbers
         * layers \{Array\}: List of layers for current folder
         * sub_folders \{Array\}: List of subfolders for current folder
         * indent \{Number\}: Hierarchy level for current folder
         * name \{String\}: Optional - only from indent 1, base folder is not named
         * @public
         */
        (this.folders = {
            //TODO: need to describe how hsl_path works here
            hsl_path: '',
            coded_path: '0-',
            layers: [],
            sub_folders: [],
            indent: 0,
        }),
            /**
             * List of all layers (baselayers are excluded) loaded in LayerManager.
             * @public
             */
            (this.layers = []);
        /**
         * List of all baselayers loaded in layer manager.
         * @public
         */
        this.baselayers = [];
        /*
         * List of all cesium terrain layers loaded in layer manager.
         * @public
         */
        this.terrainlayers = [];
        /**
         * Store if baselayers are visible (more precisely one of baselayers)
         * @public
         */
        this.baselayersVisible = true;
        this.filter = '';
    }
}
class HsLayermanagerAppObject {
    constructor() {
        this.data = new HsLayermanagerDataObject();
        this.menuExpanded = false;
        this.zIndexValue = 0;
    }
}
class HsLayerManagerService {
    /**
     * Property for pointer to main map object
     */
    constructor(HsConfig, HsDimensionTimeService, HsDrawService, HsEventBusService, HsLanguageService, HsLayerEditorVectorLayerService, HsLayerManagerMetadata, HsLayerSelectorService, HsLayerUtilsService, HsLayoutService, HsLog, HsMapService, HsQueuesService, HsAddDataOwsService, HsShareUrlService, HsUtilsService, sanitizer, zone) {
        this.HsConfig = HsConfig;
        this.HsDimensionTimeService = HsDimensionTimeService;
        this.HsDrawService = HsDrawService;
        this.HsEventBusService = HsEventBusService;
        this.HsLanguageService = HsLanguageService;
        this.HsLayerEditorVectorLayerService = HsLayerEditorVectorLayerService;
        this.HsLayerManagerMetadata = HsLayerManagerMetadata;
        this.HsLayerSelectorService = HsLayerSelectorService;
        this.HsLayerUtilsService = HsLayerUtilsService;
        this.HsLayoutService = HsLayoutService;
        this.HsLog = HsLog;
        this.HsMapService = HsMapService;
        this.HsQueuesService = HsQueuesService;
        this.HsAddDataOwsService = HsAddDataOwsService;
        this.HsShareUrlService = HsShareUrlService;
        this.HsUtilsService = HsUtilsService;
        this.sanitizer = sanitizer;
        this.zone = zone;
        this.apps = { default: new HsLayermanagerAppObject() };
        this.HsEventBusService.layoutLoads.subscribe(({ element, innerElement, app }) => {
            if (!this.apps[app]) {
                this.apps[app] = new HsLayermanagerAppObject();
            }
        });
        this.HsEventBusService.layerManagerUpdates.subscribe(({ layer, app }) => {
            this.refreshLists(app);
        });
        this.HsEventBusService.layerDimensionDefinitionChanges.subscribe(({ layer: olLayer, app }) => {
            if (this.HsDimensionTimeService.layerIsWmsT(olLayer)) {
                const layerDescriptor = this.apps[app !== null && app !== void 0 ? app : 'default'].data.layers.find((ld) => ld.layer == olLayer);
                if (layerDescriptor) {
                    this.HsDimensionTimeService.setupTimeLayer(layerDescriptor, app);
                }
            }
        });
    }
    get(app) {
        if (this.apps[app !== null && app !== void 0 ? app : 'default'] == undefined) {
            this.apps[app !== null && app !== void 0 ? app : 'default'] = new HsLayermanagerAppObject();
        }
        return this.apps[app !== null && app !== void 0 ? app : 'default'];
    }
    /**
     * Function for adding layer added to map into layer manager structure.
     * In service automatically used after layer is added to map.
     * Layers which shouldn't be in layer manager (showInLayerManager property) aren't added.
     * Loading events and legends URLs are created for each layer.
     * Layers also get automatic watcher for changing visibility (to synchronize visibility in map and layer manager).
     * Position is calculated for each layer and for time layers time properties are created.
     * Each layer is also inserted in correct layer list and inserted into folder structure.
     * @private
     * @param e - Event object emitted by OL add layer event
     * @param suspendEvents - If set to true, no new values for layerAdditions, layerManagerUpdates or compositionEdits observables will be emitted. Otherwise will.
     */
    layerAdded(e, app, suspendEvents) {
        return __awaiter(this, void 0, void 0, function* () {
            const layer = e.element;
            this.checkLayerHealth(layer);
            if (getShowInLayerManager(layer) !== null &&
                getShowInLayerManager(layer) == false) {
                return;
            }
            layer.on('change:visible', (e) => this.layerVisibilityChanged(e, app));
            if (this.HsLayerUtilsService.isLayerVectorLayer(layer) &&
                getCluster(layer)) {
                this.HsLayerEditorVectorLayerService.layersClusteredFromStart.push(layer);
                yield this.HsLayerEditorVectorLayerService.cluster(true, layer, this.HsConfig.get(app).clusteringDistance || 40, false, app);
            }
            /**
             * Wrapper for layers in layer manager structure.
             * Each layer object stores layer's title, grayed (if layer is currently visible - for layers which have max/min resolution), visible (layer is visible), and actual layer.
             * Each layer wrapper is accessible from layer list or folder structure.
             * @private
             */
            const layerDescriptor = {
                title: this.HsLayerUtilsService.getLayerTitle(layer),
                abstract: getAbstract(layer),
                layer,
                grayed: !this.isLayerInResolutionInterval(layer, app),
                visible: layer.getVisible(),
                uid: this.HsUtilsService.generateUuid(),
                idString() {
                    return 'layer' + (this.coded_path || '') + (this.uid || '');
                },
                type: this.getLayerSourceType(layer),
                source: this.getLayerSourceUrl(layer),
            };
            this.loadingEvents(layerDescriptor, app);
            layerDescriptor.trackBy = `${layerDescriptor.uid} ${layerDescriptor.position}`;
            layer.on('propertychange', (event) => {
                if (event.key == 'title') {
                    layerDescriptor.title = this.HsLayerUtilsService.getLayerTitle(layer);
                }
            });
            if (getBase(layer) !== true) {
                this.populateFolders(layer, app);
                layerDescriptor.legends = getLegends(layer);
                this.apps[app].data.layers.push(layerDescriptor);
                if (getSubLayers(layer)) {
                    /*Need to
                     keep track of original LAYERS value for saving to composition*/
                    const params = this.HsLayerUtilsService.getLayerParams(layer);
                    if (params === null || params === void 0 ? void 0 : params.LAYERS) {
                        setOrigLayers(layer, params.LAYERS);
                    }
                }
                if (getQueryCapabilities(layer) !== false) {
                    const que = this.HsQueuesService.ensureQueue('wmsGetCapabilities', app, 1, 5000);
                    que.push((cb) => __awaiter(this, void 0, void 0, function* () {
                        try {
                            yield this.HsLayerManagerMetadata.fillMetadata(layerDescriptor, app);
                            layerDescriptor.grayed = !this.isLayerInResolutionInterval(layer, app);
                            cb();
                        }
                        catch (err) {
                            cb(err);
                        }
                    }));
                }
            }
            else {
                layerDescriptor.active = layer.getVisible();
                if (layerDescriptor.active) {
                    this.changeBaseLayerVisibility(true, layerDescriptor, app);
                }
                layerDescriptor.thumbnail = this.getImage(layer, app);
                this.apps[app].data.baselayers.push(layerDescriptor);
            }
            if (!getName(layer)) {
                setName(layer, getTitle(layer));
            }
            //*NOTE Commented out, because the  following references to this.apps[app].data.baselayer are causing issues.
            // if (layer.getVisible() && getBase(layer)) {
            //   this.apps[app].data.baselayer = this.HsLayerUtilsService.getLayerTitle(layer);
            // }
            this.sortFoldersByZ(app);
            if (!suspendEvents) {
                this.HsEventBusService.layerAdditions.next(layerDescriptor);
                this.HsEventBusService.layerManagerUpdates.next({ layer, app });
                this.HsEventBusService.compositionEdits.next({ app });
            }
        });
    }
    /**
     * Triage of layer source type and format.
     * Only the commonly used values are listed here, it shall be probably extended in the future.
     * @returns Short description of source type: 'WMS', 'XYZ', 'vector (GeoJSON)' etc.
     */
    getLayerSourceType(layer) {
        if (this.HsLayerUtilsService.isLayerKMLSource(layer)) {
            return `vector (KML)`;
        }
        if (this.HsLayerUtilsService.isLayerGPXSource(layer)) {
            return `vector (GPX)`;
        }
        if (this.HsLayerUtilsService.isLayerGeoJSONSource(layer)) {
            return `vector (GeoJSON)`;
        }
        if (this.HsLayerUtilsService.isLayerTopoJSONSource(layer)) {
            return `vector (TopoJSON)`;
        }
        if (this.HsLayerUtilsService.isLayerVectorLayer(layer)) {
            return 'vector';
        }
        if (this.HsLayerUtilsService.isLayerWMTS(layer)) {
            return 'WMTS';
        }
        if (this.HsLayerUtilsService.isLayerWMS(layer)) {
            return 'WMS';
        }
        if (this.HsLayerUtilsService.isLayerXYZ(layer)) {
            return 'XYZ';
        }
        if (this.HsLayerUtilsService.isLayerArcgis(layer)) {
            return 'ArcGIS';
        }
        if (this.HsLayerUtilsService.isLayerIDW(layer)) {
            return 'IDW';
        }
        this.HsLog.warn(`Cannot decide a type of source of layer ${getTitle(layer)}`);
        return 'unknown type';
    }
    /**
     * Gets the URL provided in the layer's source, if it is not a data blob or undefined
     * @returns URL provided in the layer's source or 'memory'
     */
    getLayerSourceUrl(layer) {
        var _a;
        const url = (_a = this.HsLayerUtilsService.getURL(layer)) === null || _a === void 0 ? void 0 : _a.split('?')[0]; //better stripe out any URL params
        if (!url || url.startsWith('data:')) {
            return 'memory';
        }
        return url;
    }
    /**
     * Function for adding baselayer thumbnail visible in basemap gallery.
     * @param layer - Base layer added to map
     */
    getImage(layer, app) {
        const thumbnail = getThumbnail(layer);
        const configRef = this.HsConfig.get(app);
        if (thumbnail) {
            if (thumbnail.length > 10) {
                return thumbnail;
            }
            else {
                return configRef.assetsPath + 'img/' + thumbnail;
            }
        }
        else {
            return configRef.assetsPath + 'img/default.png';
        }
    }
    /**
     * @param layer
     */
    checkLayerHealth(layer) {
        if (this.isWms(layer)) {
            if (this.HsLayerUtilsService.getLayerParams(layer).LAYERS == undefined) {
                this.HsLog.warn('Layer', layer, 'is missing LAYERS parameter');
            }
        }
    }
    /**
     * @param e
     */
    layerVisibilityChanged(e, app) {
        if (getBase(e.target) != true) {
            for (const layer of this.apps[app].data.layers) {
                if (layer.layer == e.target) {
                    layer.visible = e.target.getVisible();
                    break;
                }
            }
        }
        else {
            for (const baseLayer of this.apps[app].data.baselayers) {
                if (baseLayer.layer == e.target) {
                    baseLayer.active = e.target.getVisible();
                }
                else {
                    baseLayer.active = false;
                }
            }
        }
    }
    /**
     * Sort layers which are added to map and registered
     * in layermanager by Z and notify components that layer positions have changed.
     */
    updateLayerListPositions(app) {
        //TODO: We could also sort by title or other property. Not supported right now though, just zIndex
        this.apps[app].data.layers = this.sortLayersByZ(this.apps[app].data.layers, app);
    }
    sortLayersByZ(arr, app) {
        var _a;
        const minus = (_a = this.HsConfig.get(app).reverseLayerList) !== null && _a !== void 0 ? _a : true;
        return arr.sort((a, b) => {
            a = a.layer.getZIndex();
            b = b.layer.getZIndex();
            return (a < b ? -1 : a > b ? 1 : 0) * (minus ? -1 : 1);
        });
    }
    /**
     * Executed when a content of data.baselayers or data.terrainlayers changes.
     * Angular does not detect changes inside arrays unless triggered from the view.
     * But it does detect changes of class properties.
     * Hence the whole array is copied so an "immutable" change happens and Angular detects that.
     */
    refreshLists(app) {
        const appRef = this.get(app);
        appRef.data.baselayers = Array.from(appRef.data.baselayers);
        appRef.data.terrainlayers = Array.from(appRef.data.terrainlayers);
    }
    /**
     * (PRIVATE) Get layer by its title
     * @private
     * @param title
     */
    getLayerByTitle(title, app) {
        let tmp;
        for (const layer of this.get(app).data.layers) {
            if (layer.title == title) {
                tmp = layer;
            }
        }
        return tmp;
    }
    /**
     * Get layer container object for OL layer
     * @private
     * @param layer - to get layer title
     * @returns Layer container which is used in layer-list directive
     */
    getLayerDescriptorForOlLayer(layer, app) {
        const tmp = this.apps[app].data.layers.filter((l) => l.layer == layer);
        if (tmp.length > 0) {
            return tmp[0];
        }
        return;
    }
    /**
     * Place layer into layer manager folder structure based on path property hsl-path of layer
     * @private
     * @param lyr - Layer to add into folder structure
     */
    populateFolders(lyr, app) {
        var _a;
        let path = getPath(lyr);
        if (!path) {
            /* Check whether 'other' folder exists.
              Can not just add getTranslationIgnoreNonExisting string in case no path exists
              because on init the translation is ignored.
            */
            if ((_a = this.apps[app].data.folders.sub_folders) === null || _a === void 0 ? void 0 : _a.filter((f) => f.name == 'other')[0]) {
                path = 'other';
            }
            else {
                path = this.HsLanguageService.getTranslationIgnoreNonExisting('LAYERMANAGER', 'other', undefined, app);
            }
            setPath(lyr, path);
        }
        const parts = path.split('/');
        let curfolder = this.apps[app].data.folders;
        const zIndex = lyr.getZIndex();
        for (let i = 0; i < parts.length; i++) {
            let found = null;
            for (const folder of curfolder.sub_folders) {
                if (folder.name == parts[i]) {
                    found = folder;
                }
            }
            if (found === null) {
                //TODO: Need to describe how hsl_path works here
                const new_folder = {
                    sub_folders: [],
                    indent: i,
                    layers: [],
                    name: parts[i],
                    hsl_path: curfolder.hsl_path +
                        (curfolder.hsl_path != '' ? '/' : '') +
                        parts[i],
                    coded_path: curfolder.coded_path + curfolder.sub_folders.length + '-',
                    visible: true,
                    zIndex: zIndex,
                };
                curfolder.sub_folders.push(new_folder);
                curfolder = new_folder;
            }
            else {
                curfolder = found;
            }
        }
        curfolder.zIndex = curfolder.zIndex < zIndex ? zIndex : curfolder.zIndex;
        curfolder.layers.push(lyr);
        // if (this.apps[app].data.folders.layers.indexOf(lyr) > -1) {
        //   this.apps[app].data.folders.layers.splice(this.apps[app].data.folders.layers.indexOf(lyr), 1);
        // }
    }
    /**
     * Remove layer from layer folder structure a clean empty folder
     * @private
     * @param lyr - Layer to remove from layer folder
     */
    cleanFolders(lyr, app) {
        if (getShowInLayerManager(lyr) == false) {
            return;
        }
        if (getPath(lyr) != undefined && getPath(lyr) !== 'undefined') {
            const path = getPath(lyr);
            const parts = path.split('/');
            let curfolder = this.apps[app].data.folders;
            for (let i = 0; i < parts.length; i++) {
                for (const folder of curfolder.sub_folders) {
                    if (folder.name == parts[i]) {
                        curfolder = folder;
                    }
                }
            }
            curfolder.layers.splice(curfolder.layers.indexOf(lyr), 1);
            for (let i = parts.length; i > 0; i--) {
                if (curfolder.layers.length == 0 && curfolder.sub_folders.length == 0) {
                    let newfolder = this.apps[app].data.folders;
                    if (i > 1) {
                        for (let j = 0; j < i - 1; j++) {
                            for (const folder of newfolder.sub_folders) {
                                if (folder.name == parts[j]) {
                                    newfolder = folder;
                                }
                            }
                        }
                    }
                    const ixToRemove = newfolder.sub_folders.indexOf(curfolder);
                    if (ixToRemove > -1) {
                        newfolder.sub_folders.splice(ixToRemove, 1);
                    }
                    curfolder = newfolder;
                }
                else {
                    break;
                }
            }
        }
        else {
            const ixToRemove = this.apps[app].data.folders.layers.indexOf(lyr);
            if (ixToRemove > -1) {
                this.apps[app].data.folders.layers.splice(ixToRemove, 1);
            }
        }
    }
    /**
     * Callback function for removing layer. Clean layers variables
     * (PRIVATE)
     * @private
     * @param e - Events emitted by ol.Collection instances are instances of this type.
     */
    layerRemoved(e, app) {
        this.cleanFolders(e.element, app);
        for (let i = 0; i < this.apps[app].data.layers.length; i++) {
            if (this.apps[app].data.layers[i].layer == e.element) {
                this.apps[app].data.layers.splice(i, 1);
            }
        }
        for (let i = 0; i < this.apps[app].data.baselayers.length; i++) {
            if (this.apps[app].data.baselayers[i].layer == e.element) {
                this.apps[app].data.baselayers.splice(i, 1);
            }
        }
        this.removeFromArray(this.HsLayerEditorVectorLayerService.layersClusteredFromStart, e.element);
        this.HsEventBusService.layerManagerUpdates.next({
            layer: e.element,
            app: app,
        });
        this.HsEventBusService.layerRemovals.next(e.element);
        if (getShowInLayerManager(e.element)) {
            this.HsEventBusService.compositionEdits.next({ app });
        }
        const layers = this.HsMapService.getMap(app).getLayers().getArray();
        if (this.apps[app].zIndexValue > layers.length) {
            this.apps[app].zIndexValue--;
        }
    }
    removeFromArray(arrayToSearch, layer) {
        for (let i = 0; i < arrayToSearch.length; i++) {
            if (arrayToSearch[i] == layer) {
                arrayToSearch.splice(i, 1);
            }
        }
    }
    /**
     * Initialize box layers and their starting active state
     * (PRIVATE)
     * @private
     */
    boxLayersInit(app) {
        if (this.HsConfig.get(app).box_layers != undefined) {
            this.apps[app].data.box_layers = this.HsConfig.get(app).box_layers;
            for (const box of this.apps[app].data.box_layers) {
                let visible = false;
                let baseVisible = false;
                for (const layer of box.get('layers').getArray()) {
                    if (layer.get('visible') == true && getBase(layer) == true) {
                        baseVisible = true;
                    }
                    else if (layer.get('visible') == true) {
                        visible = true;
                    }
                }
                box.thumbnail = getThumbnail(box);
                setActive(box, baseVisible ? baseVisible : visible);
            }
        }
    }
    /**
     * Change visibility of selected layer. If layer has exclusive setting, other layers from same group may be turned invisible
     * @param visibility - Visibility layer should have
     * @param layer - Selected layer - wrapped layer object (layer.layer expected)
     */
    changeLayerVisibility(visibility, layer, app) {
        layer.layer.setVisible(visibility);
        layer.visible = visibility;
        layer.grayed = !this.isLayerInResolutionInterval(layer.layer, app);
        //Set the other exclusive layers invisible - all or the ones with same path based on config
        if (visibility && getExclusive(layer.layer) == true) {
            for (const other_layer of this.apps[app].data.layers) {
                const pathExclusivity = this.HsConfig.get(app).pathExclusivity
                    ? getPath(other_layer.layer) == getPath(layer.layer)
                    : true;
                if (getExclusive(other_layer.layer) == true &&
                    other_layer != layer &&
                    pathExclusivity) {
                    other_layer.layer.setVisible(false);
                    other_layer.visible = false;
                }
            }
        }
        if (!visibility && this.HsUtilsService.instOf(layer.layer, Vector$1)) {
            this.HsEventBusService.LayerManagerLayerVisibilityChanges.next(layer);
        }
    }
    /**
     * Change visibility (on/off) of baselayers, only one baselayer may be visible
     * @param $event - Info about the event change visibility event, used if visibility of only one layer is changed
     * @param layer - Selected layer - wrapped layer object (layer.layer expected)
     */
    changeBaseLayerVisibility($event = null, layer = null, app) {
        if (layer === null || layer.layer != undefined) {
            if (this.apps[app].data.baselayersVisible == true) {
                //*NOTE Currently breaking base layer visibility when loading from composition with custom base layer to
                //other compositions without any base layer
                //*TODO Rewrite this loop hell to more readable code
                if ($event) {
                    //&& this.apps[app].data.baselayer != layer.title
                    for (const baseLayer of this.apps[app].data.baselayers) {
                        if (baseLayer.layer) {
                            baseLayer.layer.setVisible(false);
                            baseLayer.visible = false;
                            baseLayer.active = false;
                            if (baseLayer != layer) {
                                baseLayer.galleryMiniMenu = false;
                            }
                        }
                    }
                    for (const baseLayer of this.apps[app].data.baselayers) {
                        if (baseLayer.layer && baseLayer == layer) {
                            baseLayer.layer.setVisible(true);
                            baseLayer.visible = true;
                            baseLayer.active = true;
                            //this.apps[app].data.baselayer = layer.title;
                            break;
                        }
                    }
                }
                else {
                    this.apps[app].data.baselayersVisible = false;
                    for (const baseLayer of this.apps[app].data.baselayers) {
                        baseLayer.layer.setVisible(false);
                        baseLayer.galleryMiniMenu = false;
                    }
                }
            }
            else {
                if ($event) {
                    layer.active = true;
                    for (const baseLayer of this.apps[app].data.baselayers) {
                        if (baseLayer != layer) {
                            baseLayer.active = false;
                            baseLayer.visible = false;
                        }
                        else {
                            baseLayer.layer.setVisible(true);
                            baseLayer.visible = true;
                            //this.apps[app].data.baselayer = layer.title;
                        }
                    }
                }
                else {
                    for (const baseLayer of this.apps[app].data.baselayers) {
                        if (baseLayer.visible == true) {
                            baseLayer.layer.setVisible(true);
                        }
                    }
                }
                this.apps[app].data.baselayersVisible = true;
            }
        }
        else {
            for (const baseLayer of this.apps[app].data.baselayers) {
                if (baseLayer.type != undefined && baseLayer.type == 'terrain') {
                    baseLayer.visible = baseLayer == layer;
                    baseLayer.active = baseLayer.visible;
                }
            }
        }
        this.HsEventBusService.LayerManagerBaseLayerVisibilityChanges.next(layer);
    }
    /**
     * Change visibility (on/off) of baselayers, only one baselayer may be visible
     * @param $event - Info about the event change visibility event, used if visibility of only one layer is changed
     * @param layer - Selected layer - wrapped layer object (layer.layer expected)
     */
    changeTerrainLayerVisibility($event, layer, app) {
        for (let i = 0; i < this.apps[app].data.terrainlayers.length; i++) {
            if (this.apps[app].data.terrainlayers[i].type != undefined &&
                this.apps[app].data.terrainlayers[i].type == 'terrain') {
                this.apps[app].data.terrainlayers[i].visible =
                    this.apps[app].data.terrainlayers[i] == layer;
                this.apps[app].data.terrainlayers[i].active =
                    this.apps[app].data.terrainlayers[i].visible;
            }
        }
        this.HsEventBusService.LayerManagerBaseLayerVisibilityChanges.next(layer);
    }
    /**
     * Remove all non-base layers that were added to the map by user.
     * Doesn't remove layers added through app config (In case we want it to be 'removable', it can be set to true in the config.)
     * (PRIVATE)
     * @private
     */
    removeAllLayers(app) {
        const to_be_removed = [];
        this.HsMapService.getMap(app)
            .getLayers()
            .forEach((lyr) => {
            if (getRemovable(lyr) == true) {
                if (getBase(lyr) == undefined || getBase(lyr) == false) {
                    if (getShowInLayerManager(lyr) == undefined ||
                        getShowInLayerManager(lyr) == true) {
                        to_be_removed.push(lyr);
                    }
                }
            }
        });
        while (to_be_removed.length > 0) {
            this.HsMapService.getMap(app).removeLayer(to_be_removed.shift());
        }
        this.HsDrawService.get(app).addedLayersRemoved = true;
        this.HsDrawService.fillDrawableLayers(app);
    }
    /**
     * Show all layers of particular layer group (when groups are defined)
     * @param theme - Group layer to activate
     */
    activateTheme(theme, app) {
        let switchOn = true;
        if (getActive(theme) == true) {
            switchOn = false;
        }
        setActive(theme, switchOn);
        let baseSwitched = false;
        theme.setVisible(switchOn);
        for (const layer of theme.get('layers')) {
            if (getBase(layer) == true && !baseSwitched) {
                this.changeBaseLayerVisibility(null, null, app);
                baseSwitched = true;
            }
            else if (getBase(layer) == true) {
                return;
            }
            else {
                layer.setVisible(switchOn);
            }
        }
    }
    /**
     * Create events for checking if layer is being loaded or is loaded for ol.layer.Image or ol.layer.Tile
     * @param layer - Layer which is being added
     */
    loadingEvents(layer, app) {
        const olLayer = layer.layer;
        const source = olLayer.getSource();
        const loadProgress = {
            loadCounter: 0,
            loadTotal: 0,
            loadError: 0,
            loaded: true,
            error: undefined,
            percents: 0,
        };
        layer.loadProgress = loadProgress;
        if (this.HsUtilsService.instOf(olLayer, Vector$1)) {
            source.on('propertychange', (event) => {
                if (event.key == 'loaded') {
                    if (event.oldValue == false) {
                        this.HsEventBusService.layerLoads.next({ layer: olLayer, app });
                    }
                    else {
                        this.HsEventBusService.layerLoadings.next({
                            layer: olLayer,
                            progress: loadProgress,
                            app,
                        });
                    }
                }
            });
        }
        else if (this.HsUtilsService.instOf(olLayer, Image$1)) {
            source.on('imageloadstart', (event) => {
                loadProgress.loadTotal += 1;
                this.changeLoadCounter(olLayer, loadProgress, 1, app);
            });
            source.on('imageloadend', (event) => {
                loadProgress.error = false;
                this.changeLoadCounter(olLayer, loadProgress, -1, app);
            });
            source.on('imageloaderror', (event) => {
                loadProgress.loaded = true;
                loadProgress.error = true;
                this.HsEventBusService.layerLoads.next({ layer: olLayer, app });
            });
        }
        else if (this.HsUtilsService.instOf(olLayer, Tile)) {
            source.on('tileloadstart', (event) => {
                loadProgress.loadTotal += 1;
                this.changeLoadCounter(olLayer, loadProgress, 1, app);
            });
            source.on('tileloadend', (event) => {
                loadProgress.error = false;
                this.changeLoadCounter(olLayer, loadProgress, -1, app);
            });
            source.on('tileloaderror', (event) => {
                this.changeLoadCounter(olLayer, loadProgress, -1, app);
                loadProgress.loadError += 1;
                if (loadProgress.loadError == loadProgress.loadTotal) {
                    loadProgress.error = true;
                }
            });
        }
    }
    changeLoadCounter(layer, progress, change, app) {
        progress.loadCounter += change;
        //No more tiles to load?
        if (progress.loadCounter == 0) {
            progress.loaded = true;
            // If in 2 seconds no new tiles are starting to to load
            // we can assume that layer has finished loading
            if (progress.timer) {
                clearTimeout(progress.timer);
            }
            progress.timer = setTimeout(() => {
                if (progress.loadCounter == 0) {
                    this.zone.run(() => {
                        progress.loadTotal = 0;
                        this.HsEventBusService.layerLoads.next({ layer, app });
                        progress.percents = 100;
                    });
                }
            }, 2000);
        }
        else {
            progress.loaded = progress.loadTotal > 0 ? false : true;
        }
        let percents = 100.0;
        if (progress.loadTotal > 0) {
            percents = Math.round(((progress.loadTotal - progress.loadCounter) / progress.loadTotal) * 100);
        }
        progress.percents = percents;
        this.HsEventBusService.layerLoadings.next({ layer, progress, app });
        //Throttle updating UI a bit for many layers * many tiles
        const delta = new Date().getTime() - this.apps[app].lastProgressUpdate;
        if (percents == 100 || delta > 1000) {
            this.zone.run(() => {
                this.apps[app].lastProgressUpdate = new Date().getTime();
            });
        }
    }
    /**
     * Checks if given layer is a WMS layer
     */
    isWms(layer) {
        return (this.HsUtilsService.instOf(layer.getSource(), TileWMS) ||
            this.HsUtilsService.instOf(layer.getSource(), ImageWMS) ||
            this.HsUtilsService.instOf(layer.getSource(), TileArcGISRest));
    }
    /**
     * Test if layer (WMS) resolution is within map resolution interval
     * @param lyr - Selected layer
     */
    isLayerInResolutionInterval(lyr, app) {
        const cur_res = this.HsMapService.getMap(app).getView().getResolution();
        this.apps[app].currentResolution = cur_res;
        return (lyr.getMinResolution() <= cur_res && cur_res <= lyr.getMaxResolution());
    }
    /**
     * Toggles Additional information panel for current layer.
     * @param layer - Selected layer (HsLayerManagerService.currentLayer)
     * @param toToggle - Part of layer editor to be toggled
     * @param control - Part of layer editor to be controlled for state.
     * Determines whether only toggled part or whole layereditor would be closed
     */
    toggleLayerEditor(layer, toToggle, control, app) {
        if (!getCachedCapabilities(layer.layer)) {
            this.HsLayerManagerMetadata.fillMetadata(layer, app);
        }
        if (toToggle == 'sublayers' && layer.hasSublayers != true) {
            return;
        }
        if (this.apps[app].currentLayer != layer) {
            this.toggleCurrentLayer(layer, app);
            if (this.apps[app].menuExpanded) {
                this.apps[app].menuExpanded = false;
            }
            layer[toToggle] = true;
        }
        else {
            layer[toToggle] = !layer[toToggle];
            if (!layer[control]) {
                this.toggleCurrentLayer(layer, app);
            }
        }
    }
    /**
     * Opens detailed panel for manipulating selected layer and viewing metadata
     * @param layer - Selected layer to edit or view - Wrapped layer object
     */
    toggleCurrentLayer(layer, app) {
        if (this.apps[app].currentLayer == layer) {
            layer.sublayers = false;
            layer.settings = false;
            this.apps[app].currentLayer = null;
            this.updateGetParam(undefined, app);
        }
        else {
            this.setCurrentLayer(layer, app);
            return false;
        }
    }
    setCurrentLayer(layer, app) {
        try {
            this.apps[app].currentLayer = layer;
            this.updateGetParam(layer.title, app);
            if (!layer.checkedSubLayers) {
                layer.checkedSubLayers = {};
                layer.withChildren = {};
            }
            this.HsLayerSelectorService.select(layer, app);
            if (this.HsUtilsService.runningInBrowser()) {
                const layerNode = document.getElementById(layer.idString());
                if (layerNode && this.apps[app].layerEditorElement) {
                    this.HsUtilsService.insertAfter(this.apps[app].layerEditorElement, layerNode);
                }
            }
            return false;
        }
        catch (ex) {
            console.error(ex);
        }
    }
    updateGetParam(title, app) {
        const t = {};
        t[HS_PRMS.layerSelected] = title;
        this.HsShareUrlService.updateCustomParams(t, app);
    }
    /**
     * Makes layer grayscale
     * @param layer - Selected layer (currentLayer)
     */
    setGreyscale(layer, app) {
        const layerContainer = this.HsLayoutService.apps[app].contentWrapper.querySelector('.ol-layers > div:first-child');
        if (layerContainer.classList.contains('hs-grayscale')) {
            layerContainer.classList.remove('hs-grayscale');
            layer.grayscale = false;
        }
        else {
            layerContainer.classList.add('hs-grayscale');
            layer.grayscale = true;
        }
        setTimeout(() => {
            //Dispatching change event triggers renderer which causes non base layer to be
            //moved into separate canvas thus not being affected by css filter
            layer.layer.getSource().changed();
            layer.galleryMiniMenu = false;
        }, 0);
    }
    sortFoldersByZ(app) {
        this.apps[app].data.folders.sub_folders.sort((a, b) => {
            var _a;
            return (a.zIndex < b.zIndex ? -1 : a.zIndex > b.zIndex ? 1 : 0) *
                (((_a = this.HsConfig.get(app).reverseLayerList) !== null && _a !== void 0 ? _a : true) ? -1 : 1);
        });
    }
    /**
     * Initialization of needed controllers, run when map object is available
     * (PRIVATE)
     * @private
     */
    init(app) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.HsMapService.loaded(app);
            this.apps[app].map = this.HsMapService.getMap(app);
            const appRef = this.apps[app];
            for (const lyr of this.HsMapService.getMap(app).getLayers().getArray()) {
                this.applyZIndex(lyr, app);
                yield this.layerAdded({
                    element: lyr,
                }, app, true);
            }
            this.sortFoldersByZ(app);
            this.sortLayersByZ(appRef.data.layers, app);
            this.HsEventBusService.layerManagerUpdates.next({ layer: null, app });
            this.toggleEditLayerByUrlParam(app);
            this.boxLayersInit(app);
            appRef.changeResolutionHandler = appRef.map.getView().on('change:resolution', this.HsUtilsService.debounce((e) => this.resolutionChangeDebounceCallback(app), 200, false, this));
            appRef.addLayerHandler = appRef.map.getLayers().on('add', (e) => {
                this.applyZIndex(e.element, app, true);
                if (getShowInLayerManager(e.element) == false) {
                    return;
                }
                this.layerAdded(e, app);
            });
            appRef.removeLayerHandler = appRef.map
                .getLayers()
                .on('remove', (e) => this.layerRemoved(e, app));
        });
    }
    destroy(app) {
        const appRef = this.apps[app];
        unByKey(appRef.changeResolutionHandler);
        unByKey(appRef.addLayerHandler);
        unByKey(appRef.removeLayerHandler);
        delete this.apps[app];
    }
    resolutionChangeDebounceCallback(app) {
        setTimeout(() => {
            for (let i = 0; i < this.apps[app].data.layers.length; i++) {
                const tmp = !this.isLayerInResolutionInterval(this.apps[app].data.layers[i].layer, app);
                if (this.apps[app].data.layers[i].grayed != tmp) {
                    this.apps[app].data.layers[i].grayed = tmp;
                }
            }
            this.apps[app].timer = null;
        }, 250);
    }
    /**
     * Opens editor for layer specified in 'hs-layer-selected' url parameter
     */
    toggleEditLayerByUrlParam(app) {
        const layerTitle = this.HsShareUrlService.getParamValue(HS_PRMS.layerSelected);
        if (layerTitle != undefined) {
            setTimeout(() => {
                const layerFound = this.apps[app].data.layers.find((layer) => layer.title == layerTitle);
                if (layerFound !== undefined) {
                    this.toggleLayerEditor(layerFound, 'settings', 'sublayers', app);
                    this.HsEventBusService.layerSelectedFromUrl.next(layerFound.layer);
                }
            }, 500);
        }
    }
    /**
     * Sets zIndex of layer being added to be the highest among layers in same path
     * @param layer - layer being added
     */
    setPathMaxZIndex(layer, app) {
        let pathLayers;
        if (getBase(layer)) {
            pathLayers = this.apps[app].data.baselayers;
        }
        else {
            let path = getPath(layer);
            //If not set it'll be assigned inside populateFolders function as 'other'
            path = path ? path : 'other';
            pathLayers = this.apps[app].data.layers.filter((layer) => getPath(layer.layer) == path);
        }
        if (pathLayers.length > 0) {
            //Get max available index value
            const maxPathZIndex = Math.max(...pathLayers.map((lyr) => lyr.layer.getZIndex() || 0));
            layer.setZIndex(maxPathZIndex + 1);
            //Increase zIndex of the layer that are supposed to be rendered above inserted
            for (const lyr of this.apps[app].data.layers.filter((lyr) => lyr.layer.getZIndex() >= layer.getZIndex())) {
                lyr.layer.setZIndex(lyr.layer.getZIndex() + 1);
            }
        }
    }
    /**
     * Sets zIndex of layer being added.
     * @param layer - layer being added
     * @param asCallback - Whether the function is called directly or as a callback of add layer event.
     * No need to run each layer through setPathMaxZIndex on init
     */
    applyZIndex(layer, app, asCallback) {
        if (asCallback && getShowInLayerManager(layer) !== false) {
            this.setPathMaxZIndex(layer, app);
        }
        if (layer.getZIndex() == undefined) {
            layer.setZIndex(this.apps[app].zIndexValue++);
        }
        else {
            this.apps[app].zIndexValue++;
        }
    }
    makeSafeAndTranslate(group, input, app) {
        const translation = this.HsLanguageService.getTranslationIgnoreNonExisting(group, input, undefined, app);
        if (translation) {
            return this.sanitizer.bypassSecurityTrustHtml(translation);
        }
        else {
            return '';
        }
    }
    expandFilter(layer, value, app) {
        layer.expandFilter = value;
        this.apps[app].currentLayer = layer;
        this.HsLayerSelectorService.select(layer, app);
    }
    expandInfo(layer, value) {
        layer.expandInfo = value;
    }
    /*
      Generates downloadable geoJSON for vector layer.
      Features are also transformed into the EPSG:4326 projection
    */
    saveGeoJson(app) {
        const geojsonParser = new GeoJSON();
        const olLayer = this.apps[app].currentLayer.layer;
        const geojson = geojsonParser.writeFeatures((this.HsLayerUtilsService.isLayerClustered(olLayer)
            ? olLayer.getSource().getSource()
            : olLayer.getSource()).getFeatures(), {
            dataProjection: 'EPSG:4326',
            featureProjection: this.HsMapService.getCurrentProj(app),
        });
        const file = new Blob([geojson], { type: 'application/json' });
        const a = document.createElement('a'), url = URL.createObjectURL(file);
        a.href = url;
        a.download = getTitle(this.apps[app].currentLayer.layer).replace(/\s/g, '');
        document.body.appendChild(a);
        a.click();
        setTimeout(() => {
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
        }, 0);
    }
    /*
      Creats a copy of the currentLayer
    */
    copyLayer(newTitle, app) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const copyTitle = this.createCopyTitle(newTitle, app);
            if (this.HsLayerUtilsService.isLayerVectorLayer(this.apps[app].currentLayer.layer)) {
                this.copyVectorLayer(copyTitle, app);
            }
            else {
                const url = this.HsLayerUtilsService.getURL(this.apps[app].currentLayer.layer);
                let name = (_a = getCachedCapabilities(this.apps[app].currentLayer.layer)) === null || _a === void 0 ? void 0 : _a.Name;
                if (!name || typeof name === 'number') {
                    name = getName(this.apps[app].currentLayer.layer);
                }
                const layerCopy = yield this.HsAddDataOwsService.connectToOWS({
                    type: this.getLayerSourceType(this.apps[app].currentLayer.layer).toLowerCase(),
                    uri: url,
                    layer: name,
                    getOnly: true,
                }, app);
                if (layerCopy[0]) {
                    layerCopy[0].setProperties(this.apps[app].currentLayer.layer.getProperties());
                    setTitle(layerCopy[0], copyTitle);
                    //Currently ticked sub-layers are stored in LAYERS
                    const subLayers = (_b = this.HsLayerUtilsService.getLayerParams(this.apps[app].currentLayer.layer)) === null || _b === void 0 ? void 0 : _b.LAYERS;
                    if (subLayers) {
                        setSubLayers(layerCopy[0], subLayers);
                    }
                    this.HsLayerUtilsService.updateLayerParams(layerCopy[0], this.HsLayerUtilsService.getLayerParams(this.apps[app].currentLayer.layer));
                    // We don't want the default styles to be set which add-data panel does.
                    // Otherwise they won't be cleared if the original layer has undefined STYLES
                    // Also we have to set LAYERS to currentLayer original values for composition saving
                    this.HsLayerUtilsService.updateLayerParams(layerCopy[0], {
                        STYLES: null,
                        //Object.assign will ignore it if origLayers is undefined.
                        LAYERS: getOrigLayers(this.apps[app].currentLayer.layer),
                    });
                    this.HsMapService.getMap(app).addLayer(layerCopy[0]);
                }
            }
        });
    }
    /*
      Creats a copy of the currentLayer if it is a vector layer
    */
    copyVectorLayer(newTitle, app) {
        var _a, _b;
        let features;
        if (this.HsLayerUtilsService.isLayerClustered(this.apps[app].currentLayer.layer)) {
            features = (_a = this.apps[app].currentLayer.layer.getSource()
                .getSource()) === null || _a === void 0 ? void 0 : _a.getFeatures();
        }
        else {
            features = (_b = this.apps[app].currentLayer.layer.getSource()) === null || _b === void 0 ? void 0 : _b.getFeatures();
        }
        const copiedLayer = new Vector$1({
            properties: this.apps[app].currentLayer.layer.getProperties(),
            source: new VectorSource({
                features,
            }),
            style: this.apps[app].currentLayer.layer.getStyle(),
        });
        setTitle(copiedLayer, newTitle);
        setName(copiedLayer, getName(this.apps[app].currentLayer.layer));
        this.HsMapService.addLayer(copiedLayer, app);
    }
    /*
      Creats a new title for the copied layer
    */
    createCopyTitle(newTitle, app) {
        const layerName = getName(this.apps[app].currentLayer.layer);
        let copyTitle = getTitle(this.apps[app].currentLayer.layer);
        let numb = 0;
        if (newTitle && newTitle !== copyTitle) {
            copyTitle = newTitle;
        }
        else {
            const layerCopies = this.HsMapService.getLayersArray(app).filter((l) => getName(l) == layerName);
            numb = layerCopies !== undefined ? layerCopies.length : 0;
            copyTitle = copyTitle.replace(/\([0-9]\)/g, '').trimEnd();
            copyTitle = copyTitle + ` (${numb})`;
        }
        return copyTitle;
    }
}
HsLayerManagerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerManagerService, deps: [{ token: HsConfig }, { token: HsDimensionTimeService }, { token: HsDrawService }, { token: HsEventBusService }, { token: HsLanguageService }, { token: HsLayerEditorVectorLayerService }, { token: HsLayerManagerMetadataService }, { token: HsLayerSelectorService }, { token: HsLayerUtilsService }, { token: HsLayoutService }, { token: HsLogService }, { token: HsMapService }, { token: HsQueuesService }, { token: HsAddDataOwsService }, { token: HsShareUrlService }, { token: HsUtilsService }, { token: i1$3.DomSanitizer }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Injectable });
HsLayerManagerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerManagerService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerManagerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsConfig }, { type: HsDimensionTimeService }, { type: HsDrawService }, { type: HsEventBusService }, { type: HsLanguageService }, { type: HsLayerEditorVectorLayerService }, { type: HsLayerManagerMetadataService }, { type: HsLayerSelectorService }, { type: HsLayerUtilsService }, { type: HsLayoutService }, { type: HsLogService }, { type: HsMapService }, { type: HsQueuesService }, { type: HsAddDataOwsService }, { type: HsShareUrlService }, { type: HsUtilsService }, { type: i1$3.DomSanitizer }, { type: i0.NgZone }]; } });

class HsPositionComponent {
    constructor(hsLayerUtilsService, hsLayerManagerService) {
        this.hsLayerUtilsService = hsLayerUtilsService;
        this.hsLayerManagerService = hsLayerManagerService;
        this.app = 'default';
        this.addUnderChange = new EventEmitter();
    }
    updateChanges() {
        this.addUnderChange.next(this.addUnder);
    }
}
HsPositionComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsPositionComponent, deps: [{ token: HsLayerUtilsService }, { token: HsLayerManagerService }], target: i0.ɵɵFactoryTarget.Component });
HsPositionComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsPositionComponent, selector: "hs-target-position", inputs: { app: "app", addUnder: "addUnder" }, outputs: { addUnderChange: "addUnderChange" }, ngImport: i0, template: "<div class=\"form-group\">\n    <div class=\"input-group\">\n        <span class=\"input-group-text control-label\">{{'ADDLAYERS.under' | translateHs : {app} }}</span>\n        <select class=\"form-control form-select\" [(ngModel)]=\"addUnder\" (ngModelChange)=\"updateChanges()\"\n            name=\"addUnder\">\n            <option [ngValue]=\"null\" selected>{{'ADDLAYERS.none' | translateHs : {app} }}</option>\n            <option [ngValue]=\"layer.layer\" *ngFor=\"let layer of hsLayerManagerService.apps[app].data.layers\">\n                {{layer.title | translateHs : {app, module: 'LAYERS'} }}</option>\n        </select>\n    </div>\n</div>\n", directives: [{ type: i3$1.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3$1.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i3$1.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsPositionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-target-position', template: "<div class=\"form-group\">\n    <div class=\"input-group\">\n        <span class=\"input-group-text control-label\">{{'ADDLAYERS.under' | translateHs : {app} }}</span>\n        <select class=\"form-control form-select\" [(ngModel)]=\"addUnder\" (ngModelChange)=\"updateChanges()\"\n            name=\"addUnder\">\n            <option [ngValue]=\"null\" selected>{{'ADDLAYERS.none' | translateHs : {app} }}</option>\n            <option [ngValue]=\"layer.layer\" *ngFor=\"let layer of hsLayerManagerService.apps[app].data.layers\">\n                {{layer.title | translateHs : {app, module: 'LAYERS'} }}</option>\n        </select>\n    </div>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: HsLayerUtilsService }, { type: HsLayerManagerService }]; }, propDecorators: { app: [{
                type: Input
            }], addUnder: [{
                type: Input
            }], addUnderChange: [{
                type: Output
            }] } });

class HsAdvancedOptionsComponent {
    constructor(hsAddDataVectorService) {
        this.hsAddDataVectorService = hsAddDataVectorService;
        this.app = 'default';
    }
    ngOnInit() {
        this.isKml = this.hsAddDataVectorService.isKml(this.data.type, this.data.url);
    }
}
HsAdvancedOptionsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAdvancedOptionsComponent, deps: [{ token: HsAddDataVectorService }], target: i0.ɵɵFactoryTarget.Component });
HsAdvancedOptionsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsAdvancedOptionsComponent, selector: "hs-advanced-options", inputs: { data: "data", app: "app" }, ngImport: i0, template: "<div class=\"hs-advanced-options\">\n  <div class=\"form-floating mb-3\">\n    <input class=\"form-control\" name=\"folder\" [(ngModel)]=\"data.folder_name\"\n      placeholder=\"'ADDLAYERS.folderName' | translateHs : {app} \" />\n    <label for=\"folder\" class=\"capabilities_label control-label\">{{'ADDLAYERS.folderName' | translateHs : {app}\n      }}</label>\n  </div>\n  <div class=\"form-group\" *ngIf=\"isKml\">\n    <input type=\"checkbox\" name=\"extractStyles\" [(ngModel)]=\"data.extract_styles\" />\n    <label class=\"capabilities_label control-label ms-1\">{{'ADDLAYERS.VECTOR.extractStyles' |\n      translateHs : {app} }}</label>\n  </div>\n  <hs-target-position [(addUnder)]=\"data.addUnder\" [app]=\"app\"></hs-target-position>\n</div>", components: [{ type: HsPositionComponent, selector: "hs-target-position", inputs: ["app", "addUnder"], outputs: ["addUnderChange"] }], directives: [{ type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3$1.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAdvancedOptionsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-advanced-options', template: "<div class=\"hs-advanced-options\">\n  <div class=\"form-floating mb-3\">\n    <input class=\"form-control\" name=\"folder\" [(ngModel)]=\"data.folder_name\"\n      placeholder=\"'ADDLAYERS.folderName' | translateHs : {app} \" />\n    <label for=\"folder\" class=\"capabilities_label control-label\">{{'ADDLAYERS.folderName' | translateHs : {app}\n      }}</label>\n  </div>\n  <div class=\"form-group\" *ngIf=\"isKml\">\n    <input type=\"checkbox\" name=\"extractStyles\" [(ngModel)]=\"data.extract_styles\" />\n    <label class=\"capabilities_label control-label ms-1\">{{'ADDLAYERS.VECTOR.extractStyles' |\n      translateHs : {app} }}</label>\n  </div>\n  <hs-target-position [(addUnder)]=\"data.addUnder\" [app]=\"app\"></hs-target-position>\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsAddDataVectorService }]; }, propDecorators: { data: [{
                type: Input
            }], app: [{
                type: Input
            }] } });

class HsNewLayerFormComponent {
    constructor(hsAddDataCommonFileService, hsLanguageService, hsFileService, hsLaymanService) {
        this.hsAddDataCommonFileService = hsAddDataCommonFileService;
        this.hsLanguageService = hsLanguageService;
        this.hsFileService = hsFileService;
        this.hsLaymanService = hsLaymanService;
        this.advancedPanelVisible = false;
        this.app = 'default';
        this.srsFilter = (srs) => {
            return true;
        };
    }
    ngOnInit() {
        this.appRef = this.hsAddDataCommonFileService.get(this.app);
        if (this.data.type === 'raster') {
            this.srsFilter = (item) => {
                return ['4326', '3857'].some((epsg) => item.includes(epsg));
            };
        }
    }
    sldTitle() {
        return this.data.sld
            ? this.data.sld.name
            : this.hsLanguageService.getTranslationIgnoreNonExisting('ADDLAYERS.Vector', 'addSld', undefined, this.app);
    }
    read(evt) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.hsFileService.read(evt, this.app, this.data.type === 'geojson');
        });
    }
}
HsNewLayerFormComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsNewLayerFormComponent, deps: [{ token: HsAddDataCommonFileService }, { token: HsLanguageService }, { token: HsFileService }, { token: HsLaymanService }], target: i0.ɵɵFactoryTarget.Component });
HsNewLayerFormComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsNewLayerFormComponent, selector: "hs-new-layer-form", inputs: { data: "data", app: "app" }, ngImport: i0, template: "<div>\n\n  <p [hidden]=\"data?.srs\"><sub class=\"text-danger\">{{'ADDLAYERS.Vector.note' | translateHs : {app} }}</sub></p>\n\n  <div *ngIf=\"data.type === 'raster'\"\n    class=\"alert alert-warning d-flex align-items-center mt-2 justify-content-between\">\n    <p class=\"m-0\"> {{'ADDLAYERS.rasterImageryWith' | translateHs : {app} }}</p>\n  </div>\n\n  <div class=\"form-floating mb-3\">\n    <input [placeholder]=\"'ADDDATA.URL.submitLayerName' | translateHs : {app} \" class=\"form-control\" name=\"name\"\n      [(ngModel)]=\"data.name\" (ngModelChange)=\"data.title = data.name\" />\n    <label for=\"name\" class=\"capabilities_label control-label\">{{'COMMON.name' | translateHs : {app} }}</label>\n\n  </div>\n  <div class=\"form-floating mb-3\">\n    <textarea class=\"form-control\" id='hs-ows-abstract'\n      [placeholder]=\"'COMMON.fillInDescriptive' | translateHs : {app} \" name=\"abstract\" [(ngModel)]=\"data.abstract\">\n                              </textarea>\n    <label for=\"absctract\" class=\"capabilities_label control-label\">{{'COMMON.abstract' | translateHs : {app} }}</label>\n\n  </div>\n  <div class=\"form-group\" *ngIf=\"data.type === 'shp' || data.type === 'raster'\">\n    <div class=\"input-group\">\n      <span class=\"input-group-text control-label\">{{'ADDLAYERS.srs' | translateHs : {app} }}</span>\n      <select class=\"form-control form-select\" [(ngModel)]=\"data.srs\" name=\"srs\">\n        <option [ngValue]=\"null\" disabled selected hidden>{{'ADDLAYERS.SRSRequired' | translateHs : {app} }}</option>\n        <option *ngFor=\"let epsg of hsLaymanService.supportedCRRList | filter: srsFilter\" [ngValue]=\"epsg\">{{epsg}}\n        </option>\n      </select>\n    </div>\n  </div>\n\n  <ng-container *ngIf=\"hsAddDataCommonFileService.isAuthorized() && data.saveAvailable\">\n    <!-- TODO: Remove function call from template -->\n    <hs-save-to-layman [data]=\"data\" [app]=\"app\"></hs-save-to-layman>\n  </ng-container>\n  <ng-container *ngIf=\"data.type === 'shp' || data.type === 'raster' || data.type === 'geojson'\">\n    <div class=\"d-flex justify-content-between align-items-center\">\n      <p class=\"ps-4\">{{'ADDLAYERS.SHP.SLDStyleFile' | translateHs : {app} }}</p>\n      <label class=\"dropzone-label\">\n        <input name=\"file\" type=\"file\" accept=\".sld\" class=\"inputfile\"\n          (change)=\"read({fileList: $event.target.files, uploader: 'sld', dropped: false})\" id=\"sld\">\n        <label for=\"sld\" class=\"p-2 rounded\" style=\"font-size: 1em;\" [ngClass]=\"data.sld ? 'bg-success' : 'bg-primary'\">\n          <i class=\"icon-uploadalt p-2\"></i>{{sldTitle()}}</label>\n      </label>\n    </div>\n  </ng-container>\n\n  <button type=\"button\" class=\"btn w-100 mt-2 btn-outline-secondary dropdown-toggle dropdown-toggle-split\"\n    (click)=\"advancedPanelVisible = !advancedPanelVisible\">\n    {{'COMMON.advancedOptions' | translateHs : {app} }}\n  </button>\n  <ng-container *ngIf=\"advancedPanelVisible\">\n    <hs-advanced-options [data]=\"data\" [app]=\"app\"></hs-advanced-options>\n  </ng-container>\n\n</div>", components: [{ type: HsSaveToLaymanComponent, selector: "hs-save-to-layman", inputs: ["data", "app"] }, { type: HsAdvancedOptionsComponent, selector: "hs-advanced-options", inputs: ["data", "app"] }], directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3$1.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i3$1.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i3$1.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], pipes: { "translateHs": TranslateCustomPipe, "filter": FilterPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsNewLayerFormComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-new-layer-form', template: "<div>\n\n  <p [hidden]=\"data?.srs\"><sub class=\"text-danger\">{{'ADDLAYERS.Vector.note' | translateHs : {app} }}</sub></p>\n\n  <div *ngIf=\"data.type === 'raster'\"\n    class=\"alert alert-warning d-flex align-items-center mt-2 justify-content-between\">\n    <p class=\"m-0\"> {{'ADDLAYERS.rasterImageryWith' | translateHs : {app} }}</p>\n  </div>\n\n  <div class=\"form-floating mb-3\">\n    <input [placeholder]=\"'ADDDATA.URL.submitLayerName' | translateHs : {app} \" class=\"form-control\" name=\"name\"\n      [(ngModel)]=\"data.name\" (ngModelChange)=\"data.title = data.name\" />\n    <label for=\"name\" class=\"capabilities_label control-label\">{{'COMMON.name' | translateHs : {app} }}</label>\n\n  </div>\n  <div class=\"form-floating mb-3\">\n    <textarea class=\"form-control\" id='hs-ows-abstract'\n      [placeholder]=\"'COMMON.fillInDescriptive' | translateHs : {app} \" name=\"abstract\" [(ngModel)]=\"data.abstract\">\n                              </textarea>\n    <label for=\"absctract\" class=\"capabilities_label control-label\">{{'COMMON.abstract' | translateHs : {app} }}</label>\n\n  </div>\n  <div class=\"form-group\" *ngIf=\"data.type === 'shp' || data.type === 'raster'\">\n    <div class=\"input-group\">\n      <span class=\"input-group-text control-label\">{{'ADDLAYERS.srs' | translateHs : {app} }}</span>\n      <select class=\"form-control form-select\" [(ngModel)]=\"data.srs\" name=\"srs\">\n        <option [ngValue]=\"null\" disabled selected hidden>{{'ADDLAYERS.SRSRequired' | translateHs : {app} }}</option>\n        <option *ngFor=\"let epsg of hsLaymanService.supportedCRRList | filter: srsFilter\" [ngValue]=\"epsg\">{{epsg}}\n        </option>\n      </select>\n    </div>\n  </div>\n\n  <ng-container *ngIf=\"hsAddDataCommonFileService.isAuthorized() && data.saveAvailable\">\n    <!-- TODO: Remove function call from template -->\n    <hs-save-to-layman [data]=\"data\" [app]=\"app\"></hs-save-to-layman>\n  </ng-container>\n  <ng-container *ngIf=\"data.type === 'shp' || data.type === 'raster' || data.type === 'geojson'\">\n    <div class=\"d-flex justify-content-between align-items-center\">\n      <p class=\"ps-4\">{{'ADDLAYERS.SHP.SLDStyleFile' | translateHs : {app} }}</p>\n      <label class=\"dropzone-label\">\n        <input name=\"file\" type=\"file\" accept=\".sld\" class=\"inputfile\"\n          (change)=\"read({fileList: $event.target.files, uploader: 'sld', dropped: false})\" id=\"sld\">\n        <label for=\"sld\" class=\"p-2 rounded\" style=\"font-size: 1em;\" [ngClass]=\"data.sld ? 'bg-success' : 'bg-primary'\">\n          <i class=\"icon-uploadalt p-2\"></i>{{sldTitle()}}</label>\n      </label>\n    </div>\n  </ng-container>\n\n  <button type=\"button\" class=\"btn w-100 mt-2 btn-outline-secondary dropdown-toggle dropdown-toggle-split\"\n    (click)=\"advancedPanelVisible = !advancedPanelVisible\">\n    {{'COMMON.advancedOptions' | translateHs : {app} }}\n  </button>\n  <ng-container *ngIf=\"advancedPanelVisible\">\n    <hs-advanced-options [data]=\"data\" [app]=\"app\"></hs-advanced-options>\n  </ng-container>\n\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsAddDataCommonFileService }, { type: HsLanguageService }, { type: HsFileService }, { type: HsLaymanService }]; }, propDecorators: { data: [{
                type: Input
            }], app: [{
                type: Input
            }] } });

class HsAddDataVectorUrlComponent {
    constructor(hsHistoryListService, hsAddDataVectorService, hsAddDataCommonFileService, hsLayoutService) {
        this.hsHistoryListService = hsHistoryListService;
        this.hsAddDataVectorService = hsAddDataVectorService;
        this.hsAddDataCommonFileService = hsAddDataCommonFileService;
        this.hsLayoutService = hsLayoutService;
        this.app = 'default';
        this.ngUnsubscribe = new Subject();
        this.connect = () => __awaiter(this, void 0, void 0, function* () {
            const obtainable = yield this.hsAddDataCommonFileService.isUrlObtainable(this.data.url, this.app);
            if (obtainable) {
                this.hsHistoryListService.addSourceHistory(this.fileType, this.data.url);
                this.data.showDetails = true;
            }
        });
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    ngOnInit() {
        const commonFileServiceRef = this.hsAddDataCommonFileService.get(this.app);
        commonFileServiceRef.dataObjectChanged
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((data) => {
            this.data.showDetails = true;
            Object.assign(this.data, data);
            // this.clearInput();
        });
        this.setDataToDefault();
    }
    /**
     * Handler for adding non-wms service, file in template.
     */
    add() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.hsAddDataVectorService.addNewLayer(this.data, this.app);
            if (response.complete) {
                this.hsLayoutService.setMainPanel('layermanager', this.app);
                this.setDataToDefault();
            }
        });
    }
    /**
     * Reset data object to its default values
     */
    setDataToDefault() {
        this.data = {
            // Not possible to save KML to layman yet
            abstract: '',
            addUnder: null,
            base64url: '',
            extract_styles: false,
            featureCount: 0,
            features: [],
            folder_name: '',
            name: '',
            saveAvailable: false,
            saveToLayman: false,
            showDetails: false,
            sld: null,
            srs: 'EPSG:4326',
            title: '',
            type: this.fileType,
            url: undefined,
        };
    }
}
HsAddDataVectorUrlComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataVectorUrlComponent, deps: [{ token: HsHistoryListService }, { token: HsAddDataVectorService }, { token: HsAddDataCommonFileService }, { token: HsLayoutService }], target: i0.ɵɵFactoryTarget.Component });
HsAddDataVectorUrlComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsAddDataVectorUrlComponent, selector: "hs-url-vector", inputs: { fileType: "fileType", app: "app" }, ngImport: i0, template: "<form class=\"form-horizontal\" role=\"form\">\n  <hs-common-url [type]=\"fileType\" [app]=\"app\" [(url)]=\"data.url\" (connect)=\"connect()\">\n  </hs-common-url>\n\n  <div *ngIf=\"data.showDetails\">\n    <hs-new-layer-form [data]=\"data\" [app]=\"app\"></hs-new-layer-form>\n\n    <button class=\"btn btn-primary w-100 mt-2\" [disabled]=\"!data.title\" (click)=\"add()\"><i class=\"icon-plus\"></i>\n      {{'COMMON.add' | translateHs: {app} }}\n    </button>\n  </div>\n\n</form>", components: [{ type: HsCommonUrlComponent, selector: "hs-common-url", inputs: ["type", "url", "app"], outputs: ["urlChange", "connect"] }, { type: HsNewLayerFormComponent, selector: "hs-new-layer-form", inputs: ["data", "app"] }], directives: [{ type: i3$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i3$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i3$1.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataVectorUrlComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-url-vector', template: "<form class=\"form-horizontal\" role=\"form\">\n  <hs-common-url [type]=\"fileType\" [app]=\"app\" [(url)]=\"data.url\" (connect)=\"connect()\">\n  </hs-common-url>\n\n  <div *ngIf=\"data.showDetails\">\n    <hs-new-layer-form [data]=\"data\" [app]=\"app\"></hs-new-layer-form>\n\n    <button class=\"btn btn-primary w-100 mt-2\" [disabled]=\"!data.title\" (click)=\"add()\"><i class=\"icon-plus\"></i>\n      {{'COMMON.add' | translateHs: {app} }}\n    </button>\n  </div>\n\n</form>" }]
        }], ctorParameters: function () { return [{ type: HsHistoryListService }, { type: HsAddDataVectorService }, { type: HsAddDataCommonFileService }, { type: HsLayoutService }]; }, propDecorators: { fileType: [{
                type: Input
            }], app: [{
                type: Input
            }] } });

class HsAddDataUrlComponent {
    constructor(hsConfig, hsLanguageService, hsShareUrlService, hsLayoutService, hsAddDataCommonService, hsAddDataOwsService, hsAddDataUrlService, hsDialogContainerService) {
        this.hsConfig = hsConfig;
        this.hsLanguageService = hsLanguageService;
        this.hsShareUrlService = hsShareUrlService;
        this.hsLayoutService = hsLayoutService;
        this.hsAddDataCommonService = hsAddDataCommonService;
        this.hsAddDataOwsService = hsAddDataOwsService;
        this.hsAddDataUrlService = hsAddDataUrlService;
        this.hsDialogContainerService = hsDialogContainerService;
        this.app = 'default';
        this.ngUnsubscribe = new Subject();
    }
    ngOnInit() {
        this.appRef = this.hsAddDataUrlService.get(this.app);
        if (Array.isArray(this.hsConfig.get(this.app).connectTypes)) {
            this.types = this.hsConfig
                .get(this.app)
                .connectTypes.filter((type) => servicesSupportedByUrl.includes(type))
                .map((type) => AddDataUrlValues.find((v) => v.id == type));
        }
        else {
            this.types = AddDataUrlValues;
        }
        if (this.hsAddDataUrlService.get(this.app).typeSelected) {
            this.connectServiceFromUrlParam(this.hsAddDataUrlService.get(this.app).typeSelected);
        }
        this.hsAddDataUrlService
            .get(this.app)
            .addDataCapsParsingError.pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((e) => {
            console.warn(this.app);
            let error = e.toString();
            if (error === null || error === void 0 ? void 0 : error.includes('Unsuccessful OAuth2')) {
                error = this.hsLanguageService.getTranslationIgnoreNonExisting('COMMON', 'Authentication failed. Login to the catalogue.', undefined, this.app);
            }
            else if (error.includes('property')) {
                error = this.hsLanguageService.getTranslationIgnoreNonExisting('ADDLAYERS', 'serviceTypeNotMatching', undefined, this.app);
            }
            else {
                error = this.hsLanguageService.getTranslationIgnoreNonExisting('ADDLAYERS', error, undefined, this.app);
            }
            this.hsDialogContainerService.create(HsGetCapabilitiesErrorComponent, { error: error }, this.app);
        });
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    selectType(type, app) {
        this.hsAddDataCommonService.clearParams(app);
        this.hsAddDataUrlService.get(this.app).typeSelected = type;
    }
    connectServiceFromUrlParam(type) {
        if (!this.hsAddDataUrlService.get(this.app).connectFromParams) {
            return;
        }
        const layers = this.hsShareUrlService.getParamValue(`hs-${type}-layers`);
        const url = this.hsShareUrlService.getParamValue(`hs-${type}-to-connect`);
        // const serviceName = `hsAddLayersWmsService`;
        if (layers) {
            for (const layer of layers.split(';')) {
                this.hsAddDataOwsService.connectToOWS({
                    type,
                    uri: url,
                    layer,
                    style: undefined,
                }, this.app);
            }
        }
        else {
            this.hsAddDataOwsService.connectToOWS({ type, uri: url }, this.app);
        }
        this.hsAddDataUrlService.get(this.app).connectFromParams = false;
    }
}
HsAddDataUrlComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataUrlComponent, deps: [{ token: HsConfig }, { token: HsLanguageService }, { token: HsShareUrlService }, { token: HsLayoutService }, { token: HsAddDataCommonService }, { token: HsAddDataOwsService }, { token: HsAddDataUrlService }, { token: HsDialogContainerService }], target: i0.ɵɵFactoryTarget.Component });
HsAddDataUrlComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsAddDataUrlComponent, selector: "hs-add-data-url", inputs: { app: "app" }, ngImport: i0, template: "<div class=\"d-flex justify-content-center flex-column align-items-center m-3\">\n    <div class=\"container \">\n        <div class=\"row justify-content-center\">\n            <button *ngFor=\"let type of types\" [ngClass]=\"{'active': type.id === appRef.typeSelected }\"\n                (click)=\"selectType(type.id,app)\" style=\"margin: 3px;\"\n                class=\"btn btn-light btn-outline-secondary rounded btn-sm mt-1 col-sm-3\">\n                {{type.text}}\n            </button>\n        </div>\n    </div>\n\n    <div class=\"w-100 pt-3\">\n        <hs-url-arcgis *ngIf=\"appRef.typeSelected === 'arcgis'\" [app]=\"app\"></hs-url-arcgis>\n        <hs-url-wfs *ngIf=\"appRef.typeSelected === 'wfs'\" [app]=\"app\"></hs-url-wfs>\n        <hs-url-wms *ngIf=\"appRef.typeSelected === 'wms'\" [app]=\"app\"></hs-url-wms>\n        <hs-url-wmts *ngIf=\"appRef.typeSelected === 'wmts'\" [app]=\"app\"></hs-url-wmts>\n        <hs-url-vector *ngIf=\"appRef.typeSelected === 'geojson'\" [app]=\"app\" [fileType]=\"appRef.typeSelected\">\n        </hs-url-vector>\n        <hs-url-vector *ngIf=\"appRef.typeSelected === 'kml'\" [app]=\"app\" [fileType]=\"appRef.typeSelected\">\n        </hs-url-vector>\n        <hs-url-vector *ngIf=\"appRef.typeSelected === 'gpx'\" [app]=\"app\" [fileType]=\"appRef.typeSelected\">\n        </hs-url-vector>\n    </div>\n</div>", components: [{ type: HsUrlArcGisComponent, selector: "hs-url-arcgis", inputs: ["app"] }, { type: HsUrlWfsComponent, selector: "hs-url-wfs", inputs: ["app"] }, { type: HsUrlWmsComponent, selector: "hs-url-wms", inputs: ["app"] }, { type: HsUrlWmtsComponent, selector: "hs-url-wmts", inputs: ["app"] }, { type: HsAddDataVectorUrlComponent, selector: "hs-url-vector", inputs: ["fileType", "app"] }], directives: [{ type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataUrlComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-add-data-url', template: "<div class=\"d-flex justify-content-center flex-column align-items-center m-3\">\n    <div class=\"container \">\n        <div class=\"row justify-content-center\">\n            <button *ngFor=\"let type of types\" [ngClass]=\"{'active': type.id === appRef.typeSelected }\"\n                (click)=\"selectType(type.id,app)\" style=\"margin: 3px;\"\n                class=\"btn btn-light btn-outline-secondary rounded btn-sm mt-1 col-sm-3\">\n                {{type.text}}\n            </button>\n        </div>\n    </div>\n\n    <div class=\"w-100 pt-3\">\n        <hs-url-arcgis *ngIf=\"appRef.typeSelected === 'arcgis'\" [app]=\"app\"></hs-url-arcgis>\n        <hs-url-wfs *ngIf=\"appRef.typeSelected === 'wfs'\" [app]=\"app\"></hs-url-wfs>\n        <hs-url-wms *ngIf=\"appRef.typeSelected === 'wms'\" [app]=\"app\"></hs-url-wms>\n        <hs-url-wmts *ngIf=\"appRef.typeSelected === 'wmts'\" [app]=\"app\"></hs-url-wmts>\n        <hs-url-vector *ngIf=\"appRef.typeSelected === 'geojson'\" [app]=\"app\" [fileType]=\"appRef.typeSelected\">\n        </hs-url-vector>\n        <hs-url-vector *ngIf=\"appRef.typeSelected === 'kml'\" [app]=\"app\" [fileType]=\"appRef.typeSelected\">\n        </hs-url-vector>\n        <hs-url-vector *ngIf=\"appRef.typeSelected === 'gpx'\" [app]=\"app\" [fileType]=\"appRef.typeSelected\">\n        </hs-url-vector>\n    </div>\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsConfig }, { type: HsLanguageService }, { type: HsShareUrlService }, { type: HsLayoutService }, { type: HsAddDataCommonService }, { type: HsAddDataOwsService }, { type: HsAddDataUrlService }, { type: HsDialogContainerService }]; }, propDecorators: { app: [{
                type: Input
            }] } });

const filesSupported = [
    'kml',
    'gpx',
    'geojson',
    'shp',
    'raster',
];
//https://stackoverflow.com/questions/40863488/how-can-i-iterate-over-a-custom-literal-type-in-typescript

const AddDataFileValues = [
    {
        id: 'kml',
        text: 'KML',
    },
    {
        id: 'gpx',
        text: 'GPX',
    },
    {
        id: 'geojson',
        text: 'GeoJSON',
    },
    {
        id: 'shp',
        text: 'Shapefile',
    },
    {
        id: 'raster',
        text: 'Raster image',
    },
];

class HsFileDropDirective {
    constructor() {
        this.filesDropped = new EventEmitter();
        this.filesHovered = new EventEmitter();
    }
    onDrop($event) {
        $event.preventDefault();
        const transfer = $event.dataTransfer;
        this.filesDropped.emit(transfer.files);
        this.filesHovered.emit(false);
    }
    onDragOver($event) {
        $event.preventDefault();
        this.filesHovered.emit(true);
    }
    onDragLeave($event) {
        this.filesHovered.emit(false);
    }
}
HsFileDropDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsFileDropDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
HsFileDropDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.11", type: HsFileDropDirective, selector: "[fileDrop]", outputs: { filesDropped: "filesDropped", filesHovered: "filesHovered" }, host: { listeners: { "drop": "onDrop($event)", "dragover": "onDragOver($event)", "dragleave": "onDragLeave($event)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsFileDropDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fileDrop]',
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { filesDropped: [{
                type: Output
            }], filesHovered: [{
                type: Output
            }], onDrop: [{
                type: HostListener,
                args: ['drop', ['$event']]
            }], onDragOver: [{
                type: HostListener,
                args: ['dragover', ['$event']]
            }], onDragLeave: [{
                type: HostListener,
                args: ['dragleave', ['$event']]
            }] } });

class HsUploadComponent {
    constructor() {
        this.uploaded = new EventEmitter();
        this.app = 'default';
        this.dropzoneActive = false;
    }
    emitHandleUpload(fileList, dropped) {
        this.uploaded.emit({ fileList, uploader: this.uploader, dropped });
    }
    dropZoneState($event) {
        this.dropzoneActive = $event;
    }
    getFileInput() {
        return this.fileInput;
    }
}
HsUploadComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUploadComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
HsUploadComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsUploadComponent, selector: "hs-file-upload", inputs: { acceptedFormats: "acceptedFormats", uploader: "uploader", app: "app" }, outputs: { uploaded: "uploaded" }, viewQueries: [{ propertyName: "fileInput", first: true, predicate: ["fileInput"], descendants: true }], ngImport: i0, template: "<div class=\"d-flex justify-content-center align-items-center w-100 dropzone-container\">\n    <div class=\"dropzone p-4\" fileDrop (filesDropped)=\"emitHandleUpload($event, true)\"\n        (filesHovered)=\"dropZoneState($event)\" [ngClass]=\"{'active': dropzoneActive}\">\n        <p class=\"dropzone-label mt-2 text-primary\">{{'ADDLAYERS.Vector.dragAndDropFiles' | translateHs: {app} }}</p>\n    </div>\n    <p class=\"px-5\">{{'COMMON.or' | translateHs: {app} }}</p>\n    <label class=\"dropzone-label\">\n        <input #fileInput type=\"file\" [accept]=\"acceptedFormats\" [id]=\"uploader\" class=\"inputfile\"\n            (change)=\"emitHandleUpload($event.target.files, false)\" multiple>\n        <label [for]=\"uploader\" class=\"p-2 rounded d-flex align-items-center\"> <i class=\"icon-uploadalt pe-2\"></i>\n            {{'ADDLAYERS.Vector.chooseFiles' | translateHs: {app} }}</label>\n    </label>\n\n</div>\n", directives: [{ type: HsFileDropDirective, selector: "[fileDrop]", outputs: ["filesDropped", "filesHovered"] }, { type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUploadComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-file-upload', template: "<div class=\"d-flex justify-content-center align-items-center w-100 dropzone-container\">\n    <div class=\"dropzone p-4\" fileDrop (filesDropped)=\"emitHandleUpload($event, true)\"\n        (filesHovered)=\"dropZoneState($event)\" [ngClass]=\"{'active': dropzoneActive}\">\n        <p class=\"dropzone-label mt-2 text-primary\">{{'ADDLAYERS.Vector.dragAndDropFiles' | translateHs: {app} }}</p>\n    </div>\n    <p class=\"px-5\">{{'COMMON.or' | translateHs: {app} }}</p>\n    <label class=\"dropzone-label\">\n        <input #fileInput type=\"file\" [accept]=\"acceptedFormats\" [id]=\"uploader\" class=\"inputfile\"\n            (change)=\"emitHandleUpload($event.target.files, false)\" multiple>\n        <label [for]=\"uploader\" class=\"p-2 rounded d-flex align-items-center\"> <i class=\"icon-uploadalt pe-2\"></i>\n            {{'ADDLAYERS.Vector.chooseFiles' | translateHs: {app} }}</label>\n    </label>\n\n</div>\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { uploaded: [{
                type: Output
            }], acceptedFormats: [{
                type: Input
            }], uploader: [{
                type: Input
            }], app: [{
                type: Input
            }], fileInput: [{
                type: ViewChild,
                args: ['fileInput']
            }] } });

class HsAddDataVectorFileComponent {
    constructor(hsAddDataVectorService, hsAddDataCommonFileService, hsToastService, hsLanguageService, hsCommonEndpointsService, hsLayerManagerService, hsLayerUtilsService, hsLayoutService, hsUtilsService, hsConfig) {
        this.hsAddDataVectorService = hsAddDataVectorService;
        this.hsAddDataCommonFileService = hsAddDataCommonFileService;
        this.hsToastService = hsToastService;
        this.hsLanguageService = hsLanguageService;
        this.hsCommonEndpointsService = hsCommonEndpointsService;
        this.hsLayerManagerService = hsLayerManagerService;
        this.hsLayerUtilsService = hsLayerUtilsService;
        this.hsLayoutService = hsLayoutService;
        this.hsUtilsService = hsUtilsService;
        this.hsConfig = hsConfig;
        this.app = 'default';
        this.uploadType = 'new';
        this.access_rights = {
            'access_rights.write': 'private',
            'access_rights.read': 'EVERYONE',
        };
        this.ngUnsubscribe = new Subject();
    }
    ngAfterViewInit() {
        this.fileInput = this.hsUploadComponent.getFileInput();
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    ngOnInit() {
        this.commonFileServiceRef = this.hsAddDataCommonFileService.get(this.app);
        this.configRef = this.hsConfig.get(this.app);
        this.commonFileServiceRef.dataObjectChanged
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((data) => {
            this.data.showDetails = true;
            Object.assign(this.data, data);
            // this.clearInput();
        });
        this.getAcceptedFormats();
        this.setToDefault();
    }
    getAcceptedFormats() {
        switch (this.fileType) {
            case 'kml':
                this.acceptedFormats = '.kml';
                break;
            case 'gpx':
                this.acceptedFormats = '.gpx';
                break;
            default:
                this.acceptedFormats = '.geojson, .json';
                break;
        }
    }
    /**
     * Handler for adding non-wms service, file in template.
     */
    add() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.uploadType == 'new') {
                const response = yield this.hsAddDataVectorService.addNewLayer(this.data, this.app);
                if (response.complete) {
                    this.moveToLayerManager();
                }
            }
            else {
                yield this.updateExistingLayer();
                this.moveToLayerManager();
            }
        });
    }
    /**
     * After layer has successfully been added to the map, move to LM panel and clean up the code
     */
    moveToLayerManager() {
        this.hsLayoutService.setMainPanel('layermanager', this.app);
        this.hsAddDataVectorService.setPanelToCatalogue(this.app);
        this.setToDefault();
    }
    updateExistingLayer() {
        return __awaiter(this, void 0, void 0, function* () {
            let features = this.data.features.length > 0 ? this.data.features : [];
            if (this.fileType != 'geojson') {
                const nonJson = yield this.hsAddDataVectorService.convertUploadedData(this.fileInput.nativeElement.files[0], this.app);
                features = nonJson.features; //proper typing will get rid of this
            }
            this.hsLayerUtilsService.isLayerClustered(this.data.sourceLayer)
                ? this.data.sourceLayer.getSource()
                    .getSource()
                    .addFeatures(features)
                : this.data.sourceLayer.getSource().addFeatures(features);
        });
    }
    handleFileUpload(evt) {
        Array.from(evt.fileList).forEach((f) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            const uploadedData = yield this.hsAddDataVectorService.readUploadedFile(f, this.app);
            if (uploadedData !== undefined && !uploadedData.error) {
                uploadedData.url !== undefined
                    ? (this.data.base64url = uploadedData.url)
                    : ((this.data.url = undefined), (this.data.base64url = undefined));
                uploadedData.name !== undefined
                    ? (this.data.name = uploadedData.name)
                    : (this.data.name = '');
                uploadedData.title !== undefined
                    ? (this.data.title = uploadedData.title)
                    : (this.data.title = '');
                uploadedData.srs !== undefined
                    ? (this.data.srs = uploadedData.srs.getCode())
                    : (this.data.srs = 'EPSG:4326');
                uploadedData.abstract !== undefined
                    ? (this.data.abstract = uploadedData.abstract)
                    : (this.data.abstract = '');
                if (uploadedData.features !== undefined) {
                    this.data.features = uploadedData.features;
                    this.data.featureCount = uploadedData.features.length;
                }
                else {
                    this.data.features = [];
                    this.data.featureCount = 0;
                }
                if (uploadedData.nativeFeatures !== undefined) {
                    this.data.nativeFeatures = uploadedData.nativeFeatures;
                }
                if (uploadedData.nativeSRS !== undefined) {
                    this.data.nativeSRS = uploadedData.nativeSRS.getCode();
                }
                if (uploadedData.type !== undefined) {
                    this.data.type = uploadedData.type;
                }
                else {
                    this.data.type = this.fileType;
                }
                if (this.hsAddDataVectorService.isKml(this.data.type, this.data.url)) {
                    this.data.saveToLayman = false;
                    this.data.saveAvailable = false;
                }
                else {
                    this.data.saveAvailable = true;
                    this.data.saveToLayman =
                        (_a = this.hsCommonEndpointsService.endpoints.filter((ep) => ep.type == 'layman')[0]) === null || _a === void 0 ? void 0 : _a.authenticated;
                }
                //add layman endpoint url as url to allow sync
                if (this.hsUtilsService.undefineEmptyString(this.data.url) ===
                    undefined &&
                    this.data.saveToLayman) {
                    this.data.url = (_b = this.hsCommonEndpointsService.endpoints.filter((ep) => ep.type == 'layman')[0]) === null || _b === void 0 ? void 0 : _b.url;
                }
                this.data.showDetails = true;
            }
            else {
                this.setToDefault();
                this.hsToastService.createToastPopupMessage(this.hsLanguageService.getTranslation('ADDLAYERS.ERROR.someErrorHappened', undefined, this.app), this.hsLanguageService.getTranslationIgnoreNonExisting('ADDLAYERS', `${(_c = uploadedData === null || uploadedData === void 0 ? void 0 : uploadedData.error) !== null && _c !== void 0 ? _c : 'someErrorHappened'}`, undefined, this.app), { disableLocalization: true }, this.app);
            }
        }));
    }
    setUploadType(type) {
        this.uploadType = type;
        if (type == 'existing') {
            this.data.vectorLayers = this.hsLayerManagerService.apps[this.app].data.layers.filter((layer) => {
                return this.hsLayerUtilsService.isLayerVectorLayer(layer.layer);
            });
        }
    }
    setToDefault() {
        this.setDataToDefault();
        this.data.showDetails = false;
        this.uploadType = 'new';
        if (this.fileInput) {
            this.fileInput.nativeElement.value = '';
        }
    }
    /**
     * Reset data object to its default valuess
     */
    setDataToDefault() {
        this.data = {
            // Not possible to save KML to layman yet
            abstract: '',
            addUnder: null,
            base64url: '',
            extract_styles: false,
            featureCount: 0,
            features: [],
            nativeFeatures: [],
            folder_name: '',
            name: '',
            saveAvailable: false,
            saveToLayman: false,
            showDetails: false,
            srs: 'EPSG:4326',
            nativeSRS: undefined,
            title: '',
            type: this.fileType,
            url: undefined,
            sld: null,
            access_rights: {
                'access_rights.write': 'private',
                'access_rights.read': 'EVERYONE',
            },
            sourceLayer: null,
            vectorLayers: null,
        };
        this.hsAddDataCommonFileService.clearParams(this.app);
    }
}
HsAddDataVectorFileComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataVectorFileComponent, deps: [{ token: HsAddDataVectorService }, { token: HsAddDataCommonFileService }, { token: HsToastService }, { token: HsLanguageService }, { token: HsCommonEndpointsService }, { token: HsLayerManagerService }, { token: HsLayerUtilsService }, { token: HsLayoutService }, { token: HsUtilsService }, { token: HsConfig }], target: i0.ɵɵFactoryTarget.Component });
HsAddDataVectorFileComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsAddDataVectorFileComponent, selector: "hs-file-vector", inputs: { fileType: "fileType", app: "app" }, viewQueries: [{ propertyName: "hsUploadComponent", first: true, predicate: HsUploadComponent, descendants: true }], ngImport: i0, template: "<form class=\"form-horizontal\" role=\"form\">\n  <div class=\"form-group m-3\">\n    <hs-file-upload (uploaded)=\"handleFileUpload($event)\" [app]=\"app\" [uploader]=\"'hs-file-vector-'+app\"\n      [acceptedFormats]=\"acceptedFormats\">\n    </hs-file-upload>\n  </div>\n  <div *ngIf=\"data.showDetails\">\n    <div class=\"border-bottom d-flex flex-row justify-content-between\">\n      <p class=\"align-self-center m-0\">\n        {{hsLanguageService.getTranslationIgnoreNonExisting('ADDLAYERS.Vector','addingFiles',{featuresCount:data.featureCount},\n        app)}}\n      </p>\n      <ul class=\"nav nav-tabs justify-content-end\">\n        <li class=\"nav-item\">\n          <a class=\"nav-link text-secondary\" [ngClass]=\"{'active': uploadType === 'new'}\"\n            (click)=\"setUploadType('new')\">{{'LAYERS.newLayer' | translateHs: {app} }}</a>\n        </li>\n        <li class=\"nav-item\">\n          <a class=\"nav-link text-secondary\" [ngClass]=\"{'active': uploadType === 'existing'}\"\n            (click)=\"setUploadType('existing')\">{{'LAYERS.existingLayer' | translateHs: {app} }}</a>\n        </li>\n      </ul>\n    </div>\n    <div [hidden]=\"uploadType === 'new'\">\n      <div class=\"form-group my-3\">\n        <label class=\"capabilities_label control-label\">{{'LAYERS.existingLayer' | translateHs: {app} }}</label>\n        <select class=\"hsl-custom-select\" name=\"sourceLayer\" [(ngModel)]=\"data.sourceLayer\" style=\"flex-grow: 1;\">\n          <option [ngValue]=\"null\" [disabled]=\"true\" selected hidden> {{'ADDLAYERS.Vector.chooseLayer' |\n            translateHs: {app} }}</option>\n          <option *ngFor=\"let lyr of data.vectorLayers\" [ngValue]=\"lyr.layer\">{{ lyr.title }} </option>\n        </select>\n      </div>\n    </div>\n    <div [hidden]=\"uploadType === 'existing'\">\n      <hs-new-layer-form [data]=\"data\" [app]=\"app\"></hs-new-layer-form>\n    </div>\n    <button class=\"btn btn-primary w-100 mt-2\" [disabled]=\"uploadType === 'new' ? !data.title : !data.sourceLayer\"\n      (click)=\"add()\">\n      <i class=\"icon-plus\" [hidden]=\"commonFileServiceRef.loadingToLayman\"></i>\n      <img [src]=\"configRef._ajaxLoaderPath\" [hidden]=\"!commonFileServiceRef.loadingToLayman\" />\n      <span [hidden]=\"commonFileServiceRef.loadingToLayman\">{{'COMMON.add' | translateHs : {app} }}</span>\n      <span [hidden]=\"!commonFileServiceRef.loadingToLayman\">{{'COMMON.uploading' | translateHs : {app} }}</span>\n    </button>\n  </div>\n</form>", components: [{ type: HsUploadComponent, selector: "hs-file-upload", inputs: ["acceptedFormats", "uploader", "app"], outputs: ["uploaded"] }, { type: HsNewLayerFormComponent, selector: "hs-new-layer-form", inputs: ["data", "app"] }], directives: [{ type: i3$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i3$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i3$1.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3$1.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3$1.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i3$1.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataVectorFileComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-file-vector', template: "<form class=\"form-horizontal\" role=\"form\">\n  <div class=\"form-group m-3\">\n    <hs-file-upload (uploaded)=\"handleFileUpload($event)\" [app]=\"app\" [uploader]=\"'hs-file-vector-'+app\"\n      [acceptedFormats]=\"acceptedFormats\">\n    </hs-file-upload>\n  </div>\n  <div *ngIf=\"data.showDetails\">\n    <div class=\"border-bottom d-flex flex-row justify-content-between\">\n      <p class=\"align-self-center m-0\">\n        {{hsLanguageService.getTranslationIgnoreNonExisting('ADDLAYERS.Vector','addingFiles',{featuresCount:data.featureCount},\n        app)}}\n      </p>\n      <ul class=\"nav nav-tabs justify-content-end\">\n        <li class=\"nav-item\">\n          <a class=\"nav-link text-secondary\" [ngClass]=\"{'active': uploadType === 'new'}\"\n            (click)=\"setUploadType('new')\">{{'LAYERS.newLayer' | translateHs: {app} }}</a>\n        </li>\n        <li class=\"nav-item\">\n          <a class=\"nav-link text-secondary\" [ngClass]=\"{'active': uploadType === 'existing'}\"\n            (click)=\"setUploadType('existing')\">{{'LAYERS.existingLayer' | translateHs: {app} }}</a>\n        </li>\n      </ul>\n    </div>\n    <div [hidden]=\"uploadType === 'new'\">\n      <div class=\"form-group my-3\">\n        <label class=\"capabilities_label control-label\">{{'LAYERS.existingLayer' | translateHs: {app} }}</label>\n        <select class=\"hsl-custom-select\" name=\"sourceLayer\" [(ngModel)]=\"data.sourceLayer\" style=\"flex-grow: 1;\">\n          <option [ngValue]=\"null\" [disabled]=\"true\" selected hidden> {{'ADDLAYERS.Vector.chooseLayer' |\n            translateHs: {app} }}</option>\n          <option *ngFor=\"let lyr of data.vectorLayers\" [ngValue]=\"lyr.layer\">{{ lyr.title }} </option>\n        </select>\n      </div>\n    </div>\n    <div [hidden]=\"uploadType === 'existing'\">\n      <hs-new-layer-form [data]=\"data\" [app]=\"app\"></hs-new-layer-form>\n    </div>\n    <button class=\"btn btn-primary w-100 mt-2\" [disabled]=\"uploadType === 'new' ? !data.title : !data.sourceLayer\"\n      (click)=\"add()\">\n      <i class=\"icon-plus\" [hidden]=\"commonFileServiceRef.loadingToLayman\"></i>\n      <img [src]=\"configRef._ajaxLoaderPath\" [hidden]=\"!commonFileServiceRef.loadingToLayman\" />\n      <span [hidden]=\"commonFileServiceRef.loadingToLayman\">{{'COMMON.add' | translateHs : {app} }}</span>\n      <span [hidden]=\"!commonFileServiceRef.loadingToLayman\">{{'COMMON.uploading' | translateHs : {app} }}</span>\n    </button>\n  </div>\n</form>" }]
        }], ctorParameters: function () { return [{ type: HsAddDataVectorService }, { type: HsAddDataCommonFileService }, { type: HsToastService }, { type: HsLanguageService }, { type: HsCommonEndpointsService }, { type: HsLayerManagerService }, { type: HsLayerUtilsService }, { type: HsLayoutService }, { type: HsUtilsService }, { type: HsConfig }]; }, propDecorators: { fileType: [{
                type: Input
            }], app: [{
                type: Input
            }], hsUploadComponent: [{
                type: ViewChild,
                args: [HsUploadComponent]
            }] } });

class HsAddDataFileBaseComponent {
    constructor(hsAddDataCommonService, hsAddDataCommonFileService, hsLayoutService) {
        this.hsAddDataCommonService = hsAddDataCommonService;
        this.hsAddDataCommonFileService = hsAddDataCommonFileService;
        this.hsLayoutService = hsLayoutService;
        this.app = 'default';
        this.ngUnsubscribe = new Subject();
    }
    clearInput() {
        if (this.fileInput) {
            this.fileInput.nativeElement.value = '';
        }
    }
    ngAfterViewInit() {
        if (this.hsUploadComponent) {
            this.fileInput = this.hsUploadComponent.getFileInput();
        }
    }
    ngOnInit() {
        const commonFileServiceRef = this.hsAddDataCommonFileService.get(this.app);
        commonFileServiceRef.dataObjectChanged
            .pipe(takeUntil$1(this.ngUnsubscribe))
            .subscribe((data) => {
            this.hsAddDataCommonService.get(this.app).showDetails = true;
            Object.assign(this.data, data);
            this.clearInput();
        });
        commonFileServiceRef.layerAddedAsWms
            .pipe(takeUntil$1(this.ngUnsubscribe))
            .subscribe((success) => {
            if (success) {
                this.hsLayoutService.setMainPanel('layermanager', this.app);
                this.hsAddDataCommonService.setPanelToCatalogue(this.app);
            }
            this.setDataToDefault();
            this.clearInput();
        });
        this.setDataToDefault();
        this.hsAddDataCommonFileService.pickEndpoint(this.app);
    }
    /**
     * Reset data object to its default values
     */
    setDataToDefault() {
        this.data = {
            abstract: '',
            access_rights: {
                'access_rights.write': 'private',
                'access_rights.read': 'EVERYONE',
            },
            addUnder: null,
            extract_styles: false,
            files: [],
            folder_name: '',
            name: '',
            saveAvailable: true,
            saveToLayman: true,
            sld: null,
            srs: null,
            title: '',
            type: this.baseFileType,
        };
        this.hsAddDataCommonFileService.clearParams(this.app);
        this.hsAddDataCommonService.clearParams(this.app);
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
}
HsAddDataFileBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataFileBaseComponent, deps: [{ token: HsAddDataCommonService }, { token: HsAddDataCommonFileService }, { token: HsLayoutService }], target: i0.ɵɵFactoryTarget.Component });
HsAddDataFileBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsAddDataFileBaseComponent, selector: "ng-component", inputs: { app: "app" }, viewQueries: [{ propertyName: "hsUploadComponent", first: true, predicate: HsUploadComponent, descendants: true }], ngImport: i0, template: '<div></div>', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataFileBaseComponent, decorators: [{
            type: Component,
            args: [{
                    template: '<div></div>',
                }]
        }], ctorParameters: function () { return [{ type: HsAddDataCommonService }, { type: HsAddDataCommonFileService }, { type: HsLayoutService }]; }, propDecorators: { app: [{
                type: Input
            }], hsUploadComponent: [{
                type: ViewChild,
                args: [HsUploadComponent]
            }] } });

class HsLaymanLoginComponent {
    constructor(HsCommonLaymanService, HsDialogContainerService, sanitizer) {
        this.HsCommonLaymanService = HsCommonLaymanService;
        this.HsDialogContainerService = HsDialogContainerService;
        this.sanitizer = sanitizer;
        this.authChangeSubscription =
            this.HsCommonLaymanService.authChange.subscribe(() => {
                this.close();
            });
    }
    ngOnDestroy() {
        this.authChangeSubscription.unsubscribe();
    }
    ngOnInit() {
        this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.data.url);
    }
    close() {
        this.HsDialogContainerService.destroy(this, this.data.app);
    }
}
HsLaymanLoginComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLaymanLoginComponent, deps: [{ token: HsCommonLaymanService }, { token: HsDialogContainerService }, { token: i1$3.DomSanitizer }], target: i0.ɵɵFactoryTarget.Component });
HsLaymanLoginComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsLaymanLoginComponent, selector: "hs-layman-login", inputs: { data: "data" }, ngImport: i0, template: "<div class=\"modal in\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n    <div class=\"modal-dialog modal-lg\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h4 class=\"modal-title\">\n                    {{'COMMON.Login' | translateHs : {app: data.app} }}\n                </h4>\n                <button type=\"button\" (click)=\"close()\" class=\"btn-close\" data-dismiss=\"modal\"\n                    attr.aria-label=\"{{'COMMON.close' | translateHs : {app: data.app} }}\"></button>\n            </div>\n            <div class=\"modal-body\" style=\"max-height:600px; height: 35em; overflow-y:auto\">\n                <iframe [src]=\"url\" style=\"width:100%; height:100%;border:0\"></iframe>\n            </div>\n        </div>\n    </div>\n</div>", pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLaymanLoginComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-layman-login', template: "<div class=\"modal in\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n    <div class=\"modal-dialog modal-lg\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h4 class=\"modal-title\">\n                    {{'COMMON.Login' | translateHs : {app: data.app} }}\n                </h4>\n                <button type=\"button\" (click)=\"close()\" class=\"btn-close\" data-dismiss=\"modal\"\n                    attr.aria-label=\"{{'COMMON.close' | translateHs : {app: data.app} }}\"></button>\n            </div>\n            <div class=\"modal-body\" style=\"max-height:600px; height: 35em; overflow-y:auto\">\n                <iframe [src]=\"url\" style=\"width:100%; height:100%;border:0\"></iframe>\n            </div>\n        </div>\n    </div>\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsCommonLaymanService }, { type: HsDialogContainerService }, { type: i1$3.DomSanitizer }]; }, propDecorators: { data: [{
                type: Input
            }] } });

class HsLaymanCurrentUserComponent {
    constructor(hsLaymanService, HsCommonLaymanService, HsDialogContainerService) {
        this.hsLaymanService = hsLaymanService;
        this.HsCommonLaymanService = HsCommonLaymanService;
        this.HsDialogContainerService = HsDialogContainerService;
        this.app = 'default';
        this.monitorTries = 0;
        this.DEFAULT_TIMER_INTERVAL = 2000;
        this.MAX_MONITOR_TRIES = 100;
        this.timerInterval = this.DEFAULT_TIMER_INTERVAL;
    }
    ngOnInit() {
        if (!this.endpoint) {
            this.endpoint = this.hsLaymanService.getLaymanEndpoint();
        }
    }
    isGuest() {
        return this.endpoint.user == 'anonymous' || this.endpoint.user == 'browser';
    }
    logout() {
        this.monitorUser();
        this.HsCommonLaymanService.logout(this.endpoint, this.app);
    }
    sameDomain() {
        const endpointUrl = new URL(this.endpoint.url);
        return (location.protocol == endpointUrl.protocol &&
            location.host == endpointUrl.host);
    }
    authUrl() {
        return this.endpoint.url + '/login';
    }
    /**
     * Periodically poll layman client endpoint for auth change.
     * This is used for hiding login iframe and toggling state for login buttons,
     * which is done in separate modules by subscribing to HsCommonLaymanService.authChange
     */
    monitorUser() {
        if (this.getCurrentUserTimer) {
            clearTimeout(this.getCurrentUserTimer);
        }
        this.monitorTries = 0;
        this.timerInterval = this.DEFAULT_TIMER_INTERVAL;
        const poll = () => {
            this.HsCommonLaymanService.detectAuthChange(this.endpoint, this.app).then((somethingChanged) => {
                if (somethingChanged && this.getCurrentUserTimer) {
                    clearTimeout(this.getCurrentUserTimer);
                    this.monitorTries = this.MAX_MONITOR_TRIES;
                }
            });
            this.monitorTries++;
            if (this.monitorTries > this.MAX_MONITOR_TRIES) {
                clearTimeout(this.getCurrentUserTimer);
            }
            this.getCurrentUserTimer = setTimeout(poll, this.timerInterval);
        };
        this.getCurrentUserTimer = setTimeout(poll, this.timerInterval);
    }
    login() {
        this.monitorUser();
        if (!this.sameDomain()) {
            return;
        }
        this.HsDialogContainerService.create(HsLaymanLoginComponent, { url: this.authUrl() }, this.app);
    }
}
HsLaymanCurrentUserComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLaymanCurrentUserComponent, deps: [{ token: HsLaymanService }, { token: HsCommonLaymanService }, { token: HsDialogContainerService }], target: i0.ɵɵFactoryTarget.Component });
HsLaymanCurrentUserComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsLaymanCurrentUserComponent, selector: "hs-layman-current-user", inputs: { app: "app", endpoint: "endpoint" }, ngImport: i0, template: "<div *ngIf=\"endpoint\" style=\"margin-left: 1em; float: right; \">\n    <a class=\"btn btn-primary\" style=\"border-radius: 0.25rem; color: #fff;\" (click)=\"login();\"\n        *ngIf=\"isGuest() && sameDomain()\"> <!-- TODO: Remove function call from template -->\n        {{'COMPOSITIONS.loginToCatalogue' | translateHs : {app} }}</a>\n    <a class=\"btn btn-primary\" style=\"border-radius: 0.25rem; color: #fff;\" (click)=\"login();\"\n        *ngIf=\"isGuest() && !sameDomain()\" href=\"{{authUrl()}}\" target=\"_blank\"><!-- TODO: Remove function call from template -->\n        {{'COMPOSITIONS.loginToCatalogue' | translateHs : {app} }}</a>\n    <a class=\"btn btn-primary text-truncate\"\n        style=\"border-radius: 0.25rem; color: #fff; max-width:25ch; white-space:nowrap\" (click)=\"logout()\"\n        *ngIf=\"!isGuest()\">{{'COMMON.Logout' | translateHs : {app} }} \n        {{endpoint.user}}</a><!-- TODO: Remove function call from template -->\n</div>\n", directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLaymanCurrentUserComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-layman-current-user', template: "<div *ngIf=\"endpoint\" style=\"margin-left: 1em; float: right; \">\n    <a class=\"btn btn-primary\" style=\"border-radius: 0.25rem; color: #fff;\" (click)=\"login();\"\n        *ngIf=\"isGuest() && sameDomain()\"> <!-- TODO: Remove function call from template -->\n        {{'COMPOSITIONS.loginToCatalogue' | translateHs : {app} }}</a>\n    <a class=\"btn btn-primary\" style=\"border-radius: 0.25rem; color: #fff;\" (click)=\"login();\"\n        *ngIf=\"isGuest() && !sameDomain()\" href=\"{{authUrl()}}\" target=\"_blank\"><!-- TODO: Remove function call from template -->\n        {{'COMPOSITIONS.loginToCatalogue' | translateHs : {app} }}</a>\n    <a class=\"btn btn-primary text-truncate\"\n        style=\"border-radius: 0.25rem; color: #fff; max-width:25ch; white-space:nowrap\" (click)=\"logout()\"\n        *ngIf=\"!isGuest()\">{{'COMMON.Logout' | translateHs : {app} }} \n        {{endpoint.user}}</a><!-- TODO: Remove function call from template -->\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: HsLaymanService }, { type: HsCommonLaymanService }, { type: HsDialogContainerService }]; }, propDecorators: { app: [{
                type: Input
            }], endpoint: [{
                type: Input
            }] } });

class HsAddLayerAuthorizedComponent {
    constructor(hsAddDataCommonFileService, hsLaymanService, hsConfig) {
        this.hsAddDataCommonFileService = hsAddDataCommonFileService;
        this.hsLaymanService = hsLaymanService;
        this.hsConfig = hsConfig;
        this.app = 'default';
    }
    ngOnInit() {
        this.commonFileServiceRef = this.hsAddDataCommonFileService.get(this.app);
        this.configRef = this.hsConfig.get(this.app);
    }
    addAsWms() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.hsAddDataCommonFileService.addAsWms(this.data, this.app);
        });
    }
}
HsAddLayerAuthorizedComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddLayerAuthorizedComponent, deps: [{ token: HsAddDataCommonFileService }, { token: HsLaymanService }, { token: HsConfig }], target: i0.ɵɵFactoryTarget.Component });
HsAddLayerAuthorizedComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsAddLayerAuthorizedComponent, selector: "hs-add-layer-authorized", inputs: { data: "data", app: "app" }, ngImport: i0, template: "<div class=\"w-100 mt-2\" style=\"display: inline-block;\" data-toggle=\"tooltip\" data-placement=\"top\"\n  title=\"{{hsAddDataCommonFileService.getToolTipText(data, app)}}\">\n  <!-- TODO: Remove function call from template -->\n  <button *ngIf=\"hsAddDataCommonFileService.isAuthorized()\" class=\"btn btn-primary w-100\"\n    [disabled]=\"!data.name || !data.srs\" (click)=\"addAsWms()\">\n    <i class=\"icon-plus\" [hidden]=\"commonFileServiceRef.loadingToLayman\"></i>\n    <img [src]=\"configRef._ajaxLoaderPath\" [hidden]=\"!commonFileServiceRef.loadingToLayman\" />\n    <span [hidden]=\"commonFileServiceRef.loadingToLayman\">{{'COMMON.add' | translateHs : {app} }}</span>\n    <span *ngIf=\"commonFileServiceRef.loadingToLayman && commonFileServiceRef.asyncLoading\">{{'COMMON.uploading' |\n      translateHs : {app} }}</span>\n    <span *ngIf=\"commonFileServiceRef.loadingToLayman && commonFileServiceRef.readingData\">{{'COMMON.reading' |\n      translateHs : {app} }}</span>\n    <ngb-progressbar\n      *ngIf=\"commonFileServiceRef.loadingToLayman && (commonFileServiceRef.asyncLoading || commonFileServiceRef.readingData)\"\n      showValue=\"true\" class=\"rounded-0 mb-1\" type=\"secondary\" [max]=\"1\" [value]=\"hsLaymanService.totalProgress\">\n    </ngb-progressbar>\n  </button>\n</div>\n<div *ngIf=\"!hsAddDataCommonFileService.isAuthorized()\"\n  class=\"alert alert-warning d-flex align-items-center mt-2 justify-content-between\">\n  <!-- TODO: Remove function call from template -->\n  <p class=\"m-0\"> {{'ADDLAYERS.SHP.loginRequired' | translateHs : {app} }}</p>\n  <hs-layman-current-user [app]=\"app\"></hs-layman-current-user>\n</div>\n", components: [{ type: i7.NgbProgressbar, selector: "ngb-progressbar", inputs: ["max", "animated", "striped", "showValue", "textType", "type", "value", "height"] }, { type: HsLaymanCurrentUserComponent, selector: "hs-layman-current-user", inputs: ["app", "endpoint"] }], directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddLayerAuthorizedComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-add-layer-authorized', template: "<div class=\"w-100 mt-2\" style=\"display: inline-block;\" data-toggle=\"tooltip\" data-placement=\"top\"\n  title=\"{{hsAddDataCommonFileService.getToolTipText(data, app)}}\">\n  <!-- TODO: Remove function call from template -->\n  <button *ngIf=\"hsAddDataCommonFileService.isAuthorized()\" class=\"btn btn-primary w-100\"\n    [disabled]=\"!data.name || !data.srs\" (click)=\"addAsWms()\">\n    <i class=\"icon-plus\" [hidden]=\"commonFileServiceRef.loadingToLayman\"></i>\n    <img [src]=\"configRef._ajaxLoaderPath\" [hidden]=\"!commonFileServiceRef.loadingToLayman\" />\n    <span [hidden]=\"commonFileServiceRef.loadingToLayman\">{{'COMMON.add' | translateHs : {app} }}</span>\n    <span *ngIf=\"commonFileServiceRef.loadingToLayman && commonFileServiceRef.asyncLoading\">{{'COMMON.uploading' |\n      translateHs : {app} }}</span>\n    <span *ngIf=\"commonFileServiceRef.loadingToLayman && commonFileServiceRef.readingData\">{{'COMMON.reading' |\n      translateHs : {app} }}</span>\n    <ngb-progressbar\n      *ngIf=\"commonFileServiceRef.loadingToLayman && (commonFileServiceRef.asyncLoading || commonFileServiceRef.readingData)\"\n      showValue=\"true\" class=\"rounded-0 mb-1\" type=\"secondary\" [max]=\"1\" [value]=\"hsLaymanService.totalProgress\">\n    </ngb-progressbar>\n  </button>\n</div>\n<div *ngIf=\"!hsAddDataCommonFileService.isAuthorized()\"\n  class=\"alert alert-warning d-flex align-items-center mt-2 justify-content-between\">\n  <!-- TODO: Remove function call from template -->\n  <p class=\"m-0\"> {{'ADDLAYERS.SHP.loginRequired' | translateHs : {app} }}</p>\n  <hs-layman-current-user [app]=\"app\"></hs-layman-current-user>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: HsAddDataCommonFileService }, { type: HsLaymanService }, { type: HsConfig }]; }, propDecorators: { data: [{
                type: Input
            }], app: [{
                type: Input
            }] } });

class HsFileShpComponent extends HsAddDataFileBaseComponent {
    constructor(hsFileService, hsAddDataCommonService, hsAddDataCommonFileService, hsLayoutService) {
        super(hsAddDataCommonService, hsAddDataCommonFileService, hsLayoutService);
        this.hsFileService = hsFileService;
        this.hsAddDataCommonService = hsAddDataCommonService;
        this.hsAddDataCommonFileService = hsAddDataCommonFileService;
        this.hsLayoutService = hsLayoutService;
        this.fileType = 'shp';
    }
    ngAfterViewInit() {
        this.fileInput = this.hsUploadComponent.getFileInput();
    }
    ngOnInit() {
        this.acceptedFormats = '.shp, .shx, .dbf, .sbn, .zip';
        this.baseFileType = this.fileType;
        super.ngOnInit();
    }
    handleFileUpload(evt, app) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.hsFileService.read(evt, app);
        });
    }
}
HsFileShpComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsFileShpComponent, deps: [{ token: HsFileService }, { token: HsAddDataCommonService }, { token: HsAddDataCommonFileService }, { token: HsLayoutService }], target: i0.ɵɵFactoryTarget.Component });
HsFileShpComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsFileShpComponent, selector: "hs-file-shp", usesInheritance: true, ngImport: i0, template: "<form class=\"form-horizontal m-3\" role=\"form\">\n    <div class=\"form-group justify-content-center\">\n        <hs-file-upload (uploaded)=\"handleFileUpload($event,app)\" [app]=\"app\" [acceptedFormats]=\"acceptedFormats\"\n            [uploader]=\"'shpdbfshx-'+app\">\n        </hs-file-upload>\n    </div>\n    <div *ngIf=\"data.files?.length === 0\"\n        class=\"alert alert-warning d-flex align-items-center mt-2 justify-content-between\">\n        <p class=\"m-0\"> {{'ADDLAYERS.SHP.neededFiles' | translateHs : {app} }}</p>\n    </div>\n    <div *ngIf=\"hsAddDataCommonService.get(app).showDetails\">\n        <div class=\"d-flex flex-row justify-content-around\">\n            <div class=\"d-flex flex-column justify-content-center\">\n                <p class=\"p-2 bg-success rounded\" style=\"color: white;\"> {{data.files.length}}\n                    {{'ADDLAYERS.filesSelected' | translateHs: {app} }}</p>\n            </div>\n            <div class=\"d-flex flex-column mw-75\">\n                <p *ngFor=\"let file of data.files\">{{file.name}}</p>\n            </div>\n        </div>\n        <hs-new-layer-form [data]=\"data\" [app]=\"app\"></hs-new-layer-form>\n        <hs-add-layer-authorized [data]=\"data\" [app]=\"app\"></hs-add-layer-authorized>\n    </div>\n</form>", components: [{ type: HsUploadComponent, selector: "hs-file-upload", inputs: ["acceptedFormats", "uploader", "app"], outputs: ["uploaded"] }, { type: HsNewLayerFormComponent, selector: "hs-new-layer-form", inputs: ["data", "app"] }, { type: HsAddLayerAuthorizedComponent, selector: "hs-add-layer-authorized", inputs: ["data", "app"] }], directives: [{ type: i3$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i3$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i3$1.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsFileShpComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-file-shp', template: "<form class=\"form-horizontal m-3\" role=\"form\">\n    <div class=\"form-group justify-content-center\">\n        <hs-file-upload (uploaded)=\"handleFileUpload($event,app)\" [app]=\"app\" [acceptedFormats]=\"acceptedFormats\"\n            [uploader]=\"'shpdbfshx-'+app\">\n        </hs-file-upload>\n    </div>\n    <div *ngIf=\"data.files?.length === 0\"\n        class=\"alert alert-warning d-flex align-items-center mt-2 justify-content-between\">\n        <p class=\"m-0\"> {{'ADDLAYERS.SHP.neededFiles' | translateHs : {app} }}</p>\n    </div>\n    <div *ngIf=\"hsAddDataCommonService.get(app).showDetails\">\n        <div class=\"d-flex flex-row justify-content-around\">\n            <div class=\"d-flex flex-column justify-content-center\">\n                <p class=\"p-2 bg-success rounded\" style=\"color: white;\"> {{data.files.length}}\n                    {{'ADDLAYERS.filesSelected' | translateHs: {app} }}</p>\n            </div>\n            <div class=\"d-flex flex-column mw-75\">\n                <p *ngFor=\"let file of data.files\">{{file.name}}</p>\n            </div>\n        </div>\n        <hs-new-layer-form [data]=\"data\" [app]=\"app\"></hs-new-layer-form>\n        <hs-add-layer-authorized [data]=\"data\" [app]=\"app\"></hs-add-layer-authorized>\n    </div>\n</form>" }]
        }], ctorParameters: function () { return [{ type: HsFileService }, { type: HsAddDataCommonService }, { type: HsAddDataCommonFileService }, { type: HsLayoutService }]; } });

class HsFileRasterComponent extends HsAddDataFileBaseComponent {
    constructor(hsFileService, hsAddDataCommonService, hsAddDataCommonFileService, hsLayoutService) {
        super(hsAddDataCommonService, hsAddDataCommonFileService, hsLayoutService);
        this.hsFileService = hsFileService;
        this.hsAddDataCommonService = hsAddDataCommonService;
        this.hsAddDataCommonFileService = hsAddDataCommonFileService;
        this.hsLayoutService = hsLayoutService;
        this.fileType = 'raster';
    }
    ngOnInit() {
        this.baseFileType = this.fileType;
        this.acceptedFormats =
            '.tif, .tifw, .tiff, .tiffw, .gtiff, .gtiffw, .tfw, .png, .pngw, .pgw, .png.aux.xml, .jpg, .jpgw, .jgw, .jpg.aux.xml, .jp2, .jp2w, .j2w, .zip, .wld';
        super.ngOnInit();
    }
    handleFileUpload(evt) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.hsFileService.read(evt, this.app);
        });
    }
}
HsFileRasterComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsFileRasterComponent, deps: [{ token: HsFileService }, { token: HsAddDataCommonService }, { token: HsAddDataCommonFileService }, { token: HsLayoutService }], target: i0.ɵɵFactoryTarget.Component });
HsFileRasterComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsFileRasterComponent, selector: "hs-file-raster", usesInheritance: true, ngImport: i0, template: "<form class=\"form-horizontal\" role=\"form\" name=\"frmRaster\">\n  <div class=\"form-group m-3\">\n    <hs-file-upload (uploaded)=\"handleFileUpload($event)\" [app]=\"app\" [uploader]=\"'hs-file-raster-'+app\"\n      [acceptedFormats]=\"acceptedFormats\">\n    </hs-file-upload>\n  </div>\n  <div *ngIf=\"hsAddDataCommonService.get(app).showDetails\">\n    <div class=\"d-flex flex-row justify-content-around\">\n      <div class=\"d-flex flex-column justify-content-center\">\n        <p class=\"p-2 bg-success rounded\" style=\"color: white;\"> {{data.files.length}}\n          {{'ADDLAYERS.filesSelected' | translateHs: {app} }}</p>\n      </div>\n      <div class=\"d-flex flex-column mw-75\">\n        <p *ngFor=\"let file of data.files\">{{file.name}}</p>\n      </div>\n    </div>\n    <hs-new-layer-form [data]=\"data\" [app]=\"app\"></hs-new-layer-form>\n    <hs-add-layer-authorized [data]=\"data\" [app]=\"app\"></hs-add-layer-authorized>\n  </div>\n</form>\n", components: [{ type: HsUploadComponent, selector: "hs-file-upload", inputs: ["acceptedFormats", "uploader", "app"], outputs: ["uploaded"] }, { type: HsNewLayerFormComponent, selector: "hs-new-layer-form", inputs: ["data", "app"] }, { type: HsAddLayerAuthorizedComponent, selector: "hs-add-layer-authorized", inputs: ["data", "app"] }], directives: [{ type: i3$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i3$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i3$1.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsFileRasterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-file-raster', template: "<form class=\"form-horizontal\" role=\"form\" name=\"frmRaster\">\n  <div class=\"form-group m-3\">\n    <hs-file-upload (uploaded)=\"handleFileUpload($event)\" [app]=\"app\" [uploader]=\"'hs-file-raster-'+app\"\n      [acceptedFormats]=\"acceptedFormats\">\n    </hs-file-upload>\n  </div>\n  <div *ngIf=\"hsAddDataCommonService.get(app).showDetails\">\n    <div class=\"d-flex flex-row justify-content-around\">\n      <div class=\"d-flex flex-column justify-content-center\">\n        <p class=\"p-2 bg-success rounded\" style=\"color: white;\"> {{data.files.length}}\n          {{'ADDLAYERS.filesSelected' | translateHs: {app} }}</p>\n      </div>\n      <div class=\"d-flex flex-column mw-75\">\n        <p *ngFor=\"let file of data.files\">{{file.name}}</p>\n      </div>\n    </div>\n    <hs-new-layer-form [data]=\"data\" [app]=\"app\"></hs-new-layer-form>\n    <hs-add-layer-authorized [data]=\"data\" [app]=\"app\"></hs-add-layer-authorized>\n  </div>\n</form>\n" }]
        }], ctorParameters: function () { return [{ type: HsFileService }, { type: HsAddDataCommonService }, { type: HsAddDataCommonFileService }, { type: HsLayoutService }]; } });

// import {HsDragDropLayerService} from './drag-drop-layer.service';
class HsAddDataFileComponent {
    constructor(hsConfig, hsLanguageService) {
        this.hsConfig = hsConfig;
        this.hsLanguageService = hsLanguageService;
        this.app = 'default';
        if (Array.isArray(this.hsConfig.get(this.app).uploadTypes)) {
            this.types = this.hsConfig
                .get(this.app)
                .uploadTypes.filter((type) => filesSupported.includes(type))
                .map((type) => AddDataFileValues.find((v) => v.id == type));
        }
        else {
            this.types = AddDataFileValues;
        }
    }
    selectType(type) {
        this.typeSelected = type;
    }
    //Not being used
    isVectorType() {
        return (this.typeSelected == 'kml' ||
            this.typeSelected == 'gpx' ||
            this.typeSelected == 'geojson');
    }
}
HsAddDataFileComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataFileComponent, deps: [{ token: HsConfig }, { token: HsLanguageService }], target: i0.ɵɵFactoryTarget.Component });
HsAddDataFileComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsAddDataFileComponent, selector: "hs-add-data-file", inputs: { app: "app" }, ngImport: i0, template: "<div class=\"d-flex justify-content-center flex-column align-items-center m-3\">\n    <div class=\"container \">\n        <div class=\"row justify-content-center\">\n            <button *ngFor=\"let type of types\" [ngClass]=\"{'active': type.id === typeSelected }\"\n                (click)=\"selectType(type.id)\" style=\"margin: 3px;\"\n                class=\"btn btn-light btn-outline-secondary rounded btn-sm mt-1 col-sm-3\">\n                {{hsLanguageService.getTranslationIgnoreNonExisting('ADDLAYERS', type.text, undefined, app)}}\n                <!-- TODO: Remove function call from template -->\n            </button>\n        </div>\n    </div>\n    <div class=\"w-100 pt-3\">\n        <hs-file-vector [fileType]=\"typeSelected\" *ngIf=\"typeSelected === 'geojson'\" [app]=\"app\"></hs-file-vector>\n        <hs-file-vector [fileType]=\"typeSelected\" *ngIf=\"typeSelected === 'gpx'\" [app]=\"app\"></hs-file-vector>\n        <hs-file-vector [fileType]=\"typeSelected\" *ngIf=\"typeSelected === 'kml'\" [app]=\"app\"></hs-file-vector>\n        <hs-file-shp *ngIf=\"typeSelected === 'shp'\" [app]=\"app\"></hs-file-shp>\n        <hs-file-raster *ngIf=\"typeSelected === 'raster'\" [app]=\"app\"></hs-file-raster>\n    </div>\n</div>", components: [{ type: HsAddDataVectorFileComponent, selector: "hs-file-vector", inputs: ["fileType", "app"] }, { type: HsFileShpComponent, selector: "hs-file-shp" }, { type: HsFileRasterComponent, selector: "hs-file-raster" }], directives: [{ type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataFileComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-add-data-file', template: "<div class=\"d-flex justify-content-center flex-column align-items-center m-3\">\n    <div class=\"container \">\n        <div class=\"row justify-content-center\">\n            <button *ngFor=\"let type of types\" [ngClass]=\"{'active': type.id === typeSelected }\"\n                (click)=\"selectType(type.id)\" style=\"margin: 3px;\"\n                class=\"btn btn-light btn-outline-secondary rounded btn-sm mt-1 col-sm-3\">\n                {{hsLanguageService.getTranslationIgnoreNonExisting('ADDLAYERS', type.text, undefined, app)}}\n                <!-- TODO: Remove function call from template -->\n            </button>\n        </div>\n    </div>\n    <div class=\"w-100 pt-3\">\n        <hs-file-vector [fileType]=\"typeSelected\" *ngIf=\"typeSelected === 'geojson'\" [app]=\"app\"></hs-file-vector>\n        <hs-file-vector [fileType]=\"typeSelected\" *ngIf=\"typeSelected === 'gpx'\" [app]=\"app\"></hs-file-vector>\n        <hs-file-vector [fileType]=\"typeSelected\" *ngIf=\"typeSelected === 'kml'\" [app]=\"app\"></hs-file-vector>\n        <hs-file-shp *ngIf=\"typeSelected === 'shp'\" [app]=\"app\"></hs-file-shp>\n        <hs-file-raster *ngIf=\"typeSelected === 'raster'\" [app]=\"app\"></hs-file-raster>\n    </div>\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsConfig }, { type: HsLanguageService }]; }, propDecorators: { app: [{
                type: Input
            }] } });

class HsMickaBrowserService {
    constructor(http, log, hsMapService, hsUtilsService, hsToastService, hsLanguageService) {
        this.http = http;
        this.log = log;
        this.hsMapService = hsMapService;
        this.hsUtilsService = hsUtilsService;
        this.hsToastService = hsToastService;
        this.hsLanguageService = hsLanguageService;
    }
    /**
     * @param dataset - Configuration of selected datasource (from app config)
     * @param data - Query properties
     * @param extentFeatureCreated - Function which gets called
     * @param textField - Name of the field to search in
     * extent feature is created. Has one parameter: feature
     * Loads datasets metadata from selected source (CSW server).
     * Currently supports only "Micka" type of source.
     * Use all query params (search text, bbox, params.., sorting, start)
     * @returns
     */
    queryCatalog(dataset, data, extentFeatureCreated, textField, app) {
        const url = this.createRequestUrl(dataset, data, textField, app);
        dataset.datasourcePaging.loaded = false;
        dataset.httpCall = this.http
            .get(url, {
            responseType: 'json',
        })
            .pipe(timeout$1(5000), map$1((x) => {
            x.dataset = dataset;
            x.extentFeatureCreated = extentFeatureCreated;
            this.datasetsReceived(x, app);
            return x;
        }), catchError$1((e) => {
            var _a, _b, _c;
            if (isErrorHandlerFunction((_a = dataset.onError) === null || _a === void 0 ? void 0 : _a.compositionLoad)) {
                (_b = dataset.onError) === null || _b === void 0 ? void 0 : _b.compositionLoad.handle(dataset, e);
                return of(e);
            }
            switch ((_c = dataset.onError) === null || _c === void 0 ? void 0 : _c.compositionLoad) {
                case EndpointErrorHandling.ignore:
                    break;
                case EndpointErrorHandling.toast:
                default:
                    this.hsToastService.createToastPopupMessage(this.hsLanguageService.getTranslation('ADDLAYERS.ERROR.errorWhileRequestingLayers', undefined, app), dataset.title +
                        ': ' +
                        this.hsLanguageService.getTranslationIgnoreNonExisting('ERRORMESSAGES', e.status ? e.status.toString() : e.message, { url }, app), {
                        disableLocalization: true,
                        serviceCalledFrom: 'HsMickaBrowserService',
                    }, app);
            }
            dataset.datasourcePaging.loaded = true;
            return of(e);
        }));
        // .subscribe(()=>{console.log('sub')});
        return dataset.httpCall;
    }
    createRequestUrl(dataset, data, textField, app) {
        const query = data.query;
        const b = transformExtent(this.hsMapService
            .getMap(app)
            .getView()
            .calculateExtent(this.hsMapService.getMap(app).getSize()), this.hsMapService.getMap(app).getView().getProjection(), 'EPSG:4326');
        const bbox = data.filterByExtent ? "BBOX='" + b.join(' ') + "'" : '';
        const sortBy = query.sortby !== undefined && query.sortby != ''
            ? query.sortby == 'date'
                ? 'date:D'
                : query.sortby
            : 'date:D';
        const text = query.textFilter !== undefined && query.textFilter.length > 0
            ? query.textFilter
            : query.title;
        const sql = [
            // 'validservice>0',
            text != '' ? `${textField} like '*${text}*'` : '',
            bbox,
            //param2Query('type'),
            this.param2Query('ServiceType', query),
            // this.param2Query('topicCategory', query),
            // this.param2Query('Subject', query),
            // this.param2Query('Denominator', query),
            // this.param2Query('OrganisationName', query),
            // this.param2Query('keywords', query),
        ]
            .filter((n) => {
            return n != '';
        })
            .join(' AND ');
        const url = dataset.url +
            '?' +
            this.hsUtilsService.paramsToURL({
                request: 'GetRecords',
                format: 'application/json',
                language: dataset.language,
                query: sql,
                sortby: sortBy,
                limit: dataset.datasourcePaging.limit,
                start: dataset.datasourcePaging.start,
                validservice: '>0',
            });
        return this.hsUtilsService.proxify(url, app);
    }
    /**
     * @param data - HTTP response containing all the layers
     * Callback for catalogue http query
     */
    datasetsReceived(data, app) {
        if (!data.dataset || !data.extentFeatureCreated) {
            return;
        }
        const dataset = data.dataset;
        dataset.loading = false;
        dataset.layers = [];
        dataset.datasourcePaging.loaded = true;
        if (data.records.length == 0) {
            dataset.datasourcePaging.matched = 0;
            return false;
        }
        else {
            dataset.datasourcePaging.matched = data.matched;
            dataset.datasourcePaging.next = data.next;
            for (const lyr of data.records) {
                dataset.layers.push(lyr);
                if (data.extentFeatureCreated) {
                    const extentFeature = addExtentFeature(lyr, this.hsMapService.getCurrentProj(app));
                    if (extentFeature) {
                        lyr.featureId = extentFeature.getId();
                        data.extentFeatureCreated(extentFeature);
                    }
                }
            }
            return true;
        }
    }
    /**
     * @param which - Parameter name to parse
     * @param query -
     * @returns
     * Parse query parameter into encoded key value pair.
     */
    param2Query(which, query) {
        const dataset = 'type=dataset OR type=series OR type=tile';
        if (query[which] !== undefined) {
            if (which == 'type' && query[which] == 'data') {
                //Special case for type 'data' because it can contain many things
                return `(${dataset})`;
            }
            return query[which] != '' ? which + "='" + query[which] + "'" : '';
        }
        else {
            if (which == 'ServiceType') {
                const service = 'type=service';
                switch (query.type) {
                    case 'service':
                        return `(${service})`;
                    case 'dataset':
                        return `(${dataset})`;
                    case 'all':
                    default:
                        return `(${service} OR ${dataset})`;
                }
            }
            else {
                return '';
            }
        }
    }
    /**
     * @param type -
     * @param layer - Micka layer for which to get metadata
     * @param type - Optional service type specification
     * @returns Url of service or resource
     * Get first link from records links array or link
     * property of record in older Micka versions
     * in a common format for use in add-layers component
     */
    getLayerLink(layer, type) {
        var _a;
        if (((_a = layer.links) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            if (type) {
                layer.links = layer.links.filter((link) => link.url.toLowerCase().includes(type) ||
                    (!Array.isArray(link) && link.includes(type)));
            }
            if (layer.links[0].url !== undefined) {
                return layer.links[0].url;
            }
            else {
                return layer.links[0];
            }
        }
        if (layer.link) {
            return layer.link;
        }
        this.log.warn('Layer does not contain any links or link properties');
    }
    /**
     *   Parse layer name from dataset url (Micka includes LAYER parameters for both WMS/WFS in record url)
     */
    parseLayerName(whatToAdd) {
        var _a, _b;
        const link = Array.isArray(whatToAdd.link)
            ? whatToAdd.link[0]
            : whatToAdd.link;
        return (_b = (_a = link
            .split('&')) === null || _a === void 0 ? void 0 : _a.find((part) => part.includes('LAYERS'))) === null || _b === void 0 ? void 0 : _b.split('=')[1];
    }
    /**
     * Parse workspace from micka dataset record. Null if not layman layer
     */
    parseWorkspaceFromURL(whatToAdd) {
        const link = Array.isArray(whatToAdd.link)
            ? whatToAdd.link.find((link) => link.includes('wfs'))
            : whatToAdd.link;
        //Assuming its layman layer
        if (link === null || link === void 0 ? void 0 : link.includes('geoserver')) {
            whatToAdd.workspace = link.match('(?<=geoserver/).*?(?=/)')[0];
        }
    }
    isLinkValid(link, type) {
        var _a;
        return (((_a = link.protocol) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(type)) ||
            link.url.toLowerCase().includes(`service=${type}`));
    }
    /**
     * @param ds - Configuration of selected datasource (from app config)
     * @param layer - Micka layer for which to get metadata
     * @returns Promise which describes layer
     * in a common format for use in add-layers component
     * Gets layer metadata and returns promise which describes layer
     * in a common format for use in add-layers component
     */
    describeWhatToAdd(ds, layer, app) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            let whatToAdd = { type: 'none' };
            const type = layer.type || layer.trida;
            const layerLink = this.getLayerLink(layer);
            if (!layerLink) {
                return false;
            }
            if (type == 'service') {
                if (['WMS', 'OGC:WMS', 'view'].includes(layer.serviceType)) {
                    whatToAdd.type = 'WMS';
                    whatToAdd.link = layerLink;
                }
                else if (layerLink.toLowerCase().includes('sparql')) {
                    whatToAdd = {
                        type: 'sparql',
                        link: layerLink,
                        projection: 'EPSG:4326',
                    };
                }
                else if (['WFS', 'OGC:WFS', 'download'].includes(layer.serviceType)) {
                    whatToAdd.type = 'WFS';
                    whatToAdd.link = layerLink;
                    whatToAdd.dsType = ds.type;
                }
                else if (layer.formats &&
                    ['kml', 'geojson', 'json'].includes(layer.formats[0].toLowerCase())) {
                    whatToAdd = {
                        type: layer.formats[0].toUpperCase() == 'KML' ? 'kml' : 'geojson',
                        link: layerLink,
                        projection: 'EPSG:4326',
                        extractStyles: layer.formats[0].toLowerCase() == 'kml',
                    };
                }
                else {
                    alert(`Service type "${layer.serviceType}" not supported.`);
                    return false;
                }
            }
            else if (type == 'dataset') {
                if (layer.links) {
                    //Filter invalid links
                    //TODO: possible kml, geojson, shp
                    layer.links = layer.links.filter((link) => ['wms', 'wfs', 'wmts'].some((type) => this.isLinkValid(link, type)));
                    //Check WMS endpoints
                    if (layer.links.some((link) => this.isLinkValid(link, 'wms'))) {
                        whatToAdd = {
                            type: 'WMS',
                        };
                    }
                    //Check WMTS endpoints
                    if (layer.links.some((link) => this.isLinkValid(link, 'wmts'))) {
                        whatToAdd = {
                            type: 'WMTS',
                        };
                    }
                    //Check WFS endpoints
                    if (layer.links.some((link) => this.isLinkValid(link, 'wfs'))) {
                        whatToAdd.type = whatToAdd.type == 'WMS' ? ['WMS', 'WFS'] : 'WFS';
                    }
                    //Parse links
                    whatToAdd.link = Array.isArray(whatToAdd.type)
                        ? layer.links.map((link) => link.url)
                        : this.getLayerLink(layer, whatToAdd.type.toLowerCase());
                    this.parseWorkspaceFromURL(whatToAdd);
                }
                else {
                    return false;
                }
                // else if (
                //   ['kml', 'geojson', 'json'].includes(layer.formats[0].toLowerCase())
                // ) {
                //   whatToAdd = {
                //     type: layer.formats[0].toUpperCase() == 'KML' ? 'kml' : 'geojson',
                //     link: layerLink,
                //     projection: 'EPSG:4326',
                //     extractStyles: layer.formats[0].toLowerCase() == 'kml',
                //   };
                // }
            }
            else {
                console.warn(`Datasource type "${type}" not supported.`);
                this.datasourceParsingError(layer.title, 'unsupportedDatasourceType', app);
                return false;
            }
            if (whatToAdd.type == 'none') {
                this.datasourceParsingError(layer.title, 'urlInvalid', app);
                return false;
            }
            whatToAdd.recordType = type;
            whatToAdd.title = layer.title || 'Layer';
            whatToAdd.name =
                type === 'dataset'
                    ? (_a = this.parseLayerName(whatToAdd)) !== null && _a !== void 0 ? _a : layer.title
                    : layer.title;
            whatToAdd.abstract = layer.abstract || 'Layer';
            return whatToAdd;
        });
    }
    datasourceParsingError(title, error, app) {
        this.hsToastService.createToastPopupMessage(this.hsLanguageService.getTranslation('ADDLAYERS.ERROR.errorWhileRequestingLayers', undefined, app), title +
            ': ' +
            this.hsLanguageService.getTranslation(`ADDLAYERS.ERROR.${error}`, undefined, app), {
            disableLocalization: true,
            serviceCalledFrom: 'HsMickaBrowserService',
        }, app);
    }
}
HsMickaBrowserService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsMickaBrowserService, deps: [{ token: i1.HttpClient }, { token: HsLogService }, { token: HsMapService }, { token: HsUtilsService }, { token: HsToastService }, { token: HsLanguageService }], target: i0.ɵɵFactoryTarget.Injectable });
HsMickaBrowserService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsMickaBrowserService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsMickaBrowserService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: HsLogService }, { type: HsMapService }, { type: HsUtilsService }, { type: HsToastService }, { type: HsLanguageService }]; } });

class HsAddDataCatalogueMapParams {
    constructor() {
        this.extentLayer = new VectorLayer({
            source: new Vector(),
            properties: {
                title: 'Datasources extents',
                showInLayerManager: false,
                removable: false,
            },
            style: function (feature, resolution) {
                return [
                    new Style({
                        stroke: new Stroke({
                            color: '#005CB6',
                            width: getHighlighted(feature) ? 4 : 1,
                        }),
                        fill: new Fill({
                            color: 'rgba(0, 0, 255, 0.01)',
                        }),
                    }),
                ];
            },
        });
        this.initRun = false;
    }
}
class HsAddDataCatalogueMapService {
    constructor(hsMapService, hsLogService, hsSaveMapService, hsLayerUtilsService, hsCommonEndpointsService) {
        this.hsMapService = hsMapService;
        this.hsLogService = hsLogService;
        this.hsSaveMapService = hsSaveMapService;
        this.hsLayerUtilsService = hsLayerUtilsService;
        this.hsCommonEndpointsService = hsCommonEndpointsService;
        this.apps = { default: new HsAddDataCatalogueMapParams() };
    }
    get(app) {
        if (this.apps[app !== null && app !== void 0 ? app : 'default'] == undefined) {
            this.apps[app !== null && app !== void 0 ? app : 'default'] = new HsAddDataCatalogueMapParams();
        }
        return this.apps[app !== null && app !== void 0 ? app : 'default'];
    }
    /**
     * @param evt -
     */
    mapPointerMoved(evt, app) {
        const featuresUnderMouse = this.get(app)
            .extentLayer.getSource()
            .getFeaturesAtCoordinate(evt.coordinate);
        for (const endpoint of this.hsCommonEndpointsService.endpoints.filter((ep) => ep.layers)) {
            this.hsLayerUtilsService.highlightFeatures(featuresUnderMouse, this.get(app).extentLayer, endpoint.layers);
        }
    }
    /**
     * @param map -
     */
    init(app) {
        return __awaiter(this, void 0, void 0, function* () {
            const appRef = this.get(app);
            if (!appRef.initRun) {
                yield this.hsMapService.loaded(app);
                const map = this.hsMapService.getMap(app);
                map.on('pointermove', (evt) => this.mapPointerMoved(evt, app));
                map.addLayer(appRef.extentLayer);
                this.hsSaveMapService.internalLayers.push(appRef.extentLayer);
                this.apps[app].initRun = true;
            }
        });
    }
    clearExtentLayer(app) {
        this.get(app).extentLayer.getSource().clear();
    }
    /**
     * @param dataset - Configuration of selected datasource (from app config)
     * Remove layer extent features from map
     */
    clearDatasetFeatures(dataset, app) {
        if (dataset.layers) {
            dataset.layers.forEach((val) => {
                try {
                    if (val) {
                        this.get(app).extentLayer.getSource().clear();
                    }
                }
                catch (ex) {
                    this.hsLogService.warn(ex);
                }
            });
        }
    }
    /**
     * Test if it possible to zoom to layer overview (bbox has to be defined
     * in metadata of selected layer)
     * @param layer - TODO
     * @returns Returns if bbox is specified and thus layer is zoomable
     */
    isZoomable(layer) {
        return layer.bbox !== undefined;
    }
    /**
     * Callback function which gets executed when extent feature
     * is created. It should add the feature to vector layer source
     * @param extentFeature - OpenLayers Feature
     */
    addExtentFeature(extentFeature, app) {
        this.get(app).extentLayer.getSource().addFeatures([extentFeature]);
    }
    highlightLayer(composition, state, app) {
        if (composition.featureId !== undefined) {
            const found = this.get(app)
                .extentLayer.getSource()
                .getFeatureById(composition.featureId);
            if (found) {
                setHighlighted(found, state);
            }
        }
    }
    /**
     * ZoomTo / MoveTo to selected layer overview
     * @param bbox - Bounding box of selected layer
     */
    zoomTo(bbox, app) {
        if (bbox === undefined) {
            return;
        }
        let b = null;
        if (typeof bbox === 'string') {
            b = bbox.split(' ');
        }
        else if (Array.isArray(bbox)) {
            b = bbox;
        }
        let first_pair = [parseFloat(b[0]), parseFloat(b[1])];
        let second_pair = [parseFloat(b[2]), parseFloat(b[3])];
        first_pair = transform(first_pair, 'EPSG:4326', this.hsMapService.getMap(app).getView().getProjection());
        second_pair = transform(second_pair, 'EPSG:4326', this.hsMapService.getMap(app).getView().getProjection());
        if (isNaN(first_pair[0]) ||
            isNaN(first_pair[1]) ||
            isNaN(second_pair[0]) ||
            isNaN(second_pair[1])) {
            return;
        }
        const extent = [
            first_pair[0],
            first_pair[1],
            second_pair[0],
            second_pair[1],
        ];
        this.hsMapService.fitExtent(extent, app);
    }
}
HsAddDataCatalogueMapService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataCatalogueMapService, deps: [{ token: HsMapService }, { token: HsLogService }, { token: HsSaveMapService }, { token: HsLayerUtilsService }, { token: HsCommonEndpointsService }], target: i0.ɵɵFactoryTarget.Injectable });
HsAddDataCatalogueMapService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataCatalogueMapService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataCatalogueMapService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsMapService }, { type: HsLogService }, { type: HsSaveMapService }, { type: HsLayerUtilsService }, { type: HsCommonEndpointsService }]; } });

class EndpointsWithDatasourcesPipe {
    transform(endpoints, typeToFilter = 'statusmanager', filterType = 'exclusive') {
        switch (filterType) {
            case 'exclusive':
                return endpoints.filter((ep) => ep.type != typeToFilter);
            case 'inclusive':
                return endpoints.filter((ep) => ep.type == typeToFilter);
            default:
                return endpoints;
        }
    }
}
EndpointsWithDatasourcesPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EndpointsWithDatasourcesPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
EndpointsWithDatasourcesPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EndpointsWithDatasourcesPipe, name: "endpointsWithDatasources" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EndpointsWithDatasourcesPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'endpointsWithDatasources',
                }]
        }] });

class HsAddDataCatalogueParams {
    constructor() {
        this.data = {
            query: {
                textFilter: '',
                title: '',
                type: 'all',
                Subject: '',
                sortby: 'date',
            },
            textField: 'AnyText',
            selectedLayer: null,
            id_selected: 'OWS',
            filterByExtent: true,
            onlyMine: false,
        };
        this.catalogEntries = [];
        this.recordsPerPage = 20;
        this.listStart = 0;
        this.listNext = this.recordsPerPage;
        this.extentChangeSuppressed = false;
    }
}
class HsAddDataCatalogueService {
    constructor(hsConfig, hsAddDataVectorService, hsEventBusService, hsMickaBrowserService, hsLaymanBrowserService, hsLayoutService, hsCommonEndpointsService, hsUtilsService, hsMapService, hsAddDataCatalogueMapService, hsAddDataService, endpointsWithDatasourcesPipe, zone, hsCommonLaymanService, hsAddDataOwsService) {
        this.hsConfig = hsConfig;
        this.hsAddDataVectorService = hsAddDataVectorService;
        this.hsEventBusService = hsEventBusService;
        this.hsMickaBrowserService = hsMickaBrowserService;
        this.hsLaymanBrowserService = hsLaymanBrowserService;
        this.hsLayoutService = hsLayoutService;
        this.hsCommonEndpointsService = hsCommonEndpointsService;
        this.hsUtilsService = hsUtilsService;
        this.hsMapService = hsMapService;
        this.hsAddDataCatalogueMapService = hsAddDataCatalogueMapService;
        this.hsAddDataService = hsAddDataService;
        this.endpointsWithDatasourcesPipe = endpointsWithDatasourcesPipe;
        this.zone = zone;
        this.hsCommonLaymanService = hsCommonLaymanService;
        this.hsAddDataOwsService = hsAddDataOwsService;
        this.apps = { default: new HsAddDataCatalogueParams() };
        this.hsEventBusService.mainPanelChanges.subscribe(({ which, app }) => {
            if (this.dataSourceExistsAndEmpty(app) && this.panelVisible(app)) {
                this.reloadData(app);
                this.get(app).extentChangeSuppressed = true;
            }
            this.calcExtentLayerVisibility(app);
        });
        this.hsCommonLaymanService.authChange.subscribe(({ app }) => {
            if (this.panelVisible(app)) {
                this.reloadData(app);
            }
        });
        this.hsAddDataService.datasetSelected.subscribe(({ type, app }) => {
            if (type == 'catalogue' && this.panelVisible(app)) {
                this.reloadData(app);
            }
        });
    }
    get(app) {
        if (this.apps[app !== null && app !== void 0 ? app : 'default'] == undefined) {
            this.apps[app !== null && app !== void 0 ? app : 'default'] = new HsAddDataCatalogueParams();
        }
        return this.apps[app !== null && app !== void 0 ? app : 'default'];
    }
    init(_app) {
        this.get(_app).endpointsWithDatasources =
            this.endpointsWithDatasourcesPipe.transform(this.hsCommonEndpointsService.endpoints);
        if (this.dataSourceExistsAndEmpty(_app) && this.panelVisible(_app)) {
            this.queryCatalogs(_app);
            // this.hsMickaFilterService.fillCodesets();
        }
        this.hsEventBusService.mapExtentChanges.subscribe(this.hsUtilsService.debounce(({ map, event, extent, app }) => {
            if (app == _app) {
                const appRef = this.get(app);
                if (!this.panelVisible(app) || appRef.extentChangeSuppressed) {
                    appRef.extentChangeSuppressed = false;
                    return;
                }
                if (appRef.data.filterByExtent) {
                    this.zone.run(() => {
                        this.reloadData(app);
                    });
                }
            }
        }, 500, false, this));
    }
    resetList(app) {
        const appRef = this.get(app);
        appRef.listStart = 0;
        appRef.listNext = appRef.recordsPerPage;
        appRef.selectedLayer = {};
        appRef.endpointsWithDatasources.forEach((ep) => {
            ep.datasourcePaging.start = 0;
            ep.datasourcePaging.next = ep.datasourcePaging.limit;
            ep.datasourcePaging.matched = 0;
        });
    }
    reloadData(app) {
        this.get(app).endpointsWithDatasources =
            this.endpointsWithDatasourcesPipe.transform(this.hsCommonEndpointsService.endpoints);
        this.resetList(app);
        this.queryCatalogs(app);
        // this.hsMickaFilterService.fillCodesets();
        this.calcExtentLayerVisibility(app);
    }
    /**
     * Queries all configured catalogs for datasources (layers)
     * @param suspendLimitCalculation -
     */
    queryCatalogs(app, suspendLimitCalculation) {
        const appRef = this.get(app);
        if (appRef.endpointsWithDatasources.length > 0) {
            if (appRef.catalogQuery) {
                appRef.catalogQuery.unsubscribe();
                delete appRef.catalogQuery;
            }
            this.clearLoadedData(app);
            this.hsMapService.loaded(app).then(() => {
                appRef.dataLoading = true;
                this.hsAddDataCatalogueMapService.clearExtentLayer(app);
                const observables = [];
                //TODO Mark non functional endpoint
                for (const endpoint of appRef.endpointsWithDatasources) {
                    if (!appRef.data.onlyMine || endpoint.type == 'layman') {
                        const promise = this.queryCatalog(endpoint, app);
                        observables.push(promise);
                    }
                }
                appRef.catalogQuery = forkJoin(observables).subscribe(() => {
                    suspendLimitCalculation
                        ? this.createLayerList(app)
                        : this.calculateEndpointLimits(app);
                });
            });
        }
    }
    /**
     * Calculates each endpoint layer request limit, based on the matched layers ratio
     * from all endpoint matched layers
     */
    calculateEndpointLimits(app) {
        const appRef = this.get(app);
        appRef.matchedRecords = 0;
        appRef.endpointsWithDatasources = appRef.endpointsWithDatasources.filter((ep) => ep.datasourcePaging.matched != 0);
        if (appRef.endpointsWithDatasources.length == 0) {
            appRef.dataLoading = false;
            return;
        }
        appRef.endpointsWithDatasources.forEach((ep) => (appRef.matchedRecords += ep.datasourcePaging.matched));
        let sumLimits = 0;
        appRef.endpointsWithDatasources.forEach((ep) => {
            ep.datasourcePaging.limit = Math.floor((ep.datasourcePaging.matched / appRef.matchedRecords) *
                appRef.recordsPerPage);
            if (ep.datasourcePaging.limit == 0) {
                ep.datasourcePaging.limit = 1;
            }
            sumLimits += ep.datasourcePaging.limit;
        });
        appRef.recordsPerPage = sumLimits;
        appRef.listNext = appRef.recordsPerPage;
        this.queryCatalogs(app, true);
    }
    createLayerList(app) {
        const appRef = this.get(app);
        for (const endpoint of appRef.endpointsWithDatasources) {
            if (!appRef.data.onlyMine || endpoint.type == 'layman') {
                if (endpoint.layers) {
                    endpoint.layers.forEach((layer) => {
                        layer.endpoint = endpoint;
                        // this.catalogEntries.push(layer);
                    });
                    if (appRef.catalogEntries.length > 0) {
                        this.filterDuplicates(endpoint, app);
                    }
                    else {
                        appRef.catalogEntries = appRef.catalogEntries.concat(endpoint.layers);
                    }
                }
            }
        }
        if (appRef.matchedRecords < appRef.recordsPerPage) {
            appRef.listNext = appRef.matchedRecords;
        }
        appRef.catalogEntries.sort((a, b) => a.title.localeCompare(b.title));
        appRef.dataLoading = false;
    }
    filterDuplicates(endpoint, app) {
        var _a;
        const appRef = this.get(app);
        if (endpoint.layers === undefined || ((_a = endpoint.layers) === null || _a === void 0 ? void 0 : _a.length) == 0) {
            return [];
        }
        const filteredLayers = endpoint.layers.filter((layer) => appRef.catalogEntries.filter((u) => u.id == layer.id ||
            u.id == 'm-' + layer.id ||
            'm-' + u.id == layer.id).length == 0);
        if (endpoint.type != 'layman') {
            appRef.matchedRecords -= endpoint.layers.length - filteredLayers.length;
        }
        appRef.catalogEntries = appRef.catalogEntries.concat(filteredLayers);
    }
    getNextRecords(app) {
        const appRef = this.get(app);
        appRef.listStart += appRef.recordsPerPage;
        appRef.listNext += appRef.recordsPerPage;
        if (appRef.listNext > appRef.matchedRecords) {
            appRef.listNext = appRef.matchedRecords;
        }
        appRef.endpointsWithDatasources.forEach((ep) => (ep.datasourcePaging.start += ep.datasourcePaging.limit));
        this.queryCatalogs(app, true);
    }
    getPreviousRecords(app) {
        const appRef = this.get(app);
        if (appRef.listStart - appRef.recordsPerPage <= 0) {
            appRef.listStart = 0;
            appRef.listNext = appRef.recordsPerPage;
            appRef.endpointsWithDatasources.forEach((ep) => (ep.datasourcePaging.start = 0));
        }
        else {
            appRef.listStart -= appRef.recordsPerPage;
            appRef.listNext = appRef.listStart + appRef.recordsPerPage;
            appRef.endpointsWithDatasources.forEach((ep) => (ep.datasourcePaging.start -= ep.datasourcePaging.limit));
        }
        this.queryCatalogs(app, true);
    }
    changeRecordsPerPage(perPage, app) {
        this.resetList(app);
        this.queryCatalogs(app);
    }
    clearLoadedData(app) {
        const appRef = this.get(app);
        appRef.catalogEntries = [];
        appRef.endpointsWithDatasources.forEach((ep) => (ep.layers = []));
    }
    /**
     * Loads datasets metadata from selected source (CSW server).
     * Uses pagination set by 'start' attribute of 'dataset' param.
     * Currently supports only "Micka" type of source.
     * Use all query params (search text, bbox, params.., sorting, start)
     * @param catalog - Configuration of selected datasource (from app config)
     */
    queryCatalog(catalog, app) {
        const appRef = this.get(app);
        this.hsAddDataCatalogueMapService.clearDatasetFeatures(catalog, app);
        let query;
        switch (catalog.type) {
            case 'micka':
                query = this.hsMickaBrowserService.queryCatalog(catalog, appRef.data, (feature) => this.hsAddDataCatalogueMapService.addExtentFeature(feature, app), appRef.data.textField, app);
                return query;
            case 'layman':
                query = this.hsLaymanBrowserService.queryCatalog(catalog, app, appRef.data, (feature) => this.hsAddDataCatalogueMapService.addExtentFeature(feature, app));
                return query;
            default:
                break;
        }
    }
    /**
     * Test if layer of selected record is downloadable (KML and JSON files, with direct URL) and gives URL.
     * @param ds - Datasource of selected layer
     * @param layer - Metadata record of selected layer
     * @returns Download URL of layer if possible
     */
    layerDownload(ds, layer) {
        if (ds.download == true) {
            if (['kml', 'geojson', 'json'].includes(layer.formats[0].toLowerCase()) &&
                layer.url.length > 0) {
                return layer.url;
            }
        }
        return '#';
    }
    /**
     * Get URL for RDF-DCAT record of selected layer
     * @param ds - Datasource of selected layer
     * @param layer - Metadata record of selected layer
     * @returns URL to record file
     */
    layerRDF(ds, layer) {
        return `${ds.url}?request=GetRecordById&id=${layer.id}&outputschema=http://www.w3.org/ns/dcat%23`;
    }
    /**
     * Add selected layer to map (into layer manager) if possible
     * @param ds - Datasource of selected layer
     * @param layer - Metadata record of selected layer
     * @param type - Type of layer (supported values: WMS, WFS, Sparql, kml, geojson, json)
     * @returns Type or array of types in which this layer can be added to map
     */
    addLayerToMap(ds, layer, app, type) {
        return __awaiter(this, void 0, void 0, function* () {
            let whatToAdd;
            if (ds.type == 'micka') {
                whatToAdd = yield this.hsMickaBrowserService.describeWhatToAdd(ds, layer, app);
            }
            else if (ds.type == 'layman') {
                whatToAdd = yield this.hsLaymanBrowserService.describeWhatToAdd(ds, layer, app);
            }
            else {
                whatToAdd = { type: 'none' };
            }
            if (!whatToAdd) {
                return;
            }
            if (type) {
                whatToAdd.type = type;
            }
            if (Array.isArray(whatToAdd.type)) {
                return whatToAdd.type;
            }
            if (whatToAdd.type == 'WMS') {
                whatToAdd.link = Array.isArray(whatToAdd.link)
                    ? whatToAdd.link.filter((link) => link.toLowerCase().includes('wms'))[0]
                    : whatToAdd.link;
                if (ds.type == 'micka' && whatToAdd.recordType != 'dataset') {
                    this.datasetSelect('url', app);
                }
                yield this.hsAddDataOwsService.connectToOWS({
                    type: whatToAdd.type.toLowerCase(),
                    uri: decodeURIComponent(whatToAdd.link),
                    layer: ds.type == 'layman' || whatToAdd.recordType === 'dataset'
                        ? ds.type == 'layman'
                            ? layer.name
                            : whatToAdd.name
                        : undefined,
                }, app);
            }
            else if (whatToAdd.type == 'WFS') {
                if (ds.type == 'micka') {
                    if (!whatToAdd.workspace) {
                        this.datasetSelect('url', app);
                    }
                    whatToAdd.link = Array.isArray(whatToAdd.link)
                        ? whatToAdd.link.filter((link) => link.toLowerCase().includes('wfs'))[0]
                        : whatToAdd.link;
                    yield this.hsAddDataOwsService.connectToOWS({
                        type: whatToAdd.type.toLowerCase(),
                        uri: decodeURIComponent(whatToAdd.link),
                        layer: whatToAdd.workspace
                            ? `${whatToAdd.workspace}:${whatToAdd.name}`
                            : undefined,
                        style: whatToAdd.style,
                    }, app);
                }
                else {
                    //Layman layers of logged user/ with write access
                    if (whatToAdd.editable) {
                        const layer = yield this.hsAddDataVectorService.addVectorLayer('wfs', whatToAdd.link.replace('_wms/ows', '/wfs'), whatToAdd.name, whatToAdd.title, whatToAdd.abstract, whatToAdd.projection, {
                            extractStyles: whatToAdd.extractStyles,
                            workspace: whatToAdd.workspace,
                            style: whatToAdd.style,
                            saveToLayman: true,
                        }, app);
                        this.hsAddDataVectorService.fitExtent(layer, app);
                        this.datasetSelect('catalogue', app);
                    }
                    else {
                        //Layman layers without write access
                        yield this.hsAddDataOwsService.connectToOWS({
                            type: 'wfs',
                            uri: whatToAdd.link.replace('_wms/ows', '/wfs'),
                            style: whatToAdd.style,
                            layer: `${whatToAdd.workspace}:${whatToAdd.name}`,
                        }, app);
                    }
                    this.hsLayoutService.setMainPanel('layermanager', app);
                }
            }
            else if (['KML', 'GEOJSON'].includes(whatToAdd.type)) {
                const layer = yield this.hsAddDataVectorService.addVectorLayer(whatToAdd.type.toLowerCase(), whatToAdd.link, whatToAdd.name, whatToAdd.title, whatToAdd.abstract, whatToAdd.projection, { extractStyles: whatToAdd.extractStyles }, app);
                this.hsAddDataVectorService.fitExtent(layer, app);
            }
            else if (whatToAdd.type == 'WMTS' && ds.type == 'micka') {
                //Micka only  yet
                if (whatToAdd.recordType === 'service') {
                    this.datasetSelect('url', app);
                }
                yield this.hsAddDataOwsService.connectToOWS({
                    type: whatToAdd.type.toLowerCase(),
                    uri: decodeURIComponent(whatToAdd.link),
                    layer: whatToAdd.recordType === 'dataset' ? whatToAdd.name : undefined,
                }, app);
            }
            else {
                this.hsLayoutService.setMainPanel('layermanager', app);
            }
            return whatToAdd.type;
        });
    }
    datasetSelect(id_selected, app) {
        this.get(app).data.id_selected = id_selected;
        this.hsAddDataService.selectType(id_selected, app);
        this.calcExtentLayerVisibility(app);
    }
    /**
     * Clear query variable
     */
    clear(app) {
        const appRef = this.get(app);
        appRef.data.query.textFilter = '';
        appRef.data.query.title = '';
        appRef.data.query.Subject = '';
        appRef.data.query.keywords = '';
        appRef.data.query.OrganisationName = '';
        appRef.data.query.sortby = '';
    }
    /**
     *
     */
    dataSourceExistsAndEmpty(app) {
        return !!this.get(app).endpointsWithDatasources;
    }
    /**
     *
     */
    panelVisible(app) {
        return this.hsLayoutService.panelVisible('addData', app);
    }
    calcExtentLayerVisibility(app) {
        this.hsAddDataCatalogueMapService
            .get(app)
            .extentLayer.setVisible(this.panelVisible(app) &&
            this.hsAddDataService.get(app).dsSelected == 'catalogue');
    }
}
HsAddDataCatalogueService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataCatalogueService, deps: [{ token: HsConfig }, { token: HsAddDataVectorService }, { token: HsEventBusService }, { token: HsMickaBrowserService }, { token: HsLaymanBrowserService }, { token: HsLayoutService }, { token: HsCommonEndpointsService }, { token: HsUtilsService }, { token: HsMapService }, { token: HsAddDataCatalogueMapService }, { token: HsAddDataService }, { token: EndpointsWithDatasourcesPipe }, { token: i0.NgZone }, { token: HsCommonLaymanService }, { token: HsAddDataOwsService }], target: i0.ɵɵFactoryTarget.Injectable });
HsAddDataCatalogueService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataCatalogueService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataCatalogueService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsConfig }, { type: HsAddDataVectorService }, { type: HsEventBusService }, { type: HsMickaBrowserService }, { type: HsLaymanBrowserService }, { type: HsLayoutService }, { type: HsCommonEndpointsService }, { type: HsUtilsService }, { type: HsMapService }, { type: HsAddDataCatalogueMapService }, { type: HsAddDataService }, { type: EndpointsWithDatasourcesPipe }, { type: i0.NgZone }, { type: HsCommonLaymanService }, { type: HsAddDataOwsService }]; } });

class HsUiExtensionsRecursiveDdComponent {
    constructor(hsDSMapService // used in template
    ) {
        this.hsDSMapService = hsDSMapService;
        this.app = 'default';
    }
    isIterable() {
        if (this.value && typeof this.value === 'object') {
            this.entries = Object.entries(this.value);
            return true;
        }
        return false;
    }
}
HsUiExtensionsRecursiveDdComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUiExtensionsRecursiveDdComponent, deps: [{ token: HsAddDataCatalogueMapService }], target: i0.ɵɵFactoryTarget.Component });
HsUiExtensionsRecursiveDdComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsUiExtensionsRecursiveDdComponent, selector: "hs-widgets-recursive-dd", inputs: { value: "value", app: "app" }, ngImport: i0, template: "<dd *ngIf=\"!isIterable()\">{{value}}</dd><!-- TODO: Remove function call from template -->\n<dl *ngFor=\"let item of entries\">\n    <dt>{{item.key || item[0]}}</dt>\n    <hs-widgets-recursive-dd [value]=\"item.value || item[1]\" [app]=\"app\"></hs-widgets-recursive-dd>\n    <button *ngIf=\"item.key==='bbox'\" (click)=\"hsDSMapService.zoomTo(value, app)\" class='btn btn-secondary' i18n>Zoom to</button>\n</dl>\n", components: [{ type: HsUiExtensionsRecursiveDdComponent, selector: "hs-widgets-recursive-dd", inputs: ["value", "app"] }], directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUiExtensionsRecursiveDdComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-widgets-recursive-dd', template: "<dd *ngIf=\"!isIterable()\">{{value}}</dd><!-- TODO: Remove function call from template -->\n<dl *ngFor=\"let item of entries\">\n    <dt>{{item.key || item[0]}}</dt>\n    <hs-widgets-recursive-dd [value]=\"item.value || item[1]\" [app]=\"app\"></hs-widgets-recursive-dd>\n    <button *ngIf=\"item.key==='bbox'\" (click)=\"hsDSMapService.zoomTo(value, app)\" class='btn btn-secondary' i18n>Zoom to</button>\n</dl>\n" }]
        }], ctorParameters: function () { return [{ type: HsAddDataCatalogueMapService }]; }, propDecorators: { value: [{
                type: Input
            }], app: [{
                type: Input
            }] } });

class HsCatalogueMetadataComponent {
    constructor(hsConfig, // used in template
    hsAddDataCatalogueService, //used in template
    hsAddDataCatalogueMapService, //used in template
    hsDialogContainerService) {
        this.hsConfig = hsConfig;
        this.hsAddDataCatalogueService = hsAddDataCatalogueService;
        this.hsAddDataCatalogueMapService = hsAddDataCatalogueMapService;
        this.hsDialogContainerService = hsDialogContainerService;
    }
    ngOnInit() {
        this.selectedDS = this.data.selectedDS;
        this.selectedLayer = this.data.selectedLayer;
        this.selectedLayerKeys = Object.keys(this.selectedLayer);
        this.selectedLayerKeys = this.selectedLayerKeys.filter((e) => e !== 'endpoint');
    }
    /**
     * @param ds - Datasource (i.e. endpoint)
     * @param layer - Description of a layer to be added
     * @param type - Type in which the layer shall be added (WMS, WFS, etc.)
     */
    addLayerToMap(ds, layer, type) {
        this.hsAddDataCatalogueService.addLayerToMap(ds, layer, this.data.app, type);
        this.close();
    }
    close() {
        this.hsDialogContainerService.destroy(this, this.data.app);
    }
}
HsCatalogueMetadataComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCatalogueMetadataComponent, deps: [{ token: HsConfig }, { token: HsAddDataCatalogueService }, { token: HsAddDataCatalogueMapService }, { token: HsDialogContainerService }], target: i0.ɵɵFactoryTarget.Component });
HsCatalogueMetadataComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsCatalogueMetadataComponent, selector: "hs-catalogue-metadata", inputs: { data: "data" }, ngImport: i0, template: "<div class=\"modal in hs-datasource_selector-metadata-dialog\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n    <div class=\"modal-dialog modal-lg\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h4 class=\"modal-title\">\n                    {{'DATASOURCE_SELECTOR.metadataFor' | translateHs: {app: data.app} }} {{ selectedLayer.title}}\n                </h4>\n                <button type=\"button\" (click)=\"close()\" class=\"btn-close\" data-dismiss=\"modal\" attr.aria-label=\"{{'COMMON.close' | translateHs: {app: data.app} }}\"></button>\n            </div>\n            <div class=\"modal-body\" style=\"max-height:400px; overflow-y:auto\">\n                <ng-container *ngFor=\"let key of selectedLayerKeys\">\n                    <dl *ngIf=\"key!=='feature'\">\n                        <dt>{{key}}</dt>\n                        <hs-widgets-recursive-dd [value]=\"selectedLayer[key]\" [app]=\"data.app\"></hs-widgets-recursive-dd>\n                    </dl>\n                </ng-container>\n            </div>\n            <div class=\"modal-footer\">\n                <a role=\"button\" class=\"btn btn-success\"\n                    [href]='hsAddDataCatalogueService.layerRDF(selectedDS, selectedLayer)' data-toggle=\"tooltip\"\n                    title=\"GeoDCAT-AP\" target=\"_blank\"\n                    [hidden]='selectedDS.type!==\"micka\" || hsAddDataCatalogueService.layerRDF(selectedDS, selectedLayer) === \"#\"'>\n                    <i class=\"icon-share-alt\"></i> RDF\n                </a><!-- TODO: Remove function call from template -->\n                <button type=\"button\" class=\"btn btn-success\"\n                    [hidden]=\"!hsAddDataCatalogueMapService.isZoomable(selectedLayer)\"\n                    (click)=\"hsAddDataCatalogueMapService.zoomTo(selectedLayer.bbox, data.app)\">{{'COMMON.zoomTo' |\n                    translateHs: {app: data.app} }}</button><!-- TODO: Remove function call from template -->\n                <div *ngIf=\"selectedDS.type === 'layman'\">\n                    <button type=\"button\" class=\"btn btn-primary ms-2\" *ngFor=\"let type of selectedLayer.type\"\n                        (click)=\"addLayerToMap(selectedDS, selectedLayer, type)\" data-dismiss=\"modal\">\n                        <span class=\"icon-plus\"></span><span>{{'DATASOURCE_SELECTOR.addToMapAs' | translateHs: {app: data.app} }}\n                            {{type}}</span>\n                    </button>\n                </div>\n                <button type=\"button\" class=\"btn btn-secondary\" (click)=\"close()\" data-dismiss=\"modal\"\n                    [title]=\"'COMMON.close' | translateHs: {app: data.app} \">\n                    {{'COMMON.close' | translateHs: {app: data.app} }}\n                </button>\n            </div>\n        </div>\n    </div>\n</div>\n", components: [{ type: HsUiExtensionsRecursiveDdComponent, selector: "hs-widgets-recursive-dd", inputs: ["value", "app"] }], directives: [{ type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCatalogueMetadataComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-catalogue-metadata', template: "<div class=\"modal in hs-datasource_selector-metadata-dialog\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n    <div class=\"modal-dialog modal-lg\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h4 class=\"modal-title\">\n                    {{'DATASOURCE_SELECTOR.metadataFor' | translateHs: {app: data.app} }} {{ selectedLayer.title}}\n                </h4>\n                <button type=\"button\" (click)=\"close()\" class=\"btn-close\" data-dismiss=\"modal\" attr.aria-label=\"{{'COMMON.close' | translateHs: {app: data.app} }}\"></button>\n            </div>\n            <div class=\"modal-body\" style=\"max-height:400px; overflow-y:auto\">\n                <ng-container *ngFor=\"let key of selectedLayerKeys\">\n                    <dl *ngIf=\"key!=='feature'\">\n                        <dt>{{key}}</dt>\n                        <hs-widgets-recursive-dd [value]=\"selectedLayer[key]\" [app]=\"data.app\"></hs-widgets-recursive-dd>\n                    </dl>\n                </ng-container>\n            </div>\n            <div class=\"modal-footer\">\n                <a role=\"button\" class=\"btn btn-success\"\n                    [href]='hsAddDataCatalogueService.layerRDF(selectedDS, selectedLayer)' data-toggle=\"tooltip\"\n                    title=\"GeoDCAT-AP\" target=\"_blank\"\n                    [hidden]='selectedDS.type!==\"micka\" || hsAddDataCatalogueService.layerRDF(selectedDS, selectedLayer) === \"#\"'>\n                    <i class=\"icon-share-alt\"></i> RDF\n                </a><!-- TODO: Remove function call from template -->\n                <button type=\"button\" class=\"btn btn-success\"\n                    [hidden]=\"!hsAddDataCatalogueMapService.isZoomable(selectedLayer)\"\n                    (click)=\"hsAddDataCatalogueMapService.zoomTo(selectedLayer.bbox, data.app)\">{{'COMMON.zoomTo' |\n                    translateHs: {app: data.app} }}</button><!-- TODO: Remove function call from template -->\n                <div *ngIf=\"selectedDS.type === 'layman'\">\n                    <button type=\"button\" class=\"btn btn-primary ms-2\" *ngFor=\"let type of selectedLayer.type\"\n                        (click)=\"addLayerToMap(selectedDS, selectedLayer, type)\" data-dismiss=\"modal\">\n                        <span class=\"icon-plus\"></span><span>{{'DATASOURCE_SELECTOR.addToMapAs' | translateHs: {app: data.app} }}\n                            {{type}}</span>\n                    </button>\n                </div>\n                <button type=\"button\" class=\"btn btn-secondary\" (click)=\"close()\" data-dismiss=\"modal\"\n                    [title]=\"'COMMON.close' | translateHs: {app: data.app} \">\n                    {{'COMMON.close' | translateHs: {app: data.app} }}\n                </button>\n            </div>\n        </div>\n    </div>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: HsConfig }, { type: HsAddDataCatalogueService }, { type: HsAddDataCatalogueMapService }, { type: HsDialogContainerService }]; }, propDecorators: { data: [{
                type: Input
            }] } });

class CswLayersDialogComponent {
    constructor(HsDialogContainerService, hsAddDataUrlService, hsAddDataOwsService, hsUtilsService, hsLayerUtilsService, hsMapService, hsConfig) {
        this.HsDialogContainerService = HsDialogContainerService;
        this.hsAddDataUrlService = hsAddDataUrlService;
        this.hsAddDataOwsService = hsAddDataOwsService;
        this.hsUtilsService = hsUtilsService;
        this.hsLayerUtilsService = hsLayerUtilsService;
        this.hsMapService = hsMapService;
        this.hsConfig = hsConfig;
        this.servicesLoaded = false;
    }
    close() {
        this.HsDialogContainerService.destroy(this, this.data.app);
        this.dialogItem.resolve(false);
    }
    ngOnInit() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            if (this.data.layers) {
                this.layersString = this.data.layers.map((l) => l.title).join(', ');
            }
            this.configRef = this.hsConfig.get(this.data.app);
            for (const service of this.data.services) {
                this.hsAddDataUrlService.get(this.data.app).typeSelected = service.type;
                yield this.hsAddDataOwsService.setUrlAndConnect({ type: service.type, uri: service.url, getOnly: true }, this.data.app);
                service.typeService = this.hsAddDataOwsService.get(this.data.app).typeService;
                const data = (_a = service.typeService.get(this.data.app)) === null || _a === void 0 ? void 0 : _a.data;
                if (((_b = data === null || data === void 0 ? void 0 : data.layers) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                    //Store data object outside service so it can be reasigned later
                    service.data = Object.assign({}, service.typeService.apps[this.data.app].data);
                    service.loaded = true;
                }
                else {
                    //TODO: Toast error?
                    this.removeService(service);
                }
            }
            this.servicesLoaded = this.data.services.every((s) => s.loaded);
        });
    }
    /**
     * Determines wether all layers should be added or just the checked ones
     */
    lookForChecked(layers) {
        for (const lyr of layers) {
            if (lyr.checked) {
                return true;
            }
            if (lyr.Layer) {
                if (this.lookForChecked(lyr.Layer)) {
                    return true;
                }
            }
        }
        return false;
    }
    /**
     * Sets additional layer params
     */
    setLayerParams(layers, service, checkedOnly) {
        for (const layer of layers) {
            setFromComposition(layer, true);
            setPath(layer, service.title);
            if (this.hsLayerUtilsService.isLayerWMS(layer) && !checkedOnly) {
                setSubLayers(layer, layers.map((l) => l.getSource().getParams().LAYERS).join(','));
                setTitle(layer, service.title);
                layer.set('serviceLayer', true);
                return [layer];
            }
        }
        return layers;
    }
    /**
     * Creates service layers and adds them to the map
     */
    addLayers() {
        this.hsMapService.removeCompositionLayers(this.data.app);
        for (const service of this.data.services) {
            const checkedOnly = this.lookForChecked(service.data.layers);
            service.typeService.apps[this.data.app].data = service.data;
            let layers = service.typeService.getLayers(this.data.app, checkedOnly, !checkedOnly);
            layers = this.setLayerParams(layers, service, checkedOnly);
            service.typeService.addLayers(layers, this.data.app);
        }
        this.HsDialogContainerService.destroy(this, this.data.app);
        this.dialogItem.resolve(true);
    }
    /**
     * Removes service from CSW compostion
     */
    removeService(service) {
        this.data.services = this.data.services.filter((s) => s != service);
    }
    /**
     * Assigns per service data to the input addData-urlType service when switching between different services (many times of same type)
     */
    beforeChange(e) {
        const service = this.data.services.find((s) => s.id == e.panelId);
        //Assign correct service data object to typeService
        service.typeService.apps[this.data.app].data = service.data;
    }
}
CswLayersDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: CswLayersDialogComponent, deps: [{ token: HsDialogContainerService }, { token: HsAddDataUrlService }, { token: HsAddDataOwsService }, { token: HsUtilsService }, { token: HsLayerUtilsService }, { token: HsMapService }, { token: HsConfig }], target: i0.ɵɵFactoryTarget.Component });
CswLayersDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: CswLayersDialogComponent, selector: "hs-csw-layers-dialog", inputs: { data: "data" }, viewQueries: [{ propertyName: "acc", first: true, predicate: ["acc"], descendants: true }], ngImport: i0, template: "<div class=\"modal in hs-composition-overwrite-dialog\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n    <div class=\"modal-dialog\" style=\"max-width: 65em;\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h4 class=\"modal-title\">{{'COMPOSITIONS.cswDialog.loadComposition' | translateHs: {app: data.app} }}\n                    </h4>\n                <button type=\"button\" (click)=\"close()\" class=\"btn-close\" data-dismiss=\"modal\"\n                    attr.aria-label=\"{{'COMMON.close' | translateHs: {app: data.app} }}\">\n                </button>\n            </div>\n            <p class=\"py-3 text-danger m-auto w-75 ps-3\">\n                {{'COMPOSITIONS.cswDialog.infoText' | translateHs: {app: data.app} }}\n            </p>\n            <div class=\"modal-body w-75 mh-75\" style=\"max-height: 75vh; overflow-y: auto; margin:auto\">\n                <ngb-accordion [closeOthers]=\"true\" #acc=\"ngbAccordion\" (panelChange)=\"beforeChange($event)\">\n                    <ngb-panel [disabled]=\"!servicesLoaded\" id=\"{{service.id}}\" *ngFor=\"let service of data.services\">\n                        <ng-template ngbPanelHeader>\n                            <button ngbPanelToggle *ngIf=\"service.loaded; else loadingLayers\"\n                                class=\"accordion-button justify-content-between\">{{service.title}}\n                                <span>\n                                    <i class=\"icon-trash text-secondary pe-3 \" role=\"button\"\n                                        (click)=\"$event.stopPropagation();removeService(service)\"\n                                        [title]=\"'COMMON.delete' | translateHs : {app: data.app}\"></i>\n                                    <i class=\"text-black\" role=\"button\"\n                                        [ngClass]=\" acc.isExpanded(service.id)  ? 'icon-chevron-down' : 'icon-chevron-right' \"\n                                        [title]=\"'COMMON.toggle' | translateHs : {app: data.app}\"></i>\n                                </span>\n                            </button>\n                            <ng-template #loadingLayers>\n                                <button\n                                    class=\"accordion-button justify-content-between\">{{'COMPOSITIONS.cswDialog.servicesLoading'\n                                    | translateHs:{app: data.app} }}<img [src]=\"configRef._ajaxLoaderPath\" /></button>\n                            </ng-template>\n                        </ng-template>\n                        <ng-template ngbPanelContent>\n                            <hs-layer-table *ngIf=\"service.loaded\" [app]=\"data.app\" [type]=\"service.type\"\n                                [injectedService]=\"service.typeService\"> </hs-layer-table>\n                        </ng-template>\n                    </ngb-panel>\n                </ngb-accordion>\n            </div>\n            <div class=\"w-75 mh-75 m-auto p-3\" [hidden]=\"layersString.length === 0\">\n                {{'COMPOSITIONS.cswDialog.otherLayers' | translateHs: {app: data.app} }}: {{layersString}}\n            </div>\n\n            <div class=\"modal-footer\">\n                <button (click)=\"addLayers()\" [disabled]=\"!servicesLoaded\" type=\"button\" class=\"btn btn-primary\"\n                    data-dismiss=\"modal\">{{'COMMON.addLayers' |\n                    translateHs: {'app': data.app} }}</button>\n                <button (click)=\"close()\" type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\">{{'COMMON.cancel'\n                    | translateHs: {'app': data.app} }}</button>\n            </div>\n        </div>\n    </div>\n</div>\n", styles: [".accordion-button:after{content:unset!important}.accordion-button:hover{background-color:#efefef}.accordion-button i:hover{color:#dc3545!important}\n"], components: [{ type: i7.NgbAccordion, selector: "ngb-accordion", inputs: ["animation", "activeIds", "closeOthers", "destroyOnHide", "type"], outputs: ["panelChange", "shown", "hidden"], exportAs: ["ngbAccordion"] }, { type: HsLayerTableComponent, selector: "hs-layer-table", inputs: ["injectedService", "type", "app"] }], directives: [{ type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i7.NgbPanel, selector: "ngb-panel", inputs: ["disabled", "id", "title", "type", "cardClass"], outputs: ["shown", "hidden"] }, { type: i7.NgbPanelHeader, selector: "ng-template[ngbPanelHeader]" }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i7.NgbPanelToggle, selector: "button[ngbPanelToggle]", inputs: ["ngbPanelToggle"] }, { type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i7.NgbPanelContent, selector: "ng-template[ngbPanelContent]" }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: CswLayersDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-csw-layers-dialog', template: "<div class=\"modal in hs-composition-overwrite-dialog\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n    <div class=\"modal-dialog\" style=\"max-width: 65em;\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h4 class=\"modal-title\">{{'COMPOSITIONS.cswDialog.loadComposition' | translateHs: {app: data.app} }}\n                    </h4>\n                <button type=\"button\" (click)=\"close()\" class=\"btn-close\" data-dismiss=\"modal\"\n                    attr.aria-label=\"{{'COMMON.close' | translateHs: {app: data.app} }}\">\n                </button>\n            </div>\n            <p class=\"py-3 text-danger m-auto w-75 ps-3\">\n                {{'COMPOSITIONS.cswDialog.infoText' | translateHs: {app: data.app} }}\n            </p>\n            <div class=\"modal-body w-75 mh-75\" style=\"max-height: 75vh; overflow-y: auto; margin:auto\">\n                <ngb-accordion [closeOthers]=\"true\" #acc=\"ngbAccordion\" (panelChange)=\"beforeChange($event)\">\n                    <ngb-panel [disabled]=\"!servicesLoaded\" id=\"{{service.id}}\" *ngFor=\"let service of data.services\">\n                        <ng-template ngbPanelHeader>\n                            <button ngbPanelToggle *ngIf=\"service.loaded; else loadingLayers\"\n                                class=\"accordion-button justify-content-between\">{{service.title}}\n                                <span>\n                                    <i class=\"icon-trash text-secondary pe-3 \" role=\"button\"\n                                        (click)=\"$event.stopPropagation();removeService(service)\"\n                                        [title]=\"'COMMON.delete' | translateHs : {app: data.app}\"></i>\n                                    <i class=\"text-black\" role=\"button\"\n                                        [ngClass]=\" acc.isExpanded(service.id)  ? 'icon-chevron-down' : 'icon-chevron-right' \"\n                                        [title]=\"'COMMON.toggle' | translateHs : {app: data.app}\"></i>\n                                </span>\n                            </button>\n                            <ng-template #loadingLayers>\n                                <button\n                                    class=\"accordion-button justify-content-between\">{{'COMPOSITIONS.cswDialog.servicesLoading'\n                                    | translateHs:{app: data.app} }}<img [src]=\"configRef._ajaxLoaderPath\" /></button>\n                            </ng-template>\n                        </ng-template>\n                        <ng-template ngbPanelContent>\n                            <hs-layer-table *ngIf=\"service.loaded\" [app]=\"data.app\" [type]=\"service.type\"\n                                [injectedService]=\"service.typeService\"> </hs-layer-table>\n                        </ng-template>\n                    </ngb-panel>\n                </ngb-accordion>\n            </div>\n            <div class=\"w-75 mh-75 m-auto p-3\" [hidden]=\"layersString.length === 0\">\n                {{'COMPOSITIONS.cswDialog.otherLayers' | translateHs: {app: data.app} }}: {{layersString}}\n            </div>\n\n            <div class=\"modal-footer\">\n                <button (click)=\"addLayers()\" [disabled]=\"!servicesLoaded\" type=\"button\" class=\"btn btn-primary\"\n                    data-dismiss=\"modal\">{{'COMMON.addLayers' |\n                    translateHs: {'app': data.app} }}</button>\n                <button (click)=\"close()\" type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\">{{'COMMON.cancel'\n                    | translateHs: {'app': data.app} }}</button>\n            </div>\n        </div>\n    </div>\n</div>\n", styles: [".accordion-button:after{content:unset!important}.accordion-button:hover{background-color:#efefef}.accordion-button i:hover{color:#dc3545!important}\n"] }]
        }], ctorParameters: function () { return [{ type: HsDialogContainerService }, { type: HsAddDataUrlService }, { type: HsAddDataOwsService }, { type: HsUtilsService }, { type: HsLayerUtilsService }, { type: HsMapService }, { type: HsConfig }]; }, propDecorators: { acc: [{
                type: ViewChild,
                args: ['acc']
            }], data: [{
                type: Input
            }] } });

class HsCompositionsWarningDialogComponent {
    constructor(HsDialogContainerService) {
        this.HsDialogContainerService = HsDialogContainerService;
    }
    close() {
        this.HsDialogContainerService.destroy(this, this.data.app);
    }
}
HsCompositionsWarningDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCompositionsWarningDialogComponent, deps: [{ token: HsDialogContainerService }], target: i0.ɵɵFactoryTarget.Component });
HsCompositionsWarningDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsCompositionsWarningDialogComponent, selector: "hs-compositions-warning-dialog", ngImport: i0, template: "<div class=\"modal in hs-composition-warning-dialog\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h4 class=\"modal-title\">{{'COMMON.warning' | translateHs: {app: data.app} }}</h4>\n                <button type=\"button\" (click)=\"close()\" class=\"btn-close\" data-dismiss=\"modal\"\n                    attr.aria-label=\"{{'COMMON.close' | translateHs: {app: data.app} }}\">\n                </button>\n            </div>\n            <div class=\"modal-body\" style=\"max-height: 600px; overflow-y: auto\">\n                <br>{{'COMMON.name' | translateHs: {app: data.app} }}: <b>{{data.composition_title}}</b>\n                <hr>\n                <br>{{data.message}}\n                <br>{{'COMPOSITIONS.dialogWarning.toContinue' | translateHs: {app: data.app} }}\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-primary compositions-btn-warning\" (click)=\"close()\"\n                    data-dismiss=\"modal\">{{'COMMON.ignoreAndContinue' | translateHs: {app: data.app} }}</button>\n            </div>\n        </div>\n    </div>\n</div>", pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCompositionsWarningDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-compositions-warning-dialog', template: "<div class=\"modal in hs-composition-warning-dialog\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h4 class=\"modal-title\">{{'COMMON.warning' | translateHs: {app: data.app} }}</h4>\n                <button type=\"button\" (click)=\"close()\" class=\"btn-close\" data-dismiss=\"modal\"\n                    attr.aria-label=\"{{'COMMON.close' | translateHs: {app: data.app} }}\">\n                </button>\n            </div>\n            <div class=\"modal-body\" style=\"max-height: 600px; overflow-y: auto\">\n                <br>{{'COMMON.name' | translateHs: {app: data.app} }}: <b>{{data.composition_title}}</b>\n                <hr>\n                <br>{{data.message}}\n                <br>{{'COMPOSITIONS.dialogWarning.toContinue' | translateHs: {app: data.app} }}\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-primary compositions-btn-warning\" (click)=\"close()\"\n                    data-dismiss=\"modal\">{{'COMMON.ignoreAndContinue' | translateHs: {app: data.app} }}</button>\n            </div>\n        </div>\n    </div>\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsDialogContainerService }]; } });

class HsCompositionsLayerParserService {
    constructor(HsMapService, HsAddDataVectorService, HsStylerService, HsWmtsGetCapabilitiesService, HsLanguageService, HsToastService, HsUrlWfsService, hsWfsGetCapabilitiesService, hsAddDataCommonService, HsLaymanBrowserService) {
        this.HsMapService = HsMapService;
        this.HsAddDataVectorService = HsAddDataVectorService;
        this.HsStylerService = HsStylerService;
        this.HsWmtsGetCapabilitiesService = HsWmtsGetCapabilitiesService;
        this.HsLanguageService = HsLanguageService;
        this.HsToastService = HsToastService;
        this.HsUrlWfsService = HsUrlWfsService;
        this.hsWfsGetCapabilitiesService = hsWfsGetCapabilitiesService;
        this.hsAddDataCommonService = hsAddDataCommonService;
        this.HsLaymanBrowserService = HsLaymanBrowserService;
    }
    /**
     * @public
     * @param lyr_def - Layer definition object
     * @param app - App identifier
     * Initiate creation of WFS layer thorough HsUrlWfsService
     */
    createWFSLayer(lyr_def, app) {
        return __awaiter(this, void 0, void 0, function* () {
            this.hsAddDataCommonService.get(app).layerToSelect = lyr_def.name;
            const wrapper = yield this.hsWfsGetCapabilitiesService.request(lyr_def.protocol.url, app);
            return yield this.HsUrlWfsService.listLayerFromCapabilities(wrapper, app, lyr_def.style);
        });
    }
    /**
     * @public
     * Parse definition object to create WMTS Ol.layer  (source = ol.source.WMTS)
     * @param lyr_def - Layer definition object
     * @param app - App identifier
     * @returns Ol Tile layer
     */
    createWMTSLayer(lyr_def, app) {
        return __awaiter(this, void 0, void 0, function* () {
            const wmts = new Tile({
                source: new WMTS$1({}),
                properties: {
                    title: lyr_def.title,
                    info_format: lyr_def.info_format,
                },
            });
            // Get WMTS Capabilities and create WMTS source base on it
            const wrapper = yield this.HsWmtsGetCapabilitiesService.request(lyr_def.url, app);
            try {
                //parse the XML response and create options object...
                const parser = new WMTSCapabilities();
                const result = parser.read(wrapper.response);
                // ...create WMTS Capabilities based on the parsed options
                const options = optionsFromCapabilities(result, {
                    layer: lyr_def.layer,
                    matrixSet: lyr_def.matrixSet,
                    format: lyr_def.format,
                });
                // WMTS source for raster tiles layer
                wmts.setSource(new WMTS$1(options));
                this.HsMapService.proxifyLayerLoader(wmts, true, app);
            }
            catch (error) {
                this.HsToastService.createToastPopupMessage(this.HsLanguageService.getTranslation('ADDLAYERS.capabilitiesParsingProblem', undefined, app), this.HsLanguageService.getTranslationIgnoreNonExisting('ERRORMESSAGES', error, app), {
                    disableLocalization: true,
                    serviceCalledFrom: 'HsCompositionsLayerParserService',
                }, app);
                this.HsMapService.getMap(app).getLayers().remove(wmts);
            }
            wmts.setVisible(lyr_def.visibility);
            return wmts;
        });
    }
    /**
     * @public
     * Parse definition object to create WMS Ol.layer  (source = ol.source.ImageWMS / ol.source.TileWMS)
     * @param lyr_def - Layer definition object
     * @param app - App identifier
     * @returns Ol Image or Tile layer
     */
    createWmsLayer(lyr_def, app) {
        var _a;
        const params = lyr_def.params;
        const legends = this.getLegends(lyr_def);
        delete params.REQUEST;
        //delete params.FORMAT; Commented, because otherwise when loading from cookie or store, it displays jpeg
        const url = decodeURIComponent(lyr_def.url);
        const sourceOptions = {
            url: url,
            attributions: lyr_def.attribution
                ? `<a href="${lyr_def.attribution.OnlineResource}">${lyr_def.attribution.Title}</a>`
                : undefined,
            params,
            crossOrigin: 'anonymous',
            projection: (_a = lyr_def.projection) === null || _a === void 0 ? void 0 : _a.toUpperCase(),
            ratio: lyr_def.ratio,
        };
        const source = lyr_def.singleTile
            ? new ImageWMS(sourceOptions)
            : new TileWMS(sourceOptions);
        const layerOptions = {
            title: lyr_def.title,
            fromComposition: true,
            maxResolution: lyr_def.maxResolution || Infinity,
            minResolution: lyr_def.minResolution || 0,
            showInLayerManager: lyr_def.displayInLayerSwitcher,
            abstract: lyr_def.name || lyr_def.abstract,
            base: lyr_def.base,
            metadata: lyr_def.metadata,
            dimensions: lyr_def.dimensions,
            legends: legends,
            path: lyr_def.path,
            opacity: lyr_def.opacity || 1,
            source,
            subLayers: lyr_def.subLayers,
        };
        const new_layer = lyr_def.singleTile
            ? new Image$1(layerOptions)
            : new Tile(layerOptions);
        new_layer.setVisible(lyr_def.visibility);
        this.HsMapService.proxifyLayerLoader(new_layer, !lyr_def.singleTile, app);
        return new_layer;
    }
    /**
     * @public
     * Parse definition object to create ArcGIS Ol.layer  (source = ol.source.ImageArcGISRest / ol.source.TileArcGISRest)
     * @param lyr_def - Layer definition object
     * @returns Ol Image or Tile layer
     */
    createArcGISLayer(lyr_def) {
        var _a;
        const params = lyr_def.params;
        const legends = this.getLegends(lyr_def);
        if (params) {
            delete params.REQUEST;
        }
        //delete params.FORMAT; Commented, because otherwise when loading from cookie or store, it displays jpeg
        const sourceOptions = {
            url: decodeURIComponent(lyr_def.url),
            attributions: lyr_def.attribution
                ? `<a href="${lyr_def.attribution.OnlineResource}">${lyr_def.attribution.Title}</a>`
                : undefined,
            params,
            crossOrigin: 'anonymous',
            projection: (_a = lyr_def.projection) === null || _a === void 0 ? void 0 : _a.toUpperCase(),
            ratio: lyr_def.ratio,
        };
        const source = lyr_def.singleTile
            ? new ImageArcGISRest(sourceOptions)
            : new TileArcGISRest(sourceOptions);
        const layerOptions = {
            title: lyr_def.title,
            fromComposition: true,
            maxResolution: lyr_def.maxResolution || Infinity,
            minResolution: lyr_def.minResolution || 0,
            showInLayerManager: lyr_def.displayInLayerSwitcher,
            abstract: lyr_def.name || lyr_def.abstract,
            base: lyr_def.base,
            metadata: lyr_def.metadata,
            dimensions: lyr_def.dimensions,
            legends: legends,
            path: lyr_def.path,
            opacity: lyr_def.opacity || 1,
            source,
        };
        const new_layer = new lyr_def.singleTile()
            ? new Image$1(layerOptions)
            : new Tile(layerOptions);
        new_layer.setVisible(lyr_def.visibility);
        //TODO Proxify
        //OlMap.proxifyLayerLoader(new_layer, !lyr_def.singleTile);
        return new_layer;
    }
    /**
     * @public
     * @param lyr_def - Layer definition object
     * @returns Ol Image or Tile layer
     * Parse definition object to create XYZ Ol.layer
     */
    createXYZLayer(lyr_def) {
        var _a;
        const legends = this.getLegends(lyr_def);
        const source = new XYZ({
            url: decodeURIComponent(lyr_def.url),
            attributions: lyr_def.attribution
                ? `<a href="${lyr_def.attribution.OnlineResource}">${lyr_def.attribution.Title}</a>`
                : undefined,
            crossOrigin: 'anonymous',
            projection: (_a = lyr_def.projection) === null || _a === void 0 ? void 0 : _a.toUpperCase(),
            wrapX: lyr_def.wrapX,
            //TODO Add the rest of parameters and describe in the composition schema
        });
        const new_layer = new Tile({
            maxResolution: lyr_def.maxResolution || Infinity,
            minResolution: lyr_def.minResolution || 0,
            opacity: lyr_def.opacity || 1,
            source,
            properties: {
                title: lyr_def.title,
                fromComposition: true,
                showInLayerManager: lyr_def.displayInLayerSwitcher,
                abstract: lyr_def.name || lyr_def.abstract,
                base: lyr_def.base || lyr_def.url.indexOf('openstreetmap') > -1,
                metadata: lyr_def.metadata,
                dimensions: lyr_def.dimensions,
                legends: legends,
                path: lyr_def.path,
            },
        });
        new_layer.setVisible(lyr_def.visibility);
        //TODO Proxify
        //OlMap.proxifyLayerLoader(new_layer, !lyr_def.singleTile);
        return new_layer;
    }
    /**
     * @public
     * @param lyr_def - Layer definition object
     * @returns Ol Image or Tile layer
     * Parse definition object to create ImageStatic Ol.layer
     */
    createStaticImageLayer(lyr_def) {
        var _a;
        const legends = this.getLegends(lyr_def);
        const source = new ImageStatic({
            url: decodeURIComponent(lyr_def.url),
            attributions: lyr_def.attribution
                ? `<a href="${lyr_def.attribution.OnlineResource}">${lyr_def.attribution.Title}</a>`
                : undefined,
            imageExtent: lyr_def.extent,
            crossOrigin: 'anonymous',
            projection: (_a = lyr_def.projection) === null || _a === void 0 ? void 0 : _a.toUpperCase(),
            //TODO Add the rest of parameters and describe in the composition schema
        });
        const new_layer = new Image$1({
            maxResolution: lyr_def.maxResolution || Infinity,
            minResolution: lyr_def.minResolution || 0,
            opacity: lyr_def.opacity || 1,
            source,
            properties: {
                title: lyr_def.title,
                fromComposition: true,
                showInLayerManager: lyr_def.displayInLayerSwitcher,
                abstract: lyr_def.name || lyr_def.abstract,
                base: lyr_def.base,
                metadata: lyr_def.metadata,
                dimensions: lyr_def.dimensions,
                legends: legends,
                path: lyr_def.path,
            },
        });
        new_layer.setVisible(lyr_def.visibility);
        return new_layer;
    }
    /**
     * @public
     * @param lyr_def - Layer definition object
     * Parse definition object to create Sparql layer
     */
    createSparqlLayer(lyr_def, app) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = decodeURIComponent(lyr_def.protocol.url);
            const definition = {};
            definition.url = url;
            definition.format = 'hs.format.Sparql';
            let style = null;
            if (lyr_def.style) {
                style = (yield this.HsStylerService.parseStyle(lyr_def.style, app)).style;
            }
            const src = new SparqlJson({
                geom_attribute: '?geom',
                url: url,
                category: 'http://www.openvoc.eu/poi#categoryWaze',
                projection: 'EPSG:3857',
            });
            const lyr = new Vector$1({
                properties: {
                    title: lyr_def.title,
                    fromComposition: true,
                    definition,
                },
                source: src,
                opacity: lyr_def.opacity || 1,
                style: style,
            });
            lyr.setVisible(lyr_def.visibility);
            return lyr;
        });
    }
    /**
     * @public
     * @param lyr_def - Layer definition object
     * Get layer legends
     */
    getLegends(lyr_def) {
        if (lyr_def.legends) {
            return lyr_def.legends.map((legend) => decodeURIComponent(legend));
        }
        return [];
    }
    /**
     * @public
     * @param lyr_def - Layer definition object
     * @returns Either valid vector layer or function for creation of other supported vector file types)
     * Parse definition object to create Vector layer (classic Ol.vector, KML, GeoJSON, WFS, Sparql)
     */
    createVectorLayer(lyr_def, app) {
        var _a, _b, _c, _d, _e;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let format = '';
                if (lyr_def.protocol) {
                    format = lyr_def.protocol.format;
                    if (lyr_def.protocol.url !== undefined) {
                        lyr_def.protocol.url = decodeURIComponent(lyr_def.protocol.url);
                    }
                }
                const options = {
                    opacity: lyr_def.opacity || 1,
                    fromComposition: true,
                    path: lyr_def.path,
                    visible: lyr_def.visibility,
                    // Extract workspace name for partial backwards compatibility.
                    workspace: lyr_def.workspace ||
                        ((_a = lyr_def.protocol) === null || _a === void 0 ? void 0 : _a.url.split('geoserver/')[1].split('/')[0]),
                };
                let extractStyles = true;
                if (lyr_def.style) {
                    if (typeof lyr_def.style == 'string' &&
                        lyr_def.style.startsWith('http')) {
                        try {
                            lyr_def.style = yield this.HsLaymanBrowserService.getStyleFromUrl(lyr_def.style);
                        }
                        catch (ex) {
                            console.warn('Could not get style from ' + lyr_def.style);
                        }
                    }
                    Object.assign(options, yield this.HsStylerService.parseStyle(lyr_def.style, app));
                    extractStyles = false;
                }
                const title = lyr_def.title || 'Layer';
                let layer;
                switch (format) {
                    case 'ol.format.KML':
                        layer = yield this.HsAddDataVectorService.createVectorLayer('kml', lyr_def.protocol.url, lyr_def.name || title, title, lyr_def.abstract, (_b = lyr_def.projection) === null || _b === void 0 ? void 0 : _b.toUpperCase(), Object.assign(options, { extractStyles }), app);
                        break;
                    case 'ol.format.GeoJSON':
                        layer = yield this.HsAddDataVectorService.createVectorLayer('geojson', lyr_def.protocol.url, lyr_def.name || title, title, lyr_def.abstract, (_c = lyr_def.projection) === null || _c === void 0 ? void 0 : _c.toUpperCase(), options, app);
                        break;
                    case 'hs.format.WFS':
                    case 'WFS':
                        layer = yield this.HsAddDataVectorService.createVectorLayer('wfs', lyr_def.protocol.url, 
                        //lyr_def.protocol.LAYERS
                        lyr_def.name || title, title, lyr_def.abstract, (_d = lyr_def.projection) === null || _d === void 0 ? void 0 : _d.toUpperCase(), options, app);
                        break;
                    case 'hs.format.Sparql':
                        layer = yield this.createSparqlLayer(lyr_def, app);
                        break;
                    default:
                        const features = lyr_def.features
                            ? new GeoJSON().readFeatures(lyr_def.features, {
                                dataProjection: 'EPSG:4326',
                                featureProjection: this.HsMapService.getCurrentProj(app),
                            })
                            : undefined;
                        layer = yield this.HsAddDataVectorService.createVectorLayer('', undefined, lyr_def.name || title, title, lyr_def.abstract, (_e = lyr_def.projection) === null || _e === void 0 ? void 0 : _e.toUpperCase(), {
                            opacity: lyr_def.opacity,
                            visible: lyr_def.visibility,
                            path: lyr_def.path,
                            fromComposition: lyr_def.fromComposition,
                            style: lyr_def.style,
                            features,
                        }, app);
                }
                setDefinition(layer, lyr_def.protocol);
                return layer;
            }
            catch (error) {
                return null;
            }
        });
    }
}
HsCompositionsLayerParserService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCompositionsLayerParserService, deps: [{ token: HsMapService }, { token: HsAddDataVectorService }, { token: HsStylerService }, { token: HsWmtsGetCapabilitiesService }, { token: HsLanguageService }, { token: HsToastService }, { token: HsUrlWfsService }, { token: HsWfsGetCapabilitiesService }, { token: HsAddDataCommonService }, { token: HsLaymanBrowserService }], target: i0.ɵɵFactoryTarget.Injectable });
HsCompositionsLayerParserService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCompositionsLayerParserService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCompositionsLayerParserService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsMapService }, { type: HsAddDataVectorService }, { type: HsStylerService }, { type: HsWmtsGetCapabilitiesService }, { type: HsLanguageService }, { type: HsToastService }, { type: HsUrlWfsService }, { type: HsWfsGetCapabilitiesService }, { type: HsAddDataCommonService }, { type: HsLaymanBrowserService }]; } });

class HsCompositionsParserParams {
    constructor() {
        /**
         * @public
         * Stores current composition URL if there is one or NULL
         */
        this.composition_loaded = null;
        /**
         * @public
         * Stores whether current composition was edited (for composition changes, saving etc.)
         */
        this.composition_edited = false;
        /**
         * @public
         * Stores title of current composition
         */
        this.current_composition_title = '';
        this.loadingOptions = {
            suspendZoomingToExtent: false,
            suspendPanelChange: false,
        };
    }
}
class HsCompositionsParserService {
    constructor(hsMapService, hsConfig, $http, hsUtilsService, hsCompositionsLayerParserService, hsDialogContainerService, hsLayoutService, $log, hsEventBusService, hsLanguageService, hsCommonEndpointsService, hsLayerManagerService, hsToastService) {
        this.hsMapService = hsMapService;
        this.hsConfig = hsConfig;
        this.$http = $http;
        this.hsUtilsService = hsUtilsService;
        this.hsCompositionsLayerParserService = hsCompositionsLayerParserService;
        this.hsDialogContainerService = hsDialogContainerService;
        this.hsLayoutService = hsLayoutService;
        this.$log = $log;
        this.hsEventBusService = hsEventBusService;
        this.hsLanguageService = hsLanguageService;
        this.hsCommonEndpointsService = hsCommonEndpointsService;
        this.hsLayerManagerService = hsLayerManagerService;
        this.hsToastService = hsToastService;
        this.apps = { default: new HsCompositionsParserParams() };
    }
    /**
     * Get the params saved by the composition parser service for the current app
     * @param app - App identifier
     */
    get(app) {
        if (this.apps[app !== null && app !== void 0 ? app : 'default'] == undefined) {
            this.apps[app !== null && app !== void 0 ? app : 'default'] = new HsCompositionsParserParams();
        }
        return this.apps[app !== null && app !== void 0 ? app : 'default'];
    }
    /**
     * @public
     * Load selected composition from server, parse it and add layers to map.
     * Optionally (based on app config) may open layer manager panel
     * @param url - Url of selected composition
     * @param app - App identifier
     * @param overwrite - Whether overwrite current composition in map -
     * remove all layers from maps which originate from composition (if not pasted, it counts as "true")
     * @param callback - Optional function which should be called when composition is successfully loaded
     * @param pre_parse - Optional function for pre-parsing loaded data about composition to accepted format
     */
    loadUrl(url, //CSW recrod object
    app, overwrite, callback, pre_parse) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            if (typeof url !== 'string') {
                pre_parse = (res) => this.parseCSW(res);
                url.success = true;
                url.app = app;
                this.loaded(url, pre_parse, url, overwrite, callback, app);
                return;
            }
            this.get(app).current_composition_url = url;
            url = url.replace(/&amp;/g, '&');
            url = this.hsUtilsService.proxify(url, app);
            const options = {};
            if (url.includes('.wmc')) {
                pre_parse = (res) => this.parseWMC(res);
                options['responseType'] = 'text';
            }
            options['withCredentials'] = url.includes((_b = (_a = this.hsCommonEndpointsService) === null || _a === void 0 ? void 0 : _a.endpoints.find((ep) => ep.type == 'layman')) === null || _b === void 0 ? void 0 : _b.url);
            const data = yield lastValueFrom(this.$http.get(url, options)).catch((e) => {
                this.raiseCompositionLoadError(e, app);
            });
            if (data) {
                if (data.file) {
                    // Layman composition wrapper
                    return this.loadUrl(data.file.url, app, overwrite, callback, pre_parse);
                }
                this.loaded(data, pre_parse, url, overwrite, callback, app);
            }
        });
    }
    /**
     * Check if the response holds the composition data and try to load the composition object
     * @param response - Response from http get request requesting composition data
     * @param pre_parse - Function for pre-parsing loaded data about composition to accepted format
     * @param url - Url of selected composition
     * @param overwrite - Whether overwrite current composition in map -
     * remove all layers from maps which originate from composition (if not pasted, it counts as "true")
     * @param callback - Function which should be called when composition is successfully loaded
     * @param app - App identifier
     */
    loaded(response, pre_parse, url, overwrite, callback, app) {
        return __awaiter(this, void 0, void 0, function* () {
            this.hsEventBusService.compositionLoading.next(response);
            const appRef = this.get(app);
            if (this.checkLoadSuccess(response)) {
                appRef.composition_loaded = url;
                if (this.hsUtilsService.isFunction(pre_parse)) {
                    response = yield pre_parse(response);
                }
                response.workspace = appRef.current_composition_workspace;
                /*
                Response might contain {data:{abstract:...}} or {abstract:}
                directly. If there is data object,
                that means composition is enclosed in
                container which itself might contain title or extent
                properties */
                const loaded = yield this.loadCompositionObject(response.data || response, overwrite && !pre_parse, //For CSW comps we need to wait for dialog to resolve before removing existing layers
                app, response.title, response.extent);
                if (loaded) {
                    this.finalizeCompositionLoading(response, app);
                }
                if (this.hsUtilsService.isFunction(callback)) {
                    callback();
                }
            }
            else {
                this.raiseCompositionLoadError(response, app);
            }
        });
    }
    /**
     * Parse url from CSW compostion format layer/service
     */
    parseCSWLayer(layer) {
        if (!layer.online) {
            return;
        }
        for (const link of layer.online) {
            const type = servicesSupportedByUrl.find((type) => link.protocolUri.toLowerCase().includes(type));
            if (type) {
                return {
                    type: type,
                    title: layer.title,
                    url: link.url,
                    id: generateUuid(),
                };
            }
        }
    }
    /**
     * Parse CSW composition record extracting layers
     */
    getCSWLayers(record) {
        const layers = [];
        const services = [];
        for (const layer of record.operatesOn) {
            const layerObject = this.parseCSWLayer(layer);
            if (layerObject) {
                (layerObject.url.includes('LAYERS=') ? layers : services).push(layerObject);
            }
        }
        return { layers, services };
    }
    parseCSW(record) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const composition = {};
            composition['name'] = getLaymanFriendlyLayerName(record.title);
            composition['title'] = record.title;
            composition['scale'] = 1; //not nice
            composition['schema_version'] = '2.0.0'; //not nice
            composition['title'] = record.title;
            composition['abstract'] = record.abstract;
            const operatesOn = this.getCSWLayers(record);
            composition['layers'] = operatesOn['layers'];
            composition['services'] = operatesOn['services'];
            if (((_a = composition['layers']) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                composition['layers'].filter((l) => {
                    l.className = l.type == 'wms' ? 'HSLayers.Layer.WMS' : null;
                    l.params = {
                        FORMAT: 'image/png',
                        INFO_FORMAT: 'text/html',
                        LAYERS: l.url
                            .split('&')
                            .find((p) => p.includes('LAYERS'))
                            .split('=')[1],
                        VERSION: l.url
                            .split('&')
                            .find((p) => p.includes('VERSION'))
                            .split('=')[1],
                    };
                    l.url = l.url.split('?')[0];
                    return l.className;
                });
            }
            // "user": {
            //   "email": "leitnerfilip@gmail.com",
            //   "name": "Filip Leitner"
            // }
            return composition;
        });
    }
    /**
     * Parse WMC to JSON object
     * @param response - Response from http get request requesting composition data
     */
    parseWMC(response) {
        let res = xml2Json.xml2js(response, { compact: true });
        res = res.ViewContext;
        const compositionJSON = {
            current_base_layer: {
                title: 'Composite_base_layer',
            },
            extent: [
                parseFloat(res.General.BoundingBox._attributes['maxx']),
                parseFloat(res.General.BoundingBox._attributes['maxy']),
                parseFloat(res.General.BoundingBox._attributes['minx']),
                parseFloat(res.General.BoundingBox._attributes['miny']),
            ],
            layers: [],
            units: res.LayerList.Layer[0].Extension['ol:units']._text,
            scale: 1,
            id: res._attributes.id,
        };
        compositionJSON.name = res.General.Title._text;
        compositionJSON.projection = res.General.BoundingBox._attributes.SRS;
        compositionJSON.projection =
            compositionJSON.projection == 'EPSG:102067'
                ? 'EPSG:5514'
                : compositionJSON.projection;
        compositionJSON.extent = transformExtent(compositionJSON.extent, compositionJSON.projection, 'EPSG:4326');
        for (const layer of res.LayerList.Layer) {
            const layerToAdd = {
                className: 'HSLayers.Layer.WMS',
                dimensions: {},
                legends: [''],
                maxResolution: null,
                metadata: {},
                minResolution: 0,
                opacity: layer.Extension['ol:opacity']
                    ? parseFloat(layer.Extension['ol:opacity']._text)
                    : 1,
                showInLayerManager: layer.Extension['ol:displayInLayerSwitcher']._text,
                params: {
                    FORMAT: 'image/png',
                    INFO_FORMAT: 'text/html',
                    LAYERS: layer.Name._text,
                    VERSION: layer.Server._attributes.version,
                },
                ratio: 1.5,
                singleTile: true,
                title: layer.Extension['hsl:layer_title']._text,
                url: layer.Server.OnlineResource._attributes['xlink:href'],
                visibility: true,
            };
            compositionJSON.layers.push(layerToAdd);
        }
        const composition = { data: {} };
        composition.data = compositionJSON;
        return composition;
    }
    /**
     * Check if the response indicates a successful data request
     * @param response - Response from http get request requesting composition data
     */
    checkLoadSuccess(response) {
        return (response.success == true /*micka*/ ||
            (response.success == undefined /*layman*/ &&
                response.name !== undefined) ||
            response.includes('LayerList') /*.wmc micka*/);
    }
    loadCompositionObject(obj, overwrite, app = 'default', titleFromContainer, extentFromContainer) {
        return __awaiter(this, void 0, void 0, function* () {
            if (overwrite == undefined || overwrite == true) {
                this.hsMapService.removeCompositionLayers(app);
            }
            this.hsEventBusService.currentComposition.next(obj); //Doesnt seems to be used
            this.get(app).current_composition_title = titleFromContainer || obj.title;
            const possibleExtent = extentFromContainer || obj.extent;
            if (possibleExtent !== undefined &&
                !this.get(app).loadingOptions.suspendZoomingToExtent) {
                const extent = parseExtent(possibleExtent);
                if ((extent[0][0] < -90 && extent[0][1] < -180) ||
                    (extent[1][0] > 90 && extent[1][1] > 180)) {
                    this.loadWarningBootstrap(extent, app);
                }
                else {
                    this.hsMapService.fitExtent(transformExtentValue(extent, this.hsMapService.getCurrentProj(app)), app);
                }
            }
            //CSW serviceType compostitions
            const layers = yield this.jsonToLayers(obj, app);
            const confirmed = obj.services
                ? yield this.hsDialogContainerService
                    .create(CswLayersDialogComponent, { app: app, services: obj.services, layers: obj.layers }, app)
                    .waitResult()
                : true;
            if (confirmed) {
                if ((layers === null || layers === void 0 ? void 0 : layers.length) > 0) {
                    layers.forEach((lyr) => {
                        this.hsMapService.addLayer(lyr, app, DuplicateHandling.RemoveOriginal);
                    });
                    this.hsLayerManagerService.updateLayerListPositions(app);
                }
                if (obj.current_base_layer) {
                    this.hsMapService
                        .getMap(app)
                        .getLayers()
                        .forEach((lyr) => {
                        if (getTitle(lyr) == obj.current_base_layer.title ||
                            getTitle(lyr) == obj.current_base_layer) {
                            lyr.setVisible(true);
                        }
                    });
                }
                return true;
            }
            return false;
        });
    }
    /**
     * Finalize composition loading to the OL map
     * @param responseData - Response from http get request requesting composition data
     * @param app - App identifier
     */
    finalizeCompositionLoading(responseData, app) {
        const configRef = this.hsConfig.get(app);
        const open_lm_after_comp_loaded = configRef.open_lm_after_comp_loaded;
        const appRef = this.get(app);
        if ((open_lm_after_comp_loaded === true ||
            open_lm_after_comp_loaded === undefined) &&
            !appRef.loadingOptions.suspendPanelChange) {
            appRef.loadingOptions.suspendPanelChange = false;
            this.hsLayoutService.setMainPanel('layermanager', app);
        }
        appRef.composition_edited = false;
        this.hsEventBusService.compositionLoads.next({ data: responseData, app });
    }
    /**
     * Create an error message in case of on an unsuccessful composition load
     * @param response - Response from http get request requesting composition data
     * @param app - App identifier
     */
    raiseCompositionLoadError(response, app) {
        const respError = {};
        respError.error = response.error;
        switch (response.error) {
            case 'no data':
                respError.title = this.hsLanguageService.getTranslation('COMPOSITIONS.compositionNotFound', undefined, app);
                respError.abstract = this.hsLanguageService.getTranslation('COMPOSITIONS.sorryButComposition', undefined, app);
                break;
            default:
                respError.title = this.hsLanguageService.getTranslation('COMPOSITIONS.compositionNotLoaded', undefined, app);
                respError.abstract = this.hsLanguageService.getTranslation('COMPOSITIONS.weAreSorryBut', undefined, app);
                break;
        }
        this.hsEventBusService.compositionLoads.next({ data: respError, app });
    }
    /**
     * @public
     * Send Ajax request to selected server to gain information about composition
     * @param url - Url to composition info
     * @param app - App identifier
     * @returns Object containing composition info
     */
    loadInfo(url, app) {
        return __awaiter(this, void 0, void 0, function* () {
            url = url.replace(/&amp;/g, '&');
            url = this.hsUtilsService.proxify(url, app);
            let options;
            options = { responseType: 'json' };
            let response;
            if (url.endsWith('.wmc')) {
                options = { responseType: 'text' };
                response = yield lastValueFrom(this.$http.get(url, options));
                response = this.parseMickaWmcInfo(response);
            }
            else if (url.includes('GetRecordById')) {
                //CSW composition
                options = { responseType: 'text' };
                response = yield lastValueFrom(this.$http.get(url, options));
                response = this.parseMickaCSWInfo(response);
            }
            else {
                response = yield lastValueFrom(this.$http.get(url, options));
            }
            return response.data || response;
        });
    }
    /**
     * Parse Micka datasource WMC info to JSON object
     * @param response - Response from http get request requesting composition data
     * @returns Object containing composition info
     */
    parseMickaWmcInfo(response) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10;
        let res = xml2Json.xml2js(response, { compact: true });
        const layersInfo = (_a = res.ViewContext.LayerList) === null || _a === void 0 ? void 0 : _a.Layer;
        const keywordsInfo = (_b = res.ViewContext.General.KeywordList) === null || _b === void 0 ? void 0 : _b.Keyword;
        res = res.ViewContext.General;
        const infoDetails = {
            title: (_c = res.Title) === null || _c === void 0 ? void 0 : _c._text,
            abstract: (_d = res.Abstract) === null || _d === void 0 ? void 0 : _d._text,
            srs: (_f = (_e = res.BoundingBox) === null || _e === void 0 ? void 0 : _e._attributes) === null || _f === void 0 ? void 0 : _f.SRS,
            extent: [
                parseFloat((_g = res.BoundingBox) === null || _g === void 0 ? void 0 : _g._attributes['maxx']),
                parseFloat((_h = res.BoundingBox) === null || _h === void 0 ? void 0 : _h._attributes['maxy']),
                parseFloat((_j = res.BoundingBox) === null || _j === void 0 ? void 0 : _j._attributes['minx']),
                parseFloat((_k = res.BoundingBox) === null || _k === void 0 ? void 0 : _k._attributes['miny']),
            ],
            contactAddress: {
                address: (_o = (_m = (_l = res.ContactInformation) === null || _l === void 0 ? void 0 : _l.ContactAddress) === null || _m === void 0 ? void 0 : _m.Address) === null || _o === void 0 ? void 0 : _o._text,
                city: (_r = (_q = (_p = res.ContactInformation) === null || _p === void 0 ? void 0 : _p.ContactAddress) === null || _q === void 0 ? void 0 : _q.City) === null || _r === void 0 ? void 0 : _r._text,
                country: (_u = (_t = (_s = res.ContactInformation) === null || _s === void 0 ? void 0 : _s.ContactAddress) === null || _t === void 0 ? void 0 : _t.Country) === null || _u === void 0 ? void 0 : _u._text,
                postalCode: (_x = (_w = (_v = res.ContactInformation) === null || _v === void 0 ? void 0 : _v.ContactAddress) === null || _w === void 0 ? void 0 : _w.PostCode) === null || _x === void 0 ? void 0 : _x._text,
                stateOrProvince: (_0 = (_z = (_y = res.ContactInformation) === null || _y === void 0 ? void 0 : _y.ContactAddress) === null || _z === void 0 ? void 0 : _z.StateOrProvince) === null || _0 === void 0 ? void 0 : _0._text,
            },
            contactPersonPrimary: {
                organization: (_3 = (_2 = (_1 = res.ContactInformation) === null || _1 === void 0 ? void 0 : _1.ContactPersonPrimary) === null || _2 === void 0 ? void 0 : _2.ContactOrganization) === null || _3 === void 0 ? void 0 : _3._text,
                person: (_6 = (_5 = (_4 = res.ContactInformation) === null || _4 === void 0 ? void 0 : _4.ContactPersonPrimary) === null || _5 === void 0 ? void 0 : _5.ContactPerson) === null || _6 === void 0 ? void 0 : _6._text,
                phone: (_8 = (_7 = res.ContactInformation) === null || _7 === void 0 ? void 0 : _7.ContactVoiceTelephone) === null || _8 === void 0 ? void 0 : _8._text,
                email: (_10 = (_9 = res.ContactInformation) === null || _9 === void 0 ? void 0 : _9.ContactElectronicMailAddress) === null || _10 === void 0 ? void 0 : _10._text,
            },
        };
        if (layersInfo !== undefined) {
            infoDetails.layers = layersInfo.map((lyr) => {
                var _a;
                return {
                    title: (_a = lyr.Title) === null || _a === void 0 ? void 0 : _a._text,
                };
            });
        }
        if (keywordsInfo !== undefined) {
            Array.isArray(keywordsInfo)
                ? (infoDetails.keywords = keywordsInfo.map((kw) => kw._text))
                : (infoDetails.keywords = keywordsInfo._text);
        }
        return infoDetails;
    }
    parseMickaCSWInfo(response) {
        const res = xml2Json.xml2js(response, { compact: true });
        console.log(res);
        const serviceIdentification = res['csw:GetRecordByIdResponse']['gmd:MD_Metadata']['gmd:identificationInfo']['srv:SV_ServiceIdentification'];
        const layersInfo = serviceIdentification['srv:operatesOn'];
        const bbox = serviceIdentification['srv:extent']['gmd:EX_Extent']['gmd:geographicElement']['gmd:EX_GeographicBoundingBox'];
        const infoDetails = {
            title: serviceIdentification['gmd:citation']['gmd:CI_Citation']['gmd:title']['gco:CharacterString']._text,
            abstract: serviceIdentification['gmd:abstract']['gco:CharacterString']._text,
            extent: [
                parseFloat(bbox['gmd:eastBoundLongitude']['gco:Decimal']._text),
                parseFloat(bbox['gmd:southBoundLatitude']['gco:Decimal']._text),
                parseFloat(bbox['gmd:northBoundLatitude']['gco:Decimal']._text),
                parseFloat(bbox['gmd:westBoundLongitude']['gco:Decimal']._text),
            ],
        };
        if (layersInfo !== undefined) {
            infoDetails['layers'] = layersInfo.map((lyr) => {
                return {
                    title: lyr._attributes['xlink:title'],
                };
            });
        }
        let keywordsInfo = serviceIdentification['gmd:descriptiveKeywords'];
        keywordsInfo = Array.isArray(keywordsInfo)
            ? this.getCSWKeyWords(keywordsInfo)
            : keywordsInfo['gmd:MD_Keywords']['gmd:keyword'];
        if (keywordsInfo) {
            Array.isArray(keywordsInfo);
            infoDetails['keywords'] = keywordsInfo.map((kw) => kw['gco:CharacterString']._text);
        }
        return infoDetails;
    }
    getCSWKeyWords(keywordInfo) {
        var _a;
        let kw;
        for (const keywordObject of keywordInfo) {
            kw = (_a = keywordObject['gmd:MD_Keywords']['gmd:keyword']) !== null && _a !== void 0 ? _a : kw;
        }
        return [kw];
    }
    /**
     * Load and display a warning dialog about out of bounds extent
     * @param extent - Extent value
     * @param app - App identifier
     */
    loadWarningBootstrap(extent, app) {
        this.hsDialogContainerService.create(HsCompositionsWarningDialogComponent, {
            extent: extent,
            composition_title: this.get(app).current_composition_title,
            message: this.hsLanguageService.getTranslationIgnoreNonExisting('COMPOSITIONS.dialogWarning', 'outOfBounds', undefined, app),
        }, app);
    }
    /**
     * @public
     * Parse composition object to extract individual layers and add them to map
     * @param j - Composition object with Layers
     * @param app - App identifier
     * @returns Array of created layers
     */
    jsonToLayers(j, app) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const layers = [];
            if (j.data) {
                j = j.data;
            }
            const baselayersOnTop = (_a = j.layers[0]) === null || _a === void 0 ? void 0 : _a.base;
            for (const lyr_def of j.layers) {
                const layer = yield this.jsonToLayer(lyr_def, app);
                if (layer == undefined) {
                    if (lyr_def.protocol.format != 'hs.format.externalWFS') {
                        this.$log.warn('Was not able to parse layer from composition', lyr_def);
                        this.hsToastService.createToastPopupMessage(this.hsLanguageService.getTranslation('COMPOSITIONS.errorWhileCreatingLayerFromComposition'), this.hsLanguageService.getTranslation('COMPOSITIONS.notAbleToParseLayerFromComposition') + lyr_def.title, {
                            disableLocalization: true,
                            serviceCalledFrom: 'HsCompositionsParserService',
                        }, app);
                    }
                }
                else {
                    const addToList = baselayersOnTop ? 'push' : 'unshift';
                    layers[addToList](layer);
                }
            }
            return layers;
        });
    }
    /**
     * @public
     * Select correct layer parser for input data based on layer "className" property (HSLayers.Layer.WMS/OpenLayers.Layer.Vector)
     * @param lyr_def - Layer to be created (encapsulated in layer definition object)
     * @param app - App identifier
     * @returns Parser function to create layer (using config_parsers service)
     */
    jsonToLayer(lyr_def, app) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            let resultLayer;
            switch (lyr_def.className) {
                case 'HSLayers.Layer.WMS':
                case 'WMS':
                    resultLayer = this.hsCompositionsLayerParserService.createWmsLayer(lyr_def, app);
                    break;
                case 'HSLayers.Layer.WMTS':
                    resultLayer = this.hsCompositionsLayerParserService.createWMTSLayer(lyr_def, app);
                    break;
                case 'ArcGISRest':
                    resultLayer =
                        this.hsCompositionsLayerParserService.createArcGISLayer(lyr_def);
                    break;
                case 'XYZ':
                    resultLayer =
                        this.hsCompositionsLayerParserService.createXYZLayer(lyr_def);
                    break;
                case 'StaticImage':
                    resultLayer =
                        this.hsCompositionsLayerParserService.createStaticImageLayer(lyr_def);
                    break;
                case 'OpenLayers.Layer.Vector':
                case 'Vector':
                case 'hs.format.LaymanWfs':
                    if (((_a = lyr_def.protocol) === null || _a === void 0 ? void 0 : _a.format) == 'hs.format.externalWFS') {
                        this.hsCompositionsLayerParserService.createWFSLayer(lyr_def, app);
                    }
                    else {
                        resultLayer =
                            yield this.hsCompositionsLayerParserService.createVectorLayer(lyr_def, app);
                    }
                    break;
                default:
                    const existing = this.hsMapService
                        .getLayersArray(app)
                        .find((l) => getTitle(l) == lyr_def.title);
                    if (existing != undefined) {
                        existing.setZIndex(undefined);
                        return existing;
                    }
                    return;
            }
            if (resultLayer) {
                setMetadata(resultLayer, lyr_def.metadata);
                setSwipeSide(resultLayer, lyr_def.swipeSide);
            }
            return resultLayer;
        });
    }
}
HsCompositionsParserService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCompositionsParserService, deps: [{ token: HsMapService }, { token: HsConfig }, { token: i1.HttpClient }, { token: HsUtilsService }, { token: HsCompositionsLayerParserService }, { token: HsDialogContainerService }, { token: HsLayoutService }, { token: HsLogService }, { token: HsEventBusService }, { token: HsLanguageService }, { token: HsCommonEndpointsService }, { token: HsLayerManagerService }, { token: HsToastService }], target: i0.ɵɵFactoryTarget.Injectable });
HsCompositionsParserService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCompositionsParserService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCompositionsParserService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsMapService }, { type: HsConfig }, { type: i1.HttpClient }, { type: HsUtilsService }, { type: HsCompositionsLayerParserService }, { type: HsDialogContainerService }, { type: HsLayoutService }, { type: HsLogService }, { type: HsEventBusService }, { type: HsLanguageService }, { type: HsCommonEndpointsService }, { type: HsLayerManagerService }, { type: HsToastService }]; } });

class HsStatusManagerService {
    constructor(http, hsConfig, hsUtilsService, hsCommonEndpointsService) {
        this.http = http;
        this.hsConfig = hsConfig;
        this.hsUtilsService = hsUtilsService;
        this.hsCommonEndpointsService = hsCommonEndpointsService;
    }
    /**
     * Get status manager endpoint's url
     * @param app - App identifier
     */
    endpointUrl(app) {
        var _a, _b, _c, _d, _e, _f, _g;
        let hostName = location.protocol + '//' + location.host;
        if ((_b = (_a = this.hsConfig.get(app).hostname) === null || _a === void 0 ? void 0 : _a.status_manager) === null || _b === void 0 ? void 0 : _b.url) {
            return this.hsConfig.get(app).hostname.status_manager.url;
        }
        if ((_d = (_c = this.hsConfig.get(app).hostname) === null || _c === void 0 ? void 0 : _c.user) === null || _d === void 0 ? void 0 : _d.url) {
            hostName = this.hsConfig.get(app).hostname.user.url;
        }
        else if ((_f = (_e = this.hsConfig.get(app).hostname) === null || _e === void 0 ? void 0 : _e.default) === null || _f === void 0 ? void 0 : _f.url) {
            hostName = this.hsConfig.get(app).hostname.default.url;
        }
        if ((_g = this.hsConfig.get(app).status_manager_url) === null || _g === void 0 ? void 0 : _g.includes('://')) {
            //Full url specified
            return this.hsConfig.get(app).status_manager_url;
        }
        else {
            return (hostName + (this.hsConfig.get(app).status_manager_url || '/share/'));
        }
    }
    /**
     * Get status manager endpoint's description
     * @returns Status manager's endpoint
     */
    findStatusmanagerEndpoint() {
        const found = this.hsCommonEndpointsService.endpoints.filter((e) => e.type == 'status_manager');
        if (found.length > 0) {
            return found[0];
        }
    }
    /**
     * Save composition to Status manager's service
     * @param compositionJson - Json with composition's definition
     * @param endpoint - Endpoint's description
     * @param compoData - Additional data for composition
     * @param saveAsNew - Save as new composition
     * @returns Promise result of POST
     */
    save(compositionJson, endpoint, compoData, saveAsNew, app) {
        if (saveAsNew || compoData.id == '') {
            compoData.id = this.hsUtilsService.generateUuid();
        }
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield lastValueFrom(this.http.post(this.endpointUrl(app), {
                    data: compositionJson,
                    permanent: true,
                    id: compoData.id,
                    project: this.hsConfig.get(app).project_name,
                    thumbnail: compoData.thumbnail,
                    request: 'save',
                }));
                resolve(response);
            }
            catch (err) {
                reject();
            }
        }));
    }
}
HsStatusManagerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsStatusManagerService, deps: [{ token: i1.HttpClient }, { token: HsConfig }, { token: HsUtilsService }, { token: HsCommonEndpointsService }], target: i0.ɵɵFactoryTarget.Injectable });
HsStatusManagerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsStatusManagerService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsStatusManagerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: HsConfig }, { type: HsUtilsService }, { type: HsCommonEndpointsService }]; } });

class HsCompositionsMickaService {
    constructor($http, hsMapService, hsUtilsService, hsToastService, hsLanguageService) {
        this.$http = $http;
        this.hsMapService = hsMapService;
        this.hsUtilsService = hsUtilsService;
        this.hsToastService = hsToastService;
        this.hsLanguageService = hsLanguageService;
    }
    /**
     * Get Micka compositions query url
     * @param endpoint - Micka endpoint selected
     * @param params - HTTP request query params
     * @param bbox - Bounding box
     * @param app - App identifier
     */
    getCompositionsQueryUrl(endpoint, params, bbox, app) {
        const query = params.query;
        const bboxDelimiter = endpoint.url.indexOf('cswClientRun.php') > 0 ? ',' : ' ';
        const serviceName = endpoint.serviceName !== undefined
            ? 'serviceName=&' + endpoint.serviceName
            : '';
        bbox = params.filterByExtent
            ? encodeURIComponent(" and BBOX='" + bbox.join(bboxDelimiter) + "'")
            : '';
        const serviceTypeFilter = ' AND (serviceType like "Map" OR serviceType like "CSW" OR serviceType like "WMC")';
        const textFilter = query && query.title !== undefined && query.title != ''
            ? encodeURIComponent(" AND (title like '*" +
                query.title +
                "*' OR abstract like '*" +
                query.title +
                "*')")
            : '';
        const selected = [];
        let keywordFilter = '';
        let tmp = endpoint.url;
        for (const key of params.keywords) {
            if (key.selected) {
                selected.push("Subject='" + key.value + "'");
            }
        }
        for (const theme of params.themes) {
            if (theme.selected) {
                selected.push("Subject='" + theme.value + "'");
            }
        }
        if (selected.length > 0) {
            keywordFilter = encodeURIComponent(' AND ' + selected.join(' OR '));
        }
        tmp +=
            '?format=json&' +
                serviceName +
                'query=type%3D' +
                params.type +
                bbox +
                serviceTypeFilter +
                textFilter +
                keywordFilter +
                '&lang=eng&sortBy=' +
                params.sortBy +
                '&detail=summary&start=' +
                params.start +
                '&limit=' +
                params.limit;
        tmp = this.hsUtilsService.proxify(tmp, app);
        return tmp;
    }
    /**
     * Middleware function before returning compositions list to the rest of the app
     * @param endpoint - Micka endpoint selected
     * @param response - HTTP request response
     * @param app - App identifier
     */
    compositionsReceived(endpoint, response, app) {
        if (!response.records) {
            this.hsToastService.createToastPopupMessage(this.hsLanguageService.getTranslation('COMMON.warning', undefined, app), endpoint.title +
                ': ' +
                this.hsLanguageService.getTranslation('COMMON.noDataReceived', undefined, app), {
                disableLocalization: true,
                toastStyleClasses: 'bg-warning text-light',
                serviceCalledFrom: 'HsCompositionsMickaService',
            }, app);
            return;
        }
        endpoint.compositionsPaging.loaded = true;
        endpoint.compositions = response.records;
        if (response.records && response.records.length > 0) {
            endpoint.compositionsPaging.matched = response.matched;
        }
        else {
            endpoint.compositionsPaging.matched = 0;
        }
        endpoint.compositionsPaging.next = response.next;
        for (const record of endpoint.compositions) {
            record.editable = false;
            record.endpoint = endpoint;
            if (record.thumbnail == undefined) {
                record.thumbnail = endpoint.url + '?request=loadthumb&id=' + record.id;
            }
            if (response.extentFeatureCreated) {
                const extentFeature = addExtentFeature(record, this.hsMapService.getCurrentProj(app));
                if (extentFeature) {
                    record.featureId = extentFeature.getId().toString();
                    response.extentFeatureCreated(extentFeature);
                }
            }
        }
    }
    /**
     * Load composition list from the external Micka server
     * @param endpoint - Micka endpoint selected
     * @param params - HTTP request query params
     * @param extentFeatureCreated - Function for creating extent vector feature that will reference all listed composition from the response
     * @param bbox - Bounding box
     * @param app - App identifier
     */
    loadList(endpoint, params, extentFeatureCreated, bbox, app) {
        params = this.checkForParams(endpoint, params);
        const url = this.getCompositionsQueryUrl(endpoint, params, bbox, app);
        endpoint.compositionsPaging.loaded = false;
        endpoint.httpCall = this.$http
            .get(url, {
            responseType: 'json',
        })
            .pipe(timeout$1(5000), map$1((response) => {
            response.extentFeatureCreated = extentFeatureCreated;
            this.compositionsReceived(endpoint, response, app);
        }), catchError$1((e) => {
            this.hsToastService.createToastPopupMessage(this.hsLanguageService.getTranslation('COMPOSITIONS.errorWhileRequestingCompositions', undefined, app), endpoint.title +
                ': ' +
                this.hsLanguageService.getTranslationIgnoreNonExisting('ERRORMESSAGES', e.status ? e.status.toString() : e.message, { url: url }, app), {
                disableLocalization: true,
                serviceCalledFrom: 'HsCompositionsMickaService',
            }, app);
            return of(e);
        }));
        return endpoint.httpCall;
    }
    /**
     * Reset Micka composition paging values
     * @param endpoint - Micka endpoint selected
     * @param app - App identifier
     */
    resetCompositionCounter(endpoint) {
        endpoint.compositionsPaging.start = 0;
        endpoint.compositionsPaging.next = endpoint.compositionsPaging.limit;
        endpoint.compositionsPaging.matched = 0;
    }
    /**
     * Check if query params are correct and defined
     * @param endpoint - Micka endpoint selected
     * @param params - HTTP request query params
     */
    checkForParams(endpoint, params) {
        if (params.sortBy == undefined || params.sortBy === 'None') {
            params.sortBy = 'date:D';
        }
        if (params.type == undefined || params.type === 'None') {
            params.type = 'application';
        }
        if (params.start == undefined) {
            params.start = endpoint.compositionsPaging.start;
        }
        if (params.limit == undefined || isNaN(params.limit)) {
            params.limit = endpoint.compositionsPaging.limit;
        }
        return params;
    }
}
HsCompositionsMickaService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCompositionsMickaService, deps: [{ token: i1.HttpClient }, { token: HsMapService }, { token: HsUtilsService }, { token: HsToastService }, { token: HsLanguageService }], target: i0.ɵɵFactoryTarget.Injectable });
HsCompositionsMickaService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCompositionsMickaService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCompositionsMickaService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: HsMapService }, { type: HsUtilsService }, { type: HsToastService }, { type: HsLanguageService }]; } });

class HsCompositionsStatusManagerService {
    constructor(hsStatusManagerService, hsConfig, hsUtilsService, $http, hsEventBusService, hsToastService, hsLanguageService) {
        this.hsStatusManagerService = hsStatusManagerService;
        this.hsConfig = hsConfig;
        this.hsUtilsService = hsUtilsService;
        this.$http = $http;
        this.hsEventBusService = hsEventBusService;
        this.hsToastService = hsToastService;
        this.hsLanguageService = hsLanguageService;
    }
    /**
     * @public
     * Load list of compositions according to current
     * filter values and pager position (filter, keywords, current
     * extent, start composition, compositions number per page).
     * Display compositions extent in map. Loops through the existing
     * list of compositions, and when a composition is
     * found in statusmanagers list, then it becomes editable.
     * @param ds - Datasource selected
     * @param params - HTML query params
     * @param bbox - Bounding box
     * @param app - App identifier
     */
    loadList(ds, params, bbox, app) {
        let url = this.hsStatusManagerService.endpointUrl(app);
        const query = params.query;
        const textFilter = query && query.title !== undefined && query.title != ''
            ? '&q=' + encodeURIComponent('*' + query.title + '*')
            : '';
        url +=
            '?request=list&project=' +
                encodeURIComponent(this.hsConfig.get(app).project_name) +
                '&extent=' +
                bbox.join(',') +
                textFilter +
                '&start=0&limit=1000&sort=' +
                getStatusSortAttr(params.sortBy);
        url = this.hsUtilsService.proxify(url, app);
        if (ds.listLoading) {
            ds.listLoading.unsubscribe();
            delete ds.listLoading;
        }
        const listLoading = this.$http.get(url).pipe(timeout(2000), map((response) => response), catchError((e) => {
            var _a, _b, _c;
            if (isErrorHandlerFunction((_a = ds.onError) === null || _a === void 0 ? void 0 : _a.compositionLoad)) {
                (_b = ds.onError) === null || _b === void 0 ? void 0 : _b.compositionLoad.handle(ds, e);
                return of(e);
            }
            switch ((_c = ds.onError) === null || _c === void 0 ? void 0 : _c.compositionLoad) {
                case EndpointErrorHandling.ignore:
                    break;
                case EndpointErrorHandling.toast:
                default:
                    this.hsToastService.createToastPopupMessage(this.hsLanguageService.getTranslation('COMPOSITIONS.errorWhileRequestingCompositions', undefined, app), ds.title +
                        ': ' +
                        this.hsLanguageService.getTranslationIgnoreNonExisting('ERRORMESSAGES', e.status ? e.status.toString() : e.message, { url: url }, app), {
                        disableLocalization: true,
                        serviceCalledFrom: 'HsCompositionsStatusManagerService',
                    }, app);
            }
            return of(e);
        }));
        ds.listLoading = listLoading.subscribe((response) => {
            if (response.results === undefined) {
                return;
            }
            if (ds.compositions === undefined) {
                ds.compositions = [];
                ds.matched = 0;
            }
            for (const record of response.results) {
                let found = false;
                for (const composition of ds.compositions) {
                    if (composition.id == record.id) {
                        if (record.edit !== undefined) {
                            composition.editable = record.edit;
                        }
                        found = true;
                    }
                }
                if (!found) {
                    record.editable = false;
                    if (record.edit !== undefined) {
                        record.editable = record.edit;
                    }
                    if (record.link == undefined) {
                        record.link =
                            this.hsStatusManagerService.endpointUrl(app) +
                                '?request=load&id=' +
                                record.id;
                    }
                    if (record.thumbnail == undefined) {
                        record.thumbnail =
                            this.hsStatusManagerService.endpointUrl(app) +
                                '?request=loadthumb&id=' +
                                record.id;
                    }
                    const attributes = {
                        record: record,
                        hs_notqueryable: true,
                        highlighted: false,
                    };
                    if (record) {
                        ds.compositions.push(record);
                        ds.matched = ds.matched + 1;
                    }
                }
            }
        }, (err) => {
            //Do nothing
        });
    }
    /**
     * Delete selected composition
     * @param endpoint - Endpoint selected
     * @param composition - Composition to be deleted
     * @param app - App identifier
     */
    delete(endpoint, composition, app) {
        return __awaiter(this, void 0, void 0, function* () {
            let url = this.hsStatusManagerService.endpointUrl(app) +
                '?request=delete&id=' +
                composition.id +
                '&project=' +
                encodeURIComponent(this.hsConfig.get(app).project_name);
            url = this.hsUtilsService.proxify(url, app);
            yield lastValueFrom(this.$http.get(url));
            this.hsEventBusService.compositionDeletes.next({ composition, app });
        });
    }
}
HsCompositionsStatusManagerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCompositionsStatusManagerService, deps: [{ token: HsStatusManagerService }, { token: HsConfig }, { token: HsUtilsService }, { token: i1.HttpClient }, { token: HsEventBusService }, { token: HsToastService }, { token: HsLanguageService }], target: i0.ɵɵFactoryTarget.Injectable });
HsCompositionsStatusManagerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCompositionsStatusManagerService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCompositionsStatusManagerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsStatusManagerService }, { type: HsConfig }, { type: HsUtilsService }, { type: i1.HttpClient }, { type: HsEventBusService }, { type: HsToastService }, { type: HsLanguageService }]; } });
/**
 * Get status manager sort attribute value
 * @param sortBy - Sorting value
 */
function getStatusSortAttr(sortBy) {
    const sortMap = {
        bbox: '[{"property":"bbox","direction":"ASC"}]',
        title: '[{"property":"title","direction":"ASC"}]',
        date: '[{"property":"date","direction":"ASC"}]',
    };
    return encodeURIComponent(sortMap[sortBy]);
}

class HsCompositionsStatusManagerMickaJointService {
    constructor(hsCompositionsStatusManagerService, hsCompositionsMickaService, hsCompositionsParserService, hsToastService, hsLanguageService) {
        this.hsCompositionsStatusManagerService = hsCompositionsStatusManagerService;
        this.hsCompositionsMickaService = hsCompositionsMickaService;
        this.hsCompositionsParserService = hsCompositionsParserService;
        this.hsToastService = hsToastService;
        this.hsLanguageService = hsLanguageService;
    }
    /**
     * @public
     * Load list of compositions according to current
     * filter values and pager position (filter, keywords, current
     * extent, start composition, compositions number per page).
     * Display compositions extent in map. Loops through the existing
     * list of compositions, and when a composition is
     * found in statusmanagers list, then it becomes editable.
     * @param ds - Datasource selected
     * @param params - HTML query params
     * @param bbox - Bounding box
     */
    loadList(ds, params, extentFeatureCreated, bbox, app) {
        const Observable = this.hsCompositionsMickaService
            .loadList(ds, params, extentFeatureCreated, bbox, app)
            .pipe(map$1((response) => {
            this.hsCompositionsStatusManagerService.loadList(ds, params, bbox, app);
        }), catchError$1((e) => {
            var _a, _b, _c;
            if (isErrorHandlerFunction((_a = ds.onError) === null || _a === void 0 ? void 0 : _a.compositionLoad)) {
                (_b = ds.onError) === null || _b === void 0 ? void 0 : _b.compositionLoad.handle(ds, e);
                return of(e);
            }
            switch ((_c = ds.onError) === null || _c === void 0 ? void 0 : _c.compositionLoad) {
                case EndpointErrorHandling.ignore:
                    break;
                case EndpointErrorHandling.toast:
                default:
                    this.hsToastService.createToastPopupMessage(this.hsLanguageService.getTranslation('COMPOSITIONS.errorWhileRequestingCompositions', undefined, app), ds.title +
                        ': ' +
                        this.hsLanguageService.getTranslationIgnoreNonExisting('ERRORMESSAGES', e.status ? e.status.toString() : e.message, { url: ds.url }, app), {
                        disableLocalization: true,
                        serviceCalledFrom: 'HsCompositionsStatusManagerMickaJointService',
                    }, app);
            }
            return of(e);
        }));
        return Observable;
    }
    /**
     * Get information about the selected composition
     * @param composition - Composition selected
     * @param app - App identifier
     */
    getInfo(composition, app) {
        return __awaiter(this, void 0, void 0, function* () {
            const compLinks = composition.link || composition.links;
            if (compLinks === undefined) {
                return;
            }
            const compUrls = this.getCompositionUrls(compLinks);
            let info = {};
            let url = '';
            Array.isArray(compUrls) ? (url = compUrls[0]) : (url = compUrls);
            try {
                info = yield this.hsCompositionsParserService.loadInfo(url, app);
                //TODO: find out if this is even available
                // info.thumbnail = this.HsUtilsService.proxify(composition.thumbnail);
                info.metadata = {
                    record_url: composition.endpoint.url.replace('csw', 'record/basic/') +
                        composition.id,
                };
                return info;
            }
            catch (e) {
                this.hsToastService.createToastPopupMessage(this.hsLanguageService.getTranslation('COMPOSITIONS.errorWhileLoadingCompositionMetadata', undefined, app), this.hsLanguageService.getTranslationIgnoreNonExisting('ERRORMESSAGES', e.status ? e.status.toString() : e.message, { url: url }, app), {
                    disableLocalization: true,
                    serviceCalledFrom: 'HsCompositionsStatusManagerMickaJointService',
                }, app);
            }
        });
    }
    /**
     * Delete selected composition from endpoint database
     * @param endpoint - Endpoint selected
     * @param composition - Composition to be deleted
     * @param app - App identifier
     */
    delete(endpoint, composition, app) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.hsCompositionsStatusManagerService.delete(endpoint, composition, app);
        });
    }
    /**
     * Get composition urls
     * @param compData - Composition data
     */
    getCompositionUrls(compData) {
        if (typeof compData == 'string') {
            return compData;
        }
        if (typeof compData == 'object' && compData.url !== undefined) {
            return compData.url;
        }
        return compData.map((link) => typeof link == 'object' && link.url !== undefined ? link.url : link);
    }
}
HsCompositionsStatusManagerMickaJointService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCompositionsStatusManagerMickaJointService, deps: [{ token: HsCompositionsStatusManagerService }, { token: HsCompositionsMickaService }, { token: HsCompositionsParserService }, { token: HsToastService }, { token: HsLanguageService }], target: i0.ɵɵFactoryTarget.Injectable });
HsCompositionsStatusManagerMickaJointService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCompositionsStatusManagerMickaJointService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCompositionsStatusManagerMickaJointService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsCompositionsStatusManagerService }, { type: HsCompositionsMickaService }, { type: HsCompositionsParserService }, { type: HsToastService }, { type: HsLanguageService }]; } });

class HsCompositionsLaymanService {
    constructor($http, hsCommonLaymanService, hsCompositionsParserService, hsEventBusService, hsToastService, hsLanguageService, hsMapService) {
        this.$http = $http;
        this.hsCommonLaymanService = hsCommonLaymanService;
        this.hsCompositionsParserService = hsCompositionsParserService;
        this.hsEventBusService = hsEventBusService;
        this.hsToastService = hsToastService;
        this.hsLanguageService = hsLanguageService;
        this.hsMapService = hsMapService;
    }
    /**
     * Load composition list from the external Layman server
     * @param endpoint - Layman endpoint selected
     * @param params - HTTP request query params
     * @param extentFeatureCreated - Function for creating extent vector feature that will reference all listed composition from the response
     * @param _bbox - Bounding box
     * @param app - App identifier
     */
    loadList(endpoint, params, extentFeatureCreated, _bbox, app) {
        endpoint.getCurrentUserIfNeeded(endpoint, app);
        endpoint.compositionsPaging.loaded = false;
        const query = params.query.title ? params.query.title : '';
        const sortBy = params.sortBy == 'date:D'
            ? 'last_change'
            : params.sortBy !== undefined && params.sortBy != 'None' //Set by date by default, was requested long time ago
                ? params.sortBy
                : 'last_change';
        const b = transformExtent(this.hsMapService
            .getMap(app)
            .getView()
            .calculateExtent(this.hsMapService.getMap(app).getSize()), this.hsMapService.getCurrentProj(app), 'EPSG:3857');
        const bbox = params.filterByExtent ? b.join(',') : '';
        const withPermissionOrMine = params.filterByOnlyMine
            ? endpoint.user !== 'anonymous' && endpoint.user !== 'browser'
                ? `workspaces/${endpoint.user}/`
                : ''
            : '';
        const url = `${endpoint.url}/rest/${withPermissionOrMine}maps`;
        endpoint.listLoading = this.$http
            .get(url, {
            observe: 'response',
            withCredentials: true,
            params: {
                'limit': `${endpoint.compositionsPaging.limit}`,
                'offset': `${endpoint.compositionsPaging.start}`,
                'full_text_filter': `${query}`,
                'order_by': `${sortBy}`,
                'bbox_filter': `${bbox}`,
            },
        })
            .pipe(timeout(5000), map((response) => {
            if (Array.isArray(response.body)) {
                response.body.extentFeatureCreated = extentFeatureCreated;
                this.compositionsReceived(endpoint, response, app);
            }
            else {
                this.hsCommonLaymanService.displayLaymanError(endpoint, 'COMPOSITIONS.errorWhileRequestingCompositions', response.body, app);
            }
        }), catchError((e) => {
            var _a, _b, _c;
            if (isErrorHandlerFunction((_a = endpoint.onError) === null || _a === void 0 ? void 0 : _a.compositionLoad)) {
                (_b = endpoint.onError) === null || _b === void 0 ? void 0 : _b.compositionLoad.handle(endpoint, e);
                return of(e);
            }
            switch ((_c = endpoint.onError) === null || _c === void 0 ? void 0 : _c.compositionLoad) {
                case EndpointErrorHandling.ignore:
                    break;
                case EndpointErrorHandling.toast:
                default:
                    this.hsToastService.createToastPopupMessage(this.hsLanguageService.getTranslation('COMPOSITIONS.errorWhileRequestingCompositions', undefined, app), endpoint.title +
                        ': ' +
                        this.hsLanguageService.getTranslationIgnoreNonExisting('ERRORMESSAGES', e.status ? e.status.toString() : e.message, { url: endpoint.url }, app), {
                        disableLocalization: true,
                        serviceCalledFrom: 'HsCompositionsLaymanService',
                    }, app);
                    break;
            }
            return of(e);
        }));
        return endpoint.listLoading;
    }
    /**
     * Middleware function before returning compositions list to the rest of the app
     * @param endpoint - Layman endpoint selected
     * @param response - HTTP request response
     * @param app - App identifier
     */
    compositionsReceived(endpoint, response, app) {
        if (response.body.length == 0) {
            endpoint.compositionsPaging.matched = 0;
            this.displayWarningToast(endpoint, 'COMMON.noDataReceived', app);
            return;
        }
        endpoint.compositionsPaging.loaded = true;
        endpoint.compositionsPaging.matched = response.headers.get('x-total-count') // in case response is an error, x-total-count will return null, it must be checked
            ? parseInt(response.headers.get('x-total-count'))
            : response.body.length;
        endpoint.compositions = response.body.map((record) => {
            const tmp = {
                name: record.name,
                title: record.title,
                access_rights: record.access_rights,
                featureId: undefined,
                highlighted: false,
                editable: record.access_rights.write.some((user) => {
                    return [endpoint.user, 'EVERYONE'].includes(user);
                }),
                url: `${endpoint.url}/rest/workspaces/${record.workspace}/maps/${record.name}`,
                endpoint,
                workspace: record.workspace,
                id: `m-${record.uuid}`, //m-* to match micka's id structure.
            };
            if (response.body.extentFeatureCreated) {
                const extentFeature = addExtentFeature(record, this.hsMapService.getCurrentProj(app));
                if (extentFeature) {
                    tmp.featureId = extentFeature.getId().toString();
                    response.body.extentFeatureCreated(extentFeature);
                }
            }
            return tmp;
        });
    }
    /**
     * Delete selected composition from Layman database
     * @param endpoint - Layman endpoint selected
     * @param composition - Composition to be deleted
     */
    delete(endpoint, composition, app) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${endpoint.url}/rest/workspaces/${composition.workspace}/maps/${composition.name}`;
            yield lastValueFrom(this.$http.delete(url, { withCredentials: true }));
            this.hsEventBusService.compositionDeletes.next({ composition, app });
        });
    }
    /**
     * Get information about the selected composition
     * @param composition - Composition selected
     * @param app - App identifier
     */
    getInfo(composition, app) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = composition.endpoint;
            if (composition.name == undefined) {
                this.displayWarningToast(endpoint, 'COMPOSITIONS.compostionsNameAttributeIsNotDefined', app);
                return;
            }
            if (endpoint.user == undefined) {
                this.displayWarningToast(endpoint, 'COMPOSITIONS.endpointUserIsNotDefined', app);
                return;
            }
            if (endpoint.url == undefined) {
                this.displayWarningToast(endpoint, 'COMPOSITIONS.endpointUrlIsNotDefined', app);
                return;
            }
            const url = `${endpoint.url}/rest/workspaces/${composition.workspace}/maps/${composition.name}`;
            const info = yield this.hsCompositionsParserService.loadInfo(url, app);
            if (((_a = info.thumbnail) === null || _a === void 0 ? void 0 : _a.status) !== undefined &&
                ((_b = info.thumbnail) === null || _b === void 0 ? void 0 : _b.status) == 'NOT_AVAILABLE') {
                delete info.thumbnail;
            }
            info.abstract = info.description;
            return info;
        });
    }
    /**
     * Reset Layman composition paging values
     * @param endpoint - Layman endpoint selected
     */
    resetCompositionCounter(endpoint) {
        endpoint.compositionsPaging.start = 0;
        endpoint.compositionsPaging.next = endpoint.compositionsPaging.limit;
        endpoint.compositionsPaging.matched = 0;
    }
    /**
     * Display warning toast about some error while requesting compositions
     * @param endpoint - Layman endpoint selected
     * @param message - Message to be displayed when warning is issued
     * @param app - App identifier
     */
    displayWarningToast(endpoint, message, app) {
        this.hsToastService.createToastPopupMessage(this.hsLanguageService.getTranslation('COMMON.warning', undefined, app), endpoint.title + ': ' + this.hsLanguageService.getTranslation(message), {
            disableLocalization: true,
            toastStyleClasses: 'bg-warning text-light',
            serviceCalledFrom: 'HsCompositionsLaymanService',
        }, app);
    }
}
HsCompositionsLaymanService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCompositionsLaymanService, deps: [{ token: i1.HttpClient }, { token: HsCommonLaymanService }, { token: HsCompositionsParserService }, { token: HsEventBusService }, { token: HsToastService }, { token: HsLanguageService }, { token: HsMapService }], target: i0.ɵɵFactoryTarget.Injectable });
HsCompositionsLaymanService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCompositionsLaymanService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCompositionsLaymanService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: HsCommonLaymanService }, { type: HsCompositionsParserService }, { type: HsEventBusService }, { type: HsToastService }, { type: HsLanguageService }, { type: HsMapService }]; } });

class HsCompositionsMapService {
    constructor(hsEventBusService, hsMapService, hsLayoutService, hsSaveMapService, hsLayerUtilsService, hsCommonEndpointsService) {
        this.hsEventBusService = hsEventBusService;
        this.hsMapService = hsMapService;
        this.hsLayoutService = hsLayoutService;
        this.hsSaveMapService = hsSaveMapService;
        this.hsLayerUtilsService = hsLayerUtilsService;
        this.hsCommonEndpointsService = hsCommonEndpointsService;
        this.apps = {
            default: {
                extentLayer: this.createNewExtentLayer(),
            },
        };
        this.hsEventBusService.mainPanelChanges.subscribe(({ which, app }) => {
            const appRef = this.get(app);
            if (appRef.extentLayer) {
                if (this.hsLayoutService.get(app).mainpanel === 'composition_browser' ||
                    this.hsLayoutService.get(app).mainpanel === 'composition') {
                    appRef.extentLayer.setVisible(true);
                }
                else {
                    appRef.extentLayer.setVisible(false);
                }
            }
        });
    }
    /**
     * Initialize compositions map service data and listeners
     * @param app - App identifier
     */
    init(app) {
        const appRef = this.get(app);
        this.hsMapService.loaded(app).then((map) => {
            map.on('pointermove', (e) => this.mapPointerMoved(e, app));
            map.addLayer(appRef.extentLayer);
            this.hsSaveMapService.internalLayers.push(appRef.extentLayer);
        });
    }
    /**
     * Create new extent layer
     */
    createNewExtentLayer() {
        return new VectorLayer({
            properties: {
                title: 'Composition extents',
                showInLayerManager: false,
                removable: false,
            },
            source: new Vector(),
            style: function (feature, resolution) {
                return [
                    new Style({
                        stroke: new Stroke({
                            color: '#005CB6',
                            width: getHighlighted(feature) ? 4 : 1,
                        }),
                        fill: new Fill({
                            color: 'rgba(0, 0, 255, 0.01)',
                        }),
                    }),
                ];
            },
        });
    }
    /**
     * Get the params saved by the composition map service for the current app
     * @param app - App identifier
     */
    get(app) {
        if (this.apps[app !== null && app !== void 0 ? app : 'default'] == undefined) {
            this.apps[app !== null && app !== void 0 ? app : 'default'] = { extentLayer: this.createNewExtentLayer() };
        }
        return this.apps[app !== null && app !== void 0 ? app : 'default'];
    }
    /**
     * Act on map pointer movement and highlight features under it
     * @param evt -
     * @param app - App identifier
     */
    mapPointerMoved(evt, app) {
        const appRef = this.get(app);
        const featuresUnderMouse = appRef.extentLayer
            .getSource()
            .getFeaturesAtCoordinate(evt.coordinate);
        for (const endpoint of this.hsCommonEndpointsService.endpoints.filter((ep) => ep.compositions)) {
            this.hsLayerUtilsService.highlightFeatures(featuresUnderMouse, appRef.extentLayer, endpoint.compositions);
        }
    }
    /**
     * Highlight composition from map feature referencing it
     * @param composition - Composition highlighted from map feature reference
     * @param state - Highlighte state
     * @param app - App identifier
     */
    highlightComposition(composition, state, app) {
        if (composition.featureId !== undefined) {
            const found = this.get(app)
                .extentLayer.getSource()
                .getFeatureById(composition.featureId);
            if (found) {
                setHighlighted(found, state);
            }
        }
    }
    /**
     * Clear extent layer from all of the features
     * @param app - App identifier
     */
    clearExtentLayer(app) {
        this.get(app).extentLayer.getSource().clear();
    }
    /**
     * Callback function which gets executed when extent feature
     * is created. It should add the feature to vector layer source
     * @param extentFeature - OpenLayers Feature
     */
    addExtentFeature(extentFeature, app) {
        this.get(app).extentLayer.getSource().addFeatures([extentFeature]);
    }
    /**
     * Get feature record and unhighlight the same feature and composition
     * @param feature - Feature under the pointer
     * @param selector - Feature selector
     * @param list - Record list referenced from the feature
     * @param app - App identifier
     */
    getFeatureRecordAndUnhighlight(feature, selector, list, app) {
        const record = list === null || list === void 0 ? void 0 : list.find((record) => record.featureId == feature.getId());
        if (this.hsMapService.getLayerForFeature(feature, app) ==
            this.get(app).extentLayer &&
            record) {
            setHighlighted(feature, false);
            selector.getFeatures().clear();
            return record;
        }
    }
}
HsCompositionsMapService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCompositionsMapService, deps: [{ token: HsEventBusService }, { token: HsMapService }, { token: HsLayoutService }, { token: HsSaveMapService }, { token: HsLayerUtilsService }, { token: HsCommonEndpointsService }], target: i0.ɵɵFactoryTarget.Injectable });
HsCompositionsMapService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCompositionsMapService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCompositionsMapService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsEventBusService }, { type: HsMapService }, { type: HsLayoutService }, { type: HsSaveMapService }, { type: HsLayerUtilsService }, { type: HsCommonEndpointsService }]; } });

class HsCompositionsParams {
    constructor() {
        this.data = {};
        this.notSavedCompositionLoading = new Subject();
        this.compositionNotFoundAtUrl = new Subject();
    }
}
class HsCompositionsService {
    constructor(http, hsMapService, hsCore, hsCompositionsParserService, hsConfig, hsPermalinkUrlService, hsUtilsService, hsStatusManagerService, hsCompositionsMickaService, hsCompositionsStatusManagerMickaJointService, hsCompositionsLaymanService, hsLanguageService, $log, hsCommonEndpointsService, hsCompositionsMapService, hsEventBusService, hsToastService) {
        this.http = http;
        this.hsMapService = hsMapService;
        this.hsCore = hsCore;
        this.hsCompositionsParserService = hsCompositionsParserService;
        this.hsConfig = hsConfig;
        this.hsPermalinkUrlService = hsPermalinkUrlService;
        this.hsUtilsService = hsUtilsService;
        this.hsStatusManagerService = hsStatusManagerService;
        this.hsCompositionsMickaService = hsCompositionsMickaService;
        this.hsCompositionsStatusManagerMickaJointService = hsCompositionsStatusManagerMickaJointService;
        this.hsCompositionsLaymanService = hsCompositionsLaymanService;
        this.hsLanguageService = hsLanguageService;
        this.$log = $log;
        this.hsCommonEndpointsService = hsCommonEndpointsService;
        this.hsCompositionsMapService = hsCompositionsMapService;
        this.hsEventBusService = hsEventBusService;
        this.hsToastService = hsToastService;
        this.apps = { default: new HsCompositionsParams() };
        this.hsEventBusService.compositionEdits.subscribe(({ app }) => {
            this.hsCompositionsParserService.get(app).composition_edited = true;
        });
        this.hsEventBusService.compositionLoadStarts.subscribe(({ id, app }) => {
            id = `${this.hsStatusManagerService.endpointUrl(app)}?request=load&id=${id}`;
            this.hsCompositionsParserService.loadUrl(id, app);
        });
    }
    /**
     * Get the params saved by the composition service for the current app
     * @param app - App identifier
     */
    get(app) {
        if (this.apps[app !== null && app !== void 0 ? app : 'default'] == undefined) {
            this.apps[app !== null && app !== void 0 ? app : 'default'] = new HsCompositionsParams();
        }
        return this.apps[app !== null && app !== void 0 ? app : 'default'];
    }
    /**
     * Initialize the composition service data and subscribers
     * @param _app - App identifier
     */
    init(_app) {
        this.tryParseCompositionFromUrlParam(_app);
        this.parsePermalinkLayers(_app);
        if (this.hsConfig.get(_app).saveMapStateOnReload) {
            //Load composition data from cookies only if it is anticipated
            setTimeout(() => {
                this.tryParseCompositionFromCookie(_app);
            }, 500);
        }
        this.hsEventBusService.mapResets.subscribe(({ app }) => {
            if (app == _app) {
                this.hsCompositionsParserService.get(app).composition_loaded = null;
                this.hsCompositionsParserService.get(app).composition_edited = false;
            }
        });
        this.hsEventBusService.vectorQueryFeatureSelection.subscribe((e) => {
            if (e.app == _app) {
                for (const endpoint of this.hsCommonEndpointsService.endpoints) {
                    const record = this.hsCompositionsMapService.getFeatureRecordAndUnhighlight(e.feature, e.selector, endpoint.compositions, _app);
                    if (record) {
                        this.loadComposition(this.getRecordLink(record), _app);
                    }
                }
            }
        });
    }
    /**
     * Load composition list
     * @param ds - Datasource endpoint
     * @param params - Provided params for querying list items
     * @param app - App identifier
     */
    loadCompositions(ds, params, app) {
        this.hsCompositionsMapService.clearExtentLayer(app);
        const bbox = this.hsMapService.getMapExtentInEpsg4326(app);
        const Observable = this.managerByType(ds).loadList(ds, params, (feature) => this.hsCompositionsMapService.addExtentFeature(feature, app), bbox, app);
        return Observable;
    }
    /**
     * Reset composition counters for datasource endpoints
     */
    resetCompositionCounter() {
        this.hsCommonEndpointsService.endpoints.forEach((ep) => {
            switch (ep.type) {
                case 'micka':
                    return this.hsCompositionsMickaService.resetCompositionCounter(ep);
                case 'layman':
                    return this.hsCompositionsLaymanService.resetCompositionCounter(ep);
                default:
                    this.$log.warn(`Endpoint type '${ep.type} not supported`);
            }
        });
    }
    /**
     * Find and return required service reference for each endpoint type
     * @param endpoint - Datasource endpoint
     */
    managerByType(endpoint) {
        switch (endpoint.type) {
            case 'micka':
                return this.hsCompositionsStatusManagerMickaJointService;
            case 'layman':
                return this.hsCompositionsLaymanService;
            default:
                this.$log.warn(`Endpoint type '${endpoint.type} not supported`);
        }
    }
    /**
     * Delete composition from datasource database
     * @param composition - Composition selected
     */
    deleteComposition(composition, app) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            yield ((_a = this.managerByType(composition.endpoint)) === null || _a === void 0 ? void 0 : _a.delete(composition.endpoint, composition, app));
        });
    }
    /**
     * Share composition to other platforms
     * @param record - Datasource record selected
     * @param app - App identifier
     */
    shareComposition(record, app) {
        return __awaiter(this, void 0, void 0, function* () {
            const appRef = this.get(app);
            const recordLink = encodeURIComponent(this.getRecordLink(record));
            const permalinkOverride = this.hsConfig.get(app).permalinkLocation;
            const compositionUrl = this.hsCore.isMobile() && permalinkOverride
                ? permalinkOverride.origin + permalinkOverride.pathname
                : `${location.origin}${location.pathname}?composition=${recordLink}`;
            appRef.shareId = this.hsUtilsService.generateUuid();
            const headers = new HttpHeaders().set('Content-Type', 'text/plain; charset=utf-8');
            return yield lastValueFrom(this.http.post(this.hsStatusManagerService.endpointUrl(app), JSON.stringify({
                request: 'socialShare',
                id: appRef.shareId,
                url: encodeURIComponent(compositionUrl),
                title: record.title,
                description: record.abstract,
                image: record.thumbnail || 'https://ng.hslayers.org/img/logo.png',
            }), { headers, responseType: 'text' }));
        });
    }
    /**
     * Get composition share url
     * @param app - App identifier
     */
    getShareUrl(app) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield this.hsUtilsService.shortUrl(this.hsStatusManagerService.endpointUrl(app) +
                    '?request=socialshare&id=' +
                    this.get(app).shareId, app);
            }
            catch (ex) {
                this.$log.log('Error creating short URL');
            }
        });
    }
    /**
     * Get composition information
     * @param composition - Composition selected
     * @param app - App identifier
     */
    getCompositionInfo(composition, app) {
        return __awaiter(this, void 0, void 0, function* () {
            const info = yield this.managerByType(composition.endpoint).getInfo(composition);
            this.get(app).data.info = info;
            return info;
        });
    }
    /**
     * Get record external link
     * @param record - Datasource record selected
     */
    getRecordLink(record) {
        var _a;
        try {
            let url;
            if (record.link !== undefined) {
                url = record.link;
            }
            else if (record.links !== undefined) {
                url = record.links.filter((l) => l.url.includes('/file') || l.url.endsWith('.wmc'))[0].url;
            }
            if (((_a = record.endpoint) === null || _a === void 0 ? void 0 : _a.type) == 'layman') {
                url = record.url + '/file' + '?timestamp=' + Date.now();
            }
            return url;
        }
        catch (e) {
            this.$log.warn(e);
        }
    }
    /**
     * Get 'report-layman' template of composition object (operatesOn property included).
     * Necessary for CSW serviceType compositions to be parsed
     */
    getLaymanTemplateRecordObject(record, app) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = `?request=GetRecords&format=text/json&template=report-layman&query=ServiceType like 'CSW' and title like '${record.title}' and BoundingBox like '${record.bbox.join(' ')}'`;
            const url = this.hsUtilsService.proxify(record.endpoint.url + params, app);
            try {
                const compositions = yield lastValueFrom(this.http.get(url, {
                    responseType: 'json',
                }));
                return compositions['records'].length > 1
                    ? compositions['records'].find((r) => r.id == record.id)
                    : compositions['records'][0];
            }
            catch (e) {
                this.hsToastService.createToastPopupMessage(this.hsLanguageService.getTranslation('COMPOSITIONS.errorWhileRequestingCompositions', undefined, app), record.endpoint.title +
                    ': ' +
                    this.hsLanguageService.getTranslationIgnoreNonExisting('ERRORMESSAGES', e.status ? e.status.toString() : e.message, { url: url }, app), {
                    disableLocalization: true,
                    serviceCalledFrom: 'HsCompositionsMickaService',
                }, app);
            }
        });
    }
    getRecordUrl(record, app) {
        return __awaiter(this, void 0, void 0, function* () {
            const recordEndpoint = record.endpoint;
            if (recordEndpoint.type == 'micka') {
                return record.serviceType == 'CSW'
                    ? yield this.getLaymanTemplateRecordObject(record, app)
                    : this.getRecordLink(record);
            }
            else if (recordEndpoint.type == 'layman') {
                return record.url + '/file';
            }
            else {
                this.$log.warn(`Endpoint type '${recordEndpoint.type} not supported`);
                return;
            }
        });
    }
    /**
     * Load composition from datasource record url
     * @param record - Datasource record selected
     * @param app - App identifier
     */
    loadCompositionParser(record, app) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = yield this.getRecordUrl(record, app);
            if (url) {
                //Provide save-map comoData workspace property and distinguish between editable and non-editable compositions
                this.hsCompositionsParserService.get(app).current_composition_workspace =
                    record.editable ? record.workspace : null;
                if (this.hsCompositionsParserService.get(app).composition_edited == true) {
                    this.get(app).notSavedCompositionLoading.next(url);
                }
                else {
                    this.loadComposition(url, app, true);
                }
            }
        });
    }
    /**
     * Load layers received through permalink to map
     * @param app - App identifier
     */
    parsePermalinkLayers(app) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.hsMapService.loaded(app);
            const permalink = this.hsPermalinkUrlService.getParamValue(HS_PRMS.permalink);
            if (!permalink) {
                return;
            }
            const layersUrl = this.hsUtilsService.proxify(permalink, app);
            const response = yield lastValueFrom(this.http.get(layersUrl));
            if (response.success == true) {
                const data = {};
                data.data = {};
                if (response.data.layers) {
                    data.data.layers = response.data.layers;
                }
                else {
                    //Some old structure, where layers are stored in data
                    data.data.layers = response.data;
                }
                this.hsMapService.removeCompositionLayers(app);
                const layers = yield this.hsCompositionsParserService.jsonToLayers(data, app);
                for (let i = 0; i < layers.length; i++) {
                    this.hsMapService.addLayer(layers[i], app, DuplicateHandling.RemoveOriginal);
                }
            }
            else {
                this.$log.log('Error loading permalink layers');
            }
        });
    }
    /**
     * Load composition from composition list
     * @param url - URL
     * @param app - App identifier
     * @param overwrite - Overwrite existing map composition with the new one
     */
    loadComposition(url, app, overwrite) {
        return this.hsCompositionsParserService.loadUrl(url, app, overwrite);
    }
    /**
     * Parse and load composition from cookies
     * @param app - App identifier
     */
    tryParseCompositionFromCookie(app) {
        return __awaiter(this, void 0, void 0, function* () {
            if (localStorage.getItem('hs_layers') &&
                window.permalinkApp != true) {
                yield this.hsMapService.loaded(app);
                const data = localStorage.getItem('hs_layers');
                if (!data) {
                    return;
                }
                const parsed = JSON.parse(data);
                if (parsed.expires && parsed.expires < new Date().getTime()) {
                    return;
                }
                const layers = yield this.hsCompositionsParserService.jsonToLayers(parsed, app);
                for (let i = 0; i < layers.length; i++) {
                    this.hsMapService.addLayer(layers[i], app, DuplicateHandling.IgnoreNew);
                }
                localStorage.removeItem('hs_layers');
            }
        });
    }
    /**
     * Parse and load composition from browser URL
     * @param app - App identifier
     */
    tryParseCompositionFromUrlParam(app) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const configRef = this.hsConfig.get(app);
            let id = this.hsPermalinkUrlService.getParamValue(HS_PRMS.composition) ||
                configRef.defaultComposition;
            if (id) {
                if (!id.includes('http') && !id.includes(configRef.status_manager_url)) {
                    id =
                        this.hsStatusManagerService.endpointUrl(app) +
                            '?request=load&id=' +
                            id;
                }
                try {
                    const defaultViewProperties = (_a = configRef.default_view) === null || _a === void 0 ? void 0 : _a.getProperties();
                    const compoParserServiceRef = this.hsCompositionsParserService.get(app);
                    /**
                     * Little bit tricky but solution to force affect default composition loading behavior. Used to prevent
                     * passing params all the way down the loading pipeline
                     */
                    compoParserServiceRef.loadingOptions.suspendZoomingToExtent =
                        (defaultViewProperties === null || defaultViewProperties === void 0 ? void 0 : defaultViewProperties.hasOwnProperty('center')) &&
                            (defaultViewProperties === null || defaultViewProperties === void 0 ? void 0 : defaultViewProperties.hasOwnProperty('zoom'));
                    compoParserServiceRef.loadingOptions.suspendPanelChange =
                        configRef.sidebarClosed;
                    yield this.hsCompositionsParserService.loadUrl(id, app);
                    compoParserServiceRef.loadingOptions.suspendZoomingToExtent = false;
                }
                catch (error) {
                    this.get(app).compositionNotFoundAtUrl.next({ error, app });
                    this.$log.warn(error);
                }
            }
        });
    }
    /**
     * Get composition common id value
     * @param composition - Composition selected
     */
    commonId(composition) {
        if (composition === undefined) {
            return '';
        }
        return composition.uuid || composition.id;
    }
    /**
     * Translate string value to the selected UI language
     * @param module - Locales json key
     * @param text - Locales json key value
     * @returns Translated text
     */
    translateString(module, text, app) {
        return this.hsLanguageService.getTranslationIgnoreNonExisting(module, text, undefined, app);
    }
}
HsCompositionsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCompositionsService, deps: [{ token: i1.HttpClient }, { token: HsMapService }, { token: HsCoreService }, { token: HsCompositionsParserService }, { token: HsConfig }, { token: HsShareUrlService }, { token: HsUtilsService }, { token: HsStatusManagerService }, { token: HsCompositionsMickaService }, { token: HsCompositionsStatusManagerMickaJointService }, { token: HsCompositionsLaymanService }, { token: HsLanguageService }, { token: HsLogService }, { token: HsCommonEndpointsService }, { token: HsCompositionsMapService }, { token: HsEventBusService }, { token: HsToastService }], target: i0.ɵɵFactoryTarget.Injectable });
HsCompositionsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCompositionsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCompositionsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: HsMapService }, { type: HsCoreService }, { type: HsCompositionsParserService }, { type: HsConfig }, { type: HsShareUrlService }, { type: HsUtilsService }, { type: HsStatusManagerService }, { type: HsCompositionsMickaService }, { type: HsCompositionsStatusManagerMickaJointService }, { type: HsCompositionsLaymanService }, { type: HsLanguageService }, { type: HsLogService }, { type: HsCommonEndpointsService }, { type: HsCompositionsMapService }, { type: HsEventBusService }, { type: HsToastService }]; } });

class HsCompositionsInfoDialogComponent {
    constructor(HsDialogContainerService, HsCompositionsService) {
        this.HsDialogContainerService = HsDialogContainerService;
        this.HsCompositionsService = HsCompositionsService;
    }
    close() {
        console.log(this.data);
        this.HsDialogContainerService.destroy(this, this.data.app);
    }
}
HsCompositionsInfoDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCompositionsInfoDialogComponent, deps: [{ token: HsDialogContainerService }, { token: HsCompositionsService }], target: i0.ɵɵFactoryTarget.Component });
HsCompositionsInfoDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsCompositionsInfoDialogComponent, selector: "hs-compositions-info-dialog", ngImport: i0, template: "<div class=\"modal in hs-composition-info-dialog\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h4 class=\"modal-title\">\n                    {{data.info.title}} <span>{{'COMPOSITIONS.dialogInfo.details' | translateHs: {app: data.app} }}</span>\n                </h4>\n                <button type=\"button\" (click)=\"close()\" class=\"btn-close\" data-dismiss=\"modal\"\n                    attr.aria-label=\"{{'COMMON.close' | translateHs: {app: data.app} }}\">\n                </button>\n            </div>\n            <div class=\"modal-body\" style=\"max-height: 600px; overflow-y: auto\">\n                <div class=\"row\" style=\"text-align: justify; text-justify: inter-word;\">\n                    <div class=\"col-md-3\"><b>{{'COMMON.abstract' | translateHs: {app: data.app} }}</b></div>\n                    <div class=\"col-md-9\">{{data.info.abstract}}</div>\n                </div>\n                <div *ngIf=\"data.info.keywords\">\n                    <div *ngFor=\"let keyword of data.info.keywords;let first = first;\">\n                        <div class=\"row\" *ngIf=\"first\">\n                            <div class=\"col-md-3\"><b>{{'COMMON.keywords' | translateHs: {app: data.app} }}</b></div>\n                            <div class=\"col-md-9\">{{keyword}}</div>\n                        </div>\n                        <div class=\"row\" *ngIf=\"!first\">\n                            <div class=\"col-md-offset-3 col-md-9\">{{keyword}}</div>\n                        </div>\n                    </div>\n                    <br>\n                </div>\n                <div class=\"row\" *ngIf=\"data.info.thumbnail\">\n                    <div class=\"col-md-3\"><b>{{'COMMON.thumbnail' | translateHs: {app: data.app} }}</b></div>\n                    <div class=\"col-md-9\"><img\n                            src=\"{{data.info.thumbnail.url ? data.info.thumbnail.url : data.info.thumbnail}}\"></div>\n                </div>\n                <div class=\"row\" *ngIf=\"data.info.url && data.info\">\n                    <div class=\"col-md-3\"><b>{{'COMMON.url' | translateHs: {app: data.app} }}</b></div>\n                    <div class=\"col-md-9\">{{data.info.url}}</div>\n                </div>\n                <div class=\"row\" *ngIf=\"data.info.srs\">\n                    <div class=\"col-md-3\"><b>{{'ADDLAYERS.srs' | translateHs: {app: data.app} }}</b></div>\n                    <div class=\"col-md-9\">{{data.info.srs}}</div>\n                </div>\n                <div class=\"row\" *ngIf=\"data.info.extent\">\n                    <div class=\"col-md-3\"><b>{{'COMMON.extent' | translateHs: {app: data.app} }}</b></div>\n                    <div class=\"col-md-9\" style=\"word-break:break-all\">{{data.info.extent}}</div>\n                </div>\n                <div *ngIf=\"data.info.layers\">\n                    <div *ngFor=\"let layer of data.info.layers;let first = first;\">\n                        <div class=\"row\" *ngIf=\"first\">\n                            <div class=\"col-md-3\"><b>{{'COMMON.layers' | translateHs: {app: data.app} }}</b></div>\n                            <div class=\"col-md-9\">{{layer.title}}</div>\n                        </div>\n                        <div class=\"row\" *ngIf=\"!first\">\n                            <div class=\"offset-md-3 col-md-9\">{{layer.title}}</div>\n                        </div>\n                    </div>\n                    <br>\n                </div>\n                <!-- <div *ngIf=\"data.info.metadata\">\n                    <div class=\"row\">\n                         <div class=\"col\"><b>{{'COMPOSITIONS.dialogInfo.metadataAboutMetadata' | translateHs: {app: data.app} }}</b></div>\n                    </div>\n                     <div *ngFor=\"let metadata of data.info.metadata | keyvalue\">\n                         <div class=\"row\" *ngIf=\"metadata.value\">\n                            <div class=\"col-md-3\"><b>{{HsCompositionsService.translateString('COMPOSITIONS.dialogInfo.metadata', metadata.key)}}</b></div>\n                            <div class=\"col-md-9\" style=\"overflow-wrap: break-word\">{{metadata.value}}</div>\n                         </div>\n                     </div>\n                </div> -->\n                <div class=\"row\" *ngIf=\"data.info.contactAddress || data.info.contactPersonPrimary\">\n                    <div class=\"col\"><b>{{'COMMON.contactInformation' | translateHs: {app: data.app} }}</b></div>\n                </div>\n                <div *ngIf=\"data.info.contactAddress\">\n                    <div *ngFor=\"let data of data.info.contactAddress | keyvalue\">\n                        <div class=\"row\" *ngIf=\"data.value\">\n                            <div class=\"col-md-4\"><b>{{HsCompositionsService.translateString('SAVECOMPOSITION.form',\n                                    data.key, data.app)}}</b></div>\n                            <div class=\"col-md-8\">{{data.value}}</div>\n                        </div>\n                    </div>\n                </div>\n                <div *ngIf=\"data.info.contactPersonPrimary\">\n                    <div *ngFor=\"let data of data.info.contactPersonPrimary | keyvalue\">\n                        <div class=\"row\" *ngIf=\"data.value\">\n                            <div class=\"col-md-4\" style=\"word-break:break-all\">\n                                <b>{{HsCompositionsService.translateString('SAVECOMPOSITION.form', data.key,\n                                    data.app)}}</b>\n                            </div>\n                            <div class=\"col-md-8\">{{data.value}}</div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"modal-footer\">\n                <ng-container *ngIf=\"data.info?.metadata?.record_url\">\n                    <a target=\"_blank\" [href]=\"data.info.metadata.record_url\" class=\"btn btn-primary\"\n                        (click)=\"close()\">See\n                        full metadata record <i class=\"icon icon-opennewwindow\"></i></a>\n                </ng-container>\n                <button class=\"btn btn-secondary\" (click)=\"close()\" data-dismiss=\"modal\">{{'COMMON.close' |\n                    translateHs: {app: data.app} }}</button>\n            </div>\n        </div>\n    </div>\n</div>", directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "translateHs": TranslateCustomPipe, "keyvalue": i3.KeyValuePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCompositionsInfoDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-compositions-info-dialog', template: "<div class=\"modal in hs-composition-info-dialog\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h4 class=\"modal-title\">\n                    {{data.info.title}} <span>{{'COMPOSITIONS.dialogInfo.details' | translateHs: {app: data.app} }}</span>\n                </h4>\n                <button type=\"button\" (click)=\"close()\" class=\"btn-close\" data-dismiss=\"modal\"\n                    attr.aria-label=\"{{'COMMON.close' | translateHs: {app: data.app} }}\">\n                </button>\n            </div>\n            <div class=\"modal-body\" style=\"max-height: 600px; overflow-y: auto\">\n                <div class=\"row\" style=\"text-align: justify; text-justify: inter-word;\">\n                    <div class=\"col-md-3\"><b>{{'COMMON.abstract' | translateHs: {app: data.app} }}</b></div>\n                    <div class=\"col-md-9\">{{data.info.abstract}}</div>\n                </div>\n                <div *ngIf=\"data.info.keywords\">\n                    <div *ngFor=\"let keyword of data.info.keywords;let first = first;\">\n                        <div class=\"row\" *ngIf=\"first\">\n                            <div class=\"col-md-3\"><b>{{'COMMON.keywords' | translateHs: {app: data.app} }}</b></div>\n                            <div class=\"col-md-9\">{{keyword}}</div>\n                        </div>\n                        <div class=\"row\" *ngIf=\"!first\">\n                            <div class=\"col-md-offset-3 col-md-9\">{{keyword}}</div>\n                        </div>\n                    </div>\n                    <br>\n                </div>\n                <div class=\"row\" *ngIf=\"data.info.thumbnail\">\n                    <div class=\"col-md-3\"><b>{{'COMMON.thumbnail' | translateHs: {app: data.app} }}</b></div>\n                    <div class=\"col-md-9\"><img\n                            src=\"{{data.info.thumbnail.url ? data.info.thumbnail.url : data.info.thumbnail}}\"></div>\n                </div>\n                <div class=\"row\" *ngIf=\"data.info.url && data.info\">\n                    <div class=\"col-md-3\"><b>{{'COMMON.url' | translateHs: {app: data.app} }}</b></div>\n                    <div class=\"col-md-9\">{{data.info.url}}</div>\n                </div>\n                <div class=\"row\" *ngIf=\"data.info.srs\">\n                    <div class=\"col-md-3\"><b>{{'ADDLAYERS.srs' | translateHs: {app: data.app} }}</b></div>\n                    <div class=\"col-md-9\">{{data.info.srs}}</div>\n                </div>\n                <div class=\"row\" *ngIf=\"data.info.extent\">\n                    <div class=\"col-md-3\"><b>{{'COMMON.extent' | translateHs: {app: data.app} }}</b></div>\n                    <div class=\"col-md-9\" style=\"word-break:break-all\">{{data.info.extent}}</div>\n                </div>\n                <div *ngIf=\"data.info.layers\">\n                    <div *ngFor=\"let layer of data.info.layers;let first = first;\">\n                        <div class=\"row\" *ngIf=\"first\">\n                            <div class=\"col-md-3\"><b>{{'COMMON.layers' | translateHs: {app: data.app} }}</b></div>\n                            <div class=\"col-md-9\">{{layer.title}}</div>\n                        </div>\n                        <div class=\"row\" *ngIf=\"!first\">\n                            <div class=\"offset-md-3 col-md-9\">{{layer.title}}</div>\n                        </div>\n                    </div>\n                    <br>\n                </div>\n                <!-- <div *ngIf=\"data.info.metadata\">\n                    <div class=\"row\">\n                         <div class=\"col\"><b>{{'COMPOSITIONS.dialogInfo.metadataAboutMetadata' | translateHs: {app: data.app} }}</b></div>\n                    </div>\n                     <div *ngFor=\"let metadata of data.info.metadata | keyvalue\">\n                         <div class=\"row\" *ngIf=\"metadata.value\">\n                            <div class=\"col-md-3\"><b>{{HsCompositionsService.translateString('COMPOSITIONS.dialogInfo.metadata', metadata.key)}}</b></div>\n                            <div class=\"col-md-9\" style=\"overflow-wrap: break-word\">{{metadata.value}}</div>\n                         </div>\n                     </div>\n                </div> -->\n                <div class=\"row\" *ngIf=\"data.info.contactAddress || data.info.contactPersonPrimary\">\n                    <div class=\"col\"><b>{{'COMMON.contactInformation' | translateHs: {app: data.app} }}</b></div>\n                </div>\n                <div *ngIf=\"data.info.contactAddress\">\n                    <div *ngFor=\"let data of data.info.contactAddress | keyvalue\">\n                        <div class=\"row\" *ngIf=\"data.value\">\n                            <div class=\"col-md-4\"><b>{{HsCompositionsService.translateString('SAVECOMPOSITION.form',\n                                    data.key, data.app)}}</b></div>\n                            <div class=\"col-md-8\">{{data.value}}</div>\n                        </div>\n                    </div>\n                </div>\n                <div *ngIf=\"data.info.contactPersonPrimary\">\n                    <div *ngFor=\"let data of data.info.contactPersonPrimary | keyvalue\">\n                        <div class=\"row\" *ngIf=\"data.value\">\n                            <div class=\"col-md-4\" style=\"word-break:break-all\">\n                                <b>{{HsCompositionsService.translateString('SAVECOMPOSITION.form', data.key,\n                                    data.app)}}</b>\n                            </div>\n                            <div class=\"col-md-8\">{{data.value}}</div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"modal-footer\">\n                <ng-container *ngIf=\"data.info?.metadata?.record_url\">\n                    <a target=\"_blank\" [href]=\"data.info.metadata.record_url\" class=\"btn btn-primary\"\n                        (click)=\"close()\">See\n                        full metadata record <i class=\"icon icon-opennewwindow\"></i></a>\n                </ng-container>\n                <button class=\"btn btn-secondary\" (click)=\"close()\" data-dismiss=\"modal\">{{'COMMON.close' |\n                    translateHs: {app: data.app} }}</button>\n            </div>\n        </div>\n    </div>\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsDialogContainerService }, { type: HsCompositionsService }]; } });

const KEYWORDS = [
    { name: 'Basemap', value: 'Basemap', selected: false },
    { name: 'Borders', value: 'Borders', selected: false },
    { name: 'Physical geography', value: 'Physical geography', selected: false },
    { name: 'Demographics', value: 'Demographics', selected: false },
    { name: 'Economics', value: 'Economics', selected: false },
    {
        name: 'Socio political conditions',
        value: 'Socio political conditions',
        selected: false,
    },
    { name: 'Culture', value: 'Culture', selected: false },
    { name: 'Transport', value: 'Transport', selected: false },
    { name: 'Land use', value: 'Land use', selected: false },
    { name: 'Environment', value: 'Environment', selected: false },
    { name: 'Water', value: 'Water', selected: false },
    { name: 'Hazards', value: 'Hazards', selected: false },
    { name: 'Cadastre', value: 'Cadastre', selected: false },
    { name: 'Infrastructure', value: 'Infrastructure', selected: false },
    { name: 'Real estate', value: 'Real estate', selected: false },
    { name: 'Planning', value: 'Planning', selected: false },
    { name: 'Complex information', value: 'Complex information', selected: false },
];
const INSPIRETHEMES = [
    {
        name: 'Addresses',
        value: 'http://inspire.ec.europa.eu/theme/ad',
        selected: false,
    },
    {
        name: 'Administrative units',
        value: 'http://inspire.ec.europa.eu/theme/au',
        selected: false,
    },
    {
        name: 'Coordinate reference systems',
        value: 'http://inspire.ec.europa.eu/theme/rs',
        selected: false,
    },
    {
        name: 'Geographical grid systems',
        value: 'http://inspire.ec.europa.eu/theme/gg',
        selected: false,
    },
    {
        name: 'Cadastral parcels',
        value: 'http://inspire.ec.europa.eu/theme/cp',
        selected: false,
    },
    {
        name: 'Geographical names',
        value: 'http://inspire.ec.europa.eu/theme/gn',
        selected: false,
    },
    {
        name: 'Hydrography',
        value: 'http://inspire.ec.europa.eu/theme/hy',
        selected: false,
    },
    {
        name: 'Protected sites',
        value: 'http://inspire.ec.europa.eu/theme/ps',
        selected: false,
    },
    {
        name: 'Transport networks',
        value: 'http://inspire.ec.europa.eu/theme/tn',
        selected: false,
    },
    {
        name: 'Elevation',
        value: 'http://inspire.ec.europa.eu/theme/el',
        selected: false,
    },
    {
        name: 'Geology',
        value: 'http://inspire.ec.europa.eu/theme/ge',
        selected: false,
    },
    {
        name: 'Land cover',
        value: 'http://inspire.ec.europa.eu/theme/lc',
        selected: false,
    },
    {
        name: 'Orthoimagery',
        value: 'http://inspire.ec.europa.eu/theme/oi',
        selected: false,
    },
    {
        name: 'Agricultural and aquaculture facilities',
        value: 'http://inspire.ec.europa.eu/theme/af',
        selected: false,
    },
    {
        name: 'Area management/restriction/regulation zones and reporting units',
        value: 'http://inspire.ec.europa.eu/theme/am',
        selected: false,
    },
    {
        name: 'Atmospheric conditions',
        value: 'http://inspire.ec.europa.eu/theme/ac',
        selected: false,
    },
    {
        name: 'Bio-geographical regions',
        value: 'http://inspire.ec.europa.eu/theme/br',
        selected: false,
    },
    {
        name: 'Buildings',
        value: 'http://inspire.ec.europa.eu/theme/bu',
        selected: false,
    },
    {
        name: 'Energy resources',
        value: 'http://inspire.ec.europa.eu/theme/er',
        selected: false,
    },
    {
        name: 'Environmental monitoring facilities',
        value: 'http://inspire.ec.europa.eu/theme/ef',
        selected: false,
    },
    {
        name: 'Habitants and biotopes',
        value: 'http://inspire.ec.europa.eu/theme/hb',
        selected: false,
    },
    {
        name: 'Human health and safety',
        value: 'http://inspire.ec.europa.eu/theme/hh',
        selected: false,
    },
    {
        name: 'Land use',
        value: 'http://inspire.ec.europa.eu/theme/lu',
        selected: false,
    },
    {
        name: 'Mineral resources',
        value: 'http://inspire.ec.europa.eu/theme/mr',
        selected: false,
    },
    {
        name: 'Natural risk zones',
        value: 'http://inspire.ec.europa.eu/theme/nz',
        selected: false,
    },
    {
        name: 'Oceanographic geographical features',
        value: 'http://inspire.ec.europa.eu/theme/of',
        selected: false,
    },
    {
        name: 'Population distribution - demography',
        value: 'http://inspire.ec.europa.eu/theme/pd',
        selected: false,
    },
    {
        name: 'Production and industrial facilities',
        value: 'http://inspire.ec.europa.eu/theme/pf',
        selected: false,
    },
    {
        name: 'Sea regions',
        value: 'http://inspire.ec.europa.eu/theme/sr',
        selected: false,
    },
    {
        name: 'Soil',
        value: 'http://inspire.ec.europa.eu/theme/so',
        selected: false,
    },
    {
        name: 'Species distribution',
        value: 'http://inspire.ec.europa.eu/theme/sd',
        selected: false,
    },
    {
        name: 'Statistical units',
        value: 'http://inspire.ec.europa.eu/theme/su',
        selected: false,
    },
    {
        name: 'Utility and governmental services',
        value: 'http://inspire.ec.europa.eu/theme/us',
        selected: false,
    },
    {
        name: 'Meteorological geographical features',
        value: 'http://inspire.ec.europa.eu/theme/mf',
        selected: false,
    },
    {
        name: 'Atmospheric Conditions and meteorological geographical features',
        value: 'http://inspire.ec.europa.eu/theme/ac-mf',
        selected: false,
    },
];
const SORTBYVALUES = [
    { name: 'None', value: 'None' },
    { name: 'Title', value: 'title' },
    { name: 'Date', value: 'date:D' },
    { name: 'Bbox', value: 'bbox' },
];
const TYPES = [
    { name: 'None', value: 'None' },
    { name: 'Datasource', value: 'datasource' },
    { name: 'Service', value: 'service' },
    { name: 'Application', value: 'application' },
    { name: 'Feature catalogue', value: 'feature catalogue' },
];

class HsCompositionsCatalogueParams {
    constructor() {
        this.compositionEntries = [];
        /**
         *List of sort by values (currently hard-coded selection),that will be applied in compositions lookup
         */
        this.sortByValues = SORTBYVALUES;
        /**
         * List of composition type values (currently hard-coded selection),that will be applied in compositions lookup
         */
        this.types = TYPES;
        /**
         * List of composition theme values (currently hard-coded selection),that will be applied in compositions lookup
         */
        this.inspireThemes = INSPIRETHEMES;
        this.data = {
            query: { editable: false, title: '' },
            keywords: KEYWORDS,
            sortBy: SORTBYVALUES[0],
            type: TYPES[0].name,
            themes: INSPIRETHEMES,
        };
        this.recordsPerPage = 20;
        this.matchedRecords = 0;
        this.listStart = 0;
        this.listNext = this.recordsPerPage;
        /**
         * Store whether filter compositions by current window extent during composition search
         */
        this.filterByExtent = true;
        this.filterByOnlyMine = false;
        this.extentChangeSuppressed = false;
    }
}
class HsCompositionsCatalogueService {
    constructor(hsMapService, hsCompositionsService, hsLayoutService, hsCommonEndpointsService, hsUtilsService, hsEventBusService, hsDialogContainerService, hsLaymanService, hsCommonLaymanService, _zone) {
        this.hsMapService = hsMapService;
        this.hsCompositionsService = hsCompositionsService;
        this.hsLayoutService = hsLayoutService;
        this.hsCommonEndpointsService = hsCommonEndpointsService;
        this.hsUtilsService = hsUtilsService;
        this.hsEventBusService = hsEventBusService;
        this.hsDialogContainerService = hsDialogContainerService;
        this.hsLaymanService = hsLaymanService;
        this.hsCommonLaymanService = hsCommonLaymanService;
        this._zone = _zone;
        this.apps = { default: new HsCompositionsCatalogueParams() };
        this.hsCommonEndpointsService.endpointsFilled.subscribe((filled) => {
            if (filled === null || filled === void 0 ? void 0 : filled.app) {
                this.get(filled.app).filteredEndpoints =
                    this.getFilteredEndpointsForCompositions();
            }
        });
        this.hsEventBusService.mainPanelChanges.subscribe(({ which, app }) => {
            if (this.hsLayoutService.get(app).mainpanel === 'composition_browser' ||
                this.hsLayoutService.get(app).mainpanel === 'composition') {
                this.loadFilteredCompositions(app);
                this.get(app).extentChangeSuppressed = true;
            }
        });
        const extentChangeDebouncer = {};
        this.hsEventBusService.mapExtentChanges.subscribe(hsUtilsService.debounce(({ map, event, extent, app }) => {
            const appRef = this.get(app);
            if ((this.hsLayoutService.get(app).mainpanel != 'composition_browser' &&
                this.hsLayoutService.get(app).mainpanel != 'composition') ||
                appRef.extentChangeSuppressed) {
                appRef.extentChangeSuppressed = false;
                return;
            }
            if (appRef.filterByExtent) {
                this._zone.run(() => {
                    this.loadFilteredCompositions(app);
                });
            }
        }, 400, false, extentChangeDebouncer));
        this.hsEventBusService.compositionDeletes.subscribe(({ composition, app }) => {
            //TODO: rewrite
            const deleteDialog = this.hsLayoutService
                .get(app)
                .contentWrapper.querySelector('.hs-composition-delete-dialog');
            if (deleteDialog) {
                deleteDialog.parentNode.remove(deleteDialog);
            }
            this._zone.run(() => {
                this.loadFilteredCompositions(app);
            });
        });
        this.hsCommonLaymanService.authChange.subscribe(({ endpoint, app }) => {
            if (this.hsLayoutService.get(app).mainpanel != 'composition_browser' &&
                this.hsLayoutService.get(app).mainpanel != 'composition') {
                return;
            }
            this.loadFilteredCompositions(app);
        });
    }
    /**
     * Initialize compositions catalogue service data and subscribers
     * @param app - App identifier
     */
    init(app) {
        this.get(app).filteredEndpoints =
            this.getFilteredEndpointsForCompositions();
        this.hsCompositionsService
            .get(app)
            .compositionNotFoundAtUrl.subscribe((data) => {
            this.hsDialogContainerService.create(HsCompositionsInfoDialogComponent, {
                info: {
                    title: this.hsCompositionsService.translateString('COMPOSITIONS', 'compositionNotFound', app),
                    abstract: data.error.message,
                },
            }, data.app);
        });
    }
    get(app) {
        if (this.apps[app !== null && app !== void 0 ? app : 'default'] == undefined) {
            this.apps[app !== null && app !== void 0 ? app : 'default'] = new HsCompositionsCatalogueParams();
        }
        return this.apps[app !== null && app !== void 0 ? app : 'default'];
    }
    /**
     * Load list of compositions for all endpoints
     * @param suspendLimitCalculation -
     */
    loadCompositions(app, suspendLimitCalculation) {
        const appRef = this.get(app);
        if (appRef.loadCompositionsQuery) {
            appRef.loadCompositionsQuery.unsubscribe();
            delete appRef.loadCompositionsQuery;
        }
        this.clearLoadedData(app);
        appRef.dataLoading = true;
        this.hsMapService.loaded(app).then(() => {
            const observables = [];
            for (const endpoint of appRef.filteredEndpoints) {
                observables.push(this.loadCompositionFromEndpoint(endpoint, app));
            }
            appRef.loadCompositionsQuery = forkJoin(observables).subscribe(() => {
                suspendLimitCalculation
                    ? this.createCompositionList(app)
                    : this.calculateEndpointLimits(app);
            });
        });
    }
    /**
     * Calculates each endpoint composition request limit, based on the matched compositions ratio
     * from all endpoint matched compositions
     */
    calculateEndpointLimits(app) {
        const appRef = this.get(app);
        appRef.matchedRecords = 0;
        appRef.filteredEndpoints =
            this.getFilteredEndpointsForCompositions().filter((ep) => ep.compositionsPaging.matched != 0);
        if (appRef.filteredEndpoints.length == 0) {
            appRef.dataLoading = false;
            return;
        }
        appRef.filteredEndpoints.forEach((ep) => (appRef.matchedRecords += ep.compositionsPaging.matched));
        let sumLimits = 0;
        appRef.filteredEndpoints.forEach((ep) => {
            ep.compositionsPaging.limit = Math.floor((ep.compositionsPaging.matched / appRef.matchedRecords) *
                appRef.recordsPerPage);
            if (ep.compositionsPaging.limit == 0) {
                ep.compositionsPaging.limit = 1;
            }
            sumLimits += ep.compositionsPaging.limit;
        });
        appRef.recordsPerPage = sumLimits;
        appRef.listNext = appRef.recordsPerPage;
        this.loadCompositions(app, true);
    }
    /**
     * Load list of compositions according to current filter values and pager position
     * (filter, keywords, current extent, start composition, compositions number per page). Display compositions extent in map
     * @param ep -
     */
    loadCompositionFromEndpoint(ep, app) {
        const appRef = this.get(app);
        return this.hsCompositionsService.loadCompositions(ep, {
            query: appRef.data.query,
            sortBy: appRef.data.sortBy.value,
            filterByExtent: appRef.filterByExtent,
            keywords: appRef.data.keywords,
            themes: appRef.data.themes,
            type: appRef.data.type,
            start: ep.compositionsPaging.start,
            limit: ep.compositionsPaging.limit,
            filterByOnlyMine: appRef.filterByOnlyMine,
        }, app);
    }
    /**
     * Clear all loaded data and filter endpoint array (if required) before loading compositions
     */
    loadFilteredCompositions(app) {
        const appRef = this.get(app);
        this.clearListCounters(app);
        appRef.filteredEndpoints =
            this.getFilteredEndpointsForCompositions().filter((ep) => {
                if (appRef.filterByOnlyMine) {
                    return !appRef.filterByOnlyMine || ep.type == 'layman';
                }
                else {
                    return true;
                }
            });
        this.loadCompositions(app);
    }
    /**
     * Creates list of compositions from all endpoints currently available
     */
    createCompositionList(app) {
        const appRef = this.get(app);
        for (const endpoint of appRef.filteredEndpoints) {
            this.arrayContainsData(appRef.compositionEntries)
                ? this.filterDuplicates(endpoint, app)
                : (appRef.compositionEntries = appRef.compositionEntries.concat(endpoint.compositions));
        }
        appRef.dataLoading = false;
        if (appRef.matchedRecords < appRef.recordsPerPage) {
            appRef.listNext = appRef.matchedRecords;
        }
    }
    /**
     *  Filters compositions from responseArray with the same id in already loaded compositionEntries array
     * @param endpoint -
     */
    filterDuplicates(endpoint, app) {
        const appRef = this.get(app);
        if (!this.arrayContainsData(endpoint.compositions)) {
            return;
        }
        const filteredCompositions = endpoint.compositions.filter((record) => appRef.compositionEntries.filter((loaded) => loaded.id == record.id ||
            'm-' + loaded.id == record.id ||
            loaded.id == 'm-' + record.id).length == 0);
        appRef.matchedRecords -=
            endpoint.compositions.length - filteredCompositions.length;
        appRef.compositionEntries =
            appRef.compositionEntries.concat(filteredCompositions);
    }
    /**
     * Clears all list counters regarding paging
     */
    clearListCounters(app) {
        const appRef = this.get(app);
        appRef.listStart = 0;
        appRef.listNext = appRef.recordsPerPage;
        this.hsCompositionsService.resetCompositionCounter();
    }
    /**
     * Clears all data saved regarding loaded compositions
     */
    clearLoadedData(app) {
        const appRef = this.get(app);
        appRef.compositionEntries = [];
        appRef.filteredEndpoints.forEach((ep) => (ep.compositions = []));
    }
    /**
     
     * Evaluates if array is defined and contains any data
     * @param arr - Endpoint composition records
     */
    arrayContainsData(arr) {
        return arr !== undefined && arr.length > 0;
    }
    /**
     * Load previous list of compositions to display on pager
     */
    getPreviousRecords(app) {
        const appRef = this.get(app);
        if (appRef.listStart - appRef.recordsPerPage <= 0) {
            appRef.listStart = 0;
            appRef.listNext = appRef.recordsPerPage;
            appRef.filteredEndpoints.forEach((ep) => (ep.compositionsPaging.start = 0));
        }
        else {
            appRef.listStart -= appRef.recordsPerPage;
            appRef.listNext = appRef.listStart + appRef.recordsPerPage;
            appRef.filteredEndpoints.forEach((ep) => (ep.compositionsPaging.start -= ep.compositionsPaging.limit));
        }
        this.loadCompositions(app, true);
    }
    /**
     * Load next list of compositions to display on pager
     */
    getNextRecords(app) {
        const appRef = this.get(app);
        appRef.listStart += appRef.recordsPerPage;
        appRef.listNext += appRef.recordsPerPage;
        if (appRef.listNext > appRef.matchedRecords) {
            appRef.listNext = appRef.matchedRecords;
        }
        appRef.filteredEndpoints.forEach((ep) => (ep.compositionsPaging.start += ep.compositionsPaging.limit));
        this.loadCompositions(app, true);
    }
    changeRecordsPerPage(app) {
        this.clearListCounters(app);
        this.loadCompositions(app);
    }
    /**
     * Filters statusmanager endpoint out from rest of the endpoints
     */
    getFilteredEndpointsForCompositions() {
        if (this.hsCommonEndpointsService.endpoints == undefined) {
            return [];
        }
        return this.hsCommonEndpointsService.endpoints.filter((ep) => ep.type != 'statusmanager');
    }
    /**
     * Clears all filters set for composition list filtering
     */
    clearFilters(app) {
        const appRef = this.get(app);
        appRef.data.query.title = '';
        appRef.data.sortBy = SORTBYVALUES[0];
        appRef.data.type = TYPES[0].name;
        appRef.data.keywords.forEach((kw) => (kw.selected = false));
        appRef.data.themes.forEach((th) => (th.selected = false));
        const laymanEndpoint = this.hsLaymanService.getLaymanEndpoint();
        if (laymanEndpoint) {
            appRef.filteredEndpoints.push(laymanEndpoint);
        }
        this.loadFilteredCompositions(app);
    }
}
HsCompositionsCatalogueService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCompositionsCatalogueService, deps: [{ token: HsMapService }, { token: HsCompositionsService }, { token: HsLayoutService }, { token: HsCommonEndpointsService }, { token: HsUtilsService }, { token: HsEventBusService }, { token: HsDialogContainerService }, { token: HsLaymanService }, { token: HsCommonLaymanService }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Injectable });
HsCompositionsCatalogueService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCompositionsCatalogueService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCompositionsCatalogueService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsMapService }, { type: HsCompositionsService }, { type: HsLayoutService }, { type: HsCommonEndpointsService }, { type: HsUtilsService }, { type: HsEventBusService }, { type: HsDialogContainerService }, { type: HsLaymanService }, { type: HsCommonLaymanService }, { type: i0.NgZone }]; } });

class HsSetPermissionsDialogComponent {
    constructor(hsDialogContainerService, hsLaymanService, hsAddDataCatalogueService, hsCompositionsCatalogueService) {
        this.hsDialogContainerService = hsDialogContainerService;
        this.hsLaymanService = hsLaymanService;
        this.hsAddDataCatalogueService = hsAddDataCatalogueService;
        this.hsCompositionsCatalogueService = hsCompositionsCatalogueService;
        this.currentAccessRights = {
            'access_rights.write': 'private',
            'access_rights.read': 'EVERYONE',
        };
    }
    ngOnInit() {
        var _a;
        if (!((_a = this.data.selectedRecord) === null || _a === void 0 ? void 0 : _a.access_rights)) {
            this.close();
            return;
        }
        this.parseCurrentPermissions();
    }
    /**
     * Parse current permissions for the selected record
     * so it can be used for Layman access rights component
     */
    parseCurrentPermissions() {
        const currentUser = this.data.selectedRecord.endpoint.user;
        let read = this.data.selectedRecord.access_rights.read;
        let write = this.data.selectedRecord.access_rights.write;
        if (read.includes('EVERYONE')) {
            read = read.filter((r) => r != currentUser);
        }
        if (write.includes('EVERYONE')) {
            write = write.filter((r) => r != currentUser);
        }
        this.currentAccessRights['access_rights.read'] =
            read.length == 1 && read[0] == currentUser ? 'private' : read.join(',');
        this.currentAccessRights['access_rights.write'] =
            write.length == 1 && write[0] == currentUser
                ? 'private'
                : write.join(',');
    }
    /**
     * @public
     * Close the dialog
     */
    close() {
        this.hsDialogContainerService.destroy(this, this.data.app);
    }
    /**
     * Save permissions for selected record
     */
    savePermissions() {
        return __awaiter(this, void 0, void 0, function* () {
            let response;
            switch (this.data.recordType) {
                case 'layer':
                    const layerDesc = {
                        name: this.data.selectedRecord.name,
                        title: this.data.selectedRecord.title,
                        workspace: this.data.selectedRecord.endpoint.user,
                        access_rights: this.currentAccessRights,
                    };
                    response = yield this.hsLaymanService.makeUpsertLayerRequest(this.data.selectedRecord.endpoint, null, layerDesc, this.data.app);
                    if (response === null || response === void 0 ? void 0 : response.error) {
                        return;
                    }
                    this.hsAddDataCatalogueService.reloadData(this.data.app);
                    this.close();
                    break;
                case 'composition':
                    response = yield this.hsLaymanService.updateCompositionAccessRights(this.data.selectedRecord.name, this.data.selectedRecord.endpoint, this.currentAccessRights, this.data.app);
                    if (response === null || response === void 0 ? void 0 : response.error) {
                        return;
                    }
                    this.hsCompositionsCatalogueService.loadFilteredCompositions(this.data.app);
                    this.close();
                    break;
                default:
            }
        });
    }
}
HsSetPermissionsDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSetPermissionsDialogComponent, deps: [{ token: HsDialogContainerService }, { token: HsLaymanService }, { token: HsAddDataCatalogueService }, { token: HsCompositionsCatalogueService }], target: i0.ɵɵFactoryTarget.Component });
HsSetPermissionsDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsSetPermissionsDialogComponent, selector: "hs-set-permissions-dialog", ngImport: i0, template: "<div class=\"modal in hs-set-permissions-dialog\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n  <div class=\"modal-dialog\">\n    <div class=\"modal-content\">\n      <div class=\"modal-header\">\n        <h4 class=\"modal-title\">{{'COMMON.selectAndSavePermissions' | translateHs: {app:\n          data.app} }}: {{data.selectedRecord.name}}</h4>\n        <button type=\"button\" (click)=\"close()\" class=\"btn-close\" data-dismiss=\"modal\"\n          attr.aria-label=\"{{'COMMON.close' | translateHs: {app: data.app} }}\">\n        </button>\n      </div>\n      <div class=\"modal-body\" style=\"overflow-y:auto\">\n        <hs-layman-access-rights *ngIf=\"data.selectedRecord.endpoint?.type === 'layman'\" [app]=\"data.app\"\n          [(access_rights)]=\"currentAccessRights\">\n        </hs-layman-access-rights>\n        <div class=\"modal-footer\">\n          <button type=\"button\" class=\"btn btn-primary\" (click)=\"savePermissions()\" data-dismiss=\"modal\">{{'COMMON.save'\n            | translateHs: {app: data.app} }}</button>\n          <button type=\"button\" class=\"btn btn-secondary\" (click)=\"close()\" data-dismiss=\"modal\">{{'COMMON.cancel' |\n            translateHs: {app: data.app} }}</button>\n        </div>\n      </div>\n    </div>\n  </div>", components: [{ type: HsCommonLaymanAccessRightsComponent, selector: "hs-layman-access-rights", inputs: ["access_rights", "app"] }], directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSetPermissionsDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-set-permissions-dialog', template: "<div class=\"modal in hs-set-permissions-dialog\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n  <div class=\"modal-dialog\">\n    <div class=\"modal-content\">\n      <div class=\"modal-header\">\n        <h4 class=\"modal-title\">{{'COMMON.selectAndSavePermissions' | translateHs: {app:\n          data.app} }}: {{data.selectedRecord.name}}</h4>\n        <button type=\"button\" (click)=\"close()\" class=\"btn-close\" data-dismiss=\"modal\"\n          attr.aria-label=\"{{'COMMON.close' | translateHs: {app: data.app} }}\">\n        </button>\n      </div>\n      <div class=\"modal-body\" style=\"overflow-y:auto\">\n        <hs-layman-access-rights *ngIf=\"data.selectedRecord.endpoint?.type === 'layman'\" [app]=\"data.app\"\n          [(access_rights)]=\"currentAccessRights\">\n        </hs-layman-access-rights>\n        <div class=\"modal-footer\">\n          <button type=\"button\" class=\"btn btn-primary\" (click)=\"savePermissions()\" data-dismiss=\"modal\">{{'COMMON.save'\n            | translateHs: {app: data.app} }}</button>\n          <button type=\"button\" class=\"btn btn-secondary\" (click)=\"close()\" data-dismiss=\"modal\">{{'COMMON.cancel' |\n            translateHs: {app: data.app} }}</button>\n        </div>\n      </div>\n    </div>\n  </div>" }]
        }], ctorParameters: function () { return [{ type: HsDialogContainerService }, { type: HsLaymanService }, { type: HsAddDataCatalogueService }, { type: HsCompositionsCatalogueService }]; } });

/* eslint-disable @typescript-eslint/no-unused-vars */
class HsCatalogueMetadataService {
    constructor(hsUtilsService) {
        this.hsUtilsService = hsUtilsService;
    }
    /**
     * @param input -
     * @param prestring -
     */
    decomposeMetadata(input, prestring) {
        console.log(input);
        if (this.hsUtilsService.isPOJO(input)) {
            console.log('Decomposing OBJ');
            return this.decomposeObject(input, prestring);
        }
        else if (Array.isArray(input)) {
            console.log('Decomposing Arr');
            return this.decomposeArray(input, prestring);
        }
        else {
            return false;
        }
    }
    /**
     * @param obj -
     * @param substring -
     */
    decomposeObject(obj, substring) {
        let decomposed = {};
        let subvalue = undefined;
        Object.entries(obj).forEach((entry) => {
            const [key, value] = entry;
            console.log('deco', decomposed);
            console.log(key, value);
            if (key == 'feature') {
                return;
            }
            let newstring = '';
            if (substring !== undefined) {
                newstring = substring + ' - ' + key;
            }
            else {
                newstring = key;
            }
            if (this.hsUtilsService.isPOJO(value)) {
                console.log('decomposing obj ', value);
                subvalue = this.decomposeObject(value, newstring);
            }
            else if (Array.isArray(value)) {
                console.log('decomposing arr ', value);
                subvalue = this.decomposeArray(value, newstring);
            }
            else {
                subvalue = value;
            }
            if (this.hsUtilsService.isPOJO(subvalue)) {
                decomposed = this.hsUtilsService.structuredClone(subvalue, decomposed);
            }
            else {
                decomposed[newstring] = subvalue;
            }
        });
        return decomposed;
    }
    /**
     * @param arr -
     * @param substring -
     */
    decomposeArray(arr, substring) {
        console.log('decomposing array ', arr, 'with substring ', substring);
        let decomposed = undefined;
        let sub = '';
        arr.forEach((value) => {
            console.log(value);
            if (this.hsUtilsService.isPOJO(value)) {
                sub = this.decomposeObject(value, substring);
            }
            else if (Array.isArray(value)) {
                sub = this.decomposeArray(value, substring);
            }
            else {
                sub += value;
            }
            console.log(sub);
            if (this.hsUtilsService.isPOJO(sub)) {
                decomposed = this.hsUtilsService.structuredClone(sub, decomposed);
            }
            else {
                decomposed[substring] = sub;
            }
        });
        return decomposed;
    }
}
HsCatalogueMetadataService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCatalogueMetadataService, deps: [{ token: HsUtilsService }], target: i0.ɵɵFactoryTarget.Injectable });
HsCatalogueMetadataService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCatalogueMetadataService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCatalogueMetadataService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: HsUtilsService }]; } });

class HsCatalogueListItemComponent {
    constructor(hsConfig, //used in template
    hsDatasourcesMetadataService, hsAddDataCatalogueService, hsDialogContainerService, hsLaymanBrowserService, hsLogService, hsLanguageService, hsLaymanService, hsUtilsService, hsCommonEndpointsService) {
        this.hsConfig = hsConfig;
        this.hsDatasourcesMetadataService = hsDatasourcesMetadataService;
        this.hsAddDataCatalogueService = hsAddDataCatalogueService;
        this.hsDialogContainerService = hsDialogContainerService;
        this.hsLaymanBrowserService = hsLaymanBrowserService;
        this.hsLogService = hsLogService;
        this.hsLanguageService = hsLanguageService;
        this.hsLaymanService = hsLaymanService;
        this.hsUtilsService = hsUtilsService;
        this.hsCommonEndpointsService = hsCommonEndpointsService;
        this.app = 'default';
        this.loadingInfo = false;
    }
    ngOnInit() {
        this.appRef = this.hsAddDataCatalogueService.get(this.app);
        this.configRef = this.hsConfig.get(this.app);
    }
    /**
     * Add selected layer to map (into layer manager) if possible (supported formats: WMS, WFS, Sparql, kml, geojson, json)
     * @param endpoint - Datasource of selected layer
     * @param layer - Metadata record of selected layer
     */
    addLayerToMap(endpoint, layer) {
        return __awaiter(this, void 0, void 0, function* () {
            this.loadingInfo = true;
            const availableTypes = yield this.hsAddDataCatalogueService.addLayerToMap(endpoint, layer, this.app, this.selectedType);
            this.loadingInfo = false;
            if (Array.isArray(availableTypes)) {
                this.whatToAddTypes = availableTypes;
                this.selectTypeToAddLayerVisible = true;
            }
            else {
                this.selectTypeToAddLayerVisible = false;
                this.selectedType = null;
            }
            this.explanationsVisible = false;
        });
    }
    abortAdd() {
        this.selectTypeToAddLayerVisible = false;
        this.explanationsVisible = false;
        this.selectedType = null;
    }
    /**
     * Add layer by type click wrapper. Prevents bubbling of DOM event
     * @param type - One of 'WMS', 'WFS'
     * @param event - Mouse click event
     */
    selectTypeAndAdd(type, event) {
        event.preventDefault();
        this.selectedType = type;
        this.addLayerToMap(this.layer.endpoint, this.layer);
    }
    /**
     * Translate string value to the selected UI language
     * @param module - Locales json key
     * @param text - Locales json key value
     * @returns Translated text
     */
    translateString(module, text) {
        return this.hsLanguageService.getTranslationIgnoreNonExisting(module, text, undefined, this.app);
    }
    toggleExplanations() {
        this.explanationsVisible = !this.explanationsVisible;
    }
    /**
     * Show metadata record dialog window for selected layer.
     * @param endpoint - Datasource of selected layer
     * @param layer - Metadata record of selected layer
     */
    showMetadata(endpoint, layer) {
        return __awaiter(this, void 0, void 0, function* () {
            this.selected_layer = layer;
            this.selected_ds = endpoint;
            if (endpoint.type == 'layman') {
                yield this.hsLaymanBrowserService.fillLayerMetadata(endpoint, layer);
            }
            //this.metadata = this.hsDatasourcesMetadataService.decomposeMetadata(layer);
            //console.log(this.metadata);
            this.hsDialogContainerService.create(HsCatalogueMetadataComponent, {
                selectedLayer: this.selected_layer,
                selectedDS: this.selected_ds,
                app: this.app,
            }, this.app);
        });
    }
    /**
     * Show permissions dialog window for selected layer.
     * @param layer - Metadata record of selected layer
     */
    showPermissions(layer) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (!((_a = this.layer.endpoint) === null || _a === void 0 ? void 0 : _a.authenticated)) {
            }
            this.hsDialogContainerService.create(HsSetPermissionsDialogComponent, {
                recordType: 'layer',
                selectedRecord: layer,
                app: this.app,
            }, this.app);
        });
    }
    /**
     * @param endpoint - Datasource of selected layer
     * @param layer - Metadata record of selected layer
     * @returns URL to record file
     */
    layerRDF(endpoint, layer) {
        return this.hsAddDataCatalogueService.layerRDF(endpoint, layer);
    }
    /**
     * Removes selected drawing layer from both Layermanager and Layman
     * @param layer - Metadata record of selected layer
     */
    removeLayer(layer) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!layer.editable) {
                return;
            }
            const dialog = this.hsDialogContainerService.create(HsConfirmDialogComponent, {
                message: this.hsLanguageService.getTranslation('DRAW.reallyDeleteThisLayer', undefined, this.app),
                note: this.hsLanguageService.getTranslation('DRAW.deleteNote', undefined, this.app),
                title: this.hsLanguageService.getTranslation('COMMON.confirmDelete', undefined, this.app),
            }, this.app);
            const confirmed = yield dialog.waitResult();
            if (confirmed == 'yes') {
                const success = yield this.hsLaymanService.removeLayer(this.app, layer.name);
                if (success) {
                    this.appRef.catalogEntries = this.appRef.catalogEntries.filter((item) => {
                        return item.id != layer.id;
                    });
                }
            }
        });
    }
}
HsCatalogueListItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCatalogueListItemComponent, deps: [{ token: HsConfig }, { token: HsCatalogueMetadataService }, { token: HsAddDataCatalogueService }, { token: HsDialogContainerService }, { token: HsLaymanBrowserService }, { token: HsLogService }, { token: HsLanguageService }, { token: HsLaymanService }, { token: HsUtilsService }, { token: HsCommonEndpointsService }], target: i0.ɵɵFactoryTarget.Component });
HsCatalogueListItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsCatalogueListItemComponent, selector: "hs-catalogue-list-item", inputs: { layer: "layer", app: "app" }, ngImport: i0, template: "<div class=\"d-flex flex-column\">\n    <div class=\"\">\n        <a data-toggle=\"tooltip\" [title]=\"layer.abstract || ''\">{{layer.title || layer.abstract}}</a>\n    </div>\n    <div class=\"d-flex flex-column w-100 justify-content-around mt-2\" *ngIf=\"appRef.selectedLayer?.id === layer.id\">\n        <hr class=\"hs-dotted-line w-100 \">\n        <div class=\"d-flex flex-row justify-content-around align-items-end\">\n            <!-- <div class=\"p-0\" [hidden]=\"(selectTypeToAddLayerVisible)\">\n                            <button type=\"button\" class=\"btn btn-sm btn-primary align-middle\" (click)=\"addLayerToMap(layer.endpoint, layer)\"\n                                data-toggle=\"tooltip\" [title]=\"'DATASOURCE_SELECTOR.datasourceListItem.addToMap' | translateHs: {app} \"\n                                [ngClass]=\"{' btn-light text-primary' : layer.highlighted }\">\n                                <i class=\"icon-plus\"></i>\n                            </button>\n                            <span class=\"ms-2\">{{'DATASOURCE_SELECTOR.datasourceListItem.addToMap' | translateHs: {app} }}</span>\n                        </div> -->\n            <a class=\"btn btn-sm\" [hidden]=\"selectTypeToAddLayerVisible\"\n                (click)=\"$event.stopPropagation();addLayerToMap(layer.endpoint, layer)\">\n                <i [hidden]=\"loadingInfo\" class=\"icon-plus icon-primary\"></i>\n                <img [hidden]=\"!loadingInfo\" [src]=\"configRef._ajaxLoaderPath\" />\n                <span class=\"ms-1\">{{'DATASOURCE_SELECTOR.datasourceListItem.addToMap' |\n                    translateHs: {app} }}</span>\n            </a>\n            <a class=\"btn btn-sm\" [title]=\"'DATASOURCE_SELECTOR.datasourceListItem.abortAdd' | translateHs: {app} \"\n                (click)=\"$event.stopPropagation();abortAdd()\" [hidden]=\"!selectTypeToAddLayerVisible\">\n                <i class=\"icon-remove text-danger\"></i><span\n                    class=\"ms-1\">{{'DATASOURCE_SELECTOR.datasourceListItem.abortAdd' |\n                    translateHs: {app} }}</span>\n            </a>\n            <a class=\"btn btn-sm\" (click)=\"showMetadata(layer.endpoint, layer)\">\n                <i class=\"icon-info-sign icon-primary\"></i><span class=\"ms-1\">{{'COMMON.metadata' |\n                    translateHs: {app} }}</span>\n            </a>\n            <ng-container *ngIf=\"layer.endpoint?.authenticated\">\n                <a class=\"btn btn-sm\" (click)=\"$event.stopPropagation();showPermissions(layer)\" data-toggle=\"tooltip\"\n                    data-placement=\"bottom\"\n                    [title]=\"layer.editable ? '' : 'DATASOURCE_SELECTOR.datasourceListItem.notAllowedToEditLayer' | translateHs: {app} \">\n                    <i class=\"icon-lock icon-primary\" [ngClass]=\"{'text-muted': !layer.editable}\"\n                        [ngStyle]=\"{'cursor' : layer.editable ? 'pointer' : 'default'}\"></i><span class=\"ms-1\"\n                        *ngIf=\"layer.editable\">{{'COMMON.setPermissions' | translateHs: {app} }}</span>\n                </a>\n                <a class=\"btn btn-sm\" (click)=\"$event.stopPropagation();removeLayer(layer)\" data-toggle=\"tooltip\"\n                    data-placement=\"bottom\"\n                    [title]=\"layer.editable ? '' : 'DATASOURCE_SELECTOR.datasourceListItem.notAllowedToEditLayer' | translateHs: {app} \">\n                    <i class=\"icon-trash text-danger\" [ngClass]=\"layer.editable ? 'text-danger' : 'text-muted'\"\n                        [ngStyle]=\"{'cursor' : layer.editable ? 'pointer' : 'default'}\"></i><span class=\"ms-1\"\n                        *ngIf=\"layer.editable\">{{'COMMON.removeLayer' | translateHs: {app} }}</span>\n                </a>\n            </ng-container>\n        </div>\n    </div>\n    <div class=\"d-none\">\n        <div class=\"p-0\" [hidden]='hsAddDataCatalogueService.layerDownload(layer.endpoint,layer) === \"#\"'>\n            <!-- TODO: Remove function call from template -->\n            <a class=\"btn btn-sm btn-secondary\" [href]='hsAddDataCatalogueService.layerDownload(layer.endpoint, layer)'\n                data-toggle=\"tooltip\" [title]=\"'COMMON.download' | translateHs: {app} \"><i\n                    class=\"icon-download\"></i></a>\n        </div>\n        <!-- <div class=\"p-0\" [hidden]='getEndpoint(layer.endpoint).type != \"micka\" || layerRDF(layer.endpoint, layer) == \"#\"'>\n            <a class=\"btn btn-sm btn-secondary\" [href]='layerRDF(layer.endpoint, layer)'\n                data-toggle=\"tooltip\" title=\"GeoDCAT-AP\" target=\"_blank\"><i class=\"icon-share-alt\"></i></a>\n        </div> -->\n    </div>\n</div>\n<div>\n    <!-- <div class=\"p-0\" [hidden]=\"!selectTypeToAddLayerVisible || selectedType\">\n        <button type=\"button\" class=\"btn btn-sm btn-danger\" (click)=\"$event.stopPropagation();abortAdd()\" data-toggle=\"tooltip\"\n            [title]=\"'DATASOURCE_SELECTOR.datasourceListItem.abortAdd' | translateHs: {app} \">\n            <i class=\"icon-remove\"></i>\n        </button>\n    </div> -->\n    <div [hidden]=\"!loadingInfo\" class='list-group-item text-primary text-center py-2'><img class=\"pe-2\"\n            [src]=\"configRef._ajaxLoaderPath\" />{{'ADDDATA.CATALOGUE.loading' | translateHs : {app} }}</div>\n\n    <div class=\"card bg-light align-items-center\"\n        [hidden]=\"!selectTypeToAddLayerVisible || loadingInfo || appRef.selectedLayer?.id !== layer.id\">\n        <div class=\"d-flex flex-row justify-content-between align-items-center w-100\">\n            <div class=\"px-3\">\n                <span class=\"btn btn-sm\" disabled=\"true\" aria-disabled=\"true\">{{\n                    'ADDDATA.CATALOGUE.addAs' |\n                    translateHs: {app} }}&nbsp;</span>\n                <div class=\"btn-group btn-group-toggle h-100 pe-2 align-items-center\" data-toggle=\"buttons\">\n                    <label class=\"btn btn-sm btn-outline-secondary\" *ngFor=\"let type of whatToAddTypes\"\n                        style=\"width:6em\" (click)=\"selectTypeAndAdd(type,$event)\">\n                        {{type}}\n                    </label>\n                </div>\n            </div>\n            <div>\n                <a class=\"btn btn-sm\" (click)=\"$event.stopPropagation();toggleExplanations()\"\n                    [title]=\"'DATASOURCE_SELECTOR.datasourceListItem.whatDoesItMean' | translateHs: {app} \">\n                    <i class=\"icon-question-sign text-primary\"></i>\n                </a>\n            </div>\n        </div>\n        <div class=\"d-flex\">\n            <ul class=\"ms-auto p-2 list-unstyled\" [hidden]=\"!explanationsVisible\">\n                <li class=\"text-secondary small\" *ngFor=\"let type of whatToAddTypes\">\n                    {{type}} &ndash; {{translateString('ADDDATA.CATALOGUE.DESC', type)}}\n                    <!-- TODO: Remove function call from template -->\n                </li>\n            </ul>\n        </div>\n    </div>\n\n</div>", directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCatalogueListItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-catalogue-list-item', template: "<div class=\"d-flex flex-column\">\n    <div class=\"\">\n        <a data-toggle=\"tooltip\" [title]=\"layer.abstract || ''\">{{layer.title || layer.abstract}}</a>\n    </div>\n    <div class=\"d-flex flex-column w-100 justify-content-around mt-2\" *ngIf=\"appRef.selectedLayer?.id === layer.id\">\n        <hr class=\"hs-dotted-line w-100 \">\n        <div class=\"d-flex flex-row justify-content-around align-items-end\">\n            <!-- <div class=\"p-0\" [hidden]=\"(selectTypeToAddLayerVisible)\">\n                            <button type=\"button\" class=\"btn btn-sm btn-primary align-middle\" (click)=\"addLayerToMap(layer.endpoint, layer)\"\n                                data-toggle=\"tooltip\" [title]=\"'DATASOURCE_SELECTOR.datasourceListItem.addToMap' | translateHs: {app} \"\n                                [ngClass]=\"{' btn-light text-primary' : layer.highlighted }\">\n                                <i class=\"icon-plus\"></i>\n                            </button>\n                            <span class=\"ms-2\">{{'DATASOURCE_SELECTOR.datasourceListItem.addToMap' | translateHs: {app} }}</span>\n                        </div> -->\n            <a class=\"btn btn-sm\" [hidden]=\"selectTypeToAddLayerVisible\"\n                (click)=\"$event.stopPropagation();addLayerToMap(layer.endpoint, layer)\">\n                <i [hidden]=\"loadingInfo\" class=\"icon-plus icon-primary\"></i>\n                <img [hidden]=\"!loadingInfo\" [src]=\"configRef._ajaxLoaderPath\" />\n                <span class=\"ms-1\">{{'DATASOURCE_SELECTOR.datasourceListItem.addToMap' |\n                    translateHs: {app} }}</span>\n            </a>\n            <a class=\"btn btn-sm\" [title]=\"'DATASOURCE_SELECTOR.datasourceListItem.abortAdd' | translateHs: {app} \"\n                (click)=\"$event.stopPropagation();abortAdd()\" [hidden]=\"!selectTypeToAddLayerVisible\">\n                <i class=\"icon-remove text-danger\"></i><span\n                    class=\"ms-1\">{{'DATASOURCE_SELECTOR.datasourceListItem.abortAdd' |\n                    translateHs: {app} }}</span>\n            </a>\n            <a class=\"btn btn-sm\" (click)=\"showMetadata(layer.endpoint, layer)\">\n                <i class=\"icon-info-sign icon-primary\"></i><span class=\"ms-1\">{{'COMMON.metadata' |\n                    translateHs: {app} }}</span>\n            </a>\n            <ng-container *ngIf=\"layer.endpoint?.authenticated\">\n                <a class=\"btn btn-sm\" (click)=\"$event.stopPropagation();showPermissions(layer)\" data-toggle=\"tooltip\"\n                    data-placement=\"bottom\"\n                    [title]=\"layer.editable ? '' : 'DATASOURCE_SELECTOR.datasourceListItem.notAllowedToEditLayer' | translateHs: {app} \">\n                    <i class=\"icon-lock icon-primary\" [ngClass]=\"{'text-muted': !layer.editable}\"\n                        [ngStyle]=\"{'cursor' : layer.editable ? 'pointer' : 'default'}\"></i><span class=\"ms-1\"\n                        *ngIf=\"layer.editable\">{{'COMMON.setPermissions' | translateHs: {app} }}</span>\n                </a>\n                <a class=\"btn btn-sm\" (click)=\"$event.stopPropagation();removeLayer(layer)\" data-toggle=\"tooltip\"\n                    data-placement=\"bottom\"\n                    [title]=\"layer.editable ? '' : 'DATASOURCE_SELECTOR.datasourceListItem.notAllowedToEditLayer' | translateHs: {app} \">\n                    <i class=\"icon-trash text-danger\" [ngClass]=\"layer.editable ? 'text-danger' : 'text-muted'\"\n                        [ngStyle]=\"{'cursor' : layer.editable ? 'pointer' : 'default'}\"></i><span class=\"ms-1\"\n                        *ngIf=\"layer.editable\">{{'COMMON.removeLayer' | translateHs: {app} }}</span>\n                </a>\n            </ng-container>\n        </div>\n    </div>\n    <div class=\"d-none\">\n        <div class=\"p-0\" [hidden]='hsAddDataCatalogueService.layerDownload(layer.endpoint,layer) === \"#\"'>\n            <!-- TODO: Remove function call from template -->\n            <a class=\"btn btn-sm btn-secondary\" [href]='hsAddDataCatalogueService.layerDownload(layer.endpoint, layer)'\n                data-toggle=\"tooltip\" [title]=\"'COMMON.download' | translateHs: {app} \"><i\n                    class=\"icon-download\"></i></a>\n        </div>\n        <!-- <div class=\"p-0\" [hidden]='getEndpoint(layer.endpoint).type != \"micka\" || layerRDF(layer.endpoint, layer) == \"#\"'>\n            <a class=\"btn btn-sm btn-secondary\" [href]='layerRDF(layer.endpoint, layer)'\n                data-toggle=\"tooltip\" title=\"GeoDCAT-AP\" target=\"_blank\"><i class=\"icon-share-alt\"></i></a>\n        </div> -->\n    </div>\n</div>\n<div>\n    <!-- <div class=\"p-0\" [hidden]=\"!selectTypeToAddLayerVisible || selectedType\">\n        <button type=\"button\" class=\"btn btn-sm btn-danger\" (click)=\"$event.stopPropagation();abortAdd()\" data-toggle=\"tooltip\"\n            [title]=\"'DATASOURCE_SELECTOR.datasourceListItem.abortAdd' | translateHs: {app} \">\n            <i class=\"icon-remove\"></i>\n        </button>\n    </div> -->\n    <div [hidden]=\"!loadingInfo\" class='list-group-item text-primary text-center py-2'><img class=\"pe-2\"\n            [src]=\"configRef._ajaxLoaderPath\" />{{'ADDDATA.CATALOGUE.loading' | translateHs : {app} }}</div>\n\n    <div class=\"card bg-light align-items-center\"\n        [hidden]=\"!selectTypeToAddLayerVisible || loadingInfo || appRef.selectedLayer?.id !== layer.id\">\n        <div class=\"d-flex flex-row justify-content-between align-items-center w-100\">\n            <div class=\"px-3\">\n                <span class=\"btn btn-sm\" disabled=\"true\" aria-disabled=\"true\">{{\n                    'ADDDATA.CATALOGUE.addAs' |\n                    translateHs: {app} }}&nbsp;</span>\n                <div class=\"btn-group btn-group-toggle h-100 pe-2 align-items-center\" data-toggle=\"buttons\">\n                    <label class=\"btn btn-sm btn-outline-secondary\" *ngFor=\"let type of whatToAddTypes\"\n                        style=\"width:6em\" (click)=\"selectTypeAndAdd(type,$event)\">\n                        {{type}}\n                    </label>\n                </div>\n            </div>\n            <div>\n                <a class=\"btn btn-sm\" (click)=\"$event.stopPropagation();toggleExplanations()\"\n                    [title]=\"'DATASOURCE_SELECTOR.datasourceListItem.whatDoesItMean' | translateHs: {app} \">\n                    <i class=\"icon-question-sign text-primary\"></i>\n                </a>\n            </div>\n        </div>\n        <div class=\"d-flex\">\n            <ul class=\"ms-auto p-2 list-unstyled\" [hidden]=\"!explanationsVisible\">\n                <li class=\"text-secondary small\" *ngFor=\"let type of whatToAddTypes\">\n                    {{type}} &ndash; {{translateString('ADDDATA.CATALOGUE.DESC', type)}}\n                    <!-- TODO: Remove function call from template -->\n                </li>\n            </ul>\n        </div>\n    </div>\n\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsConfig }, { type: HsCatalogueMetadataService }, { type: HsAddDataCatalogueService }, { type: HsDialogContainerService }, { type: HsLaymanBrowserService }, { type: HsLogService }, { type: HsLanguageService }, { type: HsLaymanService }, { type: HsUtilsService }, { type: HsCommonEndpointsService }]; }, propDecorators: { layer: [{
                type: Input
            }], app: [{
                type: Input
            }] } });

class HsPagerComponent {
    constructor() {
        this.app = 'default';
        this.recordsPerPageArray = [5, 10, 15, 20, 25, 50, 100];
    }
    ngOnInit() {
        this.appRef = this.pagerService.get(this.app);
    }
    /**
     * Checks if next page for pagination is available
     */
    nextPageAvailable() {
        if (this.appRef.listNext == this.appRef.matchedRecords ||
            this.appRef.matchedRecords == 0) {
            return true;
        }
        else {
            return false;
        }
    }
    /**
     * Load previous list of items to display on pager
     */
    getPreviousRecords() {
        if (this.pagerService.getPreviousRecords) {
            this.pagerService.getPreviousRecords(this.app);
        }
        else {
            if (this.appRef.listStart - this.appRef.recordsPerPage <= 0) {
                this.appRef.listStart = 0;
                this.appRef.listNext = this.appRef.recordsPerPage;
            }
            else {
                this.appRef.listStart -= this.appRef.recordsPerPage;
                this.appRef.listNext =
                    this.appRef.listStart + this.appRef.recordsPerPage;
            }
        }
    }
    changeRecordsPerPage(perPage) {
        if (perPage > this.appRef.matchedRecords) {
            this.appRef.recordsPerPage = this.appRef.matchedRecords;
        }
        else {
            this.appRef.recordsPerPage = perPage;
        }
        this.appRef.listStart = 0;
        this.appRef.listNext = this.appRef.recordsPerPage;
        if (this.pagerService.changeRecordsPerPage) {
            this.pagerService.changeRecordsPerPage(this.app);
        }
    }
    /**
     * Load next list of items to display on pager
     */
    getNextRecords() {
        if (this.pagerService.getNextRecords) {
            this.pagerService.getNextRecords(this.app);
        }
        else {
            this.appRef.listStart += this.appRef.recordsPerPage;
            this.appRef.listNext += this.appRef.recordsPerPage;
            if (this.appRef.listNext > this.appRef.matchedRecords) {
                this.appRef.listNext = this.appRef.matchedRecords;
            }
        }
    }
    resultsVisible() {
        return this.appRef.listNext && this.appRef.matchedRecords ? true : false;
    }
}
HsPagerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsPagerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
HsPagerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsPagerComponent, selector: "hs-pager", inputs: { app: "app", pagerService: "pagerService" }, ngImport: i0, template: "<div class=\"card-footer\" *ngIf=\"resultsVisible()\"> <!-- TODO: Remove function call from template -->\n  <ul class=\"pagination d-flex justify-content-center m-1 align-items-center\">\n    <li class=\"page-item\" [ngClass]=\"{'disabled': appRef.listStart === 0 }\"\n      [ngStyle]=\"{'color' : appRef.listStart === 0 ? '#555' : '#007bff'}\">\n      <a class=\"page-link\" (click)=\"getPreviousRecords()\"><span aria-hidden=\"true\">&laquo;</span></a>\n    </li>\n    <li class=\"page-item\" *ngIf=\"appRef.listNext !== appRef.matchedRecords\">\n      <span class=\"page-link\">\n        {{'COMMON.results' | translateHs: {app} }}\n        {{appRef.listStart + 1}} -\n        {{appRef.listNext}}</span>\n    </li>\n    <li class=\"page-item\" *ngIf=\"appRef.listNext === appRef.matchedRecords\">\n      <span class=\"page-link\">\n        {{'COMMON.results' | translateHs: {app} }}\n        {{appRef.listStart + 1}} -\n        {{appRef.matchedRecords}}</span>\n    </li>\n    <li class=\"page-item\" [ngClass]=\"{'disabled': nextPageAvailable() }\"\n      [ngStyle]=\"{'color' : nextPageAvailable() ? '#555' : '#007bff'}\"> <!-- TODO: Remove function call from template -->\n      <a class=\"page-link\" (click)=\"getNextRecords()\"><span aria-hidden=\"true\">&raquo;</span></a>\n    </li>\n    <li ngbDropdown display=\"dynamic\" placement=\"top-right\" class=\"pe-3\" style=\"position: absolute;\n    right: 0;\">\n      <div class=\"btn-group\">\n        <button class=\"but-title-sm m-1\" data-toggle=\"tooltip\"\n          [title]=\"'ADDDATA.CATALOGUE.theNumberOfRecords' | translateHs: {app} \">\n          <i class=\"icon-question-sign\"></i>\n        </button>\n        <button ngbDropdownToggle type=\"button\"\n          class=\"btn btn-outline-secondary btn-sm dropdown-toggle dropdown-toggle-split rounded-0\"\n          [title]=\"'COMMON.selectRecordCountPerPage' | translateHs: {app} \" aria-haspopup=\"true\" aria-expanded=\"false\">\n        </button>\n      </div>\n      <div ngbDropdownMenu class=\"dropdown-menu\">\n        <a class=\"dropdown-item\" *ngFor=\"let perPage of recordsPerPageArray\"\n          (click)=\"changeRecordsPerPage(perPage)\">{{perPage}}</a>\n      </div>\n    </li>\n  </ul>\n</div>\n", directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { type: i7.NgbDropdown, selector: "[ngbDropdown]", inputs: ["autoClose", "dropdownClass", "open", "placement", "container", "display"], outputs: ["openChange"], exportAs: ["ngbDropdown"] }, { type: i7.NgbDropdownToggle, selector: "[ngbDropdownToggle]" }, { type: i7.NgbDropdownMenu, selector: "[ngbDropdownMenu]" }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsPagerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-pager', template: "<div class=\"card-footer\" *ngIf=\"resultsVisible()\"> <!-- TODO: Remove function call from template -->\n  <ul class=\"pagination d-flex justify-content-center m-1 align-items-center\">\n    <li class=\"page-item\" [ngClass]=\"{'disabled': appRef.listStart === 0 }\"\n      [ngStyle]=\"{'color' : appRef.listStart === 0 ? '#555' : '#007bff'}\">\n      <a class=\"page-link\" (click)=\"getPreviousRecords()\"><span aria-hidden=\"true\">&laquo;</span></a>\n    </li>\n    <li class=\"page-item\" *ngIf=\"appRef.listNext !== appRef.matchedRecords\">\n      <span class=\"page-link\">\n        {{'COMMON.results' | translateHs: {app} }}\n        {{appRef.listStart + 1}} -\n        {{appRef.listNext}}</span>\n    </li>\n    <li class=\"page-item\" *ngIf=\"appRef.listNext === appRef.matchedRecords\">\n      <span class=\"page-link\">\n        {{'COMMON.results' | translateHs: {app} }}\n        {{appRef.listStart + 1}} -\n        {{appRef.matchedRecords}}</span>\n    </li>\n    <li class=\"page-item\" [ngClass]=\"{'disabled': nextPageAvailable() }\"\n      [ngStyle]=\"{'color' : nextPageAvailable() ? '#555' : '#007bff'}\"> <!-- TODO: Remove function call from template -->\n      <a class=\"page-link\" (click)=\"getNextRecords()\"><span aria-hidden=\"true\">&raquo;</span></a>\n    </li>\n    <li ngbDropdown display=\"dynamic\" placement=\"top-right\" class=\"pe-3\" style=\"position: absolute;\n    right: 0;\">\n      <div class=\"btn-group\">\n        <button class=\"but-title-sm m-1\" data-toggle=\"tooltip\"\n          [title]=\"'ADDDATA.CATALOGUE.theNumberOfRecords' | translateHs: {app} \">\n          <i class=\"icon-question-sign\"></i>\n        </button>\n        <button ngbDropdownToggle type=\"button\"\n          class=\"btn btn-outline-secondary btn-sm dropdown-toggle dropdown-toggle-split rounded-0\"\n          [title]=\"'COMMON.selectRecordCountPerPage' | translateHs: {app} \" aria-haspopup=\"true\" aria-expanded=\"false\">\n        </button>\n      </div>\n      <div ngbDropdownMenu class=\"dropdown-menu\">\n        <a class=\"dropdown-item\" *ngFor=\"let perPage of recordsPerPageArray\"\n          (click)=\"changeRecordsPerPage(perPage)\">{{perPage}}</a>\n      </div>\n    </li>\n  </ul>\n</div>\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { app: [{
                type: Input
            }], pagerService: [{
                type: Input
            }] } });

// import {HsDragDropLayerService} from './drag-drop-layer.service';
class HsAddDataCatalogueComponent {
    constructor(hsLanguageService, hsCommonEndpointsService, //Used in template
    hsConfig, //Used in template
    hsCore, //Used in template
    hsAddDataCatalogueService, hsAddDataCatalogueMapService, //Used in template
    hsLayoutService, hsUtilsService, hsLaymanService //Used in template
    ) {
        this.hsLanguageService = hsLanguageService;
        this.hsCommonEndpointsService = hsCommonEndpointsService;
        this.hsConfig = hsConfig;
        this.hsCore = hsCore;
        this.hsAddDataCatalogueService = hsAddDataCatalogueService;
        this.hsAddDataCatalogueMapService = hsAddDataCatalogueMapService;
        this.hsLayoutService = hsLayoutService;
        this.hsUtilsService = hsUtilsService;
        this.hsLaymanService = hsLaymanService;
        this.app = 'default';
        this.textFieldTypes = ['AnyText', 'Abstract', 'Title'];
        this.dataTypes = ['all', 'service', 'dataset'];
        this.sortbyTypes = ['date', 'title', 'bbox'];
        this.optionsButtonLabel = 'more';
        this.advancedSearch = false;
    }
    ngOnInit() {
        this.appRef = this.hsAddDataCatalogueService.get(this.app);
        this.data = this.appRef.data;
        this.configRef = this.hsConfig.get(this.app);
        this.queryCatalogs = () => this.hsAddDataCatalogueService.queryCatalogs(this.data.app);
        this.hsAddDataCatalogueService.init(this.app);
        this.hsAddDataCatalogueMapService.init(this.app);
    }
    layerSelected(layer) {
        this.appRef.selectedLayer =
            this.appRef.selectedLayer == layer ? {} : layer;
    }
    translateString(module, text) {
        return this.hsLanguageService.getTranslationIgnoreNonExisting(module, text, undefined, this.data.app);
    }
    openOptionsMenu() {
        this.filterTypeMenu = !this.filterTypeMenu;
        if (this.filterTypeMenu) {
            this.optionsButtonLabel = 'less';
        }
        else {
            this.optionsButtonLabel = 'more';
        }
    }
    queryByFilter() {
        this.hsAddDataCatalogueService.reloadData(this.app);
    }
    selectType(type) {
        this.data.textField = type;
        if (this.data.query.textFilter.length > 0) {
            this.queryByFilter();
        }
        this.filterTypeMenu = !this.filterTypeMenu;
    }
    selectQueryType(type, query) {
        this.data.query[query] = type;
        this.queryByFilter();
        this.filterTypeMenu = !this.filterTypeMenu;
    }
    highlightLayer(layer, state, app) {
        layer.highlighted = state;
        this.hsAddDataCatalogueMapService.highlightLayer(layer, state, app);
    }
    datasetSelect(id_selected, endpoint) {
        this.hsAddDataCatalogueService.datasetSelect(id_selected, this.app);
        if (endpoint) {
            this.appRef.selectedEndpoint = endpoint;
        }
    }
}
HsAddDataCatalogueComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataCatalogueComponent, deps: [{ token: HsLanguageService }, { token: HsCommonEndpointsService }, { token: HsConfig }, { token: HsCoreService }, { token: HsAddDataCatalogueService }, { token: HsAddDataCatalogueMapService }, { token: HsLayoutService }, { token: HsUtilsService }, { token: HsLaymanService }], target: i0.ɵɵFactoryTarget.Component });
HsAddDataCatalogueComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsAddDataCatalogueComponent, selector: "hs-add-data-catalogue", inputs: { app: "app" }, ngImport: i0, template: "<div class=\"card hs-main-panel\">\n    <div class=\"mt-3 mx-3 ps-1 d-flex justify-content-between\">\n        <div class=\"input-group w-50\">\n            <input type=\"search\" class=\"form-control w-50\" [placeholder]=\"'COMMON.search' | translateHs : {app}  \"\n                name=\"search\" [(ngModel)]=\"data.query.textFilter\" (ngModelChange)=\"queryByFilter()\">\n            <button class=\"input-group-text text-secondary border-start-0\" (click)=\"queryByFilter()\">\n                <i class=\"icon-search icon-primary\"></i>\n            </button>\n        </div>\n        <hs-layman-current-user [app]=\"app\" [endpoint]=\"hsLaymanService.getLaymanEndpoint()\"></hs-layman-current-user>\n        <!-- TODO: Remove function call from template -->\n    </div>\n    <div class=\"d-flex ms-4 me-3 justify-content-between py-1 \">\n        <div class=\"d-flex\">\n            <div class=\"input-group-text border-0\">\n                <input type=\"checkbox\" [(ngModel)]=\"data.filterByExtent\" (change)=\"queryByFilter()\"\n                    name=\"filterByExtent\">\n                <span class=\"ms-1\">{{'COMPOSITIONS.filterByMap' | translateHs : {app} }}</span>\n            </div>\n            <div class=\"input-group-text border-0 ms-1\"\n                *ngIf=\"hsLaymanService.getLaymanEndpoint() && !hsLaymanService.isLaymanGuest()\">\n                <!-- TODO: Remove function call from template -->\n                <input type=\"checkbox\" [(ngModel)]=\"data.onlyMine\" (ngModelChange)=\"queryByFilter()\" name=\"onlyMine\">\n                <span class=\"ms-1\">{{'COMPOSITIONS.onlyMine' | translateHs : {app} }}</span>\n            </div>\n        </div>\n\n        <div ngbDropdown display=\"dynamic\" placement=\"bottom-right\" class=\"d-inline-block\">\n            <button class=\"btn btn-light hs-white-background hs-custom-toggle\" (click)=\"openOptionsMenu()\"\n                ngbDropdownToggle>{{translateString('COMMON',optionsButtonLabel)}}</button>\n            <!-- TODO: Remove function call from template -->\n            <div ngbDropdownMenu class=\"dropdown-menu-right p-2 m-1\"\n                style=\"min-width: 23rem; max-width: 23rem;  overflow: visible\" aria-labelledby=\"filtersDropdown\">\n                <table class=\"p-1 ps-3\" style=\"border-collapse:separate; border-spacing:0.5rem 0.5rem;\">\n                    <tbody>\n                        <tr>\n                            <td class=\"tdbreak\">\n                                {{'ADDDATA.CATALOGUE.filterType' | translateHs : {app} }}\n                            </td>\n                            <td ngbDropdown display=\"dynamic\" placement=\"bottom-right\"\n                                #searchTypeDropdown=\"ngbDropdown\">\n                                <button type=\"button\" ngbDropdownToggle\n                                    class=\"btn btn-light btn-sm hs-custom-toggle hs-background-alfa p-2 ps-1 border-0\"\n                                    style=\"text-align:start; min-width: 11rem; max-width: 11rem; border-radius: 0px; justify-content: space-between; display:flex; align-items: center;\">\n                                    {{translateString('ADDDATA.CATALOGUE.searchFilterTypes',\n                                    data.textField)}}\n                                </button>\n                                <ul ngbDropdownMenu aria-labelledby=\"searchType\" class=\"ps-2\"\n                                    style=\"overflow-y: auto; max-height: 10rem; min-width:10rem\">\n                                    <li *ngFor=\"let searchType of textFieldTypes; let index = index\">\n                                        <label style=\"cursor: pointer;\"><input class=\"me-2\" type=\"radio\"\n                                                name=\"searchType-index\" [checked]=\"(index === 0)\"\n                                                (change)=\"selectType(searchType);searchTypeDropdown.close()\">{{translateString('ADDDATA.CATALOGUE.searchFilterTypes',\n                                            searchType)}}</label>\n                                    </li>\n                                </ul>\n                            </td>\n                        </tr>\n                        <tr>\n                            <td class=\"tdbreak\">\n                                {{'ADDDATA.CATALOGUE.resourceType' | translateHs : {app} }}\n                            </td>\n                            <td ngbDropdown display=\"dynamic\" placement=\"bottom-right\" #resourceType=\"ngbDropdown\">\n                                <button type=\"button\" ngbDropdownToggle\n                                    class=\"btn btn-light btn-sm hs-custom-toggle hs-background-alfa p-2 ps-1 border-0\"\n                                    style=\"text-align:start; min-width: 11rem; max-width: 11rem; border-radius: 0px; justify-content: space-between; display:flex; align-items: center;\">\n                                    {{translateString('ADDDATA.CATALOGUE.queryDataTypes',\n                                    data.query.type)}}\n                                </button>\n                                <ul ngbDropdownMenu aria-labelledby=\"type\" class=\"ps-2\"\n                                    style=\"overflow-y: auto; max-height: 10rem; min-width:10rem\">\n                                    <li *ngFor=\"let type of dataTypes; let index = index\">\n                                        <label style=\"cursor: pointer;\"><input class=\"me-2\" type=\"radio\"\n                                                name=\"type-index\" [checked]=\"(index === 1)\"\n                                                (change)=\"selectQueryType(type, 'type');resourceType.close()\">{{translateString('ADDDATA.CATALOGUE.queryDataTypes',\n                                            type)}}</label>\n                                    </li>\n                                </ul>\n                            </td>\n                        </tr>\n                        <tr>\n                            <td class=\"tdbreak\">\n                                {{'COMMON.sortBy' | translateHs : {app} }}\n                            </td>\n                            <td ngbDropdown display=\"dynamic\" placement=\"bottom-right\" #sortByDrop=\"ngbDropdown\">\n                                <button type=\"button\" ngbDropdownToggle\n                                    class=\"btn btn-light btn-sm hs-custom-toggle hs-background-alfa p-2 ps-1 border-0\"\n                                    style=\"text-align:start; min-width: 11rem; max-width: 11rem; border-radius: 0px; justify-content: space-between; display:flex; align-items: center;\">\n                                    {{translateString('ADDDATA.CATALOGUE.sortbyTypes', data.query.sortby)}}\n                                    <!-- TODO: Remove function call from template -->\n                                </button>\n                                <ul ngbDropdownMenu aria-labelledby=\"sortBy\" class=\"ps-2\"\n                                    style=\"overflow-y: auto; max-height: 10rem; min-width:10rem\">\n                                    <li *ngFor=\"let sortType of sortbyTypes, let index = index;\">\n                                        <label style=\"cursor: pointer;\"><input class=\"me-2\" type=\"radio\"\n                                                name=\"sort-index\" [checked]=\"(index === 0)\"\n                                                (change)=\"selectQueryType(sortType, 'sortby');sortByDrop.close()\">{{translateString('ADDDATA.CATALOGUE.sortbyTypes',\n                                            sortType)}}</label>\n                                    </li>\n                                </ul>\n                            </td>\n                        </tr>\n                    </tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n    <div class=\"tab-content\">\n        <div class=\"card d-flex\" style=\"font-size: 1rem !important;\">\n            <div class=\"card-body\">\n                <!-- <div *ngIf=\"endpoint.type == 'micka'\">\n                        <hs-micka-filters micka-dataset-config=\"{url: endpoint.url}\"></hs-micka-filters>\n                    </div>\n                -->\n                <ul class=\"list-group\">\n                    <li [hidden]=\"appRef.dataLoading\" style=\"cursor: pointer;\"\n                        *ngFor=\"let layer of appRef.catalogEntries; trackBy:( 'id' | trackByProperty )\"\n                        class=\"clearfix list-group-item\" [ngClass]=\"{'hs-endpoint-item-active': layer.highlighted}\"\n                        (click)=\"layerSelected(layer)\" (mouseover)=\"highlightLayer(layer, true,app)\"\n                        (mouseleave)=\"highlightLayer(layer, false,app)\">\n                        <hs-catalogue-list-item [layer]=\"layer\" [app]=\"app\"></hs-catalogue-list-item>\n                    </li>\n                    <li class='list-group-item text-primary text-center py-2' [hidden]=\"!appRef.dataLoading\"><img\n                            class=\"pe-2\" [src]=\"configRef._ajaxLoaderPath\" />{{'ADDDATA.CATALOGUE.loading' | translateHs\n                        : {app} }}</li>\n                    <li [hidden]='appRef.catalogEntries.length > 0 || appRef.dataLoading' class='list-group-item'\n                        style=\"border-top-width: 1px; border-radius: inherit\">\n                        {{'DATASOURCE_SELECTOR.noResults' | translateHs : {app} }}</li>\n                </ul>\n            </div>\n            <ng-container *ngIf=\"appRef.matchedRecords !== 0 && !appRef.dataLoading\">\n                <hs-pager [app]=\"app\" [pagerService]=\"hsAddDataCatalogueService\"></hs-pager>\n            </ng-container>\n        </div>\n    </div>\n</div>", components: [{ type: HsLaymanCurrentUserComponent, selector: "hs-layman-current-user", inputs: ["app", "endpoint"] }, { type: HsCatalogueListItemComponent, selector: "hs-catalogue-list-item", inputs: ["layer", "app"] }, { type: HsPagerComponent, selector: "hs-pager", inputs: ["app", "pagerService"] }], directives: [{ type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3$1.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i7.NgbDropdown, selector: "[ngbDropdown]", inputs: ["autoClose", "dropdownClass", "open", "placement", "container", "display"], outputs: ["openChange"], exportAs: ["ngbDropdown"] }, { type: i7.NgbDropdownToggle, selector: "[ngbDropdownToggle]" }, { type: i7.NgbDropdownMenu, selector: "[ngbDropdownMenu]" }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], pipes: { "translateHs": TranslateCustomPipe, "trackByProperty": TrackByPropertyPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataCatalogueComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-add-data-catalogue', template: "<div class=\"card hs-main-panel\">\n    <div class=\"mt-3 mx-3 ps-1 d-flex justify-content-between\">\n        <div class=\"input-group w-50\">\n            <input type=\"search\" class=\"form-control w-50\" [placeholder]=\"'COMMON.search' | translateHs : {app}  \"\n                name=\"search\" [(ngModel)]=\"data.query.textFilter\" (ngModelChange)=\"queryByFilter()\">\n            <button class=\"input-group-text text-secondary border-start-0\" (click)=\"queryByFilter()\">\n                <i class=\"icon-search icon-primary\"></i>\n            </button>\n        </div>\n        <hs-layman-current-user [app]=\"app\" [endpoint]=\"hsLaymanService.getLaymanEndpoint()\"></hs-layman-current-user>\n        <!-- TODO: Remove function call from template -->\n    </div>\n    <div class=\"d-flex ms-4 me-3 justify-content-between py-1 \">\n        <div class=\"d-flex\">\n            <div class=\"input-group-text border-0\">\n                <input type=\"checkbox\" [(ngModel)]=\"data.filterByExtent\" (change)=\"queryByFilter()\"\n                    name=\"filterByExtent\">\n                <span class=\"ms-1\">{{'COMPOSITIONS.filterByMap' | translateHs : {app} }}</span>\n            </div>\n            <div class=\"input-group-text border-0 ms-1\"\n                *ngIf=\"hsLaymanService.getLaymanEndpoint() && !hsLaymanService.isLaymanGuest()\">\n                <!-- TODO: Remove function call from template -->\n                <input type=\"checkbox\" [(ngModel)]=\"data.onlyMine\" (ngModelChange)=\"queryByFilter()\" name=\"onlyMine\">\n                <span class=\"ms-1\">{{'COMPOSITIONS.onlyMine' | translateHs : {app} }}</span>\n            </div>\n        </div>\n\n        <div ngbDropdown display=\"dynamic\" placement=\"bottom-right\" class=\"d-inline-block\">\n            <button class=\"btn btn-light hs-white-background hs-custom-toggle\" (click)=\"openOptionsMenu()\"\n                ngbDropdownToggle>{{translateString('COMMON',optionsButtonLabel)}}</button>\n            <!-- TODO: Remove function call from template -->\n            <div ngbDropdownMenu class=\"dropdown-menu-right p-2 m-1\"\n                style=\"min-width: 23rem; max-width: 23rem;  overflow: visible\" aria-labelledby=\"filtersDropdown\">\n                <table class=\"p-1 ps-3\" style=\"border-collapse:separate; border-spacing:0.5rem 0.5rem;\">\n                    <tbody>\n                        <tr>\n                            <td class=\"tdbreak\">\n                                {{'ADDDATA.CATALOGUE.filterType' | translateHs : {app} }}\n                            </td>\n                            <td ngbDropdown display=\"dynamic\" placement=\"bottom-right\"\n                                #searchTypeDropdown=\"ngbDropdown\">\n                                <button type=\"button\" ngbDropdownToggle\n                                    class=\"btn btn-light btn-sm hs-custom-toggle hs-background-alfa p-2 ps-1 border-0\"\n                                    style=\"text-align:start; min-width: 11rem; max-width: 11rem; border-radius: 0px; justify-content: space-between; display:flex; align-items: center;\">\n                                    {{translateString('ADDDATA.CATALOGUE.searchFilterTypes',\n                                    data.textField)}}\n                                </button>\n                                <ul ngbDropdownMenu aria-labelledby=\"searchType\" class=\"ps-2\"\n                                    style=\"overflow-y: auto; max-height: 10rem; min-width:10rem\">\n                                    <li *ngFor=\"let searchType of textFieldTypes; let index = index\">\n                                        <label style=\"cursor: pointer;\"><input class=\"me-2\" type=\"radio\"\n                                                name=\"searchType-index\" [checked]=\"(index === 0)\"\n                                                (change)=\"selectType(searchType);searchTypeDropdown.close()\">{{translateString('ADDDATA.CATALOGUE.searchFilterTypes',\n                                            searchType)}}</label>\n                                    </li>\n                                </ul>\n                            </td>\n                        </tr>\n                        <tr>\n                            <td class=\"tdbreak\">\n                                {{'ADDDATA.CATALOGUE.resourceType' | translateHs : {app} }}\n                            </td>\n                            <td ngbDropdown display=\"dynamic\" placement=\"bottom-right\" #resourceType=\"ngbDropdown\">\n                                <button type=\"button\" ngbDropdownToggle\n                                    class=\"btn btn-light btn-sm hs-custom-toggle hs-background-alfa p-2 ps-1 border-0\"\n                                    style=\"text-align:start; min-width: 11rem; max-width: 11rem; border-radius: 0px; justify-content: space-between; display:flex; align-items: center;\">\n                                    {{translateString('ADDDATA.CATALOGUE.queryDataTypes',\n                                    data.query.type)}}\n                                </button>\n                                <ul ngbDropdownMenu aria-labelledby=\"type\" class=\"ps-2\"\n                                    style=\"overflow-y: auto; max-height: 10rem; min-width:10rem\">\n                                    <li *ngFor=\"let type of dataTypes; let index = index\">\n                                        <label style=\"cursor: pointer;\"><input class=\"me-2\" type=\"radio\"\n                                                name=\"type-index\" [checked]=\"(index === 1)\"\n                                                (change)=\"selectQueryType(type, 'type');resourceType.close()\">{{translateString('ADDDATA.CATALOGUE.queryDataTypes',\n                                            type)}}</label>\n                                    </li>\n                                </ul>\n                            </td>\n                        </tr>\n                        <tr>\n                            <td class=\"tdbreak\">\n                                {{'COMMON.sortBy' | translateHs : {app} }}\n                            </td>\n                            <td ngbDropdown display=\"dynamic\" placement=\"bottom-right\" #sortByDrop=\"ngbDropdown\">\n                                <button type=\"button\" ngbDropdownToggle\n                                    class=\"btn btn-light btn-sm hs-custom-toggle hs-background-alfa p-2 ps-1 border-0\"\n                                    style=\"text-align:start; min-width: 11rem; max-width: 11rem; border-radius: 0px; justify-content: space-between; display:flex; align-items: center;\">\n                                    {{translateString('ADDDATA.CATALOGUE.sortbyTypes', data.query.sortby)}}\n                                    <!-- TODO: Remove function call from template -->\n                                </button>\n                                <ul ngbDropdownMenu aria-labelledby=\"sortBy\" class=\"ps-2\"\n                                    style=\"overflow-y: auto; max-height: 10rem; min-width:10rem\">\n                                    <li *ngFor=\"let sortType of sortbyTypes, let index = index;\">\n                                        <label style=\"cursor: pointer;\"><input class=\"me-2\" type=\"radio\"\n                                                name=\"sort-index\" [checked]=\"(index === 0)\"\n                                                (change)=\"selectQueryType(sortType, 'sortby');sortByDrop.close()\">{{translateString('ADDDATA.CATALOGUE.sortbyTypes',\n                                            sortType)}}</label>\n                                    </li>\n                                </ul>\n                            </td>\n                        </tr>\n                    </tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n    <div class=\"tab-content\">\n        <div class=\"card d-flex\" style=\"font-size: 1rem !important;\">\n            <div class=\"card-body\">\n                <!-- <div *ngIf=\"endpoint.type == 'micka'\">\n                        <hs-micka-filters micka-dataset-config=\"{url: endpoint.url}\"></hs-micka-filters>\n                    </div>\n                -->\n                <ul class=\"list-group\">\n                    <li [hidden]=\"appRef.dataLoading\" style=\"cursor: pointer;\"\n                        *ngFor=\"let layer of appRef.catalogEntries; trackBy:( 'id' | trackByProperty )\"\n                        class=\"clearfix list-group-item\" [ngClass]=\"{'hs-endpoint-item-active': layer.highlighted}\"\n                        (click)=\"layerSelected(layer)\" (mouseover)=\"highlightLayer(layer, true,app)\"\n                        (mouseleave)=\"highlightLayer(layer, false,app)\">\n                        <hs-catalogue-list-item [layer]=\"layer\" [app]=\"app\"></hs-catalogue-list-item>\n                    </li>\n                    <li class='list-group-item text-primary text-center py-2' [hidden]=\"!appRef.dataLoading\"><img\n                            class=\"pe-2\" [src]=\"configRef._ajaxLoaderPath\" />{{'ADDDATA.CATALOGUE.loading' | translateHs\n                        : {app} }}</li>\n                    <li [hidden]='appRef.catalogEntries.length > 0 || appRef.dataLoading' class='list-group-item'\n                        style=\"border-top-width: 1px; border-radius: inherit\">\n                        {{'DATASOURCE_SELECTOR.noResults' | translateHs : {app} }}</li>\n                </ul>\n            </div>\n            <ng-container *ngIf=\"appRef.matchedRecords !== 0 && !appRef.dataLoading\">\n                <hs-pager [app]=\"app\" [pagerService]=\"hsAddDataCatalogueService\"></hs-pager>\n            </ng-container>\n        </div>\n    </div>\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsLanguageService }, { type: HsCommonEndpointsService }, { type: HsConfig }, { type: HsCoreService }, { type: HsAddDataCatalogueService }, { type: HsAddDataCatalogueMapService }, { type: HsLayoutService }, { type: HsUtilsService }, { type: HsLaymanService }]; }, propDecorators: { app: [{
                type: Input
            }] } });

class HsAddDataComponent extends HsPanelBaseComponent {
    constructor(hsAddDataService, hsLanguageService, hsShareUrlService, hsLayoutService, hsEventBusService, hsAddDataUrlService, hsCommonEndpointsService, hsSidebarService) {
        super(hsLayoutService);
        this.hsAddDataService = hsAddDataService;
        this.hsLanguageService = hsLanguageService;
        this.hsShareUrlService = hsShareUrlService;
        this.hsLayoutService = hsLayoutService;
        this.hsEventBusService = hsEventBusService;
        this.hsAddDataUrlService = hsAddDataUrlService;
        this.hsCommonEndpointsService = hsCommonEndpointsService;
        this.hsSidebarService = hsSidebarService;
        this.name = 'addData';
    }
    datasetSelect(type) {
        this.hsAddDataService.selectType(type, this.data.app);
    }
    ngOnInit() {
        this.appRef = this.hsAddDataService.get(this.data.app);
        this.appRef.dsSelected = 'catalogue';
        this.hsSidebarService.addButton({
            panel: 'addData',
            module: 'hs.addData',
            order: 4,
            fits: true,
            title: 'PANEL_HEADER.ADDLAYERS',
            description: 'SIDEBAR.descriptions.ADDLAYERS',
            icon: 'icon-database',
        }, this.data.app);
        servicesSupportedByUrl.forEach((type) => this.connectServiceFromUrlParam(type));
        this.hsCommonEndpointsService.init(this.data.app);
    }
    connectServiceFromUrlParam(type) {
        const url = this.hsShareUrlService.getParamValue(`hs-${type}-to-connect`);
        if (url) {
            this.hsLayoutService.setMainPanel('addData', this.data.app);
            this.hsAddDataService.get(this.data.app).dsSelected = 'url';
            this.hsAddDataUrlService.get(this.data.app).typeSelected = type;
        }
    }
}
HsAddDataComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataComponent, deps: [{ token: HsAddDataService }, { token: HsLanguageService }, { token: HsShareUrlService }, { token: HsLayoutService }, { token: HsEventBusService }, { token: HsAddDataUrlService }, { token: HsCommonEndpointsService }, { token: HsSidebarService }], target: i0.ɵɵFactoryTarget.Component });
HsAddDataComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsAddDataComponent, selector: "hs-add-data", usesInheritance: true, ngImport: i0, template: "<div class=\"card hs-main-panel\" [hidden]=\"(isVisible$ | async) === false\">\n    <hs-panel-header name=\"datasource_selector\" [title]=\"'PANEL_HEADER.DATASOURCE_SELECTOR' | translateHs : data\"\n        [app]=\"data.app\">\n    </hs-panel-header>\n    <div class=\"card-body\">\n        <ul class=\"nav flex-column flex-sm-row dss-tabs\" role=\"tablist\">\n            <li class=\"nav-item hs-tab-single-datasources\">\n                <a class=\"nav-link\" [ngClass]=\"{'btn-primary active': appRef.dsSelected === 'catalogue'}\" role=\"tab\"\n                    data-toggle=\"tab\" (click)=\"datasetSelect('catalogue')\">\n                    {{'ADDDATA.catalogue' | translateHs : {app: data.app} }}\n                </a>\n            </li>\n            <li class=\"nav-item hs-tab-single-datasources\">\n                <a class=\"nav-link\"\n                    [ngClass]=\"{'btn-primary active': appRef.dsSelected === 'url' || appRef.dsSelected === 'OWS'}\"\n                    role=\"tab\" data-toggle=\"tab\" (click)=\"datasetSelect('url')\">\n                    URL\n                </a>\n            </li>\n            <li class=\"nav-item hs-tab-single-datasources\">\n                <a class=\"nav-link\" [ngClass]=\"{'btn-primary active': appRef.dsSelected === 'file'}\" role=\"tab\"\n                    data-toggle=\"tab\" (click)=\"datasetSelect('file')\">\n                    {{'ADDDATA.file' | translateHs : {app: data.app} }}\n                </a>\n            </li>\n        </ul>\n        <hs-add-data-url *ngIf=\"appRef.dsSelected === 'url' || appRef.dsSelected === 'OWS'\" [app]=\"data.app\">\n        </hs-add-data-url>\n        <hs-add-data-file *ngIf=\"appRef.dsSelected === 'file'\" [app]=\"data.app\">\n        </hs-add-data-file>\n        <hs-add-data-catalogue *ngIf=\"appRef.dsSelected === 'catalogue'\" [app]=\"data.app\">\n        </hs-add-data-catalogue>\n    </div>\n</div>", components: [{ type: HsPanelHeaderComponent, selector: "hs-panel-header", inputs: ["name", "app", "title"] }, { type: HsAddDataUrlComponent, selector: "hs-add-data-url", inputs: ["app"] }, { type: HsAddDataFileComponent, selector: "hs-add-data-file", inputs: ["app"] }, { type: HsAddDataCatalogueComponent, selector: "hs-add-data-catalogue", inputs: ["app"] }], directives: [{ type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "async": i3.AsyncPipe, "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-add-data', template: "<div class=\"card hs-main-panel\" [hidden]=\"(isVisible$ | async) === false\">\n    <hs-panel-header name=\"datasource_selector\" [title]=\"'PANEL_HEADER.DATASOURCE_SELECTOR' | translateHs : data\"\n        [app]=\"data.app\">\n    </hs-panel-header>\n    <div class=\"card-body\">\n        <ul class=\"nav flex-column flex-sm-row dss-tabs\" role=\"tablist\">\n            <li class=\"nav-item hs-tab-single-datasources\">\n                <a class=\"nav-link\" [ngClass]=\"{'btn-primary active': appRef.dsSelected === 'catalogue'}\" role=\"tab\"\n                    data-toggle=\"tab\" (click)=\"datasetSelect('catalogue')\">\n                    {{'ADDDATA.catalogue' | translateHs : {app: data.app} }}\n                </a>\n            </li>\n            <li class=\"nav-item hs-tab-single-datasources\">\n                <a class=\"nav-link\"\n                    [ngClass]=\"{'btn-primary active': appRef.dsSelected === 'url' || appRef.dsSelected === 'OWS'}\"\n                    role=\"tab\" data-toggle=\"tab\" (click)=\"datasetSelect('url')\">\n                    URL\n                </a>\n            </li>\n            <li class=\"nav-item hs-tab-single-datasources\">\n                <a class=\"nav-link\" [ngClass]=\"{'btn-primary active': appRef.dsSelected === 'file'}\" role=\"tab\"\n                    data-toggle=\"tab\" (click)=\"datasetSelect('file')\">\n                    {{'ADDDATA.file' | translateHs : {app: data.app} }}\n                </a>\n            </li>\n        </ul>\n        <hs-add-data-url *ngIf=\"appRef.dsSelected === 'url' || appRef.dsSelected === 'OWS'\" [app]=\"data.app\">\n        </hs-add-data-url>\n        <hs-add-data-file *ngIf=\"appRef.dsSelected === 'file'\" [app]=\"data.app\">\n        </hs-add-data-file>\n        <hs-add-data-catalogue *ngIf=\"appRef.dsSelected === 'catalogue'\" [app]=\"data.app\">\n        </hs-add-data-catalogue>\n    </div>\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsAddDataService }, { type: HsLanguageService }, { type: HsShareUrlService }, { type: HsLayoutService }, { type: HsEventBusService }, { type: HsAddDataUrlService }, { type: HsCommonEndpointsService }, { type: HsSidebarService }]; } });

class HsSaveMapManagerParams {
    constructor() {
        this.statusData = {
            titleFree: undefined,
            hasPermission: undefined,
            success: undefined,
            changeTitle: undefined,
            groups: [],
        };
        this.compoData = {
            name: '',
            abstract: '',
            keywords: '',
            layers: [],
            id: '',
            thumbnail: undefined,
            bbox: { east: '0', south: '0', west: '0', north: '0' },
            currentCompositionTitle: '',
            currentComposition: undefined,
            access_rights: {
                'access_rights.write': 'private',
                'access_rights.read': 'EVERYONE',
            },
        };
        this.userData = {
            email: '',
            phone: '',
            name: '',
            address: '',
            country: '',
            postalCode: '',
            city: '',
            organization: '',
            position: '',
            state: '',
        };
        this.panelOpened = new Subject();
        this.saveMapResulted = new Subject();
        this.endpointSelected = new BehaviorSubject(null);
        this.preSaveCheckCompleted = new Subject();
        this.missingName = false;
        this.missingAbstract = false;
    }
}
class HsSaveMapManagerService {
    constructor(hsMapService, hsSaveMapService, hsConfig, http, hsStatusManagerService, hsLaymanService, hsLayoutService, hsUtilsService, hsEventBusService, hsLogService) {
        this.hsMapService = hsMapService;
        this.hsSaveMapService = hsSaveMapService;
        this.hsConfig = hsConfig;
        this.http = http;
        this.hsStatusManagerService = hsStatusManagerService;
        this.hsLaymanService = hsLaymanService;
        this.hsLayoutService = hsLayoutService;
        this.hsUtilsService = hsUtilsService;
        this.hsEventBusService = hsEventBusService;
        this.hsLogService = hsLogService;
        this.apps = {
            default: new HsSaveMapManagerParams(),
        };
        this.hsEventBusService.compositionLoads.subscribe(({ data, app }) => {
            var _a;
            if (data.error == undefined) {
                const appRef = this.get(app);
                const responseData = (_a = data.data) !== null && _a !== void 0 ? _a : data;
                appRef.compoData.id = responseData.id;
                appRef.compoData.abstract = responseData.abstract;
                appRef.compoData.name = responseData.name;
                appRef.compoData.keywords = responseData.keywords;
                appRef.compoData.currentComposition = responseData;
                appRef.compoData.workspace = responseData.workspace;
                appRef.compoData.currentCompositionTitle = appRef.compoData.name;
                if (Object.keys(data).length !== 0) {
                    this.validateForm(app);
                }
            }
        });
        this.hsEventBusService.mainPanelChanges.subscribe(({ which, app }) => {
            if (this.hsLayoutService.apps[app].mainpanel == 'saveMap' ||
                this.hsLayoutService.apps[app].mainpanel == 'statusCreator') {
                this.init(app);
            }
        });
        this.hsEventBusService.olMapLoads.subscribe(({ map, app }) => {
            this.setCurrentBoundingBox(app);
            map.on('postcompose', this.hsUtilsService.debounce(() => {
                if (this.hsLayoutService.apps[app].mainpanel == 'saveMap') {
                    this.setCurrentBoundingBox(app);
                    this.hsSaveMapService.generateThumbnail(this.hsLayoutService.apps[app].contentWrapper.querySelector('.hs-stc-thumbnail'), app);
                }
            }, 1000, false, this));
        });
    }
    /**
     * Get the params saved by the saveMapManagerService for the current app
     * @param app - App identifier
     */
    get(app) {
        if (this.apps[app !== null && app !== void 0 ? app : 'default'] == undefined) {
            this.apps[app !== null && app !== void 0 ? app : 'default'] = new HsSaveMapManagerParams();
        }
        return this.apps[app !== null && app !== void 0 ? app : 'default'];
    }
    /**
     * Initialize the saveMapManagerService data and subscribers
     * @param _app - App identifier
     */
    init(_app) {
        this.hsMapService.loaded(_app).then(() => {
            this.fillCompositionLayers(_app);
            this.hsSaveMapService.generateThumbnail(this.hsLayoutService.apps[_app].contentWrapper.querySelector('.hs-stc-thumbnail'), _app);
        });
        this.hsEventBusService.mapResets.subscribe(({ app }) => {
            if (app == _app) {
                this.resetCompoData(app);
            }
        });
    }
    /**
     * Select the endpoint
     * @param app - Endpoint's description
     * @param app - App identifier
     */
    selectEndpoint(endpoint, app) {
        this.get(app).endpointSelected.next(endpoint);
    }
    /**
     * Set composition's data bounding box to the current OL map view extent
     * @param app - App identifier
     */
    setCurrentBoundingBox(app) {
        this.get(app).compoData.bbox = this.hsMapService.describeExtent(app);
    }
    /**
     * Request confirmation if the composition is ready to be saved
     * NOTE not being used
     * @param app - App identifier
     */
    confirmSave(app) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const appRef = this.get(app);
                const response = yield lastValueFrom(this.http.post(this.hsStatusManagerService.endpointUrl(app), {
                    project: this.hsConfig.get(app).project_name,
                    title: appRef.compoData.name,
                    request: 'rightToSave',
                }));
                const j = response.data;
                appRef.statusData.hasPermission = j.results.hasPermission;
                appRef.statusData.titleFree = j.results.titleFree;
                if (j.results.guessedTitle) {
                    appRef.statusData.guessedTitle = j.results.guessedTitle;
                }
                if (!appRef.statusData.titleFree) {
                    appRef.statusData.changeTitle = false;
                }
                if (appRef.statusData.titleFree && appRef.statusData.hasPermission) {
                    this.save(true, this.hsStatusManagerService.findStatusmanagerEndpoint(), app);
                }
                appRef.preSaveCheckCompleted.next({
                    endpoint: this.hsStatusManagerService.findStatusmanagerEndpoint(),
                    app,
                });
            }
            catch (ex) {
                this.get(app).statusData.success = false;
            }
        });
    }
    /**
     * Save composition to external service database
     * @param saveAsNew - Save as new composition
     * @param endpoint - Endpoint's description
     * @param app - App identifier
     * @returns Promise result of POST
     */
    save(saveAsNew, endpoint, app) {
        return new Promise((resolve, reject) => {
            const tempCompoData = {};
            Object.assign(tempCompoData, this.get(app).compoData);
            // Check whether layers were already formatted
            if (tempCompoData.layers[0].layer) {
                tempCompoData.layers = tempCompoData.layers.filter((l) => l.checked);
            }
            const compositionJson = this.generateCompositionJson(app, tempCompoData);
            let saver = this.hsStatusManagerService;
            if (endpoint.type == 'layman') {
                saver = this.hsLaymanService;
            }
            saver
                .save(compositionJson, endpoint, tempCompoData, saveAsNew, app)
                .then((response) => {
                const compInfo = {};
                const j = response;
                let status = false;
                if (endpoint.type == 'statusmanager') {
                    status = j.saved;
                }
                if (endpoint.type == 'layman') {
                    if (saveAsNew) {
                        status = j.length == 1 && j[0].uuid !== undefined;
                    }
                    else {
                        status = j.uuid !== undefined;
                    }
                }
                if (!status) {
                    if (endpoint.type == 'layman' && j.status == 'CONFLICT') {
                        compInfo.id = j[0].uuid;
                        compInfo.name = j[0].name;
                    }
                    if (endpoint.type == 'statusmanager') {
                        compInfo.id = j.id;
                        compInfo.title = j.title;
                        compInfo.abstract = j.abstract || '';
                    }
                }
                else {
                    this.hsEventBusService.compositionLoading.next(compInfo);
                    this.hsEventBusService.compositionLoads.next({ data: compInfo, app });
                }
                //const saveStatus = this.status ? 'ok' : 'not-saved';
                //this.statusData.success = this.status;
                response.status = status;
                resolve(response);
            })
                .catch((e) => {
                //e contains the json responses data object from api
                //this.statusData.success = false;
                reject({
                    status: false,
                    error: e,
                });
            });
        });
    }
    /**
     * Generate composition JSON for downloading
     * @param app - App identifier
     * @param compoData - Additional data for composition
     * @returns composition JSON
     */
    generateCompositionJson(app, compoData) {
        /*TODO: REFACTOR
          Workaround for composition JSON generated for download.
          Should be handled differently and generated only once. Task for upcoming component rework
        */
        const appRef = this.get(app);
        const tempCompoData = Object.assign({}, (compoData !== null && compoData !== void 0 ? compoData : appRef.compoData));
        if (!compoData) {
            tempCompoData.layers = tempCompoData.layers.filter((l) => l.checked);
        }
        return this.hsSaveMapService.map2json(this.hsMapService.getMap(app), tempCompoData, appRef.userData, appRef.statusData, app);
    }
    /**
     * Initialization of Save map wizard from outside of component
     * @param composition - Composition selected from the compositions list
     * @param app - App identifier
     */
    openPanel(composition, app) {
        this.hsLayoutService.setMainPanel('saveMap', app, true);
        this.fillCompositionLayers(app);
        this.get(app).panelOpened.next({ composition });
    }
    /**
     * Fill composition's layers from the OL map layers list
     * @param app - App identifier
     */
    fillCompositionLayers(app) {
        const compoData = this.get(app).compoData;
        compoData.layers = [];
        compoData.bbox = this.hsMapService.describeExtent(app);
        compoData.layers = this.hsMapService
            .getMap(app)
            .getLayers()
            .getArray()
            .filter((lyr) => getShowInLayerManager(lyr) == undefined ||
            getShowInLayerManager(lyr) == true)
            .map((lyr) => {
            return {
                title: getTitle(lyr),
                checked: true,
                layer: lyr,
            };
        })
            .sort((a, b) => {
            return a.layer.getZIndex() - b.layer.getZIndex();
        });
    }
    /**
     * Process user's info into controller model, so they can be used in Save composition forms
     * @param response - HTTP response containing user data
     * @param app - App identifier
     */
    setUserDetails(response, app) {
        const appRef = this.get(app);
        const user = response.data;
        if (user && user.success == true) {
            // set the values
            if (user.userInfo) {
                appRef.userData.email = user.userInfo.email;
                appRef.userData.phone = user.userInfo.phone;
                appRef.userData.name =
                    user.userInfo.firstName + ' ' + user.userInfo.lastName;
            }
            if (user.userInfo && user.userInfo.org) {
                appRef.userData.address = user.userInfo.org.street;
                appRef.userData.country = user.userInfo.org.state;
                appRef.userData.postalCode = user.userInfo.org.zip;
                appRef.userData.city = user.userInfo.org.city;
                appRef.userData.organization = user.userInfo.org.name;
            }
        }
    }
    /**
     * Callback for saving with new name
     * @param app - App identifier
     */
    selectNewName(app) {
        const appRef = this.get(app);
        appRef.compoData.name = appRef.statusData.guessedTitle;
        appRef.changeTitle = true;
    }
    /**
     * Check if the composition's input form is valid
     * @param app - App identifier
     * @returns True if the form is valid, false otherwise
     */
    validateForm(app) {
        const appRef = this.get(app);
        appRef.missingName = !appRef.compoData.name;
        appRef.missingAbstract = !appRef.compoData.abstract;
        return !!appRef.compoData.name && !!appRef.compoData.abstract;
    }
    /**
     * Reset localy stored composition's input data to default values
     * @param app - App identifier
     */
    resetCompoData(app) {
        const appRef = this.get(app);
        appRef.compoData.id = '';
        appRef.compoData.abstract = '';
        appRef.compoData.name = '';
        appRef.compoData.currentCompositionTitle = '';
        appRef.compoData.keywords = '';
        appRef.compoData.currentComposition = '';
    }
    /**
     * Initiate composition's saving procedure
     * @param saveAsNew - If true save a new composition, otherwise overwrite to current one
     * @param app - App identifier
     */
    initiateSave(saveAsNew, app) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.validateForm(app)) {
                this.hsLogService.log('validationfailed');
                return;
            }
            try {
                const augmentedResponse = yield this.save(saveAsNew, this.get(app).endpointSelected.getValue(), app);
                this.processSaveCallback(augmentedResponse, app);
            }
            catch (ex) {
                this.hsLogService.error(ex);
                this.processSaveCallback(ex, app);
            }
        });
    }
    /**
     * Process response data after saving the composition
     * @param response - HTTP response after saving the composition
     * @param app - App identifier
     */
    processSaveCallback(response, app) {
        const appRef = this.get(app);
        appRef.statusData.status = response.status;
        if (!response.status) {
            if (response.code == 24) {
                appRef.statusData.overWriteNeeded = true;
                appRef.compoData.name = response.detail.mapname;
                appRef.statusData.resultCode = 'exists';
            }
            else if (response.code == 32) {
                appRef.statusData.resultCode = 'not-saved';
            }
            else {
                appRef.statusData.resultCode = 'error';
            }
            appRef.statusData.error = response;
        }
        else {
            this.hsLayoutService.setMainPanel('layermanager', app, true);
        }
        appRef.saveMapResulted.next({ statusData: appRef.statusData, app });
    }
    /**
     * Focus the browser to composition's title
     * @param app - App identifier
     */
    focusTitle(app) {
        const appRef = this.get(app);
        if (appRef.statusData.guessedTitle) {
            appRef.compoData.name = appRef.statusData.guessedTitle;
        }
        //TODO Check if this works and input is focused
        this.hsLayoutService
            .get(app)
            .contentWrapper.querySelector('.hs-stc-title')
            .focus();
    }
}
HsSaveMapManagerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSaveMapManagerService, deps: [{ token: HsMapService }, { token: HsSaveMapService }, { token: HsConfig }, { token: i1.HttpClient }, { token: HsStatusManagerService }, { token: HsLaymanService }, { token: HsLayoutService }, { token: HsUtilsService }, { token: HsEventBusService }, { token: HsLogService }], target: i0.ɵɵFactoryTarget.Injectable });
HsSaveMapManagerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSaveMapManagerService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSaveMapManagerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsMapService }, { type: HsSaveMapService }, { type: HsConfig }, { type: i1.HttpClient }, { type: HsStatusManagerService }, { type: HsLaymanService }, { type: HsLayoutService }, { type: HsUtilsService }, { type: HsEventBusService }, { type: HsLogService }]; } });

class HsCompositionsOverwriteDialogComponent {
    constructor(HsDialogContainerService, HsCompositionsService, HsSaveMapManagerService) {
        this.HsDialogContainerService = HsDialogContainerService;
        this.HsCompositionsService = HsCompositionsService;
        this.HsSaveMapManagerService = HsSaveMapManagerService;
    }
    close() {
        this.HsDialogContainerService.destroy(this, this.data.app);
    }
    /**
     * @public
     * Load new composition without saving old composition
     */
    overwrite() {
        this.HsCompositionsService.loadComposition(this.HsCompositionsService.get(this.data.app).compositionToLoad.url, this.data.app, true);
        this.close();
    }
    /**
     * @public
     * Save currently loaded composition first
     */
    save() {
        this.HsSaveMapManagerService.openPanel(null, this.data.app);
        this.close();
    }
    /**
     * @public
     * Load new composition (with service_parser Load function) and merge it with old composition
     */
    add() {
        this.HsCompositionsService.loadComposition(this.HsCompositionsService.get(this.data.app).compositionToLoad.url, this.data.app, false);
        this.close();
    }
}
HsCompositionsOverwriteDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCompositionsOverwriteDialogComponent, deps: [{ token: HsDialogContainerService }, { token: HsCompositionsService }, { token: HsSaveMapManagerService }], target: i0.ɵɵFactoryTarget.Component });
HsCompositionsOverwriteDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsCompositionsOverwriteDialogComponent, selector: "hs-compositions-overwrite-dialog", ngImport: i0, template: "<div class=\"modal in hs-composition-overwrite-dialog\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h4 class=\"modal-title\">{{'COMPOSITIONS.dialogoverwriteConfirm.overwriteExistingMap' | translateHs: {app: data.app} \n                    }}</h4>\n                <button type=\"button\" (click)=\"close()\" class=\"btn-close\" data-dismiss=\"modal\"\n                    attr.aria-label=\"{{'COMMON.close' | translateHs: {app: data.app} }}\">\n                </button>\n            </div>\n            <div class=\"modal-body\" style=\"max-height: 600px; overflow-y: auto\">\n                {{'COMPOSITIONS.dialogoverwriteConfirm.youAreOpeningMap' | translateHs: {app: data.app} }}\n                <b>{{data.composition_name_to_be_loaded}}</b>\n                <br>{{'COMPOSITIONS.dialogoverwriteConfirm.thereAreCurrentlyUnsavedChanges' | translateHs: {app: data.app} }}\n                <br>{{'COMPOSITIONS.dialogoverwriteConfirm.whatDoYouWant' | translateHs: {app: data.app} }}\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-primary compositions-btn-overwrite\" (click)=\"overwrite()\"\n                    data-dismiss=\"modal\">{{'COMMON.continue' | translateHs: {app: data.app} }}</button>\n                <button type=\"button\" class=\"btn btn-primary compositions-btn-add\" (click)=\"add();\"\n                    data-dismiss=\"modal\">{{'COMPOSITIONS.dialogoverwriteConfirm.mergeCompositions' | translateHs: {app: data.app} \n                    }}</button>\n                <button type=\"button\" class=\"btn btn-primary compositions-btn-save\" (click)=\"save()\"\n                    data-dismiss=\"modal\">{{'COMPOSITIONS.dialogoverwriteConfirm.saveChangesFirst' | translateHs: {app: data.app} \n                    }}</button>\n                <button type=\"button\" class=\"btn btn-secondary compositions-btn-cancel\" (click)=\"close()\"\n                    data-dismiss=\"modal\">{{'COMMON.cancel' | translateHs: {app: data.app} }}</button>\n            </div>\n        </div>\n    </div>\n</div>", pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCompositionsOverwriteDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-compositions-overwrite-dialog', template: "<div class=\"modal in hs-composition-overwrite-dialog\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h4 class=\"modal-title\">{{'COMPOSITIONS.dialogoverwriteConfirm.overwriteExistingMap' | translateHs: {app: data.app} \n                    }}</h4>\n                <button type=\"button\" (click)=\"close()\" class=\"btn-close\" data-dismiss=\"modal\"\n                    attr.aria-label=\"{{'COMMON.close' | translateHs: {app: data.app} }}\">\n                </button>\n            </div>\n            <div class=\"modal-body\" style=\"max-height: 600px; overflow-y: auto\">\n                {{'COMPOSITIONS.dialogoverwriteConfirm.youAreOpeningMap' | translateHs: {app: data.app} }}\n                <b>{{data.composition_name_to_be_loaded}}</b>\n                <br>{{'COMPOSITIONS.dialogoverwriteConfirm.thereAreCurrentlyUnsavedChanges' | translateHs: {app: data.app} }}\n                <br>{{'COMPOSITIONS.dialogoverwriteConfirm.whatDoYouWant' | translateHs: {app: data.app} }}\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-primary compositions-btn-overwrite\" (click)=\"overwrite()\"\n                    data-dismiss=\"modal\">{{'COMMON.continue' | translateHs: {app: data.app} }}</button>\n                <button type=\"button\" class=\"btn btn-primary compositions-btn-add\" (click)=\"add();\"\n                    data-dismiss=\"modal\">{{'COMPOSITIONS.dialogoverwriteConfirm.mergeCompositions' | translateHs: {app: data.app} \n                    }}</button>\n                <button type=\"button\" class=\"btn btn-primary compositions-btn-save\" (click)=\"save()\"\n                    data-dismiss=\"modal\">{{'COMPOSITIONS.dialogoverwriteConfirm.saveChangesFirst' | translateHs: {app: data.app} \n                    }}</button>\n                <button type=\"button\" class=\"btn btn-secondary compositions-btn-cancel\" (click)=\"close()\"\n                    data-dismiss=\"modal\">{{'COMMON.cancel' | translateHs: {app: data.app} }}</button>\n            </div>\n        </div>\n    </div>\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsDialogContainerService }, { type: HsCompositionsService }, { type: HsSaveMapManagerService }]; } });

class HsCompositionsDeleteDialogComponent {
    constructor(HsDialogContainerService, HsCompositionsService) {
        this.HsDialogContainerService = HsDialogContainerService;
        this.HsCompositionsService = HsCompositionsService;
    }
    close() {
        this.HsDialogContainerService.destroy(this, this.data.app);
    }
    /**
     * @public
     * @param composition - Composition selected for deletion
     * Delete selected composition from project (including deletion from composition server, useful for user created compositions)
     */
    delete(composition) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.HsCompositionsService.deleteComposition(composition, this.data.app);
            this.close();
        });
    }
}
HsCompositionsDeleteDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCompositionsDeleteDialogComponent, deps: [{ token: HsDialogContainerService }, { token: HsCompositionsService }], target: i0.ɵɵFactoryTarget.Component });
HsCompositionsDeleteDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsCompositionsDeleteDialogComponent, selector: "hs-compositions-delete-dialog", ngImport: i0, template: "<div class=\"modal in hs-composition-delete-dialog\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h4 class=\"modal-title\">\n                    {{'COMMON.confirm' | translateHs: {app: data.app} }}\n                </h4>\n                <button type=\"button\" (click)=\"close()\" class=\"btn-close\" data-dismiss=\"modal\"\n                    attr.aria-label=\"{{'COMMON.close' | translateHs: {app: data.app} }}\">\n                </button>\n            </div>\n            <div class=\"modal-body\" style=\"max-height: 600px; overflow-y: auto\">\n                <span>{{'COMPOSITIONS.dialogDelete.doYouWantToDeleteMap' | translateHs: {app: data.app} }}</span>\n                {{data.compositionToDelete.title}}\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-danger\"\n                    (click)=\"delete(data.compositionToDelete)\">{{'COMMON.ok' | translateHs: {app: data.app} }}</button>\n                <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\"\n                    (click)=\"close()\">{{'COMMON.close' | translateHs: {app: data.app} }}</button>\n            </div>\n        </div>\n    </div>\n</div>\n", pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCompositionsDeleteDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-compositions-delete-dialog', template: "<div class=\"modal in hs-composition-delete-dialog\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h4 class=\"modal-title\">\n                    {{'COMMON.confirm' | translateHs: {app: data.app} }}\n                </h4>\n                <button type=\"button\" (click)=\"close()\" class=\"btn-close\" data-dismiss=\"modal\"\n                    attr.aria-label=\"{{'COMMON.close' | translateHs: {app: data.app} }}\">\n                </button>\n            </div>\n            <div class=\"modal-body\" style=\"max-height: 600px; overflow-y: auto\">\n                <span>{{'COMPOSITIONS.dialogDelete.doYouWantToDeleteMap' | translateHs: {app: data.app} }}</span>\n                {{data.compositionToDelete.title}}\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-danger\"\n                    (click)=\"delete(data.compositionToDelete)\">{{'COMMON.ok' | translateHs: {app: data.app} }}</button>\n                <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\"\n                    (click)=\"close()\">{{'COMMON.close' | translateHs: {app: data.app} }}</button>\n            </div>\n        </div>\n    </div>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: HsDialogContainerService }, { type: HsCompositionsService }]; } });

class HsShareService {
    constructor(HsConfig, HsShareUrlService, HsUtilsService, HsMapService, HsStatusManagerService, HsLayoutService, HsSaveMapService, HsEventBusService, HsLanguageService, HsToastService, HsLogService, HttpClient, HsShareThumbnailService) {
        this.HsConfig = HsConfig;
        this.HsShareUrlService = HsShareUrlService;
        this.HsUtilsService = HsUtilsService;
        this.HsMapService = HsMapService;
        this.HsStatusManagerService = HsStatusManagerService;
        this.HsLayoutService = HsLayoutService;
        this.HsSaveMapService = HsSaveMapService;
        this.HsEventBusService = HsEventBusService;
        this.HsLanguageService = HsLanguageService;
        this.HsToastService = HsToastService;
        this.HsLogService = HsLogService;
        this.HttpClient = HttpClient;
        this.HsShareThumbnailService = HsShareThumbnailService;
        /**
         * @public
         * @description variables which describe sharable link: url, title, abstract etc.
         */
        this.data = {
            pureMapUrl: '',
            permalinkUrl: '',
            shareLink: 'permalink',
            embedCode: '',
            shareUrlValid: false,
            title: '',
            abstract: '',
            shareUrl: '',
        };
        this.HsEventBusService.compositionLoads.subscribe(({ data, app }) => {
            if (data.data) {
                data = data.data;
                this.data.title = data.title;
                if (this.HsConfig.get(app).social_hashtag) {
                    this.data.title += ' ' + this.HsConfig.get(app).social_hashtag;
                }
                this.data.abstract = data.abstract;
            }
        });
    }
    init(app1) {
        this.HsEventBusService.mainPanelChanges.subscribe(({ which, app }) => __awaiter(this, void 0, void 0, function* () {
            if (this.HsLayoutService.apps[app].mainpanel == 'permalink') {
                this.generateThumbnail(this.HsLayoutService.get(app).contentWrapper.querySelector('.hs-permalink-thumbnail'), false, app);
                this.HsShareUrlService.statusSaving = true;
                const status_url = this.HsStatusManagerService.endpointUrl(app);
                const layers = this.HsMapService.getLayersArray(app)
                    .filter((l) => getShowInLayerManager(l) == undefined || getShowInLayerManager(l))
                    .map((lyr) => {
                    return {
                        title: getTitle(lyr),
                        checked: true,
                        layer: lyr,
                    };
                })
                    .sort((a, b) => {
                    return a.layer.getZIndex() - b.layer.getZIndex();
                });
                try {
                    const bbox = this.HsMapService.describeExtent(app);
                    const data = this.HsSaveMapService.map2json(this.HsMapService.getMap(app), { layers, bbox }, {}, {}, app);
                    yield lastValueFrom(this.HttpClient.post(status_url, JSON.stringify({
                        data,
                        permalink: true,
                        id: this.HsShareUrlService.id,
                        project: this.HsConfig.get(app1).project_name,
                        request: 'save',
                    })));
                    this.HsShareUrlService.statusSaving = false;
                    this.HsShareUrlService.permalinkRequestUrl =
                        status_url + '?request=load&id=' + this.HsShareUrlService.id;
                    this.HsShareUrlService.update(app1);
                }
                catch (ex) {
                    this.HsLogService.error('Error saving permalink layers.', ex);
                    throw ex;
                }
            }
        }));
        this.HsShareUrlService.browserUrlUpdated.subscribe(() => __awaiter(this, void 0, void 0, function* () {
            if (this.HsLayoutService.apps[app1].mainpanel == 'permalink' ||
                this.HsLayoutService.apps[app1].mainpanel == 'shareMap') {
                this.data.shareUrlValid = false;
                try {
                    this.data.pureMapUrl = yield this.HsUtilsService.shortUrl(this.HsShareUrlService.getPureMapUrl(app1), app1);
                    this.data.permalinkUrl = yield this.HsUtilsService.shortUrl(this.HsShareUrlService.getPermalinkUrl(app1), app1);
                    this.getEmbedCode();
                }
                catch (ex) {
                    this.HsLogService.log('Error creating short URL', ex);
                    this.data.pureMapUrl = this.HsShareUrlService.getPureMapUrl(app1);
                    this.data.permalinkUrl = this.HsShareUrlService.getPermalinkUrl(app1);
                }
            }
        }));
        this.HsEventBusService.olMapLoads.subscribe(({ map, app }) => {
            map.on('postcompose', this.HsUtilsService.debounce(() => {
                if (this.HsLayoutService.get(app).mainpanel == 'permalink') {
                    this.generateThumbnail(this.HsLayoutService.get(app).contentWrapper.querySelector('.hs-permalink-thumbnail'), false, app);
                }
            }, 300, false, this));
        });
    }
    /**
     * @public
     * @description Get correct Embed code with correct share link type
     * @returns {string} embeddable iframe html code
     */
    getEmbedCode() {
        this.data.embedCode =
            '<iframe src="' +
                this.getShareUrl() +
                '" width="1000" height="700"></iframe>';
        return this.data.embedCode;
    }
    /**
     * @public
     * @returns {string} Share URL
     * @description Get share Url based on app choice
     */
    getShareUrl() {
        let tmp;
        if (this.data.shareLink == 'permalink') {
            tmp = this.data.permalinkUrl;
        }
        else if (this.data.shareLink == 'puremap') {
            tmp = this.data.pureMapUrl;
        }
        return tmp;
    }
    /**
     * @public
     * @returns {string} Encoded share URL
     * @description Get encoded share Url based on app choice
     */
    getShareUrlEncoded() {
        return encodeURIComponent(this.getShareUrl());
    }
    /**
     * @public
     * @description Make current share url invalid for social sharing
     */
    invalidateShareUrl() {
        this.data.shareUrlValid = false;
    }
    /**
     * @public
     * @param {string} provider Social share provider (twitter/facebook)
     * @param {boolean} newShare If new share record on server should be created
     * @description Share map on social network
     */
    shareOnSocial(newShare, app) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.data.shareUrlValid) {
                if (this.HsShareUrlService.shareId === null || newShare) {
                    this.HsShareUrlService.shareId = this.HsUtilsService.generateUuid();
                }
                try {
                    const endpointUrl = this.HsStatusManagerService.endpointUrl(app);
                    const headers = new HttpHeaders().set('Content-Type', 'text/plain; charset=utf-8');
                    yield lastValueFrom(this.HttpClient.post(endpointUrl, JSON.stringify({
                        request: 'socialShare',
                        id: this.HsShareUrlService.shareId,
                        url: encodeURIComponent(this.getShareUrl()),
                        title: this.data.title,
                        description: this.data.abstract,
                        image: this.data.thumbnail,
                    }), { headers, responseType: 'text' }));
                    const shortUrl = yield this.HsUtilsService.shortUrl(`${endpointUrl}?request=socialshare&id=${this.HsShareUrlService.shareId}`, app);
                    const shareUrl = shortUrl;
                    this.openInShareApi(this.data.title, this.data.abstract, shareUrl, app);
                    this.data.shareUrlValid = true;
                }
                catch (ex) {
                    this.HsLogService.log('Error creating short URL', ex);
                }
            }
            else {
                this.openInShareApi(this.data.title, this.data.abstract, this.getShareUrl(), app);
            }
        });
    }
    openInShareApi(title, abstract, url, app) {
        navigator
            .share({
            title,
            text: abstract || title,
            url,
        })
            .then((response) => {
            console.log(response);
        })
            .catch((error) => {
            this.HsToastService.createToastPopupMessage(this.HsLanguageService.getTranslation('COMPOSITIONS.errorWhileSharingOnSocialNetwork', undefined, this.data.app), this.HsLanguageService.getTranslationIgnoreNonExisting('ERRORMESSAGES', error, undefined, app), { disableLocalization: true, serviceCalledFrom: 'HsShareService' }, app);
        });
    }
    /**
     * @public
     * @param {object} $element DOM img element where to place the thumbnail
     * @param {boolean} newRender Force synchronous rendering again or use last canvas state
     * @description Generate thumbnail of current map and save it to variable and selected element
     */
    generateThumbnail($element, newRender, app) {
        this.rendered($element, app, newRender);
        if ($element === null) {
            return;
        }
        $element.setAttribute('crossOrigin', 'Anonymous');
        const map = this.HsMapService.getMap(app);
        if (newRender) {
            map.once('postcompose', () => this.rendered($element, app, newRender));
            map.renderSync();
        }
        else {
            this.rendered($element, app, newRender);
        }
    }
    rendered($element, app, newRender) {
        this.data.thumbnail = this.HsShareThumbnailService.rendered($element, app, newRender);
    }
    isCanvasTainted(canvas) {
        try {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const pixel = canvas.getContext('2d').getImageData(0, 0, 1, 1);
            return false;
        }
        catch (err) {
            return err.code === 18;
        }
    }
}
HsShareService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsShareService, deps: [{ token: HsConfig }, { token: HsShareUrlService }, { token: HsUtilsService }, { token: HsMapService }, { token: HsStatusManagerService }, { token: HsLayoutService }, { token: HsSaveMapService }, { token: HsEventBusService }, { token: HsLanguageService }, { token: HsToastService }, { token: HsLogService }, { token: i1.HttpClient }, { token: HsShareThumbnailService }], target: i0.ɵɵFactoryTarget.Injectable });
HsShareService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsShareService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsShareService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsConfig }, { type: HsShareUrlService }, { type: HsUtilsService }, { type: HsMapService }, { type: HsStatusManagerService }, { type: HsLayoutService }, { type: HsSaveMapService }, { type: HsEventBusService }, { type: HsLanguageService }, { type: HsToastService }, { type: HsLogService }, { type: i1.HttpClient }, { type: HsShareThumbnailService }]; } });

class HsCompositionsShareDialogComponent {
    constructor(HsDialogContainerService, HsShareService) {
        this.HsDialogContainerService = HsDialogContainerService;
        this.HsShareService = HsShareService;
    }
    close() {
        this.HsDialogContainerService.destroy(this, this.data.app);
    }
    shareOnSocial() {
        this.HsShareService.openInShareApi(this.data.title, this.data.abstract, this.data.url, this.data.app);
    }
}
HsCompositionsShareDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCompositionsShareDialogComponent, deps: [{ token: HsDialogContainerService }, { token: HsShareService }], target: i0.ɵɵFactoryTarget.Component });
HsCompositionsShareDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsCompositionsShareDialogComponent, selector: "hs-compositions-share-dialog", ngImport: i0, template: "<div class=\"modal in hs-composition-share-dialog\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h4 class=\"modal-title\">\n                    <span>{{'COMPOSITIONS.dialogShare.shareMap' | translateHs: {app: data.app} }}</span> {{data.title}}\n                </h4>\n                <button type=\"button\" (click)=\"close()\" class=\"btn-close\" data-dismiss=\"modal\"\n                    attr.aria-label=\"{{'COMMON.close' | translateHs: {app: data.app} }}\">\n                </button>\n            </div>\n            <div class=\"modal-body\" style=\"max-height: 600px; overflow-y: auto\">\n                <div class=\"row\">\n                    <div class=\"col-md-3\"><b>{{'COMMON.abstract' | translateHs: {app: data.app} }}</b></div>\n                    <div class=\"col-md-9\">{{data.abstract}}</div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"col-md-3\"><b>{{'COMMON.url' | translateHs: {app: data.app} }}</b></div>\n                    <div class=\"col-md-9\"><a [href]=\"data.url\">{{data.url}}</a></div>\n                </div>\n            </div>\n            <div class=\"modal-footer\">\n                <div class=\"btn-group\" role=\"group\">\n                    <button class=\"btn btn-secondary\" (click)=\"shareOnSocial()\">\n                        <i class=\"icon-share-alt\"></i> {{'COMMON.share' | translateHs: {app: data.app} }}\n                    </button>\n                </div>\n                <button type=\"button\" class=\"btn btn-secondary\" (click)=\"close()\" data-dismiss=\"modal\">{{'COMMON.close'\n                    | translateHs: {app: data.app} }}</button>\n            </div>\n        </div>\n    </div>\n</div>", pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCompositionsShareDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-compositions-share-dialog', template: "<div class=\"modal in hs-composition-share-dialog\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h4 class=\"modal-title\">\n                    <span>{{'COMPOSITIONS.dialogShare.shareMap' | translateHs: {app: data.app} }}</span> {{data.title}}\n                </h4>\n                <button type=\"button\" (click)=\"close()\" class=\"btn-close\" data-dismiss=\"modal\"\n                    attr.aria-label=\"{{'COMMON.close' | translateHs: {app: data.app} }}\">\n                </button>\n            </div>\n            <div class=\"modal-body\" style=\"max-height: 600px; overflow-y: auto\">\n                <div class=\"row\">\n                    <div class=\"col-md-3\"><b>{{'COMMON.abstract' | translateHs: {app: data.app} }}</b></div>\n                    <div class=\"col-md-9\">{{data.abstract}}</div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"col-md-3\"><b>{{'COMMON.url' | translateHs: {app: data.app} }}</b></div>\n                    <div class=\"col-md-9\"><a [href]=\"data.url\">{{data.url}}</a></div>\n                </div>\n            </div>\n            <div class=\"modal-footer\">\n                <div class=\"btn-group\" role=\"group\">\n                    <button class=\"btn btn-secondary\" (click)=\"shareOnSocial()\">\n                        <i class=\"icon-share-alt\"></i> {{'COMMON.share' | translateHs: {app: data.app} }}\n                    </button>\n                </div>\n                <button type=\"button\" class=\"btn btn-secondary\" (click)=\"close()\" data-dismiss=\"modal\">{{'COMMON.close'\n                    | translateHs: {app: data.app} }}</button>\n            </div>\n        </div>\n    </div>\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsDialogContainerService }, { type: HsShareService }]; } });

class HsCompositionsListItemComponent {
    constructor(hsCompositionsService, hsToastService, hsDialogContainerService, hsConfig, hsLanguageService) {
        this.hsCompositionsService = hsCompositionsService;
        this.hsToastService = hsToastService;
        this.hsDialogContainerService = hsDialogContainerService;
        this.hsConfig = hsConfig;
        this.hsLanguageService = hsLanguageService;
        this.app = 'default';
    }
    /**
     * Load selected composition
     * @param composition - Selected composition
     */
    openComposition(composition) {
        this.hsCompositionsService.loadCompositionParser(composition, this.app);
    }
    /**
     * @param record - Composition to show details
     * Load info about composition through service and display composition info dialog
     */
    detailComposition(record) {
        return __awaiter(this, void 0, void 0, function* () {
            const info = yield this.hsCompositionsService.getCompositionInfo(record, this.app);
            if (info !== undefined) {
                this.infoDialogBootstrap(info);
            }
        });
    }
    /**
     * @param record - Composition to share
     * Prepare share object on server and display share dialog to share composition
     */
    shareComposition(record) {
        return __awaiter(this, void 0, void 0, function* () {
            let url;
            try {
                yield this.hsCompositionsService
                    .shareComposition(record, this.app)
                    .then(() => __awaiter(this, void 0, void 0, function* () {
                    url = yield this.hsCompositionsService.getShareUrl(this.app);
                    if (url !== undefined) {
                        this.shareDialogBootstrap(record, url);
                    }
                    else {
                        throw new Error('COMPOSITIONS.sharingUrlIsNotAvailable');
                    }
                }));
            }
            catch (e) {
                this.hsToastService.createToastPopupMessage(this.hsLanguageService.getTranslation('COMPOSITIONS.errorWhileSharingOnSocialNetwork', undefined, this.app), this.hsLanguageService.getTranslationIgnoreNonExisting('ERRORMESSAGES', e.message, { url: url }, this.app), { disableLocalization: true }, this.app);
            }
        });
    }
    /**
     * Show permissions dialog window for selected composition.
     * @param composition - Selected composition
     */
    showPermissions(composition) {
        return __awaiter(this, void 0, void 0, function* () {
            this.hsDialogContainerService.create(HsSetPermissionsDialogComponent, {
                recordType: 'composition',
                selectedRecord: composition,
                app: this.app,
            }, this.app);
        });
    }
    /**
     * @param composition - Composition selected for deletion
     * Display delete dialog of composition
     */
    confirmDelete(composition) {
        if (!composition.editable) {
            return;
        }
        this.deleteDialogBootstrap(composition);
    }
    /**
     * @param composition - Composition selected for deletion
     */
    deleteDialogBootstrap(composition) {
        this.hsDialogContainerService.create(HsCompositionsDeleteDialogComponent, {
            compositionToDelete: composition,
        }, this.app);
    }
    /**
     * @param record - Composition selected for sharing
     * @param url -
     */
    shareDialogBootstrap(record, url) {
        this.hsDialogContainerService.create(HsCompositionsShareDialogComponent, {
            url,
            title: this.hsConfig.get(this.app).social_hashtag &&
                !record.title.includes(this.hsConfig.get(this.app).social_hashtag)
                ? record.title + ' ' + this.hsConfig.get(this.app).social_hashtag
                : record.title,
            abstract: record.abstract,
        }, this.app);
    }
    /**
     * Display composition info dialog
     * @param info - Composition info
     */
    infoDialogBootstrap(info) {
        this.hsDialogContainerService.create(HsCompositionsInfoDialogComponent, {
            info,
        }, this.app);
    }
    /**
     * Get composition common id
     * @param composition - Composition item
     */
    getCommonId(composition) {
        return this.hsCompositionsService.commonId(composition);
    }
}
HsCompositionsListItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCompositionsListItemComponent, deps: [{ token: HsCompositionsService }, { token: HsToastService }, { token: HsDialogContainerService }, { token: HsConfig }, { token: HsLanguageService }], target: i0.ɵɵFactoryTarget.Component });
HsCompositionsListItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsCompositionsListItemComponent, selector: "hs-compositions-list-item", inputs: { composition: "composition", selectedCompId: "selectedCompId", app: "app" }, ngImport: i0, template: "<div class=\"hs-comp-item-title\">{{composition.title || composition.name}}</div>\n<div class=\"mt-2\" [ngClass]=\"{'d-none': getCommonId(composition) !== selectedCompId}\">\n    <hr class=\"hs-dotted-line\">\n    <div class=\"btn-group w-100\" role=\"group\">\n        <a class=\"btn btn-sm\" (click)=\"$event.stopPropagation();openComposition(composition)\">\n            <i class=\"icon-map icon-primary\"></i><span class=\"ms-1\">{{'COMMON.open' |\n                translateHs: {app} }}</span>\n        </a>\n        <a class=\"btn btn-sm\" (click)=\"$event.stopPropagation();detailComposition(composition)\">\n            <i class=\"icon-info-sign icon-primary\"></i><span class=\"ms-1\">{{'COMMON.metadata' |\n                translateHs: {app} }}</span>\n        </a>\n        <a class=\"btn btn-sm\" (click)=\"$event.stopPropagation();shareComposition(composition)\">\n            <i class=\"icon-share-alt icon-primary\"></i><span class=\"ms-1\">{{'COMMON.share' |\n                translateHs: {app} }}</span>\n        </a>\n        <ng-container *ngIf=\"composition.endpoint?.authenticated\">\n            <a class=\"btn btn-sm\" (click)=\"$event.stopPropagation();showPermissions(composition)\" data-toggle=\"tooltip\"\n                data-placement=\"bottom\"\n                [title]=\"composition.editable ? '' : 'COMPOSITIONS.notAllowedToEditLayer' | translateHs: {app} \">\n                <i class=\"icon-lock icon-primary\" [ngClass]=\"{'text-muted': !composition.editable}\"\n                    [ngStyle]=\"{'cursor' : composition.editable ? 'pointer' : 'default'}\"></i><span\n                    [hidden]=\"!composition.editable\" class=\"ms-1\">{{'COMMON.setPermissions' |\n                    translateHs: {app} }}</span>\n            </a>\n            <a class=\"btn btn-sm\" (click)=\"$event.stopPropagation();confirmDelete(composition)\" data-toggle=\"tooltip\"\n                data-placement=\"bottom\"\n                [title]=\"composition.editable ? '' : 'COMPOSITIONS.notAllowedToEditLayer' | translateHs: {app} \">\n                <i class=\"icon-trash icon-primary\" [ngClass]=\"{'text-muted': !composition.editable}\"\n                    [ngStyle]=\"{'cursor' : composition.editable ? 'pointer' : 'default'}\"></i><span\n                    [hidden]=\"!composition.editable\" class=\"ms-1\">{{'COMMON.delete' |\n                    translateHs: {app} }}</span>\n            </a>\n        </ng-container>\n    </div>\n</div>", directives: [{ type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCompositionsListItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-compositions-list-item', template: "<div class=\"hs-comp-item-title\">{{composition.title || composition.name}}</div>\n<div class=\"mt-2\" [ngClass]=\"{'d-none': getCommonId(composition) !== selectedCompId}\">\n    <hr class=\"hs-dotted-line\">\n    <div class=\"btn-group w-100\" role=\"group\">\n        <a class=\"btn btn-sm\" (click)=\"$event.stopPropagation();openComposition(composition)\">\n            <i class=\"icon-map icon-primary\"></i><span class=\"ms-1\">{{'COMMON.open' |\n                translateHs: {app} }}</span>\n        </a>\n        <a class=\"btn btn-sm\" (click)=\"$event.stopPropagation();detailComposition(composition)\">\n            <i class=\"icon-info-sign icon-primary\"></i><span class=\"ms-1\">{{'COMMON.metadata' |\n                translateHs: {app} }}</span>\n        </a>\n        <a class=\"btn btn-sm\" (click)=\"$event.stopPropagation();shareComposition(composition)\">\n            <i class=\"icon-share-alt icon-primary\"></i><span class=\"ms-1\">{{'COMMON.share' |\n                translateHs: {app} }}</span>\n        </a>\n        <ng-container *ngIf=\"composition.endpoint?.authenticated\">\n            <a class=\"btn btn-sm\" (click)=\"$event.stopPropagation();showPermissions(composition)\" data-toggle=\"tooltip\"\n                data-placement=\"bottom\"\n                [title]=\"composition.editable ? '' : 'COMPOSITIONS.notAllowedToEditLayer' | translateHs: {app} \">\n                <i class=\"icon-lock icon-primary\" [ngClass]=\"{'text-muted': !composition.editable}\"\n                    [ngStyle]=\"{'cursor' : composition.editable ? 'pointer' : 'default'}\"></i><span\n                    [hidden]=\"!composition.editable\" class=\"ms-1\">{{'COMMON.setPermissions' |\n                    translateHs: {app} }}</span>\n            </a>\n            <a class=\"btn btn-sm\" (click)=\"$event.stopPropagation();confirmDelete(composition)\" data-toggle=\"tooltip\"\n                data-placement=\"bottom\"\n                [title]=\"composition.editable ? '' : 'COMPOSITIONS.notAllowedToEditLayer' | translateHs: {app} \">\n                <i class=\"icon-trash icon-primary\" [ngClass]=\"{'text-muted': !composition.editable}\"\n                    [ngStyle]=\"{'cursor' : composition.editable ? 'pointer' : 'default'}\"></i><span\n                    [hidden]=\"!composition.editable\" class=\"ms-1\">{{'COMMON.delete' |\n                    translateHs: {app} }}</span>\n            </a>\n        </ng-container>\n    </div>\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsCompositionsService }, { type: HsToastService }, { type: HsDialogContainerService }, { type: HsConfig }, { type: HsLanguageService }]; }, propDecorators: { composition: [{
                type: Input
            }], selectedCompId: [{
                type: Input
            }], app: [{
                type: Input
            }] } });

class HsCompositionsComponent extends HsPanelBaseComponent {
    constructor(hsCompositionsService, hsCompositionsParserService, hsLayoutService, hsConfig, hsCompositionsMapService, hsDialogContainerService, hsCompositionsCatalogueService, hsLaymanService, hsSidebarService, hsLanguageService) {
        super(hsLayoutService);
        this.hsCompositionsService = hsCompositionsService;
        this.hsCompositionsParserService = hsCompositionsParserService;
        this.hsLayoutService = hsLayoutService;
        this.hsConfig = hsConfig;
        this.hsCompositionsMapService = hsCompositionsMapService;
        this.hsDialogContainerService = hsDialogContainerService;
        this.hsCompositionsCatalogueService = hsCompositionsCatalogueService;
        this.hsLaymanService = hsLaymanService;
        this.hsSidebarService = hsSidebarService;
        this.hsLanguageService = hsLanguageService;
        this.keywordsVisible = false;
        this.themesVisible = false;
        this.urlToAdd = '';
        this.addCompositionUrlVisible = false;
        this.optionsButtonLabel = 'more';
        this.optionsMenuOpen = false;
        this.name = 'composition_browser';
    }
    ngOnInit() {
        this.hsSidebarService.addButton({
            panel: 'composition_browser',
            module: 'hs.compositions',
            order: 3,
            fits: true,
            title: 'PANEL_HEADER.MAPCOMPOSITIONS',
            description: 'SIDEBAR.descriptions.MAPCOMPOSITIONS',
            icon: 'icon-map',
        }, this.data.app);
        this.configRef = this.hsConfig.get(this.data.app);
        this.hsCompositionsCatalogueService.init(this.data.app);
        this.hsCompositionsService.init(this.data.app);
        this.hsCompositionsMapService.init(this.data.app);
        this.catalogueRef = this.hsCompositionsCatalogueService.get(this.data.app);
        this.loadFilteredCompositions = () => this.hsCompositionsCatalogueService.loadFilteredCompositions(this.data.app);
        this.notSavedCompositionLoadingSubscription = this.hsCompositionsService
            .get(this.data.app)
            .notSavedCompositionLoading.subscribe((url) => {
            this.hsCompositionsService.get(this.data.app).compositionToLoad = {
                url,
                title: '',
            };
            this.loadUnsavedDialogBootstrap('');
        });
    }
    ngOnDestroy() {
        this.notSavedCompositionLoadingSubscription.unsubscribe();
    }
    /**
     * @param composition - Composition to highlight
     * @param state - Target state of composition ( True - highlighted, False - normal)
     * Highlight (or dim) composition, toggle visual state of composition extent on map
     */
    highlightComposition(composition, state) {
        composition.highlighted = state;
        this.hsCompositionsMapService.highlightComposition(composition, state, this.data.app);
    }
    /**
     * @param url -
     * Load selected composition in map, if current composition was edited display Overwrite dialog
     */
    addCompositionUrl(url) {
        if (this.hsCompositionsParserService.get(this.data.app).composition_edited ==
            true) {
            this.hsCompositionsService
                .get(this.data.app)
                .notSavedCompositionLoading.next(url);
        }
        else {
            this.hsCompositionsService
                .loadComposition(url, this.data.app, true)
                .then((_) => {
                this.addCompositionUrlVisible = false;
            });
        }
    }
    /**
     * @param evt - File upload event
     * @param app - App identifier
     * Handle composition upload from file list
     */
    handleFileSelect(evt, app) {
        const files = evt.target.files; // FileList object
        for (const f of files) {
            if (!f.type.match('application/json')) {
                continue;
            }
            const reader = new FileReader();
            reader.onload = (theFile) => __awaiter(this, void 0, void 0, function* () {
                const json = JSON.parse(reader.result);
                yield this.hsCompositionsParserService.loadCompositionObject(json, true, app);
            });
            reader.readAsText(f);
        }
    }
    /**
     * Open overwrite dialog
     * @param title - Dialog title
     */
    loadUnsavedDialogBootstrap(title) {
        this.hsDialogContainerService.create(HsCompositionsOverwriteDialogComponent, {
            composition_name_to_be_loaded: title,
            app: this.data.app,
        }, this.data.app);
    }
    /**
     * Open options menu
     */
    openOptionsMenu() {
        this.optionsMenuOpen = !this.optionsMenuOpen;
        if (this.optionsMenuOpen) {
            this.optionsButtonLabel = 'less';
            this.keywordsVisible = false;
            this.themesVisible = false;
        }
        else {
            this.optionsButtonLabel = 'more';
        }
    }
    /**
     * Clear all options menu filters
     */
    clearFilters() {
        this.optionsMenuOpen = false;
        this.themesVisible = false;
        this.keywordsVisible = false;
        this.selectedCompId = '';
        this.hsCompositionsCatalogueService.clearFilters(this.data.app);
    }
    /**
     * Change add composition url button visibility
     */
    changeUrlButtonVisible() {
        this.addCompositionUrlVisible = !this.addCompositionUrlVisible;
    }
    /**
     * Open save map panel
     */
    openSaveMapPanel() {
        this.hsLayoutService.setMainPanel('saveMap', this.data.app);
    }
    /**
     * Act on composition clicked
     * @param composition - Composition list item selected
     */
    compositionClicked(composition) {
        if (this.selectedCompId != this.hsCompositionsService.commonId(composition)) {
            this.selectedCompId = this.hsCompositionsService.commonId(composition);
        }
        else {
            this.selectedCompId = '';
        }
    }
    /**
     * Reload compositions list
     */
    reload() {
        this.clearFilters();
        this.loadFilteredCompositions();
    }
    /**
     * Act on sort value changes for sorting compositions
     * @param sortBy - Sorting value
     */
    sortByValueChanged(sortBy) {
        this.catalogueRef.data.sortBy = sortBy;
        this.loadFilteredCompositions();
    }
    /**
     * Get layman endpoint reference
     */
    getLaymanEndpoint() {
        return this.hsLaymanService.getLaymanEndpoint();
    }
    /**
     * Check if Layman user is a guest
     */
    isLaymanGuest() {
        return this.hsLaymanService.isLaymanGuest();
    }
    /**
     * Translate string value to the selected UI language
     * @param module - Locales json key
     * @param text - Locales json key value
     * @returns Translated text
     */
    translateString(module, text) {
        return this.hsLanguageService.getTranslationIgnoreNonExisting(module, text, undefined, this.data.app);
    }
    /**
     * Get save map panel status
     */
    saveMapAvailable() {
        return this.hsLayoutService.panelEnabled('saveMap', this.data.app);
    }
}
HsCompositionsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCompositionsComponent, deps: [{ token: HsCompositionsService }, { token: HsCompositionsParserService }, { token: HsLayoutService }, { token: HsConfig }, { token: HsCompositionsMapService }, { token: HsDialogContainerService }, { token: HsCompositionsCatalogueService }, { token: HsLaymanService }, { token: HsSidebarService }, { token: HsLanguageService }], target: i0.ɵɵFactoryTarget.Component });
HsCompositionsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsCompositionsComponent, selector: "hs-compositions", usesInheritance: true, ngImport: i0, template: "<div class=\"card hs-main-panel\" [hidden]=\"(isVisible$ | async) === false\">\n    <hs-panel-header name=\"composition_browser\" [title]=\"'PANEL_HEADER.COMPOSITIONS' | translateHs : data\"\n        [app]=\"data.app\">\n        <extra-buttons>\n            <button class=\"but-title-sm hs-extra-buttons\" (click)=\"reload()\"\n                [title]=\"'COMMON.reload' | translateHs : data\">\n                <i class=\"glyphicon icon-fatredo\"></i>\n            </button>\n            <button class=\"but-title-sm hs-extra-buttons\" [title]=\"'PANEL_HEADER.SAVECOMPOSITION'|translateHs : data\"\n                (click)=\"openSaveMapPanel()\" [hidden]=\"!saveMapAvailable()\"><!-- TODO: Remove function call from template -->\n                <span class=\"icon-save-floppy\"></span>\n            </button>\n            <label class=\"but-title-sm hs-extra-buttons btn-file mb-0\" style=\"font-size: 14px; padding: 1px 6px;\"\n                [title]=\"'COMPOSITIONS.import' | translateHs : data\">\n                <span class=\"icon-upload\"></span><input type=\"file\" (change)=\"handleFileSelect($event, data.app)\"\n                    accept=\".json\" style=\"display: none;\">\n            </label>\n            <button class=\"but-title-sm hs-extra-buttons\" [title]=\"'COMPOSITIONS.addByAddress'|translateHs : data\"\n                (click)=\"changeUrlButtonVisible()\">\n                <span class=\"icon-plus\"></span>\n            </button>\n        </extra-buttons>\n    </hs-panel-header>\n    <div class=\"mt-3 mx-3 ps-1 d-flex justify-content-between\">\n        <div class=\"input-group mb-2\" [hidden]=\"!addCompositionUrlVisible\">\n            <input type=\"text\" class=\"form-control\" [placeholder]=\"'COMPOSITIONS.Address'|translateHs : data\"\n                [(ngModel)]=\"urlToAdd\" [ngModelOptions]=\"{standalone: true}\">\n            <button type=\"button\" class=\"btn btn-secondary\" (click)=\"addCompositionUrl(urlToAdd)\"><i\n                    class=\"icon-link\"></i></button>\n        </div>\n    </div>\n    <div class=\"mx-3 ps-1 d-flex justify-content-between\">\n        <div class=\"input-group\" style=\"width: 55% !important;\">\n            <input type=\"search\" class=\"form-control border-end-0\" [placeholder]=\"'COMMON.search'|translateHs : data\"\n                name=\"search\" [(ngModel)]=\"catalogueRef.data.query.title\" (ngModelChange)=\"loadFilteredCompositions()\">\n            <button class=\"input-group-text text-secondary border-start-0\" (click)=\"loadFilteredCompositions()\">\n                <i class=\"icon-search icon-primary\"></i>\n            </button>\n        </div>\n        <hs-layman-current-user [app]=\"data.app\" [endpoint]=\"getLaymanEndpoint()\"><!-- TODO: Remove function call from template -->\n        </hs-layman-current-user>\n    </div>\n    <div class=\"d-flex ms-4 me-3 justify-content-between py-1 \">\n        <div class=\"d-flex\">\n            <div class=\"input-group-text border-0\">\n                <input type=\"checkbox\" [(ngModel)]=\"catalogueRef.filterByExtent\" (change)='loadFilteredCompositions()'\n                    name=\"catalogueRef.filterByExtent\">\n                <span class=\"ms-1\">{{'COMPOSITIONS.filterByMap' | translateHs : {app: data.app} }}</span>\n            </div>\n            <div class=\"input-group-text border-0 ms-1\" *ngIf=\"getLaymanEndpoint() && !isLaymanGuest()\"><!-- TODO: Remove function call from template -->\n                <input type=\"checkbox\" [(ngModel)]=\"catalogueRef.filterByOnlyMine\" (change)='loadFilteredCompositions()'\n                    name=\"catalogueRef.filterByOnlyMine\">\n                <span class=\"ms-1\">{{'COMPOSITIONS.onlyMine' | translateHs : {app: data.app} }}</span>\n            </div>\n        </div>\n        <div ngbDropdown display=\"dynamic\" placement=\"bottom-right\" class=\"d-inline-block\">\n            <button class=\"btn btn-light hs-white-background hs-custom-toggle\" (click)=\"openOptionsMenu()\"\n                ngbDropdownToggle>{{translateString('COMMON', optionsButtonLabel)}}</button><!-- TODO: Remove function call from template -->\n            <div ngbDropdownMenu class=\"dropdown-menu-right p-2 m-1\"\n                style=\"min-width: 23rem; max-width: 23rem;  overflow: visible\" aria-labelledby=\"filtersDropdown\">\n                <table class=\"p-1 ps-3\" style=\"border-collapse:separate; border-spacing:0.5rem 0.5rem;\">\n                    <tbody>\n                        <!-- <tr>\n                                    <td class=\"tdbreak\">\n                                        {{'COMMON.type' | translateHs : {app: data.app} }}\n                                    </td>\n                                    <td>\n                                        <select class=\"form-control hs-background-alfa ps-1\" name=\"type\"\n                                            [(ngModel)]=\"catalogueRef.data.type\"\n                                            (change)=\"loadFilteredCompositions()\"\n                                            style=\"min-width: 11rem; max-width: 11rem;border:0px\">\n                                            <option *ngFor=\"let type of catalogueRef.types\"\n                                                [ngValue]=\"type.value\">\n                                                {{translateString('COMPOSITONTYPES', type.name)}}</option>\n                                        </select>\n                                    </td>\n                                </tr> -->\n                        <tr>\n                            <td class=\"tdbreak\">\n                                {{'COMMON.keywords' | translateHs : {app: data.app} }}\n                            </td>\n                            <td ngbDropdown display=\"dynamic\" placement=\"bottom-right\">\n                                <button type=\"button\" ngbDropdownToggle\n                                    class=\"btn btn-light btn-sm hs-custom-toggle hs-background-alfa p-2 ps-1 border-0\"\n                                    style=\"text-align:start; min-width: 11rem; max-width: 11rem; border-radius: 0px; justify-content: space-between; display:flex; align-items: center;\">\n                                    {{'COMPOSITIONS.selectKeywords' | translateHs : {app: data.app} }}\n                                </button>\n                                <ul ngbDropdownMenu aria-labelledby=\"keywords\" class=\"ps-2\"\n                                    style=\"overflow-y: auto; max-height: 10rem; min-width: 15rem\">\n                                    <li *ngFor=\"let keyword of catalogueRef.data.keywords, let index = index;\">\n                                        <label style=\"cursor: pointer;\"><input class=\"me-2\" type=\"checkbox\"\n                                                [(ngModel)]=\"keyword.selected\" name=\"keyword[index]\"\n                                                (change)=\"loadFilteredCompositions()\">{{translateString('COMPOSITONKEYWORDS',\n                                            keyword.name)}}</label>\n                                    </li>\n                                </ul>\n                            </td>\n                        </tr>\n                        <tr>\n                            <td class=\"tdbreak\">\n                                {{'COMPOSITIONS.inspireTheme' | translateHs : {app: data.app} }}\n                            </td>\n                            <td ngbDropdown display=\"dynamic\" placement=\"bottom-right\">\n                                <button type=\"button\" ngbDropdownToggle\n                                    class=\"btn btn-light btn-sm hs-custom-toggle hs-background-alfa p-2 ps-1 border-0\"\n                                    style=\"text-align:start; min-width: 11rem; max-width: 11rem; border-radius: 0px; justify-content: space-between; display:flex; align-items: center;\">\n                                    {{'COMPOSITIONS.selectThemes' | translateHs : {app: data.app} }}\n                                </button>\n                                <ul ngbDropdownMenu aria-labelledby=\"inspireThemes\" class=\"ps-2\"\n                                    style=\"overflow-y: auto; max-height: 10rem; min-width: 20rem\">\n                                    <li *ngFor=\"let theme of catalogueRef.data.themes, let index = index;\">\n                                        <label style=\"cursor: pointer;\"><input class=\"me-2\" type=\"checkbox\"\n                                                [(ngModel)]=\"theme.selected\" name=\"theme[index]\"\n                                                (change)=\"loadFilteredCompositions()\">{{translateString('COMPOSITONINSPIRETHEMES',\n                                            theme.name)}}</label>\n                                    </li>\n                                </ul>\n                            </td>\n                        </tr>\n\n                        <tr>\n                            <td class=\"tdbreak\">\n                                {{'COMMON.sortBy' | translateHs : {app: data.app} }}\n                            </td>\n                            <td ngbDropdown display=\"dynamic\" placement=\"bottom-right\" #sortByDrop=\"ngbDropdown\">\n                                <button type=\"button\" ngbDropdownToggle\n                                    class=\"btn btn-light btn-sm hs-custom-toggle hs-background-alfa p-2 ps-1 border-0\"\n                                    style=\"text-align:start; min-width: 11rem; max-width: 11rem; border-radius: 0px; justify-content: space-between; display:flex; align-items: center;\">\n                                    {{translateString('COMPOSITONSORTVALUES',\n                                    catalogueRef.data.sortBy.name)}}\n                                </button>\n                                <ul ngbDropdownMenu aria-labelledby=\"sortBy\" class=\"ps-2\"\n                                    style=\"overflow-y: auto; max-height: 10rem; min-width:10rem\">\n                                    <li *ngFor=\"let item of catalogueRef.sortByValues, let index = index;\">\n                                        <label style=\"cursor: pointer;\"><input class=\"me-2\" type=\"radio\"\n                                                name=\"sort-index\" [checked]=\"(index === 0)\"\n                                                (change)=\"sortByValueChanged(item);sortByDrop.close()\">{{translateString('COMPOSITONSORTVALUES',\n                                            item.name)}}</label>\n                                    </li>\n                                </ul>\n                            </td>\n                        </tr>\n                        <tr>\n                            <td colspan=\"2\" style=\"text-align: center; vertical-align: middle;\">\n                                <button class=\"btn w-100 btn-light hs-background-alfa\" style=\"border-radius: 0.25rem;\"\n                                    (click)=\"clearFilters()\">\n                                    {{'COMPOSITIONS.clearFilters' | translateHs : {app: data.app} }}</button>\n                            </td>\n                        </tr>\n                    </tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n    <div class=\"tab-content\">\n        <div class=\"card d-flex\" style=\"font-size: 1rem !important;\">\n            <div class=\"card-body\">\n                <ul class=\"list-group\">\n                    <li *ngFor=\"let composition of catalogueRef.compositionEntries\" [hidden]=\"catalogueRef.dataLoading\"\n                        class=\"list-group-item clearfix\" style=\"cursor: pointer;\"\n                        [ngClass]=\"{'hs-endpoint-item-active' : composition.highlighted}\"\n                        (mouseover)=\"highlightComposition(composition, true)\"\n                        (mouseleave)=\"highlightComposition(composition, false)\"\n                        (click)=\"compositionClicked(composition)\" data-container=\"body\" data-placement=\"bottom\"\n                        [attr.title]=\"composition.mdAbstract\">\n                        <hs-compositions-list-item [composition]=\"composition\" [app]=\"data.app\"\n                            [selectedCompId]=\"selectedCompId\">\n                        </hs-compositions-list-item>\n                    </li>\n                    <li class=\"list-group-item text-primary text-center py-2\" *ngIf=\"catalogueRef.dataLoading\"><img\n                            class=\"pe-2\" [src]=\"configRef._ajaxLoaderPath\" />{{'COMMON.loading' |\n                        translateHs: {app: data.app} }}</li>\n                    <li [hidden]=\"catalogueRef.compositionEntries.length > 0 || catalogueRef.dataLoading\"\n                        class=\"list-group-item\">\n                        {{'DATASOURCE_SELECTOR.noResults' | translateHs : {app: data.app} }}</li>\n                </ul>\n            </div>\n            <ng-container *ngIf=\"catalogueRef.matchedRecords !== 0 && !catalogueRef.dataLoading\">\n                <hs-pager [app]=\"data.app\" [pagerService]=\"hsCompositionsCatalogueService\"></hs-pager>\n            </ng-container>\n        </div>\n    </div>\n</div>", components: [{ type: HsPanelHeaderComponent, selector: "hs-panel-header", inputs: ["name", "app", "title"] }, { type: HsLaymanCurrentUserComponent, selector: "hs-layman-current-user", inputs: ["app", "endpoint"] }, { type: HsCompositionsListItemComponent, selector: "hs-compositions-list-item", inputs: ["composition", "selectedCompId", "app"] }, { type: HsPagerComponent, selector: "hs-pager", inputs: ["app", "pagerService"] }], directives: [{ type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3$1.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i7.NgbDropdown, selector: "[ngbDropdown]", inputs: ["autoClose", "dropdownClass", "open", "placement", "container", "display"], outputs: ["openChange"], exportAs: ["ngbDropdown"] }, { type: i7.NgbDropdownToggle, selector: "[ngbDropdownToggle]" }, { type: i7.NgbDropdownMenu, selector: "[ngbDropdownMenu]" }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], pipes: { "async": i3.AsyncPipe, "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCompositionsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-compositions', template: "<div class=\"card hs-main-panel\" [hidden]=\"(isVisible$ | async) === false\">\n    <hs-panel-header name=\"composition_browser\" [title]=\"'PANEL_HEADER.COMPOSITIONS' | translateHs : data\"\n        [app]=\"data.app\">\n        <extra-buttons>\n            <button class=\"but-title-sm hs-extra-buttons\" (click)=\"reload()\"\n                [title]=\"'COMMON.reload' | translateHs : data\">\n                <i class=\"glyphicon icon-fatredo\"></i>\n            </button>\n            <button class=\"but-title-sm hs-extra-buttons\" [title]=\"'PANEL_HEADER.SAVECOMPOSITION'|translateHs : data\"\n                (click)=\"openSaveMapPanel()\" [hidden]=\"!saveMapAvailable()\"><!-- TODO: Remove function call from template -->\n                <span class=\"icon-save-floppy\"></span>\n            </button>\n            <label class=\"but-title-sm hs-extra-buttons btn-file mb-0\" style=\"font-size: 14px; padding: 1px 6px;\"\n                [title]=\"'COMPOSITIONS.import' | translateHs : data\">\n                <span class=\"icon-upload\"></span><input type=\"file\" (change)=\"handleFileSelect($event, data.app)\"\n                    accept=\".json\" style=\"display: none;\">\n            </label>\n            <button class=\"but-title-sm hs-extra-buttons\" [title]=\"'COMPOSITIONS.addByAddress'|translateHs : data\"\n                (click)=\"changeUrlButtonVisible()\">\n                <span class=\"icon-plus\"></span>\n            </button>\n        </extra-buttons>\n    </hs-panel-header>\n    <div class=\"mt-3 mx-3 ps-1 d-flex justify-content-between\">\n        <div class=\"input-group mb-2\" [hidden]=\"!addCompositionUrlVisible\">\n            <input type=\"text\" class=\"form-control\" [placeholder]=\"'COMPOSITIONS.Address'|translateHs : data\"\n                [(ngModel)]=\"urlToAdd\" [ngModelOptions]=\"{standalone: true}\">\n            <button type=\"button\" class=\"btn btn-secondary\" (click)=\"addCompositionUrl(urlToAdd)\"><i\n                    class=\"icon-link\"></i></button>\n        </div>\n    </div>\n    <div class=\"mx-3 ps-1 d-flex justify-content-between\">\n        <div class=\"input-group\" style=\"width: 55% !important;\">\n            <input type=\"search\" class=\"form-control border-end-0\" [placeholder]=\"'COMMON.search'|translateHs : data\"\n                name=\"search\" [(ngModel)]=\"catalogueRef.data.query.title\" (ngModelChange)=\"loadFilteredCompositions()\">\n            <button class=\"input-group-text text-secondary border-start-0\" (click)=\"loadFilteredCompositions()\">\n                <i class=\"icon-search icon-primary\"></i>\n            </button>\n        </div>\n        <hs-layman-current-user [app]=\"data.app\" [endpoint]=\"getLaymanEndpoint()\"><!-- TODO: Remove function call from template -->\n        </hs-layman-current-user>\n    </div>\n    <div class=\"d-flex ms-4 me-3 justify-content-between py-1 \">\n        <div class=\"d-flex\">\n            <div class=\"input-group-text border-0\">\n                <input type=\"checkbox\" [(ngModel)]=\"catalogueRef.filterByExtent\" (change)='loadFilteredCompositions()'\n                    name=\"catalogueRef.filterByExtent\">\n                <span class=\"ms-1\">{{'COMPOSITIONS.filterByMap' | translateHs : {app: data.app} }}</span>\n            </div>\n            <div class=\"input-group-text border-0 ms-1\" *ngIf=\"getLaymanEndpoint() && !isLaymanGuest()\"><!-- TODO: Remove function call from template -->\n                <input type=\"checkbox\" [(ngModel)]=\"catalogueRef.filterByOnlyMine\" (change)='loadFilteredCompositions()'\n                    name=\"catalogueRef.filterByOnlyMine\">\n                <span class=\"ms-1\">{{'COMPOSITIONS.onlyMine' | translateHs : {app: data.app} }}</span>\n            </div>\n        </div>\n        <div ngbDropdown display=\"dynamic\" placement=\"bottom-right\" class=\"d-inline-block\">\n            <button class=\"btn btn-light hs-white-background hs-custom-toggle\" (click)=\"openOptionsMenu()\"\n                ngbDropdownToggle>{{translateString('COMMON', optionsButtonLabel)}}</button><!-- TODO: Remove function call from template -->\n            <div ngbDropdownMenu class=\"dropdown-menu-right p-2 m-1\"\n                style=\"min-width: 23rem; max-width: 23rem;  overflow: visible\" aria-labelledby=\"filtersDropdown\">\n                <table class=\"p-1 ps-3\" style=\"border-collapse:separate; border-spacing:0.5rem 0.5rem;\">\n                    <tbody>\n                        <!-- <tr>\n                                    <td class=\"tdbreak\">\n                                        {{'COMMON.type' | translateHs : {app: data.app} }}\n                                    </td>\n                                    <td>\n                                        <select class=\"form-control hs-background-alfa ps-1\" name=\"type\"\n                                            [(ngModel)]=\"catalogueRef.data.type\"\n                                            (change)=\"loadFilteredCompositions()\"\n                                            style=\"min-width: 11rem; max-width: 11rem;border:0px\">\n                                            <option *ngFor=\"let type of catalogueRef.types\"\n                                                [ngValue]=\"type.value\">\n                                                {{translateString('COMPOSITONTYPES', type.name)}}</option>\n                                        </select>\n                                    </td>\n                                </tr> -->\n                        <tr>\n                            <td class=\"tdbreak\">\n                                {{'COMMON.keywords' | translateHs : {app: data.app} }}\n                            </td>\n                            <td ngbDropdown display=\"dynamic\" placement=\"bottom-right\">\n                                <button type=\"button\" ngbDropdownToggle\n                                    class=\"btn btn-light btn-sm hs-custom-toggle hs-background-alfa p-2 ps-1 border-0\"\n                                    style=\"text-align:start; min-width: 11rem; max-width: 11rem; border-radius: 0px; justify-content: space-between; display:flex; align-items: center;\">\n                                    {{'COMPOSITIONS.selectKeywords' | translateHs : {app: data.app} }}\n                                </button>\n                                <ul ngbDropdownMenu aria-labelledby=\"keywords\" class=\"ps-2\"\n                                    style=\"overflow-y: auto; max-height: 10rem; min-width: 15rem\">\n                                    <li *ngFor=\"let keyword of catalogueRef.data.keywords, let index = index;\">\n                                        <label style=\"cursor: pointer;\"><input class=\"me-2\" type=\"checkbox\"\n                                                [(ngModel)]=\"keyword.selected\" name=\"keyword[index]\"\n                                                (change)=\"loadFilteredCompositions()\">{{translateString('COMPOSITONKEYWORDS',\n                                            keyword.name)}}</label>\n                                    </li>\n                                </ul>\n                            </td>\n                        </tr>\n                        <tr>\n                            <td class=\"tdbreak\">\n                                {{'COMPOSITIONS.inspireTheme' | translateHs : {app: data.app} }}\n                            </td>\n                            <td ngbDropdown display=\"dynamic\" placement=\"bottom-right\">\n                                <button type=\"button\" ngbDropdownToggle\n                                    class=\"btn btn-light btn-sm hs-custom-toggle hs-background-alfa p-2 ps-1 border-0\"\n                                    style=\"text-align:start; min-width: 11rem; max-width: 11rem; border-radius: 0px; justify-content: space-between; display:flex; align-items: center;\">\n                                    {{'COMPOSITIONS.selectThemes' | translateHs : {app: data.app} }}\n                                </button>\n                                <ul ngbDropdownMenu aria-labelledby=\"inspireThemes\" class=\"ps-2\"\n                                    style=\"overflow-y: auto; max-height: 10rem; min-width: 20rem\">\n                                    <li *ngFor=\"let theme of catalogueRef.data.themes, let index = index;\">\n                                        <label style=\"cursor: pointer;\"><input class=\"me-2\" type=\"checkbox\"\n                                                [(ngModel)]=\"theme.selected\" name=\"theme[index]\"\n                                                (change)=\"loadFilteredCompositions()\">{{translateString('COMPOSITONINSPIRETHEMES',\n                                            theme.name)}}</label>\n                                    </li>\n                                </ul>\n                            </td>\n                        </tr>\n\n                        <tr>\n                            <td class=\"tdbreak\">\n                                {{'COMMON.sortBy' | translateHs : {app: data.app} }}\n                            </td>\n                            <td ngbDropdown display=\"dynamic\" placement=\"bottom-right\" #sortByDrop=\"ngbDropdown\">\n                                <button type=\"button\" ngbDropdownToggle\n                                    class=\"btn btn-light btn-sm hs-custom-toggle hs-background-alfa p-2 ps-1 border-0\"\n                                    style=\"text-align:start; min-width: 11rem; max-width: 11rem; border-radius: 0px; justify-content: space-between; display:flex; align-items: center;\">\n                                    {{translateString('COMPOSITONSORTVALUES',\n                                    catalogueRef.data.sortBy.name)}}\n                                </button>\n                                <ul ngbDropdownMenu aria-labelledby=\"sortBy\" class=\"ps-2\"\n                                    style=\"overflow-y: auto; max-height: 10rem; min-width:10rem\">\n                                    <li *ngFor=\"let item of catalogueRef.sortByValues, let index = index;\">\n                                        <label style=\"cursor: pointer;\"><input class=\"me-2\" type=\"radio\"\n                                                name=\"sort-index\" [checked]=\"(index === 0)\"\n                                                (change)=\"sortByValueChanged(item);sortByDrop.close()\">{{translateString('COMPOSITONSORTVALUES',\n                                            item.name)}}</label>\n                                    </li>\n                                </ul>\n                            </td>\n                        </tr>\n                        <tr>\n                            <td colspan=\"2\" style=\"text-align: center; vertical-align: middle;\">\n                                <button class=\"btn w-100 btn-light hs-background-alfa\" style=\"border-radius: 0.25rem;\"\n                                    (click)=\"clearFilters()\">\n                                    {{'COMPOSITIONS.clearFilters' | translateHs : {app: data.app} }}</button>\n                            </td>\n                        </tr>\n                    </tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n    <div class=\"tab-content\">\n        <div class=\"card d-flex\" style=\"font-size: 1rem !important;\">\n            <div class=\"card-body\">\n                <ul class=\"list-group\">\n                    <li *ngFor=\"let composition of catalogueRef.compositionEntries\" [hidden]=\"catalogueRef.dataLoading\"\n                        class=\"list-group-item clearfix\" style=\"cursor: pointer;\"\n                        [ngClass]=\"{'hs-endpoint-item-active' : composition.highlighted}\"\n                        (mouseover)=\"highlightComposition(composition, true)\"\n                        (mouseleave)=\"highlightComposition(composition, false)\"\n                        (click)=\"compositionClicked(composition)\" data-container=\"body\" data-placement=\"bottom\"\n                        [attr.title]=\"composition.mdAbstract\">\n                        <hs-compositions-list-item [composition]=\"composition\" [app]=\"data.app\"\n                            [selectedCompId]=\"selectedCompId\">\n                        </hs-compositions-list-item>\n                    </li>\n                    <li class=\"list-group-item text-primary text-center py-2\" *ngIf=\"catalogueRef.dataLoading\"><img\n                            class=\"pe-2\" [src]=\"configRef._ajaxLoaderPath\" />{{'COMMON.loading' |\n                        translateHs: {app: data.app} }}</li>\n                    <li [hidden]=\"catalogueRef.compositionEntries.length > 0 || catalogueRef.dataLoading\"\n                        class=\"list-group-item\">\n                        {{'DATASOURCE_SELECTOR.noResults' | translateHs : {app: data.app} }}</li>\n                </ul>\n            </div>\n            <ng-container *ngIf=\"catalogueRef.matchedRecords !== 0 && !catalogueRef.dataLoading\">\n                <hs-pager [app]=\"data.app\" [pagerService]=\"hsCompositionsCatalogueService\"></hs-pager>\n            </ng-container>\n        </div>\n    </div>\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsCompositionsService }, { type: HsCompositionsParserService }, { type: HsLayoutService }, { type: HsConfig }, { type: HsCompositionsMapService }, { type: HsDialogContainerService }, { type: HsCompositionsCatalogueService }, { type: HsLaymanService }, { type: HsSidebarService }, { type: HsLanguageService }]; } });

class HsDrawLayerMetadataDialogComponent {
    constructor(HsMapService, HsDialogContainerService) {
        this.HsMapService = HsMapService;
        this.HsDialogContainerService = HsDialogContainerService;
        this.attributes = [];
        this.folderVisible = false;
        this.access_rights = {
            'access_rights.write': 'private',
            'access_rights.read': 'EVERYONE',
        };
        this.onlyMineFilterVisible = false;
    }
    ngOnInit() {
        this.appRef = this.data.service.get(this.data.app);
        this.layer = this.appRef.selectedLayer;
        this.title = getTitle(this.layer);
        this.path = getPath(this.layer);
        this.endpoint = this.appRef.laymanEndpoint;
        this.type = 'draw';
    }
    titleChanged() {
        setTitle(this.layer, this.title);
    }
    confirm() {
        const dic = {};
        setName(this.layer, getLaymanFriendlyLayerName(getTitle(this.layer)));
        const tmpLayer = this.HsMapService.findLayerByTitle('tmpDrawLayer', this.data.app) || null;
        if (tmpLayer) {
            this.HsMapService.getMap(this.data.app).removeLayer(tmpLayer);
        }
        this.attributes.forEach((a) => {
            dic[a.name] = a.value;
        });
        let editorConfig = getEditor(this.layer);
        if (!editorConfig) {
            editorConfig = {};
            setEditor(this.layer, editorConfig);
        }
        editorConfig.defaultAttributes = dic;
        this.layer.getSource().forEachFeature((f) => {
            f.setProperties(dic);
        });
        setAccessRights(this.layer, this.access_rights);
        const appService = this.data.service;
        appService.changeDrawSource(this.data.app);
        appService.addDrawLayer(this.layer, this.data.app);
        appService.fillDrawableLayers(this.data.app);
        this.tmpFeatures = this.layer.getSource().getFeatures();
        //Dispatch add feature event in order to trigger sync
        this.awaitLayerSync(this.layer).then(() => {
            const event = this.tmpFeatures ? this.getEventType() : 'addfeature';
            this.layer.getSource().dispatchEvent(event);
        });
        this.appRef.tmpDrawLayer = false;
        this.HsDialogContainerService.destroy(this, this.data.app);
    }
    getEventType() {
        return this.layer.getSource().getFeatures().length > this.tmpFeatures.length
            ? //Existing layer
                { type: 'addfeature', feature: this.tmpFeatures }
            : //New layer
                'addfeature';
    }
    cancel() {
        this.appRef.selectedLayer = this.appRef.previouslySelected;
        this.HsDialogContainerService.destroy(this, this.data.app);
    }
    awaitLayerSync(layer) {
        return __awaiter(this, void 0, void 0, function* () {
            while (getHsLaymanSynchronizing(layer)) {
                yield new Promise((r) => setTimeout(r, 200));
            }
            return true;
        });
    }
    pathChanged() {
        setPath(this.layer, this.path);
    }
    addAttr() {
        this.attributes.push({ id: Math.random(), name: '', value: '' });
    }
    selectLayer(layer) {
        this.data.service.selectLayer(layer, this.data.app);
        this.HsDialogContainerService.destroy(this, this.data.app);
    }
}
HsDrawLayerMetadataDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsDrawLayerMetadataDialogComponent, deps: [{ token: HsMapService }, { token: HsDialogContainerService }], target: i0.ɵɵFactoryTarget.Component });
HsDrawLayerMetadataDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsDrawLayerMetadataDialogComponent, selector: "hs-draw-layer-metadata", inputs: { data: "data" }, ngImport: i0, template: "<div class=\"modal in hs-draw-layer-metadata\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header d-flex flex-column\" style=\"height: auto\">\n                <div class=\"d-flex w-100 align-items-center\">\n                    <h4 class=\"modal-title\">\n                        {{'COMMON.newDrawingLayer' | translateHs: {app: data.app} }}\n                    </h4>\n                    <button type=\"button\" (click)=\"cancel()\" class=\"btn-close\" data-dismiss=\"modal\"\n                        attr.aria-label=\"{{'COMMON.close' | translateHs: {app: data.app} }}\">\n                    </button>\n                </div>\n                <p class=\"m-0 p-0\" style=\"font-size: small; color: red;\">\n                    {{'DRAW.drawLayerMetadata.layerWillBeAdded' | translateHs: {app: data.app} }}</p>\n            </div>\n            <div *ngIf=\"!appRef.isAuthorized && appRef.laymanEndpoint !== undefined\" class=\"alert alert-danger\"\n                role=\"alert\">\n                <p class=\"text-center\">\n                    {{'DRAW.notAuthorized' | translateHs: {app: data.app} }}\n                </p>\n                <hs-layman-current-user [app]=\"data.app\" [endpoint]=\"endpoint\"></hs-layman-current-user>\n            </div>\n            <div class=\"d-flex w-75 m-auto p-4 justify-content-around\" style=\"white-space: nowrap;\"\n                *ngIf=\"appRef.drawableLaymanLayers.length > 0 && appRef.isAuthorized\">\n                <button type=\"button\" class=\"btn btn-sm rounded  hs-toolbar-button\" (click)=\"type = 'draw'\"\n                    [ngClass]=\"type === 'draw' ? 'btn-primary' : 'btn-secondary'\">\n                    {{'DRAW.drawToolbar.addDrawLayer' | translateHs: {app: data.app} }}\n                </button>\n                <button type=\"button\" class=\"btn ms-1 btn-sm rounded hs-toolbar-button\" (click)=\"type = 'layman'\"\n                    [ngClass]=\"type === 'layman' ? 'btn-primary' : 'btn-secondary'\">\n                    {{'DRAW.drawLayerMetadata.loadServerLayers' | translateHs: {app: data.app} }}\n                </button>\n            </div>\n            <div class=\"modal-body\" style=\"max-height:400px; overflow-y:auto\">\n                <form *ngIf=\"type === 'draw'\">\n                    <div class=\"form-floating mb-3\">\n                        <input class=\"form-control\" [(ngModel)]=\"title\" (ngModelChange)=\"titleChanged()\" name=\"title\"\n                            placeholder=\"'DRAW.drawLayerMetadata.layerTitle' | translateHs: {app: data.app} \" />\n                        <label for=\"title\" class=\"control-label\">{{'DRAW.drawLayerMetadata.layerTitle' |\n                            translateHs: {app: data.app} }}</label>\n\n                    </div>\n                    <hs-layman-access-rights *ngIf=\"appRef.isAuthorized\" [app]=\"data.app\"\n                        [(access_rights)]=\"access_rights\">\n                    </hs-layman-access-rights>\n                    <div class=\"flex-row w-75 align-items-center\" style=\"display: flex;\">\n                        <a class=\"p-1 mb-1\" (click)=\"folderVisible = !folderVisible\">{{'COMMON.advancedOptions' |\n                            translateHs: {app: data.app} }}</a>\n                    </div>\n                    <div [hidden]=\"!folderVisible\">\n                        <div class=\"form-floating mb-3\"\n                            [title]=\"'DRAW.drawLayerMetadata.nameOfFolder' | translateHs: {app: data.app} \">\n                            <input class=\"form-control\" [(ngModel)]=\"path\" (ngModelChange)=\"pathChanged()\" name=\"path\"\n                                [placeholder]=\"'COMMON.folder' | translateHs: {app: data.app} \" />\n                            <label for=\"path\" class=\"control-label\">{{'COMMON.folder' | translateHs: {app: data.app} \n                                }}</label>\n                        </div>\n                        <div class=\"card\">\n                            <h5 class=\"card-header\">{{'DRAW.drawLayerMetadata.defaultAttributes' | translateHs: {'app':\n                                data.app} }}</h5>\n                            <div class=\"card-body\">\n                                <table class=\"table table-condensed\">\n                                    <tr>\n                                        <th>{{'COMMON.attribute' | translateHs: {app: data.app} }}</th>\n                                        <th>{{'DRAW.drawLayerMetadata.defaultValue' | translateHs: {app: data.app} }}\n                                        </th>\n                                    </tr>\n                                    <tr *ngFor=\"let attr of attributes\">\n                                        <td><input class=\"form-control\" [(ngModel)]=\"attr.name\"\n                                                [ngModelOptions]=\"{standalone: true}\" /></td>\n                                        <td><input class=\"form-control\" [(ngModel)]=\"attr.value\"\n                                                [ngModelOptions]=\"{standalone: true}\" /></td>\n                                    </tr>\n                                </table>\n                                <button class=\"btn btn-primary\" (click)=\"addAttr()\"><i class=\"icon-plus\"></i></button>\n                            </div>\n                        </div>\n                    </div>\n                </form>\n                <form *ngIf=\"type === 'layman'\">\n                    <div class=\"d-flex align-items-center w-100 flex-column\"\n                        *ngIf=\"appRef.drawableLaymanLayers.length > 0\">\n                        <div class=\" bg-primary w-100 text-light m-0 p-1\">\n                            <div class=\"d-flex justify-content-between m-1\">\n                                {{'DRAW.serverLayers' | translateHs: {app: data.app} }}\n                                <span (click)=\"onlyMineFilterVisible = !onlyMineFilterVisible\" style=\"cursor: pointer;\">\n                                    <i class=\"icon-settingsthree-gears\"></i>\n                                </span>\n                            </div>\n\n                            <div class=\"input-group-text border-0 justify-content-center bg-white\"\n                                *ngIf=\"onlyMineFilterVisible\">\n                                <label class=\"m-0\">\n                                    <input type=\"checkbox\" name=\"onlyMine\" [(ngModel)]=\"appRef.onlyMine\"\n                                        (ngModelChange)=\"data.service.fillDrawableLayers(data.app); onlyMineFilterVisible = !onlyMineFilterVisible\">\n                                    {{'COMPOSITIONS.onlyMine' | translateHs: {app: data.app} }}\n                                </label>\n                            </div>\n                        </div>\n                        <ul class=\"list-group w-100\">\n                            <li *ngFor=\"let layer of appRef.drawableLaymanLayers\" class=\"clearfix\"\n                                [ngClass]=\"'list-group-item'+(layer.highlighted ? ' active' : '')\">\n                                <b><a data-toggle=\"tooltip\" title=\"{{layer.description}}\">{{layer.title}}</a></b>\n                                <span class=\"float-right\">\n                                    <button type=\"button\" class=\"btn btn-sm btn-primary\" (click)=\"selectLayer(layer)\"\n                                        data-toggle=\"tooltip\" [title]=\"'ADDLAYERS.WFS.addToMap' | translateHs: {app: data.app} \"><i\n                                            class=\"icon-plus\"></i></button>\n                                </span>\n                            </li>\n                        </ul>\n                    </div>\n                </form>\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" *ngIf=\"type === 'draw'\"\n                    (click)=\"confirm()\">{{'DRAW.drawToolbar.addLayer' | translateHs: {app: data.app} }}</button>\n                <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" (click)=\"cancel()\">{{'COMMON.cancel'\n                    | translateHs: {app: data.app} }}</button>\n            </div>\n        </div>\n    </div>\n</div>", components: [{ type: HsLaymanCurrentUserComponent, selector: "hs-layman-current-user", inputs: ["app", "endpoint"] }, { type: HsCommonLaymanAccessRightsComponent, selector: "hs-layman-access-rights", inputs: ["access_rights", "app"] }], directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i3$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i3$1.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3$1.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsDrawLayerMetadataDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-draw-layer-metadata', template: "<div class=\"modal in hs-draw-layer-metadata\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header d-flex flex-column\" style=\"height: auto\">\n                <div class=\"d-flex w-100 align-items-center\">\n                    <h4 class=\"modal-title\">\n                        {{'COMMON.newDrawingLayer' | translateHs: {app: data.app} }}\n                    </h4>\n                    <button type=\"button\" (click)=\"cancel()\" class=\"btn-close\" data-dismiss=\"modal\"\n                        attr.aria-label=\"{{'COMMON.close' | translateHs: {app: data.app} }}\">\n                    </button>\n                </div>\n                <p class=\"m-0 p-0\" style=\"font-size: small; color: red;\">\n                    {{'DRAW.drawLayerMetadata.layerWillBeAdded' | translateHs: {app: data.app} }}</p>\n            </div>\n            <div *ngIf=\"!appRef.isAuthorized && appRef.laymanEndpoint !== undefined\" class=\"alert alert-danger\"\n                role=\"alert\">\n                <p class=\"text-center\">\n                    {{'DRAW.notAuthorized' | translateHs: {app: data.app} }}\n                </p>\n                <hs-layman-current-user [app]=\"data.app\" [endpoint]=\"endpoint\"></hs-layman-current-user>\n            </div>\n            <div class=\"d-flex w-75 m-auto p-4 justify-content-around\" style=\"white-space: nowrap;\"\n                *ngIf=\"appRef.drawableLaymanLayers.length > 0 && appRef.isAuthorized\">\n                <button type=\"button\" class=\"btn btn-sm rounded  hs-toolbar-button\" (click)=\"type = 'draw'\"\n                    [ngClass]=\"type === 'draw' ? 'btn-primary' : 'btn-secondary'\">\n                    {{'DRAW.drawToolbar.addDrawLayer' | translateHs: {app: data.app} }}\n                </button>\n                <button type=\"button\" class=\"btn ms-1 btn-sm rounded hs-toolbar-button\" (click)=\"type = 'layman'\"\n                    [ngClass]=\"type === 'layman' ? 'btn-primary' : 'btn-secondary'\">\n                    {{'DRAW.drawLayerMetadata.loadServerLayers' | translateHs: {app: data.app} }}\n                </button>\n            </div>\n            <div class=\"modal-body\" style=\"max-height:400px; overflow-y:auto\">\n                <form *ngIf=\"type === 'draw'\">\n                    <div class=\"form-floating mb-3\">\n                        <input class=\"form-control\" [(ngModel)]=\"title\" (ngModelChange)=\"titleChanged()\" name=\"title\"\n                            placeholder=\"'DRAW.drawLayerMetadata.layerTitle' | translateHs: {app: data.app} \" />\n                        <label for=\"title\" class=\"control-label\">{{'DRAW.drawLayerMetadata.layerTitle' |\n                            translateHs: {app: data.app} }}</label>\n\n                    </div>\n                    <hs-layman-access-rights *ngIf=\"appRef.isAuthorized\" [app]=\"data.app\"\n                        [(access_rights)]=\"access_rights\">\n                    </hs-layman-access-rights>\n                    <div class=\"flex-row w-75 align-items-center\" style=\"display: flex;\">\n                        <a class=\"p-1 mb-1\" (click)=\"folderVisible = !folderVisible\">{{'COMMON.advancedOptions' |\n                            translateHs: {app: data.app} }}</a>\n                    </div>\n                    <div [hidden]=\"!folderVisible\">\n                        <div class=\"form-floating mb-3\"\n                            [title]=\"'DRAW.drawLayerMetadata.nameOfFolder' | translateHs: {app: data.app} \">\n                            <input class=\"form-control\" [(ngModel)]=\"path\" (ngModelChange)=\"pathChanged()\" name=\"path\"\n                                [placeholder]=\"'COMMON.folder' | translateHs: {app: data.app} \" />\n                            <label for=\"path\" class=\"control-label\">{{'COMMON.folder' | translateHs: {app: data.app} \n                                }}</label>\n                        </div>\n                        <div class=\"card\">\n                            <h5 class=\"card-header\">{{'DRAW.drawLayerMetadata.defaultAttributes' | translateHs: {'app':\n                                data.app} }}</h5>\n                            <div class=\"card-body\">\n                                <table class=\"table table-condensed\">\n                                    <tr>\n                                        <th>{{'COMMON.attribute' | translateHs: {app: data.app} }}</th>\n                                        <th>{{'DRAW.drawLayerMetadata.defaultValue' | translateHs: {app: data.app} }}\n                                        </th>\n                                    </tr>\n                                    <tr *ngFor=\"let attr of attributes\">\n                                        <td><input class=\"form-control\" [(ngModel)]=\"attr.name\"\n                                                [ngModelOptions]=\"{standalone: true}\" /></td>\n                                        <td><input class=\"form-control\" [(ngModel)]=\"attr.value\"\n                                                [ngModelOptions]=\"{standalone: true}\" /></td>\n                                    </tr>\n                                </table>\n                                <button class=\"btn btn-primary\" (click)=\"addAttr()\"><i class=\"icon-plus\"></i></button>\n                            </div>\n                        </div>\n                    </div>\n                </form>\n                <form *ngIf=\"type === 'layman'\">\n                    <div class=\"d-flex align-items-center w-100 flex-column\"\n                        *ngIf=\"appRef.drawableLaymanLayers.length > 0\">\n                        <div class=\" bg-primary w-100 text-light m-0 p-1\">\n                            <div class=\"d-flex justify-content-between m-1\">\n                                {{'DRAW.serverLayers' | translateHs: {app: data.app} }}\n                                <span (click)=\"onlyMineFilterVisible = !onlyMineFilterVisible\" style=\"cursor: pointer;\">\n                                    <i class=\"icon-settingsthree-gears\"></i>\n                                </span>\n                            </div>\n\n                            <div class=\"input-group-text border-0 justify-content-center bg-white\"\n                                *ngIf=\"onlyMineFilterVisible\">\n                                <label class=\"m-0\">\n                                    <input type=\"checkbox\" name=\"onlyMine\" [(ngModel)]=\"appRef.onlyMine\"\n                                        (ngModelChange)=\"data.service.fillDrawableLayers(data.app); onlyMineFilterVisible = !onlyMineFilterVisible\">\n                                    {{'COMPOSITIONS.onlyMine' | translateHs: {app: data.app} }}\n                                </label>\n                            </div>\n                        </div>\n                        <ul class=\"list-group w-100\">\n                            <li *ngFor=\"let layer of appRef.drawableLaymanLayers\" class=\"clearfix\"\n                                [ngClass]=\"'list-group-item'+(layer.highlighted ? ' active' : '')\">\n                                <b><a data-toggle=\"tooltip\" title=\"{{layer.description}}\">{{layer.title}}</a></b>\n                                <span class=\"float-right\">\n                                    <button type=\"button\" class=\"btn btn-sm btn-primary\" (click)=\"selectLayer(layer)\"\n                                        data-toggle=\"tooltip\" [title]=\"'ADDLAYERS.WFS.addToMap' | translateHs: {app: data.app} \"><i\n                                            class=\"icon-plus\"></i></button>\n                                </span>\n                            </li>\n                        </ul>\n                    </div>\n                </form>\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" *ngIf=\"type === 'draw'\"\n                    (click)=\"confirm()\">{{'DRAW.drawToolbar.addLayer' | translateHs: {app: data.app} }}</button>\n                <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" (click)=\"cancel()\">{{'COMMON.cancel'\n                    | translateHs: {app: data.app} }}</button>\n            </div>\n        </div>\n    </div>\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsMapService }, { type: HsDialogContainerService }]; }, propDecorators: { data: [{
                type: Input
            }] } });

class HsDialogHostDirective {
    constructor(viewContainerRef) {
        this.viewContainerRef = viewContainerRef;
    }
}
HsDialogHostDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsDialogHostDirective, deps: [{ token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive });
HsDialogHostDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.11", type: HsDialogHostDirective, selector: "[dialog-host]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsDialogHostDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[dialog-host]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }]; } });

class HsDialogContainerComponent {
    constructor(HsDialogContainerService, componentFactoryResolver) {
        this.HsDialogContainerService = HsDialogContainerService;
        this.componentFactoryResolver = componentFactoryResolver;
        this.app = 'default';
        this.ngUnsubscribe = new Subject();
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    ngOnInit() {
        this.HsDialogContainerService.get(this.app)
            .dialogObserver.pipe(takeUntil$1(this.ngUnsubscribe))
            .subscribe((item) => {
            this.loadDialog(item);
        });
        this.HsDialogContainerService.get(this.app)
            .dialogDestroyObserver.pipe(takeUntil$1(this.ngUnsubscribe))
            .subscribe((item) => {
            this.destroyDialog(item);
        });
    }
    destroyDialog(dialog) {
        const viewContainerRef = this.dialogHost.viewContainerRef;
        const index = viewContainerRef.indexOf(dialog.viewRef);
        if (index > -1) {
            viewContainerRef.remove(index);
        }
    }
    loadDialog(dialogItem) {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(dialogItem.component);
        const viewContainerRef = this.dialogHost.viewContainerRef;
        //    viewContainerRef.clear();
        const componentRef = viewContainerRef.createComponent(componentFactory);
        componentRef.instance.viewRef = componentRef.hostView;
        componentRef.instance.data = dialogItem.data;
        componentRef.instance.dialogItem = dialogItem;
        this.HsDialogContainerService.get(this.app).dialogs.push(componentRef.instance);
    }
}
HsDialogContainerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsDialogContainerComponent, deps: [{ token: HsDialogContainerService }, { token: i0.ComponentFactoryResolver }], target: i0.ɵɵFactoryTarget.Component });
HsDialogContainerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsDialogContainerComponent, selector: "hs-dialog-container", inputs: { app: "app" }, viewQueries: [{ propertyName: "dialogHost", first: true, predicate: HsDialogHostDirective, descendants: true, static: true }], ngImport: i0, template: "<div>\n    <ng-template dialog-host></ng-template>\n</div>", directives: [{ type: HsDialogHostDirective, selector: "[dialog-host]" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsDialogContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-dialog-container', template: "<div>\n    <ng-template dialog-host></ng-template>\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsDialogContainerService }, { type: i0.ComponentFactoryResolver }]; }, propDecorators: { app: [{
                type: Input
            }], dialogHost: [{
                type: ViewChild,
                args: [HsDialogHostDirective, { static: true }]
            }] } });

class HsPanelHostDirective {
    constructor(viewContainerRef) {
        this.viewContainerRef = viewContainerRef;
    }
}
HsPanelHostDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsPanelHostDirective, deps: [{ token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive });
HsPanelHostDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.11", type: HsPanelHostDirective, selector: "[panel-host]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsPanelHostDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[panel-host]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }]; } });

class HsPanelContainerComponent {
    constructor(componentFactoryResolver, HsConfig) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.HsConfig = HsConfig;
        this.app = 'default';
        this.init = new EventEmitter();
        this.ngUnsubscribe = new Subject();
    }
    ngOnDestroy() {
        const appRef = this.service.get(this.app);
        if (appRef.panelObserver && this.reusePanelObserver !== true) {
            appRef.panelObserver.complete();
            appRef.panelObserver = new ReplaySubject();
        }
        for (const p of appRef.panels) {
            this.service.destroy(p, this.app);
        }
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    ngOnInit() {
        var _a;
        const appRef = this.service.get(this.app);
        appRef.panels = [];
        ((_a = this.panelObserver) !== null && _a !== void 0 ? _a : appRef.panelObserver)
            .pipe(takeUntil$1(this.ngUnsubscribe))
            .subscribe((item) => {
            this.loadPanel(item);
        });
        appRef.panelDestroyObserver
            .pipe(takeUntil$1(this.ngUnsubscribe))
            .subscribe((item) => {
            this.destroyPanel(item);
        });
        this.init.emit();
    }
    destroyPanel(panel) {
        const viewContainerRef = this.panelHost.viewContainerRef;
        const index = viewContainerRef.indexOf(panel.viewRef);
        if (index > -1) {
            viewContainerRef.remove(index);
        }
    }
    loadPanel(panelItem) {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(panelItem.component);
        const viewContainerRef = this.panelHost.viewContainerRef;
        const componentRef = viewContainerRef.createComponent(componentFactory);
        const componentRefInstance = componentRef.instance;
        componentRefInstance.viewRef = componentRef.hostView;
        if (this.HsConfig.get(this.app)) {
            /**
             * Assign panel width class to a component host first child
             * Used to define panelSpace panel width
             */
            this.service.setPanelWidth(this.HsConfig.get(this.app).panelWidths, componentRefInstance);
        }
        /* When component doesn't create its own data object
        set data by merging two sources: html attribute (this.data) and parameter passed
        to PanelContainerService.create function (panelItem.data). It can contain
        layerDescriptor for example */
        if (componentRefInstance.data == undefined) {
            Object.assign(panelItem.data, this.data);
            componentRefInstance.data = panelItem.data;
        }
        this.service.get(this.app).panels.push(componentRefInstance);
        if (componentRefInstance.isVisible$) {
            const visible = componentRefInstance.isVisible
                ? componentRefInstance.isVisible()
                : true;
            componentRefInstance.isVisible$.next(visible);
        }
        else {
            console.warn(componentRefInstance, 'should contain isVisible$ BehaviourSubject');
        }
    }
}
HsPanelContainerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsPanelContainerComponent, deps: [{ token: i0.ComponentFactoryResolver }, { token: HsConfig }], target: i0.ɵɵFactoryTarget.Component });
HsPanelContainerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsPanelContainerComponent, selector: "hs-panel-container", inputs: { service: "service", data: "data", app: "app", reusePanelObserver: "reusePanelObserver", panelObserver: "panelObserver" }, outputs: { init: "init" }, viewQueries: [{ propertyName: "panelHost", first: true, predicate: HsPanelHostDirective, descendants: true, static: true }], ngImport: i0, template: "<ng-template panel-host></ng-template>\n", directives: [{ type: HsPanelHostDirective, selector: "[panel-host]" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsPanelContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-panel-container', template: "<ng-template panel-host></ng-template>\n" }]
        }], ctorParameters: function () { return [{ type: i0.ComponentFactoryResolver }, { type: HsConfig }]; }, propDecorators: { panelHost: [{
                type: ViewChild,
                args: [HsPanelHostDirective, { static: true }]
            }], service: [{
                type: Input
            }], data: [{
                type: Input
            }], app: [{
                type: Input
            }], reusePanelObserver: [{
                type: Input
            }], panelObserver: [{
                type: Input
            }], init: [{
                type: Output
            }] } });

class HsPanelHelpersModule {
}
HsPanelHelpersModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsPanelHelpersModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HsPanelHelpersModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsPanelHelpersModule, declarations: [HsPanelHeaderComponent,
        HsPanelHostDirective,
        HsPanelContainerComponent,
        HsPanelBaseComponent], exports: [HsPanelHeaderComponent,
        HsPanelContainerComponent,
        HsPanelBaseComponent] });
HsPanelHelpersModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsPanelHelpersModule, imports: [[]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsPanelHelpersModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        HsPanelHeaderComponent,
                        HsPanelHostDirective,
                        HsPanelContainerComponent,
                        HsPanelBaseComponent,
                    ],
                    imports: [],
                    exports: [
                        HsPanelHeaderComponent,
                        HsPanelContainerComponent,
                        HsPanelBaseComponent,
                    ],
                }]
        }] });

class HsToastComponent {
    constructor(PmToastService) {
        this.PmToastService = PmToastService;
        this.app = 'default';
    }
    ngOnInit() {
        this.appRef = this.PmToastService.get(this.app);
    }
}
HsToastComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsToastComponent, deps: [{ token: HsToastService }], target: i0.ɵɵFactoryTarget.Component });
HsToastComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsToastComponent, selector: "hs-toast", inputs: { app: "app" }, ngImport: i0, template: "<ngb-toast *ngFor=\"let toast of appRef.toasts\" [header]=\"toast.header\" [class]=\"toast.classname\"\n  style=\"overflow: hidden;\"\n  [ngStyle]=\"{'max-height': toast.details.length > 0 ? 'toast.details.length + 8' + 'rem' : '8rem'}\"\n  [autohide]=\"toast.autohide\" [delay]=\"toast.delay || 5000\" (shown)=\"PmToastService.shown(app)\"\n  (hidden)=\"PmToastService.remove(toast,app)\">{{toast.textOrTpl}}\n  <ng-container *ngIf=\"toast.details?.length > 0\">\n    <ul *ngFor=\"let detail of toast.details\" class=\"mt-2\">\n      <li>{{detail}}</li>\n    </ul>\n  </ng-container>\n</ngb-toast>", styles: [":host{position:absolute;bottom:.1rem;z-index:150;border-style:none;display:flex;max-height:90%;flex-direction:column;max-width:400px}\n"], components: [{ type: i7.NgbToast, selector: "ngb-toast", inputs: ["animation", "delay", "autohide", "header"], outputs: ["shown", "hidden"], exportAs: ["ngbToast"] }], directives: [{ type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsToastComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-toast', styles: [
                        `
      :host {
        position: absolute;
        bottom: 0.1rem;
        z-index: 150;
        border-style: none;
        display: flex;
        max-height: 90%;
        flex-direction: column;
        max-width: 400px;
      }
    `,
                    ], template: "<ngb-toast *ngFor=\"let toast of appRef.toasts\" [header]=\"toast.header\" [class]=\"toast.classname\"\n  style=\"overflow: hidden;\"\n  [ngStyle]=\"{'max-height': toast.details.length > 0 ? 'toast.details.length + 8' + 'rem' : '8rem'}\"\n  [autohide]=\"toast.autohide\" [delay]=\"toast.delay || 5000\" (shown)=\"PmToastService.shown(app)\"\n  (hidden)=\"PmToastService.remove(toast,app)\">{{toast.textOrTpl}}\n  <ng-container *ngIf=\"toast.details?.length > 0\">\n    <ul *ngFor=\"let detail of toast.details\" class=\"mt-2\">\n      <li>{{detail}}</li>\n    </ul>\n  </ng-container>\n</ngb-toast>" }]
        }], ctorParameters: function () { return [{ type: HsToastService }]; }, propDecorators: { app: [{
                type: Input
            }] } });

class HsToastModule {
}
HsToastModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsToastModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HsToastModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsToastModule, declarations: [HsToastComponent], imports: [CommonModule, NgbToastModule], exports: [HsToastComponent] });
HsToastModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsToastModule, imports: [[CommonModule, NgbToastModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsToastModule, decorators: [{
            type: NgModule,
            args: [{
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                    declarations: [HsToastComponent],
                    imports: [CommonModule, NgbToastModule],
                    exports: [HsToastComponent],
                }]
        }] });

class HsMapHostDirective {
    constructor(viewContainerRef) {
        this.viewContainerRef = viewContainerRef;
    }
}
HsMapHostDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsMapHostDirective, deps: [{ token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive });
HsMapHostDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.11", type: HsMapHostDirective, selector: "[map-host]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsMapHostDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[map-host]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }]; } });

class HsMapComponent {
    constructor(HsMapService, HsPermalinkUrlService, HsCoreService, HsConfig, HsEventBusService, zone) {
        this.HsMapService = HsMapService;
        this.HsPermalinkUrlService = HsPermalinkUrlService;
        this.HsCoreService = HsCoreService;
        this.HsConfig = HsConfig;
        this.HsEventBusService = HsEventBusService;
        this.zone = zone;
        this.app = 'default';
        this.unregisterMapSyncCenterHandlerSubscription =
            this.HsEventBusService.mapCenterSynchronizations.subscribe((data) => {
                this.onCenterSync(data);
            });
    }
    ngAfterViewInit() {
        const visibleLayersParam = this.HsPermalinkUrlService.getParamValue(HS_PRMS.visibleLayers);
        if (visibleLayersParam) {
            this.HsMapService.visibleLayersInUrl = visibleLayersParam.split(';');
        }
        this.zone.runOutsideAngular(() => this.HsMapService.init(this.map.nativeElement, this.app));
        const pos = this.HsPermalinkUrlService.getParamValues([
            HS_PRMS.x,
            HS_PRMS.y,
            HS_PRMS.zoom,
        ]);
        if (!Object.keys(pos).some((k) => pos[k] == undefined || pos[k] == 'NaN')) {
            this.HsMapService.moveToAndZoom(parseFloat(pos[HS_PRMS.x]), parseFloat(pos[HS_PRMS.y]), parseInt(pos[HS_PRMS.zoom]), this.app);
        }
        if (this.HsPermalinkUrlService.getParamValue(HS_PRMS.pureMap) ||
            this.HsConfig.get(this.app).pureMap == true) {
            this.HsCoreService.setPuremapApp(true, this.app);
        }
        this.HsMapService.getMap(this.app).updateSize();
    }
    ngOnDestroy() {
        this.unregisterMapSyncCenterHandlerSubscription.unsubscribe();
    }
    /**
     * @param data Coordinates in lon/lat and resolution
     * This gets called from Cesium map, to
     * synchronize center and resolution between Ol and Cesium maps
     */
    onCenterSync(data) {
        if (this.app == data.app) {
            const center = data.center;
            if (!center) {
                return;
            }
            const toProj = this.HsMapService.getCurrentProj(data.app);
            const transformed = transform([center[0], center[1]], 'EPSG:4326', toProj);
            this.HsMapService.moveToAndZoom(transformed[0], transformed[1], this.zoomForResolution(center[2]), this.app);
        }
    }
    /**
     * @param resolution Resolution
     * Calculates zoom level for a given resolution
     * @returns Zoom level for resolution. If resolution
     * was greater than 156543.03390625 return 0
     */
    zoomForResolution(resolution) {
        let zoom = 0;
        //Sometimes resolution is under 0. Ratis
        resolution = Math.abs(resolution);
        let r = 156543.03390625; // resolution for zoom 0
        while (resolution < r) {
            r /= 2.0;
            zoom++;
            if (resolution > r) {
                return zoom;
            }
        }
        return zoom; // resolution was greater than 156543.03390625 so return 0
    }
}
HsMapComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsMapComponent, deps: [{ token: HsMapService }, { token: HsShareUrlService }, { token: HsCoreService }, { token: HsConfig }, { token: HsEventBusService }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
HsMapComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsMapComponent, selector: "hs-map", inputs: { app: "app" }, viewQueries: [{ propertyName: "map", first: true, predicate: ["map"], descendants: true }], ngImport: i0, template: "<div #map class=\"hs-ol-map hs-flex-fill d-flex\"></div>\n" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsMapComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-map', template: "<div #map class=\"hs-ol-map hs-flex-fill d-flex\"></div>\n" }]
        }], ctorParameters: function () { return [{ type: HsMapService }, { type: HsShareUrlService }, { type: HsCoreService }, { type: HsConfig }, { type: HsEventBusService }, { type: i0.NgZone }]; }, propDecorators: { map: [{
                type: ViewChild,
                args: ['map']
            }], app: [{
                type: Input
            }] } });

var name = "hslayers-ng";
var version = "9.3.0";
var description = "HSLayers-NG mapping library";
var author = "Plan4All";
var keywords = [
    "hslayers",
    "hslayers-ng",
    "openlayers",
    "ol",
    "map",
    "mapping",
    "angular"
];
var homepage = "https://ng.hslayers.org/";
var bugs = {
    url: "https://github.com/hslayers/hslayers-ng/issues"
};
var repository = {
    type: "git",
    directory: "https://github.com/hslayers/hslayers-ng"
};
var license = "MIT";
var packageJson = {
    name: name,
    version: version,
    description: description,
    author: author,
    keywords: keywords,
    homepage: homepage,
    bugs: bugs,
    repository: repository,
    license: license
};

class HsImpressumComponent {
    constructor(hsConfig) {
        this.hsConfig = hsConfig;
        this.app = 'default';
        this.version = 'dev';
        this.logo = '';
        this.logoDisabled = false;
        this.version = packageJson.version;
    }
    ngOnInit() {
        this.logoPath =
            this.hsConfig.get(this.app).assetsPath + 'img/hslayers-ng-logo.png';
    }
}
HsImpressumComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsImpressumComponent, deps: [{ token: HsConfig }], target: i0.ɵɵFactoryTarget.Component });
HsImpressumComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsImpressumComponent, selector: "hs-impressum", inputs: { app: "app" }, ngImport: i0, template: "<div class=\"hs-impressum px-3 pb-2 pt-1\">\n  <div>\n    <span class=\"text-dark\">Powered by</span>\n    <div class=\"hs-logo\">\n      <a href=\"https://ng.hslayers.org/\" target=\"_blank\">\n        <img [src]=\"logoPath\" alt=\"HSLayers-NG\"\n          [hidden]=\"logoDisabled\">\n      </a>\n    </div>\n    <div class=\"text-end\">\n      <span class=\"text-dark\">version <a href=\"https://github.com/hslayers/hslayers-ng/releases/tag/{{version}}\"\n          target=\"_blank\">{{version}}</a></span>\n    </div>\n  </div>\n</div>\n" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsImpressumComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-impressum', template: "<div class=\"hs-impressum px-3 pb-2 pt-1\">\n  <div>\n    <span class=\"text-dark\">Powered by</span>\n    <div class=\"hs-logo\">\n      <a href=\"https://ng.hslayers.org/\" target=\"_blank\">\n        <img [src]=\"logoPath\" alt=\"HSLayers-NG\"\n          [hidden]=\"logoDisabled\">\n      </a>\n    </div>\n    <div class=\"text-end\">\n      <span class=\"text-dark\">version <a href=\"https://github.com/hslayers/hslayers-ng/releases/tag/{{version}}\"\n          target=\"_blank\">{{version}}</a></span>\n    </div>\n  </div>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: HsConfig }]; }, propDecorators: { app: [{
                type: Input
            }] } });

class HsSidebarComponent {
    constructor(HsLayoutService, HsCoreService, HsSidebarService, HsPermalinkUrlService, HsConfig, HsEventBusService) {
        this.HsLayoutService = HsLayoutService;
        this.HsCoreService = HsCoreService;
        this.HsSidebarService = HsSidebarService;
        this.HsPermalinkUrlService = HsPermalinkUrlService;
        this.HsConfig = HsConfig;
        this.HsEventBusService = HsEventBusService;
        this.app = 'default';
        this.buttons = [];
        this.end = new Subject();
    }
    ngOnDestroy() {
        this.end.next();
    }
    ngOnInit() {
        const panel = this.HsPermalinkUrlService.getParamValue(HS_PRMS.panel);
        this.serviceAppRef = this.HsSidebarService.get(this.app);
        this.layoutAppRef = this.HsLayoutService.get(this.app);
        this.serviceAppRef.buttons
            .pipe(startWith([]), delay(0))
            .pipe(takeUntil(this.end))
            .subscribe((buttons) => {
            this.buttons = this.HsSidebarService.prepareForTemplate(buttons);
            this.HsSidebarService.setPanelState(this.buttons, this.app);
            this.HsSidebarService.setButtonVisibility(this.buttons, this.app);
        });
        this.miniSidebarButton = {
            title: 'SIDEBAR.additionalPanels',
        };
        if (panel) {
            setTimeout(() => {
                //Without timeout we get ExpressionChangedAfterItHasBeenCheckedError
                if (!this.HsLayoutService.get(this.app).minisidebar) {
                    this.HsLayoutService.setMainPanel(panel, this.app);
                }
            });
        }
        this.HsEventBusService.layoutResizes
            .pipe(takeUntil(this.end))
            .subscribe(() => {
            this.HsSidebarService.setButtonVisibility(this.buttons, this.app);
        });
        this.HsConfig.configChanges
            .pipe(takeUntil(this.end))
            .subscribe(({ app, config }) => {
            if (app == this.app) {
                this.HsSidebarService.setPanelState(this.buttons, this.app);
            }
        });
        this.HsSidebarService.sidebarLoad.next(this.app);
    }
    /**
     * Seat whether to show all sidebar buttons or just a
     * subset of important ones
     */
    toggleUnimportant() {
        this.serviceAppRef.showUnimportant = !this.serviceAppRef.showUnimportant;
    }
    /**
     * Toggle sidebar mode between expanded and narrow
     */
    toggleSidebar() {
        const layoutAppRef = this.HsLayoutService.get(this.app);
        layoutAppRef.sidebarExpanded = !layoutAppRef.sidebarExpanded;
        this.HsLayoutService.updPanelSpaceWidth(this.app);
        setTimeout(() => {
            this.HsCoreService.updateMapSize(this.app);
        }, 110);
    }
}
HsSidebarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSidebarComponent, deps: [{ token: HsLayoutService }, { token: HsCoreService }, { token: HsSidebarService }, { token: HsShareUrlService }, { token: HsConfig }, { token: HsEventBusService }], target: i0.ɵɵFactoryTarget.Component });
HsSidebarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsSidebarComponent, selector: "hs-sidebar", inputs: { app: "app" }, ngImport: i0, template: "<div class=\"hs-sidebar-list hs-main-panel list-group\">\n    <hs-panel-header class=\"sidebar-header w-100\" *ngIf=\"layoutAppRef.minisidebar\" name=\"additional\"\n        [title]=\"'SIDEBAR.additionalPanels' | translateHs: {app} \" [app]=\"app\"></hs-panel-header>\n\n    <span class=\"hs-sidebar-item list-group-item border-top-0\" *ngIf=\"layoutAppRef.sidebarToggleable\"\n        (click)=\"toggleSidebar()\">\n        <i class=\"menu-icon\"\n            [ngClass]=\"layoutAppRef.sidebarExpanded ? (layoutAppRef.sidebarPosition === 'left' ? 'icon-chevron-left' : 'icon-chevron-right') : (layoutAppRef.sidebarPosition === 'left' ? 'icon-chevron-right' : 'icon-chevron-left')\"></i>\n    </span><!-- TODO: Remove function call from template -->\n\n    <span *ngFor=\"let button of buttons\" class=\"hs-sidebar-item list-group-item\"\n        [hidden]=\"!button.visible\" (click)=\"HsSidebarService.buttonClicked(button, app)\"\n        [ngClass]=\"{'active': layoutAppRef.mainpanel === button.panel,  'hs-panel-hidden' : !button.fits}\"\n        title=\"{{button.description | translateHs: {app} }}\"><!-- TODO: Remove function call from template -->\n        <i *ngIf=\"button.icon\" class=\"menu-icon {{button.icon}}\" data-toggle=\"tooltip\" data-container=\"body\"\n            data-placement=\"auto\"></i>\n        <span *ngIf=\"button.content\" data-toggle=\"tooltip\" data-container=\"body\" data-placement=\"auto\" class=\"\"\n            title=\"{{button.description | translateHs: {app} }}\">{{button.content()}}</span>\n        <span [ngStyle]=\"{'margin-left' : button.panel === 'language' ? '14px' : '20px'}\" [attr.data-cy]=\"button.panel\"\n            class=\"hs-sidebar-item-title\">{{button.title | translateHs: {app} }}</span>\n    </span>\n<!-- TODO: Remove function call from template -->\n    <span class=\"hs-sidebar-item  list-group-item\" *ngIf=\"layoutAppRef.minisidebar\"\n        (click)=\"HsLayoutService.setMainPanel('sidebar', app, true)\"\n        [ngClass]=\"{'active': layoutAppRef.mainpanel === 'sidebar'}\">\n        <i class=\"menu-icon icon-equals\" data-toggle=\"tooltip\" data-container=\"body\" data-placement=\"auto\" title=\"Menu\"\n            style=\"margin-left: 0px !important;\"></i>\n        <span class=\"hs-sidebar-item-title\">{{miniSidebarButton.title | translateHs: {app} }}</span>\n    </span>\n    <hs-impressum class=\"mt-auto\" [app]=\"app\"></hs-impressum>\n</div>", components: [{ type: HsPanelHeaderComponent, selector: "hs-panel-header", inputs: ["name", "app", "title"] }, { type: HsImpressumComponent, selector: "hs-impressum", inputs: ["app"] }], directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSidebarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-sidebar', template: "<div class=\"hs-sidebar-list hs-main-panel list-group\">\n    <hs-panel-header class=\"sidebar-header w-100\" *ngIf=\"layoutAppRef.minisidebar\" name=\"additional\"\n        [title]=\"'SIDEBAR.additionalPanels' | translateHs: {app} \" [app]=\"app\"></hs-panel-header>\n\n    <span class=\"hs-sidebar-item list-group-item border-top-0\" *ngIf=\"layoutAppRef.sidebarToggleable\"\n        (click)=\"toggleSidebar()\">\n        <i class=\"menu-icon\"\n            [ngClass]=\"layoutAppRef.sidebarExpanded ? (layoutAppRef.sidebarPosition === 'left' ? 'icon-chevron-left' : 'icon-chevron-right') : (layoutAppRef.sidebarPosition === 'left' ? 'icon-chevron-right' : 'icon-chevron-left')\"></i>\n    </span><!-- TODO: Remove function call from template -->\n\n    <span *ngFor=\"let button of buttons\" class=\"hs-sidebar-item list-group-item\"\n        [hidden]=\"!button.visible\" (click)=\"HsSidebarService.buttonClicked(button, app)\"\n        [ngClass]=\"{'active': layoutAppRef.mainpanel === button.panel,  'hs-panel-hidden' : !button.fits}\"\n        title=\"{{button.description | translateHs: {app} }}\"><!-- TODO: Remove function call from template -->\n        <i *ngIf=\"button.icon\" class=\"menu-icon {{button.icon}}\" data-toggle=\"tooltip\" data-container=\"body\"\n            data-placement=\"auto\"></i>\n        <span *ngIf=\"button.content\" data-toggle=\"tooltip\" data-container=\"body\" data-placement=\"auto\" class=\"\"\n            title=\"{{button.description | translateHs: {app} }}\">{{button.content()}}</span>\n        <span [ngStyle]=\"{'margin-left' : button.panel === 'language' ? '14px' : '20px'}\" [attr.data-cy]=\"button.panel\"\n            class=\"hs-sidebar-item-title\">{{button.title | translateHs: {app} }}</span>\n    </span>\n<!-- TODO: Remove function call from template -->\n    <span class=\"hs-sidebar-item  list-group-item\" *ngIf=\"layoutAppRef.minisidebar\"\n        (click)=\"HsLayoutService.setMainPanel('sidebar', app, true)\"\n        [ngClass]=\"{'active': layoutAppRef.mainpanel === 'sidebar'}\">\n        <i class=\"menu-icon icon-equals\" data-toggle=\"tooltip\" data-container=\"body\" data-placement=\"auto\" title=\"Menu\"\n            style=\"margin-left: 0px !important;\"></i>\n        <span class=\"hs-sidebar-item-title\">{{miniSidebarButton.title | translateHs: {app} }}</span>\n    </span>\n    <hs-impressum class=\"mt-auto\" [app]=\"app\"></hs-impressum>\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsLayoutService }, { type: HsCoreService }, { type: HsSidebarService }, { type: HsShareUrlService }, { type: HsConfig }, { type: HsEventBusService }]; }, propDecorators: { app: [{
                type: Input
            }] } });

class HsMiniSidebarComponent {
    constructor(HsCoreService, HsSidebarService, HsLayoutService, HsConfig) {
        this.HsCoreService = HsCoreService;
        this.HsSidebarService = HsSidebarService;
        this.HsLayoutService = HsLayoutService;
        this.HsConfig = HsConfig;
        this.app = 'default';
        this.buttons = [];
        this.ngUnsubscribe = new Subject();
    }
    ngOnInit() {
        this.layoutAppRef = this.HsLayoutService.get(this.app);
        this.HsSidebarService.apps[this.app].buttons
            .pipe(takeUntil(this.ngUnsubscribe))
            .pipe(startWith([]), delay(0))
            .subscribe((buttons) => {
            this.buttons = this.HsSidebarService.prepareForTemplate(buttons);
        });
        this.miniSidebarButton = {
            title: 'SIDEBAR.additionalPanels',
        };
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    /**
     * Seat weather to show all sidebar buttons or just a
     * subset of important ones
     */
    toggleUnimportant() {
        this.HsSidebarService.get(this.app).showUnimportant =
            !this.HsSidebarService.get(this.app).showUnimportant;
    }
    /**
     * Toggle sidebar mode between expanded and narrow
     */
    toggleSidebar() {
        this.HsLayoutService.get(this.app).sidebarExpanded =
            !this.HsLayoutService.get(this.app).sidebarExpanded;
        setTimeout(() => {
            this.HsCoreService.updateMapSize(this.app);
        }, 110);
    }
}
HsMiniSidebarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsMiniSidebarComponent, deps: [{ token: HsCoreService }, { token: HsSidebarService }, { token: HsLayoutService }, { token: HsConfig }], target: i0.ɵɵFactoryTarget.Component });
HsMiniSidebarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsMiniSidebarComponent, selector: "hs-mini-sidebar", inputs: { app: "app" }, ngImport: i0, template: "<div class=\"hs-sidebar-list hs-main-panel list-group\">\n    <hs-panel-header class=\"sidebar-header w-100\" *ngIf=\"layoutAppRef.minisidebar\" name=\"additional\"\n        [title]=\"'SIDEBAR.additionalPanels' | translateHs: {app} \" [app]=\"app\"></hs-panel-header>\n\n    <span class=\"hs-sidebar-item list-group-item border-top-0\" *ngIf=\"layoutAppRef.sidebarToggleable\"\n        (click)=\"toggleSidebar()\">\n        <i class=\"menu-icon\"\n            [ngClass]=\"layoutAppRef.sidebarExpanded ? (layoutAppRef.sidebarPosition === 'left' ? 'icon-chevron-left' : 'icon-chevron-right') : (layoutAppRef.sidebarPosition === 'left' ? 'icon-chevron-right' : 'icon-chevron-left')\"></i>\n    </span><!-- TODO: Remove function call from template -->\n\n    <span *ngFor=\"let button of buttons\" class=\"hs-sidebar-item list-group-item\"\n        [hidden]=\"!button.visible\" (click)=\"HsSidebarService.buttonClicked(button, app)\"\n        [ngClass]=\"{'active': layoutAppRef.mainpanel === button.panel,  'hs-panel-hidden' : !button.fits}\"\n        title=\"{{button.description | translateHs: {app} }}\"><!-- TODO: Remove function call from template -->\n        <i *ngIf=\"button.icon\" class=\"menu-icon {{button.icon}}\" data-toggle=\"tooltip\" data-container=\"body\"\n            data-placement=\"auto\"></i>\n        <span *ngIf=\"button.content\" data-toggle=\"tooltip\" data-container=\"body\" data-placement=\"auto\" class=\"\"\n            title=\"{{button.description | translateHs: {app} }}\">{{button.content()}}</span>\n        <span [ngStyle]=\"{'margin-left' : button.panel === 'language' ? '14px' : '20px'}\" [attr.data-cy]=\"button.panel\"\n            class=\"hs-sidebar-item-title\">{{button.title | translateHs: {app} }}</span>\n    </span>\n<!-- TODO: Remove function call from template -->\n    <span class=\"hs-sidebar-item  list-group-item\" *ngIf=\"layoutAppRef.minisidebar\"\n        (click)=\"HsLayoutService.setMainPanel('sidebar', app, true)\"\n        [ngClass]=\"{'active': layoutAppRef.mainpanel === 'sidebar'}\">\n        <i class=\"menu-icon icon-equals\" data-toggle=\"tooltip\" data-container=\"body\" data-placement=\"auto\" title=\"Menu\"\n            style=\"margin-left: 0px !important;\"></i>\n        <span class=\"hs-sidebar-item-title\">{{miniSidebarButton.title | translateHs: {app} }}</span>\n    </span>\n    <hs-impressum class=\"mt-auto\" [app]=\"app\"></hs-impressum>\n</div>", components: [{ type: HsPanelHeaderComponent, selector: "hs-panel-header", inputs: ["name", "app", "title"] }, { type: HsImpressumComponent, selector: "hs-impressum", inputs: ["app"] }], directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsMiniSidebarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-mini-sidebar', template: "<div class=\"hs-sidebar-list hs-main-panel list-group\">\n    <hs-panel-header class=\"sidebar-header w-100\" *ngIf=\"layoutAppRef.minisidebar\" name=\"additional\"\n        [title]=\"'SIDEBAR.additionalPanels' | translateHs: {app} \" [app]=\"app\"></hs-panel-header>\n\n    <span class=\"hs-sidebar-item list-group-item border-top-0\" *ngIf=\"layoutAppRef.sidebarToggleable\"\n        (click)=\"toggleSidebar()\">\n        <i class=\"menu-icon\"\n            [ngClass]=\"layoutAppRef.sidebarExpanded ? (layoutAppRef.sidebarPosition === 'left' ? 'icon-chevron-left' : 'icon-chevron-right') : (layoutAppRef.sidebarPosition === 'left' ? 'icon-chevron-right' : 'icon-chevron-left')\"></i>\n    </span><!-- TODO: Remove function call from template -->\n\n    <span *ngFor=\"let button of buttons\" class=\"hs-sidebar-item list-group-item\"\n        [hidden]=\"!button.visible\" (click)=\"HsSidebarService.buttonClicked(button, app)\"\n        [ngClass]=\"{'active': layoutAppRef.mainpanel === button.panel,  'hs-panel-hidden' : !button.fits}\"\n        title=\"{{button.description | translateHs: {app} }}\"><!-- TODO: Remove function call from template -->\n        <i *ngIf=\"button.icon\" class=\"menu-icon {{button.icon}}\" data-toggle=\"tooltip\" data-container=\"body\"\n            data-placement=\"auto\"></i>\n        <span *ngIf=\"button.content\" data-toggle=\"tooltip\" data-container=\"body\" data-placement=\"auto\" class=\"\"\n            title=\"{{button.description | translateHs: {app} }}\">{{button.content()}}</span>\n        <span [ngStyle]=\"{'margin-left' : button.panel === 'language' ? '14px' : '20px'}\" [attr.data-cy]=\"button.panel\"\n            class=\"hs-sidebar-item-title\">{{button.title | translateHs: {app} }}</span>\n    </span>\n<!-- TODO: Remove function call from template -->\n    <span class=\"hs-sidebar-item  list-group-item\" *ngIf=\"layoutAppRef.minisidebar\"\n        (click)=\"HsLayoutService.setMainPanel('sidebar', app, true)\"\n        [ngClass]=\"{'active': layoutAppRef.mainpanel === 'sidebar'}\">\n        <i class=\"menu-icon icon-equals\" data-toggle=\"tooltip\" data-container=\"body\" data-placement=\"auto\" title=\"Menu\"\n            style=\"margin-left: 0px !important;\"></i>\n        <span class=\"hs-sidebar-item-title\">{{miniSidebarButton.title | translateHs: {app} }}</span>\n    </span>\n    <hs-impressum class=\"mt-auto\" [app]=\"app\"></hs-impressum>\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsCoreService }, { type: HsSidebarService }, { type: HsLayoutService }, { type: HsConfig }]; }, propDecorators: { app: [{
                type: Input
            }] } });

class HsLayoutComponent {
    constructor(HsConfig, HsLayoutService, HsEventBusService, elementRef, HsUtilsService, HsPanelContainerService, HsOverlayPanelContainerService) {
        this.HsConfig = HsConfig;
        this.HsLayoutService = HsLayoutService;
        this.HsEventBusService = HsEventBusService;
        this.elementRef = elementRef;
        this.HsUtilsService = HsUtilsService;
        this.HsPanelContainerService = HsPanelContainerService;
        this.HsOverlayPanelContainerService = HsOverlayPanelContainerService;
        this.app = 'default';
    }
    panelVisible(which, app, scope) {
        return this.HsLayoutService.panelVisible(which, app, scope);
    }
    panelEnabled(which, status) {
        return this.HsLayoutService.panelEnabled(which, status);
    }
    ngOnInit() {
        this.HsLayoutService.get(this.app).layoutElement =
            this.elementRef.nativeElement;
        this.HsLayoutService.get(this.app).contentWrapper =
            this.elementRef.nativeElement.querySelector('.hs-content-wrapper');
        this.HsLayoutService.init(this.app);
        if (window.innerWidth < 600 && this.HsUtilsService.runningInBrowser()) {
            const viewport = document.querySelector('meta[name="viewport"]');
            viewport.setAttribute('content', 'width=device-width, initial-scale=0.6, maximum-scale=2, user-scalable=no');
        }
        this.HsEventBusService.layoutLoads.next({
            element: this.elementRef.nativeElement,
            innerElement: '.hs-map-space',
            app: this.app,
        });
        this.HsLayoutService.mapSpaceRef.next({
            viewContainerRef: this.mapHost.viewContainerRef,
            app: this.app,
        });
        this.HsLayoutService.panelSpaceWidth.subscribe(({ app, width }) => {
            if (this.app == app) {
                this.panelSpaceWidth = width;
            }
        });
        this.HsLayoutService.sidebarPosition.subscribe(({ app, position }) => {
            if (this.app == app) {
                this.sidebarPosition = position;
                if (position === 'left') {
                    this.HsLayoutService.get(this.app).contentWrapper.classList.add('flex-reverse');
                    this.HsLayoutService.get(this.app).sidebarRight = false;
                }
            }
        });
        this.HsLayoutService.sidebarVisible.subscribe(({ app, visible }) => {
            if (this.app == app) {
                this.sidebarVisible = visible;
            }
        });
        window.addEventListener('resize', this.HsUtilsService.debounce(() => {
            this.HsLayoutService.updPanelSpaceWidth(this.app);
            this.HsLayoutService.updSidebarPosition(this.app);
        }, 50, false, this));
    }
    ngAfterViewInit() {
        this.HsLayoutService.get(this.app).layoutElement =
            this.hslayout.nativeElement;
        const hsapp = this.elementRef.nativeElement.parentElement;
        if (window.innerWidth < 767) {
            document.body.style.margin = '0px';
        }
        if (getComputedStyle(hsapp).display == 'inline') {
            hsapp.style.display = 'block';
            console.warn('Main element (<hslayers>) needs display property to be defined...fallback value added');
        }
        //Minimal value expected for clientHeight of hsapp element at the initiation in case of WINDOWED mode
        //In comparison with clientHeight used to distinguish between full and windowed mode.
        const minHeight = window.devicePixelRatio <= 1 ? 350 : 300 * window.devicePixelRatio;
        //In case the app height is not set on hslayers element, height is determined by
        //the main panel height which vary from 0 if no mainpanel is set to 90 or even 208 in some cases .
        //Value of 300 or less /would mean that height is not set we need do something
        if (hsapp.clientHeight < minHeight &&
            getComputedStyle(hsapp).height === '0px' //Prevents changes to defined height settings
        ) {
            const heightBefore = hsapp.clientHeight;
            hsapp.style.height = '100%';
            //If its still the same, height is not even set on parents of hslayers element - we want fullscreen app
            if (hsapp.clientHeight == heightBefore) {
                hsapp.style.height = 'calc(var(--vh, 1vh) * 100)';
            }
            console.warn('Main element (<hslayers>) needs height property to be defined...fallback value added');
        }
    }
}
HsLayoutComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayoutComponent, deps: [{ token: HsConfig }, { token: HsLayoutService }, { token: HsEventBusService }, { token: i0.ElementRef }, { token: HsUtilsService }, { token: HsPanelContainerService }, { token: HsOverlayPanelContainerService }], target: i0.ɵɵFactoryTarget.Component });
HsLayoutComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsLayoutComponent, selector: "hs-layout", inputs: { app: "app" }, viewQueries: [{ propertyName: "hslayout", first: true, predicate: ["hslayout"], descendants: true }, { propertyName: "mapHost", first: true, predicate: HsMapHostDirective, descendants: true, static: true }], ngImport: i0, template: "<div #hslayout class=\"hs-page-wrapper hsl\" style=\"width: 100%; height: 100%;\">\n    <div class=\"hs-content-wrapper d-flex w-100 h-100\"\n        [ngClass]=\"{'hs-open': HsLayoutService.apps[app].sidebarExpanded && sidebarVisible, 'hs-sb-right': sidebarPosition === 'right' && sidebarVisible, 'hs-sb-left': sidebarPosition === 'left' && sidebarVisible,'hs-sb-bottom': sidebarPosition === 'bottom'}\">\n        <!-- ng-if=\"HsLayoutService.componentEnabled('guiOverlay')\" -->\n        <div class=\"hs-map-space d-flex\">\n            <hs-map class=\"hs-flex-fill d-flex\" [app]=\"app\"></hs-map>\n            <ng-template map-host></ng-template>\n            <hs-panel-container [service]=\"HsOverlayPanelContainerService\" [app]=\"app\"></hs-panel-container>\n        </div>\n        <div class=\"hs-panelspace\" [hidden]=\"!sidebarVisible\"\n            [ngClass]=\"{'labels': HsLayoutService.apps[app].sidebarLabels, 'buttons': HsLayoutService.apps[app].sidebarButtons}\">\n            <div class=\"hs-panelspace-wrapper me-1\">\n                <hs-sidebar class=\"border-0\" [app]=\"app\"></hs-sidebar>\n                <div class=\"hs-panelplace\">\n                    <hs-mini-sidebar *ngIf=\"HsLayoutService.apps[app].minisidebar\" [app]=\"app\"\n                        [hidden]=\"!panelVisible('sidebar',app, this)\"><!-- TODO: Remove function call from template -->\n                    </hs-mini-sidebar>\n                    <hs-panel-container [service]=\"HsPanelContainerService\" class=\"hs-panelplace\" [app]=\"app\">\n                    </hs-panel-container>\n                </div>\n            </div>\n        </div>\n        <hs-toast aria-live=\"polite\" aria-atomic=\"true\"\n            [ngClass]=\"sidebarPosition === 'left' ? 'hs-sb-right' : 'hs-sb-left'\" [app]=\"app\">\n        </hs-toast>\n        <div class=\"hs-dialog-area\"></div>\n    </div>\n    <hs-dialog-container [app]=\"app\"></hs-dialog-container>\n</div>", components: [{ type: HsMapComponent, selector: "hs-map", inputs: ["app"] }, { type: HsPanelContainerComponent, selector: "hs-panel-container", inputs: ["service", "data", "app", "reusePanelObserver", "panelObserver"], outputs: ["init"] }, { type: HsSidebarComponent, selector: "hs-sidebar", inputs: ["app"] }, { type: HsMiniSidebarComponent, selector: "hs-mini-sidebar", inputs: ["app"] }, { type: HsToastComponent, selector: "hs-toast", inputs: ["app"] }, { type: HsDialogContainerComponent, selector: "hs-dialog-container", inputs: ["app"] }], directives: [{ type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: HsMapHostDirective, selector: "[map-host]" }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayoutComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-layout', template: "<div #hslayout class=\"hs-page-wrapper hsl\" style=\"width: 100%; height: 100%;\">\n    <div class=\"hs-content-wrapper d-flex w-100 h-100\"\n        [ngClass]=\"{'hs-open': HsLayoutService.apps[app].sidebarExpanded && sidebarVisible, 'hs-sb-right': sidebarPosition === 'right' && sidebarVisible, 'hs-sb-left': sidebarPosition === 'left' && sidebarVisible,'hs-sb-bottom': sidebarPosition === 'bottom'}\">\n        <!-- ng-if=\"HsLayoutService.componentEnabled('guiOverlay')\" -->\n        <div class=\"hs-map-space d-flex\">\n            <hs-map class=\"hs-flex-fill d-flex\" [app]=\"app\"></hs-map>\n            <ng-template map-host></ng-template>\n            <hs-panel-container [service]=\"HsOverlayPanelContainerService\" [app]=\"app\"></hs-panel-container>\n        </div>\n        <div class=\"hs-panelspace\" [hidden]=\"!sidebarVisible\"\n            [ngClass]=\"{'labels': HsLayoutService.apps[app].sidebarLabels, 'buttons': HsLayoutService.apps[app].sidebarButtons}\">\n            <div class=\"hs-panelspace-wrapper me-1\">\n                <hs-sidebar class=\"border-0\" [app]=\"app\"></hs-sidebar>\n                <div class=\"hs-panelplace\">\n                    <hs-mini-sidebar *ngIf=\"HsLayoutService.apps[app].minisidebar\" [app]=\"app\"\n                        [hidden]=\"!panelVisible('sidebar',app, this)\"><!-- TODO: Remove function call from template -->\n                    </hs-mini-sidebar>\n                    <hs-panel-container [service]=\"HsPanelContainerService\" class=\"hs-panelplace\" [app]=\"app\">\n                    </hs-panel-container>\n                </div>\n            </div>\n        </div>\n        <hs-toast aria-live=\"polite\" aria-atomic=\"true\"\n            [ngClass]=\"sidebarPosition === 'left' ? 'hs-sb-right' : 'hs-sb-left'\" [app]=\"app\">\n        </hs-toast>\n        <div class=\"hs-dialog-area\"></div>\n    </div>\n    <hs-dialog-container [app]=\"app\"></hs-dialog-container>\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsConfig }, { type: HsLayoutService }, { type: HsEventBusService }, { type: i0.ElementRef }, { type: HsUtilsService }, { type: HsPanelContainerService }, { type: HsOverlayPanelContainerService }]; }, propDecorators: { app: [{
                type: Input
            }], hslayout: [{
                type: ViewChild,
                args: ['hslayout']
            }], mapHost: [{
                type: ViewChild,
                args: [HsMapHostDirective, { static: true }]
            }] } });

class HsLayoutHostDirective {
    constructor(viewContainerRef) {
        this.viewContainerRef = viewContainerRef;
    }
}
HsLayoutHostDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayoutHostDirective, deps: [{ token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive });
HsLayoutHostDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.11", type: HsLayoutHostDirective, selector: "[hslayout]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayoutHostDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[hslayout]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }]; } });

class HsLanguageComponent extends HsPanelBaseComponent {
    constructor(hsLanguageService, hsConfig, hsLayoutService, hsSidebarService) {
        super(hsLayoutService);
        this.hsLanguageService = hsLanguageService;
        this.hsConfig = hsConfig;
        this.hsSidebarService = hsSidebarService;
        this.name = 'language';
    }
    ngOnInit() {
        const app = this.data.app;
        this.hsSidebarService.addButton({
            panel: 'language',
            module: 'hs.language',
            order: 13,
            fits: true,
            title: 'PANEL_HEADER.LANGUAGE',
            description: 'SIDEBAR.descriptions.LANGUAGE',
            content: () => {
                return this.hsLanguageService
                    .getCurrentLanguageCode(app)
                    .toUpperCase();
            },
        }, app);
        this.available_languages =
            this.hsLanguageService.listAvailableLanguages(app);
    }
    /**
     * Check if provided language is active language
     * @param langCode - Language code
     * @returns True, if current language is active
     */
    isCurrentLang(langCode) {
        var _a;
        return (_a = this.hsLanguageService.apps[this.data.app]) === null || _a === void 0 ? void 0 : _a.language.endsWith(langCode.toLowerCase());
    }
    /**
     * Set UI language to provided one
     * @param langCode - Language code
     */
    setLanguage(langCode) {
        this.hsLanguageService.setLanguage(langCode, this.data.app);
    }
}
HsLanguageComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLanguageComponent, deps: [{ token: HsLanguageService }, { token: HsConfig }, { token: HsLayoutService }, { token: HsSidebarService }], target: i0.ɵɵFactoryTarget.Component });
HsLanguageComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsLanguageComponent, selector: "hs-language", usesInheritance: true, ngImport: i0, template: "<div class=\"card hs-main-panel\" [hidden]=\"(isVisible$ | async) === false\">\n    <hs-panel-header name=\"language\" [title]=\"'PANEL_HEADER.LANGUAGE' | translateHs : data\" [app]=\"data.app\">\n    </hs-panel-header>\n    <div class=\"card-body\">\n        <ul class=\"m-3 hs-senslog-list list-group\">\n            <button *ngFor=\"let lang of available_languages\" class=\"btn m-1\"\n                [ngClass]=\"isCurrentLang(lang.key) ? ' btn-primary' : ' btn-secondary'\"\n                (click)=\"setLanguage(lang.key)\">{{lang.name}}</button><!-- TODO: Remove function call from template -->\n        </ul>\n    </div>\n</div>", components: [{ type: HsPanelHeaderComponent, selector: "hs-panel-header", inputs: ["name", "app", "title"] }], directives: [{ type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], pipes: { "async": i3.AsyncPipe, "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLanguageComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-language', template: "<div class=\"card hs-main-panel\" [hidden]=\"(isVisible$ | async) === false\">\n    <hs-panel-header name=\"language\" [title]=\"'PANEL_HEADER.LANGUAGE' | translateHs : data\" [app]=\"data.app\">\n    </hs-panel-header>\n    <div class=\"card-body\">\n        <ul class=\"m-3 hs-senslog-list list-group\">\n            <button *ngFor=\"let lang of available_languages\" class=\"btn m-1\"\n                [ngClass]=\"isCurrentLang(lang.key) ? ' btn-primary' : ' btn-secondary'\"\n                (click)=\"setLanguage(lang.key)\">{{lang.name}}</button><!-- TODO: Remove function call from template -->\n        </ul>\n    </div>\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsLanguageService }, { type: HsConfig }, { type: HsLayoutService }, { type: HsSidebarService }]; } });

/**
 * @param HsConfig
 */
function getWebpackTranslateLoader(HsConfig, HttpClient) {
    return new WebpackTranslateLoader(HsConfig, HttpClient);
}
class HsLanguageModule {
}
HsLanguageModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLanguageModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HsLanguageModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLanguageModule, declarations: [HsLanguageComponent, TranslateCustomPipe], imports: [FormsModule,
        CommonModule,
        TranslateModule,
        HsPanelHelpersModule, i1$1.TranslateModule], exports: [HsLanguageComponent, TranslateCustomPipe] });
HsLanguageModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLanguageModule, providers: [
        TranslateStore,
        {
            provide: CustomTranslationService,
            useFactory: (dep1, dep2) => {
                return () => new CustomTranslationService(dep1, dep2);
            },
            deps: [HsConfig, HttpClient],
        },
    ], imports: [[
            FormsModule,
            CommonModule,
            TranslateModule,
            HsPanelHelpersModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useFactory: getWebpackTranslateLoader,
                    multi: false,
                    deps: [HsConfig, HttpClient],
                },
            }),
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLanguageModule, decorators: [{
            type: NgModule,
            args: [{
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                    declarations: [HsLanguageComponent, TranslateCustomPipe],
                    imports: [
                        FormsModule,
                        CommonModule,
                        TranslateModule,
                        HsPanelHelpersModule,
                        TranslateModule.forRoot({
                            loader: {
                                provide: TranslateLoader,
                                useFactory: getWebpackTranslateLoader,
                                multi: false,
                                deps: [HsConfig, HttpClient],
                            },
                        }),
                    ],
                    exports: [HsLanguageComponent, TranslateCustomPipe],
                    providers: [
                        TranslateStore,
                        {
                            provide: CustomTranslationService,
                            useFactory: (dep1, dep2) => {
                                return () => new CustomTranslationService(dep1, dep2);
                            },
                            deps: [HsConfig, HttpClient],
                        },
                    ],
                }]
        }] });

class HsConfirmModule {
}
HsConfirmModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsConfirmModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HsConfirmModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsConfirmModule, declarations: [HsConfirmDialogComponent], imports: [CommonModule, HsLanguageModule], exports: [HsConfirmDialogComponent] });
HsConfirmModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsConfirmModule, imports: [[CommonModule, HsLanguageModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsConfirmModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [HsConfirmDialogComponent],
                    imports: [CommonModule, HsLanguageModule],
                    exports: [HsConfirmDialogComponent],
                }]
        }] });

class HsMapDirective {
    constructor(viewContainerRef) {
        this.viewContainerRef = viewContainerRef;
        this.app = 'default';
    }
}
HsMapDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsMapDirective, deps: [{ token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive });
HsMapDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.11", type: HsMapDirective, selector: "[map]", inputs: { app: "app" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsMapDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[map]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }]; }, propDecorators: { app: [{
                type: Input
            }] } });

class HsMapModule {
}
HsMapModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsMapModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HsMapModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsMapModule, declarations: [HsMapComponent, HsMapDirective], imports: [CommonModule], exports: [HsMapComponent] });
HsMapModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsMapModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsMapModule, decorators: [{
            type: NgModule,
            args: [{
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                    declarations: [HsMapComponent, HsMapDirective],
                    imports: [CommonModule],
                    exports: [HsMapComponent],
                }]
        }] });

class SortByPipe {
    transform(value, order = '', column = '') {
        if (value.length <= 1) {
            return value;
        } // array with only one item
        if (order === undefined || order == '') {
            value ? (column ? this.ascendingOrder(value, column) : value) : [];
            return value;
        }
        if (column === undefined || column == '') {
            return value;
        }
        if (column || column !== '') {
            value
                ? order === 'asc'
                    ? this.ascendingOrder(value, column)
                    : this.descendingOrder(value, column)
                : [];
            return value;
        }
    }
    ascendingOrder(array, column) {
        return array.sort((a, b) => {
            return a[column] - b[column];
        });
    }
    descendingOrder(array, column) {
        return array.sort((a, b) => {
            return b[column] - a[column];
        });
    }
}
SortByPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: SortByPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
SortByPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: SortByPipe, name: "sortBy" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: SortByPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'sortBy' }]
        }] });

class HsSidebarModule {
}
HsSidebarModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSidebarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HsSidebarModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSidebarModule, declarations: [HsImpressumComponent,
        HsMiniSidebarComponent,
        HsSidebarComponent,
        SortByPipe], imports: [CommonModule, HsPanelHelpersModule, HsLanguageModule], exports: [HsMiniSidebarComponent, HsSidebarComponent] });
HsSidebarModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSidebarModule, imports: [[CommonModule, HsPanelHelpersModule, HsLanguageModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSidebarModule, decorators: [{
            type: NgModule,
            args: [{
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                    declarations: [
                        HsImpressumComponent,
                        HsMiniSidebarComponent,
                        HsSidebarComponent,
                        SortByPipe,
                    ],
                    imports: [CommonModule, HsPanelHelpersModule, HsLanguageModule],
                    exports: [HsMiniSidebarComponent, HsSidebarComponent],
                }]
        }] });

class HsLayoutModule {
    ngDoBootstrap() { }
}
HsLayoutModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayoutModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HsLayoutModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayoutModule, declarations: [HsDialogContainerComponent,
        HsDialogHostDirective,
        HsMapHostDirective,
        HsLayoutComponent,
        HsLayoutHostDirective], imports: [CommonModule,
        HsConfirmModule,
        HsMapModule,
        HsSidebarModule,
        HsPanelHelpersModule,
        HsToastModule], exports: [HsDialogContainerComponent, HsLayoutComponent] });
HsLayoutModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayoutModule, imports: [[
            CommonModule,
            HsConfirmModule,
            HsMapModule,
            HsSidebarModule,
            HsPanelHelpersModule,
            HsToastModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayoutModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        HsDialogContainerComponent,
                        HsDialogHostDirective,
                        HsMapHostDirective,
                        HsLayoutComponent,
                        HsLayoutHostDirective,
                    ],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                    imports: [
                        CommonModule,
                        HsConfirmModule,
                        HsMapModule,
                        HsSidebarModule,
                        HsPanelHelpersModule,
                        HsToastModule,
                    ],
                    exports: [HsDialogContainerComponent, HsLayoutComponent],
                }]
        }] });

class DrawPanelComponent {
    constructor(HsDrawService, HsLayerUtilsService, hsLayoutService, HsLanguageService) {
        this.HsDrawService = HsDrawService;
        this.HsLayerUtilsService = HsLayerUtilsService;
        this.hsLayoutService = hsLayoutService;
        this.HsLanguageService = HsLanguageService;
        this.opacity = 0.2;
        this.linewidth = 1;
        this.fillcolor = { 'background-color': 'rgba(0, 153, 255, 1)' };
        this.onlyMineFilterVisible = false;
        this.getTitle = getTitle;
        this.app = 'default';
    }
    ngOnInit() {
        this.appRef = this.HsDrawService.get(this.app);
        this.hsLayoutService.sidebarPosition.subscribe(({ app, position }) => {
            if (this.app == app) {
                this.sidebarPosition = position;
            }
        });
    }
    translateString(module, text) {
        return this.HsLanguageService.getTranslationIgnoreNonExisting(module, text);
    }
    changeSnapSource(layer) {
        this.HsDrawService.changeSnapSource(layer, this.app);
    }
    setType(what) {
        const type = this.HsDrawService.setType(what, this.app);
        if (type) {
            this.activateDrawing(this.hsLayoutService.panelVisible('draw', this.app));
        }
    }
    activateDrawing(withStyle) {
        this.HsDrawService.activateDrawing({
            changeStyle: withStyle ? () => this.changeStyle() : undefined,
        }, this.app);
    }
    selectLayer(layer) {
        this.HsDrawService.selectLayer(layer, this.app);
    }
    updateStyle() {
        this.appRef.updateStyle(() => this.changeStyle());
    }
    /**
     * @param {Event} e optional parameter passed when changeStyle is called
     * for 'ondrawend' event features
     * @description Dynamically create draw feature style according to parameters selected in
     * hs.styler.colorDirective
     * @returns {Array} Array of style definitions
     */
    changeStyle(e = null) {
        const newStyle = new Style({
            stroke: new Stroke({
                color: this.fillcolor['background-color'],
                width: this.linewidth,
            }),
            fill: new Fill({
                color: this.fillcolor['background-color'].slice(0, -2) + this.opacity + ')',
            }),
            image: new Circle({
                radius: 5,
                fill: new Fill({
                    color: this.fillcolor['background-color'].slice(0, -2) +
                        this.opacity +
                        ')',
                }),
                stroke: new Stroke({
                    color: this.fillcolor['background-color'],
                    width: this.linewidth,
                }),
            }),
        });
        return newStyle;
    }
    drawStyle() {
        return {
            'background-color': this.fillcolor['background-color'].slice(0, -2) + this.opacity + ')',
            border: this.linewidth + 'px solid ' + this.fillcolor['background-color'],
        };
    }
}
DrawPanelComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DrawPanelComponent, deps: [{ token: HsDrawService }, { token: HsLayerUtilsService }, { token: HsLayoutService }, { token: HsLanguageService }], target: i0.ɵɵFactoryTarget.Component });
DrawPanelComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: DrawPanelComponent, selector: "hs-draw-panel", inputs: { app: "app" }, ngImport: i0, template: "<div class=\"d-flex flex-column\">\n    <div class=\"d-flex w-75 m-auto py-2 justify-content-around\" style=\"white-space: nowrap;\">\n        <button type=\"button\" class=\"btn rounded btn-primary hs-toolbar-button\"\n            (click)=\"HsDrawService.saveDrawingLayer(app)\" [ngClass]=\"{'btn-sm' : sidebarPosition !== 'bottom'}\">\n            {{'COMMON.newDrawingLayer' | translateHs: {app} }}\n        </button>\n        <button type=\"button\" (click)=\"HsDrawService.setType(appRef.type, app)\"\n            [ngClass]=\"{'btn-sm' : sidebarPosition !== 'bottom'}\" class=\"btn ms-1 rounded btn-primary hs-toolbar-button\"\n            [disabled]=\"!appRef.type\">\n            {{'DRAW.disableDrawing' | translateHs: {app} }}\n        </button>\n    </div>\n    <!-- <p class=\"m-auto p-0 w-75\" style=\"color:crimson; font-size: smaller;text-align: center;\"\n        [hidden]=\"HsDrawService.type\">{{'DRAW.activateDrawing' | translateHs: {app} }}</p> -->\n    <div class=\"btn-group w-100  m-auto justify-content-center\"\n        [ngClass]=\"sidebarPosition === 'bottom' ? 'btn-group-lg' : 'btn-group-sm'\">\n        <ng-template #noLayerAvailable>\n            <p class=\"m-0 text-danger\">{{'DRAW.noSuitableLayer' | translateHs: {app} }}</p>\n        </ng-template>\n\n        <div *ngIf=\"appRef.hasSomeDrawables || appRef.tmpDrawLayer; else noLayerAvailable\"\n            class=\"flex-row w-100 m-auto justify-content-center align-items-center text-primary\" style=\"display: flex;\">\n            <p class=\"m-0 p-0\">{{'DRAW.drawingTo' | translateHs: {app} }}</p>\n            <div ngbDropdown style=\"max-width: 50%;\" placement=\"bottom\">\n                <button type=\"button\" class=\"btn btn-sm rounded-0 hs-toolbar-button d-flex align-items-center mw-100\"\n                    ngbDropdownToggle (click)=\"HsDrawService.fillDrawableLayers(app)\"\n                    [ngClass]=\"{'btn-light btn-outline-danger border-0' : appRef.tmpDrawLayer,'dropdown-toggle' : appRef.hasSomeDrawables }\"\n                    [disabled]=\"!appRef.hasSomeDrawables\">\n                    <div class=\"text-truncate\">{{HsDrawService.selectedLayerString(app)}}</div>\n                </button>\n                <div ngbDropdownMenu style=\"max-width: 15em;\">\n                    <div class=\"d-flex align-items-center w-100 flex-column\" *ngIf=\"appRef.drawableLayers.length > 0\">\n                        <label class=\" bg-primary w-100 text-light m-0 p-1\">{{'DRAW.activeLayers' |\n                            translateHs: {app} }}</label>\n                        <a class=\"dropdown-item text-truncate\" *ngFor=\"let layer of appRef.drawableLayers\"\n                            data-toggle=\"tooltip\" title=\"{{getTitle(layer) | translateHs : {app, module: 'LAYERS'} }}\"\n                            (click)=\"selectLayer(layer)\">{{getTitle(layer) | translateHs : {app, module: 'LAYERS'} }}</a><!-- TODO: Remove function call from template -->\n                    </div>\n                    <div class=\"d-flex align-items-center w-100 flex-column\"\n                        *ngIf=\"appRef.drawableLaymanLayers.length > 0\">\n                        <div class=\" bg-primary w-100 text-light m-0 p-1\">\n                            <div class=\"d-flex justify-content-between\">\n                                {{'DRAW.serverLayers' | translateHs: {app} }}\n                                <span (click)=\"onlyMineFilterVisible = !onlyMineFilterVisible\" style=\"cursor: pointer;\">\n                                    <i class=\"icon-settingsthree-gears\"></i>\n                                </span>\n                            </div>\n                            <div class=\"p-0 input-group-text border-0 justify-content-center bg-white\"\n                                *ngIf=\"onlyMineFilterVisible\">\n                                <label class=\"m-0\">\n                                    <input type=\"checkbox\" name=\"onlyMine\" [(ngModel)]=\"appRef.onlyMine\"\n                                        (ngModelChange)=\"HsDrawService.fillDrawableLayers(app); onlyMineFilterVisible = !onlyMineFilterVisible\">\n                                    {{'COMPOSITIONS.onlyMine' | translateHs: {app} }}\n                                </label>\n                            </div>\n                        </div>\n                        <a class=\"dropdown-item text-truncate\" *ngFor=\"let layer of appRef.drawableLaymanLayers\"\n                            data-toggle=\"tooltip\" title=\"{{layer.title | translateHs : {app, module: 'LAYERS'} }}\"\n                            (click)=\"selectLayer(layer)\">{{layer.title | translateHs : {app, module: 'LAYERS'} }}</a>\n                    </div>\n                </div>\n            </div>\n            <button type=\"button\" *ngIf=\"appRef.tmpDrawLayer\" class=\"btn btn-light btn-outline-primary border-0 btn-sm\"\n                (click)=\"HsDrawService.saveDrawingLayer(app)\" [title]=\"'DRAW.saveDrawingToLayer' | translateHs: {app} \">\n                <i class=\"glyphicon icon-save-floppy\"></i>\n            </button>\n            <ng-container *ngIf=\"appRef.hasSomeDrawables\">\n                <ng-container *ngIf=\"appRef.moreThenOneDrawable === true; else deleteButton\">\n                    <div ngbDropdown placement=\"bottom-right\" display=\"dynamic\" style=\"white-space: nowrap;\"\n                        #removeLayersDropdown=\"ngbDropdown\">\n                        <button type=\"button\" ngbDropdownToggle class=\"btn btn-light  btn-outline-danger btn-sm\"\n                            [disabled]=\"!appRef.hasSomeDrawables\" style=\"border: none !important;\">\n                            <i class=\"glyphicon icon-trash\"></i>\n                        </button>\n                        <div ngbDropdownMenu class=\"flex-column px-1 py-2\">\n                            <div class=\"d-flex align-items-center w-100 flex-column\">\n                                <a class=\"dropdown-item\" *ngIf=\"appRef.selectedLayer\"\n                                    (click)=\"HsDrawService.removeLayer(app); removeLayersDropdown.close()\">{{'COMMON.removeLayer'\n                                    |\n                                    translateHs: {app} }}</a>\n                                <a class=\"dropdown-item\"\n                                    (click)=\"HsDrawService.removeMultipleLayers(app); removeLayersDropdown.close()\">{{'DRAW.removeMultipleLayers'\n                                    | translateHs: {app} }}</a>\n                            </div>\n                        </div>\n                    </div>\n                </ng-container>\n                <ng-template #deleteButton>\n                    <button type=\"button\" class=\"btn btn-light  btn-outline-danger btn-sm\"\n                        (click)=\"HsDrawService.removeLayer(app)\" [title]=\"'COMMON.removeLayer' | translateHs: {app} \"\n                        style=\"border: none !important;\">\n                        <i class=\"glyphicon icon-trash\"></i>\n                    </button>\n                </ng-template>\n            </ng-container>\n\n        </div>\n    </div>\n</div>\n\n<div class=\"rounded-0 my-1 draw-buttons d-flex justify-content-center\"\n    [ngClass]=\"sidebarPosition === 'bottom' ? 'btn-group-lg' : 'btn-group-sm'\">\n    <button class=\"btn btn-light btn-outline-primary\" [ngClass]=\"{active: appRef.type==='Point' }\"\n        (click)=\"setType('Point')\" data-toggle=\"tooltip\" [title]=\"'COMMON.point' | translateHs: {app} \">\n        <i class=\"icon-pin\"></i>\n    </button>\n    <button class=\"btn btn-light btn-outline-primary\" [ngClass]=\"{active: appRef.type==='Polygon' }\"\n        (click)=\"setType('Polygon')\" data-toggle=\"tooltip\" [title]=\"'COMMON.polygon' | translateHs: {app} \">\n        <i class=\"icon-polygonlasso\"></i>\n    </button>\n    <button class=\"btn btn-light btn-outline-primary\" [ngClass]=\"{active: appRef.type==='LineString' }\"\n        (click)=\"setType('LineString')\" data-toggle=\"tooltip\" [title]=\"'COMMON.line' | translateHs: {app} \">\n        <i class=\"icon-line\"></i>\n    </button>\n    <button class=\"btn btn-light btn-outline-primary\" [ngClass]=\"{active: appRef.type==='Circle' }\"\n        (click)=\"setType('Circle')\" data-toggle=\"tooltip\" [title]=\"'COMMON.circle' | translateHs: {app} \">\n        <i class=\"icon-circleloaderfull\"></i>\n    </button>\n    <div ngbDropdown placement=\"bottom-right\" class=\"btn-group btn-group-sm\" role=\"group\"\n        #selectionTypeDropdown=\"ngbDropdown\">\n        <button ngbDropdownToggle type=\"button\" [ngClass]=\"{active: !appRef.type }\"\n            [title]=\"'STYLER.selection' | translateHs: {app} \" class=\"btn btn-light btn-outline-primary\">\n            <i class=\"icon-cursor\"></i>\n        </button>\n        <div ngbDropdownMenu style=\"white-space: nowrap;\">\n            <div class=\"flex-column px-1 py-2\">\n                <div class=\"d-flex flex-row justify-content-around align-items-baseline\">\n                    <label class=\"ms-1 cursor-pointer\" for=\"draw-boxSelection\">{{'DRAW.boxSelection' |\n                        translateHs: {app} }}</label>\n                    <input type=\"checkbox\" [(ngModel)]=\"appRef.boxSelectionActive\"\n                        (change)=\"HsDrawService.toggleBoxSelection(app);selectionTypeDropdown.close()\"\n                        id=\"draw-boxSelection\" name=\"filterByExtent\" class=\"cursor-pointer\">\n                </div>\n                <button class=\"btn btn-primary btn-sm hs-draw-selectAll\" [disabled]=\"!appRef.selectedLayer\"\n                    (click)=\"HsDrawService.selectAllFeatures(app);selectionTypeDropdown.close()\" data-toggle=\"tooltip\"\n                    [title]=\"'DRAW.deselectAllFeatures' | translateHs: {app} \">\n                    {{translateString('DRAW',appRef.toggleSelectionString)}}<!-- TODO: Remove function call from template -->\n                </button>\n            </div>\n        </div>\n    </div>\n</div>\n<div class=\"pt-2\">\n    <div style=\"font-size: smaller\">\n        <div class=\"pb-2\">\n            <div class=\"form-check\">\n                <input class=\"d-none\" type=\"checkbox\" id=\"hs-draw-snap\" [(ngModel)]=\"appRef.snapActive\"\n                    (change)=\"HsDrawService.toggleSnapping(app)\" />\n                <label for=\"hs-draw-snap\"\n                    [ngClass]=\"{'hs-checkmark':appRef.snapActive,'hs-uncheckmark':!appRef.snapActive}\">{{'DRAW.allowSnapping'\n                    | translateHs: {app} }}</label>\n            </div>\n            <div *ngIf=\"appRef.snapActive && appRef.drawableLayers.length > 1\"\n                class=\"d-flex align-items-center card flex-row justify-content-around mx-3 text-primary\">\n                <p class=\"m-0 p-0\">{{'DRAW.snapTo' | translateHs: {app} }}:</p>\n                <div ngbDropdown placement=\"bottom\" class=\"w-50 d-flex justify-content-center\">\n                    <button ngbDropdownToggle type=\"button\"\n                        class=\"btn btn-sm rounded-0 hs-toolbar-button d-flex align-items-center mw-100\"\n                        (click)=\" HsDrawService.fillDrawableLayers(app) \" style=\" font-size: small;\">\n                        <div class=\"mw-100 text-truncate\">{{HsDrawService.snapLayerString(app)}}</div>\n                    </button>\n                    <div ngbDropdownMenu style=\"max-width: 150%;\">\n                        <div class=\"d-flex align-items-center w-100 flex-column\">\n                            <a class=\"dropdown-item text-truncate\" *ngFor=\"let layer of appRef.drawableLayers\"\n                                data-toggle=\"tooltip\"\n                                title=\"{{getTitle(layer) | translateHs : {app, module: 'LAYERS'} }}\"\n                                (click)=\"changeSnapSource(layer)\">{{getTitle(layer) | translateHs : {app, module: 'LAYERS'} }}</a><!-- TODO: Remove function call from template -->\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>", styles: [""], directives: [{ type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i7.NgbDropdown, selector: "[ngbDropdown]", inputs: ["autoClose", "dropdownClass", "open", "placement", "container", "display"], outputs: ["openChange"], exportAs: ["ngbDropdown"] }, { type: i7.NgbDropdownToggle, selector: "[ngbDropdownToggle]" }, { type: i7.NgbDropdownMenu, selector: "[ngbDropdownMenu]" }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3$1.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DrawPanelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-draw-panel', template: "<div class=\"d-flex flex-column\">\n    <div class=\"d-flex w-75 m-auto py-2 justify-content-around\" style=\"white-space: nowrap;\">\n        <button type=\"button\" class=\"btn rounded btn-primary hs-toolbar-button\"\n            (click)=\"HsDrawService.saveDrawingLayer(app)\" [ngClass]=\"{'btn-sm' : sidebarPosition !== 'bottom'}\">\n            {{'COMMON.newDrawingLayer' | translateHs: {app} }}\n        </button>\n        <button type=\"button\" (click)=\"HsDrawService.setType(appRef.type, app)\"\n            [ngClass]=\"{'btn-sm' : sidebarPosition !== 'bottom'}\" class=\"btn ms-1 rounded btn-primary hs-toolbar-button\"\n            [disabled]=\"!appRef.type\">\n            {{'DRAW.disableDrawing' | translateHs: {app} }}\n        </button>\n    </div>\n    <!-- <p class=\"m-auto p-0 w-75\" style=\"color:crimson; font-size: smaller;text-align: center;\"\n        [hidden]=\"HsDrawService.type\">{{'DRAW.activateDrawing' | translateHs: {app} }}</p> -->\n    <div class=\"btn-group w-100  m-auto justify-content-center\"\n        [ngClass]=\"sidebarPosition === 'bottom' ? 'btn-group-lg' : 'btn-group-sm'\">\n        <ng-template #noLayerAvailable>\n            <p class=\"m-0 text-danger\">{{'DRAW.noSuitableLayer' | translateHs: {app} }}</p>\n        </ng-template>\n\n        <div *ngIf=\"appRef.hasSomeDrawables || appRef.tmpDrawLayer; else noLayerAvailable\"\n            class=\"flex-row w-100 m-auto justify-content-center align-items-center text-primary\" style=\"display: flex;\">\n            <p class=\"m-0 p-0\">{{'DRAW.drawingTo' | translateHs: {app} }}</p>\n            <div ngbDropdown style=\"max-width: 50%;\" placement=\"bottom\">\n                <button type=\"button\" class=\"btn btn-sm rounded-0 hs-toolbar-button d-flex align-items-center mw-100\"\n                    ngbDropdownToggle (click)=\"HsDrawService.fillDrawableLayers(app)\"\n                    [ngClass]=\"{'btn-light btn-outline-danger border-0' : appRef.tmpDrawLayer,'dropdown-toggle' : appRef.hasSomeDrawables }\"\n                    [disabled]=\"!appRef.hasSomeDrawables\">\n                    <div class=\"text-truncate\">{{HsDrawService.selectedLayerString(app)}}</div>\n                </button>\n                <div ngbDropdownMenu style=\"max-width: 15em;\">\n                    <div class=\"d-flex align-items-center w-100 flex-column\" *ngIf=\"appRef.drawableLayers.length > 0\">\n                        <label class=\" bg-primary w-100 text-light m-0 p-1\">{{'DRAW.activeLayers' |\n                            translateHs: {app} }}</label>\n                        <a class=\"dropdown-item text-truncate\" *ngFor=\"let layer of appRef.drawableLayers\"\n                            data-toggle=\"tooltip\" title=\"{{getTitle(layer) | translateHs : {app, module: 'LAYERS'} }}\"\n                            (click)=\"selectLayer(layer)\">{{getTitle(layer) | translateHs : {app, module: 'LAYERS'} }}</a><!-- TODO: Remove function call from template -->\n                    </div>\n                    <div class=\"d-flex align-items-center w-100 flex-column\"\n                        *ngIf=\"appRef.drawableLaymanLayers.length > 0\">\n                        <div class=\" bg-primary w-100 text-light m-0 p-1\">\n                            <div class=\"d-flex justify-content-between\">\n                                {{'DRAW.serverLayers' | translateHs: {app} }}\n                                <span (click)=\"onlyMineFilterVisible = !onlyMineFilterVisible\" style=\"cursor: pointer;\">\n                                    <i class=\"icon-settingsthree-gears\"></i>\n                                </span>\n                            </div>\n                            <div class=\"p-0 input-group-text border-0 justify-content-center bg-white\"\n                                *ngIf=\"onlyMineFilterVisible\">\n                                <label class=\"m-0\">\n                                    <input type=\"checkbox\" name=\"onlyMine\" [(ngModel)]=\"appRef.onlyMine\"\n                                        (ngModelChange)=\"HsDrawService.fillDrawableLayers(app); onlyMineFilterVisible = !onlyMineFilterVisible\">\n                                    {{'COMPOSITIONS.onlyMine' | translateHs: {app} }}\n                                </label>\n                            </div>\n                        </div>\n                        <a class=\"dropdown-item text-truncate\" *ngFor=\"let layer of appRef.drawableLaymanLayers\"\n                            data-toggle=\"tooltip\" title=\"{{layer.title | translateHs : {app, module: 'LAYERS'} }}\"\n                            (click)=\"selectLayer(layer)\">{{layer.title | translateHs : {app, module: 'LAYERS'} }}</a>\n                    </div>\n                </div>\n            </div>\n            <button type=\"button\" *ngIf=\"appRef.tmpDrawLayer\" class=\"btn btn-light btn-outline-primary border-0 btn-sm\"\n                (click)=\"HsDrawService.saveDrawingLayer(app)\" [title]=\"'DRAW.saveDrawingToLayer' | translateHs: {app} \">\n                <i class=\"glyphicon icon-save-floppy\"></i>\n            </button>\n            <ng-container *ngIf=\"appRef.hasSomeDrawables\">\n                <ng-container *ngIf=\"appRef.moreThenOneDrawable === true; else deleteButton\">\n                    <div ngbDropdown placement=\"bottom-right\" display=\"dynamic\" style=\"white-space: nowrap;\"\n                        #removeLayersDropdown=\"ngbDropdown\">\n                        <button type=\"button\" ngbDropdownToggle class=\"btn btn-light  btn-outline-danger btn-sm\"\n                            [disabled]=\"!appRef.hasSomeDrawables\" style=\"border: none !important;\">\n                            <i class=\"glyphicon icon-trash\"></i>\n                        </button>\n                        <div ngbDropdownMenu class=\"flex-column px-1 py-2\">\n                            <div class=\"d-flex align-items-center w-100 flex-column\">\n                                <a class=\"dropdown-item\" *ngIf=\"appRef.selectedLayer\"\n                                    (click)=\"HsDrawService.removeLayer(app); removeLayersDropdown.close()\">{{'COMMON.removeLayer'\n                                    |\n                                    translateHs: {app} }}</a>\n                                <a class=\"dropdown-item\"\n                                    (click)=\"HsDrawService.removeMultipleLayers(app); removeLayersDropdown.close()\">{{'DRAW.removeMultipleLayers'\n                                    | translateHs: {app} }}</a>\n                            </div>\n                        </div>\n                    </div>\n                </ng-container>\n                <ng-template #deleteButton>\n                    <button type=\"button\" class=\"btn btn-light  btn-outline-danger btn-sm\"\n                        (click)=\"HsDrawService.removeLayer(app)\" [title]=\"'COMMON.removeLayer' | translateHs: {app} \"\n                        style=\"border: none !important;\">\n                        <i class=\"glyphicon icon-trash\"></i>\n                    </button>\n                </ng-template>\n            </ng-container>\n\n        </div>\n    </div>\n</div>\n\n<div class=\"rounded-0 my-1 draw-buttons d-flex justify-content-center\"\n    [ngClass]=\"sidebarPosition === 'bottom' ? 'btn-group-lg' : 'btn-group-sm'\">\n    <button class=\"btn btn-light btn-outline-primary\" [ngClass]=\"{active: appRef.type==='Point' }\"\n        (click)=\"setType('Point')\" data-toggle=\"tooltip\" [title]=\"'COMMON.point' | translateHs: {app} \">\n        <i class=\"icon-pin\"></i>\n    </button>\n    <button class=\"btn btn-light btn-outline-primary\" [ngClass]=\"{active: appRef.type==='Polygon' }\"\n        (click)=\"setType('Polygon')\" data-toggle=\"tooltip\" [title]=\"'COMMON.polygon' | translateHs: {app} \">\n        <i class=\"icon-polygonlasso\"></i>\n    </button>\n    <button class=\"btn btn-light btn-outline-primary\" [ngClass]=\"{active: appRef.type==='LineString' }\"\n        (click)=\"setType('LineString')\" data-toggle=\"tooltip\" [title]=\"'COMMON.line' | translateHs: {app} \">\n        <i class=\"icon-line\"></i>\n    </button>\n    <button class=\"btn btn-light btn-outline-primary\" [ngClass]=\"{active: appRef.type==='Circle' }\"\n        (click)=\"setType('Circle')\" data-toggle=\"tooltip\" [title]=\"'COMMON.circle' | translateHs: {app} \">\n        <i class=\"icon-circleloaderfull\"></i>\n    </button>\n    <div ngbDropdown placement=\"bottom-right\" class=\"btn-group btn-group-sm\" role=\"group\"\n        #selectionTypeDropdown=\"ngbDropdown\">\n        <button ngbDropdownToggle type=\"button\" [ngClass]=\"{active: !appRef.type }\"\n            [title]=\"'STYLER.selection' | translateHs: {app} \" class=\"btn btn-light btn-outline-primary\">\n            <i class=\"icon-cursor\"></i>\n        </button>\n        <div ngbDropdownMenu style=\"white-space: nowrap;\">\n            <div class=\"flex-column px-1 py-2\">\n                <div class=\"d-flex flex-row justify-content-around align-items-baseline\">\n                    <label class=\"ms-1 cursor-pointer\" for=\"draw-boxSelection\">{{'DRAW.boxSelection' |\n                        translateHs: {app} }}</label>\n                    <input type=\"checkbox\" [(ngModel)]=\"appRef.boxSelectionActive\"\n                        (change)=\"HsDrawService.toggleBoxSelection(app);selectionTypeDropdown.close()\"\n                        id=\"draw-boxSelection\" name=\"filterByExtent\" class=\"cursor-pointer\">\n                </div>\n                <button class=\"btn btn-primary btn-sm hs-draw-selectAll\" [disabled]=\"!appRef.selectedLayer\"\n                    (click)=\"HsDrawService.selectAllFeatures(app);selectionTypeDropdown.close()\" data-toggle=\"tooltip\"\n                    [title]=\"'DRAW.deselectAllFeatures' | translateHs: {app} \">\n                    {{translateString('DRAW',appRef.toggleSelectionString)}}<!-- TODO: Remove function call from template -->\n                </button>\n            </div>\n        </div>\n    </div>\n</div>\n<div class=\"pt-2\">\n    <div style=\"font-size: smaller\">\n        <div class=\"pb-2\">\n            <div class=\"form-check\">\n                <input class=\"d-none\" type=\"checkbox\" id=\"hs-draw-snap\" [(ngModel)]=\"appRef.snapActive\"\n                    (change)=\"HsDrawService.toggleSnapping(app)\" />\n                <label for=\"hs-draw-snap\"\n                    [ngClass]=\"{'hs-checkmark':appRef.snapActive,'hs-uncheckmark':!appRef.snapActive}\">{{'DRAW.allowSnapping'\n                    | translateHs: {app} }}</label>\n            </div>\n            <div *ngIf=\"appRef.snapActive && appRef.drawableLayers.length > 1\"\n                class=\"d-flex align-items-center card flex-row justify-content-around mx-3 text-primary\">\n                <p class=\"m-0 p-0\">{{'DRAW.snapTo' | translateHs: {app} }}:</p>\n                <div ngbDropdown placement=\"bottom\" class=\"w-50 d-flex justify-content-center\">\n                    <button ngbDropdownToggle type=\"button\"\n                        class=\"btn btn-sm rounded-0 hs-toolbar-button d-flex align-items-center mw-100\"\n                        (click)=\" HsDrawService.fillDrawableLayers(app) \" style=\" font-size: small;\">\n                        <div class=\"mw-100 text-truncate\">{{HsDrawService.snapLayerString(app)}}</div>\n                    </button>\n                    <div ngbDropdownMenu style=\"max-width: 150%;\">\n                        <div class=\"d-flex align-items-center w-100 flex-column\">\n                            <a class=\"dropdown-item text-truncate\" *ngFor=\"let layer of appRef.drawableLayers\"\n                                data-toggle=\"tooltip\"\n                                title=\"{{getTitle(layer) | translateHs : {app, module: 'LAYERS'} }}\"\n                                (click)=\"changeSnapSource(layer)\">{{getTitle(layer) | translateHs : {app, module: 'LAYERS'} }}</a><!-- TODO: Remove function call from template -->\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>", styles: [""] }]
        }], ctorParameters: function () { return [{ type: HsDrawService }, { type: HsLayerUtilsService }, { type: HsLayoutService }, { type: HsLanguageService }]; }, propDecorators: { app: [{
                type: Input
            }] } });

class DrawEditComponent {
    constructor(HsDrawService, HsQueryBaseService, HsQueryVectorService, HsLanguageService, hsMapService, hsToastService, hsEventBusService) {
        this.HsDrawService = HsDrawService;
        this.HsQueryBaseService = HsQueryBaseService;
        this.HsQueryVectorService = HsQueryVectorService;
        this.HsLanguageService = HsLanguageService;
        this.hsMapService = hsMapService;
        this.hsToastService = hsToastService;
        this.hsEventBusService = hsEventBusService;
        this.app = 'default';
        this.editOptions = ['difference', 'union', 'intersection', 'split'];
        this.editLayer = new VectorLayer({
            properties: {
                title: 'Layer editor helper',
                queryable: true,
                showInLayerManager: false,
                sld: defaultStyle,
            },
            source: new Vector({}),
        });
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.appRef = this.HsDrawService.get(this.app);
            if (this.appRef.selectedLayer) {
                this.appRef.previouslySelected = this.appRef.selectedLayer;
            }
            else {
                this.appRef.previouslySelected = null;
            }
            yield this.hsMapService.loaded(this.app);
            this.hsMapService.getMap(this.app).addLayer(this.editLayer);
            this.HsQueryVectorService.init(this.app);
            this.checkFeatureGeometryType(this.HsQueryVectorService.apps[this.app].selector
                .getFeatures()
                .getArray()[0]);
            this.vectorQueryFeatureSubscription =
                this.hsEventBusService.vectorQueryFeatureSelection.subscribe((data) => {
                    if (data.app == this.app) {
                        const selectorFeatures = data.selector.getFeatures().getArray();
                        if (!this.checkFeatureGeometryType(selectorFeatures[0])) {
                            return;
                        }
                        if (selectorFeatures.length > 1 &&
                            this.editLayer !=
                                this.hsMapService.getLayerForFeature(data.feature, this.app) &&
                            this.selectedType == 'split') {
                            if (selectorFeatures.length == 3) {
                                //Switch between two splitting lines
                                if (selectorFeatures[2].getGeometry().getType() == 'LineString') {
                                    data.selector.getFeatures().remove(selectorFeatures[1]);
                                    this.hsToastService.createToastPopupMessage(this.HsLanguageService.getTranslation('DRAW.featureEditor.featureEditor', undefined, this.app), this.HsLanguageService.getTranslation('DRAW.featureEditor.onlyOneSplitLine', undefined, this.app), {
                                        toastStyleClasses: 'bg-info text-light',
                                    }, this.app);
                                }
                                else {
                                    //Remove lastly selected feature.
                                    //TODO: Feature is removed from selector properly but its style is not refreshed(looks like its still selected)
                                    data.selector.getFeatures().pop();
                                }
                            }
                            if (selectorFeatures.length == 2 &&
                                selectorFeatures[1].getGeometry().getType() != 'LineString') {
                                this.deselectMultiple();
                            }
                        }
                    }
                });
        });
    }
    ngOnDestroy() {
        this.hsMapService.loaded(this.app).then((map) => {
            map.removeLayer(this.editLayer);
            this.setType(this.appRef.type);
            //Timeout necessary because setType triggers async deactivateDrawing
            //HsDrawService.draw needs to be null in order to change draw soruce properly
            setTimeout(() => {
                if (this.appRef.previouslySelected) {
                    this.appRef.selectedLayer = this.appRef.previouslySelected;
                    this.HsDrawService.changeDrawSource(this.app);
                }
                else {
                    this.HsDrawService.fillDrawableLayers(this.app);
                }
            });
            this.vectorQueryFeatureSubscription.unsubscribe();
        });
    }
    /**
     * Check whether selected feature geometry type is valid
     * (Geometry operations work on polygon only)
     */
    checkFeatureGeometryType(feature) {
        if (!feature) {
            return false;
        }
        const isValidType = feature.getGeometry().getType() == 'Polygon';
        if (!isValidType) {
            this.hsToastService.createToastPopupMessage(this.HsLanguageService.getTranslation('DRAW.featureEditor.featureEditor', undefined, this.app), 'Only polygon geometry can be edited', undefined, this.app);
            this.resetState();
        }
        return isValidType;
    }
    /**
     * Selects geometry operation (one of editOptions)
     */
    selectGeomOperation(option) {
        const features = this.HsQueryVectorService.apps[this.app].selector.getFeatures();
        this.selectedType = option;
        if (this.appRef.draw) {
            const drawTypeRequired = option == 'split' ? 'LineString' : 'Polygon';
            if (this.appRef.type != drawTypeRequired) {
                this.setType(drawTypeRequired);
            }
        }
        if (this.selectedType == 'split') {
            if (this.editLayer.getSource().getFeatures().length > 0) {
                this.editLayer.getSource().clear();
            }
            if (features.getLength() > 1) {
                this.deselectMultiple();
            }
            this.setType('LineString'); //Commence drawing right away
        }
        else {
            if (features.getLength() > 1) {
                //Remove non polygon features from selection
                const featuresToRemove = features
                    .getArray()
                    .filter((feature) => feature.getGeometry().getType() != 'Polygon');
                for (const feature of featuresToRemove) {
                    features.remove(feature);
                }
            }
        }
    }
    //Deselects multi selection. Only one feature can be edited at the time
    //Index can specify whitch feature to preserve in selection
    deselectMultiple(index = 1) {
        this.hsToastService.createToastPopupMessage(this.HsLanguageService.getTranslation('DRAW.featureEditor.featureEditor'), this.HsLanguageService.getTranslation('DRAW.featureEditor.onlyOneFeatureToEdit', undefined, this.app), {
            toastStyleClasses: 'bg-info text-light',
        }, this.app);
        setTimeout(() => {
            try {
                const feature = this.HsQueryBaseService.get(this.app)
                    .selector.getFeatures()
                    .getArray()[index];
                this.HsQueryBaseService.apps[this.app].clear('features');
                this.HsQueryBaseService.apps[this.app].selector.getFeatures().clear();
                this.HsQueryBaseService.apps[this.app].selector
                    .getFeatures()
                    .push(feature);
                this.HsQueryVectorService.createFeatureAttributeList(this.app);
            }
            catch (error) {
                console.error(error);
            }
        });
    }
    //Custom onDrawEnd callback preventing HsQueryBaseService.clearData
    onDrawEnd(e) {
        setTimeout(() => {
            if (this.selectedType == 'split') {
                const features = this.editLayer.getSource().getFeatures();
                if (features.length > 1) {
                    this.HsQueryVectorService.removeFeature(features[0], this.app);
                    this.hsToastService.createToastPopupMessage(this.HsLanguageService.getTranslation('DRAW.featureEditor.featureEditor', undefined, this.app), this.HsLanguageService.getTranslation('DRAW.featureEditor.onlyOneSplitLine', undefined, this.app), {
                        toastStyleClasses: 'bg-info text-light',
                    }, this.app);
                }
            }
            this.HsDrawService.addFeatureToSelector(e.feature, this.app);
        });
    }
    selectionMenuToggled() {
        this.setType(this.appRef.type);
        this.editLayer.getSource().clear();
    }
    setType(what) {
        this.appRef.selectedLayer = this.editLayer;
        this.HsQueryBaseService.get(this.app).selector.setActive(what === this.appRef.type);
        this.appRef.modify.setActive(what === this.appRef.type);
        const type = this.HsDrawService.setType(what, this.app);
        if (type) {
            this.HsDrawService.activateDrawing({ onDrawEnd: (e) => this.onDrawEnd(e) }, this.app);
        }
        if (this.selectedType == 'split' && this.features.length > 1) {
            this.deselectMultiple(0);
        }
    }
    translateString(module, text) {
        return this.HsLanguageService.getTranslationIgnoreNonExisting(module, text);
    }
    //Modifiy firstly selected features with the output of polygonClipping
    setCoordinatesToFirstFeature(coords) {
        this.features[0].feature.getGeometry().setCoordinates(coords[0], 'XY');
    }
    get features() {
        return this.HsQueryBaseService.apps[this.app].features;
    }
    modify(type) {
        const features = [];
        const editCoords = [];
        this.features.forEach((feature, idx) => {
            if ((type == 'difference' && idx < 2) || type != 'difference') {
                features.push(feature.feature.clone());
            }
        });
        for (const index in features) {
            editCoords[index] = features[index].getGeometry().getCoordinates();
        }
        let newGeom;
        let properties;
        if (type === 'split') {
            const splittingLine = this.features.length > 1
                ? this.features[1].feature
                : this.editLayer.getSource().getFeatures()[0];
            newGeom = polygonSplitter({
                type: 'Polygon',
                coordinates: editCoords[0],
            }, {
                type: 'LineString',
                coordinates: splittingLine.getGeometry().getCoordinates(),
            }).geometry.coordinates;
            properties = features[0].getProperties();
        }
        else {
            if (type == 'union' || type == 'intersection') {
                const properties = {};
                for (const f of features) {
                    Object.assign(properties, f.getProperties());
                }
            }
            newGeom = polygonClipping[type](editCoords[0], ...editCoords.slice(1));
        }
        //TYPE SPECIFFIC ACTION
        this[type](newGeom, properties);
    }
    intersection(newGeom, properties) {
        if (newGeom.length > 0) {
            this.setCoordinatesToFirstFeature(newGeom);
            this.features[0].feature.setProperties(properties);
            this.resetState();
        }
        else {
            this.hsToastService.createToastPopupMessage(this.HsLanguageService.getTranslation('DRAW.featureEditor.featureEditor', undefined, this.app), this.HsLanguageService.getTranslation('DRAW.featureEditor.noIntersection', undefined, this.app), {
                toastStyleClasses: 'bg-warning text-light',
            }, this.app);
        }
    }
    union(newGeom, properties) {
        const features = this.features;
        const featuresLength = features.length;
        for (let i = 0; i <= featuresLength; i++) {
            //Remove all but the first (edited) features
            if (features.length != 1) {
                this.HsQueryVectorService.removeFeature(features[features.length - 1].feature, //pop() ??
                this.app);
            }
        }
        this.features[0].feature.setProperties(properties);
        this.setCoordinatesToFirstFeature(newGeom);
        this.resetState();
    }
    split(coords, properties) {
        for (const c of coords) {
            const layer = this.hsMapService.getLayerForFeature(this.features[0].feature, this.app);
            const feature = new Feature(Object.assign(properties, { geometry: new Polygon(c) }));
            layer.getSource().addFeature(feature);
        }
        for (const feature of this.features) {
            this.HsQueryVectorService.removeFeature(feature.feature, this.app);
        }
        this.resetState();
    }
    difference(newGeom, properties) {
        //TODO: Not sure what to do with properties here
        if (newGeom.length === 1) {
            this.setCoordinatesToFirstFeature(newGeom);
        }
        else {
            const layer = this.hsMapService.getLayerForFeature(this.features[0].feature, this.app);
            for (const geom of newGeom) {
                const feature = new Feature(new Polygon(geom));
                layer.getSource().addFeature(feature);
            }
            for (const feature of this.features) {
                this.HsQueryVectorService.removeFeature(feature.feature, this.app);
            }
        }
        this.resetState();
    }
    resetState() {
        this.editLayer.getSource().clear();
        this.setType(this.HsDrawService.get(this.app).type);
        this.HsQueryBaseService.apps[this.app].clear('features');
        this.HsQueryBaseService.get(this.app).selector.getFeatures().clear();
        this.HsQueryBaseService.get(this.app).selector.setActive(true);
    }
}
DrawEditComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DrawEditComponent, deps: [{ token: HsDrawService }, { token: HsQueryBaseService }, { token: HsQueryVectorService }, { token: HsLanguageService }, { token: HsMapService }, { token: HsToastService }, { token: HsEventBusService }], target: i0.ɵɵFactoryTarget.Component });
DrawEditComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: DrawEditComponent, selector: "hs-draw-edit", inputs: { app: "app" }, ngImport: i0, template: "<div class=\"alert alert-info w-75 m-auto mt-3 text-center\" role=\"alert\"\n    *ngIf=\"HsQueryBaseService.apps[app].features.length === 0; else editOptionsTemplate\">\n    {{'DRAW.featureEditor.selectFeatureToEdit' | translateHs: {app} }}\n</div>\n<ng-template #editOptionsTemplate>\n    <span class=\"w-75 text-center bg-primary text-white p-2 rounded mb-2\" style=\"--bs-bg-opacity: .8;\"><span\n            class=\"text-decoration-underline\">{{'DRAW.featureEditor.selectedFeature' | translateHs: {app} }}</span>\n        {{'DRAW.featureEditor.featureCanBeEditedbyOptions' | translateHs: {app} }}:</span>\n\n    <div class=\"rounded-0 my-1 draw-buttons d-flex justify-content-center\">\n        <button *ngFor=\"let option of editOptions\" class=\"btn btn-sm btn-light btn-outline-primary\"\n            [ngClass]=\"{active: selectedType === option }\" (click)=\"selectGeomOperation(option)\">\n            {{HsLanguageService.getTranslationIgnoreNonExisting('DRAW.featureEditor.editOptions',option, undefined,\n            app)}}\n        </button>\n    </div>\n\n    <div *ngIf=\"selectedType\" class=\"d-flex flex-column align-items-center my-3 w-75 bg-secondary\"\n        style=\"--bs-bg-opacity: .02;\">\n        <div class=\"d-flex flex-column align-items-center border border-start-0 border-end-0 py-3 w-100\">\n            {{'DRAW.featureEditor.drawNewFeature' | translateHs: {app} }}\n            <button *ngIf=\"selectedType !== 'split'\" class=\"w-50 btn btn-sm btn-light btn-outline-primary\"\n                (click)=\"setType('Polygon')\" [ngClass]=\"{active: appRef.type==='Polygon' }\"\n                [title]=\"'COMMON.polygon' | translateHs: {app} \">\n                <i class=\"icon-polygonlasso\"></i>\n            </button>\n            <button *ngIf=\"selectedType === 'split'\" class=\"w-50 btn btn-sm btn-light btn-outline-primary\"\n                [ngClass]=\"{active: appRef.type==='LineString' }\" (click)=\"setType('LineString')\" data-toggle=\"tooltip\"\n                [title]=\"'COMMON.line' | translateHs: {app} \">\n                <i class=\"icon-line\"></i>\n            </button>\n            <span class=\"py-1\"> {{'DRAW.featureEditor.orSelectOne' | translateHs: {app} }}\n            </span>\n            <button class=\"w-50 btn btn-sm btn-light btn-outline-primary\" [ngClass]=\"{active: !appRef.type }\"\n                (click)=\"setType(appRef.type)\" data-toggle=\"tooltip\" [title]=\"'COMMON.line' | translateHs: {app} \">\n                <i class=\"icon-cursor\"></i>\n            </button>\n        </div>\n\n        <button class=\"btn btn-primary m-2 w-100\" (click)=\"modify(selectedType)\" *ngIf=\"selectedType\"\n            [disabled]=\"HsQueryBaseService.apps[app].features.length < 2\">{{'COMMON.continue' | translateHs: {app} }}:\n            {{HsLanguageService.getTranslationIgnoreNonExisting('DRAW.featureEditor.editOptions',selectedType,\n            undefined, app)}}</button>\n    </div>\n</ng-template>", styles: [""], directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DrawEditComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-draw-edit', template: "<div class=\"alert alert-info w-75 m-auto mt-3 text-center\" role=\"alert\"\n    *ngIf=\"HsQueryBaseService.apps[app].features.length === 0; else editOptionsTemplate\">\n    {{'DRAW.featureEditor.selectFeatureToEdit' | translateHs: {app} }}\n</div>\n<ng-template #editOptionsTemplate>\n    <span class=\"w-75 text-center bg-primary text-white p-2 rounded mb-2\" style=\"--bs-bg-opacity: .8;\"><span\n            class=\"text-decoration-underline\">{{'DRAW.featureEditor.selectedFeature' | translateHs: {app} }}</span>\n        {{'DRAW.featureEditor.featureCanBeEditedbyOptions' | translateHs: {app} }}:</span>\n\n    <div class=\"rounded-0 my-1 draw-buttons d-flex justify-content-center\">\n        <button *ngFor=\"let option of editOptions\" class=\"btn btn-sm btn-light btn-outline-primary\"\n            [ngClass]=\"{active: selectedType === option }\" (click)=\"selectGeomOperation(option)\">\n            {{HsLanguageService.getTranslationIgnoreNonExisting('DRAW.featureEditor.editOptions',option, undefined,\n            app)}}\n        </button>\n    </div>\n\n    <div *ngIf=\"selectedType\" class=\"d-flex flex-column align-items-center my-3 w-75 bg-secondary\"\n        style=\"--bs-bg-opacity: .02;\">\n        <div class=\"d-flex flex-column align-items-center border border-start-0 border-end-0 py-3 w-100\">\n            {{'DRAW.featureEditor.drawNewFeature' | translateHs: {app} }}\n            <button *ngIf=\"selectedType !== 'split'\" class=\"w-50 btn btn-sm btn-light btn-outline-primary\"\n                (click)=\"setType('Polygon')\" [ngClass]=\"{active: appRef.type==='Polygon' }\"\n                [title]=\"'COMMON.polygon' | translateHs: {app} \">\n                <i class=\"icon-polygonlasso\"></i>\n            </button>\n            <button *ngIf=\"selectedType === 'split'\" class=\"w-50 btn btn-sm btn-light btn-outline-primary\"\n                [ngClass]=\"{active: appRef.type==='LineString' }\" (click)=\"setType('LineString')\" data-toggle=\"tooltip\"\n                [title]=\"'COMMON.line' | translateHs: {app} \">\n                <i class=\"icon-line\"></i>\n            </button>\n            <span class=\"py-1\"> {{'DRAW.featureEditor.orSelectOne' | translateHs: {app} }}\n            </span>\n            <button class=\"w-50 btn btn-sm btn-light btn-outline-primary\" [ngClass]=\"{active: !appRef.type }\"\n                (click)=\"setType(appRef.type)\" data-toggle=\"tooltip\" [title]=\"'COMMON.line' | translateHs: {app} \">\n                <i class=\"icon-cursor\"></i>\n            </button>\n        </div>\n\n        <button class=\"btn btn-primary m-2 w-100\" (click)=\"modify(selectedType)\" *ngIf=\"selectedType\"\n            [disabled]=\"HsQueryBaseService.apps[app].features.length < 2\">{{'COMMON.continue' | translateHs: {app} }}:\n            {{HsLanguageService.getTranslationIgnoreNonExisting('DRAW.featureEditor.editOptions',selectedType,\n            undefined, app)}}</button>\n    </div>\n</ng-template>", styles: [""] }]
        }], ctorParameters: function () { return [{ type: HsDrawService }, { type: HsQueryBaseService }, { type: HsQueryVectorService }, { type: HsLanguageService }, { type: HsMapService }, { type: HsToastService }, { type: HsEventBusService }]; }, propDecorators: { app: [{
                type: Input
            }] } });

[];
class HsFeatureCommonServiceParams {
    constructor() {
        this.listSubject = new BehaviorSubject([]);
        this.availableLayer$ = this.listSubject.asObservable();
    }
}
class HsFeatureCommonService {
    constructor(hsQueryVectorService, hsToastService, hsLanguageService, hsMapService, hsLayerUtilsService) {
        this.hsQueryVectorService = hsQueryVectorService;
        this.hsToastService = hsToastService;
        this.hsLanguageService = hsLanguageService;
        this.hsMapService = hsMapService;
        this.hsLayerUtilsService = hsLayerUtilsService;
        this.apps = { default: new HsFeatureCommonServiceParams() };
    }
    /**
     * Initialize the feature common service data and subscribers
     * @param app - App identifier
     */
    init(app) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.apps[app]) {
                return;
            }
            yield this.hsMapService.loaded(app);
            this.hsMapService
                .getMap(app)
                .getLayers()
                .on('change:length', () => {
                this.updateLayerList(app);
            });
            this.apps[app] = new HsFeatureCommonServiceParams();
        });
    }
    /**
     * Translate string value to the selected UI language
     * @param module - Locales json key
     * @param text - Locales json key value
     * @param app - App identifier
     * @returns Translated text
     */
    translateString(module, text, app) {
        return this.hsLanguageService.getTranslationIgnoreNonExisting(module, text, undefined, app);
    }
    /**
     * Update layer list from the current app map
     * @param app - App identifier
     */
    updateLayerList(app) {
        const layers = this.hsMapService
            .getLayersArray(app)
            .filter((layer) => {
            return this.hsLayerUtilsService.isLayerDrawable(layer);
        });
        this.apps[app].listSubject.next(layers);
    }
    /**
     * Prepare features for export
     * @param exportFormats - Export formats selected
     * @param features - Features to export
     * @param app - App identifier
     */
    toggleExportMenu(exportFormats, features, app) {
        for (const format of exportFormats) {
            format.serializedData = this.hsQueryVectorService.exportData(format.name, features, app);
        }
    }
    /**
     * Move or copy feature/s
     * @param type - Action type ('move' or 'copy')
     * @param features - Features to interact with
     * @param toLayer - Target layer
     * @param app - App identifier
     */
    moveOrCopyFeature(type, features, toLayer, app) {
        features.forEach((feature) => {
            feature.setStyle(null); //To prevent feature from getting individual style
            toLayer.getSource().addFeature(feature.clone());
            if (type == 'move') {
                this.hsQueryVectorService.removeFeature(feature, app);
            }
        });
        this.hsToastService.createToastPopupMessage(this.hsLanguageService.getTranslation('QUERY.feature.featureEdited'), this.hsLanguageService.getTranslation(`QUERY.feature.feature${type}Succ`, undefined, app) + getTitle(toLayer), {
            toastStyleClasses: 'bg-success text-light',
            serviceCalledFrom: 'HsFeatureCommonService',
        }, app);
    }
}
HsFeatureCommonService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsFeatureCommonService, deps: [{ token: HsQueryVectorService }, { token: HsToastService }, { token: HsLanguageService }, { token: HsMapService }, { token: HsLayerUtilsService }], target: i0.ɵɵFactoryTarget.Injectable });
HsFeatureCommonService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsFeatureCommonService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsFeatureCommonService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsQueryVectorService }, { type: HsToastService }, { type: HsLanguageService }, { type: HsMapService }, { type: HsLayerUtilsService }]; } });

class HsQueryAttributeRowComponent {
    constructor() {
        this.isObject = false;
    }
    ngOnInit() {
        this.checkAttributeValue();
    }
    /**
     * Act on feature attribute changes
     */
    change() {
        var _a;
        if ((_a = this.feature) === null || _a === void 0 ? void 0 : _a.feature) {
            const feature = this.feature.feature;
            if (this.isObject) {
                feature.set(this.attribute.name, JSON.parse(this.tmpObjectValue));
            }
            else {
                feature.set(this.attribute.name, this.attribute.value);
            }
        }
    }
    /**
     * Check if attribute value is object and stringify it if needed
     */
    checkAttributeValue() {
        if (typeof this.attribute.value == 'object' &&
            !Array.isArray(this.attribute.value)) {
            this.isObject = true;
            this.tmpObjectValue = JSON.stringify(this.attribute.value);
        }
    }
}
HsQueryAttributeRowComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsQueryAttributeRowComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
HsQueryAttributeRowComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsQueryAttributeRowComponent, selector: "hs-query-attribute-row", inputs: { attribute: "attribute", feature: "feature", readonly: "readonly", template: "template" }, ngImport: i0, template: "<div class=\"row\">\n    <div class=\"input-group m-1\">\n        <span class=\"input-group-text\">{{attribute.name}}</span>\n        <input class=\"form-control\" *ngIf=\"!isObject\" [(ngModel)]=\"attribute.value\" (change)=\"change()\"\n            [readonly]=\"readonly\" [ngModelOptions]=\"{standalone: true}\">\n        <textarea class=\"form-control\" *ngIf=\"isObject\" name=\"attributeValue\" [(ngModel)]=\"tmpObjectValue\"\n            [readonly]=\"readonly\" (change)=\"change()\" [ngModelOptions]=\"{standalone: true}\">\n            </textarea>\n    </div>\n</div>\n", directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsQueryAttributeRowComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-query-attribute-row', template: "<div class=\"row\">\n    <div class=\"input-group m-1\">\n        <span class=\"input-group-text\">{{attribute.name}}</span>\n        <input class=\"form-control\" *ngIf=\"!isObject\" [(ngModel)]=\"attribute.value\" (change)=\"change()\"\n            [readonly]=\"readonly\" [ngModelOptions]=\"{standalone: true}\">\n        <textarea class=\"form-control\" *ngIf=\"isObject\" name=\"attributeValue\" [(ngModel)]=\"tmpObjectValue\"\n            [readonly]=\"readonly\" (change)=\"change()\" [ngModelOptions]=\"{standalone: true}\">\n            </textarea>\n    </div>\n</div>\n" }]
        }], propDecorators: { attribute: [{
                type: Input
            }], feature: [{
                type: Input
            }], readonly: [{
                type: Input
            }], template: [{
                type: Input
            }] } });

class HsDownloadDirective {
    constructor(DomSanitizer) {
        this.DomSanitizer = DomSanitizer;
        this.hsDownload = '';
        this.mimeType = '';
        this.downloadPrepared = new EventEmitter();
    }
    ngOnChanges(changes) {
        const data = new Blob([this.hsDownload], { type: this.mimeType });
        const url = URL.createObjectURL(data);
        if (this.exportedHref) {
            URL.revokeObjectURL(this.exportedHref);
        }
        this.exportedHref = this.DomSanitizer.bypassSecurityTrustResourceUrl(url);
        //Timeout is needed, otherwise the hsDownload will be from previous digest i.e undefined
        setTimeout(() => {
            this.downloadPrepared.emit(this.exportedHref);
        }, 0);
    }
}
HsDownloadDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsDownloadDirective, deps: [{ token: i1$3.DomSanitizer }], target: i0.ɵɵFactoryTarget.Directive });
HsDownloadDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.11", type: HsDownloadDirective, selector: "[hsDownload]", inputs: { hsDownload: "hsDownload", mimeType: "mimeType" }, outputs: { downloadPrepared: "downloadPrepared" }, usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsDownloadDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[hsDownload]',
                }]
        }], ctorParameters: function () { return [{ type: i1$3.DomSanitizer }]; }, propDecorators: { hsDownload: [{
                type: Input
            }], mimeType: [{
                type: Input
            }], downloadPrepared: [{
                type: Output
            }] } });

class HsQueryFeatureComponent {
    constructor(hsMapService, hsQueryVectorService, hsFeatureCommonService, hsLayerUtilsService) {
        this.hsMapService = hsMapService;
        this.hsQueryVectorService = hsQueryVectorService;
        this.hsFeatureCommonService = hsFeatureCommonService;
        this.hsLayerUtilsService = hsLayerUtilsService;
        this.app = 'default';
        this.attributeName = '';
        this.attributeValue = '';
        this.newAttribVisible = false;
        this.exportFormats = [
            { name: 'WKT', ext: 'wkt', mimeType: 'text/plain', downloadData: '' },
            {
                name: 'GeoJSON',
                ext: 'geojson',
                mimeType: 'application/json',
                downloadData: '',
            },
        ];
        this.exportMenuVisible = false;
        this.editMenuVisible = false;
        this.selectedLayer = null;
        this.getTitle = getTitle;
        this.availableLayers = [];
    }
    ngOnInit() {
        this.hsFeatureCommonService.init(this.app);
        this.availableLayersSubscription = this.hsFeatureCommonService.apps[this.app].availableLayer$.subscribe((layers) => {
            if (!this.olFeature()) {
                //Feature from WMS getFeatureInfo
                return;
            }
            const featureLayer = this.hsMapService.getLayerForFeature(this.olFeature(), this.app);
            this.availableLayers = layers.filter((layer) => layer != featureLayer);
        });
    }
    ngOnDestroy() {
        var _a;
        (_a = this.availableLayersSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
    }
    /**
     * Get OL feature
     * @returns Returns feature
     */
    olFeature() {
        var _a;
        return (_a = this.feature) === null || _a === void 0 ? void 0 : _a.feature;
    }
    /**
     * Check if this feature is removable
     * @returns True if the feature can be removed from the map, false otherwise
     */
    isFeatureRemovable() {
        return this.olFeature()
            ? this.hsQueryVectorService.isFeatureRemovable(this.olFeature(), this.app)
            : false;
    }
    /**
     * Set new feature attribute
     * @param attributeName - New attribute name
     * @param attributeValue - New attribute value
     */
    saveNewAttribute(attributeName, attributeValue) {
        var _a;
        if ((_a = this.feature) === null || _a === void 0 ? void 0 : _a.feature) {
            const feature = this.feature.feature;
            const getDuplicates = this.feature.attributes.filter((duplicate) => duplicate.name == attributeName);
            if (getDuplicates.length == 0) {
                const obj = { name: attributeName, value: attributeValue };
                this.feature.attributes.push(obj);
                feature.set(attributeName, attributeValue);
            }
        }
        this.newAttribVisible = !this.newAttribVisible;
        this.attributeName = '';
        this.attributeValue = '';
    }
    /**
     * Remove this feature
     */
    removeFeature() {
        this.hsQueryVectorService.removeFeature(this.olFeature(), this.app);
    }
    /**
     * Zoom to this feature
     */
    zoomToFeature() {
        const extent = this.olFeature().getGeometry().getExtent();
        this.hsMapService.fitExtent(extent, this.app);
    }
    /**
     * Toggle dropdown menus
     * @param beingToggled - Menu name that is being toggled
     * @param other - Other menu name to be closed if opened
     */
    toggleMenus(beingToggled, other) {
        this[other] = this[other] ? !this[other] : this[other];
        this[beingToggled] = !this[beingToggled];
    }
    /**
     * Toggle export menus
     * @param app - App identifier
     */
    toggleExportMenu(app) {
        this.hsFeatureCommonService.toggleExportMenu(this.exportFormats, this.olFeature(), app);
        this.toggleMenus('exportMenuVisible', 'editMenuVisible');
    }
    /**
     * Set edit type (move or copy)
     * @param type - Type selected
     */
    editTypeSelected(type) {
        this.editType = type;
        this.editMenuVisible = !this.editMenuVisible;
    }
    /**
     * Show or hide edit menu
     */
    toggleEditMenu() {
        if (this.editType) {
            this.editType = null;
            return;
        }
        this.toggleMenus('editMenuVisible', 'exportMenuVisible');
    }
    /**
     * Move or copy feature
     * @param app - App identifier
     */
    moveOrCopyFeature(app) {
        this.hsFeatureCommonService.moveOrCopyFeature(this.editType, [this.olFeature()], this.selectedLayer, app);
    }
    /**
     * Translate string value to the selected UI language
     * @param module - Locales json key
     * @param text - Locales json key value
     * @returns Translated text
     */
    translateString(module, text) {
        return this.hsFeatureCommonService.translateString(module, text, this.app);
    }
}
HsQueryFeatureComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsQueryFeatureComponent, deps: [{ token: HsMapService }, { token: HsQueryVectorService }, { token: HsFeatureCommonService }, { token: HsLayerUtilsService }], target: i0.ɵɵFactoryTarget.Component });
HsQueryFeatureComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsQueryFeatureComponent, selector: "hs-query-feature", inputs: { feature: "feature", app: "app" }, ngImport: i0, template: "<div class=\"container-fluid\">\n    <div class=\"row\">\n        <div class=\"col-12 m-2\"><strong>{{feature.name}} <span *ngIf=\"feature.layer\">{{'QUERY.feature.inLayer' |\n                    translateHs : {app} }}</span>\n                {{feature.layer}}</strong></div>\n    </div>\n    <hs-query-attribute-row *ngFor=\"let attribute of feature.attributes\" [template]=\"feature.hstemplate\"\n        [feature]=\"feature\" [attribute]=\"attribute\" [readonly]=\"false\">\n    </hs-query-attribute-row>\n    <hs-query-attribute-row *ngFor=\"let stat of feature.stats\" [feature]=\"feature\" [attribute]=\"stat\" [readonly]=\"true\">\n    </hs-query-attribute-row>\n    <div class=\"row\">\n        <div class=\"input-group m-1\" [hidden]=\"!newAttribVisible\">\n            <div class=\"input-group m-1\">\n                <input class=\"form-control\" [placeholder]=\"'QUERY.feature.attributeName' | translateHs : {app} \"\n                    [(ngModel)]=\"attributeName\" [ngModelOptions]=\"{standalone: true}\">\n            </div>\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"input-group m-1\" [hidden]=\"!(attributeName && newAttribVisible)\">\n            <div class=\"input-group m-1\">\n                <input class=\"form-control\" [placeholder]=\"'QUERY.feature.attributeValue' | translateHs : {app} \"\n                    [(ngModel)]=\"attributeValue\" [ngModelOptions]=\"{standalone: true}\">\n            </div>\n        </div>\n    </div>\n    <div class=\"row\" [hidden]=\"!(attributeName && attributeValue && newAttribVisible)\">\n        <div class=\"col-6 mb-2 text-start\">\n            <div class=\"btn-group\">\n                <button class=\"btn btn-primary btn-sm\" (click)=\"saveNewAttribute(attributeName,attributeValue)\"><i\n                        class=\"icon-save-floppy\"></i></button>\n            </div>\n        </div>\n    </div>\n\n    <div [hidden]=\"!editType\" class=\"row p-2 \">\n        <div class=\"d-flex w-100 input-group input-group-sm align-items-baseline\">\n            <label for=\"selectedLayer\" class=\"px-2\">{{translateString('QUERY.feature',editType+'Feature')}}\n                {{'COMMON.into' | translateHs : {app} }}:</label>\n            <select class=\"form-control text-truncate\" [title]=\"'ADDLAYERS.Vector.chooseLayer' | translateHs : {app} \"\n                [(ngModel)]=\"selectedLayer\" name=\"selectedLayer\">\n                <option [ngValue]=\"null\" [disabled]=\"true\" selected hidden> {{'ADDLAYERS.Vector.chooseLayer' |\n                    translateHs : {app} }}</option>\n                <option *ngFor=\"let layer of availableLayers\" [ngValue]=\"layer\">\n                    {{getTitle(layer) | translateHs : {app, module: 'LAYERS'} }}</option>\n            </select>\n            <button class=\"btn btn-primary btn-sm\" (click)=\"moveOrCopyFeature(app)\" [disabled]=\"!selectedLayer\"><i\n                    class=\"icon-save-floppy\"></i></button>\n        </div>\n    </div>\n</div>\n<div class=\"justify-content-end\" style=\"padding-left: 10px\" *ngIf=\"olFeature() !== undefined\">\n    <div class=\"mx-1 mb-2 text-end\">\n        <div class=\"btn-group\">\n            <button class=\"btn btn-secondary btn-sm\" (click)=\"newAttribVisible = !newAttribVisible\"><i\n                    class=\"icon-calcplus\"></i></button>\n            <button class=\"btn btn-secondary btn-sm\" (click)=\"zoomToFeature()\"><i class=\"icon-search\"></i></button>\n            <div class=\"btn-group\" ngbDropdown placement=\"bottom\" display=\"dynamic\">\n                <button ngbDropdownToggle class=\"btn btn-secondary btn-sm\" type=\"button\"\n                    (click)=\"toggleEditMenu()\"><i class=\"icon-settingsthree-gears\"></i></button>\n                <div ngbDropdownMenu [ngClass]=\"{'show': editMenuVisible}\">\n                    <a class=\"dropdown-item\" (click)=\"editTypeSelected('copy')\">{{'QUERY.feature.copyFeature' |\n                        translateHs : {app} }}</a>\n                    <a class=\"dropdown-item\" (click)=\"editTypeSelected('move')\">{{'QUERY.feature.moveFeature' |\n                        translateHs : {app} }}</a>\n                </div>\n            </div>\n            <div class=\"btn-group\" ngbDropdown placement=\"bottom\" display=\"dynamic\">\n                <button ngbDropdownToggle class=\"btn btn-secondary btn-sm rounded-0\" type=\"button\"\n                    (click)=\"toggleExportMenu(app)\" [title]=\"'QUERY.downloadAs' | translateHs : {app} \"><i\n                        class=\"icon-download\"></i></button>\n                <div ngbDropdownMenu [ngClass]=\"{'show': exportMenuVisible}\">\n                    <a class=\"dropdown-item\" download=\"{{format.name}}_file.{{format.ext}}\"\n                        [hsDownload]=\"format.serializedData\" [mimeType]=\"format.mimeType\" [href]=\"format.downloadData\"\n                        (downloadPrepared)=\"format.downloadData = $event\"\n                        *ngFor=\"let format of exportFormats\">{{format.name}}</a>\n                </div>\n            </div>\n            <button class=\"btn btn-danger btn-sm\" (click)=\"removeFeature()\" *ngIf=\"isFeatureRemovable()\"><i\n                    class=\"icon-trash\"></i></button>\n        </div>\n    </div>\n</div>", components: [{ type: HsQueryAttributeRowComponent, selector: "hs-query-attribute-row", inputs: ["attribute", "feature", "readonly", "template"] }], directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3$1.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i3$1.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i3$1.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i7.NgbDropdown, selector: "[ngbDropdown]", inputs: ["autoClose", "dropdownClass", "open", "placement", "container", "display"], outputs: ["openChange"], exportAs: ["ngbDropdown"] }, { type: i7.NgbDropdownToggle, selector: "[ngbDropdownToggle]" }, { type: i7.NgbDropdownMenu, selector: "[ngbDropdownMenu]" }, { type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: HsDownloadDirective, selector: "[hsDownload]", inputs: ["hsDownload", "mimeType"], outputs: ["downloadPrepared"] }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsQueryFeatureComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-query-feature', template: "<div class=\"container-fluid\">\n    <div class=\"row\">\n        <div class=\"col-12 m-2\"><strong>{{feature.name}} <span *ngIf=\"feature.layer\">{{'QUERY.feature.inLayer' |\n                    translateHs : {app} }}</span>\n                {{feature.layer}}</strong></div>\n    </div>\n    <hs-query-attribute-row *ngFor=\"let attribute of feature.attributes\" [template]=\"feature.hstemplate\"\n        [feature]=\"feature\" [attribute]=\"attribute\" [readonly]=\"false\">\n    </hs-query-attribute-row>\n    <hs-query-attribute-row *ngFor=\"let stat of feature.stats\" [feature]=\"feature\" [attribute]=\"stat\" [readonly]=\"true\">\n    </hs-query-attribute-row>\n    <div class=\"row\">\n        <div class=\"input-group m-1\" [hidden]=\"!newAttribVisible\">\n            <div class=\"input-group m-1\">\n                <input class=\"form-control\" [placeholder]=\"'QUERY.feature.attributeName' | translateHs : {app} \"\n                    [(ngModel)]=\"attributeName\" [ngModelOptions]=\"{standalone: true}\">\n            </div>\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"input-group m-1\" [hidden]=\"!(attributeName && newAttribVisible)\">\n            <div class=\"input-group m-1\">\n                <input class=\"form-control\" [placeholder]=\"'QUERY.feature.attributeValue' | translateHs : {app} \"\n                    [(ngModel)]=\"attributeValue\" [ngModelOptions]=\"{standalone: true}\">\n            </div>\n        </div>\n    </div>\n    <div class=\"row\" [hidden]=\"!(attributeName && attributeValue && newAttribVisible)\">\n        <div class=\"col-6 mb-2 text-start\">\n            <div class=\"btn-group\">\n                <button class=\"btn btn-primary btn-sm\" (click)=\"saveNewAttribute(attributeName,attributeValue)\"><i\n                        class=\"icon-save-floppy\"></i></button>\n            </div>\n        </div>\n    </div>\n\n    <div [hidden]=\"!editType\" class=\"row p-2 \">\n        <div class=\"d-flex w-100 input-group input-group-sm align-items-baseline\">\n            <label for=\"selectedLayer\" class=\"px-2\">{{translateString('QUERY.feature',editType+'Feature')}}\n                {{'COMMON.into' | translateHs : {app} }}:</label>\n            <select class=\"form-control text-truncate\" [title]=\"'ADDLAYERS.Vector.chooseLayer' | translateHs : {app} \"\n                [(ngModel)]=\"selectedLayer\" name=\"selectedLayer\">\n                <option [ngValue]=\"null\" [disabled]=\"true\" selected hidden> {{'ADDLAYERS.Vector.chooseLayer' |\n                    translateHs : {app} }}</option>\n                <option *ngFor=\"let layer of availableLayers\" [ngValue]=\"layer\">\n                    {{getTitle(layer) | translateHs : {app, module: 'LAYERS'} }}</option>\n            </select>\n            <button class=\"btn btn-primary btn-sm\" (click)=\"moveOrCopyFeature(app)\" [disabled]=\"!selectedLayer\"><i\n                    class=\"icon-save-floppy\"></i></button>\n        </div>\n    </div>\n</div>\n<div class=\"justify-content-end\" style=\"padding-left: 10px\" *ngIf=\"olFeature() !== undefined\">\n    <div class=\"mx-1 mb-2 text-end\">\n        <div class=\"btn-group\">\n            <button class=\"btn btn-secondary btn-sm\" (click)=\"newAttribVisible = !newAttribVisible\"><i\n                    class=\"icon-calcplus\"></i></button>\n            <button class=\"btn btn-secondary btn-sm\" (click)=\"zoomToFeature()\"><i class=\"icon-search\"></i></button>\n            <div class=\"btn-group\" ngbDropdown placement=\"bottom\" display=\"dynamic\">\n                <button ngbDropdownToggle class=\"btn btn-secondary btn-sm\" type=\"button\"\n                    (click)=\"toggleEditMenu()\"><i class=\"icon-settingsthree-gears\"></i></button>\n                <div ngbDropdownMenu [ngClass]=\"{'show': editMenuVisible}\">\n                    <a class=\"dropdown-item\" (click)=\"editTypeSelected('copy')\">{{'QUERY.feature.copyFeature' |\n                        translateHs : {app} }}</a>\n                    <a class=\"dropdown-item\" (click)=\"editTypeSelected('move')\">{{'QUERY.feature.moveFeature' |\n                        translateHs : {app} }}</a>\n                </div>\n            </div>\n            <div class=\"btn-group\" ngbDropdown placement=\"bottom\" display=\"dynamic\">\n                <button ngbDropdownToggle class=\"btn btn-secondary btn-sm rounded-0\" type=\"button\"\n                    (click)=\"toggleExportMenu(app)\" [title]=\"'QUERY.downloadAs' | translateHs : {app} \"><i\n                        class=\"icon-download\"></i></button>\n                <div ngbDropdownMenu [ngClass]=\"{'show': exportMenuVisible}\">\n                    <a class=\"dropdown-item\" download=\"{{format.name}}_file.{{format.ext}}\"\n                        [hsDownload]=\"format.serializedData\" [mimeType]=\"format.mimeType\" [href]=\"format.downloadData\"\n                        (downloadPrepared)=\"format.downloadData = $event\"\n                        *ngFor=\"let format of exportFormats\">{{format.name}}</a>\n                </div>\n            </div>\n            <button class=\"btn btn-danger btn-sm\" (click)=\"removeFeature()\" *ngIf=\"isFeatureRemovable()\"><i\n                    class=\"icon-trash\"></i></button>\n        </div>\n    </div>\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsMapService }, { type: HsQueryVectorService }, { type: HsFeatureCommonService }, { type: HsLayerUtilsService }]; }, propDecorators: { feature: [{
                type: Input
            }], app: [{
                type: Input
            }] } });

class HsQueryFeatureListComponent {
    constructor(hsQueryVectorService, hsLanguageService, hsDialogContainerService, hsFeatureCommonService, hsLayerUtilsService, hsQueryBaseService) {
        this.hsQueryVectorService = hsQueryVectorService;
        this.hsLanguageService = hsLanguageService;
        this.hsDialogContainerService = hsDialogContainerService;
        this.hsFeatureCommonService = hsFeatureCommonService;
        this.hsLayerUtilsService = hsLayerUtilsService;
        this.hsQueryBaseService = hsQueryBaseService;
        this.app = 'default';
        this.selectedFeaturesVisible = true;
        this.exportFormats = [
            { name: 'WKT', ext: 'wkt', mimeType: 'text/plain', downloadData: '' },
            {
                name: 'GeoJSON',
                ext: 'geojson',
                mimeType: 'application/json',
                downloadData: '',
            },
        ];
        this.editType = null;
        this.editMenuVisible = false;
        this.selectedLayer = null;
        this.getTitle = getTitle;
    }
    /**
     * Track item by openlayers feature, ol_uid value
     * @param index - Index
     * @param item - Item provided
     */
    trackById(index, item) {
        if (item.feature) {
            return item.feature.ol_uid;
        }
        else {
            return JSON.stringify(item);
        }
    }
    ngOnInit() {
        this.queryBaseAppRef = this.hsQueryBaseService.get(this.app);
        this.hsFeatureCommonService.init(this.app);
        this.featureCommonAppRef = this.hsFeatureCommonService.apps[this.app];
    }
    /**
     * Get OL feature array
     * @returns Feature array
     */
    olFeatureArray() {
        return this.queryBaseAppRef.features
            .map((feature) => feature.feature)
            .filter((f) => f);
    }
    /**
     * Toggle dropdown menus
     * @param beingToggled - Menu name that is being toggled
     * @param other - Other menu name to be closed if opened
     */
    toggleMenus(beingToggled, other) {
        this[other] = this[other] ? !this[other] : this[other];
        this[beingToggled] = !this[beingToggled];
    }
    /**
     * Toggle export menu
     * @param app - App identifier
     */
    toggleExportMenu(app) {
        this.hsFeatureCommonService.toggleExportMenu(this.exportFormats, this.olFeatureArray(), app);
        this.toggleMenus('exportMenuVisible', 'editMenuVisible');
    }
    /**
     * Toggle edit menu
     */
    toggleEditMenu() {
        if (this.editType) {
            this.editType = null;
            return;
        }
        this.toggleMenus('editMenuVisible', 'exportMenuVisible');
    }
    /**
     * Set edit type
     * @param type - Type selected
     */
    editTypeSelected(type) {
        this.editType = type;
        this.editMenuVisible = !this.editMenuVisible;
    }
    /**
     * Move or copy feature
     * @param app - App identifier
     */
    moveOrCopyFeature(app) {
        this.hsFeatureCommonService.moveOrCopyFeature(this.editType, this.olFeatureArray(), this.selectedLayer, app);
    }
    /**
     * Remove all selected features
     * @param app - App identifier
     */
    removeAllSelectedFeatures(app) {
        return __awaiter(this, void 0, void 0, function* () {
            const dialog = this.hsDialogContainerService.create(HsConfirmDialogComponent, {
                message: this.hsLanguageService.getTranslation('QUERY.reallyDeleteAllSelectedLayers', undefined, this.app),
                title: this.hsLanguageService.getTranslation('COMMON.confirmDelete', undefined, this.app),
            }, this.app);
            const confirmed = yield dialog.waitResult();
            if (confirmed == 'yes') {
                for (const feature of this.queryBaseAppRef.features) {
                    //Give HsQueryVectorService.featureRemovals time to splice QueryBase.data.features
                    setTimeout(() => {
                        this.hsQueryVectorService.removeFeature(feature.feature, app);
                    }, 250);
                }
            }
        });
    }
    /**
     * Translate string value to the selected UI language
     * @param module - Locales json key
     * @param text - Locales json key value
     * @returns Translated text
     */
    translateString(module, text) {
        return this.hsFeatureCommonService.translateString(module, text, this.app);
    }
}
HsQueryFeatureListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsQueryFeatureListComponent, deps: [{ token: HsQueryVectorService }, { token: HsLanguageService }, { token: HsDialogContainerService }, { token: HsFeatureCommonService }, { token: HsLayerUtilsService }, { token: HsQueryBaseService }], target: i0.ɵɵFactoryTarget.Component });
HsQueryFeatureListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsQueryFeatureListComponent, selector: "hs-query-feature-list", inputs: { app: "app" }, ngImport: i0, template: "<ng-container>\n    <div class=\"navbar navbar-light bg-light px-1\" *ngIf=\"queryBaseAppRef.features.length > 0\">\n        <div class=\"d-flex align-items-baseline w-100\">\n            <div class=\"d-flex align-items-baseline\" style=\"flex: 1;\">\n                <p class=\"m-0\" [ngStyle]=\"{'flex' : queryBaseAppRef.features.length > 1 ? '' : '1'}\">\n                    {{'QUERY.featuresSelected' | translateHs : {app} }}{{queryBaseAppRef.features.length}}\n                </p>\n                <button type=\"button\" class=\"btn dropdown-toggle border-0 ms-2\"\n                    [title]=\"'HISTORY.toggleDropdown' | translateHs : {app} \"\n                    (click)=\"selectedFeaturesVisible = !selectedFeaturesVisible\">\n                </button>\n            </div>\n            <div class=\"btn-group\" *ngIf=\"olFeatureArray().length > 0\">\n                <div class=\"btn-group\" ngbDropdown placement=\"bottom\" display=\"dynamic\">\n                    <button ngbDropdownToggle class=\"btn btn-secondary btn-sm\" type=\"button\"\n                        (click)=\"toggleEditMenu()\"><i class=\"icon-settingsthree-gears\"></i></button>\n                    <div ngbDropdownMenu [ngClass]=\"{'show': editMenuVisible}\">\n                        <a class=\"dropdown-item\" (click)=\"editTypeSelected('copy')\">{{'QUERY.feature.copyFeatures' |\n                            translateHs : {app} }}</a>\n                        <a class=\"dropdown-item\" (click)=\"editTypeSelected('move')\">{{'QUERY.feature.moveFeatures' |\n                            translateHs : {app} }}</a>\n                    </div>\n                </div>\n                <div class=\"btn-group\" ngbDropdown placement=\"bottom\" display=\"dynamic\">\n                    <button ngbDropdownToggle class=\"btn btn-secondary btn-sm rounded-0\" type=\"button\"\n                        [title]=\"'QUERY.downloadAs' | translateHs : {app} \" (click)=\"toggleExportMenu(app)\"><i\n                            class=\"icon-download\"></i></button>\n                    <div ngbDropdownMenu [ngClass]=\"{'show': exportMenuVisible}\">\n                        <a class=\"dropdown-item\" *ngFor=\"let format of exportFormats\"\n                            download=\"{{format.name}}_file.{{format.ext}}\" [hsDownload]=\"format.serializedData\"\n                            [mimeType]=\"format.mimeType\" [href]=\"format.downloadData\"\n                            (downloadPrepared)=\"format.downloadData = $event\">\n                            {{format.name}}</a>\n                    </div>\n                </div>\n                <button type=\"button\" class=\"btn-danger btn btn-sm border-0\"\n                    [title]=\"'QUERY.deleteAllSelected' | translateHs : {app} \" (click)=\"removeAllSelectedFeatures(app)\">\n                    <i class=\"glyphicon icon-trash\"></i>\n                </button>\n            </div>\n        </div>\n        <div *ngIf=\"editType\" class=\"d-flex p-2 w-100\">\n            <div class=\"d-flex w-100 input-group input-group-sm align-items-baseline\">\n                <label for=\"selectedLayer\" class=\"px-2\">{{translateString('QUERY.feature',editType+'Features')}}\n                    {{'COMMON.into' | translateHs : {app} }}:</label>\n                <select class=\"form-control text-truncate\" [(ngModel)]=\"selectedLayer\" name=\"selectedLayer\"\n                    [title]=\"'ADDLAYERS.Vector.chooseLayer' | translateHs : {app} \">\n                    <option [ngValue]=\"null\" [disabled]=\"true\" selected hidden> {{'ADDLAYERS.Vector.chooseLayer' |\n                        translateHs : {app} }}</option>\n                    <option *ngFor=\"let layer of featureCommonAppRef.availableLayer$ | async\" [ngValue]=\"layer\">\n                        {{getTitle(layer) | translateHs : {app, module: 'LAYERS'} }}</option>\n                </select>\n                <button class=\"btn btn-primary btn-sm\" (click)=\"moveOrCopyFeature(app)\" [disabled]=\"!selectedLayer\"><i\n                        class=\"icon-save-floppy\"></i></button>\n            </div>\n        </div>\n    </div>\n    <div *ngIf=\"selectedFeaturesVisible\">\n        <hs-query-feature *ngFor=\"let item of queryBaseAppRef.features | slice:0:50; trackBy: trackById\" [app]=\"app\"\n            [feature]=\"item\">\n        </hs-query-feature>\n    </div>\n</ng-container>", components: [{ type: HsQueryFeatureComponent, selector: "hs-query-feature", inputs: ["feature", "app"] }], directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i7.NgbNavbar, selector: ".navbar" }, { type: i3.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { type: i7.NgbDropdown, selector: "[ngbDropdown]", inputs: ["autoClose", "dropdownClass", "open", "placement", "container", "display"], outputs: ["openChange"], exportAs: ["ngbDropdown"] }, { type: i7.NgbDropdownToggle, selector: "[ngbDropdownToggle]" }, { type: i7.NgbDropdownMenu, selector: "[ngbDropdownMenu]" }, { type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: HsDownloadDirective, selector: "[hsDownload]", inputs: ["hsDownload", "mimeType"], outputs: ["downloadPrepared"] }, { type: i3$1.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3$1.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i3$1.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }], pipes: { "translateHs": TranslateCustomPipe, "async": i3.AsyncPipe, "slice": i3.SlicePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsQueryFeatureListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-query-feature-list', template: "<ng-container>\n    <div class=\"navbar navbar-light bg-light px-1\" *ngIf=\"queryBaseAppRef.features.length > 0\">\n        <div class=\"d-flex align-items-baseline w-100\">\n            <div class=\"d-flex align-items-baseline\" style=\"flex: 1;\">\n                <p class=\"m-0\" [ngStyle]=\"{'flex' : queryBaseAppRef.features.length > 1 ? '' : '1'}\">\n                    {{'QUERY.featuresSelected' | translateHs : {app} }}{{queryBaseAppRef.features.length}}\n                </p>\n                <button type=\"button\" class=\"btn dropdown-toggle border-0 ms-2\"\n                    [title]=\"'HISTORY.toggleDropdown' | translateHs : {app} \"\n                    (click)=\"selectedFeaturesVisible = !selectedFeaturesVisible\">\n                </button>\n            </div>\n            <div class=\"btn-group\" *ngIf=\"olFeatureArray().length > 0\">\n                <div class=\"btn-group\" ngbDropdown placement=\"bottom\" display=\"dynamic\">\n                    <button ngbDropdownToggle class=\"btn btn-secondary btn-sm\" type=\"button\"\n                        (click)=\"toggleEditMenu()\"><i class=\"icon-settingsthree-gears\"></i></button>\n                    <div ngbDropdownMenu [ngClass]=\"{'show': editMenuVisible}\">\n                        <a class=\"dropdown-item\" (click)=\"editTypeSelected('copy')\">{{'QUERY.feature.copyFeatures' |\n                            translateHs : {app} }}</a>\n                        <a class=\"dropdown-item\" (click)=\"editTypeSelected('move')\">{{'QUERY.feature.moveFeatures' |\n                            translateHs : {app} }}</a>\n                    </div>\n                </div>\n                <div class=\"btn-group\" ngbDropdown placement=\"bottom\" display=\"dynamic\">\n                    <button ngbDropdownToggle class=\"btn btn-secondary btn-sm rounded-0\" type=\"button\"\n                        [title]=\"'QUERY.downloadAs' | translateHs : {app} \" (click)=\"toggleExportMenu(app)\"><i\n                            class=\"icon-download\"></i></button>\n                    <div ngbDropdownMenu [ngClass]=\"{'show': exportMenuVisible}\">\n                        <a class=\"dropdown-item\" *ngFor=\"let format of exportFormats\"\n                            download=\"{{format.name}}_file.{{format.ext}}\" [hsDownload]=\"format.serializedData\"\n                            [mimeType]=\"format.mimeType\" [href]=\"format.downloadData\"\n                            (downloadPrepared)=\"format.downloadData = $event\">\n                            {{format.name}}</a>\n                    </div>\n                </div>\n                <button type=\"button\" class=\"btn-danger btn btn-sm border-0\"\n                    [title]=\"'QUERY.deleteAllSelected' | translateHs : {app} \" (click)=\"removeAllSelectedFeatures(app)\">\n                    <i class=\"glyphicon icon-trash\"></i>\n                </button>\n            </div>\n        </div>\n        <div *ngIf=\"editType\" class=\"d-flex p-2 w-100\">\n            <div class=\"d-flex w-100 input-group input-group-sm align-items-baseline\">\n                <label for=\"selectedLayer\" class=\"px-2\">{{translateString('QUERY.feature',editType+'Features')}}\n                    {{'COMMON.into' | translateHs : {app} }}:</label>\n                <select class=\"form-control text-truncate\" [(ngModel)]=\"selectedLayer\" name=\"selectedLayer\"\n                    [title]=\"'ADDLAYERS.Vector.chooseLayer' | translateHs : {app} \">\n                    <option [ngValue]=\"null\" [disabled]=\"true\" selected hidden> {{'ADDLAYERS.Vector.chooseLayer' |\n                        translateHs : {app} }}</option>\n                    <option *ngFor=\"let layer of featureCommonAppRef.availableLayer$ | async\" [ngValue]=\"layer\">\n                        {{getTitle(layer) | translateHs : {app, module: 'LAYERS'} }}</option>\n                </select>\n                <button class=\"btn btn-primary btn-sm\" (click)=\"moveOrCopyFeature(app)\" [disabled]=\"!selectedLayer\"><i\n                        class=\"icon-save-floppy\"></i></button>\n            </div>\n        </div>\n    </div>\n    <div *ngIf=\"selectedFeaturesVisible\">\n        <hs-query-feature *ngFor=\"let item of queryBaseAppRef.features | slice:0:50; trackBy: trackById\" [app]=\"app\"\n            [feature]=\"item\">\n        </hs-query-feature>\n    </div>\n</ng-container>" }]
        }], ctorParameters: function () { return [{ type: HsQueryVectorService }, { type: HsLanguageService }, { type: HsDialogContainerService }, { type: HsFeatureCommonService }, { type: HsLayerUtilsService }, { type: HsQueryBaseService }]; }, propDecorators: { app: [{
                type: Input
            }] } });

class HsDrawComponent extends HsPanelBaseComponent {
    constructor(HsDrawService, hsLayoutService, HsLanguageService, HsQueryBaseService, hsUtilsService, hsSidebarService, HsDialogContainerService, hsConfig) {
        super(hsLayoutService);
        this.HsDrawService = HsDrawService;
        this.hsLayoutService = hsLayoutService;
        this.HsLanguageService = HsLanguageService;
        this.HsQueryBaseService = HsQueryBaseService;
        this.hsUtilsService = hsUtilsService;
        this.hsSidebarService = hsSidebarService;
        this.HsDialogContainerService = HsDialogContainerService;
        this.hsConfig = hsConfig;
        this.name = 'draw';
        this.selectedOption = 'draw';
    }
    ngOnInit() {
        this.appRef = this.HsDrawService.get(this.data.app);
        this.configRef = this.hsConfig.get(this.data.app);
        this.appRef.layerMetadataDialog.subscribe(() => {
            this.HsDialogContainerService.create(HsDrawLayerMetadataDialogComponent, { service: this.HsDrawService, app: this.data.app }, this.data.app);
        });
        this.hsSidebarService.addButton({
            panel: 'draw',
            module: 'hs.draw',
            order: 16,
            fits: true,
            title: 'PANEL_HEADER.DRAW',
            description: 'SIDEBAR.descriptions.DRAW',
            icon: 'icon-pencil',
        }, this.data.app);
        this.HsDrawService.init(this.data.app);
    }
    componentOptionSelected(option) {
        this.selectedOption = option;
        if (this.selectedOption == 'edit') {
            this.HsDrawService.setType(this.appRef.type, this.data.app);
        }
    }
}
HsDrawComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsDrawComponent, deps: [{ token: HsDrawService }, { token: HsLayoutService }, { token: HsLanguageService }, { token: HsQueryBaseService }, { token: HsUtilsService }, { token: HsSidebarService }, { token: HsDialogContainerService }, { token: HsConfig }], target: i0.ɵɵFactoryTarget.Component });
HsDrawComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsDrawComponent, selector: "hs-draw", usesInheritance: true, ngImport: i0, template: "<div class=\"card hs-main-panel\" [hidden]=\"(isVisible$ | async) === false\">\n    <hs-panel-header name=\"draw\" [title]=\"'PANEL_HEADER.DRAW' | translateHs: {app: data.app} \" [app]=\"data.app\">\n        <extra-buttons>\n            <button class=\"but-title-sm\" data-toggle=\"tooltip\" [title]=\"'DRAW.drawInfo' | translateHs: {app: data.app} \">\n                <i class=\"icon-question-sign\"></i>\n            </button>\n        </extra-buttons>\n    </hs-panel-header>\n\n    <!-- draw panel -->\n    <ul class=\"nav nav-tabs justify-content-end my-1\">\n        <li class=\"nav-item\" (click)=\"componentOptionSelected('draw')\">\n            <a [ngClass]=\"{'active': selectedOption === 'draw'}\" class=\"nav-link \"\n                aria-current=\"page\">{{'PANEL_HEADER.DRAW' |\n                translateHs: {app: data.app} }}</a>\n        </li>\n        <li class=\"nav-item\" (click)=\"componentOptionSelected('edit')\">\n            <a [ngClass]=\"{'active': selectedOption === 'edit'}\" class=\"nav-link \" aria-current=\"page\">{{'COMMON.edit' |\n                translateHs: {app: data.app} }}</a>\n        </li>\n    </ul>\n    <hs-draw-panel *ngIf=\"selectedOption === 'draw'\" [app]=\"data.app\"></hs-draw-panel>\n    <hs-draw-edit class=\"my-4 d-flex flex-column align-items-center\" *ngIf=\"selectedOption === 'edit'\" [app]=\"data.app\">\n    </hs-draw-edit>\n    <div *ngIf=\"appRef.pendingLayers.length > 0\" class=\"m-auto w-100 p-3\">\n        <div class=\"alert alert-warning text-justify\">\n            <ol>\n                <li *ngFor=\"let layer of appRef.pendingLayers\">\n                    {{'DRAW.loadingLayer' | translateHs: {app: data.app} }} <strong>{{layer}}</strong>\n                </li>\n            </ol>\n            {{'DRAW.longerLoading' | translateHs: {app: data.app} }}\n            <div class=\"d-flex justify-content-center pt-3\">\n                <img [src]=\"configRef._ajaxLoaderPath\" />\n            </div>\n        </div>\n    </div>\n    <div class=\"mh-75 pt-2\">\n        <hs-query-feature-list [app]=\"data.app\"></hs-query-feature-list>\n    </div>\n</div>", components: [{ type: HsPanelHeaderComponent, selector: "hs-panel-header", inputs: ["name", "app", "title"] }, { type: DrawPanelComponent, selector: "hs-draw-panel", inputs: ["app"] }, { type: DrawEditComponent, selector: "hs-draw-edit", inputs: ["app"] }, { type: HsQueryFeatureListComponent, selector: "hs-query-feature-list", inputs: ["app"] }], directives: [{ type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "async": i3.AsyncPipe, "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsDrawComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-draw', template: "<div class=\"card hs-main-panel\" [hidden]=\"(isVisible$ | async) === false\">\n    <hs-panel-header name=\"draw\" [title]=\"'PANEL_HEADER.DRAW' | translateHs: {app: data.app} \" [app]=\"data.app\">\n        <extra-buttons>\n            <button class=\"but-title-sm\" data-toggle=\"tooltip\" [title]=\"'DRAW.drawInfo' | translateHs: {app: data.app} \">\n                <i class=\"icon-question-sign\"></i>\n            </button>\n        </extra-buttons>\n    </hs-panel-header>\n\n    <!-- draw panel -->\n    <ul class=\"nav nav-tabs justify-content-end my-1\">\n        <li class=\"nav-item\" (click)=\"componentOptionSelected('draw')\">\n            <a [ngClass]=\"{'active': selectedOption === 'draw'}\" class=\"nav-link \"\n                aria-current=\"page\">{{'PANEL_HEADER.DRAW' |\n                translateHs: {app: data.app} }}</a>\n        </li>\n        <li class=\"nav-item\" (click)=\"componentOptionSelected('edit')\">\n            <a [ngClass]=\"{'active': selectedOption === 'edit'}\" class=\"nav-link \" aria-current=\"page\">{{'COMMON.edit' |\n                translateHs: {app: data.app} }}</a>\n        </li>\n    </ul>\n    <hs-draw-panel *ngIf=\"selectedOption === 'draw'\" [app]=\"data.app\"></hs-draw-panel>\n    <hs-draw-edit class=\"my-4 d-flex flex-column align-items-center\" *ngIf=\"selectedOption === 'edit'\" [app]=\"data.app\">\n    </hs-draw-edit>\n    <div *ngIf=\"appRef.pendingLayers.length > 0\" class=\"m-auto w-100 p-3\">\n        <div class=\"alert alert-warning text-justify\">\n            <ol>\n                <li *ngFor=\"let layer of appRef.pendingLayers\">\n                    {{'DRAW.loadingLayer' | translateHs: {app: data.app} }} <strong>{{layer}}</strong>\n                </li>\n            </ol>\n            {{'DRAW.longerLoading' | translateHs: {app: data.app} }}\n            <div class=\"d-flex justify-content-center pt-3\">\n                <img [src]=\"configRef._ajaxLoaderPath\" />\n            </div>\n        </div>\n    </div>\n    <div class=\"mh-75 pt-2\">\n        <hs-query-feature-list [app]=\"data.app\"></hs-query-feature-list>\n    </div>\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsDrawService }, { type: HsLayoutService }, { type: HsLanguageService }, { type: HsQueryBaseService }, { type: HsUtilsService }, { type: HsSidebarService }, { type: HsDialogContainerService }, { type: HsConfig }]; } });

class HsToolbarPanelBaseComponent {
    constructor(hsLayoutService) {
        this.hsLayoutService = hsLayoutService;
        this.isVisible$ = new BehaviorSubject(false);
    }
    isVisible() {
        return this.hsLayoutService.componentEnabled(this.name, this.data.app);
    }
}
HsToolbarPanelBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsToolbarPanelBaseComponent, deps: [{ token: HsLayoutService }], target: i0.ɵɵFactoryTarget.Component });
HsToolbarPanelBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsToolbarPanelBaseComponent, selector: "ng-component", ngImport: i0, template: '<div></div>', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsToolbarPanelBaseComponent, decorators: [{
            type: Component,
            args: [{
                    template: '<div></div>',
                }]
        }], ctorParameters: function () { return [{ type: HsLayoutService }]; } });

class HsDrawToolbarComponent extends HsToolbarPanelBaseComponent {
    constructor(HsDrawService, HsLayoutService, HsLayerUtilsService, //Used in template
    HsConfig, HsLanguageService) {
        super(HsLayoutService);
        this.HsDrawService = HsDrawService;
        this.HsLayoutService = HsLayoutService;
        this.HsLayerUtilsService = HsLayerUtilsService;
        this.HsConfig = HsConfig;
        this.HsLanguageService = HsLanguageService;
        this.drawToolbarExpanded = false;
        this.onlyMineFilterVisible = false;
        this.name = 'drawToolbar';
        this.getTitle = getTitle;
    }
    ngOnInit() {
        this.appRef = this.HsDrawService.get(this.data.app);
        this.HsLayoutService.sidebarPosition.subscribe(({ app, position }) => {
            if (this.data.app == app) {
                this.sidebarPosition = position;
            }
        });
    }
    selectionMenuToggled() {
        this.setType(this.appRef.type);
    }
    translateString(module, text) {
        return this.HsLanguageService.getTranslationIgnoreNonExisting(module, text);
    }
    toggleDrawToolbar(app) {
        this.appRef.highlightDrawButton = false;
        if (this.HsLayoutService.get(app).layoutElement.clientWidth > 767 &&
            this.HsLayoutService.get(app).layoutElement.clientWidth < 870 &&
            !this.drawToolbarExpanded) {
            this.HsLayoutService.get(app).sidebarExpanded = false;
        }
        this.drawToolbarExpanded = !this.drawToolbarExpanded;
        if (!this.drawToolbarExpanded) {
            this.HsDrawService.stopDrawing(this.data.app);
        }
        this.HsDrawService.fillDrawableLayers(this.data.app);
    }
    selectLayer(layer) {
        this.HsDrawService.selectLayer(layer, this.data.app);
    }
    controlLayerListAction() {
        if (!this.appRef.hasSomeDrawables && this.appRef.tmpDrawLayer) {
            this.HsDrawService.saveDrawingLayer(this.data.app);
        }
    }
    setType(what) {
        const type = this.HsDrawService.setType(what, this.data.app);
        if (type) {
            this.HsDrawService.activateDrawing({}, this.data.app);
        }
    }
    finishDrawing() {
        this.HsDrawService.stopDrawing(this.data.app);
    }
}
HsDrawToolbarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsDrawToolbarComponent, deps: [{ token: HsDrawService }, { token: HsLayoutService }, { token: HsLayerUtilsService }, { token: HsConfig }, { token: HsLanguageService }], target: i0.ɵɵFactoryTarget.Component });
HsDrawToolbarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsDrawToolbarComponent, selector: "hs-draw-toolbar", usesInheritance: true, ngImport: i0, template: "<div class=\"btn-group\" [hidden]=\"(isVisible$ | async) === false\">\n    <button class=\"btn rounded-0 btn-light hs-toolbar-button\"\n        [ngClass]=\"appRef.highlightDrawButton ? 'btn-outline-danger' : 'btn-outline-secondary'\"\n        (click)=\"toggleDrawToolbar(data.app)\">\n        <i [ngClass]=\"{'icon-pencil':!drawToolbarExpanded, 'icon-remove':drawToolbarExpanded}\" data-toggle=\"tooltip\"\n            [title]=\"'PANEL_HEADER.DRAW' | translateHs: {app: data.app} \"></i></button>\n    <div class=\"btn-group\" *ngIf=\"drawToolbarExpanded\">\n        <div class=\"btn-group\" ngbDropdown placement=\"bottom-left\" display=\"dynamic\">\n            <button type=\"button\" ngbDropdownToggle\n                class=\"btn btn-light rounded-0 btn-secondary dropdown-toggle hs-draw-layer-toggle d-flex align-items-center\"\n                [hidden]=\"!(appRef.hasSomeDrawables || appRef.tmpDrawLayer)\"\n                (click)=\"controlLayerListAction(); HsDrawService.fillDrawableLayers(data.app) \"\n                style=\"max-width: 125px; overflow: hidden; font-size: smaller; z-index: 2;\"\n                [ngClass]=\"appRef.tmpDrawLayer ? 'btn-outline-danger' : 'btn-outline-primary'\">\n                <div class=\"text-truncate pe-1\">{{HsDrawService.selectedLayerString(data.app)}}</div>\n            </button>\n            <div ngbDropdownMenu class=\"dropdown-menu\" style=\"max-width: 20em;\">\n                <div class=\"d-flex align-items-center w-100 flex-column\" *ngIf=\"appRef.drawableLayers.length > 0\">\n                    <label class=\" bg-primary w-100 text-light m-0 p-1\">{{'DRAW.activeLayers' | translateHs: {app: data.app} \n                        }}</label>\n                    <a class=\"dropdown-item text-truncate\" *ngFor=\"let layer of appRef.drawableLayers\"\n                        (click)=\"selectLayer(layer)\">{{getTitle(layer) | translateHs : {app: data.app, module: 'LAYERS'} }}</a>\n                </div>\n                <div class=\"d-flex align-items-center w-100 flex-column\" *ngIf=\"appRef.drawableLaymanLayers.length > 0\">\n                    <div class=\" bg-primary w-100 text-light m-0 p-1\">\n                        <div class=\"d-flex justify-content-between\">\n                            {{'DRAW.serverLayers' | translateHs: {app: data.app} }}\n                            <span (click)=\"onlyMineFilterVisible = !onlyMineFilterVisible\" style=\"cursor: pointer;\">\n                                <i class=\"icon-settingsthree-gears\"></i>\n                            </span>\n                        </div>\n                        <div class=\"p-0 input-group-text border-0 justify-content-center bg-white\"\n                            *ngIf=\"onlyMineFilterVisible\">\n                            <label class=\"m-0\">\n                                <input type=\"checkbox\" name=\"onlyMine\" [(ngModel)]=\"appRef.onlyMine\"\n                                    (ngModelChange)=\"HsDrawService.fillDrawableLayers(data.app); onlyMineFilterVisible = !onlyMineFilterVisible\">\n                                {{'COMPOSITIONS.onlyMine' | translateHs: {app: data.app} }}\n                            </label>\n                        </div>\n                    </div>\n                    <a class=\"dropdown-item  text-truncate\" *ngFor=\"let layer of appRef.drawableLaymanLayers\"\n                        (click)=\"selectLayer(layer)\">{{layer.title | translateHs : {app: data.app, module: 'LAYERS'} }}</a>\n                </div>\n            </div>\n        </div>\n\n        <button class=\"btn btn-light hs-toolbar-button btn-outline-secondary\" [hidden]=\"appRef.tmpDrawLayer\"\n            (click)=\"HsDrawService.saveDrawingLayer(data.app)\" data-toggle=\"tooltip\"\n            [title]=\"'DRAW.drawToolbar.addDrawLayer' | translateHs: {app: data.app} \">\n            <i class=\"icon-plus\"></i></button>\n        <button type=\"button\" *ngIf=\"appRef.tmpDrawLayer\"\n            class=\"btn btn-light  hs-toolbar-button  btn-outline-secondary\"\n            (click)=\"HsDrawService.saveDrawingLayer(data.app)\" [title]=\"'DRAW.saveDrawingToLayer' | translateHs: {app: data.app} \">\n            <i class=\"glyphicon icon-save-floppy\"></i>\n        </button>\n        <ng-container *ngIf=\"appRef.hasSomeDrawables\">\n            <ng-container *ngIf=\"appRef.moreThenOneDrawable === true; else deleteButton\">\n                <div class=\"btn-group\">\n                    <div ngbDropdown placement=\"bottom-right\" display=\"dynamic\" style=\"white-space: nowrap;\"\n                        #removeLayersDropdown=\"ngbDropdown\">\n                        <button type=\"button\" ngbDropdownToggle\n                            class=\"btn btn-light hs-toolbar-button rounded-0 btn-outline-secondary\">\n                            <i class=\"glyphicon icon-trash\"></i>\n                        </button>\n                        <div ngbDropdownMenu class=\"flex-column px-1 py-2\">\n                            <div class=\"d-flex align-items-center w-100 flex-column\">\n                                <a class=\"dropdown-item\" *ngIf=\"appRef.selectedLayer\"\n                                    (click)=\"HsDrawService.removeLayer(data.app); removeLayersDropdown.close()\">{{'COMMON.removeLayer'\n                                    |\n                                    translateHs: {app: data.app} }}</a>\n                                <a class=\"dropdown-item\"\n                                    (click)=\"HsDrawService.removeMultipleLayers(data.app); removeLayersDropdown.close()\">{{'DRAW.removeMultipleLayers'\n                                    | translateHs: {app: data.app} }}</a>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </ng-container>\n            <ng-template #deleteButton>\n                <button type=\"button\" class=\"btn btn-light hs-toolbar-button rounded-0 btn-outline-secondary\"\n                    (click)=\"HsDrawService.removeLayer(data.app)\" [title]=\"'COMMON.removeLayer' | translateHs: {app: data.app} \">\n                    <i class=\"glyphicon icon-trash\"></i>\n                </button>\n            </ng-template>\n        </ng-container>\n        <div class=\"btn-group\">\n            <div ngbDropdown placement=\"bottom-right\" display=\"dynamic\" style=\"white-space: nowrap;\"\n                #selectionTypeDropdown=\"ngbDropdown\">\n                <button type=\"button\" ngbDropdownToggle [ngClass]=\"{active: !appRef.type }\"\n                    [title]=\"'STYLER.selection' | translateHs: {app: data.app} \"\n                    class=\"btn btn-light hs-toolbar-button btn-outline-secondary rounded-0\"\n                    (click)=\"$event.preventDefault(); selectionMenuToggled()\">\n                    <i class=\"icon-cursor\"></i>\n                </button>\n                <div ngbDropdownMenu class=\"flex-column px-1 py-2\">\n                    <div class=\"d-flex flex-row justify-content-around align-items-baseline\">\n                        <label class=\"ms-1 cursor-pointer\" for=\"draw-boxSelection\"> {{'DRAW.boxSelection' |\n                            translateHs: {app: data.app} }}</label>\n                        <input type=\"checkbox\" [(ngModel)]=\"appRef.boxSelectionActive\"\n                            (change)=\"HsDrawService.toggleBoxSelection(data.app); selectionTypeDropdown.close()\"\n                            id=\"draw-boxSelection\" name=\"filterByExtent\" class=\"cursor-pointer\">\n                    </div>\n                    <button class=\"btn btn-primary btn-sm hs-draw-selectAll w-100\" [disabled]=\"!appRef.selectedLayer\"\n                        (click)=\"HsDrawService.selectAllFeatures(data.app); selectionTypeDropdown.close()\"\n                        data-toggle=\"tooltip\" [title]=\"'STYLER.selection' | translateHs: {app: data.app} \">\n                        {{translateString('DRAW',appRef.toggleSelectionString)}}<!-- TODO: Remove function call from template -->\n                    </button>\n                </div>\n            </div>\n        </div>\n        <div class=\"btn-group\" ngbDropdown placement=\"bottom\" display=\"dynamic\" *ngIf=\"drawToolbarExpanded\"\n            #geometryTypeDropdown=\"ngbDropdown\">\n            <div style=\"top: 35vh;\" role=\"group\" class=\"btn-group-vertical position-fixed d-flex flex-column\"\n                [ngStyle]=\"sidebarPosition === 'right' || sidebarPosition === 'bottom' ? {'left': 0} : {'right': 0} \">\n                <button class=\"btn btn-secondary\" *ngIf=\"appRef.drawActive\"\n                    (click)=\"HsDrawService.removeLastPoint(data.app)\" data-toggle=\"tooltip\"\n                    [title]=\"'DRAW.drawToolbar.removeLastPoint' | translateHs: {app: data.app} \">\n                    <i class=\"icon-remove-circle\"></i></button>\n                <button class=\"btn btn-secondary\" *ngIf=\"appRef.drawActive\" (click)=\"finishDrawing()\"\n                    data-toggle=\"tooltip\" [title]=\"'DRAW.drawToolbar.finishFeature' | translateHs: {app: data.app} \">\n                    <i class=\"icon-check\"></i></button>\n            </div>\n            <button ngbDropdownToggle type=\"button\" style=\"line-height: 1 !important;\"\n                [ngClass]=\"{active: appRef.type }\" class=\"btn  btn-light rounded-0 btn-outline-secondary\"\n                aria-haspopup=\"true\">\n                <label *ngIf=\"!appRef.type\" class=\"m-0\">{{'DRAW.drawToolbar.selectType' | translateHs: {app: data.app} }}</label>\n                <i [ngClass]=\"{\n                    'icon-pin': appRef.type==='Point',\n                    'icon-polygonlasso': appRef.type==='Polygon',\n                    'icon-line': appRef.type==='LineString'\n                }\"></i>\n            </button>\n            <div ngbDropdownMenu class=\"p-0\" style=\"min-width: unset;\">\n                <div class=\"btn-group\">\n                    <button class=\"btn btn-light hs-toolbar-button btn-outline-secondary\"\n                        [ngClass]=\"{active: appRef.type==='Point' }\"\n                        (click)=\"setType('Point'); geometryTypeDropdown.close()\" data-toggle=\"tooltip\"\n                        [title]=\"'COMMON.point' | translateHs: {app: data.app} \"><i class=\"icon-pin\"></i></button>\n                    <button class=\"btn btn-light hs-toolbar-button btn-outline-secondary\"\n                        [ngClass]=\"{active: appRef.type==='Polygon' }\"\n                        (click)=\"setType('Polygon'); geometryTypeDropdown.close()\" data-toggle=\"tooltip\"\n                        [title]=\"'COMMON.polygon' | translateHs: {app: data.app} \"><i class=\"icon-polygonlasso\"></i></button>\n                    <button class=\"btn btn-light hs-toolbar-button btn-outline-secondary\"\n                        [ngClass]=\"{active: appRef.type==='LineString' }\"\n                        (click)=\"setType('LineString'); geometryTypeDropdown.close()\" data-toggle=\"tooltip\"\n                        [title]=\"'COMMON.line' | translateHs: {app: data.app} \">\n                        <i class=\"icon-line\"></i></button>\n                </div>\n            </div>\n        </div>\n    </div>\n\n</div>", directives: [{ type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i7.NgbDropdown, selector: "[ngbDropdown]", inputs: ["autoClose", "dropdownClass", "open", "placement", "container", "display"], outputs: ["openChange"], exportAs: ["ngbDropdown"] }, { type: i7.NgbDropdownToggle, selector: "[ngbDropdownToggle]" }, { type: i7.NgbDropdownMenu, selector: "[ngbDropdownMenu]" }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3$1.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }], pipes: { "async": i3.AsyncPipe, "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsDrawToolbarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-draw-toolbar', template: "<div class=\"btn-group\" [hidden]=\"(isVisible$ | async) === false\">\n    <button class=\"btn rounded-0 btn-light hs-toolbar-button\"\n        [ngClass]=\"appRef.highlightDrawButton ? 'btn-outline-danger' : 'btn-outline-secondary'\"\n        (click)=\"toggleDrawToolbar(data.app)\">\n        <i [ngClass]=\"{'icon-pencil':!drawToolbarExpanded, 'icon-remove':drawToolbarExpanded}\" data-toggle=\"tooltip\"\n            [title]=\"'PANEL_HEADER.DRAW' | translateHs: {app: data.app} \"></i></button>\n    <div class=\"btn-group\" *ngIf=\"drawToolbarExpanded\">\n        <div class=\"btn-group\" ngbDropdown placement=\"bottom-left\" display=\"dynamic\">\n            <button type=\"button\" ngbDropdownToggle\n                class=\"btn btn-light rounded-0 btn-secondary dropdown-toggle hs-draw-layer-toggle d-flex align-items-center\"\n                [hidden]=\"!(appRef.hasSomeDrawables || appRef.tmpDrawLayer)\"\n                (click)=\"controlLayerListAction(); HsDrawService.fillDrawableLayers(data.app) \"\n                style=\"max-width: 125px; overflow: hidden; font-size: smaller; z-index: 2;\"\n                [ngClass]=\"appRef.tmpDrawLayer ? 'btn-outline-danger' : 'btn-outline-primary'\">\n                <div class=\"text-truncate pe-1\">{{HsDrawService.selectedLayerString(data.app)}}</div>\n            </button>\n            <div ngbDropdownMenu class=\"dropdown-menu\" style=\"max-width: 20em;\">\n                <div class=\"d-flex align-items-center w-100 flex-column\" *ngIf=\"appRef.drawableLayers.length > 0\">\n                    <label class=\" bg-primary w-100 text-light m-0 p-1\">{{'DRAW.activeLayers' | translateHs: {app: data.app} \n                        }}</label>\n                    <a class=\"dropdown-item text-truncate\" *ngFor=\"let layer of appRef.drawableLayers\"\n                        (click)=\"selectLayer(layer)\">{{getTitle(layer) | translateHs : {app: data.app, module: 'LAYERS'} }}</a>\n                </div>\n                <div class=\"d-flex align-items-center w-100 flex-column\" *ngIf=\"appRef.drawableLaymanLayers.length > 0\">\n                    <div class=\" bg-primary w-100 text-light m-0 p-1\">\n                        <div class=\"d-flex justify-content-between\">\n                            {{'DRAW.serverLayers' | translateHs: {app: data.app} }}\n                            <span (click)=\"onlyMineFilterVisible = !onlyMineFilterVisible\" style=\"cursor: pointer;\">\n                                <i class=\"icon-settingsthree-gears\"></i>\n                            </span>\n                        </div>\n                        <div class=\"p-0 input-group-text border-0 justify-content-center bg-white\"\n                            *ngIf=\"onlyMineFilterVisible\">\n                            <label class=\"m-0\">\n                                <input type=\"checkbox\" name=\"onlyMine\" [(ngModel)]=\"appRef.onlyMine\"\n                                    (ngModelChange)=\"HsDrawService.fillDrawableLayers(data.app); onlyMineFilterVisible = !onlyMineFilterVisible\">\n                                {{'COMPOSITIONS.onlyMine' | translateHs: {app: data.app} }}\n                            </label>\n                        </div>\n                    </div>\n                    <a class=\"dropdown-item  text-truncate\" *ngFor=\"let layer of appRef.drawableLaymanLayers\"\n                        (click)=\"selectLayer(layer)\">{{layer.title | translateHs : {app: data.app, module: 'LAYERS'} }}</a>\n                </div>\n            </div>\n        </div>\n\n        <button class=\"btn btn-light hs-toolbar-button btn-outline-secondary\" [hidden]=\"appRef.tmpDrawLayer\"\n            (click)=\"HsDrawService.saveDrawingLayer(data.app)\" data-toggle=\"tooltip\"\n            [title]=\"'DRAW.drawToolbar.addDrawLayer' | translateHs: {app: data.app} \">\n            <i class=\"icon-plus\"></i></button>\n        <button type=\"button\" *ngIf=\"appRef.tmpDrawLayer\"\n            class=\"btn btn-light  hs-toolbar-button  btn-outline-secondary\"\n            (click)=\"HsDrawService.saveDrawingLayer(data.app)\" [title]=\"'DRAW.saveDrawingToLayer' | translateHs: {app: data.app} \">\n            <i class=\"glyphicon icon-save-floppy\"></i>\n        </button>\n        <ng-container *ngIf=\"appRef.hasSomeDrawables\">\n            <ng-container *ngIf=\"appRef.moreThenOneDrawable === true; else deleteButton\">\n                <div class=\"btn-group\">\n                    <div ngbDropdown placement=\"bottom-right\" display=\"dynamic\" style=\"white-space: nowrap;\"\n                        #removeLayersDropdown=\"ngbDropdown\">\n                        <button type=\"button\" ngbDropdownToggle\n                            class=\"btn btn-light hs-toolbar-button rounded-0 btn-outline-secondary\">\n                            <i class=\"glyphicon icon-trash\"></i>\n                        </button>\n                        <div ngbDropdownMenu class=\"flex-column px-1 py-2\">\n                            <div class=\"d-flex align-items-center w-100 flex-column\">\n                                <a class=\"dropdown-item\" *ngIf=\"appRef.selectedLayer\"\n                                    (click)=\"HsDrawService.removeLayer(data.app); removeLayersDropdown.close()\">{{'COMMON.removeLayer'\n                                    |\n                                    translateHs: {app: data.app} }}</a>\n                                <a class=\"dropdown-item\"\n                                    (click)=\"HsDrawService.removeMultipleLayers(data.app); removeLayersDropdown.close()\">{{'DRAW.removeMultipleLayers'\n                                    | translateHs: {app: data.app} }}</a>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </ng-container>\n            <ng-template #deleteButton>\n                <button type=\"button\" class=\"btn btn-light hs-toolbar-button rounded-0 btn-outline-secondary\"\n                    (click)=\"HsDrawService.removeLayer(data.app)\" [title]=\"'COMMON.removeLayer' | translateHs: {app: data.app} \">\n                    <i class=\"glyphicon icon-trash\"></i>\n                </button>\n            </ng-template>\n        </ng-container>\n        <div class=\"btn-group\">\n            <div ngbDropdown placement=\"bottom-right\" display=\"dynamic\" style=\"white-space: nowrap;\"\n                #selectionTypeDropdown=\"ngbDropdown\">\n                <button type=\"button\" ngbDropdownToggle [ngClass]=\"{active: !appRef.type }\"\n                    [title]=\"'STYLER.selection' | translateHs: {app: data.app} \"\n                    class=\"btn btn-light hs-toolbar-button btn-outline-secondary rounded-0\"\n                    (click)=\"$event.preventDefault(); selectionMenuToggled()\">\n                    <i class=\"icon-cursor\"></i>\n                </button>\n                <div ngbDropdownMenu class=\"flex-column px-1 py-2\">\n                    <div class=\"d-flex flex-row justify-content-around align-items-baseline\">\n                        <label class=\"ms-1 cursor-pointer\" for=\"draw-boxSelection\"> {{'DRAW.boxSelection' |\n                            translateHs: {app: data.app} }}</label>\n                        <input type=\"checkbox\" [(ngModel)]=\"appRef.boxSelectionActive\"\n                            (change)=\"HsDrawService.toggleBoxSelection(data.app); selectionTypeDropdown.close()\"\n                            id=\"draw-boxSelection\" name=\"filterByExtent\" class=\"cursor-pointer\">\n                    </div>\n                    <button class=\"btn btn-primary btn-sm hs-draw-selectAll w-100\" [disabled]=\"!appRef.selectedLayer\"\n                        (click)=\"HsDrawService.selectAllFeatures(data.app); selectionTypeDropdown.close()\"\n                        data-toggle=\"tooltip\" [title]=\"'STYLER.selection' | translateHs: {app: data.app} \">\n                        {{translateString('DRAW',appRef.toggleSelectionString)}}<!-- TODO: Remove function call from template -->\n                    </button>\n                </div>\n            </div>\n        </div>\n        <div class=\"btn-group\" ngbDropdown placement=\"bottom\" display=\"dynamic\" *ngIf=\"drawToolbarExpanded\"\n            #geometryTypeDropdown=\"ngbDropdown\">\n            <div style=\"top: 35vh;\" role=\"group\" class=\"btn-group-vertical position-fixed d-flex flex-column\"\n                [ngStyle]=\"sidebarPosition === 'right' || sidebarPosition === 'bottom' ? {'left': 0} : {'right': 0} \">\n                <button class=\"btn btn-secondary\" *ngIf=\"appRef.drawActive\"\n                    (click)=\"HsDrawService.removeLastPoint(data.app)\" data-toggle=\"tooltip\"\n                    [title]=\"'DRAW.drawToolbar.removeLastPoint' | translateHs: {app: data.app} \">\n                    <i class=\"icon-remove-circle\"></i></button>\n                <button class=\"btn btn-secondary\" *ngIf=\"appRef.drawActive\" (click)=\"finishDrawing()\"\n                    data-toggle=\"tooltip\" [title]=\"'DRAW.drawToolbar.finishFeature' | translateHs: {app: data.app} \">\n                    <i class=\"icon-check\"></i></button>\n            </div>\n            <button ngbDropdownToggle type=\"button\" style=\"line-height: 1 !important;\"\n                [ngClass]=\"{active: appRef.type }\" class=\"btn  btn-light rounded-0 btn-outline-secondary\"\n                aria-haspopup=\"true\">\n                <label *ngIf=\"!appRef.type\" class=\"m-0\">{{'DRAW.drawToolbar.selectType' | translateHs: {app: data.app} }}</label>\n                <i [ngClass]=\"{\n                    'icon-pin': appRef.type==='Point',\n                    'icon-polygonlasso': appRef.type==='Polygon',\n                    'icon-line': appRef.type==='LineString'\n                }\"></i>\n            </button>\n            <div ngbDropdownMenu class=\"p-0\" style=\"min-width: unset;\">\n                <div class=\"btn-group\">\n                    <button class=\"btn btn-light hs-toolbar-button btn-outline-secondary\"\n                        [ngClass]=\"{active: appRef.type==='Point' }\"\n                        (click)=\"setType('Point'); geometryTypeDropdown.close()\" data-toggle=\"tooltip\"\n                        [title]=\"'COMMON.point' | translateHs: {app: data.app} \"><i class=\"icon-pin\"></i></button>\n                    <button class=\"btn btn-light hs-toolbar-button btn-outline-secondary\"\n                        [ngClass]=\"{active: appRef.type==='Polygon' }\"\n                        (click)=\"setType('Polygon'); geometryTypeDropdown.close()\" data-toggle=\"tooltip\"\n                        [title]=\"'COMMON.polygon' | translateHs: {app: data.app} \"><i class=\"icon-polygonlasso\"></i></button>\n                    <button class=\"btn btn-light hs-toolbar-button btn-outline-secondary\"\n                        [ngClass]=\"{active: appRef.type==='LineString' }\"\n                        (click)=\"setType('LineString'); geometryTypeDropdown.close()\" data-toggle=\"tooltip\"\n                        [title]=\"'COMMON.line' | translateHs: {app: data.app} \">\n                        <i class=\"icon-line\"></i></button>\n                </div>\n            </div>\n        </div>\n    </div>\n\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsDrawService }, { type: HsLayoutService }, { type: HsLayerUtilsService }, { type: HsConfig }, { type: HsLanguageService }]; } });

class FeatureTableServiceParams {
    constructor() {
        this.sortReverse = false; //trigger for reverse sorting
        this.lastSortValue = ''; //last sorting value selected
        this.features = []; //all feature attributes for html table
    }
}
class HsFeatureTableService {
    constructor(hsUtilsService, hsLayerUtilsService, hsQueryVectorService, hsLanguageService) {
        this.hsUtilsService = hsUtilsService;
        this.hsLayerUtilsService = hsLayerUtilsService;
        this.hsQueryVectorService = hsQueryVectorService;
        this.hsLanguageService = hsLanguageService;
        this.apps = { default: new FeatureTableServiceParams() };
    }
    /**
     * Get the params saved by the feature table service for the current app
     * @param app - App identifier
     */
    get(app) {
        if (this.apps[app !== null && app !== void 0 ? app : 'default'] == undefined) {
            this.apps[app !== null && app !== void 0 ? app : 'default'] = new FeatureTableServiceParams();
        }
        return this.apps[app !== null && app !== void 0 ? app : 'default'];
    }
    /**
     * @param layer - Layer from HsConfig.get(app).layersInFeatureTable
     * Checks if layer is vectorLayer and is visible in layer_manager, to exclude layers, such as, point Clicked
     * @returns Returns layer
     */
    addLayer(layer) {
        if (!getBase(layer) &&
            this.hsUtilsService.instOf(layer, Vector$1) &&
            (getShowInLayerManager(layer) === undefined ||
                getShowInLayerManager(layer) == true)) {
            return this.wrapLayer(layer);
        }
        return;
    }
    /**
     * @param layer - Layer from HsConfig.get(app).layersInFeatureTable
     * Wrap layer object
     * @returns Returns wrapped layer object
     */
    wrapLayer(layer) {
        return {
            title: getTitle(layer),
            lyr: layer,
            type: 'vector',
        };
    }
    /**
     * @param layer - Layer from HsConfig.get(app).layersInFeatureTable
     * @param app - App identifier
     * Search all layers feature attributes and map them into new objects for html table
     */
    fillFeatureList(layer, app) {
        const source = this.hsLayerUtilsService.isLayerClustered(layer)
            ? layer.getSource().getSource()
            : layer.getSource();
        this.get(app).features = source
            .getFeatures()
            .map((f) => this.describeFeature(f, app))
            .filter((f) => { var _a; return ((_a = f === null || f === void 0 ? void 0 : f.attributes) === null || _a === void 0 ? void 0 : _a.length) > 0; });
    }
    /**
     * @param feature - Feature selected
     * @param app - App identifier
     * Update feature description
     */
    updateFeatureDescription(feature, app) {
        const appRef = this.get(app);
        const newDescriptor = this.describeFeature(feature, app);
        const currentIx = appRef.features.findIndex((f) => f.feature == feature);
        if (newDescriptor && currentIx > -1) {
            appRef.features[currentIx] = newDescriptor;
        }
    }
    /**
     * @param feature - Feature selected
     * @param app - App identifier
     * Add feature description
     */
    addFeatureDescription(feature, app) {
        const newDescriptor = this.describeFeature(feature, app);
        if (newDescriptor) {
            this.get(app).features.push(newDescriptor);
        }
    }
    /**
     * @param feature - Feature selected
     * @param app - App identifier
     * Remove feature description
     */
    removeFeatureDescription(feature, app) {
        const appRef = this.get(app);
        const currentIx = appRef.features.findIndex((f) => f.feature == feature);
        if (currentIx > -1) {
            appRef.features.splice(currentIx, 1);
        }
    }
    /**
     * @param feature - Feature selected
     * @param app - App identifier
     * Describe feature
     */
    describeFeature(feature, app) {
        const attribWrapper = this.hsQueryVectorService
            .getFeatureAttributes(feature, app)
            .pop();
        if (!attribWrapper) {
            return null;
        }
        return {
            name: this.setFeatureName(attribWrapper.attributes),
            feature,
            attributes: this.attributesWithoutFeatureName(attribWrapper.attributes),
            stats: attribWrapper.stats,
        };
    }
    /**
     * @param attributes - layers feature attributes
     * Find feature name attribute and seperate it from other attributes for html table purposes
     * @returns feature name
     */
    setFeatureName(attributes) {
        if (attributes.length > 0) {
            let name = 'Feature';
            for (const attribute of attributes) {
                if (attribute.name === 'name') {
                    name = attribute.value;
                }
            }
            return name;
        }
        else {
            return 'Feature';
        }
    }
    /**
     * @param attributes - layers feature attributes
     * Remove feature name attribute from feature attributes array
     * @returns feature attributes
     */
    attributesWithoutFeatureName(attributes) {
        return attributes.filter((attr) => attr.name !== 'name');
    }
    /**
     * @param valueName - Requested value to sort the feature table list
     * @param app - App identifier
     * Sort features by requested value
     */
    sortFeaturesBy(valueName, app) {
        const appRef = this.get(app);
        if (appRef.features !== undefined && appRef.features.length > 1) {
            appRef.lastSortValue === valueName //if last sort by value is the same as current sort table list in reverse
                ? (appRef.sortReverse = !appRef.sortReverse)
                : (appRef.sortReverse = false);
            appRef.features = appRef.features.sort((a, b) => this.sortFeatures(a, b, valueName, app));
        }
    }
    /**
     * @param a - First input feature
     * @param b - second input feature
     * @param valueName - Sorting value
     * @param app - App identifier
     * Sorting algorithm
     * @returns Returns each features relative position in the table
     */
    sortFeatures(a, b, valueName, app) {
        const appRef = this.get(app);
        let aFeature, bFeature;
        let position;
        if (valueName === 'name') {
            //check if table is being sorted by name
            aFeature = a[valueName];
            bFeature = b[valueName];
        }
        else {
            aFeature = this.getValue(a.attributes, valueName); //get requested attribute value
            bFeature = this.getValue(b.attributes, valueName);
        }
        if (aFeature === null) {
            position = 1;
        }
        if (bFeature === null) {
            position = -1;
        }
        if (typeof aFeature == 'string' && typeof bFeature == 'string') {
            position =
                aFeature.charAt(0) > bFeature.charAt(0)
                    ? 1
                    : aFeature.charAt(0) < bFeature.charAt(0)
                        ? -1
                        : 0;
        }
        if (typeof aFeature == 'number' && typeof bFeature == 'number') {
            position = aFeature - bFeature;
        }
        appRef.sortReverse ? (position = position * -1) : position;
        appRef.lastSortValue = valueName;
        return position;
    }
    /**
     * @param attributes - features attributes
     * @param valueName - Sorting value
     * Get requested features attribute value, which will be used in the sorting algorithm
     * @returns Returns attributes value
     */
    getValue(attributes, valueName) {
        let value = attributes //get requested attribute value
            .filter((attr) => attr.name == valueName)
            .map((attr) => attr.value);
        if (value.length == 0 || value === undefined) {
            value = null;
        }
        else {
            value = value[0];
        }
        return value;
    }
}
HsFeatureTableService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsFeatureTableService, deps: [{ token: HsUtilsService }, { token: HsLayerUtilsService }, { token: HsQueryVectorService }, { token: HsLanguageService }], target: i0.ɵɵFactoryTarget.Injectable });
HsFeatureTableService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsFeatureTableService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsFeatureTableService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsUtilsService }, { type: HsLayerUtilsService }, { type: HsQueryVectorService }, { type: HsLanguageService }]; } });

const featureLimit = 20;
class HsFeatureFilterPipe {
    /**
     * Transform
     *
     * @param features -
     * @param searchText -
     * @returns Filtered features
     */
    transform(features, searchText) {
        if (!features) {
            return [];
        }
        if (!searchText) {
            return features;
        }
        searchText = searchText.toLocaleLowerCase();
        return features
            .filter((feature) => {
            return feature.name.toLocaleLowerCase().includes(searchText);
        })
            .slice(0, featureLimit);
    }
}
HsFeatureFilterPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsFeatureFilterPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
HsFeatureFilterPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsFeatureFilterPipe, name: "featureFilter" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsFeatureFilterPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'featureFilter' }]
        }] });

class HsLayerFeaturesComponent {
    constructor(hsFeatureTableService, hsUtilsService, hsMapService, hsLanguageService, hsLayerUtilsService //Used in template
    ) {
        this.hsFeatureTableService = hsFeatureTableService;
        this.hsUtilsService = hsUtilsService;
        this.hsMapService = hsMapService;
        this.hsLanguageService = hsLanguageService;
        this.hsLayerUtilsService = hsLayerUtilsService;
        this.app = 'default';
        this.showFeatureStats = false; //Toggle for showing feature statistics
        this.searchedFeatures = '';
    }
    /**
     * Activate listeners for any layer source changes to update the html table
     */
    ngOnInit() {
        const olLayer = this.layer.lyr;
        const source = this.hsLayerUtilsService.isLayerClustered(olLayer)
            ? olLayer.getSource().getSource()
            : olLayer.getSource();
        if (source) {
            this.hsFeatureTableService.fillFeatureList(olLayer, this.app);
            source.on('changefeature', (e) => {
                this.hsFeatureTableService.updateFeatureDescription(e.feature, this.app);
            });
            source.on('addfeature', (e) => {
                this.hsFeatureTableService.addFeatureDescription(e.feature, this.app);
            });
            source.on('removefeature', (e) => {
                this.hsFeatureTableService.removeFeatureDescription(e.feature, this.app);
            });
        }
        this.appRef = this.hsFeatureTableService.get(this.app);
    }
    /**
     * @param operation - Action for html table
     * @public
     * zoom to feature from html table after triggering zoom action
     */
    executeOperation(operation) {
        switch (operation.action) {
            case 'zoom to':
                const extent = operation.feature.getGeometry().getExtent();
                this.hsMapService.fitExtent(extent, this.app);
                break;
            case 'custom action':
                operation.customAction(operation.feature);
                break;
            default:
        }
    }
    /**
     * @param text - Text to translate to locale
     * @param app - App identifier
     * Translate provided text to selected locale language
     * @returns Returns translation
     */
    translate(text) {
        const translation = this.hsLanguageService.getTranslationIgnoreNonExisting('FEATURE_TABLE', text, undefined, this.app);
        return translation;
    }
    /**
     * @param name - Sort value
     * Sort features by value
     */
    sortFeaturesBy(name) {
        this.hsFeatureTableService.sortFeaturesBy(name, this.app);
    }
}
HsLayerFeaturesComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerFeaturesComponent, deps: [{ token: HsFeatureTableService }, { token: HsUtilsService }, { token: HsMapService }, { token: HsLanguageService }, { token: HsLayerUtilsService }], target: i0.ɵɵFactoryTarget.Component });
HsLayerFeaturesComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsLayerFeaturesComponent, selector: "hs-layer-features", inputs: { layer: "layer", app: "app" }, ngImport: i0, template: "<h3 class=\"mt-1\" style=\"text-align: center\">{{layer.title | translateHs : {app, module: 'LAYERS'} }}</h3>\n<div class=\"form-group mt-1 mb-1\">\n    <div class=\"input-group\" style=\"margin-bottom: 4px\">\n        <input type=\"text\" class=\"form-control hs-filter\" [placeholder]=\"'COMMON.filter' | translateHs : {app} \"\n            [(ngModel)]=\"searchedFeatures\" name=\"FeatureName\">\n    </div>\n</div>\n<table style=\"width:100%;\" *ngFor=\"let feature of appRef.features | featureFilter: searchedFeatures\">\n    <thead>\n        <tr style=\"text-align: center; background-color: rgba(0,0,0,0.05);\">\n            <th colspan=\"2\">{{translate(feature.name)}}<!-- TODO: Remove function call from template -->\n                <a style=\"float: center;\" (click)=\"sortFeaturesBy(feature.name)\"\n                    [title]=\"'FEATURE_TABLE.sortFeaturesByValue' | translateHs : {app} \">^</a>\n            </th>\n        </tr>\n    </thead>\n    <tbody>\n        <tr *ngFor=\"let attr of feature.attributes\" rowspan=\"3\">\n            <th class=\"tdbreak\" style=\"background-color: rgba(0,0,0,0.03);\">\n                {{translate(attr.name)}}<a style=\"float: right;\" (click)=\"sortFeaturesBy(attr.name)\"\n                    [title]=\"'FEATURE_TABLE.sortFeaturesByValue' | translateHs : {app} \">^</a><!-- TODO: Remove function call from template -->\n            </th>\n            <td class=\"tdbreak\" style=\"min-width: 200px; max-width: 200px;\">\n                <span *ngIf=\"!attr.sanitizedValue && !attr.value?.operations\">\n                    <i>{{attr.value}}</i>\n                </span>\n                <i><span *ngIf=\"!!attr.sanitizedValue\" [innerHTML]=\"attr.sanitizedValue\"></span></i>\n                <div *ngIf=\"attr.value?.operations\">\n                    <a *ngFor=\"let operation of attr.value.operations\" (click)=\"executeOperation(operation)\"><span>\n                            <i> {{translate(operation.customActionName) ||\n                                translate(operation.action)}};</i></span></a><!-- TODO: Remove function call from template -->\n                </div>\n            </td>\n        </tr>\n        <tr [hidden]=\"!showFeatureStats\" class=\"tdbreak\" *ngFor=\"let stat of feature.stats\">\n            <th class=\"tdbreak\" style=\"background-color: rgba(0,0,0,0.03);\">\n                {{translate(stat.name)}}</th><!-- TODO: Remove function call from template -->\n            <td class=\"tdbreak\" style=\"min-width: 200px; max-width: 200px;\"><span><i>{{stat.value}}</i></span></td>\n        </tr>\n    </tbody>\n</table>\n<p class=\"p-2\">\n    <small><a (click)=\"showFeatureStats = !showFeatureStats\">{{'FEATURE_TABLE.showFeatureStats' | translateHs : {app}\n            }}</a></small>\n</p>\n<hr />", styles: ["td,th{border:1px solid #dddddd;text-align:left;padding:6px;font-size:14px}.tdbreak{overflow-wrap:break-word;word-break:break-word}\n"], directives: [{ type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "translateHs": TranslateCustomPipe, "featureFilter": HsFeatureFilterPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerFeaturesComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-layer-features', styles: [
                        `
      td,
      th {
        border: 1px solid #dddddd;
        text-align: left;
        padding: 6px;
        font-size: 14px;
      }
      .tdbreak {
        overflow-wrap: break-word;
        word-break: break-word;
      }
    `,
                    ], template: "<h3 class=\"mt-1\" style=\"text-align: center\">{{layer.title | translateHs : {app, module: 'LAYERS'} }}</h3>\n<div class=\"form-group mt-1 mb-1\">\n    <div class=\"input-group\" style=\"margin-bottom: 4px\">\n        <input type=\"text\" class=\"form-control hs-filter\" [placeholder]=\"'COMMON.filter' | translateHs : {app} \"\n            [(ngModel)]=\"searchedFeatures\" name=\"FeatureName\">\n    </div>\n</div>\n<table style=\"width:100%;\" *ngFor=\"let feature of appRef.features | featureFilter: searchedFeatures\">\n    <thead>\n        <tr style=\"text-align: center; background-color: rgba(0,0,0,0.05);\">\n            <th colspan=\"2\">{{translate(feature.name)}}<!-- TODO: Remove function call from template -->\n                <a style=\"float: center;\" (click)=\"sortFeaturesBy(feature.name)\"\n                    [title]=\"'FEATURE_TABLE.sortFeaturesByValue' | translateHs : {app} \">^</a>\n            </th>\n        </tr>\n    </thead>\n    <tbody>\n        <tr *ngFor=\"let attr of feature.attributes\" rowspan=\"3\">\n            <th class=\"tdbreak\" style=\"background-color: rgba(0,0,0,0.03);\">\n                {{translate(attr.name)}}<a style=\"float: right;\" (click)=\"sortFeaturesBy(attr.name)\"\n                    [title]=\"'FEATURE_TABLE.sortFeaturesByValue' | translateHs : {app} \">^</a><!-- TODO: Remove function call from template -->\n            </th>\n            <td class=\"tdbreak\" style=\"min-width: 200px; max-width: 200px;\">\n                <span *ngIf=\"!attr.sanitizedValue && !attr.value?.operations\">\n                    <i>{{attr.value}}</i>\n                </span>\n                <i><span *ngIf=\"!!attr.sanitizedValue\" [innerHTML]=\"attr.sanitizedValue\"></span></i>\n                <div *ngIf=\"attr.value?.operations\">\n                    <a *ngFor=\"let operation of attr.value.operations\" (click)=\"executeOperation(operation)\"><span>\n                            <i> {{translate(operation.customActionName) ||\n                                translate(operation.action)}};</i></span></a><!-- TODO: Remove function call from template -->\n                </div>\n            </td>\n        </tr>\n        <tr [hidden]=\"!showFeatureStats\" class=\"tdbreak\" *ngFor=\"let stat of feature.stats\">\n            <th class=\"tdbreak\" style=\"background-color: rgba(0,0,0,0.03);\">\n                {{translate(stat.name)}}</th><!-- TODO: Remove function call from template -->\n            <td class=\"tdbreak\" style=\"min-width: 200px; max-width: 200px;\"><span><i>{{stat.value}}</i></span></td>\n        </tr>\n    </tbody>\n</table>\n<p class=\"p-2\">\n    <small><a (click)=\"showFeatureStats = !showFeatureStats\">{{'FEATURE_TABLE.showFeatureStats' | translateHs : {app}\n            }}</a></small>\n</p>\n<hr />" }]
        }], ctorParameters: function () { return [{ type: HsFeatureTableService }, { type: HsUtilsService }, { type: HsMapService }, { type: HsLanguageService }, { type: HsLayerUtilsService }]; }, propDecorators: { layer: [{
                type: Input
            }], app: [{
                type: Input
            }] } });

class HsFeatureTableComponent extends HsPanelBaseComponent {
    constructor(hsFeatureTableService, hsConfig, hsMapService, hsLayoutService, hsLanguageService, hsSidebarService) {
        super(hsLayoutService);
        this.hsFeatureTableService = hsFeatureTableService;
        this.hsConfig = hsConfig;
        this.hsMapService = hsMapService;
        this.hsLanguageService = hsLanguageService;
        this.hsSidebarService = hsSidebarService;
        this.layers = [];
        this.name = 'feature_table';
    }
    ngOnInit() {
        this.hsSidebarService.addButton({
            panel: 'feature_table',
            module: 'hs.feature-table',
            order: 14,
            fits: true,
            title: 'PANEL_HEADER.FEATURE_TABLE',
            description: 'SIDEBAR.descriptions.FEATURE_TABLE',
            icon: 'icon-indexmanager',
        }, this.data.app);
        this.hsMapService.loaded(this.data.app).then(() => {
            for (const layer of this.hsConfig.get(this.data.app)
                .layersInFeatureTable || []) {
                this.addLayerToTable(layer);
            }
        });
    }
    /**
     * @param layer - Layer to add
     * Add layer to feature description table
     */
    addLayerToTable(layer) {
        const layerDescriptor = this.hsFeatureTableService.addLayer(layer);
        if (layerDescriptor) {
            this.layers.push(layerDescriptor);
        }
    }
}
HsFeatureTableComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsFeatureTableComponent, deps: [{ token: HsFeatureTableService }, { token: HsConfig }, { token: HsMapService }, { token: HsLayoutService }, { token: HsLanguageService }, { token: HsSidebarService }], target: i0.ɵɵFactoryTarget.Component });
HsFeatureTableComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsFeatureTableComponent, selector: "hs-feature-table", usesInheritance: true, ngImport: i0, template: "<div class=\"card hs-main-panel\" [hidden]=\"(isVisible$ | async) === false\">\n    <hs-panel-header name=\"feature_table\" [title]=\"'PANEL_HEADER.FEATURE_TABLE' | translateHs : data\" [app]=\"data.app\"></hs-panel-header>\n    <div class=\"card-body\">\n        <div *ngFor=\"let layer of layers\">\n            <hs-layer-features [app]=\"data.app\" [layer]=\"layer\"></hs-layer-features>\n        </div>\n    </div>\n</div>", components: [{ type: HsPanelHeaderComponent, selector: "hs-panel-header", inputs: ["name", "app", "title"] }, { type: HsLayerFeaturesComponent, selector: "hs-layer-features", inputs: ["layer", "app"] }], directives: [{ type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "async": i3.AsyncPipe, "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsFeatureTableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-feature-table', template: "<div class=\"card hs-main-panel\" [hidden]=\"(isVisible$ | async) === false\">\n    <hs-panel-header name=\"feature_table\" [title]=\"'PANEL_HEADER.FEATURE_TABLE' | translateHs : data\" [app]=\"data.app\"></hs-panel-header>\n    <div class=\"card-body\">\n        <div *ngFor=\"let layer of layers\">\n            <hs-layer-features [app]=\"data.app\" [layer]=\"layer\"></hs-layer-features>\n        </div>\n    </div>\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsFeatureTableService }, { type: HsConfig }, { type: HsMapService }, { type: HsLayoutService }, { type: HsLanguageService }, { type: HsSidebarService }]; } });

class HsGeolocationParams {
    constructor() {
        this.localization = false;
        /**
         * Represents geolocalization tracking option (on/off).
         * Used to determine state of tracking in directive's html
         */
        this.following = false;
        /**
      
         * Turns off position centering while 'following'.
         */
    }
}
class HsGeolocationService {
    constructor(HsMapService, HsLayoutService, hsLog, HsUtilsService) {
        this.HsMapService = HsMapService;
        this.HsLayoutService = HsLayoutService;
        this.hsLog = hsLog;
        this.HsUtilsService = HsUtilsService;
        this.apps = { default: new HsGeolocationParams() };
    }
    /**
     * @public
     * Get map rotate control
     * @param app - App identifier
     */
    getRotate(app) {
        for (const control of this.HsMapService.getMap(app)
            .getControls()
            .getArray()) {
            if (control instanceof Rotate) {
                return control;
            }
        }
    }
    /**
     * @public
     * Set accuracy feature
     * @param app - App identifier
     */
    setAccuracyFeature(app) {
        this.get(app).accuracyFeature = new Feature({
            known: false,
            geometry: new Circle$1([0, 0], 1),
        });
    }
    /**
     * @public
     * Set position feature
     * @param app - App identifier
     */
    setPositionFeature(app) {
        this.get(app).positionFeature = new Feature({
            known: false,
            geometry: new Point([0, 0]),
        });
    }
    /**
     * @public
     * Set feature style
     * @param app - App identifier
     */
    setStyle(app) {
        this.get(app).style = new Style({
            image: new Circle({
                fill: new Fill({
                    color: [242, 121, 0, 0.7],
                }),
                stroke: new Stroke({
                    color: [0xbb, 0x33, 0x33, 0.7],
                }),
                radius: 5,
            }),
            fill: new Fill({
                color: [0xbb, 0xbb, 0xbb, 0.2],
            }),
            stroke: new Stroke({
                color: [0x66, 0x66, 0x00, 0.8],
            }),
        });
    }
    /**
     * @public
     * Get app instance service params
     * @param app - App identifier
     */
    get(app) {
        if (this.apps[app !== null && app !== void 0 ? app : 'default'] == undefined) {
            this.apps[app !== null && app !== void 0 ? app : 'default'] = new HsGeolocationParams();
        }
        return this.apps[app !== null && app !== void 0 ? app : 'default'];
    }
    /**
     * @public
     * Reset all geolocalization parameters concerning position tracking
     * @param app - App identifier
     */
    stopTracking(app) {
        const appRef = this.get(app);
        appRef.following = false;
        const rotate = this.getRotate(app);
        rotate.element.classList.add('hidden');
        this.HsMapService.getMap(app).on('pointermove', () => {
            appRef.centering = false;
        });
        appRef.geolocation.setTracking(false);
        if (appRef.gn !== null) {
            appRef.gn.stop();
        }
        this.HsMapService.getMap(app).getView().setRotation(0);
    }
    /**
     * @public
     * Toggles tracking/following
     * Takes care of the distinction between click and double-click on mobile
     * @param app - App identifier
     */
    toggleTracking(app) {
        return __awaiter(this, void 0, void 0, function* () {
            const appRef = this.get(app);
            if (appRef.clicked) {
                appRef.cancelClick = true;
                if ((yield lastValueFrom(this.HsLayoutService.sidebarPosition)).position ==
                    'bottom') {
                    this.HsLayoutService.get(app)
                        .contentWrapper.querySelector('.hs-locationButton')
                        .dispatchEvent(new Event('dblclick'));
                }
                return;
            }
            appRef.clicked = true;
            setTimeout(() => {
                if (appRef.cancelClick) {
                    appRef.cancelClick = false;
                    appRef.clicked = false;
                    return;
                }
                if (this.isCentered(app)) {
                    if (!appRef.following) {
                        //position
                        appRef.geolocation.on('change:position', () => this.setNewPosition(app));
                        appRef.geolocation.setTracking(true);
                        appRef.following = true;
                        //rotation
                        this.setRotation();
                        appRef.geolocation.on('change:heading', () => this.newRotation(app));
                        appRef.centering = true;
                        this.HsMapService.getMap(app).on('pointermove', () => {
                            appRef.centering = false;
                        });
                        const rotate = this.getRotate(app);
                        rotate.element.classList.remove('hidden');
                        this.HsLayoutService.get(app)
                            .contentWrapper.querySelector('button.ol-rotate')
                            .classList.add('active');
                    }
                    else {
                        this.HsLayoutService.get(app)
                            .contentWrapper.querySelector('button.ol-rotate')
                            .classList.remove('active');
                        this.stopTracking(app);
                    }
                }
                else {
                    if (appRef.geolocation.getPosition()) {
                        this.HsMapService.getMap(app)
                            .getView()
                            .setCenter(appRef.geolocation.getPosition());
                        appRef.centering = true;
                    }
                }
                //clean up
                appRef.cancelClick = false;
                appRef.clicked = false;
            }, 500);
        });
    }
    /**
     * @public
     * Reset all geolocalization parameters
     * @param app - App identifier
     */
    stopLocalization(app) {
        const appRef = this.get(app);
        appRef.localization = false;
        this.HsMapService.getMap(app).removeLayer(appRef.position_layer);
        this.stopTracking(app);
    }
    /**
     * @public
     * Display current position by querying geolocation, once
     * @param app - App identifier
     */
    startLocalization(app) {
        const appRef = this.get(app);
        if (!appRef.localization) {
            appRef.geolocation.setTracking(true);
            appRef.localization = true;
            appRef.geolocation.once('change:position', () => {
                this.setNewPosition(app);
                this.HsMapService.getMap(app)
                    .getView()
                    .setCenter(appRef.geolocation.getPosition());
                this.HsMapService.getMap(app).addLayer(appRef.position_layer);
                appRef.position_layer.setZIndex(99);
                //stop tracking position
                appRef.geolocation.setTracking(false);
            });
        }
    }
    /**
     * @public
     * Function which determines whether map is centered on current position or not
     * @param app - App identifier
     */
    isCentered(app) {
        return (JSON.stringify(this.HsMapService.getMap(app).getView().getCenter()) ===
            JSON.stringify(this.get(app).positionFeature.getGeometry().getCoordinates()));
    }
    /**
     * @public
     * Callback function handling geolocation change:position event
     * @param app - App identifier
     */
    setNewPosition(app) {
        const appRef = this.get(app);
        const position = appRef.geolocation.getPosition();
        appRef.positionFeature.getGeometry().setCoordinates(position);
        appRef.accuracyFeature
            .getGeometry()
            .setCenterAndRadius(position, appRef.geolocation.getAccuracy());
        if (appRef.centering) {
            this.HsMapService.getMap(app).getView().setCenter(position);
        }
    }
    /**
     * @public
     * Callback function handling geolocation change:heading event
     * @param app - App identifier
     */
    newRotation(app) {
        const appRef = this.get(app);
        this.HsUtilsService.debounce(() => {
            const heading = appRef.geolocation.getHeading()
                ? appRef.geolocation.getHeading()
                : null;
            if (heading) {
                this.HsMapService.getMap(app).getView().setRotation(heading);
            }
        }, 150, false, this);
    }
    setRotation() {
        this.hsLog.error('Device rotation tracking currently not implemented');
    }
    /**
     * @public
     * Init function of service, establish instance of geolocation object and layer.
     * Set map rotate control.
     * @param app - App identifier
     */
    init(app) {
        return __awaiter(this, void 0, void 0, function* () {
            const appRef = this.get(app);
            this.setAccuracyFeature(app);
            this.setPositionFeature(app);
            this.setStyle(app);
            yield this.HsMapService.loaded(app);
            const map = this.HsMapService.getMap(app);
            appRef.geolocation = new Geolocation({
                projection: this.HsMapService.getCurrentProj(app),
                trackingOptions: {
                    enableHighAccuracy: true,
                },
            });
            appRef.accuracyFeature.setStyle(appRef.style);
            appRef.positionFeature.setStyle(appRef.style);
            appRef.position_layer = new VectorLayer({
                source: new Vector(),
            });
            setTitle(appRef.position_layer, 'Position');
            setShowInLayerManager(appRef.position_layer, false);
            setRemovable(appRef.position_layer, false);
            const src = appRef.position_layer.getSource();
            src.addFeature(appRef.accuracyFeature);
            src.addFeature(appRef.positionFeature);
            const reset = function () {
                if (this.gn !== undefined) {
                    if (this.gn.isRunning() && this.gn !== null) {
                        this.gn.stop();
                        map.getView().setRotation(0);
                        this.HsLayoutService.contentWrapper
                            .querySelector('button.ol-rotate')
                            .classList.remove('active');
                    }
                    else {
                        this.setRotation();
                        this.HsLayoutService.contentWrapper
                            .querySelector('button.ol-rotate')
                            .classList.add('active');
                    }
                }
            };
            map.addControl(new Rotate({
                resetNorth: reset,
                className: 'ol-rotate hidden',
                autoHide: false,
            }));
        });
    }
}
HsGeolocationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsGeolocationService, deps: [{ token: HsMapService }, { token: HsLayoutService }, { token: HsLogService }, { token: HsUtilsService }], target: i0.ɵɵFactoryTarget.Injectable });
HsGeolocationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsGeolocationService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsGeolocationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsMapService }, { type: HsLayoutService }, { type: HsLogService }, { type: HsUtilsService }]; } });

class HsGeolocationComponent extends HsPanelBaseComponent {
    constructor(hsGeolocationService, HsLayoutService) {
        super(HsLayoutService);
        this.hsGeolocationService = hsGeolocationService;
        this.HsLayoutService = HsLayoutService;
    }
    ngOnInit() {
        this.collapsed = true;
        this.hsGeolocationService.init(this.data.app);
    }
    isVisible() {
        return (this.HsLayoutService.componentEnabled('geolocationButton', this.data.app) && this.HsLayoutService.componentEnabled('guiOverlay', this.data.app));
    }
    /**
     * Start localization
     */
    startLocalization() {
        this.hsGeolocationService.startLocalization(this.data.app);
    }
    /**
     * Stop localization
     */
    stopLocalization() {
        this.hsGeolocationService.stopLocalization(this.data.app);
    }
    /**
     * Get localization
     */
    getLocalization() {
        return this.hsGeolocationService.get(this.data.app).localization;
    }
    /**
     * Toggle tracking
     */
    toggleTracking() {
        this.hsGeolocationService.toggleTracking(this.data.app);
    }
    /**
     * Determine state of tracking
     */
    isFollowing() {
        return this.hsGeolocationService.get(this.data.app).following;
    }
}
HsGeolocationComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsGeolocationComponent, deps: [{ token: HsGeolocationService }, { token: HsLayoutService }], target: i0.ɵɵFactoryTarget.Component });
HsGeolocationComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsGeolocationComponent, selector: "hs-geolocation", usesInheritance: true, ngImport: i0, template: "<div class=\"hs-locate ol-unselectable ol-control hs-locateToggler\" [hidden]=\"(isVisible$ | async) === false\"\n    [ngClass]=\"{'ol-collapsed': collapsed}\">\n    <button class=\"ol-has-tooltip blocate hs-locateToggler\" [title]=\"'GEOLOCATION.locateMe' | translateHs : data\"\n        *ngIf=\"!getLocalization()\" type=\"button\" (click)=\"startLocalization()\">\n        <i class=\"glyphicon icon-gpsoff-gps hs-locateToggler\"></i>\n    </button>\n    <button *ngIf=\"getLocalization()\" class=\"ol-has-tooltip blocate hs-locateToggler hs-locationButton\" type=\"button\"\n        (click)=\"toggleTracking()\" [title]=\"'GEOLOCATION.locateMe' | translateHs : data\" (dblclick)=\"stopLocalization()\">\n        <i class=\"glyphicon hs-locateToggler\"\n            [ngClass]=\"(isFollowing() && getLocalization()) ? 'icon-navigation' : 'icon-gpson'\"></i><!-- TODO: Remove function call from template -->\n    </button>\n</div>", directives: [{ type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "async": i3.AsyncPipe, "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsGeolocationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-geolocation', template: "<div class=\"hs-locate ol-unselectable ol-control hs-locateToggler\" [hidden]=\"(isVisible$ | async) === false\"\n    [ngClass]=\"{'ol-collapsed': collapsed}\">\n    <button class=\"ol-has-tooltip blocate hs-locateToggler\" [title]=\"'GEOLOCATION.locateMe' | translateHs : data\"\n        *ngIf=\"!getLocalization()\" type=\"button\" (click)=\"startLocalization()\">\n        <i class=\"glyphicon icon-gpsoff-gps hs-locateToggler\"></i>\n    </button>\n    <button *ngIf=\"getLocalization()\" class=\"ol-has-tooltip blocate hs-locateToggler hs-locationButton\" type=\"button\"\n        (click)=\"toggleTracking()\" [title]=\"'GEOLOCATION.locateMe' | translateHs : data\" (dblclick)=\"stopLocalization()\">\n        <i class=\"glyphicon hs-locateToggler\"\n            [ngClass]=\"(isFollowing() && getLocalization()) ? 'icon-navigation' : 'icon-gpson'\"></i><!-- TODO: Remove function call from template -->\n    </button>\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsGeolocationService }, { type: HsLayoutService }]; } });

/**
 * HsInfoComponent
 */
class HsInfoComponent extends HsPanelBaseComponent {
    constructor(hsEventBusService, hsLayoutService, hsConfig) {
        super(hsLayoutService);
        this.hsEventBusService = hsEventBusService;
        this.hsLayoutService = hsLayoutService;
        this.hsConfig = hsConfig;
        /**
         * Store if composition is loaded
         */
        this.composition_loaded = true;
        /**
         * List of layers which are currently loading.
         */
        this.layer_loading = [];
        this.ngUnsubscribe = new Subject();
        this.hsEventBusService.compositionLoading
            .pipe(takeUntil$1(this.ngUnsubscribe))
            .subscribe((data) => {
            if (data.error === undefined) {
                if (data.data !== undefined) {
                    this.composition_abstract = data.data.abstract;
                    this.composition_title = data.data.title;
                    this.composition_id = data.data.id;
                }
                else {
                    this.composition_abstract = data.abstract;
                    this.composition_title = data.title;
                    this.composition_id = data.id;
                }
                this.composition_loaded = false;
                //Composition image (should be glyphicon?)
                this.info_image = 'icon-map';
            }
        });
        this.hsEventBusService.compositionLoads
            .pipe(takeUntil$1(this.ngUnsubscribe))
            .subscribe(({ data }) => {
            if (data.error !== undefined) {
                const temp_abstract = this.composition_abstract;
                const temp_title = this.composition_title;
                this.composition_abstract = data.abstract;
                this.composition_title = data.title;
                this.info_image = 'icon-warning-sign';
                this.composition_title = temp_title;
                this.composition_abstract = temp_abstract;
                this.info_image = 'icon-map';
            }
            this.composition_loaded = true;
            this.composition_edited = false;
        });
        this.hsEventBusService.layerLoadings
            .pipe(takeUntil$1(this.ngUnsubscribe))
            .subscribe(({ layer, progress, app }) => {
            if (app == this.data.app) {
                if (!this.layer_loading.includes(getTitle(layer))) {
                    this.layer_loading.push(getTitle(layer));
                    this.composition_loaded = false;
                }
            }
        });
        this.hsEventBusService.layerLoads
            .pipe(takeUntil$1(this.ngUnsubscribe))
            .subscribe(({ layer, app }) => {
            if (app == this.data.app) {
                for (let i = 0; i < this.layer_loading.length; i++) {
                    if (this.layer_loading[i] == getTitle(layer)) {
                        this.layer_loading.splice(i, 1);
                    }
                }
                if (this.layer_loading.length == 0 && !this.composition_loaded) {
                    this.composition_loaded = true;
                }
            }
        });
        this.hsEventBusService.compositionDeletes
            .pipe(takeUntil$1(this.ngUnsubscribe))
            .subscribe(({ composition, app }) => {
            if (app == this.data.app) {
                if (composition.id == this.composition_id) {
                    delete this.composition_title;
                    delete this.composition_abstract;
                }
            }
        });
        this.hsEventBusService.mapResets
            .pipe(takeUntil$1(this.ngUnsubscribe))
            .subscribe(({ app }) => {
            if (app == this.data.app) {
                delete this.composition_title;
                delete this.composition_abstract;
                this.layer_loading.length = 0;
                this.composition_loaded = true;
                this.composition_edited = false;
            }
        });
        this.hsEventBusService.compositionEdits
            .pipe(takeUntil$1(this.ngUnsubscribe))
            .subscribe(() => {
            this.composition_edited = true;
        });
        this.hsConfig.configChanges
            .pipe(takeUntil$1(this.ngUnsubscribe))
            .subscribe(({ app, config }) => {
            if (this.data.app == app) {
                this.isVisible$.next(this.isVisible());
            }
        });
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    trackByFn(index) {
        return index; // or item.id
    }
    /**
  
     * @returns Returns true if composition title available
     * est if composition is loaded, to change info template.
     */
    compositionLoaded() {
        return this.composition_title !== undefined;
    }
    isVisible() {
        return this.hsLayoutService.panelEnabled('compositionLoadingProgress', this.data.app);
    }
}
HsInfoComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsInfoComponent, deps: [{ token: HsEventBusService }, { token: HsLayoutService }, { token: HsConfig }], target: i0.ɵɵFactoryTarget.Component });
HsInfoComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsInfoComponent, selector: "hs-info", usesInheritance: true, ngImport: i0, template: "<div class=\"hs-info-container\" [hidden]=\"(isVisible$ | async) === false\">\n    <div class=\"hs-info-area\">\n        <div class=\"hs-info-composition hs-main-panel\" [hidden]=\"!!compositionLoaded()\">\n            <div class=\"hs-info-composition-image\" [hidden]=\"!!composition_loaded\">\n                <span class=\"icon-refresh icon-spin\"></span>\n                <span class=\"glyphicon\" [ngClass]=\"info_image\" [hidden]=\"!composition_loaded\"></span>\n            </div>\n            <div class=\"hs-info-composition-container\" *ngIf=\"!composition_edited\">\n                <div class=\"hs-info-composition-title\" title=\"{{'INFOCOMPONENT.viewComposeAndAnalyse' | translateHs : {app: data.app} }}\">{{'INFOCOMPONENT.newMap' | translateHs : {app: data.app} }}</div>\n            </div>\n            <div class=\"hs-info-composition-container\" *ngIf=\"composition_edited\">\n                <div class=\"hs-info-composition-title\">{{'INFOCOMPONENT.unsavedMap' | translateHs : {app: data.app} }}</div>\n                <div class=\"hs-info-composition-abstract\" [hidden]=\"!!(!layer_loading.length && composition_edited)\">\n                    {{'INFOCOMPONENT.youHaveUnsavedChanges' | translateHs : {app: data.app} }}</div>\n            </div>\n        </div>\n\n        <div class=\"hs-info-composition\" [hidden]=\"!compositionLoaded()\">\n            <div class=\"hs-info-composition-image\">\n                <span class=\"icon-refresh icon-spin\" [hidden]=\"!!composition_loaded\"></span>\n                <span class=\"glyphicon\" [ngClass]=\"info_image\" [hidden]=\"!composition_loaded\"></span>\n            </div>\n            <div class=\"hs-info-composition-container\">\n                <div class=\"hs-info-composition-title\">{{composition_title}}</div>\n                <div class=\"hs-info-composition-abstract\">{{composition_abstract}}</div>\n            </div>\n        </div>\n\n        <div class=\"hs-info-layers\" [hidden]=\"!layer_loading.length\">\n            <span>{{'COMMON.loading' | translateHs : {app: data.app} }}: </span>\n            <span *ngFor=\"let layer of layer_loading; trackBy: trackByFn\">{{layer}} </span>\n        </div>\n\n        <div class=\"hs-info-composition-edited\" [hidden]=\"!(!layer_loading.length && composition_edited)\">\n            <span>{{'INFOCOMPONENT.youHaveUnsavedChanges' | translateHs : {app: data.app} }}</span>\n        </div>\n\n        <update-title title=\"{{composition_title}}\"></update-title>\n        <update-meta property=\"og:title\" content=\"{{composition_title}}\"></update-meta>\n        <update-meta property=\"twitter:title\" content=\"{{composition_title}}\"></update-meta>\n        <update-meta itemprop=\"title\" content=\"{{composition_title}}\"></update-meta>\n\n        <update-meta name=\"description\" content=\"{{composition_abstract}}\"></update-meta>\n        <update-meta property=\"og:description\" content=\"{{composition_abstract}}\"></update-meta>\n        <update-meta property=\"twitter:description\" content=\"{{composition_abstract}}\"></update-meta>\n        <update-meta itemprop=\"description\" content=\"{{composition_abstract}}\"></update-meta>\n    </div>\n</div>", directives: [{ type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "async": i3.AsyncPipe, "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsInfoComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-info', template: "<div class=\"hs-info-container\" [hidden]=\"(isVisible$ | async) === false\">\n    <div class=\"hs-info-area\">\n        <div class=\"hs-info-composition hs-main-panel\" [hidden]=\"!!compositionLoaded()\">\n            <div class=\"hs-info-composition-image\" [hidden]=\"!!composition_loaded\">\n                <span class=\"icon-refresh icon-spin\"></span>\n                <span class=\"glyphicon\" [ngClass]=\"info_image\" [hidden]=\"!composition_loaded\"></span>\n            </div>\n            <div class=\"hs-info-composition-container\" *ngIf=\"!composition_edited\">\n                <div class=\"hs-info-composition-title\" title=\"{{'INFOCOMPONENT.viewComposeAndAnalyse' | translateHs : {app: data.app} }}\">{{'INFOCOMPONENT.newMap' | translateHs : {app: data.app} }}</div>\n            </div>\n            <div class=\"hs-info-composition-container\" *ngIf=\"composition_edited\">\n                <div class=\"hs-info-composition-title\">{{'INFOCOMPONENT.unsavedMap' | translateHs : {app: data.app} }}</div>\n                <div class=\"hs-info-composition-abstract\" [hidden]=\"!!(!layer_loading.length && composition_edited)\">\n                    {{'INFOCOMPONENT.youHaveUnsavedChanges' | translateHs : {app: data.app} }}</div>\n            </div>\n        </div>\n\n        <div class=\"hs-info-composition\" [hidden]=\"!compositionLoaded()\">\n            <div class=\"hs-info-composition-image\">\n                <span class=\"icon-refresh icon-spin\" [hidden]=\"!!composition_loaded\"></span>\n                <span class=\"glyphicon\" [ngClass]=\"info_image\" [hidden]=\"!composition_loaded\"></span>\n            </div>\n            <div class=\"hs-info-composition-container\">\n                <div class=\"hs-info-composition-title\">{{composition_title}}</div>\n                <div class=\"hs-info-composition-abstract\">{{composition_abstract}}</div>\n            </div>\n        </div>\n\n        <div class=\"hs-info-layers\" [hidden]=\"!layer_loading.length\">\n            <span>{{'COMMON.loading' | translateHs : {app: data.app} }}: </span>\n            <span *ngFor=\"let layer of layer_loading; trackBy: trackByFn\">{{layer}} </span>\n        </div>\n\n        <div class=\"hs-info-composition-edited\" [hidden]=\"!(!layer_loading.length && composition_edited)\">\n            <span>{{'INFOCOMPONENT.youHaveUnsavedChanges' | translateHs : {app: data.app} }}</span>\n        </div>\n\n        <update-title title=\"{{composition_title}}\"></update-title>\n        <update-meta property=\"og:title\" content=\"{{composition_title}}\"></update-meta>\n        <update-meta property=\"twitter:title\" content=\"{{composition_title}}\"></update-meta>\n        <update-meta itemprop=\"title\" content=\"{{composition_title}}\"></update-meta>\n\n        <update-meta name=\"description\" content=\"{{composition_abstract}}\"></update-meta>\n        <update-meta property=\"og:description\" content=\"{{composition_abstract}}\"></update-meta>\n        <update-meta property=\"twitter:description\" content=\"{{composition_abstract}}\"></update-meta>\n        <update-meta itemprop=\"description\" content=\"{{composition_abstract}}\"></update-meta>\n    </div>\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsEventBusService }, { type: HsLayoutService }, { type: HsConfig }]; } });

class HsLayerManagerRemoveAllDialogComponent {
    constructor(HsLayerManagerService, HsDialogContainerService, HsEventBusService) {
        this.HsLayerManagerService = HsLayerManagerService;
        this.HsDialogContainerService = HsDialogContainerService;
        this.HsEventBusService = HsEventBusService;
    }
    removeAllLayers(reloadComposition) {
        this.HsLayerManagerService.removeAllLayers(this.data.app);
        if (reloadComposition) {
            this.HsEventBusService.compositionLoadStarts.next(this.HsLayerManagerService.apps[this.data.app].composition_id);
        }
        this.close();
    }
    close() {
        this.HsDialogContainerService.destroy(this, this.data.app);
    }
}
HsLayerManagerRemoveAllDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerManagerRemoveAllDialogComponent, deps: [{ token: HsLayerManagerService }, { token: HsDialogContainerService }, { token: HsEventBusService }], target: i0.ɵɵFactoryTarget.Component });
HsLayerManagerRemoveAllDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsLayerManagerRemoveAllDialogComponent, selector: "hs-layermanager-remove-all-dialog", inputs: { data: "data" }, ngImport: i0, template: "<div class=\"modal hs-remove-all-dialog in\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h4 class=\"modal-title\">\n                    {{'PANEL_HEADER.LM' | translateHs : {app: data.app} }}\n                </h4>\n                <button (click)=\"close()\" class=\"btn-close\" data-dismiss=\"modal\" attr.aria-label=\"{{'COMMON.close' | translateHs : {app: data.app} }}\">\n                </button>\n            </div>\n            <div class=\"modal-body\" style=\"max-height:600px; overflow-y:auto\">\n                {{'LAYERMANAGER.dialogRemoveAll.dialogMessage' | translateHs : {app: data.app} }}</div>\n            <div class=\"modal-footer\">\n                <button class=\"btn btn-primary\" (click)=\"removeAllLayers(false);\"\n                    data-dismiss=\"modal\">{{'LAYERMANAGER.dialogRemoveAll.removeAllAdded' | translateHs : {app: data.app} }}</button>\n                <button class=\"btn btn-primary\" *ngIf=\"HsEventBusService.currentComposition.value\" (click)=\"removeAllLayers(true)\"\n                    data-dismiss=\"modal\">{{'LAYERMANAGER.dialogRemoveAll.reloadComposition' | translateHs : {app: data.app} }}</button>\n                <button class=\"btn btn-secondary\" (click)=\"close()\"\n                    data-dismiss=\"modal\">{{'COMMON.no' | translateHs : {app: data.app} }}</button>\n            </div>\n        </div>\n    </div>\n</div>\n", directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerManagerRemoveAllDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-layermanager-remove-all-dialog', template: "<div class=\"modal hs-remove-all-dialog in\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h4 class=\"modal-title\">\n                    {{'PANEL_HEADER.LM' | translateHs : {app: data.app} }}\n                </h4>\n                <button (click)=\"close()\" class=\"btn-close\" data-dismiss=\"modal\" attr.aria-label=\"{{'COMMON.close' | translateHs : {app: data.app} }}\">\n                </button>\n            </div>\n            <div class=\"modal-body\" style=\"max-height:600px; overflow-y:auto\">\n                {{'LAYERMANAGER.dialogRemoveAll.dialogMessage' | translateHs : {app: data.app} }}</div>\n            <div class=\"modal-footer\">\n                <button class=\"btn btn-primary\" (click)=\"removeAllLayers(false);\"\n                    data-dismiss=\"modal\">{{'LAYERMANAGER.dialogRemoveAll.removeAllAdded' | translateHs : {app: data.app} }}</button>\n                <button class=\"btn btn-primary\" *ngIf=\"HsEventBusService.currentComposition.value\" (click)=\"removeAllLayers(true)\"\n                    data-dismiss=\"modal\">{{'LAYERMANAGER.dialogRemoveAll.reloadComposition' | translateHs : {app: data.app} }}</button>\n                <button class=\"btn btn-secondary\" (click)=\"close()\"\n                    data-dismiss=\"modal\">{{'COMMON.no' | translateHs : {app: data.app} }}</button>\n            </div>\n        </div>\n    </div>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: HsLayerManagerService }, { type: HsDialogContainerService }, { type: HsEventBusService }]; }, propDecorators: { data: [{
                type: Input
            }] } });

class HsLayerSynchronizerService {
    constructor(hsUtilsService, hsLaymanService, hsCommonEndpointsService, hsMapService, hsCommonLaymanService, hsToastService, hsLanguageService, hsLogService) {
        this.hsUtilsService = hsUtilsService;
        this.hsLaymanService = hsLaymanService;
        this.hsCommonEndpointsService = hsCommonEndpointsService;
        this.hsMapService = hsMapService;
        this.hsCommonLaymanService = hsCommonLaymanService;
        this.hsToastService = hsToastService;
        this.hsLanguageService = hsLanguageService;
        this.hsLogService = hsLogService;
        this.debounceInterval = 1000;
        this.syncedLayers = [];
    }
    /**
     * Initialize the LayerSynchronizerService data and subscribers
     * @param app - App identifier
     */
    init(app) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.hsMapService.loaded(app);
            const map = this.hsMapService.getMap(app);
            const layerAdded = (e) => this.addLayer(e.element, app);
            map.getLayers().on('add', layerAdded);
            map.getLayers().on('remove', (e) => {
                this.removeLayer(e.element);
            });
            map.getLayers().forEach((lyr) => {
                layerAdded({
                    element: lyr,
                });
            });
            this.hsCommonLaymanService.authChange.subscribe(() => {
                this.reloadLayersOnAuthChange(app);
            });
            this.crs = this.hsMapService.getCurrentProj(app).getCode();
            this.hsLaymanService.crs = this.crs;
        });
    }
    /**
     * Reload all the synchronized layers after Layman's authorization change
     * @param app - App identifier
     */
    reloadLayersOnAuthChange(app) {
        for (const layer of this.syncedLayers) {
            const layerSource = layer.getSource();
            setLaymanLayerDescriptor(layer, undefined);
            layerSource.clear();
            this.pull(layer, layerSource, app);
        }
    }
    /**
     * Start synchronizing layer to database
     * @param layer - Layer to add
     * @param app - App identifier
     */
    addLayer(layer, app) {
        if (this.isLayerSynchronizable(layer)) {
            this.syncedLayers.push(layer);
            this.startMonitoringIfNeeded(layer, app);
        }
    }
    /**
     * Check if the selected layer is synchronizable
     * @param layer - Layer to check
     * @returns True if the layer can be synchronized, false otherwise
     */
    isLayerSynchronizable(layer) {
        var _a;
        const definition = getDefinition(layer);
        return (this.hsUtilsService.instOf(layer.getSource(), Vector) &&
            //Test whether fromat cointains 'wfs' AND does not contian 'external'. Case insensitive
            new RegExp('^(?=.*wfs)(?:(?!external).)*$', 'i').test((_a = definition === null || definition === void 0 ? void 0 : definition.format) === null || _a === void 0 ? void 0 : _a.toLowerCase()));
    }
    /**
     * Keep track of synchronized vector layers by listening to
     * VectorSources change events. Initially also get features from server
     * @param layer - Layer to add
     * @param app - App identifier
     */
    startMonitoringIfNeeded(layer, app) {
        return __awaiter(this, void 0, void 0, function* () {
            const layerSource = layer.getSource();
            yield this.pull(layer, layerSource, app);
            layer.on('propertychange', (e) => {
                if (e.key == 'sld' || e.key == 'title') {
                    this.hsLaymanService.upsertLayer(this.findLaymanForWfsLayer(layer), layer, false, app);
                }
            });
            layerSource.forEachFeature((f) => this.observeFeature(f, app));
            layerSource.on('addfeature', (e) => {
                this.sync(Array.isArray(e.feature) ? e.feature : [e.feature], [], [], layer, app);
            });
            layerSource.on('removefeature', (e) => {
                this.sync([], [], [e.feature], layer, app);
            });
        });
    }
    /**
     * Find Layman's endpoint description for WFS layer
     * @param layer - Layer to add
     */
    findLaymanForWfsLayer(layer) {
        const layerDefinition = getDefinition(layer);
        return (this.hsCommonEndpointsService.endpoints || [])
            .filter((ds) => { var _a; return ds.type == 'layman' && ((_a = layerDefinition === null || layerDefinition === void 0 ? void 0 : layerDefinition.url) === null || _a === void 0 ? void 0 : _a.includes(ds.url)); })
            .pop();
    }
    /**
     * Get features from Layman's endpoint service as WFS string, parse them and add
     * them to OL VectorSource
     * @param layer - Layer to get Layman friendly name for
     * @param source - OL VectorSource to store features in
     * @param app - App identifier
     */
    pull(layer, source, app) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                setEventsSuspended(layer, (getEventsSuspended(layer) || 0) + 1);
                const laymanEndpoint = this.findLaymanForWfsLayer(layer);
                if (laymanEndpoint) {
                    setHsLaymanSynchronizing(layer, true);
                    const response = yield this.hsLaymanService.makeGetLayerRequest(laymanEndpoint, layer, app);
                    let featureString;
                    if (response) {
                        featureString = response;
                    }
                    setHsLaymanSynchronizing(layer, false);
                    if (featureString) {
                        source.loading = true;
                        const format = new WFS();
                        featureString = featureString.replace(/urn:x-ogc:def:crs:EPSG:3857/gm, 'EPSG:3857');
                        featureString = featureString.replaceAll('http://www.opengis.net/gml/srs/epsg.xml#', 'EPSG:');
                        try {
                            const features = format.readFeatures(featureString);
                            source.addFeatures(features);
                            features.forEach((f) => this.observeFeature(f, app));
                        }
                        catch (ex) {
                            this.hsLogService.warn(featureString, ex);
                        }
                        source.loading = false;
                    }
                }
            }
            catch (ex) {
                this.hsLogService.warn(`Layer ${layer} could not be pulled.`);
            }
            finally {
                setEventsSuspended(layer, (getEventsSuspended(layer) || 0) - 1);
            }
        });
    }
    /**
     * Observe feature changes and execute handler for them
     * @param f - Feature to observe
     * @param app - App identifier
     */
    observeFeature(f, app) {
        f.getGeometry().on('change', this.hsUtilsService.debounce(() => {
            this.handleFeatureChange(f, app);
        }, this.debounceInterval, false, this));
        f.on('propertychange', (e) => this.handleFeaturePropertyChange(e.target, app));
    }
    /**
     * Handler for feature change event
     * @param feature - Feature whose change event was captured
     * @param app - App identifier
     */
    handleFeatureChange(feature, app) {
        this.sync([], [feature], [], this.hsMapService.getLayerForFeature(feature, app), app);
    }
    /**
     * Handler for feature property change event
     * @param feature - Feature whose property change event was captured
     * @param app - App identifier
     */
    handleFeaturePropertyChange(feature, app) {
        //NOTE Due to WFS specification, attribute addition is not possible, so we must delete the feature before.
        this.sync([], [], [feature], this.hsMapService.getLayerForFeature(feature, app), app);
        //NOTE only then we can add feature with new attributes again.
        this.sync([feature], [], [], this.hsMapService.getLayerForFeature(feature, app), app);
    }
    /**
     * Sync any feature changes inside a layer, that is being stored on Layman's service database
     * @param add - Features being added
     * @param upd - Features being uploaded
     * @param del - Features being deleted
     * @param layer - Layer interacted with
     * @param app - App identifier
     */
    sync(add, upd, del, layer, app) {
        if ((getEventsSuspended(layer) || 0) > 0) {
            return;
        }
        const ep = this.findLaymanForWfsLayer(layer);
        if (ep) {
            setHsLaymanSynchronizing(layer, true);
            this.hsLaymanService
                .sync({ ep, add, upd, del, layer }, app)
                .then((response) => {
                if (response === null || response === void 0 ? void 0 : response.includes('Exception')) {
                    this.displaySyncErrorDialog(response, app);
                    return;
                }
                if (add[0]) {
                    const id = new DOMParser()
                        .parseFromString(response, 'application/xml')
                        .getElementsByTagName('ogc:FeatureId')[0]
                        .getAttribute('fid');
                    add[0].setId(id);
                    const geometry = add[0].getGeometry();
                    add[0].setGeometryName('wkb_geometry');
                    add[0].setGeometry(geometry);
                    add[0].unset('geometry', true);
                    this.observeFeature(add[0], app);
                }
                setHsLaymanSynchronizing(layer, false);
            });
        }
    }
    /**
     * Display error dialog on synchronization failure
     * @param error - Error captured
     * @param app - App identifier
     */
    displaySyncErrorDialog(error, app) {
        const exception = xml2Json.xml2js(error, { compact: true });
        this.hsToastService.createToastPopupMessage(this.hsLanguageService.getTranslation('SAVECOMPOSITION.syncErrorDialog.errorWhenSyncing', undefined, app), exception['ows:ExceptionReport']['ows:Exception']['ows:ExceptionText']
            ._text, {
            disableLocalization: true,
            serviceCalledFrom: 'HsLayerSynchronizerService',
        }, app);
    }
    /**
     * Stop synchronizing layer to database
     * @param layer - Layer to remove from synched layers list
     */
    removeLayer(layer) {
        for (let i = 0; i < this.syncedLayers.length; i++) {
            if (this.syncedLayers[i] == layer) {
                this.syncedLayers.splice(i, 1);
                break;
            }
        }
    }
}
HsLayerSynchronizerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerSynchronizerService, deps: [{ token: HsUtilsService }, { token: HsLaymanService }, { token: HsCommonEndpointsService }, { token: HsMapService }, { token: HsCommonLaymanService }, { token: HsToastService }, { token: HsLanguageService }, { token: HsLogService }], target: i0.ɵɵFactoryTarget.Injectable });
HsLayerSynchronizerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerSynchronizerService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerSynchronizerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsUtilsService }, { type: HsLaymanService }, { type: HsCommonEndpointsService }, { type: HsMapService }, { type: HsCommonLaymanService }, { type: HsToastService }, { type: HsLanguageService }, { type: HsLogService }]; } });

class HsLayerEditorSublayerParams {
    constructor() {
        this.checkedSubLayers = {};
        this.withChildren = {};
        this.populatedLayers = [];
        this.withChildrenTmp = {};
        this.checkedSubLayersTmp = {};
    }
}
class HsLayerEditorSublayerService {
    constructor(HsLayerManagerService, HsLayerSelectorService, HsLayerUtilsService) {
        this.HsLayerManagerService = HsLayerManagerService;
        this.HsLayerSelectorService = HsLayerSelectorService;
        this.HsLayerUtilsService = HsLayerUtilsService;
        this.apps = { default: new HsLayerEditorSublayerParams() };
        this.HsLayerSelectorService.layerSelected.subscribe(({ layer, app }) => {
            this.resetSublayers(layer, app);
        });
    }
    get(app) {
        if (this.apps[app !== null && app !== void 0 ? app : 'default'] == undefined) {
            this.apps[app !== null && app !== void 0 ? app : 'default'] = new HsLayerEditorSublayerParams();
        }
        return this.apps[app !== null && app !== void 0 ? app : 'default'];
    }
    resetSublayers(layer, app) {
        const appRef = this.get(app);
        if (this.HsLayerManagerService.apps[app].currentLayer) {
            appRef.checkedSubLayers = layer.checkedSubLayers;
            appRef.checkedSubLayersTmp = layer.checkedSubLayersTmp;
            appRef.withChildren = layer.withChildren;
            appRef.withChildrenTmp = layer.withChildrenTmp;
        }
    }
    hasSubLayers(app) {
        var _a;
        const subLayers = (_a = getCachedCapabilities(this.HsLayerManagerService.apps[app].currentLayer.layer)) === null || _a === void 0 ? void 0 : _a.Layer;
        return subLayers != undefined && subLayers.length > 0;
    }
    getSubLayers(app) {
        var _a;
        if (this.HsLayerManagerService.apps[app].currentLayer === null) {
            return;
        }
        this.populateSubLayers(app);
        return (((_a = getCachedCapabilities(this.HsLayerManagerService.apps[app].currentLayer.layer)) === null || _a === void 0 ? void 0 : _a.Layer) || []);
    }
    populateSubLayers(app) {
        var _a;
        const appRef = this.get(app);
        const wrapper = this.HsLayerManagerService.apps[app].currentLayer;
        const layer = wrapper.layer;
        if (appRef.populatedLayers.includes(wrapper.uid)) {
            return;
        }
        const subLayers = (_a = getCachedCapabilities(layer)) === null || _a === void 0 ? void 0 : _a.Layer;
        if ((subLayers === null || subLayers === void 0 ? void 0 : subLayers.length) > 0) {
            //Visibility of leaf layers the same as oldest ancestor
            const visible = layer.getVisible();
            //We don't want to overwrite saved sub-layer states when changing current layer
            const clone = (src) => Object.assign({}, src);
            //Function which converts list of layers to dictionary of their names and visibility
            const toDictionary = (d, layer) => ((d[layer.Name] = visible), d);
            appRef.populatedLayers.push(wrapper.uid);
            const subLayersWithChild = subLayers.filter((sl) => sl.Layer);
            let subSubLayers = subLayersWithChild.flatMap((sl) => sl.Layer);
            //Check one level deeper for the sublayers
            subSubLayers = subSubLayers.filter((sl) => {
                if (sl.Layer) {
                    subLayersWithChild.push(sl);
                }
                return sl.Layer;
            });
            wrapper.withChildren = subLayersWithChild.reduce(toDictionary, {});
            //List either 3rd level layers or second if no 3rd level layer exists
            const leafs = subSubLayers.length > 0
                ? [...subLayers.filter((sl) => !sl.Layer), ...subSubLayers]
                : subLayers;
            wrapper.checkedSubLayers = leafs.reduce(toDictionary, {});
            appRef.checkedSubLayers = wrapper.checkedSubLayers;
            appRef.withChildren = wrapper.withChildren;
            appRef.checkedSubLayersTmp = clone(appRef.checkedSubLayers);
            wrapper.checkedSubLayersTmp = appRef.checkedSubLayersTmp;
            appRef.withChildrenTmp = clone(appRef.withChildren);
            wrapper.withChildrenTmp = appRef.withChildrenTmp;
            if (!this.HsLayerManagerService.apps[app].currentLayer.visible) {
                for (const dict of [
                    appRef.checkedSubLayersTmp,
                    appRef.withChildrenTmp,
                ]) {
                    Object.keys(dict).forEach((v) => (dict[v] = true));
                }
            }
        }
    }
    subLayerSelected(app) {
        const appRef = this.get(app);
        const layer = this.HsLayerManagerService.apps[app].currentLayer;
        const params = this.HsLayerUtilsService.getLayerParams(layer.layer);
        params.LAYERS = Object.keys(appRef.checkedSubLayers)
            .filter((key) => appRef.checkedSubLayers[key] && !appRef.withChildren[key])
            .join(',');
        if (this.HsLayerUtilsService.isLayerArcgis(layer.layer)) {
            params.LAYERS = `show:${params.LAYERS}`;
        }
        if (params.LAYERS == '' || params.LAYERS == 'show:') {
            this.HsLayerManagerService.changeLayerVisibility(!layer.visible, layer, app);
            return;
        }
        if (layer.visible == false) {
            this.HsLayerManagerService.changeLayerVisibility(!layer.visible, layer, app);
        }
        this.HsLayerUtilsService.updateLayerParams(layer.layer, params);
    }
}
HsLayerEditorSublayerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerEditorSublayerService, deps: [{ token: HsLayerManagerService }, { token: HsLayerSelectorService }, { token: HsLayerUtilsService }], target: i0.ɵɵFactoryTarget.Injectable });
HsLayerEditorSublayerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerEditorSublayerService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerEditorSublayerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsLayerManagerService }, { type: HsLayerSelectorService }, { type: HsLayerUtilsService }]; } });

class HsLayerListService {
    constructor(hsLayerManagerService, hsLayerEditorSublayerService, hsLayerUtilsService) {
        this.hsLayerManagerService = hsLayerManagerService;
        this.hsLayerEditorSublayerService = hsLayerEditorSublayerService;
        this.hsLayerUtilsService = hsLayerUtilsService;
    }
    /**
     * Controls state of layer's sublayers checkboxes with layer visibility changes
     * @param layer - Selected layer
     */
    toggleSublayersVisibility(layer, app) {
        if (!layer.visible) {
            if (this.hsLayerManagerService.apps[app].currentLayer === layer) {
                if (this.hsLayerEditorSublayerService.hasSubLayers(app)) {
                    this.changeSublayerVisibilityState(layer, this.hsLayerManagerService.apps[app].currentLayer.visible);
                }
            }
            else {
                this.changeSublayerVisibilityState(layer, layer.visible);
            }
        }
        else {
            if (layer.checkedSubLayers) {
                Object.keys(layer.checkedSubLayers).forEach((key) => {
                    layer.checkedSubLayers[key] = layer.checkedSubLayersTmp[key];
                });
            }
            if (layer.withChildren) {
                Object.keys(layer.withChildren).forEach((key) => {
                    layer.withChildren[key] = layer.withChildrenTmp[key];
                });
            }
        }
    }
    /**
     * Filters layers, and returns only the ones belonging to folder hierarchy level of directive
  
     * @returns Filtered HsLayerManagerService layers
     */
    filterLayers(folder, app) {
        const tmp = [];
        for (const layer of this.hsLayerManagerService.apps[app].data.layers) {
            if (getPath(layer.layer) == folder.hsl_path ||
                ((getPath(layer.layer) == undefined || getPath(layer.layer) == '') &&
                    folder.hsl_path == '')) {
                tmp.push(layer);
            }
        }
        return tmp;
    }
    changeSublayerVisibilityState(layer, state) {
        if (layer.checkedSubLayers) {
            Object.keys(layer.checkedSubLayers).forEach((key) => {
                layer.checkedSubLayers[key] = state;
            });
        }
        if (layer.withChildren) {
            Object.keys(layer.withChildren).forEach((key) => {
                layer.withChildren[key] = state;
            });
        }
    }
    /**
     * Test if layer is queryable (WMS layer with Info format)
     * @param layer_container - Selected layer - wrapped in layer object
     */
    isLayerQueryable(layer_container) {
        return this.hsLayerUtilsService.isLayerQueryable(layer_container.layer);
    }
}
HsLayerListService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerListService, deps: [{ token: HsLayerManagerService }, { token: HsLayerEditorSublayerService }, { token: HsLayerUtilsService }], target: i0.ɵɵFactoryTarget.Injectable });
HsLayerListService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerListService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerListService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsLayerManagerService }, { type: HsLayerEditorSublayerService }, { type: HsLayerUtilsService }]; } });

class HsLayerManagerTimeEditorComponent {
    constructor(hsEventBusService, hsDimensionTimeService, hsLayoutService, hsConfig) {
        this.hsEventBusService = hsEventBusService;
        this.hsDimensionTimeService = hsDimensionTimeService;
        this.hsLayoutService = hsLayoutService;
        this.hsConfig = hsConfig;
        this.app = 'default';
        this.availableTimesFetched = false;
        this.hasPreviousTime = false;
        this.hasFollowingTime = false;
        this.timeDisplayFormat = 'yyyy-MM-dd HH:mm:ss z';
        this.ngUnsubscribe = new Subject();
        this.hsDimensionTimeService.layerTimeChanges
            .pipe(takeUntil$1(this.ngUnsubscribe))
            .subscribe(({ layer: layerDescriptor, time, app }) => {
            if (app != this.app) {
                return;
            }
            if (this.layer.uid !== layerDescriptor.uid) {
                return;
            }
            if (!this.availableTimes) {
                this.fillAvailableTimes(layerDescriptor, time);
            }
            this.setCurrentTimeIfAvailable(time);
        });
        this.hsEventBusService.layerTimeSynchronizations
            .pipe(takeUntil$1(this.ngUnsubscribe))
            .subscribe(({ sync, time, app }) => {
            if (app != this.app) {
                return;
            }
            this.timesInSync = sync;
            if (sync) {
                this.hideTimeSelect();
                this.setCurrentTimeIfAvailable(time);
                if (this.currentTime) {
                    this.setLayerTime();
                }
            }
        });
    }
    ngOnInit() {
        this.configRef = this.hsConfig.get(this.app);
        this.selectVisible = false;
        this.timesInSync = false;
        if (this.layer.time) {
            this.fillAvailableTimes(this.layer, undefined);
        }
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    /**
     * Sets hasPreviousTime and hasFollowingTime properties
     */
    checkPrevFollowTimesAvailability() {
        if (!this.availableTimes) {
            return;
        }
        if (this.currentTimeIdx > 0) {
            this.hasPreviousTime = true;
        }
        else {
            this.hasPreviousTime = false;
        }
        if (this.currentTimeIdx < this.availableTimes.length - 1) {
            this.hasFollowingTime = true;
        }
        else {
            this.hasFollowingTime = false;
        }
    }
    /**
     * Handler for the "prev" button click
     */
    previousTime() {
        if (!this.hasPreviousTime) {
            return;
        }
        this.currentTime = this.availableTimes[--this.currentTimeIdx];
        if (this.timesInSync) {
            this.hsEventBusService.layerTimeSynchronizations.next({
                sync: this.timesInSync,
                time: this.currentTime,
                app: this.app,
            });
        }
        this.setLayerTime();
        this.checkPrevFollowTimesAvailability();
    }
    /**
     * Handler for the "next" button click
     */
    followingTime() {
        if (!this.hasFollowingTime) {
            return;
        }
        this.currentTime = this.availableTimes[++this.currentTimeIdx];
        if (this.timesInSync) {
            this.hsEventBusService.layerTimeSynchronizations.next({
                sync: this.timesInSync,
                time: this.currentTime,
                app: this.app,
            });
        }
        this.setLayerTime();
        this.checkPrevFollowTimesAvailability();
    }
    /**
     * Handler for a time selection from the SELECT element
     */
    selectTime() {
        this.currentTimeIdx = this.availableTimes.indexOf(this.currentTime);
        if (this.timesInSync) {
            this.hsEventBusService.layerTimeSynchronizations.next({
                sync: this.timesInSync,
                time: this.currentTime,
                app: this.app,
            });
        }
        this.setLayerTime();
        this.checkPrevFollowTimesAvailability();
    }
    setCurrentTimeIfAvailable(time) {
        if (this.availableTimes.includes(time)) {
            this.currentTime = time;
            this.currentTimeIdx = this.availableTimes.indexOf(time);
        }
        else {
            this.currentTime = null;
            this.currentTimeIdx = -1;
        }
        this.checkPrevFollowTimesAvailability();
    }
    /**
     * Set selected 'time' on the layer object
     */
    setLayerTime() {
        setTimeout(() => {
            this.hsDimensionTimeService.setLayerTime(this.layer, this.currentTime, this.app);
        }, 100);
    }
    showTimeSelect() {
        this.selectVisible = true;
        this.selectElement.nativeElement.focus(); //FIXME: this just refuse to work...
    }
    hideTimeSelect() {
        this.selectVisible = false;
    }
    synchronizeTimes() {
        this.timesInSync = !this.timesInSync;
        this.hsEventBusService.layerTimeSynchronizations.next({
            sync: this.timesInSync,
            time: this.currentTime,
            app: this.app,
        });
    }
    /**
     * This gets called from subscriber and also OnInit because
     * subscriber could have been set up after the event was broadcasted
     */
    fillAvailableTimes(layer, defaultTime) {
        this.availableTimes = layer.time.timePoints;
        this.setDateTimeFormatting();
        this.setCurrentTimeIfAvailable(defaultTime !== null && defaultTime !== void 0 ? defaultTime : this.layer.time.default);
        if (!this.currentTime && this.availableTimes.length > 0) {
            this.currentTime = this.availableTimes[0];
            this.currentTimeIdx = this.availableTimes.indexOf(this.currentTime);
        }
        this.availableTimesFetched = true;
        this.checkPrevFollowTimesAvailability();
    }
    setDateTimeFormatting() {
        if (this.hsConfig.get(this.app).timeDisplayFormat) {
            this.timeDisplayFormat = this.hsConfig.get(this.app).timeDisplayFormat;
        }
        else if (this.availableTimes.every((time) => time.endsWith('00-00T00:00:00.000Z'))) {
            this.timeDisplayFormat = 'yyyy';
        }
        else if (this.availableTimes.every((time) => time.endsWith('00T00:00:00.000Z'))) {
            this.timeDisplayFormat = 'yyyy-MM';
        }
        else if (this.availableTimes.every((time) => time.endsWith('00:00:00.000Z'))) {
            this.timeDisplayFormat = 'yyyy-MM-dd';
        }
        else if (this.availableTimes.every((time) => time.endsWith('00.000Z'))) {
            this.timeDisplayFormat = 'y-MM-dd HH:mm';
        }
        else if (this.availableTimes.every((time) => time.endsWith('000Z'))) {
            this.timeDisplayFormat = 'y-MM-dd HH:mm:ss';
        }
    }
}
HsLayerManagerTimeEditorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerManagerTimeEditorComponent, deps: [{ token: HsEventBusService }, { token: HsDimensionTimeService }, { token: HsLayoutService }, { token: HsConfig }], target: i0.ɵɵFactoryTarget.Component });
HsLayerManagerTimeEditorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsLayerManagerTimeEditorComponent, selector: "hs-layermanager-time-editor", inputs: { layer: "layer", app: "app" }, viewQueries: [{ propertyName: "selectElement", first: true, predicate: ["hstimeselector"], descendants: true }], ngImport: i0, template: "<div class=\"p-0 flex-grow-1\">\n  <button type=\"button\" class=\"btn btn-sm text-info\" (click)=\"previousTime()\" [disabled]=\"!hasPreviousTime\">\n    <i class=\"glyphicon icon-chevron-left\"></i>\n  </button>\n  <button class=\"btn btn-sm text-info px-0\" (click)=\"$event.preventDefault();showTimeSelect()\" [hidden]=\"selectVisible\"\n    *ngIf=\"availableTimesFetched; else loading\">\n    <span *ngIf=\"currentTime; else outOfRange\">\n      {{currentTime | date:timeDisplayFormat:timeDisplayFormat}}\n    </span>\n  </button>\n  <ng-template #loading>\n    <div class=\"spinner-border spinner-border-sm text-info\" role=\"status\">\n      <span class=\"visually-hidden\">{{'COMMON.loading' | translateHs: {app} }}</span>\n    </div>&nbsp;<span class=\"text-muted\">{{'LAYERMANAGER.time.loading'| translateHs: {app} }}</span>\n  </ng-template>\n  <ng-template #outOfRange>\n    <span class=\"bg-warning text-dark\" data-toggle=\"tooltip\" data-container=\"body\"\n    data-placement=\"auto\" [ngbTooltip]=\"'LAYERMANAGER.time.outOfRangeDescription' | translateHs : {app} \"\n    [closeDelay]=\"hsConfig.get(app).layerTooltipDelay || 0\">\n    {{'LAYERMANAGER.time.outOfRange' | translateHs : {app} }}\n  </span>\n  </ng-template>\n  <select #hstimeselector [hidden]=\"!selectVisible\" [(ngModel)]=\"currentTime\" (change)=\"selectTime();hideTimeSelect();\"\n    (blur)=\"hideTimeSelect()\">\n    <option *ngFor=\"let time of availableTimes\" [ngValue]=\"time\">\n      {{time | date:timeDisplayFormat:timeDisplayFormat}}\n    </option>\n  </select>\n  <button type=\"button\" class=\"btn btn-sm text-info\" (click)=\"followingTime()\" [disabled]=\"!hasFollowingTime\">\n    <i class=\"glyphicon icon-chevron-right\"></i>\n  </button>\n</div>\n<div class=\"p-0\">\n  <button type=\"button\" class=\"btn btn-sm px-0\"\n    [ngClass]=\"{'btn-info text-white': timesInSync, 'text-secondary': !timesInSync}\" (click)=\"synchronizeTimes()\"\n    title=\"{{'LAYERMANAGER.time.syncTimesTooltip' | translateHs : {app} }}\">\n    <i class=\"glyphicon icon-timeline\"></i>\n    <span class=\"visually-hidden\">{{'LAYERMANAGER.time.syncTimes' | translateHs : {app} }}</span>\n  </button>\n</div>\n", directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i7.NgbTooltip, selector: "[ngbTooltip]", inputs: ["animation", "autoClose", "placement", "triggers", "container", "disableTooltip", "tooltipClass", "openDelay", "closeDelay", "ngbTooltip"], outputs: ["shown", "hidden"], exportAs: ["ngbTooltip"] }, { type: i3$1.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3$1.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i3$1.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], pipes: { "date": i3.DatePipe, "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerManagerTimeEditorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-layermanager-time-editor', template: "<div class=\"p-0 flex-grow-1\">\n  <button type=\"button\" class=\"btn btn-sm text-info\" (click)=\"previousTime()\" [disabled]=\"!hasPreviousTime\">\n    <i class=\"glyphicon icon-chevron-left\"></i>\n  </button>\n  <button class=\"btn btn-sm text-info px-0\" (click)=\"$event.preventDefault();showTimeSelect()\" [hidden]=\"selectVisible\"\n    *ngIf=\"availableTimesFetched; else loading\">\n    <span *ngIf=\"currentTime; else outOfRange\">\n      {{currentTime | date:timeDisplayFormat:timeDisplayFormat}}\n    </span>\n  </button>\n  <ng-template #loading>\n    <div class=\"spinner-border spinner-border-sm text-info\" role=\"status\">\n      <span class=\"visually-hidden\">{{'COMMON.loading' | translateHs: {app} }}</span>\n    </div>&nbsp;<span class=\"text-muted\">{{'LAYERMANAGER.time.loading'| translateHs: {app} }}</span>\n  </ng-template>\n  <ng-template #outOfRange>\n    <span class=\"bg-warning text-dark\" data-toggle=\"tooltip\" data-container=\"body\"\n    data-placement=\"auto\" [ngbTooltip]=\"'LAYERMANAGER.time.outOfRangeDescription' | translateHs : {app} \"\n    [closeDelay]=\"hsConfig.get(app).layerTooltipDelay || 0\">\n    {{'LAYERMANAGER.time.outOfRange' | translateHs : {app} }}\n  </span>\n  </ng-template>\n  <select #hstimeselector [hidden]=\"!selectVisible\" [(ngModel)]=\"currentTime\" (change)=\"selectTime();hideTimeSelect();\"\n    (blur)=\"hideTimeSelect()\">\n    <option *ngFor=\"let time of availableTimes\" [ngValue]=\"time\">\n      {{time | date:timeDisplayFormat:timeDisplayFormat}}\n    </option>\n  </select>\n  <button type=\"button\" class=\"btn btn-sm text-info\" (click)=\"followingTime()\" [disabled]=\"!hasFollowingTime\">\n    <i class=\"glyphicon icon-chevron-right\"></i>\n  </button>\n</div>\n<div class=\"p-0\">\n  <button type=\"button\" class=\"btn btn-sm px-0\"\n    [ngClass]=\"{'btn-info text-white': timesInSync, 'text-secondary': !timesInSync}\" (click)=\"synchronizeTimes()\"\n    title=\"{{'LAYERMANAGER.time.syncTimesTooltip' | translateHs : {app} }}\">\n    <i class=\"glyphicon icon-timeline\"></i>\n    <span class=\"visually-hidden\">{{'LAYERMANAGER.time.syncTimes' | translateHs : {app} }}</span>\n  </button>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: HsEventBusService }, { type: HsDimensionTimeService }, { type: HsLayoutService }, { type: HsConfig }]; }, propDecorators: { layer: [{
                type: Input
            }], app: [{
                type: Input
            }], selectElement: [{
                type: ViewChild,
                args: ['hstimeselector']
            }] } });

class HsLayerListComponent {
    constructor(hsConfig, //In template
    hsLayerManagerService, hsDimensionTimeService, hsEventBusService, hsLayerUtilsService, //In template
    hsLayerListService) {
        this.hsConfig = hsConfig;
        this.hsLayerManagerService = hsLayerManagerService;
        this.hsDimensionTimeService = hsDimensionTimeService;
        this.hsEventBusService = hsEventBusService;
        this.hsLayerUtilsService = hsLayerUtilsService;
        this.hsLayerListService = hsLayerListService;
        this.app = 'default';
        /**
         * List of layers which belong to folder hierarchy level of directive instance
         */
        this.filtered_layers = [];
        this.getHsLaymanSynchronizing = getHsLaymanSynchronizing;
        this.getExclusive = getExclusive;
        this.layerFilter = (item) => {
            const r = new RegExp(this.hsLayerManagerService.apps[this.app].data.filter, 'i');
            return r.test(item.title);
        };
        this.layerManagerUpdatesSubscription =
            this.hsEventBusService.layerManagerUpdates.subscribe(() => {
                this.hsLayerManagerService.updateLayerListPositions(this.app);
                this.updateLayers();
            });
    }
    ngOnDestroy() {
        this.layerManagerUpdatesSubscription.unsubscribe();
    }
    /**
     * Test if selected layer is loaded in map
     * @param layer - Selected layer
     */
    layerLoaded(layer) {
        return this.hsLayerUtilsService.layerLoaded(layer);
    }
    /**
     * Test if selected layer is valid
     * @param layer - Selected layer
     * @returns true for invalid layer
     */
    layerValid(layer) {
        return this.hsLayerUtilsService.layerInvalid(layer);
    }
    ngOnInit() {
        this.filtered_layers = this.hsLayerListService.filterLayers(this.folder, this.app);
    }
    showLayerWmsT(layer) {
        var _a;
        return (this.hsDimensionTimeService.layerIsWmsT(layer) &&
            !((_a = getDimension(layer.layer, 'time')) === null || _a === void 0 ? void 0 : _a.onlyInEditor));
    }
    /**
     * Update layers list
     */
    updateLayers() {
        this.filtered_layers = this.hsLayerListService.filterLayers(this.folder, this.app);
    }
}
HsLayerListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerListComponent, deps: [{ token: HsConfig }, { token: HsLayerManagerService }, { token: HsDimensionTimeService }, { token: HsEventBusService }, { token: HsLayerUtilsService }, { token: HsLayerListService }], target: i0.ɵɵFactoryTarget.Component });
HsLayerListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsLayerListComponent, selector: "hs-layermanager-layer-list", inputs: { folder: "folder", app: "app" }, ngImport: i0, template: "<div class=\"list-group-item hs-lm-list pb-1\" *ngIf=\"folder.layers.length>0\">\n    <ul class=\"list-group row\"><!-- TODO: Remove function call from template -->\n        <li *ngFor=\"let layer of filtered_layers | filter:layerFilter\" id=\"{{layer.idString()}}\"\n            class=\"list-group-item hs-lm-item\"\n            [ngClass]=\"{'hs-lm-detail-activated':'currentLayer == layer', 'grayed': layer.grayed === true}\">\n            <div class=\"d-flex\">\n                <div class=\"p-0\" [ngClass]=\"getExclusive(layer.layer) ? 'exclusive' : ''\"><!-- TODO: Remove function call from template -->\n                    <button type=\"button\" class=\"btn btn-sm btn-light hs-lm-item-visibility\"\n                        (click)=\"hsLayerManagerService.changeLayerVisibility(!layer.visible, layer, app);hsLayerListService.toggleSublayersVisibility(layer,app);$event.stopPropagation()\"\n                        [ngClass]=\"layer.visible ? 'hs-checkmark' : 'hs-uncheckmark'\"></button>\n                </div>\n                <ng-template #abstractTooltip>\n                    <span [innerHtml]=\"hsLayerManagerService.makeSafeAndTranslate('LAYERS', layer.abstract, app)\"></span>\n                </ng-template>\n                <div class=\"align-items-center p-0 hs-lm-item-title flex-grow-1\"\n                    (click)=\"hsLayerManagerService.toggleLayerEditor(layer,'sublayers', 'settings', app)\"\n                    style=\"word-break:break-word;\" [ngClass]=\"{'hover': layer.hasSublayers === true}\"\n                    [ngbTooltip]=\"layer.abstract ? abstractTooltip : ''\"\n                    [closeDelay]=\"hsConfig.get(app).layerTooltipDelay || 0\">\n                    {{layer.title | translateHs : {app, module: 'LAYERS'} }}\n                </div>\n                <div class=\"p-0 me-1 ms-1 info_btn\" *ngIf=\"layer.hasSublayers\"\n                    style=\"font-size: x-small; flex-grow: 20;\"\n                    (click)=\"hsLayerManagerService.toggleLayerEditor(layer,'sublayers', 'settings', app)\">\n                    <span class=\"me-1 icon-refresh icon-spin\" [hidden]=\"layerLoaded(layer)\"></span>\n                    <span class=\"me-1\"\n                        [ngClass]=\"{'icon-chevron-right':hsLayerManagerService.apps[app].currentLayer === layer, 'icon-chevron-down': hsLayerManagerService.apps[app].currentLayer !== layer}\"\n                        [hidden]=\"!layerLoaded(layer)\"></span>\n                </div>\n\n                <div class=\"p-0 \" [hidden]=\"layerValid(layer)\">\n                    <i class=\"icon-warning-sign hs-lm-warning-scale\"\n                        [title]=\"'LAYERMANAGER.layerList.noAvailableInScale' | translateHs : {app} \" data-toggle=\"tooltip\"\n                        data-container=\"body\" data-placement=\"auto\" [hidden]=\"!layer.grayed\"\n                        (click)=\"$event.stopPropagation()\"></i>\n                </div>\n                <div class=\"p-0\" [hidden]=\"!layerValid(layer)\">\n                    <i class=\"icon-warning-sign alert-danger bg-white hs-lm-warning-error\"\n                        [title]=\"'LAYERMANAGER.layerList.layerNotAvailable' | translateHs : {app} \" data-toggle=\"tooltip\"\n                        data-container=\"body\" data-placement=\"auto\" (click)=\"$event.stopPropagation()\"></i>\n                </div>\n                <div class=\"p-0\" [hidden]=\"!getHsLaymanSynchronizing(layer.layer)\">\n                    <i class=\"icon-cloudaltsync\" [title]=\"'LAYERMANAGER.layerList.sendingToLayman' | translateHs : {app} \"\n                        data-toggle=\"tooltip\" data-container=\"body\" data-placement=\"auto\"\n                        (click)=\"$event.stopPropagation()\"></i>\n                </div>\n                <div class=\"p-0\" [hidden]=\"!hsLayerListService.isLayerQueryable(layer)\">\n                    <i class=\"icon-info-sign hs-lm-queryable\"\n                        [title]=\"'LAYERMANAGER.layerList.layerIsQueryable' | translateHs : {app} \"\n                        (click)=\"$event.stopPropagation()\"></i>\n                </div>\n                <div class=\"ps-1 info_btn\">\n                    <span class=\"icon-settingsthree-gears text-secondary\"\n                        (click)=\"hsLayerManagerService.toggleLayerEditor(layer,'settings','sublayers', app)\"\n                        [title]=\"'COMMON.info' | translateHs : {app} \" data-toggle=\"tooltip\" data-container=\"body\"\n                        data-placement=\"auto\"></span>\n                </div>\n            </div>\n            <hs-layermanager-time-editor [layer]=\"layer\" class=\"d-flex\" [app]=\"app\" *ngIf=\"showLayerWmsT(layer)\"><!-- TODO: Remove function call from template -->\n            </hs-layermanager-time-editor>\n        </li>\n    </ul>\n</div>\n", components: [{ type: HsLayerManagerTimeEditorComponent, selector: "hs-layermanager-time-editor", inputs: ["layer", "app"] }], directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i7.NgbTooltip, selector: "[ngbTooltip]", inputs: ["animation", "autoClose", "placement", "triggers", "container", "disableTooltip", "tooltipClass", "openDelay", "closeDelay", "ngbTooltip"], outputs: ["shown", "hidden"], exportAs: ["ngbTooltip"] }], pipes: { "filter": FilterPipe, "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-layermanager-layer-list', template: "<div class=\"list-group-item hs-lm-list pb-1\" *ngIf=\"folder.layers.length>0\">\n    <ul class=\"list-group row\"><!-- TODO: Remove function call from template -->\n        <li *ngFor=\"let layer of filtered_layers | filter:layerFilter\" id=\"{{layer.idString()}}\"\n            class=\"list-group-item hs-lm-item\"\n            [ngClass]=\"{'hs-lm-detail-activated':'currentLayer == layer', 'grayed': layer.grayed === true}\">\n            <div class=\"d-flex\">\n                <div class=\"p-0\" [ngClass]=\"getExclusive(layer.layer) ? 'exclusive' : ''\"><!-- TODO: Remove function call from template -->\n                    <button type=\"button\" class=\"btn btn-sm btn-light hs-lm-item-visibility\"\n                        (click)=\"hsLayerManagerService.changeLayerVisibility(!layer.visible, layer, app);hsLayerListService.toggleSublayersVisibility(layer,app);$event.stopPropagation()\"\n                        [ngClass]=\"layer.visible ? 'hs-checkmark' : 'hs-uncheckmark'\"></button>\n                </div>\n                <ng-template #abstractTooltip>\n                    <span [innerHtml]=\"hsLayerManagerService.makeSafeAndTranslate('LAYERS', layer.abstract, app)\"></span>\n                </ng-template>\n                <div class=\"align-items-center p-0 hs-lm-item-title flex-grow-1\"\n                    (click)=\"hsLayerManagerService.toggleLayerEditor(layer,'sublayers', 'settings', app)\"\n                    style=\"word-break:break-word;\" [ngClass]=\"{'hover': layer.hasSublayers === true}\"\n                    [ngbTooltip]=\"layer.abstract ? abstractTooltip : ''\"\n                    [closeDelay]=\"hsConfig.get(app).layerTooltipDelay || 0\">\n                    {{layer.title | translateHs : {app, module: 'LAYERS'} }}\n                </div>\n                <div class=\"p-0 me-1 ms-1 info_btn\" *ngIf=\"layer.hasSublayers\"\n                    style=\"font-size: x-small; flex-grow: 20;\"\n                    (click)=\"hsLayerManagerService.toggleLayerEditor(layer,'sublayers', 'settings', app)\">\n                    <span class=\"me-1 icon-refresh icon-spin\" [hidden]=\"layerLoaded(layer)\"></span>\n                    <span class=\"me-1\"\n                        [ngClass]=\"{'icon-chevron-right':hsLayerManagerService.apps[app].currentLayer === layer, 'icon-chevron-down': hsLayerManagerService.apps[app].currentLayer !== layer}\"\n                        [hidden]=\"!layerLoaded(layer)\"></span>\n                </div>\n\n                <div class=\"p-0 \" [hidden]=\"layerValid(layer)\">\n                    <i class=\"icon-warning-sign hs-lm-warning-scale\"\n                        [title]=\"'LAYERMANAGER.layerList.noAvailableInScale' | translateHs : {app} \" data-toggle=\"tooltip\"\n                        data-container=\"body\" data-placement=\"auto\" [hidden]=\"!layer.grayed\"\n                        (click)=\"$event.stopPropagation()\"></i>\n                </div>\n                <div class=\"p-0\" [hidden]=\"!layerValid(layer)\">\n                    <i class=\"icon-warning-sign alert-danger bg-white hs-lm-warning-error\"\n                        [title]=\"'LAYERMANAGER.layerList.layerNotAvailable' | translateHs : {app} \" data-toggle=\"tooltip\"\n                        data-container=\"body\" data-placement=\"auto\" (click)=\"$event.stopPropagation()\"></i>\n                </div>\n                <div class=\"p-0\" [hidden]=\"!getHsLaymanSynchronizing(layer.layer)\">\n                    <i class=\"icon-cloudaltsync\" [title]=\"'LAYERMANAGER.layerList.sendingToLayman' | translateHs : {app} \"\n                        data-toggle=\"tooltip\" data-container=\"body\" data-placement=\"auto\"\n                        (click)=\"$event.stopPropagation()\"></i>\n                </div>\n                <div class=\"p-0\" [hidden]=\"!hsLayerListService.isLayerQueryable(layer)\">\n                    <i class=\"icon-info-sign hs-lm-queryable\"\n                        [title]=\"'LAYERMANAGER.layerList.layerIsQueryable' | translateHs : {app} \"\n                        (click)=\"$event.stopPropagation()\"></i>\n                </div>\n                <div class=\"ps-1 info_btn\">\n                    <span class=\"icon-settingsthree-gears text-secondary\"\n                        (click)=\"hsLayerManagerService.toggleLayerEditor(layer,'settings','sublayers', app)\"\n                        [title]=\"'COMMON.info' | translateHs : {app} \" data-toggle=\"tooltip\" data-container=\"body\"\n                        data-placement=\"auto\"></span>\n                </div>\n            </div>\n            <hs-layermanager-time-editor [layer]=\"layer\" class=\"d-flex\" [app]=\"app\" *ngIf=\"showLayerWmsT(layer)\"><!-- TODO: Remove function call from template -->\n            </hs-layermanager-time-editor>\n        </li>\n    </ul>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: HsConfig }, { type: HsLayerManagerService }, { type: HsDimensionTimeService }, { type: HsEventBusService }, { type: HsLayerUtilsService }, { type: HsLayerListService }]; }, propDecorators: { folder: [{
                type: Input
            }], app: [{
                type: Input
            }] } });

class HsLayerManagerFolderComponent {
    constructor(HsLanguageService /* Used in template */) {
        this.HsLanguageService = HsLanguageService;
        this.app = 'default';
    }
}
HsLayerManagerFolderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerManagerFolderComponent, deps: [{ token: HsLanguageService }], target: i0.ɵɵFactoryTarget.Component });
HsLayerManagerFolderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsLayerManagerFolderComponent, selector: "hs-layer-manager-folder", inputs: { folder: "folder", app: "app" }, ngImport: i0, template: "<div>\n    <ul class=\"list-group\" *ngFor=\"let value of folder.sub_folders\">\n        <a  class=\"list-group-item list-group-item-warning\">\n            <span [ngStyle]=\"{'padding-left': value.indent*15}\">{{value.name | translateHs : {app, module: 'LAYERMANAGER'} }}</span>\n        </a>\n        <li [hidden]=\"!(value.sub_folders.length > 0)\">\n            <hs-layer-manager-folder [folder]=\"value\" [app]=\"app\"></hs-layer-manager-folder>\n        </li>\n        <li>\n            <hs-layermanager-layer-list [folder]=\"value\" [app]=\"app\"></hs-layermanager-layer-list>\n        </li>\n    </ul>\n</div>\n", components: [{ type: HsLayerManagerFolderComponent, selector: "hs-layer-manager-folder", inputs: ["folder", "app"] }, { type: HsLayerListComponent, selector: "hs-layermanager-layer-list", inputs: ["folder", "app"] }], directives: [{ type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerManagerFolderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-layer-manager-folder', template: "<div>\n    <ul class=\"list-group\" *ngFor=\"let value of folder.sub_folders\">\n        <a  class=\"list-group-item list-group-item-warning\">\n            <span [ngStyle]=\"{'padding-left': value.indent*15}\">{{value.name | translateHs : {app, module: 'LAYERMANAGER'} }}</span>\n        </a>\n        <li [hidden]=\"!(value.sub_folders.length > 0)\">\n            <hs-layer-manager-folder [folder]=\"value\" [app]=\"app\"></hs-layer-manager-folder>\n        </li>\n        <li>\n            <hs-layermanager-layer-list [folder]=\"value\" [app]=\"app\"></hs-layermanager-layer-list>\n        </li>\n    </ul>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: HsLanguageService }]; }, propDecorators: { folder: [{
                type: Input
            }], app: [{
                type: Input
            }] } });

class LayerListItem {
}
class HsLayerShiftingService {
    constructor(hsMapService, hsLayerManagerService, hsUtilsService, hsEventBusService) {
        this.hsMapService = hsMapService;
        this.hsLayerManagerService = hsLayerManagerService;
        this.hsUtilsService = hsUtilsService;
        this.hsEventBusService = hsEventBusService;
        this.apps = {
            default: { layersCopy: [] },
        };
    }
    /**
     * Get the params saved by the layer shifting service for the current app
     * @param app - App identifier
     */
    get(app) {
        if (this.apps[app !== null && app !== void 0 ? app : 'default'] == undefined) {
            this.apps[app !== null && app !== void 0 ? app : 'default'] = {
                layersCopy: [],
            };
        }
        return this.apps[app !== null && app !== void 0 ? app : 'default'];
    }
    /**
     * Get available layers
     * @param app - App identifier
     */
    getAvailableLayers(app) {
        return this.hsLayerManagerService.get(app).data.layers;
    }
    /**
     * Get map layers
     * @param app - App identifier
     */
    getMapLayers(app) {
        return this.hsMapService
            .getLayersArray(app)
            .filter((layer) => getBase(layer) !== true);
    }
    /**
     * Copies layers from Layermanager layer list for the physical layer list
     * @param app - App identifier
     */
    fillLayers(app) {
        if (!this.getAvailableLayers(app)) {
            return;
        }
        this.get(app).layersCopy = this.hsLayerManagerService.sortLayersByZ(this.getAvailableLayers(app).map((l) => {
            return { title: l.title, layer: l.layer };
        }), app);
    }
    /**
     * Move the provided layer in the middle between all other rendered layers on the map
     * @param layer - provided layer
     * @param target - Target layer number, item or source
     * @param app - App identifier
     */
    moveTo(layer, target, app) {
        if (this.hsUtilsService.instOf(target, LayerListItem)) {
            //Wrapped layer provided
            target = target.layer.getZIndex();
        }
        else if (this.hsUtilsService.instOf(target, Layer)) {
            //OL layer provided
            target = target.getZIndex();
        }
        this.moveAndShift(this.getOlLayer(layer), target, app);
    }
    /**
     * Move and shift layer order to make changes on the map
     * @param providedLayer - provided layer
     * @param preferredZIndex - ZIndex value to switch to
     * @param app - App identifier
     */
    moveAndShift(providedLayer, preferredZIndex, app) {
        if (providedLayer === undefined) {
            return;
        }
        if (providedLayer.getZIndex() != preferredZIndex) {
            const indexFrom = providedLayer.getZIndex();
            const indexTo = preferredZIndex;
            const incrementValue = indexTo > indexFrom ? -1 : 1;
            for (const lyr of this.getMapLayers(app).filter((lyr) => lyr != providedLayer)) {
                const currentZIndex = lyr.getZIndex();
                if ((currentZIndex >= indexFrom && currentZIndex <= indexTo) ||
                    (currentZIndex <= indexFrom && currentZIndex >= indexTo)) {
                    lyr.setZIndex(lyr.getZIndex() + incrementValue);
                }
            }
            providedLayer.setZIndex(preferredZIndex);
            this.hsEventBusService.layerManagerUpdates.next({
                layer: providedLayer,
                app,
            });
        }
    }
    /**
     * Gets layer property of container object or the actual provided ol layer
     * @param layer - Provided layer
     * @returns Returns ol layer
     */
    getOlLayer(providedLayer) {
        if (this.hsUtilsService.instOf(providedLayer, Layer)) {
            return providedLayer;
        }
        else {
            return providedLayer.layer;
        }
    }
    /**
     * Gets all layer ZIndex values from the layer list
     * @param app - App identifier
     * @returns Returns array of ZIndex values
     */
    zIndexList(app) {
        return this.getMapLayers(app).map((lyr) => lyr.getZIndex() || 0);
    }
    /**
     * Gets maximum value from ZIndex value array
     * @param app - App identifier
     * @returns Returns max ZIndex value
     */
    getMaxZ(app) {
        return Math.max(...this.zIndexList(app));
    }
    /**
     * Gets minimum value from ZIndex value array
     * @param app - App identifier
     * @returns Returns min ZIndex value
     */
    getMinZ(app) {
        return Math.min(...this.zIndexList(app));
    }
    /**
     * Applies a new ZIndex value to the selected layer that is responsible for layer rendering on the map
     * @param indexTo - new ZIndex value for the selected layer
     * @param layer - Selected layer from physical layer list
     * @param app - App identifier
     */
    setLayerZIndex(indexTo, layer, app) {
        const layerSwitchedWith = this.get(app).layersCopy[indexTo].layer;
        const interactedLayerZIndex = layer.getZIndex();
        layer.setZIndex(layerSwitchedWith.getZIndex());
        layerSwitchedWith.setZIndex(interactedLayerZIndex);
        this.hsEventBusService.layerManagerUpdates.next({ layer, app });
    }
    /**
     * Move the provided layer under all other rendered layers on the map
     * @param layer - provided layer
     * @param app - App identifier
     */
    moveToBottom(layer, app) {
        this.moveAndShift(this.getOlLayer(layer), this.getMinZ(app), app);
    }
    /**
     * Move the provided layer over all other rendered layers on the map
     * @param layer - provided layer
     * @param app - App identifier
     */
    moveToTop(layer, app) {
        this.moveAndShift(this.getOlLayer(layer), this.getMaxZ(app), app);
    }
    /**
     * Changes selected layers ZIndex value - layer with the largest ZIndex will be rendered on top of all other layers
     * @param baseLayer - Selected layer from physical layer list
     * @param direction - Direction in which to move the selected layer - up/down
     * @param app - App identifier
     */
    swapSibling(baseLayer, direction, app) {
        const currentLayerIndex = this.get(app).layersCopy.indexOf(baseLayer);
        switch (direction.toLocaleLowerCase()) {
            case 'up':
                if (currentLayerIndex != 0) {
                    this.setLayerZIndex(currentLayerIndex - 1, baseLayer.layer, app);
                }
                break;
            case 'down':
                if (currentLayerIndex < this.get(app).layersCopy.length - 1) {
                    this.setLayerZIndex(currentLayerIndex + 1, baseLayer.layer, app);
                }
                break;
            default:
        }
    }
}
HsLayerShiftingService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerShiftingService, deps: [{ token: HsMapService }, { token: HsLayerManagerService }, { token: HsUtilsService }, { token: HsEventBusService }], target: i0.ɵɵFactoryTarget.Injectable });
HsLayerShiftingService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerShiftingService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerShiftingService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsMapService }, { type: HsLayerManagerService }, { type: HsUtilsService }, { type: HsEventBusService }]; } });

class HsLayerPhysicalListComponent {
    constructor(hsEventBusService, hsLayerShiftingService) {
        this.hsEventBusService = hsEventBusService;
        this.hsLayerShiftingService = hsLayerShiftingService;
        this.app = 'default';
    }
    ngOnInit() {
        this.layerShiftingAppRef = this.hsLayerShiftingService.get(this.app);
        this.hsLayerShiftingService.fillLayers(this.app);
        this.layerManagerUpdatesSubscription =
            this.hsEventBusService.layerManagerUpdates.subscribe(({ layer, app }) => {
                this.hsLayerShiftingService.fillLayers(this.app);
                if (layer !== undefined) {
                    const layerFound = this.hsLayerShiftingService
                        .get(app)
                        .layersCopy.find((wrapper) => wrapper.layer == layer);
                    if (layerFound !== undefined) {
                        layerFound.active = true;
                    }
                }
            });
    }
    ngOnDestroy() {
        this.layerManagerUpdatesSubscription.unsubscribe();
    }
    drop(event) {
        const draggedLayer = event.container.data[event.previousIndex];
        const replacedLayer = event.container.data[event.currentIndex];
        moveItemInArray(this.layerShiftingAppRef.layersCopy, event.previousIndex, event.currentIndex);
        this.hsLayerShiftingService.moveTo(draggedLayer, replacedLayer.layer, this.app);
    }
}
HsLayerPhysicalListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerPhysicalListComponent, deps: [{ token: HsEventBusService }, { token: HsLayerShiftingService }], target: i0.ɵɵFactoryTarget.Component });
HsLayerPhysicalListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsLayerPhysicalListComponent, selector: "hs-layermanager-physical-layer-list", inputs: { app: "app" }, ngImport: i0, template: "<div class=\"list-group-item hs-lm-list pb-1\" *ngIf=\"layerShiftingAppRef.layersCopy.length !== 0\">\n    <div cdkDropList class=\"list-group row ps-1\" (cdkDropListDropped)=\"drop($event)\"\n        [cdkDropListData]=\"layerShiftingAppRef.layersCopy\">\n        <div class=\"list-group-item hs-lm-item p-2\" [ngClass]=\"{'activeLayer': layer.active}\"\n            *ngFor=\"let layer of layerShiftingAppRef.layersCopy;\" cdkDrag>\n            <div class=\"d-flex align-items-center justify-content-between p-0 hs-lm-item-title flex-grow-1\"\n                style=\"word-break:break-all; cursor:move\">\n                <p class=\"m-0\">{{layer.title | translateHs : {app, module: 'LAYERS'} }}</p>\n                <i class=\"icon-move text-secondary\"></i>\n            </div>\n        </div>\n    </div>\n</div>", styles: [".activeLayer{background-color:#0003}.cdk-drag-placeholder{background-color:#0000003d;color:#fff}.cdk-drag-preview{box-sizing:border-box;background-color:#b9b9b9bf;border:1px solid rgb(185,185,185);overflow:hidden;color:transparent;box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.cdk-drag-animating{transition:transform .25s cubic-bezier(0,0,.2,1)}.list-group.cdk-drop-list-dragging .list-group-item:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}\n"], directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i4.CdkDropList, selector: "[cdkDropList], cdk-drop-list", inputs: ["cdkDropListConnectedTo", "cdkDropListData", "cdkDropListOrientation", "id", "cdkDropListLockAxis", "cdkDropListDisabled", "cdkDropListSortingDisabled", "cdkDropListEnterPredicate", "cdkDropListSortPredicate", "cdkDropListAutoScrollDisabled", "cdkDropListAutoScrollStep"], outputs: ["cdkDropListDropped", "cdkDropListEntered", "cdkDropListExited", "cdkDropListSorted"], exportAs: ["cdkDropList"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i4.CdkDrag, selector: "[cdkDrag]", inputs: ["cdkDragData", "cdkDragLockAxis", "cdkDragRootElement", "cdkDragBoundary", "cdkDragStartDelay", "cdkDragFreeDragPosition", "cdkDragDisabled", "cdkDragConstrainPosition", "cdkDragPreviewClass", "cdkDragPreviewContainer"], outputs: ["cdkDragStarted", "cdkDragReleased", "cdkDragEnded", "cdkDragEntered", "cdkDragExited", "cdkDragDropped", "cdkDragMoved"], exportAs: ["cdkDrag"] }, { type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerPhysicalListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-layermanager-physical-layer-list', template: "<div class=\"list-group-item hs-lm-list pb-1\" *ngIf=\"layerShiftingAppRef.layersCopy.length !== 0\">\n    <div cdkDropList class=\"list-group row ps-1\" (cdkDropListDropped)=\"drop($event)\"\n        [cdkDropListData]=\"layerShiftingAppRef.layersCopy\">\n        <div class=\"list-group-item hs-lm-item p-2\" [ngClass]=\"{'activeLayer': layer.active}\"\n            *ngFor=\"let layer of layerShiftingAppRef.layersCopy;\" cdkDrag>\n            <div class=\"d-flex align-items-center justify-content-between p-0 hs-lm-item-title flex-grow-1\"\n                style=\"word-break:break-all; cursor:move\">\n                <p class=\"m-0\">{{layer.title | translateHs : {app, module: 'LAYERS'} }}</p>\n                <i class=\"icon-move text-secondary\"></i>\n            </div>\n        </div>\n    </div>\n</div>", styles: [".activeLayer{background-color:#0003}.cdk-drag-placeholder{background-color:#0000003d;color:#fff}.cdk-drag-preview{box-sizing:border-box;background-color:#b9b9b9bf;border:1px solid rgb(185,185,185);overflow:hidden;color:transparent;box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.cdk-drag-animating{transition:transform .25s cubic-bezier(0,0,.2,1)}.list-group.cdk-drop-list-dragging .list-group-item:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}\n"] }]
        }], ctorParameters: function () { return [{ type: HsEventBusService }, { type: HsLayerShiftingService }]; }, propDecorators: { app: [{
                type: Input
            }] } });

class HsLayerEditorWidgetBaseComponent {
    constructor(hsLayerSelectorService) {
        this.hsLayerSelectorService = hsLayerSelectorService;
        this.layerDescriptor = new BehaviorSubject(null);
        this.isVisible$ = new BehaviorSubject(true);
        this.ngBaseUnsubscribe = new Subject();
        this.layerDescriptor.subscribe((descriptor) => {
            this.olLayer = descriptor === null || descriptor === void 0 ? void 0 : descriptor.layer;
        });
    }
    ngOnInit() {
        this.layerDescriptor.next(this.hsLayerSelectorService.get(this.data.app).currentLayer);
        this.hsLayerSelectorService.layerSelected
            .pipe(takeUntil(this.ngBaseUnsubscribe))
            .subscribe(({ layer, app }) => {
            if (app == this.data.app) {
                this.layerDescriptor.next(layer);
            }
        });
    }
    isVisible() {
        return true;
    }
    ngOnDestroy() {
        this.ngBaseUnsubscribe.next();
        this.ngBaseUnsubscribe.complete();
    }
}
HsLayerEditorWidgetBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerEditorWidgetBaseComponent, deps: [{ token: HsLayerSelectorService }], target: i0.ɵɵFactoryTarget.Component });
HsLayerEditorWidgetBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsLayerEditorWidgetBaseComponent, selector: "ng-component", ngImport: i0, template: '<div></div>', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerEditorWidgetBaseComponent, decorators: [{
            type: Component,
            args: [{
                    template: '<div></div>',
                }]
        }], ctorParameters: function () { return [{ type: HsLayerSelectorService }]; } });

const NORMALIZED_WEIGHT_PROPERTY_NAME = 'hs_normalized_IDW_value';
class InterpolatedSource extends IDW {
    constructor(options) {
        super({
            // Source that contains the data
            source: new VectorSource({
                strategy: options.strategy != undefined
                    ? options.strategy
                    : (extent, resolution) => {
                        const extentCache = super
                            .getSource()
                            .loadedExtentsRtree_.getAll()
                            .map((item) => item.extent);
                        const toRemove = extentCache.filter(
                        //Delete cached extents which contain this extent because they have their feature counts limited
                        (cachedExt) => !equals$1(cachedExt, extent) &&
                            containsExtent(cachedExt, extent));
                        for (const extToRemove of toRemove) {
                            super.getSource().removeLoadedExtent(extToRemove);
                        }
                        return [extent];
                    },
                loader: (extent, resolution, projection, success, failure) => __awaiter(this, void 0, void 0, function* () {
                    if (options.loader) {
                        this.fillFeatures(yield options.loader({
                            extent,
                            resolution,
                            projection,
                            success,
                            failure,
                        }), extent);
                    }
                }),
            }),
            weight: NORMALIZED_WEIGHT_PROPERTY_NAME,
        });
        this.options = options;
        this.featureCache = new VectorSource({});
        this.cancelUrlRequest = new Subject();
        this.colorMapChanged = new Subject();
        this.geoJSONFeatures = [];
        if (options.colorMap) {
            this.setColorMapFromOptions(options);
        }
        if (options.features) {
            this.fillFeatures(options.features);
        }
    }
    /**
     * Get Minimum boundary used in normalization. Values under this minimum are set to it (clamped)
     */
    get min() {
        return this.options.min;
    }
    /**
     * Set Minimum boundary used in normalization. Values under this minimum are set to it (clamped)
     */
    set min(value) {
        this.options.min = value;
        this.normalizeWeight(this.weight);
        super.changed();
    }
    /**
     * Get Maximum boundary used in normalization. Values over this minimum are set to it (clamped)
     */
    get max() {
        return this.options.max;
    }
    /**
     * Set Maximum boundary used in normalization. Values over this minimum are set to it (clamped)
     */
    set max(value) {
        this.options.max = value;
        this.normalizeWeight(this.weight);
        super.changed();
    }
    get colorMap() {
        return this.options.colorMap;
    }
    set colorMap(value) {
        this.options.colorMap = value;
        this.setColorMapFromOptions(this.options);
        super.changed();
    }
    /**
     * Get the feature attribute used to get the values interpolated
     */
    get weight() {
        return this.options.weight;
    }
    /**
     * Set the feature attribute used to get the values interpolated
     */
    set weight(value) {
        this.options.weight = value;
        this.normalizeWeight(this.weight);
        super.changed();
    }
    /**
     * Fill Interpolated source features
     * @param features - Parsed Ol features from get request
     * @param extent - Current map extent
     */
    fillFeatures(features, extent) {
        var _a;
        if (!features) {
            return;
        }
        const featsCached = this.featureCache.getFeatures();
        const cacheLimit = this.options.maxFeaturesInCache;
        if (cacheLimit < featsCached.length + features.length) {
            const cntToRemove = featsCached.length - (cacheLimit - features.length);
            featsCached
                .slice(0, cntToRemove)
                .forEach((f) => this.featureCache.removeFeature(f));
        }
        const countToAdd = cacheLimit !== null && cacheLimit !== void 0 ? cacheLimit : Number.MAX_VALUE;
        this.featureCache.addFeatures(features.slice(0, countToAdd));
        this.normalizeWeight(this.options.weight);
        const src = super.getSource();
        if (extent) {
            src.clear();
            const limitInExt = (_a = this.options.maxFeaturesInExtent) !== null && _a !== void 0 ? _a : Number.MAX_VALUE;
            src.addFeatures(this.featureCache.getFeaturesInExtent(extent).slice(0, limitInExt));
        }
        else {
            src.addFeatures(features);
        }
    }
    /**
     * Parse features from get request
     * @param collection - Get request response feature collection
     * @param mapProjection - Map projection
     */
    parseFeatures(collection, mapProjection) {
        var _a, _b;
        if (((_a = collection === null || collection === void 0 ? void 0 : collection.features) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            const dataProj = (_b = (collection.crs || collection.srs)) !== null && _b !== void 0 ? _b : 'EPSG:4326';
            collection.features = collection.features.filter((f) => !this.geoJSONFeatures.includes(f));
            this.geoJSONFeatures = this.geoJSONFeatures.concat(collection.features);
            collection.features = new GeoJSON().readFeatures(collection, {
                dataProjection: dataProj,
                featureProjection: mapProjection,
            });
            collection.features = collection.features.filter((f) => {
                const value = f.get(this.options.weight);
                if (value && !isNaN(parseInt(value))) {
                    return f;
                }
            });
            return collection.features;
        }
    }
    /**
     * Create url for get request including current map extent
     * @param url - external source URL
     * @param extent - Current map extent
     */
    createIDWSourceUrl(url, extent) {
        var _a;
        if (!url) {
            return;
        }
        else if (extent) {
            const extentObj = [
                { ref: 'minx', value: extent[0].toFixed(1) },
                { ref: 'miny', value: extent[1].toFixed(1) },
                { ref: 'maxx', value: extent[2].toFixed(1) },
                { ref: 'maxy', value: extent[3].toFixed(1) },
            ];
            const matches = url.match(/{.+?}/g);
            if ((matches === null || matches === void 0 ? void 0 : matches.length) > 0 && (matches === null || matches === void 0 ? void 0 : matches.length) <= 4) {
                for (const m of matches) {
                    const ix = matches.indexOf(m);
                    const key = m.replace(/[{}]/g, '').toLowerCase();
                    const coord = (_a = extentObj.find((e) => e.ref === key)) !== null && _a !== void 0 ? _a : extentObj[ix];
                    url = url.replace(m, coord.value);
                }
            }
        }
        return url;
    }
    /**
     * Normalize weight values to be between 0 and 100
     * //https://www.statology.org/normalize-data-between-0-and-100/
     * @param weight - Weight property name
     */
    normalizeWeight(weight) {
        var _a, _b;
        const features = this.featureCache.getFeatures();
        const weightValues = features.map((f) => parseFloat(f.get(weight)));
        const min = (_a = this.options.min) !== null && _a !== void 0 ? _a : Math.min(...weightValues);
        const max = (_b = this.options.max) !== null && _b !== void 0 ? _b : Math.max(...weightValues);
        features.forEach((f) => {
            const val = Math.min(Math.max(f.get(weight), min), max); //https://www.webtips.dev/webtips/javascript/how-to-clamp-numbers-in-javascript
            const normalizedWeight = Math.ceil(((val - min) / (max - min)) * 99);
            f.set(NORMALIZED_WEIGHT_PROPERTY_NAME, normalizedWeight, true);
        });
    }
    /**
     * Assingns colorMap function based on colorMap option used.
     * Predefined color maps if name of color map is provided
     * or uses the passed function directly.
     * @param options
     */
    setColorMapFromOptions(options) {
        if (typeof options.colorMap == 'string') {
            super.getColor = this.getColorMap();
        }
        else {
            super.getColor = options.colorMap;
        }
        this.colorMapChanged.next();
    }
    /**
     * Creates a function to return value from predefined color maps if name of color map is provided
     */
    getColorMap() {
        const clrMap = this.generateColormap(this.options.colorMap);
        return (v) => {
            const black = [0, 0, 0, 255];
            if (isNaN(v)) {
                return black;
            }
            if (v > 99) {
                v = 99;
            }
            if (v < 0) {
                v = 0;
            }
            v = Math.floor(v);
            return clrMap[v];
        };
    }
    /**
     * Gets predefined colorMap array based on name and number of shades.
     * If you want to reverse defined color map add '-reverse' to the map name
     * @param name Predefined color map name [https://github.com/bpostlethwaite/colormap]
     * @param nshades Number of shades [default = 100]
     * @returns Array of colors
     */
    generateColormap(name, nshades = 100) {
        const reverse = name.includes('-reverse');
        name = reverse ? name.split('-')[0] : name;
        const cmap = colormap({
            colormap: name,
            nshades,
            format: 'rgb',
            alpha: 255,
        }).map((v) => {
            v[3] = 255;
            return v;
        });
        return reverse ? cmap.reverse() : cmap;
    }
}

class HsLegendService {
    constructor(hsUtilsService, hsStylerService, hsLayerUtilsService, hsLayerSelectorService, sanitizer) {
        this.hsUtilsService = hsUtilsService;
        this.hsStylerService = hsStylerService;
        this.hsLayerUtilsService = hsLayerUtilsService;
        this.hsLayerSelectorService = hsLayerSelectorService;
        this.sanitizer = sanitizer;
        this.hsLayerSelectorService.layerSelected.subscribe(({ layer, app }) => __awaiter(this, void 0, void 0, function* () {
            yield this.getLayerLegendDescriptor(layer.layer, app);
        }));
    }
    /**
     * Test if layer is visible and has supported type (conditions for displaying legend)
     * @param layer - Layer to test
     * @returns Return if legend might exist for layer and layer is visible
     */
    legendValid(layer) {
        if (layer === undefined || layer.type == undefined) {
            return false;
        }
        if (['vector', 'wms', 'static'].indexOf(layer.type) > -1 &&
            layer.lyr.getVisible()) {
            return true;
        }
        return false;
    }
    /**
     * Get legend graphics for a vector layer based on sld attribute. If no SLD exists, try to generate it from OL style.
     * @param currentLayer - Layer of interest
     * @returns Image as SVG string
     */
    getVectorLayerLegendSvg(currentLayer) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (currentLayer === undefined) {
                    return;
                }
                const styleArray = [];
                if (!currentLayer.getStyle) {
                    return;
                }
                const parser = SLDParser.default
                    ? new SLDParser.default()
                    : new SLDParser();
                let sld = getSld(currentLayer);
                let sldObject;
                if (!sld) {
                    let layerStyle = currentLayer.getStyle();
                    if (typeof layerStyle == 'function') {
                        layerStyle = layerStyle(new Feature(), 1);
                    }
                    const symbolizers = new OlStyleParser().getSymbolizersFromOlStyle(Array.isArray(layerStyle) ? layerStyle : [layerStyle]);
                    sldObject = {
                        name: '',
                        rules: [
                            {
                                name: '',
                                symbolizers,
                            },
                        ],
                    };
                }
                else {
                    sldObject = (yield parser.readStyle(sld)).output;
                }
                //In case sld was not valid for parser, create a new one from default style
                if (!sldObject) {
                    sld = defaultStyle;
                    sldObject = (yield parser.readStyle(sld)).output;
                }
                const legendOpts = {
                    styles: [sldObject],
                    size: [300, 200],
                    hideRect: true,
                };
                const legendRenderer = LegendRenderer.default
                    ? new LegendRenderer.default(legendOpts)
                    : new LegendRenderer(legendOpts);
                const el = document.createElement('div');
                yield legendRenderer.render(el);
                return el.innerHTML;
            }
            catch (ex) {
                throw ex;
            }
        });
    }
    /**
     * Generate url for GetLegendGraphic request of WMS service for selected layer
     * @param source - Source of wms layer
     * @param layer_name - Name of layer for which legend is requested
     * @param layer - Layer to get legend for
     * @returns Url of the legend graphics
     */
    getLegendUrl(source, layer_name, layer, app) {
        if (!this.hsLayerUtilsService.isLayerWMS(layer)) {
            return '';
        }
        const params = this.hsLayerUtilsService.getLayerParams(layer);
        const version = params.VERSION || '1.3.0';
        let source_url = this.hsLayerUtilsService.getURL(layer);
        if (source_url.indexOf('proxy4ows') > -1) {
            const params = this.hsUtilsService.getParamsFromUrl(source_url);
            source_url = params.OWSURL;
        }
        const legendImage = getLegends(layer);
        if (legendImage === undefined ||
            (Array.isArray(legendImage) && legendImage.length == 0)) {
            source_url +=
                (source_url.indexOf('?') > 0 ? '' : '?') +
                    '&version=' +
                    version +
                    '&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=' +
                    layer_name +
                    '&format=image%2Fpng';
            if (getEnableProxy(layer) === undefined ||
                getEnableProxy(layer) == true) {
                source_url = this.hsUtilsService.proxify(source_url, app, false);
            }
            return source_url;
        }
        else {
            if (typeof legendImage == 'string') {
                return legendImage;
            }
            if (Array.isArray(legendImage)) {
                return legendImage[0];
            }
        }
    }
    setSvg(layer) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.sanitizer.bypassSecurityTrustHtml(yield this.getVectorLayerLegendSvg(layer));
        });
    }
    generateInterpolatedLayerLegend(layer, app) {
        const source = layer.getSource();
        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('width', '75%');
        svg.setAttribute('height', '100%');
        svg.setAttribute('style', 'max-width: 7em');
        const defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
        const linearGradient = document.createElementNS('http://www.w3.org/2000/svg', 'linearGradient');
        const id = `${+new Date()}-idwGradient-${getLaymanFriendlyLayerName(layer.get('name'))}`;
        linearGradient.setAttribute('id', id);
        linearGradient.setAttribute('gradientTransform', 'rotate(90)');
        const rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
        rect.setAttribute('width', '50%');
        rect.setAttribute('height', '100%');
        rect.setAttribute('fill', `url('#${id}')`);
        const arr = Array.from(Array(100).keys());
        for (const i of arr.filter((e, i) => i % 5 === 5 - 1).reverse()) {
            const color = source.getColor(i);
            const stop = document.createElementNS('http://www.w3.org/2000/svg', 'stop');
            stop.setAttribute('offset', `${100 - i}%`);
            const rgb = `rgb(${color[0]},${color[1]},${color[2]})`;
            stop.setAttribute('stop-color', rgb);
            linearGradient.appendChild(stop);
        }
        defs.appendChild(linearGradient);
        const max = document.createElementNS('http://www.w3.org/2000/svg', 'text');
        max.setAttribute('x', '50%');
        max.setAttribute('y', '10%');
        max.innerHTML = 'High';
        const min = document.createElementNS('http://www.w3.org/2000/svg', 'text');
        min.setAttribute('x', '50%');
        min.setAttribute('y', '95%');
        min.innerHTML = 'Low';
        svg.appendChild(defs);
        svg.appendChild(rect);
        svg.appendChild(max);
        svg.appendChild(min);
        return {
            autoLegend: true,
            title: getTitle(layer),
            lyr: layer,
            type: 'vector',
            visible: layer.getVisible(),
            svg: this.sanitizer.bypassSecurityTrustHtml(svg.outerHTML),
        };
    }
    /**
     * (PRIVATE) Generate url for GetLegendGraphic request of WMS service for selected layer
     * @param layer - OpenLayers layer
     * @returns Description of layer to be used for creating the legend. It contains type of layer, sublayer legends, title, visibility etc.
     */
    getLayerLegendDescriptor(layer, app) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            if (getBase(layer)) {
                return;
            }
            if (this.hsLayerUtilsService.isLayerWMS(layer)) {
                const subLayerLegends = (_a = this.hsLayerUtilsService
                    .getLayerParams(layer)
                    .LAYERS) === null || _a === void 0 ? void 0 : _a.split(',');
                for (let i = 0; i < subLayerLegends.length; i++) {
                    subLayerLegends[i] = this.getLegendUrl(layer.getSource(), subLayerLegends[i], layer, app);
                }
                return {
                    title: getTitle(layer),
                    lyr: layer,
                    type: 'wms',
                    subLayerLegends: subLayerLegends,
                    visible: layer.getVisible(),
                };
            }
            else if (this.hsUtilsService.instOf(layer, Vector$1) &&
                (getShowInLayerManager(layer) === undefined ||
                    getShowInLayerManager(layer) == true)) {
                return {
                    autoLegend: (_b = getAutoLegend(layer)) !== null && _b !== void 0 ? _b : true,
                    title: getTitle(layer),
                    lyr: layer,
                    type: 'vector',
                    visible: layer.getVisible(),
                    svg: yield this.setSvg(layer),
                };
            }
            else if (this.hsUtilsService.instOf(layer, Image$1) &&
                this.hsUtilsService.instOf(layer.getSource(), ImageStatic)) {
                return {
                    title: getTitle(layer),
                    lyr: layer,
                    type: 'static',
                    visible: layer.getVisible(),
                };
            }
            else if (this.hsUtilsService.instOf(layer.getSource(), XYZ)) {
                return {
                    title: getTitle(layer),
                    lyr: layer,
                    type: 'static',
                    visible: layer.getVisible(),
                };
            }
            else if (this.hsUtilsService.instOf(layer.getSource(), InterpolatedSource)) {
                return this.generateInterpolatedLayerLegend(layer, app);
            }
            else {
                return undefined;
            }
        });
    }
}
HsLegendService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLegendService, deps: [{ token: HsUtilsService }, { token: HsStylerService }, { token: HsLayerUtilsService }, { token: HsLayerSelectorService }, { token: i1$3.DomSanitizer }], target: i0.ɵɵFactoryTarget.Injectable });
HsLegendService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLegendService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLegendService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsUtilsService }, { type: HsStylerService }, { type: HsLayerUtilsService }, { type: HsLayerSelectorService }, { type: i1$3.DomSanitizer }]; } });

class HsLayerEditorServiceParams {
}
class HsLayerEditorService {
    constructor(HsMapService, HsWmsGetCapabilitiesService, HsLayerUtilsService, HsLayerEditorVectorLayerService, HsEventBusService, HsLayoutService, HsLegendService, HsLayerSelectorService, HsLayerManagerMetadataService) {
        this.HsMapService = HsMapService;
        this.HsWmsGetCapabilitiesService = HsWmsGetCapabilitiesService;
        this.HsLayerUtilsService = HsLayerUtilsService;
        this.HsLayerEditorVectorLayerService = HsLayerEditorVectorLayerService;
        this.HsEventBusService = HsEventBusService;
        this.HsLayoutService = HsLayoutService;
        this.HsLegendService = HsLegendService;
        this.HsLayerSelectorService = HsLayerSelectorService;
        this.HsLayerManagerMetadataService = HsLayerManagerMetadataService;
        this.apps = { default: new HsLayerEditorServiceParams() };
        this.layerTitleChange = new Subject();
        this.HsLayerSelectorService.layerSelected.subscribe(({ layer, app }) => __awaiter(this, void 0, void 0, function* () {
            this.get(app).legendDescriptor =
                yield this.HsLegendService.getLayerLegendDescriptor(layer.layer, app);
        }));
    }
    get(app) {
        if (this.apps[app !== null && app !== void 0 ? app : 'default'] == undefined) {
            this.apps[app !== null && app !== void 0 ? app : 'default'] = new HsLayerEditorServiceParams();
        }
        return this.apps[app !== null && app !== void 0 ? app : 'default'];
    }
    /**
     * Zoom to selected layer (layer extent). Get extent
     * from bounding box property, getExtent() function or from
     * BoundingBox property of GetCapabilities request (for WMS layer)
     * @param layer - OpenLayers layer to zoom to
     */
    zoomToLayer(layer, app) {
        return __awaiter(this, void 0, void 0, function* () {
            let extent = null;
            if (layer.getExtent()) {
                extent = layer.getExtent();
            }
            else if (layer.getSource().getExtent != undefined) {
                extent = layer.getSource().getExtent();
            }
            if (extent) {
                this.fitIfExtentSet(extent, layer, app);
                return true;
            }
            if (extent === null && this.HsLayerUtilsService.isLayerWMS(layer)) {
                const url = this.HsLayerUtilsService.getURL(layer);
                const wrapper = yield this.HsWmsGetCapabilitiesService.request(url, app);
                const parser = new WMSCapabilities();
                const caps = parser.read(wrapper.response);
                if (Array.isArray(caps.Capability.Layer.Layer)) {
                    const foundDefs = caps.Capability.Layer.Layer.map((lyr) => { var _a; return this.HsLayerManagerMetadataService.identifyLayerObject((_a = this.HsLayerUtilsService.getLayerParams(layer)) === null || _a === void 0 ? void 0 : _a.LAYERS, lyr); }).filter((item) => item);
                    const foundDef = foundDefs.length > 0 ? foundDefs[0] : null;
                    if (foundDef) {
                        extent = foundDef.EX_GeographicBoundingBox || foundDef.BoundingBox;
                        this.fitIfExtentSet(this.transformToCurrentProj(extent, app), layer, app);
                        return true;
                    }
                }
                else if (typeof caps.Capability.Layer == 'object') {
                    extent =
                        caps.Capability.Layer.EX_GeographicBoundingBox ||
                            caps.Capability.Layer.BoundingBox;
                    this.fitIfExtentSet(this.transformToCurrentProj(extent, app), layer, app);
                    return true;
                }
                else {
                    return false;
                }
            }
        });
    }
    /**
     * Set cluster for layer
     * @param layer - Layer
     * @param newValue - To cluster or not to cluster
     * @param distance - Distance in pixels
     * @returns Current cluster state
     */
    cluster(layer, newValue, distance, app) {
        if (layer == undefined) {
            return;
        }
        if (newValue != undefined) {
            setCluster(layer, newValue);
            this.HsLayerEditorVectorLayerService.cluster(newValue, layer, distance, !this.HsLayerEditorVectorLayerService.layersClusteredFromStart.includes(layer), app);
            this.HsEventBusService.compositionEdits.next({ app });
        }
        else {
            return getCluster(layer);
        }
    }
    /**
     * @typedef {Array<number>} Extent
     * @param {Extent} extent - Extent in EPSG:4326
     * @param layer
     */
    fitIfExtentSet(extent, layer, app) {
        if (extent !== null) {
            layer.setExtent(extent);
            this.HsMapService.fitExtent(extent, app);
        }
    }
    /**
     * @param extent
     */
    transformToCurrentProj(extent, app) {
        return transformExtent(extent, 'EPSG:4326', this.HsMapService.getCurrentProj(app));
    }
    legendVisible(app) {
        const legendDescriptor = this.get(app).legendDescriptor;
        return (this.HsLegendService.legendValid(legendDescriptor) &&
            (getInlineLegend(legendDescriptor.lyr) ||
                !this.HsLayoutService.panelEnabled('legend', app)));
    }
    /**
     * Test if layer is Vector layer
     * @param layer - Selected layer
     */
    isLayerVectorLayer(layer) {
        return this.HsLayerUtilsService.isLayerVectorLayer(layer);
    }
}
HsLayerEditorService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerEditorService, deps: [{ token: HsMapService }, { token: HsWmsGetCapabilitiesService }, { token: HsLayerUtilsService }, { token: HsLayerEditorVectorLayerService }, { token: HsEventBusService }, { token: HsLayoutService }, { token: HsLegendService }, { token: HsLayerSelectorService }, { token: HsLayerManagerMetadataService }], target: i0.ɵɵFactoryTarget.Injectable });
HsLayerEditorService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerEditorService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerEditorService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsMapService }, { type: HsWmsGetCapabilitiesService }, { type: HsLayerUtilsService }, { type: HsLayerEditorVectorLayerService }, { type: HsEventBusService }, { type: HsLayoutService }, { type: HsLegendService }, { type: HsLayerSelectorService }, { type: HsLayerManagerMetadataService }]; } });

class HsClusterWidgetComponent extends HsLayerEditorWidgetBaseComponent {
    constructor(hsLayerSelectorService, HsLayerEditorService, HsConfig) {
        super(hsLayerSelectorService);
        this.HsLayerEditorService = HsLayerEditorService;
        this.HsConfig = HsConfig;
        this.name = 'cluster-widget';
        this.distance = {
            value: 40,
        };
    }
    ngOnInit() {
        /*Call super ngOnInit manually as its getting overridden by local one*/
        super.ngOnInit();
        this.distance.value = this.setClusteringDistanceFromConfig();
    }
    /**
     * Set cluster for layer
     * @param newValue - To cluster or not to cluster
     */
    set cluster(newValue) {
        if (!this.layerDescriptor) {
            return;
        }
        this.HsLayerEditorService.cluster(this.olLayer, newValue, this.distance.value, this.data.app);
    }
    /**
     * @returns Current cluster state
     */
    get cluster() {
        if (!this.layerDescriptor) {
            return;
        }
        return this.HsLayerEditorService.cluster(this.olLayer, undefined, this.distance.value, this.data.app);
    }
    /**
     * Set distance between cluster features;
     */
    changeDistance() {
        if (!this.layerDescriptor) {
            return;
        }
        const layer = this.olLayer;
        const src = layer.getSource();
        if (src.setDistance == undefined) {
            return;
        }
        src.setDistance(this.distance.value);
    }
    /**
     * Test if layer is WMS layer
     */
    isVectorLayer() {
        if (!this.layerDescriptor) {
            return;
        }
        const layer = this.olLayer;
        if (!this.HsLayerEditorService.isLayerVectorLayer(layer)) {
            return;
        }
        else {
            return true;
        }
    }
    /**
     * Parse initial cluster distance value
     */
    setClusteringDistanceFromConfig() {
        var _a;
        const distance = (_a = this.HsConfig.get(this.data.app).clusteringDistance) !== null && _a !== void 0 ? _a : this.distance.value;
        return distance > 100 ? 100 : distance;
    }
}
HsClusterWidgetComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsClusterWidgetComponent, deps: [{ token: HsLayerSelectorService }, { token: HsLayerEditorService }, { token: HsConfig }], target: i0.ɵɵFactoryTarget.Component });
HsClusterWidgetComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsClusterWidgetComponent, selector: "hs-cluster-widget", usesInheritance: true, ngImport: i0, template: "<div\n  class=\"d-flex flex-row\"\n  style=\"border-bottom: 1px solid rgba(0, 0, 0, 0.125)\"\n>\n  <!-- Cluster features checkbox  -->\n  <div *ngIf=\"isVectorLayer()\" class=\"form-check flex-fill\"><!-- TODO: Remove function call from template -->\n    <input\n      name=\"layer-cluster\"\n      class=\"form-check-input\"\n      type=\"checkbox\"\n      [(ngModel)]=\"cluster\"\n    />\n    <label class=\"form-check-label\">{{\n      \"LAYERMANAGER.layerEditor.cluster\" | translateHs : data\n    }}</label>\n  </div>\n  <div class=\"form-group flex-fill\" *ngIf=\"cluster\">\n    <label>{{ \"COMMON.distance\" | translateHs : {app: data.app} }}</label>\n    <input\n      name=\"layer-cluster-distance\"\n      type=\"range\"\n      min=\"0\"\n      max=\"100\"\n      step=\"1\"\n      [(ngModel)]=\"distance.value\"\n      (change)=\"changeDistance()\"\n      style=\"width: 100%; height: 21px\"\n    />\n  </div>\n</div>\n", directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3$1.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3$1.RangeValueAccessor, selector: "input[type=range][formControlName],input[type=range][formControl],input[type=range][ngModel]" }, { type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsClusterWidgetComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-cluster-widget', template: "<div\n  class=\"d-flex flex-row\"\n  style=\"border-bottom: 1px solid rgba(0, 0, 0, 0.125)\"\n>\n  <!-- Cluster features checkbox  -->\n  <div *ngIf=\"isVectorLayer()\" class=\"form-check flex-fill\"><!-- TODO: Remove function call from template -->\n    <input\n      name=\"layer-cluster\"\n      class=\"form-check-input\"\n      type=\"checkbox\"\n      [(ngModel)]=\"cluster\"\n    />\n    <label class=\"form-check-label\">{{\n      \"LAYERMANAGER.layerEditor.cluster\" | translateHs : data\n    }}</label>\n  </div>\n  <div class=\"form-group flex-fill\" *ngIf=\"cluster\">\n    <label>{{ \"COMMON.distance\" | translateHs : {app: data.app} }}</label>\n    <input\n      name=\"layer-cluster-distance\"\n      type=\"range\"\n      min=\"0\"\n      max=\"100\"\n      step=\"1\"\n      [(ngModel)]=\"distance.value\"\n      (change)=\"changeDistance()\"\n      style=\"width: 100%; height: 21px\"\n    />\n  </div>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: HsLayerSelectorService }, { type: HsLayerEditorService }, { type: HsConfig }]; } });

class HsCopyLayerDialogComponent {
    constructor(HsDialogContainerService) {
        this.HsDialogContainerService = HsDialogContainerService;
    }
    yes() {
        this.HsDialogContainerService.destroy(this, this.data.app);
        this.dialogItem.resolve({
            confirmed: 'yes',
            layerTitle: this.data.layerTitle,
        });
    }
    no() {
        this.HsDialogContainerService.destroy(this, this.data.app);
        this.dialogItem.resolve('no');
    }
}
HsCopyLayerDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCopyLayerDialogComponent, deps: [{ token: HsDialogContainerService }], target: i0.ɵɵFactoryTarget.Component });
HsCopyLayerDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsCopyLayerDialogComponent, selector: "hs-copy-layer-dialog", ngImport: i0, template: "<div class=\"modal in\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h4 class=\"modal-title\">\n                    {{data.title}}\n                </h4>\n                <button type=\"button\" (click)=\"no()\" class=\"btn-close\" data-dismiss=\"modal\" attr.aria-label=\"{{'COMMON.close' | translateHs : {app: data.app} }}\"></button>\n            </div>\n            <div class=\"modal-body\" style=\"overflow-y:auto\">\n                <p class=\"fw-bold h6\">{{data.message}}</p>\n                <div class=\"form-floating m-2\">\n                    <input class=\"form-control\" name=\"title\" [(ngModel)]=\"data.layerTitle\"\n                        placeholder=\"'COMMON.title' | translateHs : data\" />\n                    <label for=\"title\" class=\"capabilities_label control-label\">{{'COMMON.title' | translateHs : {app: data.app} }}</label>\n                </div>\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-primary\" (click)=\"yes()\" [title]=\"'COMMON.yes' | translateHs : data\" data-dismiss=\"modal\">{{'COMMON.yes' | translateHs : {app: data.app} }}</button>\n                <button type=\"button\" class=\"btn btn-secondary compositions-btn-cancel\" [title]=\"'COMMON.no' | translateHs : data\" (click)=\"no()\" data-dismiss=\"modal\">{{'COMMON.no' | translateHs : {app: data.app} }}</button>\n            </div>\n        </div>\n    </div>\n</div>\n", directives: [{ type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCopyLayerDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-copy-layer-dialog', template: "<div class=\"modal in\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h4 class=\"modal-title\">\n                    {{data.title}}\n                </h4>\n                <button type=\"button\" (click)=\"no()\" class=\"btn-close\" data-dismiss=\"modal\" attr.aria-label=\"{{'COMMON.close' | translateHs : {app: data.app} }}\"></button>\n            </div>\n            <div class=\"modal-body\" style=\"overflow-y:auto\">\n                <p class=\"fw-bold h6\">{{data.message}}</p>\n                <div class=\"form-floating m-2\">\n                    <input class=\"form-control\" name=\"title\" [(ngModel)]=\"data.layerTitle\"\n                        placeholder=\"'COMMON.title' | translateHs : data\" />\n                    <label for=\"title\" class=\"capabilities_label control-label\">{{'COMMON.title' | translateHs : {app: data.app} }}</label>\n                </div>\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-primary\" (click)=\"yes()\" [title]=\"'COMMON.yes' | translateHs : data\" data-dismiss=\"modal\">{{'COMMON.yes' | translateHs : {app: data.app} }}</button>\n                <button type=\"button\" class=\"btn btn-secondary compositions-btn-cancel\" [title]=\"'COMMON.no' | translateHs : data\" (click)=\"no()\" data-dismiss=\"modal\">{{'COMMON.no' | translateHs : {app: data.app} }}</button>\n            </div>\n        </div>\n    </div>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: HsDialogContainerService }]; } });

function listNumericAttributes(features) {
    return features.length > 0
        ? Object.keys(features[0].getProperties()).filter((attr) => {
            return (attr != 'geometry' &&
                attr != 'hs_normalized_IDW_value' &&
                !isNaN(Number(features[0].get(attr))));
        } //Check if number
        )
        : [];
}
/**
 * A widget to configure IDW interpolated layer attribute being
 * interpolated, color scheme used and range of values supported.
 */
class HsIdwWidgetComponent extends HsLayerEditorWidgetBaseComponent {
    constructor(HsLanguageService, hsLayerSelectorService, hsUtilsService) {
        super(hsLayerSelectorService);
        this.HsLanguageService = HsLanguageService;
        this.hsUtilsService = hsUtilsService;
        this.name = 'idw-widget';
        this.colorMaps = Object.keys(colorScales);
        this.min = '';
        this.max = '';
    }
    ngOnInit() {
        super.ngOnInit();
        if (!this.hsUtilsService.instOf(this.olLayer.getSource(), InterpolatedSource)) {
            return;
        }
        this.fillAttributes();
        this.fillColorMapValue();
    }
    /**
     * Sets colorMap variable value if predefined colorMap is used
     */
    fillColorMapValue() {
        const srcAsIDW = this.getIdwSource();
        const colorMap = srcAsIDW.options.colorMap;
        if (typeof colorMap === 'string') {
            this.reversed = colorMap.includes('-reverse');
            this.colorMap = this.reversed ? colorMap.split('-')[0] : colorMap;
        }
    }
    /**
     * Get possible attributes from first feature which might be used for interpolation.
     * If no features exist, wait for them.
     */
    fillAttributes() {
        const srcAsIDW = this.getIdwSource();
        const underSource = srcAsIDW.featureCache;
        const features = underSource.getFeatures();
        this.attributes = this.listNumericAttributes(features);
        if (this.attributes.length == 0) {
            underSource.once('change', () => this.fillAttributes());
        }
        this.weightAttribute = srcAsIDW.weight;
    }
    listNumericAttributes(features) {
        return listNumericAttributes(features);
    }
    getIdwSource() {
        const srcAsAny = this.olLayer.getSource();
        const srcAsIDW = srcAsAny;
        return srcAsIDW;
    }
    setWeight() {
        const srcAsIDW = this.getIdwSource();
        srcAsIDW.weight = this.weightAttribute;
    }
    setBounds() {
        const srcAsIDW = this.getIdwSource();
        srcAsIDW.min = this.min == '' ? undefined : parseFloat(this.min.toString());
        srcAsIDW.max = this.max == '' ? undefined : parseFloat(this.max.toString());
    }
    setColorMap() {
        const srcAsIDW = this.getIdwSource();
        srcAsIDW.colorMap = this.reversed
            ? `${this.colorMap}-reverse`
            : this.colorMap;
    }
}
HsIdwWidgetComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsIdwWidgetComponent, deps: [{ token: HsLanguageService }, { token: HsLayerSelectorService }, { token: HsUtilsService }], target: i0.ɵɵFactoryTarget.Component });
HsIdwWidgetComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsIdwWidgetComponent, selector: "hs-idw-widget", usesInheritance: true, ngImport: i0, template: "<div class=\"form-group\" *ngIf=\"(layerDescriptor | async).type === 'IDW'\">\n  <div class=\"form-inline\">\n    <label class=\"control-label\" style=\"width: 100%; justify-content: left\">{{\n      \"LAYERMANAGER.layerEditor.interpolatedAttribute\" | translateHs : {app: data.app} }}:</label>\n\n    <select class=\"form-control form-select\" style=\"width: 100%\" [(ngModel)]=\"weightAttribute\"\n      [ngModelOptions]=\"{standalone: true}\" (change)=\"setWeight()\">\n      <option [ngValue]=\"attr\" *ngFor=\"let attr of attributes\">\n        {{attr}}\n      </option>\n    </select>\n  </div>\n\n  <div class=\"form-inline pt-3\">\n    <label class=\"control-label\" style=\"width: 100%; justify-content: left\">{{\n      \"LAYERMANAGER.layerEditor.colorMap\" | translateHs : {app: data.app} }}:</label>\n\n    <select class=\"form-control form-select\" style=\"width: 100%\" [(ngModel)]=\"colorMap\"\n      [ngModelOptions]=\"{standalone: true}\" (change)=\"setColorMap()\">\n      <option [ngValue]=\"cm\" *ngFor=\"let cm of colorMaps\">\n        {{cm}}\n      </option>\n    </select>\n  </div>\n  <div class=\"form-check\">\n    <label class=\"form-check-label\" [for]=\"'hs-idw-widget-reversed' + data.app\">\n      {{ \"COMMON.reversed\" | translateHs : {app: data.app} }}\n    </label>\n    <input class=\"form-check-input\" type=\"checkbox\" (change)=\"setColorMap()\" [(ngModel)]=\"reversed\"\n      [id]=\"'hs-idw-widget-reversed' + data.app\">\n  </div>\n\n  <div class=\"row g-3 pt-3\">\n    <div class=\"col-md-6\">\n      <label class=\"form-label\" for=\"hsIdwMin\">{{\n        \"LAYERMANAGER.layerEditor.min\" | translateHs : {app: data.app} }}:</label>\n      <input class=\"form-control inline\" (change)=\"setBounds()\" [(ngModel)]=\"min\" name=\"hsIdwMin\" id=\"hsIdwMin\" />\n\n    </div>\n    <div class=\"col-md-6\">\n      <label class=\"form-label\" for=\"hsIdwMax\">{{\n        \"LAYERMANAGER.layerEditor.max\" | translateHs : {app: data.app} }}:</label>\n      <input class=\"form-control\" (change)=\"setBounds()\" [(ngModel)]=\"max\" name=\"hsIdwMax\" for=\"hsIdwMax\" />\n    </div>\n  </div>\n</div>\n", directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3$1.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3$1.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i3$1.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i3$1.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }], pipes: { "async": i3.AsyncPipe, "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsIdwWidgetComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-idw-widget', template: "<div class=\"form-group\" *ngIf=\"(layerDescriptor | async).type === 'IDW'\">\n  <div class=\"form-inline\">\n    <label class=\"control-label\" style=\"width: 100%; justify-content: left\">{{\n      \"LAYERMANAGER.layerEditor.interpolatedAttribute\" | translateHs : {app: data.app} }}:</label>\n\n    <select class=\"form-control form-select\" style=\"width: 100%\" [(ngModel)]=\"weightAttribute\"\n      [ngModelOptions]=\"{standalone: true}\" (change)=\"setWeight()\">\n      <option [ngValue]=\"attr\" *ngFor=\"let attr of attributes\">\n        {{attr}}\n      </option>\n    </select>\n  </div>\n\n  <div class=\"form-inline pt-3\">\n    <label class=\"control-label\" style=\"width: 100%; justify-content: left\">{{\n      \"LAYERMANAGER.layerEditor.colorMap\" | translateHs : {app: data.app} }}:</label>\n\n    <select class=\"form-control form-select\" style=\"width: 100%\" [(ngModel)]=\"colorMap\"\n      [ngModelOptions]=\"{standalone: true}\" (change)=\"setColorMap()\">\n      <option [ngValue]=\"cm\" *ngFor=\"let cm of colorMaps\">\n        {{cm}}\n      </option>\n    </select>\n  </div>\n  <div class=\"form-check\">\n    <label class=\"form-check-label\" [for]=\"'hs-idw-widget-reversed' + data.app\">\n      {{ \"COMMON.reversed\" | translateHs : {app: data.app} }}\n    </label>\n    <input class=\"form-check-input\" type=\"checkbox\" (change)=\"setColorMap()\" [(ngModel)]=\"reversed\"\n      [id]=\"'hs-idw-widget-reversed' + data.app\">\n  </div>\n\n  <div class=\"row g-3 pt-3\">\n    <div class=\"col-md-6\">\n      <label class=\"form-label\" for=\"hsIdwMin\">{{\n        \"LAYERMANAGER.layerEditor.min\" | translateHs : {app: data.app} }}:</label>\n      <input class=\"form-control inline\" (change)=\"setBounds()\" [(ngModel)]=\"min\" name=\"hsIdwMin\" id=\"hsIdwMin\" />\n\n    </div>\n    <div class=\"col-md-6\">\n      <label class=\"form-label\" for=\"hsIdwMax\">{{\n        \"LAYERMANAGER.layerEditor.max\" | translateHs : {app: data.app} }}:</label>\n      <input class=\"form-control\" (change)=\"setBounds()\" [(ngModel)]=\"max\" name=\"hsIdwMax\" for=\"hsIdwMax\" />\n    </div>\n  </div>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: HsLanguageService }, { type: HsLayerSelectorService }, { type: HsUtilsService }]; } });

class HsLayerEditorDimensionsComponent extends HsLayerEditorWidgetBaseComponent {
    constructor(hsDimensionService, hsDimensionTimeService, hsMapService, hsEventBusService, hsUtilsService, hsLayerSelectorService) {
        super(hsLayerSelectorService);
        this.hsDimensionService = hsDimensionService;
        this.hsDimensionTimeService = hsDimensionTimeService;
        this.hsMapService = hsMapService;
        this.hsEventBusService = hsEventBusService;
        this.hsUtilsService = hsUtilsService;
        this.name = 'dimensions';
        this.dimensions = [];
        this.ngUnsubscribe = new Subject();
        this.hsEventBusService.layerDimensionDefinitionChanges
            .pipe(takeUntil$1(this.ngUnsubscribe))
            .subscribe(({ layer }) => {
            if (layer == this.olLayer) {
                this.ngOnChanges();
            }
        });
        this.layerDescriptor
            .pipe(takeUntil$1(this.ngUnsubscribe))
            .subscribe((descriptor) => {
            this.ngOnChanges();
        });
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    ngOnChanges() {
        const layer = this.olLayer;
        if (!layer) {
            return;
        }
        this.dimensions = [];
        const dimensions = getDimensions(layer);
        if (dimensions && Object.entries(dimensions)) {
            for (const [key, dimension] of Object.entries(dimensions)) {
                let available = true;
                if (this.hsUtilsService.isFunction(dimension.availability)) {
                    available = dimension.availability(layer);
                }
                if (available) {
                    if (typeof dimension.values === 'string') {
                        dimension.values = this.hsDimensionTimeService.parseTimePoints(dimension.values);
                    }
                    this.dimensions.push(new HsDimensionDescriptor(key, dimension));
                }
            }
        }
    }
    dimensionIsTime(dimension) {
        var _a;
        const dimensions = getDimensions(this.olLayer);
        const type = Object.keys(dimensions).find((key) => dimensions[key] === dimension);
        // value of time.onlyInEditor used inversely here intentionally
        // ( => replacement for inline time-editor)
        return type === 'time' && ((_a = dimensions.time) === null || _a === void 0 ? void 0 : _a.onlyInEditor);
    }
}
HsLayerEditorDimensionsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerEditorDimensionsComponent, deps: [{ token: HsDimensionService }, { token: HsDimensionTimeService }, { token: HsMapService }, { token: HsEventBusService }, { token: HsUtilsService }, { token: HsLayerSelectorService }], target: i0.ɵɵFactoryTarget.Component });
HsLayerEditorDimensionsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsLayerEditorDimensionsComponent, selector: "hs-layer-editor-dimensions", usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "<div *ngIf=\"hsDimensionService.isLayerWithDimensions(olLayer)\"><!-- TODO: Remove function call from template -->\n  <p style=\"text-align: center; font-weight: bold\">\n    {{'LAYERMANAGER.dimensions' | translateHs : {app: data.app} }}\n  </p>\n  <div class=\"form-inline\" *ngFor=\"let dimension of dimensions\">\n    <label class=\"control-label\" style=\"width: 100%; justify-content: left\"\n      >{{dimension.label || dimension.name}}:</label\n    >\n    <select\n      class=\"form-control form-select\"\n      style=\"width: 100%\"\n      [(ngModel)]=\"dimension.modelValue\"\n      [ngModelOptions]=\"{standalone: true}\"\n      *ngIf=\"!dimension.type\"\n      (change)=\"hsDimensionService.dimensionChanged(dimension, data.app)\"\n    >\n      <option\n        [ngValue]=\"dimension_value\"\n        *ngFor=\"let dimension_value of dimension.values\"\n      >\n        {{dimension_value}}\n      </option>\n    </select>\n\n    <!-- Time slider replaced by layermanger-time-editor component -->\n    <div class=\"form-group\" [hidden]=\"!dimensionIsTime(dimension)\">\n      <label>{{'COMMON.date' | translateHs : {app: data.app} }}</label>\n    </div>\n\n    <div\n      class=\"input-group flex-fill\"\n      *ngIf=\"dimension.type === 'datetime' || dimension.type === 'date'\"\n    >\n      <input\n        type=\"text\"\n        style=\"width: 6.1em\"\n        ngbDatepicker\n        placeholder=\"YYYY-MM-DD\"\n        #d=\"ngbDatepicker\"\n        [(ngModel)]=\"dimension.modelValue\"\n        (dateSelect)=\"hsDimensionService.dimensionChanged(dimension, data.app)\"\n        [ngModelOptions]=\"{standalone: true}\"\n      />\n      <button\n        class=\"btn btn-outline-secondary\"\n        (click)=\"d.toggle()\"\n        type=\"button\"\n      >\n        <i class=\"icon-calendarthree\"></i>\n      </button>\n    </div>\n\n    <ngb-timepicker\n      *ngIf=\"dimension.type === 'datetime'\"\n      size=\"small\"\n      [(ngModel)]=\"dimension.modelTimeValue\"\n      (ngModelChange)=\"hsDimensionService.dimensionChanged(dimension, data.app)\"\n      [ngModelOptions]=\"{standalone: true}\"\n    >\n    </ngb-timepicker>\n  </div>\n</div>\n", directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3$1.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3$1.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i3$1.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i7.NgbInputDatepicker, selector: "input[ngbDatepicker]", inputs: ["autoClose", "datepickerClass", "dayTemplate", "dayTemplateData", "displayMonths", "firstDayOfWeek", "footerTemplate", "markDisabled", "minDate", "maxDate", "navigation", "outsideDays", "placement", "restoreFocus", "showWeekNumbers", "startDate", "container", "positionTarget", "weekdays", "disabled"], outputs: ["dateSelect", "navigate", "closed"], exportAs: ["ngbDatepicker"] }, { type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerEditorDimensionsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-layer-editor-dimensions', template: "<div *ngIf=\"hsDimensionService.isLayerWithDimensions(olLayer)\"><!-- TODO: Remove function call from template -->\n  <p style=\"text-align: center; font-weight: bold\">\n    {{'LAYERMANAGER.dimensions' | translateHs : {app: data.app} }}\n  </p>\n  <div class=\"form-inline\" *ngFor=\"let dimension of dimensions\">\n    <label class=\"control-label\" style=\"width: 100%; justify-content: left\"\n      >{{dimension.label || dimension.name}}:</label\n    >\n    <select\n      class=\"form-control form-select\"\n      style=\"width: 100%\"\n      [(ngModel)]=\"dimension.modelValue\"\n      [ngModelOptions]=\"{standalone: true}\"\n      *ngIf=\"!dimension.type\"\n      (change)=\"hsDimensionService.dimensionChanged(dimension, data.app)\"\n    >\n      <option\n        [ngValue]=\"dimension_value\"\n        *ngFor=\"let dimension_value of dimension.values\"\n      >\n        {{dimension_value}}\n      </option>\n    </select>\n\n    <!-- Time slider replaced by layermanger-time-editor component -->\n    <div class=\"form-group\" [hidden]=\"!dimensionIsTime(dimension)\">\n      <label>{{'COMMON.date' | translateHs : {app: data.app} }}</label>\n    </div>\n\n    <div\n      class=\"input-group flex-fill\"\n      *ngIf=\"dimension.type === 'datetime' || dimension.type === 'date'\"\n    >\n      <input\n        type=\"text\"\n        style=\"width: 6.1em\"\n        ngbDatepicker\n        placeholder=\"YYYY-MM-DD\"\n        #d=\"ngbDatepicker\"\n        [(ngModel)]=\"dimension.modelValue\"\n        (dateSelect)=\"hsDimensionService.dimensionChanged(dimension, data.app)\"\n        [ngModelOptions]=\"{standalone: true}\"\n      />\n      <button\n        class=\"btn btn-outline-secondary\"\n        (click)=\"d.toggle()\"\n        type=\"button\"\n      >\n        <i class=\"icon-calendarthree\"></i>\n      </button>\n    </div>\n\n    <ngb-timepicker\n      *ngIf=\"dimension.type === 'datetime'\"\n      size=\"small\"\n      [(ngModel)]=\"dimension.modelTimeValue\"\n      (ngModelChange)=\"hsDimensionService.dimensionChanged(dimension, data.app)\"\n      [ngModelOptions]=\"{standalone: true}\"\n    >\n    </ngb-timepicker>\n  </div>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: HsDimensionService }, { type: HsDimensionTimeService }, { type: HsMapService }, { type: HsEventBusService }, { type: HsUtilsService }, { type: HsLayerSelectorService }]; } });

class HsLayerManagerRemoveLayerDialogComponent {
    constructor(HsDialogContainerService, HsEventBusService, HsDrawService, HsMapService) {
        this.HsDialogContainerService = HsDialogContainerService;
        this.HsEventBusService = HsEventBusService;
        this.HsDrawService = HsDrawService;
        this.HsMapService = HsMapService;
    }
    removeLayer() {
        if (this.HsDrawService.get(this.data.app).selectedLayer == this.data.olLayer) {
            this.HsDrawService.get(this.data.app).selectedLayer = null;
        }
        this.HsMapService.getMap(this.data.app).removeLayer(this.data.olLayer);
        this.HsDrawService.fillDrawableLayers(this.data.app);
        this.HsEventBusService.layerManagerUpdates.next({
            layer: null,
            app: this.data.app,
        });
        this.close();
    }
    close() {
        this.HsDialogContainerService.destroy(this, this.data.app);
    }
}
HsLayerManagerRemoveLayerDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerManagerRemoveLayerDialogComponent, deps: [{ token: HsDialogContainerService }, { token: HsEventBusService }, { token: HsDrawService }, { token: HsMapService }], target: i0.ɵɵFactoryTarget.Component });
HsLayerManagerRemoveLayerDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsLayerManagerRemoveLayerDialogComponent, selector: "hs-layermanager-remove-layer-dialog", inputs: { data: "data" }, ngImport: i0, template: "<div class=\"modal hs-remove-layer-dialog in\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n  <div class=\"modal-dialog\">\n    <div class=\"modal-content\">\n      <div class=\"modal-header\">\n        <h4 class=\"modal-title\">\n          {{'PANEL_HEADER.LM' | translateHs : {app: data.app} }}\n        </h4>\n        <button (click)=\"close()\" class=\"btn-close\" data-dismiss=\"modal\" attr.aria-label=\"{{'COMMON.close' | translateHs : {app: data.app} }}\">\n        </button>\n      </div>\n      <div class=\"modal-body\" style=\"max-height:600px; overflow-y:auto\">\n        {{'LAYERMANAGER.dialogRemoveLayer.dialogMessage' | translateHs : {app: data.app} }}</div>\n      <div class=\"modal-footer\">\n        <button class=\"btn btn-primary\" (click)=\"removeLayer();\"\n          data-dismiss=\"modal\">{{'COMMON.removeLayer' | translateHs : {app: data.app} }}</button>\n        <button class=\"btn btn-secondary\" (click)=\"close()\" data-dismiss=\"modal\">{{'COMMON.no' | translateHs : {app: data.app} }}</button>\n      </div>\n    </div>\n  </div>\n</div>\n", pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerManagerRemoveLayerDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-layermanager-remove-layer-dialog', template: "<div class=\"modal hs-remove-layer-dialog in\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n  <div class=\"modal-dialog\">\n    <div class=\"modal-content\">\n      <div class=\"modal-header\">\n        <h4 class=\"modal-title\">\n          {{'PANEL_HEADER.LM' | translateHs : {app: data.app} }}\n        </h4>\n        <button (click)=\"close()\" class=\"btn-close\" data-dismiss=\"modal\" attr.aria-label=\"{{'COMMON.close' | translateHs : {app: data.app} }}\">\n        </button>\n      </div>\n      <div class=\"modal-body\" style=\"max-height:600px; overflow-y:auto\">\n        {{'LAYERMANAGER.dialogRemoveLayer.dialogMessage' | translateHs : {app: data.app} }}</div>\n      <div class=\"modal-footer\">\n        <button class=\"btn btn-primary\" (click)=\"removeLayer();\"\n          data-dismiss=\"modal\">{{'COMMON.removeLayer' | translateHs : {app: data.app} }}</button>\n        <button class=\"btn btn-secondary\" (click)=\"close()\" data-dismiss=\"modal\">{{'COMMON.no' | translateHs : {app: data.app} }}</button>\n      </div>\n    </div>\n  </div>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: HsDialogContainerService }, { type: HsEventBusService }, { type: HsDrawService }, { type: HsMapService }]; }, propDecorators: { data: [{
                type: Input
            }] } });

class HsLegendLayerVectorComponent {
    constructor() { }
}
HsLegendLayerVectorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLegendLayerVectorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
HsLegendLayerVectorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsLegendLayerVectorComponent, selector: "hs-legend-vector-layer", inputs: { svg: "svg" }, ngImport: i0, template: "<div [innerHtml]=\"svg\"></div>" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLegendLayerVectorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-legend-vector-layer', template: "<div [innerHtml]=\"svg\"></div>" }]
        }], ctorParameters: function () { return []; }, propDecorators: { svg: [{
                type: Input
            }] } });

class HsLegendLayerStaticService {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    fillContent(lyr) {
        const layerLegend = {};
        let legendImage = getLegends(lyr);
        if (Array.isArray(legendImage)) {
            legendImage = legendImage[0];
        }
        if (legendImage) {
            layerLegend.lastLegendImage = legendImage;
            if (legendImage.indexOf('<svg') > -1) {
                layerLegend.legendType = 'svg';
                layerLegend.svgContent =
                    this.sanitizer.bypassSecurityTrustHtml(legendImage);
            }
            else {
                layerLegend.legendType = 'image';
                layerLegend.legendImage =
                    this.sanitizer.bypassSecurityTrustResourceUrl(legendImage);
            }
        }
        return layerLegend;
    }
}
HsLegendLayerStaticService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLegendLayerStaticService, deps: [{ token: i1$3.DomSanitizer }], target: i0.ɵɵFactoryTarget.Injectable });
HsLegendLayerStaticService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLegendLayerStaticService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLegendLayerStaticService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$3.DomSanitizer }]; } });

class HsLegendLayerStaticComponent {
    constructor(hsLegendLayerStaticService) {
        this.hsLegendLayerStaticService = hsLegendLayerStaticService;
        this.layerLegend = {};
    }
    ngOnInit() {
        if (getLegends(this.layer.lyr)) {
            Object.assign(this.layerLegend, this.hsLegendLayerStaticService.fillContent(this.layer.lyr));
        }
        this.layer.lyr.on('change', (e) => {
            //TODO: Maybe rewrite this to something more fancy like Observable
            if (getLegends(this.layer.lyr) != this.layerLegend.lastLegendImage) {
                this.hsLegendLayerStaticService.fillContent(this.layer.lyr);
            }
        });
    }
}
HsLegendLayerStaticComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLegendLayerStaticComponent, deps: [{ token: HsLegendLayerStaticService }], target: i0.ɵɵFactoryTarget.Component });
HsLegendLayerStaticComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsLegendLayerStaticComponent, selector: "hs-legend-layer-static", inputs: { layer: "layer" }, ngImport: i0, template: "<img *ngIf=\"layerLegend.legendType === 'image'\" [src]=\"layerLegend.legendImage\">\n<div *ngIf=\"layerLegend.legendType === 'svg'\" [innerHtml]=\"layerLegend.svgContent\">\n</div>", directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLegendLayerStaticComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-legend-layer-static', template: "<img *ngIf=\"layerLegend.legendType === 'image'\" [src]=\"layerLegend.legendImage\">\n<div *ngIf=\"layerLegend.legendType === 'svg'\" [innerHtml]=\"layerLegend.svgContent\">\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsLegendLayerStaticService }]; }, propDecorators: { layer: [{
                type: Input
            }] } });

class HsLegendLayerComponent {
    constructor(hsUtilsService, hsLegendService, hsStylerService) {
        this.hsUtilsService = hsUtilsService;
        this.hsLegendService = hsLegendService;
        this.hsStylerService = hsStylerService;
        this.app = 'default';
        this.ngUnsubscribe = new Subject();
        this.hsStylerService
            .get(this.app)
            .onSet.pipe(takeUntil$1(this.ngUnsubscribe))
            .subscribe((layer) => __awaiter(this, void 0, void 0, function* () {
            if (this.layer.lyr == layer) {
                this.layer.svg = yield this.hsLegendService.setSvg(layer);
            }
        }));
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
}
HsLegendLayerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLegendLayerComponent, deps: [{ token: HsUtilsService }, { token: HsLegendService }, { token: HsStylerService }], target: i0.ɵɵFactoryTarget.Component });
HsLegendLayerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsLegendLayerComponent, selector: "hs-legend-layer-directive", inputs: { layer: "layer", app: "app" }, ngImport: i0, template: "<div>\n    <hs-legend-vector-layer *ngIf=\"layer.type === 'vector' && layer.autoLegend\" [svg]=\"layer.svg\">\n    </hs-legend-vector-layer>\n    <div *ngIf=\"layer.type === 'wms'\">\n        <img *ngFor=\"let sublayer of layer.subLayerLegends\" [src]=\"sublayer\"\n            onerror=\" this.parentNode.removeChild(this); \"\n            onload=\"if(this.height<6) { this.parentNode.removeChild(this); }\">\n    </div>\n    <div *ngIf=\"layer.type === 'vector'\">\n        <p *ngFor=\"let category of layer.lyr.getSource().legend_categories\"><!-- TODO: Remove function call from template --><span\n                [ngStyle]=\"{'background-color': category.color}\">&nbsp;&nbsp;&nbsp;</span>&nbsp;{{category.name}}\n        </p>\n    </div>\n    <hs-legend-layer-static *ngIf=\"layer.type === 'static'\" [layer]=\"layer\"></hs-legend-layer-static>\n</div>", components: [{ type: HsLegendLayerVectorComponent, selector: "hs-legend-vector-layer", inputs: ["svg"] }, { type: HsLegendLayerStaticComponent, selector: "hs-legend-layer-static", inputs: ["layer"] }], directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLegendLayerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-legend-layer-directive', template: "<div>\n    <hs-legend-vector-layer *ngIf=\"layer.type === 'vector' && layer.autoLegend\" [svg]=\"layer.svg\">\n    </hs-legend-vector-layer>\n    <div *ngIf=\"layer.type === 'wms'\">\n        <img *ngFor=\"let sublayer of layer.subLayerLegends\" [src]=\"sublayer\"\n            onerror=\" this.parentNode.removeChild(this); \"\n            onload=\"if(this.height<6) { this.parentNode.removeChild(this); }\">\n    </div>\n    <div *ngIf=\"layer.type === 'vector'\">\n        <p *ngFor=\"let category of layer.lyr.getSource().legend_categories\"><!-- TODO: Remove function call from template --><span\n                [ngStyle]=\"{'background-color': category.color}\">&nbsp;&nbsp;&nbsp;</span>&nbsp;{{category.name}}\n        </p>\n    </div>\n    <hs-legend-layer-static *ngIf=\"layer.type === 'static'\" [layer]=\"layer\"></hs-legend-layer-static>\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsUtilsService }, { type: HsLegendService }, { type: HsStylerService }]; }, propDecorators: { layer: [{
                type: Input
            }], app: [{
                type: Input
            }] } });

class HsLegendWidgetComponent extends HsLayerEditorWidgetBaseComponent {
    constructor(hsLayerSelectorService, HsLayerEditorService) {
        super(hsLayerSelectorService);
        this.HsLayerEditorService = HsLayerEditorService;
        this.name = 'legend-widget';
    }
}
HsLegendWidgetComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLegendWidgetComponent, deps: [{ token: HsLayerSelectorService }, { token: HsLayerEditorService }], target: i0.ɵɵFactoryTarget.Component });
HsLegendWidgetComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsLegendWidgetComponent, selector: "hs-legend-widget", usesInheritance: true, ngImport: i0, template: "<div *ngIf=\"olLayer\">\n  <div *ngIf=\"HsLayerEditorService.legendVisible(data.app)\"><!-- TODO: Remove function call from template -->\n    <p style=\"text-align: center; font-weight: bold\">\n      {{ \"COMMON.legend\" | translateHs : {app: data.app} }}\n    </p>\n    <hs-legend-layer-directive [app]=\"data.app\" [layer]=\"HsLayerEditorService.apps[data.app].legendDescriptor\">\n    </hs-legend-layer-directive>\n    <hr />\n  </div>\n</div>", components: [{ type: HsLegendLayerComponent, selector: "hs-legend-layer-directive", inputs: ["layer", "app"] }], directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLegendWidgetComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-legend-widget', template: "<div *ngIf=\"olLayer\">\n  <div *ngIf=\"HsLayerEditorService.legendVisible(data.app)\"><!-- TODO: Remove function call from template -->\n    <p style=\"text-align: center; font-weight: bold\">\n      {{ \"COMMON.legend\" | translateHs : {app: data.app} }}\n    </p>\n    <hs-legend-layer-directive [app]=\"data.app\" [layer]=\"HsLayerEditorService.apps[data.app].legendDescriptor\">\n    </hs-legend-layer-directive>\n    <hr />\n  </div>\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsLayerSelectorService }, { type: HsLayerEditorService }]; } });

class HsMetadataWidgetComponent extends HsLayerEditorWidgetBaseComponent {
    constructor(HsLanguageService, hsLayerSelectorService, metadataService, // Used in template
    HsLayerManagerService) {
        super(hsLayerSelectorService);
        this.HsLanguageService = HsLanguageService;
        this.metadataService = metadataService;
        this.HsLayerManagerService = HsLayerManagerService;
        this.name = 'metadata-widget';
        this.getAttribution = getAttribution;
    }
    /**
     * Determines if layer has copyright information available
     * @param layer - Selected layer (HsLayerManagerService.currentLayer)
     */
    hasCopyright(layer) {
        var _a;
        if (!this.layerDescriptor) {
            return;
        }
        else {
            return ((_a = getAttribution(layer.layer)) === null || _a === void 0 ? void 0 : _a.onlineResource) != undefined;
        }
    }
    set abstract(newAbstract) {
        const layer = this.olLayer;
        if (layer == undefined) {
            return;
        }
        setAbstract(layer, newAbstract);
    }
    get abstract() {
        const layer = this.olLayer;
        if (layer == undefined) {
            return;
        }
        return getAbstract(layer);
    }
}
HsMetadataWidgetComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsMetadataWidgetComponent, deps: [{ token: HsLanguageService }, { token: HsLayerSelectorService }, { token: HsLayerManagerMetadataService }, { token: HsLayerManagerService }], target: i0.ɵɵFactoryTarget.Component });
HsMetadataWidgetComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsMetadataWidgetComponent, selector: "hs-metadata-widget", usesInheritance: true, ngImport: i0, template: "<ng-container>\n  <div class=\"form-group\" *ngIf=\"(layerDescriptor | async) && metadataService.hasMetadata((layerDescriptor | async))\">\n    <!-- Metadata -->\n    <div class=\"pt-2\">\n      <a class=\"card-href\" *ngFor=\"let metadataUrl of metadataService.metadataArray((layerDescriptor | async))\"\n        href=\"{{ metadataUrl.onlineResource }}\" target=\"_blank\" [title]=\"'COMMON.metadata' | translateHs : data\">\n        <span [hidden]=\"!metadataUrl.type\">\n          {{ \"LAYERMANAGER.layerEditor.metadataOfLayer\" | translateHs : {app: data.app} }}\n          {{ metadataUrl.type }}\n        </span>\n        <span [hidden]=\"metadataUrl.type\">\n          {{ \"LAYERMANAGER.layerEditor.metadataOfService\" | translateHs : {app: data.app} }}\n        </span>\n      </a>\n    </div>\n    <!-- Copyright -->\n    <div *ngIf=\"hasCopyright((layerDescriptor | async))\">\n      <a class=\"card-href\" href=\"{{ getAttribution((layerDescriptor | async).layer).onlineResource }}\" target=\"_blank\"\n        [title]=\"'LAYERMANAGER.layerEditor.copyright' | translateHs : data\">\n        {{ \"LAYERMANAGER.layerEditor.copyright\" | translateHs : {app: data.app} }}</a>\n    </div>\n  </div>\n\n  <div class=\"form-group\" [hidden]=\"!abstract\">\n    <label>{{ \"COMMON.abstract\" | translateHs : {app: data.app} }}</label>\n    <p [innerHtml]=\"\n        HsLayerManagerService.makeSafeAndTranslate('LAYERS', abstract, data.app)\n      \"></p><!-- TODO: Remove function call from template -->\n  </div>\n</ng-container>", directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "async": i3.AsyncPipe, "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsMetadataWidgetComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-metadata-widget', template: "<ng-container>\n  <div class=\"form-group\" *ngIf=\"(layerDescriptor | async) && metadataService.hasMetadata((layerDescriptor | async))\">\n    <!-- Metadata -->\n    <div class=\"pt-2\">\n      <a class=\"card-href\" *ngFor=\"let metadataUrl of metadataService.metadataArray((layerDescriptor | async))\"\n        href=\"{{ metadataUrl.onlineResource }}\" target=\"_blank\" [title]=\"'COMMON.metadata' | translateHs : data\">\n        <span [hidden]=\"!metadataUrl.type\">\n          {{ \"LAYERMANAGER.layerEditor.metadataOfLayer\" | translateHs : {app: data.app} }}\n          {{ metadataUrl.type }}\n        </span>\n        <span [hidden]=\"metadataUrl.type\">\n          {{ \"LAYERMANAGER.layerEditor.metadataOfService\" | translateHs : {app: data.app} }}\n        </span>\n      </a>\n    </div>\n    <!-- Copyright -->\n    <div *ngIf=\"hasCopyright((layerDescriptor | async))\">\n      <a class=\"card-href\" href=\"{{ getAttribution((layerDescriptor | async).layer).onlineResource }}\" target=\"_blank\"\n        [title]=\"'LAYERMANAGER.layerEditor.copyright' | translateHs : data\">\n        {{ \"LAYERMANAGER.layerEditor.copyright\" | translateHs : {app: data.app} }}</a>\n    </div>\n  </div>\n\n  <div class=\"form-group\" [hidden]=\"!abstract\">\n    <label>{{ \"COMMON.abstract\" | translateHs : {app: data.app} }}</label>\n    <p [innerHtml]=\"\n        HsLayerManagerService.makeSafeAndTranslate('LAYERS', abstract, data.app)\n      \"></p><!-- TODO: Remove function call from template -->\n  </div>\n</ng-container>" }]
        }], ctorParameters: function () { return [{ type: HsLanguageService }, { type: HsLayerSelectorService }, { type: HsLayerManagerMetadataService }, { type: HsLayerManagerService }]; } });

class HsOpacityWidgetComponent extends HsLayerEditorWidgetBaseComponent {
    constructor(hsLayerSelectorService, hsEventBusService) {
        super(hsLayerSelectorService);
        this.hsEventBusService = hsEventBusService;
        this.name = 'opacity-widget';
    }
    /**
     * Set selected layer's opacity and emits "compositionchanged"
     * @param newValue
     */
    set opacity(newValue) {
        if (!this.layerDescriptor) {
            return;
        }
        this.olLayer.setOpacity(newValue);
        this.hsEventBusService.compositionEdits.next(this.data.app);
    }
    get opacity() {
        return this.olLayer.getOpacity();
    }
}
HsOpacityWidgetComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsOpacityWidgetComponent, deps: [{ token: HsLayerSelectorService }, { token: HsEventBusService }], target: i0.ɵɵFactoryTarget.Component });
HsOpacityWidgetComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsOpacityWidgetComponent, selector: "hs-opacity-widget", usesInheritance: true, ngImport: i0, template: "<div class=\"form-group\">\n  <label>{{ \"LAYERMANAGER.layerEditor.opacity\" | translateHs : {app: data.app} }}</label>\n  <input type=\"range\" name=\"layer-opacity\" step=\"0.01\" min=\"0\" max=\"1\" style=\"width: 100%; height: 21px\"\n    [(ngModel)]=\"opacity\" />\n</div>", directives: [{ type: i3$1.RangeValueAccessor, selector: "input[type=range][formControlName],input[type=range][formControl],input[type=range][ngModel]" }, { type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsOpacityWidgetComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-opacity-widget', template: "<div class=\"form-group\">\n  <label>{{ \"LAYERMANAGER.layerEditor.opacity\" | translateHs : {app: data.app} }}</label>\n  <input type=\"range\" name=\"layer-opacity\" step=\"0.01\" min=\"0\" max=\"1\" style=\"width: 100%; height: 21px\"\n    [(ngModel)]=\"opacity\" />\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsLayerSelectorService }, { type: HsEventBusService }]; } });

class HsScaleWidgetComponent extends HsLayerEditorWidgetBaseComponent {
    constructor(hsLayerSelectorService, hsLayerUtilsService, hsMapService) {
        super(hsLayerSelectorService);
        this.hsLayerUtilsService = hsLayerUtilsService;
        this.hsMapService = hsMapService;
        this.name = 'scale-widget';
    }
    /**
     * Test if selected layer has min and max resolution set
     */
    isScaleVisible() {
        const layer = this.olLayer;
        if (layer == undefined) {
            return false;
        }
        return this.minResolutionValid() || this.maxResolutionValid();
    }
    /**
     * Set min resolution for selected layer
     * @param newValue
     */
    set minResolution(newValue) {
        if (!this.layerDescriptor) {
            return;
        }
        const layer = this.olLayer;
        layer.setMinResolution(this.hsLayerUtilsService.calculateResolutionFromScale(newValue, this.data.app));
    }
    get minResolution() {
        if (!this.layerDescriptor) {
            return;
        }
        const layer = this.olLayer;
        return this.resolutionToScale(layer.getMinResolution());
    }
    /**
     * Set max resolution for selected layer
     * @param newValue
     */
    set maxResolution(newValue) {
        if (!this.layerDescriptor) {
            return;
        }
        const layer = this.olLayer;
        layer.setMaxResolution(this.hsLayerUtilsService.calculateResolutionFromScale(newValue, this.data.app));
    }
    get maxResolution() {
        if (!this.layerDescriptor) {
            return;
        }
        const layer = this.olLayer;
        return this.resolutionToScale(layer.getMaxResolution());
    }
    resolutionToScale(resolution) {
        const view = this.hsMapService.getMap(this.data.app).getView();
        const units = view.getProjection().getUnits();
        const dpi = 25.4 / 0.28;
        const mpu = METERS_PER_UNIT[units];
        return Math.round(resolution * mpu * 39.37 * dpi);
    }
    minResolutionValid() {
        const layer = this.olLayer;
        if (layer == undefined) {
            return false;
        }
        return (layer.getMinResolution() != undefined && layer.getMinResolution() != 0);
    }
    maxResolutionValid() {
        const layer = this.olLayer;
        if (layer == undefined) {
            return false;
        }
        return (layer.getMaxResolution() != undefined &&
            layer.getMaxResolution() != Infinity);
    }
}
HsScaleWidgetComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsScaleWidgetComponent, deps: [{ token: HsLayerSelectorService }, { token: HsLayerUtilsService }, { token: HsMapService }], target: i0.ɵɵFactoryTarget.Component });
HsScaleWidgetComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsScaleWidgetComponent, selector: "hs-scale-widget", usesInheritance: true, ngImport: i0, template: "<div class=\"form-group\" [hidden]=\"!isScaleVisible()\"><!-- TODO: Remove function call from template -->\n  <label>{{ \"COMMON.scale\" | translateHs : {app: data.app} }}</label>\n  <span *ngIf=\"minResolutionValid()\"><span class=\"ms-1\">{{ \"COMMON.from\" | translateHs : {app: data.app} }}</span> 1:{{\n    minResolution\n    }}</span>\n  <span *ngIf=\"maxResolutionValid()\"><span class=\"ms-1\">{{ \"COMMON.to\" | translateHs : {app: data.app} }}</span> 1:{{\n    maxResolution\n    }}</span>\n\n  <!-- TODO This editor need to be toggle-able-->\n  <div class=\"form\">\n    <br />\n    <label>{{ \"COMMON.scale\" | translateHs : {app: data.app} }}</label>\n    <div *ngIf=\"minResolutionValid()\">\n      <div class=\"input-group\">\n        <span class=\"input-group-text\"><span>{{ \"COMMON.from\" | translateHs : {app: data.app} }}</span>&nbsp;1</span>\n        <input class=\"form-control\" style=\"width: 65px\" [(ngModel)]=\"minResolution\" name=\"minResolution\" />\n      </div>\n    </div>\n    <div *ngIf=\"maxResolutionValid()\">\n      <div class=\"input-group\">\n        <span class=\"input-group-text\">\n          <span>{{ \"COMMON.to\" | translateHs : {app: data.app} }}</span>&nbsp;1</span>\n        <input class=\"form-control\" style=\"width: 65px\" [(ngModel)]=\"maxResolution\" name=\"maxResolution\" />\n      </div>\n    </div>\n  </div>\n</div>", directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsScaleWidgetComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-scale-widget', template: "<div class=\"form-group\" [hidden]=\"!isScaleVisible()\"><!-- TODO: Remove function call from template -->\n  <label>{{ \"COMMON.scale\" | translateHs : {app: data.app} }}</label>\n  <span *ngIf=\"minResolutionValid()\"><span class=\"ms-1\">{{ \"COMMON.from\" | translateHs : {app: data.app} }}</span> 1:{{\n    minResolution\n    }}</span>\n  <span *ngIf=\"maxResolutionValid()\"><span class=\"ms-1\">{{ \"COMMON.to\" | translateHs : {app: data.app} }}</span> 1:{{\n    maxResolution\n    }}</span>\n\n  <!-- TODO This editor need to be toggle-able-->\n  <div class=\"form\">\n    <br />\n    <label>{{ \"COMMON.scale\" | translateHs : {app: data.app} }}</label>\n    <div *ngIf=\"minResolutionValid()\">\n      <div class=\"input-group\">\n        <span class=\"input-group-text\"><span>{{ \"COMMON.from\" | translateHs : {app: data.app} }}</span>&nbsp;1</span>\n        <input class=\"form-control\" style=\"width: 65px\" [(ngModel)]=\"minResolution\" name=\"minResolution\" />\n      </div>\n    </div>\n    <div *ngIf=\"maxResolutionValid()\">\n      <div class=\"input-group\">\n        <span class=\"input-group-text\">\n          <span>{{ \"COMMON.to\" | translateHs : {app: data.app} }}</span>&nbsp;1</span>\n        <input class=\"form-control\" style=\"width: 65px\" [(ngModel)]=\"maxResolution\" name=\"maxResolution\" />\n      </div>\n    </div>\n  </div>\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsLayerSelectorService }, { type: HsLayerUtilsService }, { type: HsMapService }]; } });

class HsTypeWidgetComponent extends HsLayerEditorWidgetBaseComponent {
    constructor(HsLanguageService, hsLayerSelectorService) {
        super(hsLayerSelectorService);
        this.HsLanguageService = HsLanguageService;
        this.name = 'type-widget';
    }
}
HsTypeWidgetComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsTypeWidgetComponent, deps: [{ token: HsLanguageService }, { token: HsLayerSelectorService }], target: i0.ɵɵFactoryTarget.Component });
HsTypeWidgetComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsTypeWidgetComponent, selector: "hs-type-widget", usesInheritance: true, ngImport: i0, template: "<div class=\"form-group\">\n  <small class=\"text-secondary\" *ngIf=\"(layerDescriptor | async)\">\n    {{\n    HsLanguageService.getTranslationIgnoreNonExisting(\n    \"LAYERMANAGER.layerEditor\",\n    (layerDescriptor | async).type,\n    undefined,\n    data.app\n    )\n    }}<!-- TODO: Remove function call from template -->\n    {{ \"LAYERMANAGER.layerEditor.layerFrom\" | translateHs : {app: data.app} }}\n    <span class=\"text-truncate mw-100 d-block\">\n      {{\n      HsLanguageService.getTranslationIgnoreNonExisting(\n      \"LAYERMANAGER.layerEditor\",\n      (layerDescriptor | async).source,\n      undefined,\n      data.app\n      )\n      }}<!-- TODO: Remove function call from template -->\n    </span>\n  </small>\n</div>\n", directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "async": i3.AsyncPipe, "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsTypeWidgetComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-type-widget', template: "<div class=\"form-group\">\n  <small class=\"text-secondary\" *ngIf=\"(layerDescriptor | async)\">\n    {{\n    HsLanguageService.getTranslationIgnoreNonExisting(\n    \"LAYERMANAGER.layerEditor\",\n    (layerDescriptor | async).type,\n    undefined,\n    data.app\n    )\n    }}<!-- TODO: Remove function call from template -->\n    {{ \"LAYERMANAGER.layerEditor.layerFrom\" | translateHs : {app: data.app} }}\n    <span class=\"text-truncate mw-100 d-block\">\n      {{\n      HsLanguageService.getTranslationIgnoreNonExisting(\n      \"LAYERMANAGER.layerEditor\",\n      (layerDescriptor | async).source,\n      undefined,\n      data.app\n      )\n      }}<!-- TODO: Remove function call from template -->\n    </span>\n  </small>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: HsLanguageService }, { type: HsLayerSelectorService }]; } });

class HsLayerEditorWidgetContainerService extends HsPanelContainerService {
    constructor() {
        super();
    }
}
HsLayerEditorWidgetContainerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerEditorWidgetContainerService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
HsLayerEditorWidgetContainerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerEditorWidgetContainerService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerEditorWidgetContainerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return []; } });

class HsLayerEditorSubLayerCheckboxesComponent {
    constructor(HsLayerEditorSublayerService, HsLayerManagerService) {
        this.HsLayerEditorSublayerService = HsLayerEditorSublayerService;
        this.HsLayerManagerService = HsLayerManagerService;
        this.app = 'default';
        this.expanded = false;
    }
    ngOnInit() {
        this.appRef = this.HsLayerEditorSublayerService.get(this.app);
        this.checkedSubLayers = this.appRef.checkedSubLayers;
        this.withChildren = this.appRef.withChildren;
    }
    getSubLayers(app) {
        return this.HsLayerEditorSublayerService.getSubLayers(app);
    }
    subLayerIsString(subLayer) {
        return typeof subLayer == 'string';
    }
    toggleExpanded() {
        this.expanded = !this.expanded;
    }
    /**
     * @description Controls state of layer´s sublayers manipulated by input checkboxes
     * @param {object} sublayer Selected sublayer
     * @param {object} state New state of sublayer
     */
    subLayerSelected(sublayer, state) {
        //TODO: Check if this works where subLayerSelected() is called from template. The second 'if' might fail
        if (sublayer != undefined && sublayer.Layer) {
            for (const children of sublayer.Layer) {
                const nameOrId = children.Name;
                const sublayersObject = children.Layer
                    ? this.withChildren
                    : this.checkedSubLayers;
                Object.assign(sublayersObject, {
                    [nameOrId]: state,
                });
                this.appRef.checkedSubLayersTmp[nameOrId] = state;
            }
        }
        const nameOrId = sublayer.Name; //ID is stored in Name prop for ArcGISREST
        if (this.checkedSubLayers[nameOrId] != undefined) {
            this.appRef.checkedSubLayersTmp[nameOrId] = state;
        }
        else {
            this.appRef.withChildrenTmp[nameOrId] = state;
        }
        return this.HsLayerEditorSublayerService.subLayerSelected(this.app);
    }
}
HsLayerEditorSubLayerCheckboxesComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerEditorSubLayerCheckboxesComponent, deps: [{ token: HsLayerEditorSublayerService }, { token: HsLayerManagerService }], target: i0.ɵɵFactoryTarget.Component });
HsLayerEditorSubLayerCheckboxesComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsLayerEditorSubLayerCheckboxesComponent, selector: "hs-layer-editor-sub-layer-checkbox", inputs: { subLayer: "subLayer", app: "app" }, ngImport: i0, template: "<div class=\"d-flex m-auto sublayerContainer\">\n    <!-- string -->\n    <div class=\"p-0 form-check form-check-inline\" *ngIf=\"subLayerIsString(subLayer)\">\n        <input class=\"form-check-input\" type=\"checkbox\" [(ngModel)]=\"checkedSubLayers[subLayer]\"\n            (change)=\"subLayerSelected()\">\n        <label class=\"form-check-label\">{{subLayer}}</label>\n    </div>\n    <!-- object -->\n    <div *ngIf=\"!subLayerIsString(subLayer)\" class=\"w-100\"><!-- TODO: Remove function call from template -->\n        <div class=\"d-flex\">\n            <div class=\"p-0 form-check form-check-inline\">\n                <input class=\"form-check-input\" type=\"checkbox\" [(ngModel)]=\"checkedSubLayers[subLayer.Name]\"\n                    name=\"sublayerWithoutNestedSublayers\"\n                    (change)=\"subLayerSelected(subLayer,checkedSubLayers[subLayer.Name])\"\n                    [attr.id]=\"'hs-sublayers-' + subLayer.Name + '-' + app\" *ngIf=\"!subLayer.Layer\">\n                <input class=\"form-check-input\" type=\"checkbox\" [(ngModel)]=\"withChildren[subLayer.Name]\"\n                    name=\"sublayerWithNestedSublayers\"\n                    (change)=\"subLayerSelected(subLayer, withChildren[subLayer.Name])\"\n                    [attr.id]=\"'hs-sublayers-' + subLayer.Name + '-' + app\" *ngIf=\"subLayer.Layer\">\n\n                <div class=\"p-0 d-inline-flex flex-grow\" *ngIf=\"subLayer.Layer\">\n                    <label class=\"form-check-label m-0\"\n                        [ngClass]=\"{'hs-checkmark':withChildren[subLayer.Name],'hs-uncheckmark':!withChildren[subLayer.Name]}\"\n                        [attr.for]=\"'hs-sublayers-' + subLayer.Name + '-' + app\"></label>\n                    <div (click)=\"toggleExpanded()\" [ngStyle]=\"{'cursor':'pointer'}\"\n                        [ngClass]=\"{'grayed': HsLayerManagerService.apps[app].currentResolution >= subLayer.maxResolution}\">\n                        {{subLayer.Title || subLayer.Name}}\n                        <button type=\"button\" class=\"btn btn-sm p-0\" [ngStyle]=\"{'font-size':'x-small'}\">\n                            <i [ngClass]=\"{'icon-chevron-down': expanded, 'icon-chevron-right': !expanded}\"></i>\n                        </button>\n                    </div>\n                </div>\n                <div *ngIf=\"!subLayer.Layer\">\n                    <label class=\"form-check-label m-0\"\n                        [ngClass]=\"{'hs-checkmark':checkedSubLayers[subLayer.Name],'hs-uncheckmark':!checkedSubLayers[subLayer.Name], 'grayed': (HsLayerManagerService.apps[app].currentResolution > subLayer.maxResolution) }\"\n                        [attr.for]=\"'hs-sublayers-' + subLayer.Name + '-' + app\">{{subLayer.Title ||\n                        subLayer.Name}}</label>\n                </div>\n            </div>\n        </div>\n        <div *ngIf=\"subLayer.Layer\" class=\"ms-4\" [hidden]=\"!expanded\">\n            <div *ngFor=\"let subLayer of subLayer.Layer\">\n                <div *ngIf=\"subLayerIsString(subLayer)\">\n                    <input class=\"form-check-input\" type=\"checkbox\" [(ngModel)]=\"checkedSubLayers[subLayer]\"\n                        (change)=\"subLayerSelected(subLayer,checkedSubLayers[subLayer.Name])\"\n                        [attr.id]=\"'hs-sublayers-'+subLayer\" [ngModelOptions]=\"{standalone: true}\">\n                    <label class=\"form-check-label\" [attr.for]=\"'hs-sublayers-'+subLayer\">{{subLayer}}</label>\n                </div>\n                <hs-layer-editor-sub-layer-checkbox [subLayer]=\"subLayer\" [app]=\"app\"\n                    *ngIf=\"!subLayerIsString(subLayer)\"><!-- TODO: Remove function call from template -->\n                </hs-layer-editor-sub-layer-checkbox>\n            </div>\n        </div>\n\n    </div>\n</div>", components: [{ type: HsLayerEditorSubLayerCheckboxesComponent, selector: "hs-layer-editor-sub-layer-checkbox", inputs: ["subLayer", "app"] }], directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3$1.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerEditorSubLayerCheckboxesComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-layer-editor-sub-layer-checkbox', template: "<div class=\"d-flex m-auto sublayerContainer\">\n    <!-- string -->\n    <div class=\"p-0 form-check form-check-inline\" *ngIf=\"subLayerIsString(subLayer)\">\n        <input class=\"form-check-input\" type=\"checkbox\" [(ngModel)]=\"checkedSubLayers[subLayer]\"\n            (change)=\"subLayerSelected()\">\n        <label class=\"form-check-label\">{{subLayer}}</label>\n    </div>\n    <!-- object -->\n    <div *ngIf=\"!subLayerIsString(subLayer)\" class=\"w-100\"><!-- TODO: Remove function call from template -->\n        <div class=\"d-flex\">\n            <div class=\"p-0 form-check form-check-inline\">\n                <input class=\"form-check-input\" type=\"checkbox\" [(ngModel)]=\"checkedSubLayers[subLayer.Name]\"\n                    name=\"sublayerWithoutNestedSublayers\"\n                    (change)=\"subLayerSelected(subLayer,checkedSubLayers[subLayer.Name])\"\n                    [attr.id]=\"'hs-sublayers-' + subLayer.Name + '-' + app\" *ngIf=\"!subLayer.Layer\">\n                <input class=\"form-check-input\" type=\"checkbox\" [(ngModel)]=\"withChildren[subLayer.Name]\"\n                    name=\"sublayerWithNestedSublayers\"\n                    (change)=\"subLayerSelected(subLayer, withChildren[subLayer.Name])\"\n                    [attr.id]=\"'hs-sublayers-' + subLayer.Name + '-' + app\" *ngIf=\"subLayer.Layer\">\n\n                <div class=\"p-0 d-inline-flex flex-grow\" *ngIf=\"subLayer.Layer\">\n                    <label class=\"form-check-label m-0\"\n                        [ngClass]=\"{'hs-checkmark':withChildren[subLayer.Name],'hs-uncheckmark':!withChildren[subLayer.Name]}\"\n                        [attr.for]=\"'hs-sublayers-' + subLayer.Name + '-' + app\"></label>\n                    <div (click)=\"toggleExpanded()\" [ngStyle]=\"{'cursor':'pointer'}\"\n                        [ngClass]=\"{'grayed': HsLayerManagerService.apps[app].currentResolution >= subLayer.maxResolution}\">\n                        {{subLayer.Title || subLayer.Name}}\n                        <button type=\"button\" class=\"btn btn-sm p-0\" [ngStyle]=\"{'font-size':'x-small'}\">\n                            <i [ngClass]=\"{'icon-chevron-down': expanded, 'icon-chevron-right': !expanded}\"></i>\n                        </button>\n                    </div>\n                </div>\n                <div *ngIf=\"!subLayer.Layer\">\n                    <label class=\"form-check-label m-0\"\n                        [ngClass]=\"{'hs-checkmark':checkedSubLayers[subLayer.Name],'hs-uncheckmark':!checkedSubLayers[subLayer.Name], 'grayed': (HsLayerManagerService.apps[app].currentResolution > subLayer.maxResolution) }\"\n                        [attr.for]=\"'hs-sublayers-' + subLayer.Name + '-' + app\">{{subLayer.Title ||\n                        subLayer.Name}}</label>\n                </div>\n            </div>\n        </div>\n        <div *ngIf=\"subLayer.Layer\" class=\"ms-4\" [hidden]=\"!expanded\">\n            <div *ngFor=\"let subLayer of subLayer.Layer\">\n                <div *ngIf=\"subLayerIsString(subLayer)\">\n                    <input class=\"form-check-input\" type=\"checkbox\" [(ngModel)]=\"checkedSubLayers[subLayer]\"\n                        (change)=\"subLayerSelected(subLayer,checkedSubLayers[subLayer.Name])\"\n                        [attr.id]=\"'hs-sublayers-'+subLayer\" [ngModelOptions]=\"{standalone: true}\">\n                    <label class=\"form-check-label\" [attr.for]=\"'hs-sublayers-'+subLayer\">{{subLayer}}</label>\n                </div>\n                <hs-layer-editor-sub-layer-checkbox [subLayer]=\"subLayer\" [app]=\"app\"\n                    *ngIf=\"!subLayerIsString(subLayer)\"><!-- TODO: Remove function call from template -->\n                </hs-layer-editor-sub-layer-checkbox>\n            </div>\n        </div>\n\n    </div>\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsLayerEditorSublayerService }, { type: HsLayerManagerService }]; }, propDecorators: { subLayer: [{
                type: Input
            }], app: [{
                type: Input
            }] } });

class HsLayerEditorComponent {
    constructor(HsLayerUtilsService, HsDimensionTimeService, HsStylerService, HsMapService, HsLayerManagerService, HsLayoutService, HsLayerEditorSublayerService, HsLayerEditorService, HsDrawService, HsEventBusService, HsDialogContainerService, HsLanguageService, hsWidgetContainerService) {
        this.HsLayerUtilsService = HsLayerUtilsService;
        this.HsDimensionTimeService = HsDimensionTimeService;
        this.HsStylerService = HsStylerService;
        this.HsMapService = HsMapService;
        this.HsLayerManagerService = HsLayerManagerService;
        this.HsLayoutService = HsLayoutService;
        this.HsLayerEditorSublayerService = HsLayerEditorSublayerService;
        this.HsLayerEditorService = HsLayerEditorService;
        this.HsDrawService = HsDrawService;
        this.HsEventBusService = HsEventBusService;
        this.HsDialogContainerService = HsDialogContainerService;
        this.HsLanguageService = HsLanguageService;
        this.hsWidgetContainerService = hsWidgetContainerService;
        this.app = 'default';
        this.layer_renamer_visible = false;
        this.getBase = getBase;
        this.tmpTitle = undefined;
    }
    set currentLayer(value) {
        this._currentLayer = value;
        this.tmpTitle = undefined;
        this.layer_renamer_visible = false;
    }
    get currentLayer() {
        return this._currentLayer;
    }
    createWidgets() {
        const widgets = [
            HsTypeWidgetComponent,
            HsMetadataWidgetComponent,
            HsClusterWidgetComponent,
            HsScaleWidgetComponent,
            HsLegendWidgetComponent,
            HsLayerEditorDimensionsComponent,
            HsOpacityWidgetComponent,
            HsIdwWidgetComponent,
        ];
        for (const widgetClass of widgets) {
            this.hsWidgetContainerService.create(widgetClass, {}, this.app);
        }
    }
    /**
     * Confirm saving a vector layer content as a geoJSON
     * @returns an empty promise
     */
    createSaveDialog() {
        return __awaiter(this, void 0, void 0, function* () {
            const dialog = this.HsDialogContainerService.create(HsConfirmDialogComponent, {
                message: this.HsLanguageService.getTranslation('LAYERMANAGER.layerEditor.savegeojson', undefined, this.app) + '?',
                title: this.HsLanguageService.getTranslation('COMMON.confirm', undefined, this.app),
            }, this.app);
            const confirmed = yield dialog.waitResult();
            if (confirmed == 'yes') {
                return this.HsLayerManagerService.saveGeoJson(this.app);
            }
        });
    }
    layerIsWmsT() {
        return this.HsDimensionTimeService.layerIsWmsT(this.currentLayer);
    }
    /**
     * Zoom to selected layer (layer extent). Get extent
     * from bounding box property, getExtent() function or from
     * BoundingBox property of GetCapabilities request (for WMS layer)
     * @returns a promise
     */
    zoomToLayer(app) {
        return this.HsLayerEditorService.zoomToLayer(this.olLayer(), app);
    }
    /**
     * Display styler panel for selected layer, so user can change its style
     */
    styleLayer() {
        const layer = this.olLayer();
        this.HsStylerService.get(this.app).layer = layer;
        this.HsLayoutService.setMainPanel('styler', this.app);
    }
    /**
     * Toggle layer rename control on panel (through layer rename variable)
     */
    toggleLayerRename() {
        this.tmpTitle = undefined;
        this.layer_renamer_visible = !this.layer_renamer_visible;
    }
    /**
     * Determines if selected layer has BoundingBox defined as
     * its metadata or is a Vector layer. Used for setting visibility
     * of 'Zoom to ' button
     */
    layerIsZoomable() {
        return this.HsLayerUtilsService.layerIsZoomable(this.olLayer());
    }
    /**
     * Determines if selected layer is a Vector layer and
     * styleable. Used for allowing styling
     */
    layerIsStyleable() {
        return this.HsLayerUtilsService.layerIsStyleable(this.olLayer());
    }
    /**
     * Check if layer can be removed based on 'removable'
     * layer attribute
     */
    isLayerRemovable() {
        const layer = this.olLayer();
        return (!layer || getRemovable(layer) == undefined || getRemovable(layer) == true);
    }
    removeLayer() {
        this.HsDialogContainerService.create(HsLayerManagerRemoveLayerDialogComponent, { olLayer: this.olLayer() }, this.app);
    }
    olLayer() {
        if (!this.currentLayer) {
            return undefined;
        }
        return this.currentLayer.layer;
    }
    /**
     * Change title of layer (Angular automatically change title in object wrapper but it is needed to manually change in Ol.layer object)
     * @param newTitle - New title to set
     */
    set title(newTitle) {
        this.tmpTitle = newTitle.trim();
    }
    get title() {
        const layer = this.olLayer();
        if (layer == undefined) {
            return;
        }
        if (this.tmpTitle == undefined) {
            this.tmpTitle = getTitle(layer);
        }
        return this.tmpTitle;
    }
    saveTitle() {
        const layer = this.olLayer();
        if (layer == undefined) {
            return;
        }
        this.HsLayerEditorService.layerTitleChange.next({
            newTitle: this.tmpTitle,
            oldTitle: getTitle(layer),
            layer,
        });
        setTitle(layer, this.tmpTitle);
        this.HsEventBusService.layerManagerUpdates.next({
            layer: null,
            app: this.app,
        });
        this.toggleLayerRename();
    }
    titleUnsaved() {
        return this.tmpTitle != getTitle(this.olLayer());
    }
    hasSubLayers() {
        var _a;
        if (this.currentLayer === null) {
            return;
        }
        const subLayers = (_a = getCachedCapabilities(this.currentLayer.layer)) === null || _a === void 0 ? void 0 : _a.Layer;
        return subLayers != undefined && subLayers.length > 0;
    }
    getSubLayers() {
        return this.HsLayerEditorSublayerService.getSubLayers(this.app);
    }
    copyLayer() {
        return __awaiter(this, void 0, void 0, function* () {
            const dialog = this.HsDialogContainerService.create(HsCopyLayerDialogComponent, {
                message: this.HsLanguageService.getTranslation('LAYERMANAGER.layerEditor.copyLayer', undefined, this.app) + '?',
                title: this.HsLanguageService.getTranslation('COMMON.copyLayer', undefined, this.app),
                layerTitle: getTitle(this.currentLayer.layer),
                app: this.app,
            }, this.app);
            const result = yield dialog.waitResult();
            if (result.confirmed == 'yes') {
                return this.HsLayerManagerService.copyLayer(result.layerTitle, this.app);
            }
        });
    }
}
HsLayerEditorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerEditorComponent, deps: [{ token: HsLayerUtilsService }, { token: HsDimensionTimeService }, { token: HsStylerService }, { token: HsMapService }, { token: HsLayerManagerService }, { token: HsLayoutService }, { token: HsLayerEditorSublayerService }, { token: HsLayerEditorService }, { token: HsDrawService }, { token: HsEventBusService }, { token: HsDialogContainerService }, { token: HsLanguageService }, { token: HsLayerEditorWidgetContainerService }], target: i0.ɵɵFactoryTarget.Component });
HsLayerEditorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsLayerEditorComponent, selector: "hs-layer-editor", inputs: { app: "app", currentLayer: ["current-layer", "currentLayer"] }, ngImport: i0, template: "<div class=\"card panel-default\">\n    <div class=\"card-body\" *ngIf=\"currentLayer\">\n        <!-- Sublayers-->\n        <div [hidden]=\"!currentLayer.sublayers\" class=\"form-group\">\n            <div *ngFor=\"let subLayer of getSubLayers()\">\n                <hs-layer-editor-sub-layer-checkbox [subLayer]=\"subLayer\" [app]=\"app\">\n                </hs-layer-editor-sub-layer-checkbox>\n            </div>\n        </div>\n        <div *ngIf=\"currentLayer.settings\">\n            <form>\n                <hs-panel-container [service]=\"hsWidgetContainerService\" (init)=\"createWidgets()\" [app]=\"app\">\n                </hs-panel-container>\n            </form>\n            <div class=\"btn-group m-auto d-flex w-75\" *ngIf=\"currentLayer.visible && getBase(currentLayer.layer)\">\n                <button class=\"btn btn-sm btn-outline-primary  w-50\"\n                    (click)=\"HsLayerManagerService.setGreyscale(currentLayer, app)\"\n                    [ngClass]=\"{'active' : !currentLayer.grayscale}\" data-toggle=\"tooltip\"\n                    [title]=\"'LAYERMANAGER.layerEditor.zoomToLayer' | translateHs : {app} \">{{'COMMON.color' | translateHs : {app} }}</button>\n                <button class=\"btn btn-sm btn-outline-primary  w-50\"\n                    (click)=\"HsLayerManagerService.setGreyscale(currentLayer, app)\"\n                    [ngClass]=\"{'active' : currentLayer.grayscale}\" data-toggle=\"tooltip\"\n                    [title]=\"'LAYERMANAGER.layerEditor.styleLayer' | translateHs : {app} \">{{'LAYERMANAGER.baseMapGallery.grayscale'\n                    | translateHs : {app} }}</button>\n            </div>\n        </div>\n    </div>\n    <div class=\"card-footer\" *ngIf=\"currentLayer?.settings\">\n        <div class=\"form-group\" [hidden]=\"!layer_renamer_visible\">\n            <label>{{'COMMON.title' | translateHs : {app} }}</label>\n            <div class=\"input-group\">\n                <input type=\"text\" class=\"form-control\" [(ngModel)]=\"title\" name=\"title\">\n                <button [hidden]=\"!titleUnsaved()\" (click)=\"saveTitle()\" class=\"btn btn-outline-secondary\"\n                    type=\"button\"><i class=\"icon-save-floppy\"></i></button><!-- TODO: Remove function call from template -->\n            </div>\n        </div>\n        <div class=\"btn-group\" role=\"group\" [attr.aria-label]=\"'LAYERMANAGER.editorButtons' | translateHs : {app} \">\n            <button class=\"btn btn-primary\" (click)=\"zoomToLayer(app)\" [disabled]=\"!layerIsZoomable()\"\n                data-toggle=\"tooltip\" [title]=\"'LAYERMANAGER.layerEditor.zoomToLayer' | translateHs : {app} \"><!-- TODO: Remove function call from template --><i\n                    class=\"icon-search\"></i></button>\n            <button class=\"btn btn-primary\" (click)=\"styleLayer()\" [disabled]=\"!layerIsStyleable()\"\n                data-toggle=\"tooltip\" [title]=\"'LAYERMANAGER.layerEditor.styleLayer' | translateHs : {app} \"><i\n                    class=\"icon-brush\"></i></button><!-- TODO: Remove function call from template -->\n            <button class=\"btn btn-primary\" (click)=\"toggleLayerRename()\" data-toggle=\"tooltip\"\n                [title]=\"'COMMON.renameLayer' | translateHs : {app} \"><i class=\"icon-textfield\"></i></button>\n            <button class=\"btn btn-primary\" (click)=\"createSaveDialog()\" data-toggle=\"tooltip\"\n                *ngIf=\"HsLayerEditorService.isLayerVectorLayer(currentLayer.layer)\"\n                [title]=\"'LAYERMANAGER.layerEditor.savegeojson' | translateHs : {app} \"><!-- TODO: Remove function call from template --><i class=\"icon-save-floppy\"></i></button>\n            <button class=\"btn btn-primary\" (click)=\"copyLayer()\" data-toggle=\"tooltip\"\n                [title]=\"'COMMON.copyLayer' | translateHs : {app} \"><i class=\"icon-copy\"></i></button>\n            <button class=\"btn btn-danger\" (click)=\"removeLayer()\" *ngIf=\"isLayerRemovable()\" data-toggle=\"tooltip\"\n                [title]=\"'COMMON.removeLayer' | translateHs : {app} \"><i class=\"icon-trash\"></i></button><!-- TODO: Remove function call from template -->\n        </div>\n    </div>\n\n</div>\n", components: [{ type: HsLayerEditorSubLayerCheckboxesComponent, selector: "hs-layer-editor-sub-layer-checkbox", inputs: ["subLayer", "app"] }, { type: HsPanelContainerComponent, selector: "hs-panel-container", inputs: ["service", "data", "app", "reusePanelObserver", "panelObserver"], outputs: ["init"] }], directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i3$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i3$1.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerEditorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-layer-editor', template: "<div class=\"card panel-default\">\n    <div class=\"card-body\" *ngIf=\"currentLayer\">\n        <!-- Sublayers-->\n        <div [hidden]=\"!currentLayer.sublayers\" class=\"form-group\">\n            <div *ngFor=\"let subLayer of getSubLayers()\">\n                <hs-layer-editor-sub-layer-checkbox [subLayer]=\"subLayer\" [app]=\"app\">\n                </hs-layer-editor-sub-layer-checkbox>\n            </div>\n        </div>\n        <div *ngIf=\"currentLayer.settings\">\n            <form>\n                <hs-panel-container [service]=\"hsWidgetContainerService\" (init)=\"createWidgets()\" [app]=\"app\">\n                </hs-panel-container>\n            </form>\n            <div class=\"btn-group m-auto d-flex w-75\" *ngIf=\"currentLayer.visible && getBase(currentLayer.layer)\">\n                <button class=\"btn btn-sm btn-outline-primary  w-50\"\n                    (click)=\"HsLayerManagerService.setGreyscale(currentLayer, app)\"\n                    [ngClass]=\"{'active' : !currentLayer.grayscale}\" data-toggle=\"tooltip\"\n                    [title]=\"'LAYERMANAGER.layerEditor.zoomToLayer' | translateHs : {app} \">{{'COMMON.color' | translateHs : {app} }}</button>\n                <button class=\"btn btn-sm btn-outline-primary  w-50\"\n                    (click)=\"HsLayerManagerService.setGreyscale(currentLayer, app)\"\n                    [ngClass]=\"{'active' : currentLayer.grayscale}\" data-toggle=\"tooltip\"\n                    [title]=\"'LAYERMANAGER.layerEditor.styleLayer' | translateHs : {app} \">{{'LAYERMANAGER.baseMapGallery.grayscale'\n                    | translateHs : {app} }}</button>\n            </div>\n        </div>\n    </div>\n    <div class=\"card-footer\" *ngIf=\"currentLayer?.settings\">\n        <div class=\"form-group\" [hidden]=\"!layer_renamer_visible\">\n            <label>{{'COMMON.title' | translateHs : {app} }}</label>\n            <div class=\"input-group\">\n                <input type=\"text\" class=\"form-control\" [(ngModel)]=\"title\" name=\"title\">\n                <button [hidden]=\"!titleUnsaved()\" (click)=\"saveTitle()\" class=\"btn btn-outline-secondary\"\n                    type=\"button\"><i class=\"icon-save-floppy\"></i></button><!-- TODO: Remove function call from template -->\n            </div>\n        </div>\n        <div class=\"btn-group\" role=\"group\" [attr.aria-label]=\"'LAYERMANAGER.editorButtons' | translateHs : {app} \">\n            <button class=\"btn btn-primary\" (click)=\"zoomToLayer(app)\" [disabled]=\"!layerIsZoomable()\"\n                data-toggle=\"tooltip\" [title]=\"'LAYERMANAGER.layerEditor.zoomToLayer' | translateHs : {app} \"><!-- TODO: Remove function call from template --><i\n                    class=\"icon-search\"></i></button>\n            <button class=\"btn btn-primary\" (click)=\"styleLayer()\" [disabled]=\"!layerIsStyleable()\"\n                data-toggle=\"tooltip\" [title]=\"'LAYERMANAGER.layerEditor.styleLayer' | translateHs : {app} \"><i\n                    class=\"icon-brush\"></i></button><!-- TODO: Remove function call from template -->\n            <button class=\"btn btn-primary\" (click)=\"toggleLayerRename()\" data-toggle=\"tooltip\"\n                [title]=\"'COMMON.renameLayer' | translateHs : {app} \"><i class=\"icon-textfield\"></i></button>\n            <button class=\"btn btn-primary\" (click)=\"createSaveDialog()\" data-toggle=\"tooltip\"\n                *ngIf=\"HsLayerEditorService.isLayerVectorLayer(currentLayer.layer)\"\n                [title]=\"'LAYERMANAGER.layerEditor.savegeojson' | translateHs : {app} \"><!-- TODO: Remove function call from template --><i class=\"icon-save-floppy\"></i></button>\n            <button class=\"btn btn-primary\" (click)=\"copyLayer()\" data-toggle=\"tooltip\"\n                [title]=\"'COMMON.copyLayer' | translateHs : {app} \"><i class=\"icon-copy\"></i></button>\n            <button class=\"btn btn-danger\" (click)=\"removeLayer()\" *ngIf=\"isLayerRemovable()\" data-toggle=\"tooltip\"\n                [title]=\"'COMMON.removeLayer' | translateHs : {app} \"><i class=\"icon-trash\"></i></button><!-- TODO: Remove function call from template -->\n        </div>\n    </div>\n\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: HsLayerUtilsService }, { type: HsDimensionTimeService }, { type: HsStylerService }, { type: HsMapService }, { type: HsLayerManagerService }, { type: HsLayoutService }, { type: HsLayerEditorSublayerService }, { type: HsLayerEditorService }, { type: HsDrawService }, { type: HsEventBusService }, { type: HsDialogContainerService }, { type: HsLanguageService }, { type: HsLayerEditorWidgetContainerService }]; }, propDecorators: { app: [{
                type: Input
            }], currentLayer: [{
                type: Input,
                args: ['current-layer']
            }] } });

class HsLayerManagerComponent extends HsPanelBaseComponent {
    constructor(hsCore, hsUtilsService, hsLayerUtilsService, hsMapService, hsLayerManagerService, hsLayoutService, hsLayerSynchronizerService, hsEventBusService, hsDialogContainerService, hsLanguageService, hsConfig, hsLayerListService, hsSidebarService) {
        super(hsLayoutService);
        this.hsCore = hsCore;
        this.hsUtilsService = hsUtilsService;
        this.hsLayerUtilsService = hsLayerUtilsService;
        this.hsMapService = hsMapService;
        this.hsLayerManagerService = hsLayerManagerService;
        this.hsLayoutService = hsLayoutService;
        this.hsLayerSynchronizerService = hsLayerSynchronizerService;
        this.hsEventBusService = hsEventBusService;
        this.hsDialogContainerService = hsDialogContainerService;
        this.hsLanguageService = hsLanguageService;
        this.hsConfig = hsConfig;
        this.hsLayerListService = hsLayerListService;
        this.hsSidebarService = hsSidebarService;
        this.shiftDown = false;
        this.allLayersVisible = false;
        this.physicalLayerListEnabled = false;
        this.icons = [
            'bag1.svg',
            'banking4.svg',
            'bar.svg',
            'beach17.svg',
            'bicycles.svg',
            'building103.svg',
            'bus4.svg',
            'cabinet9.svg',
            'camping13.svg',
            'caravan.svg',
            'church15.svg',
            'church1.svg',
            'coffee-shop1.svg',
            'disabled.svg',
            'favourite28.svg',
            'football1.svg',
            'footprint.svg',
            'gift-shop.svg',
            'gps40.svg',
            'gps41.svg',
            'gps42.svg',
            'gps43.svg',
            'gps5.svg',
            'hospital.svg',
            'hot-air-balloon2.svg',
            'information78.svg',
            'library21.svg',
            'location6.svg',
            'luggage13.svg',
            'monument1.svg',
            'mountain42.svg',
            'museum35.svg',
            'park11.svg',
            'parking28.svg',
            'pharmacy17.svg',
            'port2.svg',
            'restaurant52.svg',
            'road-sign1.svg',
            'sailing-boat2.svg',
            'ski1.svg',
            'swimming26.svg',
            'telephone119.svg',
            'toilets2.svg',
            'train-station.svg',
            'university2.svg',
            'warning.svg',
            'wifi8.svg',
        ];
        this.getActive = getActive;
        this.getTitle = getTitle;
        this.getThumbnail = getThumbnail;
        this.name = 'layermanager';
        this.layerTooltipDelay = 0;
        this.ngUnsubscribe = new Subject();
        this.baselayerFilter = (item) => {
            const r = new RegExp(this.hsLayerManagerService.apps[this.data.app].data.filter, 'i');
            return r.test(item.title);
        };
        this.hsEventBusService.layerRemovals
            .pipe(takeUntil$1(this.ngUnsubscribe))
            .subscribe((layer) => {
            var _a, _b;
            if (((_b = (_a = this.hsLayerManagerService) === null || _a === void 0 ? void 0 : _a.apps[this.data.app].currentLayer) === null || _b === void 0 ? void 0 : _b.layer) ==
                layer &&
                this.hsUtilsService.runningInBrowser()) {
                const layerNode = document.getElementsByClassName('hs-lm-mapcontentlist')[0];
                this.hsUtilsService.insertAfter(this.layerEditorRef.nativeElement, layerNode);
                this.hsLayerManagerService.apps[this.data.app].currentLayer = null;
            }
        });
        this.hsEventBusService.compositionLoads
            .pipe(takeUntil$1(this.ngUnsubscribe))
            .subscribe(({ data }) => {
            if (data.error == undefined) {
                if (data.data != undefined && data.data.id != undefined) {
                    this.hsLayerManagerService.apps[this.data.app].composition_id =
                        data.data.id;
                }
                else if (data.id != undefined) {
                    this.hsLayerManagerService.apps[this.data.app].composition_id =
                        data.id;
                }
                else {
                    this.hsLayerManagerService.apps[this.data.app].composition_id =
                        null;
                }
            }
        });
        this.hsEventBusService.compositionDeletes
            .pipe(takeUntil$1(this.ngUnsubscribe))
            .subscribe(({ composition, app }) => {
            if (composition.id ==
                this.hsLayerManagerService.apps[this.data.app].composition_id) {
                this.hsLayerManagerService.apps[this.data.app].composition_id = null;
            }
        });
    }
    ngOnDestroy() {
        this.hsLayerManagerService.destroy(this.data.app);
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    ngOnInit() {
        this.appRef = this.hsLayerManagerService.get(this.data.app);
        this.hsSidebarService.addButton({
            panel: 'layermanager',
            module: 'hs.layermanager',
            order: 0,
            fits: true,
            title: 'PANEL_HEADER.LM',
            description: 'SIDEBAR.descriptions.LM',
            icon: 'icon-layers',
        }, this.data.app);
        this.layerTooltipDelay = this.hsConfig.get(this.data.app).layerTooltipDelay;
        this.layerlistVisible = true;
        this.init();
        this.hsLayerManagerService.init(this.data.app);
    }
    ngAfterViewInit() {
        this.hsLayerManagerService.apps[this.data.app].layerEditorElement =
            this.layerEditorRef.nativeElement;
    }
    changeBaseLayerVisibility(e, layer) {
        return this.hsLayerManagerService.changeBaseLayerVisibility(e, layer, this.data.app);
    }
    changeTerrainLayerVisibility(e, layer) {
        return this.hsLayerManagerService.changeTerrainLayerVisibility(e, layer, this.data.app);
    }
    changeLayerVisibility(toWhat, layer) {
        return this.hsLayerManagerService.changeLayerVisibility(toWhat, layer, this.data.app);
    }
    setProp(layer, property, value) {
        layer.set(property, value);
    }
    activateTheme(e) {
        return this.hsLayerManagerService.activateTheme(e, this.data.app);
    }
    filterLayerTitles() {
        this.hsEventBusService.layerManagerUpdates.next(this.data.app);
    }
    toggleVisibilityForAll() {
        this.allLayersVisible = !this.allLayersVisible;
        this.appRef.data.layers.forEach((l) => {
            this.hsLayerManagerService.changeLayerVisibility(this.allLayersVisible, l, this.data.app);
            this.hsLayerListService.toggleSublayersVisibility(l, this.data.app);
        });
    }
    /**
     * Removes layer from map object
     * @param layer - Layer to remove
     */
    removeLayer(layer) {
        this.map.removeLayer(layer);
    }
    /**
     * Removes all layers which don't have 'removable' attribute
     * set to false if user confirms the removal. Might reload composition again.
     */
    removeAllLayers() {
        this.hsDialogContainerService.create(HsLayerManagerRemoveAllDialogComponent, { app: this.data.app }, this.data.app);
    }
    /**
     * Determines if layer has copyright information available *
     * @param layer - Selected layer (HsLayerManagerService.currentLayer)
     */
    hasCopyright(layer) {
        var _a;
        if (!this.hsLayerManagerService.apps[this.data.app].currentLayer) {
            return;
        }
        else {
            return ((_a = getAttribution(layer.layer)) === null || _a === void 0 ? void 0 : _a.onlineResource) != undefined;
        }
    }
    /**
     * Test if box layers are loaded
     */
    hasBoxImages() {
        var _a;
        return (_a = this.appRef.data.box_layers) === null || _a === void 0 ? void 0 : _a.some((layer) => getThumbnail(layer) !== undefined);
    }
    /**
     * Test if layer (WMS) resolution is within map resolution interval
     * @param layer - Selected layer
     */
    isLayerInResolutionInterval(layer, app) {
        return this.hsLayerManagerService.isLayerInResolutionInterval(layer, app);
    }
    /**
     * Test if selected layer is loaded in map
     * @param layer - Selected layer
     */
    layerLoaded(layer) {
        return this.hsLayerUtilsService.layerLoaded(layer);
    }
    init() {
        this.hsLayerSynchronizerService.init(this.data.app);
        this.hsEventBusService.mapResets
            .pipe(takeUntil$1(this.ngUnsubscribe))
            .subscribe(({ app }) => {
            if (app == this.data.app) {
                this.hsLayerManagerService.apps[this.data.app].composition_id = null;
            }
        });
    }
}
HsLayerManagerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerManagerComponent, deps: [{ token: HsCoreService }, { token: HsUtilsService }, { token: HsLayerUtilsService }, { token: HsMapService }, { token: HsLayerManagerService }, { token: HsLayoutService }, { token: HsLayerSynchronizerService }, { token: HsEventBusService }, { token: HsDialogContainerService }, { token: HsLanguageService }, { token: HsConfig }, { token: HsLayerListService }, { token: HsSidebarService }], target: i0.ɵɵFactoryTarget.Component });
HsLayerManagerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsLayerManagerComponent, selector: "hs-layer-manager", viewQueries: [{ propertyName: "layerEditorRef", first: true, predicate: ["layerEditor"], descendants: true, read: ElementRef }], usesInheritance: true, ngImport: i0, template: "<div class=\"card panel-default hs-main-panel hs-layermanager-card\" [hidden]=\"(isVisible$ | async) === false\">\n    <hs-panel-header name=\"layermanager\" [title]=\"'PANEL_HEADER.LM' | translateHs : {app: data.app}\" [app]=\"data.app\">\n        <extra-buttons>\n            <div class=\"btn-group\" ngbDropdown placement=\"left-top\" display=\"dynamic\">\n                <button type=\"button\" class=\"btn\" (click)=\"physicalLayerListEnabled = !physicalLayerListEnabled\"\n                    [title]=\"'LAYERMANAGER.enablePhysicalLayerList' | translateHs : {app: data.app}\">\n                    <i class=\"glyphicon icon-layerorder\"></i>\n                </button>\n                <button ngbDropdownToggle class=\"btn but-title-sm\" type=\"button\"><i\n                        class=\"icon-menu\"></i></button>\n                <div ngbDropdownMenu>\n                    <a class=\"dropdown-item\" (click)=\"removeAllLayers()\">\n                        <i\n                            class=\"glyphicon icon-trash hs-extra-button\"></i>&nbsp;{{'LAYERMANAGER.dialogRemoveAll.removeAllAdded'\n                        |\n                        translateHs : {app: data.app} }}\n                    </a>\n                    <a class=\"dropdown-item\" (click)=\"hsCore.resetMap(data.app)\">\n                        <i class=\"glyphicon icon-fatredo hs-extra-button\"></i>&nbsp;{{'LAYERMANAGER.resetMap' |\n                        translateHs : {app: data.app} }}\n                    </a>\n                    <a class=\"dropdown-item\" *ngIf=\"appRef.data.layers?.length > 0 && !physicalLayerListEnabled\"\n                        (click)=\"toggleVisibilityForAll()\">\n                        <i class=\"glyphicon\" [ngClass]=\"allLayersVisible ? 'hs-checkmark' : 'hs-uncheckmark'\"></i>\n                        {{'LAYERMANAGER.toggleAllLayerVisibility'|translateHs : {app: data.app} }}\n                    </a>\n                </div>\n            </div>\n        </extra-buttons>\n    </hs-panel-header>\n    <div class=\"card-body hs-lm-panel\">\n        <div class=\"nav nav-pills\" [hidden]=\"!hasBoxImages()\">\n            <div *ngFor=\"let box of appRef.data.box_layers\" class=\"col-xs-2 col-md-2 list-group-item-primary\"\n                style=\"padding-right: 2px; padding-left: 2px;\">\n                <a [ngClass]=\"{ 'thumbnail': true, 'alert-info': getActive(box)}\" title=\"{{getTitle(box)}}\"\n                    (click)=\"activateTheme(box)\"><!-- TODO: Remove function call from template -->\n                    <img [src]=\"box.thumbnail\" alt=\"{{getTitle(box)}}\"><!-- TODO: Remove function call from template -->\n                </a>\n            </div>\n        </div>\n        <div><input type=\"text\" class=\"form-control hs-filter\" [placeholder]=\"'COMMON.filter' | translateHs : data\"\n                [(ngModel)]=\"appRef.data.filter\" [ngModelOptions]=\"{standalone: true}\" (input)=\"filterLayerTitles()\">\n        </div>\n\n        <ul *ngIf=\"!hsLayoutService.componentEnabled('basemapGallery', data.app)\"\n            class=\"list-group hs-lm-baselayerlist\"><!-- TODO: Remove function call from template -->\n            <li class=\"list-group-item hs-lm-item hs-lm-header clearfix list-group-item-primary\">\n                <div class=\"d-flex\">\n                    <div class=\"p-0 flex-grow-1 hs-lm-item-title\">\n                        <span class=\"align-middle\" style=\"line-height: 2em;\">{{'LAYERMANAGER.baselayers' | translateHs :\n                            {app: data.app}\n                            }}</span>\n                    </div>\n                    <div class=\"p-0\">\n                        <button type=\"button\" class=\"btn btn-sm hs-btn-baselayers\" (click)=\"changeBaseLayerVisibility()\"\n                            [ngClass]=\"appRef.data.baselayersVisible ? 'hs-checkmark' : 'hs-uncheckmark'\"></button>\n                    </div>\n                </div>\n            </li>\n            <li class=\"list-group-item hs-lm-item\" *ngFor=\"let layer of appRef.data.baselayers | filter:baselayerFilter\"\n                [ngClass]=\"{'hs-lm-deactivated-layer': !layer.visible || !layer.active}\" id=\"{{layer.idString()}}\">\n                <div class=\"d-flex\">\n                    <div class=\"p-0\">\n                        <button type=\"button\" class=\"btn btn-sm btn-light hs-lm-item-visibility\"\n                            (click)=\"changeBaseLayerVisibility($event, layer);\"\n                            [ngClass]=\"(appRef.data.baselayersVisible && layer.visible) ? 'hs-checkmark' : 'hs-uncheckmark'\"></button>\n                    </div>\n                    <ng-template #abstractTooltip>\n                        <span\n                            [innerHtml]=\"hsLayerManagerService.makeSafeAndTranslate('LAYERS', layer.abstract, data.app)\"></span>\n                    </ng-template>\n                    <div class=\"align-items-center p-0 flex-grow-1 hs-lm-item-title\" style=\"cursor:context-menu\"\n                        [ngClass]=\"{'fw-bold': layer.active, 'text-muted' : layer.grayed}\"\n                        [ngbTooltip]=\"layer.abstract ? abstractTooltip : ''\"\n                        [closeDelay]=\"layerTooltipDelay\">\n                        {{layer.title | translateHs : {app: data.app, module: 'LAYERS'} }}\n                    </div>\n                    <div class=\"ps-1 info_btn\" style=\"cursor: pointer;\">\n                        <span class=\"icon-settingsthree-gears text-secondary\"\n                            (click)=\"hsLayerManagerService.toggleLayerEditor(layer,'settings','sublayers', data.app)\"\n                            [title]=\"'COMMON.info' | translateHs : data\" data-toggle=\"tooltip\" data-container=\"body\"\n                            data-placement=\"auto\"></span>\n                    </div>\n                </div>\n                <ngb-progressbar type=\"secondary\" *ngIf=\"layer.loadProgress?.loadTotal > 0\"\n                    [value]=\"layer.loadProgress.percents\" height=\"2px\"></ngb-progressbar>\n            </li>\n        </ul>\n\n        <ul class=\"list-group hs-lm-baselayerlist\" [hidden]=\"!(appRef.data.terrainlayers.length > 0)\">\n            <li class=\"list-group-item hs-lm-item hs-lm-header clearfix list-group-item-primary\">\n                <div class=\"d-flex\">\n                    <div class=\"p-0 flex-grow-1 hs-lm-item-title\">\n                        <span class=\"align-middle\" style=\"line-height: 2em;\">{{ 'LAYERMANAGER.terrains' | translateHs :\n                            {app: data.app}\n                            }}</span>\n                    </div>\n                </div>\n            </li>\n            <li class=\"list-group-item hs-lm-item\"\n                *ngFor=\"let layer of appRef.data.terrainlayers | filter:baselayerFilter\"\n                (click)=\"changeTerrainLayerVisibility($event, layer)\" (mouseenter)=\"hovering=true\"\n                (mouseleave)=\"hovering=false\" [ngClass]=\"{'hovering': (hovering && !layer.active)}\">\n                <div class=\"d-flex \">\n                    <!-- <div class=\"p-0\" ng-show=\"layer.active || hovering\"\n                        ng-style=\"hovering && !layer.active && {'opacity':'0.5'}\">\n                        <button class=\"btn btn-sm btn-link hs-lm-baseitem-visibility\"><i\n                                class=\"icon-globe\"></i></button>\n                    </div> -->\n                    <div class=\"p-0\">\n                        <button type=\"button\" class=\"btn btn-sm btn-light hs-lm-item-visibility\"\n                            [ngClass]=\"(appRef.data.baselayersVisible && layer.visible) ? 'hs-checkmark' : 'hs-uncheckmark'\"></button>\n                    </div>\n                    <ng-template #abstractTooltip>\n                        <span\n                            [innerHtml]=\"hsLayerManagerService.makeSafeAndTranslate('LAYERS', layer.abstract, data.app)\"></span>\n                    </ng-template>\n                    <div class=\"align-items-center p-0 flex-grow-1 hs-lm-item-title\"\n                        [ngClass]=\"{'fw-bold': layer.active, 'text-muted': layer.grayed}\"\n                        [ngbTooltip]=\"layer.abstract ? abstractTooltip : ''\"\n                        [closeDelay]=\"layerTooltipDelay\"><!-- TODO: Remove function call from template -->\n                        {{layer.title | translateHs : {app: data.app, module: 'LAYERS'} }}\n                    </div>\n                </div>\n            </li>\n        </ul>\n        <ul class=\"list-group hs-lm-mapcontentlist\"><!-- TODO: Remove function call from template -->\n            <li *ngIf=\"!hsLayoutService.componentEnabled('basemapGallery', data.app)\"\n                class=\"hs-lm-header hs-lm-item list-group-item-primary hs-lm-map-content-header list-group-item\"\n                style=\"margin-bottom: 0.2em;\">\n                <span class=\"align-middle\" style=\"line-height: 2em;\">{{ 'LAYERMANAGER.mapContent' | translateHs :\n                    {app: data.app} }}</span>\n            </li>\n            <ul class=\"list-group hs-lm-layerlist mb-1\" *ngFor=\"let value of appRef.data.folders.sub_folders\"\n                [hidden]=\"physicalLayerListEnabled\">\n                <li class=\"list-group-item hs-lm-layerlist-header list-group-item-primary\"\n                    *ngIf=\"appRef.data.folders.sub_folders.length > 1\" (click)=\"value.visible = !value.visible\">\n                    <span>{{value.name | translateHs : {app: data.app, module: 'LAYERMANAGER'} }}&nbsp;</span>\n                    <span class=\"glyphicon\"\n                        [ngClass]=\"value.visible ? 'icon-chevron-right' : 'icon-chevron-down'\"></span>\n                </li>\n                <div [hidden]=\"!value.visible\">\n                    <li [hidden]=\"!(value.sub_folders.length > 0)\">\n                        <hs-layer-manager-folder [folder]=\"value\" [app]=\"data.app\"></hs-layer-manager-folder>\n                    </li>\n                    <li>\n                        <hs-layermanager-layer-list [folder]=\"value\" [app]=\"data.app\"></hs-layermanager-layer-list>\n                    </li>\n                </div>\n            </ul>\n            <ul class=\"list-group hs-lm-layerlist mb-1\" [hidden]=\"!physicalLayerListEnabled\">\n                <li>\n                    <hs-layermanager-physical-layer-list [app]=\"data.app\"></hs-layermanager-physical-layer-list>\n                </li>\n            </ul>\n            <!--\n        <div class=\"btn-group\" data-toggle=\"buttons\">\n            <label class=\"btn btn-secondary active\">\n            <input type=\"radio\" name=\"options\" id=\"option1\" checked> Logical order\n            </label>\n            <label class=\"btn btn-secondary\">\n            <input type=\"radio\" name=\"options\" id=\"option2\"> Physical order\n            </label>\n        </div> -->\n        </ul>\n        <hs-layer-editor [current-layer]=\"appRef.currentLayer\" #layerEditor [app]=\"data.app\"\n            [hidden]=\"!(appRef.currentLayer !== null) || appRef.menuExpanded\" class=\"hs-layerpanel\">\n        </hs-layer-editor>\n    </div>\n</div>\n", components: [{ type: HsPanelHeaderComponent, selector: "hs-panel-header", inputs: ["name", "app", "title"] }, { type: HsLayerManagerFolderComponent, selector: "hs-layer-manager-folder", inputs: ["folder", "app"] }, { type: HsLayerListComponent, selector: "hs-layermanager-layer-list", inputs: ["folder", "app"] }, { type: HsLayerPhysicalListComponent, selector: "hs-layermanager-physical-layer-list", inputs: ["app"] }, { type: HsLayerEditorComponent, selector: "hs-layer-editor", inputs: ["app", "current-layer"] }], directives: [{ type: i7.NgbDropdown, selector: "[ngbDropdown]", inputs: ["autoClose", "dropdownClass", "open", "placement", "container", "display"], outputs: ["openChange"], exportAs: ["ngbDropdown"] }, { type: i7.NgbDropdownToggle, selector: "[ngbDropdownToggle]" }, { type: i7.NgbDropdownMenu, selector: "[ngbDropdownMenu]" }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i7.NgbTooltip, selector: "[ngbTooltip]", inputs: ["animation", "autoClose", "placement", "triggers", "container", "disableTooltip", "tooltipClass", "openDelay", "closeDelay", "ngbTooltip"], outputs: ["shown", "hidden"], exportAs: ["ngbTooltip"] }], pipes: { "async": i3.AsyncPipe, "translateHs": TranslateCustomPipe, "filter": FilterPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerManagerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-layer-manager', template: "<div class=\"card panel-default hs-main-panel hs-layermanager-card\" [hidden]=\"(isVisible$ | async) === false\">\n    <hs-panel-header name=\"layermanager\" [title]=\"'PANEL_HEADER.LM' | translateHs : {app: data.app}\" [app]=\"data.app\">\n        <extra-buttons>\n            <div class=\"btn-group\" ngbDropdown placement=\"left-top\" display=\"dynamic\">\n                <button type=\"button\" class=\"btn\" (click)=\"physicalLayerListEnabled = !physicalLayerListEnabled\"\n                    [title]=\"'LAYERMANAGER.enablePhysicalLayerList' | translateHs : {app: data.app}\">\n                    <i class=\"glyphicon icon-layerorder\"></i>\n                </button>\n                <button ngbDropdownToggle class=\"btn but-title-sm\" type=\"button\"><i\n                        class=\"icon-menu\"></i></button>\n                <div ngbDropdownMenu>\n                    <a class=\"dropdown-item\" (click)=\"removeAllLayers()\">\n                        <i\n                            class=\"glyphicon icon-trash hs-extra-button\"></i>&nbsp;{{'LAYERMANAGER.dialogRemoveAll.removeAllAdded'\n                        |\n                        translateHs : {app: data.app} }}\n                    </a>\n                    <a class=\"dropdown-item\" (click)=\"hsCore.resetMap(data.app)\">\n                        <i class=\"glyphicon icon-fatredo hs-extra-button\"></i>&nbsp;{{'LAYERMANAGER.resetMap' |\n                        translateHs : {app: data.app} }}\n                    </a>\n                    <a class=\"dropdown-item\" *ngIf=\"appRef.data.layers?.length > 0 && !physicalLayerListEnabled\"\n                        (click)=\"toggleVisibilityForAll()\">\n                        <i class=\"glyphicon\" [ngClass]=\"allLayersVisible ? 'hs-checkmark' : 'hs-uncheckmark'\"></i>\n                        {{'LAYERMANAGER.toggleAllLayerVisibility'|translateHs : {app: data.app} }}\n                    </a>\n                </div>\n            </div>\n        </extra-buttons>\n    </hs-panel-header>\n    <div class=\"card-body hs-lm-panel\">\n        <div class=\"nav nav-pills\" [hidden]=\"!hasBoxImages()\">\n            <div *ngFor=\"let box of appRef.data.box_layers\" class=\"col-xs-2 col-md-2 list-group-item-primary\"\n                style=\"padding-right: 2px; padding-left: 2px;\">\n                <a [ngClass]=\"{ 'thumbnail': true, 'alert-info': getActive(box)}\" title=\"{{getTitle(box)}}\"\n                    (click)=\"activateTheme(box)\"><!-- TODO: Remove function call from template -->\n                    <img [src]=\"box.thumbnail\" alt=\"{{getTitle(box)}}\"><!-- TODO: Remove function call from template -->\n                </a>\n            </div>\n        </div>\n        <div><input type=\"text\" class=\"form-control hs-filter\" [placeholder]=\"'COMMON.filter' | translateHs : data\"\n                [(ngModel)]=\"appRef.data.filter\" [ngModelOptions]=\"{standalone: true}\" (input)=\"filterLayerTitles()\">\n        </div>\n\n        <ul *ngIf=\"!hsLayoutService.componentEnabled('basemapGallery', data.app)\"\n            class=\"list-group hs-lm-baselayerlist\"><!-- TODO: Remove function call from template -->\n            <li class=\"list-group-item hs-lm-item hs-lm-header clearfix list-group-item-primary\">\n                <div class=\"d-flex\">\n                    <div class=\"p-0 flex-grow-1 hs-lm-item-title\">\n                        <span class=\"align-middle\" style=\"line-height: 2em;\">{{'LAYERMANAGER.baselayers' | translateHs :\n                            {app: data.app}\n                            }}</span>\n                    </div>\n                    <div class=\"p-0\">\n                        <button type=\"button\" class=\"btn btn-sm hs-btn-baselayers\" (click)=\"changeBaseLayerVisibility()\"\n                            [ngClass]=\"appRef.data.baselayersVisible ? 'hs-checkmark' : 'hs-uncheckmark'\"></button>\n                    </div>\n                </div>\n            </li>\n            <li class=\"list-group-item hs-lm-item\" *ngFor=\"let layer of appRef.data.baselayers | filter:baselayerFilter\"\n                [ngClass]=\"{'hs-lm-deactivated-layer': !layer.visible || !layer.active}\" id=\"{{layer.idString()}}\">\n                <div class=\"d-flex\">\n                    <div class=\"p-0\">\n                        <button type=\"button\" class=\"btn btn-sm btn-light hs-lm-item-visibility\"\n                            (click)=\"changeBaseLayerVisibility($event, layer);\"\n                            [ngClass]=\"(appRef.data.baselayersVisible && layer.visible) ? 'hs-checkmark' : 'hs-uncheckmark'\"></button>\n                    </div>\n                    <ng-template #abstractTooltip>\n                        <span\n                            [innerHtml]=\"hsLayerManagerService.makeSafeAndTranslate('LAYERS', layer.abstract, data.app)\"></span>\n                    </ng-template>\n                    <div class=\"align-items-center p-0 flex-grow-1 hs-lm-item-title\" style=\"cursor:context-menu\"\n                        [ngClass]=\"{'fw-bold': layer.active, 'text-muted' : layer.grayed}\"\n                        [ngbTooltip]=\"layer.abstract ? abstractTooltip : ''\"\n                        [closeDelay]=\"layerTooltipDelay\">\n                        {{layer.title | translateHs : {app: data.app, module: 'LAYERS'} }}\n                    </div>\n                    <div class=\"ps-1 info_btn\" style=\"cursor: pointer;\">\n                        <span class=\"icon-settingsthree-gears text-secondary\"\n                            (click)=\"hsLayerManagerService.toggleLayerEditor(layer,'settings','sublayers', data.app)\"\n                            [title]=\"'COMMON.info' | translateHs : data\" data-toggle=\"tooltip\" data-container=\"body\"\n                            data-placement=\"auto\"></span>\n                    </div>\n                </div>\n                <ngb-progressbar type=\"secondary\" *ngIf=\"layer.loadProgress?.loadTotal > 0\"\n                    [value]=\"layer.loadProgress.percents\" height=\"2px\"></ngb-progressbar>\n            </li>\n        </ul>\n\n        <ul class=\"list-group hs-lm-baselayerlist\" [hidden]=\"!(appRef.data.terrainlayers.length > 0)\">\n            <li class=\"list-group-item hs-lm-item hs-lm-header clearfix list-group-item-primary\">\n                <div class=\"d-flex\">\n                    <div class=\"p-0 flex-grow-1 hs-lm-item-title\">\n                        <span class=\"align-middle\" style=\"line-height: 2em;\">{{ 'LAYERMANAGER.terrains' | translateHs :\n                            {app: data.app}\n                            }}</span>\n                    </div>\n                </div>\n            </li>\n            <li class=\"list-group-item hs-lm-item\"\n                *ngFor=\"let layer of appRef.data.terrainlayers | filter:baselayerFilter\"\n                (click)=\"changeTerrainLayerVisibility($event, layer)\" (mouseenter)=\"hovering=true\"\n                (mouseleave)=\"hovering=false\" [ngClass]=\"{'hovering': (hovering && !layer.active)}\">\n                <div class=\"d-flex \">\n                    <!-- <div class=\"p-0\" ng-show=\"layer.active || hovering\"\n                        ng-style=\"hovering && !layer.active && {'opacity':'0.5'}\">\n                        <button class=\"btn btn-sm btn-link hs-lm-baseitem-visibility\"><i\n                                class=\"icon-globe\"></i></button>\n                    </div> -->\n                    <div class=\"p-0\">\n                        <button type=\"button\" class=\"btn btn-sm btn-light hs-lm-item-visibility\"\n                            [ngClass]=\"(appRef.data.baselayersVisible && layer.visible) ? 'hs-checkmark' : 'hs-uncheckmark'\"></button>\n                    </div>\n                    <ng-template #abstractTooltip>\n                        <span\n                            [innerHtml]=\"hsLayerManagerService.makeSafeAndTranslate('LAYERS', layer.abstract, data.app)\"></span>\n                    </ng-template>\n                    <div class=\"align-items-center p-0 flex-grow-1 hs-lm-item-title\"\n                        [ngClass]=\"{'fw-bold': layer.active, 'text-muted': layer.grayed}\"\n                        [ngbTooltip]=\"layer.abstract ? abstractTooltip : ''\"\n                        [closeDelay]=\"layerTooltipDelay\"><!-- TODO: Remove function call from template -->\n                        {{layer.title | translateHs : {app: data.app, module: 'LAYERS'} }}\n                    </div>\n                </div>\n            </li>\n        </ul>\n        <ul class=\"list-group hs-lm-mapcontentlist\"><!-- TODO: Remove function call from template -->\n            <li *ngIf=\"!hsLayoutService.componentEnabled('basemapGallery', data.app)\"\n                class=\"hs-lm-header hs-lm-item list-group-item-primary hs-lm-map-content-header list-group-item\"\n                style=\"margin-bottom: 0.2em;\">\n                <span class=\"align-middle\" style=\"line-height: 2em;\">{{ 'LAYERMANAGER.mapContent' | translateHs :\n                    {app: data.app} }}</span>\n            </li>\n            <ul class=\"list-group hs-lm-layerlist mb-1\" *ngFor=\"let value of appRef.data.folders.sub_folders\"\n                [hidden]=\"physicalLayerListEnabled\">\n                <li class=\"list-group-item hs-lm-layerlist-header list-group-item-primary\"\n                    *ngIf=\"appRef.data.folders.sub_folders.length > 1\" (click)=\"value.visible = !value.visible\">\n                    <span>{{value.name | translateHs : {app: data.app, module: 'LAYERMANAGER'} }}&nbsp;</span>\n                    <span class=\"glyphicon\"\n                        [ngClass]=\"value.visible ? 'icon-chevron-right' : 'icon-chevron-down'\"></span>\n                </li>\n                <div [hidden]=\"!value.visible\">\n                    <li [hidden]=\"!(value.sub_folders.length > 0)\">\n                        <hs-layer-manager-folder [folder]=\"value\" [app]=\"data.app\"></hs-layer-manager-folder>\n                    </li>\n                    <li>\n                        <hs-layermanager-layer-list [folder]=\"value\" [app]=\"data.app\"></hs-layermanager-layer-list>\n                    </li>\n                </div>\n            </ul>\n            <ul class=\"list-group hs-lm-layerlist mb-1\" [hidden]=\"!physicalLayerListEnabled\">\n                <li>\n                    <hs-layermanager-physical-layer-list [app]=\"data.app\"></hs-layermanager-physical-layer-list>\n                </li>\n            </ul>\n            <!--\n        <div class=\"btn-group\" data-toggle=\"buttons\">\n            <label class=\"btn btn-secondary active\">\n            <input type=\"radio\" name=\"options\" id=\"option1\" checked> Logical order\n            </label>\n            <label class=\"btn btn-secondary\">\n            <input type=\"radio\" name=\"options\" id=\"option2\"> Physical order\n            </label>\n        </div> -->\n        </ul>\n        <hs-layer-editor [current-layer]=\"appRef.currentLayer\" #layerEditor [app]=\"data.app\"\n            [hidden]=\"!(appRef.currentLayer !== null) || appRef.menuExpanded\" class=\"hs-layerpanel\">\n        </hs-layer-editor>\n    </div>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: HsCoreService }, { type: HsUtilsService }, { type: HsLayerUtilsService }, { type: HsMapService }, { type: HsLayerManagerService }, { type: HsLayoutService }, { type: HsLayerSynchronizerService }, { type: HsEventBusService }, { type: HsDialogContainerService }, { type: HsLanguageService }, { type: HsConfig }, { type: HsLayerListService }, { type: HsSidebarService }]; }, propDecorators: { layerEditorRef: [{
                type: ViewChild,
                args: ['layerEditor', { static: false, read: ElementRef }]
            }] } });

class HsLayerManagerGalleryComponent extends HsPanelBaseComponent {
    constructor(hsLayoutService, hsLayerManagerService, hsLayerUtilsService //Used in template
    ) {
        super(hsLayoutService);
        this.hsLayoutService = hsLayoutService;
        this.hsLayerManagerService = hsLayerManagerService;
        this.hsLayerUtilsService = hsLayerUtilsService;
        this.menuExpanded = false;
    }
    toggleMiniMenu(layer) {
        if (layer.galleryMiniMenu) {
            layer.galleryMiniMenu = !layer.galleryMiniMenu;
        }
        else {
            layer.galleryMiniMenu = true;
        }
    }
    toggleBasemap(layer) {
        var _a;
        if (layer) {
            if (!layer.active) {
                this.hsLayerManagerService.changeBaseLayerVisibility(true, layer, this.data.app);
                this.dropdown.close();
                this.hsLayerManagerService.apps[this.data.app].menuExpanded = false;
                const olLayer = (_a = this.hsLayerManagerService.apps[this.data.app].currentLayer) === null || _a === void 0 ? void 0 : _a.layer;
                if (!olLayer || getBase(olLayer)) {
                    this.hsLayerManagerService.apps[this.data.app].currentLayer = null;
                }
            }
        }
        else {
            this.dropdown.close();
            this.hsLayerManagerService.apps[this.data.app].currentLayer = null;
            this.hsLayerManagerService.changeBaseLayerVisibility(null, null, this.data.app);
        }
    }
    expandMenu(layer) {
        this.hsLayerManagerService.toggleLayerEditor(layer, 'settings', 'sublayers', this.data.app);
        this.hsLayerManagerService.apps[this.data.app].menuExpanded =
            !this.hsLayerManagerService.apps[this.data.app].menuExpanded;
    }
    isVisible() {
        return (this.hsLayoutService.componentEnabled('basemapGallery', this.data.app) &&
            this.hsLayoutService.componentEnabled('guiOverlay', this.data.app));
    }
}
HsLayerManagerGalleryComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerManagerGalleryComponent, deps: [{ token: HsLayoutService }, { token: HsLayerManagerService }, { token: HsLayerUtilsService }], target: i0.ɵɵFactoryTarget.Component });
HsLayerManagerGalleryComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsLayerManagerGalleryComponent, selector: "hs-layermanager-gallery", viewQueries: [{ propertyName: "dropdown", first: true, predicate: ["galleryDropdown"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<div class=\"basemapGallery\" style=\"z-index: 101;\" [hidden]=\"(isVisible$ | async) === false\">\n    <div ngbDropdown placement=\"bottom-right\" class=\"btn-group btn-group-sm\" role=\"group\"\n        [attr.data-cy]=\"'basemap-gallery'\" #galleryDropdown=\"ngbDropdown\">\n        <button ngbDropdownToggle type=\"button\" class=\"btn rounded galleryButton pt-0 pb-0\" aria-haspopup=\"true\">\n            <i class=\"glyphicon icon-map x-large p-0\"></i>\n        </button>\n        <div ngbDropdownMenu class=\"p-0 galleryDropdown bg-light rounded\">\n            <div *ngFor=\"let layer of hsLayerManagerService.apps[data.app].data.baselayers\" [attr.data-cy]=\"layer.title\"\n                (click)=\"toggleBasemap(layer);\" [ngStyle]=\"{'position':'relative'}\" class=\"m-0\">\n                <div style=\"position:absolute;top:5px; right:5px;z-index:5\"\n                    [ngClass]=\"layer.galleryMiniMenu ? 'text-white' : 'text-primary'\" *ngIf=\"layer.active\"\n                    (click)=\"$event.preventDefault();toggleMiniMenu(layer)\">\n                    <span class=\"glyphicon icon-menu icon-small\"></span>\n                </div>\n                <div class=\"hs-miniMenu\" [hidden]=\"!(layer.galleryMiniMenu === true && layer.active)\"\n                    [ngStyle]=\"{'position':'absolute'}\"\n                    [ngClass]=\"{'expanded': hsLayerManagerService.apps[data.app].menuExpanded}\"><!-- TODO: Remove function call from template -->\n                    <div class=\"ps-1 w-100\" *ngIf=\"!hsLayerManagerService.apps[data.app].menuExpanded\"\n                        (click)=\"hsLayerManagerService.setGreyscale(layer, data.app)\">\n                        <label class=\"form-check-label m-0\"\n                            [ngClass]=\"{'hs-checkmark': layer.grayscale,'hs-uncheckmark':!layer.grayscale}\"></label>\n                        <p class=\"ms-1 mb-0\">\n                            {{'LAYERMANAGER.baseMapGallery.grayscale' | translateHs : {app: data.app} }}</p>\n                    </div>\n                    <label class=\"ps-2 mb-0 w-100\" [ngStyle]=\"{'background-color':'rgba(192, 189, 189, 0.644)'}\"\n                        (click)=\"expandMenu(layer)\">\n\n                        {{hsLayerManagerService.apps[data.app].menuExpanded ? 'Less ': 'More'}}</label>\n                    <hs-layer-editor [current-layer]=\"layer\" *ngIf=\"hsLayerManagerService.apps[data.app].menuExpanded\"\n                        [app]=\"data.app\" class=\"hs-layerpanel w-100\" #layerEditor>\n                    </hs-layer-editor>\n                </div>\n\n                <img [ngClass]=\"{'active': layer.active, 'hs-ale': !layer.active}\" src=\"{{layer.thumbnail}}\"\n                    alt=\"Basemap thumbnail\" style=\"width:100%\">\n                <a class=\"dropdown-item\" [ngClass]=\"{'active': layer.active}\"\n                    style=\"white-space: pre-line; overflow-wrap: anywhere;\">{{layer.title | translateHs : {app: data.app, module: 'LAYERS'} }}</a>\n            </div>\n            <div (click)=\"toggleBasemap()\">\n                <div style=\"height: 4em; width: 100%; background: white\"\n                    [ngClass]=\"{'active': !hsLayerManagerService.apps[data.app].data.baselayersVisible}\"></div>\n                <a class=\"dropdown-item\"\n                    [ngClass]=\"{'active': !hsLayerManagerService.apps[data.app].data.baselayersVisible}\">{{'LAYERMANAGER.baseMapGallery.noBaseMap'\n                    | translateHs : {app: data.app} }}</a>\n            </div>\n        </div>\n    </div>\n</div>", components: [{ type: HsLayerEditorComponent, selector: "hs-layer-editor", inputs: ["app", "current-layer"] }], directives: [{ type: i7.NgbDropdown, selector: "[ngbDropdown]", inputs: ["autoClose", "dropdownClass", "open", "placement", "container", "display"], outputs: ["openChange"], exportAs: ["ngbDropdown"] }, { type: i7.NgbDropdownToggle, selector: "[ngbDropdownToggle]" }, { type: i7.NgbDropdownMenu, selector: "[ngbDropdownMenu]" }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], pipes: { "async": i3.AsyncPipe, "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerManagerGalleryComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-layermanager-gallery', template: "<div class=\"basemapGallery\" style=\"z-index: 101;\" [hidden]=\"(isVisible$ | async) === false\">\n    <div ngbDropdown placement=\"bottom-right\" class=\"btn-group btn-group-sm\" role=\"group\"\n        [attr.data-cy]=\"'basemap-gallery'\" #galleryDropdown=\"ngbDropdown\">\n        <button ngbDropdownToggle type=\"button\" class=\"btn rounded galleryButton pt-0 pb-0\" aria-haspopup=\"true\">\n            <i class=\"glyphicon icon-map x-large p-0\"></i>\n        </button>\n        <div ngbDropdownMenu class=\"p-0 galleryDropdown bg-light rounded\">\n            <div *ngFor=\"let layer of hsLayerManagerService.apps[data.app].data.baselayers\" [attr.data-cy]=\"layer.title\"\n                (click)=\"toggleBasemap(layer);\" [ngStyle]=\"{'position':'relative'}\" class=\"m-0\">\n                <div style=\"position:absolute;top:5px; right:5px;z-index:5\"\n                    [ngClass]=\"layer.galleryMiniMenu ? 'text-white' : 'text-primary'\" *ngIf=\"layer.active\"\n                    (click)=\"$event.preventDefault();toggleMiniMenu(layer)\">\n                    <span class=\"glyphicon icon-menu icon-small\"></span>\n                </div>\n                <div class=\"hs-miniMenu\" [hidden]=\"!(layer.galleryMiniMenu === true && layer.active)\"\n                    [ngStyle]=\"{'position':'absolute'}\"\n                    [ngClass]=\"{'expanded': hsLayerManagerService.apps[data.app].menuExpanded}\"><!-- TODO: Remove function call from template -->\n                    <div class=\"ps-1 w-100\" *ngIf=\"!hsLayerManagerService.apps[data.app].menuExpanded\"\n                        (click)=\"hsLayerManagerService.setGreyscale(layer, data.app)\">\n                        <label class=\"form-check-label m-0\"\n                            [ngClass]=\"{'hs-checkmark': layer.grayscale,'hs-uncheckmark':!layer.grayscale}\"></label>\n                        <p class=\"ms-1 mb-0\">\n                            {{'LAYERMANAGER.baseMapGallery.grayscale' | translateHs : {app: data.app} }}</p>\n                    </div>\n                    <label class=\"ps-2 mb-0 w-100\" [ngStyle]=\"{'background-color':'rgba(192, 189, 189, 0.644)'}\"\n                        (click)=\"expandMenu(layer)\">\n\n                        {{hsLayerManagerService.apps[data.app].menuExpanded ? 'Less ': 'More'}}</label>\n                    <hs-layer-editor [current-layer]=\"layer\" *ngIf=\"hsLayerManagerService.apps[data.app].menuExpanded\"\n                        [app]=\"data.app\" class=\"hs-layerpanel w-100\" #layerEditor>\n                    </hs-layer-editor>\n                </div>\n\n                <img [ngClass]=\"{'active': layer.active, 'hs-ale': !layer.active}\" src=\"{{layer.thumbnail}}\"\n                    alt=\"Basemap thumbnail\" style=\"width:100%\">\n                <a class=\"dropdown-item\" [ngClass]=\"{'active': layer.active}\"\n                    style=\"white-space: pre-line; overflow-wrap: anywhere;\">{{layer.title | translateHs : {app: data.app, module: 'LAYERS'} }}</a>\n            </div>\n            <div (click)=\"toggleBasemap()\">\n                <div style=\"height: 4em; width: 100%; background: white\"\n                    [ngClass]=\"{'active': !hsLayerManagerService.apps[data.app].data.baselayersVisible}\"></div>\n                <a class=\"dropdown-item\"\n                    [ngClass]=\"{'active': !hsLayerManagerService.apps[data.app].data.baselayersVisible}\">{{'LAYERMANAGER.baseMapGallery.noBaseMap'\n                    | translateHs : {app: data.app} }}</a>\n            </div>\n        </div>\n    </div>\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsLayoutService }, { type: HsLayerManagerService }, { type: HsLayerUtilsService }]; }, propDecorators: { dropdown: [{
                type: ViewChild,
                args: ['galleryDropdown', { static: false }]
            }] } });

class HsLegendComponent extends HsPanelBaseComponent {
    constructor(hsLegendService, hsMapService, hsLayerUtilsService, hsUtilsService, hsQueuesService, hsLayoutService, hsLanguageService, hsSidebarService) {
        super(hsLayoutService);
        this.hsLegendService = hsLegendService;
        this.hsMapService = hsMapService;
        this.hsLayerUtilsService = hsLayerUtilsService;
        this.hsUtilsService = hsUtilsService;
        this.hsQueuesService = hsQueuesService;
        this.hsLanguageService = hsLanguageService;
        this.hsSidebarService = hsSidebarService;
        this.layerDescriptors = [];
        this.titleSearch = '';
        this.name = 'legend';
        this.ngUnsubscribe = new Subject();
        this.legendFilter = (item) => {
            const r = new RegExp(this.titleSearch, 'i');
            return r.test(item.title);
        };
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    ngOnInit() {
        this.hsSidebarService.addButton({
            panel: 'legend',
            module: 'hs.legend',
            order: 1,
            fits: true,
            title: 'PANEL_HEADER.LEGEND',
            description: 'SIDEBAR.descriptions.LEGEND',
            icon: 'icon-dotlist',
        }, this.data.app);
        this.hsMapService.loaded(this.data.app).then((map) => this.init(map));
    }
    /**
     * Add selected layer to the list of layers in legend (with event listener
     * to display/hide legend item when layer visibility change)
     * @param layer - Layer to add legend for
     */
    addLayerToLegends(layer) {
        return __awaiter(this, void 0, void 0, function* () {
            const descriptor = yield this.hsLegendService.getLayerLegendDescriptor(layer, this.data.app);
            if (descriptor) {
                const source = layer.getSource();
                if (this.hsUtilsService.instOf(source, InterpolatedSource)) {
                    source.colorMapChanged
                        .pipe(takeUntil(this.ngUnsubscribe))
                        .subscribe(() => {
                        this.layerSourcePropChanged({ target: source });
                    });
                }
                this.layerDescriptors.push(descriptor);
                this.refreshList();
                layer.on('change:visible', (e) => this.layerVisibilityChanged(e));
                if (this.hsLayerUtilsService.isLayerWMS(layer)) {
                    layer.getSource().on('change', (e) => {
                        this.hsUtilsService.debounce(this.layerSourcePropChanged(e), 100, false, this);
                    });
                }
            }
        });
    }
    rebuildLegends(app) {
        this.layerDescriptors = [];
        this.buildLegendsForLayers(this.hsMapService.getMap(app));
    }
    filterDescriptors() {
        return this.layerDescriptors;
    }
    /**
     * Check if there is any visible layer
     * @returns Returns true if no layers with legend exist
     */
    noLayerExists() {
        const visibleLayers = this.layerDescriptors.filter((check) => check.visible);
        return visibleLayers.length == 0;
    }
    /**
     * Remove selected layer from legend items
     * @param layer - Layer to remove from legend
     */
    removeLayerFromLegends(layer) {
        for (let i = 0; i < this.layerDescriptors.length; i++) {
            if (this.layerDescriptors[i].lyr == layer) {
                this.layerDescriptors.splice(i, 1);
                this.refreshList();
                break;
            }
        }
    }
    /**
     * @param map -
     */
    init(map) {
        map.getLayers().on('add', (e) => this.layerAdded(e));
        map.getLayers().on('remove', (e) => {
            this.removeLayerFromLegends(e.element);
        });
        this.buildLegendsForLayers(map);
    }
    buildLegendsForLayers(map) {
        map.getLayers().forEach((lyr) => {
            this.layerAdded({
                element: lyr,
            });
        });
    }
    /**
     * (PRIVATE) Callback function for adding layer to map, add layers legend
     * @param e - Event object, should have element property
     */
    layerAdded(e) {
        const que = this.hsQueuesService.ensureQueue('addLayerToLegends', this.data.app, 3, 10000);
        que.push((cb) => __awaiter(this, void 0, void 0, function* () {
            yield this.addLayerToLegends(e.element);
            cb(null);
        }));
    }
    /**
     * @param e - event description
     */
    layerVisibilityChanged(e) {
        const descriptor = this.findLayerDescriptor(e.target);
        if (descriptor) {
            descriptor.visible = e.target.getVisible();
        }
    }
    /**
     * @param e - event description
     */
    layerSourcePropChanged(e) {
        const descriptor = this.findLayerDescriptorBySource(e.target);
        if (descriptor) {
            this.hsLegendService
                .getLayerLegendDescriptor(descriptor.lyr, this.data.app)
                .then((newDescriptor) => {
                if (newDescriptor.subLayerLegends != descriptor.subLayerLegends ||
                    newDescriptor.title != descriptor.title ||
                    this.hsLayerUtilsService.isLayerIDW(descriptor.lyr)) {
                    this.layerDescriptors[this.layerDescriptors.indexOf(descriptor)] =
                        newDescriptor;
                    this.refreshList();
                }
            });
        }
    }
    /**
     * Finds layer descriptor for OpenLayers layer
     * @param layer - OpenLayers layer
     * @returns Object describing the legend
     */
    findLayerDescriptor(layer) {
        return this.layerDescriptors.find((ld) => ld.lyr == layer);
    }
    /**
     * @param source -
     */
    findLayerDescriptorBySource(source) {
        const found = this.layerDescriptors.filter((ld) => ld.lyr.getSource() == source);
        if (found.length > 0) {
            return found[0];
        }
    }
    refreshList() {
        this.layerDescriptors = Array.from(this.layerDescriptors);
    }
}
HsLegendComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLegendComponent, deps: [{ token: HsLegendService }, { token: HsMapService }, { token: HsLayerUtilsService }, { token: HsUtilsService }, { token: HsQueuesService }, { token: HsLayoutService }, { token: HsLanguageService }, { token: HsSidebarService }], target: i0.ɵɵFactoryTarget.Component });
HsLegendComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsLegendComponent, selector: "hs-legend", usesInheritance: true, ngImport: i0, template: "<div class=\"card hs-main-panel\" [hidden]=\"(isVisible$ | async) === false\">\n    <hs-panel-header name=\"legend\" [title]=\"'PANEL_HEADER.LEGEND' | translateHs : data\" [app]=\"data.app\">\n    </hs-panel-header>\n    <div class=\"card-body\">\n        <p><input type=\"text\" class=\"form-control hs-filter\" [placeholder]=\"'COMMON.filter' | translateHs : data\"\n                [(ngModel)]=\"titleSearch\" (input)=\"refreshList()\"></p>\n        <span *ngIf=\"noLayerExists()\">\n            <p style=\"text-align: center\">{{'LEGEND.noLegendExists' | translateHs : {app: data.app} }}</p>\n        </span>\n        <ul class=\"list-group\">\n            <li *ngFor=\"let layer of filterDescriptors() | filter:legendFilter\" class=\"list-group-item\"\n                [hidden]=\"!hsLegendService.legendValid(layer)\"><!-- TODO: Remove function call from template -->\n                <div>\n                    {{layer.title | translateHs : {app: data.app, module: 'LAYERS'} }}\n                    <hs-legend-layer-directive [app]=\"data.app\" [layer]=\"layer\"></hs-legend-layer-directive>\n                </div>\n\n            </li>\n        </ul>\n        <div class=\"row justify-content-center\">\n            <div class=\"col col-md-2 d-flex justify-content-center\">\n                <button type=\"button\" class=\"btn btn-light btn-outline ng-scope\"\n                    [title]=\"'COMMON.reload' | translateHs : data\" (click)=\"rebuildLegends(data.app)\">\n                    <i class=\"icon-refresh\"></i>\n                </button>\n            </div>\n        </div>\n    </div>\n</div>\n", components: [{ type: HsPanelHeaderComponent, selector: "hs-panel-header", inputs: ["name", "app", "title"] }, { type: HsLegendLayerComponent, selector: "hs-legend-layer-directive", inputs: ["layer", "app"] }], directives: [{ type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "async": i3.AsyncPipe, "translateHs": TranslateCustomPipe, "filter": FilterPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLegendComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-legend', template: "<div class=\"card hs-main-panel\" [hidden]=\"(isVisible$ | async) === false\">\n    <hs-panel-header name=\"legend\" [title]=\"'PANEL_HEADER.LEGEND' | translateHs : data\" [app]=\"data.app\">\n    </hs-panel-header>\n    <div class=\"card-body\">\n        <p><input type=\"text\" class=\"form-control hs-filter\" [placeholder]=\"'COMMON.filter' | translateHs : data\"\n                [(ngModel)]=\"titleSearch\" (input)=\"refreshList()\"></p>\n        <span *ngIf=\"noLayerExists()\">\n            <p style=\"text-align: center\">{{'LEGEND.noLegendExists' | translateHs : {app: data.app} }}</p>\n        </span>\n        <ul class=\"list-group\">\n            <li *ngFor=\"let layer of filterDescriptors() | filter:legendFilter\" class=\"list-group-item\"\n                [hidden]=\"!hsLegendService.legendValid(layer)\"><!-- TODO: Remove function call from template -->\n                <div>\n                    {{layer.title | translateHs : {app: data.app, module: 'LAYERS'} }}\n                    <hs-legend-layer-directive [app]=\"data.app\" [layer]=\"layer\"></hs-legend-layer-directive>\n                </div>\n\n            </li>\n        </ul>\n        <div class=\"row justify-content-center\">\n            <div class=\"col col-md-2 d-flex justify-content-center\">\n                <button type=\"button\" class=\"btn btn-light btn-outline ng-scope\"\n                    [title]=\"'COMMON.reload' | translateHs : data\" (click)=\"rebuildLegends(data.app)\">\n                    <i class=\"icon-refresh\"></i>\n                </button>\n            </div>\n        </div>\n    </div>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: HsLegendService }, { type: HsMapService }, { type: HsLayerUtilsService }, { type: HsUtilsService }, { type: HsQueuesService }, { type: HsLayoutService }, { type: HsLanguageService }, { type: HsSidebarService }]; } });

/**
 * Original code from https://github.com/Viglino/ol-ext/blob/master/src/control/Swipe.js
 */
class SwipeControl extends Control {
    constructor(options) {
        var _a;
        const button = document.createElement('button');
        const element = document.createElement('div');
        element.className =
            ((options === null || options === void 0 ? void 0 : options.className) || 'ol-swipe') + ' ol-unselectable ol-control';
        element.appendChild(button);
        super({ element: element });
        this.options = options || {};
        element.addEventListener('mousedown', this.move.bind(this));
        element.addEventListener('touchstart', this.move.bind(this));
        // An array of listener on layer postcompose
        this.precomposeRight = this.precomposeRight.bind(this);
        this.precomposeLeft = this.precomposeLeft.bind(this);
        this.postcompose = this.postcompose.bind(this);
        this.leftLayers = [];
        this.rightLayers = [];
        if (options === null || options === void 0 ? void 0 : options.leftLayers) {
            this.addLayers(options.leftLayers);
        }
        if (options === null || options === void 0 ? void 0 : options.rightLayers) {
            this.addLayers(options.rightLayers, true);
        }
        const storagePos = localStorage.getItem(`${options.app}:hs_map_swipe_pos`);
        this.on('propertychange', () => {
            if (this.getMap()) {
                try {
                    this.getMap().renderSync();
                }
                catch (e) {
                    console.error(e);
                }
            }
            if (this.get('orientation') === 'horizontal') {
                this.element.style.top = this.get('position') * 100 + '%';
                this.element.style.left = '';
            }
            else {
                if (this.get('orientation') !== 'vertical') {
                    this.set('orientation', 'vertical');
                }
                this.element.style.left = this.get('position') * 100 + '%';
                this.element.style.top = '';
            }
            this.element.classList.remove('horizontal', 'vertical');
            this.element.classList.add(this.get('orientation'));
            localStorage.setItem(`${options.app}:hs_map_swipe_pos`, this.get('position'));
        });
        this.set('position', (_a = storagePos !== null && storagePos !== void 0 ? storagePos : options === null || options === void 0 ? void 0 : options.position) !== null && _a !== void 0 ? _a : 0.5);
        this.set('orientation', (options === null || options === void 0 ? void 0 : options.orientation) || 'vertical');
    }
    /**
     * Set the map instance the control associated with.
     * @param map - The map instance.
     */
    setTargetMap(map) {
        if (map) {
            this.setMap(map);
        }
        if (this.getMap()) {
            for (const l of this.leftLayers) {
                this.disableEvents(l);
            }
            for (const l of this.rightLayers) {
                this.disableEvents(l, true);
            }
            try {
                this.getMap().renderSync();
            }
            catch (e) {
                //console.error(e);
            }
        }
    }
    enableEvents(l, right) {
        if (right) {
            l.layer.on(['precompose', 'prerender'], this.precomposeRight);
        }
        else {
            l.layer.on(['precompose', 'prerender'], this.precomposeLeft);
        }
        l.layer.on(['postcompose', 'postrender'], this.postcompose);
    }
    disableEvents(l, right) {
        if (right) {
            l.layer.un(['precompose', 'prerender'], this.precomposeRight);
        }
        else {
            l.layer.un(['precompose', 'prerender'], this.precomposeLeft);
        }
        l.layer.un(['postcompose', 'postrender'], this.postcompose);
    }
    isLayerAdded(lyr, right) {
        const found = right
            ? this.rightLayers.find((l) => l.layer == lyr.layer)
            : this.leftLayers.find((l) => l.layer == lyr.layer);
        if (!found) {
            return -1;
        }
        else {
            const index = right
                ? this.rightLayers.indexOf(found)
                : this.leftLayers.indexOf(found);
            return index;
        }
    }
    /** Add layers array to clip
     *	@param layers - to clip
     *	@param right - layers in the right part of the map, default left.
     */
    addLayers(layers, right) {
        if (!(layers instanceof Array)) {
            layers = [layers];
        }
        for (const l of layers) {
            this.addLayer(l, right);
        }
    }
    /** Add a layer to clip
     *	@param layer - to clip
     *	@param right - layer in the right part of the map, default left.
     */
    addLayer(layer, right) {
        if (this.isLayerAdded(layer, right) < 0) {
            right ? this.rightLayers.push(layer) : this.leftLayers.push(layer);
            if (this.getMap()) {
                this.enableEvents(layer, right);
                try {
                    this.getMap().renderSync();
                }
                catch (e) {
                    console.error(e);
                }
            }
        }
    }
    /**
     * Sets available layer events to enabled/disabled
     * @param enabled - (Optional) If true, map swipe control is enabled, else it is removed
     */
    setEvents(enabled) {
        this.leftLayers.forEach((l) => {
            enabled ? this.enableEvents(l) : this.disableEvents(l);
        });
        this.rightLayers.forEach((l) => {
            enabled ? this.enableEvents(l, true) : this.disableEvents(l, true);
        });
    }
    /** Remove all layers
     */
    removeLayers() {
        this.leftLayers.forEach((l) => {
            this.removeLayer(l);
        });
        this.rightLayers.forEach((l) => {
            this.removeLayer(l, true);
        });
    }
    /** Remove a specific layer from swipe control completely
     */
    removeCompletely(layerToRm) {
        let layerFound;
        layerFound = this.leftLayers.find((l) => l.layer == layerToRm);
        if (layerFound) {
            this.removeLayer(layerFound);
        }
        else {
            layerFound = this.rightLayers.find((l) => l.layer == layerToRm);
            if (layerFound) {
                this.removeLayer(layerFound, true);
            }
        }
    }
    /** Remove a layer to clip
     *	@param layer - to clip
     *  @param right - layer from right side to clip
     */
    removeLayer(layer, right) {
        const k = this.isLayerAdded(layer, right);
        if (k > -1) {
            this.disableEvents(layer, right);
            right ? this.rightLayers.splice(k, 1) : this.leftLayers.splice(k, 1);
        }
        if (this.getMap()) {
            try {
                this.getMap().renderSync();
            }
            catch (e) {
                console.error(e);
            }
        }
    }
    move(e) {
        let l;
        switch (e.type) {
            case 'touchcancel':
            case 'touchend':
            case 'mouseup': {
                this.isMoving = false;
                [
                    'mouseup',
                    'mousemove',
                    'touchend',
                    'touchcancel',
                    'touchmove',
                ].forEach((eventName) => {
                    document.removeEventListener(eventName, this.move);
                });
                break;
            }
            case 'mousedown':
            case 'touchstart': {
                this.isMoving = true;
                [
                    'mouseup',
                    'mousemove',
                    'touchend',
                    'touchcancel',
                    'touchmove',
                ].forEach((eventName) => {
                    document.addEventListener(eventName, this.move.bind(this));
                });
            }
            // fallthrough
            case 'mousemove':
            case 'touchmove': {
                if (this.isMoving) {
                    if (this.get('orientation') === 'vertical') {
                        let pageX = e.pageX ||
                            (e.touches && e.touches.length && e.touches[0].pageX) ||
                            (e.changedTouches &&
                                e.changedTouches.length &&
                                e.changedTouches[0].pageX);
                        if (!pageX) {
                            break;
                        }
                        pageX -=
                            this.getMap().getTargetElement().getBoundingClientRect().left +
                                window.pageXOffset -
                                document.documentElement.clientLeft;
                        this.set('position', this.getPosValue(this.getMap().getSize()[0], pageX));
                        this.dispatchEvent('moving');
                    }
                    else {
                        let pageY = e.pageY ||
                            (e.touches && e.touches.length && e.touches[0].pageY) ||
                            (e.changedTouches &&
                                e.changedTouches.length &&
                                e.changedTouches[0].pageY);
                        if (!pageY) {
                            break;
                        }
                        pageY -=
                            this.getMap().getTargetElement().getBoundingClientRect().top +
                                window.pageYOffset -
                                document.documentElement.clientTop;
                        this.set('position', this.getPosValue(this.getMap().getSize()[1], pageY));
                        this.dispatchEvent('moving');
                    }
                }
                break;
            }
            default:
                break;
        }
    }
    drawRect(e, pts) {
        const tr = e.inversePixelTransform;
        if (tr) {
            const r = [
                [pts[0][0], pts[0][1]],
                [pts[0][0], pts[1][1]],
                [pts[1][0], pts[1][1]],
                [pts[1][0], pts[0][1]],
                [pts[0][0], pts[0][1]],
            ];
            r.forEach((pt, i) => {
                pt = [
                    pt[0] * tr[0] - pt[1] * tr[1] + tr[4],
                    -pt[0] * tr[2] + pt[1] * tr[3] + tr[5],
                ];
                if (!i) {
                    e.context.moveTo(pt[0], pt[1]);
                }
                else {
                    e.context.lineTo(pt[0], pt[1]);
                }
            });
        }
        else {
            const ratio = e.frameState.pixelRatio;
            e.context.rect(pts[0][0] * ratio, pts[0][1] * ratio, pts[1][0] * ratio, pts[1][1] * ratio);
        }
    }
    precomposeLeft(e) {
        const size = e.frameState.size;
        const pts = [
            [0, 0],
            [size[0], size[1]],
        ];
        if (this.get('orientation') === 'vertical') {
            pts[1] = [size[0] * this.get('position'), size[1]];
        }
        else {
            pts[1] = [size[0], size[1] * this.get('position')];
        }
        this.precompose(e, pts);
    }
    precompose(e, pts) {
        const ctx = e.context;
        ctx.save();
        ctx.beginPath();
        this.drawRect(e, pts);
        ctx.clip();
    }
    precomposeRight(e) {
        const size = e.frameState.size;
        const pts = [
            [0, 0],
            [size[0], size[1]],
        ];
        if (this.get('orientation') === 'vertical') {
            pts[0] = [size[0] * this.get('position'), 0];
        }
        else {
            pts[0] = [0, size[1] * this.get('position')];
        }
        this.precompose(e, pts);
    }
    postcompose(e) {
        // restore context when decluttering is done (ol>=6)
        // https://github.com/openlayers/openlayers/issues/10096
        if (e.target.getClassName &&
            e.target.getClassName() !== 'ol-layer' &&
            e.target.get('declutter')) {
            setTimeout(() => {
                e.context.restore();
            }, 0);
        }
        else {
            e.context.restore();
        }
    }
    /** Get the position of an element or event action relative to the map
     *	@param mapSize - OL Map size (width or height)
     *  @param coord - Coordinate provided (X or Y)
     * @returns Position relative to map size
     */
    getPosValue(mapSize, coord) {
        let l = mapSize;
        const w = l - Math.min(Math.max(0, l - coord), l);
        l = w / l;
        return l;
    }
}

var SwipeSide;
(function (SwipeSide) {
    SwipeSide["Left"] = "left";
    SwipeSide["Right"] = "right";
    SwipeSide["Full"] = "full";
})(SwipeSide || (SwipeSide = {}));
class HsMapSwipeParams {
    constructor() {
        this.rightLayers = [];
        this.leftLayers = [];
        this.entireMapLayers = [];
        this.movingSide = SwipeSide.Left;
        this.orientationVertical = true;
    }
}
class HsMapSwipeService {
    constructor(hsMapService, hsConfig, hsToastService, hsLayerShiftingService, hsEventBusService, hsLayerManagerService, hsShareUrlService, hsLayoutService) {
        this.hsMapService = hsMapService;
        this.hsConfig = hsConfig;
        this.hsToastService = hsToastService;
        this.hsLayerShiftingService = hsLayerShiftingService;
        this.hsEventBusService = hsEventBusService;
        this.hsLayerManagerService = hsLayerManagerService;
        this.hsShareUrlService = hsShareUrlService;
        this.hsLayoutService = hsLayoutService;
        this.apps = { default: new HsMapSwipeParams() };
    }
    /**
     * Initialize the map swipe service data and subscribers
     * @param app - App identifier
     */
    init(app) {
        this.apps[app] = {
            swipeCtrl: null,
            rightLayers: [],
            leftLayers: [],
            entireMapLayers: [],
            movingSide: SwipeSide.Left,
            orientationVertical: true,
            wasMoved: null,
            swipeControlActive: null,
            orientation: null,
        };
        this.setInitCtrlActive(app);
        this.setInitOri(app);
        this.hsMapService.loaded(app).then(() => {
            if (this.hsLayoutService.panelEnabled('mapSwipe', app)) {
                this.initSwipeControl(app);
            }
        });
        this.hsEventBusService.layerManagerUpdates.pipe(first()).subscribe(() => {
            if (this.hsLayoutService.panelEnabled('mapSwipe', app)) {
                this.setInitialSwipeLayers(app);
            }
        });
        this.hsEventBusService.layerManagerUpdates.subscribe(({ layer, app }) => {
            if (this.hsLayoutService.panelEnabled('mapSwipe', app)) {
                this.fillSwipeLayers(layer, app);
            }
        });
    }
    /**
     * Set initial map-swipe control state
     * @param app - App identifier
     */
    setInitCtrlActive(app) {
        var _a, _b, _c;
        const appRef = this.get(app);
        const param = this.hsShareUrlService.getParamValue('map-swipe');
        if (param) {
            switch (param) {
                case 'enabled':
                    appRef.swipeControlActive = true;
                    break;
                default:
                    appRef.swipeControlActive = false;
                    break;
            }
        }
        else {
            appRef.swipeControlActive =
                (_c = (_b = (_a = this.hsConfig) === null || _a === void 0 ? void 0 : _a.get(app).componentsEnabled) === null || _b === void 0 ? void 0 : _b.mapSwipe) !== null && _c !== void 0 ? _c : false;
        }
        this.updateUrlParam(app);
    }
    /**
     * Set initial orientation value
     * @param app - App identifier
     */
    setInitOri(app) {
        var _a, _b, _c;
        const appRef = this.get(app);
        const storageOri = localStorage.getItem(`${app}:hs_map_swipe_ori`);
        if (storageOri) {
            appRef.orientation = storageOri;
        }
        else {
            appRef.orientation =
                (_c = (_b = (_a = this.hsConfig) === null || _a === void 0 ? void 0 : _a.get(app).mapSwipeOptions) === null || _b === void 0 ? void 0 : _b.orientation) !== null && _c !== void 0 ? _c : 'vertical';
        }
        if (appRef.orientation !== 'vertical') {
            appRef.orientationVertical = false;
        }
        this.updateStorageOri(app);
    }
    /**
     * Initializes swipe control add adds it to the map
     * @param app - App identifier
     */
    initSwipeControl(app) {
        const appRef = this.get(app);
        appRef.swipeCtrl = new SwipeControl({
            orientation: appRef.orientation,
            app: app,
        });
        if (appRef.swipeControlActive) {
            appRef.swipeCtrl.setTargetMap(this.hsMapService.getMap(app));
            this.hsMapService.getMap(app).addControl(appRef.swipeCtrl);
        }
    }
    /**
     * Update local storage orientation value
     * @param app - App identifier
     */
    updateStorageOri(app) {
        localStorage.setItem(`${app}:hs_map_swipe_ori`, this.get(app).orientation);
    }
    /**
     * Update url params to include map swipe state
     * @param app - App identifier
     */
    updateUrlParam(app) {
        this.hsShareUrlService.updateCustomParams({
            'map-swipe': this.get(app).swipeControlActive ? 'enabled' : 'disabled',
        }, app);
    }
    /**
     * Check if any layers are added to the swipe control
     * @param app - App identifier
     */
    layersAvailable(app) {
        var _a, _b, _c, _d, _e;
        const appRef = this.get(app);
        if (appRef == undefined) {
            return false;
        }
        return (((_b = (_a = appRef.swipeCtrl) === null || _a === void 0 ? void 0 : _a.leftLayers) === null || _b === void 0 ? void 0 : _b.length) > 0 ||
            ((_d = (_c = appRef.swipeCtrl) === null || _c === void 0 ? void 0 : _c.rightLayers) === null || _d === void 0 ? void 0 : _d.length) > 0 ||
            ((_e = appRef.entireMapLayers) === null || _e === void 0 ? void 0 : _e.length) > 0);
    }
    /**
     * Set swipe control orientation
     * @param app - App identifier
     */
    setOrientation(app) {
        const appRef = this.get(app);
        appRef.orientationVertical = !appRef.orientationVertical;
        appRef.orientation = appRef.orientationVertical ? 'vertical' : 'horizontal';
        appRef.swipeCtrl.set('orientation', appRef.orientation);
        this.updateStorageOri(app);
    }
    /**
     * Fill swipe control layers
     * @param layer - layer issued from layerManagerUpdates event
     * @param app - App identifier
     */
    fillSwipeLayers(layer, app) {
        const appRef = this.get(app);
        this.hsLayerShiftingService.fillLayers(app);
        if (!layer) {
            return;
        }
        const layerFound = this.hsLayerShiftingService
            .get(app)
            .layersCopy.find((wrapper) => wrapper.layer == layer);
        if (layerFound !== undefined) {
            this.setLayerActive(layerFound, app);
            appRef.wasMoved
                ? this.moveSwipeLayer(layerFound, app)
                : this.addSwipeLayer(layerFound, app);
            this.checkForMissingLayers(app);
        }
        else {
            this.removeCompletely(layer, app);
        }
        this.sortLayers(app);
        appRef.wasMoved = false;
        appRef.movingSide = SwipeSide.Left;
    }
    /**
     * Move a layer to swipe control
     * @param layerItem - layer issued from layerManagerUpdates event
     * @param app - App identifier
     */
    addSwipeLayer(layerItem, app) {
        var _a;
        const appRef = this.get(app);
        if (!appRef.swipeCtrl) {
            this.initSwipeControl(app);
        }
        this.createQueryFilter(layerItem, app);
        if (!((_a = this.findLayer(layerItem.layer, app)) === null || _a === void 0 ? void 0 : _a.l)) {
            layerItem.visible = layerItem.layer.getVisible();
            if (getSwipeSide(layerItem.layer) === 'right') {
                appRef.swipeCtrl.addLayer(layerItem, true);
                appRef.rightLayers.push(layerItem);
            }
            else if (getSwipeSide(layerItem.layer) === 'left') {
                appRef.swipeCtrl.addLayer(layerItem);
                appRef.leftLayers.push(layerItem);
            }
            else {
                appRef.entireMapLayers.push(layerItem);
            }
            layerItem.layer.on('change:visible', (e) => this.layerVisibilityChanged(e, app));
        }
    }
    /**
     * Crate queryFilter callback function for layer and set it as layer's property
     * Query will work for the layer, if the user's click was made on the same map swipe panel
     * where the layer is being rendered
     * If the layer swipe side is not specified, query will work by default
     * @param layerItem - layer issued from layerManagerUpdates event
     * @param app - App identifier
     */
    createQueryFilter(layerItem, app) {
        const appRef = this.get(app);
        const existingFilter = getQueryFilter(layerItem.layer);
        const filter = (map, layer, pixel) => {
            let swipeFilter;
            const swipeSide = getSwipeSide(layer);
            if (!appRef.swipeControlActive || !swipeSide) {
                swipeFilter = true;
            }
            else {
                const clickPos = appRef.orientation == 'vertical'
                    ? appRef.swipeCtrl.getPosValue(map.getSize()[0], pixel[0])
                    : appRef.swipeCtrl.getPosValue(map.getSize()[1], pixel[1]);
                if ((clickPos <= appRef.swipeCtrl.get('position') &&
                    swipeSide == 'left') ||
                    (clickPos > appRef.swipeCtrl.get('position') && swipeSide == 'right')) {
                    swipeFilter = true;
                }
                else {
                    swipeFilter = false;
                }
            }
            if (existingFilter != undefined) {
                return existingFilter(map, layer, pixel) && swipeFilter;
            }
            else {
                return swipeFilter;
            }
        };
        setQueryFilter(layerItem.layer, filter);
    }
    /**
     * Move a layer to swipe control
     * @param lyrListItem - layer issued from layerManagerUpdates event
     * @param app - App identifier
     */
    moveSwipeLayer(lyrListItem, app) {
        const appRef = this.get(app);
        if (appRef.movingSide === SwipeSide.Right) {
            this.moveRight(lyrListItem, app);
            setSwipeSide(lyrListItem.layer, 'right');
        }
        if (appRef.movingSide === SwipeSide.Left) {
            this.moveLeft(lyrListItem, app);
            setSwipeSide(lyrListItem.layer, 'left');
        }
        if (appRef.movingSide === SwipeSide.Full) {
            setSwipeSide(lyrListItem.layer, undefined);
            appRef.swipeCtrl.removeCompletely(lyrListItem.layer);
        }
    }
    /**
     * Move a layer to swipe control right side
     * @param layer - layer issued from layerManagerUpdates event
     * @param app - App identifier
     */
    moveRight(layer, app) {
        const appRef = this.get(app);
        appRef.swipeCtrl.removeLayer(layer);
        appRef.swipeCtrl.addLayer(layer, true);
    }
    /**
     * Move a layer to swipe control left side
     * @param layer - layer issued from layerManagerUpdates event
     * @param app - App identifier
     */
    moveLeft(layer, app) {
        const appRef = this.get(app);
        appRef.swipeCtrl.removeLayer(layer, true);
        appRef.swipeCtrl.addLayer(layer);
    }
    /**
     * Set map swipe control status enabled/disabled
     * @param app - App identifier
     */
    setControl(app) {
        const appRef = this.get(app);
        appRef.swipeControlActive = !appRef.swipeControlActive;
        this.updateUrlParam(app);
        if (!this.hsMapService.getMap(app)) {
            return;
        }
        if (appRef.swipeControlActive) {
            appRef.swipeCtrl.setTargetMap(this.hsMapService.getMap(app));
            this.hsMapService.getMap(app).addControl(appRef.swipeCtrl);
            appRef.swipeCtrl.setEvents(true);
        }
        else {
            this.hsMapService.getMap(app).removeControl(appRef.swipeCtrl);
            appRef.swipeCtrl.setEvents();
        }
        try {
            this.hsMapService.getMap(app).renderSync();
        }
        catch (e) {
            console.error(e);
        }
    }
    /**
     * Remove layer completely
     * @param layer - layer issued from layerManagerUpdates event
     * @param app - App identifier
     */
    removeCompletely(layerToRm, app) {
        const appRef = this.get(app);
        const layerFound = this.findLayer(layerToRm, app);
        if (layerFound.l) {
            if (layerFound.arr === 'layers') {
                appRef.leftLayers = appRef.leftLayers.filter((l) => l.layer != layerToRm);
            }
            if (layerFound.arr === 'rightLayers') {
                appRef.rightLayers = appRef.rightLayers.filter((l) => l.layer != layerToRm);
            }
            if (layerFound.arr === 'entireMapLayers') {
                appRef.entireMapLayers = appRef.entireMapLayers.filter((l) => l.layer != layerToRm);
            }
        }
        appRef.swipeCtrl.removeCompletely(layerToRm);
    }
    /**
     * Set layer as active (last dragged)
     * @param layer - layer issued from layerManagerUpdates event
     * @param app - App identifier
     */
    setLayerActive(layer, app) {
        const appRef = this.get(app);
        const layerFound = this.findLayer(layer.layer, app);
        appRef.leftLayers.forEach((l) => (l.active = false));
        appRef.rightLayers.forEach((l) => (l.active = false));
        appRef.entireMapLayers.forEach((l) => (l.active = false));
        if (layerFound === null || layerFound === void 0 ? void 0 : layerFound.l) {
            layerFound.l.active = true;
        }
    }
    /**
     * Set and add initial swipe control layers
     * @param app - App identifier
     */
    setInitialSwipeLayers(app) {
        const appRef = this.get(app);
        const layerShiftingappRef = this.hsLayerShiftingService.get(app);
        appRef.leftLayers = [];
        appRef.rightLayers = [];
        appRef.entireMapLayers = [];
        this.hsLayerShiftingService.fillLayers(app);
        if (!layerShiftingappRef.layersCopy) {
            return;
        }
        for (const layer of layerShiftingappRef.layersCopy) {
            this.addSwipeLayer(layer, app);
        }
        this.sortLayers(app);
    }
    /**
     * Check if any layer is left out from swipe control and add it
     * @param app - App identifier
     */
    checkForMissingLayers(app) {
        const missingLayers = this.hsLayerShiftingService
            .get(app)
            .layersCopy.filter((l) => {
            var _a;
            return !((_a = this.findLayer(l.layer, app)) === null || _a === void 0 ? void 0 : _a.l);
        });
        for (const layer of missingLayers) {
            this.addSwipeLayer(layer, app);
        }
        this.sortLayers(app);
    }
    /**
     * Sort layers to resemple layer order by ZIndex on the map
     * @param app - App identifier
     */
    sortLayers(app) {
        const appRef = this.get(app);
        appRef.leftLayers = this.hsLayerManagerService.sortLayersByZ(appRef.leftLayers, app);
        appRef.rightLayers = this.hsLayerManagerService.sortLayersByZ(appRef.rightLayers, app);
        appRef.entireMapLayers = this.hsLayerManagerService.sortLayersByZ(appRef.entireMapLayers, app);
    }
    /**
     * Change layer visibility
     * @param layerItem - Layer item selected
     */
    changeLayerVisibility(layerItem) {
        layerItem.layer.setVisible(!layerItem.layer.getVisible());
        layerItem.visible = layerItem.layer.getVisible();
    }
    /**
     * Act upon layer visibility changes
     * @param e - Event description
     * @param app - App identifier
     */
    layerVisibilityChanged(e, app) {
        const found = this.findLayer(e.target, app);
        if (found.l) {
            found.l.visible = e.target.getVisible();
        }
    }
    /**
     * Find layer based on layer source
     * @param targetLayer - Layer to be found
     * @param app - App identifier
     */
    findLayer(targetLayer, app) {
        const appRef = this.get(app);
        const found = { l: null, arr: '' };
        found.l = appRef.leftLayers.find((lyr) => lyr.layer == targetLayer);
        found.arr = 'layers';
        if (!found.l) {
            found.l = appRef.rightLayers.find((lyr) => lyr.layer == targetLayer);
            found.arr = 'rightLayers';
        }
        if (!found.l) {
            found.l = appRef.entireMapLayers.find((lyr) => lyr.layer == targetLayer);
            found.arr = 'entireMapLayers';
        }
        return found;
    }
    /**
     * Get the params saved by the map swipe service for the current app
     * @param app - App identifier
     */
    get(app) {
        if (this.apps[app !== null && app !== void 0 ? app : 'default'] == undefined) {
            this.apps[app !== null && app !== void 0 ? app : 'default'] = new HsMapSwipeParams();
        }
        return this.apps[app !== null && app !== void 0 ? app : 'default'];
    }
}
HsMapSwipeService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsMapSwipeService, deps: [{ token: HsMapService }, { token: HsConfig }, { token: HsToastService }, { token: HsLayerShiftingService }, { token: HsEventBusService }, { token: HsLayerManagerService }, { token: HsShareUrlService }, { token: HsLayoutService }], target: i0.ɵɵFactoryTarget.Injectable });
HsMapSwipeService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsMapSwipeService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsMapSwipeService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsMapService }, { type: HsConfig }, { type: HsToastService }, { type: HsLayerShiftingService }, { type: HsEventBusService }, { type: HsLayerManagerService }, { type: HsShareUrlService }, { type: HsLayoutService }]; } });

class HsMapSwipeComponent extends HsPanelBaseComponent {
    constructor(hsLayoutService, hsSidebarService, hsLanguageService, hsMapSwipeService, hsLayerUtilsService, //In template
    hsLayerShiftingService) {
        super(hsLayoutService);
        this.hsLayoutService = hsLayoutService;
        this.hsSidebarService = hsSidebarService;
        this.hsLanguageService = hsLanguageService;
        this.hsMapSwipeService = hsMapSwipeService;
        this.hsLayerUtilsService = hsLayerUtilsService;
        this.hsLayerShiftingService = hsLayerShiftingService;
        this.ngUnsubscribe = new Subject();
        this.swipeSide = SwipeSide;
        this.placeholders = {
            entire: true,
            left: true,
            right: true,
        };
        this.name = 'mapSwipe';
    }
    ngOnInit() {
        this.hsSidebarService.addButton({
            panel: 'mapSwipe',
            module: 'hs.mapSwipe',
            order: 18,
            fits: true,
            title: 'PANEL_HEADER.MAP_SWIPE',
            description: 'SIDEBAR.descriptions.MAP_SWIPE',
            icon: 'icon-resizehorizontalalt',
        }, this.data.app);
        this.hsMapSwipeService.init(this.data.app);
        this.appRef = this.hsMapSwipeService.get(this.data.app);
    }
    /**
     * Return label for button changing map swipe state from enabled to disabled
     */
    getEnabledButtonString() {
        if (this.hsMapSwipeService.get(this.data.app).swipeControlActive) {
            return 'MAP_SWIPE.disableSwipe';
        }
        else {
            return 'MAP_SWIPE.enableSwipe';
        }
    }
    /**
     * Return label for button changing swipe orientation from horizontal swipe to vertical swipe
     */
    getOrientationButtonString() {
        if (this.hsMapSwipeService.get(this.data.app).orientationVertical) {
            return 'MAP_SWIPE.horizontalSwipe';
        }
        else {
            return 'MAP_SWIPE.verticalSwipe';
        }
    }
    /**
     * Reset swipe slider position to default
     */
    resetSwipePos() {
        this.hsMapSwipeService.get(this.data.app).swipeCtrl.set('position', 0.5);
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    /**
     * Modify arrays after drag and drop
     * @param event - CdkDragDrop drop event
     * @param right - (Optional) Item dragged to right
     */
    drop(event, side) {
        let draggedLayer;
        let replacedLayer;
        this.hsMapSwipeService.get(this.data.app).movingSide = side;
        this.hsMapSwipeService.get(this.data.app).wasMoved = true;
        if (event.previousContainer === event.container) {
            draggedLayer = event.container.data[event.previousIndex];
            replacedLayer = event.container.data[event.currentIndex];
            moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
        }
        else {
            draggedLayer = event.previousContainer.data[event.previousIndex];
            replacedLayer = event.container.data[event.currentIndex];
            transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
        }
        if (draggedLayer && (replacedLayer === null || replacedLayer === void 0 ? void 0 : replacedLayer.layer)) {
            this.hsLayerShiftingService.moveTo(draggedLayer, replacedLayer.layer, this.data.app);
        }
        else {
            this.hsMapSwipeService.fillSwipeLayers(draggedLayer.layer, this.data.app);
        }
    }
    /**
     * Change selected layer visibility
     * @param layer - Selected layer from the list
     */
    changeLayerVisibility(layer) {
        this.hsMapSwipeService.changeLayerVisibility(layer);
    }
    /**
     * Set map-swipe swipe element orientation
     */
    setOrientation() {
        this.hsMapSwipeService.setOrientation(this.data.app);
    }
    /**
     * Check if layers for map-swipe component are available
     */
    layersAvailable() {
        return this.hsMapSwipeService.layersAvailable(this.data.app);
    }
    /**
     * Set control for map-swipe component
     */
    setControl() {
        this.hsMapSwipeService.setControl(this.data.app);
    }
    /**
     * Get rightLayers for map-swipe component
     */
    getRightLayers() {
        return this.hsMapSwipeService.get(this.data.app).rightLayers;
    }
}
HsMapSwipeComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsMapSwipeComponent, deps: [{ token: HsLayoutService }, { token: HsSidebarService }, { token: HsLanguageService }, { token: HsMapSwipeService }, { token: HsLayerUtilsService }, { token: HsLayerShiftingService }], target: i0.ɵɵFactoryTarget.Component });
HsMapSwipeComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsMapSwipeComponent, selector: "hs-map-swipe", usesInheritance: true, ngImport: i0, template: "<!-- Layer item template -->\n<ng-template #layerItem let-layer=\"layer\">\n  <div class=\"hs-lm-item-title d-flex align-items-center\" style=\"word-break:break-all; cursor:move\">\n    <button type=\"button\" class=\"btn btn-sm hs-lm-item-visibility m-0 p-0\"\n      (click)=\"changeLayerVisibility(layer);$event.stopPropagation()\"\n      [ngClass]=\"layer.visible ? 'hs-checkmark' : 'hs-uncheckmark'\"></button>\n    <p class=\"m-0 ps-1\">{{layer.title | translateHs : {app: data.app, module: 'LAYERS'} }}</p>\n  </div>\n</ng-template>\n<!-- List placeholder template -->\n<ng-template #listPlaceholder>\n  <div class=\"p-2\" style=\"border: 1px solid #ddd; text-align: center; color: rgba(0,0,0,0.3);\">\n    {{'MAP_SWIPE.noLayers' | translateHs : {app: data.app} }}\n  </div>\n</ng-template>\n\n<div class=\"card hs-main-panel\" [hidden]=\"(isVisible$ | async) === false\">\n  <hs-panel-header name=\"mapSwipe\" [title]=\"'PANEL_HEADER.MAP_SWIPE' | translateHs : data\" [app]=\"data.app\">\n  </hs-panel-header>\n  <div class=\"card-body m-2\">\n    <div class=\"alert alert-info ps-2\" role=\"alert\">\n      {{'MAP_SWIPE.dndLayers' | translateHs : {app: data.app} }}\n    </div>\n    <div class=\"btn-group align-items-center d-flex justify-content-between\" style=\"margin-bottom: 1rem;\"\n      data-toggle=\"buttons\">\n      <button class=\"btn btn-sm btn-secondary text-truncate\" style=\"max-width: 30%;\" type=\"button\"\n        (click)=\"setOrientation()\" [disabled]=\"!appRef.swipeControlActive\">\n        {{getOrientationButtonString() | translateHs : {app: data.app} }}\n      </button>\n      <button class=\"btn btn-sm btn-secondary\" type=\"button\" (click)=\"resetSwipePos()\"\n        [disabled]=\"!appRef.swipeControlActive\">\n        {{'MAP_SWIPE.resetSlider' | translateHs : {app: data.app} }}\n      </button>\n      <button class=\"btn btn-sm btn-primary\" type=\"button\" (click)=\"setControl()\"\n        [ngClass]=\"appRef.swipeControlActive ? 'active' : ''\">\n        {{getEnabledButtonString() | translateHs : {app: data.app} }}\n      </button>\n    </div>\n    <div *ngIf=\"layersAvailable() && appRef.swipeControlActive\" class=\"pt-1\">\n      <table class=\"table table-sm table-striped table-borderless p-1\" style=\"table-layout: fixed;\">\n        <tbody>\n          <tr style=\"text-align: center;\">\n            <th colspan=\"2\">{{'MAP_SWIPE.entireMap' | translateHs : {app: data.app} }}</th>\n          </tr>\n          <tr class=\"mb-1\">\n            <td colspan=\"2\" cdkDropList #entireMapList=\"cdkDropList\" (cdkDropListExited)=\"placeholders.entire = true\"\n              (cdkDropListEntered)=\"placeholders.entire = false\" [cdkDropListConnectedTo]=\"[leftList, rightList]\"\n              [cdkDropListData]=\"appRef.entireMapLayers\" (cdkDropListDropped)=\"drop($event, swipeSide.Full)\">\n              <div class=\"list-group-item p-2\" [ngClass]=\"{'activeLayer': layer.active}\"\n                *ngFor=\"let layer of appRef.entireMapLayers\" cdkDrag>\n                <ng-container *ngTemplateOutlet=\"layerItem;context:{layer: layer}\"></ng-container>\n              </div>\n              <div *ngIf=\"appRef.entireMapLayers?.length === 0 && placeholders.entire\">\n                <ng-container *ngTemplateOutlet=\"listPlaceholder\"></ng-container>\n              </div>\n            </td>\n          </tr>\n          <tr style=\"text-align: center;\">\n            <ng-container *ngIf=\"appRef.orientation === 'vertical'; else topDownLabels\">\n              <th>{{'MAP_SWIPE.leftSide' | translateHs : {app: data.app} }}</th>\n              <th>{{'MAP_SWIPE.rightSide' | translateHs : {app: data.app} }}</th>\n            </ng-container>\n            <ng-template #topDownLabels>\n              <th>{{'MAP_SWIPE.top' | translateHs : {app: data.app} }}</th>\n              <th>{{'MAP_SWIPE.bottom' | translateHs : {app: data.app} }}</th>\n            </ng-template>\n          </tr>\n          <tr>\n            <td cdkDropList #leftList=\"cdkDropList\" [cdkDropListConnectedTo]=\"[rightList, entireMapList]\"\n              [cdkDropListData]=\"appRef.leftLayers\" (cdkDropListDropped)=\"drop($event, swipeSide.Left)\"\n              (cdkDropListExited)=\"placeholders.left = true\" (cdkDropListEntered)=\"placeholders.left = false\">\n              <div class=\"list-group-item p-2\" [ngClass]=\"{'activeLayer': layer.active}\"\n                *ngFor=\"let layer of appRef.leftLayers\" cdkDrag>\n                <ng-container *ngTemplateOutlet=\"layerItem;context:{layer: layer}\"></ng-container>\n              </div>\n              <div *ngIf=\"appRef.leftLayers?.length === 0 && placeholders.left\">\n                <ng-container *ngTemplateOutlet=\"listPlaceholder\"></ng-container>\n              </div>\n            </td>\n            <td cdkDropList #rightList=\"cdkDropList\" [cdkDropListConnectedTo]=\"[leftList, entireMapList]\"\n              [cdkDropListData]=\"appRef.rightLayers\" (cdkDropListDropped)=\"drop($event, swipeSide.Right)\"\n              (cdkDropListExited)=\"placeholders.right = true\" (cdkDropListEntered)=\"placeholders.right = false\">\n              <div class=\"list-group-item p-2\" [ngClass]=\"{'activeLayer': layer.active}\"\n                *ngFor=\"let layer of appRef.rightLayers\" cdkDrag>\n                <ng-container *ngTemplateOutlet=\"layerItem;context:{layer: layer}\"></ng-container>\n              </div>\n              <div *ngIf=\"appRef.rightLayers?.length === 0 && placeholders.right\">\n                <ng-container *ngTemplateOutlet=\"listPlaceholder\"></ng-container>\n              </div>\n            </td>\n          </tr>\n        </tbody>\n      </table>\n    </div>\n  </div>\n</div>", styles: [".activeLayer{background-color:#0003}.cdk-drag-placeholder{background-color:#0000003d;color:#fff}.cdk-drag-preview{box-sizing:border-box;background-color:#b9b9b956;border:1px solid rgb(185,185,185);overflow:hidden;color:transparent;box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.cdk-drag-preview>*{display:none}.cdk-drag-animating{transition:transform .25s cubic-bezier(0,0,.2,1)}td.cdk-drop-list{vertical-align:top}.list-group.cdk-drop-list-dragging .list-group-item:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}\n"], components: [{ type: HsPanelHeaderComponent, selector: "hs-panel-header", inputs: ["name", "app", "title"] }], directives: [{ type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i4.CdkDropList, selector: "[cdkDropList], cdk-drop-list", inputs: ["cdkDropListConnectedTo", "cdkDropListData", "cdkDropListOrientation", "id", "cdkDropListLockAxis", "cdkDropListDisabled", "cdkDropListSortingDisabled", "cdkDropListEnterPredicate", "cdkDropListSortPredicate", "cdkDropListAutoScrollDisabled", "cdkDropListAutoScrollStep"], outputs: ["cdkDropListDropped", "cdkDropListEntered", "cdkDropListExited", "cdkDropListSorted"], exportAs: ["cdkDropList"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i4.CdkDrag, selector: "[cdkDrag]", inputs: ["cdkDragData", "cdkDragLockAxis", "cdkDragRootElement", "cdkDragBoundary", "cdkDragStartDelay", "cdkDragFreeDragPosition", "cdkDragDisabled", "cdkDragConstrainPosition", "cdkDragPreviewClass", "cdkDragPreviewContainer"], outputs: ["cdkDragStarted", "cdkDragReleased", "cdkDragEnded", "cdkDragEntered", "cdkDragExited", "cdkDragDropped", "cdkDragMoved"], exportAs: ["cdkDrag"] }, { type: i3.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }], pipes: { "translateHs": TranslateCustomPipe, "async": i3.AsyncPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsMapSwipeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-map-swipe', template: "<!-- Layer item template -->\n<ng-template #layerItem let-layer=\"layer\">\n  <div class=\"hs-lm-item-title d-flex align-items-center\" style=\"word-break:break-all; cursor:move\">\n    <button type=\"button\" class=\"btn btn-sm hs-lm-item-visibility m-0 p-0\"\n      (click)=\"changeLayerVisibility(layer);$event.stopPropagation()\"\n      [ngClass]=\"layer.visible ? 'hs-checkmark' : 'hs-uncheckmark'\"></button>\n    <p class=\"m-0 ps-1\">{{layer.title | translateHs : {app: data.app, module: 'LAYERS'} }}</p>\n  </div>\n</ng-template>\n<!-- List placeholder template -->\n<ng-template #listPlaceholder>\n  <div class=\"p-2\" style=\"border: 1px solid #ddd; text-align: center; color: rgba(0,0,0,0.3);\">\n    {{'MAP_SWIPE.noLayers' | translateHs : {app: data.app} }}\n  </div>\n</ng-template>\n\n<div class=\"card hs-main-panel\" [hidden]=\"(isVisible$ | async) === false\">\n  <hs-panel-header name=\"mapSwipe\" [title]=\"'PANEL_HEADER.MAP_SWIPE' | translateHs : data\" [app]=\"data.app\">\n  </hs-panel-header>\n  <div class=\"card-body m-2\">\n    <div class=\"alert alert-info ps-2\" role=\"alert\">\n      {{'MAP_SWIPE.dndLayers' | translateHs : {app: data.app} }}\n    </div>\n    <div class=\"btn-group align-items-center d-flex justify-content-between\" style=\"margin-bottom: 1rem;\"\n      data-toggle=\"buttons\">\n      <button class=\"btn btn-sm btn-secondary text-truncate\" style=\"max-width: 30%;\" type=\"button\"\n        (click)=\"setOrientation()\" [disabled]=\"!appRef.swipeControlActive\">\n        {{getOrientationButtonString() | translateHs : {app: data.app} }}\n      </button>\n      <button class=\"btn btn-sm btn-secondary\" type=\"button\" (click)=\"resetSwipePos()\"\n        [disabled]=\"!appRef.swipeControlActive\">\n        {{'MAP_SWIPE.resetSlider' | translateHs : {app: data.app} }}\n      </button>\n      <button class=\"btn btn-sm btn-primary\" type=\"button\" (click)=\"setControl()\"\n        [ngClass]=\"appRef.swipeControlActive ? 'active' : ''\">\n        {{getEnabledButtonString() | translateHs : {app: data.app} }}\n      </button>\n    </div>\n    <div *ngIf=\"layersAvailable() && appRef.swipeControlActive\" class=\"pt-1\">\n      <table class=\"table table-sm table-striped table-borderless p-1\" style=\"table-layout: fixed;\">\n        <tbody>\n          <tr style=\"text-align: center;\">\n            <th colspan=\"2\">{{'MAP_SWIPE.entireMap' | translateHs : {app: data.app} }}</th>\n          </tr>\n          <tr class=\"mb-1\">\n            <td colspan=\"2\" cdkDropList #entireMapList=\"cdkDropList\" (cdkDropListExited)=\"placeholders.entire = true\"\n              (cdkDropListEntered)=\"placeholders.entire = false\" [cdkDropListConnectedTo]=\"[leftList, rightList]\"\n              [cdkDropListData]=\"appRef.entireMapLayers\" (cdkDropListDropped)=\"drop($event, swipeSide.Full)\">\n              <div class=\"list-group-item p-2\" [ngClass]=\"{'activeLayer': layer.active}\"\n                *ngFor=\"let layer of appRef.entireMapLayers\" cdkDrag>\n                <ng-container *ngTemplateOutlet=\"layerItem;context:{layer: layer}\"></ng-container>\n              </div>\n              <div *ngIf=\"appRef.entireMapLayers?.length === 0 && placeholders.entire\">\n                <ng-container *ngTemplateOutlet=\"listPlaceholder\"></ng-container>\n              </div>\n            </td>\n          </tr>\n          <tr style=\"text-align: center;\">\n            <ng-container *ngIf=\"appRef.orientation === 'vertical'; else topDownLabels\">\n              <th>{{'MAP_SWIPE.leftSide' | translateHs : {app: data.app} }}</th>\n              <th>{{'MAP_SWIPE.rightSide' | translateHs : {app: data.app} }}</th>\n            </ng-container>\n            <ng-template #topDownLabels>\n              <th>{{'MAP_SWIPE.top' | translateHs : {app: data.app} }}</th>\n              <th>{{'MAP_SWIPE.bottom' | translateHs : {app: data.app} }}</th>\n            </ng-template>\n          </tr>\n          <tr>\n            <td cdkDropList #leftList=\"cdkDropList\" [cdkDropListConnectedTo]=\"[rightList, entireMapList]\"\n              [cdkDropListData]=\"appRef.leftLayers\" (cdkDropListDropped)=\"drop($event, swipeSide.Left)\"\n              (cdkDropListExited)=\"placeholders.left = true\" (cdkDropListEntered)=\"placeholders.left = false\">\n              <div class=\"list-group-item p-2\" [ngClass]=\"{'activeLayer': layer.active}\"\n                *ngFor=\"let layer of appRef.leftLayers\" cdkDrag>\n                <ng-container *ngTemplateOutlet=\"layerItem;context:{layer: layer}\"></ng-container>\n              </div>\n              <div *ngIf=\"appRef.leftLayers?.length === 0 && placeholders.left\">\n                <ng-container *ngTemplateOutlet=\"listPlaceholder\"></ng-container>\n              </div>\n            </td>\n            <td cdkDropList #rightList=\"cdkDropList\" [cdkDropListConnectedTo]=\"[leftList, entireMapList]\"\n              [cdkDropListData]=\"appRef.rightLayers\" (cdkDropListDropped)=\"drop($event, swipeSide.Right)\"\n              (cdkDropListExited)=\"placeholders.right = true\" (cdkDropListEntered)=\"placeholders.right = false\">\n              <div class=\"list-group-item p-2\" [ngClass]=\"{'activeLayer': layer.active}\"\n                *ngFor=\"let layer of appRef.rightLayers\" cdkDrag>\n                <ng-container *ngTemplateOutlet=\"layerItem;context:{layer: layer}\"></ng-container>\n              </div>\n              <div *ngIf=\"appRef.rightLayers?.length === 0 && placeholders.right\">\n                <ng-container *ngTemplateOutlet=\"listPlaceholder\"></ng-container>\n              </div>\n            </td>\n          </tr>\n        </tbody>\n      </table>\n    </div>\n  </div>\n</div>", styles: [".activeLayer{background-color:#0003}.cdk-drag-placeholder{background-color:#0000003d;color:#fff}.cdk-drag-preview{box-sizing:border-box;background-color:#b9b9b956;border:1px solid rgb(185,185,185);overflow:hidden;color:transparent;box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.cdk-drag-preview>*{display:none}.cdk-drag-animating{transition:transform .25s cubic-bezier(0,0,.2,1)}td.cdk-drop-list{vertical-align:top}.list-group.cdk-drop-list-dragging .list-group-item:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}\n"] }]
        }], ctorParameters: function () { return [{ type: HsLayoutService }, { type: HsSidebarService }, { type: HsLanguageService }, { type: HsMapSwipeService }, { type: HsLayerUtilsService }, { type: HsLayerShiftingService }]; } });

class MeasureServiceParams {
    constructor() {
        this.data = {
            measurements: [],
            multipleShapeMode: false,
        };
        /**
         * sketches Array of measure sketches
         */
        this.sketches = [];
        this.measuringActivated = false;
    }
}
class HsMeasureService {
    constructor(HsMapService, HsUtilsService, HsEventBusService) {
        this.HsMapService = HsMapService;
        this.HsUtilsService = HsUtilsService;
        this.HsEventBusService = HsEventBusService;
        this.apps = { default: new MeasureServiceParams() };
    }
    /**
     * Initialize the map swipe service data and subscribers
     * @param app - App identifier
     */
    init(app) {
        this.setMeasureLayer(app);
        setTitle(this.get(app).measureVector, 'Measurement sketches');
    }
    /**
     * Get the params saved by the measure service for the current app
     * @param app - App identifier
     */
    get(app) {
        if (this.apps[app !== null && app !== void 0 ? app : 'default'] == undefined) {
            this.apps[app !== null && app !== void 0 ? app : 'default'] = new MeasureServiceParams();
        }
        return this.apps[app !== null && app !== void 0 ? app : 'default'];
    }
    /**
     * @public
     * @param mode - Optional parameter if multiple shape mode should be enabled
     * @param app - App identifier
     * Enable/disable multiple shape mode for measuring (switch without parameter)
     */
    switchMultipleMode(app, mode) {
        const appRef = this.get(app);
        if (mode !== undefined) {
            appRef.data.multipleShapeMode = mode;
        }
        else {
            appRef.data.multipleShapeMode = !appRef.data.multipleShapeMode;
        }
    }
    /**
     * Set new measure vector layer
     * @param app - App identifier
     */
    setMeasureLayer(app) {
        this.get(app).measureVector = new VectorLayer({
            source: new VectorSource(),
            style: new Style({
                fill: new Fill({
                    color: 'rgba(255, 255, 255, 0.2)',
                }),
                stroke: new Stroke({
                    color: '#ffcc33',
                    width: 2,
                }),
            }),
        });
    }
    /**
     * @public
     * @param type - Geometry type of measurement ('area' for polygon, 'line' for linestring)
     * @param app - App identifier
     * Change geometry type of measurement without deleting of old ones
     */
    changeMeasureParams(type, app) {
        const appRef = this.get(app);
        this.HsMapService.getMap(app).removeInteraction(appRef.draw);
        appRef.sketches = [];
        this.addInteraction(type, app);
    }
    /**
     * @public
     * @param app - App identifier
     * Clear all measurements and restart measuring
     */
    clearMeasurement(app) {
        const appRef = this.get(app);
        appRef.draw.setActive(false);
        appRef.data.measurements = [];
        appRef.measureVector.getSource().clear();
        appRef.sketches = [];
        appRef.draw.setActive(true);
    }
    /**
     * @public
     * @param type -
     * @param app - App identifier
     * Start measuring interaction in app
     */
    activateMeasuring(type, app) {
        const appRef = this.get(app);
        if (appRef.measuringActivated) {
            return;
        }
        const map = this.HsMapService.getMap(app);
        if (!map) {
            setTimeout(() => {
                this.activateMeasuring(type, app);
            }, 500);
            return;
        }
        map.addLayer(appRef.measureVector);
        map.getViewport().addEventListener('mousemove', (evt) => {
            this.mouseMoveHandler(evt, app);
        });
        map.getViewport().addEventListener('touchmove', (evt) => {
            this.mouseMoveHandler(evt, app);
        });
        map.getViewport().addEventListener('touchend', (evt) => {
            this.mouseMoveHandler(evt, app);
        });
        this.addInteraction(type, app);
        appRef.measuringActivated = true;
    }
    /**
     * @public
     * @param app - App identifier
     * Stop measuring interaction in app
     */
    deactivateMeasuring(app) {
        const appRef = this.get(app);
        this.HsMapService.loaded(app).then((map) => {
            map.getViewport().removeEventListener('mousemove', (evt) => {
                this.mouseMoveHandler(evt, app);
            });
            map.getViewport().removeEventListener('touchmove', (evt) => {
                this.mouseMoveHandler(evt, app);
            });
            map.getViewport().removeEventListener('touchend', (evt) => {
                this.mouseMoveHandler(evt, app);
            });
            map.removeInteraction(appRef.draw);
            map.removeLayer(appRef.measureVector);
        });
        appRef.measuringActivated = false;
        this.HsEventBusService.measurementEnds.next({ app }); //better emit drawingEnds here
    }
    /**
     * @param evt - Callback param for mouse move event
     * @param app - App identifier
     * Callback for mouse and touch move event, compute live measurement results
     */
    mouseMoveHandler(evt, app) {
        const appRef = this.get(app);
        if (appRef.sketches.length > 0) {
            let output;
            for (const sketch of appRef.sketches) {
                const geom = sketch.getGeometry();
                if (this.HsUtilsService.instOf(geom, Polygon$1)) {
                    output = this.addMultiple(this.HsUtilsService.formatArea(geom, this.HsMapService.getCurrentProj(app)), output);
                }
                else if (this.HsUtilsService.instOf(geom, LineString)) {
                    output = this.addMultiple(this.HsUtilsService.formatLength(geom, this.HsMapService.getCurrentProj(app)), output);
                }
            }
            //output.geom = this.sketch;
            setTimeout(() => {
                appRef.data.measurements[appRef.lastMeasurementId] = output;
            }, 0);
        }
    }
    /**
  
     * @param val1 - Output of new object
     * @param val2 - Old value
     * @returns
     * Adds two measure results for multiple shape mode to display joined result
     */
    addMultiple(val1, val2) {
        if (val2 == undefined) {
            return val1;
        }
        let unit = val1.unit;
        const type = val1.type;
        let value;
        if (val1.unit == val2.unit) {
            value = Math.round((val1.size + val2.size) * 100) / 100;
            if (unit == 'm' && type == 'length' && value > 1000) {
                value = Math.round((value / 1000) * 100) / 100;
                unit = 'km';
            }
            else if (unit == 'm' && type == 'area' && value > 10000) {
                value = Math.round((value / 1000000) * 100) / 100;
                unit = 'km';
            }
        }
        else {
            const arr = [val1, val2];
            for (let i = 0; i < arr.length; i++) {
                if (arr[i].unit == 'm') {
                    type == 'length' ? (arr[i].size /= 1000) : (arr[i].size /= 1000000);
                }
            }
            value = Math.round((arr[0].size + arr[1].size) * 100) / 100;
            unit = 'km';
        }
        return {
            size: value,
            type: type,
            unit: unit,
        };
    }
    /**
     * @param type - Geometry type
     * @param app - App identifier
     * Initialize draw interaction on Ol.map and event handlers for handling start and end of drawing
     */
    addInteraction(type, app) {
        const appRef = this.get(app);
        const drawType = type == 'area' ? 'Polygon' : 'LineString';
        appRef.draw = new Draw({
            source: appRef.measureVector.getSource(),
            type: /** @type {GeometryType} */ drawType,
            dragVertexDelay: 150,
        });
        this.HsMapService.getMap(app).addInteraction(appRef.draw);
        appRef.draw.on('drawstart', (evt) => {
            this.HsEventBusService.measurementStarts.next({ app });
            if (appRef.data.multipleShapeMode) {
                if (!Array.isArray(appRef.sketches)) {
                    appRef.sketches = [];
                    appRef.data.measurements.push({
                        size: 0,
                        unit: '',
                    });
                }
                appRef.sketches.push(evt.feature);
            }
            else {
                appRef.sketches = [evt.feature];
                appRef.data.measurements.push({
                    size: 0,
                    unit: '',
                });
            }
            appRef.lastMeasurementId = appRef.data.measurements.length - 1;
        });
        appRef.draw.on('drawend', (evt) => {
            this.HsEventBusService.measurementEnds.next({ app });
        });
    }
}
HsMeasureService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsMeasureService, deps: [{ token: HsMapService }, { token: HsUtilsService }, { token: HsEventBusService }], target: i0.ɵɵFactoryTarget.Injectable });
HsMeasureService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsMeasureService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsMeasureService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsMapService }, { type: HsUtilsService }, { type: HsEventBusService }]; } });

class HsMeasureComponent extends HsPanelBaseComponent {
    constructor(hsEventBusService, hsLayoutService, hsMeasureService, hsUtilsService, hsLanguageService, hsSidebarService) {
        super(hsLayoutService);
        this.hsEventBusService = hsEventBusService;
        this.hsLayoutService = hsLayoutService;
        this.hsMeasureService = hsMeasureService;
        this.hsUtilsService = hsUtilsService;
        this.hsLanguageService = hsLanguageService;
        this.hsSidebarService = hsSidebarService;
        this.name = 'measure';
        this.ngUnsubscribe = new Subject();
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    ngOnInit() {
        const app = this.data.app;
        this.hsMeasureService.init(app);
        this.appRef = this.hsMeasureService.get(this.data.app);
        this.type = 'distance';
        if (this.hsUtilsService.runningInBrowser()) {
            document.addEventListener('keyup', (e) => {
                if (e.key == 'Control') {
                    //ControlLeft
                    setTimeout(() => {
                        this.hsMeasureService.switchMultipleMode(app);
                    }, 0);
                }
            });
        }
        this.hsEventBusService.measurementStarts
            .pipe(takeUntil$1(this.ngUnsubscribe))
            .subscribe(({ app }) => {
            if (app == app) {
                this.hsLayoutService.panelEnabled('toolbar', app, false);
            }
        });
        this.hsEventBusService.measurementEnds
            .pipe(takeUntil$1(this.ngUnsubscribe))
            .subscribe(({ app }) => {
            if (app == app) {
                this.hsLayoutService.panelEnabled('toolbar', app, true);
            }
        });
        this.hsEventBusService.mainPanelChanges
            .pipe(takeUntil$1(this.ngUnsubscribe))
            .subscribe(({ which, app }) => {
            if (this.hsLayoutService.get(app).mainpanel == 'measure') {
                this.hsMeasureService.activateMeasuring(this.type, app);
            }
            else {
                this.hsMeasureService.deactivateMeasuring(app);
            }
        });
        //Temporary fix when measure panel is loaded as default (e.g. reloading page with parameters in link)
        if (this.hsLayoutService.get(app).mainpanel == 'measure') {
            this.hsMeasureService.activateMeasuring(this.type, app);
        }
        //Don't need two buttons (sidebar and toolbar) to toggle measure panel
        if (!this.hsLayoutService.componentEnabled('measureToolbar', app)) {
            this.hsSidebarService.addButton({
                panel: 'measure',
                module: 'hs.measure',
                order: 2,
                fits: true,
                title: 'PANEL_HEADER.MEASURE',
                description: 'SIDEBAR.descriptions.MEASURE',
                icon: 'icon-design',
                condition: true,
            }, app);
        }
    }
    /**
     * Change geometry type of measurement without deleting of old ones
     */
    changeMeasureParams() {
        if (this.hsLayoutService.get(this.data.app).mainpanel != 'measure') {
            return;
        }
        this.hsMeasureService.changeMeasureParams(this.type, this.data.app);
    }
    /**
     * Reset sketch and all measurements to start new drawing
     */
    clearAll() {
        this.hsMeasureService.clearMeasurement(this.data.app);
    }
}
HsMeasureComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsMeasureComponent, deps: [{ token: HsEventBusService }, { token: HsLayoutService }, { token: HsMeasureService }, { token: HsUtilsService }, { token: HsLanguageService }, { token: HsSidebarService }], target: i0.ɵɵFactoryTarget.Component });
HsMeasureComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsMeasureComponent, selector: "hs-measure", usesInheritance: true, ngImport: i0, template: "<div class=\"card hs-main-panel\" [hidden]=\"(isVisible$ | async) === false\">\n  <hs-panel-header name=\"measure\" [title]=\"'PANEL_HEADER.MEASURE' | translateHs : data\" [app]=\"data.app\">\n    <extra-title>&nbsp;<span [hidden]=\"!appRef.data.multipleShapeMode\">{{'MEASURE.multipleShapes' |\n        translateHs : {app: data.app} }}</span></extra-title>\n  </hs-panel-header>\n  <div class=\"card-body p-2\">\n    <div class=\"btn-group btn-group-toggle\" style=\"margin-bottom: 10px\">\n      <label class=\"btn btn-secondary\" [ngClass]=\"{'active': type === 'distance'}\" for=\"hs-measure-distance\">\n        {{'COMMON.distance' | translateHs : {app: data.app} }}\n        <input type=\"radio\" name=\"type\" id=\"hs-measure-distance\" value=\"distance\" [(ngModel)]=\"type\"\n          (ngModelChange)=\"changeMeasureParams()\">\n      </label>\n      <label class=\"btn btn-secondary\" [ngClass]=\"{'active': type === 'area'}\" for=\"hs-measure-area\">\n        {{'COMMON.area' | translateHs : {app: data.app} }}\n        <input type=\"radio\" name=\"type\" id=\"hs-measure-area\" value=\"area\" [(ngModel)]=\"type\"\n          (ngModelChange)=\"changeMeasureParams()\">\n      </label>\n    </div>\n    <button class=\"btn btn-secondary\" style=\"float:right\" (click)=\"clearAll()\">{{'COMMON.clear' | translateHs : data\n      }}</button>\n    <ul class=\"list-group\">\n      <li *ngFor=\"let measurement of appRef.data.measurements\" class=\"list-group-item\">\n        {{measurement?.size}}&nbsp;{{measurement?.unit}}<span *ngIf=\"measurement?.type === 'Area'\"><sup>2</sup></span>\n      </li>\n    </ul>\n  </div>\n</div>", components: [{ type: HsPanelHeaderComponent, selector: "hs-panel-header", inputs: ["name", "app", "title"] }], directives: [{ type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3$1.RadioControlValueAccessor, selector: "input[type=radio][formControlName],input[type=radio][formControl],input[type=radio][ngModel]", inputs: ["name", "formControlName", "value"] }, { type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "async": i3.AsyncPipe, "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsMeasureComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-measure', template: "<div class=\"card hs-main-panel\" [hidden]=\"(isVisible$ | async) === false\">\n  <hs-panel-header name=\"measure\" [title]=\"'PANEL_HEADER.MEASURE' | translateHs : data\" [app]=\"data.app\">\n    <extra-title>&nbsp;<span [hidden]=\"!appRef.data.multipleShapeMode\">{{'MEASURE.multipleShapes' |\n        translateHs : {app: data.app} }}</span></extra-title>\n  </hs-panel-header>\n  <div class=\"card-body p-2\">\n    <div class=\"btn-group btn-group-toggle\" style=\"margin-bottom: 10px\">\n      <label class=\"btn btn-secondary\" [ngClass]=\"{'active': type === 'distance'}\" for=\"hs-measure-distance\">\n        {{'COMMON.distance' | translateHs : {app: data.app} }}\n        <input type=\"radio\" name=\"type\" id=\"hs-measure-distance\" value=\"distance\" [(ngModel)]=\"type\"\n          (ngModelChange)=\"changeMeasureParams()\">\n      </label>\n      <label class=\"btn btn-secondary\" [ngClass]=\"{'active': type === 'area'}\" for=\"hs-measure-area\">\n        {{'COMMON.area' | translateHs : {app: data.app} }}\n        <input type=\"radio\" name=\"type\" id=\"hs-measure-area\" value=\"area\" [(ngModel)]=\"type\"\n          (ngModelChange)=\"changeMeasureParams()\">\n      </label>\n    </div>\n    <button class=\"btn btn-secondary\" style=\"float:right\" (click)=\"clearAll()\">{{'COMMON.clear' | translateHs : data\n      }}</button>\n    <ul class=\"list-group\">\n      <li *ngFor=\"let measurement of appRef.data.measurements\" class=\"list-group-item\">\n        {{measurement?.size}}&nbsp;{{measurement?.unit}}<span *ngIf=\"measurement?.type === 'Area'\"><sup>2</sup></span>\n      </li>\n    </ul>\n  </div>\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsEventBusService }, { type: HsLayoutService }, { type: HsMeasureService }, { type: HsUtilsService }, { type: HsLanguageService }, { type: HsSidebarService }]; } });

class HsMeasureToolbarComponent extends HsToolbarPanelBaseComponent {
    constructor(hsLayoutService) {
        super(hsLayoutService);
        this.hsLayoutService = hsLayoutService;
        this.name = 'measureToolbar';
    }
    isVisible() {
        return (this.hsLayoutService.panelEnabled('measure', this.data.app) &&
            this.hsLayoutService.componentEnabled('measureToolbar', this.data.app));
    }
    measureButtonClicked() {
        this.hsLayoutService.setMainPanel('measure', this.data.app, true);
    }
}
HsMeasureToolbarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsMeasureToolbarComponent, deps: [{ token: HsLayoutService }], target: i0.ɵɵFactoryTarget.Component });
HsMeasureToolbarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsMeasureToolbarComponent, selector: "hs-measure-toolbar", usesInheritance: true, ngImport: i0, template: "<div class=\"nav-item\" [hidden]=\"(isVisible$ | async) === false\">\n    <div class=\"btn-group\">\n        <button class=\"btn rounded-0 hs-toolbar-button btn-light btn-outline-secondary\" [title]=\"'TOOLBAR.measureLinesAndPolygon' | translateHs : data\" (click)=\"measureButtonClicked()\">\n            <i class=\"icon-design\"></i>\n        </button>\n    </div>\n</div>", pipes: { "async": i3.AsyncPipe, "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsMeasureToolbarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-measure-toolbar', template: "<div class=\"nav-item\" [hidden]=\"(isVisible$ | async) === false\">\n    <div class=\"btn-group\">\n        <button class=\"btn rounded-0 hs-toolbar-button btn-light btn-outline-secondary\" [title]=\"'TOOLBAR.measureLinesAndPolygon' | translateHs : data\" (click)=\"measureButtonClicked()\">\n            <i class=\"icon-design\"></i>\n        </button>\n    </div>\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsLayoutService }]; } });

class PrintLegendParams {
    constructor() {
        this.loadingExternalImages = false;
        this.cancelRequest = new Subject();
        this.subscriptions = [];
    }
}
class HsPrintLegendService {
    constructor(hsMapService, hsLegendService, hsLegendLayerStaticService, hsLayerUtilsService, hsShareThumbnailService) {
        this.hsMapService = hsMapService;
        this.hsLegendService = hsLegendService;
        this.hsLegendLayerStaticService = hsLegendLayerStaticService;
        this.hsLayerUtilsService = hsLayerUtilsService;
        this.hsShareThumbnailService = hsShareThumbnailService;
        this.apps = { default: new PrintLegendParams() };
    }
    /**
     * Initialize the print legend service data and subscribers
     * @param app - App identifier
     */
    init(app) {
        const appRef = this.get(app);
        appRef.cancelRequest.subscribe(() => {
            appRef.loadingExternalImages = false;
            for (const subs of appRef.subscriptions) {
                subs.unsubscribe();
                appRef.subscriptions.splice(appRef.subscriptions.indexOf(subs), 1);
            }
        });
    }
    /**
     * Get the params saved by the print legend service for the current app
     * @param app - App identifier
     */
    get(app) {
        if (this.apps[app !== null && app !== void 0 ? app : 'default'] == undefined) {
            this.apps[app !== null && app !== void 0 ? app : 'default'] = new PrintLegendParams();
        }
        return this.apps[app !== null && app !== void 0 ? app : 'default'];
    }
    /**
     * Convert svg to image
     * @param svgSource - Svg source
     * @param app - App identifier
     */
    svgToImage(svgSource, app) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            const obs = new Observable((subscriber) => {
                const img = new Image();
                img.onload = function () {
                    subscriber.next(img);
                    subscriber.complete();
                };
                img.onerror = function (event) {
                    subscriber.next();
                    subscriber.complete();
                };
                if ((svgSource === null || svgSource === void 0 ? void 0 : svgSource.indexOf('data')) !== 0 &&
                    img.getAttribute('crossOrigin') !== undefined) {
                    img.setAttribute('crossOrigin', 'anonymous');
                }
                img.src = svgSource;
            });
            this.get(app).subscriptions.push(obs.subscribe((img) => {
                resolve(img);
            }));
        }));
    }
    /**
     * Draw legend canvas
     * @param legendObj - Legend object
     * @param app - App identifier
     */
    drawLegendCanvas(legendObj, app) {
        return __awaiter(this, void 0, void 0, function* () {
            const appRef = this.get(app);
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            appRef.legendWidth = legendObj.width || 200; //Needs to have some default width if none is set
            const legendImages = yield this.getLegendImages(app);
            if ((legendImages === null || legendImages === void 0 ? void 0 : legendImages.length) > 0) {
                const canvasHeight = legendImages
                    .map((img) => img.height)
                    .reduce((height, img) => height + img);
                this.hsShareThumbnailService.setCanvasSize(canvas, appRef.legendWidth, canvasHeight);
                this.styleLegendCanvas(canvas, legendObj);
                yield this.fillLegendCanvas(ctx, legendImages);
                return canvas;
            }
        });
    }
    /**
     * Fill legend canvas with images
     * @param ctx - Legend canvas context
     * @param legendImages - All available legend images
     */
    fillLegendCanvas(ctx, legendImages) {
        return __awaiter(this, void 0, void 0, function* () {
            let height = 0;
            for (const img of legendImages) {
                ctx.drawImage(img, 0, height);
                height += img.height;
            }
        });
    }
    /**
     * Style legend canvas background
     * @param canvas - Legend canvas
     * @param legendObj - Legend object
     */
    styleLegendCanvas(canvas, legendObj) {
        const ctx = canvas.getContext('2d');
        ctx.fillStyle = legendObj.bcColor || 'white';
        ctx.rect(0, 0, canvas.width, canvas.height);
        ctx.fillRect(0, 0, canvas.width, canvas.height);
    }
    /**
     * Get legend images from layer legend descriptors
     * @param app - App identifier
     */
    getLegendImages(app) {
        return __awaiter(this, void 0, void 0, function* () {
            const svgSources = [];
            const images = [];
            const layers = this.hsMapService
                .getLayersArray(app)
                .filter((l) => l.getVisible());
            for (const layer of layers) {
                let svgSource;
                const desc = yield this.hsLegendService.getLayerLegendDescriptor(layer, app);
                if (desc) {
                    switch (desc.type) {
                        case 'vector':
                            svgSource = yield this.getVectorSvgSource(desc, app);
                            break;
                        case 'wms':
                            for (const sublayer of desc.subLayerLegends) {
                                const wmsSvg = yield this.legendImageToSvg(sublayer, this.hsLayerUtilsService.translateTitle(desc.title, app), app);
                                if (wmsSvg) {
                                    svgSources.push(wmsSvg);
                                }
                            }
                            break;
                        case 'static':
                            svgSource = yield this.getStaticSvgSource(desc, app);
                            break;
                        default:
                            return;
                    }
                    if (svgSource) {
                        svgSources.push(svgSource);
                    }
                }
            }
            this.get(app).loadingExternalImages = false;
            if ((svgSources === null || svgSources === void 0 ? void 0 : svgSources.length) > 0) {
                {
                    for (const source of svgSources) {
                        const image = yield this.svgToImage(source, app);
                        if (image) {
                            images.push(image);
                        }
                    }
                }
            }
            return images;
        });
    }
    /**
     * Get Vector layer legend svg source
     * @param desc - HsLegendDescriptor
     * @param app - App identifier
     */
    getVectorSvgSource(desc, app) {
        return __awaiter(this, void 0, void 0, function* () {
            let svgSource = '';
            if (!desc.svg) {
                return;
            }
            if (desc.autoLegend) {
                const legendSource = yield this.hsLegendService.getVectorLayerLegendSvg(desc.lyr);
                if (!legendSource) {
                    return;
                }
                svgSource = this.legendToSvg(legendSource, this.hsLayerUtilsService.translateTitle(desc.title, app), app);
            }
            else {
                for (const category of desc.lyr.getSource()
                    .legend_categories) {
                    svgSource = this.sparqlJsonToSvg(category, desc.title, app);
                }
            }
            return svgSource;
        });
    }
    /**
     * Get Static layer legend svg source
     * @param desc - HsLegendDescriptor
     * @param app - App identifier
     */
    getStaticSvgSource(desc, app) {
        return __awaiter(this, void 0, void 0, function* () {
            let svgSource = '';
            const layerLegend = this.hsLegendLayerStaticService.fillContent(desc.lyr);
            switch (layerLegend.legendType) {
                case 'image':
                    svgSource = yield this.legendImageToSvg(layerLegend.lastLegendImage, this.hsLayerUtilsService.translateTitle(desc.title, app), app);
                    break;
                case 'svg':
                    svgSource = this.legendToSvg(layerLegend.lastLegendImage, this.hsLayerUtilsService.translateTitle(desc.title, app), app);
                    break;
                default:
                    return;
            }
            return svgSource;
        });
    }
    /**
     * Create svg from legend source and layer title
     * @param source - Legend source
     * @param layerTitle - Layer title
     * @param app - App identifier
     */
    legendToSvg(source, layerTitle, app) {
        var _a;
        const heightRegex = /height="([0-9]+)"/;
        const height = (_a = Number(source.match(heightRegex)[1])) !== null && _a !== void 0 ? _a : 70;
        const svgSource = `<svg xmlns='http://www.w3.org/2000/svg' width='${this.get(app).legendWidth}' height='${height + 12}px'>
            <foreignObject width='100%' height='100%'>
              <div xmlns='http://www.w3.org/1999/xhtml'>
                ${layerTitle}
              </div>
            ${source.replace(/&nbsp;/g, '')}
            </foreignObject>
        </svg>`;
        const svg = 'data:image/svg+xml,' + encodeURIComponent(svgSource);
        return svg;
    }
    /**
     * Create svg from sparqlJson source and layer title
     * @param category - Category property for sparqlJson layer
     * @param layerTitle - Layer title
     * @param app - App identifier
     */
    sparqlJsonToSvg(category, layerTitle, app) {
        const svgSource = `<svg xmlns='http://www.w3.org/2000/svg' width='${this.get(app).legendWidth}' height='70px'>
            <foreignObject width='100%' height='100%'>
            <div xmlns='http://www.w3.org/1999/xhtml'>
              ${layerTitle}
              <p>
                <span style="background-color: ${category.color}" xml:space="preserve"></span>${category.name}
              </p>
            </div>
            </foreignObject>
        </svg>`;
        const svg = 'data:image/svg+xml,' + encodeURIComponent(svgSource);
        return svg;
    }
    /**
     * Create svg from image url (external source) and layer title
     * @param imageUrl - Image url
     * @param layerTitle - Layer title
     * @param app - App identifier
     */
    legendImageToSvg(imageUrl, layerTitle, app) {
        const appRef = this.get(app);
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            const obs = new Observable((subscriber) => {
                appRef.loadingExternalImages = true;
                const img = new Image();
                const width = appRef.legendWidth;
                if ((imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.indexOf('data')) !== 0 &&
                    img.getAttribute('crossOrigin') !== undefined) {
                    img.setAttribute('crossOrigin', 'anonymous');
                }
                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    this.hsShareThumbnailService.setCanvasSize(canvas, appRef.legendWidth, img.height);
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0);
                    ctx.font = '14px sans-serif';
                    const additionalHeight = Math.ceil(ctx.measureText(layerTitle).width) > width ? 40 : 20;
                    const dataURL = canvas.toDataURL('image/png');
                    const svgSource = `<svg xmlns='http://www.w3.org/2000/svg' width='${width}' height='${canvas.height + additionalHeight}'>
            <foreignObject width='100%' height='100%'>
                <div xmlns='http://www.w3.org/1999/xhtml'>
                    ${layerTitle}
                </div>
              <svg width='${width}' height='${canvas.height}'><image href="${dataURL}"></image></svg>
            </foreignObject>
        </svg>`;
                    const svg = 'data:image/svg+xml,' + encodeURIComponent(svgSource);
                    subscriber.next(svg);
                    subscriber.complete();
                };
                img.onerror = function () {
                    subscriber.next();
                    subscriber.complete();
                };
                img.src = imageUrl;
            });
            appRef.subscriptions.push(obs.subscribe((svg) => {
                resolve(svg);
            }));
        }));
    }
}
HsPrintLegendService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsPrintLegendService, deps: [{ token: HsMapService }, { token: HsLegendService }, { token: HsLegendLayerStaticService }, { token: HsLayerUtilsService }, { token: HsShareThumbnailService }], target: i0.ɵɵFactoryTarget.Injectable });
HsPrintLegendService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsPrintLegendService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsPrintLegendService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsMapService }, { type: HsLegendService }, { type: HsLegendLayerStaticService }, { type: HsLayerUtilsService }, { type: HsShareThumbnailService }]; } });

/**
 * Taken from openlayers styles
 */
const SCALE_LINE_CLASSES = `            
<style type="text/css" >
  <![CDATA[
      .ol-scale-line {
          border-radius: 4px; 
          background: rgba(0, 60, 136, 0.3); 
          padding: 2px
      }
      .ol-scale-line-inner {
          border: 1px solid #eee; 
          border-top: none; 
          color #eee; 
          font-size: 10px; 
          text-align: center; 
          margin: 1px;
      }
  ]]>
</style>`;
const SCALE_BAR_CLASSES = `            
<style type="text/css" >
  <![CDATA[
      .ol-scale-bar {
      position: absolute;
      bottom: 8px;
      left: 8px;
      }
      .ol-scale-step-marker {
        width: 1px;
        height: 15px;
        background-color: #000000;
        float: right;
        z-index: 10;
      }
      .ol-scale-step-text {
        position: absolute;
        bottom: -5px;
        font-size: 12px;
        z-index: 11;
        color: #000000;
        text-shadow: -2px 0 #FFFFFF, 0 2px #FFFFFF, 2px 0 #FFFFFF, 0 -2px #FFFFFF;
      }
      .ol-scale-text {
        position: absolute;
        font-size: 14px;
        text-align: center;
        bottom: 25px;
        color: #000000;
        text-shadow: -2px 0 #FFFFFF, 0 2px #FFFFFF, 2px 0 #FFFFFF, 0 -2px #FFFFFF;
      }
      .ol-scale-singlebar {
        position: relative;
        height: 10px;
        z-index: 9;
        box-sizing: border-box;
        border: 1px solid black;
      }
  ]]>
</style>`;

class HsPrintScaleService {
    constructor(hsMapService, hsPrintLegendService) {
        this.hsMapService = hsMapService;
        this.hsPrintLegendService = hsPrintLegendService;
        this.apps = { default: { defaultScaleLine: null } };
        this.scaleBarCSS = SCALE_BAR_CLASSES;
        this.scaleLineCSS = SCALE_LINE_CLASSES;
    }
    /**
     * Initialize the print scale service data and subscribers
     * @param app - App identifier
     */
    init(app) {
        this.hsMapService.loaded(app).then((_) => {
            this.get(app).defaultScaleLine = this.getMapScale(app);
        });
    }
    /**
     * Get the params saved by the print scale service for the current app
     * @param app - App identifier
     */
    get(app) {
        if (this.apps[app !== null && app !== void 0 ? app : 'default'] == undefined) {
            this.apps[app !== null && app !== void 0 ? app : 'default'] = { defaultScaleLine: null };
        }
        return this.apps[app !== null && app !== void 0 ? app : 'default'];
    }
    /**
     * Set original map scale if it exists
     * @param app - App identifier
     */
    setToDefaultScale(app) {
        const appRef = this.get(app);
        if (appRef.defaultScaleLine && this.hsMapService.getMap(app)) {
            this.setMapScale(appRef.defaultScaleLine, app);
        }
    }
    /**
     * Triggered when the scale type or its values have been changed by the user
     * @param scaleObj - Scale object
     * @param app - App identifier
     */
    scaleChanged(scaleObj, app) {
        this.setMapScale(this.createNewScaleControl(scaleObj), app);
    }
    /**
     * Draw canvas with scale DOM element
     * @param scaleObj - Scale object
     * @param app - App identifier
     */
    drawScaleCanvas(scaleObj, app) {
        return __awaiter(this, void 0, void 0, function* () {
            const canvas = document.createElement('canvas');
            let cssClasses;
            const type = scaleObj === null || scaleObj === void 0 ? void 0 : scaleObj.scaleType;
            const scaleElem = this.hsMapService.getScaleLineElement(type, app);
            if (!scaleElem) {
                return;
            }
            switch (type) {
                case 'scalebar':
                    cssClasses = this.scaleBarCSS;
                    canvas.height = scaleElem.clientHeight + 35; //Need to add some px because scale used absolute items outside the parent div
                    break;
                case 'scaleline':
                default:
                    cssClasses = this.scaleLineCSS;
                    canvas.height = scaleElem.clientHeight + 5;
            }
            const svgSource = this.createScaleSvgSource(type, scaleElem, cssClasses);
            yield this.drawScaleImage(canvas, svgSource, app);
            return canvas;
        });
    }
    /**
     * Create svg source from scale DOM element
     * @param type - Scale type
     * @param scaleElem - Scale element from Openlayers map DOM
     * @param cssClasses - CSS classes taken from openlayers css
     */
    createScaleSvgSource(type, scaleElem, cssClasses) {
        let width;
        let height;
        switch (type) {
            case 'scalebar':
                width = scaleElem.clientWidth + 35; //Need to add some px because scale used absolute items outside the parent div
                height = scaleElem.clientHeight + 35;
                break;
            case 'scaleline':
            default:
                width = scaleElem.clientWidth + 2;
                height = scaleElem.clientHeight;
        }
        const svgSource = `<svg xmlns='http://www.w3.org/2000/svg' width='${width}px' height='${height}px'>
            ${cssClasses}
            <foreignObject width='100%' height='100%'>
                <div style="color: #eee" xmlns='http://www.w3.org/1999/xhtml'>
                  ${scaleElem.outerHTML.replace(/&nbsp;/g, '.')}
                </div>
            </foreignObject>
        </svg>`;
        const svg = 'data:image/svg+xml,' + encodeURIComponent(svgSource);
        return svg;
    }
    /**
     * Draw scale image from svg source into a canvas
     * @param canvas - HTMLCanvasElement
     * @param svgSource - Svg source string
     * @param app - App identifier
     */
    drawScaleImage(canvas, svgSource, app) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            const ctx = canvas.getContext('2d');
            const img = yield this.hsPrintLegendService.svgToImage(svgSource, app);
            if (img) {
                ctx.drawImage(img, 0, 0);
            }
            resolve();
        }));
    }
    /**
     * Get current map scale Control
     * @param app - App identifier
     */
    getMapScale(app) {
        for (const control of this.hsMapService
            .getMap(app)
            .getControls()
            .getArray()) {
            if (control instanceof ScaleLine) {
                return control;
            }
        }
    }
    /**
     * Create new scale control for the map
     * @param scaleObj - Scale object
     */
    createNewScaleControl(scaleObj) {
        let newScaleCtrl;
        if ((scaleObj === null || scaleObj === void 0 ? void 0 : scaleObj.scaleType) === 'scalebar') {
            newScaleCtrl = new ScaleLine({
                units: scaleObj === null || scaleObj === void 0 ? void 0 : scaleObj.scaleUnits,
                bar: true,
                steps: scaleObj === null || scaleObj === void 0 ? void 0 : scaleObj.scaleBarSteps,
                text: scaleObj === null || scaleObj === void 0 ? void 0 : scaleObj.scaleBarText,
                minWidth: 140,
            });
        }
        else {
            newScaleCtrl = new ScaleLine({
                units: scaleObj === null || scaleObj === void 0 ? void 0 : scaleObj.scaleUnits,
            });
        }
        return newScaleCtrl;
    }
    /**
     * Set map scale to a new scale object
     * @param newControl - Control
     * @param app - App identifier
     */
    setMapScale(newControl, app) {
        const currentScaleControl = this.getMapScale(app);
        if (currentScaleControl) {
            this.hsMapService.getMap(app).removeControl(currentScaleControl);
        }
        this.hsMapService.getMap(app).addControl(newControl);
    }
}
HsPrintScaleService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsPrintScaleService, deps: [{ token: HsMapService }, { token: HsPrintLegendService }], target: i0.ɵɵFactoryTarget.Injectable });
HsPrintScaleService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsPrintScaleService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsPrintScaleService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsMapService }, { type: HsPrintLegendService }]; } });

class HsPrintTitleService {
    constructor() { }
    /**
     * Draw canvas with styled text
     * @param text - Text string
     * @param textStyle - Text style object
     */
    drawTitleCanvas(text, textStyle) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            this.applyTextStyles(ctx, textStyle);
            const textHeight = Number(textStyle.textSize.replace(/[^0-9]+/, ''));
            this.drawTitle(ctx, text, textStyle, textHeight);
            //Neccessary in order to measure text width and height, so that the canvas can be adjusted accordingly
            setTimeout(() => {
                canvas.width = ctx.measureText(text).width + 10;
                canvas.height = textHeight + 20;
                canvas.style.width = canvas.width + 'px';
                this.applyTextStyles(ctx, textStyle);
                this.drawTitle(ctx, text, textStyle, textHeight);
                resolve(canvas);
            }, 0);
        }));
    }
    /**
     * Draw title text inside canvas
     * @param ctx - Title canvas context
     * @param text - Text string
     * @param textStyle - Text style object
     * @param yPos - Y pixels position
     */
    drawTitle(ctx, text, textStyle, yPos) {
        if (textStyle.textDraw === 'stroke') {
            ctx.strokeText(text, 0, yPos);
        }
        else {
            ctx.fillText(text, 0, yPos);
        }
    }
    /**
     * Apply styles to title canvas context
     * @param ctx - Title canvas context
     * @param textStyle - Text style object
     */
    applyTextStyles(ctx, textStyle) {
        if (!textStyle.textSize) {
            textStyle.textSize = '30px';
        }
        if (!textStyle.fontFamily) {
            textStyle.fontFamily = 'Times New Roman';
        }
        ctx.font = textStyle.fontStyle.concat(' ', textStyle.textSize, ' ', textStyle.fontFamily);
        if (textStyle.textColor) {
            ctx.strokeStyle = textStyle.textColor;
            ctx.fillStyle = textStyle.textColor;
        }
    }
}
HsPrintTitleService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsPrintTitleService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
HsPrintTitleService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsPrintTitleService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsPrintTitleService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return []; } });

class HsPrintImprintService {
    constructor(hsPrintLegendService, hsShareThumbnailService) {
        this.hsPrintLegendService = hsPrintLegendService;
        this.hsShareThumbnailService = hsShareThumbnailService;
    }
    /**
     * Draw imprint canvas
     * @param imprintObj - Imprint object
     * @param app - App identifier
     */
    drawImprintCanvas(imprintObj, app) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            const img = yield this.hsPrintLegendService.svgToImage(this.imprintToSvg(imprintObj), app);
            if (img) {
                this.hsShareThumbnailService.setCanvasSize(canvas, img.width, img.height);
                ctx.drawImage(img, 0, 0);
            }
            resolve(canvas);
        }));
    }
    /**
     * Convert imprint styles and text to an svg
     * @param imprintObj - Imprint object
     */
    imprintToSvg(imprintObj) {
        var _a, _b;
        const styles = this.getStyles(imprintObj.textStyle);
        const height = (_a = imprintObj.height) !== null && _a !== void 0 ? _a : 50;
        const width = (_b = imprintObj.width) !== null && _b !== void 0 ? _b : 150;
        const svgSource = `<svg xmlns='http://www.w3.org/2000/svg' width='${width}px' height='${height}px'>
            <foreignObject width='100%' height='100%'>
              <div xmlns='http://www.w3.org/1999/xhtml' style="${styles}">
                <div>${imprintObj.author}</div>
                ${imprintObj.abstract}
              </div>
            </foreignObject>
        </svg>`;
        const svg = 'data:image/svg+xml,' + encodeURIComponent(svgSource);
        return svg;
    }
    /**
     * Get styles string from textStyle object for the svg
     * @param textStyle - TextStyle object
     */
    getStyles(textStyle) {
        let tmpStyle = 'padding: 5px;';
        if (textStyle.posX === 'right') {
            tmpStyle += 'text-align:end;';
        }
        else if (textStyle.posX === 'left') {
            tmpStyle += 'text-align:start;';
        }
        else {
            tmpStyle += 'text-align:center;';
        }
        if (!textStyle.textSize) {
            textStyle.textSize = '12px';
        }
        if (!textStyle.fontFamily) {
            textStyle.fontFamily = 'Times New Roman';
        }
        if (textStyle.textColor) {
            tmpStyle += `color: ${textStyle.textColor};`;
        }
        else {
            tmpStyle += `color:black;`;
        }
        if (textStyle.bcColor) {
            tmpStyle += `background-color: ${textStyle.bcColor};`;
        }
        tmpStyle += `font:${textStyle.fontStyle.concat(' ', textStyle.textSize, ' ', textStyle.fontFamily)};`;
        return tmpStyle;
    }
}
HsPrintImprintService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsPrintImprintService, deps: [{ token: HsPrintLegendService }, { token: HsShareThumbnailService }], target: i0.ɵɵFactoryTarget.Injectable });
HsPrintImprintService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsPrintImprintService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsPrintImprintService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsPrintLegendService }, { type: HsShareThumbnailService }]; } });

class HsPrintService {
    constructor(hsMapService, hsShareThumbnailService, hsPrintLegendService, hsPrintScaleService, hsPrintTitleService, hsPrintImprintService) {
        this.hsMapService = hsMapService;
        this.hsShareThumbnailService = hsShareThumbnailService;
        this.hsPrintLegendService = hsPrintLegendService;
        this.hsPrintScaleService = hsPrintScaleService;
        this.hsPrintTitleService = hsPrintTitleService;
        this.hsPrintImprintService = hsPrintImprintService;
    }
    /**
     * Print styled print layout
     * @param print - Print object
     * @param app - App identifier
     * @param complete - If true, generated image will be opened and printing interface will be created
     */
    print(print, app, complete) {
        return __awaiter(this, void 0, void 0, function* () {
            const obs = from(new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                const img = yield this.createMapImage(print, app);
                resolve(img);
            })));
            obs
                .pipe(takeUntil(this.hsPrintLegendService.get(app).cancelRequest))
                .subscribe((img) => {
                const win = window.open();
                const html = `<html><head></head><style>body{background-color:white !important;}@page { size: landscape; }</style><body><img src='${img}'/></body></html>`;
                if (!win) {
                    return;
                }
                win.document.write(html);
                setTimeout(() => {
                    if (complete) {
                        win.print();
                    }
                    //win.location.reload();
                }, 250);
            });
        });
    }
    /**
     * Download map print layout as png image
     * @param print - Print object
     * @param app - App identifier
     */
    download(print, app) {
        return __awaiter(this, void 0, void 0, function* () {
            const img = yield this.createMapImage(print, app);
            if (!document) {
                return;
            }
            const a = document.createElement('a');
            document.body.appendChild(a);
            a.setAttribute('style', 'display: none');
            a.href = img;
            a.download = 'HSL-map';
            a.click();
            window.URL.revokeObjectURL(img);
            a.remove();
        });
    }
    /**
     * Create map image with additional styled text, optional scale, legend or imprint
     * @param print - Print object
     * @param app - App identifier
     */
    createMapImage(print, app) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        return __awaiter(this, void 0, void 0, function* () {
            yield this.hsMapService.loaded(app);
            const canvases = this.hsMapService.getCanvases(app);
            const composition = document.createElement('canvas');
            const ctx = composition.getContext('2d');
            const res = [canvases[0].clientWidth, canvases[0].clientHeight];
            this.hsShareThumbnailService.setCanvasSize(composition, res[0], res[1]);
            canvases.forEach((canvas) => {
                if (canvas.clientWidth > 0 && canvas.clientHeight > 0) {
                    ctx.drawImage(canvas, 0, 0);
                }
            });
            if ((_a = print.titleObj) === null || _a === void 0 ? void 0 : _a.text) {
                const tCanvas = yield this.hsPrintTitleService.drawTitleCanvas(print.titleObj.text, print.titleObj.textStyle);
                if (tCanvas) {
                    const textPos = this.getChildPosition(composition, tCanvas, print.titleObj.textStyle.posX, (_b = print.titleObj.textStyle.posY) !== null && _b !== void 0 ? _b : 'top');
                    ctx.drawImage(tCanvas, textPos[0], textPos[1]);
                }
            }
            if ((_c = print.scaleObj) === null || _c === void 0 ? void 0 : _c.include) {
                const sCanvas = yield this.hsPrintScaleService.drawScaleCanvas(print.scaleObj, app);
                if (sCanvas) {
                    ctx.drawImage(sCanvas, 3, composition.height - sCanvas.height);
                }
            }
            if ((_d = print.legendObj) === null || _d === void 0 ? void 0 : _d.include) {
                const lCanvas = yield this.hsPrintLegendService.drawLegendCanvas(print.legendObj, app);
                if (lCanvas) {
                    const legendPos = this.getChildPosition(composition, lCanvas, (_e = print.legendObj.posX) !== null && _e !== void 0 ? _e : 'right', (_f = print.legendObj.posY) !== null && _f !== void 0 ? _f : 'bottom');
                    ctx.drawImage(lCanvas, legendPos[0], legendPos[1]);
                }
            }
            if (((_g = print.imprintObj) === null || _g === void 0 ? void 0 : _g.author) || ((_h = print.imprintObj) === null || _h === void 0 ? void 0 : _h.abstract)) {
                const iCanvas = yield this.hsPrintImprintService.drawImprintCanvas(print.imprintObj, app);
                if (iCanvas) {
                    const imprintPos = this.getChildPosition(composition, iCanvas, (_j = print.imprintObj.textStyle.posX) !== null && _j !== void 0 ? _j : 'center', (_k = print.imprintObj.textStyle.posY) !== null && _k !== void 0 ? _k : 'bottom');
                    ctx.drawImage(iCanvas, imprintPos[0], imprintPos[1]);
                }
            }
            return composition.toDataURL('image/png');
        });
    }
    /**
     * Get child canvas position relative to parent canvas
     * @param parentC - Parent HTMLCanvasElement
     * @param childC - Child HTMLCanvasElement
     * @param xPos - X pixels
     * @param yPos - Y pixels
     */
    getChildPosition(parentC, childC, xPos, yPos) {
        const pos = [0, 0];
        if (!xPos && !yPos) {
            return pos;
        }
        switch (xPos) {
            case 'right':
                pos[0] = parentC.width - childC.width;
                break;
            case 'left':
                pos[0] = 0;
                break;
            case 'center':
            default:
                pos[0] = (parentC.width - childC.width) / 2;
        }
        switch (yPos) {
            case 'middle':
                pos[1] = (parentC.height - childC.height) / 2;
                break;
            case 'bottom':
                pos[1] = parentC.height - childC.height;
                break;
            case 'top':
            default:
                pos[1] = 0;
                break;
        }
        return pos;
    }
}
HsPrintService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsPrintService, deps: [{ token: HsMapService }, { token: HsShareThumbnailService }, { token: HsPrintLegendService }, { token: HsPrintScaleService }, { token: HsPrintTitleService }, { token: HsPrintImprintService }], target: i0.ɵɵFactoryTarget.Injectable });
HsPrintService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsPrintService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsPrintService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsMapService }, { type: HsShareThumbnailService }, { type: HsPrintLegendService }, { type: HsPrintScaleService }, { type: HsPrintTitleService }, { type: HsPrintImprintService }]; } });

const POSITION_OPTIONS = {
    positionsX: ['left', 'center', 'right'],
    positionsY: ['top', 'middle', 'bottom'],
};
const CANVAS_SIZES = [50, 100, 200, 300, 400, 500, 600, 800, 1000];

const TEXT_STYLING_OPTIONS = {
    // resolutions: [
    //   '640:360',
    //   '800:600',
    //   '1024:768',
    //   '1280:720',
    //   '1280:800',
    //   '1280:1024',
    //   '1360:768',
    //   '1366:768',
    //   '1440:900',
    //   '1536:864',
    //   '1600:900',
    //   '1680:1050',
    //   '1920:1080',
    //   '1920:1200',
    //   '2048:1536',
    //   '2560:1080',
    //   '2560:1440',
    //   '3440:1440',
    //   '3840:2160',
    // ];
    fonts: [
        'Arial',
        'Verdana',
        'Sans-serif',
        'Courier New',
        'Lucida Console',
        'Monospace',
        'Times New Roman',
        'Georgia',
        'Serif',
    ],
    fontStyles: ['normal', 'italic', 'bold'],
    textDrawTypes: ['fill', 'stroke'],
    textSizes: [
        '9px',
        '10px',
        '13px',
        '16px',
        '18px',
        '24px',
        '30px',
        '32px',
        '40px',
        '46px',
        '48px',
        '72px',
    ],
};

class HsColorPickerService {
    constructor() { }
    addAlpha(color, opacity) {
        if (opacity == undefined) {
            return color;
        }
        const t = Object.assign(Object.assign({}, this.hex2Rgb(color)), { a: opacity });
        return `rgba(${t.r}, ${t.g}, ${t.b}, ${t.a})`;
    }
    hex2Rgb(aRgbHex) {
        if (!aRgbHex) {
            return { r: 0, g: 0, b: 0 };
        }
        const rgb = aRgbHex.replace('#', '').match(/.{1,2}/g);
        return {
            r: parseInt(rgb[0], 16),
            g: parseInt(rgb[1], 16),
            b: parseInt(rgb[2], 16),
        };
    }
    generateFontColor(rgbColor) {
        const [r, g, b] = rgbColor;
        const hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));
        return hsp > 127.5 ? 'black' : 'white';
    }
    colorPickerStyle(bcolor, color) {
        return {
            'background-color': bcolor,
            'color': color,
        };
    }
}
HsColorPickerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsColorPickerService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
HsColorPickerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsColorPickerService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsColorPickerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return []; } });

var ColorPickers;
(function (ColorPickers) {
    ColorPickers["Fill"] = "fill";
    ColorPickers["Background"] = "background";
})(ColorPickers || (ColorPickers = {}));
class HsPrintTextStylerComponent {
    constructor(hsColorPickerService, hsLanguageService) {
        this.hsColorPickerService = hsColorPickerService;
        this.hsLanguageService = hsLanguageService;
        this.app = 'default';
        this.fillPickerVisible = false;
        this.bcPickerVisible = false;
        this.textColor = 'white';
        this.backgroundColor = 'white';
        this.stylingOptions = TEXT_STYLING_OPTIONS;
        this.positionOptions = POSITION_OPTIONS;
    }
    /**
     * Triggered when color picker value has been selected
     * @param $event - ColorEvent
     * @param type - color picker type selected
     */
    onPick($event, type) {
        const hex = $event.color.hex;
        const hsp = this.hsColorPickerService.generateFontColor([
            $event.color.rgb.r,
            $event.color.rgb.g,
            $event.color.rgb.b,
        ]);
        switch (type) {
            case ColorPickers.Fill:
                this.textStyle.textColor = hex;
                this.textColor = hsp;
                break;
            case ColorPickers.Background:
                this.textStyle.bcColor = hex;
                this.backgroundColor = hsp;
                break;
            default:
                return;
        }
    }
    /**
     * Get color picker style values for DOM styling
     * @param type - color picker type selected
     */
    getColorPickerStyle(type) {
        switch (type) {
            case ColorPickers.Fill:
                return this.hsColorPickerService.colorPickerStyle(this.textStyle.textColor, this.textColor);
            case ColorPickers.Background:
                return this.hsColorPickerService.colorPickerStyle(this.textStyle.bcColor, this.backgroundColor);
            default:
                return;
        }
    }
    /**
     * Set color picker visibility
     * @param type - color picker type selected
     */
    setColorPickerVisible(type) {
        switch (type) {
            case ColorPickers.Fill:
                this.fillPickerVisible = !this.fillPickerVisible;
                this.bcPickerVisible = false;
                break;
            case ColorPickers.Background:
                this.bcPickerVisible = !this.bcPickerVisible;
                this.fillPickerVisible = false;
                break;
            default:
                return;
        }
    }
    /**
     * Get translation for the value string
     * @param module - Translation module
     * @param text - Text to translate
     */
    getTranslation(module, text) {
        return this.hsLanguageService.getTranslationIgnoreNonExisting(module, text, undefined, this.app);
    }
}
HsPrintTextStylerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsPrintTextStylerComponent, deps: [{ token: HsColorPickerService }, { token: HsLanguageService }], target: i0.ɵɵFactoryTarget.Component });
HsPrintTextStylerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsPrintTextStylerComponent, selector: "hs-print-text-styler", inputs: { textStyle: "textStyle", objectName: "objectName", app: "app" }, ngImport: i0, template: "<div class=\"d-flex flex-row\">\n  <div class=\"p-1 w-50 mt-1\">{{'PRINT.textColor' | translateHs : {app} }}:</div>\n  <div class=\"p-1 w-100\">\n    <input class=\"form-control form-select-sm\" (click)=\"setColorPickerVisible('fill')\"\n      [ngStyle]=\"getColorPickerStyle('fill')\" [ngModelOptions]=\"{standalone: true}\" [(ngModel)]=\"textStyle.textColor\" />\n    <color-sketch *ngIf=\"fillPickerVisible\" (onChangeComplete)=\"onPick($event, 'fill')\" width=\"320px\">\n    </color-sketch>\n  </div>\n</div>\n<div class=\"d-flex flex-row\" *ngIf=\"objectName === 'imprint'\">\n  <div class=\"p-1 w-50 mt-1\">{{'PRINT.backgroundColor' | translateHs : {app} }}:</div>\n  <div class=\"p-1 w-100\">\n    <input class=\"form-control form-select-sm\" (click)=\"setColorPickerVisible('background')\"\n      [ngStyle]=\"getColorPickerStyle('background')\" [ngModelOptions]=\"{standalone: true}\"\n      [(ngModel)]=\"textStyle.bcColor\" /><!-- TODO: Remove function call from template -->\n    <color-sketch *ngIf=\"bcPickerVisible\" (onChangeComplete)=\"onPick($event, 'background')\" width=\"320px\">\n    </color-sketch>\n  </div>\n</div>\n<div class=\"d-flex flex-row\">\n  <div class=\"p-1 w-50 mt-1\">{{'STYLER.textSize' | translateHs : {app} }}:</div>\n  <div class=\"p-1 w-100\">\n    <select class=\"form-control form-select-sm form-select\" [(ngModel)]=\"textStyle.textSize\"\n      [ngModelOptions]=\"{standalone: true}\" style=\"flex-grow: 1;\">\n      <option *ngFor=\"let size of stylingOptions.textSizes\">{{size}}\n      </option>\n    </select>\n  </div>\n</div>\n<div class=\"d-flex flex-row\">\n  <div class=\"p-1 w-50 mt-1\">{{'STYLER.font' | translateHs : {app} }}:</div>\n  <div class=\"p-1 w-100\">\n    <select class=\"form-control form-select-sm form-select\" [(ngModel)]=\"textStyle.fontFamily\"\n      [ngModelOptions]=\"{standalone: true}\">\n      <option *ngFor=\"let font of stylingOptions.fonts\">{{font}}\n      </option>\n    </select>\n  </div>\n</div>\n<div class=\"d-flex flex-row\">\n  <div class=\"p-1 w-50 mt-1\">{{'STYLER.fontStyle' | translateHs : {app} }}:</div>\n  <div class=\"p-1 w-100\">\n    <select class=\"form-control form-select-sm form-select\" [(ngModel)]=\"textStyle.fontStyle\"\n      [ngModelOptions]=\"{standalone: true}\">\n      <option [ngValue]=\"fontStyle\" *ngFor=\"let fontStyle of stylingOptions.fontStyles\">\n        {{getTranslation('PRINT',fontStyle)}}<!-- TODO: Remove function call from template -->\n      </option>\n    </select>\n  </div>\n</div>\n<div class=\"d-flex flex-row\" *ngIf=\"objectName === 'title'\">\n  <div class=\"p-1 w-50 mt-1\">{{'PRINT.textDraw' | translateHs : {app} }}:</div>\n  <div class=\"p-1 w-100\">\n    <select class=\"form-control form-select-sm form-select\" [(ngModel)]=\"textStyle.textDraw\"\n      [ngModelOptions]=\"{standalone: true}\">\n      <option [ngValue]=\"textDraw\" *ngFor=\"let textDraw of stylingOptions.textDrawTypes\">\n        {{getTranslation('COMMON',textDraw)}}<!-- TODO: Remove function call from template -->\n      </option>\n    </select>\n  </div>\n</div>\n<div class=\"d-flex flex-row\">\n  <div class=\"p-1 w-50 mt-1\">{{'PRINT.textPosition' | translateHs : {app} }} X:</div>\n  <div class=\"p-1 w-100\">\n    <select class=\"form-control form-select-sm form-select\" [(ngModel)]=\"textStyle.posX\"\n      [ngModelOptions]=\"{standalone: true}\">\n      <option [ngValue]=\"positionX\" *ngFor=\"let positionX of positionOptions.positionsX\">\n        {{getTranslation('PRINT',positionX)}}<!-- TODO: Remove function call from template -->\n      </option>\n    </select>\n  </div>\n</div>\n\n<div class=\"d-flex flex-row mb-2\">\n  <div class=\"p-1 w-50 mt-1\">{{'PRINT.textPosition' | translateHs : {app} }} Y:</div>\n  <div class=\"p-1 w-100\">\n    <select class=\"form-control form-select-sm form-select\" [(ngModel)]=\"textStyle.posY\"\n      [ngModelOptions]=\"{standalone: true}\">\n      <option [ngValue]=\"positionY\" *ngFor=\"let positionY of positionOptions.positionsY\">\n        {{getTranslation('PRINT',positionY)}}<!-- TODO: Remove function call from template -->\n      </option>\n    </select>\n  </div>\n</div>", components: [{ type: i3$2.SketchComponent, selector: "color-sketch", inputs: ["disableAlpha", "presetColors", "width"] }], directives: [{ type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3$1.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3$1.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i3$1.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsPrintTextStylerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-print-text-styler', template: "<div class=\"d-flex flex-row\">\n  <div class=\"p-1 w-50 mt-1\">{{'PRINT.textColor' | translateHs : {app} }}:</div>\n  <div class=\"p-1 w-100\">\n    <input class=\"form-control form-select-sm\" (click)=\"setColorPickerVisible('fill')\"\n      [ngStyle]=\"getColorPickerStyle('fill')\" [ngModelOptions]=\"{standalone: true}\" [(ngModel)]=\"textStyle.textColor\" />\n    <color-sketch *ngIf=\"fillPickerVisible\" (onChangeComplete)=\"onPick($event, 'fill')\" width=\"320px\">\n    </color-sketch>\n  </div>\n</div>\n<div class=\"d-flex flex-row\" *ngIf=\"objectName === 'imprint'\">\n  <div class=\"p-1 w-50 mt-1\">{{'PRINT.backgroundColor' | translateHs : {app} }}:</div>\n  <div class=\"p-1 w-100\">\n    <input class=\"form-control form-select-sm\" (click)=\"setColorPickerVisible('background')\"\n      [ngStyle]=\"getColorPickerStyle('background')\" [ngModelOptions]=\"{standalone: true}\"\n      [(ngModel)]=\"textStyle.bcColor\" /><!-- TODO: Remove function call from template -->\n    <color-sketch *ngIf=\"bcPickerVisible\" (onChangeComplete)=\"onPick($event, 'background')\" width=\"320px\">\n    </color-sketch>\n  </div>\n</div>\n<div class=\"d-flex flex-row\">\n  <div class=\"p-1 w-50 mt-1\">{{'STYLER.textSize' | translateHs : {app} }}:</div>\n  <div class=\"p-1 w-100\">\n    <select class=\"form-control form-select-sm form-select\" [(ngModel)]=\"textStyle.textSize\"\n      [ngModelOptions]=\"{standalone: true}\" style=\"flex-grow: 1;\">\n      <option *ngFor=\"let size of stylingOptions.textSizes\">{{size}}\n      </option>\n    </select>\n  </div>\n</div>\n<div class=\"d-flex flex-row\">\n  <div class=\"p-1 w-50 mt-1\">{{'STYLER.font' | translateHs : {app} }}:</div>\n  <div class=\"p-1 w-100\">\n    <select class=\"form-control form-select-sm form-select\" [(ngModel)]=\"textStyle.fontFamily\"\n      [ngModelOptions]=\"{standalone: true}\">\n      <option *ngFor=\"let font of stylingOptions.fonts\">{{font}}\n      </option>\n    </select>\n  </div>\n</div>\n<div class=\"d-flex flex-row\">\n  <div class=\"p-1 w-50 mt-1\">{{'STYLER.fontStyle' | translateHs : {app} }}:</div>\n  <div class=\"p-1 w-100\">\n    <select class=\"form-control form-select-sm form-select\" [(ngModel)]=\"textStyle.fontStyle\"\n      [ngModelOptions]=\"{standalone: true}\">\n      <option [ngValue]=\"fontStyle\" *ngFor=\"let fontStyle of stylingOptions.fontStyles\">\n        {{getTranslation('PRINT',fontStyle)}}<!-- TODO: Remove function call from template -->\n      </option>\n    </select>\n  </div>\n</div>\n<div class=\"d-flex flex-row\" *ngIf=\"objectName === 'title'\">\n  <div class=\"p-1 w-50 mt-1\">{{'PRINT.textDraw' | translateHs : {app} }}:</div>\n  <div class=\"p-1 w-100\">\n    <select class=\"form-control form-select-sm form-select\" [(ngModel)]=\"textStyle.textDraw\"\n      [ngModelOptions]=\"{standalone: true}\">\n      <option [ngValue]=\"textDraw\" *ngFor=\"let textDraw of stylingOptions.textDrawTypes\">\n        {{getTranslation('COMMON',textDraw)}}<!-- TODO: Remove function call from template -->\n      </option>\n    </select>\n  </div>\n</div>\n<div class=\"d-flex flex-row\">\n  <div class=\"p-1 w-50 mt-1\">{{'PRINT.textPosition' | translateHs : {app} }} X:</div>\n  <div class=\"p-1 w-100\">\n    <select class=\"form-control form-select-sm form-select\" [(ngModel)]=\"textStyle.posX\"\n      [ngModelOptions]=\"{standalone: true}\">\n      <option [ngValue]=\"positionX\" *ngFor=\"let positionX of positionOptions.positionsX\">\n        {{getTranslation('PRINT',positionX)}}<!-- TODO: Remove function call from template -->\n      </option>\n    </select>\n  </div>\n</div>\n\n<div class=\"d-flex flex-row mb-2\">\n  <div class=\"p-1 w-50 mt-1\">{{'PRINT.textPosition' | translateHs : {app} }} Y:</div>\n  <div class=\"p-1 w-100\">\n    <select class=\"form-control form-select-sm form-select\" [(ngModel)]=\"textStyle.posY\"\n      [ngModelOptions]=\"{standalone: true}\">\n      <option [ngValue]=\"positionY\" *ngFor=\"let positionY of positionOptions.positionsY\">\n        {{getTranslation('PRINT',positionY)}}<!-- TODO: Remove function call from template -->\n      </option>\n    </select>\n  </div>\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsColorPickerService }, { type: HsLanguageService }]; }, propDecorators: { textStyle: [{
                type: Input
            }], objectName: [{
                type: Input
            }], app: [{
                type: Input
            }] } });

class HsPrintLegendStylerComponent {
    constructor(hsLanguageService, hsColorPickerService) {
        this.hsLanguageService = hsLanguageService;
        this.hsColorPickerService = hsColorPickerService;
        this.fillPickerVisible = false;
        this.positionOptions = POSITION_OPTIONS;
        this.legendWidths = CANVAS_SIZES;
        this.app = 'default';
    }
    /**
     * Triggered when color picker value has been selected
     * @param $event - ColorEvent
     */
    onPick($event) {
        const hex = $event.color.hex;
        const hsp = this.hsColorPickerService.generateFontColor([
            $event.color.rgb.r,
            $event.color.rgb.g,
            $event.color.rgb.b,
        ]);
        this.legendObj.bcColor = hex;
        this.bcColor = hsp;
    }
    /**
     * Get color picker style values for DOM styling
     */
    getColorPickerStyle() {
        return this.hsColorPickerService.colorPickerStyle(this.legendObj.bcColor, this.bcColor);
    }
    /**
     * Get translation for the value string
     * @param module - Translation module
     * @param text - Text to translate
     */
    getTranslation(module, text) {
        return this.hsLanguageService.getTranslationIgnoreNonExisting(module, text, undefined, this.app);
    }
}
HsPrintLegendStylerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsPrintLegendStylerComponent, deps: [{ token: HsLanguageService }, { token: HsColorPickerService }], target: i0.ɵɵFactoryTarget.Component });
HsPrintLegendStylerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsPrintLegendStylerComponent, selector: "hs-print-legend-styler", inputs: { legendObj: "legendObj", app: "app" }, ngImport: i0, template: "<div class=\"d-flex flex-row\">\n  <div class=\"p-1 w-50 mt-1\">{{'PRINT.backgroundColor' | translateHs : {app} }}:</div>\n  <div class=\"p-1 w-100\">\n    <input class=\"form-control form-select-sm\" (click)=\"fillPickerVisible = !fillPickerVisible\"\n      [ngStyle]=\"getColorPickerStyle()\" [ngModelOptions]=\"{standalone: true}\" [(ngModel)]=\"legendObj.bcColor\" />\n    <color-sketch *ngIf=\"fillPickerVisible\" (onChangeComplete)=\"onPick($event)\" width=\"320px\">\n    </color-sketch>\n  </div>\n</div>\n<div class=\"d-flex flex-row\">\n  <div class=\"p-1 w-50 mt-1\">{{'COMMON.width' | translateHs : {app} }}</div>\n  <div class=\"p-1 w-100\">\n    <select class=\"form-control form-select-sm form-select\" [(ngModel)]=\"legendObj.width\"\n      [ngModelOptions]=\"{standalone: true}\">\n      <option [ngValue]=\"width\" *ngFor=\"let width of legendWidths\">\n        {{width}}px\n      </option>\n    </select>\n  </div>\n</div>\n<div class=\"d-flex flex-row\">\n  <div class=\"p-1 w-50 mt-1\">{{'PRINT.textPosition' | translateHs : {app} }} X:</div>\n  <div class=\"p-1 w-100\">\n    <select class=\"form-control form-select-sm form-select\" [(ngModel)]=\"legendObj.posX\"\n      [ngModelOptions]=\"{standalone: true}\">\n      <option [ngValue]=\"positionX\" *ngFor=\"let positionX of positionOptions.positionsX\">\n        {{getTranslation('PRINT',positionX)}}<!-- TODO: Remove function call from template -->\n      </option>\n    </select>\n  </div>\n</div>\n<div class=\"d-flex flex-row mb-2\">\n  <div class=\"p-1 w-50 mt-1\">{{'PRINT.textPosition' | translateHs : {app} }} Y:</div>\n  <div class=\"p-1 w-100\">\n    <select class=\"form-control form-select-sm form-select\" [(ngModel)]=\"legendObj.posY\"\n      [ngModelOptions]=\"{standalone: true}\">\n      <option [ngValue]=\"positionY\" *ngFor=\"let positionY of positionOptions.positionsY\">\n        {{getTranslation('PRINT',positionY)}}<!-- TODO: Remove function call from template -->\n      </option>\n    </select>\n  </div>\n</div>", components: [{ type: i3$2.SketchComponent, selector: "color-sketch", inputs: ["disableAlpha", "presetColors", "width"] }], directives: [{ type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3$1.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3$1.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i3$1.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsPrintLegendStylerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-print-legend-styler', template: "<div class=\"d-flex flex-row\">\n  <div class=\"p-1 w-50 mt-1\">{{'PRINT.backgroundColor' | translateHs : {app} }}:</div>\n  <div class=\"p-1 w-100\">\n    <input class=\"form-control form-select-sm\" (click)=\"fillPickerVisible = !fillPickerVisible\"\n      [ngStyle]=\"getColorPickerStyle()\" [ngModelOptions]=\"{standalone: true}\" [(ngModel)]=\"legendObj.bcColor\" />\n    <color-sketch *ngIf=\"fillPickerVisible\" (onChangeComplete)=\"onPick($event)\" width=\"320px\">\n    </color-sketch>\n  </div>\n</div>\n<div class=\"d-flex flex-row\">\n  <div class=\"p-1 w-50 mt-1\">{{'COMMON.width' | translateHs : {app} }}</div>\n  <div class=\"p-1 w-100\">\n    <select class=\"form-control form-select-sm form-select\" [(ngModel)]=\"legendObj.width\"\n      [ngModelOptions]=\"{standalone: true}\">\n      <option [ngValue]=\"width\" *ngFor=\"let width of legendWidths\">\n        {{width}}px\n      </option>\n    </select>\n  </div>\n</div>\n<div class=\"d-flex flex-row\">\n  <div class=\"p-1 w-50 mt-1\">{{'PRINT.textPosition' | translateHs : {app} }} X:</div>\n  <div class=\"p-1 w-100\">\n    <select class=\"form-control form-select-sm form-select\" [(ngModel)]=\"legendObj.posX\"\n      [ngModelOptions]=\"{standalone: true}\">\n      <option [ngValue]=\"positionX\" *ngFor=\"let positionX of positionOptions.positionsX\">\n        {{getTranslation('PRINT',positionX)}}<!-- TODO: Remove function call from template -->\n      </option>\n    </select>\n  </div>\n</div>\n<div class=\"d-flex flex-row mb-2\">\n  <div class=\"p-1 w-50 mt-1\">{{'PRINT.textPosition' | translateHs : {app} }} Y:</div>\n  <div class=\"p-1 w-100\">\n    <select class=\"form-control form-select-sm form-select\" [(ngModel)]=\"legendObj.posY\"\n      [ngModelOptions]=\"{standalone: true}\">\n      <option [ngValue]=\"positionY\" *ngFor=\"let positionY of positionOptions.positionsY\">\n        {{getTranslation('PRINT',positionY)}}<!-- TODO: Remove function call from template -->\n      </option>\n    </select>\n  </div>\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsLanguageService }, { type: HsColorPickerService }]; }, propDecorators: { legendObj: [{
                type: Input
            }], app: [{
                type: Input
            }] } });

class HsPrintImprintStylerComponent {
    constructor() {
        this.app = 'default';
        this.sizes = CANVAS_SIZES;
    }
}
HsPrintImprintStylerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsPrintImprintStylerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
HsPrintImprintStylerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsPrintImprintStylerComponent, selector: "hs-print-imprint-styler", inputs: { imprintObj: "imprintObj", app: "app" }, ngImport: i0, template: "<div class=\"form-floating mb-2\">\n  <input type=\"text\" class=\"form-control\" id=\"imprint-author\" [(ngModel)]=\"imprintObj.author\"\n    placeholder=\"'COMMON.author' | translateHs : {app} \" />\n  <label for=\"imprint-author\" class=\"control-label\">{{'COMMON.author' | translateHs : {app} }}</label>\n</div>\n<div class=\"form-floating mb-2\">\n  <textarea class=\"form-control\" id='imprint-abstract' [placeholder]=\"'COMMON.fillInDescriptive' | translateHs : {app} \"\n    name=\"imprint-abstract\" [(ngModel)]=\"imprintObj.abstract\">\n                              </textarea>\n  <label for=\"imprint-abstract\" class=\"control-label\">{{'COMMON.abstract' | translateHs : {app} }}</label>\n</div>\n<div class=\"d-flex flex-row\">\n  <div class=\"p-1 w-50 mt-1\">{{'COMMON.width' | translateHs : {app} }}</div>\n  <div class=\"p-1 w-100\">\n    <select class=\"form-control form-select-sm form-select\" [(ngModel)]=\"imprintObj.width\"\n      [ngModelOptions]=\"{standalone: true}\">\n      <option [ngValue]=\"width\" *ngFor=\"let width of sizes\">\n        {{width}}px\n      </option>\n    </select>\n  </div>\n</div>\n<div class=\"d-flex flex-row\">\n  <div class=\"p-1 w-50 mt-1\">{{'COMMON.height' | translateHs : {app} }}</div>\n  <div class=\"p-1 w-100\">\n    <select class=\"form-control form-select-sm form-select\" [(ngModel)]=\"imprintObj.height\"\n      [ngModelOptions]=\"{standalone: true}\">\n      <option [ngValue]=\"height\" *ngFor=\"let height of sizes\">\n        {{height}}px\n      </option>\n    </select>\n  </div>\n</div>\n<hs-print-text-styler [textStyle]=\"imprintObj.textStyle\" [app]=\"app\" [objectName]=\"'imprint'\"></hs-print-text-styler>", components: [{ type: HsPrintTextStylerComponent, selector: "hs-print-text-styler", inputs: ["textStyle", "objectName", "app"] }], directives: [{ type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3$1.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3$1.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i3$1.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsPrintImprintStylerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-print-imprint-styler', template: "<div class=\"form-floating mb-2\">\n  <input type=\"text\" class=\"form-control\" id=\"imprint-author\" [(ngModel)]=\"imprintObj.author\"\n    placeholder=\"'COMMON.author' | translateHs : {app} \" />\n  <label for=\"imprint-author\" class=\"control-label\">{{'COMMON.author' | translateHs : {app} }}</label>\n</div>\n<div class=\"form-floating mb-2\">\n  <textarea class=\"form-control\" id='imprint-abstract' [placeholder]=\"'COMMON.fillInDescriptive' | translateHs : {app} \"\n    name=\"imprint-abstract\" [(ngModel)]=\"imprintObj.abstract\">\n                              </textarea>\n  <label for=\"imprint-abstract\" class=\"control-label\">{{'COMMON.abstract' | translateHs : {app} }}</label>\n</div>\n<div class=\"d-flex flex-row\">\n  <div class=\"p-1 w-50 mt-1\">{{'COMMON.width' | translateHs : {app} }}</div>\n  <div class=\"p-1 w-100\">\n    <select class=\"form-control form-select-sm form-select\" [(ngModel)]=\"imprintObj.width\"\n      [ngModelOptions]=\"{standalone: true}\">\n      <option [ngValue]=\"width\" *ngFor=\"let width of sizes\">\n        {{width}}px\n      </option>\n    </select>\n  </div>\n</div>\n<div class=\"d-flex flex-row\">\n  <div class=\"p-1 w-50 mt-1\">{{'COMMON.height' | translateHs : {app} }}</div>\n  <div class=\"p-1 w-100\">\n    <select class=\"form-control form-select-sm form-select\" [(ngModel)]=\"imprintObj.height\"\n      [ngModelOptions]=\"{standalone: true}\">\n      <option [ngValue]=\"height\" *ngFor=\"let height of sizes\">\n        {{height}}px\n      </option>\n    </select>\n  </div>\n</div>\n<hs-print-text-styler [textStyle]=\"imprintObj.textStyle\" [app]=\"app\" [objectName]=\"'imprint'\"></hs-print-text-styler>" }]
        }], ctorParameters: function () { return []; }, propDecorators: { imprintObj: [{
                type: Input
            }], app: [{
                type: Input
            }] } });

const SCALE_STYLING_OPTIONS = {
    scaleType: ['scaleline', 'scalebar'],
    scaleUnits: [
        { name: 'degrees', value: 'degrees' },
        { name: 'us inch', value: 'us' },
        { name: 'nautical mile', value: 'nautical' },
        { name: 'metric', value: 'metric' },
    ],
    scaleBarSteps: [2, 4, 6, 8],
};

class HsPrintScaleStylerComponent {
    constructor(hsPrintScaleService, hsLanguageService) {
        this.hsPrintScaleService = hsPrintScaleService;
        this.hsLanguageService = hsLanguageService;
        this.app = 'default';
        this.stylingOptions = SCALE_STYLING_OPTIONS;
    }
    /**
     * Triggered when scale object values have been changed
     */
    scaleObjChanged() {
        this.hsPrintScaleService.scaleChanged(this.scaleObj, this.app);
    }
    /**
     * Get translation for the value string
     * @param module - Translation module
     * @param text - Text to translate
     */
    getTranslation(module, text) {
        return this.hsLanguageService.getTranslationIgnoreNonExisting(module, text, undefined, this.app);
    }
}
HsPrintScaleStylerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsPrintScaleStylerComponent, deps: [{ token: HsPrintScaleService }, { token: HsLanguageService }], target: i0.ɵɵFactoryTarget.Component });
HsPrintScaleStylerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsPrintScaleStylerComponent, selector: "hs-print-scale-styler", inputs: { scaleObj: "scaleObj", app: "app" }, ngImport: i0, template: "<div class=\"d-flex flex-row\">\n  <div class=\"p-1 w-50 mt-1\">{{'PRINT.scaleType' | translateHs : {app} }}:</div>\n  <div class=\"p-1 w-100\">\n    <select class=\"form-control form-select-sm form-select\" [(ngModel)]=\"scaleObj.scaleType\"\n      [ngModelOptions]=\"{standalone: true}\" style=\"flex-grow: 1;\" (ngModelChange)=\"scaleObjChanged()\">\n      <option [ngValue]=\"scaleType\" *ngFor=\"let scaleType of stylingOptions.scaleType\">\n        {{getTranslation('PRINT',scaleType)}}<!-- TODO: Remove function call from template -->\n      </option>\n    </select>\n  </div>\n</div>\n<div class=\"d-flex flex-row\" *ngIf=\"scaleObj.scaleType === 'scalebar'\">\n  <div class=\"p-1 w-50 mt-1\">{{'PRINT.scaleBarText' | translateHs : {app} }}:</div>\n  <div class=\"p-1 w-100\">\n    <input type=\"checkbox\" class=\"form-check-input\" [(ngModel)]=\"scaleObj.scaleBarText\" (ngModelChange)=\"scaleObjChanged()\" />\n  </div>\n</div>\n<div class=\"d-flex flex-row\">\n  <div class=\"p-1 w-50 mt-1\">{{'PRINT.scaleUnits' | translateHs : {app} }}:</div>\n  <div class=\"p-1 w-100\">\n    <select class=\"form-control form-select-sm form-select\" [(ngModel)]=\"scaleObj.scaleUnits\"\n      (ngModelChange)=\"scaleObjChanged()\" [ngModelOptions]=\"{standalone: true}\" style=\"flex-grow: 1;\">\n      <option [ngValue]=\"scaleUnits.value\" *ngFor=\"let scaleUnits of stylingOptions.scaleUnits\">\n        {{getTranslation('PRINT',scaleUnits.name)}}<!-- TODO: Remove function call from template -->\n      </option>\n    </select>\n  </div>\n</div>\n<div class=\"d-flex flex-row\" *ngIf=\"scaleObj.scaleType === 'scalebar'\">\n  <div class=\"p-1 w-50 mt-1\">{{'PRINT.scaleSteps' | translateHs : {app} }}:</div>\n  <div class=\"p-1 w-100\">\n    <select class=\"form-control form-select-sm form-select\" [(ngModel)]=\"scaleObj.scaleBarSteps\"\n      (ngModelChange)=\"scaleObjChanged()\" [ngModelOptions]=\"{standalone: true}\" style=\"flex-grow: 1;\">\n      <option [ngValue]=\"scaleBarSteps\" *ngFor=\"let scaleBarSteps of stylingOptions.scaleBarSteps\">{{scaleBarSteps}}\n        {{'COMMON.steps' |\n        translateHs : {app} }}\n      </option>\n    </select>\n  </div>\n</div>\n", directives: [{ type: i3$1.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3$1.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i3$1.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3$1.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsPrintScaleStylerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-print-scale-styler', template: "<div class=\"d-flex flex-row\">\n  <div class=\"p-1 w-50 mt-1\">{{'PRINT.scaleType' | translateHs : {app} }}:</div>\n  <div class=\"p-1 w-100\">\n    <select class=\"form-control form-select-sm form-select\" [(ngModel)]=\"scaleObj.scaleType\"\n      [ngModelOptions]=\"{standalone: true}\" style=\"flex-grow: 1;\" (ngModelChange)=\"scaleObjChanged()\">\n      <option [ngValue]=\"scaleType\" *ngFor=\"let scaleType of stylingOptions.scaleType\">\n        {{getTranslation('PRINT',scaleType)}}<!-- TODO: Remove function call from template -->\n      </option>\n    </select>\n  </div>\n</div>\n<div class=\"d-flex flex-row\" *ngIf=\"scaleObj.scaleType === 'scalebar'\">\n  <div class=\"p-1 w-50 mt-1\">{{'PRINT.scaleBarText' | translateHs : {app} }}:</div>\n  <div class=\"p-1 w-100\">\n    <input type=\"checkbox\" class=\"form-check-input\" [(ngModel)]=\"scaleObj.scaleBarText\" (ngModelChange)=\"scaleObjChanged()\" />\n  </div>\n</div>\n<div class=\"d-flex flex-row\">\n  <div class=\"p-1 w-50 mt-1\">{{'PRINT.scaleUnits' | translateHs : {app} }}:</div>\n  <div class=\"p-1 w-100\">\n    <select class=\"form-control form-select-sm form-select\" [(ngModel)]=\"scaleObj.scaleUnits\"\n      (ngModelChange)=\"scaleObjChanged()\" [ngModelOptions]=\"{standalone: true}\" style=\"flex-grow: 1;\">\n      <option [ngValue]=\"scaleUnits.value\" *ngFor=\"let scaleUnits of stylingOptions.scaleUnits\">\n        {{getTranslation('PRINT',scaleUnits.name)}}<!-- TODO: Remove function call from template -->\n      </option>\n    </select>\n  </div>\n</div>\n<div class=\"d-flex flex-row\" *ngIf=\"scaleObj.scaleType === 'scalebar'\">\n  <div class=\"p-1 w-50 mt-1\">{{'PRINT.scaleSteps' | translateHs : {app} }}:</div>\n  <div class=\"p-1 w-100\">\n    <select class=\"form-control form-select-sm form-select\" [(ngModel)]=\"scaleObj.scaleBarSteps\"\n      (ngModelChange)=\"scaleObjChanged()\" [ngModelOptions]=\"{standalone: true}\" style=\"flex-grow: 1;\">\n      <option [ngValue]=\"scaleBarSteps\" *ngFor=\"let scaleBarSteps of stylingOptions.scaleBarSteps\">{{scaleBarSteps}}\n        {{'COMMON.steps' |\n        translateHs : {app} }}\n      </option>\n    </select>\n  </div>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: HsPrintScaleService }, { type: HsLanguageService }]; }, propDecorators: { scaleObj: [{
                type: Input
            }], app: [{
                type: Input
            }] } });

class HsPrintComponent extends HsPanelBaseComponent {
    constructor(HsLayoutService, hsConfig, hsSidebarService, hsUtilsService, hsPrintService, hsPrintScaleService, hsPrintLegendService) {
        super(HsLayoutService);
        this.hsConfig = hsConfig;
        this.hsSidebarService = hsSidebarService;
        this.hsUtilsService = hsUtilsService;
        this.hsPrintService = hsPrintService;
        this.hsPrintScaleService = hsPrintScaleService;
        this.hsPrintLegendService = hsPrintLegendService;
        this.name = 'print';
        this.stylers = [
            { name: 'title', visible: false },
            { name: 'legend', visible: false },
            { name: 'imprint', visible: false },
            { name: 'scale', visible: false },
        ];
    }
    ngOnInit() {
        this.hsSidebarService.addButton({
            panel: 'print',
            module: 'hs.print',
            order: 10,
            fits: true,
            title: 'PANEL_HEADER.PRINT',
            description: 'SIDEBAR.descriptions.PRINT',
            icon: 'icon-print',
        }, this.data.app);
        this.configRef = this.hsConfig.get(this.data.app);
        this.hsPrintScaleService.init(this.data.app);
        this.hsPrintLegendService.init(this.data.app);
        this.setToDefault();
    }
    /**
     * Set print object to default values
     */
    setToDefault() {
        this.print = {
            titleObj: {
                text: '',
                textStyle: {
                    textColor: '',
                    textSize: '',
                    fontFamily: '',
                    fontStyle: '',
                    textDraw: null,
                    posX: null,
                    posY: null,
                },
            },
            scaleObj: {
                include: false,
                scaleType: null,
                scaleBarText: null,
                scaleBarSteps: null,
                scaleUnits: null,
            },
            legendObj: {
                include: false,
                width: null,
                bcColor: '',
                posX: null,
                posY: null,
            },
            imprintObj: {
                include: false,
                author: '',
                abstract: '',
                width: null,
                height: null,
                textStyle: {
                    textColor: '',
                    bcColor: '',
                    textSize: '',
                    fontFamily: '',
                    fontStyle: '',
                    posX: null,
                    posY: null,
                },
            },
        };
        this.stylers.forEach((s) => {
            s.visible = false;
        });
        this.hsPrintScaleService.setToDefaultScale(this.data.app);
        this.hsPrintLegendService.get(this.data.app).loadingExternalImages = false;
    }
    /**
     * Cancel loading print layout image
     */
    cancelLoading() {
        this.hsPrintLegendService.get(this.data.app).cancelRequest.next();
    }
    /**
     * Print or preview print layout
     * @param complete - Indicates whether the user wants to print or preview the image
     */
    printLayout(complete) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.hsPrintService.print(this.print, this.data.app, complete);
        });
    }
    /**
     * Download print layout as png image
     */
    download() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.hsPrintService.download(this.print, this.data.app);
        });
    }
    isLoading() {
        return this.hsPrintLegendService.get(this.data.app).loadingExternalImages;
    }
    /**
     * Set styler visibility
     * @param stylerVisible - Selected styler name, that is being toggled
     */
    setStylerVisible(stylerVisible) {
        this.stylers.forEach((s) => {
            if (s.name === stylerVisible) {
                s.visible = !s.visible;
            }
            else {
                s.visible = false;
            }
        });
    }
    /**
     * Get styler visibility
     * @param stylerVisible - Selected styler name, that is being toggled
     */
    getStylerVisible(stylerVisible) {
        var _a, _b;
        return (_b = (_a = this.stylers.find((s) => s.name === stylerVisible)) === null || _a === void 0 ? void 0 : _a.visible) !== null && _b !== void 0 ? _b : false;
    }
}
HsPrintComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsPrintComponent, deps: [{ token: HsLayoutService }, { token: HsConfig }, { token: HsSidebarService }, { token: HsUtilsService }, { token: HsPrintService }, { token: HsPrintScaleService }, { token: HsPrintLegendService }], target: i0.ɵɵFactoryTarget.Component });
HsPrintComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsPrintComponent, selector: "hs-print", usesInheritance: true, ngImport: i0, template: "<div class=\"card hs-main-panel\" [hidden]=\"(isVisible$ | async) === false\">\n    <hs-panel-header name=\"print\" [title]=\"'PANEL_HEADER.PRINT' | translateHs : {app: data.app} \">\n        <extra-buttons>\n            <button class=\"but-title-sm hs-extra-buttons mt-1\" (click)=\"setToDefault()\"\n                [title]=\"'COMMON.resetToDefault' | translateHs : {app: data.app} \">\n                <i class=\"glyphicon icon-fatredo\"></i>\n            </button>\n        </extra-buttons>\n    </hs-panel-header>\n    <div class=\"card-body\">\n        <div class=\"card-body\">\n            <div class=\"form-floating mb-2\">\n                <input type=\"text\" class=\"form-control\" id=\"print-title\" [(ngModel)]=\"print.titleObj.text\"\n                    placeholder=\"'COMMON.title' | translateHs : {app: data.app} \" />\n                <label for=\"print-title\" class=\"control-label\">{{'COMMON.title' | translateHs : {app: data.app} }}</label>\n            </div>\n            <div class=\"d-flex justify-content-around mb-2\">\n                <div class=\"form-check border-0\">\n                    <input type=\"checkbox\" class=\"form-check-input\" [(ngModel)]=\"print.legendObj.include\"\n                        name=\"includeLegend\" id=\"includeLegend\">\n                    <label class=\"form-check-label pt-1\" for=\"includeLegend\" style=\"cursor:pointer\">{{'COMMON.legend' |\n                        translateHs : {app: data.app} }}</label>\n                </div>\n                <div class=\"form-check border-0\">\n                    <input type=\"checkbox\" class=\"form-check-input\" [(ngModel)]=\"print.imprintObj.include\"\n                        name=\"includeImprint\" id=\"includeImprint\">\n                    <label class=\"form-check-label pt-1\" for=\"includeImprint\" style=\"cursor:pointer\">{{'PRINT.imprint' |\n                        translateHs : {app: data.app} }}</label>\n                </div>\n                <div class=\"form-check border-0\">\n                    <input type=\"checkbox\" class=\"form-check-input\" [(ngModel)]=\"print.scaleObj.include\"\n                        name=\"includeScale\" id=\"includeScale\">\n                    <label class=\"form-check-label pt-1\" for=\"includeScale\" style=\"cursor:pointer\">{{'COMMON.scale' |\n                        translateHs : {app: data.app} }}</label>\n                </div>\n            </div>\n            <!-- <div class=\"form-group\">\n                <div class=\"input-group\">\n                    <span class=\"input-group-text control-label\">{{'Resolution' | translateHs : {app: data.app} }}</span>\n                    <select class=\"form-control form-select\" [(ngModel)]=\"print.resolution\" name=\"resolution\"\n                        style=\"flex-grow: 1;\" [ngModelOptions]=\"{standalone: true}\">\n                        <option [ngValue]=\"deviceRes\">{{deviceRes}}</option>\n                        <option *ngFor=\"let res of resolutions\" [ngValue]=\"res\">{{res}}\n                        </option>\n                    </select>\n                </div>\n            </div> -->\n            <button type=\"button\" class=\"btn w-100 mb-2 btn-outline-secondary dropdown-toggle dropdown-toggle-split\"\n                (click)=\"setStylerVisible('title')\" [disabled]=\"!print.titleObj.text\">\n                {{'PRINT.titleStylingOptions' | translateHs : {app: data.app} }}\n            </button>\n            <hs-print-text-styler *ngIf=\"getStylerVisible('title')\" [app]=\"data.app\" [textStyle]=\"print.titleObj.textStyle\"\n                [objectName]=\"'title'\"><!-- TODO: Remove function call from template -->\n            </hs-print-text-styler>\n            <button type=\"button\" [disabled]=\"!print.legendObj.include\" (click)=\"setStylerVisible('legend')\"\n                class=\"btn w-100 mb-2 btn-outline-secondary dropdown-toggle dropdown-toggle-split\">\n                {{'PRINT.legendStylingOptions' | translateHs : {app: data.app} }}\n            </button>\n            <hs-print-legend-styler *ngIf=\"getStylerVisible('legend') && print.legendObj.include\" [app]=\"data.app\"\n                [legendObj]=\"print.legendObj\"><!-- TODO: Remove function call from template -->\n            </hs-print-legend-styler>\n            <button [disabled]=\"!print.imprintObj.include\" type=\"button\" (click)=\"setStylerVisible('imprint')\"\n                class=\"btn w-100 mb-2 btn-outline-secondary dropdown-toggle dropdown-toggle-split\">\n                {{'PRINT.imprintStylingOptions' | translateHs : {app: data.app} }}\n            </button>\n            <hs-print-imprint-styler *ngIf=\"getStylerVisible('imprint') && print.imprintObj.include\" [app]=\"data.app\"\n                [imprintObj]=\"print.imprintObj\"><!-- TODO: Remove function call from template -->\n            </hs-print-imprint-styler>\n            <button [disabled]=\"!print.scaleObj.include\" type=\"button\" (click)=\"setStylerVisible('scale')\"\n                class=\"btn w-100 mb-2 btn-outline-secondary dropdown-toggle dropdown-toggle-split\">\n                {{'PRINT.scaleStylingOptions' | translateHs : {app: data.app} }}\n            </button>\n            <hs-print-scale-styler *ngIf=\"getStylerVisible('scale') && print.scaleObj.include\" [app]=\"data.app\"\n                [scaleObj]=\"print.scaleObj\"><!-- TODO: Remove function call from template -->\n            </hs-print-scale-styler>\n            <div class=\"mb-2 mt-2 d-flex justify-content-start\" *ngIf=\"!isLoading()\">\n                <button type=\"button\" class=\"btn btn-primary me-2 w-50\" (click)=\"printLayout(true)\">{{'COMMON.print' |\n                    translateHs : {app: data.app} }}</button>\n                <button type=\"button\" class=\"btn btn-secondary w-50\" (click)=\"printLayout(false)\">{{'COMMON.preview' |\n                    translateHs : {app: data.app} }}</button>\n                <button class=\"btn btn-secondary ms-2\" (click)=\"download()\" data-toggle=\"tooltip\"\n                    [title]=\"'COMMON.downloadAsPng' | translateHs : {app: data.app}\"><i class=\"icon-download\"></i></button>\n            </div>\n            <div class=\"d-flex justify-content-center btn-group w-75 m-auto\" *ngIf=\"isLoading()\">\n                <button class=\"btn btn-primary w-75\">{{'ADDDATA.CATALOGUE.loading' | translateHs : {app: data.app} }}...<img class=\"ms-2\"\n                        [src]=\"configRef._ajaxLoaderPath\" /></button>\n                <button class=\"btn btn-secondary\" (click)=\"cancelLoading()\">&#10006;\n                </button>\n            </div>\n        </div>\n    </div>\n</div>", components: [{ type: HsPanelHeaderComponent, selector: "hs-panel-header", inputs: ["name", "app", "title"] }, { type: HsPrintTextStylerComponent, selector: "hs-print-text-styler", inputs: ["textStyle", "objectName", "app"] }, { type: HsPrintLegendStylerComponent, selector: "hs-print-legend-styler", inputs: ["legendObj", "app"] }, { type: HsPrintImprintStylerComponent, selector: "hs-print-imprint-styler", inputs: ["imprintObj", "app"] }, { type: HsPrintScaleStylerComponent, selector: "hs-print-scale-styler", inputs: ["scaleObj", "app"] }], directives: [{ type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3$1.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "async": i3.AsyncPipe, "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsPrintComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-print', template: "<div class=\"card hs-main-panel\" [hidden]=\"(isVisible$ | async) === false\">\n    <hs-panel-header name=\"print\" [title]=\"'PANEL_HEADER.PRINT' | translateHs : {app: data.app} \">\n        <extra-buttons>\n            <button class=\"but-title-sm hs-extra-buttons mt-1\" (click)=\"setToDefault()\"\n                [title]=\"'COMMON.resetToDefault' | translateHs : {app: data.app} \">\n                <i class=\"glyphicon icon-fatredo\"></i>\n            </button>\n        </extra-buttons>\n    </hs-panel-header>\n    <div class=\"card-body\">\n        <div class=\"card-body\">\n            <div class=\"form-floating mb-2\">\n                <input type=\"text\" class=\"form-control\" id=\"print-title\" [(ngModel)]=\"print.titleObj.text\"\n                    placeholder=\"'COMMON.title' | translateHs : {app: data.app} \" />\n                <label for=\"print-title\" class=\"control-label\">{{'COMMON.title' | translateHs : {app: data.app} }}</label>\n            </div>\n            <div class=\"d-flex justify-content-around mb-2\">\n                <div class=\"form-check border-0\">\n                    <input type=\"checkbox\" class=\"form-check-input\" [(ngModel)]=\"print.legendObj.include\"\n                        name=\"includeLegend\" id=\"includeLegend\">\n                    <label class=\"form-check-label pt-1\" for=\"includeLegend\" style=\"cursor:pointer\">{{'COMMON.legend' |\n                        translateHs : {app: data.app} }}</label>\n                </div>\n                <div class=\"form-check border-0\">\n                    <input type=\"checkbox\" class=\"form-check-input\" [(ngModel)]=\"print.imprintObj.include\"\n                        name=\"includeImprint\" id=\"includeImprint\">\n                    <label class=\"form-check-label pt-1\" for=\"includeImprint\" style=\"cursor:pointer\">{{'PRINT.imprint' |\n                        translateHs : {app: data.app} }}</label>\n                </div>\n                <div class=\"form-check border-0\">\n                    <input type=\"checkbox\" class=\"form-check-input\" [(ngModel)]=\"print.scaleObj.include\"\n                        name=\"includeScale\" id=\"includeScale\">\n                    <label class=\"form-check-label pt-1\" for=\"includeScale\" style=\"cursor:pointer\">{{'COMMON.scale' |\n                        translateHs : {app: data.app} }}</label>\n                </div>\n            </div>\n            <!-- <div class=\"form-group\">\n                <div class=\"input-group\">\n                    <span class=\"input-group-text control-label\">{{'Resolution' | translateHs : {app: data.app} }}</span>\n                    <select class=\"form-control form-select\" [(ngModel)]=\"print.resolution\" name=\"resolution\"\n                        style=\"flex-grow: 1;\" [ngModelOptions]=\"{standalone: true}\">\n                        <option [ngValue]=\"deviceRes\">{{deviceRes}}</option>\n                        <option *ngFor=\"let res of resolutions\" [ngValue]=\"res\">{{res}}\n                        </option>\n                    </select>\n                </div>\n            </div> -->\n            <button type=\"button\" class=\"btn w-100 mb-2 btn-outline-secondary dropdown-toggle dropdown-toggle-split\"\n                (click)=\"setStylerVisible('title')\" [disabled]=\"!print.titleObj.text\">\n                {{'PRINT.titleStylingOptions' | translateHs : {app: data.app} }}\n            </button>\n            <hs-print-text-styler *ngIf=\"getStylerVisible('title')\" [app]=\"data.app\" [textStyle]=\"print.titleObj.textStyle\"\n                [objectName]=\"'title'\"><!-- TODO: Remove function call from template -->\n            </hs-print-text-styler>\n            <button type=\"button\" [disabled]=\"!print.legendObj.include\" (click)=\"setStylerVisible('legend')\"\n                class=\"btn w-100 mb-2 btn-outline-secondary dropdown-toggle dropdown-toggle-split\">\n                {{'PRINT.legendStylingOptions' | translateHs : {app: data.app} }}\n            </button>\n            <hs-print-legend-styler *ngIf=\"getStylerVisible('legend') && print.legendObj.include\" [app]=\"data.app\"\n                [legendObj]=\"print.legendObj\"><!-- TODO: Remove function call from template -->\n            </hs-print-legend-styler>\n            <button [disabled]=\"!print.imprintObj.include\" type=\"button\" (click)=\"setStylerVisible('imprint')\"\n                class=\"btn w-100 mb-2 btn-outline-secondary dropdown-toggle dropdown-toggle-split\">\n                {{'PRINT.imprintStylingOptions' | translateHs : {app: data.app} }}\n            </button>\n            <hs-print-imprint-styler *ngIf=\"getStylerVisible('imprint') && print.imprintObj.include\" [app]=\"data.app\"\n                [imprintObj]=\"print.imprintObj\"><!-- TODO: Remove function call from template -->\n            </hs-print-imprint-styler>\n            <button [disabled]=\"!print.scaleObj.include\" type=\"button\" (click)=\"setStylerVisible('scale')\"\n                class=\"btn w-100 mb-2 btn-outline-secondary dropdown-toggle dropdown-toggle-split\">\n                {{'PRINT.scaleStylingOptions' | translateHs : {app: data.app} }}\n            </button>\n            <hs-print-scale-styler *ngIf=\"getStylerVisible('scale') && print.scaleObj.include\" [app]=\"data.app\"\n                [scaleObj]=\"print.scaleObj\"><!-- TODO: Remove function call from template -->\n            </hs-print-scale-styler>\n            <div class=\"mb-2 mt-2 d-flex justify-content-start\" *ngIf=\"!isLoading()\">\n                <button type=\"button\" class=\"btn btn-primary me-2 w-50\" (click)=\"printLayout(true)\">{{'COMMON.print' |\n                    translateHs : {app: data.app} }}</button>\n                <button type=\"button\" class=\"btn btn-secondary w-50\" (click)=\"printLayout(false)\">{{'COMMON.preview' |\n                    translateHs : {app: data.app} }}</button>\n                <button class=\"btn btn-secondary ms-2\" (click)=\"download()\" data-toggle=\"tooltip\"\n                    [title]=\"'COMMON.downloadAsPng' | translateHs : {app: data.app}\"><i class=\"icon-download\"></i></button>\n            </div>\n            <div class=\"d-flex justify-content-center btn-group w-75 m-auto\" *ngIf=\"isLoading()\">\n                <button class=\"btn btn-primary w-75\">{{'ADDDATA.CATALOGUE.loading' | translateHs : {app: data.app} }}...<img class=\"ms-2\"\n                        [src]=\"configRef._ajaxLoaderPath\" /></button>\n                <button class=\"btn btn-secondary\" (click)=\"cancelLoading()\">&#10006;\n                </button>\n            </div>\n        </div>\n    </div>\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsLayoutService }, { type: HsConfig }, { type: HsSidebarService }, { type: HsUtilsService }, { type: HsPrintService }, { type: HsPrintScaleService }, { type: HsPrintLegendService }]; } });

class HsQueryWmtsService {
    constructor(hsMapService, hsUtilsService) {
        this.hsMapService = hsMapService;
        this.hsUtilsService = hsUtilsService;
    }
    /**
     * Parse request URL
     * @param layer - Layer to Query
     * @param coordinate - Clicked coordinates
     * @param app - App identifier
     * @returns Request URL and format
     */
    parseRequestURL(layer, coordinate, app) {
        return __awaiter(this, void 0, void 0, function* () {
            const source = layer.getSource();
            coordinate = transform(coordinate, this.hsMapService.getCurrentProj(app), source.getProjection());
            const tileGrid = source.getTileGrid();
            const tileCoord = tileGrid.getTileCoordForCoordAndResolution(coordinate, this.hsMapService.getMap(app).getView().getResolution());
            const tileExtent = tileGrid.getTileCoordExtent(tileCoord);
            const tileResolution = tileGrid.getResolution(tileCoord[0]);
            const tileMatrix = tileGrid.getMatrixIds()[tileCoord[0]];
            // I.J params (clicked pixel position relative to tile)
            const x = Math.floor((coordinate[0] - tileExtent[0]) / (tileResolution / 1)); //pixelRatio
            const y = Math.floor((tileExtent[3] - coordinate[1]) / (tileResolution / 1)); //pixelRatio
            const urls = source.getUrls()[0];
            const params = {
                LAYER: source.getLayer(),
                service: 'WMTS',
                INFOFORMAT: getInfoFormat(layer),
                REQUEST: 'GetFeatureInfo',
                TileCol: tileCoord[1],
                TileRow: tileCoord[2],
                I: x,
                J: y,
                TILEMATRIXSET: source.getMatrixSet(),
                TileMatrix: tileMatrix,
            };
            const url = [urls, this.hsUtilsService.paramsToURLWoEncode(params)].join('');
            return {
                url: url,
                format: params.INFOFORMAT,
            };
        });
    }
}
HsQueryWmtsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsQueryWmtsService, deps: [{ token: HsMapService }, { token: HsUtilsService }], target: i0.ɵɵFactoryTarget.Injectable });
HsQueryWmtsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsQueryWmtsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsQueryWmtsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsMapService }, { type: HsUtilsService }]; } });

class HsQueryWmsService {
    constructor(hsQueryBaseService, hsMapService, hsLayerUtilsService, hsLanguageService, hsUtilsService, httpClient, hsLogService, hsQueryWmtsService) {
        this.hsQueryBaseService = hsQueryBaseService;
        this.hsMapService = hsMapService;
        this.hsLayerUtilsService = hsLayerUtilsService;
        this.hsLanguageService = hsLanguageService;
        this.hsUtilsService = hsUtilsService;
        this.httpClient = httpClient;
        this.hsLogService = hsLogService;
        this.hsQueryWmtsService = hsQueryWmtsService;
        this.infoCounter = 0;
    }
    /**
     * Initialize the query WMS service data and subscribers
     * @param _app - App identifier
     */
    init(_app) {
        this.hsQueryBaseService.getFeatureInfoStarted.subscribe(({ evt, app }) => {
            if (_app == app) {
                this.infoCounter = 0;
                this.hsMapService
                    .getLayersArray(app)
                    .forEach((layer) => {
                    if (getBase(layer) == true || layer.get('queryable') == false) {
                        return;
                    }
                    if (getQueryFilter(layer) != undefined) {
                        const filter = getQueryFilter(layer);
                        if (!filter(this.hsMapService.getMap(app), layer, evt.pixel)) {
                            return;
                        }
                    }
                    this.queryWmsLayer(instOf(layer, Tile)
                        ? layer
                        : layer, evt.coordinate, app);
                });
            }
        });
    }
    /**
     * Update feature list
     * @param updated - Feature list has been updated
     * @param group -
     * @param app - App identifier
     */
    updateFeatureList(updated, group, app) {
        const queryBaseAppRef = this.hsQueryBaseService.get(app);
        if (updated) {
            if (group.customInfoTemplate) {
                queryBaseAppRef.set(group, 'customFeatures');
                queryBaseAppRef.dataCleared = false;
            }
            else {
                queryBaseAppRef.set(group, 'features');
            }
        }
    }
    /**
     * Request information about clicked WMS layer coordinates
     * @param url - Request URL
     * @param infoFormat - Request information format
     * @param coordinate - Clicked coordinates
     * @param layer - Target layer
     * @param app - App identifier
     */
    request(url, infoFormat, coordinate, layer, app) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryBaseAppRef = this.hsQueryBaseService.get(app);
            const req_url = this.hsUtilsService.proxify(url, app, true);
            const reqHash = queryBaseAppRef.currentQuery;
            try {
                const headers = new Headers({ 'Content-Type': 'text' });
                headers.set('Accept', 'text');
                const response = yield lastValueFrom(this.httpClient.get(req_url, {
                    headers: new HttpHeaders().set('Content-Type', 'text'),
                    responseType: 'text',
                }));
                if (reqHash != queryBaseAppRef.currentQuery) {
                    return;
                }
                this.featureInfoReceived(response, infoFormat, coordinate, layer, app);
            }
            catch (exception) {
                if (reqHash != queryBaseAppRef.currentQuery) {
                    return;
                }
                this.featureInfoError(coordinate, exception, app);
            }
        });
    }
    /**
     * Error callback to decrease infoCounter
     * @param coordinate - Clicked coordinates
     * @param exception - Error caught
     * @param app - App identifier
     */
    featureInfoError(coordinate, exception, app) {
        this.infoCounter--;
        this.hsLogService.warn(exception);
        if (this.infoCounter === 0) {
            this.queriesCollected(coordinate, app);
        }
    }
    /**
     * Parse Information from GetFeatureInfo request. If result came in XML format, Infopanel data are updated. If response is in HTML, popup window is updated and shown.
     * @param response - Response of GetFeatureInfoRequest
     * @param infoFormat - Format of GetFeatureInfoResponse
     * @param coordinate - Coordinate of request
     * @param layer - Target layer
     * @param app - App identifier
     */
    featureInfoReceived(response, infoFormat, coordinate, layer, app) {
        /* Maybe this will work in future OL versions
         * var format = new GML();
         *  console.log(format.readFeatures(response, {}));
         */
        const queryBaseAppRef = this.hsQueryBaseService.get(app);
        const customInfoTemplate = getCustomInfoTemplate(layer) || false;
        if (infoFormat.includes('xml') || infoFormat.includes('gml')) {
            const oParser = new DOMParser();
            const oDOM = oParser.parseFromString(response, 'application/xml');
            const doc = oDOM.documentElement;
            //This is suggests that WMTS only provides gml, is that the case?
            //http://opengeospatial.github.io/e-learning/wmts/text/operations.html
            if (infoFormat.includes('gml') || instOf(layer.getSource(), WMTS)) {
                this.parseGmlResponse(doc, layer, customInfoTemplate, app);
            }
            else if (infoFormat == 'text/xml' ||
                infoFormat === 'application/vnd.ogc.wms_xml') {
                if (doc.childNodes[1]['attributes'] != undefined) {
                    const group = {
                        name: 'Feature',
                        attributes: doc.childNodes[1]['attributes'],
                        layer: getTitle(layer) || getName(layer),
                        customInfoTemplate: customInfoTemplate,
                    };
                    if (customInfoTemplate) {
                        queryBaseAppRef.set(group, 'customFeatures');
                        queryBaseAppRef.dataCleared = false;
                    }
                    else {
                        queryBaseAppRef.set(group, 'features');
                    }
                }
                else {
                    return;
                }
            }
        }
        if (infoFormat.includes('html')) {
            if (response.length <= 1) {
                return;
            }
            if (getFeatureInfoTarget(layer) == 'info-panel') {
                this.hsQueryBaseService.pushFeatureInfoHtml(response, app);
            }
            else {
                this.hsQueryBaseService.fillIframeAndResize(response, true, app);
                if (getPopupClass(layer) != undefined) {
                    this.hsQueryBaseService.popupClassname =
                        'ol-popup ' + getPopupClass(layer);
                }
            }
        }
        if (infoFormat.includes('json')) {
            const resJSON = JSON.parse(response);
            this.hsQueryBaseService.get(app).set(resJSON.features, 'customFeatures');
            console.log('jsonquery');
        }
        this.infoCounter--;
        if (this.infoCounter === 0) {
            this.queriesCollected(coordinate, app);
        }
    }
    /**
     * Parse Information from GetFeatureInfo request. If result came in XML format, Infopanel data are updated. If response is in HTML, popup window is updated and shown.
     * @param doc - Parsed HTML document from GetFeatureInfoRequest response
     * @param layer - Target layer
     * @param customInfoTemplate - Custom info template
     * @param app - App identifier
     */
    parseGmlResponse(doc, layer, customInfoTemplate, app) {
        let updated = false;
        let features = doc.querySelectorAll('gml\\:featureMember');
        if (features.length == 0) {
            features = doc.querySelectorAll('featureMember');
        }
        features.forEach((feature) => {
            const layerName = getTitle(layer) || getName(layer);
            const layers = feature.getElementsByTagName('Layer');
            for (const fioLayer of Array.from(layers)) {
                const featureName = fioLayer.attributes[0].nodeValue;
                const attrs = fioLayer.getElementsByTagName('Attribute');
                const attributes = [];
                for (const attr of Array.from(attrs)) {
                    attributes.push({
                        'name': attr.attributes[0].nodeValue,
                        'value': attr.innerHTML,
                    });
                }
                const group = {
                    layer: layerName,
                    name: featureName,
                    attributes,
                    customInfoTemplate,
                };
                this.updateFeatureList(updated, group, app);
            }
            const featureNode = feature.firstChild;
            const group = {
                name: 'Feature',
                layer: this.hsLayerUtilsService.getLayerName(layer),
                attributes: [],
            };
            for (const attribute in featureNode.children) {
                if (featureNode.children[attribute].childElementCount == 0) {
                    group.attributes.push({
                        'name': featureNode.children[attribute].localName,
                        'value': featureNode.children[attribute].innerHTML,
                    });
                    updated = true;
                }
            }
            this.updateFeatureList(updated, group, app);
        });
        const msGMLOutputs = doc.querySelectorAll('msGMLOutput');
        if ((msGMLOutputs === null || msGMLOutputs === void 0 ? void 0 : msGMLOutputs.length) > 0) {
            msGMLOutputs.forEach((output) => {
                this.extractMsGMLAttributes(output, updated, customInfoTemplate, app);
            });
        }
        else if (doc.nodeName == 'msGMLOutput') {
            this.extractMsGMLAttributes(doc, updated, customInfoTemplate, app);
        }
    }
    /**
     * Extract MsGMLOutput feature attributes
     * @param output - MsGMLOutput from parsed HTML document
     * @param updated - Is feature list updated
     * @param customInfoTemplate - Custom info template
     * @param app - App identifier
     */
    extractMsGMLAttributes(output, updated, customInfoTemplate, app) {
        for (const layer_i in output.children) {
            const layer = output.children[layer_i];
            let layer_name = '';
            if (layer.children == undefined) {
                continue;
            }
            for (let feature_i = 0; feature_i < layer.children.length; feature_i++) {
                const feature = layer.children[feature_i];
                if (feature.nodeName == 'gml:name') {
                    layer_name = feature.innerHTML;
                }
                else {
                    const group = {
                        name: layer_name + ' Feature',
                        attributes: [],
                        customInfoTemplate,
                    };
                    for (const attribute in feature.children) {
                        if (feature.children[attribute].childElementCount == 0) {
                            group.attributes.push({
                                'name': feature.children[attribute].localName,
                                'value': feature.children[attribute].innerHTML,
                            });
                            updated = true;
                        }
                    }
                    this.updateFeatureList(updated, group, app);
                }
            }
        }
    }
    /**
     * Acknowledge that queries for clicked coordinates have been collected
     * @param coordinate - Clicked coordinates
     * @param app - App identifier
     */
    queriesCollected(coordinate, app) {
        const invisiblePopup = this.hsQueryBaseService.getInvisiblePopup();
        if (this.hsQueryBaseService.get(app).features.length > 0 ||
            invisiblePopup.contentDocument.body.innerHTML.length > 30) {
            this.hsQueryBaseService.getFeatureInfoCollected.next(coordinate);
        }
    }
    /**
     * Get FeatureInfo from WMS queryable layer (only if format of response is XML/GML/HTML). Use hs.query.service_getwmsfeatureinfo service for request and parsing response.
     * @param layer - Layer to Query
     * @param coordinate - Clicked coordinates
     * @param app - App identifier
     */
    queryWmsLayer(layer, coordinate, app) {
        if (this.isLayerWmsQueryable(layer)) {
            if (instOf(layer.getSource(), WMTS)) {
                this.hsQueryWmtsService
                    .parseRequestURL(layer, coordinate, app)
                    .then((res) => {
                    console.log(res);
                    this.infoCounter++;
                    this.request(res.url, res.format, coordinate, layer, app);
                });
                return;
            }
            let source;
            if (instOf(layer.getSource(), ImageWMS)) {
                source = layer.getSource();
            }
            else if (instOf(layer.getSource(), TileWMS)) {
                source = layer.getSource();
            }
            const map = this.hsMapService.getMap(app);
            const viewResolution = map.getView().getResolution();
            let url = source.getFeatureInfoUrl(coordinate, viewResolution, source.getProjection()
                ? source.getProjection()
                : this.hsMapService.getCurrentProj(app), {
                INFO_FORMAT: source.getParams().INFO_FORMAT,
            });
            if (getFeatureInfoLang(layer) &&
                getFeatureInfoLang(layer)[this.hsLanguageService.apps[app].language]) {
                if (instOf(source, TileWMS)) {
                    url = url.replace(source.getUrls()[0], getFeatureInfoLang(layer)[this.hsLanguageService.apps[app].language]);
                }
                else {
                    url = url.replace(source.getUrl(), getFeatureInfoLang(layer)[this.hsLanguageService.apps[app].language]);
                }
            }
            if (url) {
                this.hsLogService.log(url);
                if (source.getParams().INFO_FORMAT.includes('xml') ||
                    source.getParams().INFO_FORMAT.includes('html') ||
                    source.getParams().INFO_FORMAT.includes('gml') ||
                    source.getParams().INFO_FORMAT.includes('json')) {
                    this.infoCounter++;
                    this.request(url, source.getParams().INFO_FORMAT, coordinate, layer, app);
                }
            }
        }
    }
    /**
     * Check if the selected layer is queryable
     * @param layer - Layer selected
     * @returns True if the layer is queryable, false otherwise
     */
    isLayerWmsQueryable(layer) {
        if (!layer.getVisible()) {
            return false;
        }
        if (instOf(layer, Tile)) {
            if (instOf(layer.getSource(), TileWMS) &&
                layer.getSource().getParams().INFO_FORMAT) {
                return true;
            }
            if (instOf(layer.getSource(), WMTS) && getInfoFormat(layer)) {
                return true;
            }
        }
        if (instOf(layer, Image$1) &&
            instOf(layer.getSource(), ImageWMS) &&
            layer.getSource().getParams().INFO_FORMAT) {
            return true;
        }
        return false;
    }
}
HsQueryWmsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsQueryWmsService, deps: [{ token: HsQueryBaseService }, { token: HsMapService }, { token: HsLayerUtilsService }, { token: HsLanguageService }, { token: HsUtilsService }, { token: i1.HttpClient }, { token: HsLogService }, { token: HsQueryWmtsService }], target: i0.ɵɵFactoryTarget.Injectable });
HsQueryWmsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsQueryWmsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsQueryWmsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsQueryBaseService }, { type: HsMapService }, { type: HsLayerUtilsService }, { type: HsLanguageService }, { type: HsUtilsService }, { type: i1.HttpClient }, { type: HsLogService }, { type: HsQueryWmtsService }]; } });

class HsQueryDefaultInfoPanelBodyComponent {
    constructor(hsQueryBaseService) {
        this.hsQueryBaseService = hsQueryBaseService;
        this.app = 'default';
    }
    ngOnInit() {
        this.featureInfoExpanded = true;
        this.queryBaseAppRef = this.hsQueryBaseService.get(this.app);
    }
}
HsQueryDefaultInfoPanelBodyComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsQueryDefaultInfoPanelBodyComponent, deps: [{ token: HsQueryBaseService }], target: i0.ɵɵFactoryTarget.Component });
HsQueryDefaultInfoPanelBodyComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsQueryDefaultInfoPanelBodyComponent, selector: "hs-query-default-info-panel-body", inputs: { app: "app" }, ngImport: i0, template: "<div *ngIf=\"(queryBaseAppRef.features.length > 0) || (queryBaseAppRef.coordinates.length > 0)\"\n    class=\"card hs-main-panel\">\n    <div class=\"card-body\">\n        <div ngbDropdown [hidden]=\"!(queryBaseAppRef.featureInfoHtmls.length > 0)\">\n            <button ngbDropdownToggle class=\"btn btn-light w-100 rounded-0\">\n                {{'QUERY.featureInfo' | translateHs : {app} }}\n            </button>\n            <div ngbDropdownMenu class=\"position-relative w-100\"\n                *ngFor=\"let html of queryBaseAppRef.featureInfoHtmls\" [innerHtml]=\"html\"></div>\n        </div>\n        <hs-query-feature-list [app]=\"app\"></hs-query-feature-list>\n        <table class=\"table table-striped\" style=\"table-layout:fixed\"\n            [hidden]=\"!(queryBaseAppRef.attributes.length > 0)\">\n            <tbody>\n                <tr *ngFor=\"let attribute of queryBaseAppRef.attributes\">\n                    <td class=\"first-col\">{{attribute.name}}</td>\n                    <td class=\"second-col\" [innerHtml]=\"attribute.value\"></td>\n                </tr>\n            </tbody>\n        </table>\n    </div>\n    <iframe id=\"invisible_popup\" style=\"display:block; z-index:12122;left:-10000px; position:absolute\"></iframe>\n</div>", components: [{ type: HsQueryFeatureListComponent, selector: "hs-query-feature-list", inputs: ["app"] }], directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i7.NgbDropdown, selector: "[ngbDropdown]", inputs: ["autoClose", "dropdownClass", "open", "placement", "container", "display"], outputs: ["openChange"], exportAs: ["ngbDropdown"] }, { type: i7.NgbDropdownToggle, selector: "[ngbDropdownToggle]" }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i7.NgbDropdownMenu, selector: "[ngbDropdownMenu]" }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsQueryDefaultInfoPanelBodyComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-query-default-info-panel-body', template: "<div *ngIf=\"(queryBaseAppRef.features.length > 0) || (queryBaseAppRef.coordinates.length > 0)\"\n    class=\"card hs-main-panel\">\n    <div class=\"card-body\">\n        <div ngbDropdown [hidden]=\"!(queryBaseAppRef.featureInfoHtmls.length > 0)\">\n            <button ngbDropdownToggle class=\"btn btn-light w-100 rounded-0\">\n                {{'QUERY.featureInfo' | translateHs : {app} }}\n            </button>\n            <div ngbDropdownMenu class=\"position-relative w-100\"\n                *ngFor=\"let html of queryBaseAppRef.featureInfoHtmls\" [innerHtml]=\"html\"></div>\n        </div>\n        <hs-query-feature-list [app]=\"app\"></hs-query-feature-list>\n        <table class=\"table table-striped\" style=\"table-layout:fixed\"\n            [hidden]=\"!(queryBaseAppRef.attributes.length > 0)\">\n            <tbody>\n                <tr *ngFor=\"let attribute of queryBaseAppRef.attributes\">\n                    <td class=\"first-col\">{{attribute.name}}</td>\n                    <td class=\"second-col\" [innerHtml]=\"attribute.value\"></td>\n                </tr>\n            </tbody>\n        </table>\n    </div>\n    <iframe id=\"invisible_popup\" style=\"display:block; z-index:12122;left:-10000px; position:absolute\"></iframe>\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsQueryBaseService }]; }, propDecorators: { app: [{
                type: Input
            }] } });

class HsQueryComponent extends HsPanelBaseComponent {
    constructor(hsQueryBaseService, hsLayoutService, hsMapService, hsEventBusService, hsQueryVectorService, hsQueryWmsService, hsDrawService, hsSidebarService, hsLanguageService) {
        super(hsLayoutService);
        this.hsQueryBaseService = hsQueryBaseService;
        this.hsLayoutService = hsLayoutService;
        this.hsMapService = hsMapService;
        this.hsEventBusService = hsEventBusService;
        this.hsQueryVectorService = hsQueryVectorService;
        this.hsQueryWmsService = hsQueryWmsService;
        this.hsDrawService = hsDrawService;
        this.hsSidebarService = hsSidebarService;
        this.hsLanguageService = hsLanguageService;
        this.popup = new Popup();
        this.popupOpens = new Subject();
        this.name = 'info';
        //To Unsubscribe all subscribers
        this.ngUnsubscribe = new Subject();
        //To deactivate queries (unsubscribe subscribers) per app
        this.queryDeactivator = new Subject();
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.hsSidebarService.addButton({
                panel: 'info',
                module: 'hs.query',
                order: 7,
                fits: true,
                title: 'PANEL_HEADER.INFO',
                description: 'SIDEBAR.descriptions.INFO',
                icon: 'icon-info-sign',
            }, this.data.app);
            this.hsQueryWmsService.init(this.data.app);
            this.queryBaseAppRef = this.hsQueryBaseService.get(this.data.app);
            this.layoutAppRef = this.hsLayoutService.get(this.data.app);
            this.popupOpens.pipe(takeUntil$1(this.ngUnsubscribe)).subscribe((source) => {
                if (source && source != 'hs.query' && this.popup !== undefined) {
                    this.popup.hide();
                }
            });
            this.hsQueryVectorService.featureRemovals
                .pipe(takeUntil$1(this.ngUnsubscribe))
                .subscribe((feature) => {
                this.queryBaseAppRef.features.splice(this.queryBaseAppRef.features.indexOf(feature), 1);
            });
            this.hsMapService.loaded(this.data.app).then((map) => {
                map.addOverlay(this.popup);
            });
            yield this.hsQueryBaseService.init(this.data.app);
            //add current panel queryable - activate/deactivate
            this.hsEventBusService.mainPanelChanges
                .pipe(takeUntil$1(this.ngUnsubscribe))
                .subscribe(({ which, app }) => {
                if (this.data.app == app) {
                    if (this.hsQueryBaseService.currentPanelQueryable(this.data.app)) {
                        if (!this.queryBaseAppRef.queryActive &&
                            !this.hsDrawService.get(app).drawActive) {
                            this.hsQueryBaseService.activateQueries(this.data.app);
                        }
                    }
                    else {
                        if (this.queryBaseAppRef.queryActive) {
                            this.hsQueryBaseService.deactivateQueries(this.data.app);
                        }
                    }
                }
            });
            this.hsQueryBaseService.queryStatusChanges
                .pipe(takeUntil$1(this.ngUnsubscribe))
                .subscribe(({ status, app }) => {
                if (app == this.data.app) {
                    this.queryStatusChanged(status);
                }
            });
            const active = this.hsQueryBaseService.get(this.data.app).queryActive;
            if (active) {
                this.queryStatusChanged(active);
            }
        });
    }
    /**
     * Act on query status changes
     * @param active - Query status state
     */
    queryStatusChanged(active) {
        if (!active) {
            this.queryDeactivator.next();
            return;
        }
        this.hsQueryBaseService.getFeatureInfoStarted
            .pipe(takeUntil$1(this.ngUnsubscribe))
            .pipe(takeUntil$1(this.queryDeactivator))
            .subscribe(({ evt, app }) => {
            if (this.data.app == app) {
                this.popup.hide();
                if (this.hsQueryBaseService.currentPanelQueryable(this.data.app) &&
                    this.hsLayoutService.get(this.data.app).mainpanel != 'draw') {
                    this.hsLayoutService.setMainPanel('info', this.data.app);
                }
            }
        });
        this.hsQueryBaseService.getFeatureInfoCollected
            .pipe(takeUntil$1(this.ngUnsubscribe))
            .pipe(takeUntil$1(this.queryDeactivator))
            .subscribe((coordinate) => {
            const invisiblePopup = this.hsQueryBaseService.getInvisiblePopup();
            if (!invisiblePopup) {
                return;
            }
            const bodyElementsFound = this.checkForBodyElements(invisiblePopup.contentDocument.body.children);
            if (bodyElementsFound) {
                //TODO: don't count style, title, meta towards length
                if (this.hsQueryBaseService.popupClassname.length > 0) {
                    this.popup.getElement().className =
                        this.hsQueryBaseService.popupClassname;
                }
                else {
                    this.popup.getElement().className = 'ol-popup';
                }
                this.popup.show(coordinate, invisiblePopup.contentDocument.body.innerHTML);
                this.popupOpens.next('hs.query');
            }
        });
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    /**
     * Check if popup HTML body contains valid elements
     * @param docChildren - Popup HTML collection
     * @returns True or false
     */
    checkForBodyElements(docChildren) {
        return Array.from(docChildren).some((ch) => {
            if (ch.tagName == 'TITLE' && ch.title == '') {
                return false;
            }
            return (ch.tagName != 'SERVICEEXCEPTIONREPORT' &&
                ch.tagName != 'META' &&
                ch.tagName != 'STYLE');
        });
    }
    /**
     * Check if any feature is selected
     * @returns True or false
     */
    noFeatureSelected() {
        return (this.queryBaseAppRef == undefined ||
            (this.queryBaseAppRef.features.length == 0 &&
                (this.queryBaseAppRef.coordinates === undefined ||
                    this.queryBaseAppRef.coordinates.length == 0)));
    }
    showQueryDialog(ev) {
        //TODO Rewrite this to new material design
        /* this.$mdDialog
          .show({
            scope: this,
            preserveScope: true,
            templateUrl: './partials/infopanel.html',
            parent: document.body,
            targetEvent: ev,
            clickOutsideToClose: true,
          })
          .then(
            () => {
              console.log('Closed.');
            },
            () => {
              console.log('Cancelled.');
            }
          ); */
    }
    cancelQueryDialog() {
        //this.$mdDialog.cancel();
    }
    showNoImagesWarning() {
        /*this.$mdToast.show(
          this.$mdToast.simple().textContent('No images matched the query.')
          // .position(pinTo )
          // .hideDelay(3000)
        );*/
    }
}
HsQueryComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsQueryComponent, deps: [{ token: HsQueryBaseService }, { token: HsLayoutService }, { token: HsMapService }, { token: HsEventBusService }, { token: HsQueryVectorService }, { token: HsQueryWmsService }, { token: HsDrawService }, { token: HsSidebarService }, { token: HsLanguageService }], target: i0.ɵɵFactoryTarget.Component });
HsQueryComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsQueryComponent, selector: "hs-query", usesInheritance: true, ngImport: i0, template: "<div class=\"card hs-main-panel\" [hidden]=\"(isVisible$ | async) === false\">\n    <hs-panel-header name=\"info\" [title]=\"'PANEL_HEADER.INFO' | translateHs : data\" [app]=\"data.app\"></hs-panel-header>\n    <div class=\"card hs-main-panel\" *ngIf=\"noFeatureSelected()\">\n        <div class=\"d-flex flex-column align-items-center p-4\">\n            <i class=\"icon-cursor bg-primary p-3 text-white rounded \"\n                style=\"font-size: x-large; color:hsl(208, 100%, 97%)\"></i>\n            <p class=\"h4\">No features selected</p>\n            <p class=\"small\">{{'QUERY.infoPanel.clickOnMap' | translateHs : {app: data.app} }}</p>\n        </div>\n    </div>\n    <hs-query-default-info-panel-body *ngIf=\"layoutAppRef.mainpanel === 'info'\" [app]=\"data.app\">\n    </hs-query-default-info-panel-body>\n    <hs-custom-info-panel-body></hs-custom-info-panel-body>\n    <div class=\"container-fluid\"\n        *ngIf=\"queryBaseAppRef?.coordinates !== undefined && queryBaseAppRef?.coordinates.length > 0\">\n        <div class=\"row\">\n            <div class=\"col-12 m-2\"><strong>{{queryBaseAppRef?.coordinates[0].name}}</strong></div>\n        </div>\n        <div class=\"row\">\n            <div class=\"input-group m-1\">\n                <select class=\"form-control form-select\" [(ngModel)]=\"queryBaseAppRef.selectedProj\"\n                    [ngModelOptions]=\"{standalone: true}\" *ngIf=\"queryBaseAppRef?.coordinates.length>0\">\n                    <option *ngFor=\"let projection of queryBaseAppRef.coordinates[0].projections\"\n                        [ngValue]=\"projection\">{{projection.name}}</option>\n                </select>\n                <input class=\"form-control\" [value]=\"queryBaseAppRef.selectedProj.value\" readonly=\"\">\n            </div>\n        </div>\n    </div>\n\n</div>", components: [{ type: HsPanelHeaderComponent, selector: "hs-panel-header", inputs: ["name", "app", "title"] }, { type: HsQueryDefaultInfoPanelBodyComponent, selector: "hs-query-default-info-panel-body", inputs: ["app"] }], directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3$1.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3$1.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i3$1.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }], pipes: { "async": i3.AsyncPipe, "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsQueryComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-query', template: "<div class=\"card hs-main-panel\" [hidden]=\"(isVisible$ | async) === false\">\n    <hs-panel-header name=\"info\" [title]=\"'PANEL_HEADER.INFO' | translateHs : data\" [app]=\"data.app\"></hs-panel-header>\n    <div class=\"card hs-main-panel\" *ngIf=\"noFeatureSelected()\">\n        <div class=\"d-flex flex-column align-items-center p-4\">\n            <i class=\"icon-cursor bg-primary p-3 text-white rounded \"\n                style=\"font-size: x-large; color:hsl(208, 100%, 97%)\"></i>\n            <p class=\"h4\">No features selected</p>\n            <p class=\"small\">{{'QUERY.infoPanel.clickOnMap' | translateHs : {app: data.app} }}</p>\n        </div>\n    </div>\n    <hs-query-default-info-panel-body *ngIf=\"layoutAppRef.mainpanel === 'info'\" [app]=\"data.app\">\n    </hs-query-default-info-panel-body>\n    <hs-custom-info-panel-body></hs-custom-info-panel-body>\n    <div class=\"container-fluid\"\n        *ngIf=\"queryBaseAppRef?.coordinates !== undefined && queryBaseAppRef?.coordinates.length > 0\">\n        <div class=\"row\">\n            <div class=\"col-12 m-2\"><strong>{{queryBaseAppRef?.coordinates[0].name}}</strong></div>\n        </div>\n        <div class=\"row\">\n            <div class=\"input-group m-1\">\n                <select class=\"form-control form-select\" [(ngModel)]=\"queryBaseAppRef.selectedProj\"\n                    [ngModelOptions]=\"{standalone: true}\" *ngIf=\"queryBaseAppRef?.coordinates.length>0\">\n                    <option *ngFor=\"let projection of queryBaseAppRef.coordinates[0].projections\"\n                        [ngValue]=\"projection\">{{projection.name}}</option>\n                </select>\n                <input class=\"form-control\" [value]=\"queryBaseAppRef.selectedProj.value\" readonly=\"\">\n            </div>\n        </div>\n    </div>\n\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsQueryBaseService }, { type: HsLayoutService }, { type: HsMapService }, { type: HsEventBusService }, { type: HsQueryVectorService }, { type: HsQueryWmsService }, { type: HsDrawService }, { type: HsSidebarService }, { type: HsLanguageService }]; } });

class HsQueryPopupWidgetBaseComponent {
    constructor() {
        this.isVisible$ = new BehaviorSubject(false);
    }
    /**
     * Check if widget is visible
     * @returns True if the widget is visible, false otherwise
     */
    isVisible() {
        return true;
    }
}
HsQueryPopupWidgetBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsQueryPopupWidgetBaseComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
HsQueryPopupWidgetBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsQueryPopupWidgetBaseComponent, selector: "ng-component", ngImport: i0, template: '<div></div>', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsQueryPopupWidgetBaseComponent, decorators: [{
            type: Component,
            args: [{
                    template: '<div></div>',
                }]
        }], ctorParameters: function () { return []; } });

class HsClearLayerComponent extends HsQueryPopupWidgetBaseComponent {
    constructor(hsLayerUtilsService, hsDialogContainerService, hsLanguageService) {
        super();
        this.hsLayerUtilsService = hsLayerUtilsService;
        this.hsDialogContainerService = hsDialogContainerService;
        this.hsLanguageService = hsLanguageService;
        this.name = 'clear-layer';
    }
    ngOnInit() {
        this.layerDescriptor = this.data.layerDescriptor;
    }
    /**
     * Clear all layer source
     * @param layer - Layer selected
     */
    clearLayer(layer) {
        return __awaiter(this, void 0, void 0, function* () {
            const dialog = this.hsDialogContainerService.create(HsConfirmDialogComponent, {
                message: this.hsLanguageService
                    .getTranslation('QUERY.reallyDeleteAllFeaturesFrom', undefined, this.data.app)
                    .replace('{0}', getTitle(layer)),
                title: this.hsLanguageService.getTranslation('QUERY.confirmClear', undefined, this.data.app),
            }, this.data.app);
            const confirmed = yield dialog.waitResult();
            if (confirmed == 'yes') {
                if (layer.getSource().getSource) {
                    //Clear clustered?
                    layer.getSource().getSource().clear();
                }
                layer.getSource().clear();
                this.data.service.apps[this.data.app].featuresUnderMouse = [];
            }
        });
    }
    /**
     * Check if layer is editable
     * @param layer - Layer selected
     * @returns True if the layer is editable, false otherwise
     */
    isLayerEditable(layer) {
        return this.hsLayerUtilsService.isLayerEditable(layer);
    }
}
HsClearLayerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsClearLayerComponent, deps: [{ token: HsLayerUtilsService }, { token: HsDialogContainerService }, { token: HsLanguageService }], target: i0.ɵɵFactoryTarget.Component });
HsClearLayerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsClearLayerComponent, selector: "hs-clear-layer", inputs: { data: "data" }, usesInheritance: true, ngImport: i0, template: "<div class=\"d-flex justify-content-center\">\n  <a class=\"text-danger\" (click)=\"clearLayer(layerDescriptor.layer)\"\n    *ngIf=\"isLayerEditable(layerDescriptor.layer)\" data-toggle=\"tooltip\"\n    [title]=\"'QUERY.featurePopup.clearLayer'| translateHs : data\"><!-- TODO: Remove function call from template -->\n    {{'QUERY.featurePopup.clearLayer' | translateHs : {app: data.app} }}\n  </a>\n</div>", directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "translateHs": TranslateCustomPipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsClearLayerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-clear-layer', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"d-flex justify-content-center\">\n  <a class=\"text-danger\" (click)=\"clearLayer(layerDescriptor.layer)\"\n    *ngIf=\"isLayerEditable(layerDescriptor.layer)\" data-toggle=\"tooltip\"\n    [title]=\"'QUERY.featurePopup.clearLayer'| translateHs : data\"><!-- TODO: Remove function call from template -->\n    {{'QUERY.featurePopup.clearLayer' | translateHs : {app: data.app} }}\n  </a>\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsLayerUtilsService }, { type: HsDialogContainerService }, { type: HsLanguageService }]; }, propDecorators: { data: [{
                type: Input
            }] } });

class HsDynamicTextComponent extends HsQueryPopupWidgetBaseComponent {
    constructor(sanitizer) {
        super();
        this.sanitizer = sanitizer;
        this.name = 'dynamic-text';
    }
    ngOnInit() {
        this.layerDescriptor = this.data.layerDescriptor;
    }
    /**
     * Generate dynamic text content using display function
     * @param feature - Feature selected
     * @returns Safe HTML
     */
    generateContent(feature) {
        const displayFunction = getPopUp(this.layerDescriptor.layer).displayFunction;
        const content = displayFunction(feature);
        return this.sanitizer.bypassSecurityTrustHtml(content);
    }
}
HsDynamicTextComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsDynamicTextComponent, deps: [{ token: i1$3.DomSanitizer }], target: i0.ɵɵFactoryTarget.Component });
HsDynamicTextComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsDynamicTextComponent, selector: "hs-dynamic-text", inputs: { data: "data" }, usesInheritance: true, ngImport: i0, template: "<ng-container *ngFor=\"let feature of layerDescriptor.features\">\n    <div [innerHtml]=\"generateContent(feature)\"></div><!-- TODO: Remove function call from template -->\n</ng-container>", directives: [{ type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsDynamicTextComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-dynamic-text', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngFor=\"let feature of layerDescriptor.features\">\n    <div [innerHtml]=\"generateContent(feature)\"></div><!-- TODO: Remove function call from template -->\n</ng-container>" }]
        }], ctorParameters: function () { return [{ type: i1$3.DomSanitizer }]; }, propDecorators: { data: [{
                type: Input
            }] } });

class HsFeatureInfoComponent extends HsQueryPopupWidgetBaseComponent {
    constructor(hsLanguageService, hsQueryVectorService, hsDialogContainerService) {
        super();
        this.hsLanguageService = hsLanguageService;
        this.hsQueryVectorService = hsQueryVectorService;
        this.hsDialogContainerService = hsDialogContainerService;
        this.attributesForHover = [];
        this.name = 'feature-info';
    }
    ngOnInit() {
        this.layerDescriptor = this.data.layerDescriptor;
        this.attributesForHover = this.data.attributesForHover;
    }
    /**
     * Serialize feature name. Searches for 'title', 'name' and 'label' properties. If the feature is a cluster, a description of the cluster is returned instead.
     * @param feature - Feature selected
     * @returns Serialized feature name
     */
    serializeFeatureName(feature) {
        if (!feature) {
            return;
        }
        if (getFeatureName(feature)) {
            return getFeatureName(feature);
        }
        if (getFeatureTitle(feature)) {
            return getFeatureTitle(feature);
        }
        if (getFeatureLabel(feature)) {
            return getFeatureLabel(feature);
        }
        if (getFeatures(feature)) {
            return this.hsLanguageService.getTranslation('QUERY.clusterContaining', {
                count: getFeatures(feature).length,
            }, this.data.app);
        }
        return this.hsLanguageService.getTranslation('QUERY.untitledFeature', undefined, this.data.app);
    }
    /**
     * Remove feature
     * @param feature - Feature selected
     */
    removeFeature(feature) {
        return __awaiter(this, void 0, void 0, function* () {
            const dialog = this.hsDialogContainerService.create(HsConfirmDialogComponent, {
                message: this.hsLanguageService.getTranslation('QUERY.reallyDelete', undefined, this.data.app),
                title: this.hsLanguageService.getTranslation('QUERY.confirmDelete', undefined, this.data.app),
            }, this.data.app);
            const confirmed = yield dialog.waitResult();
            if (confirmed == 'yes') {
                this.hsQueryVectorService.removeFeature(feature, this.data.app);
                this.data.service.apps[this.data.app].featuresUnderMouse = [];
            }
        });
    }
    /**
     * Check if feature is a cluster
     * @param feature - Feature selected
     * @returns True if the feature is a cluster, false otherwise
     */
    isClustered(feature) {
        return getFeatures(feature) && getFeatures(feature).length > 0;
    }
    /**
     * Check if feature has sub-features
     * @param feature - Feature selected
     * @returns True if this cluster has more than 1 sub-feature, false otherwise
     */
    hasMultipleSubFeatures(feature) {
        return getFeatures(feature).length > 1;
    }
    /**
     * Check if feature is removable
     * @param feature - Feature selected
     * @returns True if the feature is removable, false otherwise
     */
    isFeatureRemovable(feature) {
        return this.hsQueryVectorService.isFeatureRemovable(feature, this.data.app);
    }
    /**
     * Translate string value to the selected UI language
     * @param module - Locales json key
     * @param text - Locales json key value
     * @returns Translated text
     */
    translateString(module, text) {
        return this.hsLanguageService.getTranslationIgnoreNonExisting(module, text, undefined, this.data.app);
    }
}
HsFeatureInfoComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsFeatureInfoComponent, deps: [{ token: HsLanguageService }, { token: HsQueryVectorService }, { token: HsDialogContainerService }], target: i0.ɵɵFactoryTarget.Component });
HsFeatureInfoComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsFeatureInfoComponent, selector: "hs-feature-info", inputs: { data: "data" }, usesInheritance: true, ngImport: i0, template: "<!-- Feature header template -->\n<ng-template #featureHeader let-feature=\"feature\" let-type=\"type\">\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 flex-grow-1\"><em>{{serializeFeatureName(feature)}}</em></div><!-- TODO: Remove function call from template -->\n    <a class=\"p-1\" *ngIf=\"isFeatureRemovable(feature) && type\" (click)=\"removeFeature(feature)\" data-toggle=\"tooltip\"\n      [title]=\"'QUERY.featurePopup.' + type | translateHs : data\">\n      <i class=\"icon-remove-circle\" style=\"color: rgb(228, 99, 99)\"></i>\n    </a>\n  </div>\n</ng-template>\n\n<!-- Feature attribute row template -->\n<ng-template #featureAttribute let-attributes=\"attributes\">\n  <div *ngFor=\"let attribute of attributes\" class=\"d-flex flex-row\">\n    <ng-container *ngIf=\"attribute.key\">\n      <div class=\"p-1 flex-grow-1\">\n        {{translateString(\n        'FEATURE_TABLE',\n        attribute.key\n        )}}\u2003\n      </div>\n    </ng-container>\n    <ng-container *ngIf=\"attribute.displayFunction\">\n      <div class=\"p-1\" [innerHtml]=\"attribute.displayFunction(attribute.value)\"></div><!-- TODO: Remove function call from template -->\n    </ng-container>\n  </div>\n</ng-template>\n\n<!-- Layout for clustered layers -->\n<ng-container *ngFor=\"let feature of layerDescriptor.features\">\n  <div *ngIf=\"isClustered(feature); else nonClusteredPopUp\"\n    style=\"font-size: small; line-height: 1; margin-bottom: 2px; border-bottom: 2px solid rgb(199, 199, 199)\"><!-- TODO: Remove function call from template -->\n    <div class=\"d-flex flex-column\">\n      <ng-container *ngTemplateOutlet=\"featureHeader;context:{feature: feature}\"></ng-container>\n      <div [hidden]=\"!(attributesForHover.length > 0)\" class=\"ms-1 mt-1\">\n        <ng-container *ngFor=\"let attribute of attributesForHover\">\n          <div *ngIf=\"attribute.feature\"\n            [ngClass]=\"{'d-flex flex-column hs-hover-popup-feature' : hasMultipleSubFeatures(feature)}\"><!-- TODO: Remove function call from template -->\n            <ng-container\n              *ngTemplateOutlet=\"featureHeader;context:{feature: attribute.feature, type: 'removeClusterPart'}\">\n            </ng-container>\n            <ng-container *ngTemplateOutlet=\"featureAttribute;context:{attributes: attribute.attributes}\">\n            </ng-container>\n          </div>\n        </ng-container>\n      </div>\n    </div>\n  </div>\n  <!-- Layout for non-clustered layers -->\n  <ng-template #nonClusteredPopUp>\n    <div class=\"hs-hover-popup-feature\">\n      <ng-container *ngTemplateOutlet=\"featureHeader;context:{feature: feature, type: 'removeFeature'}\">\n      </ng-container>\n      <ng-container\n        *ngTemplateOutlet=\"featureAttribute;context:{attributes: data.service.serializeFeatureAttributes(feature, data.app)}\"><!-- TODO: Remove function call from template -->\n      </ng-container>\n    </div>\n  </ng-template>\n</ng-container>", directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], pipes: { "translateHs": TranslateCustomPipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsFeatureInfoComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-feature-info', changeDetection: ChangeDetectionStrategy.OnPush, template: "<!-- Feature header template -->\n<ng-template #featureHeader let-feature=\"feature\" let-type=\"type\">\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 flex-grow-1\"><em>{{serializeFeatureName(feature)}}</em></div><!-- TODO: Remove function call from template -->\n    <a class=\"p-1\" *ngIf=\"isFeatureRemovable(feature) && type\" (click)=\"removeFeature(feature)\" data-toggle=\"tooltip\"\n      [title]=\"'QUERY.featurePopup.' + type | translateHs : data\">\n      <i class=\"icon-remove-circle\" style=\"color: rgb(228, 99, 99)\"></i>\n    </a>\n  </div>\n</ng-template>\n\n<!-- Feature attribute row template -->\n<ng-template #featureAttribute let-attributes=\"attributes\">\n  <div *ngFor=\"let attribute of attributes\" class=\"d-flex flex-row\">\n    <ng-container *ngIf=\"attribute.key\">\n      <div class=\"p-1 flex-grow-1\">\n        {{translateString(\n        'FEATURE_TABLE',\n        attribute.key\n        )}}\u2003\n      </div>\n    </ng-container>\n    <ng-container *ngIf=\"attribute.displayFunction\">\n      <div class=\"p-1\" [innerHtml]=\"attribute.displayFunction(attribute.value)\"></div><!-- TODO: Remove function call from template -->\n    </ng-container>\n  </div>\n</ng-template>\n\n<!-- Layout for clustered layers -->\n<ng-container *ngFor=\"let feature of layerDescriptor.features\">\n  <div *ngIf=\"isClustered(feature); else nonClusteredPopUp\"\n    style=\"font-size: small; line-height: 1; margin-bottom: 2px; border-bottom: 2px solid rgb(199, 199, 199)\"><!-- TODO: Remove function call from template -->\n    <div class=\"d-flex flex-column\">\n      <ng-container *ngTemplateOutlet=\"featureHeader;context:{feature: feature}\"></ng-container>\n      <div [hidden]=\"!(attributesForHover.length > 0)\" class=\"ms-1 mt-1\">\n        <ng-container *ngFor=\"let attribute of attributesForHover\">\n          <div *ngIf=\"attribute.feature\"\n            [ngClass]=\"{'d-flex flex-column hs-hover-popup-feature' : hasMultipleSubFeatures(feature)}\"><!-- TODO: Remove function call from template -->\n            <ng-container\n              *ngTemplateOutlet=\"featureHeader;context:{feature: attribute.feature, type: 'removeClusterPart'}\">\n            </ng-container>\n            <ng-container *ngTemplateOutlet=\"featureAttribute;context:{attributes: attribute.attributes}\">\n            </ng-container>\n          </div>\n        </ng-container>\n      </div>\n    </div>\n  </div>\n  <!-- Layout for non-clustered layers -->\n  <ng-template #nonClusteredPopUp>\n    <div class=\"hs-hover-popup-feature\">\n      <ng-container *ngTemplateOutlet=\"featureHeader;context:{feature: feature, type: 'removeFeature'}\">\n      </ng-container>\n      <ng-container\n        *ngTemplateOutlet=\"featureAttribute;context:{attributes: data.service.serializeFeatureAttributes(feature, data.app)}\"><!-- TODO: Remove function call from template -->\n      </ng-container>\n    </div>\n  </ng-template>\n</ng-container>" }]
        }], ctorParameters: function () { return [{ type: HsLanguageService }, { type: HsQueryVectorService }, { type: HsDialogContainerService }]; }, propDecorators: { data: [{
                type: Input
            }] } });

class HsLayerNameComponent extends HsQueryPopupWidgetBaseComponent {
    constructor(hsLayerUtilsService) {
        super();
        this.hsLayerUtilsService = hsLayerUtilsService;
        this.name = 'layer-name';
    }
    ngOnInit() {
        this.layerDescriptor = this.data.layerDescriptor;
    }
    /**
     * Get title translation
     * @param title - Title to translate
     * @returns Translated title
     */
    translateTitle(title) {
        return this.hsLayerUtilsService.translateTitle(title, this.data.app);
    }
}
HsLayerNameComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerNameComponent, deps: [{ token: HsLayerUtilsService }], target: i0.ɵɵFactoryTarget.Component });
HsLayerNameComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsLayerNameComponent, selector: "hs-layer-name", inputs: { data: "data" }, usesInheritance: true, ngImport: i0, template: "<strong style=\"font-size: small;\">{{layerDescriptor.title | translateHs : {app: data.app, module: 'LAYERS'} }}</strong>", pipes: { "translateHs": TranslateCustomPipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerNameComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-layer-name', changeDetection: ChangeDetectionStrategy.OnPush, template: "<strong style=\"font-size: small;\">{{layerDescriptor.title | translateHs : {app: data.app, module: 'LAYERS'} }}</strong>" }]
        }], ctorParameters: function () { return [{ type: HsLayerUtilsService }]; }, propDecorators: { data: [{
                type: Input
            }] } });

class HsQueryPopupWidgetContainerService extends HsPanelContainerService {
    constructor(hsConfig) {
        super();
        this.hsConfig = hsConfig;
        this.queryPopupWidgets = [
            { name: 'layer-name', component: HsLayerNameComponent },
            { name: 'feature-info', component: HsFeatureInfoComponent },
            { name: 'clear-layer', component: HsClearLayerComponent },
            { name: 'dynamic-text', component: HsDynamicTextComponent },
        ];
    }
    /**
     * Initialize query popup widgets
     * @param widgetNames - Array of widget names
     * @param app - App identifier
     * @param panelObserver - (Optional)
     */
    initWidgets(widgetNames, app, panelObserver) {
        var _a;
        if ((widgetNames === null || widgetNames === void 0 ? void 0 : widgetNames.length) > 0) {
            for (const widgetName of widgetNames) {
                let widgetFound = this.queryPopupWidgets.find((widget) => widget.name == widgetName);
                if (!widgetFound &&
                    ((_a = this.hsConfig.get(app).customQueryPopupWidgets) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    widgetFound = this.hsConfig
                        .get(app)
                        .customQueryPopupWidgets.find((widget) => widget.name == widgetName);
                }
                this.create(widgetFound.component, undefined, app, panelObserver);
            }
        }
    }
}
HsQueryPopupWidgetContainerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsQueryPopupWidgetContainerService, deps: [{ token: HsConfig }], target: i0.ɵɵFactoryTarget.Injectable });
HsQueryPopupWidgetContainerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsQueryPopupWidgetContainerService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsQueryPopupWidgetContainerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsConfig }]; } });

class HsQueryPopupComponent {
    constructor(hsEventBusService, hsMapService, ElementRef, hsQueryPopupWidgetContainerService, hsConfig, HsQueryVectorService) {
        this.hsEventBusService = hsEventBusService;
        this.hsMapService = hsMapService;
        this.ElementRef = ElementRef;
        this.hsQueryPopupWidgetContainerService = hsQueryPopupWidgetContainerService;
        this.hsConfig = hsConfig;
        this.HsQueryVectorService = HsQueryVectorService;
        this.getFeatures = getFeatures;
        this.attributesForHover = [];
        this.isVisible$ = new BehaviorSubject(true);
    }
    ngAfterViewInit() {
        this.data.service.registerPopup(this.ElementRef.nativeElement, this.data.app);
    }
    ngOnInit() {
        this.dataAppRef = this.data.service.apps[this.data.app];
        this.HsQueryVectorService.init(this.data.app);
        this.olMapLoadsSubscription = this.hsEventBusService.olMapLoads.subscribe(({ map, app }) => {
            if (app == this.data.app) {
                map.addOverlay(this.dataAppRef.hoverPopup);
            }
        });
        this.hsQueryPopupWidgetContainerService.initWidgets(this.hsConfig.get(this.data.app).queryPopupWidgets, this.data.app);
    }
    ngOnDestroy() {
        this.hsMapService
            .getMap(this.data.app)
            .removeOverlay(this.dataAppRef.hoverPopup);
        this.olMapLoadsSubscription.unsubscribe();
    }
    /**
     * Return popup visibility state
     */
    popupVisible() {
        const DISPLAY_NONE = {
            'display': 'none',
        };
        if (this.dataAppRef == undefined) {
            return DISPLAY_NONE;
        }
        const featuresWithPopup = this.dataAppRef.featuresUnderMouse.filter((f) => {
            const layer = this.hsMapService.getLayerForFeature(f, this.data.app);
            if (!layer) {
                return DISPLAY_NONE;
            }
            return getPopUp(layer) != undefined;
        });
        const featureCount = featuresWithPopup.length;
        if (featureCount > 0) {
            let tmpForHover = [];
            this.dataAppRef.featuresUnderMouse.forEach((feature) => {
                tmpForHover = tmpForHover.concat(this.data.service.serializeFeatureAttributes(feature, this.data.app));
                if (getFeatures(feature)) {
                    getFeatures(feature).forEach((subfeature) => {
                        const subFeatureObj = {};
                        subFeatureObj.feature = subfeature;
                        subFeatureObj.attributes =
                            this.data.service.serializeFeatureAttributes(subfeature, this.data.app);
                        tmpForHover.push(subFeatureObj);
                    });
                }
            });
            this.attributesForHover = tmpForHover.filter((f) => f);
        }
        return {
            'display': featureCount > 0 ? 'block' : 'none',
        };
    }
}
HsQueryPopupComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsQueryPopupComponent, deps: [{ token: HsEventBusService }, { token: HsMapService }, { token: i0.ElementRef }, { token: HsQueryPopupWidgetContainerService }, { token: HsConfig }, { token: HsQueryVectorService }], target: i0.ɵɵFactoryTarget.Component });
HsQueryPopupComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsQueryPopupComponent, selector: "hs-query-popup", ngImport: i0, template: "<div [ngStyle]=\"popupVisible()\" class=\"hs-hover-popup\">\n    <div class=\"card\">\n        <a class=\"p-1\" (click)=\"data.service.closePopup(data.app)\" data-toggle=\"tooltip\"\n            [title]=\"'QUERY.featurePopup.closePopup' | translateHs : data\">\n            <i class=\"icon-remove-circle\"></i>\n        </a>\n        <div *ngFor=\"let layerDesc of dataAppRef.featureLayersUnderMouse; let i = index\" class=\"hs-popup-layer\">\n            <hs-panel-container [service]=\"hsQueryPopupWidgetContainerService\" [app]=\"data.app\"\n                [reusePanelObserver]=\"true\" [panelObserver]=\"layerDesc.panelObserver\"\n                [data]=\"{layerDescriptor: layerDesc, attributesForHover: attributesForHover, service: data.service, app: data.app}\">\n            </hs-panel-container>\n        </div>\n    </div>\n</div>", components: [{ type: HsPanelContainerComponent, selector: "hs-panel-container", inputs: ["service", "data", "app", "reusePanelObserver", "panelObserver"], outputs: ["init"] }], directives: [{ type: i3.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsQueryPopupComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-query-popup', template: "<div [ngStyle]=\"popupVisible()\" class=\"hs-hover-popup\">\n    <div class=\"card\">\n        <a class=\"p-1\" (click)=\"data.service.closePopup(data.app)\" data-toggle=\"tooltip\"\n            [title]=\"'QUERY.featurePopup.closePopup' | translateHs : data\">\n            <i class=\"icon-remove-circle\"></i>\n        </a>\n        <div *ngFor=\"let layerDesc of dataAppRef.featureLayersUnderMouse; let i = index\" class=\"hs-popup-layer\">\n            <hs-panel-container [service]=\"hsQueryPopupWidgetContainerService\" [app]=\"data.app\"\n                [reusePanelObserver]=\"true\" [panelObserver]=\"layerDesc.panelObserver\"\n                [data]=\"{layerDescriptor: layerDesc, attributesForHover: attributesForHover, service: data.service, app: data.app}\">\n            </hs-panel-container>\n        </div>\n    </div>\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsEventBusService }, { type: HsMapService }, { type: i0.ElementRef }, { type: HsQueryPopupWidgetContainerService }, { type: HsConfig }, { type: HsQueryVectorService }]; } });

class HsSaveMapDialogComponent {
    constructor(hsDialogContainerService, hsSaveMapManagerService) {
        this.hsDialogContainerService = hsDialogContainerService;
        this.hsSaveMapManagerService = hsSaveMapManagerService;
    }
    ngOnInit() {
        this.appRef = this.hsSaveMapManagerService.get(this.data.app);
    }
    close() {
        this.hsDialogContainerService.destroy(this, this.data.app);
    }
    /**
     * Initiate composition saving procedure
     * @param saveAsNew - If true save composition as new, otherwise overwrite to current one
     */
    save(saveAsNew) {
        this.hsSaveMapManagerService.save(saveAsNew, this.data.endpoint, this.data.app);
        this.close();
    }
    /**
     * Select new composition's title
     */
    selectNewName() {
        this.hsSaveMapManagerService.selectNewName(this.data.app);
    }
    /**
     * Focus the browser to composition's title
     */
    focusTitle() {
        this.hsSaveMapManagerService.focusTitle(this.data.app);
        this.close();
    }
}
HsSaveMapDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSaveMapDialogComponent, deps: [{ token: HsDialogContainerService }, { token: HsSaveMapManagerService }], target: i0.ɵɵFactoryTarget.Component });
HsSaveMapDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsSaveMapDialogComponent, selector: "hs-save-map-dialog-save", ngImport: i0, template: "<div class=\"modal hs-status-creator-save-dialog in\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h4 class=\"modal-title\">\n                    {{'SAVECOMPOSITION.dialogSave.saveComposition' | translateHs : {app: data.app} }}\n                </h4>\n                <button type=\"button\" (click)=\"close()\" class=\"btn-close\" data-dismiss=\"modal\"\n                    attr.aria-label=\"{{'COMMON.close' | translateHs : {app: data.app} }}\"></button>\n            </div>\n            <div class=\"modal-body\" style=\"max-height: 600px; overflow-y: auto; text-align: center; font-size: 16px\">\n                <div>\n                    {{'SAVECOMPOSITION.dialogSave.areYouAttempting' | translateHs : {app: data.app} }}\n                </div>\n                <div>\n                    <b>{{appRef.compoData.name}}</b>\n                </div>\n                <div\n                    *ngIf=\"!appRef.statusData?.titleFree && appRef.statusData?.hasPermission && !appRef.statusData?.changeTitle\">\n                    <div>\n                        {{'SAVECOMPOSITION.dialogSave.wantToOverwrite' | translateHs : {app: data.app} }}\n                        <b>{{appRef.compoData.name}}</b>\n                    </div>\n                    <p>\n                        <button type=\"button\" class=\"btn btn-secondary btn-lg\" data-dismiss=\"modal\"\n                            (click)=\"save(false)\">{{'SAVECOMPOSITION.dialogSave.yesSave'\n                            | translateHs : {app: data.app} }}</button>\n                    </p>\n                    <p>\n                        <button type=\"button\" class=\"btn btn-secondary btn-lg\"\n                            (click)=\"selectNewName()\">{{'SAVECOMPOSITION.dialogSave.noSaveAs'\n                            | translateHs : {app: data.app} }}</button>\n                    </p>\n                </div>\n\n                <div\n                    *ngIf=\"!appRef.statusData?.titleFree && appRef.statusData?.hasPermission && appRef.statusData?.changeTitle\">\n                    <div>{{'SAVECOMPOSITION.dialogSave.selectNewNameForMap' | translateHs : {app: data.app} }}</div>\n                    <p>\n                        <input type=\"text\" class=\"form-control hs-stc-title\" [(ngModel)]=\"appRef.compoData.name\">\n                    </p>\n                    <p>\n                        <button type=\"button\" class=\"btn btn-secondary btn-lg\" data-dismiss=\"modal\"\n                            (click)=\"save(true); close()\">{{'COMMON.save'\n                            | translateHs : {app: data.app} }}</button>\n                    </p>\n                </div>\n\n                <div *ngIf=\"!appRef.statusData?.titleFree || !appRef.statusData?.hasPermission\">\n                    <div>\n                        <p *ngIf=\"!appRef.statusData?.hasPermission\">{{'SAVECOMPOSITION.dialogSave.youDoNotHave' |\n                            translateHs : {app: data.app} }}\n                        </p>\n                        <p *ngIf=\"!appRef.statusData?.titleFree\">{{'SAVECOMPOSITION.dialogSave.useDifferentName' |\n                            translateHs : {app: data.app} }}\n                        </p>\n                    </div>\n                    <p>\n                        <button type=\"button\" class=\"btn btn-secondary btn-lg\" data-dismiss=\"modal\"\n                            (click)=\"focusTitle()\">{{'COMMON.ok' |\n                            translateHs : {app: data.app} }}</button>\n                    </p>\n                </div>\n\n            </div>\n        </div>\n    </div>\n</div>", directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSaveMapDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-save-map-dialog-save', template: "<div class=\"modal hs-status-creator-save-dialog in\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h4 class=\"modal-title\">\n                    {{'SAVECOMPOSITION.dialogSave.saveComposition' | translateHs : {app: data.app} }}\n                </h4>\n                <button type=\"button\" (click)=\"close()\" class=\"btn-close\" data-dismiss=\"modal\"\n                    attr.aria-label=\"{{'COMMON.close' | translateHs : {app: data.app} }}\"></button>\n            </div>\n            <div class=\"modal-body\" style=\"max-height: 600px; overflow-y: auto; text-align: center; font-size: 16px\">\n                <div>\n                    {{'SAVECOMPOSITION.dialogSave.areYouAttempting' | translateHs : {app: data.app} }}\n                </div>\n                <div>\n                    <b>{{appRef.compoData.name}}</b>\n                </div>\n                <div\n                    *ngIf=\"!appRef.statusData?.titleFree && appRef.statusData?.hasPermission && !appRef.statusData?.changeTitle\">\n                    <div>\n                        {{'SAVECOMPOSITION.dialogSave.wantToOverwrite' | translateHs : {app: data.app} }}\n                        <b>{{appRef.compoData.name}}</b>\n                    </div>\n                    <p>\n                        <button type=\"button\" class=\"btn btn-secondary btn-lg\" data-dismiss=\"modal\"\n                            (click)=\"save(false)\">{{'SAVECOMPOSITION.dialogSave.yesSave'\n                            | translateHs : {app: data.app} }}</button>\n                    </p>\n                    <p>\n                        <button type=\"button\" class=\"btn btn-secondary btn-lg\"\n                            (click)=\"selectNewName()\">{{'SAVECOMPOSITION.dialogSave.noSaveAs'\n                            | translateHs : {app: data.app} }}</button>\n                    </p>\n                </div>\n\n                <div\n                    *ngIf=\"!appRef.statusData?.titleFree && appRef.statusData?.hasPermission && appRef.statusData?.changeTitle\">\n                    <div>{{'SAVECOMPOSITION.dialogSave.selectNewNameForMap' | translateHs : {app: data.app} }}</div>\n                    <p>\n                        <input type=\"text\" class=\"form-control hs-stc-title\" [(ngModel)]=\"appRef.compoData.name\">\n                    </p>\n                    <p>\n                        <button type=\"button\" class=\"btn btn-secondary btn-lg\" data-dismiss=\"modal\"\n                            (click)=\"save(true); close()\">{{'COMMON.save'\n                            | translateHs : {app: data.app} }}</button>\n                    </p>\n                </div>\n\n                <div *ngIf=\"!appRef.statusData?.titleFree || !appRef.statusData?.hasPermission\">\n                    <div>\n                        <p *ngIf=\"!appRef.statusData?.hasPermission\">{{'SAVECOMPOSITION.dialogSave.youDoNotHave' |\n                            translateHs : {app: data.app} }}\n                        </p>\n                        <p *ngIf=\"!appRef.statusData?.titleFree\">{{'SAVECOMPOSITION.dialogSave.useDifferentName' |\n                            translateHs : {app: data.app} }}\n                        </p>\n                    </div>\n                    <p>\n                        <button type=\"button\" class=\"btn btn-secondary btn-lg\" data-dismiss=\"modal\"\n                            (click)=\"focusTitle()\">{{'COMMON.ok' |\n                            translateHs : {app: data.app} }}</button>\n                    </p>\n                </div>\n\n            </div>\n        </div>\n    </div>\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsDialogContainerService }, { type: HsSaveMapManagerService }]; } });

class HsSaveMapResultDialogComponent {
    constructor(hsDialogContainerService, hsSaveMapManagerService) {
        this.hsDialogContainerService = hsDialogContainerService;
        this.hsSaveMapManagerService = hsSaveMapManagerService;
    }
    ngOnInit() {
        this.appRef = this.hsSaveMapManagerService.get(this.data.app);
    }
    close() {
        this.hsDialogContainerService.destroy(this, this.data.app);
    }
    /**
     * Initiate composition's saving procedure
     * @param newSave - If true save a new composition, otherwise overwrite to current one
     */
    initiateSave(newSave) {
        this.hsSaveMapManagerService.initiateSave(newSave, this.data.app);
        this.close();
    }
    /**
     * Request to change composition's name to a new one
     */
    changeName() {
        this.hsSaveMapManagerService.get(this.data.app).saveMapResulted.next({
            statusData: 'rename',
            app: this.data.app,
        });
        this.close();
    }
}
HsSaveMapResultDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSaveMapResultDialogComponent, deps: [{ token: HsDialogContainerService }, { token: HsSaveMapManagerService }], target: i0.ɵɵFactoryTarget.Component });
HsSaveMapResultDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsSaveMapResultDialogComponent, selector: "hs-save-map-dialog-result", ngImport: i0, template: "<div class=\"modal hs-status-creator-result-dialog in\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h4 class=\"modal-title\">\n                    {{'SAVECOMPOSITION.dialogResult.savingCompositionStatus' | translateHs : {app: data.app} }}\n                </h4>\n                <button type=\"button\" (click)=\"close()\" class=\"btn-close\" data-dismiss=\"modal\"\n                    attr.aria-label=\"{{'COMMON.close' | translateHs : {app: data.app} }}\">\n                </button>\n            </div>\n            <div class=\"modal-body\" style=\"max-height:600px; overflow-y:auto\">\n                <div class=\"alert alert-status\" [hidden]=\"!appRef.statusData.status\">\n                    {{'SAVECOMPOSITION.dialogResult.compositionSavedSuccessfully' | translateHs : {app: data.app} }}</div>\n                <div class=\"alert alert-danger\" [hidden]=\"!!appRef.statusData.status\">\n                    {{'SAVECOMPOSITION.dialogResult.compositionFailedToSave' | translateHs : {app: data.app} }}</div>\n                <div class=\"alert alert-danger\"\n                    [hidden]=\"!(!appRef.statusData.status && appRef.statusData.resultCode === 'not-saved')\">\n                    {{'SAVECOMPOSITION.dialogResult.requestWasProcessed' | translateHs : {app: data.app} }}</div>\n                <div class=\"alert alert-danger\"\n                    [hidden]=\"!(!appRef.statusData.status && appRef.statusData.resultCode === 'exists')\">\n                    Map already exists\n\n                </div>\n                <div class=\"alert alert-danger\"\n                    [hidden]=\"!(!appRef.statusData.status && appRef.statusData.resultCode === 'error')\">\n                    {{'SAVECOMPOSITION.dialogResult.serverDidNotRespond' | translateHs : {app: data.app} }}</div>\n                <div class=\"alert alert-danger\"\n                    [hidden]=\"!(!appRef.statusData.status && appRef.statusData.resultCode === 'error')\">\n                    <dl *ngFor=\"let item of appRef.statusData.error | keyvalue\">\n                        <dt>{{item.key}} </dt>\n                        <dd>\n                            <hs-widgets-recursive-dd [value]=\"item.value\" [app]=\"data.app\"></hs-widgets-recursive-dd>\n                        </dd>\n                    </dl>\n                </div>\n            </div>\n            <div class=\"modal-footer\"\n                [ngClass]=\"{'justify-content-between' : appRef.statusData.resultCode === 'exists' }\">\n                <div *ngIf=\"!appRef.statusData.status && appRef.statusData.resultCode === 'exists'\">\n                    <button type=\"button\" class=\"btn btn-primary\"\n                        (click)=\"initiateSave(false)\">{{'SAVECOMPOSITION.form.overwrite' | translateHs : {app: data.app} }}</button>\n                    <button type=\"button\" class=\"btn btn-primary ms-2\"\n                        (click)=\"changeName()\">{{'SAVECOMPOSITION.form.changeName' | translateHs : {app: data.app} }}</button>\n                </div>\n                <button type=\"button\" class=\"btn btn-primary\" (click)=\"close()\" data-dismiss=\"modal\">{{'COMMON.close' |\n                    translateHs : {app: data.app} }}</button>\n            </div>\n        </div>\n    </div>\n</div>\n", components: [{ type: HsUiExtensionsRecursiveDdComponent, selector: "hs-widgets-recursive-dd", inputs: ["value", "app"] }], directives: [{ type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "translateHs": TranslateCustomPipe, "keyvalue": i3.KeyValuePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSaveMapResultDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-save-map-dialog-result', template: "<div class=\"modal hs-status-creator-result-dialog in\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h4 class=\"modal-title\">\n                    {{'SAVECOMPOSITION.dialogResult.savingCompositionStatus' | translateHs : {app: data.app} }}\n                </h4>\n                <button type=\"button\" (click)=\"close()\" class=\"btn-close\" data-dismiss=\"modal\"\n                    attr.aria-label=\"{{'COMMON.close' | translateHs : {app: data.app} }}\">\n                </button>\n            </div>\n            <div class=\"modal-body\" style=\"max-height:600px; overflow-y:auto\">\n                <div class=\"alert alert-status\" [hidden]=\"!appRef.statusData.status\">\n                    {{'SAVECOMPOSITION.dialogResult.compositionSavedSuccessfully' | translateHs : {app: data.app} }}</div>\n                <div class=\"alert alert-danger\" [hidden]=\"!!appRef.statusData.status\">\n                    {{'SAVECOMPOSITION.dialogResult.compositionFailedToSave' | translateHs : {app: data.app} }}</div>\n                <div class=\"alert alert-danger\"\n                    [hidden]=\"!(!appRef.statusData.status && appRef.statusData.resultCode === 'not-saved')\">\n                    {{'SAVECOMPOSITION.dialogResult.requestWasProcessed' | translateHs : {app: data.app} }}</div>\n                <div class=\"alert alert-danger\"\n                    [hidden]=\"!(!appRef.statusData.status && appRef.statusData.resultCode === 'exists')\">\n                    Map already exists\n\n                </div>\n                <div class=\"alert alert-danger\"\n                    [hidden]=\"!(!appRef.statusData.status && appRef.statusData.resultCode === 'error')\">\n                    {{'SAVECOMPOSITION.dialogResult.serverDidNotRespond' | translateHs : {app: data.app} }}</div>\n                <div class=\"alert alert-danger\"\n                    [hidden]=\"!(!appRef.statusData.status && appRef.statusData.resultCode === 'error')\">\n                    <dl *ngFor=\"let item of appRef.statusData.error | keyvalue\">\n                        <dt>{{item.key}} </dt>\n                        <dd>\n                            <hs-widgets-recursive-dd [value]=\"item.value\" [app]=\"data.app\"></hs-widgets-recursive-dd>\n                        </dd>\n                    </dl>\n                </div>\n            </div>\n            <div class=\"modal-footer\"\n                [ngClass]=\"{'justify-content-between' : appRef.statusData.resultCode === 'exists' }\">\n                <div *ngIf=\"!appRef.statusData.status && appRef.statusData.resultCode === 'exists'\">\n                    <button type=\"button\" class=\"btn btn-primary\"\n                        (click)=\"initiateSave(false)\">{{'SAVECOMPOSITION.form.overwrite' | translateHs : {app: data.app} }}</button>\n                    <button type=\"button\" class=\"btn btn-primary ms-2\"\n                        (click)=\"changeName()\">{{'SAVECOMPOSITION.form.changeName' | translateHs : {app: data.app} }}</button>\n                </div>\n                <button type=\"button\" class=\"btn btn-primary\" (click)=\"close()\" data-dismiss=\"modal\">{{'COMMON.close' |\n                    translateHs : {app: data.app} }}</button>\n            </div>\n        </div>\n    </div>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: HsDialogContainerService }, { type: HsSaveMapManagerService }]; } });

class HsSaveMapDialogSpawnerService {
    constructor(hsDialogContainerService, hsSaveMapManagerService) {
        this.hsDialogContainerService = hsDialogContainerService;
        this.hsSaveMapManagerService = hsSaveMapManagerService;
    }
    /**
     * Initialize the SaveMapDialogSpawnerService data and subscribers
     * @param app - App identifier
     */
    init(app) {
        this.hsSaveMapManagerService
            .get(app)
            .saveMapResulted.subscribe(({ statusData, app }) => {
            if (typeof statusData != 'string') {
                this.hsDialogContainerService.create(HsSaveMapResultDialogComponent, {
                    app,
                    statusData,
                }, app);
            }
        });
        this.hsSaveMapManagerService
            .get(app)
            .preSaveCheckCompleted.subscribe(({ endpoint, app }) => {
            this.hsDialogContainerService.create(HsSaveMapDialogComponent, {
                endpoint,
                app,
            }, app);
        });
    }
}
HsSaveMapDialogSpawnerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSaveMapDialogSpawnerService, deps: [{ token: HsDialogContainerService }, { token: HsSaveMapManagerService }], target: i0.ɵɵFactoryTarget.Injectable });
HsSaveMapDialogSpawnerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSaveMapDialogSpawnerService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSaveMapDialogSpawnerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsDialogContainerService }, { type: HsSaveMapManagerService }]; } });

class HsSaveMapAdvancedFormComponent {
    constructor(hsSaveMapManagerService, hsCoreService, hsUtilsService, hsLayerUtilsService, //Used in template
    hsLayoutService) {
        this.hsSaveMapManagerService = hsSaveMapManagerService;
        this.hsCoreService = hsCoreService;
        this.hsUtilsService = hsUtilsService;
        this.hsLayerUtilsService = hsLayerUtilsService;
        this.hsLayoutService = hsLayoutService;
        this.btnSelectDeselectClicked = true;
        this.overwrite = false;
        this.extraFormOpened = '';
        this.app = 'default';
        this.ngUnsubscribe = new Subject();
    }
    ngOnInit() {
        this.appRef = this.hsSaveMapManagerService.get(this.app);
        this.appRef.endpointSelected
            .pipe(takeUntil$1(this.ngUnsubscribe))
            .subscribe((endpoint) => {
            this.endpoint = endpoint;
        });
        this.appRef.saveMapResulted
            .pipe(takeUntil$1(this.ngUnsubscribe))
            .subscribe(({ statusData, app }) => {
            if (statusData.overWriteNeeded) {
                this.overwrite = true;
            }
            if (statusData == 'rename') {
                this.hsLayoutService
                    .get(app)
                    .layoutElement.querySelector('[name="hs-save-map-name"]')
                    .focus();
            }
        });
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    /**
     * Set extra form that will get opened
     * @param form - Form name that needs to be opened
     */
    setExtraFormTo(form) {
        if (this.extraFormOpened === form) {
            this.extraFormOpened = '';
        }
        else {
            this.extraFormOpened = form;
        }
    }
    /**
     * Save map composition as json file
     */
    saveCompoJson() {
        const compositionJSON = this.hsSaveMapManagerService.generateCompositionJson(this.app);
        const file = new Blob([JSON.stringify(compositionJSON)], {
            type: 'application/json',
        });
        const a = document.getElementById('stc-download'), url = URL.createObjectURL(file);
        a.href = url;
        a.download = 'composition';
        setTimeout(() => {
            window.URL.revokeObjectURL(url);
        }, 0);
    }
    /**
     * Select or deselect all available composition's layers
     */
    selectDeselectAllLayers() {
        this.btnSelectDeselectClicked = !this.btnSelectDeselectClicked;
        this.appRef.compoData.layers.forEach((layer) => (layer.checked = this.btnSelectDeselectClicked));
    }
    /**
     * Set the first string letter to an uppercase
     * NOTE not being used
     * @returns Returns the same string, but with a capitalized first letter
     */
    capitalizeFirstLetter(string) {
        return this.hsUtilsService.capitalizeFirstLetter(string);
    }
    /**
     * Triggered when composition's title input field receives user's input
     */
    nameChanged() {
        this.overwrite = false;
        this.appRef.missingName = false;
    }
    /**
     * Triggered when composition's abstract input field receives user's input
     */
    abstractChanged() {
        this.appRef.missingAbstract = false;
    }
    /**
     * Check if user is allowed to save the composition, based on the currently selected endpoint type
     * @returns True if endpoint type is 'layman'.
     * True if the endpoint type is 'statusmanager' and the user is authorized,
     * false otherwise
     */
    isAllowed() {
        if (this.endpoint === null) {
            return false;
        }
        if (this.endpoint.type == 'statusmanager') {
            return !this.hsCoreService.isAuthorized();
        }
        else if (this.endpoint.type == 'layman') {
            return true;
        }
    }
    /**
     * Initiate composition's saving procedure
     * @param newSave - If true save a new composition, otherwise overwrite to current one
     */
    initiateSave(newSave) {
        this.hsSaveMapManagerService.initiateSave(newSave, this.app);
    }
    /**
     * Set bounding box property from the current OL map view
     */
    setCurrentBoundingBox() {
        this.hsSaveMapManagerService.setCurrentBoundingBox(this.app);
    }
    /**
     * Check if current user can overwrite the composition data
     */
    canOverwrite() {
        return (this.appRef.compoData.workspace &&
            this.appRef.currentUser !== this.appRef.compoData.workspace);
    }
}
HsSaveMapAdvancedFormComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSaveMapAdvancedFormComponent, deps: [{ token: HsSaveMapManagerService }, { token: HsCoreService }, { token: HsUtilsService }, { token: HsLayerUtilsService }, { token: HsLayoutService }], target: i0.ɵɵFactoryTarget.Component });
HsSaveMapAdvancedFormComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsSaveMapAdvancedFormComponent, selector: "hs-save-map-form", inputs: { app: "app" }, ngImport: i0, template: "<div class=\"form\">\n    <div class=\"form-floating mb-2\">\n        <input type=\"text\" class=\"form-control\" [ngStyle]=\"{'border-color': appRef.missingName ? '#ff0000' : '#ced4da'}\"\n            name=\"hs-save-map-name\" [(ngModel)]=\"appRef.compoData.name\" (ngModelChange)=\"nameChanged()\"\n            placeholder=\"'COMMON.name' | translateHs : {app} \">\n        <label for=\"hs-save-map-name\">{{'COMMON.name' | translateHs : {app} }} *</label>\n        <span class=\"d-flex justify-content-end text-danger\" *ngIf=\"appRef.missingName\">{{'COMMON.required' |\n            translateHs : {app} }}</span>\n    </div>\n    <div class=\"form-floating mb-2\">\n        <textarea class=\"form-control\" name=\"hs-save-map-abstract\"\n            placeholder=\"'COMMON.abstract' | translateHs : {app} \"\n            [ngStyle]=\"{'border-color': appRef.missingAbstract ? '#ff0000' : '#ced4da'}\"\n            [(ngModel)]=\"appRef.compoData.abstract\" (ngModelChange)=\"abstractChanged()\"></textarea>\n        <label for=\"hs-save-map-abstract\">{{'COMMON.abstract' | translateHs : {app} }} *</label>\n        <span class=\"d-flex justify-content-end text-danger\" *ngIf=\"appRef.missingAbstract\">{{'COMMON.required' |\n            translateHs : {app} }}</span>\n    </div>\n    <div class=\"form-floating mb-2\">\n        <input type=\"text\" class=\"form-control\" name=\"hs-save-map-keywords\"\n            placeholder=\"'COMMON.keywords' | translateHs : {app} \" [(ngModel)]=\"appRef.compoData.keywords\">\n        <label for=\"hs-save-map-keywords\">{{'COMMON.keywords' | translateHs : {app} }}</label>\n    </div>\n    <label class=\"form-group\">{{'COMMON.thumbnail' | translateHs : {app} }}\n        <img class=\"hs-stc-thumbnail img-thumbnail\" alt=\"Composition thumbnail\" width=\"256\" height=\"256\">\n    </label>\n    <hs-layman-access-rights *ngIf=\"endpoint?.type === 'layman'\" [app]=\"app\"\n        [(access_rights)]=\"appRef.compoData.access_rights\">\n    </hs-layman-access-rights>\n    <ng-container *ngIf=\"appRef.statusData?.groups?.length > 0 && endpoint?.type !== 'layman'\">\n        <table class=\"table table-condensed\">\n            <tbody>\n                <tr>\n                    <th></th>\n                    <th>{{'SAVECOMPOSITION.form.read' | translateHs : {app} }}</th>\n                    <th>{{'SAVECOMPOSITION.form.write' | translateHs : {app} }}</th>\n                </tr>\n                <tr *ngFor=\"let g of appRef.statusData.groups\">\n                    <td>{{g.roleTitle || g.roleName}}:</td>\n                    <td><input type=\"checkbox\" class=\"form-control\" [(ngModel)]=\"g.r\"\n                            [ngModelOptions]=\"{standalone: true}\">\n                    </td>\n                    <td><input type=\"checkbox\" class=\"form-control\" [(ngModel)]=\"g.w\"\n                            [ngModelOptions]=\"{standalone: true}\">\n                    </td>\n                </tr>\n            </tbody>\n        </table>\n    </ng-container>\n</div>\n<div class=\"mb-2 d-flex justify-content-center\">\n    <button type=\"button\" class=\"btn btn-secondary me-2 w-50\" id=\"stc-advanced-options\"\n        (click)=\"setExtraFormTo('advancedOptions')\">{{'COMMON.advancedOptions' | translateHs : {app} }}</button>\n    <!-- <button type=\"button\" class=\"btn btn-secondary w-50\" id=\"stc-user-information\"\n        (click)=\"setExtraFormTo('aboutAuthor')\">{{'COMMON.aboutAuthor' | translateHs : {app} }}</button> -->\n</div>\n<div class=\"hs-save-comp-advanced-panel\" *ngIf=\"extraFormOpened === 'advancedOptions'\">\n    <form class=\"form\">\n        <div class=\"form-group\">\n            <label for=\"stc-extent1\" class=\"form-group\">{{'COMMON.extent' | translateHs : {app} }}</label>\n            <div class=\"d-flex w-100 pb-2 stc-extent-row\" *ngIf=\"appRef.compoData.bbox\">\n                <div class=\"form-floating px-0\">\n                    <input type=\"text\" class=\"form-control\" id=\"floatingEast\" [ngModelOptions]=\"{standalone: true}\"\n                        [(ngModel)]=\"appRef.compoData.bbox.east\" [title]=\"'COMMON.east' | translateHs : {app} \">\n                    <label for=\"floatingEast\">{{'COMMON.east' | translateHs : {app} }}</label>\n                </div>\n                <div class=\"form-floating px-0\">\n                    <input type=\"text\" class=\"form-control\" id=\"floatingSouth\" [ngModelOptions]=\"{standalone: true}\"\n                        [(ngModel)]=\"appRef.compoData.bbox.south\" [title]=\"'COMMON.south' | translateHs : {app} \">\n                    <label for=\"floatingSouth\">{{'COMMON.south' | translateHs : {app} }}</label>\n                </div>\n                <div class=\"form-floating px-0\">\n                    <input type=\"text\" class=\"form-control\" id=\"floatingWest\" [ngModelOptions]=\"{standalone: true}\"\n                        [(ngModel)]=\"appRef.compoData.bbox.west\" [title]=\"'COMMON.west' | translateHs : {app} \">\n                    <label for=\"floatingWest\">{{'COMMON.west' | translateHs : {app} }}</label>\n                </div>\n                <div class=\"form-floating px-0\">\n                    <input type=\"text\" class=\"form-control\" id=\"floatingNorth\" [ngModelOptions]=\"{standalone: true}\"\n                        [(ngModel)]=\"appRef.compoData.bbox.north\" [title]=\"'COMMON.north' | translateHs : {app} \">\n                    <label for=\"floatingNorth\">{{'COMMON.north' | translateHs : {app} }}</label>\n                </div>\n            </div>\n            <button type=\"button\" class=\"mt-1 btn btn-secondary w-100\"\n                (click)=\"setCurrentBoundingBox()\">{{'SAVECOMPOSITION.form.userCurrentMapExtent'\n                | translateHs : {app} }}</button>\n        </div>\n        <div class=\"form-group\">\n            <ul class=\"list-group\" id=\"stc-layerlist\">\n                <li *ngFor=\"let layer of appRef.compoData.layers; let i = index\" class=\"list-group-item\">\n                    <div class=\"form-check text-truncat\">\n                        <input type=\"checkbox\" class=\"form-check-input mt-0\" name=\"hs-stclayer-{{i}}\"\n                            id=\"hs-stclayer-{{i}}\" [(ngModel)]=\"layer.checked\" [ngModelOptions]=\"{standalone: true}\">\n                        <label for=\"hs-stclayer-{{i}}\" title=\"{{layer.title | translateHs : {app, module: 'LAYERS'} }}\"\n                            class=\"form-check-label mw-100 text-truncate\">{{layer.title | translateHs : {app, module:\n                            'LAYERS'} }}</label>\n                    </div>\n                </li>\n                <li class=\"list-group-item\" style=\"padding: 3px\">\n                    <div class=\"d-flex w-100 justify-content-center\">\n                        <button type=\"button\" class=\"mt-1 btn btn-primary\"\n                            (click)=\"selectDeselectAllLayers()\">{{'SAVECOMPOSITION.form.toggleAll' |\n                            translateHs : {app} }}</button>\n                    </div>\n                </li>\n            </ul>\n        </div>\n    </form>\n</div>\n<div *ngIf=\"extraFormOpened === 'aboutAuthor'\">\n    <div class=\"form\">\n        <div class=\"form-floating mb-2\">\n            <input type=\"text\" class=\"form-control\" [(ngModel)]=\"appRef.userData.name\" name=\"hs-savemap-userdata-name\"\n                placeholder=\"'SAVECOMPOSITION.form.person' | translateHs : {app} \">\n            <label for=\"hs-savemap-userdata-name\">{{'SAVECOMPOSITION.form.person' | translateHs : {app} }}</label>\n        </div>\n\n        <div class=\"form-floating mb-2\">\n            <input type=\"text\" class=\"form-control\" [(ngModel)]=\"appRef.userData.organization\"\n                name=\"hs-savemap-userdata-organization\"\n                placeholder=\"'SAVECOMPOSITION.form.organization' | translateHs : {app} \">\n            <label for=\"hs-savemap-userdata-porganizationosition\"> {{'SAVECOMPOSITION.form.organization' |\n                translateHs : {app} }}</label>\n        </div>\n\n        <div class=\"form-floating mb-2\">\n            <input type=\"text\" class=\"form-control\" [(ngModel)]=\"appRef.userData.position\"\n                name=\"hs-savemap-userdata-position\"\n                placeholder=\"'SAVECOMPOSITION.form.position' | translateHs : {app} \">\n            <label for=\"hs-savemap-userdata-position\">{{'SAVECOMPOSITION.form.position' | translateHs : {app} }}</label>\n        </div>\n\n        <div class=\"form-floating mb-2\">\n            <input type=\"text\" class=\"form-control\" [(ngModel)]=\"appRef.userData.address\"\n                name=\"hs-savemap-userdata-address\" placeholder=\"'SAVECOMPOSITION.form.address' | translateHs : {app} \">\n            <label for=\"hs-savemap-userdata-address\">{{'SAVECOMPOSITION.form.address' | translateHs : {app} }}</label>\n        </div>\n\n        <div class=\"form-floating mb-2\">\n            <input type=\"text\" class=\"form-control\" [(ngModel)]=\"appRef.userData.city\" name=\"hs-savemap-userdata-city\"\n                placeholder=\"'SAVECOMPOSITION.form.city' | translateHs : {app} \">\n            <label for=\"hs-savemap-userdata-city\">{{'SAVECOMPOSITION.form.city' | translateHs : {app} }}</label>\n        </div>\n\n        <div class=\"form-floating mb-2\">\n            <input type=\"text\" class=\"form-control\" [(ngModel)]=\"appRef.userData.state\" name=\"hs-savemap-userdata-state\"\n                placeholder=\"'SAVECOMPOSITION.form.state' | translateHs : {app} \">\n            <label for=\"hs-savemap-userdata-state\">{{'SAVECOMPOSITION.form.state' | translateHs : {app} }}</label>\n        </div>\n\n        <div class=\"form-floating mb-2\">\n            <input type=\"text\" class=\"form-control\" [(ngModel)]=\"appRef.userData.postalCode\"\n                name=\"hs-savemap-userdata-postalcode\"\n                placeholder=\"'SAVECOMPOSITION.form.postalCode' | translateHs : {app} \">\n            <label for=\"hs-savemap-userdata-postalcode\">{{'SAVECOMPOSITION.form.postalCode' | translateHs : {app}\n                }}</label>\n        </div>\n\n        <div class=\"form-floating mb-2\">\n            <input type=\"text\" class=\"form-control\" [(ngModel)]=\"appRef.userData.country\"\n                name=\"hs-savemap-userdata-country\" placeholder=\"'SAVECOMPOSITION.form.country' | translateHs : {app} \">\n            <label for=\"hs-savemap-userdata-country\">{{'SAVECOMPOSITION.form.country' | translateHs : {app} }}</label>\n        </div>\n\n        <div class=\"form-floating mb-2\">\n            <input type=\"text\" class=\"form-control\" [(ngModel)]=\"appRef.userData.phone\" name=\"hs-savemap-userdata-phone\"\n                placeholder=\"'SAVECOMPOSITION.form.phone' | translateHs : {app} \">\n            <label for=\"hs-savemap-userdata-phone\">{{'SAVECOMPOSITION.form.phone' | translateHs : {app} }}</label>\n        </div>\n\n        <div class=\"form-floating mb-2\">\n            <input type=\"text\" class=\"form-control\" [(ngModel)]=\"appRef.userData.email\" name=\"hs-savemap-userdata-email\"\n                placeholder=\"'SAVECOMPOSITION.form.email' | translateHs : {app} \">\n            <label for=\"hs-savemap-userdata-email\"> {{'SAVECOMPOSITION.form.email' | translateHs : {app} }}</label>\n        </div>\n    </div>\n</div>\n<div class=\"modal-footer w-100\">\n    <div [hidden]=\"!canOverwrite()\">\n        <div class=\"alert alert-info text-gray\">\n            {{'SAVECOMPOSITION.saveOrOverwrite' | translateHs : {app} }}\n        </div>\n        <button type=\"button\" class=\"btn btn-primary\" id=\"stc-save\"\n            (click)=\"initiateSave(false)\">{{'SAVECOMPOSITION.form.overwrite' |\n            translateHs : {app} }}</button>\n        <p style=\"text-align: center;\" class=\"m-1\">{{'COMMON.or' | translateHs : {app} }}</p>\n    </div>\n    <div class=\"mb-2 d-flex justify-content-end\">\n        <button type=\"button\" class=\"btn btn-primary me-2\" id=\"stc-saveas\" [hidden]=\"!(isAllowed())\"\n            (click)=\"initiateSave(true)\">\n            <!-- TODO: Remove function call from template -->{{'COMMON.save' | translateHs : {app} }}\n        </button>\n        <a type=\"button\" class=\"btn btn-secondary\" (click)=\"saveCompoJson()\" id=\"stc-download\">{{'COMMON.download'\n            |\n            translateHs: this}}</a>\n    </div>\n</div>", components: [{ type: HsCommonLaymanAccessRightsComponent, selector: "hs-layman-access-rights", inputs: ["access_rights", "app"] }], directives: [{ type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3$1.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { type: i3$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i3$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i3$1.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSaveMapAdvancedFormComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-save-map-form', template: "<div class=\"form\">\n    <div class=\"form-floating mb-2\">\n        <input type=\"text\" class=\"form-control\" [ngStyle]=\"{'border-color': appRef.missingName ? '#ff0000' : '#ced4da'}\"\n            name=\"hs-save-map-name\" [(ngModel)]=\"appRef.compoData.name\" (ngModelChange)=\"nameChanged()\"\n            placeholder=\"'COMMON.name' | translateHs : {app} \">\n        <label for=\"hs-save-map-name\">{{'COMMON.name' | translateHs : {app} }} *</label>\n        <span class=\"d-flex justify-content-end text-danger\" *ngIf=\"appRef.missingName\">{{'COMMON.required' |\n            translateHs : {app} }}</span>\n    </div>\n    <div class=\"form-floating mb-2\">\n        <textarea class=\"form-control\" name=\"hs-save-map-abstract\"\n            placeholder=\"'COMMON.abstract' | translateHs : {app} \"\n            [ngStyle]=\"{'border-color': appRef.missingAbstract ? '#ff0000' : '#ced4da'}\"\n            [(ngModel)]=\"appRef.compoData.abstract\" (ngModelChange)=\"abstractChanged()\"></textarea>\n        <label for=\"hs-save-map-abstract\">{{'COMMON.abstract' | translateHs : {app} }} *</label>\n        <span class=\"d-flex justify-content-end text-danger\" *ngIf=\"appRef.missingAbstract\">{{'COMMON.required' |\n            translateHs : {app} }}</span>\n    </div>\n    <div class=\"form-floating mb-2\">\n        <input type=\"text\" class=\"form-control\" name=\"hs-save-map-keywords\"\n            placeholder=\"'COMMON.keywords' | translateHs : {app} \" [(ngModel)]=\"appRef.compoData.keywords\">\n        <label for=\"hs-save-map-keywords\">{{'COMMON.keywords' | translateHs : {app} }}</label>\n    </div>\n    <label class=\"form-group\">{{'COMMON.thumbnail' | translateHs : {app} }}\n        <img class=\"hs-stc-thumbnail img-thumbnail\" alt=\"Composition thumbnail\" width=\"256\" height=\"256\">\n    </label>\n    <hs-layman-access-rights *ngIf=\"endpoint?.type === 'layman'\" [app]=\"app\"\n        [(access_rights)]=\"appRef.compoData.access_rights\">\n    </hs-layman-access-rights>\n    <ng-container *ngIf=\"appRef.statusData?.groups?.length > 0 && endpoint?.type !== 'layman'\">\n        <table class=\"table table-condensed\">\n            <tbody>\n                <tr>\n                    <th></th>\n                    <th>{{'SAVECOMPOSITION.form.read' | translateHs : {app} }}</th>\n                    <th>{{'SAVECOMPOSITION.form.write' | translateHs : {app} }}</th>\n                </tr>\n                <tr *ngFor=\"let g of appRef.statusData.groups\">\n                    <td>{{g.roleTitle || g.roleName}}:</td>\n                    <td><input type=\"checkbox\" class=\"form-control\" [(ngModel)]=\"g.r\"\n                            [ngModelOptions]=\"{standalone: true}\">\n                    </td>\n                    <td><input type=\"checkbox\" class=\"form-control\" [(ngModel)]=\"g.w\"\n                            [ngModelOptions]=\"{standalone: true}\">\n                    </td>\n                </tr>\n            </tbody>\n        </table>\n    </ng-container>\n</div>\n<div class=\"mb-2 d-flex justify-content-center\">\n    <button type=\"button\" class=\"btn btn-secondary me-2 w-50\" id=\"stc-advanced-options\"\n        (click)=\"setExtraFormTo('advancedOptions')\">{{'COMMON.advancedOptions' | translateHs : {app} }}</button>\n    <!-- <button type=\"button\" class=\"btn btn-secondary w-50\" id=\"stc-user-information\"\n        (click)=\"setExtraFormTo('aboutAuthor')\">{{'COMMON.aboutAuthor' | translateHs : {app} }}</button> -->\n</div>\n<div class=\"hs-save-comp-advanced-panel\" *ngIf=\"extraFormOpened === 'advancedOptions'\">\n    <form class=\"form\">\n        <div class=\"form-group\">\n            <label for=\"stc-extent1\" class=\"form-group\">{{'COMMON.extent' | translateHs : {app} }}</label>\n            <div class=\"d-flex w-100 pb-2 stc-extent-row\" *ngIf=\"appRef.compoData.bbox\">\n                <div class=\"form-floating px-0\">\n                    <input type=\"text\" class=\"form-control\" id=\"floatingEast\" [ngModelOptions]=\"{standalone: true}\"\n                        [(ngModel)]=\"appRef.compoData.bbox.east\" [title]=\"'COMMON.east' | translateHs : {app} \">\n                    <label for=\"floatingEast\">{{'COMMON.east' | translateHs : {app} }}</label>\n                </div>\n                <div class=\"form-floating px-0\">\n                    <input type=\"text\" class=\"form-control\" id=\"floatingSouth\" [ngModelOptions]=\"{standalone: true}\"\n                        [(ngModel)]=\"appRef.compoData.bbox.south\" [title]=\"'COMMON.south' | translateHs : {app} \">\n                    <label for=\"floatingSouth\">{{'COMMON.south' | translateHs : {app} }}</label>\n                </div>\n                <div class=\"form-floating px-0\">\n                    <input type=\"text\" class=\"form-control\" id=\"floatingWest\" [ngModelOptions]=\"{standalone: true}\"\n                        [(ngModel)]=\"appRef.compoData.bbox.west\" [title]=\"'COMMON.west' | translateHs : {app} \">\n                    <label for=\"floatingWest\">{{'COMMON.west' | translateHs : {app} }}</label>\n                </div>\n                <div class=\"form-floating px-0\">\n                    <input type=\"text\" class=\"form-control\" id=\"floatingNorth\" [ngModelOptions]=\"{standalone: true}\"\n                        [(ngModel)]=\"appRef.compoData.bbox.north\" [title]=\"'COMMON.north' | translateHs : {app} \">\n                    <label for=\"floatingNorth\">{{'COMMON.north' | translateHs : {app} }}</label>\n                </div>\n            </div>\n            <button type=\"button\" class=\"mt-1 btn btn-secondary w-100\"\n                (click)=\"setCurrentBoundingBox()\">{{'SAVECOMPOSITION.form.userCurrentMapExtent'\n                | translateHs : {app} }}</button>\n        </div>\n        <div class=\"form-group\">\n            <ul class=\"list-group\" id=\"stc-layerlist\">\n                <li *ngFor=\"let layer of appRef.compoData.layers; let i = index\" class=\"list-group-item\">\n                    <div class=\"form-check text-truncat\">\n                        <input type=\"checkbox\" class=\"form-check-input mt-0\" name=\"hs-stclayer-{{i}}\"\n                            id=\"hs-stclayer-{{i}}\" [(ngModel)]=\"layer.checked\" [ngModelOptions]=\"{standalone: true}\">\n                        <label for=\"hs-stclayer-{{i}}\" title=\"{{layer.title | translateHs : {app, module: 'LAYERS'} }}\"\n                            class=\"form-check-label mw-100 text-truncate\">{{layer.title | translateHs : {app, module:\n                            'LAYERS'} }}</label>\n                    </div>\n                </li>\n                <li class=\"list-group-item\" style=\"padding: 3px\">\n                    <div class=\"d-flex w-100 justify-content-center\">\n                        <button type=\"button\" class=\"mt-1 btn btn-primary\"\n                            (click)=\"selectDeselectAllLayers()\">{{'SAVECOMPOSITION.form.toggleAll' |\n                            translateHs : {app} }}</button>\n                    </div>\n                </li>\n            </ul>\n        </div>\n    </form>\n</div>\n<div *ngIf=\"extraFormOpened === 'aboutAuthor'\">\n    <div class=\"form\">\n        <div class=\"form-floating mb-2\">\n            <input type=\"text\" class=\"form-control\" [(ngModel)]=\"appRef.userData.name\" name=\"hs-savemap-userdata-name\"\n                placeholder=\"'SAVECOMPOSITION.form.person' | translateHs : {app} \">\n            <label for=\"hs-savemap-userdata-name\">{{'SAVECOMPOSITION.form.person' | translateHs : {app} }}</label>\n        </div>\n\n        <div class=\"form-floating mb-2\">\n            <input type=\"text\" class=\"form-control\" [(ngModel)]=\"appRef.userData.organization\"\n                name=\"hs-savemap-userdata-organization\"\n                placeholder=\"'SAVECOMPOSITION.form.organization' | translateHs : {app} \">\n            <label for=\"hs-savemap-userdata-porganizationosition\"> {{'SAVECOMPOSITION.form.organization' |\n                translateHs : {app} }}</label>\n        </div>\n\n        <div class=\"form-floating mb-2\">\n            <input type=\"text\" class=\"form-control\" [(ngModel)]=\"appRef.userData.position\"\n                name=\"hs-savemap-userdata-position\"\n                placeholder=\"'SAVECOMPOSITION.form.position' | translateHs : {app} \">\n            <label for=\"hs-savemap-userdata-position\">{{'SAVECOMPOSITION.form.position' | translateHs : {app} }}</label>\n        </div>\n\n        <div class=\"form-floating mb-2\">\n            <input type=\"text\" class=\"form-control\" [(ngModel)]=\"appRef.userData.address\"\n                name=\"hs-savemap-userdata-address\" placeholder=\"'SAVECOMPOSITION.form.address' | translateHs : {app} \">\n            <label for=\"hs-savemap-userdata-address\">{{'SAVECOMPOSITION.form.address' | translateHs : {app} }}</label>\n        </div>\n\n        <div class=\"form-floating mb-2\">\n            <input type=\"text\" class=\"form-control\" [(ngModel)]=\"appRef.userData.city\" name=\"hs-savemap-userdata-city\"\n                placeholder=\"'SAVECOMPOSITION.form.city' | translateHs : {app} \">\n            <label for=\"hs-savemap-userdata-city\">{{'SAVECOMPOSITION.form.city' | translateHs : {app} }}</label>\n        </div>\n\n        <div class=\"form-floating mb-2\">\n            <input type=\"text\" class=\"form-control\" [(ngModel)]=\"appRef.userData.state\" name=\"hs-savemap-userdata-state\"\n                placeholder=\"'SAVECOMPOSITION.form.state' | translateHs : {app} \">\n            <label for=\"hs-savemap-userdata-state\">{{'SAVECOMPOSITION.form.state' | translateHs : {app} }}</label>\n        </div>\n\n        <div class=\"form-floating mb-2\">\n            <input type=\"text\" class=\"form-control\" [(ngModel)]=\"appRef.userData.postalCode\"\n                name=\"hs-savemap-userdata-postalcode\"\n                placeholder=\"'SAVECOMPOSITION.form.postalCode' | translateHs : {app} \">\n            <label for=\"hs-savemap-userdata-postalcode\">{{'SAVECOMPOSITION.form.postalCode' | translateHs : {app}\n                }}</label>\n        </div>\n\n        <div class=\"form-floating mb-2\">\n            <input type=\"text\" class=\"form-control\" [(ngModel)]=\"appRef.userData.country\"\n                name=\"hs-savemap-userdata-country\" placeholder=\"'SAVECOMPOSITION.form.country' | translateHs : {app} \">\n            <label for=\"hs-savemap-userdata-country\">{{'SAVECOMPOSITION.form.country' | translateHs : {app} }}</label>\n        </div>\n\n        <div class=\"form-floating mb-2\">\n            <input type=\"text\" class=\"form-control\" [(ngModel)]=\"appRef.userData.phone\" name=\"hs-savemap-userdata-phone\"\n                placeholder=\"'SAVECOMPOSITION.form.phone' | translateHs : {app} \">\n            <label for=\"hs-savemap-userdata-phone\">{{'SAVECOMPOSITION.form.phone' | translateHs : {app} }}</label>\n        </div>\n\n        <div class=\"form-floating mb-2\">\n            <input type=\"text\" class=\"form-control\" [(ngModel)]=\"appRef.userData.email\" name=\"hs-savemap-userdata-email\"\n                placeholder=\"'SAVECOMPOSITION.form.email' | translateHs : {app} \">\n            <label for=\"hs-savemap-userdata-email\"> {{'SAVECOMPOSITION.form.email' | translateHs : {app} }}</label>\n        </div>\n    </div>\n</div>\n<div class=\"modal-footer w-100\">\n    <div [hidden]=\"!canOverwrite()\">\n        <div class=\"alert alert-info text-gray\">\n            {{'SAVECOMPOSITION.saveOrOverwrite' | translateHs : {app} }}\n        </div>\n        <button type=\"button\" class=\"btn btn-primary\" id=\"stc-save\"\n            (click)=\"initiateSave(false)\">{{'SAVECOMPOSITION.form.overwrite' |\n            translateHs : {app} }}</button>\n        <p style=\"text-align: center;\" class=\"m-1\">{{'COMMON.or' | translateHs : {app} }}</p>\n    </div>\n    <div class=\"mb-2 d-flex justify-content-end\">\n        <button type=\"button\" class=\"btn btn-primary me-2\" id=\"stc-saveas\" [hidden]=\"!(isAllowed())\"\n            (click)=\"initiateSave(true)\">\n            <!-- TODO: Remove function call from template -->{{'COMMON.save' | translateHs : {app} }}\n        </button>\n        <a type=\"button\" class=\"btn btn-secondary\" (click)=\"saveCompoJson()\" id=\"stc-download\">{{'COMMON.download'\n            |\n            translateHs: this}}</a>\n    </div>\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsSaveMapManagerService }, { type: HsCoreService }, { type: HsUtilsService }, { type: HsLayerUtilsService }, { type: HsLayoutService }]; }, propDecorators: { app: [{
                type: Input
            }] } });

class HsSaveMapComponent extends HsPanelBaseComponent {
    constructor(
    //Used in template
    hsConfig, hsSaveMapManagerService, hsLayoutService, hsCommonLaymanService, hsCommonEndpointsService, 
    //Running in background and watching observables
    hsSaveMapDialogSpawnerService, hsLanguageService, hsSidebarService, hsSaveMapService) {
        super(hsLayoutService);
        this.hsConfig = hsConfig;
        this.hsSaveMapManagerService = hsSaveMapManagerService;
        this.hsCommonLaymanService = hsCommonLaymanService;
        this.hsCommonEndpointsService = hsCommonEndpointsService;
        this.hsSaveMapDialogSpawnerService = hsSaveMapDialogSpawnerService;
        this.hsLanguageService = hsLanguageService;
        this.hsSidebarService = hsSidebarService;
        this.hsSaveMapService = hsSaveMapService;
        this.endpoint = null;
        this.isAuthorized = false;
        this.name = 'saveMap';
        this.ngUnsubscribe = new Subject();
    }
    ngOnInit() {
        this.endpoints = this.hsCommonEndpointsService.endpoints;
        this.hsSidebarService.addButton({
            panel: 'saveMap',
            module: 'hs.save-map',
            order: 12,
            fits: true,
            title: 'PANEL_HEADER.SAVECOMPOSITION',
            description: 'SIDEBAR.descriptions.SAVECOMPOSITION',
            icon: 'icon-save-floppy',
        }, this.data.app);
        this.hsCommonEndpointsService.endpointsFilled
            .pipe(takeUntil$1(this.ngUnsubscribe))
            .subscribe((filled) => {
            var _a, _b;
            if (!filled || !((_a = this.data) === null || _a === void 0 ? void 0 : _a.app)) {
                return;
            }
            if (((_b = filled.endpoints) === null || _b === void 0 ? void 0 : _b.length) > 0 && !this.endpoint) {
                const laymans = filled.endpoints.filter((ep) => ep.type == 'layman');
                if (laymans.length > 0) {
                    this.hsSaveMapManagerService.selectEndpoint(laymans[0], this.data.app);
                }
                else {
                    this.hsSaveMapManagerService.selectEndpoint(filled.endpoints[0], this.data.app);
                }
                if (this.endpoint && this.endpoint.type == 'layman') {
                    this.hsCommonLaymanService.detectAuthChange(this.endpoint, this.data.app);
                }
            }
        });
        this.hsCommonLaymanService.authChange
            .pipe(takeUntil$1(this.ngUnsubscribe))
            .subscribe(({ endpoint, app }) => {
            this.isAuthorized =
                endpoint.user !== 'anonymous' && endpoint.user !== 'browser';
            this.hsSaveMapManagerService.get(app).currentUser = endpoint.user;
        });
        this.hsSaveMapManagerService
            .get(this.data.app)
            .endpointSelected.pipe(takeUntil$1(this.ngUnsubscribe))
            .subscribe((endpoint) => {
            if (endpoint) {
                this.endpoint = endpoint;
                if (endpoint.getCurrentUserIfNeeded) {
                    endpoint.getCurrentUserIfNeeded(endpoint, this.data.app);
                }
            }
        });
        this.hsSaveMapManagerService
            .get(this.data.app)
            .panelOpened.pipe(takeUntil$1(this.ngUnsubscribe))
            .subscribe((composition) => {
            if (composition && composition.endpoint) {
                const openedType = composition.endpoint.type;
                const found = this.hsCommonEndpointsService.endpoints.filter((ep) => ep.type == openedType);
                if (found.length > 0) {
                    this.hsSaveMapManagerService.selectEndpoint(found[0], this.data.app);
                }
            }
        });
        window.addEventListener('beforeunload', () => {
            if (this.hsConfig.get(this.data.app).saveMapStateOnReload) {
                this.hsSaveMapService.save2storage(this.data.app);
            }
        });
        this.hsSaveMapManagerService.init(this.data.app);
        this.hsSaveMapDialogSpawnerService.init(this.data.app);
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    /**
     * Select service endpoint, which will be used to save the map composition
     * @param endpoint - Endpoint to select
     */
    selectEndpoint(endpoint) {
        this.hsSaveMapManagerService.selectEndpoint(endpoint, this.data.app);
    }
}
HsSaveMapComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSaveMapComponent, deps: [{ token: HsConfig }, { token: HsSaveMapManagerService }, { token: HsLayoutService }, { token: HsCommonLaymanService }, { token: HsCommonEndpointsService }, { token: HsSaveMapDialogSpawnerService }, { token: HsLanguageService }, { token: HsSidebarService }, { token: HsSaveMapService }], target: i0.ɵɵFactoryTarget.Component });
HsSaveMapComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsSaveMapComponent, selector: "hs-save-map", usesInheritance: true, ngImport: i0, template: "<div class=\"card panel-default hs-main-panel mainpanel hs-stc-mainpanel\" [hidden]=\"(isVisible$ | async) === false\">\n    <hs-panel-header name=\"saveMap\" [title]=\"'PANEL_HEADER.SAVECOMPOSITION' | translateHs : data\" [app]=\"data.app\">\n    </hs-panel-header>\n    <div class=\"card-body\">\n        <div class=\"form-group\">\n            <div class=\"input-group\">\n                <span class=\"input-group-text control-label\">{{'COMMON.saveTo' | translateHs : {app: data.app} }}</span>\n                <select class=\"form-control form-select\" [(ngModel)]=\"endpoint\" (change)=\"selectEndpoint(endpoint)\"\n                    name=\"endpoint\">\n                    <option *ngFor=\"let e of endpoints\" [ngValue]=\"e\">{{e.title}}</option>\n                </select>\n            </div>\n        </div>\n        <div [hidden]=\"endpoint?.type !== 'layman' || isAuthorized\">\n            <div class=\"alert alert-info text-gray\">\n                {{'SAVECOMPOSITION.panelMd.youAreNotAuthorized' | translateHs : {app: data.app} }} </div>\n        </div>\n        <hs-layman-current-user class=\"d-block pb-5\" [app]=\"data.app\" *ngIf=\"endpoint?.type === 'layman'\"\n            [endpoint]=\"endpoint\">\n        </hs-layman-current-user>\n        <hs-save-map-form *ngIf=\"(isAuthorized || endpoint?.type !== 'layman')\" [app]=\"data.app\">\n        </hs-save-map-form>\n    </div>\n</div>", components: [{ type: HsPanelHeaderComponent, selector: "hs-panel-header", inputs: ["name", "app", "title"] }, { type: HsLaymanCurrentUserComponent, selector: "hs-layman-current-user", inputs: ["app", "endpoint"] }, { type: HsSaveMapAdvancedFormComponent, selector: "hs-save-map-form", inputs: ["app"] }], directives: [{ type: i3$1.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3$1.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i3$1.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "async": i3.AsyncPipe, "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSaveMapComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-save-map', template: "<div class=\"card panel-default hs-main-panel mainpanel hs-stc-mainpanel\" [hidden]=\"(isVisible$ | async) === false\">\n    <hs-panel-header name=\"saveMap\" [title]=\"'PANEL_HEADER.SAVECOMPOSITION' | translateHs : data\" [app]=\"data.app\">\n    </hs-panel-header>\n    <div class=\"card-body\">\n        <div class=\"form-group\">\n            <div class=\"input-group\">\n                <span class=\"input-group-text control-label\">{{'COMMON.saveTo' | translateHs : {app: data.app} }}</span>\n                <select class=\"form-control form-select\" [(ngModel)]=\"endpoint\" (change)=\"selectEndpoint(endpoint)\"\n                    name=\"endpoint\">\n                    <option *ngFor=\"let e of endpoints\" [ngValue]=\"e\">{{e.title}}</option>\n                </select>\n            </div>\n        </div>\n        <div [hidden]=\"endpoint?.type !== 'layman' || isAuthorized\">\n            <div class=\"alert alert-info text-gray\">\n                {{'SAVECOMPOSITION.panelMd.youAreNotAuthorized' | translateHs : {app: data.app} }} </div>\n        </div>\n        <hs-layman-current-user class=\"d-block pb-5\" [app]=\"data.app\" *ngIf=\"endpoint?.type === 'layman'\"\n            [endpoint]=\"endpoint\">\n        </hs-layman-current-user>\n        <hs-save-map-form *ngIf=\"(isAuthorized || endpoint?.type !== 'layman')\" [app]=\"data.app\">\n        </hs-save-map-form>\n    </div>\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsConfig }, { type: HsSaveMapManagerService }, { type: HsLayoutService }, { type: HsCommonLaymanService }, { type: HsCommonEndpointsService }, { type: HsSaveMapDialogSpawnerService }, { type: HsLanguageService }, { type: HsSidebarService }, { type: HsSaveMapService }]; } });

class HsSearchData {
    constructor(resultsLayerStyle) {
        this.canceler = new Subject();
        this.providers = {};
        this.searchResultsLayer = new VectorLayer({
            source: new Vector({}),
            style: resultsLayerStyle,
        });
        setTitle(this.searchResultsLayer, 'Search results');
        setShowInLayerManager(this.searchResultsLayer, false);
    }
}
class HsSearchService {
    constructor(http, hsUtilsService, hsConfig, hsMapService, hsStylerService, hsEventBusService, hsLayerUtilsService) {
        this.http = http;
        this.hsUtilsService = hsUtilsService;
        this.hsConfig = hsConfig;
        this.hsMapService = hsMapService;
        this.hsStylerService = hsStylerService;
        this.hsEventBusService = hsEventBusService;
        this.hsLayerUtilsService = hsLayerUtilsService;
        this.formatWKT = new WKT();
        this.apps = {};
    }
    init(app) {
        if (this.apps[app] == undefined) {
            this.apps[app] = new HsSearchData(this.hsStylerService.get(app).pin_white_blue_highlight);
        }
    }
    /**
     * @public
     * @param query - Place name or part of it
     * Send geolocation request to Geolocation server (based on app config), pass response to results function
     */
    request(query, app) {
        let url = null;
        let providers = [];
        if (this.hsConfig.get(app).search_provider !== undefined &&
            this.hsConfig.get(app).searchProvider === undefined) {
            this.hsConfig.get(app).searchProvider =
                this.hsConfig.get(app).search_provider;
        }
        if (this.hsConfig.get(app).searchProvider === undefined) {
            providers = ['geonames'];
        }
        else if (typeof this.hsConfig.get(app).searchProvider === 'string' ||
            typeof this.hsConfig.get(app).searchProvider === 'function') {
            providers = [this.hsConfig.get(app).searchProvider];
        }
        else if (typeof this.hsConfig.get(app).searchProvider === 'object') {
            providers = this.hsConfig.get(app).searchProvider;
        }
        this.cleanResults(app);
        for (const provider of providers) {
            let providerId = provider;
            if (provider == 'geonames') {
                if (this.hsConfig.get(app).geonamesUser !== undefined) {
                    url = `http://api.geonames.org/searchJSON?&name_startsWith=${query}&username=${this.hsConfig.get(app).geonamesUser}`;
                }
                else {
                    //Username will have to be set in proxy
                    url = this.hsUtilsService.proxify(`http://api.geonames.org/searchJSON?&name_startsWith=${query}`, app);
                }
                if (window.location.protocol == 'https:') {
                    url = this.hsUtilsService.proxify(url, app);
                }
            }
            else if (provider == 'sdi4apps_openapi') {
                url = 'http://portal.sdi4apps.eu/openapi/search?q=' + query;
            }
            else if (typeof provider === 'function') {
                url = provider(query);
                if (provider.name == 'searchProvider') {
                    //Anonymous function?
                    providerId = 'geonames';
                }
                else {
                    providerId = provider.name;
                }
            }
            //url = utils.proxify(url);
            const canceler = this.apps[app].canceler[providerId];
            if (canceler !== undefined) {
                canceler.unsubscribe();
            }
            this.apps[app].canceler[providerId] = this.http.get(url).subscribe((data) => {
                this.searchResultsReceived(data, providerId, app);
            }, () => {
                //
            });
        }
    }
    /**
     * @public
     * @param response - Response object of Geolocation request
     * @param providerName - Name of request provider
     * Maintain inner results object and parse response with correct provider parser
     */
    searchResultsReceived(response, providerName, app) {
        if (this.apps[app].providers[providerName] === undefined) {
            this.apps[app].providers[providerName] = {
                results: [],
                name: providerName,
            };
        }
        const provider = this.apps[app].providers[providerName];
        if (providerName.indexOf('geonames') > -1) {
            this.parseGeonamesResults(response, provider, app);
        }
        else if (providerName == 'sdi4apps_openapi') {
            this.parseOpenApiResults(response, provider, app);
        }
        else {
            this.parseGeonamesResults(response, provider, app);
        }
        this.apps[app].pointerMoveEventKey = this.hsMapService
            .getMap(app)
            .on('pointermove', (e) => this.mapPointerMoved(e, app));
        this.hsEventBusService.searchResultsReceived.next({
            app,
        });
    }
    /**
     * @public
     * Remove results layer from map
     */
    hideResultsLayer(app) {
        this.hsMapService
            .getMap(app)
            .removeLayer(this.apps[app].searchResultsLayer);
    }
    /**
     * @public
     * Send geolocation request to Geolocation server (based on app config), pass response to results function
     */
    showResultsLayer(app) {
        this.hideResultsLayer(app);
        this.hsMapService.getMap(app).addLayer(this.apps[app].searchResultsLayer);
    }
    /**
     * @public
     * Clean all search results from results variable and results layer
     */
    cleanResults(app) {
        if (this.apps[app].providers !== undefined) {
            for (const key of Object.keys(this.apps[app].providers)) {
                const provider = this.apps[app].providers[key];
                if (provider.results !== undefined) {
                    provider.results.length = 0;
                }
            }
            this.apps[app].searchResultsLayer.getSource().clear();
            this.hideResultsLayer(app);
            unByKey(this.apps[app].pointerMoveEventKey);
        }
    }
    /**
     * @param evt -
     * Highlight in the search list result, that corresponds with the nearest found feature under the pointer over the map
     */
    mapPointerMoved(evt, app) {
        console.log('searchlistener');
        const featuresUnderMouse = this.hsMapService
            .getMap(app)
            .getFeaturesAtPixel(evt.pixel)
            .filter((feature) => {
            const layer = this.hsMapService.getLayerForFeature(feature, app);
            return layer && layer == this.apps[app].searchResultsLayer;
        });
        for (const provider of Object.keys(this.apps[app].providers)
            .map((key) => this.apps[app].providers[key])
            .filter((provider) => provider === null || provider === void 0 ? void 0 : provider.results)) {
            this.hsLayerUtilsService.highlightFeatures(featuresUnderMouse, this.apps[app].searchResultsLayer, provider.results);
        }
    }
    /**
     * @public
     * @param result - Entity of selected result
     * @param zoomLevel - Zoom level to zoom on
     * Move map and zoom on selected search result
     */
    selectResult(result, zoomLevel, app) {
        const coordinate = this.getResultCoordinate(result, app);
        this.hsMapService.getMap(app).getView().setCenter(coordinate);
        if (zoomLevel === undefined) {
            zoomLevel = 10;
        }
        this.hsMapService.getMap(app).getView().setZoom(zoomLevel);
        this.hsEventBusService.searchZoomTo.next({
            coordinate: transform(coordinate, this.hsMapService.getCurrentProj(app), 'EPSG:4326'),
            zoom: zoomLevel,
        });
    }
    /**
     * @public
     * @param result - Entity of selected result
     * @returns Ol.coordinate of selected result
     * Parse coordinate of selected result
     */
    getResultCoordinate(result, app) {
        const currentProj = this.hsMapService.getCurrentProj(app);
        if (result.provider_name.indexOf('geonames') > -1 ||
            result.provider_name == 'searchFunctionsearchProvider') {
            return transform([parseFloat(result.lng), parseFloat(result.lat)], 'EPSG:4326', currentProj);
        }
        else if (result.provider_name == 'sdi4apps_openapi') {
            const g_feature = this.formatWKT.readFeature(result.FullGeom.toUpperCase());
            return g_feature.getGeometry().transform('EPSG:4326', currentProj).getCoordinates();
        }
    }
    /**
     * @param response - Result of search request
     * @param provider - Which provider sent the search results
     * Result parser of results from Geonames service
     */
    parseGeonamesResults(response, provider, app) {
        provider.results = response.geonames;
        this.generateGeonamesFeatures(provider, app);
    }
    /**
     * @param provider -
     */
    generateGeonamesFeatures(provider, app) {
        const src = this.apps[app].searchResultsLayer.getSource();
        for (const result of provider.results) {
            result.provider_name = provider.name;
            const feature = new Feature({
                geometry: new Point(this.getResultCoordinate(result, app)),
                record: result,
                id: this.hsUtilsService.generateUuid(),
            });
            feature.setId(feature.get('id'));
            src.addFeature(feature);
            result.featureId = feature.getId();
        }
    }
    /**
     * @param response - Result of search request
     * @param provider - Which provider sent the search results
     * Result parser of results from OpenApi service
     */
    parseOpenApiResults(response, provider, app) {
        provider.results = response.data;
        this.generateOpenApiFeatures(provider, app);
    }
    /**
     * @param provider -
     */
    generateOpenApiFeatures(provider, app) {
        const src = this.apps[app].searchResultsLayer.getSource();
        for (const result of provider.results) {
            result.provider_name = provider.name;
            const feature = new Feature({
                geometry: new Point(this.getResultCoordinate(result, app)),
                record: result,
            });
            src.addFeature(feature);
            result.feature = feature;
        }
    }
}
HsSearchService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSearchService, deps: [{ token: i1.HttpClient }, { token: HsUtilsService }, { token: HsConfig }, { token: HsMapService }, { token: HsStylerService }, { token: HsEventBusService }, { token: HsLayerUtilsService }], target: i0.ɵɵFactoryTarget.Injectable });
HsSearchService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSearchService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSearchService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: HsUtilsService }, { type: HsConfig }, { type: HsMapService }, { type: HsStylerService }, { type: HsEventBusService }, { type: HsLayerUtilsService }]; } });

/**
 * Add search input template to page
 */
class HsSearchInputComponent {
    constructor(hsSearchService, hsEventBusService, hsShareUrlService) {
        this.hsSearchService = hsSearchService;
        this.hsEventBusService = hsEventBusService;
        this.hsShareUrlService = hsShareUrlService;
        this.app = 'default';
        this.query = '';
        this.clearVisible = false;
        this.searchResultsReceivedSubscription =
            this.hsEventBusService.searchResultsReceived.subscribe((_) => {
                this.clearVisible = true;
            });
    }
    ngOnDestroy() {
        this.searchResultsReceivedSubscription.unsubscribe();
    }
    ngOnInit() {
        const query = this.hsShareUrlService.getParamValue(HS_PRMS.search);
        if (query) {
            this.query = query;
            this.queryChanged();
        }
        window.innerWidth < 767
            ? (this.searchInputVisible = false)
            : (this.searchInputVisible = true);
    }
    /**
     * Handler of search input, request search service and display results div
     */
    queryChanged() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.hsSearchService.hsMapService.loaded(this.app);
            if (this.query.length == 0) {
                this.clear();
                return;
            }
            this.hsSearchService.request(this.query, this.app);
        });
    }
    /**
     * Remove previous search and search results
     */
    clear() {
        this.query = '';
        this.clearVisible = false;
        this.hsSearchService.cleanResults(this.app);
        this.hsEventBusService.clearSearchResults.next({ app: this.app });
    }
    toggleSearchInput() {
        this.searchInputVisible = !this.searchInputVisible;
        if (this.query != '') {
            this.clear();
        }
    }
}
HsSearchInputComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSearchInputComponent, deps: [{ token: HsSearchService }, { token: HsEventBusService }, { token: HsShareUrlService }], target: i0.ɵɵFactoryTarget.Component });
HsSearchInputComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsSearchInputComponent, selector: "hs-search-input", inputs: { app: "app" }, ngImport: i0, template: "<div class=\"input-group\">\n    <button (click)=\"toggleSearchInput()\" class=\"btn btn-light btn-outline-secondary rounded-0 hs-toolbar-button\"><i\n            class=\"glyphicon icon-search\" [title]=\"'COMMON.search' | translateHs : {app} \"></i></button>\n    <input [(ngModel)]=\"query\" [hidden]=\"!searchInputVisible\" name=\"query\"\n        class=\"form-control hs-search-address-input rounded-0 hs-toolbar-button\"\n        [placeholder]=\"'COMMON.search' | translateHs : {app} \" (ngModelChange)=\"queryChanged()\">\n    <button class=\"clearSearch\" (click)=\"clear()\" *ngIf=\"clearVisible\"><i\n            class=\"icon-remove-circle align-middle\"></i></button>\n</div>\n", directives: [{ type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSearchInputComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-search-input', template: "<div class=\"input-group\">\n    <button (click)=\"toggleSearchInput()\" class=\"btn btn-light btn-outline-secondary rounded-0 hs-toolbar-button\"><i\n            class=\"glyphicon icon-search\" [title]=\"'COMMON.search' | translateHs : {app} \"></i></button>\n    <input [(ngModel)]=\"query\" [hidden]=\"!searchInputVisible\" name=\"query\"\n        class=\"form-control hs-search-address-input rounded-0 hs-toolbar-button\"\n        [placeholder]=\"'COMMON.search' | translateHs : {app} \" (ngModelChange)=\"queryChanged()\">\n    <button class=\"clearSearch\" (click)=\"clear()\" *ngIf=\"clearVisible\"><i\n            class=\"icon-remove-circle align-middle\"></i></button>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: HsSearchService }, { type: HsEventBusService }, { type: HsShareUrlService }]; }, propDecorators: { app: [{
                type: Input
            }] } });

class limitToPipe {
    transform(value, limit) {
        return value.slice(0, limit);
    }
}
limitToPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: limitToPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
limitToPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: limitToPipe, name: "limitTo" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: limitToPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'limitTo' }]
        }] });

/**
 * Add search results template to page
 */
class HsSearchResultsComponent {
    constructor(hsEventBusService, hsSearchService) {
        this.hsEventBusService = hsEventBusService;
        this.hsSearchService = hsSearchService;
        this.app = 'default';
        this.ngUnsubscribe = new Subject();
        this.hsEventBusService.searchResultsReceived
            .pipe(takeUntil$1(this.ngUnsubscribe))
            .subscribe(({ app }) => {
            if (app == this.app) {
                this.searchResultsReceived();
            }
        });
        this.hsEventBusService.clearSearchResults
            .pipe(takeUntil$1(this.ngUnsubscribe))
            .subscribe(({ app }) => {
            if (app == this.app) {
                this.clear();
            }
        });
    }
    ngOnInit() {
        this.hsSearchService.init(this.app);
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    /**
     * Handler for receiving results of search request, sends results to correct parser
     */
    searchResultsReceived() {
        this.searchResultsVisible = true;
        this.hsSearchService.showResultsLayer(this.app);
    }
    clear() {
        this.searchResultsVisible = false;
    }
    /**
     * @param featureId - feature id
     * Finds feature from search result layer based on featureId
     */
    findFeature(featureId) {
        return this.hsSearchService.apps[this.app].searchResultsLayer
            .getSource()
            .getFeatureById(featureId);
    }
    /**
     * @param result - Search result record
     * @param highlight - Feature highlight state
     * Highlights feature, when hovering search list
     */
    highlightResult(result, highlight) {
        const found = this.findFeature(result.featureId);
        if (found) {
            setHighlighted(found, highlight);
        }
    }
    /**
     * Zoom map to selected result from results list
     *
     * @param result - Selected result
     */
    zoomTo(result) {
        this.fcode_zoom_map = {
            'PPLA': 12,
            'PPL': 15,
            'PPLC': 10,
            'ADM1': 9,
            'FRM': 15,
            'PPLF': 13,
            'LCTY': 13,
            'RSTN': 15,
            'PPLA3': 9,
            'AIRP': 13,
            'AIRF': 13,
            'HTL': 17,
            'STM': 14,
            'LK': 13,
        };
        let zoom_level = 10;
        if (result.fcode !== undefined &&
            this.fcode_zoom_map[result.fcode] !== undefined) {
            zoom_level = this.fcode_zoom_map[result.fcode];
        }
        this.hsSearchService.selectResult(result, zoom_level, this.app);
    }
}
HsSearchResultsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSearchResultsComponent, deps: [{ token: HsEventBusService }, { token: HsSearchService }], target: i0.ɵɵFactoryTarget.Component });
HsSearchResultsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsSearchResultsComponent, selector: "hs-search-results", inputs: { app: "app" }, ngImport: i0, template: "<div class=\"list-group\" [hidden]=\"!searchResultsVisible\" style=\"display: block; margin-bottom: 0px\">\n    <div *ngFor=\"let provider of hsSearchService.apps[app].providers | keyvalue \">\n        <a class=\"list-group-item active\" [hidden]=\"!(provider.value.results.length > 0)\">Provider:\n            {{provider.value.name}}</a>\n        <a *ngFor=\"let result of provider.value.results | limitTo: 10\" class=\"list-group-item hsl-search-result\"\n            [ngClass]=\"{'active': result.highlighted}\" (click)=\"zoomTo(result)\"\n            (mouseover)=\"highlightResult(result, true)\" (mouseleave)=\"highlightResult(result, false)\"\n            [attr.title]=\"result.DisplayDescription\">{{result.name || result.DisplayTitle}}<small\n                style=\"color: rgb(148, 143, 143)\"><br>{{result.fcodeName}}</small></a>\n    </div>\n</div>", directives: [{ type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], pipes: { "keyvalue": i3.KeyValuePipe, "limitTo": limitToPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSearchResultsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-search-results', template: "<div class=\"list-group\" [hidden]=\"!searchResultsVisible\" style=\"display: block; margin-bottom: 0px\">\n    <div *ngFor=\"let provider of hsSearchService.apps[app].providers | keyvalue \">\n        <a class=\"list-group-item active\" [hidden]=\"!(provider.value.results.length > 0)\">Provider:\n            {{provider.value.name}}</a>\n        <a *ngFor=\"let result of provider.value.results | limitTo: 10\" class=\"list-group-item hsl-search-result\"\n            [ngClass]=\"{'active': result.highlighted}\" (click)=\"zoomTo(result)\"\n            (mouseover)=\"highlightResult(result, true)\" (mouseleave)=\"highlightResult(result, false)\"\n            [attr.title]=\"result.DisplayDescription\">{{result.name || result.DisplayTitle}}<small\n                style=\"color: rgb(148, 143, 143)\"><br>{{result.fcodeName}}</small></a>\n    </div>\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsEventBusService }, { type: HsSearchService }]; }, propDecorators: { app: [{
                type: Input
            }] } });

class HsSearchComponent extends HsPanelBaseComponent {
    constructor(hsEventBusService, hsLayoutService, hsLanguageService, hsSidebarService) {
        super(hsLayoutService);
        this.hsEventBusService = hsEventBusService;
        this.hsLayoutService = hsLayoutService;
        this.hsLanguageService = hsLanguageService;
        this.hsSidebarService = hsSidebarService;
        this.replace = false;
        this.clearVisible = false;
        this.name = 'search';
        this.searchResultsReceivedSubscription =
            this.hsEventBusService.searchResultsReceived.subscribe(() => {
                this.clearVisible = true;
            });
    }
    ngOnDestroy() {
        this.searchResultsReceivedSubscription.unsubscribe();
    }
    ngOnInit() {
        this.hsSidebarService.addButton({
            panel: 'search',
            module: 'hs.search',
            order: 15,
            fits: true,
            title: 'PANEL_HEADER.SEARCH',
            description: 'SIDEBAR.descriptions.SEARCH',
            icon: 'icon-search',
        }, this.data.app);
        window.innerWidth < 767
            ? (this.searchInputVisible = false)
            : (this.searchInputVisible = true);
    }
}
HsSearchComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSearchComponent, deps: [{ token: HsEventBusService }, { token: HsLayoutService }, { token: HsLanguageService }, { token: HsSidebarService }], target: i0.ɵɵFactoryTarget.Component });
HsSearchComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsSearchComponent, selector: "hs-search", usesInheritance: true, ngImport: i0, template: "<div [hidden]=\"(isVisible$ | async) === false\">\n    <hs-panel-header name=\"Search\" [title]=\"'PANEL_HEADER.SEARCH' | translateHs : data\" [app]=\"data.app\"></hs-panel-header>\n    <div class=\"input-group search-panel hs-search-address pt-1 pb-1 d-flex\">\n        <hs-search-input [app]=\"data.app\"></hs-search-input>\n        <hs-search-results [app]=\"data.app\"></hs-search-results>\n    </div>\n</div>\n", components: [{ type: HsPanelHeaderComponent, selector: "hs-panel-header", inputs: ["name", "app", "title"] }, { type: HsSearchInputComponent, selector: "hs-search-input", inputs: ["app"] }, { type: HsSearchResultsComponent, selector: "hs-search-results", inputs: ["app"] }], pipes: { "async": i3.AsyncPipe, "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSearchComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-search', template: "<div [hidden]=\"(isVisible$ | async) === false\">\n    <hs-panel-header name=\"Search\" [title]=\"'PANEL_HEADER.SEARCH' | translateHs : data\" [app]=\"data.app\"></hs-panel-header>\n    <div class=\"input-group search-panel hs-search-address pt-1 pb-1 d-flex\">\n        <hs-search-input [app]=\"data.app\"></hs-search-input>\n        <hs-search-results [app]=\"data.app\"></hs-search-results>\n    </div>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: HsEventBusService }, { type: HsLayoutService }, { type: HsLanguageService }, { type: HsSidebarService }]; } });

class HsSearchToolbarComponent extends HsToolbarPanelBaseComponent {
    constructor(hsLayoutService) {
        super(hsLayoutService);
        this.hsLayoutService = hsLayoutService;
        this.name = 'searchToolbar';
    }
}
HsSearchToolbarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSearchToolbarComponent, deps: [{ token: HsLayoutService }], target: i0.ɵɵFactoryTarget.Component });
HsSearchToolbarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsSearchToolbarComponent, selector: "hs-search-toolbar", usesInheritance: true, ngImport: i0, template: "<div class=\"nav-item\" [hidden]=\"(isVisible$ | async) === false\">\n    <div>\n        <hs-search-input [app]=\"data.app\"></hs-search-input>\n        <hs-search-results [app]=\"data.app\"></hs-search-results>\n    </div>\n</div>", components: [{ type: HsSearchInputComponent, selector: "hs-search-input", inputs: ["app"] }, { type: HsSearchResultsComponent, selector: "hs-search-results", inputs: ["app"] }], pipes: { "async": i3.AsyncPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSearchToolbarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-search-toolbar', template: "<div class=\"nav-item\" [hidden]=\"(isVisible$ | async) === false\">\n    <div>\n        <hs-search-input [app]=\"data.app\"></hs-search-input>\n        <hs-search-results [app]=\"data.app\"></hs-search-results>\n    </div>\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsLayoutService }]; } });

class HsShareComponent extends HsPanelBaseComponent {
    constructor(HsShareService, HsShareUrlService, HsCore, HsLayoutService, hsLanguageService, hsSidebarService) {
        super(HsLayoutService);
        this.HsShareService = HsShareService;
        this.HsShareUrlService = HsShareUrlService;
        this.HsCore = HsCore;
        this.hsLanguageService = hsLanguageService;
        this.hsSidebarService = hsSidebarService;
        this.new_share = false;
        this.name = 'permalink';
    }
    /**
     * @returns {string} Iframe tag with src attribute on embed Url and default width and height (1000x700px)
     * @description Create Iframe tag for embedded map
     */
    updateEmbedCode() {
        return this.HsShareService.getEmbedCode();
    }
    /**
     * @returns {string} Right share Url
     * @description Select right share Url based on shareLink property (either Permalink Url or PureMap url)
     */
    getShareUrl() {
        return this.HsShareService.getShareUrl();
    }
    /**
     * @description Set share Url state invalid
     */
    invalidateShareUrl() {
        this.HsShareService.invalidateShareUrl();
    }
    /**
     * @description Create share post on selected social network
     */
    shareOnSocial() {
        this.HsShareService.shareOnSocial(this.new_share, this.data.app);
    }
    ngOnInit() {
        this.hsSidebarService.addButton({
            panel: 'permalink',
            module: 'hs.permalink',
            order: 11,
            fits: true,
            title: 'PANEL_HEADER.PERMALINK',
            description: 'SIDEBAR.descriptions.PERMALINK',
            icon: 'icon-share-alt',
        }, this.data.app);
        this.HsShareUrlService.init(this.data.app);
        this.HsShareService.init(this.data.app);
    }
}
HsShareComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsShareComponent, deps: [{ token: HsShareService }, { token: HsShareUrlService }, { token: HsCoreService }, { token: HsLayoutService }, { token: HsLanguageService }, { token: HsSidebarService }], target: i0.ɵɵFactoryTarget.Component });
HsShareComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsShareComponent, selector: "hs-share", usesInheritance: true, ngImport: i0, template: "<div class=\"card panel-default hs-main-panel\" [hidden]=\"(isVisible$ | async) === false\">\n    <hs-panel-header name=\"permalink\" [title]=\"'PANEL_HEADER.PERMALINK' | translateHs : data\" [app]=\"data.app\">\n    </hs-panel-header>\n    <div class=\"card-body\">\n        <div class=\"card-body\">\n\n            <div class=\"form-group\">\n                <label for=\"pure-map-link\" class=\"control-label\">{{'PERMALINK.sharePureMap' | translateHs :\n                    {app: data.app} }}</label>\n                <a [href]=\"HsShareService.data.pureMapUrl\" target=\"_blank\"\n                    id=\"pure-map-link\">{{HsShareService.data.pureMapUrl}}</a>\n                <p><sub class=\"text-danger\">{{'PERMALINK.sharesOnlyMap' | translateHs : {app: data.app} }}</sub></p>\n            </div>\n            <br>\n            <div class=\"form-group\">\n                <label for=\"permalink-link\" class=\"control-label\">{{'PERMALINK.permalink' | translateHs :\n                    {app: data.app} }}</label><br />\n                <a [href]=\"HsShareService.data.permalinkUrl\" target=\"_blank\" style=\"overflow-x: hidden;\"\n                    id=\"permalink-link\">{{HsShareService.data.permalinkUrl}}</a>\n                <p><sub class=\"text-danger\">{{'PERMALINK.sharesMapWith' | translateHs : {app: data.app} }}</sub></p>\n            </div>\n            <hr>\n\n            <fieldset class=\"form-group\">\n                <label class=\"mb-2\" style=\"font-size: 1.5em;\" for=\"{{'share-link-' + data.app}}\">{{'PERMALINK.linkFor' |\n                    translateHs : {app: data.app} }}&nbsp;<span [hidden]=\"!HsCore.embeddedEnabled\">{{'PERMALINK.embed' |\n                        translateHs : {app: data.app} }}/</span>{{'PERMALINK.socialShare' | translateHs : {app: data.app} }}\n                </label>\n                <div class=\"form-check\">\n                    <label class=\"form-check-label\">\n                        <input type=\"radio\" class=\"form-check-input\" [name]=\"'share-link-' + data.app\" value=\"puremap\"\n                            [(ngModel)]=\"HsShareService.data.shareLink\" (click)=\"updateEmbedCode()\">\n                        {{'PERMALINK.pureMap' | translateHs : {app: data.app} }}\n                    </label>\n                </div>\n                <div class=\"form-check\">\n                    <label class=\"form-check-label\">\n                        <input type=\"radio\" class=\"form-check-input\" [name]=\"'share-link-' + data.app\" value=\"permalink\"\n                            [(ngModel)]=\"HsShareService.data.shareLink\" (click)=\"updateEmbedCode()\">\n                        {{'PERMALINK.permalink' | translateHs : {app: data.app} }}\n                    </label>\n                </div>\n            </fieldset>\n            <div class=\"form-floating mb-3\" [hidden]=\"!HsCore.embeddedEnabled\">\n                <textarea class=\"form-control\" style=\"height: 80px\" id=\"permalink-embed\"\n                    placeholder=\"'PERMALINK.embedCode' | translateHs : data\" [(ngModel)]=\"HsShareService.data.embedCode\"\n                    [ngModelOptions]=\"{standalone: true}\"></textarea>\n                <label for=\"permalink-embed\" class=\"control-label\">{{'PERMALINK.embedCode' | translateHs :\n                    {app: data.app} }}</label>\n                <br>\n            </div>\n\n            <hr>\n\n            <fieldset>\n                <h4>{{'PERMALINK.shareOnSocialNetwork' | translateHs : {app: data.app} }}</h4>\n                <div class=\"form-floating mb-3\" [title]=\"'COMMON.fillInName' | translateHs : data\">\n                    <input type=\"text\" class=\"form-control\" id=\"hs-prmlnk-title\"\n                        [placeholder]=\"'COMMON.name' | translateHs : data\" (change)=\"invalidateShareUrl()\"\n                        [(ngModel)]=\"HsShareService.data.title\" [ngModelOptions]=\"{standalone: true}\">\n                    <label for=\"hs-prmlnk-title\" class=\"control-label\">{{'COMMON.name' | translateHs : {app: data.app} }}</label>\n                </div>\n                <div class=\"form-floating mb-3\" [title]=\"'COMMON.fillInDescriptive' | translateHs : data\">\n                    <textarea class=\"form-control\" id=\"hs-prmlnk-abstract\"\n                        [placeholder]=\"'COMMON.abstract' | translateHs : data\" (change)=\"invalidateShareUrl()\"\n                        [(ngModel)]=\"HsShareService.data.abstract\"\n                        [ngModelOptions]=\"{standalone: true}\">                    </textarea>\n                    <label for=\"hs-prmlnk-abstract\" class=\"control-label\">{{'COMMON.abstract' | translateHs :\n                        {app: data.app} }}</label>\n                </div>\n\n                <div class=\"form-group\">\n                    <div class=\"form-group\">\n                        <label class=\"control-label\"><input type=\"checkbox\" class=\"me-2\" [(ngModel)]=\"new_share\"\n                                [ngModelOptions]=\"{standalone: true}\" /><span class=\"ng-scope\">{{'PERMALINK.newShare' |\n                                translateHs : {app: data.app} }}</span></label>\n                    </div>\n                    <div class=\"btn-group\" role=\"group\">\n                        <button class=\"btn btn-secondary\" (click)=\"shareOnSocial()\">\n                            <i class=\"icon-share-alt\"></i> {{'COMMON.share' | translateHs : {app: data.app} }}\n                        </button>\n                    </div>\n                </div>\n\n                <div class=\"form-group\">\n                    <label class=\"control-label\">{{'COMMON.thumbnail' | translateHs : {app: data.app} }}</label>\n                    <img class=\"img-thumbnail hs-permalink-thumbnail\" alt=\"Thumbnail\" width=\"256\" height=\"256\">\n                </div>\n            </fieldset>\n        </div>\n    </div>\n</div>\n", components: [{ type: HsPanelHeaderComponent, selector: "hs-panel-header", inputs: ["name", "app", "title"] }], directives: [{ type: i3$1.RadioControlValueAccessor, selector: "input[type=radio][formControlName],input[type=radio][formControl],input[type=radio][ngModel]", inputs: ["name", "formControlName", "value"] }, { type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3$1.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }], pipes: { "async": i3.AsyncPipe, "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsShareComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-share', template: "<div class=\"card panel-default hs-main-panel\" [hidden]=\"(isVisible$ | async) === false\">\n    <hs-panel-header name=\"permalink\" [title]=\"'PANEL_HEADER.PERMALINK' | translateHs : data\" [app]=\"data.app\">\n    </hs-panel-header>\n    <div class=\"card-body\">\n        <div class=\"card-body\">\n\n            <div class=\"form-group\">\n                <label for=\"pure-map-link\" class=\"control-label\">{{'PERMALINK.sharePureMap' | translateHs :\n                    {app: data.app} }}</label>\n                <a [href]=\"HsShareService.data.pureMapUrl\" target=\"_blank\"\n                    id=\"pure-map-link\">{{HsShareService.data.pureMapUrl}}</a>\n                <p><sub class=\"text-danger\">{{'PERMALINK.sharesOnlyMap' | translateHs : {app: data.app} }}</sub></p>\n            </div>\n            <br>\n            <div class=\"form-group\">\n                <label for=\"permalink-link\" class=\"control-label\">{{'PERMALINK.permalink' | translateHs :\n                    {app: data.app} }}</label><br />\n                <a [href]=\"HsShareService.data.permalinkUrl\" target=\"_blank\" style=\"overflow-x: hidden;\"\n                    id=\"permalink-link\">{{HsShareService.data.permalinkUrl}}</a>\n                <p><sub class=\"text-danger\">{{'PERMALINK.sharesMapWith' | translateHs : {app: data.app} }}</sub></p>\n            </div>\n            <hr>\n\n            <fieldset class=\"form-group\">\n                <label class=\"mb-2\" style=\"font-size: 1.5em;\" for=\"{{'share-link-' + data.app}}\">{{'PERMALINK.linkFor' |\n                    translateHs : {app: data.app} }}&nbsp;<span [hidden]=\"!HsCore.embeddedEnabled\">{{'PERMALINK.embed' |\n                        translateHs : {app: data.app} }}/</span>{{'PERMALINK.socialShare' | translateHs : {app: data.app} }}\n                </label>\n                <div class=\"form-check\">\n                    <label class=\"form-check-label\">\n                        <input type=\"radio\" class=\"form-check-input\" [name]=\"'share-link-' + data.app\" value=\"puremap\"\n                            [(ngModel)]=\"HsShareService.data.shareLink\" (click)=\"updateEmbedCode()\">\n                        {{'PERMALINK.pureMap' | translateHs : {app: data.app} }}\n                    </label>\n                </div>\n                <div class=\"form-check\">\n                    <label class=\"form-check-label\">\n                        <input type=\"radio\" class=\"form-check-input\" [name]=\"'share-link-' + data.app\" value=\"permalink\"\n                            [(ngModel)]=\"HsShareService.data.shareLink\" (click)=\"updateEmbedCode()\">\n                        {{'PERMALINK.permalink' | translateHs : {app: data.app} }}\n                    </label>\n                </div>\n            </fieldset>\n            <div class=\"form-floating mb-3\" [hidden]=\"!HsCore.embeddedEnabled\">\n                <textarea class=\"form-control\" style=\"height: 80px\" id=\"permalink-embed\"\n                    placeholder=\"'PERMALINK.embedCode' | translateHs : data\" [(ngModel)]=\"HsShareService.data.embedCode\"\n                    [ngModelOptions]=\"{standalone: true}\"></textarea>\n                <label for=\"permalink-embed\" class=\"control-label\">{{'PERMALINK.embedCode' | translateHs :\n                    {app: data.app} }}</label>\n                <br>\n            </div>\n\n            <hr>\n\n            <fieldset>\n                <h4>{{'PERMALINK.shareOnSocialNetwork' | translateHs : {app: data.app} }}</h4>\n                <div class=\"form-floating mb-3\" [title]=\"'COMMON.fillInName' | translateHs : data\">\n                    <input type=\"text\" class=\"form-control\" id=\"hs-prmlnk-title\"\n                        [placeholder]=\"'COMMON.name' | translateHs : data\" (change)=\"invalidateShareUrl()\"\n                        [(ngModel)]=\"HsShareService.data.title\" [ngModelOptions]=\"{standalone: true}\">\n                    <label for=\"hs-prmlnk-title\" class=\"control-label\">{{'COMMON.name' | translateHs : {app: data.app} }}</label>\n                </div>\n                <div class=\"form-floating mb-3\" [title]=\"'COMMON.fillInDescriptive' | translateHs : data\">\n                    <textarea class=\"form-control\" id=\"hs-prmlnk-abstract\"\n                        [placeholder]=\"'COMMON.abstract' | translateHs : data\" (change)=\"invalidateShareUrl()\"\n                        [(ngModel)]=\"HsShareService.data.abstract\"\n                        [ngModelOptions]=\"{standalone: true}\">                    </textarea>\n                    <label for=\"hs-prmlnk-abstract\" class=\"control-label\">{{'COMMON.abstract' | translateHs :\n                        {app: data.app} }}</label>\n                </div>\n\n                <div class=\"form-group\">\n                    <div class=\"form-group\">\n                        <label class=\"control-label\"><input type=\"checkbox\" class=\"me-2\" [(ngModel)]=\"new_share\"\n                                [ngModelOptions]=\"{standalone: true}\" /><span class=\"ng-scope\">{{'PERMALINK.newShare' |\n                                translateHs : {app: data.app} }}</span></label>\n                    </div>\n                    <div class=\"btn-group\" role=\"group\">\n                        <button class=\"btn btn-secondary\" (click)=\"shareOnSocial()\">\n                            <i class=\"icon-share-alt\"></i> {{'COMMON.share' | translateHs : {app: data.app} }}\n                        </button>\n                    </div>\n                </div>\n\n                <div class=\"form-group\">\n                    <label class=\"control-label\">{{'COMMON.thumbnail' | translateHs : {app: data.app} }}</label>\n                    <img class=\"img-thumbnail hs-permalink-thumbnail\" alt=\"Thumbnail\" width=\"256\" height=\"256\">\n                </div>\n            </fieldset>\n        </div>\n    </div>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: HsShareService }, { type: HsShareUrlService }, { type: HsCoreService }, { type: HsLayoutService }, { type: HsLanguageService }, { type: HsSidebarService }]; } });

class HsAddColormapComponent {
    constructor(HsLanguageService, hsStylerService) {
        this.HsLanguageService = HsLanguageService;
        this.hsStylerService = hsStylerService;
        this.name = 'add-colormap';
        this.colorMaps = Object.keys(colorScales);
        this.min = '';
        this.max = '';
        this.canceled = new EventEmitter();
    }
    ngOnInit() {
        const src = this.layer.getSource();
        const features = src.getFeatures();
        this.attributes = listNumericAttributes(features);
    }
    changeAttrib() {
        const values = this.layer
            .getSource()
            .getFeatures()
            .map((f) => parseFloat(f.get(this.weightAttribute)));
        const min = Math.min(...values);
        const max = Math.max(...values);
        if (!isNaN(min)) {
            this.min = min;
        }
        if (!isNaN(max)) {
            this.max = max;
        }
    }
    save() {
        this.hsStylerService.addRule('ColorMap', this.data.app, {
            colorMapName: this.colorMap,
            min: this.min ? parseFloat(this.min.toString()) : undefined,
            max: this.max ? parseFloat(this.max.toString()) : undefined,
            attribute: this.weightAttribute,
        });
    }
    cancel() {
        this.canceled.emit();
    }
}
HsAddColormapComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddColormapComponent, deps: [{ token: HsLanguageService }, { token: HsStylerService }], target: i0.ɵɵFactoryTarget.Component });
HsAddColormapComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsAddColormapComponent, selector: "add-colormap", inputs: { layer: "layer", data: "data" }, outputs: { canceled: "canceled" }, ngImport: i0, template: "<div class=\"form-group\">\n  <div class=\"form-inline\">\n    <label class=\"control-label\" style=\"width: 100%; justify-content: left\">{{\n      \"LAYERMANAGER.layerEditor.interpolatedAttribute\" | translateHs : {app: data.app} }}:</label>\n\n    <select class=\"form-control form-select\" style=\"width: 100%\" [(ngModel)]=\"weightAttribute\"\n      [ngModelOptions]=\"{standalone: true}\" (change)=\"changeAttrib()\">\n      <option [ngValue]=\"attr\" *ngFor=\"let attr of attributes\">\n        {{attr}}\n      </option>\n    </select>\n  </div>\n\n  <div class=\"form-inline\">\n    <label class=\"control-label\" style=\"width: 100%; justify-content: left\">{{\n      \"LAYERMANAGER.layerEditor.colorMap\" | translateHs : {app: data.app} }}:</label>\n\n    <select class=\"form-control form-select\" style=\"width: 100%\" [(ngModel)]=\"colorMap\"\n      [ngModelOptions]=\"{standalone: true}\">\n      <option [ngValue]=\"cm\" *ngFor=\"let cm of colorMaps\">\n        {{cm}}\n      </option>\n    </select>\n  </div>\n\n  <div class=\"row g-3\">\n    <div class=\"col-md-6\">\n      <label class=\"form-label\">{{\n        \"LAYERMANAGER.layerEditor.min\" | translateHs : {app: data.app} }}:</label>\n      <input class=\"form-control inline\" [(ngModel)]=\"min\" name=\"hsIdwMin\"/>\n\n    </div>\n    <div class=\"col-md-6\">\n      <label class=\"form-label\">{{\n        \"LAYERMANAGER.layerEditor.max\" | translateHs : {app: data.app} }}:</label>\n      <input class=\"form-control\" [(ngModel)]=\"max\" name=\"hsIdwMax\" />\n    </div>\n  </div>\n\n  <div class=\"row g-3 p-2\">\n    <div class=\"col-md-6\">\n        <button (click)=\"save()\" class=\"btn btn-primary\">{{\"COMMON.apply\" | translateHs : {app: data.app} }}</button>\n    </div>\n    <div class=\"col-md-6\">\n      <button (click)=\"cancel()\" class=\"btn btn-outline-secondary\">{{\"COMMON.close\" | translateHs : {app: data.app} }}</button>\n  </div>\n  </div>\n</div>", directives: [{ type: i3$1.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3$1.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i3$1.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddColormapComponent, decorators: [{
            type: Component,
            args: [{ selector: 'add-colormap', template: "<div class=\"form-group\">\n  <div class=\"form-inline\">\n    <label class=\"control-label\" style=\"width: 100%; justify-content: left\">{{\n      \"LAYERMANAGER.layerEditor.interpolatedAttribute\" | translateHs : {app: data.app} }}:</label>\n\n    <select class=\"form-control form-select\" style=\"width: 100%\" [(ngModel)]=\"weightAttribute\"\n      [ngModelOptions]=\"{standalone: true}\" (change)=\"changeAttrib()\">\n      <option [ngValue]=\"attr\" *ngFor=\"let attr of attributes\">\n        {{attr}}\n      </option>\n    </select>\n  </div>\n\n  <div class=\"form-inline\">\n    <label class=\"control-label\" style=\"width: 100%; justify-content: left\">{{\n      \"LAYERMANAGER.layerEditor.colorMap\" | translateHs : {app: data.app} }}:</label>\n\n    <select class=\"form-control form-select\" style=\"width: 100%\" [(ngModel)]=\"colorMap\"\n      [ngModelOptions]=\"{standalone: true}\">\n      <option [ngValue]=\"cm\" *ngFor=\"let cm of colorMaps\">\n        {{cm}}\n      </option>\n    </select>\n  </div>\n\n  <div class=\"row g-3\">\n    <div class=\"col-md-6\">\n      <label class=\"form-label\">{{\n        \"LAYERMANAGER.layerEditor.min\" | translateHs : {app: data.app} }}:</label>\n      <input class=\"form-control inline\" [(ngModel)]=\"min\" name=\"hsIdwMin\"/>\n\n    </div>\n    <div class=\"col-md-6\">\n      <label class=\"form-label\">{{\n        \"LAYERMANAGER.layerEditor.max\" | translateHs : {app: data.app} }}:</label>\n      <input class=\"form-control\" [(ngModel)]=\"max\" name=\"hsIdwMax\" />\n    </div>\n  </div>\n\n  <div class=\"row g-3 p-2\">\n    <div class=\"col-md-6\">\n        <button (click)=\"save()\" class=\"btn btn-primary\">{{\"COMMON.apply\" | translateHs : {app: data.app} }}</button>\n    </div>\n    <div class=\"col-md-6\">\n      <button (click)=\"cancel()\" class=\"btn btn-outline-secondary\">{{\"COMMON.close\" | translateHs : {app: data.app} }}</button>\n  </div>\n  </div>\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsLanguageService }, { type: HsStylerService }]; }, propDecorators: { layer: [{
                type: Input
            }], canceled: [{
                type: Output
            }], data: [{
                type: Input
            }] } });

class HsStylerPartBaseComponent {
    constructor() {
        this.changes = new EventEmitter();
        this.app = 'default';
    }
    emitChange() {
        this.changes.emit();
    }
}
HsStylerPartBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsStylerPartBaseComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
HsStylerPartBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsStylerPartBaseComponent, selector: "ng-component", inputs: { warning: "warning", app: "app" }, outputs: { changes: "changes" }, ngImport: i0, template: '<div></div>', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsStylerPartBaseComponent, decorators: [{
            type: Component,
            args: [{
                    template: '<div></div>',
                }]
        }], propDecorators: { changes: [{
                type: Output
            }], warning: [{
                type: Input
            }], app: [{
                type: Input
            }] } });

var Kinds;
(function (Kinds) {
    Kinds["fill"] = "Fill";
    Kinds["icon"] = "Icon";
    Kinds["line"] = "Line";
    Kinds["text"] = "Text";
    Kinds["mark"] = "Mark";
})(Kinds || (Kinds = {}));

class HsFiltersService {
    add(kind, append, collection) {
        let filter;
        switch (kind) {
            case 'AND':
                filter = ['&&', ['==', '<attribute>', '<value>']];
                break;
            case 'OR':
                filter = ['||', ['==', '<attribute>', '<value>']];
                break;
            case 'COMPARE':
                filter = ['==', '<attribute>', '<value>'];
                break;
            default:
        }
        if (append) {
            collection.push(filter);
        }
        else {
            collection.length = 0;
            collection.push(...filter);
        }
    }
    humanReadableLogOp(logOp) {
        return { '&&': 'AND', '||': 'OR', '!': 'NOT' }[logOp];
    }
    isLogOp(filters) {
        return (filters === null || filters === void 0 ? void 0 : filters.length) > 0 && ['&&', '||'].includes(filters[0]);
    }
}
HsFiltersService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsFiltersService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
HsFiltersService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsFiltersService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsFiltersService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class HsAddFilterButtonComponent {
    constructor() {
        this.clicks = new EventEmitter();
        this.app = 'default';
    }
    emitClick(kind) {
        this.clicks.emit({ kind });
    }
}
HsAddFilterButtonComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddFilterButtonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
HsAddFilterButtonComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsAddFilterButtonComponent, selector: "hs-add-filter-button", inputs: { app: "app" }, outputs: { clicks: "clicks" }, ngImport: i0, template: "<div class=\"p-1\">\n  <div ngbDropdown class=\"d-inline-block\">\n    <button class=\"btn btn-outline-primary btn-sm\" [title]=\"'STYLER.addFilter' | translateHs : {app} \" id=\"dropdownAddFilter\"\n      ngbDropdownToggle>\n      <span class=\"icon-plus\"></span>\n    </button>\n    <div ngbDropdownMenu aria-labelledby=\"dropdownAddFilter\">\n      <button ngbDropdownItem (click)=\"emitClick('AND')\">\n        {{'STYLER.andFilter' | translateHs : {app} }}\n      </button>\n      <button ngbDropdownItem (click)=\"emitClick('OR')\">\n        {{'STYLER.orFilter' | translateHs : {app} }}\n      </button>\n      <button ngbDropdownItem (click)=\"emitClick('NOT')\">\n        {{'STYLER.notFilter' | translateHs : {app} }}\n      </button>\n      <button ngbDropdownItem (click)=\"emitClick('COMPARE')\">\n        {{'STYLER.comparisonFilter' | translateHs : {app} }}\n      </button>\n    </div>\n  </div>\n</div>", directives: [{ type: i7.NgbDropdown, selector: "[ngbDropdown]", inputs: ["autoClose", "dropdownClass", "open", "placement", "container", "display"], outputs: ["openChange"], exportAs: ["ngbDropdown"] }, { type: i7.NgbDropdownToggle, selector: "[ngbDropdownToggle]" }, { type: i7.NgbDropdownMenu, selector: "[ngbDropdownMenu]" }, { type: i7.NgbDropdownItem, selector: "[ngbDropdownItem]", inputs: ["disabled"] }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddFilterButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-add-filter-button', template: "<div class=\"p-1\">\n  <div ngbDropdown class=\"d-inline-block\">\n    <button class=\"btn btn-outline-primary btn-sm\" [title]=\"'STYLER.addFilter' | translateHs : {app} \" id=\"dropdownAddFilter\"\n      ngbDropdownToggle>\n      <span class=\"icon-plus\"></span>\n    </button>\n    <div ngbDropdownMenu aria-labelledby=\"dropdownAddFilter\">\n      <button ngbDropdownItem (click)=\"emitClick('AND')\">\n        {{'STYLER.andFilter' | translateHs : {app} }}\n      </button>\n      <button ngbDropdownItem (click)=\"emitClick('OR')\">\n        {{'STYLER.orFilter' | translateHs : {app} }}\n      </button>\n      <button ngbDropdownItem (click)=\"emitClick('NOT')\">\n        {{'STYLER.notFilter' | translateHs : {app} }}\n      </button>\n      <button ngbDropdownItem (click)=\"emitClick('COMPARE')\">\n        {{'STYLER.comparisonFilter' | translateHs : {app} }}\n      </button>\n    </div>\n  </div>\n</div>" }]
        }], propDecorators: { clicks: [{
                type: Output
            }], app: [{
                type: Input
            }] } });

class HsComparisonFilterComponent extends HsStylerPartBaseComponent {
    constructor() {
        super();
    }
    remove() {
        this.parent.splice(this.parent.indexOf(this.filter), 1);
        this.emitChange();
    }
}
HsComparisonFilterComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsComparisonFilterComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
HsComparisonFilterComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsComparisonFilterComponent, selector: "hs-comparison-filter", inputs: { filter: "filter", parent: "parent" }, usesInheritance: true, ngImport: i0, template: "<div class=\"d-flex flex-row\">\n  <div>\n    <input class=\"form-control\" [ngModelOptions]=\"{standalone: true}\" [(ngModel)]=\"filter[1]\" (change)=\"emitChange()\" />\n  </div>\n  <div>\n    <input class=\"form-control\" [ngModelOptions]=\"{standalone: true}\" [(ngModel)]=\"filter[0]\" (change)=\"emitChange()\" />\n  </div>\n  <div>\n    <input class=\"form-control\" [ngModelOptions]=\"{standalone: true}\" [(ngModel)]=\"filter[2]\" (change)=\"emitChange()\" />\n  </div>\n  <div>\n    <button class=\"btn btn-outline-danger btn-sm rounded-0\" style=\"height: 100%\" (click)=\"remove()\">\n      <span class=\"icon-trash\"></span>\n    </button>\n  </div>\n</div>", directives: [{ type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsComparisonFilterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-comparison-filter', template: "<div class=\"d-flex flex-row\">\n  <div>\n    <input class=\"form-control\" [ngModelOptions]=\"{standalone: true}\" [(ngModel)]=\"filter[1]\" (change)=\"emitChange()\" />\n  </div>\n  <div>\n    <input class=\"form-control\" [ngModelOptions]=\"{standalone: true}\" [(ngModel)]=\"filter[0]\" (change)=\"emitChange()\" />\n  </div>\n  <div>\n    <input class=\"form-control\" [ngModelOptions]=\"{standalone: true}\" [(ngModel)]=\"filter[2]\" (change)=\"emitChange()\" />\n  </div>\n  <div>\n    <button class=\"btn btn-outline-danger btn-sm rounded-0\" style=\"height: 100%\" (click)=\"remove()\">\n      <span class=\"icon-trash\"></span>\n    </button>\n  </div>\n</div>" }]
        }], ctorParameters: function () { return []; }, propDecorators: { filter: [{
                type: Input
            }], parent: [{
                type: Input
            }] } });

class HsFilterComponent extends HsStylerPartBaseComponent {
    constructor(hsFiltersService) {
        super();
        this.hsFiltersService = hsFiltersService;
    }
    remove() {
        this.parent.splice(this.parent.indexOf(this.filter), 1);
        this.emitChange();
    }
}
HsFilterComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsFilterComponent, deps: [{ token: HsFiltersService }], target: i0.ɵɵFactoryTarget.Component });
HsFilterComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsFilterComponent, selector: "hs-filter", inputs: { filter: "filter", parent: "parent" }, usesInheritance: true, ngImport: i0, template: "<div>\n  <div *ngIf=\"hsFiltersService.isLogOp(filter)\" class=\"card m-2\"><!-- TODO: Remove function call from template -->\n    <div class=\"d-flex flex-row card-header p-0\">\n      <div class=\"p-2\">{{hsFiltersService.humanReadableLogOp(filter[0])}}</div><!-- TODO: Remove function call from template -->\n      <hs-add-filter-button (clicks)=\"hsFiltersService.add($event.kind, true, filter)\" [app]=\"app\"></hs-add-filter-button>\n      <button class=\"btn btn-outline-danger btn-sm m-1\" [title]=\"'STYLER.removeFilter' | translateHs : {app} \" (click)=\"remove()\">\n        <span class=\"icon-trash\"></span>\n      </button>\n    </div>\n    <div class=\"d-flex flex-row\" *ngFor=\"let item of filter; let i = index\">\n      <hs-filter *ngIf=\"i>0\" [app]=\"app\" [filter]=\"item\" [parent]=\"filter\"></hs-filter>\n    </div>\n  </div>\n  <hs-comparison-filter *ngIf=\"filter.length > 1 && !(hsFiltersService.isLogOp(filter))\" [app]=\"app\" [filter]=\"filter\"\n    (changes)=\"emitChange()\" [parent]=\"parent\"></hs-comparison-filter><!-- TODO: Remove function call from template -->\n</div>", components: [{ type: HsAddFilterButtonComponent, selector: "hs-add-filter-button", inputs: ["app"], outputs: ["clicks"] }, { type: HsFilterComponent, selector: "hs-filter", inputs: ["filter", "parent"] }, { type: HsComparisonFilterComponent, selector: "hs-comparison-filter", inputs: ["filter", "parent"] }], directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsFilterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-filter', template: "<div>\n  <div *ngIf=\"hsFiltersService.isLogOp(filter)\" class=\"card m-2\"><!-- TODO: Remove function call from template -->\n    <div class=\"d-flex flex-row card-header p-0\">\n      <div class=\"p-2\">{{hsFiltersService.humanReadableLogOp(filter[0])}}</div><!-- TODO: Remove function call from template -->\n      <hs-add-filter-button (clicks)=\"hsFiltersService.add($event.kind, true, filter)\" [app]=\"app\"></hs-add-filter-button>\n      <button class=\"btn btn-outline-danger btn-sm m-1\" [title]=\"'STYLER.removeFilter' | translateHs : {app} \" (click)=\"remove()\">\n        <span class=\"icon-trash\"></span>\n      </button>\n    </div>\n    <div class=\"d-flex flex-row\" *ngFor=\"let item of filter; let i = index\">\n      <hs-filter *ngIf=\"i>0\" [app]=\"app\" [filter]=\"item\" [parent]=\"filter\"></hs-filter>\n    </div>\n  </div>\n  <hs-comparison-filter *ngIf=\"filter.length > 1 && !(hsFiltersService.isLogOp(filter))\" [app]=\"app\" [filter]=\"filter\"\n    (changes)=\"emitChange()\" [parent]=\"parent\"></hs-comparison-filter><!-- TODO: Remove function call from template -->\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsFiltersService }]; }, propDecorators: { filter: [{
                type: Input
            }], parent: [{
                type: Input
            }] } });

class HsFiltersComponent extends HsStylerPartBaseComponent {
    constructor(hsFiltersService) {
        super();
        this.hsFiltersService = hsFiltersService;
    }
    add(kind, append) {
        if (this.rule.filter == undefined) {
            this.rule.filter = [];
        }
        this.hsFiltersService.add(kind, append, this.rule.filter);
    }
    remove() {
        delete this.rule.filter;
        this.emitChange();
    }
}
HsFiltersComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsFiltersComponent, deps: [{ token: HsFiltersService }], target: i0.ɵɵFactoryTarget.Component });
HsFiltersComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsFiltersComponent, selector: "hs-filters", inputs: { rule: "rule" }, usesInheritance: true, ngImport: i0, template: "<div>\n  <div class=\"d-flex flex-row justify-content-end\">\n    <hs-add-filter-button (clicks)=\"add($event.kind, false)\" [app]=\"app\"></hs-add-filter-button>\n  </div>\n  <div *ngIf=\"hsFiltersService.isLogOp(rule.filter)\" class=\"card\"><!-- TODO: Remove function call from template -->\n    <div class=\"d-flex flex-row card-header p-0\">\n      <div class=\"p-2\">\n        {{hsFiltersService.humanReadableLogOp(rule.filter[0])}}<!-- TODO: Remove function call from template -->\n      </div>\n      <hs-add-filter-button (clicks)=\"add($event.kind, true)\" [app]=\"app\"></hs-add-filter-button>\n      <button class=\"btn btn-outline-danger btn-sm m-1\" [title]=\"'STYLER.removeFilter'\" (click)=\"remove()\">\n        <span class=\"icon-trash\"></span>\n      </button>\n    </div>\n    <div class=\"d-flex flex-row\" *ngFor=\"let item of rule.filter; let i = index\">\n      <hs-filter (changes)=\"emitChange()\" [app]=\"app\" *ngIf=\"i>0\" [filter]=\"item\" [parent]=\"rule.filter\"></hs-filter>\n    </div>\n  </div>\n  <hs-comparison-filter *ngIf=\"rule.filter?.length > 0 && !(hsFiltersService.isLogOp(rule.filter))\" [app]=\"app\"\n    (changes)=\"emitChange()\" [filter]=\"rule.filter\"></hs-comparison-filter><!-- TODO: Remove function call from template -->\n</div>", components: [{ type: HsAddFilterButtonComponent, selector: "hs-add-filter-button", inputs: ["app"], outputs: ["clicks"] }, { type: HsFilterComponent, selector: "hs-filter", inputs: ["filter", "parent"] }, { type: HsComparisonFilterComponent, selector: "hs-comparison-filter", inputs: ["filter", "parent"] }], directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsFiltersComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-filters', template: "<div>\n  <div class=\"d-flex flex-row justify-content-end\">\n    <hs-add-filter-button (clicks)=\"add($event.kind, false)\" [app]=\"app\"></hs-add-filter-button>\n  </div>\n  <div *ngIf=\"hsFiltersService.isLogOp(rule.filter)\" class=\"card\"><!-- TODO: Remove function call from template -->\n    <div class=\"d-flex flex-row card-header p-0\">\n      <div class=\"p-2\">\n        {{hsFiltersService.humanReadableLogOp(rule.filter[0])}}<!-- TODO: Remove function call from template -->\n      </div>\n      <hs-add-filter-button (clicks)=\"add($event.kind, true)\" [app]=\"app\"></hs-add-filter-button>\n      <button class=\"btn btn-outline-danger btn-sm m-1\" [title]=\"'STYLER.removeFilter'\" (click)=\"remove()\">\n        <span class=\"icon-trash\"></span>\n      </button>\n    </div>\n    <div class=\"d-flex flex-row\" *ngFor=\"let item of rule.filter; let i = index\">\n      <hs-filter (changes)=\"emitChange()\" [app]=\"app\" *ngIf=\"i>0\" [filter]=\"item\" [parent]=\"rule.filter\"></hs-filter>\n    </div>\n  </div>\n  <hs-comparison-filter *ngIf=\"rule.filter?.length > 0 && !(hsFiltersService.isLogOp(rule.filter))\" [app]=\"app\"\n    (changes)=\"emitChange()\" [filter]=\"rule.filter\"></hs-comparison-filter><!-- TODO: Remove function call from template -->\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsFiltersService }]; }, propDecorators: { rule: [{
                type: Input
            }] } });

class HsScaleDenominatorComponent extends HsStylerPartBaseComponent {
    constructor() {
        super(...arguments);
        this.scaleDenominator = { min: null, max: null };
    }
    ngOnInit() {
        Object.assign(this.scaleDenominator, this.rule.scaleDenominator);
    }
    emitChange() {
        if (this.scaleDenominator.min === null &&
            this.scaleDenominator.max === null) {
            delete this.rule.scaleDenominator;
            super.emitChange();
            return;
        }
        if (this.rule.scaleDenominator == undefined) {
            this.rule.scaleDenominator = {};
        }
        Object.assign(this.rule.scaleDenominator, this.scaleDenominator);
        //After assign to keep max input empty -> prevent 'out of range' warning
        if (this.rule.scaleDenominator.max === null &&
            this.rule.scaleDenominator.min !== null) {
            this.rule.scaleDenominator.max = Infinity;
        }
        super.emitChange();
    }
}
HsScaleDenominatorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsScaleDenominatorComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
HsScaleDenominatorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsScaleDenominatorComponent, selector: "hs-scale-denominator", inputs: { rule: "rule" }, usesInheritance: true, ngImport: i0, template: "<form class=\"form\">\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-2 w-50\">{{'STYLER.minScale' | translateHs : {app} }}:</div>\n    <div class=\"p-1 w-50\">\n      <div class=\"input-group\">\n        <div class=\"input-group-text\">1:</div>\n        <input class=\"form-control\" type=\"number\" [ngModelOptions]=\"{standalone: true}\"\n          [(ngModel)]=\"scaleDenominator.min\" (change)=\"emitChange()\" />\n      </div>\n    </div>\n  </div>\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-2 w-50\">{{'STYLER.maxScale' | translateHs : {app} }}:</div>\n    <div class=\"p-1 w-50\">\n      <div class=\"input-group\">\n        <div class=\"input-group-text\">1:</div>\n        <input class=\"form-control\" type=\"number\" [ngModelOptions]=\"{standalone: true}\"\n          [(ngModel)]=\"scaleDenominator.max\" (change)=\"emitChange()\" />\n      </div>\n    </div>\n  </div>\n</form>\n", directives: [{ type: i3$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i3$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i3$1.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i3$1.NumberValueAccessor, selector: "input[type=number][formControlName],input[type=number][formControl],input[type=number][ngModel]" }, { type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsScaleDenominatorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-scale-denominator', template: "<form class=\"form\">\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-2 w-50\">{{'STYLER.minScale' | translateHs : {app} }}:</div>\n    <div class=\"p-1 w-50\">\n      <div class=\"input-group\">\n        <div class=\"input-group-text\">1:</div>\n        <input class=\"form-control\" type=\"number\" [ngModelOptions]=\"{standalone: true}\"\n          [(ngModel)]=\"scaleDenominator.min\" (change)=\"emitChange()\" />\n      </div>\n    </div>\n  </div>\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-2 w-50\">{{'STYLER.maxScale' | translateHs : {app} }}:</div>\n    <div class=\"p-1 w-50\">\n      <div class=\"input-group\">\n        <div class=\"input-group-text\">1:</div>\n        <input class=\"form-control\" type=\"number\" [ngModelOptions]=\"{standalone: true}\"\n          [(ngModel)]=\"scaleDenominator.max\" (change)=\"emitChange()\" />\n      </div>\n    </div>\n  </div>\n</form>\n" }]
        }], propDecorators: { rule: [{
                type: Input
            }] } });

class HsColorPickerComponent extends HsStylerPartBaseComponent {
    constructor(hsColorPickerService) {
        super();
        this.hsColorPickerService = hsColorPickerService;
        this.fontColor = 'white';
        this.pickerVisible = false;
    }
    onPick($event) {
        this.symbolizer[this.attribute] = $event.color.hex;
        if (this.opacityAttribute) {
            this.symbolizer[this.opacityAttribute] = $event.color.rgb.a;
        }
        this.fontColor = this.hsColorPickerService.generateFontColor([
            $event.color.rgb.r,
            $event.color.rgb.g,
            $event.color.rgb.b,
        ]);
        this.emitChange();
    }
    colorPickerStyle() {
        return this.hsColorPickerService.colorPickerStyle(this.symbolizer[this.attribute], this.fontColor);
    }
}
HsColorPickerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsColorPickerComponent, deps: [{ token: HsColorPickerService }], target: i0.ɵɵFactoryTarget.Component });
HsColorPickerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsColorPickerComponent, selector: "hs-symbolizer-color-picker", inputs: { symbolizer: "symbolizer", attribute: "attribute", opacityAttribute: "opacityAttribute", label: "label" }, usesInheritance: true, ngImport: i0, template: "<div>\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25 mt-2\">{{label}}</div>\n    <div class=\"p-1 w-75\">\n      <input class=\"form-control form-select-sm\" (click)=\"pickerVisible = !pickerVisible\" [ngStyle]=\"colorPickerStyle()\"\n        [ngModelOptions]=\"{standalone: true}\" [(ngModel)]=\"symbolizer[attribute]\" />\n    </div>\n  </div>\n  <!-- TODO: Remove function call from template -->\n  <color-sketch [color]=\"hsColorPickerService.addAlpha(symbolizer[attribute], symbolizer[opacityAttribute])\"\n  width=\"320px\"\n    *ngIf=\"pickerVisible && symbolizer[attribute] !== undefined\" (onChangeComplete)=\"onPick($event)\"></color-sketch>\n  <color-sketch *ngIf=\"pickerVisible && symbolizer[attribute] === undefined\" width=\"320px\" (onChangeComplete)=\"onPick($event)\">\n  </color-sketch>\n</div>", components: [{ type: i3$2.SketchComponent, selector: "color-sketch", inputs: ["disableAlpha", "presetColors", "width"] }], directives: [{ type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsColorPickerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-symbolizer-color-picker', template: "<div>\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25 mt-2\">{{label}}</div>\n    <div class=\"p-1 w-75\">\n      <input class=\"form-control form-select-sm\" (click)=\"pickerVisible = !pickerVisible\" [ngStyle]=\"colorPickerStyle()\"\n        [ngModelOptions]=\"{standalone: true}\" [(ngModel)]=\"symbolizer[attribute]\" />\n    </div>\n  </div>\n  <!-- TODO: Remove function call from template -->\n  <color-sketch [color]=\"hsColorPickerService.addAlpha(symbolizer[attribute], symbolizer[opacityAttribute])\"\n  width=\"320px\"\n    *ngIf=\"pickerVisible && symbolizer[attribute] !== undefined\" (onChangeComplete)=\"onPick($event)\"></color-sketch>\n  <color-sketch *ngIf=\"pickerVisible && symbolizer[attribute] === undefined\" width=\"320px\" (onChangeComplete)=\"onPick($event)\">\n  </color-sketch>\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsColorPickerService }]; }, propDecorators: { symbolizer: [{
                type: Input
            }], attribute: [{
                type: Input
            }], opacityAttribute: [{
                type: Input
            }], label: [{
                type: Input
            }] } });

class HsSliderComponent extends HsStylerPartBaseComponent {
}
HsSliderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSliderComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
HsSliderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsSliderComponent, selector: "hs-symbolizer-slider", inputs: { symbolizer: "symbolizer", attribute: "attribute", label: "label", min: "min", max: "max", step: "step" }, usesInheritance: true, ngImport: i0, template: "<div>\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25 mt-1\">{{label}}</div>\n    <span class=\"badge bg-warning mt-1\" title=\"{{warning}}\" *ngIf=\"warning !== undefined\">!</span>\n    <div class=\"p-1 w-75\">\n      <input type=\"range\" class=\"w-100\" [step]=\"step\" [min]=\"min\" [max]=\"max\" [ngModelOptions]=\"{standalone: true}\"\n        [(ngModel)]=\"symbolizer[attribute]\" (change)=\"emitChange()\" />\n    </div>\n  </div>\n</div>\n", directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3$1.RangeValueAccessor, selector: "input[type=range][formControlName],input[type=range][formControl],input[type=range][ngModel]" }, { type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSliderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-symbolizer-slider', template: "<div>\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25 mt-1\">{{label}}</div>\n    <span class=\"badge bg-warning mt-1\" title=\"{{warning}}\" *ngIf=\"warning !== undefined\">!</span>\n    <div class=\"p-1 w-75\">\n      <input type=\"range\" class=\"w-100\" [step]=\"step\" [min]=\"min\" [max]=\"max\" [ngModelOptions]=\"{standalone: true}\"\n        [(ngModel)]=\"symbolizer[attribute]\" (change)=\"emitChange()\" />\n    </div>\n  </div>\n</div>\n" }]
        }], propDecorators: { symbolizer: [{
                type: Input
            }], attribute: [{
                type: Input
            }], label: [{
                type: Input
            }], min: [{
                type: Input
            }], max: [{
                type: Input
            }], step: [{
                type: Input
            }] } });

class HsMarkSymbolizerComponent extends HsStylerPartBaseComponent {
    constructor() {
        super(...arguments);
        this.app = 'default';
        this.wellKnownNames = [
            'circle',
            'square',
            'triangle',
            'star',
            'cross',
            'x',
            'shape://vertline',
            'shape://horline',
            'shape://slash',
            'shape://backslash',
            'shape://dot',
            'shape://plus',
            'shape://times',
            'shape://oarrow',
            'shape://carrow',
        ];
        this.fillColorPickerVisible = false;
        this.strokeColorPickerVisible = false;
    }
}
HsMarkSymbolizerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsMarkSymbolizerComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
HsMarkSymbolizerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsMarkSymbolizerComponent, selector: "hs-mark-symbolizer", inputs: { symbolizer: "symbolizer", app: "app" }, usesInheritance: true, ngImport: i0, template: "<form class=\"form\">\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25\">{{'STYLER.symbol' | translateHs : {app} }}:</div>\n    <div class=\"p-1 w-75\">\n      <select class=\"form-control form-select-sm form-select\" [(ngModel)]=\"symbolizer.wellKnownName\" (change)=\"emitChange()\"\n        [ngModelOptions]=\"{standalone: true}\">\n        <option *ngFor=\"let wellKnownName of wellKnownNames\">\n          {{wellKnownName}}\n        </option>\n      </select>\n    </div>\n  </div>\n\n  <hs-symbolizer-color-picker [symbolizer]=\"symbolizer\" attribute=\"color\" opacityAttribute=\"opacity\"\n    (changes)=\"emitChange()\" label=\"{{'STYLER.fillColor' | translateHs : {app} }}\"></hs-symbolizer-color-picker>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" [app]=\"app\" attribute=\"opacity\" (changes)=\"emitChange()\" step=\"0.05\" min=\"0\"\n    max=\"1\" label=\"{{'STYLER.opacity' | translateHs : {app} }}\"></hs-symbolizer-slider>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" [app]=\"app\" attribute=\"radius\" (changes)=\"emitChange()\" step=\"1\" min=\"0\" max=\"100\"\n    label=\"{{'STYLER.radius' | translateHs : {app} }}\"></hs-symbolizer-slider>\n\n  <hs-symbolizer-color-picker [symbolizer]=\"symbolizer\" attribute=\"strokeColor\" opacityAttribute=\"strokeOpacity\"\n    (changes)=\"emitChange()\" label=\"{{'STYLER.strokeColor' | translateHs : {app} }}\"></hs-symbolizer-color-picker>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" [app]=\"app\" attribute=\"strokeOpacity\" (changes)=\"emitChange()\" step=\"0.05\" min=\"0\"\n    max=\"1\" label=\"{{'STYLER.strokeOpacity' | translateHs : {app} }}\"></hs-symbolizer-slider>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" [app]=\"app\" attribute=\"strokeWidth\" (changes)=\"emitChange()\" step=\"0.1\" min=\"0\"\n    max=\"20\" label=\"{{'STYLER.strokeWidth' | translateHs : {app} }}\"></hs-symbolizer-slider>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" [app]=\"app\" attribute=\"rotate\" (changes)=\"emitChange()\" step=\"1\" min=\"0\" max=\"360\"\n    label=\"{{'STYLER.rotation' | translateHs : {app} }}\"></hs-symbolizer-slider>\n</form>\n", components: [{ type: HsColorPickerComponent, selector: "hs-symbolizer-color-picker", inputs: ["symbolizer", "attribute", "opacityAttribute", "label"] }, { type: HsSliderComponent, selector: "hs-symbolizer-slider", inputs: ["symbolizer", "attribute", "label", "min", "max", "step"] }], directives: [{ type: i3$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i3$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i3$1.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i3$1.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3$1.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i3$1.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsMarkSymbolizerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-mark-symbolizer', template: "<form class=\"form\">\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25\">{{'STYLER.symbol' | translateHs : {app} }}:</div>\n    <div class=\"p-1 w-75\">\n      <select class=\"form-control form-select-sm form-select\" [(ngModel)]=\"symbolizer.wellKnownName\" (change)=\"emitChange()\"\n        [ngModelOptions]=\"{standalone: true}\">\n        <option *ngFor=\"let wellKnownName of wellKnownNames\">\n          {{wellKnownName}}\n        </option>\n      </select>\n    </div>\n  </div>\n\n  <hs-symbolizer-color-picker [symbolizer]=\"symbolizer\" attribute=\"color\" opacityAttribute=\"opacity\"\n    (changes)=\"emitChange()\" label=\"{{'STYLER.fillColor' | translateHs : {app} }}\"></hs-symbolizer-color-picker>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" [app]=\"app\" attribute=\"opacity\" (changes)=\"emitChange()\" step=\"0.05\" min=\"0\"\n    max=\"1\" label=\"{{'STYLER.opacity' | translateHs : {app} }}\"></hs-symbolizer-slider>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" [app]=\"app\" attribute=\"radius\" (changes)=\"emitChange()\" step=\"1\" min=\"0\" max=\"100\"\n    label=\"{{'STYLER.radius' | translateHs : {app} }}\"></hs-symbolizer-slider>\n\n  <hs-symbolizer-color-picker [symbolizer]=\"symbolizer\" attribute=\"strokeColor\" opacityAttribute=\"strokeOpacity\"\n    (changes)=\"emitChange()\" label=\"{{'STYLER.strokeColor' | translateHs : {app} }}\"></hs-symbolizer-color-picker>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" [app]=\"app\" attribute=\"strokeOpacity\" (changes)=\"emitChange()\" step=\"0.05\" min=\"0\"\n    max=\"1\" label=\"{{'STYLER.strokeOpacity' | translateHs : {app} }}\"></hs-symbolizer-slider>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" [app]=\"app\" attribute=\"strokeWidth\" (changes)=\"emitChange()\" step=\"0.1\" min=\"0\"\n    max=\"20\" label=\"{{'STYLER.strokeWidth' | translateHs : {app} }}\"></hs-symbolizer-slider>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" [app]=\"app\" attribute=\"rotate\" (changes)=\"emitChange()\" step=\"1\" min=\"0\" max=\"360\"\n    label=\"{{'STYLER.rotation' | translateHs : {app} }}\"></hs-symbolizer-slider>\n</form>\n" }]
        }], propDecorators: { symbolizer: [{
                type: Input
            }], app: [{
                type: Input
            }] } });

class HsSelectIconDialogComponent {
    constructor(hsDialogContainerService, hsConfig) {
        this.hsDialogContainerService = hsDialogContainerService;
        this.hsConfig = hsConfig;
    }
    cancel() {
        this.data.selectedIcon = null;
        this.hsDialogContainerService.destroy(this, this.data.app);
    }
    confirm() {
        if (this.data.selectedIcon) {
            this.data.symbolizer.image = this.data.selectedIcon.url;
            this.data.emitChange();
        }
        this.hsDialogContainerService.destroy(this, this.data.app);
    }
    iconSelected(icon) {
        this.data.selectedIcon = icon;
    }
}
HsSelectIconDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSelectIconDialogComponent, deps: [{ token: HsDialogContainerService }, { token: HsConfig }], target: i0.ɵɵFactoryTarget.Component });
HsSelectIconDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsSelectIconDialogComponent, selector: "hs-select-icon-dialog", ngImport: i0, template: "<div class=\"modal in hs-select-icon\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n  <div class=\"modal-dialog\">\n    <div class=\"modal-content\">\n      <div class=\"modal-header d-flex flex-column\">\n        <div class=\"d-flex w-100 align-items-center\">\n          <h4 class=\"modal-title\">{{'STYLER.selectIcon' | translateHs : {app: data.app} }}</h4>\n          <button type=\"button\" (click)=\"cancel()\" class=\"btn-close\" data-dismiss=\"modal\" attr.aria-label=\"{{'COMMON.close' | translateHs : {app: data.app} }}\">\n          </button>\n        </div>\n      </div>\n      <div class=\"modal-body\" style=\"max-height: 400px; overflow-y: auto\">\n        <div class=\"d-flex flex-wrap\">\n          <div *ngFor=\"let icon of hsConfig.get(data.app).symbolizerIcons\" [ngClass]=\"{'bg-primary': data.selectedIcon === icon}\"\n            class=\"p-1\" (click)=\"iconSelected(icon)\"><!-- TODO: Remove function call from template -->\n            <img [src]=\"icon.url\" />\n          </div>\n        </div>\n      </div>\n      <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" (click)=\"confirm()\">\n          {{'COMMON.ok' | translateHs : {app: data.app} }}\n        </button>\n        <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" (click)=\"cancel()\">\n          {{'COMMON.cancel' | translateHs : {app: data.app} }}\n        </button>\n      </div>\n    </div>\n  </div>\n</div>\n", directives: [{ type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSelectIconDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-select-icon-dialog', template: "<div class=\"modal in hs-select-icon\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n  <div class=\"modal-dialog\">\n    <div class=\"modal-content\">\n      <div class=\"modal-header d-flex flex-column\">\n        <div class=\"d-flex w-100 align-items-center\">\n          <h4 class=\"modal-title\">{{'STYLER.selectIcon' | translateHs : {app: data.app} }}</h4>\n          <button type=\"button\" (click)=\"cancel()\" class=\"btn-close\" data-dismiss=\"modal\" attr.aria-label=\"{{'COMMON.close' | translateHs : {app: data.app} }}\">\n          </button>\n        </div>\n      </div>\n      <div class=\"modal-body\" style=\"max-height: 400px; overflow-y: auto\">\n        <div class=\"d-flex flex-wrap\">\n          <div *ngFor=\"let icon of hsConfig.get(data.app).symbolizerIcons\" [ngClass]=\"{'bg-primary': data.selectedIcon === icon}\"\n            class=\"p-1\" (click)=\"iconSelected(icon)\"><!-- TODO: Remove function call from template -->\n            <img [src]=\"icon.url\" />\n          </div>\n        </div>\n      </div>\n      <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" (click)=\"confirm()\">\n          {{'COMMON.ok' | translateHs : {app: data.app} }}\n        </button>\n        <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" (click)=\"cancel()\">\n          {{'COMMON.cancel' | translateHs : {app: data.app} }}\n        </button>\n      </div>\n    </div>\n  </div>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: HsDialogContainerService }, { type: HsConfig }]; } });

class HsIconSymbolizerComponent extends HsStylerPartBaseComponent {
    constructor(hsDialogContainerService) {
        super();
        this.hsDialogContainerService = hsDialogContainerService;
        this.app = 'default';
        this.anchors = [
            'center',
            'left',
            'right',
            'top',
            'bottom',
            'top-left',
            'top-right',
            'bottom-left',
            'bottom-right',
        ];
    }
    showIconSelector() {
        this.hsDialogContainerService.create(HsSelectIconDialogComponent, this, this.app);
    }
}
HsIconSymbolizerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsIconSymbolizerComponent, deps: [{ token: HsDialogContainerService }], target: i0.ɵɵFactoryTarget.Component });
HsIconSymbolizerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsIconSymbolizerComponent, selector: "hs-icon-symbolizer", inputs: { symbolizer: "symbolizer", app: "app" }, usesInheritance: true, ngImport: i0, template: "<form class=\"form\">\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25\">{{'STYLER.source' | translateHs : {app} }}:</div>\n    <div class=\"p-1 w-75\">\n      <div class=\"input-group mb-3\">\n        <input class=\"form-control\" [ngModelOptions]=\"{standalone: true}\" [(ngModel)]=\"symbolizer.image\"\n          (change)=\"emitChange()\" />\n          <button class=\"btn btn-outline-secondary\" (click)=\"showIconSelector()\" type=\"button\">\n            ...\n          </button>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25 mt-2\">{{'STYLER.anchor' | translateHs : {app} }}:</div>\n    <span class=\"badge bg-warning mt-2\" title=\"{{'STYLER.warningAttribNotStoredNotVisualized' | translateHs : {app} }}\">!</span>\n    <div class=\"p-1 w-75\">\n      <select class=\"form-control form-select form-select-sm\" [(ngModel)]=\"symbolizer.anchor\" (change)=\"emitChange()\"\n        [ngModelOptions]=\"{standalone: true}\">\n        <option *ngFor=\"let anchor of anchors\">{{anchor}}</option>\n      </select>\n    </div>\n  </div>\n\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25\">{{'STYLER.opacity' | translateHs : {app} }}:</div>\n    <div class=\"p-1 w-75\">\n      <input type=\"range\" class=\"w-100\" step=\"0.05\" min=\"0\" max=\"1\" [ngModelOptions]=\"{standalone: true}\" [(ngModel)]=\"symbolizer.opacity\"\n        (change)=\"emitChange()\" />\n    </div>\n  </div>\n\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25\">{{'STYLER.size' | translateHs : {app} }}:</div>\n    <div class=\"p-1 w-75\">\n      <input type=\"range\" class=\"w-100\" step=\"0.2\" min=\"0.1\" max=\"10\" [ngModelOptions]=\"{standalone: true}\" [(ngModel)]=\"symbolizer.size\"\n        (change)=\"emitChange()\" />\n    </div>\n  </div>\n\n  <div class=\"d-flex flex-row\" *ngIf=\"symbolizer.offset !== undefined\">\n    <div class=\"p-1 w-25 mt-2\">{{'STYLER.anchorX' | translateHs : {app} }}:</div>\n    <span class=\"badge bg-warning mt-2\" title=\"{{'STYLER.warningAttribNotStoredNotVisualized' | translateHs : {app} }}\">!</span>\n    <div class=\"p-1 w-75\">\n      <input type=\"range\" class=\"w-100\" step=\"0.05\" min=\"-1.0\" max=\"1.0\" [ngModelOptions]=\"{standalone: true}\"\n        [(ngModel)]=\"symbolizer.offset[0]\" *ngIf=\"symbolizer.offset !== undefined\" (change)=\"emitChange()\" />\n    </div>\n  </div>\n\n\n  <div class=\"d-flex flex-row\" *ngIf=\"symbolizer.offset !== undefined\">\n    <div class=\"p-1 w-25 mt-2\">{{'STYLER.anchorY' | translateHs : {app} }}:</div>\n    <span class=\"badge bg-warning mt-2\" title=\"{{'STYLER.warningAttribNotStoredNotVisualized' | translateHs : {app} }}\">!</span>\n    <div class=\"p-1 w-75\">\n      <input type=\"range\" class=\"w-100\" step=\"0.05\" min=\"-1.0\" max=\"1.0\" [ngModelOptions]=\"{standalone: true}\"\n        [(ngModel)]=\"symbolizer.offset[1]\" *ngIf=\"symbolizer.offset !== undefined\" (change)=\"emitChange()\" />\n    </div>\n  </div>\n\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25\">{{'STYLER.rotation' | translateHs : {app} }}:</div>\n    <div class=\"p-1 w-75\">\n      <input type=\"range\" class=\"w-100\" step=\"1\" min=\"0\" max=\"360\" [ngModelOptions]=\"{standalone: true}\" [(ngModel)]=\"symbolizer.rotate\"\n        (change)=\"emitChange()\" />\n    </div>\n  </div>\n</form>\n", directives: [{ type: i3$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i3$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i3$1.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3$1.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3$1.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i3$1.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i3$1.RangeValueAccessor, selector: "input[type=range][formControlName],input[type=range][formControl],input[type=range][ngModel]" }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsIconSymbolizerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-icon-symbolizer', template: "<form class=\"form\">\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25\">{{'STYLER.source' | translateHs : {app} }}:</div>\n    <div class=\"p-1 w-75\">\n      <div class=\"input-group mb-3\">\n        <input class=\"form-control\" [ngModelOptions]=\"{standalone: true}\" [(ngModel)]=\"symbolizer.image\"\n          (change)=\"emitChange()\" />\n          <button class=\"btn btn-outline-secondary\" (click)=\"showIconSelector()\" type=\"button\">\n            ...\n          </button>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25 mt-2\">{{'STYLER.anchor' | translateHs : {app} }}:</div>\n    <span class=\"badge bg-warning mt-2\" title=\"{{'STYLER.warningAttribNotStoredNotVisualized' | translateHs : {app} }}\">!</span>\n    <div class=\"p-1 w-75\">\n      <select class=\"form-control form-select form-select-sm\" [(ngModel)]=\"symbolizer.anchor\" (change)=\"emitChange()\"\n        [ngModelOptions]=\"{standalone: true}\">\n        <option *ngFor=\"let anchor of anchors\">{{anchor}}</option>\n      </select>\n    </div>\n  </div>\n\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25\">{{'STYLER.opacity' | translateHs : {app} }}:</div>\n    <div class=\"p-1 w-75\">\n      <input type=\"range\" class=\"w-100\" step=\"0.05\" min=\"0\" max=\"1\" [ngModelOptions]=\"{standalone: true}\" [(ngModel)]=\"symbolizer.opacity\"\n        (change)=\"emitChange()\" />\n    </div>\n  </div>\n\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25\">{{'STYLER.size' | translateHs : {app} }}:</div>\n    <div class=\"p-1 w-75\">\n      <input type=\"range\" class=\"w-100\" step=\"0.2\" min=\"0.1\" max=\"10\" [ngModelOptions]=\"{standalone: true}\" [(ngModel)]=\"symbolizer.size\"\n        (change)=\"emitChange()\" />\n    </div>\n  </div>\n\n  <div class=\"d-flex flex-row\" *ngIf=\"symbolizer.offset !== undefined\">\n    <div class=\"p-1 w-25 mt-2\">{{'STYLER.anchorX' | translateHs : {app} }}:</div>\n    <span class=\"badge bg-warning mt-2\" title=\"{{'STYLER.warningAttribNotStoredNotVisualized' | translateHs : {app} }}\">!</span>\n    <div class=\"p-1 w-75\">\n      <input type=\"range\" class=\"w-100\" step=\"0.05\" min=\"-1.0\" max=\"1.0\" [ngModelOptions]=\"{standalone: true}\"\n        [(ngModel)]=\"symbolizer.offset[0]\" *ngIf=\"symbolizer.offset !== undefined\" (change)=\"emitChange()\" />\n    </div>\n  </div>\n\n\n  <div class=\"d-flex flex-row\" *ngIf=\"symbolizer.offset !== undefined\">\n    <div class=\"p-1 w-25 mt-2\">{{'STYLER.anchorY' | translateHs : {app} }}:</div>\n    <span class=\"badge bg-warning mt-2\" title=\"{{'STYLER.warningAttribNotStoredNotVisualized' | translateHs : {app} }}\">!</span>\n    <div class=\"p-1 w-75\">\n      <input type=\"range\" class=\"w-100\" step=\"0.05\" min=\"-1.0\" max=\"1.0\" [ngModelOptions]=\"{standalone: true}\"\n        [(ngModel)]=\"symbolizer.offset[1]\" *ngIf=\"symbolizer.offset !== undefined\" (change)=\"emitChange()\" />\n    </div>\n  </div>\n\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25\">{{'STYLER.rotation' | translateHs : {app} }}:</div>\n    <div class=\"p-1 w-75\">\n      <input type=\"range\" class=\"w-100\" step=\"1\" min=\"0\" max=\"360\" [ngModelOptions]=\"{standalone: true}\" [(ngModel)]=\"symbolizer.rotate\"\n        (change)=\"emitChange()\" />\n    </div>\n  </div>\n</form>\n" }]
        }], ctorParameters: function () { return [{ type: HsDialogContainerService }]; }, propDecorators: { symbolizer: [{
                type: Input
            }], app: [{
                type: Input
            }] } });

class HsFillSymbolizerComponent extends HsStylerPartBaseComponent {
    constructor() {
        super(...arguments);
        this.app = 'default';
        this.kinds = Kinds;
    }
    addSymbolizer(attribute, kind) {
        this.symbolizer[attribute] = { kind };
        this.menuRef.close();
    }
    opacityFix() {
        this.symbolizer.fillOpacity = this.symbolizer.opacity;
    }
}
HsFillSymbolizerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsFillSymbolizerComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
HsFillSymbolizerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsFillSymbolizerComponent, selector: "hs-fill-symbolizer", inputs: { symbolizer: "symbolizer", app: "app" }, viewQueries: [{ propertyName: "menuRef", first: true, predicate: ["graphicFillMenu"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<form class=\"form\">\n  <hs-symbolizer-color-picker [symbolizer]=\"symbolizer\" [app]=\"app\" attribute=\"color\" opacityAttribute=\"opacity\"\n    (changes)=\"opacityFix(); emitChange()\" label=\"{{'STYLER.fillColor' | translateHs : {app} }}\"></hs-symbolizer-color-picker>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" [app]=\"app\" attribute=\"opacity\" (changes)=\"opacityFix(); emitChange()\" step=\"0.05\"\n    min=\"0\" max=\"1\" label=\"{{'STYLER.opacity' | translateHs : {app} }}\"></hs-symbolizer-slider>\n\n  <hs-symbolizer-color-picker [symbolizer]=\"symbolizer\" [app]=\"app\" attribute=\"outlineColor\" opacityAttribute=\"outlineOpacity\"\n    (changes)=\"emitChange()\" label=\"{{'STYLER.outlineColor' | translateHs : {app} }}\"></hs-symbolizer-color-picker>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" [app]=\"app\" attribute=\"outlineOpacity\" (changes)=\"emitChange()\" step=\"0.05\"\n    min=\"0\" max=\"1\" label=\"{{'STYLER.outlineOpacity' | translateHs : {app} }}\"></hs-symbolizer-slider>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" [app]=\"app\" attribute=\"outlineWidth\" (changes)=\"emitChange()\" step=\"0.1\" min=\"0\"\n    max=\"20\" label=\"{{'STYLER.outlineWidth' | translateHs : {app} }}\"></hs-symbolizer-slider>\n\n  <div class=\"d-flex flex-row justify-content-end\">\n    <div class=\"p-1 flex-grow-1\">{{'STYLER.graphicFill' | translateHs : {app} }}:</div>\n    <span class=\"badge bg-warning mt-2\" title=\"{{'STYLER.warningAttribStoredNotVisualized' | translateHs : {app} }}\">!</span>\n    <div class=\"p-1\">\n      <div ngbDropdown #graphicFillMenu=\"ngbDropdown\" class=\"d-inline-block\" placement=\"top-right\">\n        <button class=\"btn btn-outline-primary btn-sm\" id=\"dropdownAddFillSymbolizer\" ngbDropdownToggle>\n          <span class=\"icon-plus\"></span>\n        </button>\n        <div ngbDropdownMenu aria-labelledby=\"dropdownAddFillSymbolizer\">\n          <button ngbDropdownItem (click)=\"addSymbolizer('graphicFill', 'Mark')\">Mark</button>\n          <button ngbDropdownItem (click)=\"addSymbolizer('graphicFill', 'Icon')\">Icon</button>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <hs-mark-symbolizer (remove)=\"symbolizer.graphicFill = undefined\" [app]=\"app\" [symbolizer]=\"symbolizer.graphicFill\" (changes)=\"emitChange()\" *ngIf=\"symbolizer.graphicFill && symbolizer.graphicFill.kind === kinds.mark\">\n    </hs-mark-symbolizer>\n  \n  <hs-icon-symbolizer (remove)=\"symbolizer.graphicFill = undefined\" [app]=\"app\" [symbolizer]=\"symbolizer.graphicFill\" (changes)=\"emitChange()\" *ngIf=\"symbolizer.graphicFill && symbolizer.graphicFill.kind === kinds.icon\">\n    </hs-icon-symbolizer>\n</form>\n", components: [{ type: HsColorPickerComponent, selector: "hs-symbolizer-color-picker", inputs: ["symbolizer", "attribute", "opacityAttribute", "label"] }, { type: HsSliderComponent, selector: "hs-symbolizer-slider", inputs: ["symbolizer", "attribute", "label", "min", "max", "step"] }, { type: HsMarkSymbolizerComponent, selector: "hs-mark-symbolizer", inputs: ["symbolizer", "app"] }, { type: HsIconSymbolizerComponent, selector: "hs-icon-symbolizer", inputs: ["symbolizer", "app"] }], directives: [{ type: i3$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i3$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i3$1.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i7.NgbDropdown, selector: "[ngbDropdown]", inputs: ["autoClose", "dropdownClass", "open", "placement", "container", "display"], outputs: ["openChange"], exportAs: ["ngbDropdown"] }, { type: i7.NgbDropdownToggle, selector: "[ngbDropdownToggle]" }, { type: i7.NgbDropdownMenu, selector: "[ngbDropdownMenu]" }, { type: i7.NgbDropdownItem, selector: "[ngbDropdownItem]", inputs: ["disabled"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsFillSymbolizerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-fill-symbolizer', template: "<form class=\"form\">\n  <hs-symbolizer-color-picker [symbolizer]=\"symbolizer\" [app]=\"app\" attribute=\"color\" opacityAttribute=\"opacity\"\n    (changes)=\"opacityFix(); emitChange()\" label=\"{{'STYLER.fillColor' | translateHs : {app} }}\"></hs-symbolizer-color-picker>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" [app]=\"app\" attribute=\"opacity\" (changes)=\"opacityFix(); emitChange()\" step=\"0.05\"\n    min=\"0\" max=\"1\" label=\"{{'STYLER.opacity' | translateHs : {app} }}\"></hs-symbolizer-slider>\n\n  <hs-symbolizer-color-picker [symbolizer]=\"symbolizer\" [app]=\"app\" attribute=\"outlineColor\" opacityAttribute=\"outlineOpacity\"\n    (changes)=\"emitChange()\" label=\"{{'STYLER.outlineColor' | translateHs : {app} }}\"></hs-symbolizer-color-picker>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" [app]=\"app\" attribute=\"outlineOpacity\" (changes)=\"emitChange()\" step=\"0.05\"\n    min=\"0\" max=\"1\" label=\"{{'STYLER.outlineOpacity' | translateHs : {app} }}\"></hs-symbolizer-slider>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" [app]=\"app\" attribute=\"outlineWidth\" (changes)=\"emitChange()\" step=\"0.1\" min=\"0\"\n    max=\"20\" label=\"{{'STYLER.outlineWidth' | translateHs : {app} }}\"></hs-symbolizer-slider>\n\n  <div class=\"d-flex flex-row justify-content-end\">\n    <div class=\"p-1 flex-grow-1\">{{'STYLER.graphicFill' | translateHs : {app} }}:</div>\n    <span class=\"badge bg-warning mt-2\" title=\"{{'STYLER.warningAttribStoredNotVisualized' | translateHs : {app} }}\">!</span>\n    <div class=\"p-1\">\n      <div ngbDropdown #graphicFillMenu=\"ngbDropdown\" class=\"d-inline-block\" placement=\"top-right\">\n        <button class=\"btn btn-outline-primary btn-sm\" id=\"dropdownAddFillSymbolizer\" ngbDropdownToggle>\n          <span class=\"icon-plus\"></span>\n        </button>\n        <div ngbDropdownMenu aria-labelledby=\"dropdownAddFillSymbolizer\">\n          <button ngbDropdownItem (click)=\"addSymbolizer('graphicFill', 'Mark')\">Mark</button>\n          <button ngbDropdownItem (click)=\"addSymbolizer('graphicFill', 'Icon')\">Icon</button>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <hs-mark-symbolizer (remove)=\"symbolizer.graphicFill = undefined\" [app]=\"app\" [symbolizer]=\"symbolizer.graphicFill\" (changes)=\"emitChange()\" *ngIf=\"symbolizer.graphicFill && symbolizer.graphicFill.kind === kinds.mark\">\n    </hs-mark-symbolizer>\n  \n  <hs-icon-symbolizer (remove)=\"symbolizer.graphicFill = undefined\" [app]=\"app\" [symbolizer]=\"symbolizer.graphicFill\" (changes)=\"emitChange()\" *ngIf=\"symbolizer.graphicFill && symbolizer.graphicFill.kind === kinds.icon\">\n    </hs-icon-symbolizer>\n</form>\n" }]
        }], propDecorators: { symbolizer: [{
                type: Input
            }], app: [{
                type: Input
            }], menuRef: [{
                type: ViewChild,
                args: ['graphicFillMenu']
            }] } });

class HsLineSymbolizerComponent extends HsStylerPartBaseComponent {
    constructor() {
        super(...arguments);
        this.app = 'default';
        this.caps = ['butt', 'round', 'square'];
        this.joins = ['bevel', 'round', 'miter'];
        this.kinds = Kinds;
    }
    addSymbolizer(attribute, kind) {
        this.symbolizer[attribute] = { kind };
        this.lineMenuRef.close();
        this.strokeMenuRef.close();
    }
    addDashItem() {
        if (!this.symbolizer.dasharray) {
            this.symbolizer.dasharray = [1];
        }
        else {
            this.symbolizer.dasharray.push(1);
        }
    }
    removeDashItem() {
        if (this.symbolizer.dasharray.length > 0) {
            this.symbolizer.dasharray.length--;
        }
    }
}
HsLineSymbolizerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLineSymbolizerComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
HsLineSymbolizerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsLineSymbolizerComponent, selector: "hs-line-symbolizer", inputs: { symbolizer: "symbolizer", app: "app" }, viewQueries: [{ propertyName: "lineMenuRef", first: true, predicate: ["graphicLineMenu"], descendants: true }, { propertyName: "strokeMenuRef", first: true, predicate: ["graphicStrokeMenu"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<form class=\"form\">\n  <hs-symbolizer-color-picker [symbolizer]=\"symbolizer\" attribute=\"color\" opacityAttribute=\"opacity\"\n    (changes)=\"emitChange()\" label=\"{{'STYLER.color' | translateHs : {app} }}\"></hs-symbolizer-color-picker>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" [app]=\"app\" attribute=\"opacity\" (changes)=\"emitChange()\" step=\"0.05\" min=\"0\"\n    max=\"1\" label=\"{{'STYLER.opacity' | translateHs : {app} }}\"></hs-symbolizer-slider>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" [app]=\"app\" attribute=\"width\" (changes)=\"emitChange()\" step=\"0.1\" min=\"0\" max=\"20\"\n    label=\"{{'STYLER.width' | translateHs : {app} }}\"></hs-symbolizer-slider>\n\n  <div class=\"d-flex flex-row flex-wrap\">\n    <div class=\"p-1 flex-grow-1 mt-2\">{{'STYLER.dashPattern' | translateHs : {app} }}:</div>\n    <input class=\"form-control me-1 form-select-sm\" style=\"width: 3em\"\n      *ngFor=\"let dash of symbolizer.dasharray; let i = index\" [ngModelOptions]=\"{standalone: true}\"\n      [(ngModel)]=\"symbolizer.dasharray[i]\" (change)=\"emitChange()\" />\n    <div class=\"btn-group\" role=\"group\" attr.aria-label=\"{{'STYLER.dashPattern' | translateHs : {app} }}\">\n      <button class=\"btn btn-outline-primary btn-sm\" (click)=\"addDashItem()\">\n        <span class=\"icon-plus\"></span>\n      </button>\n      <button class=\"btn btn-outline-danger btn-sm\" (click)=\"removeDashItem()\">\n        <span class=\"icon-minus\"></span>\n      </button>\n    </div>\n  </div>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" [app]=\"app\" attribute=\"blur\" (changes)=\"emitChange()\" step=\"0.1\" min=\"0\" max=\"20\"\n    label=\"{{'STYLER.blur' | translateHs : {app} }}\" warning=\"{{'STYLER.warningAttribNotStoredNotVisualized' | translateHs : {app} }}\">\n  </hs-symbolizer-slider>\n\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25 mt-2\">{{'STYLER.cap' | translateHs : {app} }}:</div>\n    <div class=\"p-1 w-75\">\n      <select class=\"form-control form-select-sm form-select\" [(ngModel)]=\"symbolizer.cap\" (change)=\"emitChange()\"\n        [ngModelOptions]=\"{standalone: true}\">\n        <option *ngFor=\"let cap of caps\">{{cap}}</option>\n      </select>\n    </div>\n  </div>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" [app]=\"app\" attribute=\"gapWidth\" (changes)=\"emitChange()\" step=\"1\" min=\"0\"\n    max=\"10\" label=\"{{'STYLER.gapWidth' | translateHs : {app} }}\"\n    warning=\"{{'STYLER.warningAttribNotStoredNotVisualized' | translateHs : {app} }}\"></hs-symbolizer-slider>\n\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25 mt-2\">{{'STYLER.join' | translateHs : {app} }}:</div>\n    <div class=\"p-1 w-75\">\n      <select class=\"form-control form-select-sm form-select\" [(ngModel)]=\"symbolizer.join\" (change)=\"emitChange()\"\n        [ngModelOptions]=\"{standalone: true}\">\n        <option *ngFor=\"let join of joins\">{{join}}</option>\n      </select>\n    </div>\n  </div>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" [app]=\"app\" attribute=\"miterLimit\" (changes)=\"emitChange()\" step=\"1\" min=\"0\"\n    max=\"90\" label=\"{{'STYLER.miterLimit' | translateHs : {app} }}\"\n    warning=\"{{'STYLER.warningAttribNotStoredNotVisualized' | translateHs : {app} }}\"></hs-symbolizer-slider>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" [app]=\"app\" attribute=\"perpendicularOffset\" (changes)=\"emitChange()\" step=\"1\"\n    min=\"0\" max=\"20\" label=\"{{'STYLER.perpendicularOffset' | translateHs : {app} }}\"\n    warning=\"{{'STYLER.warningAttribStoredNotVisualized' | translateHs : {app} }}\"></hs-symbolizer-slider>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" [app]=\"app\" attribute=\"roundLimit\" (changes)=\"emitChange()\" step=\"1\" min=\"0\"\n    max=\"90\" label=\"{{'STYLER.roundLimit' | translateHs : {app} }}\"\n    warning=\"{{'STYLER.warningAttribNotStoredNotVisualized' | translateHs : {app} }}\"></hs-symbolizer-slider>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" [app]=\"app\" attribute=\"spacing\" (changes)=\"emitChange()\" step=\"1\" min=\"0\" max=\"20\"\n    label=\"{{'STYLER.spacing' | translateHs : {app} }}\" warning=\"{{'STYLER.warningAttribNotStoredNotVisualized' | translateHs : {app} }}\">\n  </hs-symbolizer-slider>\n\n  <div class=\"d-flex flex-row justify-content-end\">\n    <div class=\"p-1 flex-grow-1 mt-2\">\n      {{'STYLER.graphicFill' | translateHs : {app} }}:\n    </div>\n    <span class=\"badge bg-warning mt-2\" title=\"{{'STYLER.warningAttribStoredNotVisualized' | translateHs : {app} }}\">!</span>\n    <div class=\"p-1\">\n      <div ngbDropdown #graphicLineMenu=\"ngbDropdown\" class=\"d-inline-block\" placement=\"top-right\">\n        <button class=\"btn btn-outline-primary btn-sm\" id=\"dropdownAddFillSymbolizer\" ngbDropdownToggle>\n          <span class=\"icon-plus\"></span>\n        </button>\n        <div ngbDropdownMenu aria-labelledby=\"dropdownAddFillSymbolizer\">\n          <button ngbDropdownItem (click)=\"addSymbolizer('graphicFill', 'Mark')\">\n            Mark\n          </button>\n          <button ngbDropdownItem (click)=\"addSymbolizer('graphicFill', 'Icon')\">\n            Icon\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <hs-mark-symbolizer (remove)=\"symbolizer.graphicFill = undefined\" [app]=\"app\" [symbolizer]=\"symbolizer.graphicFill\"\n  (changes)=\"emitChange()\" *ngIf=\"symbolizer.graphicFill && symbolizer.graphicFill.kind === kinds.mark\">\n</hs-mark-symbolizer>\n\n<hs-icon-symbolizer (remove)=\"symbolizer.graphicFill = undefined\" [app]=\"app\" [symbolizer]=\"symbolizer.graphicFill\"\n  (changes)=\"emitChange()\" *ngIf=\"symbolizer.graphicFill && symbolizer.graphicFill.kind === kinds.icon\">\n</hs-icon-symbolizer>\n\n  <div class=\"d-flex flex-row justify-content-end\">\n    <div class=\"p-1 flex-grow-1 mt-2\">\n      {{'STYLER.graphicStroke' | translateHs : {app} }}:\n    </div>\n    <span class=\"badge bg-warning mt-2\" title=\"{{'STYLER.warningAttribStoredNotVisualized' | translateHs : {app} }}\">!</span>\n    <div class=\"p-1\">\n      <div ngbDropdown #graphicStrokeMenu=\"ngbDropdown\" class=\"d-inline-block\" placement=\"top-right\">\n        <button class=\"btn btn-outline-primary btn-sm\" id=\"dropdownAddStrokeSymbolizer\" ngbDropdownToggle>\n          <span class=\"icon-plus\"></span>\n        </button>\n        <div ngbDropdownMenu aria-labelledby=\"dropdownAddStrokeSymbolizer\">\n          <button ngbDropdownItem (click)=\"addSymbolizer('graphicStroke', 'Mark')\">\n            Mark\n          </button>\n          <button ngbDropdownItem (click)=\"addSymbolizer('graphicStroke', 'Icon')\">\n            Icon\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <hs-mark-symbolizer (remove)=\"symbolizer.graphicStroke = undefined\" [app]=\"app\" [symbolizer]=\"symbolizer.graphicStroke\"\n    (changes)=\"emitChange()\" *ngIf=\"symbolizer.graphicStroke && symbolizer.graphicStroke.kind === kinds.mark\">\n  </hs-mark-symbolizer>\n\n  <hs-icon-symbolizer (remove)=\"symbolizer.graphicStroke = undefined\" [symbolizer]=\"symbolizer.graphicStroke\"\n    (changes)=\"emitChange()\" *ngIf=\"symbolizer.graphicStroke && symbolizer.graphicStroke.kind === kinds.icon\">\n  </hs-icon-symbolizer>\n\n</form>", components: [{ type: HsColorPickerComponent, selector: "hs-symbolizer-color-picker", inputs: ["symbolizer", "attribute", "opacityAttribute", "label"] }, { type: HsSliderComponent, selector: "hs-symbolizer-slider", inputs: ["symbolizer", "attribute", "label", "min", "max", "step"] }, { type: HsMarkSymbolizerComponent, selector: "hs-mark-symbolizer", inputs: ["symbolizer", "app"] }, { type: HsIconSymbolizerComponent, selector: "hs-icon-symbolizer", inputs: ["symbolizer", "app"] }], directives: [{ type: i3$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i3$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i3$1.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3$1.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i3$1.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i3$1.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i7.NgbDropdown, selector: "[ngbDropdown]", inputs: ["autoClose", "dropdownClass", "open", "placement", "container", "display"], outputs: ["openChange"], exportAs: ["ngbDropdown"] }, { type: i7.NgbDropdownToggle, selector: "[ngbDropdownToggle]" }, { type: i7.NgbDropdownMenu, selector: "[ngbDropdownMenu]" }, { type: i7.NgbDropdownItem, selector: "[ngbDropdownItem]", inputs: ["disabled"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLineSymbolizerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-line-symbolizer', template: "<form class=\"form\">\n  <hs-symbolizer-color-picker [symbolizer]=\"symbolizer\" attribute=\"color\" opacityAttribute=\"opacity\"\n    (changes)=\"emitChange()\" label=\"{{'STYLER.color' | translateHs : {app} }}\"></hs-symbolizer-color-picker>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" [app]=\"app\" attribute=\"opacity\" (changes)=\"emitChange()\" step=\"0.05\" min=\"0\"\n    max=\"1\" label=\"{{'STYLER.opacity' | translateHs : {app} }}\"></hs-symbolizer-slider>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" [app]=\"app\" attribute=\"width\" (changes)=\"emitChange()\" step=\"0.1\" min=\"0\" max=\"20\"\n    label=\"{{'STYLER.width' | translateHs : {app} }}\"></hs-symbolizer-slider>\n\n  <div class=\"d-flex flex-row flex-wrap\">\n    <div class=\"p-1 flex-grow-1 mt-2\">{{'STYLER.dashPattern' | translateHs : {app} }}:</div>\n    <input class=\"form-control me-1 form-select-sm\" style=\"width: 3em\"\n      *ngFor=\"let dash of symbolizer.dasharray; let i = index\" [ngModelOptions]=\"{standalone: true}\"\n      [(ngModel)]=\"symbolizer.dasharray[i]\" (change)=\"emitChange()\" />\n    <div class=\"btn-group\" role=\"group\" attr.aria-label=\"{{'STYLER.dashPattern' | translateHs : {app} }}\">\n      <button class=\"btn btn-outline-primary btn-sm\" (click)=\"addDashItem()\">\n        <span class=\"icon-plus\"></span>\n      </button>\n      <button class=\"btn btn-outline-danger btn-sm\" (click)=\"removeDashItem()\">\n        <span class=\"icon-minus\"></span>\n      </button>\n    </div>\n  </div>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" [app]=\"app\" attribute=\"blur\" (changes)=\"emitChange()\" step=\"0.1\" min=\"0\" max=\"20\"\n    label=\"{{'STYLER.blur' | translateHs : {app} }}\" warning=\"{{'STYLER.warningAttribNotStoredNotVisualized' | translateHs : {app} }}\">\n  </hs-symbolizer-slider>\n\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25 mt-2\">{{'STYLER.cap' | translateHs : {app} }}:</div>\n    <div class=\"p-1 w-75\">\n      <select class=\"form-control form-select-sm form-select\" [(ngModel)]=\"symbolizer.cap\" (change)=\"emitChange()\"\n        [ngModelOptions]=\"{standalone: true}\">\n        <option *ngFor=\"let cap of caps\">{{cap}}</option>\n      </select>\n    </div>\n  </div>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" [app]=\"app\" attribute=\"gapWidth\" (changes)=\"emitChange()\" step=\"1\" min=\"0\"\n    max=\"10\" label=\"{{'STYLER.gapWidth' | translateHs : {app} }}\"\n    warning=\"{{'STYLER.warningAttribNotStoredNotVisualized' | translateHs : {app} }}\"></hs-symbolizer-slider>\n\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25 mt-2\">{{'STYLER.join' | translateHs : {app} }}:</div>\n    <div class=\"p-1 w-75\">\n      <select class=\"form-control form-select-sm form-select\" [(ngModel)]=\"symbolizer.join\" (change)=\"emitChange()\"\n        [ngModelOptions]=\"{standalone: true}\">\n        <option *ngFor=\"let join of joins\">{{join}}</option>\n      </select>\n    </div>\n  </div>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" [app]=\"app\" attribute=\"miterLimit\" (changes)=\"emitChange()\" step=\"1\" min=\"0\"\n    max=\"90\" label=\"{{'STYLER.miterLimit' | translateHs : {app} }}\"\n    warning=\"{{'STYLER.warningAttribNotStoredNotVisualized' | translateHs : {app} }}\"></hs-symbolizer-slider>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" [app]=\"app\" attribute=\"perpendicularOffset\" (changes)=\"emitChange()\" step=\"1\"\n    min=\"0\" max=\"20\" label=\"{{'STYLER.perpendicularOffset' | translateHs : {app} }}\"\n    warning=\"{{'STYLER.warningAttribStoredNotVisualized' | translateHs : {app} }}\"></hs-symbolizer-slider>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" [app]=\"app\" attribute=\"roundLimit\" (changes)=\"emitChange()\" step=\"1\" min=\"0\"\n    max=\"90\" label=\"{{'STYLER.roundLimit' | translateHs : {app} }}\"\n    warning=\"{{'STYLER.warningAttribNotStoredNotVisualized' | translateHs : {app} }}\"></hs-symbolizer-slider>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" [app]=\"app\" attribute=\"spacing\" (changes)=\"emitChange()\" step=\"1\" min=\"0\" max=\"20\"\n    label=\"{{'STYLER.spacing' | translateHs : {app} }}\" warning=\"{{'STYLER.warningAttribNotStoredNotVisualized' | translateHs : {app} }}\">\n  </hs-symbolizer-slider>\n\n  <div class=\"d-flex flex-row justify-content-end\">\n    <div class=\"p-1 flex-grow-1 mt-2\">\n      {{'STYLER.graphicFill' | translateHs : {app} }}:\n    </div>\n    <span class=\"badge bg-warning mt-2\" title=\"{{'STYLER.warningAttribStoredNotVisualized' | translateHs : {app} }}\">!</span>\n    <div class=\"p-1\">\n      <div ngbDropdown #graphicLineMenu=\"ngbDropdown\" class=\"d-inline-block\" placement=\"top-right\">\n        <button class=\"btn btn-outline-primary btn-sm\" id=\"dropdownAddFillSymbolizer\" ngbDropdownToggle>\n          <span class=\"icon-plus\"></span>\n        </button>\n        <div ngbDropdownMenu aria-labelledby=\"dropdownAddFillSymbolizer\">\n          <button ngbDropdownItem (click)=\"addSymbolizer('graphicFill', 'Mark')\">\n            Mark\n          </button>\n          <button ngbDropdownItem (click)=\"addSymbolizer('graphicFill', 'Icon')\">\n            Icon\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <hs-mark-symbolizer (remove)=\"symbolizer.graphicFill = undefined\" [app]=\"app\" [symbolizer]=\"symbolizer.graphicFill\"\n  (changes)=\"emitChange()\" *ngIf=\"symbolizer.graphicFill && symbolizer.graphicFill.kind === kinds.mark\">\n</hs-mark-symbolizer>\n\n<hs-icon-symbolizer (remove)=\"symbolizer.graphicFill = undefined\" [app]=\"app\" [symbolizer]=\"symbolizer.graphicFill\"\n  (changes)=\"emitChange()\" *ngIf=\"symbolizer.graphicFill && symbolizer.graphicFill.kind === kinds.icon\">\n</hs-icon-symbolizer>\n\n  <div class=\"d-flex flex-row justify-content-end\">\n    <div class=\"p-1 flex-grow-1 mt-2\">\n      {{'STYLER.graphicStroke' | translateHs : {app} }}:\n    </div>\n    <span class=\"badge bg-warning mt-2\" title=\"{{'STYLER.warningAttribStoredNotVisualized' | translateHs : {app} }}\">!</span>\n    <div class=\"p-1\">\n      <div ngbDropdown #graphicStrokeMenu=\"ngbDropdown\" class=\"d-inline-block\" placement=\"top-right\">\n        <button class=\"btn btn-outline-primary btn-sm\" id=\"dropdownAddStrokeSymbolizer\" ngbDropdownToggle>\n          <span class=\"icon-plus\"></span>\n        </button>\n        <div ngbDropdownMenu aria-labelledby=\"dropdownAddStrokeSymbolizer\">\n          <button ngbDropdownItem (click)=\"addSymbolizer('graphicStroke', 'Mark')\">\n            Mark\n          </button>\n          <button ngbDropdownItem (click)=\"addSymbolizer('graphicStroke', 'Icon')\">\n            Icon\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <hs-mark-symbolizer (remove)=\"symbolizer.graphicStroke = undefined\" [app]=\"app\" [symbolizer]=\"symbolizer.graphicStroke\"\n    (changes)=\"emitChange()\" *ngIf=\"symbolizer.graphicStroke && symbolizer.graphicStroke.kind === kinds.mark\">\n  </hs-mark-symbolizer>\n\n  <hs-icon-symbolizer (remove)=\"symbolizer.graphicStroke = undefined\" [symbolizer]=\"symbolizer.graphicStroke\"\n    (changes)=\"emitChange()\" *ngIf=\"symbolizer.graphicStroke && symbolizer.graphicStroke.kind === kinds.icon\">\n  </hs-icon-symbolizer>\n\n</form>" }]
        }], propDecorators: { symbolizer: [{
                type: Input
            }], app: [{
                type: Input
            }], lineMenuRef: [{
                type: ViewChild,
                args: ['graphicLineMenu']
            }], strokeMenuRef: [{
                type: ViewChild,
                args: ['graphicStrokeMenu']
            }] } });

class HsTextSymbolizerComponent extends HsStylerPartBaseComponent {
    constructor() {
        super(...arguments);
        this.anchors = [
            'center',
            'left',
            'right',
            'top',
            'bottom',
            'top-left',
            'top-right',
            'bottom-left',
            'bottom-right',
        ];
        this.fonts = [
            'Arial',
            'Verdana',
            'Sans-serif',
            'Courier New',
            'Lucida Console',
            'Monospace',
            'Times New Roman',
            'Georgia',
            'Serif',
        ];
        this.fontStyles = ['normal', 'italic', 'bold'];
        this.transforms = ['none', 'uppercase', 'lowercase'];
        this.justifications = ['left', 'center', 'right'];
        this.fontWeights = ['normal', 'bold'];
    }
}
HsTextSymbolizerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsTextSymbolizerComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
HsTextSymbolizerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsTextSymbolizerComponent, selector: "hs-text-symbolizer", inputs: { symbolizer: "symbolizer" }, usesInheritance: true, ngImport: i0, template: "<form class=\"form\">\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25\">{{'STYLER.template' | translateHs: this}}:</div>\n    <div class=\"p-1 w-75\">\n      <input class=\"form-control form-select-sm\" [ngModelOptions]=\"{standalone: true}\" [(ngModel)]=\"symbolizer.label\"\n        (change)=\"emitChange()\" />\n    </div>\n  </div>\n\n  <hs-symbolizer-color-picker [symbolizer]=\"symbolizer\" attribute=\"color\" opacityAttribute=\"opacity\"\n    (changes)=\"emitChange()\" label=\"{{'STYLER.textColor' | translateHs: this}}\"></hs-symbolizer-color-picker>\n\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25\">{{'STYLER.font' | translateHs: this}}:</div>\n    <div class=\"p-1 w-75\">\n      <select class=\"form-control form-select-sm form-select\" (change)=\"emitChange()\" [ngModelOptions]=\"{standalone: true}\" [(ngModel)]=\"symbolizer.font\"\n        multiple>\n        <option *ngFor=\"let font of fonts\" [ngValue]=\"font\">{{font}}</option>\n      </select>\n    </div>\n  </div>\n\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25\">{{'STYLER.textSize' | translateHs: this}}:</div>\n    <div class=\"p-1 w-75\">\n      <input class=\"form-control form-select-sm\" [ngModelOptions]=\"{standalone: true}\" [(ngModel)]=\"symbolizer.size\"\n        (change)=\"emitChange()\" />\n    </div>\n  </div>\n\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25 mt-2\">{{'STYLER.justify' | translateHs: this}}:</div>\n    <span class=\"badge bg-warning mt-2\" title=\"{{'STYLER.warningAttribNotStoredNotVisualized' | translateHs: this}}\">!</span>\n    <div class=\"p-1 w-75\">\n      <select class=\"form-control form-select-sm form-select\" [(ngModel)]=\"symbolizer.justify\" (change)=\"emitChange()\"\n        [ngModelOptions]=\"{standalone: true}\">\n        <option *ngFor=\"let justify of justifications\">{{justify}}</option>\n      </select>\n    </div>\n  </div>\n\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25 mt-2\">{{'STYLER.transform' | translateHs: this}}:</div>\n    <span class=\"badge bg-warning mt-2\" title=\"{{'STYLER.warningAttribNotStoredNotVisualized' | translateHs: this}}\">!</span>\n    <div class=\"p-1 w-75\">\n      <select class=\"form-control form-select-sm form-select\" [(ngModel)]=\"symbolizer.transform\" (change)=\"emitChange()\"\n        [ngModelOptions]=\"{standalone: true}\">\n        <option *ngFor=\"let transform of transforms\">{{transform}}</option>\n      </select>\n    </div>\n  </div>\n\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25 mt-2\">{{'STYLER.fontStyle' | translateHs: this}}:</div>\n    <span class=\"badge bg-warning mt-2\" title=\"{{'STYLER.warningAttribStoredNotVisualized' | translateHs: this}}\">!</span>\n    <div class=\"p-1 w-75\">\n      <select class=\"form-control form-select-sm form-select\" [(ngModel)]=\"symbolizer.fontStyle\" (change)=\"emitChange()\"\n        [ngModelOptions]=\"{standalone: true}\">\n        <option *ngFor=\"let fontStyle of fontStyles\">{{fontStyle}}</option>\n      </select>\n    </div>\n  </div>\n\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25 mt-2\">{{'STYLER.fontWeight' | translateHs: this}}:</div>\n    <span class=\"badge bg-warning mt-2\" title=\"{{'STYLER.warningAttribStoredNotVisualized' | translateHs: this}}\">!</span>\n    <div class=\"p-1 w-75\">\n      <select class=\"form-control form-select-sm form-select\" [(ngModel)]=\"symbolizer.fontWeight\" (change)=\"emitChange()\"\n        [ngModelOptions]=\"{standalone: true}\">\n        <option *ngFor=\"let fontWeight of fontWeights\">{{fontWeight}}</option>\n      </select>\n    </div>\n  </div>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" [app]=\"app\" attribute=\"opacity\" (changes)=\"emitChange()\" step=\"0.05\" min=\"0\"\n    max=\"1\" label=\"{{'STYLER.opacity' | translateHs: this}}\"\n    warning=\"{{'STYLER.warningAttribNotStoredVisualized' | translateHs: this}}\"></hs-symbolizer-slider>\n\n  <hs-symbolizer-color-picker [symbolizer]=\"symbolizer\" attribute=\"haloColor\" (changes)=\"emitChange()\"\n    label=\"{{'STYLER.haloColor' | translateHs: this}}\"></hs-symbolizer-color-picker>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" [app]=\"app\" attribute=\"haloWidth\" (changes)=\"emitChange()\" step=\"1\" min=\"0\"\n    max=\"20\" label=\"{{'STYLER.haloWidth' | translateHs: this}}\"></hs-symbolizer-slider>\n\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25\">{{'STYLER.offsetX' | translateHs: this}}:</div>\n    <div class=\"p-1 w-75\">\n      <input class=\"w-100\" type=\"range\" step=\"1\" min=\"-40\" max=\"40\"\n        [ngModelOptions]=\"{standalone: true}\" [(ngModel)]=\"symbolizer.offset[0]\" *ngIf=\"symbolizer.offset !== undefined\"\n        (change)=\"emitChange()\" />\n    </div>\n  </div>\n\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25\">{{'STYLER.offsetY' | translateHs: this}}:</div>\n    <div class=\"p-1 w-75\">\n      <input class=\"w-100\" type=\"range\" step=\"1\" min=\"-40\" max=\"40\"\n        [ngModelOptions]=\"{standalone: true}\" [(ngModel)]=\"symbolizer.offset[1]\" *ngIf=\"symbolizer.offset !== undefined\"\n        (change)=\"emitChange()\" />\n    </div>\n  </div>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" [app]=\"app\" attribute=\"rotate\" (changes)=\"emitChange()\" step=\"1\" min=\"0\" max=\"360\"\n    label=\"{{'STYLER.rotation' | translateHs: this}}\"></hs-symbolizer-slider>\n\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25 mt-2\">{{'STYLER.anchor' | translateHs: this}}:</div>\n    <span class=\"badge bg-warning mt-2\" title=\"{{'STYLER.warningAttribStoredNotVisualized' | translateHs: this}}\">!</span>\n    <div class=\"p-1 w-75\">\n      <select class=\"form-control form-select-sm form-select\" [(ngModel)]=\"symbolizer.anchor\" (change)=\"emitChange()\"\n        [ngModelOptions]=\"{standalone: true}\">\n        <option *ngFor=\"let anchor of anchors\">{{anchor}}</option>\n      </select>\n    </div>\n  </div>\n</form>\n", components: [{ type: HsColorPickerComponent, selector: "hs-symbolizer-color-picker", inputs: ["symbolizer", "attribute", "opacityAttribute", "label"] }, { type: HsSliderComponent, selector: "hs-symbolizer-slider", inputs: ["symbolizer", "attribute", "label", "min", "max", "step"] }], directives: [{ type: i3$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i3$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i3$1.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3$1.SelectMultipleControlValueAccessor, selector: "select[multiple][formControlName],select[multiple][formControl],select[multiple][ngModel]", inputs: ["compareWith"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3$1.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i3$1.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i3$1.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3$1.RangeValueAccessor, selector: "input[type=range][formControlName],input[type=range][formControl],input[type=range][ngModel]" }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsTextSymbolizerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-text-symbolizer', template: "<form class=\"form\">\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25\">{{'STYLER.template' | translateHs: this}}:</div>\n    <div class=\"p-1 w-75\">\n      <input class=\"form-control form-select-sm\" [ngModelOptions]=\"{standalone: true}\" [(ngModel)]=\"symbolizer.label\"\n        (change)=\"emitChange()\" />\n    </div>\n  </div>\n\n  <hs-symbolizer-color-picker [symbolizer]=\"symbolizer\" attribute=\"color\" opacityAttribute=\"opacity\"\n    (changes)=\"emitChange()\" label=\"{{'STYLER.textColor' | translateHs: this}}\"></hs-symbolizer-color-picker>\n\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25\">{{'STYLER.font' | translateHs: this}}:</div>\n    <div class=\"p-1 w-75\">\n      <select class=\"form-control form-select-sm form-select\" (change)=\"emitChange()\" [ngModelOptions]=\"{standalone: true}\" [(ngModel)]=\"symbolizer.font\"\n        multiple>\n        <option *ngFor=\"let font of fonts\" [ngValue]=\"font\">{{font}}</option>\n      </select>\n    </div>\n  </div>\n\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25\">{{'STYLER.textSize' | translateHs: this}}:</div>\n    <div class=\"p-1 w-75\">\n      <input class=\"form-control form-select-sm\" [ngModelOptions]=\"{standalone: true}\" [(ngModel)]=\"symbolizer.size\"\n        (change)=\"emitChange()\" />\n    </div>\n  </div>\n\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25 mt-2\">{{'STYLER.justify' | translateHs: this}}:</div>\n    <span class=\"badge bg-warning mt-2\" title=\"{{'STYLER.warningAttribNotStoredNotVisualized' | translateHs: this}}\">!</span>\n    <div class=\"p-1 w-75\">\n      <select class=\"form-control form-select-sm form-select\" [(ngModel)]=\"symbolizer.justify\" (change)=\"emitChange()\"\n        [ngModelOptions]=\"{standalone: true}\">\n        <option *ngFor=\"let justify of justifications\">{{justify}}</option>\n      </select>\n    </div>\n  </div>\n\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25 mt-2\">{{'STYLER.transform' | translateHs: this}}:</div>\n    <span class=\"badge bg-warning mt-2\" title=\"{{'STYLER.warningAttribNotStoredNotVisualized' | translateHs: this}}\">!</span>\n    <div class=\"p-1 w-75\">\n      <select class=\"form-control form-select-sm form-select\" [(ngModel)]=\"symbolizer.transform\" (change)=\"emitChange()\"\n        [ngModelOptions]=\"{standalone: true}\">\n        <option *ngFor=\"let transform of transforms\">{{transform}}</option>\n      </select>\n    </div>\n  </div>\n\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25 mt-2\">{{'STYLER.fontStyle' | translateHs: this}}:</div>\n    <span class=\"badge bg-warning mt-2\" title=\"{{'STYLER.warningAttribStoredNotVisualized' | translateHs: this}}\">!</span>\n    <div class=\"p-1 w-75\">\n      <select class=\"form-control form-select-sm form-select\" [(ngModel)]=\"symbolizer.fontStyle\" (change)=\"emitChange()\"\n        [ngModelOptions]=\"{standalone: true}\">\n        <option *ngFor=\"let fontStyle of fontStyles\">{{fontStyle}}</option>\n      </select>\n    </div>\n  </div>\n\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25 mt-2\">{{'STYLER.fontWeight' | translateHs: this}}:</div>\n    <span class=\"badge bg-warning mt-2\" title=\"{{'STYLER.warningAttribStoredNotVisualized' | translateHs: this}}\">!</span>\n    <div class=\"p-1 w-75\">\n      <select class=\"form-control form-select-sm form-select\" [(ngModel)]=\"symbolizer.fontWeight\" (change)=\"emitChange()\"\n        [ngModelOptions]=\"{standalone: true}\">\n        <option *ngFor=\"let fontWeight of fontWeights\">{{fontWeight}}</option>\n      </select>\n    </div>\n  </div>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" [app]=\"app\" attribute=\"opacity\" (changes)=\"emitChange()\" step=\"0.05\" min=\"0\"\n    max=\"1\" label=\"{{'STYLER.opacity' | translateHs: this}}\"\n    warning=\"{{'STYLER.warningAttribNotStoredVisualized' | translateHs: this}}\"></hs-symbolizer-slider>\n\n  <hs-symbolizer-color-picker [symbolizer]=\"symbolizer\" attribute=\"haloColor\" (changes)=\"emitChange()\"\n    label=\"{{'STYLER.haloColor' | translateHs: this}}\"></hs-symbolizer-color-picker>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" [app]=\"app\" attribute=\"haloWidth\" (changes)=\"emitChange()\" step=\"1\" min=\"0\"\n    max=\"20\" label=\"{{'STYLER.haloWidth' | translateHs: this}}\"></hs-symbolizer-slider>\n\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25\">{{'STYLER.offsetX' | translateHs: this}}:</div>\n    <div class=\"p-1 w-75\">\n      <input class=\"w-100\" type=\"range\" step=\"1\" min=\"-40\" max=\"40\"\n        [ngModelOptions]=\"{standalone: true}\" [(ngModel)]=\"symbolizer.offset[0]\" *ngIf=\"symbolizer.offset !== undefined\"\n        (change)=\"emitChange()\" />\n    </div>\n  </div>\n\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25\">{{'STYLER.offsetY' | translateHs: this}}:</div>\n    <div class=\"p-1 w-75\">\n      <input class=\"w-100\" type=\"range\" step=\"1\" min=\"-40\" max=\"40\"\n        [ngModelOptions]=\"{standalone: true}\" [(ngModel)]=\"symbolizer.offset[1]\" *ngIf=\"symbolizer.offset !== undefined\"\n        (change)=\"emitChange()\" />\n    </div>\n  </div>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" [app]=\"app\" attribute=\"rotate\" (changes)=\"emitChange()\" step=\"1\" min=\"0\" max=\"360\"\n    label=\"{{'STYLER.rotation' | translateHs: this}}\"></hs-symbolizer-slider>\n\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25 mt-2\">{{'STYLER.anchor' | translateHs: this}}:</div>\n    <span class=\"badge bg-warning mt-2\" title=\"{{'STYLER.warningAttribStoredNotVisualized' | translateHs: this}}\">!</span>\n    <div class=\"p-1 w-75\">\n      <select class=\"form-control form-select-sm form-select\" [(ngModel)]=\"symbolizer.anchor\" (change)=\"emitChange()\"\n        [ngModelOptions]=\"{standalone: true}\">\n        <option *ngFor=\"let anchor of anchors\">{{anchor}}</option>\n      </select>\n    </div>\n  </div>\n</form>\n" }]
        }], propDecorators: { symbolizer: [{
                type: Input
            }] } });

class HsSymbolizerComponent extends HsStylerPartBaseComponent {
    constructor() {
        super(...arguments);
        this.kinds = Kinds;
    }
}
HsSymbolizerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSymbolizerComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
HsSymbolizerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsSymbolizerComponent, selector: "hs-symbolizer", inputs: { symbolizer: "symbolizer" }, usesInheritance: true, ngImport: i0, template: "<div class=\"card m-0\">\n  <form class=\"form\">\n    <hs-fill-symbolizer [symbolizer]=\"symbolizer\" [app]=\"app\" (changes)=\"emitChange()\" *ngIf=\"symbolizer.kind === kinds.fill\">\n    </hs-fill-symbolizer>\n    <hs-line-symbolizer [symbolizer]=\"symbolizer\" [app]=\"app\" (changes)=\"emitChange()\" *ngIf=\"symbolizer.kind === kinds.line\">\n    </hs-line-symbolizer>\n    <hs-mark-symbolizer [symbolizer]=\"symbolizer\" [app]=\"app\" (changes)=\"emitChange()\" *ngIf=\"symbolizer.kind === kinds.mark\">\n    </hs-mark-symbolizer>\n    <hs-icon-symbolizer [symbolizer]=\"symbolizer\" [app]=\"app\" (changes)=\"emitChange()\" *ngIf=\"symbolizer.kind === kinds.icon\">\n    </hs-icon-symbolizer>\n    <hs-text-symbolizer [symbolizer]=\"symbolizer\" [app]=\"app\" (changes)=\"emitChange()\" *ngIf=\"symbolizer.kind === kinds.text\">\n    </hs-text-symbolizer>\n  </form>\n</div>", components: [{ type: HsFillSymbolizerComponent, selector: "hs-fill-symbolizer", inputs: ["symbolizer", "app"] }, { type: HsLineSymbolizerComponent, selector: "hs-line-symbolizer", inputs: ["symbolizer", "app"] }, { type: HsMarkSymbolizerComponent, selector: "hs-mark-symbolizer", inputs: ["symbolizer", "app"] }, { type: HsIconSymbolizerComponent, selector: "hs-icon-symbolizer", inputs: ["symbolizer", "app"] }, { type: HsTextSymbolizerComponent, selector: "hs-text-symbolizer", inputs: ["symbolizer"] }], directives: [{ type: i3$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i3$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i3$1.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSymbolizerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-symbolizer', template: "<div class=\"card m-0\">\n  <form class=\"form\">\n    <hs-fill-symbolizer [symbolizer]=\"symbolizer\" [app]=\"app\" (changes)=\"emitChange()\" *ngIf=\"symbolizer.kind === kinds.fill\">\n    </hs-fill-symbolizer>\n    <hs-line-symbolizer [symbolizer]=\"symbolizer\" [app]=\"app\" (changes)=\"emitChange()\" *ngIf=\"symbolizer.kind === kinds.line\">\n    </hs-line-symbolizer>\n    <hs-mark-symbolizer [symbolizer]=\"symbolizer\" [app]=\"app\" (changes)=\"emitChange()\" *ngIf=\"symbolizer.kind === kinds.mark\">\n    </hs-mark-symbolizer>\n    <hs-icon-symbolizer [symbolizer]=\"symbolizer\" [app]=\"app\" (changes)=\"emitChange()\" *ngIf=\"symbolizer.kind === kinds.icon\">\n    </hs-icon-symbolizer>\n    <hs-text-symbolizer [symbolizer]=\"symbolizer\" [app]=\"app\" (changes)=\"emitChange()\" *ngIf=\"symbolizer.kind === kinds.text\">\n    </hs-text-symbolizer>\n  </form>\n</div>" }]
        }], propDecorators: { symbolizer: [{
                type: Input
            }] } });

class HsSymbolizerListItemComponent extends HsStylerPartBaseComponent {
    constructor() {
        super(...arguments);
        this.symbolizerVisible = false;
    }
    getSymbolizerName(symbolizer) {
        switch (symbolizer.kind) {
            case Kinds.fill:
                return 'STYLER.fillSymbolizer';
            case Kinds.icon:
                return 'STYLER.iconSymbolizer';
            case Kinds.line:
                return 'STYLER.lineSymbolizer';
            case Kinds.text:
                return 'STYLER.textSymbolizer';
            case Kinds.mark:
                return 'STYLER.markSymbolizer';
            default:
                return 'STYLER.unknownSymbolizer';
        }
    }
    removeSymbolizer(symbolizer) {
        this.rule.symbolizers.splice(this.rule.symbolizers.indexOf(symbolizer), 1);
        this.emitChange();
    }
}
HsSymbolizerListItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSymbolizerListItemComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
HsSymbolizerListItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsSymbolizerListItemComponent, selector: "hs-symbolizer-list-item", inputs: { symbolizer: "symbolizer", rule: "rule" }, usesInheritance: true, ngImport: i0, template: "<li\n  class=\"list-group-item hs-list-item-header list-group-item-primary d-flex justify-content-between align-items-center mb-1 me-3 ms-3\"\n  (click)=\"symbolizerVisible = !symbolizerVisible;\">\n  <div>\n    <button type=\"button\" style=\"border: none; background-color: transparent; cursor: move\">\n      <i class=\"icon-move text-secondary\"></i>\n    </button>\n    <span>{{getSymbolizerName(symbolizer) | translateHs : {app} }}&nbsp;</span><!-- TODO: Remove function call from template -->\n  </div>\n  <div>\n    <span class=\"glyphicon me-2\" [ngClass]=\"symbolizerVisible ? 'icon-chevron-right' : 'icon-chevron-down'\"></span>\n    <button class=\"btn btn-danger btn-sm\" (click)=\"removeSymbolizer(symbolizer)\" data-toggle=\"tooltip\"\n      [title]=\"'STYLER.removeSymbolizer' | translateHs : {app} \">\n      <i class=\"icon-trash\"></i>\n    </button>\n  </div>\n</li>\n\n<ng-container *ngIf=\"symbolizerVisible\">\n  <hs-symbolizer [symbolizer]=\"symbolizer\" [app]=\"app\" (changes)=\"emitChange()\" (mousedown)=\"$event.stopPropagation()\">\n  </hs-symbolizer>\n</ng-container>\n", styles: [".cdk-drag-preview{box-sizing:content-box;border-radius:0;background-color:#b9b9b9bf;border:1px solid rgb(185,185,185);overflow:hidden;display:flex;align-items:center;color:#000;box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.cdk-drag-placeholder{opacity:0}.cdk-drag-animating{transition:transform 125ms cubic-bezier(0,0,.2,1)}.list-group.hs-styler-content-list.cdk-drop-list-dragging hs-rule-list-item:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}.list-group.hs-styler-content-list.cdk-drop-list-dragging hs-symbolizer-list-item:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}ul.hs-styler-content-list{margin-top:0;margin-bottom:0;border-bottom:1px solid white}li.list-group-item.hs-list-item-header{padding:.3em;width:100%;cursor:pointer;display:flex;justify-content:space-between;align-items:center;border-radius:0}li.list-group-item.hs-list-item-header .btn-danger{margin-right:1rem}li.list-group-item.hs-list-item-header span.glyphicon{font-size:x-small}li.list-group-item.hs-list-item-header:hover{background-color:#b9b9b9bf}\n"], components: [{ type: HsSymbolizerComponent, selector: "hs-symbolizer", inputs: ["symbolizer"] }], directives: [{ type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSymbolizerListItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-symbolizer-list-item', template: "<li\n  class=\"list-group-item hs-list-item-header list-group-item-primary d-flex justify-content-between align-items-center mb-1 me-3 ms-3\"\n  (click)=\"symbolizerVisible = !symbolizerVisible;\">\n  <div>\n    <button type=\"button\" style=\"border: none; background-color: transparent; cursor: move\">\n      <i class=\"icon-move text-secondary\"></i>\n    </button>\n    <span>{{getSymbolizerName(symbolizer) | translateHs : {app} }}&nbsp;</span><!-- TODO: Remove function call from template -->\n  </div>\n  <div>\n    <span class=\"glyphicon me-2\" [ngClass]=\"symbolizerVisible ? 'icon-chevron-right' : 'icon-chevron-down'\"></span>\n    <button class=\"btn btn-danger btn-sm\" (click)=\"removeSymbolizer(symbolizer)\" data-toggle=\"tooltip\"\n      [title]=\"'STYLER.removeSymbolizer' | translateHs : {app} \">\n      <i class=\"icon-trash\"></i>\n    </button>\n  </div>\n</li>\n\n<ng-container *ngIf=\"symbolizerVisible\">\n  <hs-symbolizer [symbolizer]=\"symbolizer\" [app]=\"app\" (changes)=\"emitChange()\" (mousedown)=\"$event.stopPropagation()\">\n  </hs-symbolizer>\n</ng-container>\n", styles: [".cdk-drag-preview{box-sizing:content-box;border-radius:0;background-color:#b9b9b9bf;border:1px solid rgb(185,185,185);overflow:hidden;display:flex;align-items:center;color:#000;box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.cdk-drag-placeholder{opacity:0}.cdk-drag-animating{transition:transform 125ms cubic-bezier(0,0,.2,1)}.list-group.hs-styler-content-list.cdk-drop-list-dragging hs-rule-list-item:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}.list-group.hs-styler-content-list.cdk-drop-list-dragging hs-symbolizer-list-item:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}ul.hs-styler-content-list{margin-top:0;margin-bottom:0;border-bottom:1px solid white}li.list-group-item.hs-list-item-header{padding:.3em;width:100%;cursor:pointer;display:flex;justify-content:space-between;align-items:center;border-radius:0}li.list-group-item.hs-list-item-header .btn-danger{margin-right:1rem}li.list-group-item.hs-list-item-header span.glyphicon{font-size:x-small}li.list-group-item.hs-list-item-header:hover{background-color:#b9b9b9bf}\n"] }]
        }], propDecorators: { symbolizer: [{
                type: Input
            }], rule: [{
                type: Input
            }] } });

class HsRuleComponent extends HsStylerPartBaseComponent {
    constructor(hsStylerService) {
        super();
        this.hsStylerService = hsStylerService;
        this.changes = new EventEmitter();
        this.filtersVisible = false;
        this.scalesVisible = false;
    }
    addSymbolizer(kind) {
        return __awaiter(this, void 0, void 0, function* () {
            const symbolizer = { kind, color: '#000' };
            if (kind === Kinds.text) {
                Object.assign(symbolizer, { size: 12, offset: [0, 0] });
            }
            if (kind === Kinds.fill) {
                Object.assign(symbolizer, { outlineColor: '#000' });
            }
            if (kind == Kinds.icon) {
                Object.assign(symbolizer, { offset: [0.5, 0.5] });
            }
            if (kind == Kinds.mark) {
                Object.assign(symbolizer, { wellKnownName: 'circle' });
            }
            if (kind == Kinds.icon) {
                Object.assign(symbolizer, { image: 'assets/img/icons/information78.svg' });
            }
            this.rule.symbolizers.push(symbolizer);
            this.menuRef.close();
            this.emitChange();
        });
    }
    drop(event) {
        return __awaiter(this, void 0, void 0, function* () {
            moveItemInArray(this.rule.symbolizers, event.previousIndex, event.currentIndex);
            this.emitChange();
        });
    }
}
HsRuleComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsRuleComponent, deps: [{ token: HsStylerService }], target: i0.ɵɵFactoryTarget.Component });
HsRuleComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsRuleComponent, selector: "hs-rule", inputs: { rule: "rule" }, outputs: { changes: "changes" }, viewQueries: [{ propertyName: "menuRef", first: true, predicate: ["addSymMenu"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<div>\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25\">{{'STYLER.name' | translateHs : {app} }}:</div>\n    <div class=\"p-1 w-75\">\n      <input class=\"form-control form-control-sm\" [ngModelOptions]=\"{standalone: true}\" [(ngModel)]=\"rule.name\"\n        (change)=\"emitChange()\" />\n    </div>\n  </div>\n  <div class=\"d-flex flex-row justify-content-end\">\n    <div class=\"p-1 flex-grow-1\">\n      {{'STYLER.filtersAndScales' | translateHs : {app} }}:\n    </div>\n    <div class=\"p-1\">\n      <div class=\"btn-group\" role=\"group\" aria-label=\"Filters and scales\">\n        <button [title]=\"'STYLER.toggleFilters' | translateHs : {app} \" class=\"btn btn-outline-primary btn-sm\"\n          (click)=\"filtersVisible = !filtersVisible\">\n          <span class=\"icon-filter\"></span>\n        </button>\n        <button [title]=\"'STYLER.toggleScaleDenominators' | translateHs : {app} \" class=\"btn btn-outline-primary btn-sm\"\n          (click)=\"scalesVisible = !scalesVisible\">\n          <span class=\"icon-design\"></span>\n        </button>\n      </div>\n    </div>\n  </div>\n  <hs-filters (changes)=\"emitChange()\" [app]=\"app\" *ngIf=\"filtersVisible\" [rule]=\"rule\"></hs-filters>\n  <hs-scale-denominator (changes)=\"emitChange()\" *ngIf=\"scalesVisible\" [rule]=\"rule\"></hs-scale-denominator>\n  <div class=\"d-flex flex-row justify-content-end\">\n    <div class=\"p-1 flex-grow-1\">{{'STYLER.symbolizers' | translateHs : {app} }}:</div>\n    <div class=\"p-1\">\n      <div #addSymMenu=\"ngbDropdown\" ngbDropdown class=\"d-inline-block\" placement=\"bottom-right\">\n        <button class=\"btn btn-outline-primary btn-sm\" [title]=\"'STYLER.addSymbolizer' | translateHs : {app} \"\n          id=\"dropdownAddSymbolizer\" ngbDropdownToggle>\n          <span class=\"icon-plus\"></span>\n        </button>\n        <div ngbDropdownMenu aria-labelledby=\"dropdownAddSymbolizer\">\n          <button ngbDropdownItem (click)=\"addSymbolizer('Mark')\">Mark</button>\n          <button ngbDropdownItem (click)=\"addSymbolizer('Icon')\">Icon</button>\n          <button ngbDropdownItem (click)=\"addSymbolizer('Text')\">Text</button>\n          <button ngbDropdownItem (click)=\"addSymbolizer('Line')\">Line</button>\n          <button ngbDropdownItem (click)=\"addSymbolizer('Fill')\">Fill</button>\n        </div>\n      </div>\n    </div>\n  </div>\n  <ng-container *ngIf=\"rule.symbolizers.length > 0\">\n    <ul class=\"list-group hs-styler-content-list\" cdkDropList (cdkDropListDropped)=\"drop($event)\"\n      [cdkDropListData]=\"rule.symbolizers\">\n      <ng-container *ngFor=\"let symbolizer of rule.symbolizers\">\n        <hs-symbolizer-list-item cdkDrag [rule]=\"rule\" [app]=\"app\" [symbolizer]=\"symbolizer\" (changes)=\"emitChange()\">\n        </hs-symbolizer-list-item>\n      </ng-container>\n    </ul>\n  </ng-container>\n</div>\n", styles: [".cdk-drag-preview{box-sizing:content-box;border-radius:0;background-color:#b9b9b9bf;border:1px solid rgb(185,185,185);overflow:hidden;display:flex;align-items:center;color:#000;box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.cdk-drag-placeholder{opacity:0}.cdk-drag-animating{transition:transform 125ms cubic-bezier(0,0,.2,1)}.list-group.hs-styler-content-list.cdk-drop-list-dragging hs-rule-list-item:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}.list-group.hs-styler-content-list.cdk-drop-list-dragging hs-symbolizer-list-item:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}ul.hs-styler-content-list{margin-top:0;margin-bottom:0;border-bottom:1px solid white}li.list-group-item.hs-list-item-header{padding:.3em;width:100%;cursor:pointer;display:flex;justify-content:space-between;align-items:center;border-radius:0}li.list-group-item.hs-list-item-header .btn-danger{margin-right:1rem}li.list-group-item.hs-list-item-header span.glyphicon{font-size:x-small}li.list-group-item.hs-list-item-header:hover{background-color:#b9b9b9bf}\n"], components: [{ type: HsFiltersComponent, selector: "hs-filters", inputs: ["rule"] }, { type: HsScaleDenominatorComponent, selector: "hs-scale-denominator", inputs: ["rule"] }, { type: HsSymbolizerListItemComponent, selector: "hs-symbolizer-list-item", inputs: ["symbolizer", "rule"] }], directives: [{ type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i7.NgbDropdown, selector: "[ngbDropdown]", inputs: ["autoClose", "dropdownClass", "open", "placement", "container", "display"], outputs: ["openChange"], exportAs: ["ngbDropdown"] }, { type: i7.NgbDropdownToggle, selector: "[ngbDropdownToggle]" }, { type: i7.NgbDropdownMenu, selector: "[ngbDropdownMenu]" }, { type: i7.NgbDropdownItem, selector: "[ngbDropdownItem]", inputs: ["disabled"] }, { type: i4.CdkDropList, selector: "[cdkDropList], cdk-drop-list", inputs: ["cdkDropListConnectedTo", "cdkDropListData", "cdkDropListOrientation", "id", "cdkDropListLockAxis", "cdkDropListDisabled", "cdkDropListSortingDisabled", "cdkDropListEnterPredicate", "cdkDropListSortPredicate", "cdkDropListAutoScrollDisabled", "cdkDropListAutoScrollStep"], outputs: ["cdkDropListDropped", "cdkDropListEntered", "cdkDropListExited", "cdkDropListSorted"], exportAs: ["cdkDropList"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i4.CdkDrag, selector: "[cdkDrag]", inputs: ["cdkDragData", "cdkDragLockAxis", "cdkDragRootElement", "cdkDragBoundary", "cdkDragStartDelay", "cdkDragFreeDragPosition", "cdkDragDisabled", "cdkDragConstrainPosition", "cdkDragPreviewClass", "cdkDragPreviewContainer"], outputs: ["cdkDragStarted", "cdkDragReleased", "cdkDragEnded", "cdkDragEntered", "cdkDragExited", "cdkDragDropped", "cdkDragMoved"], exportAs: ["cdkDrag"] }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsRuleComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-rule', template: "<div>\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25\">{{'STYLER.name' | translateHs : {app} }}:</div>\n    <div class=\"p-1 w-75\">\n      <input class=\"form-control form-control-sm\" [ngModelOptions]=\"{standalone: true}\" [(ngModel)]=\"rule.name\"\n        (change)=\"emitChange()\" />\n    </div>\n  </div>\n  <div class=\"d-flex flex-row justify-content-end\">\n    <div class=\"p-1 flex-grow-1\">\n      {{'STYLER.filtersAndScales' | translateHs : {app} }}:\n    </div>\n    <div class=\"p-1\">\n      <div class=\"btn-group\" role=\"group\" aria-label=\"Filters and scales\">\n        <button [title]=\"'STYLER.toggleFilters' | translateHs : {app} \" class=\"btn btn-outline-primary btn-sm\"\n          (click)=\"filtersVisible = !filtersVisible\">\n          <span class=\"icon-filter\"></span>\n        </button>\n        <button [title]=\"'STYLER.toggleScaleDenominators' | translateHs : {app} \" class=\"btn btn-outline-primary btn-sm\"\n          (click)=\"scalesVisible = !scalesVisible\">\n          <span class=\"icon-design\"></span>\n        </button>\n      </div>\n    </div>\n  </div>\n  <hs-filters (changes)=\"emitChange()\" [app]=\"app\" *ngIf=\"filtersVisible\" [rule]=\"rule\"></hs-filters>\n  <hs-scale-denominator (changes)=\"emitChange()\" *ngIf=\"scalesVisible\" [rule]=\"rule\"></hs-scale-denominator>\n  <div class=\"d-flex flex-row justify-content-end\">\n    <div class=\"p-1 flex-grow-1\">{{'STYLER.symbolizers' | translateHs : {app} }}:</div>\n    <div class=\"p-1\">\n      <div #addSymMenu=\"ngbDropdown\" ngbDropdown class=\"d-inline-block\" placement=\"bottom-right\">\n        <button class=\"btn btn-outline-primary btn-sm\" [title]=\"'STYLER.addSymbolizer' | translateHs : {app} \"\n          id=\"dropdownAddSymbolizer\" ngbDropdownToggle>\n          <span class=\"icon-plus\"></span>\n        </button>\n        <div ngbDropdownMenu aria-labelledby=\"dropdownAddSymbolizer\">\n          <button ngbDropdownItem (click)=\"addSymbolizer('Mark')\">Mark</button>\n          <button ngbDropdownItem (click)=\"addSymbolizer('Icon')\">Icon</button>\n          <button ngbDropdownItem (click)=\"addSymbolizer('Text')\">Text</button>\n          <button ngbDropdownItem (click)=\"addSymbolizer('Line')\">Line</button>\n          <button ngbDropdownItem (click)=\"addSymbolizer('Fill')\">Fill</button>\n        </div>\n      </div>\n    </div>\n  </div>\n  <ng-container *ngIf=\"rule.symbolizers.length > 0\">\n    <ul class=\"list-group hs-styler-content-list\" cdkDropList (cdkDropListDropped)=\"drop($event)\"\n      [cdkDropListData]=\"rule.symbolizers\">\n      <ng-container *ngFor=\"let symbolizer of rule.symbolizers\">\n        <hs-symbolizer-list-item cdkDrag [rule]=\"rule\" [app]=\"app\" [symbolizer]=\"symbolizer\" (changes)=\"emitChange()\">\n        </hs-symbolizer-list-item>\n      </ng-container>\n    </ul>\n  </ng-container>\n</div>\n", styles: [".cdk-drag-preview{box-sizing:content-box;border-radius:0;background-color:#b9b9b9bf;border:1px solid rgb(185,185,185);overflow:hidden;display:flex;align-items:center;color:#000;box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.cdk-drag-placeholder{opacity:0}.cdk-drag-animating{transition:transform 125ms cubic-bezier(0,0,.2,1)}.list-group.hs-styler-content-list.cdk-drop-list-dragging hs-rule-list-item:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}.list-group.hs-styler-content-list.cdk-drop-list-dragging hs-symbolizer-list-item:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}ul.hs-styler-content-list{margin-top:0;margin-bottom:0;border-bottom:1px solid white}li.list-group-item.hs-list-item-header{padding:.3em;width:100%;cursor:pointer;display:flex;justify-content:space-between;align-items:center;border-radius:0}li.list-group-item.hs-list-item-header .btn-danger{margin-right:1rem}li.list-group-item.hs-list-item-header span.glyphicon{font-size:x-small}li.list-group-item.hs-list-item-header:hover{background-color:#b9b9b9bf}\n"] }]
        }], ctorParameters: function () { return [{ type: HsStylerService }]; }, propDecorators: { rule: [{
                type: Input
            }], changes: [{
                type: Output
            }], menuRef: [{
                type: ViewChild,
                args: ['addSymMenu']
            }] } });

class HsRuleListItemComponent {
    constructor(hsStylerService) {
        this.hsStylerService = hsStylerService;
        this.app = 'default';
        this.ruleVisible = false;
    }
}
HsRuleListItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsRuleListItemComponent, deps: [{ token: HsStylerService }], target: i0.ɵɵFactoryTarget.Component });
HsRuleListItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsRuleListItemComponent, selector: "hs-rule-list-item", inputs: { rule: "rule", app: "app" }, ngImport: i0, template: "<li\n  class=\"list-group-item hs-list-item-header list-group-item-primary d-flex justify-content-between align-items-center mb-1\"\n  (click)=\"ruleVisible = !ruleVisible\">\n  <div>\n    <button type=\"button\" style=\"border: none; background-color: transparent; cursor: move\">\n      <i class=\"icon-move text-secondary\"></i>\n    </button>\n    <span>{{rule.name || 'untitled rule'}}&nbsp;</span>\n  </div>\n  <div>\n    <span class=\"glyphicon me-2\" [ngClass]=\"ruleVisible ? 'icon-chevron-right' : 'icon-chevron-down'\"></span>\n    <button class=\"btn btn-danger btn-sm me-0\" (click)=\"hsStylerService.removeRule(rule,app)\" data-toggle=\"tooltip\"\n      [title]=\"'STYLER.removeRule' | translateHs : {app} \">\n      <i class=\"icon-trash\"></i>\n    </button>\n  </div>\n</li>\n\n<ng-container *ngIf=\"ruleVisible\">\n  <hs-rule [rule]=\"rule\" (changes)=\"hsStylerService.save(app)\" [app]=\"app\" (mousedown)=\"$event.stopPropagation()\">\n  </hs-rule>\n</ng-container>\n", styles: [".cdk-drag-preview{box-sizing:content-box;border-radius:0;background-color:#b9b9b9bf;border:1px solid rgb(185,185,185);overflow:hidden;display:flex;align-items:center;color:#000;box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.cdk-drag-placeholder{opacity:0}.cdk-drag-animating{transition:transform 125ms cubic-bezier(0,0,.2,1)}.list-group.hs-styler-content-list.cdk-drop-list-dragging hs-rule-list-item:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}.list-group.hs-styler-content-list.cdk-drop-list-dragging hs-symbolizer-list-item:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}ul.hs-styler-content-list{margin-top:0;margin-bottom:0;border-bottom:1px solid white}li.list-group-item.hs-list-item-header{padding:.3em;width:100%;cursor:pointer;display:flex;justify-content:space-between;align-items:center;border-radius:0}li.list-group-item.hs-list-item-header .btn-danger{margin-right:1rem}li.list-group-item.hs-list-item-header span.glyphicon{font-size:x-small}li.list-group-item.hs-list-item-header:hover{background-color:#b9b9b9bf}\n"], components: [{ type: HsRuleComponent, selector: "hs-rule", inputs: ["rule"], outputs: ["changes"] }], directives: [{ type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsRuleListItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-rule-list-item', template: "<li\n  class=\"list-group-item hs-list-item-header list-group-item-primary d-flex justify-content-between align-items-center mb-1\"\n  (click)=\"ruleVisible = !ruleVisible\">\n  <div>\n    <button type=\"button\" style=\"border: none; background-color: transparent; cursor: move\">\n      <i class=\"icon-move text-secondary\"></i>\n    </button>\n    <span>{{rule.name || 'untitled rule'}}&nbsp;</span>\n  </div>\n  <div>\n    <span class=\"glyphicon me-2\" [ngClass]=\"ruleVisible ? 'icon-chevron-right' : 'icon-chevron-down'\"></span>\n    <button class=\"btn btn-danger btn-sm me-0\" (click)=\"hsStylerService.removeRule(rule,app)\" data-toggle=\"tooltip\"\n      [title]=\"'STYLER.removeRule' | translateHs : {app} \">\n      <i class=\"icon-trash\"></i>\n    </button>\n  </div>\n</li>\n\n<ng-container *ngIf=\"ruleVisible\">\n  <hs-rule [rule]=\"rule\" (changes)=\"hsStylerService.save(app)\" [app]=\"app\" (mousedown)=\"$event.stopPropagation()\">\n  </hs-rule>\n</ng-container>\n", styles: [".cdk-drag-preview{box-sizing:content-box;border-radius:0;background-color:#b9b9b9bf;border:1px solid rgb(185,185,185);overflow:hidden;display:flex;align-items:center;color:#000;box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.cdk-drag-placeholder{opacity:0}.cdk-drag-animating{transition:transform 125ms cubic-bezier(0,0,.2,1)}.list-group.hs-styler-content-list.cdk-drop-list-dragging hs-rule-list-item:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}.list-group.hs-styler-content-list.cdk-drop-list-dragging hs-symbolizer-list-item:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}ul.hs-styler-content-list{margin-top:0;margin-bottom:0;border-bottom:1px solid white}li.list-group-item.hs-list-item-header{padding:.3em;width:100%;cursor:pointer;display:flex;justify-content:space-between;align-items:center;border-radius:0}li.list-group-item.hs-list-item-header .btn-danger{margin-right:1rem}li.list-group-item.hs-list-item-header span.glyphicon{font-size:x-small}li.list-group-item.hs-list-item-header:hover{background-color:#b9b9b9bf}\n"] }]
        }], ctorParameters: function () { return [{ type: HsStylerService }]; }, propDecorators: { rule: [{
                type: Input
            }], app: [{
                type: Input
            }] } });

class HsStylerComponent extends HsPanelBaseComponent {
    constructor(hsStylerService, hsLayoutService, hsEventBusService, sanitizer, hsLayerUtilsService, hsUtilsService, hsSaveMapService) {
        super(hsLayoutService);
        this.hsStylerService = hsStylerService;
        this.hsLayoutService = hsLayoutService;
        this.hsEventBusService = hsEventBusService;
        this.sanitizer = sanitizer;
        this.hsLayerUtilsService = hsLayerUtilsService;
        this.hsUtilsService = hsUtilsService;
        this.hsSaveMapService = hsSaveMapService;
        this.ngUnsubscribe = new Subject();
        this.uploaderVisible = false;
        this.name = 'styler';
        this.colormaps = Object.keys(colorScales);
        this.hsEventBusService.layerSelectedFromUrl
            .pipe(takeUntil$1(this.ngUnsubscribe))
            .subscribe((layer) => {
            if (layer !== null && this.hsUtilsService.instOf(layer, VectorLayer)) {
                this.hsStylerService.fill(layer, this.data.app);
            }
        });
        this.hsEventBusService.mainPanelChanges
            .pipe(takeUntil$1(this.ngUnsubscribe))
            .subscribe(({ which, app }) => {
            if (which == 'styler' && app == this.data.app) {
                this.hsStylerService.fill(this.appRef.layer, this.data.app);
            }
        });
    }
    ngOnInit() {
        this.appRef = this.hsStylerService.get(this.data.app);
        this.hsStylerService.init(this.data.app);
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    layermanager() {
        this.hsLayoutService.setMainPanel('layermanager', this.data.app);
    }
    uploadSld() {
        this.uploaderVisible = !this.uploaderVisible;
    }
    clear() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.hsStylerService.reset(this.data.app);
        });
    }
    drop(event) {
        moveItemInArray(this.appRef.styleObject.rules, event.previousIndex, event.currentIndex);
    }
    handleFileUpload(evt) {
        const files = Array.from(evt.fileList);
        const promises = files.map((file) => {
            return new Promise((resolve) => {
                const reader = new FileReader();
                reader.onload = () => resolve(reader.result);
                reader.readAsText(file);
            });
        });
        Promise.all(promises).then((fileContents) => __awaiter(this, void 0, void 0, function* () {
            const sld = fileContents[0];
            yield this.hsStylerService.loadSld(sld, this.data.app);
        }));
    }
}
HsStylerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsStylerComponent, deps: [{ token: HsStylerService }, { token: HsLayoutService }, { token: HsEventBusService }, { token: i1$3.DomSanitizer }, { token: HsLayerUtilsService }, { token: HsUtilsService }, { token: HsSaveMapService }], target: i0.ɵɵFactoryTarget.Component });
HsStylerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsStylerComponent, selector: "hs-styles", usesInheritance: true, ngImport: i0, template: "<div class=\"card hs-main-panel\" [hidden]=\"(isVisible$ | async) === false\">\n  <div class=\"card-header d-flex align-items-center justify-content-between\">\n    <span class=\"panel-title\">\n      {{'LAYERMANAGER.layerEditor.styleLayer' | translateHs : {app: data.app} }}\n      {{appRef.layerTitle}}\n    </span>\n    <button type=\"button\" class=\"btn-close\" (click)=\"layermanager()\" [title]=\"'COMMON.close' | translateHs : data\"\n      attr.aria-label=\"{{'COMMON.close' | translateHs : {app: data.app} }}\">\n    </button>\n  </div>\n  <div class=\"card-body\">\n    <input class=\"form-control\" *ngIf=\"appRef.styleObject\" type=\"text\" placeholder=\"Style name\"\n      [(ngModel)]=\"appRef.styleObject.name\" />\n    <div class=\"d-flex flex-row justify-content-end\">\n      <div class=\"p-1 flex-grow-1\">{{'STYLER.rules' | translateHs : {app: data.app} }}:</div>\n      <div class=\"p-1\">\n        <div ngbDropdown class=\"d-inline-block\" display=\"dynamic\" placement=\"bottom-right\">\n          <button class=\"btn btn-outline-primary btn-sm\" [title]=\"'STYLER.addRule' | translateHs : data\"\n            id=\"dropdownAddRule\" ngbDropdownToggle>\n            <span class=\"icon-plus\"></span>\n          </button>\n          <div ngbDropdownMenu aria-labelledby=\"dropdownAddRule\">\n            <button ngbDropdownItem (click)=\"hsStylerService.addRule('Simple',data.app)\">\n              {{'STYLER.simpleRule' | translateHs : {app: data.app} }}\n            </button>\n            <button ngbDropdownItem (click)=\"hsStylerService.addRule('Cluster',data.app)\">\n              {{'STYLER.clusterRule' | translateHs : {app: data.app} }}\n            </button>\n            <button ngbDropdownItem (click)=\"appRef.colorMapDialogVisible = !appRef.colorMapDialogVisible\">\n              {{'STYLER.colorMap' | translateHs : {app: data.app} }}\n            </button>\n          </div>\n        </div>\n      </div>\n    </div>\n    <add-colormap [layer] = \"appRef.layer\" [data]=\"data\" (canceled)=\"appRef.colorMapDialogVisible = false\" *ngIf=\"appRef.colorMapDialogVisible\"></add-colormap>\n    <ng-container *ngIf=\"appRef.styleObject\">\n      <ul class=\"list-group hs-styler-content-list\" cdkDropList (cdkDropListDropped)=\"drop($event)\"\n        [cdkDropListData]=\"appRef.styleObject.rules\">\n        <ng-container *ngFor=\"let rule of appRef.styleObject.rules\">\n          <hs-rule-list-item cdkDrag [rule]=\"rule\" [app]=\"data.app\"></hs-rule-list-item>\n        </ng-container>\n      </ul>\n    </ng-container>\n  </div>\n  <div class=\"card-footer\">\n    <div class=\"form-group m-3\" *ngIf=\"uploaderVisible\">\n      <hs-file-upload (uploaded)=\"handleFileUpload($event)\" [app]=\"data.app\" uploader=\"hs-sld-upload\"\n        acceptedFormats=\".sld\">\n      </hs-file-upload>\n    </div>\n    <div class=\"btn-group\" role=\"group\" [attr.aria-label]=\"'STYLER.manageStyle' | translateHs : data\">\n      <a class=\"btn btn-secondary\" download=\"style.sld\" [hsDownload]=\"appRef.sld\" mimeType=\"text/plain\"\n        [href]=\"downloadData\" (downloadPrepared)=\"downloadData = $event\"\n        [title]=\"'STYLER.downloadSld' | translateHs : data\">\n        <i class=\"icon-download\"></i></a>\n\n      <button class=\"btn btn-secondary\" (click)=\"uploadSld()\" data-toggle=\"tooltip\"\n        [title]=\"'STYLER.uploadSld' | translateHs : data\">\n        <i class=\"icon-upload\"></i>\n      </button>\n      <button class=\"btn btn-danger\" (click)=\"clear()\" data-toggle=\"tooltip\"\n        [title]=\"'STYLER.clear' | translateHs : data\">\n        <i class=\"icon-trash\"></i>\n      </button>\n    </div>\n  </div>\n</div>\n", styles: [".cdk-drag-preview{box-sizing:content-box;border-radius:0;background-color:#b9b9b9bf;border:1px solid rgb(185,185,185);overflow:hidden;display:flex;align-items:center;color:#000;box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.cdk-drag-placeholder{opacity:0}.cdk-drag-animating{transition:transform 125ms cubic-bezier(0,0,.2,1)}.list-group.hs-styler-content-list.cdk-drop-list-dragging hs-rule-list-item:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}.list-group.hs-styler-content-list.cdk-drop-list-dragging hs-symbolizer-list-item:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}ul.hs-styler-content-list{margin-top:0;margin-bottom:0;border-bottom:1px solid white}li.list-group-item.hs-list-item-header{padding:.3em;width:100%;cursor:pointer;display:flex;justify-content:space-between;align-items:center;border-radius:0}li.list-group-item.hs-list-item-header .btn-danger{margin-right:1rem}li.list-group-item.hs-list-item-header span.glyphicon{font-size:x-small}li.list-group-item.hs-list-item-header:hover{background-color:#b9b9b9bf}\n"], components: [{ type: HsAddColormapComponent, selector: "add-colormap", inputs: ["layer", "data"], outputs: ["canceled"] }, { type: HsRuleListItemComponent, selector: "hs-rule-list-item", inputs: ["rule", "app"] }, { type: HsUploadComponent, selector: "hs-file-upload", inputs: ["acceptedFormats", "uploader", "app"], outputs: ["uploaded"] }], directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i7.NgbDropdown, selector: "[ngbDropdown]", inputs: ["autoClose", "dropdownClass", "open", "placement", "container", "display"], outputs: ["openChange"], exportAs: ["ngbDropdown"] }, { type: i7.NgbDropdownToggle, selector: "[ngbDropdownToggle]" }, { type: i7.NgbDropdownMenu, selector: "[ngbDropdownMenu]" }, { type: i7.NgbDropdownItem, selector: "[ngbDropdownItem]", inputs: ["disabled"] }, { type: i4.CdkDropList, selector: "[cdkDropList], cdk-drop-list", inputs: ["cdkDropListConnectedTo", "cdkDropListData", "cdkDropListOrientation", "id", "cdkDropListLockAxis", "cdkDropListDisabled", "cdkDropListSortingDisabled", "cdkDropListEnterPredicate", "cdkDropListSortPredicate", "cdkDropListAutoScrollDisabled", "cdkDropListAutoScrollStep"], outputs: ["cdkDropListDropped", "cdkDropListEntered", "cdkDropListExited", "cdkDropListSorted"], exportAs: ["cdkDropList"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i4.CdkDrag, selector: "[cdkDrag]", inputs: ["cdkDragData", "cdkDragLockAxis", "cdkDragRootElement", "cdkDragBoundary", "cdkDragStartDelay", "cdkDragFreeDragPosition", "cdkDragDisabled", "cdkDragConstrainPosition", "cdkDragPreviewClass", "cdkDragPreviewContainer"], outputs: ["cdkDragStarted", "cdkDragReleased", "cdkDragEnded", "cdkDragEntered", "cdkDragExited", "cdkDragDropped", "cdkDragMoved"], exportAs: ["cdkDrag"] }, { type: HsDownloadDirective, selector: "[hsDownload]", inputs: ["hsDownload", "mimeType"], outputs: ["downloadPrepared"] }], pipes: { "async": i3.AsyncPipe, "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsStylerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-styles', template: "<div class=\"card hs-main-panel\" [hidden]=\"(isVisible$ | async) === false\">\n  <div class=\"card-header d-flex align-items-center justify-content-between\">\n    <span class=\"panel-title\">\n      {{'LAYERMANAGER.layerEditor.styleLayer' | translateHs : {app: data.app} }}\n      {{appRef.layerTitle}}\n    </span>\n    <button type=\"button\" class=\"btn-close\" (click)=\"layermanager()\" [title]=\"'COMMON.close' | translateHs : data\"\n      attr.aria-label=\"{{'COMMON.close' | translateHs : {app: data.app} }}\">\n    </button>\n  </div>\n  <div class=\"card-body\">\n    <input class=\"form-control\" *ngIf=\"appRef.styleObject\" type=\"text\" placeholder=\"Style name\"\n      [(ngModel)]=\"appRef.styleObject.name\" />\n    <div class=\"d-flex flex-row justify-content-end\">\n      <div class=\"p-1 flex-grow-1\">{{'STYLER.rules' | translateHs : {app: data.app} }}:</div>\n      <div class=\"p-1\">\n        <div ngbDropdown class=\"d-inline-block\" display=\"dynamic\" placement=\"bottom-right\">\n          <button class=\"btn btn-outline-primary btn-sm\" [title]=\"'STYLER.addRule' | translateHs : data\"\n            id=\"dropdownAddRule\" ngbDropdownToggle>\n            <span class=\"icon-plus\"></span>\n          </button>\n          <div ngbDropdownMenu aria-labelledby=\"dropdownAddRule\">\n            <button ngbDropdownItem (click)=\"hsStylerService.addRule('Simple',data.app)\">\n              {{'STYLER.simpleRule' | translateHs : {app: data.app} }}\n            </button>\n            <button ngbDropdownItem (click)=\"hsStylerService.addRule('Cluster',data.app)\">\n              {{'STYLER.clusterRule' | translateHs : {app: data.app} }}\n            </button>\n            <button ngbDropdownItem (click)=\"appRef.colorMapDialogVisible = !appRef.colorMapDialogVisible\">\n              {{'STYLER.colorMap' | translateHs : {app: data.app} }}\n            </button>\n          </div>\n        </div>\n      </div>\n    </div>\n    <add-colormap [layer] = \"appRef.layer\" [data]=\"data\" (canceled)=\"appRef.colorMapDialogVisible = false\" *ngIf=\"appRef.colorMapDialogVisible\"></add-colormap>\n    <ng-container *ngIf=\"appRef.styleObject\">\n      <ul class=\"list-group hs-styler-content-list\" cdkDropList (cdkDropListDropped)=\"drop($event)\"\n        [cdkDropListData]=\"appRef.styleObject.rules\">\n        <ng-container *ngFor=\"let rule of appRef.styleObject.rules\">\n          <hs-rule-list-item cdkDrag [rule]=\"rule\" [app]=\"data.app\"></hs-rule-list-item>\n        </ng-container>\n      </ul>\n    </ng-container>\n  </div>\n  <div class=\"card-footer\">\n    <div class=\"form-group m-3\" *ngIf=\"uploaderVisible\">\n      <hs-file-upload (uploaded)=\"handleFileUpload($event)\" [app]=\"data.app\" uploader=\"hs-sld-upload\"\n        acceptedFormats=\".sld\">\n      </hs-file-upload>\n    </div>\n    <div class=\"btn-group\" role=\"group\" [attr.aria-label]=\"'STYLER.manageStyle' | translateHs : data\">\n      <a class=\"btn btn-secondary\" download=\"style.sld\" [hsDownload]=\"appRef.sld\" mimeType=\"text/plain\"\n        [href]=\"downloadData\" (downloadPrepared)=\"downloadData = $event\"\n        [title]=\"'STYLER.downloadSld' | translateHs : data\">\n        <i class=\"icon-download\"></i></a>\n\n      <button class=\"btn btn-secondary\" (click)=\"uploadSld()\" data-toggle=\"tooltip\"\n        [title]=\"'STYLER.uploadSld' | translateHs : data\">\n        <i class=\"icon-upload\"></i>\n      </button>\n      <button class=\"btn btn-danger\" (click)=\"clear()\" data-toggle=\"tooltip\"\n        [title]=\"'STYLER.clear' | translateHs : data\">\n        <i class=\"icon-trash\"></i>\n      </button>\n    </div>\n  </div>\n</div>\n", styles: [".cdk-drag-preview{box-sizing:content-box;border-radius:0;background-color:#b9b9b9bf;border:1px solid rgb(185,185,185);overflow:hidden;display:flex;align-items:center;color:#000;box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.cdk-drag-placeholder{opacity:0}.cdk-drag-animating{transition:transform 125ms cubic-bezier(0,0,.2,1)}.list-group.hs-styler-content-list.cdk-drop-list-dragging hs-rule-list-item:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}.list-group.hs-styler-content-list.cdk-drop-list-dragging hs-symbolizer-list-item:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}ul.hs-styler-content-list{margin-top:0;margin-bottom:0;border-bottom:1px solid white}li.list-group-item.hs-list-item-header{padding:.3em;width:100%;cursor:pointer;display:flex;justify-content:space-between;align-items:center;border-radius:0}li.list-group-item.hs-list-item-header .btn-danger{margin-right:1rem}li.list-group-item.hs-list-item-header span.glyphicon{font-size:x-small}li.list-group-item.hs-list-item-header:hover{background-color:#b9b9b9bf}\n"] }]
        }], ctorParameters: function () { return [{ type: HsStylerService }, { type: HsLayoutService }, { type: HsEventBusService }, { type: i1$3.DomSanitizer }, { type: HsLayerUtilsService }, { type: HsUtilsService }, { type: HsSaveMapService }]; } });

class HsToolbarPanelContainerService extends HsPanelContainerService {
    constructor() {
        super();
    }
}
HsToolbarPanelContainerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsToolbarPanelContainerService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
HsToolbarPanelContainerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsToolbarPanelContainerService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsToolbarPanelContainerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return []; } });

class HsToolbarComponent extends HsPanelBaseComponent {
    constructor(HsEventBusService, HsLayoutService, HsCoreService, HsToolbarPanelContainerService) {
        super(HsLayoutService);
        this.HsEventBusService = HsEventBusService;
        this.HsLayoutService = HsLayoutService;
        this.HsCoreService = HsCoreService;
        this.HsToolbarPanelContainerService = HsToolbarPanelContainerService;
        this.collapsed = false;
        this.mapResetsSubscription = this.HsEventBusService.mapResets.subscribe(({ app }) => {
            setTimeout(() => {
                if (this.data.app == app) {
                    delete this.composition_title;
                    delete this.composition_abstract;
                }
            });
        });
    }
    ngOnDestroy() {
        this.mapResetsSubscription.unsubscribe();
    }
    /**
     * Change/read collapsed setting
     *
     * @returns Collapsed state
     * @param is Value to set collapsed state to
     */
    isCollapsed(is) {
        if (arguments.length > 0) {
            this.collapsed = is;
        }
        return this.collapsed;
    }
    isVisible() {
        return (this.HsLayoutService.panelEnabled('toolbar', this.data.app) &&
            this.HsLayoutService.componentEnabled('toolbar', this.data.app) &&
            this.HsLayoutService.componentEnabled('guiOverlay', this.data.app));
    }
}
HsToolbarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsToolbarComponent, deps: [{ token: HsEventBusService }, { token: HsLayoutService }, { token: HsCoreService }, { token: HsToolbarPanelContainerService }], target: i0.ɵɵFactoryTarget.Component });
HsToolbarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsToolbarComponent, selector: "hs-toolbar", usesInheritance: true, ngImport: i0, template: "<div class=\"hs-toolbar\" [hidden]=\"(isVisible$ | async) === false\">\n    <nav class=\"navbar navbar-expand p-0\">\n        <hs-panel-container \n            class=\"navbar-nav\"\n            [service]=\"HsToolbarPanelContainerService\"\n            [app]=\"data.app\">\n        </hs-panel-container >\n    </nav>\n</div>\n", components: [{ type: HsPanelContainerComponent, selector: "hs-panel-container", inputs: ["service", "data", "app", "reusePanelObserver", "panelObserver"], outputs: ["init"] }], directives: [{ type: i7.NgbNavbar, selector: ".navbar" }], pipes: { "async": i3.AsyncPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsToolbarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-toolbar', template: "<div class=\"hs-toolbar\" [hidden]=\"(isVisible$ | async) === false\">\n    <nav class=\"navbar navbar-expand p-0\">\n        <hs-panel-container \n            class=\"navbar-nav\"\n            [service]=\"HsToolbarPanelContainerService\"\n            [app]=\"data.app\">\n        </hs-panel-container >\n    </nav>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: HsEventBusService }, { type: HsLayoutService }, { type: HsCoreService }, { type: HsToolbarPanelContainerService }]; } });

const WAYPOINT = 'wp';
function setWaypoint(feature, wp) {
    feature.set(WAYPOINT, wp);
}
function getWaypoint(feature) {
    return feature.get(WAYPOINT);
}
class HsTripPlannerData {
    constructor() {
        this.waypoints = [];
        this.trip = {};
        this.movable_features = new Collection$1();
        this.selectedLayerWrapper = {};
        this.modify = new Modify({
            features: this.movable_features,
        });
    }
}
class HsTripPlannerService {
    constructor(HsMapService, HsUtilsService, $http, HsShareUrlService, HsEventBusService, HsToastService, HsLanguageService, HsLayerUtilsService, HsLayoutService, hsConfig) {
        this.HsMapService = HsMapService;
        this.HsUtilsService = HsUtilsService;
        this.$http = $http;
        this.HsShareUrlService = HsShareUrlService;
        this.HsEventBusService = HsEventBusService;
        this.HsToastService = HsToastService;
        this.HsLanguageService = HsLanguageService;
        this.HsLayerUtilsService = HsLayerUtilsService;
        this.HsLayoutService = HsLayoutService;
        this.hsConfig = hsConfig;
        this.apps = {};
    }
    init(_app) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.apps[_app] == undefined) {
                this.apps[_app] = new HsTripPlannerData();
            }
            yield this.HsMapService.loaded(_app);
            const configRef = this.hsConfig.get(_app);
            (feature, resolution) => {
                return [
                    new Style({
                        fill: new Fill({
                            color: 'rgba(255, 255, 255, 0.6)',
                        }),
                        stroke: new Stroke({
                            color: '#337AB7',
                            width: 3,
                        }),
                        image: new Icon({
                            src: configRef.assetsPath + getHighlighted(feature)
                                ? 'img/pin_white_red32.png'
                                : 'img/pin_white_blue32.png',
                            crossOrigin: 'anonymous',
                            anchor: [0.5, 1],
                        }),
                        text: new Text({
                            font: '12px Calibri,sans-serif',
                            overflow: true,
                            fill: new Fill({
                                color: '#000',
                            }),
                            stroke: new Stroke({
                                color: '#fff',
                                width: 3,
                            }),
                            offsetY: -40,
                            text: this.getTextOnFeature(feature),
                        }),
                    }),
                ];
            };
            this.HsMapService.getMap(_app).addInteraction(this.apps[_app].modify);
            this.HsEventBusService.mapClicked.subscribe(({ coordinates, app }) => {
                if (app != _app) {
                    return;
                }
                if (this.HsLayoutService.get(app).mainpanel != 'tripPlanner') {
                    return;
                }
                if (!this.apps[app].waypointLayer) {
                    this.createWaypointLayer(app);
                }
                if (!this.apps[app].routeLayer) {
                    this.createRouteLayer(app);
                }
                //Don't add waypoints when drawing and measuring
                if (this.HsMapService.getMap(app)
                    .getInteractions()
                    .getArray()
                    .find((i) => i.getActive() && this.HsUtilsService.instOf(i, Draw))) {
                    return;
                }
                this.addWaypoint({
                    x: coordinates.mapProjCoordinate[0],
                    y: coordinates.mapProjCoordinate[1],
                    lon: coordinates.epsg4326Coordinate[0],
                    lat: coordinates.epsg4326Coordinate[1],
                    app,
                });
            });
        });
    }
    fillVectorLayers(app) {
        return __awaiter(this, void 0, void 0, function* () {
            this.HsMapService.loaded(app).then((map) => {
                this.apps[app].vectorLayers = [
                    {
                        layer: null,
                        title: 'newLayer',
                    },
                    ...this.HsMapService.getLayersArray(app)
                        .filter((layer) => this.HsLayerUtilsService.isLayerDrawable(layer))
                        .map((layer) => {
                        return { layer, title: getTitle(layer) };
                    }),
                ];
                this.fillDefaultLayerWrapper('route', app);
                this.fillDefaultLayerWrapper('waypoints', app);
            });
        });
    }
    fillDefaultLayerWrapper(usage, app) {
        if (this.apps[app].selectedLayerWrapper[usage]) {
            this.apps[app].selectedLayerWrapper[usage] = this.apps[app].vectorLayers.find((w) => w.layer == this.apps[app].selectedLayerWrapper[usage].layer);
        }
        else {
            this.apps[app].selectedLayerWrapper[usage] =
                this.apps[app].vectorLayers[0];
        }
    }
    createWaypointLayer(app) {
        this.apps[app].waypointSource = new VectorSource();
        this.apps[app].waypointLayer = new VectorLayer({
            source: this.apps[app].waypointSource,
            style: this.waypointRouteStyle,
        });
        setTitle(this.apps[app].waypointLayer, this.HsLanguageService.getTranslation('TRIP_PLANNER.waypoints', undefined, app));
        this.HsMapService.getMap(app).addLayer(this.apps[app].waypointLayer);
    }
    createRouteLayer(app) {
        this.apps[app].routeSource = new VectorSource();
        this.apps[app].routeLayer = new VectorLayer({
            source: this.apps[app].routeSource,
            style: this.waypointRouteStyle,
        });
        setTitle(this.apps[app].routeLayer, this.HsLanguageService.getTranslation('TRIP_PLANNER.travelRoute', undefined, app));
        this.HsMapService.getMap(app).addLayer(this.apps[app].routeLayer);
    }
    /**
     * Select layer for storing route or waypoint features
     * @param layer - Wrapper object which contains OL layer and its title
     * @param usage - route or waypoints
     */
    selectLayer(layer, usage, app) {
        return __awaiter(this, void 0, void 0, function* () {
            if (usage == 'route') {
                this.apps[app].routeLayer = layer.layer;
                if (this.apps[app].routeLayer) {
                    this.apps[app].routeSource = this.apps[app].routeLayer.getSource();
                }
                this.apps[app].selectedLayerWrapper.route = layer;
            }
            if (usage == 'waypoints') {
                this.apps[app].waypointLayer = layer.layer;
                if (this.apps[app].waypointLayer) {
                    this.apps[app].waypointSource =
                        this.apps[app].waypointLayer.getSource();
                }
                this.apps[app].routeSource.clear();
                this.apps[app].waypoints.length = 0;
                this.apps[app].selectedLayerWrapper.waypoints = layer;
                for (const feature of this.apps[app].waypointSource.getFeatures()) {
                    const new_cords = transform(feature.getGeometry().getCoordinates(), this.HsMapService.getCurrentProj(app).getCode(), 'EPSG:4326');
                    const wp = {
                        lon: new_cords[0],
                        lat: new_cords[1],
                        name: 'Waypoint ' + (this.apps[app].waypoints.length + 1),
                        hash: this.HsUtilsService.hashCode(JSON.stringify('Waypoint ' + this.apps[app].waypoints.length + Math.random())),
                        routes: { from: null, to: null },
                        featureId: feature.getId(),
                        loading: false,
                    };
                    this.apps[app].waypoints.push(wp);
                    if (this.waypointAdded !== undefined) {
                        this.waypointAdded(wp, app);
                    }
                    yield this.calculateRoutes(app);
                }
            }
        });
    }
    getTextOnFeature(feature) {
        var _a;
        let tmp = '';
        const wp = getWaypoint(feature);
        if (wp) {
            tmp = wp.name;
            if ((_a = wp === null || wp === void 0 ? void 0 : wp.routes) === null || _a === void 0 ? void 0 : _a.to) {
                tmp += ` (${this.formatDistance(wp, 'to')})`;
            }
        }
        return tmp;
    }
    /**
     * Add waypoint to waypoint list and recalculate route
     * @param {number} lon Longitude number (part of Ol.coordinate Array)
     * @param {number} lat Latitude number (part of Ol.coordinate Array)
     */
    addWaypoint({ x, y, lon, lat, app }) {
        const wp = {
            lon,
            lat,
            name: 'Waypoint ' + (this.apps[app].waypoints.length + 1),
            hash: this.HsUtilsService.hashCode(JSON.stringify('Waypoint ' + this.apps[app].waypoints.length + Math.random())),
            routes: { from: null, to: null },
            featureId: null,
            loading: false,
        };
        const feature = new Feature({
            'wp': wp,
            geometry: new Point([x, y]),
            id: this.HsUtilsService.generateUuid(),
        });
        feature.setId(feature.get('id'));
        wp.featureId = feature.getId();
        this.apps[app].waypointSource.addFeature(feature);
        this.apps[app].waypoints.push(wp);
        if (this.waypointAdded !== undefined) {
            this.waypointAdded(wp, app);
        }
        this.calculateRoutes(app);
    }
    /**
     * Handler of adding waypoint in connected service
     * @param wp - Waypoint object, with lat, lon and routes array
     */
    waypointAdded(wp, app) {
        const feature = this.apps[app].waypointSource.getFeatureById(wp.featureId);
        this.apps[app].movable_features.push(feature);
        feature.getGeometry().on('change', (e) => {
            this.removeRoutesForWaypoint(wp, app);
            const new_cords = transform(feature.getGeometry().getCoordinates(), this.HsMapService.getCurrentProj(app).getCode(), 'EPSG:4326');
            wp.lon = new_cords[0];
            wp.lat = new_cords[1];
            const prev_index = this.apps[app].waypoints.indexOf(wp) - 1;
            if (prev_index > -1) {
                this.apps[app].waypoints[prev_index].routes.from = null;
                this.routeRemoved(this.apps[app].waypoints[prev_index].routes.from, app);
            }
            if (this.apps[app].timer !== null) {
                clearTimeout(this.apps[app].timer);
            }
            this.apps[app].timer = setTimeout(() => {
                this.calculateRoutes(app);
            }, 500);
        });
    }
    /**
     * Remove selected route from source
     * @param feature - Route feature to remove
     */
    routeRemoved(feature, app) {
        try {
            if (feature) {
                this.apps[app].routeSource.removeFeature(feature);
            }
        }
        catch (ex) {
            throw ex;
        }
    }
    /**
     * (PRIVATE) Remove routes from selected waypoint
     * @param wp - Waypoint to remove routes
     */
    removeRoutesForWaypoint(wp, app) {
        this.routeRemoved(wp.routes.from, app);
        this.routeRemoved(wp.routes.to, app);
        wp.routes = { from: null, to: null };
    }
    /**
     * Remove selected waypoint from source
     * @param wp - Waypoint feature to remove
     */
    waypointRemoved(wp, app) {
        try {
            this.apps[app].waypointSource.removeFeature(this.apps[app].waypointSource.getFeatureById(wp.featureId));
        }
        catch (ex) {
            throw ex;
        }
    }
    /**
     * Remove selected waypoint from trip
     * @param {object} wp Waypoint object to remove
     */
    removeWaypoint(wp, app) {
        const wpIndex = this.apps[app].waypoints.indexOf(wp);
        const prev_index = wpIndex - 1;
        if (prev_index > -1) {
            this.apps[app].waypoints[prev_index].routes.from = null;
        }
        this.routeRemoved(wp.routes.from, app);
        this.routeRemoved(wp.routes.to, app);
        const next_index = wpIndex + 1;
        if (next_index < this.apps[app].waypoints.length) {
            this.apps[app].waypoints[next_index].routes.to = null;
        }
        this.waypointRemoved(wp, app);
        this.apps[app].waypoints.splice(this.apps[app].waypoints.indexOf(wp), 1);
        this.calculateRoutes(app);
    }
    /**
     * Clear all waypoints from service and layer
     */
    clearAll(app) {
        this.apps[app].waypoints = [];
        this.apps[app].waypointSource.clear();
        this.apps[app].routeSource.clear();
    }
    /**
     * Handler of adding computed route to layer
     * @param feature - Route to add
     */
    routeAdded(features, app) {
        this.apps[app].routeSource.addFeatures(features);
    }
    /**
     * Calculate routes between stored waypoints
     */
    calculateRoutes(app) {
        return __awaiter(this, void 0, void 0, function* () {
            for (let i = 0; i < this.apps[app].waypoints.length - 1; i++) {
                const wpf = this.apps[app].waypoints[i];
                if (wpf.routes.from === null) {
                    const wpt = this.apps[app].waypoints[i + 1];
                    wpt.loading = true;
                    const url = this.HsUtilsService.proxify('https://api.openrouteservice.org/v2/directions/driving-car/geojson', app);
                    const response = yield lastValueFrom(this.$http
                        .post(url, {
                        'coordinates': [
                            [wpf.lon, wpf.lat],
                            [wpt.lon, wpt.lat],
                        ],
                    })
                        .pipe(timeout(10000), catchError((e) => {
                        let title = this.HsLanguageService.getTranslation('TRIP_PLANNER.serviceDown', undefined, app);
                        if (e.status == 404) {
                            title = this.HsLanguageService.getTranslation('TRIP_PLANNER.missingAuth', undefined, app);
                        }
                        this.HsToastService.createToastPopupMessage(title, this.HsLanguageService.getTranslationIgnoreNonExisting('ERRORMESSAGES', e.message, { url }, app), {
                            disableLocalization: true,
                            serviceCalledFrom: 'HsTripPlannerService',
                        }, app);
                        return of(null);
                    })));
                    if (!response) {
                        return;
                    }
                    wpt.loading = false;
                    const format = new GeoJSON();
                    const features = format.readFeatures(response);
                    features[0]
                        .getGeometry()
                        .transform('EPSG:4326', this.HsMapService.getCurrentProj(app));
                    wpf.routes.from = features[0];
                    wpt.routes.to = features[0];
                    if (this.routeAdded !== undefined) {
                        this.routeAdded(features, app);
                    }
                }
            }
        });
    }
    /**
     * Format waypoint route distance in a human friendly way
     * @param wp - Wayoint
     * @param which
     * @returns Distance
     */
    formatDistance(wp, which) {
        which = which !== undefined ? which : 'from';
        if (wp.routes[which]) {
            const route = wp.routes[which];
            const distance = (route === null || route === void 0 ? void 0 : route.get('summary').distance) / 1000.0;
            if (distance == undefined) {
                return '';
            }
            else {
                return distance.toFixed(2) + 'km';
            }
        }
    }
}
HsTripPlannerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsTripPlannerService, deps: [{ token: HsMapService }, { token: HsUtilsService }, { token: i1.HttpClient }, { token: HsShareUrlService }, { token: HsEventBusService }, { token: HsToastService }, { token: HsLanguageService }, { token: HsLayerUtilsService }, { token: HsLayoutService }, { token: HsConfig }], target: i0.ɵɵFactoryTarget.Injectable });
HsTripPlannerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsTripPlannerService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsTripPlannerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsMapService }, { type: HsUtilsService }, { type: i1.HttpClient }, { type: HsShareUrlService }, { type: HsEventBusService }, { type: HsToastService }, { type: HsLanguageService }, { type: HsLayerUtilsService }, { type: HsLayoutService }, { type: HsConfig }]; } });

class HsTripPlannerLayerSelectorComponent {
    constructor(HsTripPlannerService, HsLayerUtilsService) {
        this.HsTripPlannerService = HsTripPlannerService;
        this.HsLayerUtilsService = HsLayerUtilsService;
        this.app = 'default';
    }
}
HsTripPlannerLayerSelectorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsTripPlannerLayerSelectorComponent, deps: [{ token: HsTripPlannerService }, { token: HsLayerUtilsService }], target: i0.ɵɵFactoryTarget.Component });
HsTripPlannerLayerSelectorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsTripPlannerLayerSelectorComponent, selector: "hs-trip-planner-layer-selector", inputs: { label: "label", app: "app", usage: "usage", selectedwrapper: "selectedwrapper" }, ngImport: i0, template: "<div\n  class=\"flex-row w-100 m-auto justify-content-center align-items-center\"\n  style=\"display: flex\"\n>\n  <p class=\"m-0 p-0 flex-fill text-primary\">{{label}}:</p>\n  <div ngbDropdown placement=\"bottom\" style=\"max-width: 50%\">\n    <button\n      type=\"button\"\n      ngbDropdownToggle\n      class=\"\n        btn btn-sm\n        rounded-0\n        hs-toolbar-button\n        d-flex\n        align-items-center\n        mw-100\n      \"\n      aria-haspopup=\"true\"\n      (click)=\"layersExpanded = !layersExpanded; HsTripPlannerService.fillVectorLayers(app) \"\n      [attr.aria-expanded]=\"layersExpanded\"\n    >\n      <div class=\"text-truncate\" *ngIf=\"selectedwrapper !== undefined\">\n        {{selectedwrapper.title | translateHs : {app, module: 'LAYERS'} }}\n      </div>\n    </button>\n    <div\n      ngbDropdownMenu\n      [ngClass]=\"{'show': layersExpanded}\"\n      style=\"transform: translateX(25%); width: 15em\"\n    >\n      <div class=\"d-flex align-items-center w-100 flex-column\">\n        <a\n          class=\"dropdown-item text-truncate\"\n          *ngFor=\"let layer of HsTripPlannerService.apps[app].vectorLayers\"\n          data-toggle=\"tooltip\"\n          title=\"{{layer.title | translateHs : {app, module: 'LAYERS'} }}\"\n          (click)=\"HsTripPlannerService.selectLayer(layer, usage, app); layersExpanded = false\"\n          >{{layer.title | translateHs : {app, module: 'LAYERS'} }}</a\n        >\n      </div>\n    </div>\n  </div>\n</div>\n", directives: [{ type: i7.NgbDropdown, selector: "[ngbDropdown]", inputs: ["autoClose", "dropdownClass", "open", "placement", "container", "display"], outputs: ["openChange"], exportAs: ["ngbDropdown"] }, { type: i7.NgbDropdownToggle, selector: "[ngbDropdownToggle]" }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i7.NgbDropdownMenu, selector: "[ngbDropdownMenu]" }, { type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsTripPlannerLayerSelectorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-trip-planner-layer-selector', template: "<div\n  class=\"flex-row w-100 m-auto justify-content-center align-items-center\"\n  style=\"display: flex\"\n>\n  <p class=\"m-0 p-0 flex-fill text-primary\">{{label}}:</p>\n  <div ngbDropdown placement=\"bottom\" style=\"max-width: 50%\">\n    <button\n      type=\"button\"\n      ngbDropdownToggle\n      class=\"\n        btn btn-sm\n        rounded-0\n        hs-toolbar-button\n        d-flex\n        align-items-center\n        mw-100\n      \"\n      aria-haspopup=\"true\"\n      (click)=\"layersExpanded = !layersExpanded; HsTripPlannerService.fillVectorLayers(app) \"\n      [attr.aria-expanded]=\"layersExpanded\"\n    >\n      <div class=\"text-truncate\" *ngIf=\"selectedwrapper !== undefined\">\n        {{selectedwrapper.title | translateHs : {app, module: 'LAYERS'} }}\n      </div>\n    </button>\n    <div\n      ngbDropdownMenu\n      [ngClass]=\"{'show': layersExpanded}\"\n      style=\"transform: translateX(25%); width: 15em\"\n    >\n      <div class=\"d-flex align-items-center w-100 flex-column\">\n        <a\n          class=\"dropdown-item text-truncate\"\n          *ngFor=\"let layer of HsTripPlannerService.apps[app].vectorLayers\"\n          data-toggle=\"tooltip\"\n          title=\"{{layer.title | translateHs : {app, module: 'LAYERS'} }}\"\n          (click)=\"HsTripPlannerService.selectLayer(layer, usage, app); layersExpanded = false\"\n          >{{layer.title | translateHs : {app, module: 'LAYERS'} }}</a\n        >\n      </div>\n    </div>\n  </div>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: HsTripPlannerService }, { type: HsLayerUtilsService }]; }, propDecorators: { label: [{
                type: Input
            }], app: [{
                type: Input
            }], usage: [{
                type: Input
            }], selectedwrapper: [{
                type: Input
            }] } });

class HsTripPlannerComponent extends HsPanelBaseComponent {
    constructor(HsMapService, HsCoreService, HsTripPlannerService, HsConfig, hsLayoutService, HsUtilsService, HsLayerUtilsService, hsLanguageService, hsSidebarService) {
        super(hsLayoutService);
        this.HsMapService = HsMapService;
        this.HsCoreService = HsCoreService;
        this.HsTripPlannerService = HsTripPlannerService;
        this.HsConfig = HsConfig;
        this.HsUtilsService = HsUtilsService;
        this.HsLayerUtilsService = HsLayerUtilsService;
        this.hsLanguageService = hsLanguageService;
        this.hsSidebarService = hsSidebarService;
        this.name = 'tripPlanner';
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.hsSidebarService.addButton({
                panel: 'tripPlanner',
                module: 'hs-trip-planner',
                order: 17,
                fits: true,
                title: 'PANEL_HEADER.TRIP_PLANNER',
                description: 'SIDEBAR.descriptions.TRIP_PLANNER',
                icon: 'icon-sextant',
            }, this.data.app);
            yield this.HsTripPlannerService.init(this.data.app);
            this.configRef = this.HsConfig.apps[this.data.app];
            if (this.configRef.default_layers === undefined) {
                this.configRef.default_layers = [];
            }
            else {
                this.configRef.default_layers.push(this.HsTripPlannerService.apps[this.data.app].routeLayer);
            }
            this.HsTripPlannerService.fillVectorLayers(this.data.app);
        });
    }
    /**
     * Format waypoint route distance in a human friendly way
     * @param {float} wp Wayoint
     * @returns {string} Distance
     */
    formatDistance(wp) {
        return this.HsTripPlannerService.formatDistance(wp);
    }
    /**
     * Get the total distance for all waypoint routes
     * @returns {string} Distance
     */
    totalDistance() {
        let tmp = 0;
        this.HsTripPlannerService.apps[this.data.app].waypoints.forEach((wp) => {
            if (wp.routes.from) {
                tmp += wp.routes.from.get('summary').distance / 1000.0;
            }
        });
        return tmp.toFixed(2) + 'km';
    }
    /**
     * Remove selected waypoint from source
     * @param {object} waypoint
     */
    toggleEdit(waypoint) {
        waypoint.editMode = !waypoint.editMode;
        const src = this.HsTripPlannerService.apps[this.data.app].waypointLayer.getSource();
        setHighlighted(src.getFeatureById(waypoint.featureId), waypoint.editMode);
    }
}
HsTripPlannerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsTripPlannerComponent, deps: [{ token: HsMapService }, { token: HsCoreService }, { token: HsTripPlannerService }, { token: HsConfig }, { token: HsLayoutService }, { token: HsUtilsService }, { token: HsLayerUtilsService }, { token: HsLanguageService }, { token: HsSidebarService }], target: i0.ɵɵFactoryTarget.Component });
HsTripPlannerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HsTripPlannerComponent, selector: "hs-trip-planner", usesInheritance: true, ngImport: i0, template: "<div class=\"card hs-main-panel\" [hidden]=\"(isVisible$ | async) === false\">\n  <hs-panel-header name=\"tripPlaner\" [title]=\"'PANEL_HEADER.TRIP_PLANNER' | translateHs : data\" [app]=\"data.app\">\n  </hs-panel-header>\n  <div class=\"card-body\">\n    <hs-trip-planner-layer-selector usage=\"route\" [app]=\"data.app\"\n      label=\"{{'TRIP_PLANNER.routerLayer' | translateHs : {app: data.app} }}\"\n      [selectedwrapper]=\"HsTripPlannerService.apps[data.app].selectedLayerWrapper.route\">\n    </hs-trip-planner-layer-selector>\n    <hs-trip-planner-layer-selector usage=\"waypoints\" [app]=\"data.app\"\n      label=\"{{'TRIP_PLANNER.waypointLayer' | translateHs : {app: data.app} }}\"\n      [selectedwrapper]=\"HsTripPlannerService.apps[data.app].selectedLayerWrapper.waypoints\">\n    </hs-trip-planner-layer-selector>\n\n    <div *ngFor=\"let waypoint of HsTripPlannerService.apps[data.app].waypoints\" class=\"d-flex flex-row\">\n      <div class=\"p-1 flex-grow-1\">\n        <a (click)=\"toggleEdit(waypoint)\" [hidden]=\"!!waypoint.editMode\">{{waypoint.name}}</a>\n        <input [(ngModel)]=\"waypoint.name\" class=\"form-control hs-waypoint-name\" [ngModelOptions]=\"{standalone: true}\"\n          [hidden]=\"!waypoint.editMode\" (blur)=\"toggleEdit(waypoint)\" />\n      </div>\n      <div class=\"p-1\">\n        <img [hidden]=\"!waypoint.loading\" [src]=\"configRef._ajaxLoaderPath\" />\n      </div>\n      <div class=\"p-1\" style=\"height: 1.7em\">\n        <div style=\"margin-top: 1em\">{{ formatDistance(waypoint) }}<!-- TODO: Remove function call from template --></div>\n      </div>\n      <div class=\"p-1\">\n        <a class=\"p-1\" (click)=\"HsTripPlannerService.removeWaypoint(waypoint, data.app)\" data-toggle=\"tooltip\"\n          [title]=\"'TRIP_PLANNER.removeWaypoint' | translateHs : data\">\n          <i class=\"icon-remove-circle\" style=\"color: rgb(228, 99, 99)\"></i>\n        </a>\n      </div>\n    </div>\n    <div class=\"alert alert-primary\" role=\"alert\" *ngIf=\"HsTripPlannerService.apps[data.app].waypoints.length===0\">\n      {{'TRIP_PLANNER.waypointDrawingHint' | translateHs : {app: data.app} }}\n    </div>\n    <br />\n    <a (click)=\"HsTripPlannerService.clearAll(data.app)\">{{'TRIP_PLANNER.clearWaypoints' | translateHs : {app: data.app} }}</a>\n    <br />\n    <div class=\"d-flex flex-row\">\n      <div class=\"p-1 flex-grow-1\">\n        <strong>{{'TRIP_PLANNER.totalDistance' | translateHs : {app: data.app} }}:</strong>\n      </div>\n      <div class=\"p-1\">{{totalDistance()}}</div>\n    </div>\n  </div>\n</div>", components: [{ type: HsPanelHeaderComponent, selector: "hs-panel-header", inputs: ["name", "app", "title"] }, { type: HsTripPlannerLayerSelectorComponent, selector: "hs-trip-planner-layer-selector", inputs: ["label", "app", "usage", "selectedwrapper"] }], directives: [{ type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "async": i3.AsyncPipe, "translateHs": TranslateCustomPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsTripPlannerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hs-trip-planner', template: "<div class=\"card hs-main-panel\" [hidden]=\"(isVisible$ | async) === false\">\n  <hs-panel-header name=\"tripPlaner\" [title]=\"'PANEL_HEADER.TRIP_PLANNER' | translateHs : data\" [app]=\"data.app\">\n  </hs-panel-header>\n  <div class=\"card-body\">\n    <hs-trip-planner-layer-selector usage=\"route\" [app]=\"data.app\"\n      label=\"{{'TRIP_PLANNER.routerLayer' | translateHs : {app: data.app} }}\"\n      [selectedwrapper]=\"HsTripPlannerService.apps[data.app].selectedLayerWrapper.route\">\n    </hs-trip-planner-layer-selector>\n    <hs-trip-planner-layer-selector usage=\"waypoints\" [app]=\"data.app\"\n      label=\"{{'TRIP_PLANNER.waypointLayer' | translateHs : {app: data.app} }}\"\n      [selectedwrapper]=\"HsTripPlannerService.apps[data.app].selectedLayerWrapper.waypoints\">\n    </hs-trip-planner-layer-selector>\n\n    <div *ngFor=\"let waypoint of HsTripPlannerService.apps[data.app].waypoints\" class=\"d-flex flex-row\">\n      <div class=\"p-1 flex-grow-1\">\n        <a (click)=\"toggleEdit(waypoint)\" [hidden]=\"!!waypoint.editMode\">{{waypoint.name}}</a>\n        <input [(ngModel)]=\"waypoint.name\" class=\"form-control hs-waypoint-name\" [ngModelOptions]=\"{standalone: true}\"\n          [hidden]=\"!waypoint.editMode\" (blur)=\"toggleEdit(waypoint)\" />\n      </div>\n      <div class=\"p-1\">\n        <img [hidden]=\"!waypoint.loading\" [src]=\"configRef._ajaxLoaderPath\" />\n      </div>\n      <div class=\"p-1\" style=\"height: 1.7em\">\n        <div style=\"margin-top: 1em\">{{ formatDistance(waypoint) }}<!-- TODO: Remove function call from template --></div>\n      </div>\n      <div class=\"p-1\">\n        <a class=\"p-1\" (click)=\"HsTripPlannerService.removeWaypoint(waypoint, data.app)\" data-toggle=\"tooltip\"\n          [title]=\"'TRIP_PLANNER.removeWaypoint' | translateHs : data\">\n          <i class=\"icon-remove-circle\" style=\"color: rgb(228, 99, 99)\"></i>\n        </a>\n      </div>\n    </div>\n    <div class=\"alert alert-primary\" role=\"alert\" *ngIf=\"HsTripPlannerService.apps[data.app].waypoints.length===0\">\n      {{'TRIP_PLANNER.waypointDrawingHint' | translateHs : {app: data.app} }}\n    </div>\n    <br />\n    <a (click)=\"HsTripPlannerService.clearAll(data.app)\">{{'TRIP_PLANNER.clearWaypoints' | translateHs : {app: data.app} }}</a>\n    <br />\n    <div class=\"d-flex flex-row\">\n      <div class=\"p-1 flex-grow-1\">\n        <strong>{{'TRIP_PLANNER.totalDistance' | translateHs : {app: data.app} }}:</strong>\n      </div>\n      <div class=\"p-1\">{{totalDistance()}}</div>\n    </div>\n  </div>\n</div>" }]
        }], ctorParameters: function () { return [{ type: HsMapService }, { type: HsCoreService }, { type: HsTripPlannerService }, { type: HsConfig }, { type: HsLayoutService }, { type: HsUtilsService }, { type: HsLayerUtilsService }, { type: HsLanguageService }, { type: HsSidebarService }]; } });

class HsQueryPopupData {
    constructor() {
        this.featuresUnderMouse = [];
        this.featureLayersUnderMouse = [];
    }
}

class HsQueryPopupBaseService {
    constructor(hsMapService, hsUtilsService, zone, hsQueryPopupWidgetContainerService) {
        this.hsMapService = hsMapService;
        this.hsUtilsService = hsUtilsService;
        this.zone = zone;
        this.hsQueryPopupWidgetContainerService = hsQueryPopupWidgetContainerService;
        this.apps = {};
    }
    /**
     * Set up query popup base service data for the app if needed
     * @param app - App identifier
     */
    setAppIfNeeded(app) {
        if (this.apps[app] == undefined) {
            this.apps[app] = new HsQueryPopupData();
        }
    }
    /**
     * Fill features for the popup
     * @param features - Features found on the map under the mouse
     * @param app - App identifier
     */
    fillFeatures(features, app) {
        //Zone is needed for performance reasons. Otherwise the popups dont get hidden soon enough
        this.zone.run(() => {
            this.apps[app].featuresUnderMouse = features;
            if (this.apps[app].featuresUnderMouse.length) {
                const layersFound = this.hsUtilsService.removeDuplicates(this.apps[app].featuresUnderMouse.map((f) => this.hsMapService.getLayerForFeature(f, app)), 'title');
                this.apps[app].featureLayersUnderMouse = layersFound
                    .filter((l) => getPopUp(l)) //Only list the layers which have popUp defined
                    .map((l) => {
                    var _a, _b;
                    const needSpecialWidgets = ((_a = getPopUp(l)) === null || _a === void 0 ? void 0 : _a.widgets) || ((_b = getPopUp(l)) === null || _b === void 0 ? void 0 : _b.displayFunction);
                    const layer = {
                        title: getTitle(l),
                        layer: l,
                        features: this.apps[app].featuresUnderMouse.filter((f) => this.hsMapService.getLayerForFeature(f, app) == l),
                        panelObserver: needSpecialWidgets
                            ? new ReplaySubject()
                            : undefined,
                    };
                    return layer;
                });
                for (const layer of this.apps[app].featureLayersUnderMouse) {
                    if (layer.panelObserver) {
                        const popupDef = getPopUp(layer.layer);
                        let widgets = popupDef === null || popupDef === void 0 ? void 0 : popupDef.widgets;
                        if (popupDef === null || popupDef === void 0 ? void 0 : popupDef.displayFunction) {
                            widgets = ['dynamic-text'];
                        }
                        this.hsQueryPopupWidgetContainerService.initWidgets(widgets, app, layer.panelObserver);
                    }
                }
            }
            else {
                this.apps[app].featuresUnderMouse = [];
            }
        });
    }
    /**
     * Close the popup
     * @param app - App identifier
     */
    closePopup(app) {
        this.apps[app].featuresUnderMouse = [];
    }
    /**
     * Get feature attributes in an array, where each attribute is represented as {key, value, displayFunction}.
     * @param feature - Feature selected
     * @param app - App identifier
     * @returns Serialized attributes
     */
    serializeFeatureAttributes(feature, app) {
        var _a;
        const attributesForHover = [];
        const layer = this.hsMapService.getLayerForFeature(feature, app);
        if (layer === undefined) {
            return;
        }
        let attrsConfig = [];
        if ((_a = getPopUp(layer)) === null || _a === void 0 ? void 0 : _a.attributes) {
            //must be an array
            attrsConfig = getPopUp(layer).attributes;
        }
        else {
            // Layer is not configured to show pop-ups
            return;
        }
        if (attrsConfig.length == 1 && attrsConfig[0] == '*') {
            attrsConfig = Object.keys(feature.getProperties()).filter((attr) => attr != 'geometry');
            attrsConfig.sort((a, b) => (a < b ? -1 : 1));
        }
        for (const attr of attrsConfig) {
            let attrName, attrLabel;
            let attrFunction = (x) => x;
            if (typeof attr === 'string' || attr instanceof String) {
                //simple case when only attribute name is provided in the layer config
                attrName = attr;
                attrLabel = attr;
            }
            else {
                if (attr.attribute == undefined) {
                    //implies malformed layer config - 'attribute' is obligatory in this case
                    continue;
                }
                attrName = attr.attribute;
                attrLabel = attr.label != undefined ? attr.label : attr.attribute;
                if (attr.displayFunction) {
                    attrFunction = attr.displayFunction;
                }
            }
            if (feature.get(attrName)) {
                attributesForHover.push({
                    key: attrLabel,
                    value: feature.get(attrName),
                    displayFunction: attrFunction,
                });
            }
        }
        return attributesForHover;
    }
}
HsQueryPopupBaseService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsQueryPopupBaseService, deps: [{ token: HsMapService }, { token: HsUtilsService }, { token: i0.NgZone }, { token: HsQueryPopupWidgetContainerService }], target: i0.ɵɵFactoryTarget.Injectable });
HsQueryPopupBaseService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsQueryPopupBaseService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsQueryPopupBaseService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsMapService }, { type: HsUtilsService }, { type: i0.NgZone }, { type: HsQueryPopupWidgetContainerService }]; } });

class HsQueryPopupService extends HsQueryPopupBaseService {
    constructor(hsMapService, hsConfig, hsUtilsService, zone, HsQueryBaseService, hsQueryPopupWidgetContainerService) {
        super(hsMapService, hsUtilsService, zone, hsQueryPopupWidgetContainerService);
        this.hsMapService = hsMapService;
        this.hsConfig = hsConfig;
        this.hsUtilsService = hsUtilsService;
        this.zone = zone;
        this.HsQueryBaseService = HsQueryBaseService;
        this.hsQueryPopupWidgetContainerService = hsQueryPopupWidgetContainerService;
    }
    /**
     * Register and set hover popup overlay
     * @param nativeElement - Popup HTML content
     * @param app - App identifier
     */
    registerPopup(nativeElement, app) {
        this.setAppIfNeeded(app);
        this.apps[app].hoverPopup = new Overlay({
            element: nativeElement,
        });
    }
    /**
     * Initialize the query popup service data and subscribers
     * @param app - App identifier
     */
    init(app) {
        return __awaiter(this, void 0, void 0, function* () {
            this.setAppIfNeeded(app);
            yield this.hsMapService.loaded(app);
            this.apps[app].map = this.hsMapService.getMap(app);
            if (this.hsConfig.get(app).popUpDisplay &&
                this.hsConfig.get(app).popUpDisplay === 'hover') {
                this.apps[app].map.on('pointermove', this.hsUtilsService.debounce((e) => this.preparePopup(e, app), 200, false, this));
            }
            else if (this.hsConfig.get(app).popUpDisplay &&
                this.hsConfig.get(app).popUpDisplay === 'click') {
                this.apps[app].map.on('singleclick', this.hsUtilsService.debounce((e) => this.preparePopup(e, app), 200, false, this));
            } /* else none */
        });
    }
    /**
     * Prepare popup before the display
     * Get features dependent on mouse position.
     * For cesium the features will be filled differently.
     * @param e - Mouse event over the OL map
     * @param app - App identifier
     */
    preparePopup(e, app) {
        var _a, _b;
        // The latter case happens when hovering over the pop-up itself
        if (e.dragging || ((_b = (_a = e.originalEvent) === null || _a === void 0 ? void 0 : _a.target) === null || _b === void 0 ? void 0 : _b.tagName) != 'CANVAS') {
            return;
        }
        if (!this.HsQueryBaseService.get(app).queryActive &&
            this.hsConfig.get(app).popUpDisplay === 'click') {
            return;
        }
        const tmpFeatures = this.HsQueryBaseService.getFeaturesUnderMouse(e.map, e.pixel, app);
        if (tmpFeatures.some((f) => !this.apps[app].featuresUnderMouse.includes(f)) ||
            this.apps[app].featuresUnderMouse.some((f) => !tmpFeatures.includes(f))) {
            this.fillFeatures(tmpFeatures, app);
        }
        this.showPopup(e, app);
    }
    /**
     * Set popups position according to pixel where mouse is
     * @param e - Event, which triggered this function
     * @param app - App identifier
     */
    showPopup(e, app) {
        const map = e.map;
        const pixel = e.pixel;
        pixel[0] += 2;
        pixel[1] += 4;
        if (this.apps[app].hoverPopup) {
            this.apps[app].hoverPopup.setPosition(map.getCoordinateFromPixel(e.pixel));
        }
    }
}
HsQueryPopupService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsQueryPopupService, deps: [{ token: HsMapService }, { token: HsConfig }, { token: HsUtilsService }, { token: i0.NgZone }, { token: HsQueryBaseService }, { token: HsQueryPopupWidgetContainerService }], target: i0.ɵɵFactoryTarget.Injectable });
HsQueryPopupService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsQueryPopupService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsQueryPopupService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsMapService }, { type: HsConfig }, { type: HsUtilsService }, { type: i0.NgZone }, { type: HsQueryBaseService }, { type: HsQueryPopupWidgetContainerService }]; } });

class HsExternalService {
    constructor(hsMapService, hsUtilsService, hsLayerUtilsService, hsQueryPopupService) {
        this.hsMapService = hsMapService;
        this.hsUtilsService = hsUtilsService;
        this.hsLayerUtilsService = hsLayerUtilsService;
        this.hsQueryPopupService = hsQueryPopupService;
        this.featureLinks = {};
    }
    init(app) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.hsMapService.loaded(app);
            const map = this.hsMapService.getMap(app);
            for (const layer of map.getLayers().getArray()) {
                this.layerAdded(layer, app);
            }
            map.getLayers().on('add', (e) => this.layerAdded(e.element, app));
            map.getLayers().on('remove', (e) => this.layerRemoved(e.element));
        });
    }
    layerRemoved(layer) {
        if (this.hsLayerUtilsService.isLayerVectorLayer(layer)) {
            for (const key of Object.keys(this.featureLinks)) {
                const link = this.featureLinks[key];
                if (link.layer == layer) {
                    this.removeFeatureLink(link);
                    delete this.featureLinks[key];
                }
            }
        }
    }
    layerAdded(layer, app) {
        if (this.hsLayerUtilsService.isLayerVectorLayer(layer)) {
            if (getDomFeatureLinks(layer)) {
                this.processLinks(layer, app);
            }
            layer.on('propertychange', (e) => {
                this.hsUtilsService.debounce(this.layerPropChanged(e, app), 100, false, this);
            });
        }
    }
    layerPropChanged(e, app) {
        if (e.key == DOM_FEATURE_LINKS) {
            this.processLinks(e.target, app);
        }
    }
    processLinks(layer, app) {
        const source = this.hsLayerUtilsService.isLayerClustered(layer)
            ? layer.getSource().getSource()
            : layer.getSource();
        for (const link of getDomFeatureLinks(layer)) {
            const domElements = document.querySelectorAll(link.domSelector);
            domElements.forEach((domElement) => {
                const feature = this.getFeature(layer, source, link, domElement);
                if (feature.getId() === undefined) {
                    feature.setId(this.hsUtilsService.generateUuid());
                }
                //We dont want to add handlers with the same feature and domElement twice
                if (feature &&
                    (!this.featureLinks[feature.getId()] ||
                        !this.featureLinks[feature.getId()].domElements.includes(domElement))) {
                    const featureId = feature.getId();
                    //This was the only way how to unregister handlers afterwards
                    const handler = (e) => {
                        for (const action of link.actions) {
                            this.actOnFeature(action, feature, domElement, e, app);
                        }
                    };
                    if (!this.featureLinks[featureId]) {
                        this.featureLinks[featureId] = {
                            handles: [],
                            layer,
                            domElements: [],
                            event: link.event,
                        };
                    }
                    this.featureLinks[featureId].handles.push(handler);
                    this.featureLinks[featureId].domElements.push(domElement);
                    domElement.addEventListener(link.event, handler);
                }
            });
        }
        source.on('removefeature', (event) => {
            if (!event.features) {
                return;
            }
            for (const removedFeature of event.features) {
                const linkage = this.featureLinks[removedFeature.getId()];
                if (linkage) {
                    this.removeFeatureLink(linkage);
                    delete this.featureLinks[removedFeature.getId()];
                }
            }
        });
    }
    removeFeatureLink(linkage) {
        for (const handle of linkage.handles) {
            for (const domEl of linkage.domElements) {
                domEl.removeEventListener(linkage.event, handle);
            }
        }
    }
    actOnFeature(action, feature, domElement, e, app) {
        var _a;
        if (!((_a = this.hsMapService.getLayerForFeature(feature, app)) === null || _a === void 0 ? void 0 : _a.getVisible())) {
            return;
        }
        const extent = feature.getGeometry().getExtent();
        const center = getCenter(extent);
        const map = this.hsMapService.getMap(app);
        switch (action) {
            case 'zoomToExtent':
                this.hsMapService.fitExtent(extent, app);
                break;
            case 'panToCenter':
                map.getView().setCenter(center);
                break;
            case 'showPopup':
                this.hsQueryPopupService.fillFeatures([feature], app);
                const pixel = map.getPixelFromCoordinate(center);
                this.hsQueryPopupService.showPopup({ pixel, map }, app);
                break;
            case 'hidePopup':
                this.hsQueryPopupService.closePopup(app);
                break;
            default:
                if (typeof action == 'function') {
                    action(feature, domElement, e);
                }
        }
    }
    getFeature(layer, source, link, domElement) {
        if (typeof link.feature == 'string') {
            return source
                .getFeatures()
                .find((feature) => feature.get('id'), link.feature);
        }
        else if (this.hsUtilsService.instOf(link.feature, Feature)) {
            return link.feature;
        }
        else if (typeof link.feature == 'function') {
            return link.feature(layer, domElement);
        }
    }
}
HsExternalService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsExternalService, deps: [{ token: HsMapService }, { token: HsUtilsService }, { token: HsLayerUtilsService }, { token: HsQueryPopupService }], target: i0.ɵɵFactoryTarget.Injectable });
HsExternalService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsExternalService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsExternalService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsMapService }, { type: HsUtilsService }, { type: HsLayerUtilsService }, { type: HsQueryPopupService }]; } });

class HslayersComponent {
    constructor(hsConfig, hsLayoutService, HsLayerManagerService, HsPanelContainerService, HsOverlayPanelContainerService, hsToolbarPanelContainerService, hsQueryPopupService, HsMapSwipeService, //Leave this, need to inject somewhere
    hsQueryPopupWidgetContainerService, //Leave this, need to inject somewhere
    hsExternalService //Leave this, need to inject somewhere
    ) {
        this.hsConfig = hsConfig;
        this.hsLayoutService = hsLayoutService;
        this.HsLayerManagerService = HsLayerManagerService;
        this.HsPanelContainerService = HsPanelContainerService;
        this.HsOverlayPanelContainerService = HsOverlayPanelContainerService;
        this.hsToolbarPanelContainerService = hsToolbarPanelContainerService;
        this.hsQueryPopupService = hsQueryPopupService;
        this.HsMapSwipeService = HsMapSwipeService;
        this.hsQueryPopupWidgetContainerService = hsQueryPopupWidgetContainerService;
        this.hsExternalService = hsExternalService;
    }
    /**
     * Check if panel is configured to be visible in hsConfig.get(app).panelsEnabled
     * or hsLayoutService.panelsEnabledDefaults and create one if so.
     * @param name - Name of panel used in panelsEnabled config
     * @param panelComponent - Class defining panel
     * @param data - Extra misc data object to be stored in panel
     */
    createPanel(name, panelComponent, app, data) {
        if (this.hsConfig.apps[this.id] == undefined ||
            this.hsConfig.apps[this.id].panelsEnabled[name]) {
            this.HsPanelContainerService.create(panelComponent, data || {}, app);
        }
    }
    ngOnInit() {
        if (this.config) {
            this.hsConfig.update(this.config, this.id);
        }
        if (this.id == undefined) {
            this.id = 'default';
        }
        this.createPanel('tripPlanner', HsTripPlannerComponent, this.id, {});
        this.createPanel('addData', HsAddDataComponent, this.id, {});
        this.createPanel('draw', HsDrawComponent, this.id, {});
        this.createPanel('search', HsSearchComponent, this.id, {});
        this.createPanel('feature_table', HsFeatureTableComponent, this.id, {});
        this.createPanel('saveMap', HsSaveMapComponent, this.id, {});
        this.createPanel('language', HsLanguageComponent, this.id, {});
        this.createPanel('info', HsQueryComponent, this.id, {});
        this.createPanel('permalink', HsShareComponent, this.id, {});
        this.createPanel('print', HsPrintComponent, this.id, {});
        this.createPanel('measure', HsMeasureComponent, this.id, {});
        this.createPanel('composition_browser', HsCompositionsComponent, this.id, {});
        this.createPanel('legend', HsLegendComponent, this.id, {});
        this.createPanel('layermanager', HsLayerManagerComponent, this.id, {});
        this.createPanel('mapSwipe', HsMapSwipeComponent, this.id, {});
        this.HsPanelContainerService.create(HsStylerComponent, {}, this.id);
        this.hsToolbarPanelContainerService.create(HsSearchToolbarComponent, {}, this.id);
        this.hsToolbarPanelContainerService.create(HsDrawToolbarComponent, {}, this.id);
        this.hsToolbarPanelContainerService.create(HsMeasureToolbarComponent, {}, this.id);
        this.HsOverlayPanelContainerService.create(HsGeolocationComponent, {}, this.id);
        this.HsOverlayPanelContainerService.create(HsInfoComponent, {}, this.id);
        this.HsOverlayPanelContainerService.create(HsLayerManagerGalleryComponent, {}, this.id);
        this.HsOverlayPanelContainerService.create(HsToolbarComponent, {}, this.id);
        this.hsQueryPopupService.init(this.id);
        this.HsOverlayPanelContainerService.create(HsQueryPopupComponent, {
            service: this.hsQueryPopupService,
        }, this.id);
        this.hsExternalService.init(this.id);
    }
}
HslayersComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HslayersComponent, deps: [{ token: HsConfig }, { token: HsLayoutService }, { token: HsLayerManagerService }, { token: HsPanelContainerService }, { token: HsOverlayPanelContainerService }, { token: HsToolbarPanelContainerService }, { token: HsQueryPopupService }, { token: HsMapSwipeService }, { token: HsQueryPopupWidgetContainerService }, { token: HsExternalService }], target: i0.ɵɵFactoryTarget.Component });
HslayersComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: HslayersComponent, selector: "hslayers", inputs: { config: "config", id: "id" }, viewQueries: [{ propertyName: "layout", first: true, predicate: HsLayoutComponent, descendants: true }], ngImport: i0, template: "<hs-layout class=\"hs-layout\" #hslayout layout=\"column\" [app]=\"id\" style=\"height:100%; max-height:100vh; position: relative;width:100%; display:block\"></hs-layout>\n", components: [{ type: HsLayoutComponent, selector: "hs-layout", inputs: ["app"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HslayersComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hslayers', styles: [], template: "<hs-layout class=\"hs-layout\" #hslayout layout=\"column\" [app]=\"id\" style=\"height:100%; max-height:100vh; position: relative;width:100%; display:block\"></hs-layout>\n" }]
        }], ctorParameters: function () { return [{ type: HsConfig }, { type: HsLayoutService }, { type: HsLayerManagerService }, { type: HsPanelContainerService }, { type: HsOverlayPanelContainerService }, { type: HsToolbarPanelContainerService }, { type: HsQueryPopupService }, { type: HsMapSwipeService }, { type: HsQueryPopupWidgetContainerService }, { type: HsExternalService }]; }, propDecorators: { config: [{
                type: Input
            }], id: [{
                type: Input
            }], layout: [{
                type: ViewChild,
                args: [HsLayoutComponent]
            }] } });

class HsUiExtensionsModule {
}
HsUiExtensionsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUiExtensionsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HsUiExtensionsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUiExtensionsModule, declarations: [HsUiExtensionsRecursiveDdComponent,
        EndpointsWithDatasourcesPipe,
        FilterPipe,
        TrackByPropertyPipe], imports: [CommonModule], exports: [HsUiExtensionsRecursiveDdComponent,
        EndpointsWithDatasourcesPipe,
        FilterPipe,
        TrackByPropertyPipe] });
HsUiExtensionsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUiExtensionsModule, providers: [EndpointsWithDatasourcesPipe], imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUiExtensionsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        HsUiExtensionsRecursiveDdComponent,
                        EndpointsWithDatasourcesPipe,
                        FilterPipe,
                        TrackByPropertyPipe,
                    ],
                    imports: [CommonModule],
                    providers: [EndpointsWithDatasourcesPipe],
                    exports: [
                        HsUiExtensionsRecursiveDdComponent,
                        EndpointsWithDatasourcesPipe,
                        FilterPipe,
                        TrackByPropertyPipe,
                    ],
                }]
        }] });

class HsCatalogueMetadataModule {
}
HsCatalogueMetadataModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCatalogueMetadataModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HsCatalogueMetadataModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCatalogueMetadataModule, declarations: [HsCatalogueMetadataComponent], imports: [CommonModule, FormsModule, HsLanguageModule, HsUiExtensionsModule], exports: [HsCatalogueMetadataComponent] });
HsCatalogueMetadataModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCatalogueMetadataModule, providers: [], imports: [[CommonModule, FormsModule, HsLanguageModule, HsUiExtensionsModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCatalogueMetadataModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FormsModule, HsLanguageModule, HsUiExtensionsModule],
                    exports: [HsCatalogueMetadataComponent],
                    declarations: [HsCatalogueMetadataComponent],
                    providers: [],
                }]
        }] });

class HsLaymanModule {
}
HsLaymanModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLaymanModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HsLaymanModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLaymanModule, declarations: [HsLaymanLoginComponent,
        HsLaymanCurrentUserComponent,
        HsCommonLaymanAccessRightsComponent,
        HsSetPermissionsDialogComponent], imports: [CommonModule, HsLanguageModule, HsUiExtensionsModule, FormsModule], exports: [HsLaymanLoginComponent,
        HsLaymanCurrentUserComponent,
        HsCommonLaymanAccessRightsComponent,
        HsSetPermissionsDialogComponent] });
HsLaymanModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLaymanModule, imports: [[CommonModule, HsLanguageModule, HsUiExtensionsModule, FormsModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLaymanModule, decorators: [{
            type: NgModule,
            args: [{
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                    declarations: [
                        HsLaymanLoginComponent,
                        HsLaymanCurrentUserComponent,
                        HsCommonLaymanAccessRightsComponent,
                        HsSetPermissionsDialogComponent,
                    ],
                    imports: [CommonModule, HsLanguageModule, HsUiExtensionsModule, FormsModule],
                    exports: [
                        HsLaymanLoginComponent,
                        HsLaymanCurrentUserComponent,
                        HsCommonLaymanAccessRightsComponent,
                        HsSetPermissionsDialogComponent,
                    ],
                }]
        }] });

class HsPagerModule {
}
HsPagerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsPagerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HsPagerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsPagerModule, declarations: [HsPagerComponent], imports: [CommonModule, HsLanguageModule, FormsModule, NgbDropdownModule], exports: [HsPagerComponent] });
HsPagerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsPagerModule, imports: [[CommonModule, HsLanguageModule, FormsModule, NgbDropdownModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsPagerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [HsPagerComponent],
                    imports: [CommonModule, HsLanguageModule, FormsModule, NgbDropdownModule],
                    exports: [HsPagerComponent],
                }]
        }] });

class HsAddDataCatalogueModule {
}
HsAddDataCatalogueModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataCatalogueModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HsAddDataCatalogueModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataCatalogueModule, declarations: [HsAddDataCatalogueComponent, HsCatalogueListItemComponent], imports: [CommonModule,
        FormsModule,
        HsLanguageModule,
        HsUiExtensionsModule,
        HsLaymanModule,
        NgbDropdownModule,
        HsPagerModule,
        HsCatalogueMetadataModule], exports: [HsAddDataCatalogueComponent,
        HsCatalogueListItemComponent,
        HsCatalogueMetadataComponent] });
HsAddDataCatalogueModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataCatalogueModule, imports: [[
            CommonModule,
            FormsModule,
            HsLanguageModule,
            HsUiExtensionsModule,
            HsLaymanModule,
            NgbDropdownModule,
            HsPagerModule,
            HsCatalogueMetadataModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataCatalogueModule, decorators: [{
            type: NgModule,
            args: [{
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                    declarations: [HsAddDataCatalogueComponent, HsCatalogueListItemComponent],
                    imports: [
                        CommonModule,
                        FormsModule,
                        HsLanguageModule,
                        HsUiExtensionsModule,
                        HsLaymanModule,
                        NgbDropdownModule,
                        HsPagerModule,
                        HsCatalogueMetadataModule,
                    ],
                    exports: [
                        HsAddDataCatalogueComponent,
                        HsCatalogueListItemComponent,
                        HsCatalogueMetadataComponent,
                    ],
                }]
        }] });

class HsAddDataCommonModule {
}
HsAddDataCommonModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataCommonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HsAddDataCommonModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataCommonModule, declarations: [HsGetCapabilitiesErrorComponent,
        HsAdvancedOptionsComponent,
        HsSaveToLaymanComponent,
        HsNewLayerFormComponent,
        HsPositionComponent,
        HsAddLayerAuthorizedComponent], imports: [CommonModule,
        FormsModule,
        HsLanguageModule,
        HsLaymanModule,
        HsUiExtensionsModule,
        NgbProgressbarModule], exports: [HsGetCapabilitiesErrorComponent,
        HsAdvancedOptionsComponent,
        HsSaveToLaymanComponent,
        HsNewLayerFormComponent,
        HsPositionComponent,
        HsAddLayerAuthorizedComponent] });
HsAddDataCommonModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataCommonModule, imports: [[
            CommonModule,
            FormsModule,
            HsLanguageModule,
            HsLaymanModule,
            HsUiExtensionsModule,
            NgbProgressbarModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataCommonModule, decorators: [{
            type: NgModule,
            args: [{
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                    imports: [
                        CommonModule,
                        FormsModule,
                        HsLanguageModule,
                        HsLaymanModule,
                        HsUiExtensionsModule,
                        NgbProgressbarModule
                    ],
                    exports: [
                        HsGetCapabilitiesErrorComponent,
                        HsAdvancedOptionsComponent,
                        HsSaveToLaymanComponent,
                        HsNewLayerFormComponent,
                        HsPositionComponent,
                        HsAddLayerAuthorizedComponent,
                    ],
                    declarations: [
                        HsGetCapabilitiesErrorComponent,
                        HsAdvancedOptionsComponent,
                        HsSaveToLaymanComponent,
                        HsNewLayerFormComponent,
                        HsPositionComponent,
                        HsAddLayerAuthorizedComponent,
                    ],
                }]
        }] });

class HsHistoryListModule {
}
HsHistoryListModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsHistoryListModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HsHistoryListModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsHistoryListModule, declarations: [HsHistoryListComponent], imports: [FormsModule, CommonModule, HsLanguageModule, NgbDropdownModule], exports: [HsHistoryListComponent] });
HsHistoryListModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsHistoryListModule, providers: [CookieService], imports: [[FormsModule, CommonModule, HsLanguageModule, NgbDropdownModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsHistoryListModule, decorators: [{
            type: NgModule,
            args: [{
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                    declarations: [HsHistoryListComponent],
                    imports: [FormsModule, CommonModule, HsLanguageModule, NgbDropdownModule],
                    exports: [HsHistoryListComponent],
                    providers: [CookieService],
                }]
        }] });

class HsCommonUrlModule {
}
HsCommonUrlModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCommonUrlModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HsCommonUrlModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCommonUrlModule, declarations: [HsUrlAddComponent,
        HsUrlProgressComponent,
        HsCommonUrlComponent,
        HsNestedLayersTableComponent,
        WmsLayerHighlightDirective,
        HsUrlDetailsComponent,
        HsLayerTableComponent], imports: [CommonModule,
        FormsModule,
        HsLanguageModule,
        HsHistoryListModule,
        HsUiExtensionsModule], exports: [HsUrlAddComponent,
        HsUrlProgressComponent,
        HsCommonUrlComponent,
        HsNestedLayersTableComponent,
        WmsLayerHighlightDirective,
        HsUrlDetailsComponent,
        HsLayerTableComponent] });
HsCommonUrlModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCommonUrlModule, imports: [[
            CommonModule,
            FormsModule,
            HsLanguageModule,
            HsHistoryListModule,
            HsUiExtensionsModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCommonUrlModule, decorators: [{
            type: NgModule,
            args: [{
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                    imports: [
                        CommonModule,
                        FormsModule,
                        HsLanguageModule,
                        HsHistoryListModule,
                        HsUiExtensionsModule,
                    ],
                    exports: [
                        HsUrlAddComponent,
                        HsUrlProgressComponent,
                        HsCommonUrlComponent,
                        HsNestedLayersTableComponent,
                        WmsLayerHighlightDirective,
                        HsUrlDetailsComponent,
                        HsLayerTableComponent,
                    ],
                    declarations: [
                        HsUrlAddComponent,
                        HsUrlProgressComponent,
                        HsCommonUrlComponent,
                        HsNestedLayersTableComponent,
                        WmsLayerHighlightDirective,
                        HsUrlDetailsComponent,
                        HsLayerTableComponent,
                    ],
                }]
        }] });

class HsUploadModule {
}
HsUploadModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUploadModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HsUploadModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUploadModule, declarations: [HsUploadComponent, HsFileDropDirective], imports: [CommonModule, HsLanguageModule, FormsModule], exports: [HsUploadComponent, HsFileDropDirective] });
HsUploadModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUploadModule, providers: [], imports: [[CommonModule, HsLanguageModule, FormsModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUploadModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [HsUploadComponent, HsFileDropDirective],
                    imports: [CommonModule, HsLanguageModule, FormsModule],
                    providers: [],
                    exports: [HsUploadComponent, HsFileDropDirective],
                }]
        }] });

class HsAddDataVectorModule {
}
HsAddDataVectorModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataVectorModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HsAddDataVectorModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataVectorModule, declarations: [HsAddDataVectorFileComponent, HsAddDataVectorUrlComponent], imports: [CommonModule,
        FormsModule,
        HsLanguageModule,
        HsAddDataCommonModule,
        HsCommonUrlModule,
        HsLaymanModule,
        HsUploadModule], exports: [HsAddDataVectorFileComponent, HsAddDataVectorUrlComponent] });
HsAddDataVectorModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataVectorModule, imports: [[
            CommonModule,
            FormsModule,
            HsLanguageModule,
            HsAddDataCommonModule,
            HsCommonUrlModule,
            HsLaymanModule,
            HsUploadModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataVectorModule, decorators: [{
            type: NgModule,
            args: [{
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                    imports: [
                        CommonModule,
                        FormsModule,
                        HsLanguageModule,
                        HsAddDataCommonModule,
                        HsCommonUrlModule,
                        HsLaymanModule,
                        HsUploadModule,
                    ],
                    exports: [HsAddDataVectorFileComponent, HsAddDataVectorUrlComponent],
                    declarations: [HsAddDataVectorFileComponent, HsAddDataVectorUrlComponent],
                }]
        }] });

class HsFileRasterModule {
}
HsFileRasterModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsFileRasterModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HsFileRasterModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsFileRasterModule, declarations: [HsFileRasterComponent], imports: [CommonModule,
        FormsModule,
        HsAddDataCommonModule,
        HsCommonUrlModule,
        HsLanguageModule,
        HsUploadModule], exports: [HsFileRasterComponent] });
HsFileRasterModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsFileRasterModule, providers: [], imports: [[
            CommonModule,
            FormsModule,
            HsAddDataCommonModule,
            HsCommonUrlModule,
            HsLanguageModule,
            HsUploadModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsFileRasterModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        FormsModule,
                        HsAddDataCommonModule,
                        HsCommonUrlModule,
                        HsLanguageModule,
                        HsUploadModule,
                    ],
                    exports: [HsFileRasterComponent],
                    declarations: [HsFileRasterComponent],
                    providers: [],
                }]
        }] });

class HsFileShpModule {
}
HsFileShpModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsFileShpModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HsFileShpModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsFileShpModule, declarations: [HsFileShpComponent], imports: [CommonModule,
        FormsModule,
        HsLanguageModule,
        HsUploadModule,
        HsAddDataCommonModule], exports: [HsFileShpComponent] });
HsFileShpModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsFileShpModule, imports: [[
            CommonModule,
            FormsModule,
            HsLanguageModule,
            HsUploadModule,
            HsAddDataCommonModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsFileShpModule, decorators: [{
            type: NgModule,
            args: [{
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                    imports: [
                        CommonModule,
                        FormsModule,
                        HsLanguageModule,
                        HsUploadModule,
                        HsAddDataCommonModule,
                    ],
                    exports: [HsFileShpComponent],
                    declarations: [HsFileShpComponent],
                }]
        }] });

class HsAddDataFileModule {
}
HsAddDataFileModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataFileModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HsAddDataFileModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataFileModule, declarations: [HsAddDataFileComponent, HsAddDataFileBaseComponent], imports: [CommonModule,
        FormsModule,
        HsFileShpModule,
        HsAddDataVectorModule,
        HsFileRasterModule], exports: [HsAddDataFileComponent, HsAddDataFileBaseComponent] });
HsAddDataFileModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataFileModule, imports: [[
            CommonModule,
            FormsModule,
            HsFileShpModule,
            HsAddDataVectorModule,
            HsFileRasterModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataFileModule, decorators: [{
            type: NgModule,
            args: [{
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                    declarations: [HsAddDataFileComponent, HsAddDataFileBaseComponent],
                    imports: [
                        CommonModule,
                        FormsModule,
                        HsFileShpModule,
                        HsAddDataVectorModule,
                        HsFileRasterModule,
                    ],
                    exports: [HsAddDataFileComponent, HsAddDataFileBaseComponent],
                }]
        }] });

class HsUrlArcGisModule {
}
HsUrlArcGisModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUrlArcGisModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HsUrlArcGisModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUrlArcGisModule, declarations: [HsUrlArcGisComponent], imports: [CommonModule,
        FormsModule,
        HsAddDataCommonModule,
        HsCommonUrlModule], exports: [HsUrlArcGisComponent] });
HsUrlArcGisModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUrlArcGisModule, imports: [[
            CommonModule,
            FormsModule,
            HsAddDataCommonModule,
            HsCommonUrlModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUrlArcGisModule, decorators: [{
            type: NgModule,
            args: [{
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                    imports: [
                        CommonModule,
                        FormsModule,
                        HsAddDataCommonModule,
                        HsCommonUrlModule,
                    ],
                    exports: [HsUrlArcGisComponent],
                    declarations: [HsUrlArcGisComponent],
                }]
        }] });

class HsUrlWfsModule {
}
HsUrlWfsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUrlWfsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HsUrlWfsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUrlWfsModule, declarations: [HsUrlWfsComponent], imports: [CommonModule,
        FormsModule,
        HsLanguageModule,
        HsAddDataCommonModule,
        HsUiExtensionsModule,
        HsCommonUrlModule], exports: [HsUrlWfsComponent] });
HsUrlWfsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUrlWfsModule, imports: [[
            CommonModule,
            FormsModule,
            HsLanguageModule,
            HsAddDataCommonModule,
            HsUiExtensionsModule,
            HsCommonUrlModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUrlWfsModule, decorators: [{
            type: NgModule,
            args: [{
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                    imports: [
                        CommonModule,
                        FormsModule,
                        HsLanguageModule,
                        HsAddDataCommonModule,
                        HsUiExtensionsModule,
                        HsCommonUrlModule,
                    ],
                    exports: [HsUrlWfsComponent],
                    declarations: [HsUrlWfsComponent],
                }]
        }] });

class HsUrlWmsModule {
}
HsUrlWmsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUrlWmsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HsUrlWmsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUrlWmsModule, declarations: [HsUrlWmsComponent], imports: [CommonModule,
        FormsModule,
        HsAddDataCommonModule,
        HsCommonUrlModule], exports: [HsUrlWmsComponent] });
HsUrlWmsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUrlWmsModule, imports: [[
            CommonModule,
            FormsModule,
            HsAddDataCommonModule,
            HsCommonUrlModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUrlWmsModule, decorators: [{
            type: NgModule,
            args: [{
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                    imports: [
                        CommonModule,
                        FormsModule,
                        HsAddDataCommonModule,
                        HsCommonUrlModule,
                    ],
                    exports: [HsUrlWmsComponent],
                    declarations: [HsUrlWmsComponent],
                }]
        }] });

class HsUrlWmtsModule {
}
HsUrlWmtsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUrlWmtsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HsUrlWmtsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUrlWmtsModule, declarations: [HsUrlWmtsComponent], imports: [CommonModule,
        FormsModule,
        HsLanguageModule,
        HsAddDataCommonModule,
        HsUiExtensionsModule,
        HsCommonUrlModule], exports: [HsUrlWmtsComponent] });
HsUrlWmtsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUrlWmtsModule, imports: [[
            CommonModule,
            FormsModule,
            HsLanguageModule,
            HsAddDataCommonModule,
            HsUiExtensionsModule,
            HsCommonUrlModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUrlWmtsModule, decorators: [{
            type: NgModule,
            args: [{
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                    imports: [
                        CommonModule,
                        FormsModule,
                        HsLanguageModule,
                        HsAddDataCommonModule,
                        HsUiExtensionsModule,
                        HsCommonUrlModule,
                    ],
                    exports: [HsUrlWmtsComponent],
                    declarations: [HsUrlWmtsComponent],
                }]
        }] });

class HsAddDataUrlModule {
}
HsAddDataUrlModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataUrlModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HsAddDataUrlModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataUrlModule, declarations: [HsAddDataUrlComponent], imports: [CommonModule,
        FormsModule,
        HsLanguageModule,
        HsUrlWmsModule,
        HsUrlArcGisModule,
        HsUrlWfsModule,
        HsAddDataVectorModule,
        HsUrlWmtsModule], exports: [HsAddDataUrlComponent] });
HsAddDataUrlModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataUrlModule, imports: [[
            CommonModule,
            FormsModule,
            HsLanguageModule,
            HsUrlWmsModule,
            HsUrlArcGisModule,
            HsUrlWfsModule,
            HsAddDataVectorModule,
            HsUrlWmtsModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataUrlModule, decorators: [{
            type: NgModule,
            args: [{
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                    declarations: [HsAddDataUrlComponent],
                    imports: [
                        CommonModule,
                        FormsModule,
                        HsLanguageModule,
                        HsUrlWmsModule,
                        HsUrlArcGisModule,
                        HsUrlWfsModule,
                        HsAddDataVectorModule,
                        HsUrlWmtsModule,
                    ],
                    exports: [HsAddDataUrlComponent],
                }]
        }] });

class HsAddDataModule {
}
HsAddDataModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HsAddDataModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataModule, declarations: [HsAddDataComponent,
        HsLayerOverwriteDialogComponent,
        HsRenameLayerDialogComponent], imports: [CommonModule,
        FormsModule,
        HsLanguageModule,
        HsPanelHelpersModule,
        HsAddDataUrlModule,
        HsAddDataFileModule,
        HsAddDataCatalogueModule], exports: [HsAddDataComponent] });
HsAddDataModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataModule, imports: [[
            CommonModule,
            FormsModule,
            HsLanguageModule,
            HsPanelHelpersModule,
            HsAddDataUrlModule,
            HsAddDataFileModule,
            HsAddDataCatalogueModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsAddDataModule, decorators: [{
            type: NgModule,
            args: [{
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                    declarations: [
                        HsAddDataComponent,
                        HsLayerOverwriteDialogComponent,
                        HsRenameLayerDialogComponent,
                    ],
                    imports: [
                        CommonModule,
                        FormsModule,
                        HsLanguageModule,
                        HsPanelHelpersModule,
                        HsAddDataUrlModule,
                        HsAddDataFileModule,
                        HsAddDataCatalogueModule,
                    ],
                    exports: [HsAddDataComponent],
                }]
        }] });

//TODO: Is this module declaration needed at all?
class HsCompositionsLayerParserModule {
}
HsCompositionsLayerParserModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCompositionsLayerParserModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HsCompositionsLayerParserModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCompositionsLayerParserModule });
HsCompositionsLayerParserModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCompositionsLayerParserModule, imports: [[]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCompositionsLayerParserModule, decorators: [{
            type: NgModule,
            args: [{
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                    declarations: [],
                    imports: [],
                    exports: [],
                }]
        }] });

class HsCompositionsModule {
}
HsCompositionsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCompositionsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HsCompositionsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCompositionsModule, declarations: [HsCompositionsComponent,
        HsCompositionsOverwriteDialogComponent,
        HsCompositionsDeleteDialogComponent,
        HsCompositionsShareDialogComponent,
        HsCompositionsInfoDialogComponent,
        HsCompositionsWarningDialogComponent,
        HsCompositionsListItemComponent,
        CswLayersDialogComponent], imports: [CommonModule,
        FormsModule,
        HsPanelHelpersModule,
        HsLanguageModule,
        HsCompositionsLayerParserModule,
        NgbDropdownModule,
        NgbAccordionModule,
        HsLaymanModule,
        HsPagerModule,
        HsCommonUrlModule], exports: [HsCompositionsComponent] });
HsCompositionsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCompositionsModule, imports: [[
            CommonModule,
            FormsModule,
            HsPanelHelpersModule,
            HsLanguageModule,
            HsCompositionsLayerParserModule,
            NgbDropdownModule,
            NgbAccordionModule,
            HsLaymanModule,
            HsPagerModule,
            HsCommonUrlModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCompositionsModule, decorators: [{
            type: NgModule,
            args: [{
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                    declarations: [
                        HsCompositionsComponent,
                        HsCompositionsOverwriteDialogComponent,
                        HsCompositionsDeleteDialogComponent,
                        HsCompositionsShareDialogComponent,
                        HsCompositionsInfoDialogComponent,
                        HsCompositionsWarningDialogComponent,
                        HsCompositionsListItemComponent,
                        CswLayersDialogComponent,
                    ],
                    imports: [
                        CommonModule,
                        FormsModule,
                        HsPanelHelpersModule,
                        HsLanguageModule,
                        HsCompositionsLayerParserModule,
                        NgbDropdownModule,
                        NgbAccordionModule,
                        HsLaymanModule,
                        HsPagerModule,
                        HsCommonUrlModule,
                    ],
                    exports: [HsCompositionsComponent],
                }]
        }] });

//TODO: Is this module declaration needed at all?
class HsCommonEndpointsModule {
}
HsCommonEndpointsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCommonEndpointsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HsCommonEndpointsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCommonEndpointsModule, imports: [CommonModule] });
HsCommonEndpointsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCommonEndpointsModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCommonEndpointsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [CommonModule],
                    exports: [],
                }]
        }] });

//TODO: Is this module declaration needed at all?
class HsLogModule {
}
HsLogModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLogModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HsLogModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLogModule });
HsLogModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLogModule, imports: [[]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLogModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [],
                    bootstrap: [],
                }]
        }] });

class HsUtilsModule {
}
HsUtilsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUtilsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HsUtilsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUtilsModule });
HsUtilsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUtilsModule, providers: [HsLayerUtilsService, HsUtilsService], imports: [[]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsUtilsModule, decorators: [{
            type: NgModule,
            args: [{
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                    imports: [],
                    providers: [HsLayerUtilsService, HsUtilsService],
                }]
        }] });

class HsCoreModule {
    constructor() { }
}
HsCoreModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCoreModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HsCoreModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCoreModule, imports: [HttpClientModule,
        HsLayoutModule,
        HsSidebarModule,
        HsHistoryListModule,
        HsLogModule,
        HsUtilsModule,
        HsConfirmModule,
        HsMapModule,
        HsCommonEndpointsModule] });
HsCoreModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCoreModule, providers: [HsConfig], imports: [[
            HttpClientModule,
            HsLayoutModule,
            HsSidebarModule,
            HsHistoryListModule,
            HsLogModule,
            HsUtilsModule,
            HsConfirmModule,
            HsMapModule,
            HsCommonEndpointsModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCoreModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [
                        HttpClientModule,
                        HsLayoutModule,
                        HsSidebarModule,
                        HsHistoryListModule,
                        HsLogModule,
                        HsUtilsModule,
                        HsConfirmModule,
                        HsMapModule,
                        HsCommonEndpointsModule,
                    ],
                    exports: [],
                    providers: [HsConfig],
                }]
        }], ctorParameters: function () { return []; } });

class HsDownloadModule {
}
HsDownloadModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsDownloadModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HsDownloadModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsDownloadModule, declarations: [HsDownloadDirective], imports: [CommonModule], exports: [HsDownloadDirective] });
HsDownloadModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsDownloadModule, providers: [], imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsDownloadModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [HsDownloadDirective],
                    imports: [CommonModule],
                    providers: [],
                    exports: [HsDownloadDirective],
                }]
        }] });

class HsQueryModule {
}
HsQueryModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsQueryModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HsQueryModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsQueryModule, declarations: [HsQueryComponent,
        HsQueryPopupComponent,
        HsQueryFeatureComponent,
        HsQueryFeatureListComponent,
        HsQueryDefaultInfoPanelBodyComponent,
        HsQueryAttributeRowComponent,
        HsClearLayerComponent,
        HsQueryPopupWidgetBaseComponent,
        HsFeatureInfoComponent,
        HsLayerNameComponent,
        HsDynamicTextComponent], imports: [CommonModule,
        HsPanelHelpersModule,
        FormsModule,
        HsLanguageModule,
        HsDownloadModule,
        NgbDropdownModule], exports: [HsQueryComponent,
        HsQueryPopupComponent,
        HsQueryFeatureComponent,
        HsQueryFeatureListComponent,
        HsClearLayerComponent,
        HsQueryPopupWidgetBaseComponent,
        HsFeatureInfoComponent,
        HsLayerNameComponent,
        HsDynamicTextComponent] });
HsQueryModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsQueryModule, imports: [[
            CommonModule,
            HsPanelHelpersModule,
            FormsModule,
            HsLanguageModule,
            HsDownloadModule,
            NgbDropdownModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsQueryModule, decorators: [{
            type: NgModule,
            args: [{
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                    declarations: [
                        HsQueryComponent,
                        HsQueryPopupComponent,
                        HsQueryFeatureComponent,
                        HsQueryFeatureListComponent,
                        HsQueryDefaultInfoPanelBodyComponent,
                        HsQueryAttributeRowComponent,
                        HsClearLayerComponent,
                        HsQueryPopupWidgetBaseComponent,
                        HsFeatureInfoComponent,
                        HsLayerNameComponent,
                        HsDynamicTextComponent,
                    ],
                    imports: [
                        CommonModule,
                        HsPanelHelpersModule,
                        FormsModule,
                        HsLanguageModule,
                        HsDownloadModule,
                        NgbDropdownModule,
                    ],
                    exports: [
                        HsQueryComponent,
                        HsQueryPopupComponent,
                        HsQueryFeatureComponent,
                        HsQueryFeatureListComponent,
                        HsClearLayerComponent,
                        HsQueryPopupWidgetBaseComponent,
                        HsFeatureInfoComponent,
                        HsLayerNameComponent,
                        HsDynamicTextComponent,
                    ],
                }]
        }] });

class HsRmMultipleModule {
}
HsRmMultipleModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsRmMultipleModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HsRmMultipleModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsRmMultipleModule, declarations: [HsRmMultipleDialogComponent], imports: [CommonModule, HsLanguageModule], exports: [HsRmMultipleDialogComponent] });
HsRmMultipleModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsRmMultipleModule, imports: [[CommonModule, HsLanguageModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsRmMultipleModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [HsRmMultipleDialogComponent],
                    imports: [CommonModule, HsLanguageModule],
                    exports: [HsRmMultipleDialogComponent],
                }]
        }] });

class HsStylerModule {
}
HsStylerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsStylerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HsStylerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsStylerModule, declarations: [HsStylerComponent,
        HsRuleComponent,
        HsSymbolizerComponent,
        HsFillSymbolizerComponent,
        HsMarkSymbolizerComponent,
        HsIconSymbolizerComponent,
        HsTextSymbolizerComponent,
        HsLineSymbolizerComponent,
        HsColorPickerComponent,
        HsSliderComponent,
        HsFiltersComponent,
        HsFilterComponent,
        HsComparisonFilterComponent,
        HsAddFilterButtonComponent,
        HsScaleDenominatorComponent,
        HsSelectIconDialogComponent,
        HsStylerPartBaseComponent,
        HsRuleListItemComponent,
        HsSymbolizerListItemComponent,
        HsAddColormapComponent], imports: [CommonModule,
        ColorSketchModule,
        HsPanelHelpersModule,
        FormsModule,
        NgbDropdownModule,
        HsLanguageModule,
        HsUploadModule,
        HsDownloadModule,
        DragDropModule], exports: [HsStylerComponent,
        HsRuleComponent,
        HsSymbolizerComponent,
        HsFillSymbolizerComponent,
        HsMarkSymbolizerComponent,
        HsIconSymbolizerComponent,
        HsTextSymbolizerComponent,
        HsLineSymbolizerComponent,
        HsSymbolizerListItemComponent,
        HsColorPickerComponent,
        HsSliderComponent,
        HsFiltersComponent,
        HsFilterComponent,
        HsComparisonFilterComponent,
        HsAddFilterButtonComponent,
        HsScaleDenominatorComponent,
        HsSelectIconDialogComponent,
        HsRuleListItemComponent,
        HsAddColormapComponent] });
HsStylerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsStylerModule, imports: [[
            CommonModule,
            ColorSketchModule,
            HsPanelHelpersModule,
            FormsModule,
            NgbDropdownModule,
            HsLanguageModule,
            HsUploadModule,
            HsDownloadModule,
            DragDropModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsStylerModule, decorators: [{
            type: NgModule,
            args: [{
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                    declarations: [
                        HsStylerComponent,
                        HsRuleComponent,
                        HsSymbolizerComponent,
                        HsFillSymbolizerComponent,
                        HsMarkSymbolizerComponent,
                        HsIconSymbolizerComponent,
                        HsTextSymbolizerComponent,
                        HsLineSymbolizerComponent,
                        HsColorPickerComponent,
                        HsSliderComponent,
                        HsFiltersComponent,
                        HsFilterComponent,
                        HsComparisonFilterComponent,
                        HsAddFilterButtonComponent,
                        HsScaleDenominatorComponent,
                        HsSelectIconDialogComponent,
                        HsStylerPartBaseComponent,
                        HsRuleListItemComponent,
                        HsSymbolizerListItemComponent,
                        HsAddColormapComponent,
                    ],
                    imports: [
                        CommonModule,
                        ColorSketchModule,
                        HsPanelHelpersModule,
                        FormsModule,
                        NgbDropdownModule,
                        HsLanguageModule,
                        HsUploadModule,
                        HsDownloadModule,
                        DragDropModule,
                    ],
                    exports: [
                        HsStylerComponent,
                        HsRuleComponent,
                        HsSymbolizerComponent,
                        HsFillSymbolizerComponent,
                        HsMarkSymbolizerComponent,
                        HsIconSymbolizerComponent,
                        HsTextSymbolizerComponent,
                        HsLineSymbolizerComponent,
                        HsSymbolizerListItemComponent,
                        HsColorPickerComponent,
                        HsSliderComponent,
                        HsFiltersComponent,
                        HsFilterComponent,
                        HsComparisonFilterComponent,
                        HsAddFilterButtonComponent,
                        HsScaleDenominatorComponent,
                        HsSelectIconDialogComponent,
                        HsRuleListItemComponent,
                        HsAddColormapComponent,
                    ],
                }]
        }] });

class HsDrawModule {
}
HsDrawModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsDrawModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HsDrawModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsDrawModule, declarations: [HsDrawComponent,
        HsDrawLayerMetadataDialogComponent,
        HsDrawToolbarComponent,
        DrawPanelComponent,
        DrawEditComponent], imports: [CommonModule,
        HsPanelHelpersModule,
        FormsModule,
        NgbDropdownModule,
        HsStylerModule,
        HsLanguageModule,
        HsQueryModule,
        HsLaymanModule,
        HsRmMultipleModule], exports: [HsDrawComponent,
        HsDrawLayerMetadataDialogComponent,
        HsDrawToolbarComponent] });
HsDrawModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsDrawModule, imports: [[
            CommonModule,
            HsPanelHelpersModule,
            FormsModule,
            NgbDropdownModule,
            HsStylerModule,
            HsLanguageModule,
            HsQueryModule,
            HsLaymanModule,
            HsRmMultipleModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsDrawModule, decorators: [{
            type: NgModule,
            args: [{
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                    declarations: [
                        HsDrawComponent,
                        HsDrawLayerMetadataDialogComponent,
                        HsDrawToolbarComponent,
                        DrawPanelComponent,
                        DrawEditComponent,
                    ],
                    imports: [
                        CommonModule,
                        HsPanelHelpersModule,
                        FormsModule,
                        NgbDropdownModule,
                        HsStylerModule,
                        HsLanguageModule,
                        HsQueryModule,
                        HsLaymanModule,
                        HsRmMultipleModule,
                    ],
                    exports: [
                        HsDrawComponent,
                        HsDrawLayerMetadataDialogComponent,
                        HsDrawToolbarComponent,
                    ],
                }]
        }] });

class HsFeatureTableModule {
}
HsFeatureTableModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsFeatureTableModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HsFeatureTableModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsFeatureTableModule, declarations: [HsFeatureTableComponent,
        HsLayerFeaturesComponent,
        HsFeatureFilterPipe], imports: [CommonModule,
        FormsModule,
        HsPanelHelpersModule,
        HsLanguageModule,
        NgbDropdownModule], exports: [HsFeatureTableComponent,
        HsLayerFeaturesComponent,
        HsFeatureFilterPipe] });
HsFeatureTableModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsFeatureTableModule, imports: [[
            CommonModule,
            FormsModule,
            HsPanelHelpersModule,
            HsLanguageModule,
            NgbDropdownModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsFeatureTableModule, decorators: [{
            type: NgModule,
            args: [{
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                    declarations: [
                        HsFeatureTableComponent,
                        HsLayerFeaturesComponent,
                        HsFeatureFilterPipe,
                    ],
                    imports: [
                        CommonModule,
                        FormsModule,
                        HsPanelHelpersModule,
                        HsLanguageModule,
                        NgbDropdownModule,
                    ],
                    exports: [
                        HsFeatureTableComponent,
                        HsLayerFeaturesComponent,
                        HsFeatureFilterPipe,
                    ],
                }]
        }] });

class HsGeolocationModule {
}
HsGeolocationModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsGeolocationModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HsGeolocationModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsGeolocationModule, declarations: [HsGeolocationComponent], imports: [FormsModule, CommonModule, HsPanelHelpersModule, HsLanguageModule], exports: [HsGeolocationComponent] });
HsGeolocationModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsGeolocationModule, imports: [[FormsModule, CommonModule, HsPanelHelpersModule, HsLanguageModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsGeolocationModule, decorators: [{
            type: NgModule,
            args: [{
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                    declarations: [HsGeolocationComponent],
                    imports: [FormsModule, CommonModule, HsPanelHelpersModule, HsLanguageModule],
                    exports: [HsGeolocationComponent],
                }]
        }] });

class HsInfoModule {
}
HsInfoModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsInfoModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HsInfoModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsInfoModule, declarations: [HsInfoComponent], imports: [FormsModule, CommonModule, HsPanelHelpersModule, HsLanguageModule], exports: [HsInfoComponent] });
HsInfoModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsInfoModule, imports: [[FormsModule, CommonModule, HsPanelHelpersModule, HsLanguageModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsInfoModule, decorators: [{
            type: NgModule,
            args: [{
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                    declarations: [HsInfoComponent],
                    imports: [FormsModule, CommonModule, HsPanelHelpersModule, HsLanguageModule],
                    exports: [HsInfoComponent],
                }]
        }] });

//TODO: Is this module declaration necessary at all?
class HsGetCapabilitiesModule {
}
HsGetCapabilitiesModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsGetCapabilitiesModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HsGetCapabilitiesModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsGetCapabilitiesModule });
HsGetCapabilitiesModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsGetCapabilitiesModule, imports: [[]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsGetCapabilitiesModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [],
                    exports: [],
                }]
        }] });

//TODO: Is this module declaration needed at all?
class HsQueuesModule {
}
HsQueuesModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsQueuesModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HsQueuesModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsQueuesModule });
HsQueuesModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsQueuesModule, imports: [[]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsQueuesModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [],
                    bootstrap: [],
                }]
        }] });

class HsLegendModule {
}
HsLegendModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLegendModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HsLegendModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLegendModule, declarations: [HsLegendComponent,
        HsLegendLayerComponent,
        HsLegendLayerVectorComponent,
        HsLegendLayerStaticComponent], imports: [CommonModule,
        FormsModule,
        HsPanelHelpersModule,
        HsUiExtensionsModule,
        HsLanguageModule,
        HsQueuesModule], exports: [HsLegendComponent, HsLegendLayerComponent] });
HsLegendModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLegendModule, imports: [[
            CommonModule,
            FormsModule,
            HsPanelHelpersModule,
            HsUiExtensionsModule,
            HsLanguageModule,
            HsQueuesModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLegendModule, decorators: [{
            type: NgModule,
            args: [{
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                    declarations: [
                        HsLegendComponent,
                        HsLegendLayerComponent,
                        HsLegendLayerVectorComponent,
                        HsLegendLayerStaticComponent,
                    ],
                    imports: [
                        CommonModule,
                        FormsModule,
                        HsPanelHelpersModule,
                        HsUiExtensionsModule,
                        HsLanguageModule,
                        HsQueuesModule,
                    ],
                    exports: [HsLegendComponent, HsLegendLayerComponent],
                }]
        }] });

class HsLayerManagerModule {
}
HsLayerManagerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerManagerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HsLayerManagerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerManagerModule, declarations: [HsLayerManagerComponent,
        HsLayerEditorDimensionsComponent,
        HsLayerEditorSubLayerCheckboxesComponent,
        HsLayerManagerGalleryComponent,
        HsLayerEditorComponent,
        HsLayerManagerFolderComponent,
        HsLayerListComponent,
        HsLayerManagerRemoveAllDialogComponent,
        HsCopyLayerDialogComponent,
        HsLayerManagerRemoveLayerDialogComponent,
        HsLayerManagerTimeEditorComponent,
        HsLayerEditorWidgetBaseComponent,
        HsLayerPhysicalListComponent,
        HsTypeWidgetComponent,
        HsMetadataWidgetComponent,
        HsScaleWidgetComponent,
        HsClusterWidgetComponent,
        HsIdwWidgetComponent,
        HsLegendWidgetComponent,
        HsOpacityWidgetComponent], imports: [HsLanguageModule,
        CommonModule,
        FormsModule,
        HsGetCapabilitiesModule,
        HsPanelHelpersModule,
        HsLegendModule,
        HsUiExtensionsModule,
        NgbDatepickerModule,
        NgbDropdownModule,
        NgbTooltipModule,
        DragDropModule,
        HsQueuesModule], exports: [HsLayerManagerComponent,
        HsLayerEditorDimensionsComponent,
        HsLayerEditorSubLayerCheckboxesComponent,
        HsLayerManagerGalleryComponent,
        HsLayerEditorComponent,
        HsLayerManagerFolderComponent,
        HsLayerListComponent,
        HsLayerManagerRemoveAllDialogComponent,
        HsCopyLayerDialogComponent,
        HsLayerManagerRemoveLayerDialogComponent,
        HsLayerManagerTimeEditorComponent,
        HsLayerPhysicalListComponent,
        HsTypeWidgetComponent,
        HsMetadataWidgetComponent,
        HsScaleWidgetComponent,
        HsClusterWidgetComponent,
        HsLegendWidgetComponent,
        HsOpacityWidgetComponent,
        HsIdwWidgetComponent] });
HsLayerManagerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerManagerModule, imports: [[
            HsLanguageModule,
            CommonModule,
            FormsModule,
            HsGetCapabilitiesModule,
            HsPanelHelpersModule,
            HsLegendModule,
            HsUiExtensionsModule,
            NgbDatepickerModule,
            NgbDropdownModule,
            NgbTooltipModule,
            DragDropModule,
            HsQueuesModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsLayerManagerModule, decorators: [{
            type: NgModule,
            args: [{
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                    declarations: [
                        HsLayerManagerComponent,
                        HsLayerEditorDimensionsComponent,
                        HsLayerEditorSubLayerCheckboxesComponent,
                        HsLayerManagerGalleryComponent,
                        HsLayerEditorComponent,
                        HsLayerManagerFolderComponent,
                        HsLayerListComponent,
                        HsLayerManagerRemoveAllDialogComponent,
                        HsCopyLayerDialogComponent,
                        HsLayerManagerRemoveLayerDialogComponent,
                        HsLayerManagerTimeEditorComponent,
                        HsLayerEditorWidgetBaseComponent,
                        HsLayerPhysicalListComponent,
                        HsTypeWidgetComponent,
                        HsMetadataWidgetComponent,
                        HsScaleWidgetComponent,
                        HsClusterWidgetComponent,
                        HsIdwWidgetComponent,
                        HsLegendWidgetComponent,
                        HsOpacityWidgetComponent,
                    ],
                    imports: [
                        HsLanguageModule,
                        CommonModule,
                        FormsModule,
                        HsGetCapabilitiesModule,
                        HsPanelHelpersModule,
                        HsLegendModule,
                        HsUiExtensionsModule,
                        NgbDatepickerModule,
                        NgbDropdownModule,
                        NgbTooltipModule,
                        DragDropModule,
                        HsQueuesModule,
                    ],
                    exports: [
                        HsLayerManagerComponent,
                        HsLayerEditorDimensionsComponent,
                        HsLayerEditorSubLayerCheckboxesComponent,
                        HsLayerManagerGalleryComponent,
                        HsLayerEditorComponent,
                        HsLayerManagerFolderComponent,
                        HsLayerListComponent,
                        HsLayerManagerRemoveAllDialogComponent,
                        HsCopyLayerDialogComponent,
                        HsLayerManagerRemoveLayerDialogComponent,
                        HsLayerManagerTimeEditorComponent,
                        HsLayerPhysicalListComponent,
                        HsTypeWidgetComponent,
                        HsMetadataWidgetComponent,
                        HsScaleWidgetComponent,
                        HsClusterWidgetComponent,
                        HsLegendWidgetComponent,
                        HsOpacityWidgetComponent,
                        HsIdwWidgetComponent
                    ],
                }]
        }] });

class HsMapSwipeModule {
}
HsMapSwipeModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsMapSwipeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HsMapSwipeModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsMapSwipeModule, declarations: [HsMapSwipeComponent], imports: [CommonModule,
        HsPanelHelpersModule,
        FormsModule,
        HsLanguageModule,
        DragDropModule], exports: [HsMapSwipeComponent] });
HsMapSwipeModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsMapSwipeModule, imports: [[
            CommonModule,
            HsPanelHelpersModule,
            FormsModule,
            HsLanguageModule,
            DragDropModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsMapSwipeModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [HsMapSwipeComponent],
                    imports: [
                        CommonModule,
                        HsPanelHelpersModule,
                        FormsModule,
                        HsLanguageModule,
                        DragDropModule,
                    ],
                    exports: [HsMapSwipeComponent],
                    entryComponents: [HsMapSwipeComponent],
                }]
        }] });

class HsMeasureModule {
}
HsMeasureModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsMeasureModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HsMeasureModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsMeasureModule, declarations: [HsMeasureComponent, HsMeasureToolbarComponent], imports: [CommonModule,
        FormsModule,
        HsPanelHelpersModule,
        NgbDropdownModule,
        HsLanguageModule], exports: [HsMeasureComponent, HsMeasureToolbarComponent] });
HsMeasureModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsMeasureModule, imports: [[
            CommonModule,
            FormsModule,
            HsPanelHelpersModule,
            NgbDropdownModule,
            HsLanguageModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsMeasureModule, decorators: [{
            type: NgModule,
            args: [{
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                    declarations: [HsMeasureComponent, HsMeasureToolbarComponent],
                    imports: [
                        CommonModule,
                        FormsModule,
                        HsPanelHelpersModule,
                        NgbDropdownModule,
                        HsLanguageModule,
                    ],
                    exports: [HsMeasureComponent, HsMeasureToolbarComponent],
                }]
        }] });

/**
 * Add print dialog template to the app
 */
class HsPrintModule {
}
HsPrintModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsPrintModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HsPrintModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsPrintModule, declarations: [HsPrintComponent,
        HsPrintTextStylerComponent,
        HsPrintScaleStylerComponent,
        HsPrintLegendStylerComponent,
        HsPrintImprintStylerComponent], imports: [CommonModule,
        FormsModule,
        HsPanelHelpersModule,
        HsLanguageModule,
        ColorSketchModule,
        NgbDropdownModule], exports: [HsPrintComponent,
        HsPrintTextStylerComponent,
        HsPrintScaleStylerComponent,
        HsPrintLegendStylerComponent,
        HsPrintImprintStylerComponent] });
HsPrintModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsPrintModule, imports: [[
            CommonModule,
            FormsModule,
            HsPanelHelpersModule,
            HsLanguageModule,
            ColorSketchModule,
            NgbDropdownModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsPrintModule, decorators: [{
            type: NgModule,
            args: [{
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                    declarations: [
                        HsPrintComponent,
                        HsPrintTextStylerComponent,
                        HsPrintScaleStylerComponent,
                        HsPrintLegendStylerComponent,
                        HsPrintImprintStylerComponent,
                    ],
                    imports: [
                        CommonModule,
                        FormsModule,
                        HsPanelHelpersModule,
                        HsLanguageModule,
                        ColorSketchModule,
                        NgbDropdownModule,
                    ],
                    exports: [
                        HsPrintComponent,
                        HsPrintTextStylerComponent,
                        HsPrintScaleStylerComponent,
                        HsPrintLegendStylerComponent,
                        HsPrintImprintStylerComponent,
                    ],
                }]
        }] });

class HsSaveMapModule {
}
HsSaveMapModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSaveMapModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HsSaveMapModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSaveMapModule, declarations: [HsSaveMapComponent,
        HsSaveMapResultDialogComponent,
        HsSaveMapDialogComponent,
        HsSaveMapAdvancedFormComponent], imports: [CommonModule,
        HsPanelHelpersModule,
        FormsModule,
        HsLogModule,
        HsUiExtensionsModule,
        HsLanguageModule,
        HsLaymanModule], exports: [HsSaveMapComponent] });
HsSaveMapModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSaveMapModule, imports: [[
            CommonModule,
            HsPanelHelpersModule,
            FormsModule,
            HsLogModule,
            HsUiExtensionsModule,
            HsLanguageModule,
            HsLaymanModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSaveMapModule, decorators: [{
            type: NgModule,
            args: [{
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                    declarations: [
                        HsSaveMapComponent,
                        HsSaveMapResultDialogComponent,
                        HsSaveMapDialogComponent,
                        HsSaveMapAdvancedFormComponent,
                    ],
                    imports: [
                        CommonModule,
                        HsPanelHelpersModule,
                        FormsModule,
                        HsLogModule,
                        HsUiExtensionsModule,
                        HsLanguageModule,
                        HsLaymanModule,
                    ],
                    exports: [HsSaveMapComponent],
                }]
        }] });

class HsSearchModule {
}
HsSearchModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSearchModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HsSearchModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSearchModule, declarations: [HsSearchComponent,
        HsSearchResultsComponent,
        HsSearchInputComponent,
        limitToPipe,
        HsSearchToolbarComponent], imports: [FormsModule, CommonModule, HsPanelHelpersModule, HsLanguageModule], exports: [HsSearchComponent,
        HsSearchResultsComponent,
        HsSearchInputComponent,
        HsSearchToolbarComponent] });
HsSearchModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSearchModule, imports: [[FormsModule, CommonModule, HsPanelHelpersModule, HsLanguageModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsSearchModule, decorators: [{
            type: NgModule,
            args: [{
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                    declarations: [
                        HsSearchComponent,
                        HsSearchResultsComponent,
                        HsSearchInputComponent,
                        limitToPipe,
                        HsSearchToolbarComponent,
                    ],
                    imports: [FormsModule, CommonModule, HsPanelHelpersModule, HsLanguageModule],
                    exports: [
                        HsSearchComponent,
                        HsSearchResultsComponent,
                        HsSearchInputComponent,
                        HsSearchToolbarComponent,
                    ],
                }]
        }] });

class HsShareModule {
}
HsShareModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsShareModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HsShareModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsShareModule, declarations: [HsShareComponent], imports: [CommonModule, FormsModule, HsPanelHelpersModule, HsLanguageModule], exports: [HsShareComponent] });
HsShareModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsShareModule, providers: [
        { provide: LocationStrategy, useClass: PathLocationStrategy },
        { provide: APP_BASE_HREF, useValue: '/' },
    ], imports: [[CommonModule, FormsModule, HsPanelHelpersModule, HsLanguageModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsShareModule, decorators: [{
            type: NgModule,
            args: [{
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                    declarations: [HsShareComponent],
                    imports: [CommonModule, FormsModule, HsPanelHelpersModule, HsLanguageModule],
                    exports: [HsShareComponent],
                    providers: [
                        { provide: LocationStrategy, useClass: PathLocationStrategy },
                        { provide: APP_BASE_HREF, useValue: '/' },
                    ],
                }]
        }] });

class HsToolbarModule {
}
HsToolbarModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsToolbarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HsToolbarModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsToolbarModule, declarations: [HsToolbarComponent, HsToolbarPanelBaseComponent], imports: [CommonModule,
        FormsModule,
        NgbDropdownModule,
        HsPanelHelpersModule], exports: [HsToolbarComponent, HsToolbarPanelBaseComponent] });
HsToolbarModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsToolbarModule, imports: [[
            CommonModule,
            FormsModule,
            NgbDropdownModule,
            HsPanelHelpersModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsToolbarModule, decorators: [{
            type: NgModule,
            args: [{
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                    declarations: [HsToolbarComponent, HsToolbarPanelBaseComponent],
                    imports: [
                        CommonModule,
                        FormsModule,
                        NgbDropdownModule,
                        HsPanelHelpersModule,
                    ],
                    exports: [HsToolbarComponent, HsToolbarPanelBaseComponent],
                }]
        }] });

class HsTripPlannerModule {
}
HsTripPlannerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsTripPlannerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HsTripPlannerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsTripPlannerModule, declarations: [HsTripPlannerComponent, HsTripPlannerLayerSelectorComponent], imports: [FormsModule,
        CommonModule,
        HsLanguageModule,
        HsPanelHelpersModule,
        NgbDropdownModule], exports: [HsTripPlannerComponent, HsTripPlannerLayerSelectorComponent] });
HsTripPlannerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsTripPlannerModule, imports: [[
            FormsModule,
            CommonModule,
            HsLanguageModule,
            HsPanelHelpersModule,
            NgbDropdownModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsTripPlannerModule, decorators: [{
            type: NgModule,
            args: [{
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                    declarations: [HsTripPlannerComponent, HsTripPlannerLayerSelectorComponent],
                    imports: [
                        FormsModule,
                        CommonModule,
                        HsLanguageModule,
                        HsPanelHelpersModule,
                        NgbDropdownModule,
                    ],
                    exports: [HsTripPlannerComponent, HsTripPlannerLayerSelectorComponent],
                }]
        }] });

class HslayersModule {
}
HslayersModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HslayersModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HslayersModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HslayersModule, declarations: [HslayersComponent], imports: [HsCoreModule,
        HsLayoutModule,
        HsLayerManagerModule,
        HsMeasureModule,
        HsAddDataModule,
        HsDrawModule,
        HsGeolocationModule,
        HsInfoModule,
        HsLanguageModule,
        HsLegendModule,
        HsTripPlannerModule,
        HsSaveMapModule,
        HsFeatureTableModule,
        HsPrintModule,
        HsShareModule,
        HsQueryModule,
        HsSearchModule,
        HsCompositionsModule,
        HsStylerModule,
        HsToolbarModule,
        HsMapSwipeModule], exports: [HslayersComponent] });
HslayersModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HslayersModule, imports: [[
            HsCoreModule,
            HsLayoutModule,
            HsLayerManagerModule,
            HsMeasureModule,
            HsAddDataModule,
            HsDrawModule,
            HsGeolocationModule,
            HsInfoModule,
            HsLanguageModule,
            HsLegendModule,
            HsTripPlannerModule,
            HsSaveMapModule,
            HsFeatureTableModule,
            HsPrintModule,
            HsShareModule,
            HsQueryModule,
            HsSearchModule,
            HsCompositionsModule,
            HsStylerModule,
            HsToolbarModule,
            HsMapSwipeModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HslayersModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [HslayersComponent],
                    imports: [
                        HsCoreModule,
                        HsLayoutModule,
                        HsLayerManagerModule,
                        HsMeasureModule,
                        HsAddDataModule,
                        HsDrawModule,
                        HsGeolocationModule,
                        HsInfoModule,
                        HsLanguageModule,
                        HsLegendModule,
                        HsTripPlannerModule,
                        HsSaveMapModule,
                        HsFeatureTableModule,
                        HsPrintModule,
                        HsShareModule,
                        HsQueryModule,
                        HsSearchModule,
                        HsCompositionsModule,
                        HsStylerModule,
                        HsToolbarModule,
                        HsMapSwipeModule,
                    ],
                    exports: [HslayersComponent],
                }]
        }] });

/**
 * Handy shorthand for SparqlJson source with some params pre-filled for SPOI dataset
 */
class SPOI extends SparqlJson {
    constructor({ category, projection }) {
        const options = {
            endpointUrl: 'https://www.foodie-cloud.org/sparql',
            endpointOptions: {},
            geom_attribute: '?geom',
            optimizeForVirtuoso: true,
            projection: projection,
            query: `
        PREFIX poi: <http://www.openvoc.eu/poi#>
        PREFIX spoi: <http://gis.zcu.cz/SPOI/Ontology#>
        SELECT ?o ?p ?s
        FROM <http://www.sdi4apps.eu/poi.rdf>
        WHERE {
          ?o <http://www.w3.org/1999/02/22-rdf-syntax-ns#type> spoi:${category} .
          ?o <http://www.opengis.net/ont/geosparql#asWKT> ?geom.
          FILTER(isBlank(?geom) = false).
          <extent>
          ?o ?p ?s .
        } ORDER BY ?o`,
        };
        super(options);
    }
}

//https://stackoverflow.com/questions/40863488/how-can-i-iterate-over-a-custom-literal-type-in-typescript

class HsVectorUrlParserService {
    constructor(hsMapService, hsShareUrlService, hsAddDataVectorService) {
        this.hsMapService = hsMapService;
        this.hsShareUrlService = hsShareUrlService;
        this.hsAddDataVectorService = hsAddDataVectorService;
        this.checkUrlParamsAndAdd = function () {
            return __awaiter(this, void 0, void 0, function* () {
                const title = decodeURIComponent(this.HsShareUrlService.getParamValue('title')) ||
                    'Layer';
                const abstract = decodeURIComponent(this.HsShareUrlService.getParamValue('abstract'));
                if (this.HsShareUrlService.getParamValue('geojson_to_connect')) {
                    const url = this.HsShareUrlService.getParamValue('geojson_to_connect');
                    let type = 'geojson';
                    if (url.indexOf('gpx') > 0) {
                        type = 'gpx';
                    }
                    if (url.indexOf('kml') > 0) {
                        type = 'kml';
                    }
                    const lyr = yield this.HsAddDataVectorService.addVectorLayer(type, url, title, title, abstract, 'EPSG:4326');
                    this.HsAddDataVectorService.fitExtent(lyr);
                }
                if (this.HsShareUrlService.getParamValue('kml_to_connect')) {
                    const url = this.HsShareUrlService.getParamValue('kml_to_connect');
                    const lyr = yield this.HsAddDataVectorService.addVectorLayer('kml', url, title, title, abstract, 'EPSG:4326', { extractStyles: true });
                    this.HsAddDataVectorService.fitExtent(lyr);
                }
            });
        };
    }
    init(app) {
        this.hsMapService.loaded(app).then((map) => {
            this.checkUrlParamsAndAdd();
        });
    }
}
HsVectorUrlParserService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsVectorUrlParserService, deps: [{ token: HsMapService }, { token: HsShareUrlService }, { token: HsAddDataVectorService }], target: i0.ɵɵFactoryTarget.Injectable });
HsVectorUrlParserService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsVectorUrlParserService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsVectorUrlParserService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HsMapService }, { type: HsShareUrlService }, { type: HsAddDataVectorService }]; } });

class HsCompositionsEndpointsModule {
}
HsCompositionsEndpointsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCompositionsEndpointsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HsCompositionsEndpointsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCompositionsEndpointsModule, imports: [CommonModule, FormsModule] });
HsCompositionsEndpointsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCompositionsEndpointsModule, imports: [[CommonModule, FormsModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HsCompositionsEndpointsModule, decorators: [{
            type: NgModule,
            args: [{
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                    declarations: [],
                    imports: [CommonModule, FormsModule],
                    exports: [],
                }]
        }] });

const xpos = ['left', 'right', 'center'];
const ypos = ['top', 'middle', 'bottom'];

const queryPopupWidgets = [
    'layer-name',
    'feature-info',
    'clear-layer',
];

const StateValues = [
    'PENDING',
    'STARTED',
    'FAILURE',
    'NOT_AVAILABLE',
];

/*
 * Public API Surface of hslayers
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AddDataFileValues, AddDataUrlValues, CANVAS_SIZES, ColorPickers, CswLayersDialogComponent, CustomTranslationService, DOM_FEATURE_LINKS, DuplicateHandling, EndpointErrorHandling, EndpointsWithDatasourcesPipe, FILE_UPLOAD_SIZE_LIMIT, FilterPipe, HS_PRMS, HS_PRMS_BACKWARDS, HS_PRMS_REGENERATED, HsAddColormapComponent, HsAddDataCatalogueComponent, HsAddDataCatalogueMapService, HsAddDataCatalogueModule, HsAddDataCatalogueParams, HsAddDataCatalogueService, HsAddDataCommonFileService, HsAddDataCommonFileServiceParams, HsAddDataCommonModule, HsAddDataCommonService, HsAddDataComponent, HsAddDataFileBaseComponent, HsAddDataFileComponent, HsAddDataFileModule, HsAddDataModule, HsAddDataOwsService, HsAddDataService, HsAddDataUrlComponent, HsAddDataUrlModule, HsAddDataUrlService, HsAddDataVectorFileComponent, HsAddDataVectorModule, HsAddDataVectorService, HsAddDataVectorUrlComponent, HsAddFilterButtonComponent, HsAddLayerAuthorizedComponent, HsAdvancedOptionsComponent, HsArcgisGetCapabilitiesService, HsCapabilityCacheService, HsCatalogueListItemComponent, HsCatalogueMetadataComponent, HsCatalogueMetadataService, HsClearLayerComponent, HsClusterWidgetComponent, HsColorPickerComponent, HsColorPickerService, HsCommonEndpointsModule, HsCommonEndpointsService, HsCommonLaymanAccessRightsComponent, HsCommonLaymanService, HsCommonUrlComponent, HsCommonUrlModule, HsComparisonFilterComponent, HsCompositionsCatalogueParams, HsCompositionsCatalogueService, HsCompositionsComponent, HsCompositionsDeleteDialogComponent, HsCompositionsEndpointsModule, HsCompositionsInfoDialogComponent, HsCompositionsLayerParserModule, HsCompositionsLayerParserService, HsCompositionsLaymanService, HsCompositionsListItemComponent, HsCompositionsMapService, HsCompositionsMickaService, HsCompositionsModule, HsCompositionsOverwriteDialogComponent, HsCompositionsParserService, HsCompositionsService, HsCompositionsShareDialogComponent, HsCompositionsStatusManagerMickaJointService, HsCompositionsStatusManagerService, HsCompositionsWarningDialogComponent, HsConfig, HsConfigObject, HsConfirmDialogComponent, HsConfirmModule, HsCopyLayerDialogComponent, HsCoreModule, HsCoreService, HsDialogContainerComponent, HsDialogContainerService, HsDialogHostDirective, HsDialogItem, HsDimensionDescriptor, HsDimensionService, HsDimensionTimeService, HsDownloadDirective, HsDownloadModule, HsDrawComponent, HsDrawLayerMetadataDialogComponent, HsDrawModule, HsDrawService, HsDrawToolbarComponent, HsDynamicTextComponent, HsEventBusService, HsFeatureCommonService, HsFeatureExt, HsFeatureFilterPipe, HsFeatureInfoComponent, HsFeatureTableComponent, HsFeatureTableModule, HsFeatureTableService, HsFileDropDirective, HsFileRasterComponent, HsFileRasterModule, HsFileService, HsFileShpComponent, HsFileShpModule, HsFillSymbolizerComponent, HsFilterComponent, HsFiltersComponent, HsFiltersService, HsGeolocationComponent, HsGeolocationModule, HsGeolocationService, HsGetCapabilitiesErrorComponent, HsGetCapabilitiesModule, HsHistoryListComponent, HsHistoryListModule, HsHistoryListService, HsIconSymbolizerComponent, HsIdwWidgetComponent, HsImpressumComponent, HsInfoComponent, HsInfoModule, HsLanguageComponent, HsLanguageModule, HsLanguageService, HsLayerEditorComponent, HsLayerEditorDimensionsComponent, HsLayerEditorService, HsLayerEditorSubLayerCheckboxesComponent, HsLayerEditorSublayerService, HsLayerEditorVectorLayerService, HsLayerEditorWidgetBaseComponent, HsLayerEditorWidgetContainerService, HsLayerExt, HsLayerFeaturesComponent, HsLayerListComponent, HsLayerListService, HsLayerManagerComponent, HsLayerManagerFolderComponent, HsLayerManagerGalleryComponent, HsLayerManagerMetadataService, HsLayerManagerModule, HsLayerManagerRemoveAllDialogComponent, HsLayerManagerRemoveLayerDialogComponent, HsLayerManagerService, HsLayerManagerTimeEditorComponent, HsLayerNameComponent, HsLayerOverwriteDialogComponent, HsLayerPhysicalListComponent, HsLayerSelectorService, HsLayerShiftingService, HsLayerSynchronizerService, HsLayerTableComponent, HsLayerUtilsService, HsLaymanBrowserService, HsLaymanCurrentUserComponent, HsLaymanLoginComponent, HsLaymanModule, HsLaymanService, HsLayoutComponent, HsLayoutHostDirective, HsLayoutModule, HsLayoutService, HsLegendComponent, HsLegendLayerComponent, HsLegendLayerStaticComponent, HsLegendLayerStaticService, HsLegendLayerVectorComponent, HsLegendModule, HsLegendService, HsLegendWidgetComponent, HsLineSymbolizerComponent, HsLogModule, HsLogService, HsMapComponent, HsMapDirective, HsMapHostDirective, HsMapModule, HsMapService, HsMapSwipeComponent, HsMapSwipeModule, HsMapSwipeService, HsMarkSymbolizerComponent, HsMeasureComponent, HsMeasureModule, HsMeasureService, HsMeasureToolbarComponent, HsMetadataWidgetComponent, HsMickaBrowserService, HsMiniSidebarComponent, HsNestedLayersTableComponent, HsNewLayerFormComponent, HsOpacityWidgetComponent, HsOverlayPanelContainerService, HsPagerComponent, HsPagerModule, HsPanelBaseComponent, HsPanelContainerComponent, HsPanelContainerParams, HsPanelContainerService, HsPanelHeaderComponent, HsPanelHelpersModule, HsPanelHostDirective, HsPanelItem, HsPositionComponent, HsPrintComponent, HsPrintImprintService, HsPrintImprintStylerComponent, HsPrintLegendService, HsPrintLegendStylerComponent, HsPrintModule, HsPrintScaleService, HsPrintScaleStylerComponent, HsPrintService, HsPrintTextStylerComponent, HsPrintTitleService, HsQueryAttributeRowComponent, HsQueryBaseService, HsQueryComponent, HsQueryDefaultInfoPanelBodyComponent, HsQueryFeatureComponent, HsQueryFeatureListComponent, HsQueryModule, HsQueryPopupBaseService, HsQueryPopupComponent, HsQueryPopupData, HsQueryPopupService, HsQueryPopupWidgetBaseComponent, HsQueryPopupWidgetContainerService, HsQueryVectorService, HsQueryWmsService, HsQueryWmtsService, HsQueuesModule, HsQueuesService, HsRenameLayerDialogComponent, HsRmMultipleDialogComponent, HsRmMultipleModule, HsRuleComponent, HsRuleListItemComponent, HsSaveMapAdvancedFormComponent, HsSaveMapComponent, HsSaveMapDialogComponent, HsSaveMapDialogSpawnerService, HsSaveMapManagerParams, HsSaveMapManagerService, HsSaveMapModule, HsSaveMapResultDialogComponent, HsSaveMapService, HsSaveToLaymanComponent, HsScaleDenominatorComponent, HsScaleWidgetComponent, HsSearchComponent, HsSearchInputComponent, HsSearchModule, HsSearchResultsComponent, HsSearchService, HsSearchToolbarComponent, HsSelectIconDialogComponent, HsSetPermissionsDialogComponent, HsShareComponent, HsShareModule, HsShareService, HsShareThumbnailService, HsShareUrlService, HsSidebarComponent, HsSidebarModule, HsSidebarParams, HsSidebarService, HsSliderComponent, HsStatusManagerService, HsStylerComponent, HsStylerModule, HsStylerPartBaseComponent, HsStylerService, HsSymbolizerComponent, HsSymbolizerListItemComponent, HsTextSymbolizerComponent, HsToastComponent, HsToastModule, HsToastService, HsToolbarComponent, HsToolbarModule, HsToolbarPanelBaseComponent, HsToolbarPanelContainerService, HsTripPlannerComponent, HsTripPlannerLayerSelectorComponent, HsTripPlannerModule, HsTripPlannerService, HsTypeWidgetComponent, HsUiExtensionsModule, HsUiExtensionsRecursiveDdComponent, HsUploadComponent, HsUploadModule, HsUrlAddComponent, HsUrlArcGisComponent, HsUrlArcGisModule, HsUrlArcGisService, HsUrlDetailsComponent, HsUrlProgressComponent, HsUrlWfsComponent, HsUrlWfsModule, HsUrlWfsService, HsUrlWmsComponent, HsUrlWmsModule, HsUrlWmsService, HsUrlWmtsComponent, HsUrlWmtsModule, HsUrlWmtsService, HsUtilsModule, HsUtilsService, HsVectorUrlParserService, HsWfsGetCapabilitiesService, HsWmsGetCapabilitiesService, HsWmtsGetCapabilitiesService, HslayersComponent, HslayersModule, HslayersService, INSPIRETHEMES, InterpolatedSource, KEYWORDS, LayerListItem, NORMALIZED_WEIGHT_PROPERTY_NAME, OverwriteResponse, POSITION_OPTIONS, PREFER_RESUMABLE_SIZE_LIMIT, PrintLegendParams, SCALE_BAR_CLASSES, SCALE_LINE_CLASSES, SCALE_STYLING_OPTIONS, SORTBYVALUES, SPOI, SUPPORTED_SRS_LIST, SortByPipe, SparqlJson, StateValues, SwipeControl, SwipeSide, TEXT_STYLING_OPTIONS, TYPES, TrackByPropertyPipe, TranslateCustomPipe, VectorLayerDescriptor, VectorSourceDescriptor, VectorSourceFromUrl, WebpackTranslateLoader, WfsSource, WmsLayerHighlightDirective, _instanceOf, defaultStyle, equals, filesSupported, generateUuid, getAbstract, getAccessRights, getActive, getAttribution, getAutoLegend, getBase, getCachedCapabilities, getCluster, getCustomInfoTemplate, getDefinition, getDimension, getDimensions, getDomFeatureLinks, getEditor, getEnableProxy, getEventsSuspended, getExclusive, getFeatureInfoLang, getFeatureInfoTarget, getFeatureLabel, getFeatureName, getFeatureTitle, getFeatures, getFromComposition, getHighlighted, getHsLaymanSynchronizing, getInfoFormat, getInlineLegend, getLayerName, getLaymanFriendlyLayerName, getLaymanLayerDescriptor, getLegends, getMaxResolutionDenominator, getMetadata, getMinimumTerrainLevel, getName, getOnFeatureSelected, getOrigLayers, getPath, getPopUp, getPopupClass, getQml, getQueryCapabilities, getQueryFilter, getQueryable, getRemovable, getShowInLayerManager, getSld, getSubLayers, getSupportedSrsList, getSwipeSide, getThumbnail, getTitle, getUnitId, getVirtualAttributes, getWaypoint, getWebpackTranslateLoader, getWfsUrl, getWorkspace, instOf, isAtLeastVersions, isErrorHandlerFunction, isFunction, limitToPipe, listNumericAttributes, queryPopupWidgets, servicesSupportedByUrl, setAbstract, setAccessRights, setActive, setAttribution, setAutoLegend, setBase, setCacheCapabilities, setCluster, setCustomInfoTemplate, setDefinition, setDimension, setDimensions, setDomFeatureLinks, setEditor, setEnableProxy, setEventsSuspended, setExclusive, setFeatureInfoLang, setFeatureInfoTarget, setFeatureLabel, setFeatureName, setFeatureTitle, setFeatures, setFromComposition, setHighlighted, setHsLaymanSynchronizing, setInfoFormat, setInlineLegend, setLaymanLayerDescriptor, setLegends, setMaxResolutionDenominator, setMetadata, setMinimumTerrainLevel, setName, setOnFeatureSelected, setOrigLayers, setPath, setPopUp, setPopupClass, setQueryCapabilities, setQueryFilter, setQueryable, setRemovable, setShowInLayerManager, setSld, setSubLayers, setSwipeSide, setThumbnail, setTitle, setUnitId, setVirtualAttributes, setWaypoint, setWfsUrl, setWorkspace, simple_style, wfsFailed, wfsNotAvailable, wfsPendingOrStarting, xpos, ypos };
